/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ((function(modules) {
	// Check all modules for deduplicated modules
	for(var i in modules) {
		if(Object.prototype.hasOwnProperty.call(modules, i)) {
			switch(typeof modules[i]) {
			case "function": break;
			case "object":
				// Module can be created from a template
				modules[i] = (function(_m) {
					var args = _m.slice(1), fn = modules[_m[0]];
					return function (a,b,c) {
						fn.apply(this, [a,b,c].concat(args));
					};
				}(modules[i]));
				break;
			default:
				// Module is a copy of another module
				modules[i] = modules[modules[i]];
				break;
			}
		}
	}
	return modules;
}([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(270);
	module.exports = __webpack_require__(333);


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(562);
	} else {
	  module.exports = require('./cjs/react.development.js');
	}


/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	if (false) {
	  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
	    Symbol.for &&
	    Symbol.for('react.element')) ||
	    0xeac7;
	
	  var isValidElement = function(object) {
	    return typeof object === 'object' &&
	      object !== null &&
	      object.$$typeof === REACT_ELEMENT_TYPE;
	  };
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(509)();
	}


/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _victoryAnimation = __webpack_require__(258);
	
	Object.defineProperty(exports, "VictoryAnimation", {
	  enumerable: true,
	  get: function () {
	    return _interopRequireDefault(_victoryAnimation).default;
	  }
	});
	
	var _victoryContainer = __webpack_require__(259);
	
	Object.defineProperty(exports, "VictoryContainer", {
	  enumerable: true,
	  get: function () {
	    return _interopRequireDefault(_victoryContainer).default;
	  }
	});
	
	var _victoryLabel = __webpack_require__(145);
	
	Object.defineProperty(exports, "VictoryLabel", {
	  enumerable: true,
	  get: function () {
	    return _interopRequireDefault(_victoryLabel).default;
	  }
	});
	
	var _victoryTransition = __webpack_require__(266);
	
	Object.defineProperty(exports, "VictoryTransition", {
	  enumerable: true,
	  get: function () {
	    return _interopRequireDefault(_victoryTransition).default;
	  }
	});
	
	var _victorySharedEvents = __webpack_require__(612);
	
	Object.defineProperty(exports, "VictorySharedEvents", {
	  enumerable: true,
	  get: function () {
	    return _interopRequireDefault(_victorySharedEvents).default;
	  }
	});
	
	var _victoryClipContainer = __webpack_require__(599);
	
	Object.defineProperty(exports, "VictoryClipContainer", {
	  enumerable: true,
	  get: function () {
	    return _interopRequireDefault(_victoryClipContainer).default;
	  }
	});
	
	var _victoryTheme = __webpack_require__(147);
	
	Object.defineProperty(exports, "VictoryTheme", {
	  enumerable: true,
	  get: function () {
	    return _interopRequireDefault(_victoryTheme).default;
	  }
	});
	
	var _victoryLegend = __webpack_require__(601);
	
	Object.defineProperty(exports, "VictoryLegend", {
	  enumerable: true,
	  get: function () {
	    return _interopRequireDefault(_victoryLegend).default;
	  }
	});
	
	var _victoryTooltip = __webpack_require__(615);
	
	Object.defineProperty(exports, "VictoryTooltip", {
	  enumerable: true,
	  get: function () {
	    return _interopRequireDefault(_victoryTooltip).default;
	  }
	});
	
	var _victoryPortal = __webpack_require__(146);
	
	Object.defineProperty(exports, "VictoryPortal", {
	  enumerable: true,
	  get: function () {
	    return _interopRequireDefault(_victoryPortal).default;
	  }
	});
	
	var _portal = __webpack_require__(260);
	
	Object.defineProperty(exports, "Portal", {
	  enumerable: true,
	  get: function () {
	    return _interopRequireDefault(_portal).default;
	  }
	});
	
	var _arc = __webpack_require__(602);
	
	Object.defineProperty(exports, "Arc", {
	  enumerable: true,
	  get: function () {
	    return _interopRequireDefault(_arc).default;
	  }
	});
	
	var _area = __webpack_require__(603);
	
	Object.defineProperty(exports, "Area", {
	  enumerable: true,
	  get: function () {
	    return _interopRequireDefault(_area).default;
	  }
	});
	
	var _bar = __webpack_require__(604);
	
	Object.defineProperty(exports, "Bar", {
	  enumerable: true,
	  get: function () {
	    return _interopRequireDefault(_bar).default;
	  }
	});
	
	var _border = __webpack_require__(261);
	
	Object.defineProperty(exports, "Border", {
	  enumerable: true,
	  get: function () {
	    return _interopRequireDefault(_border).default;
	  }
	});
	
	var _candle = __webpack_require__(605);
	
	Object.defineProperty(exports, "Candle", {
	  enumerable: true,
	  get: function () {
	    return _interopRequireDefault(_candle).default;
	  }
	});
	
	var _clipPath = __webpack_require__(262);
	
	Object.defineProperty(exports, "ClipPath", {
	  enumerable: true,
	  get: function () {
	    return _interopRequireDefault(_clipPath).default;
	  }
	});
	
	var _curve = __webpack_require__(606);
	
	Object.defineProperty(exports, "Curve", {
	  enumerable: true,
	  get: function () {
	    return _interopRequireDefault(_curve).default;
	  }
	});
	
	var _errorBar = __webpack_require__(607);
	
	Object.defineProperty(exports, "ErrorBar", {
	  enumerable: true,
	  get: function () {
	    return _interopRequireDefault(_errorBar).default;
	  }
	});
	
	var _line = __webpack_require__(608);
	
	Object.defineProperty(exports, "Line", {
	  enumerable: true,
	  get: function () {
	    return _interopRequireDefault(_line).default;
	  }
	});
	
	var _point = __webpack_require__(265);
	
	Object.defineProperty(exports, "Point", {
	  enumerable: true,
	  get: function () {
	    return _interopRequireDefault(_point).default;
	  }
	});
	
	var _slice = __webpack_require__(610);
	
	Object.defineProperty(exports, "Slice", {
	  enumerable: true,
	  get: function () {
	    return _interopRequireDefault(_slice).default;
	  }
	});
	
	var _voronoi = __webpack_require__(611);
	
	Object.defineProperty(exports, "Voronoi", {
	  enumerable: true,
	  get: function () {
	    return _interopRequireDefault(_voronoi).default;
	  }
	});
	
	var _flyout = __webpack_require__(263);
	
	Object.defineProperty(exports, "Flyout", {
	  enumerable: true,
	  get: function () {
	    return _interopRequireDefault(_flyout).default;
	  }
	});
	
	var _addEvents = __webpack_require__(267);
	
	Object.defineProperty(exports, "addEvents", {
	  enumerable: true,
	  get: function () {
	    return _interopRequireDefault(_addEvents).default;
	  }
	});
	
	var _collection = __webpack_require__(8);
	
	Object.defineProperty(exports, "Collection", {
	  enumerable: true,
	  get: function () {
	    return _interopRequireDefault(_collection).default;
	  }
	});
	
	var _data = __webpack_require__(148);
	
	Object.defineProperty(exports, "Data", {
	  enumerable: true,
	  get: function () {
	    return _interopRequireDefault(_data).default;
	  }
	});
	
	var _defaultTransitions = __webpack_require__(616);
	
	Object.defineProperty(exports, "DefaultTransitions", {
	  enumerable: true,
	  get: function () {
	    return _interopRequireDefault(_defaultTransitions).default;
	  }
	});
	
	var _domain = __webpack_require__(617);
	
	Object.defineProperty(exports, "Domain", {
	  enumerable: true,
	  get: function () {
	    return _interopRequireDefault(_domain).default;
	  }
	});
	
	var _events = __webpack_require__(149);
	
	Object.defineProperty(exports, "Events", {
	  enumerable: true,
	  get: function () {
	    return _interopRequireDefault(_events).default;
	  }
	});
	
	var _helpers = __webpack_require__(6);
	
	Object.defineProperty(exports, "Helpers", {
	  enumerable: true,
	  get: function () {
	    return _interopRequireDefault(_helpers).default;
	  }
	});
	
	var _immutable = __webpack_require__(268);
	
	Object.defineProperty(exports, "Immutable", {
	  enumerable: true,
	  get: function () {
	    return _interopRequireDefault(_immutable).default;
	  }
	});
	
	var _labelHelpers = __webpack_require__(150);
	
	Object.defineProperty(exports, "LabelHelpers", {
	  enumerable: true,
	  get: function () {
	    return _interopRequireDefault(_labelHelpers).default;
	  }
	});
	
	var _log = __webpack_require__(98);
	
	Object.defineProperty(exports, "Log", {
	  enumerable: true,
	  get: function () {
	    return _interopRequireDefault(_log).default;
	  }
	});
	
	var _propTypes = __webpack_require__(26);
	
	Object.defineProperty(exports, "PropTypes", {
	  enumerable: true,
	  get: function () {
	    return _interopRequireDefault(_propTypes).default;
	  }
	});
	
	var _scale = __webpack_require__(151);
	
	Object.defineProperty(exports, "Scale", {
	  enumerable: true,
	  get: function () {
	    return _interopRequireDefault(_scale).default;
	  }
	});
	
	var _selection = __webpack_require__(618);
	
	Object.defineProperty(exports, "Selection", {
	  enumerable: true,
	  get: function () {
	    return _interopRequireDefault(_selection).default;
	  }
	});
	
	var _style = __webpack_require__(152);
	
	Object.defineProperty(exports, "Style", {
	  enumerable: true,
	  get: function () {
	    return _interopRequireDefault(_style).default;
	  }
	});
	
	var _textsize = __webpack_require__(153);
	
	Object.defineProperty(exports, "TextSize", {
	  enumerable: true,
	  get: function () {
	    return _interopRequireDefault(_textsize).default;
	  }
	});
	
	var _timer = __webpack_require__(62);
	
	Object.defineProperty(exports, "Timer", {
	  enumerable: true,
	  get: function () {
	    return _interopRequireDefault(_timer).default;
	  }
	});
	
	var _transitions = __webpack_require__(269);
	
	Object.defineProperty(exports, "Transitions", {
	  enumerable: true,
	  get: function () {
	    return _interopRequireDefault(_transitions).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	var assignValue = __webpack_require__(79),
	    copyObject = __webpack_require__(29),
	    createAssigner = __webpack_require__(50),
	    isArrayLike = __webpack_require__(23),
	    isPrototype = __webpack_require__(52),
	    keys = __webpack_require__(12);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Assigns own enumerable string keyed properties of source objects to the
	 * destination object. Source objects are applied from left to right.
	 * Subsequent sources overwrite property assignments of previous sources.
	 *
	 * **Note:** This method mutates `object` and is loosely based on
	 * [`Object.assign`](https://mdn.io/Object/assign).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.10.0
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @returns {Object} Returns `object`.
	 * @see _.assignIn
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * function Bar() {
	 *   this.c = 3;
	 * }
	 *
	 * Foo.prototype.b = 2;
	 * Bar.prototype.d = 4;
	 *
	 * _.assign({ 'a': 0 }, new Foo, new Bar);
	 * // => { 'a': 1, 'c': 3 }
	 */
	var assign = createAssigner(function(object, source) {
	  if (isPrototype(source) || isArrayLike(source)) {
	    copyObject(source, keys(source), object);
	    return;
	  }
	  for (var key in source) {
	    if (hasOwnProperty.call(source, key)) {
	      assignValue(object, key, source[key]);
	    }
	  }
	});
	
	module.exports = assign;


/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(49),
	    assignInWith = __webpack_require__(481),
	    baseRest = __webpack_require__(33),
	    customDefaultsAssignIn = __webpack_require__(428);
	
	/**
	 * Assigns own and inherited enumerable string keyed properties of source
	 * objects to the destination object for all destination properties that
	 * resolve to `undefined`. Source objects are applied from left to right.
	 * Once a property is set, additional values of the same property are ignored.
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @returns {Object} Returns `object`.
	 * @see _.defaultsDeep
	 * @example
	 *
	 * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	 * // => { 'a': 1, 'b': 2 }
	 */
	var defaults = baseRest(function(args) {
	  args.push(undefined, customDefaultsAssignIn);
	  return apply(assignInWith, undefined, args);
	});
	
	module.exports = defaults;


/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reduce2 = __webpack_require__(496);
	
	var _reduce3 = _interopRequireDefault(_reduce2);
	
	var _omit2 = __webpack_require__(25);
	
	var _omit3 = _interopRequireDefault(_omit2);
	
	var _property2 = __webpack_require__(134);
	
	var _property3 = _interopRequireDefault(_property2);
	
	var _isFunction2 = __webpack_require__(7);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _defaults2 = __webpack_require__(5);
	
	var _defaults3 = _interopRequireDefault(_defaults2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _collection = __webpack_require__(8);
	
	var _collection2 = _interopRequireDefault(_collection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  getPoint: function (datum) {
	    var exists = function (val) {
	      return val !== undefined;
	    };
	    var _x = datum._x,
	        _x1 = datum._x1,
	        _x0 = datum._x0,
	        _voronoiX = datum._voronoiX,
	        _y = datum._y,
	        _y1 = datum._y1,
	        _y0 = datum._y0,
	        _voronoiY = datum._voronoiY;
	
	    var defaultX = exists(_x1) ? _x1 : _x;
	    var defaultY = exists(_y1) ? _y1 : _y;
	    var point = {
	      x: exists(_voronoiX) ? _voronoiX : defaultX,
	      x0: exists(_x0) ? _x0 : _x,
	      y: exists(_voronoiY) ? _voronoiY : defaultY,
	      y0: exists(_y0) ? _y0 : _y
	    };
	    return (0, _defaults3.default)({}, point, datum);
	  },
	  scalePoint: function (props, datum) {
	    var scale = props.scale,
	        polar = props.polar;
	
	    var d = this.getPoint(datum);
	    var origin = props.origin || { x: 0, y: 0 };
	    var x = scale.x(d.x);
	    var x0 = scale.x(d.x0);
	    var y = scale.y(d.y);
	    var y0 = scale.y(d.y0);
	    return {
	      x: polar ? y * Math.cos(x) + origin.x : x,
	      x0: polar ? y0 * Math.cos(x0) + origin.x : x0,
	      y: polar ? -y * Math.sin(x) + origin.y : y,
	      y0: polar ? -y0 * Math.sin(x0) + origin.x : y0
	    };
	  },
	  formatPadding: function (padding) {
	    var paddingVal = typeof padding === "number" ? padding : 0;
	    var paddingObj = typeof padding === "object" ? padding : {};
	    return {
	      top: paddingObj.top || paddingVal,
	      bottom: paddingObj.bottom || paddingVal,
	      left: paddingObj.left || paddingVal,
	      right: paddingObj.right || paddingVal
	    };
	  },
	  getPadding: function (props) {
	    return this.formatPadding(props.padding);
	  },
	  getStyles: function (style, defaultStyles) {
	    var width = "100%";
	    var height = "100%";
	    if (!style) {
	      return (0, _defaults3.default)({ parent: { height: height, width: width } }, defaultStyles);
	    }
	
	    var data = style.data,
	        labels = style.labels,
	        parent = style.parent;
	
	    var defaultParent = defaultStyles && defaultStyles.parent || {};
	    var defaultLabels = defaultStyles && defaultStyles.labels || {};
	    var defaultData = defaultStyles && defaultStyles.data || {};
	    return {
	      parent: (0, _defaults3.default)({}, parent, defaultParent, { width: width, height: height }),
	      labels: (0, _defaults3.default)({}, labels, defaultLabels),
	      data: (0, _defaults3.default)({}, data, defaultData)
	    };
	  },
	  evaluateProp: function (prop, data, active) {
	    return (0, _isFunction3.default)(prop) ? prop(data, active) : prop;
	  },
	  evaluateStyle: function (style, data, active) {
	    var _this = this;
	
	    if (!style || !Object.keys(style).some(function (value) {
	      return (0, _isFunction3.default)(style[value]);
	    })) {
	      return style;
	    }
	    return Object.keys(style).reduce(function (prev, curr) {
	      prev[curr] = _this.evaluateProp(style[curr], data, active);
	      return prev;
	    }, {});
	  },
	  degreesToRadians: function (degrees) {
	    return degrees * (Math.PI / 180);
	  },
	  radiansToDegrees: function (radians) {
	    return radians / (Math.PI / 180);
	  },
	  getRadius: function (props) {
	    var _getPadding = this.getPadding(props),
	        left = _getPadding.left,
	        right = _getPadding.right,
	        top = _getPadding.top,
	        bottom = _getPadding.bottom;
	
	    var width = props.width,
	        height = props.height;
	
	    return Math.min(width - left - right, height - top - bottom) / 2;
	  },
	  getPolarOrigin: function (props) {
	    var width = props.width,
	        height = props.height;
	
	    var _getPadding2 = this.getPadding(props),
	        top = _getPadding2.top,
	        bottom = _getPadding2.bottom,
	        left = _getPadding2.left,
	        right = _getPadding2.right;
	
	    var radius = Math.min(width - left - right, height - top - bottom) / 2;
	    var offsetWidth = width / 2 + left - right;
	    var offsetHeight = height / 2 + top - bottom;
	    return {
	      x: offsetWidth + radius > width ? radius + left - right : offsetWidth,
	      y: offsetHeight + radius > height ? radius + top - bottom : offsetHeight
	    };
	  },
	  getRange: function (props, axis) {
	    if (props.range && props.range[axis]) {
	      return props.range[axis];
	    } else if (props.range && Array.isArray(props.range)) {
	      return props.range;
	    }
	    return props.polar ? this.getPolarRange(props, axis) : this.getCartesianRange(props, axis);
	  },
	  getCartesianRange: function (props, axis) {
	    // determine how to lay the axis and what direction positive and negative are
	    var isVertical = axis !== "x";
	    var padding = this.getPadding(props);
	    if (isVertical) {
	      return [props.height - padding.bottom, padding.top];
	    }
	    return [padding.left, props.width - padding.right];
	  },
	  getPolarRange: function (props, axis) {
	    if (axis === "x") {
	      var startAngle = this.degreesToRadians(props.startAngle || 0);
	      var endAngle = this.degreesToRadians(props.endAngle || 360);
	      return [startAngle, endAngle];
	    }
	    return [props.innerRadius || 0, this.getRadius(props)];
	  },
	  createAccessor: function (key) {
	    // creates a data accessor function
	    // given a property key, path, array index, or null for identity.
	    if ((0, _isFunction3.default)(key)) {
	      return key;
	    } else if (key === null || typeof key === "undefined") {
	      // null/undefined means "return the data item itself"
	      return function (x) {
	        return x;
	      };
	    }
	    // otherwise, assume it is an array index, property key or path (_.property handles all three)
	    return (0, _property3.default)(key);
	  },
	  modifyProps: function (props, fallbackProps, role) {
	    var theme = props.theme && props.theme[role] ? props.theme[role] : {};
	    var themeProps = (0, _omit3.default)(theme, ["style"]);
	    return (0, _defaults3.default)({}, props, themeProps, fallbackProps);
	  },
	
	
	  // Axis helpers
	
	  /**
	   * Returns the given axis or the opposite axis when horizontal
	   * @param {string} axis: the given axis, either "x" pr "y"
	   * @param {Boolean} horizontal: true when the chart is flipped to the horizontal orientation
	   * @returns {String} the dimension appropriate for the axis given its props "x" or "y"
	   */
	  getCurrentAxis: function (axis, horizontal) {
	    var otherAxis = axis === "x" ? "y" : "x";
	    return horizontal ? otherAxis : axis;
	  },
	
	
	  /**
	   * @param {Object} props: axis component props
	   * @returns {Boolean} true when the axis is vertical
	   */
	  isVertical: function (props) {
	    var orientation = props.orientation || (props.dependentAxis ? "left" : "bottom");
	    var vertical = { top: false, bottom: false, left: true, right: true };
	    return vertical[orientation];
	  },
	
	
	  /**
	   * @param {Object} props: axis component props
	   * @returns {Boolean} true when tickValues contain strings
	   */
	  stringTicks: function (props) {
	    return props.tickValues !== undefined && _collection2.default.containsStrings(props.tickValues);
	  },
	
	
	  /**
	   * @param {Array} children: an array of child components
	   * @param {Function} iteratee: a function with arguments "child", "childName", and "parent"
	   * @returns {Array} returns an array of results from calling the iteratee on all nested children
	   */
	  reduceChildren: function (children, iteratee) {
	    var childIndex = 0;
	    var traverseChildren = function (childArray, parent) {
	      return (0, _reduce3.default)(childArray, function (memo, child) {
	        var childName = child.props.name || childIndex;
	        childIndex++;
	        if (child.props && child.props.children) {
	          var nestedChildren = _react2.default.Children.toArray(child.props.children);
	          var nestedResults = traverseChildren(nestedChildren, child);
	          memo = memo.concat(nestedResults);
	        } else {
	          var result = iteratee(child, childName, parent);
	          memo = result ? memo.concat(result) : memo;
	        }
	        return memo;
	      }, []);
	    };
	    return traverseChildren(children);
	  }
	};

/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(30),
	    isObject = __webpack_require__(10);
	
	/** `Object#toString` result references. */
	var asyncTag = '[object AsyncFunction]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    proxyTag = '[object Proxy]';
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  if (!isObject(value)) {
	    return false;
	  }
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 9 which returns 'object' for typed arrays and other constructors.
	  var tag = baseGetTag(value);
	  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	}
	
	module.exports = isFunction;


/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isPlainObject2 = __webpack_require__(36);
	
	var _isPlainObject3 = _interopRequireDefault(_isPlainObject2);
	
	var _isEmpty2 = __webpack_require__(131);
	
	var _isEmpty3 = _interopRequireDefault(_isEmpty2);
	
	var _keys2 = __webpack_require__(12);
	
	var _keys3 = _interopRequireDefault(_keys2);
	
	var _isEqual2 = __webpack_require__(43);
	
	var _isEqual3 = _interopRequireDefault(_isEqual2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	exports.default = {
	  isNonEmptyArray: function (collection) {
	    return Array.isArray(collection) && collection.length > 0;
	  },
	  containsStrings: function (collection) {
	    return Array.isArray(collection) && collection.some(function (value) {
	      return typeof value === "string";
	    });
	  },
	  containsDates: function (collection) {
	    return Array.isArray(collection) && collection.some(function (value) {
	      return value instanceof Date;
	    });
	  },
	  containsNumbers: function (collection) {
	    return Array.isArray(collection) && collection.some(function (value) {
	      return typeof value === "number";
	    });
	  },
	  containsOnlyStrings: function (collection) {
	    return this.isNonEmptyArray(collection) && collection.every(function (value) {
	      return typeof value === "string";
	    });
	  },
	  isArrayOfArrays: function (collection) {
	    return this.isNonEmptyArray(collection) && collection.every(Array.isArray);
	  },
	  removeUndefined: function (arr) {
	    return arr.filter(function (el) {
	      return typeof el !== "undefined";
	    });
	  },
	  getMaxValue: function (arr) {
	    for (var _len = arguments.length, values = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      values[_key - 1] = arguments[_key];
	    }
	
	    var array = arr.concat(values);
	    return this.containsDates(array) ? new Date(Math.max.apply(Math, _toConsumableArray(array))) : Math.max.apply(Math, _toConsumableArray(array));
	  },
	  getMinValue: function (arr) {
	    for (var _len2 = arguments.length, values = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	      values[_key2 - 1] = arguments[_key2];
	    }
	
	    var array = arr.concat(values);
	    return this.containsDates(array) ? new Date(Math.min.apply(Math, _toConsumableArray(array))) : Math.min.apply(Math, _toConsumableArray(array));
	  },
	
	
	  /**
	   * Split array into subarrays using a delimiter function. Items qualifying as
	   * delimiters are excluded from the subarrays. Functions similarly to String.split
	   *
	   * Example:
	   * const array = [1, 2, 3, "omit", 4, 5, "omit", 6]
	   * splitArray(array, (item) => item === "omit");
	   * => [[1, 2, 3], [4, 5], [6]]
	   *
	   * @param {Array}    array        An array of items
	   * @param {Function} delimiterFn  A function indicating values to be used as delimiters
	   * @returns {Object}              Array of subarrays
	   */
	  splitArray: function (array, delimiterFn) {
	    var segmentStartIndex = 0;
	    var segments = array.reduce(function (memo, item, index) {
	      if (delimiterFn(item)) {
	        memo = memo.concat([array.slice(segmentStartIndex, index)]);
	        segmentStartIndex = index + 1;
	      } else if (index === array.length - 1) {
	        memo = memo.concat([array.slice(segmentStartIndex, array.length)]);
	      }
	      return memo;
	    }, []);
	
	    return segments.filter(function (segment) {
	      return Array.isArray(segment) && segment.length > 0;
	    });
	  },
	
	
	  /**
	   * Takes an array of arrays. Returns whether each subarray has equivalent items.
	   * Each subarray should have two items. Used for componentShouldUpdate functions.
	   *
	   * Example:
	   * const propComparisons = [
	   *   [x, nextProps.x],
	   *   [y, nextProps.y],
	   *   [style, this.style]
	   * ];
	   *
	   * allSetsEqual(propComparisons);
	   * => true
	   *
	   * @param {Array}    itemSets     An array of item sets
	   * @returns {Boolean}             Whether all item comparisons are equal
	   */
	  allSetsEqual: function (itemSets) {
	    return itemSets.every(function (comparisonSet) {
	      return (0, _isEqual3.default)(comparisonSet[0], comparisonSet[1]);
	    });
	  },
	
	
	  /*
	  Custom equality checking for props in shouldComponentUpdate.
	  `areVictoryPropsEqual` differs from lodash `isEqual` in the following ways:
	    - Functions are marked as equal (this was the main impetus for writing a new function)
	    - Does not handle symbols or maps
	    - Returns false when checking the equality of things like `1` vs. `Object(1)`
	    - Does not handle circular references in objects and arrays
	  */
	  areVictoryPropsEqual: function (a, b) {
	    return this.checkEquality(a, b);
	  },
	
	
	  // Broken into a separate method for ease of unit testing
	  checkEquality: function (o1, o2) {
	    var _this = this;
	
	    /*
	      tri-state equality checker: returns `true`, `false`, or `undefined`. When `undefined` is
	      returned this indicates that further (resursive) equality checking is required
	    */
	    var basicEqualityCheck = function (a, b) {
	      if (a === b) {
	        return true;
	      }
	      if (typeof a !== typeof b) {
	        return false;
	      }
	      // isEqual does not support equality checking on functions
	      // return true if a and b are both functions
	      if (typeof a === "function") {
	        return true;
	      }
	      if (typeof a === "object" && (0, _keys3.default)(a).length !== (0, _keys3.default)(b).length) {
	        return false;
	      }
	      if (typeof a !== "object" || (0, _keys3.default)(a).length === 0) {
	        return (0, _isEqual3.default)(a, b);
	      }
	      return undefined;
	    };
	
	    var initialEquality = basicEqualityCheck(o1, o2);
	    if (typeof initialEquality === "boolean") {
	      return initialEquality;
	    }
	    return (0, _keys3.default)(o1).reduce(function (equal, key) {
	      if (!equal) {
	        return false;
	      }
	      var val1 = o1[key];
	      var val2 = o2[key];
	      var equality = basicEqualityCheck(val1, val2);
	      if (typeof equality === "boolean") {
	        return equality;
	      }
	      if ((0, _isPlainObject3.default)(val1)) {
	        return !(0, _isPlainObject3.default)(val2) ? false : (0, _isEmpty3.default)(val1) && (0, _isEmpty3.default)(val2) || _this.checkEquality(val1, val2);
	      } else if (Array.isArray(val1)) {
	        return !Array.isArray(val2) ? false : (0, _isEmpty3.default)(val1) && (0, _isEmpty3.default)(val2) || _this.checkEquality(val1, val2);
	      } else {
	        return (0, _isEqual3.default)(val1, val2);
	      }
	    }, true);
	  }
	};

/***/ },
/* 9 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	module.exports = isArray;


/***/ },
/* 10 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}
	
	module.exports = isObject;


/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(37);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GoBackTokenPage = function (_Component) {
	  _inherits(GoBackTokenPage, _Component);
	
	  function GoBackTokenPage() {
	    _classCallCheck(this, GoBackTokenPage);
	
	    return _possibleConstructorReturn(this, (GoBackTokenPage.__proto__ || Object.getPrototypeOf(GoBackTokenPage)).apply(this, arguments));
	  }
	
	  _createClass(GoBackTokenPage, [{
	    key: "render",
	    value: function render() {
	
	      var data = this.props.data;
	
	      return _react2.default.createElement(
	        "div",
	        { "class": "text-left" },
	        _react2.default.createElement(
	          _reactRouterDom.Link,
	          { to: { pathname: "/dashboard/tokenpage" } },
	          _react2.default.createElement("i", { "class": "fa fa-2x fa-arrow-left m-r-10" }),
	          _react2.default.createElement(
	            "h4",
	            { id: "inline" },
	            " ",
	            data.back
	          )
	        )
	      );
	    }
	  }]);
	
	  return GoBackTokenPage;
	}(_react.Component);
	
	exports.default = GoBackTokenPage;

/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__(180),
	    baseKeys = __webpack_require__(188),
	    isArrayLike = __webpack_require__(23);
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	module.exports = keys;


/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _send_transaction = __webpack_require__(101);
	
	var _send_transaction2 = _interopRequireDefault(_send_transaction);
	
	var _reactRouterDom = __webpack_require__(37);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Withdraw = function (_Component) {
	    _inherits(Withdraw, _Component);
	
	    function Withdraw() {
	        _classCallCheck(this, Withdraw);
	
	        return _possibleConstructorReturn(this, (Withdraw.__proto__ || Object.getPrototypeOf(Withdraw)).apply(this, arguments));
	    }
	
	    _createClass(Withdraw, [{
	        key: 'render',
	        value: function render() {
	
	            var page = this.props.name;
	            var data = this.props.data;
	            var sendtransaction = this.props.sendtransaction;
	            var suspended = false;
	
	            if (page === "cobinhood" && window.cobinhood_allow === "False" || page === "cybermiles" && window.cybermiles_allow === "False" || page === "wandx" && window.wandx_allow === "False" || page === "xyo" && window.xyo_allow === "False" || page === "fuzex" && window.fuzex_allow === "False" || page === "nbr" && window.nbr_allow === "False" || page === "ncash" && window.ncash_allow === "False" || page === "singularitynet" && window.singularitynet_allow === "False" || page === "autonio" && window.autonio_allow === "False" || page === "credits" && window.credits_allow === "False" || page === "stacs" && window.stacs_allow === "False" || page === "orbs" && window.orbs_allow === "False" || page === "essentia" && window.essentia_allow === "False" || page === "incodium" && window.incodium_allow === "False" || page === "moneynet" && window.moneynet_allow === "False") {
	                suspended = true;
	            }
	
	            if (suspended) {
	                return _react2.default.createElement(
	                    'div',
	                    { 'class': 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { 'class': 'col-lg-12 col-md-12' },
	                        _react2.default.createElement(
	                            'div',
	                            { 'class': 'card-box' },
	                            _react2.default.createElement(
	                                'div',
	                                null,
	                                'Withdraw Temporarily Suspended'
	                            )
	                        )
	                    )
	                );
	            } else {
	                return _react2.default.createElement(
	                    'div',
	                    { 'class': 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { 'class': 'col-lg-12 col-md-12' },
	                        _react2.default.createElement(
	                            'div',
	                            { 'class': 'card-box' },
	                            _react2.default.createElement(
	                                'h4',
	                                { 'class': 'header-title m-t-0 m-b-30' },
	                                data.withdraw
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { 'class': 'widget-box-2' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'widget-detail-2' },
	                                    _react2.default.createElement(
	                                        'h4',
	                                        { 'class': 'text-left' },
	                                        data.daoTokenisUtilityToken,
	                                        _react2.default.createElement(
	                                            _reactRouterDom.Link,
	                                            { to: { pathname: '/dashboard/notification' } },
	                                            data.learnMore
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'h4',
	                                        { 'class': 'text-left' },
	                                        data.withdrawDeductsDao,
	                                        ' '
	                                    ),
	                                    _react2.default.createElement('div', { 'class': 'm-t-20' }),
	                                    _react2.default.createElement('div', { 'class': 'm-t-20' }),
	                                    _react2.default.createElement(
	                                        'button',
	                                        { 'class': 'btn btn-green w-md', 'data-toggle': 'modal', 'data-target': '#con-close-modal' },
	                                        data.withdraw
	                                    )
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(_send_transaction2.default, { name: page, withdraw: 'True', data: sendtransaction })
	                );
	            }
	        }
	    }]);
	
	    return Withdraw;
	}(_react.Component);
	
	exports.default = Withdraw;

/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * jQuery JavaScript Library v3.2.1
	 * https://jquery.com/
	 *
	 * Includes Sizzle.js
	 * https://sizzlejs.com/
	 *
	 * Copyright JS Foundation and other contributors
	 * Released under the MIT license
	 * https://jquery.org/license
	 *
	 * Date: 2017-03-20T18:59Z
	 */
	( function( global, factory ) {
	
		"use strict";
	
		if ( typeof module === "object" && typeof module.exports === "object" ) {
	
			// For CommonJS and CommonJS-like environments where a proper `window`
			// is present, execute the factory and get jQuery.
			// For environments that do not have a `window` with a `document`
			// (such as Node.js), expose a factory as module.exports.
			// This accentuates the need for the creation of a real `window`.
			// e.g. var jQuery = require("jquery")(window);
			// See ticket #14549 for more info.
			module.exports = global.document ?
				factory( global, true ) :
				function( w ) {
					if ( !w.document ) {
						throw new Error( "jQuery requires a window with a document" );
					}
					return factory( w );
				};
		} else {
			factory( global );
		}
	
	// Pass this if window is not defined yet
	} )( typeof window !== "undefined" ? window : this, function( window, noGlobal ) {
	
	// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
	// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
	// arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
	// enough that all such attempts are guarded in a try block.
	"use strict";
	
	var arr = [];
	
	var document = window.document;
	
	var getProto = Object.getPrototypeOf;
	
	var slice = arr.slice;
	
	var concat = arr.concat;
	
	var push = arr.push;
	
	var indexOf = arr.indexOf;
	
	var class2type = {};
	
	var toString = class2type.toString;
	
	var hasOwn = class2type.hasOwnProperty;
	
	var fnToString = hasOwn.toString;
	
	var ObjectFunctionString = fnToString.call( Object );
	
	var support = {};
	
	
	
		function DOMEval( code, doc ) {
			doc = doc || document;
	
			var script = doc.createElement( "script" );
	
			script.text = code;
			doc.head.appendChild( script ).parentNode.removeChild( script );
		}
	/* global Symbol */
	// Defining this global in .eslintrc.json would create a danger of using the global
	// unguarded in another place, it seems safer to define global only for this module
	
	
	
	var
		version = "3.2.1",
	
		// Define a local copy of jQuery
		jQuery = function( selector, context ) {
	
			// The jQuery object is actually just the init constructor 'enhanced'
			// Need init if jQuery is called (just allow error to be thrown if not included)
			return new jQuery.fn.init( selector, context );
		},
	
		// Support: Android <=4.0 only
		// Make sure we trim BOM and NBSP
		rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,
	
		// Matches dashed string for camelizing
		rmsPrefix = /^-ms-/,
		rdashAlpha = /-([a-z])/g,
	
		// Used by jQuery.camelCase as callback to replace()
		fcamelCase = function( all, letter ) {
			return letter.toUpperCase();
		};
	
	jQuery.fn = jQuery.prototype = {
	
		// The current version of jQuery being used
		jquery: version,
	
		constructor: jQuery,
	
		// The default length of a jQuery object is 0
		length: 0,
	
		toArray: function() {
			return slice.call( this );
		},
	
		// Get the Nth element in the matched element set OR
		// Get the whole matched element set as a clean array
		get: function( num ) {
	
			// Return all the elements in a clean array
			if ( num == null ) {
				return slice.call( this );
			}
	
			// Return just the one element from the set
			return num < 0 ? this[ num + this.length ] : this[ num ];
		},
	
		// Take an array of elements and push it onto the stack
		// (returning the new matched element set)
		pushStack: function( elems ) {
	
			// Build a new jQuery matched element set
			var ret = jQuery.merge( this.constructor(), elems );
	
			// Add the old object onto the stack (as a reference)
			ret.prevObject = this;
	
			// Return the newly-formed element set
			return ret;
		},
	
		// Execute a callback for every element in the matched set.
		each: function( callback ) {
			return jQuery.each( this, callback );
		},
	
		map: function( callback ) {
			return this.pushStack( jQuery.map( this, function( elem, i ) {
				return callback.call( elem, i, elem );
			} ) );
		},
	
		slice: function() {
			return this.pushStack( slice.apply( this, arguments ) );
		},
	
		first: function() {
			return this.eq( 0 );
		},
	
		last: function() {
			return this.eq( -1 );
		},
	
		eq: function( i ) {
			var len = this.length,
				j = +i + ( i < 0 ? len : 0 );
			return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
		},
	
		end: function() {
			return this.prevObject || this.constructor();
		},
	
		// For internal use only.
		// Behaves like an Array's method, not like a jQuery method.
		push: push,
		sort: arr.sort,
		splice: arr.splice
	};
	
	jQuery.extend = jQuery.fn.extend = function() {
		var options, name, src, copy, copyIsArray, clone,
			target = arguments[ 0 ] || {},
			i = 1,
			length = arguments.length,
			deep = false;
	
		// Handle a deep copy situation
		if ( typeof target === "boolean" ) {
			deep = target;
	
			// Skip the boolean and the target
			target = arguments[ i ] || {};
			i++;
		}
	
		// Handle case when target is a string or something (possible in deep copy)
		if ( typeof target !== "object" && !jQuery.isFunction( target ) ) {
			target = {};
		}
	
		// Extend jQuery itself if only one argument is passed
		if ( i === length ) {
			target = this;
			i--;
		}
	
		for ( ; i < length; i++ ) {
	
			// Only deal with non-null/undefined values
			if ( ( options = arguments[ i ] ) != null ) {
	
				// Extend the base object
				for ( name in options ) {
					src = target[ name ];
					copy = options[ name ];
	
					// Prevent never-ending loop
					if ( target === copy ) {
						continue;
					}
	
					// Recurse if we're merging plain objects or arrays
					if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
						( copyIsArray = Array.isArray( copy ) ) ) ) {
	
						if ( copyIsArray ) {
							copyIsArray = false;
							clone = src && Array.isArray( src ) ? src : [];
	
						} else {
							clone = src && jQuery.isPlainObject( src ) ? src : {};
						}
	
						// Never move original objects, clone them
						target[ name ] = jQuery.extend( deep, clone, copy );
	
					// Don't bring in undefined values
					} else if ( copy !== undefined ) {
						target[ name ] = copy;
					}
				}
			}
		}
	
		// Return the modified object
		return target;
	};
	
	jQuery.extend( {
	
		// Unique for each copy of jQuery on the page
		expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),
	
		// Assume jQuery is ready without the ready module
		isReady: true,
	
		error: function( msg ) {
			throw new Error( msg );
		},
	
		noop: function() {},
	
		isFunction: function( obj ) {
			return jQuery.type( obj ) === "function";
		},
	
		isWindow: function( obj ) {
			return obj != null && obj === obj.window;
		},
	
		isNumeric: function( obj ) {
	
			// As of jQuery 3.0, isNumeric is limited to
			// strings and numbers (primitives or objects)
			// that can be coerced to finite numbers (gh-2662)
			var type = jQuery.type( obj );
			return ( type === "number" || type === "string" ) &&
	
				// parseFloat NaNs numeric-cast false positives ("")
				// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
				// subtraction forces infinities to NaN
				!isNaN( obj - parseFloat( obj ) );
		},
	
		isPlainObject: function( obj ) {
			var proto, Ctor;
	
			// Detect obvious negatives
			// Use toString instead of jQuery.type to catch host objects
			if ( !obj || toString.call( obj ) !== "[object Object]" ) {
				return false;
			}
	
			proto = getProto( obj );
	
			// Objects with no prototype (e.g., `Object.create( null )`) are plain
			if ( !proto ) {
				return true;
			}
	
			// Objects with prototype are plain iff they were constructed by a global Object function
			Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
			return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
		},
	
		isEmptyObject: function( obj ) {
	
			/* eslint-disable no-unused-vars */
			// See https://github.com/eslint/eslint/issues/6125
			var name;
	
			for ( name in obj ) {
				return false;
			}
			return true;
		},
	
		type: function( obj ) {
			if ( obj == null ) {
				return obj + "";
			}
	
			// Support: Android <=2.3 only (functionish RegExp)
			return typeof obj === "object" || typeof obj === "function" ?
				class2type[ toString.call( obj ) ] || "object" :
				typeof obj;
		},
	
		// Evaluates a script in a global context
		globalEval: function( code ) {
			DOMEval( code );
		},
	
		// Convert dashed to camelCase; used by the css and data modules
		// Support: IE <=9 - 11, Edge 12 - 13
		// Microsoft forgot to hump their vendor prefix (#9572)
		camelCase: function( string ) {
			return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
		},
	
		each: function( obj, callback ) {
			var length, i = 0;
	
			if ( isArrayLike( obj ) ) {
				length = obj.length;
				for ( ; i < length; i++ ) {
					if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
						break;
					}
				}
			} else {
				for ( i in obj ) {
					if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
						break;
					}
				}
			}
	
			return obj;
		},
	
		// Support: Android <=4.0 only
		trim: function( text ) {
			return text == null ?
				"" :
				( text + "" ).replace( rtrim, "" );
		},
	
		// results is for internal usage only
		makeArray: function( arr, results ) {
			var ret = results || [];
	
			if ( arr != null ) {
				if ( isArrayLike( Object( arr ) ) ) {
					jQuery.merge( ret,
						typeof arr === "string" ?
						[ arr ] : arr
					);
				} else {
					push.call( ret, arr );
				}
			}
	
			return ret;
		},
	
		inArray: function( elem, arr, i ) {
			return arr == null ? -1 : indexOf.call( arr, elem, i );
		},
	
		// Support: Android <=4.0 only, PhantomJS 1 only
		// push.apply(_, arraylike) throws on ancient WebKit
		merge: function( first, second ) {
			var len = +second.length,
				j = 0,
				i = first.length;
	
			for ( ; j < len; j++ ) {
				first[ i++ ] = second[ j ];
			}
	
			first.length = i;
	
			return first;
		},
	
		grep: function( elems, callback, invert ) {
			var callbackInverse,
				matches = [],
				i = 0,
				length = elems.length,
				callbackExpect = !invert;
	
			// Go through the array, only saving the items
			// that pass the validator function
			for ( ; i < length; i++ ) {
				callbackInverse = !callback( elems[ i ], i );
				if ( callbackInverse !== callbackExpect ) {
					matches.push( elems[ i ] );
				}
			}
	
			return matches;
		},
	
		// arg is for internal usage only
		map: function( elems, callback, arg ) {
			var length, value,
				i = 0,
				ret = [];
	
			// Go through the array, translating each of the items to their new values
			if ( isArrayLike( elems ) ) {
				length = elems.length;
				for ( ; i < length; i++ ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
	
			// Go through every key on the object,
			} else {
				for ( i in elems ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
			}
	
			// Flatten any nested arrays
			return concat.apply( [], ret );
		},
	
		// A global GUID counter for objects
		guid: 1,
	
		// Bind a function to a context, optionally partially applying any
		// arguments.
		proxy: function( fn, context ) {
			var tmp, args, proxy;
	
			if ( typeof context === "string" ) {
				tmp = fn[ context ];
				context = fn;
				fn = tmp;
			}
	
			// Quick check to determine if target is callable, in the spec
			// this throws a TypeError, but we will just return undefined.
			if ( !jQuery.isFunction( fn ) ) {
				return undefined;
			}
	
			// Simulated bind
			args = slice.call( arguments, 2 );
			proxy = function() {
				return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
			};
	
			// Set the guid of unique handler to the same of original handler, so it can be removed
			proxy.guid = fn.guid = fn.guid || jQuery.guid++;
	
			return proxy;
		},
	
		now: Date.now,
	
		// jQuery.support is not used in Core but other projects attach their
		// properties to it so it needs to exist.
		support: support
	} );
	
	if ( typeof Symbol === "function" ) {
		jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
	}
	
	// Populate the class2type map
	jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
	function( i, name ) {
		class2type[ "[object " + name + "]" ] = name.toLowerCase();
	} );
	
	function isArrayLike( obj ) {
	
		// Support: real iOS 8.2 only (not reproducible in simulator)
		// `in` check used to prevent JIT error (gh-2145)
		// hasOwn isn't used here due to false negatives
		// regarding Nodelist length in IE
		var length = !!obj && "length" in obj && obj.length,
			type = jQuery.type( obj );
	
		if ( type === "function" || jQuery.isWindow( obj ) ) {
			return false;
		}
	
		return type === "array" || length === 0 ||
			typeof length === "number" && length > 0 && ( length - 1 ) in obj;
	}
	var Sizzle =
	/*!
	 * Sizzle CSS Selector Engine v2.3.3
	 * https://sizzlejs.com/
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license
	 * http://jquery.org/license
	 *
	 * Date: 2016-08-08
	 */
	(function( window ) {
	
	var i,
		support,
		Expr,
		getText,
		isXML,
		tokenize,
		compile,
		select,
		outermostContext,
		sortInput,
		hasDuplicate,
	
		// Local document vars
		setDocument,
		document,
		docElem,
		documentIsHTML,
		rbuggyQSA,
		rbuggyMatches,
		matches,
		contains,
	
		// Instance-specific data
		expando = "sizzle" + 1 * new Date(),
		preferredDoc = window.document,
		dirruns = 0,
		done = 0,
		classCache = createCache(),
		tokenCache = createCache(),
		compilerCache = createCache(),
		sortOrder = function( a, b ) {
			if ( a === b ) {
				hasDuplicate = true;
			}
			return 0;
		},
	
		// Instance methods
		hasOwn = ({}).hasOwnProperty,
		arr = [],
		pop = arr.pop,
		push_native = arr.push,
		push = arr.push,
		slice = arr.slice,
		// Use a stripped-down indexOf as it's faster than native
		// https://jsperf.com/thor-indexof-vs-for/5
		indexOf = function( list, elem ) {
			var i = 0,
				len = list.length;
			for ( ; i < len; i++ ) {
				if ( list[i] === elem ) {
					return i;
				}
			}
			return -1;
		},
	
		booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
	
		// Regular expressions
	
		// http://www.w3.org/TR/css3-selectors/#whitespace
		whitespace = "[\\x20\\t\\r\\n\\f]",
	
		// http://www.w3.org/TR/CSS21/syndata.html#value-def-identifier
		identifier = "(?:\\\\.|[\\w-]|[^\0-\\xa0])+",
	
		// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
		attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +
			// Operator (capture 2)
			"*([*^$|!~]?=)" + whitespace +
			// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
			"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace +
			"*\\]",
	
		pseudos = ":(" + identifier + ")(?:\\((" +
			// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
			// 1. quoted (capture 3; capture 4 or capture 5)
			"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
			// 2. simple (capture 6)
			"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
			// 3. anything else (capture 2)
			".*" +
			")\\)|)",
	
		// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
		rwhitespace = new RegExp( whitespace + "+", "g" ),
		rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g" ),
	
		rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
		rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*" ),
	
		rattributeQuotes = new RegExp( "=" + whitespace + "*([^\\]'\"]*?)" + whitespace + "*\\]", "g" ),
	
		rpseudo = new RegExp( pseudos ),
		ridentifier = new RegExp( "^" + identifier + "$" ),
	
		matchExpr = {
			"ID": new RegExp( "^#(" + identifier + ")" ),
			"CLASS": new RegExp( "^\\.(" + identifier + ")" ),
			"TAG": new RegExp( "^(" + identifier + "|[*])" ),
			"ATTR": new RegExp( "^" + attributes ),
			"PSEUDO": new RegExp( "^" + pseudos ),
			"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace +
				"*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace +
				"*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
			"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),
			// For use in libraries implementing .is()
			// We use this for POS matching in `select`
			"needsContext": new RegExp( "^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
				whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
		},
	
		rinputs = /^(?:input|select|textarea|button)$/i,
		rheader = /^h\d$/i,
	
		rnative = /^[^{]+\{\s*\[native \w/,
	
		// Easily-parseable/retrievable ID or TAG or CLASS selectors
		rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
	
		rsibling = /[+~]/,
	
		// CSS escapes
		// http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
		runescape = new RegExp( "\\\\([\\da-f]{1,6}" + whitespace + "?|(" + whitespace + ")|.)", "ig" ),
		funescape = function( _, escaped, escapedWhitespace ) {
			var high = "0x" + escaped - 0x10000;
			// NaN means non-codepoint
			// Support: Firefox<24
			// Workaround erroneous numeric interpretation of +"0x"
			return high !== high || escapedWhitespace ?
				escaped :
				high < 0 ?
					// BMP codepoint
					String.fromCharCode( high + 0x10000 ) :
					// Supplemental Plane codepoint (surrogate pair)
					String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
		},
	
		// CSS string/identifier serialization
		// https://drafts.csswg.org/cssom/#common-serializing-idioms
		rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
		fcssescape = function( ch, asCodePoint ) {
			if ( asCodePoint ) {
	
				// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
				if ( ch === "\0" ) {
					return "\uFFFD";
				}
	
				// Control characters and (dependent upon position) numbers get escaped as code points
				return ch.slice( 0, -1 ) + "\\" + ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
			}
	
			// Other potentially-special ASCII characters get backslash-escaped
			return "\\" + ch;
		},
	
		// Used for iframes
		// See setDocument()
		// Removing the function wrapper causes a "Permission Denied"
		// error in IE
		unloadHandler = function() {
			setDocument();
		},
	
		disabledAncestor = addCombinator(
			function( elem ) {
				return elem.disabled === true && ("form" in elem || "label" in elem);
			},
			{ dir: "parentNode", next: "legend" }
		);
	
	// Optimize for push.apply( _, NodeList )
	try {
		push.apply(
			(arr = slice.call( preferredDoc.childNodes )),
			preferredDoc.childNodes
		);
		// Support: Android<4.0
		// Detect silently failing push.apply
		arr[ preferredDoc.childNodes.length ].nodeType;
	} catch ( e ) {
		push = { apply: arr.length ?
	
			// Leverage slice if possible
			function( target, els ) {
				push_native.apply( target, slice.call(els) );
			} :
	
			// Support: IE<9
			// Otherwise append directly
			function( target, els ) {
				var j = target.length,
					i = 0;
				// Can't trust NodeList.length
				while ( (target[j++] = els[i++]) ) {}
				target.length = j - 1;
			}
		};
	}
	
	function Sizzle( selector, context, results, seed ) {
		var m, i, elem, nid, match, groups, newSelector,
			newContext = context && context.ownerDocument,
	
			// nodeType defaults to 9, since context defaults to document
			nodeType = context ? context.nodeType : 9;
	
		results = results || [];
	
		// Return early from calls with invalid selector or context
		if ( typeof selector !== "string" || !selector ||
			nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {
	
			return results;
		}
	
		// Try to shortcut find operations (as opposed to filters) in HTML documents
		if ( !seed ) {
	
			if ( ( context ? context.ownerDocument || context : preferredDoc ) !== document ) {
				setDocument( context );
			}
			context = context || document;
	
			if ( documentIsHTML ) {
	
				// If the selector is sufficiently simple, try using a "get*By*" DOM method
				// (excepting DocumentFragment context, where the methods don't exist)
				if ( nodeType !== 11 && (match = rquickExpr.exec( selector )) ) {
	
					// ID selector
					if ( (m = match[1]) ) {
	
						// Document context
						if ( nodeType === 9 ) {
							if ( (elem = context.getElementById( m )) ) {
	
								// Support: IE, Opera, Webkit
								// TODO: identify versions
								// getElementById can match elements by name instead of ID
								if ( elem.id === m ) {
									results.push( elem );
									return results;
								}
							} else {
								return results;
							}
	
						// Element context
						} else {
	
							// Support: IE, Opera, Webkit
							// TODO: identify versions
							// getElementById can match elements by name instead of ID
							if ( newContext && (elem = newContext.getElementById( m )) &&
								contains( context, elem ) &&
								elem.id === m ) {
	
								results.push( elem );
								return results;
							}
						}
	
					// Type selector
					} else if ( match[2] ) {
						push.apply( results, context.getElementsByTagName( selector ) );
						return results;
	
					// Class selector
					} else if ( (m = match[3]) && support.getElementsByClassName &&
						context.getElementsByClassName ) {
	
						push.apply( results, context.getElementsByClassName( m ) );
						return results;
					}
				}
	
				// Take advantage of querySelectorAll
				if ( support.qsa &&
					!compilerCache[ selector + " " ] &&
					(!rbuggyQSA || !rbuggyQSA.test( selector )) ) {
	
					if ( nodeType !== 1 ) {
						newContext = context;
						newSelector = selector;
	
					// qSA looks outside Element context, which is not what we want
					// Thanks to Andrew Dupont for this workaround technique
					// Support: IE <=8
					// Exclude object elements
					} else if ( context.nodeName.toLowerCase() !== "object" ) {
	
						// Capture the context ID, setting it first if necessary
						if ( (nid = context.getAttribute( "id" )) ) {
							nid = nid.replace( rcssescape, fcssescape );
						} else {
							context.setAttribute( "id", (nid = expando) );
						}
	
						// Prefix every selector in the list
						groups = tokenize( selector );
						i = groups.length;
						while ( i-- ) {
							groups[i] = "#" + nid + " " + toSelector( groups[i] );
						}
						newSelector = groups.join( "," );
	
						// Expand context for sibling selectors
						newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
							context;
					}
	
					if ( newSelector ) {
						try {
							push.apply( results,
								newContext.querySelectorAll( newSelector )
							);
							return results;
						} catch ( qsaError ) {
						} finally {
							if ( nid === expando ) {
								context.removeAttribute( "id" );
							}
						}
					}
				}
			}
		}
	
		// All others
		return select( selector.replace( rtrim, "$1" ), context, results, seed );
	}
	
	/**
	 * Create key-value caches of limited size
	 * @returns {function(string, object)} Returns the Object data after storing it on itself with
	 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
	 *	deleting the oldest entry
	 */
	function createCache() {
		var keys = [];
	
		function cache( key, value ) {
			// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
			if ( keys.push( key + " " ) > Expr.cacheLength ) {
				// Only keep the most recent entries
				delete cache[ keys.shift() ];
			}
			return (cache[ key + " " ] = value);
		}
		return cache;
	}
	
	/**
	 * Mark a function for special use by Sizzle
	 * @param {Function} fn The function to mark
	 */
	function markFunction( fn ) {
		fn[ expando ] = true;
		return fn;
	}
	
	/**
	 * Support testing using an element
	 * @param {Function} fn Passed the created element and returns a boolean result
	 */
	function assert( fn ) {
		var el = document.createElement("fieldset");
	
		try {
			return !!fn( el );
		} catch (e) {
			return false;
		} finally {
			// Remove from its parent by default
			if ( el.parentNode ) {
				el.parentNode.removeChild( el );
			}
			// release memory in IE
			el = null;
		}
	}
	
	/**
	 * Adds the same handler for all of the specified attrs
	 * @param {String} attrs Pipe-separated list of attributes
	 * @param {Function} handler The method that will be applied
	 */
	function addHandle( attrs, handler ) {
		var arr = attrs.split("|"),
			i = arr.length;
	
		while ( i-- ) {
			Expr.attrHandle[ arr[i] ] = handler;
		}
	}
	
	/**
	 * Checks document order of two siblings
	 * @param {Element} a
	 * @param {Element} b
	 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
	 */
	function siblingCheck( a, b ) {
		var cur = b && a,
			diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
				a.sourceIndex - b.sourceIndex;
	
		// Use IE sourceIndex if available on both nodes
		if ( diff ) {
			return diff;
		}
	
		// Check if b follows a
		if ( cur ) {
			while ( (cur = cur.nextSibling) ) {
				if ( cur === b ) {
					return -1;
				}
			}
		}
	
		return a ? 1 : -1;
	}
	
	/**
	 * Returns a function to use in pseudos for input types
	 * @param {String} type
	 */
	function createInputPseudo( type ) {
		return function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for buttons
	 * @param {String} type
	 */
	function createButtonPseudo( type ) {
		return function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return (name === "input" || name === "button") && elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for :enabled/:disabled
	 * @param {Boolean} disabled true for :disabled; false for :enabled
	 */
	function createDisabledPseudo( disabled ) {
	
		// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
		return function( elem ) {
	
			// Only certain elements can match :enabled or :disabled
			// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
			// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
			if ( "form" in elem ) {
	
				// Check for inherited disabledness on relevant non-disabled elements:
				// * listed form-associated elements in a disabled fieldset
				//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
				//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
				// * option elements in a disabled optgroup
				//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
				// All such elements have a "form" property.
				if ( elem.parentNode && elem.disabled === false ) {
	
					// Option elements defer to a parent optgroup if present
					if ( "label" in elem ) {
						if ( "label" in elem.parentNode ) {
							return elem.parentNode.disabled === disabled;
						} else {
							return elem.disabled === disabled;
						}
					}
	
					// Support: IE 6 - 11
					// Use the isDisabled shortcut property to check for disabled fieldset ancestors
					return elem.isDisabled === disabled ||
	
						// Where there is no isDisabled, check manually
						/* jshint -W018 */
						elem.isDisabled !== !disabled &&
							disabledAncestor( elem ) === disabled;
				}
	
				return elem.disabled === disabled;
	
			// Try to winnow out elements that can't be disabled before trusting the disabled property.
			// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
			// even exist on them, let alone have a boolean value.
			} else if ( "label" in elem ) {
				return elem.disabled === disabled;
			}
	
			// Remaining elements are neither :enabled nor :disabled
			return false;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for positionals
	 * @param {Function} fn
	 */
	function createPositionalPseudo( fn ) {
		return markFunction(function( argument ) {
			argument = +argument;
			return markFunction(function( seed, matches ) {
				var j,
					matchIndexes = fn( [], seed.length, argument ),
					i = matchIndexes.length;
	
				// Match elements found at the specified indexes
				while ( i-- ) {
					if ( seed[ (j = matchIndexes[i]) ] ) {
						seed[j] = !(matches[j] = seed[j]);
					}
				}
			});
		});
	}
	
	/**
	 * Checks a node for validity as a Sizzle context
	 * @param {Element|Object=} context
	 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
	 */
	function testContext( context ) {
		return context && typeof context.getElementsByTagName !== "undefined" && context;
	}
	
	// Expose support vars for convenience
	support = Sizzle.support = {};
	
	/**
	 * Detects XML nodes
	 * @param {Element|Object} elem An element or a document
	 * @returns {Boolean} True iff elem is a non-HTML XML node
	 */
	isXML = Sizzle.isXML = function( elem ) {
		// documentElement is verified for cases where it doesn't yet exist
		// (such as loading iframes in IE - #4833)
		var documentElement = elem && (elem.ownerDocument || elem).documentElement;
		return documentElement ? documentElement.nodeName !== "HTML" : false;
	};
	
	/**
	 * Sets document-related variables once based on the current document
	 * @param {Element|Object} [doc] An element or document object to use to set the document
	 * @returns {Object} Returns the current document
	 */
	setDocument = Sizzle.setDocument = function( node ) {
		var hasCompare, subWindow,
			doc = node ? node.ownerDocument || node : preferredDoc;
	
		// Return early if doc is invalid or already selected
		if ( doc === document || doc.nodeType !== 9 || !doc.documentElement ) {
			return document;
		}
	
		// Update global variables
		document = doc;
		docElem = document.documentElement;
		documentIsHTML = !isXML( document );
	
		// Support: IE 9-11, Edge
		// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
		if ( preferredDoc !== document &&
			(subWindow = document.defaultView) && subWindow.top !== subWindow ) {
	
			// Support: IE 11, Edge
			if ( subWindow.addEventListener ) {
				subWindow.addEventListener( "unload", unloadHandler, false );
	
			// Support: IE 9 - 10 only
			} else if ( subWindow.attachEvent ) {
				subWindow.attachEvent( "onunload", unloadHandler );
			}
		}
	
		/* Attributes
		---------------------------------------------------------------------- */
	
		// Support: IE<8
		// Verify that getAttribute really returns attributes and not properties
		// (excepting IE8 booleans)
		support.attributes = assert(function( el ) {
			el.className = "i";
			return !el.getAttribute("className");
		});
	
		/* getElement(s)By*
		---------------------------------------------------------------------- */
	
		// Check if getElementsByTagName("*") returns only elements
		support.getElementsByTagName = assert(function( el ) {
			el.appendChild( document.createComment("") );
			return !el.getElementsByTagName("*").length;
		});
	
		// Support: IE<9
		support.getElementsByClassName = rnative.test( document.getElementsByClassName );
	
		// Support: IE<10
		// Check if getElementById returns elements by name
		// The broken getElementById methods don't pick up programmatically-set names,
		// so use a roundabout getElementsByName test
		support.getById = assert(function( el ) {
			docElem.appendChild( el ).id = expando;
			return !document.getElementsByName || !document.getElementsByName( expando ).length;
		});
	
		// ID filter and find
		if ( support.getById ) {
			Expr.filter["ID"] = function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					return elem.getAttribute("id") === attrId;
				};
			};
			Expr.find["ID"] = function( id, context ) {
				if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
					var elem = context.getElementById( id );
					return elem ? [ elem ] : [];
				}
			};
		} else {
			Expr.filter["ID"] =  function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					var node = typeof elem.getAttributeNode !== "undefined" &&
						elem.getAttributeNode("id");
					return node && node.value === attrId;
				};
			};
	
			// Support: IE 6 - 7 only
			// getElementById is not reliable as a find shortcut
			Expr.find["ID"] = function( id, context ) {
				if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
					var node, i, elems,
						elem = context.getElementById( id );
	
					if ( elem ) {
	
						// Verify the id attribute
						node = elem.getAttributeNode("id");
						if ( node && node.value === id ) {
							return [ elem ];
						}
	
						// Fall back on getElementsByName
						elems = context.getElementsByName( id );
						i = 0;
						while ( (elem = elems[i++]) ) {
							node = elem.getAttributeNode("id");
							if ( node && node.value === id ) {
								return [ elem ];
							}
						}
					}
	
					return [];
				}
			};
		}
	
		// Tag
		Expr.find["TAG"] = support.getElementsByTagName ?
			function( tag, context ) {
				if ( typeof context.getElementsByTagName !== "undefined" ) {
					return context.getElementsByTagName( tag );
	
				// DocumentFragment nodes don't have gEBTN
				} else if ( support.qsa ) {
					return context.querySelectorAll( tag );
				}
			} :
	
			function( tag, context ) {
				var elem,
					tmp = [],
					i = 0,
					// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
					results = context.getElementsByTagName( tag );
	
				// Filter out possible comments
				if ( tag === "*" ) {
					while ( (elem = results[i++]) ) {
						if ( elem.nodeType === 1 ) {
							tmp.push( elem );
						}
					}
	
					return tmp;
				}
				return results;
			};
	
		// Class
		Expr.find["CLASS"] = support.getElementsByClassName && function( className, context ) {
			if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
				return context.getElementsByClassName( className );
			}
		};
	
		/* QSA/matchesSelector
		---------------------------------------------------------------------- */
	
		// QSA and matchesSelector support
	
		// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
		rbuggyMatches = [];
	
		// qSa(:focus) reports false when true (Chrome 21)
		// We allow this because of a bug in IE8/9 that throws an error
		// whenever `document.activeElement` is accessed on an iframe
		// So, we allow :focus to pass through QSA all the time to avoid the IE error
		// See https://bugs.jquery.com/ticket/13378
		rbuggyQSA = [];
	
		if ( (support.qsa = rnative.test( document.querySelectorAll )) ) {
			// Build QSA regex
			// Regex strategy adopted from Diego Perini
			assert(function( el ) {
				// Select is set to empty string on purpose
				// This is to test IE's treatment of not explicitly
				// setting a boolean content attribute,
				// since its presence should be enough
				// https://bugs.jquery.com/ticket/12359
				docElem.appendChild( el ).innerHTML = "<a id='" + expando + "'></a>" +
					"<select id='" + expando + "-\r\\' msallowcapture=''>" +
					"<option selected=''></option></select>";
	
				// Support: IE8, Opera 11-12.16
				// Nothing should be selected when empty strings follow ^= or $= or *=
				// The test attribute must be unknown in Opera but "safe" for WinRT
				// https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
				if ( el.querySelectorAll("[msallowcapture^='']").length ) {
					rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
				}
	
				// Support: IE8
				// Boolean attributes and "value" are not treated correctly
				if ( !el.querySelectorAll("[selected]").length ) {
					rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
				}
	
				// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
				if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
					rbuggyQSA.push("~=");
				}
	
				// Webkit/Opera - :checked should return selected option elements
				// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
				// IE8 throws error here and will not see later tests
				if ( !el.querySelectorAll(":checked").length ) {
					rbuggyQSA.push(":checked");
				}
	
				// Support: Safari 8+, iOS 8+
				// https://bugs.webkit.org/show_bug.cgi?id=136851
				// In-page `selector#id sibling-combinator selector` fails
				if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
					rbuggyQSA.push(".#.+[+~]");
				}
			});
	
			assert(function( el ) {
				el.innerHTML = "<a href='' disabled='disabled'></a>" +
					"<select disabled='disabled'><option/></select>";
	
				// Support: Windows 8 Native Apps
				// The type and name attributes are restricted during .innerHTML assignment
				var input = document.createElement("input");
				input.setAttribute( "type", "hidden" );
				el.appendChild( input ).setAttribute( "name", "D" );
	
				// Support: IE8
				// Enforce case-sensitivity of name attribute
				if ( el.querySelectorAll("[name=d]").length ) {
					rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
				}
	
				// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
				// IE8 throws error here and will not see later tests
				if ( el.querySelectorAll(":enabled").length !== 2 ) {
					rbuggyQSA.push( ":enabled", ":disabled" );
				}
	
				// Support: IE9-11+
				// IE's :disabled selector does not pick up the children of disabled fieldsets
				docElem.appendChild( el ).disabled = true;
				if ( el.querySelectorAll(":disabled").length !== 2 ) {
					rbuggyQSA.push( ":enabled", ":disabled" );
				}
	
				// Opera 10-11 does not throw on post-comma invalid pseudos
				el.querySelectorAll("*,:x");
				rbuggyQSA.push(",.*:");
			});
		}
	
		if ( (support.matchesSelector = rnative.test( (matches = docElem.matches ||
			docElem.webkitMatchesSelector ||
			docElem.mozMatchesSelector ||
			docElem.oMatchesSelector ||
			docElem.msMatchesSelector) )) ) {
	
			assert(function( el ) {
				// Check to see if it's possible to do matchesSelector
				// on a disconnected node (IE 9)
				support.disconnectedMatch = matches.call( el, "*" );
	
				// This should fail with an exception
				// Gecko does not error, returns false instead
				matches.call( el, "[s!='']:x" );
				rbuggyMatches.push( "!=", pseudos );
			});
		}
	
		rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join("|") );
		rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join("|") );
	
		/* Contains
		---------------------------------------------------------------------- */
		hasCompare = rnative.test( docElem.compareDocumentPosition );
	
		// Element contains another
		// Purposefully self-exclusive
		// As in, an element does not contain itself
		contains = hasCompare || rnative.test( docElem.contains ) ?
			function( a, b ) {
				var adown = a.nodeType === 9 ? a.documentElement : a,
					bup = b && b.parentNode;
				return a === bup || !!( bup && bup.nodeType === 1 && (
					adown.contains ?
						adown.contains( bup ) :
						a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
				));
			} :
			function( a, b ) {
				if ( b ) {
					while ( (b = b.parentNode) ) {
						if ( b === a ) {
							return true;
						}
					}
				}
				return false;
			};
	
		/* Sorting
		---------------------------------------------------------------------- */
	
		// Document order sorting
		sortOrder = hasCompare ?
		function( a, b ) {
	
			// Flag for duplicate removal
			if ( a === b ) {
				hasDuplicate = true;
				return 0;
			}
	
			// Sort on method existence if only one input has compareDocumentPosition
			var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
			if ( compare ) {
				return compare;
			}
	
			// Calculate position if both inputs belong to the same document
			compare = ( a.ownerDocument || a ) === ( b.ownerDocument || b ) ?
				a.compareDocumentPosition( b ) :
	
				// Otherwise we know they are disconnected
				1;
	
			// Disconnected nodes
			if ( compare & 1 ||
				(!support.sortDetached && b.compareDocumentPosition( a ) === compare) ) {
	
				// Choose the first element that is related to our preferred document
				if ( a === document || a.ownerDocument === preferredDoc && contains(preferredDoc, a) ) {
					return -1;
				}
				if ( b === document || b.ownerDocument === preferredDoc && contains(preferredDoc, b) ) {
					return 1;
				}
	
				// Maintain original order
				return sortInput ?
					( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
					0;
			}
	
			return compare & 4 ? -1 : 1;
		} :
		function( a, b ) {
			// Exit early if the nodes are identical
			if ( a === b ) {
				hasDuplicate = true;
				return 0;
			}
	
			var cur,
				i = 0,
				aup = a.parentNode,
				bup = b.parentNode,
				ap = [ a ],
				bp = [ b ];
	
			// Parentless nodes are either documents or disconnected
			if ( !aup || !bup ) {
				return a === document ? -1 :
					b === document ? 1 :
					aup ? -1 :
					bup ? 1 :
					sortInput ?
					( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
					0;
	
			// If the nodes are siblings, we can do a quick check
			} else if ( aup === bup ) {
				return siblingCheck( a, b );
			}
	
			// Otherwise we need full lists of their ancestors for comparison
			cur = a;
			while ( (cur = cur.parentNode) ) {
				ap.unshift( cur );
			}
			cur = b;
			while ( (cur = cur.parentNode) ) {
				bp.unshift( cur );
			}
	
			// Walk down the tree looking for a discrepancy
			while ( ap[i] === bp[i] ) {
				i++;
			}
	
			return i ?
				// Do a sibling check if the nodes have a common ancestor
				siblingCheck( ap[i], bp[i] ) :
	
				// Otherwise nodes in our document sort first
				ap[i] === preferredDoc ? -1 :
				bp[i] === preferredDoc ? 1 :
				0;
		};
	
		return document;
	};
	
	Sizzle.matches = function( expr, elements ) {
		return Sizzle( expr, null, null, elements );
	};
	
	Sizzle.matchesSelector = function( elem, expr ) {
		// Set document vars if needed
		if ( ( elem.ownerDocument || elem ) !== document ) {
			setDocument( elem );
		}
	
		// Make sure that attribute selectors are quoted
		expr = expr.replace( rattributeQuotes, "='$1']" );
	
		if ( support.matchesSelector && documentIsHTML &&
			!compilerCache[ expr + " " ] &&
			( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
			( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {
	
			try {
				var ret = matches.call( elem, expr );
	
				// IE 9's matchesSelector returns false on disconnected nodes
				if ( ret || support.disconnectedMatch ||
						// As well, disconnected nodes are said to be in a document
						// fragment in IE 9
						elem.document && elem.document.nodeType !== 11 ) {
					return ret;
				}
			} catch (e) {}
		}
	
		return Sizzle( expr, document, null, [ elem ] ).length > 0;
	};
	
	Sizzle.contains = function( context, elem ) {
		// Set document vars if needed
		if ( ( context.ownerDocument || context ) !== document ) {
			setDocument( context );
		}
		return contains( context, elem );
	};
	
	Sizzle.attr = function( elem, name ) {
		// Set document vars if needed
		if ( ( elem.ownerDocument || elem ) !== document ) {
			setDocument( elem );
		}
	
		var fn = Expr.attrHandle[ name.toLowerCase() ],
			// Don't get fooled by Object.prototype properties (jQuery #13807)
			val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
				fn( elem, name, !documentIsHTML ) :
				undefined;
	
		return val !== undefined ?
			val :
			support.attributes || !documentIsHTML ?
				elem.getAttribute( name ) :
				(val = elem.getAttributeNode(name)) && val.specified ?
					val.value :
					null;
	};
	
	Sizzle.escape = function( sel ) {
		return (sel + "").replace( rcssescape, fcssescape );
	};
	
	Sizzle.error = function( msg ) {
		throw new Error( "Syntax error, unrecognized expression: " + msg );
	};
	
	/**
	 * Document sorting and removing duplicates
	 * @param {ArrayLike} results
	 */
	Sizzle.uniqueSort = function( results ) {
		var elem,
			duplicates = [],
			j = 0,
			i = 0;
	
		// Unless we *know* we can detect duplicates, assume their presence
		hasDuplicate = !support.detectDuplicates;
		sortInput = !support.sortStable && results.slice( 0 );
		results.sort( sortOrder );
	
		if ( hasDuplicate ) {
			while ( (elem = results[i++]) ) {
				if ( elem === results[ i ] ) {
					j = duplicates.push( i );
				}
			}
			while ( j-- ) {
				results.splice( duplicates[ j ], 1 );
			}
		}
	
		// Clear input after sorting to release objects
		// See https://github.com/jquery/sizzle/pull/225
		sortInput = null;
	
		return results;
	};
	
	/**
	 * Utility function for retrieving the text value of an array of DOM nodes
	 * @param {Array|Element} elem
	 */
	getText = Sizzle.getText = function( elem ) {
		var node,
			ret = "",
			i = 0,
			nodeType = elem.nodeType;
	
		if ( !nodeType ) {
			// If no nodeType, this is expected to be an array
			while ( (node = elem[i++]) ) {
				// Do not traverse comment nodes
				ret += getText( node );
			}
		} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
			// Use textContent for elements
			// innerText usage removed for consistency of new lines (jQuery #11153)
			if ( typeof elem.textContent === "string" ) {
				return elem.textContent;
			} else {
				// Traverse its children
				for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
					ret += getText( elem );
				}
			}
		} else if ( nodeType === 3 || nodeType === 4 ) {
			return elem.nodeValue;
		}
		// Do not include comment or processing instruction nodes
	
		return ret;
	};
	
	Expr = Sizzle.selectors = {
	
		// Can be adjusted by the user
		cacheLength: 50,
	
		createPseudo: markFunction,
	
		match: matchExpr,
	
		attrHandle: {},
	
		find: {},
	
		relative: {
			">": { dir: "parentNode", first: true },
			" ": { dir: "parentNode" },
			"+": { dir: "previousSibling", first: true },
			"~": { dir: "previousSibling" }
		},
	
		preFilter: {
			"ATTR": function( match ) {
				match[1] = match[1].replace( runescape, funescape );
	
				// Move the given value to match[3] whether quoted or unquoted
				match[3] = ( match[3] || match[4] || match[5] || "" ).replace( runescape, funescape );
	
				if ( match[2] === "~=" ) {
					match[3] = " " + match[3] + " ";
				}
	
				return match.slice( 0, 4 );
			},
	
			"CHILD": function( match ) {
				/* matches from matchExpr["CHILD"]
					1 type (only|nth|...)
					2 what (child|of-type)
					3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
					4 xn-component of xn+y argument ([+-]?\d*n|)
					5 sign of xn-component
					6 x of xn-component
					7 sign of y-component
					8 y of y-component
				*/
				match[1] = match[1].toLowerCase();
	
				if ( match[1].slice( 0, 3 ) === "nth" ) {
					// nth-* requires argument
					if ( !match[3] ) {
						Sizzle.error( match[0] );
					}
	
					// numeric x and y parameters for Expr.filter.CHILD
					// remember that false/true cast respectively to 0/1
					match[4] = +( match[4] ? match[5] + (match[6] || 1) : 2 * ( match[3] === "even" || match[3] === "odd" ) );
					match[5] = +( ( match[7] + match[8] ) || match[3] === "odd" );
	
				// other types prohibit arguments
				} else if ( match[3] ) {
					Sizzle.error( match[0] );
				}
	
				return match;
			},
	
			"PSEUDO": function( match ) {
				var excess,
					unquoted = !match[6] && match[2];
	
				if ( matchExpr["CHILD"].test( match[0] ) ) {
					return null;
				}
	
				// Accept quoted arguments as-is
				if ( match[3] ) {
					match[2] = match[4] || match[5] || "";
	
				// Strip excess characters from unquoted arguments
				} else if ( unquoted && rpseudo.test( unquoted ) &&
					// Get excess from tokenize (recursively)
					(excess = tokenize( unquoted, true )) &&
					// advance to the next closing parenthesis
					(excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length) ) {
	
					// excess is a negative index
					match[0] = match[0].slice( 0, excess );
					match[2] = unquoted.slice( 0, excess );
				}
	
				// Return only captures needed by the pseudo filter method (type and argument)
				return match.slice( 0, 3 );
			}
		},
	
		filter: {
	
			"TAG": function( nodeNameSelector ) {
				var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
				return nodeNameSelector === "*" ?
					function() { return true; } :
					function( elem ) {
						return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
					};
			},
	
			"CLASS": function( className ) {
				var pattern = classCache[ className + " " ];
	
				return pattern ||
					(pattern = new RegExp( "(^|" + whitespace + ")" + className + "(" + whitespace + "|$)" )) &&
					classCache( className, function( elem ) {
						return pattern.test( typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "" );
					});
			},
	
			"ATTR": function( name, operator, check ) {
				return function( elem ) {
					var result = Sizzle.attr( elem, name );
	
					if ( result == null ) {
						return operator === "!=";
					}
					if ( !operator ) {
						return true;
					}
	
					result += "";
	
					return operator === "=" ? result === check :
						operator === "!=" ? result !== check :
						operator === "^=" ? check && result.indexOf( check ) === 0 :
						operator === "*=" ? check && result.indexOf( check ) > -1 :
						operator === "$=" ? check && result.slice( -check.length ) === check :
						operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
						operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
						false;
				};
			},
	
			"CHILD": function( type, what, argument, first, last ) {
				var simple = type.slice( 0, 3 ) !== "nth",
					forward = type.slice( -4 ) !== "last",
					ofType = what === "of-type";
	
				return first === 1 && last === 0 ?
	
					// Shortcut for :nth-*(n)
					function( elem ) {
						return !!elem.parentNode;
					} :
	
					function( elem, context, xml ) {
						var cache, uniqueCache, outerCache, node, nodeIndex, start,
							dir = simple !== forward ? "nextSibling" : "previousSibling",
							parent = elem.parentNode,
							name = ofType && elem.nodeName.toLowerCase(),
							useCache = !xml && !ofType,
							diff = false;
	
						if ( parent ) {
	
							// :(first|last|only)-(child|of-type)
							if ( simple ) {
								while ( dir ) {
									node = elem;
									while ( (node = node[ dir ]) ) {
										if ( ofType ?
											node.nodeName.toLowerCase() === name :
											node.nodeType === 1 ) {
	
											return false;
										}
									}
									// Reverse direction for :only-* (if we haven't yet done so)
									start = dir = type === "only" && !start && "nextSibling";
								}
								return true;
							}
	
							start = [ forward ? parent.firstChild : parent.lastChild ];
	
							// non-xml :nth-child(...) stores cache data on `parent`
							if ( forward && useCache ) {
	
								// Seek `elem` from a previously-cached index
	
								// ...in a gzip-friendly way
								node = parent;
								outerCache = node[ expando ] || (node[ expando ] = {});
	
								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[ node.uniqueID ] ||
									(outerCache[ node.uniqueID ] = {});
	
								cache = uniqueCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex && cache[ 2 ];
								node = nodeIndex && parent.childNodes[ nodeIndex ];
	
								while ( (node = ++nodeIndex && node && node[ dir ] ||
	
									// Fallback to seeking `elem` from the start
									(diff = nodeIndex = 0) || start.pop()) ) {
	
									// When found, cache indexes on `parent` and break
									if ( node.nodeType === 1 && ++diff && node === elem ) {
										uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
										break;
									}
								}
	
							} else {
								// Use previously-cached element index if available
								if ( useCache ) {
									// ...in a gzip-friendly way
									node = elem;
									outerCache = node[ expando ] || (node[ expando ] = {});
	
									// Support: IE <9 only
									// Defend against cloned attroperties (jQuery gh-1709)
									uniqueCache = outerCache[ node.uniqueID ] ||
										(outerCache[ node.uniqueID ] = {});
	
									cache = uniqueCache[ type ] || [];
									nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
									diff = nodeIndex;
								}
	
								// xml :nth-child(...)
								// or :nth-last-child(...) or :nth(-last)?-of-type(...)
								if ( diff === false ) {
									// Use the same loop as above to seek `elem` from the start
									while ( (node = ++nodeIndex && node && node[ dir ] ||
										(diff = nodeIndex = 0) || start.pop()) ) {
	
										if ( ( ofType ?
											node.nodeName.toLowerCase() === name :
											node.nodeType === 1 ) &&
											++diff ) {
	
											// Cache the index of each encountered element
											if ( useCache ) {
												outerCache = node[ expando ] || (node[ expando ] = {});
	
												// Support: IE <9 only
												// Defend against cloned attroperties (jQuery gh-1709)
												uniqueCache = outerCache[ node.uniqueID ] ||
													(outerCache[ node.uniqueID ] = {});
	
												uniqueCache[ type ] = [ dirruns, diff ];
											}
	
											if ( node === elem ) {
												break;
											}
										}
									}
								}
							}
	
							// Incorporate the offset, then check against cycle size
							diff -= last;
							return diff === first || ( diff % first === 0 && diff / first >= 0 );
						}
					};
			},
	
			"PSEUDO": function( pseudo, argument ) {
				// pseudo-class names are case-insensitive
				// http://www.w3.org/TR/selectors/#pseudo-classes
				// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
				// Remember that setFilters inherits from pseudos
				var args,
					fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
						Sizzle.error( "unsupported pseudo: " + pseudo );
	
				// The user may use createPseudo to indicate that
				// arguments are needed to create the filter function
				// just as Sizzle does
				if ( fn[ expando ] ) {
					return fn( argument );
				}
	
				// But maintain support for old signatures
				if ( fn.length > 1 ) {
					args = [ pseudo, pseudo, "", argument ];
					return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
						markFunction(function( seed, matches ) {
							var idx,
								matched = fn( seed, argument ),
								i = matched.length;
							while ( i-- ) {
								idx = indexOf( seed, matched[i] );
								seed[ idx ] = !( matches[ idx ] = matched[i] );
							}
						}) :
						function( elem ) {
							return fn( elem, 0, args );
						};
				}
	
				return fn;
			}
		},
	
		pseudos: {
			// Potentially complex pseudos
			"not": markFunction(function( selector ) {
				// Trim the selector passed to compile
				// to avoid treating leading and trailing
				// spaces as combinators
				var input = [],
					results = [],
					matcher = compile( selector.replace( rtrim, "$1" ) );
	
				return matcher[ expando ] ?
					markFunction(function( seed, matches, context, xml ) {
						var elem,
							unmatched = matcher( seed, null, xml, [] ),
							i = seed.length;
	
						// Match elements unmatched by `matcher`
						while ( i-- ) {
							if ( (elem = unmatched[i]) ) {
								seed[i] = !(matches[i] = elem);
							}
						}
					}) :
					function( elem, context, xml ) {
						input[0] = elem;
						matcher( input, null, xml, results );
						// Don't keep the element (issue #299)
						input[0] = null;
						return !results.pop();
					};
			}),
	
			"has": markFunction(function( selector ) {
				return function( elem ) {
					return Sizzle( selector, elem ).length > 0;
				};
			}),
	
			"contains": markFunction(function( text ) {
				text = text.replace( runescape, funescape );
				return function( elem ) {
					return ( elem.textContent || elem.innerText || getText( elem ) ).indexOf( text ) > -1;
				};
			}),
	
			// "Whether an element is represented by a :lang() selector
			// is based solely on the element's language value
			// being equal to the identifier C,
			// or beginning with the identifier C immediately followed by "-".
			// The matching of C against the element's language value is performed case-insensitively.
			// The identifier C does not have to be a valid language name."
			// http://www.w3.org/TR/selectors/#lang-pseudo
			"lang": markFunction( function( lang ) {
				// lang value must be a valid identifier
				if ( !ridentifier.test(lang || "") ) {
					Sizzle.error( "unsupported lang: " + lang );
				}
				lang = lang.replace( runescape, funescape ).toLowerCase();
				return function( elem ) {
					var elemLang;
					do {
						if ( (elemLang = documentIsHTML ?
							elem.lang :
							elem.getAttribute("xml:lang") || elem.getAttribute("lang")) ) {
	
							elemLang = elemLang.toLowerCase();
							return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
						}
					} while ( (elem = elem.parentNode) && elem.nodeType === 1 );
					return false;
				};
			}),
	
			// Miscellaneous
			"target": function( elem ) {
				var hash = window.location && window.location.hash;
				return hash && hash.slice( 1 ) === elem.id;
			},
	
			"root": function( elem ) {
				return elem === docElem;
			},
	
			"focus": function( elem ) {
				return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
			},
	
			// Boolean properties
			"enabled": createDisabledPseudo( false ),
			"disabled": createDisabledPseudo( true ),
	
			"checked": function( elem ) {
				// In CSS3, :checked should return both checked and selected elements
				// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
				var nodeName = elem.nodeName.toLowerCase();
				return (nodeName === "input" && !!elem.checked) || (nodeName === "option" && !!elem.selected);
			},
	
			"selected": function( elem ) {
				// Accessing this property makes selected-by-default
				// options in Safari work properly
				if ( elem.parentNode ) {
					elem.parentNode.selectedIndex;
				}
	
				return elem.selected === true;
			},
	
			// Contents
			"empty": function( elem ) {
				// http://www.w3.org/TR/selectors/#empty-pseudo
				// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
				//   but not by others (comment: 8; processing instruction: 7; etc.)
				// nodeType < 6 works because attributes (2) do not appear as children
				for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
					if ( elem.nodeType < 6 ) {
						return false;
					}
				}
				return true;
			},
	
			"parent": function( elem ) {
				return !Expr.pseudos["empty"]( elem );
			},
	
			// Element/input types
			"header": function( elem ) {
				return rheader.test( elem.nodeName );
			},
	
			"input": function( elem ) {
				return rinputs.test( elem.nodeName );
			},
	
			"button": function( elem ) {
				var name = elem.nodeName.toLowerCase();
				return name === "input" && elem.type === "button" || name === "button";
			},
	
			"text": function( elem ) {
				var attr;
				return elem.nodeName.toLowerCase() === "input" &&
					elem.type === "text" &&
	
					// Support: IE<8
					// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
					( (attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text" );
			},
	
			// Position-in-collection
			"first": createPositionalPseudo(function() {
				return [ 0 ];
			}),
	
			"last": createPositionalPseudo(function( matchIndexes, length ) {
				return [ length - 1 ];
			}),
	
			"eq": createPositionalPseudo(function( matchIndexes, length, argument ) {
				return [ argument < 0 ? argument + length : argument ];
			}),
	
			"even": createPositionalPseudo(function( matchIndexes, length ) {
				var i = 0;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"odd": createPositionalPseudo(function( matchIndexes, length ) {
				var i = 1;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"lt": createPositionalPseudo(function( matchIndexes, length, argument ) {
				var i = argument < 0 ? argument + length : argument;
				for ( ; --i >= 0; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"gt": createPositionalPseudo(function( matchIndexes, length, argument ) {
				var i = argument < 0 ? argument + length : argument;
				for ( ; ++i < length; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			})
		}
	};
	
	Expr.pseudos["nth"] = Expr.pseudos["eq"];
	
	// Add button/input type pseudos
	for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
		Expr.pseudos[ i ] = createInputPseudo( i );
	}
	for ( i in { submit: true, reset: true } ) {
		Expr.pseudos[ i ] = createButtonPseudo( i );
	}
	
	// Easy API for creating new setFilters
	function setFilters() {}
	setFilters.prototype = Expr.filters = Expr.pseudos;
	Expr.setFilters = new setFilters();
	
	tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
		var matched, match, tokens, type,
			soFar, groups, preFilters,
			cached = tokenCache[ selector + " " ];
	
		if ( cached ) {
			return parseOnly ? 0 : cached.slice( 0 );
		}
	
		soFar = selector;
		groups = [];
		preFilters = Expr.preFilter;
	
		while ( soFar ) {
	
			// Comma and first run
			if ( !matched || (match = rcomma.exec( soFar )) ) {
				if ( match ) {
					// Don't consume trailing commas as valid
					soFar = soFar.slice( match[0].length ) || soFar;
				}
				groups.push( (tokens = []) );
			}
	
			matched = false;
	
			// Combinators
			if ( (match = rcombinators.exec( soFar )) ) {
				matched = match.shift();
				tokens.push({
					value: matched,
					// Cast descendant combinators to space
					type: match[0].replace( rtrim, " " )
				});
				soFar = soFar.slice( matched.length );
			}
	
			// Filters
			for ( type in Expr.filter ) {
				if ( (match = matchExpr[ type ].exec( soFar )) && (!preFilters[ type ] ||
					(match = preFilters[ type ]( match ))) ) {
					matched = match.shift();
					tokens.push({
						value: matched,
						type: type,
						matches: match
					});
					soFar = soFar.slice( matched.length );
				}
			}
	
			if ( !matched ) {
				break;
			}
		}
	
		// Return the length of the invalid excess
		// if we're just parsing
		// Otherwise, throw an error or return tokens
		return parseOnly ?
			soFar.length :
			soFar ?
				Sizzle.error( selector ) :
				// Cache the tokens
				tokenCache( selector, groups ).slice( 0 );
	};
	
	function toSelector( tokens ) {
		var i = 0,
			len = tokens.length,
			selector = "";
		for ( ; i < len; i++ ) {
			selector += tokens[i].value;
		}
		return selector;
	}
	
	function addCombinator( matcher, combinator, base ) {
		var dir = combinator.dir,
			skip = combinator.next,
			key = skip || dir,
			checkNonElements = base && key === "parentNode",
			doneName = done++;
	
		return combinator.first ?
			// Check against closest ancestor/preceding element
			function( elem, context, xml ) {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						return matcher( elem, context, xml );
					}
				}
				return false;
			} :
	
			// Check against all ancestor/preceding elements
			function( elem, context, xml ) {
				var oldCache, uniqueCache, outerCache,
					newCache = [ dirruns, doneName ];
	
				// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
				if ( xml ) {
					while ( (elem = elem[ dir ]) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							if ( matcher( elem, context, xml ) ) {
								return true;
							}
						}
					}
				} else {
					while ( (elem = elem[ dir ]) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							outerCache = elem[ expando ] || (elem[ expando ] = {});
	
							// Support: IE <9 only
							// Defend against cloned attroperties (jQuery gh-1709)
							uniqueCache = outerCache[ elem.uniqueID ] || (outerCache[ elem.uniqueID ] = {});
	
							if ( skip && skip === elem.nodeName.toLowerCase() ) {
								elem = elem[ dir ] || elem;
							} else if ( (oldCache = uniqueCache[ key ]) &&
								oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {
	
								// Assign to newCache so results back-propagate to previous elements
								return (newCache[ 2 ] = oldCache[ 2 ]);
							} else {
								// Reuse newcache so results back-propagate to previous elements
								uniqueCache[ key ] = newCache;
	
								// A match means we're done; a fail means we have to keep checking
								if ( (newCache[ 2 ] = matcher( elem, context, xml )) ) {
									return true;
								}
							}
						}
					}
				}
				return false;
			};
	}
	
	function elementMatcher( matchers ) {
		return matchers.length > 1 ?
			function( elem, context, xml ) {
				var i = matchers.length;
				while ( i-- ) {
					if ( !matchers[i]( elem, context, xml ) ) {
						return false;
					}
				}
				return true;
			} :
			matchers[0];
	}
	
	function multipleContexts( selector, contexts, results ) {
		var i = 0,
			len = contexts.length;
		for ( ; i < len; i++ ) {
			Sizzle( selector, contexts[i], results );
		}
		return results;
	}
	
	function condense( unmatched, map, filter, context, xml ) {
		var elem,
			newUnmatched = [],
			i = 0,
			len = unmatched.length,
			mapped = map != null;
	
		for ( ; i < len; i++ ) {
			if ( (elem = unmatched[i]) ) {
				if ( !filter || filter( elem, context, xml ) ) {
					newUnmatched.push( elem );
					if ( mapped ) {
						map.push( i );
					}
				}
			}
		}
	
		return newUnmatched;
	}
	
	function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
		if ( postFilter && !postFilter[ expando ] ) {
			postFilter = setMatcher( postFilter );
		}
		if ( postFinder && !postFinder[ expando ] ) {
			postFinder = setMatcher( postFinder, postSelector );
		}
		return markFunction(function( seed, results, context, xml ) {
			var temp, i, elem,
				preMap = [],
				postMap = [],
				preexisting = results.length,
	
				// Get initial elements from seed or context
				elems = seed || multipleContexts( selector || "*", context.nodeType ? [ context ] : context, [] ),
	
				// Prefilter to get matcher input, preserving a map for seed-results synchronization
				matcherIn = preFilter && ( seed || !selector ) ?
					condense( elems, preMap, preFilter, context, xml ) :
					elems,
	
				matcherOut = matcher ?
					// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
					postFinder || ( seed ? preFilter : preexisting || postFilter ) ?
	
						// ...intermediate processing is necessary
						[] :
	
						// ...otherwise use results directly
						results :
					matcherIn;
	
			// Find primary matches
			if ( matcher ) {
				matcher( matcherIn, matcherOut, context, xml );
			}
	
			// Apply postFilter
			if ( postFilter ) {
				temp = condense( matcherOut, postMap );
				postFilter( temp, [], context, xml );
	
				// Un-match failing elements by moving them back to matcherIn
				i = temp.length;
				while ( i-- ) {
					if ( (elem = temp[i]) ) {
						matcherOut[ postMap[i] ] = !(matcherIn[ postMap[i] ] = elem);
					}
				}
			}
	
			if ( seed ) {
				if ( postFinder || preFilter ) {
					if ( postFinder ) {
						// Get the final matcherOut by condensing this intermediate into postFinder contexts
						temp = [];
						i = matcherOut.length;
						while ( i-- ) {
							if ( (elem = matcherOut[i]) ) {
								// Restore matcherIn since elem is not yet a final match
								temp.push( (matcherIn[i] = elem) );
							}
						}
						postFinder( null, (matcherOut = []), temp, xml );
					}
	
					// Move matched elements from seed to results to keep them synchronized
					i = matcherOut.length;
					while ( i-- ) {
						if ( (elem = matcherOut[i]) &&
							(temp = postFinder ? indexOf( seed, elem ) : preMap[i]) > -1 ) {
	
							seed[temp] = !(results[temp] = elem);
						}
					}
				}
	
			// Add elements to results, through postFinder if defined
			} else {
				matcherOut = condense(
					matcherOut === results ?
						matcherOut.splice( preexisting, matcherOut.length ) :
						matcherOut
				);
				if ( postFinder ) {
					postFinder( null, results, matcherOut, xml );
				} else {
					push.apply( results, matcherOut );
				}
			}
		});
	}
	
	function matcherFromTokens( tokens ) {
		var checkContext, matcher, j,
			len = tokens.length,
			leadingRelative = Expr.relative[ tokens[0].type ],
			implicitRelative = leadingRelative || Expr.relative[" "],
			i = leadingRelative ? 1 : 0,
	
			// The foundational matcher ensures that elements are reachable from top-level context(s)
			matchContext = addCombinator( function( elem ) {
				return elem === checkContext;
			}, implicitRelative, true ),
			matchAnyContext = addCombinator( function( elem ) {
				return indexOf( checkContext, elem ) > -1;
			}, implicitRelative, true ),
			matchers = [ function( elem, context, xml ) {
				var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
					(checkContext = context).nodeType ?
						matchContext( elem, context, xml ) :
						matchAnyContext( elem, context, xml ) );
				// Avoid hanging onto element (issue #299)
				checkContext = null;
				return ret;
			} ];
	
		for ( ; i < len; i++ ) {
			if ( (matcher = Expr.relative[ tokens[i].type ]) ) {
				matchers = [ addCombinator(elementMatcher( matchers ), matcher) ];
			} else {
				matcher = Expr.filter[ tokens[i].type ].apply( null, tokens[i].matches );
	
				// Return special upon seeing a positional matcher
				if ( matcher[ expando ] ) {
					// Find the next relative operator (if any) for proper handling
					j = ++i;
					for ( ; j < len; j++ ) {
						if ( Expr.relative[ tokens[j].type ] ) {
							break;
						}
					}
					return setMatcher(
						i > 1 && elementMatcher( matchers ),
						i > 1 && toSelector(
							// If the preceding token was a descendant combinator, insert an implicit any-element `*`
							tokens.slice( 0, i - 1 ).concat({ value: tokens[ i - 2 ].type === " " ? "*" : "" })
						).replace( rtrim, "$1" ),
						matcher,
						i < j && matcherFromTokens( tokens.slice( i, j ) ),
						j < len && matcherFromTokens( (tokens = tokens.slice( j )) ),
						j < len && toSelector( tokens )
					);
				}
				matchers.push( matcher );
			}
		}
	
		return elementMatcher( matchers );
	}
	
	function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
		var bySet = setMatchers.length > 0,
			byElement = elementMatchers.length > 0,
			superMatcher = function( seed, context, xml, results, outermost ) {
				var elem, j, matcher,
					matchedCount = 0,
					i = "0",
					unmatched = seed && [],
					setMatched = [],
					contextBackup = outermostContext,
					// We must always have either seed elements or outermost context
					elems = seed || byElement && Expr.find["TAG"]( "*", outermost ),
					// Use integer dirruns iff this is the outermost matcher
					dirrunsUnique = (dirruns += contextBackup == null ? 1 : Math.random() || 0.1),
					len = elems.length;
	
				if ( outermost ) {
					outermostContext = context === document || context || outermost;
				}
	
				// Add elements passing elementMatchers directly to results
				// Support: IE<9, Safari
				// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
				for ( ; i !== len && (elem = elems[i]) != null; i++ ) {
					if ( byElement && elem ) {
						j = 0;
						if ( !context && elem.ownerDocument !== document ) {
							setDocument( elem );
							xml = !documentIsHTML;
						}
						while ( (matcher = elementMatchers[j++]) ) {
							if ( matcher( elem, context || document, xml) ) {
								results.push( elem );
								break;
							}
						}
						if ( outermost ) {
							dirruns = dirrunsUnique;
						}
					}
	
					// Track unmatched elements for set filters
					if ( bySet ) {
						// They will have gone through all possible matchers
						if ( (elem = !matcher && elem) ) {
							matchedCount--;
						}
	
						// Lengthen the array for every element, matched or not
						if ( seed ) {
							unmatched.push( elem );
						}
					}
				}
	
				// `i` is now the count of elements visited above, and adding it to `matchedCount`
				// makes the latter nonnegative.
				matchedCount += i;
	
				// Apply set filters to unmatched elements
				// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
				// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
				// no element matchers and no seed.
				// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
				// case, which will result in a "00" `matchedCount` that differs from `i` but is also
				// numerically zero.
				if ( bySet && i !== matchedCount ) {
					j = 0;
					while ( (matcher = setMatchers[j++]) ) {
						matcher( unmatched, setMatched, context, xml );
					}
	
					if ( seed ) {
						// Reintegrate element matches to eliminate the need for sorting
						if ( matchedCount > 0 ) {
							while ( i-- ) {
								if ( !(unmatched[i] || setMatched[i]) ) {
									setMatched[i] = pop.call( results );
								}
							}
						}
	
						// Discard index placeholder values to get only actual matches
						setMatched = condense( setMatched );
					}
	
					// Add matches to results
					push.apply( results, setMatched );
	
					// Seedless set matches succeeding multiple successful matchers stipulate sorting
					if ( outermost && !seed && setMatched.length > 0 &&
						( matchedCount + setMatchers.length ) > 1 ) {
	
						Sizzle.uniqueSort( results );
					}
				}
	
				// Override manipulation of globals by nested matchers
				if ( outermost ) {
					dirruns = dirrunsUnique;
					outermostContext = contextBackup;
				}
	
				return unmatched;
			};
	
		return bySet ?
			markFunction( superMatcher ) :
			superMatcher;
	}
	
	compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
		var i,
			setMatchers = [],
			elementMatchers = [],
			cached = compilerCache[ selector + " " ];
	
		if ( !cached ) {
			// Generate a function of recursive functions that can be used to check each element
			if ( !match ) {
				match = tokenize( selector );
			}
			i = match.length;
			while ( i-- ) {
				cached = matcherFromTokens( match[i] );
				if ( cached[ expando ] ) {
					setMatchers.push( cached );
				} else {
					elementMatchers.push( cached );
				}
			}
	
			// Cache the compiled function
			cached = compilerCache( selector, matcherFromGroupMatchers( elementMatchers, setMatchers ) );
	
			// Save selector and tokenization
			cached.selector = selector;
		}
		return cached;
	};
	
	/**
	 * A low-level selection function that works with Sizzle's compiled
	 *  selector functions
	 * @param {String|Function} selector A selector or a pre-compiled
	 *  selector function built with Sizzle.compile
	 * @param {Element} context
	 * @param {Array} [results]
	 * @param {Array} [seed] A set of elements to match against
	 */
	select = Sizzle.select = function( selector, context, results, seed ) {
		var i, tokens, token, type, find,
			compiled = typeof selector === "function" && selector,
			match = !seed && tokenize( (selector = compiled.selector || selector) );
	
		results = results || [];
	
		// Try to minimize operations if there is only one selector in the list and no seed
		// (the latter of which guarantees us context)
		if ( match.length === 1 ) {
	
			// Reduce context if the leading compound selector is an ID
			tokens = match[0] = match[0].slice( 0 );
			if ( tokens.length > 2 && (token = tokens[0]).type === "ID" &&
					context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[1].type ] ) {
	
				context = ( Expr.find["ID"]( token.matches[0].replace(runescape, funescape), context ) || [] )[0];
				if ( !context ) {
					return results;
	
				// Precompiled matchers will still verify ancestry, so step up a level
				} else if ( compiled ) {
					context = context.parentNode;
				}
	
				selector = selector.slice( tokens.shift().value.length );
			}
	
			// Fetch a seed set for right-to-left matching
			i = matchExpr["needsContext"].test( selector ) ? 0 : tokens.length;
			while ( i-- ) {
				token = tokens[i];
	
				// Abort if we hit a combinator
				if ( Expr.relative[ (type = token.type) ] ) {
					break;
				}
				if ( (find = Expr.find[ type ]) ) {
					// Search, expanding context for leading sibling combinators
					if ( (seed = find(
						token.matches[0].replace( runescape, funescape ),
						rsibling.test( tokens[0].type ) && testContext( context.parentNode ) || context
					)) ) {
	
						// If seed is empty or no tokens remain, we can return early
						tokens.splice( i, 1 );
						selector = seed.length && toSelector( tokens );
						if ( !selector ) {
							push.apply( results, seed );
							return results;
						}
	
						break;
					}
				}
			}
		}
	
		// Compile and execute a filtering function if one is not provided
		// Provide `match` to avoid retokenization if we modified the selector above
		( compiled || compile( selector, match ) )(
			seed,
			context,
			!documentIsHTML,
			results,
			!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
		);
		return results;
	};
	
	// One-time assignments
	
	// Sort stability
	support.sortStable = expando.split("").sort( sortOrder ).join("") === expando;
	
	// Support: Chrome 14-35+
	// Always assume duplicates if they aren't passed to the comparison function
	support.detectDuplicates = !!hasDuplicate;
	
	// Initialize against the default document
	setDocument();
	
	// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
	// Detached nodes confoundingly follow *each other*
	support.sortDetached = assert(function( el ) {
		// Should return 1, but returns 4 (following)
		return el.compareDocumentPosition( document.createElement("fieldset") ) & 1;
	});
	
	// Support: IE<8
	// Prevent attribute/property "interpolation"
	// https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
	if ( !assert(function( el ) {
		el.innerHTML = "<a href='#'></a>";
		return el.firstChild.getAttribute("href") === "#" ;
	}) ) {
		addHandle( "type|href|height|width", function( elem, name, isXML ) {
			if ( !isXML ) {
				return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
			}
		});
	}
	
	// Support: IE<9
	// Use defaultValue in place of getAttribute("value")
	if ( !support.attributes || !assert(function( el ) {
		el.innerHTML = "<input/>";
		el.firstChild.setAttribute( "value", "" );
		return el.firstChild.getAttribute( "value" ) === "";
	}) ) {
		addHandle( "value", function( elem, name, isXML ) {
			if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
				return elem.defaultValue;
			}
		});
	}
	
	// Support: IE<9
	// Use getAttributeNode to fetch booleans when getAttribute lies
	if ( !assert(function( el ) {
		return el.getAttribute("disabled") == null;
	}) ) {
		addHandle( booleans, function( elem, name, isXML ) {
			var val;
			if ( !isXML ) {
				return elem[ name ] === true ? name.toLowerCase() :
						(val = elem.getAttributeNode( name )) && val.specified ?
						val.value :
					null;
			}
		});
	}
	
	return Sizzle;
	
	})( window );
	
	
	
	jQuery.find = Sizzle;
	jQuery.expr = Sizzle.selectors;
	
	// Deprecated
	jQuery.expr[ ":" ] = jQuery.expr.pseudos;
	jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
	jQuery.text = Sizzle.getText;
	jQuery.isXMLDoc = Sizzle.isXML;
	jQuery.contains = Sizzle.contains;
	jQuery.escapeSelector = Sizzle.escape;
	
	
	
	
	var dir = function( elem, dir, until ) {
		var matched = [],
			truncate = until !== undefined;
	
		while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
			if ( elem.nodeType === 1 ) {
				if ( truncate && jQuery( elem ).is( until ) ) {
					break;
				}
				matched.push( elem );
			}
		}
		return matched;
	};
	
	
	var siblings = function( n, elem ) {
		var matched = [];
	
		for ( ; n; n = n.nextSibling ) {
			if ( n.nodeType === 1 && n !== elem ) {
				matched.push( n );
			}
		}
	
		return matched;
	};
	
	
	var rneedsContext = jQuery.expr.match.needsContext;
	
	
	
	function nodeName( elem, name ) {
	
	  return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
	
	};
	var rsingleTag = ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );
	
	
	
	var risSimple = /^.[^:#\[\.,]*$/;
	
	// Implement the identical functionality for filter and not
	function winnow( elements, qualifier, not ) {
		if ( jQuery.isFunction( qualifier ) ) {
			return jQuery.grep( elements, function( elem, i ) {
				return !!qualifier.call( elem, i, elem ) !== not;
			} );
		}
	
		// Single element
		if ( qualifier.nodeType ) {
			return jQuery.grep( elements, function( elem ) {
				return ( elem === qualifier ) !== not;
			} );
		}
	
		// Arraylike of elements (jQuery, arguments, Array)
		if ( typeof qualifier !== "string" ) {
			return jQuery.grep( elements, function( elem ) {
				return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
			} );
		}
	
		// Simple selector that can be filtered directly, removing non-Elements
		if ( risSimple.test( qualifier ) ) {
			return jQuery.filter( qualifier, elements, not );
		}
	
		// Complex selector, compare the two sets, removing non-Elements
		qualifier = jQuery.filter( qualifier, elements );
		return jQuery.grep( elements, function( elem ) {
			return ( indexOf.call( qualifier, elem ) > -1 ) !== not && elem.nodeType === 1;
		} );
	}
	
	jQuery.filter = function( expr, elems, not ) {
		var elem = elems[ 0 ];
	
		if ( not ) {
			expr = ":not(" + expr + ")";
		}
	
		if ( elems.length === 1 && elem.nodeType === 1 ) {
			return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
		}
	
		return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
			return elem.nodeType === 1;
		} ) );
	};
	
	jQuery.fn.extend( {
		find: function( selector ) {
			var i, ret,
				len = this.length,
				self = this;
	
			if ( typeof selector !== "string" ) {
				return this.pushStack( jQuery( selector ).filter( function() {
					for ( i = 0; i < len; i++ ) {
						if ( jQuery.contains( self[ i ], this ) ) {
							return true;
						}
					}
				} ) );
			}
	
			ret = this.pushStack( [] );
	
			for ( i = 0; i < len; i++ ) {
				jQuery.find( selector, self[ i ], ret );
			}
	
			return len > 1 ? jQuery.uniqueSort( ret ) : ret;
		},
		filter: function( selector ) {
			return this.pushStack( winnow( this, selector || [], false ) );
		},
		not: function( selector ) {
			return this.pushStack( winnow( this, selector || [], true ) );
		},
		is: function( selector ) {
			return !!winnow(
				this,
	
				// If this is a positional/relative selector, check membership in the returned set
				// so $("p:first").is("p:last") won't return true for a doc with two "p".
				typeof selector === "string" && rneedsContext.test( selector ) ?
					jQuery( selector ) :
					selector || [],
				false
			).length;
		}
	} );
	
	
	// Initialize a jQuery object
	
	
	// A central reference to the root jQuery(document)
	var rootjQuery,
	
		// A simple way to check for HTML strings
		// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
		// Strict HTML recognition (#11290: must start with <)
		// Shortcut simple #id case for speed
		rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,
	
		init = jQuery.fn.init = function( selector, context, root ) {
			var match, elem;
	
			// HANDLE: $(""), $(null), $(undefined), $(false)
			if ( !selector ) {
				return this;
			}
	
			// Method init() accepts an alternate rootjQuery
			// so migrate can support jQuery.sub (gh-2101)
			root = root || rootjQuery;
	
			// Handle HTML strings
			if ( typeof selector === "string" ) {
				if ( selector[ 0 ] === "<" &&
					selector[ selector.length - 1 ] === ">" &&
					selector.length >= 3 ) {
	
					// Assume that strings that start and end with <> are HTML and skip the regex check
					match = [ null, selector, null ];
	
				} else {
					match = rquickExpr.exec( selector );
				}
	
				// Match html or make sure no context is specified for #id
				if ( match && ( match[ 1 ] || !context ) ) {
	
					// HANDLE: $(html) -> $(array)
					if ( match[ 1 ] ) {
						context = context instanceof jQuery ? context[ 0 ] : context;
	
						// Option to run scripts is true for back-compat
						// Intentionally let the error be thrown if parseHTML is not present
						jQuery.merge( this, jQuery.parseHTML(
							match[ 1 ],
							context && context.nodeType ? context.ownerDocument || context : document,
							true
						) );
	
						// HANDLE: $(html, props)
						if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
							for ( match in context ) {
	
								// Properties of context are called as methods if possible
								if ( jQuery.isFunction( this[ match ] ) ) {
									this[ match ]( context[ match ] );
	
								// ...and otherwise set as attributes
								} else {
									this.attr( match, context[ match ] );
								}
							}
						}
	
						return this;
	
					// HANDLE: $(#id)
					} else {
						elem = document.getElementById( match[ 2 ] );
	
						if ( elem ) {
	
							// Inject the element directly into the jQuery object
							this[ 0 ] = elem;
							this.length = 1;
						}
						return this;
					}
	
				// HANDLE: $(expr, $(...))
				} else if ( !context || context.jquery ) {
					return ( context || root ).find( selector );
	
				// HANDLE: $(expr, context)
				// (which is just equivalent to: $(context).find(expr)
				} else {
					return this.constructor( context ).find( selector );
				}
	
			// HANDLE: $(DOMElement)
			} else if ( selector.nodeType ) {
				this[ 0 ] = selector;
				this.length = 1;
				return this;
	
			// HANDLE: $(function)
			// Shortcut for document ready
			} else if ( jQuery.isFunction( selector ) ) {
				return root.ready !== undefined ?
					root.ready( selector ) :
	
					// Execute immediately if ready is not present
					selector( jQuery );
			}
	
			return jQuery.makeArray( selector, this );
		};
	
	// Give the init function the jQuery prototype for later instantiation
	init.prototype = jQuery.fn;
	
	// Initialize central reference
	rootjQuery = jQuery( document );
	
	
	var rparentsprev = /^(?:parents|prev(?:Until|All))/,
	
		// Methods guaranteed to produce a unique set when starting from a unique set
		guaranteedUnique = {
			children: true,
			contents: true,
			next: true,
			prev: true
		};
	
	jQuery.fn.extend( {
		has: function( target ) {
			var targets = jQuery( target, this ),
				l = targets.length;
	
			return this.filter( function() {
				var i = 0;
				for ( ; i < l; i++ ) {
					if ( jQuery.contains( this, targets[ i ] ) ) {
						return true;
					}
				}
			} );
		},
	
		closest: function( selectors, context ) {
			var cur,
				i = 0,
				l = this.length,
				matched = [],
				targets = typeof selectors !== "string" && jQuery( selectors );
	
			// Positional selectors never match, since there's no _selection_ context
			if ( !rneedsContext.test( selectors ) ) {
				for ( ; i < l; i++ ) {
					for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {
	
						// Always skip document fragments
						if ( cur.nodeType < 11 && ( targets ?
							targets.index( cur ) > -1 :
	
							// Don't pass non-elements to Sizzle
							cur.nodeType === 1 &&
								jQuery.find.matchesSelector( cur, selectors ) ) ) {
	
							matched.push( cur );
							break;
						}
					}
				}
			}
	
			return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
		},
	
		// Determine the position of an element within the set
		index: function( elem ) {
	
			// No argument, return index in parent
			if ( !elem ) {
				return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
			}
	
			// Index in selector
			if ( typeof elem === "string" ) {
				return indexOf.call( jQuery( elem ), this[ 0 ] );
			}
	
			// Locate the position of the desired element
			return indexOf.call( this,
	
				// If it receives a jQuery object, the first element is used
				elem.jquery ? elem[ 0 ] : elem
			);
		},
	
		add: function( selector, context ) {
			return this.pushStack(
				jQuery.uniqueSort(
					jQuery.merge( this.get(), jQuery( selector, context ) )
				)
			);
		},
	
		addBack: function( selector ) {
			return this.add( selector == null ?
				this.prevObject : this.prevObject.filter( selector )
			);
		}
	} );
	
	function sibling( cur, dir ) {
		while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
		return cur;
	}
	
	jQuery.each( {
		parent: function( elem ) {
			var parent = elem.parentNode;
			return parent && parent.nodeType !== 11 ? parent : null;
		},
		parents: function( elem ) {
			return dir( elem, "parentNode" );
		},
		parentsUntil: function( elem, i, until ) {
			return dir( elem, "parentNode", until );
		},
		next: function( elem ) {
			return sibling( elem, "nextSibling" );
		},
		prev: function( elem ) {
			return sibling( elem, "previousSibling" );
		},
		nextAll: function( elem ) {
			return dir( elem, "nextSibling" );
		},
		prevAll: function( elem ) {
			return dir( elem, "previousSibling" );
		},
		nextUntil: function( elem, i, until ) {
			return dir( elem, "nextSibling", until );
		},
		prevUntil: function( elem, i, until ) {
			return dir( elem, "previousSibling", until );
		},
		siblings: function( elem ) {
			return siblings( ( elem.parentNode || {} ).firstChild, elem );
		},
		children: function( elem ) {
			return siblings( elem.firstChild );
		},
		contents: function( elem ) {
	        if ( nodeName( elem, "iframe" ) ) {
	            return elem.contentDocument;
	        }
	
	        // Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
	        // Treat the template element as a regular one in browsers that
	        // don't support it.
	        if ( nodeName( elem, "template" ) ) {
	            elem = elem.content || elem;
	        }
	
	        return jQuery.merge( [], elem.childNodes );
		}
	}, function( name, fn ) {
		jQuery.fn[ name ] = function( until, selector ) {
			var matched = jQuery.map( this, fn, until );
	
			if ( name.slice( -5 ) !== "Until" ) {
				selector = until;
			}
	
			if ( selector && typeof selector === "string" ) {
				matched = jQuery.filter( selector, matched );
			}
	
			if ( this.length > 1 ) {
	
				// Remove duplicates
				if ( !guaranteedUnique[ name ] ) {
					jQuery.uniqueSort( matched );
				}
	
				// Reverse order for parents* and prev-derivatives
				if ( rparentsprev.test( name ) ) {
					matched.reverse();
				}
			}
	
			return this.pushStack( matched );
		};
	} );
	var rnothtmlwhite = ( /[^\x20\t\r\n\f]+/g );
	
	
	
	// Convert String-formatted options into Object-formatted ones
	function createOptions( options ) {
		var object = {};
		jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
			object[ flag ] = true;
		} );
		return object;
	}
	
	/*
	 * Create a callback list using the following parameters:
	 *
	 *	options: an optional list of space-separated options that will change how
	 *			the callback list behaves or a more traditional option object
	 *
	 * By default a callback list will act like an event callback list and can be
	 * "fired" multiple times.
	 *
	 * Possible options:
	 *
	 *	once:			will ensure the callback list can only be fired once (like a Deferred)
	 *
	 *	memory:			will keep track of previous values and will call any callback added
	 *					after the list has been fired right away with the latest "memorized"
	 *					values (like a Deferred)
	 *
	 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
	 *
	 *	stopOnFalse:	interrupt callings when a callback returns false
	 *
	 */
	jQuery.Callbacks = function( options ) {
	
		// Convert options from String-formatted to Object-formatted if needed
		// (we check in cache first)
		options = typeof options === "string" ?
			createOptions( options ) :
			jQuery.extend( {}, options );
	
		var // Flag to know if list is currently firing
			firing,
	
			// Last fire value for non-forgettable lists
			memory,
	
			// Flag to know if list was already fired
			fired,
	
			// Flag to prevent firing
			locked,
	
			// Actual callback list
			list = [],
	
			// Queue of execution data for repeatable lists
			queue = [],
	
			// Index of currently firing callback (modified by add/remove as needed)
			firingIndex = -1,
	
			// Fire callbacks
			fire = function() {
	
				// Enforce single-firing
				locked = locked || options.once;
	
				// Execute callbacks for all pending executions,
				// respecting firingIndex overrides and runtime changes
				fired = firing = true;
				for ( ; queue.length; firingIndex = -1 ) {
					memory = queue.shift();
					while ( ++firingIndex < list.length ) {
	
						// Run callback and check for early termination
						if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
							options.stopOnFalse ) {
	
							// Jump to end and forget the data so .add doesn't re-fire
							firingIndex = list.length;
							memory = false;
						}
					}
				}
	
				// Forget the data if we're done with it
				if ( !options.memory ) {
					memory = false;
				}
	
				firing = false;
	
				// Clean up if we're done firing for good
				if ( locked ) {
	
					// Keep an empty list if we have data for future add calls
					if ( memory ) {
						list = [];
	
					// Otherwise, this object is spent
					} else {
						list = "";
					}
				}
			},
	
			// Actual Callbacks object
			self = {
	
				// Add a callback or a collection of callbacks to the list
				add: function() {
					if ( list ) {
	
						// If we have memory from a past run, we should fire after adding
						if ( memory && !firing ) {
							firingIndex = list.length - 1;
							queue.push( memory );
						}
	
						( function add( args ) {
							jQuery.each( args, function( _, arg ) {
								if ( jQuery.isFunction( arg ) ) {
									if ( !options.unique || !self.has( arg ) ) {
										list.push( arg );
									}
								} else if ( arg && arg.length && jQuery.type( arg ) !== "string" ) {
	
									// Inspect recursively
									add( arg );
								}
							} );
						} )( arguments );
	
						if ( memory && !firing ) {
							fire();
						}
					}
					return this;
				},
	
				// Remove a callback from the list
				remove: function() {
					jQuery.each( arguments, function( _, arg ) {
						var index;
						while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
							list.splice( index, 1 );
	
							// Handle firing indexes
							if ( index <= firingIndex ) {
								firingIndex--;
							}
						}
					} );
					return this;
				},
	
				// Check if a given callback is in the list.
				// If no argument is given, return whether or not list has callbacks attached.
				has: function( fn ) {
					return fn ?
						jQuery.inArray( fn, list ) > -1 :
						list.length > 0;
				},
	
				// Remove all callbacks from the list
				empty: function() {
					if ( list ) {
						list = [];
					}
					return this;
				},
	
				// Disable .fire and .add
				// Abort any current/pending executions
				// Clear all callbacks and values
				disable: function() {
					locked = queue = [];
					list = memory = "";
					return this;
				},
				disabled: function() {
					return !list;
				},
	
				// Disable .fire
				// Also disable .add unless we have memory (since it would have no effect)
				// Abort any pending executions
				lock: function() {
					locked = queue = [];
					if ( !memory && !firing ) {
						list = memory = "";
					}
					return this;
				},
				locked: function() {
					return !!locked;
				},
	
				// Call all callbacks with the given context and arguments
				fireWith: function( context, args ) {
					if ( !locked ) {
						args = args || [];
						args = [ context, args.slice ? args.slice() : args ];
						queue.push( args );
						if ( !firing ) {
							fire();
						}
					}
					return this;
				},
	
				// Call all the callbacks with the given arguments
				fire: function() {
					self.fireWith( this, arguments );
					return this;
				},
	
				// To know if the callbacks have already been called at least once
				fired: function() {
					return !!fired;
				}
			};
	
		return self;
	};
	
	
	function Identity( v ) {
		return v;
	}
	function Thrower( ex ) {
		throw ex;
	}
	
	function adoptValue( value, resolve, reject, noValue ) {
		var method;
	
		try {
	
			// Check for promise aspect first to privilege synchronous behavior
			if ( value && jQuery.isFunction( ( method = value.promise ) ) ) {
				method.call( value ).done( resolve ).fail( reject );
	
			// Other thenables
			} else if ( value && jQuery.isFunction( ( method = value.then ) ) ) {
				method.call( value, resolve, reject );
	
			// Other non-thenables
			} else {
	
				// Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
				// * false: [ value ].slice( 0 ) => resolve( value )
				// * true: [ value ].slice( 1 ) => resolve()
				resolve.apply( undefined, [ value ].slice( noValue ) );
			}
	
		// For Promises/A+, convert exceptions into rejections
		// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
		// Deferred#then to conditionally suppress rejection.
		} catch ( value ) {
	
			// Support: Android 4.0 only
			// Strict mode functions invoked without .call/.apply get global-object context
			reject.apply( undefined, [ value ] );
		}
	}
	
	jQuery.extend( {
	
		Deferred: function( func ) {
			var tuples = [
	
					// action, add listener, callbacks,
					// ... .then handlers, argument index, [final state]
					[ "notify", "progress", jQuery.Callbacks( "memory" ),
						jQuery.Callbacks( "memory" ), 2 ],
					[ "resolve", "done", jQuery.Callbacks( "once memory" ),
						jQuery.Callbacks( "once memory" ), 0, "resolved" ],
					[ "reject", "fail", jQuery.Callbacks( "once memory" ),
						jQuery.Callbacks( "once memory" ), 1, "rejected" ]
				],
				state = "pending",
				promise = {
					state: function() {
						return state;
					},
					always: function() {
						deferred.done( arguments ).fail( arguments );
						return this;
					},
					"catch": function( fn ) {
						return promise.then( null, fn );
					},
	
					// Keep pipe for back-compat
					pipe: function( /* fnDone, fnFail, fnProgress */ ) {
						var fns = arguments;
	
						return jQuery.Deferred( function( newDefer ) {
							jQuery.each( tuples, function( i, tuple ) {
	
								// Map tuples (progress, done, fail) to arguments (done, fail, progress)
								var fn = jQuery.isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];
	
								// deferred.progress(function() { bind to newDefer or newDefer.notify })
								// deferred.done(function() { bind to newDefer or newDefer.resolve })
								// deferred.fail(function() { bind to newDefer or newDefer.reject })
								deferred[ tuple[ 1 ] ]( function() {
									var returned = fn && fn.apply( this, arguments );
									if ( returned && jQuery.isFunction( returned.promise ) ) {
										returned.promise()
											.progress( newDefer.notify )
											.done( newDefer.resolve )
											.fail( newDefer.reject );
									} else {
										newDefer[ tuple[ 0 ] + "With" ](
											this,
											fn ? [ returned ] : arguments
										);
									}
								} );
							} );
							fns = null;
						} ).promise();
					},
					then: function( onFulfilled, onRejected, onProgress ) {
						var maxDepth = 0;
						function resolve( depth, deferred, handler, special ) {
							return function() {
								var that = this,
									args = arguments,
									mightThrow = function() {
										var returned, then;
	
										// Support: Promises/A+ section 2.3.3.3.3
										// https://promisesaplus.com/#point-59
										// Ignore double-resolution attempts
										if ( depth < maxDepth ) {
											return;
										}
	
										returned = handler.apply( that, args );
	
										// Support: Promises/A+ section 2.3.1
										// https://promisesaplus.com/#point-48
										if ( returned === deferred.promise() ) {
											throw new TypeError( "Thenable self-resolution" );
										}
	
										// Support: Promises/A+ sections 2.3.3.1, 3.5
										// https://promisesaplus.com/#point-54
										// https://promisesaplus.com/#point-75
										// Retrieve `then` only once
										then = returned &&
	
											// Support: Promises/A+ section 2.3.4
											// https://promisesaplus.com/#point-64
											// Only check objects and functions for thenability
											( typeof returned === "object" ||
												typeof returned === "function" ) &&
											returned.then;
	
										// Handle a returned thenable
										if ( jQuery.isFunction( then ) ) {
	
											// Special processors (notify) just wait for resolution
											if ( special ) {
												then.call(
													returned,
													resolve( maxDepth, deferred, Identity, special ),
													resolve( maxDepth, deferred, Thrower, special )
												);
	
											// Normal processors (resolve) also hook into progress
											} else {
	
												// ...and disregard older resolution values
												maxDepth++;
	
												then.call(
													returned,
													resolve( maxDepth, deferred, Identity, special ),
													resolve( maxDepth, deferred, Thrower, special ),
													resolve( maxDepth, deferred, Identity,
														deferred.notifyWith )
												);
											}
	
										// Handle all other returned values
										} else {
	
											// Only substitute handlers pass on context
											// and multiple values (non-spec behavior)
											if ( handler !== Identity ) {
												that = undefined;
												args = [ returned ];
											}
	
											// Process the value(s)
											// Default process is resolve
											( special || deferred.resolveWith )( that, args );
										}
									},
	
									// Only normal processors (resolve) catch and reject exceptions
									process = special ?
										mightThrow :
										function() {
											try {
												mightThrow();
											} catch ( e ) {
	
												if ( jQuery.Deferred.exceptionHook ) {
													jQuery.Deferred.exceptionHook( e,
														process.stackTrace );
												}
	
												// Support: Promises/A+ section 2.3.3.3.4.1
												// https://promisesaplus.com/#point-61
												// Ignore post-resolution exceptions
												if ( depth + 1 >= maxDepth ) {
	
													// Only substitute handlers pass on context
													// and multiple values (non-spec behavior)
													if ( handler !== Thrower ) {
														that = undefined;
														args = [ e ];
													}
	
													deferred.rejectWith( that, args );
												}
											}
										};
	
								// Support: Promises/A+ section 2.3.3.3.1
								// https://promisesaplus.com/#point-57
								// Re-resolve promises immediately to dodge false rejection from
								// subsequent errors
								if ( depth ) {
									process();
								} else {
	
									// Call an optional hook to record the stack, in case of exception
									// since it's otherwise lost when execution goes async
									if ( jQuery.Deferred.getStackHook ) {
										process.stackTrace = jQuery.Deferred.getStackHook();
									}
									window.setTimeout( process );
								}
							};
						}
	
						return jQuery.Deferred( function( newDefer ) {
	
							// progress_handlers.add( ... )
							tuples[ 0 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									jQuery.isFunction( onProgress ) ?
										onProgress :
										Identity,
									newDefer.notifyWith
								)
							);
	
							// fulfilled_handlers.add( ... )
							tuples[ 1 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									jQuery.isFunction( onFulfilled ) ?
										onFulfilled :
										Identity
								)
							);
	
							// rejected_handlers.add( ... )
							tuples[ 2 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									jQuery.isFunction( onRejected ) ?
										onRejected :
										Thrower
								)
							);
						} ).promise();
					},
	
					// Get a promise for this deferred
					// If obj is provided, the promise aspect is added to the object
					promise: function( obj ) {
						return obj != null ? jQuery.extend( obj, promise ) : promise;
					}
				},
				deferred = {};
	
			// Add list-specific methods
			jQuery.each( tuples, function( i, tuple ) {
				var list = tuple[ 2 ],
					stateString = tuple[ 5 ];
	
				// promise.progress = list.add
				// promise.done = list.add
				// promise.fail = list.add
				promise[ tuple[ 1 ] ] = list.add;
	
				// Handle state
				if ( stateString ) {
					list.add(
						function() {
	
							// state = "resolved" (i.e., fulfilled)
							// state = "rejected"
							state = stateString;
						},
	
						// rejected_callbacks.disable
						// fulfilled_callbacks.disable
						tuples[ 3 - i ][ 2 ].disable,
	
						// progress_callbacks.lock
						tuples[ 0 ][ 2 ].lock
					);
				}
	
				// progress_handlers.fire
				// fulfilled_handlers.fire
				// rejected_handlers.fire
				list.add( tuple[ 3 ].fire );
	
				// deferred.notify = function() { deferred.notifyWith(...) }
				// deferred.resolve = function() { deferred.resolveWith(...) }
				// deferred.reject = function() { deferred.rejectWith(...) }
				deferred[ tuple[ 0 ] ] = function() {
					deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
					return this;
				};
	
				// deferred.notifyWith = list.fireWith
				// deferred.resolveWith = list.fireWith
				// deferred.rejectWith = list.fireWith
				deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
			} );
	
			// Make the deferred a promise
			promise.promise( deferred );
	
			// Call given func if any
			if ( func ) {
				func.call( deferred, deferred );
			}
	
			// All done!
			return deferred;
		},
	
		// Deferred helper
		when: function( singleValue ) {
			var
	
				// count of uncompleted subordinates
				remaining = arguments.length,
	
				// count of unprocessed arguments
				i = remaining,
	
				// subordinate fulfillment data
				resolveContexts = Array( i ),
				resolveValues = slice.call( arguments ),
	
				// the master Deferred
				master = jQuery.Deferred(),
	
				// subordinate callback factory
				updateFunc = function( i ) {
					return function( value ) {
						resolveContexts[ i ] = this;
						resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
						if ( !( --remaining ) ) {
							master.resolveWith( resolveContexts, resolveValues );
						}
					};
				};
	
			// Single- and empty arguments are adopted like Promise.resolve
			if ( remaining <= 1 ) {
				adoptValue( singleValue, master.done( updateFunc( i ) ).resolve, master.reject,
					!remaining );
	
				// Use .then() to unwrap secondary thenables (cf. gh-3000)
				if ( master.state() === "pending" ||
					jQuery.isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {
	
					return master.then();
				}
			}
	
			// Multiple arguments are aggregated like Promise.all array elements
			while ( i-- ) {
				adoptValue( resolveValues[ i ], updateFunc( i ), master.reject );
			}
	
			return master.promise();
		}
	} );
	
	
	// These usually indicate a programmer mistake during development,
	// warn about them ASAP rather than swallowing them by default.
	var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
	
	jQuery.Deferred.exceptionHook = function( error, stack ) {
	
		// Support: IE 8 - 9 only
		// Console exists when dev tools are open, which can happen at any time
		if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
			window.console.warn( "jQuery.Deferred exception: " + error.message, error.stack, stack );
		}
	};
	
	
	
	
	jQuery.readyException = function( error ) {
		window.setTimeout( function() {
			throw error;
		} );
	};
	
	
	
	
	// The deferred used on DOM ready
	var readyList = jQuery.Deferred();
	
	jQuery.fn.ready = function( fn ) {
	
		readyList
			.then( fn )
	
			// Wrap jQuery.readyException in a function so that the lookup
			// happens at the time of error handling instead of callback
			// registration.
			.catch( function( error ) {
				jQuery.readyException( error );
			} );
	
		return this;
	};
	
	jQuery.extend( {
	
		// Is the DOM ready to be used? Set to true once it occurs.
		isReady: false,
	
		// A counter to track how many items to wait for before
		// the ready event fires. See #6781
		readyWait: 1,
	
		// Handle when the DOM is ready
		ready: function( wait ) {
	
			// Abort if there are pending holds or we're already ready
			if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
				return;
			}
	
			// Remember that the DOM is ready
			jQuery.isReady = true;
	
			// If a normal DOM Ready event fired, decrement, and wait if need be
			if ( wait !== true && --jQuery.readyWait > 0 ) {
				return;
			}
	
			// If there are functions bound, to execute
			readyList.resolveWith( document, [ jQuery ] );
		}
	} );
	
	jQuery.ready.then = readyList.then;
	
	// The ready event handler and self cleanup method
	function completed() {
		document.removeEventListener( "DOMContentLoaded", completed );
		window.removeEventListener( "load", completed );
		jQuery.ready();
	}
	
	// Catch cases where $(document).ready() is called
	// after the browser event has already occurred.
	// Support: IE <=9 - 10 only
	// Older IE sometimes signals "interactive" too soon
	if ( document.readyState === "complete" ||
		( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {
	
		// Handle it asynchronously to allow scripts the opportunity to delay ready
		window.setTimeout( jQuery.ready );
	
	} else {
	
		// Use the handy event callback
		document.addEventListener( "DOMContentLoaded", completed );
	
		// A fallback to window.onload, that will always work
		window.addEventListener( "load", completed );
	}
	
	
	
	
	// Multifunctional method to get and set values of a collection
	// The value/s can optionally be executed if it's a function
	var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
		var i = 0,
			len = elems.length,
			bulk = key == null;
	
		// Sets many values
		if ( jQuery.type( key ) === "object" ) {
			chainable = true;
			for ( i in key ) {
				access( elems, fn, i, key[ i ], true, emptyGet, raw );
			}
	
		// Sets one value
		} else if ( value !== undefined ) {
			chainable = true;
	
			if ( !jQuery.isFunction( value ) ) {
				raw = true;
			}
	
			if ( bulk ) {
	
				// Bulk operations run against the entire set
				if ( raw ) {
					fn.call( elems, value );
					fn = null;
	
				// ...except when executing function values
				} else {
					bulk = fn;
					fn = function( elem, key, value ) {
						return bulk.call( jQuery( elem ), value );
					};
				}
			}
	
			if ( fn ) {
				for ( ; i < len; i++ ) {
					fn(
						elems[ i ], key, raw ?
						value :
						value.call( elems[ i ], i, fn( elems[ i ], key ) )
					);
				}
			}
		}
	
		if ( chainable ) {
			return elems;
		}
	
		// Gets
		if ( bulk ) {
			return fn.call( elems );
		}
	
		return len ? fn( elems[ 0 ], key ) : emptyGet;
	};
	var acceptData = function( owner ) {
	
		// Accepts only:
		//  - Node
		//    - Node.ELEMENT_NODE
		//    - Node.DOCUMENT_NODE
		//  - Object
		//    - Any
		return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
	};
	
	
	
	
	function Data() {
		this.expando = jQuery.expando + Data.uid++;
	}
	
	Data.uid = 1;
	
	Data.prototype = {
	
		cache: function( owner ) {
	
			// Check if the owner object already has a cache
			var value = owner[ this.expando ];
	
			// If not, create one
			if ( !value ) {
				value = {};
	
				// We can accept data for non-element nodes in modern browsers,
				// but we should not, see #8335.
				// Always return an empty object.
				if ( acceptData( owner ) ) {
	
					// If it is a node unlikely to be stringify-ed or looped over
					// use plain assignment
					if ( owner.nodeType ) {
						owner[ this.expando ] = value;
	
					// Otherwise secure it in a non-enumerable property
					// configurable must be true to allow the property to be
					// deleted when data is removed
					} else {
						Object.defineProperty( owner, this.expando, {
							value: value,
							configurable: true
						} );
					}
				}
			}
	
			return value;
		},
		set: function( owner, data, value ) {
			var prop,
				cache = this.cache( owner );
	
			// Handle: [ owner, key, value ] args
			// Always use camelCase key (gh-2257)
			if ( typeof data === "string" ) {
				cache[ jQuery.camelCase( data ) ] = value;
	
			// Handle: [ owner, { properties } ] args
			} else {
	
				// Copy the properties one-by-one to the cache object
				for ( prop in data ) {
					cache[ jQuery.camelCase( prop ) ] = data[ prop ];
				}
			}
			return cache;
		},
		get: function( owner, key ) {
			return key === undefined ?
				this.cache( owner ) :
	
				// Always use camelCase key (gh-2257)
				owner[ this.expando ] && owner[ this.expando ][ jQuery.camelCase( key ) ];
		},
		access: function( owner, key, value ) {
	
			// In cases where either:
			//
			//   1. No key was specified
			//   2. A string key was specified, but no value provided
			//
			// Take the "read" path and allow the get method to determine
			// which value to return, respectively either:
			//
			//   1. The entire cache object
			//   2. The data stored at the key
			//
			if ( key === undefined ||
					( ( key && typeof key === "string" ) && value === undefined ) ) {
	
				return this.get( owner, key );
			}
	
			// When the key is not a string, or both a key and value
			// are specified, set or extend (existing objects) with either:
			//
			//   1. An object of properties
			//   2. A key and value
			//
			this.set( owner, key, value );
	
			// Since the "set" path can have two possible entry points
			// return the expected data based on which path was taken[*]
			return value !== undefined ? value : key;
		},
		remove: function( owner, key ) {
			var i,
				cache = owner[ this.expando ];
	
			if ( cache === undefined ) {
				return;
			}
	
			if ( key !== undefined ) {
	
				// Support array or space separated string of keys
				if ( Array.isArray( key ) ) {
	
					// If key is an array of keys...
					// We always set camelCase keys, so remove that.
					key = key.map( jQuery.camelCase );
				} else {
					key = jQuery.camelCase( key );
	
					// If a key with the spaces exists, use it.
					// Otherwise, create an array by matching non-whitespace
					key = key in cache ?
						[ key ] :
						( key.match( rnothtmlwhite ) || [] );
				}
	
				i = key.length;
	
				while ( i-- ) {
					delete cache[ key[ i ] ];
				}
			}
	
			// Remove the expando if there's no more data
			if ( key === undefined || jQuery.isEmptyObject( cache ) ) {
	
				// Support: Chrome <=35 - 45
				// Webkit & Blink performance suffers when deleting properties
				// from DOM nodes, so set to undefined instead
				// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
				if ( owner.nodeType ) {
					owner[ this.expando ] = undefined;
				} else {
					delete owner[ this.expando ];
				}
			}
		},
		hasData: function( owner ) {
			var cache = owner[ this.expando ];
			return cache !== undefined && !jQuery.isEmptyObject( cache );
		}
	};
	var dataPriv = new Data();
	
	var dataUser = new Data();
	
	
	
	//	Implementation Summary
	//
	//	1. Enforce API surface and semantic compatibility with 1.9.x branch
	//	2. Improve the module's maintainability by reducing the storage
	//		paths to a single mechanism.
	//	3. Use the same single mechanism to support "private" and "user" data.
	//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
	//	5. Avoid exposing implementation details on user objects (eg. expando properties)
	//	6. Provide a clear path for implementation upgrade to WeakMap in 2014
	
	var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
		rmultiDash = /[A-Z]/g;
	
	function getData( data ) {
		if ( data === "true" ) {
			return true;
		}
	
		if ( data === "false" ) {
			return false;
		}
	
		if ( data === "null" ) {
			return null;
		}
	
		// Only convert to a number if it doesn't change the string
		if ( data === +data + "" ) {
			return +data;
		}
	
		if ( rbrace.test( data ) ) {
			return JSON.parse( data );
		}
	
		return data;
	}
	
	function dataAttr( elem, key, data ) {
		var name;
	
		// If nothing was found internally, try to fetch any
		// data from the HTML5 data-* attribute
		if ( data === undefined && elem.nodeType === 1 ) {
			name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
			data = elem.getAttribute( name );
	
			if ( typeof data === "string" ) {
				try {
					data = getData( data );
				} catch ( e ) {}
	
				// Make sure we set the data so it isn't changed later
				dataUser.set( elem, key, data );
			} else {
				data = undefined;
			}
		}
		return data;
	}
	
	jQuery.extend( {
		hasData: function( elem ) {
			return dataUser.hasData( elem ) || dataPriv.hasData( elem );
		},
	
		data: function( elem, name, data ) {
			return dataUser.access( elem, name, data );
		},
	
		removeData: function( elem, name ) {
			dataUser.remove( elem, name );
		},
	
		// TODO: Now that all calls to _data and _removeData have been replaced
		// with direct calls to dataPriv methods, these can be deprecated.
		_data: function( elem, name, data ) {
			return dataPriv.access( elem, name, data );
		},
	
		_removeData: function( elem, name ) {
			dataPriv.remove( elem, name );
		}
	} );
	
	jQuery.fn.extend( {
		data: function( key, value ) {
			var i, name, data,
				elem = this[ 0 ],
				attrs = elem && elem.attributes;
	
			// Gets all values
			if ( key === undefined ) {
				if ( this.length ) {
					data = dataUser.get( elem );
	
					if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
						i = attrs.length;
						while ( i-- ) {
	
							// Support: IE 11 only
							// The attrs elements can be null (#14894)
							if ( attrs[ i ] ) {
								name = attrs[ i ].name;
								if ( name.indexOf( "data-" ) === 0 ) {
									name = jQuery.camelCase( name.slice( 5 ) );
									dataAttr( elem, name, data[ name ] );
								}
							}
						}
						dataPriv.set( elem, "hasDataAttrs", true );
					}
				}
	
				return data;
			}
	
			// Sets multiple values
			if ( typeof key === "object" ) {
				return this.each( function() {
					dataUser.set( this, key );
				} );
			}
	
			return access( this, function( value ) {
				var data;
	
				// The calling jQuery object (element matches) is not empty
				// (and therefore has an element appears at this[ 0 ]) and the
				// `value` parameter was not undefined. An empty jQuery object
				// will result in `undefined` for elem = this[ 0 ] which will
				// throw an exception if an attempt to read a data cache is made.
				if ( elem && value === undefined ) {
	
					// Attempt to get data from the cache
					// The key will always be camelCased in Data
					data = dataUser.get( elem, key );
					if ( data !== undefined ) {
						return data;
					}
	
					// Attempt to "discover" the data in
					// HTML5 custom data-* attrs
					data = dataAttr( elem, key );
					if ( data !== undefined ) {
						return data;
					}
	
					// We tried really hard, but the data doesn't exist.
					return;
				}
	
				// Set the data...
				this.each( function() {
	
					// We always store the camelCased key
					dataUser.set( this, key, value );
				} );
			}, null, value, arguments.length > 1, null, true );
		},
	
		removeData: function( key ) {
			return this.each( function() {
				dataUser.remove( this, key );
			} );
		}
	} );
	
	
	jQuery.extend( {
		queue: function( elem, type, data ) {
			var queue;
	
			if ( elem ) {
				type = ( type || "fx" ) + "queue";
				queue = dataPriv.get( elem, type );
	
				// Speed up dequeue by getting out quickly if this is just a lookup
				if ( data ) {
					if ( !queue || Array.isArray( data ) ) {
						queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
					} else {
						queue.push( data );
					}
				}
				return queue || [];
			}
		},
	
		dequeue: function( elem, type ) {
			type = type || "fx";
	
			var queue = jQuery.queue( elem, type ),
				startLength = queue.length,
				fn = queue.shift(),
				hooks = jQuery._queueHooks( elem, type ),
				next = function() {
					jQuery.dequeue( elem, type );
				};
	
			// If the fx queue is dequeued, always remove the progress sentinel
			if ( fn === "inprogress" ) {
				fn = queue.shift();
				startLength--;
			}
	
			if ( fn ) {
	
				// Add a progress sentinel to prevent the fx queue from being
				// automatically dequeued
				if ( type === "fx" ) {
					queue.unshift( "inprogress" );
				}
	
				// Clear up the last queue stop function
				delete hooks.stop;
				fn.call( elem, next, hooks );
			}
	
			if ( !startLength && hooks ) {
				hooks.empty.fire();
			}
		},
	
		// Not public - generate a queueHooks object, or return the current one
		_queueHooks: function( elem, type ) {
			var key = type + "queueHooks";
			return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
				empty: jQuery.Callbacks( "once memory" ).add( function() {
					dataPriv.remove( elem, [ type + "queue", key ] );
				} )
			} );
		}
	} );
	
	jQuery.fn.extend( {
		queue: function( type, data ) {
			var setter = 2;
	
			if ( typeof type !== "string" ) {
				data = type;
				type = "fx";
				setter--;
			}
	
			if ( arguments.length < setter ) {
				return jQuery.queue( this[ 0 ], type );
			}
	
			return data === undefined ?
				this :
				this.each( function() {
					var queue = jQuery.queue( this, type, data );
	
					// Ensure a hooks for this queue
					jQuery._queueHooks( this, type );
	
					if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
						jQuery.dequeue( this, type );
					}
				} );
		},
		dequeue: function( type ) {
			return this.each( function() {
				jQuery.dequeue( this, type );
			} );
		},
		clearQueue: function( type ) {
			return this.queue( type || "fx", [] );
		},
	
		// Get a promise resolved when queues of a certain type
		// are emptied (fx is the type by default)
		promise: function( type, obj ) {
			var tmp,
				count = 1,
				defer = jQuery.Deferred(),
				elements = this,
				i = this.length,
				resolve = function() {
					if ( !( --count ) ) {
						defer.resolveWith( elements, [ elements ] );
					}
				};
	
			if ( typeof type !== "string" ) {
				obj = type;
				type = undefined;
			}
			type = type || "fx";
	
			while ( i-- ) {
				tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
				if ( tmp && tmp.empty ) {
					count++;
					tmp.empty.add( resolve );
				}
			}
			resolve();
			return defer.promise( obj );
		}
	} );
	var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;
	
	var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );
	
	
	var cssExpand = [ "Top", "Right", "Bottom", "Left" ];
	
	var isHiddenWithinTree = function( elem, el ) {
	
			// isHiddenWithinTree might be called from jQuery#filter function;
			// in that case, element will be second argument
			elem = el || elem;
	
			// Inline style trumps all
			return elem.style.display === "none" ||
				elem.style.display === "" &&
	
				// Otherwise, check computed style
				// Support: Firefox <=43 - 45
				// Disconnected elements can have computed display: none, so first confirm that elem is
				// in the document.
				jQuery.contains( elem.ownerDocument, elem ) &&
	
				jQuery.css( elem, "display" ) === "none";
		};
	
	var swap = function( elem, options, callback, args ) {
		var ret, name,
			old = {};
	
		// Remember the old values, and insert the new ones
		for ( name in options ) {
			old[ name ] = elem.style[ name ];
			elem.style[ name ] = options[ name ];
		}
	
		ret = callback.apply( elem, args || [] );
	
		// Revert the old values
		for ( name in options ) {
			elem.style[ name ] = old[ name ];
		}
	
		return ret;
	};
	
	
	
	
	function adjustCSS( elem, prop, valueParts, tween ) {
		var adjusted,
			scale = 1,
			maxIterations = 20,
			currentValue = tween ?
				function() {
					return tween.cur();
				} :
				function() {
					return jQuery.css( elem, prop, "" );
				},
			initial = currentValue(),
			unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),
	
			// Starting value computation is required for potential unit mismatches
			initialInUnit = ( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
				rcssNum.exec( jQuery.css( elem, prop ) );
	
		if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {
	
			// Trust units reported by jQuery.css
			unit = unit || initialInUnit[ 3 ];
	
			// Make sure we update the tween properties later on
			valueParts = valueParts || [];
	
			// Iteratively approximate from a nonzero starting point
			initialInUnit = +initial || 1;
	
			do {
	
				// If previous iteration zeroed out, double until we get *something*.
				// Use string for doubling so we don't accidentally see scale as unchanged below
				scale = scale || ".5";
	
				// Adjust and apply
				initialInUnit = initialInUnit / scale;
				jQuery.style( elem, prop, initialInUnit + unit );
	
			// Update scale, tolerating zero or NaN from tween.cur()
			// Break the loop if scale is unchanged or perfect, or if we've just had enough.
			} while (
				scale !== ( scale = currentValue() / initial ) && scale !== 1 && --maxIterations
			);
		}
	
		if ( valueParts ) {
			initialInUnit = +initialInUnit || +initial || 0;
	
			// Apply relative offset (+=/-=) if specified
			adjusted = valueParts[ 1 ] ?
				initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
				+valueParts[ 2 ];
			if ( tween ) {
				tween.unit = unit;
				tween.start = initialInUnit;
				tween.end = adjusted;
			}
		}
		return adjusted;
	}
	
	
	var defaultDisplayMap = {};
	
	function getDefaultDisplay( elem ) {
		var temp,
			doc = elem.ownerDocument,
			nodeName = elem.nodeName,
			display = defaultDisplayMap[ nodeName ];
	
		if ( display ) {
			return display;
		}
	
		temp = doc.body.appendChild( doc.createElement( nodeName ) );
		display = jQuery.css( temp, "display" );
	
		temp.parentNode.removeChild( temp );
	
		if ( display === "none" ) {
			display = "block";
		}
		defaultDisplayMap[ nodeName ] = display;
	
		return display;
	}
	
	function showHide( elements, show ) {
		var display, elem,
			values = [],
			index = 0,
			length = elements.length;
	
		// Determine new display value for elements that need to change
		for ( ; index < length; index++ ) {
			elem = elements[ index ];
			if ( !elem.style ) {
				continue;
			}
	
			display = elem.style.display;
			if ( show ) {
	
				// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
				// check is required in this first loop unless we have a nonempty display value (either
				// inline or about-to-be-restored)
				if ( display === "none" ) {
					values[ index ] = dataPriv.get( elem, "display" ) || null;
					if ( !values[ index ] ) {
						elem.style.display = "";
					}
				}
				if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
					values[ index ] = getDefaultDisplay( elem );
				}
			} else {
				if ( display !== "none" ) {
					values[ index ] = "none";
	
					// Remember what we're overwriting
					dataPriv.set( elem, "display", display );
				}
			}
		}
	
		// Set the display of the elements in a second loop to avoid constant reflow
		for ( index = 0; index < length; index++ ) {
			if ( values[ index ] != null ) {
				elements[ index ].style.display = values[ index ];
			}
		}
	
		return elements;
	}
	
	jQuery.fn.extend( {
		show: function() {
			return showHide( this, true );
		},
		hide: function() {
			return showHide( this );
		},
		toggle: function( state ) {
			if ( typeof state === "boolean" ) {
				return state ? this.show() : this.hide();
			}
	
			return this.each( function() {
				if ( isHiddenWithinTree( this ) ) {
					jQuery( this ).show();
				} else {
					jQuery( this ).hide();
				}
			} );
		}
	} );
	var rcheckableType = ( /^(?:checkbox|radio)$/i );
	
	var rtagName = ( /<([a-z][^\/\0>\x20\t\r\n\f]+)/i );
	
	var rscriptType = ( /^$|\/(?:java|ecma)script/i );
	
	
	
	// We have to close these tags to support XHTML (#13200)
	var wrapMap = {
	
		// Support: IE <=9 only
		option: [ 1, "<select multiple='multiple'>", "</select>" ],
	
		// XHTML parsers do not magically insert elements in the
		// same way that tag soup parsers do. So we cannot shorten
		// this by omitting <tbody> or other required elements.
		thead: [ 1, "<table>", "</table>" ],
		col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
		tr: [ 2, "<table><tbody>", "</tbody></table>" ],
		td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],
	
		_default: [ 0, "", "" ]
	};
	
	// Support: IE <=9 only
	wrapMap.optgroup = wrapMap.option;
	
	wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
	wrapMap.th = wrapMap.td;
	
	
	function getAll( context, tag ) {
	
		// Support: IE <=9 - 11 only
		// Use typeof to avoid zero-argument method invocation on host objects (#15151)
		var ret;
	
		if ( typeof context.getElementsByTagName !== "undefined" ) {
			ret = context.getElementsByTagName( tag || "*" );
	
		} else if ( typeof context.querySelectorAll !== "undefined" ) {
			ret = context.querySelectorAll( tag || "*" );
	
		} else {
			ret = [];
		}
	
		if ( tag === undefined || tag && nodeName( context, tag ) ) {
			return jQuery.merge( [ context ], ret );
		}
	
		return ret;
	}
	
	
	// Mark scripts as having already been evaluated
	function setGlobalEval( elems, refElements ) {
		var i = 0,
			l = elems.length;
	
		for ( ; i < l; i++ ) {
			dataPriv.set(
				elems[ i ],
				"globalEval",
				!refElements || dataPriv.get( refElements[ i ], "globalEval" )
			);
		}
	}
	
	
	var rhtml = /<|&#?\w+;/;
	
	function buildFragment( elems, context, scripts, selection, ignored ) {
		var elem, tmp, tag, wrap, contains, j,
			fragment = context.createDocumentFragment(),
			nodes = [],
			i = 0,
			l = elems.length;
	
		for ( ; i < l; i++ ) {
			elem = elems[ i ];
	
			if ( elem || elem === 0 ) {
	
				// Add nodes directly
				if ( jQuery.type( elem ) === "object" ) {
	
					// Support: Android <=4.0 only, PhantomJS 1 only
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );
	
				// Convert non-html into a text node
				} else if ( !rhtml.test( elem ) ) {
					nodes.push( context.createTextNode( elem ) );
	
				// Convert html into DOM nodes
				} else {
					tmp = tmp || fragment.appendChild( context.createElement( "div" ) );
	
					// Deserialize a standard representation
					tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
					wrap = wrapMap[ tag ] || wrapMap._default;
					tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];
	
					// Descend through wrappers to the right content
					j = wrap[ 0 ];
					while ( j-- ) {
						tmp = tmp.lastChild;
					}
	
					// Support: Android <=4.0 only, PhantomJS 1 only
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, tmp.childNodes );
	
					// Remember the top-level container
					tmp = fragment.firstChild;
	
					// Ensure the created nodes are orphaned (#12392)
					tmp.textContent = "";
				}
			}
		}
	
		// Remove wrapper from fragment
		fragment.textContent = "";
	
		i = 0;
		while ( ( elem = nodes[ i++ ] ) ) {
	
			// Skip elements already in the context collection (trac-4087)
			if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
				if ( ignored ) {
					ignored.push( elem );
				}
				continue;
			}
	
			contains = jQuery.contains( elem.ownerDocument, elem );
	
			// Append to fragment
			tmp = getAll( fragment.appendChild( elem ), "script" );
	
			// Preserve script evaluation history
			if ( contains ) {
				setGlobalEval( tmp );
			}
	
			// Capture executables
			if ( scripts ) {
				j = 0;
				while ( ( elem = tmp[ j++ ] ) ) {
					if ( rscriptType.test( elem.type || "" ) ) {
						scripts.push( elem );
					}
				}
			}
		}
	
		return fragment;
	}
	
	
	( function() {
		var fragment = document.createDocumentFragment(),
			div = fragment.appendChild( document.createElement( "div" ) ),
			input = document.createElement( "input" );
	
		// Support: Android 4.0 - 4.3 only
		// Check state lost if the name is set (#11217)
		// Support: Windows Web Apps (WWA)
		// `name` and `type` must use .setAttribute for WWA (#14901)
		input.setAttribute( "type", "radio" );
		input.setAttribute( "checked", "checked" );
		input.setAttribute( "name", "t" );
	
		div.appendChild( input );
	
		// Support: Android <=4.1 only
		// Older WebKit doesn't clone checked state correctly in fragments
		support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;
	
		// Support: IE <=11 only
		// Make sure textarea (and checkbox) defaultValue is properly cloned
		div.innerHTML = "<textarea>x</textarea>";
		support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;
	} )();
	var documentElement = document.documentElement;
	
	
	
	var
		rkeyEvent = /^key/,
		rmouseEvent = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
		rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
	
	function returnTrue() {
		return true;
	}
	
	function returnFalse() {
		return false;
	}
	
	// Support: IE <=9 only
	// See #13393 for more info
	function safeActiveElement() {
		try {
			return document.activeElement;
		} catch ( err ) { }
	}
	
	function on( elem, types, selector, data, fn, one ) {
		var origFn, type;
	
		// Types can be a map of types/handlers
		if ( typeof types === "object" ) {
	
			// ( types-Object, selector, data )
			if ( typeof selector !== "string" ) {
	
				// ( types-Object, data )
				data = data || selector;
				selector = undefined;
			}
			for ( type in types ) {
				on( elem, type, selector, data, types[ type ], one );
			}
			return elem;
		}
	
		if ( data == null && fn == null ) {
	
			// ( types, fn )
			fn = selector;
			data = selector = undefined;
		} else if ( fn == null ) {
			if ( typeof selector === "string" ) {
	
				// ( types, selector, fn )
				fn = data;
				data = undefined;
			} else {
	
				// ( types, data, fn )
				fn = data;
				data = selector;
				selector = undefined;
			}
		}
		if ( fn === false ) {
			fn = returnFalse;
		} else if ( !fn ) {
			return elem;
		}
	
		if ( one === 1 ) {
			origFn = fn;
			fn = function( event ) {
	
				// Can use an empty set, since event contains the info
				jQuery().off( event );
				return origFn.apply( this, arguments );
			};
	
			// Use same guid so caller can remove using origFn
			fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
		}
		return elem.each( function() {
			jQuery.event.add( this, types, fn, data, selector );
		} );
	}
	
	/*
	 * Helper functions for managing events -- not part of the public interface.
	 * Props to Dean Edwards' addEvent library for many of the ideas.
	 */
	jQuery.event = {
	
		global: {},
	
		add: function( elem, types, handler, data, selector ) {
	
			var handleObjIn, eventHandle, tmp,
				events, t, handleObj,
				special, handlers, type, namespaces, origType,
				elemData = dataPriv.get( elem );
	
			// Don't attach events to noData or text/comment nodes (but allow plain objects)
			if ( !elemData ) {
				return;
			}
	
			// Caller can pass in an object of custom data in lieu of the handler
			if ( handler.handler ) {
				handleObjIn = handler;
				handler = handleObjIn.handler;
				selector = handleObjIn.selector;
			}
	
			// Ensure that invalid selectors throw exceptions at attach time
			// Evaluate against documentElement in case elem is a non-element node (e.g., document)
			if ( selector ) {
				jQuery.find.matchesSelector( documentElement, selector );
			}
	
			// Make sure that the handler has a unique ID, used to find/remove it later
			if ( !handler.guid ) {
				handler.guid = jQuery.guid++;
			}
	
			// Init the element's event structure and main handler, if this is the first
			if ( !( events = elemData.events ) ) {
				events = elemData.events = {};
			}
			if ( !( eventHandle = elemData.handle ) ) {
				eventHandle = elemData.handle = function( e ) {
	
					// Discard the second event of a jQuery.event.trigger() and
					// when an event is called after a page has unloaded
					return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
						jQuery.event.dispatch.apply( elem, arguments ) : undefined;
				};
			}
	
			// Handle multiple events separated by a space
			types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[ t ] ) || [];
				type = origType = tmp[ 1 ];
				namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();
	
				// There *must* be a type, no attaching namespace-only handlers
				if ( !type ) {
					continue;
				}
	
				// If event changes its type, use the special event handlers for the changed type
				special = jQuery.event.special[ type ] || {};
	
				// If selector defined, determine special event api type, otherwise given type
				type = ( selector ? special.delegateType : special.bindType ) || type;
	
				// Update special based on newly reset type
				special = jQuery.event.special[ type ] || {};
	
				// handleObj is passed to all event handlers
				handleObj = jQuery.extend( {
					type: type,
					origType: origType,
					data: data,
					handler: handler,
					guid: handler.guid,
					selector: selector,
					needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
					namespace: namespaces.join( "." )
				}, handleObjIn );
	
				// Init the event handler queue if we're the first
				if ( !( handlers = events[ type ] ) ) {
					handlers = events[ type ] = [];
					handlers.delegateCount = 0;
	
					// Only use addEventListener if the special events handler returns false
					if ( !special.setup ||
						special.setup.call( elem, data, namespaces, eventHandle ) === false ) {
	
						if ( elem.addEventListener ) {
							elem.addEventListener( type, eventHandle );
						}
					}
				}
	
				if ( special.add ) {
					special.add.call( elem, handleObj );
	
					if ( !handleObj.handler.guid ) {
						handleObj.handler.guid = handler.guid;
					}
				}
	
				// Add to the element's handler list, delegates in front
				if ( selector ) {
					handlers.splice( handlers.delegateCount++, 0, handleObj );
				} else {
					handlers.push( handleObj );
				}
	
				// Keep track of which events have ever been used, for event optimization
				jQuery.event.global[ type ] = true;
			}
	
		},
	
		// Detach an event or set of events from an element
		remove: function( elem, types, handler, selector, mappedTypes ) {
	
			var j, origCount, tmp,
				events, t, handleObj,
				special, handlers, type, namespaces, origType,
				elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );
	
			if ( !elemData || !( events = elemData.events ) ) {
				return;
			}
	
			// Once for each type.namespace in types; type may be omitted
			types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[ t ] ) || [];
				type = origType = tmp[ 1 ];
				namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();
	
				// Unbind all events (on this namespace, if provided) for the element
				if ( !type ) {
					for ( type in events ) {
						jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
					}
					continue;
				}
	
				special = jQuery.event.special[ type ] || {};
				type = ( selector ? special.delegateType : special.bindType ) || type;
				handlers = events[ type ] || [];
				tmp = tmp[ 2 ] &&
					new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );
	
				// Remove matching events
				origCount = j = handlers.length;
				while ( j-- ) {
					handleObj = handlers[ j ];
	
					if ( ( mappedTypes || origType === handleObj.origType ) &&
						( !handler || handler.guid === handleObj.guid ) &&
						( !tmp || tmp.test( handleObj.namespace ) ) &&
						( !selector || selector === handleObj.selector ||
							selector === "**" && handleObj.selector ) ) {
						handlers.splice( j, 1 );
	
						if ( handleObj.selector ) {
							handlers.delegateCount--;
						}
						if ( special.remove ) {
							special.remove.call( elem, handleObj );
						}
					}
				}
	
				// Remove generic event handler if we removed something and no more handlers exist
				// (avoids potential for endless recursion during removal of special event handlers)
				if ( origCount && !handlers.length ) {
					if ( !special.teardown ||
						special.teardown.call( elem, namespaces, elemData.handle ) === false ) {
	
						jQuery.removeEvent( elem, type, elemData.handle );
					}
	
					delete events[ type ];
				}
			}
	
			// Remove data and the expando if it's no longer used
			if ( jQuery.isEmptyObject( events ) ) {
				dataPriv.remove( elem, "handle events" );
			}
		},
	
		dispatch: function( nativeEvent ) {
	
			// Make a writable jQuery.Event from the native event object
			var event = jQuery.event.fix( nativeEvent );
	
			var i, j, ret, matched, handleObj, handlerQueue,
				args = new Array( arguments.length ),
				handlers = ( dataPriv.get( this, "events" ) || {} )[ event.type ] || [],
				special = jQuery.event.special[ event.type ] || {};
	
			// Use the fix-ed jQuery.Event rather than the (read-only) native event
			args[ 0 ] = event;
	
			for ( i = 1; i < arguments.length; i++ ) {
				args[ i ] = arguments[ i ];
			}
	
			event.delegateTarget = this;
	
			// Call the preDispatch hook for the mapped type, and let it bail if desired
			if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
				return;
			}
	
			// Determine handlers
			handlerQueue = jQuery.event.handlers.call( this, event, handlers );
	
			// Run delegates first; they may want to stop propagation beneath us
			i = 0;
			while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
				event.currentTarget = matched.elem;
	
				j = 0;
				while ( ( handleObj = matched.handlers[ j++ ] ) &&
					!event.isImmediatePropagationStopped() ) {
	
					// Triggered event must either 1) have no namespace, or 2) have namespace(s)
					// a subset or equal to those in the bound event (both can have no namespace).
					if ( !event.rnamespace || event.rnamespace.test( handleObj.namespace ) ) {
	
						event.handleObj = handleObj;
						event.data = handleObj.data;
	
						ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
							handleObj.handler ).apply( matched.elem, args );
	
						if ( ret !== undefined ) {
							if ( ( event.result = ret ) === false ) {
								event.preventDefault();
								event.stopPropagation();
							}
						}
					}
				}
			}
	
			// Call the postDispatch hook for the mapped type
			if ( special.postDispatch ) {
				special.postDispatch.call( this, event );
			}
	
			return event.result;
		},
	
		handlers: function( event, handlers ) {
			var i, handleObj, sel, matchedHandlers, matchedSelectors,
				handlerQueue = [],
				delegateCount = handlers.delegateCount,
				cur = event.target;
	
			// Find delegate handlers
			if ( delegateCount &&
	
				// Support: IE <=9
				// Black-hole SVG <use> instance trees (trac-13180)
				cur.nodeType &&
	
				// Support: Firefox <=42
				// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
				// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
				// Support: IE 11 only
				// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
				!( event.type === "click" && event.button >= 1 ) ) {
	
				for ( ; cur !== this; cur = cur.parentNode || this ) {
	
					// Don't check non-elements (#13208)
					// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
					if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
						matchedHandlers = [];
						matchedSelectors = {};
						for ( i = 0; i < delegateCount; i++ ) {
							handleObj = handlers[ i ];
	
							// Don't conflict with Object.prototype properties (#13203)
							sel = handleObj.selector + " ";
	
							if ( matchedSelectors[ sel ] === undefined ) {
								matchedSelectors[ sel ] = handleObj.needsContext ?
									jQuery( sel, this ).index( cur ) > -1 :
									jQuery.find( sel, this, null, [ cur ] ).length;
							}
							if ( matchedSelectors[ sel ] ) {
								matchedHandlers.push( handleObj );
							}
						}
						if ( matchedHandlers.length ) {
							handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
						}
					}
				}
			}
	
			// Add the remaining (directly-bound) handlers
			cur = this;
			if ( delegateCount < handlers.length ) {
				handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
			}
	
			return handlerQueue;
		},
	
		addProp: function( name, hook ) {
			Object.defineProperty( jQuery.Event.prototype, name, {
				enumerable: true,
				configurable: true,
	
				get: jQuery.isFunction( hook ) ?
					function() {
						if ( this.originalEvent ) {
								return hook( this.originalEvent );
						}
					} :
					function() {
						if ( this.originalEvent ) {
								return this.originalEvent[ name ];
						}
					},
	
				set: function( value ) {
					Object.defineProperty( this, name, {
						enumerable: true,
						configurable: true,
						writable: true,
						value: value
					} );
				}
			} );
		},
	
		fix: function( originalEvent ) {
			return originalEvent[ jQuery.expando ] ?
				originalEvent :
				new jQuery.Event( originalEvent );
		},
	
		special: {
			load: {
	
				// Prevent triggered image.load events from bubbling to window.load
				noBubble: true
			},
			focus: {
	
				// Fire native event if possible so blur/focus sequence is correct
				trigger: function() {
					if ( this !== safeActiveElement() && this.focus ) {
						this.focus();
						return false;
					}
				},
				delegateType: "focusin"
			},
			blur: {
				trigger: function() {
					if ( this === safeActiveElement() && this.blur ) {
						this.blur();
						return false;
					}
				},
				delegateType: "focusout"
			},
			click: {
	
				// For checkbox, fire native event so checked state will be right
				trigger: function() {
					if ( this.type === "checkbox" && this.click && nodeName( this, "input" ) ) {
						this.click();
						return false;
					}
				},
	
				// For cross-browser consistency, don't fire native .click() on links
				_default: function( event ) {
					return nodeName( event.target, "a" );
				}
			},
	
			beforeunload: {
				postDispatch: function( event ) {
	
					// Support: Firefox 20+
					// Firefox doesn't alert if the returnValue field is not set.
					if ( event.result !== undefined && event.originalEvent ) {
						event.originalEvent.returnValue = event.result;
					}
				}
			}
		}
	};
	
	jQuery.removeEvent = function( elem, type, handle ) {
	
		// This "if" is needed for plain objects
		if ( elem.removeEventListener ) {
			elem.removeEventListener( type, handle );
		}
	};
	
	jQuery.Event = function( src, props ) {
	
		// Allow instantiation without the 'new' keyword
		if ( !( this instanceof jQuery.Event ) ) {
			return new jQuery.Event( src, props );
		}
	
		// Event object
		if ( src && src.type ) {
			this.originalEvent = src;
			this.type = src.type;
	
			// Events bubbling up the document may have been marked as prevented
			// by a handler lower down the tree; reflect the correct value.
			this.isDefaultPrevented = src.defaultPrevented ||
					src.defaultPrevented === undefined &&
	
					// Support: Android <=2.3 only
					src.returnValue === false ?
				returnTrue :
				returnFalse;
	
			// Create target properties
			// Support: Safari <=6 - 7 only
			// Target should not be a text node (#504, #13143)
			this.target = ( src.target && src.target.nodeType === 3 ) ?
				src.target.parentNode :
				src.target;
	
			this.currentTarget = src.currentTarget;
			this.relatedTarget = src.relatedTarget;
	
		// Event type
		} else {
			this.type = src;
		}
	
		// Put explicitly provided properties onto the event object
		if ( props ) {
			jQuery.extend( this, props );
		}
	
		// Create a timestamp if incoming event doesn't have one
		this.timeStamp = src && src.timeStamp || jQuery.now();
	
		// Mark it as fixed
		this[ jQuery.expando ] = true;
	};
	
	// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
	// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
	jQuery.Event.prototype = {
		constructor: jQuery.Event,
		isDefaultPrevented: returnFalse,
		isPropagationStopped: returnFalse,
		isImmediatePropagationStopped: returnFalse,
		isSimulated: false,
	
		preventDefault: function() {
			var e = this.originalEvent;
	
			this.isDefaultPrevented = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.preventDefault();
			}
		},
		stopPropagation: function() {
			var e = this.originalEvent;
	
			this.isPropagationStopped = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.stopPropagation();
			}
		},
		stopImmediatePropagation: function() {
			var e = this.originalEvent;
	
			this.isImmediatePropagationStopped = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.stopImmediatePropagation();
			}
	
			this.stopPropagation();
		}
	};
	
	// Includes all common event props including KeyEvent and MouseEvent specific props
	jQuery.each( {
		altKey: true,
		bubbles: true,
		cancelable: true,
		changedTouches: true,
		ctrlKey: true,
		detail: true,
		eventPhase: true,
		metaKey: true,
		pageX: true,
		pageY: true,
		shiftKey: true,
		view: true,
		"char": true,
		charCode: true,
		key: true,
		keyCode: true,
		button: true,
		buttons: true,
		clientX: true,
		clientY: true,
		offsetX: true,
		offsetY: true,
		pointerId: true,
		pointerType: true,
		screenX: true,
		screenY: true,
		targetTouches: true,
		toElement: true,
		touches: true,
	
		which: function( event ) {
			var button = event.button;
	
			// Add which for key events
			if ( event.which == null && rkeyEvent.test( event.type ) ) {
				return event.charCode != null ? event.charCode : event.keyCode;
			}
	
			// Add which for click: 1 === left; 2 === middle; 3 === right
			if ( !event.which && button !== undefined && rmouseEvent.test( event.type ) ) {
				if ( button & 1 ) {
					return 1;
				}
	
				if ( button & 2 ) {
					return 3;
				}
	
				if ( button & 4 ) {
					return 2;
				}
	
				return 0;
			}
	
			return event.which;
		}
	}, jQuery.event.addProp );
	
	// Create mouseenter/leave events using mouseover/out and event-time checks
	// so that event delegation works in jQuery.
	// Do the same for pointerenter/pointerleave and pointerover/pointerout
	//
	// Support: Safari 7 only
	// Safari sends mouseenter too often; see:
	// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
	// for the description of the bug (it existed in older Chrome versions as well).
	jQuery.each( {
		mouseenter: "mouseover",
		mouseleave: "mouseout",
		pointerenter: "pointerover",
		pointerleave: "pointerout"
	}, function( orig, fix ) {
		jQuery.event.special[ orig ] = {
			delegateType: fix,
			bindType: fix,
	
			handle: function( event ) {
				var ret,
					target = this,
					related = event.relatedTarget,
					handleObj = event.handleObj;
	
				// For mouseenter/leave call the handler if related is outside the target.
				// NB: No relatedTarget if the mouse left/entered the browser window
				if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
					event.type = handleObj.origType;
					ret = handleObj.handler.apply( this, arguments );
					event.type = fix;
				}
				return ret;
			}
		};
	} );
	
	jQuery.fn.extend( {
	
		on: function( types, selector, data, fn ) {
			return on( this, types, selector, data, fn );
		},
		one: function( types, selector, data, fn ) {
			return on( this, types, selector, data, fn, 1 );
		},
		off: function( types, selector, fn ) {
			var handleObj, type;
			if ( types && types.preventDefault && types.handleObj ) {
	
				// ( event )  dispatched jQuery.Event
				handleObj = types.handleObj;
				jQuery( types.delegateTarget ).off(
					handleObj.namespace ?
						handleObj.origType + "." + handleObj.namespace :
						handleObj.origType,
					handleObj.selector,
					handleObj.handler
				);
				return this;
			}
			if ( typeof types === "object" ) {
	
				// ( types-object [, selector] )
				for ( type in types ) {
					this.off( type, selector, types[ type ] );
				}
				return this;
			}
			if ( selector === false || typeof selector === "function" ) {
	
				// ( types [, fn] )
				fn = selector;
				selector = undefined;
			}
			if ( fn === false ) {
				fn = returnFalse;
			}
			return this.each( function() {
				jQuery.event.remove( this, types, fn, selector );
			} );
		}
	} );
	
	
	var
	
		/* eslint-disable max-len */
	
		// See https://github.com/eslint/eslint/issues/3229
		rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi,
	
		/* eslint-enable */
	
		// Support: IE <=10 - 11, Edge 12 - 13
		// In IE/Edge using regex groups here causes severe slowdowns.
		// See https://connect.microsoft.com/IE/feedback/details/1736512/
		rnoInnerhtml = /<script|<style|<link/i,
	
		// checked="checked" or checked
		rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
		rscriptTypeMasked = /^true\/(.*)/,
		rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;
	
	// Prefer a tbody over its parent table for containing new rows
	function manipulationTarget( elem, content ) {
		if ( nodeName( elem, "table" ) &&
			nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {
	
			return jQuery( ">tbody", elem )[ 0 ] || elem;
		}
	
		return elem;
	}
	
	// Replace/restore the type attribute of script elements for safe DOM manipulation
	function disableScript( elem ) {
		elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
		return elem;
	}
	function restoreScript( elem ) {
		var match = rscriptTypeMasked.exec( elem.type );
	
		if ( match ) {
			elem.type = match[ 1 ];
		} else {
			elem.removeAttribute( "type" );
		}
	
		return elem;
	}
	
	function cloneCopyEvent( src, dest ) {
		var i, l, type, pdataOld, pdataCur, udataOld, udataCur, events;
	
		if ( dest.nodeType !== 1 ) {
			return;
		}
	
		// 1. Copy private data: events, handlers, etc.
		if ( dataPriv.hasData( src ) ) {
			pdataOld = dataPriv.access( src );
			pdataCur = dataPriv.set( dest, pdataOld );
			events = pdataOld.events;
	
			if ( events ) {
				delete pdataCur.handle;
				pdataCur.events = {};
	
				for ( type in events ) {
					for ( i = 0, l = events[ type ].length; i < l; i++ ) {
						jQuery.event.add( dest, type, events[ type ][ i ] );
					}
				}
			}
		}
	
		// 2. Copy user data
		if ( dataUser.hasData( src ) ) {
			udataOld = dataUser.access( src );
			udataCur = jQuery.extend( {}, udataOld );
	
			dataUser.set( dest, udataCur );
		}
	}
	
	// Fix IE bugs, see support tests
	function fixInput( src, dest ) {
		var nodeName = dest.nodeName.toLowerCase();
	
		// Fails to persist the checked state of a cloned checkbox or radio button.
		if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
			dest.checked = src.checked;
	
		// Fails to return the selected option to the default selected state when cloning options
		} else if ( nodeName === "input" || nodeName === "textarea" ) {
			dest.defaultValue = src.defaultValue;
		}
	}
	
	function domManip( collection, args, callback, ignored ) {
	
		// Flatten any nested arrays
		args = concat.apply( [], args );
	
		var fragment, first, scripts, hasScripts, node, doc,
			i = 0,
			l = collection.length,
			iNoClone = l - 1,
			value = args[ 0 ],
			isFunction = jQuery.isFunction( value );
	
		// We can't cloneNode fragments that contain checked, in WebKit
		if ( isFunction ||
				( l > 1 && typeof value === "string" &&
					!support.checkClone && rchecked.test( value ) ) ) {
			return collection.each( function( index ) {
				var self = collection.eq( index );
				if ( isFunction ) {
					args[ 0 ] = value.call( this, index, self.html() );
				}
				domManip( self, args, callback, ignored );
			} );
		}
	
		if ( l ) {
			fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
			first = fragment.firstChild;
	
			if ( fragment.childNodes.length === 1 ) {
				fragment = first;
			}
	
			// Require either new content or an interest in ignored elements to invoke the callback
			if ( first || ignored ) {
				scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
				hasScripts = scripts.length;
	
				// Use the original fragment for the last item
				// instead of the first because it can end up
				// being emptied incorrectly in certain situations (#8070).
				for ( ; i < l; i++ ) {
					node = fragment;
	
					if ( i !== iNoClone ) {
						node = jQuery.clone( node, true, true );
	
						// Keep references to cloned scripts for later restoration
						if ( hasScripts ) {
	
							// Support: Android <=4.0 only, PhantomJS 1 only
							// push.apply(_, arraylike) throws on ancient WebKit
							jQuery.merge( scripts, getAll( node, "script" ) );
						}
					}
	
					callback.call( collection[ i ], node, i );
				}
	
				if ( hasScripts ) {
					doc = scripts[ scripts.length - 1 ].ownerDocument;
	
					// Reenable scripts
					jQuery.map( scripts, restoreScript );
	
					// Evaluate executable scripts on first document insertion
					for ( i = 0; i < hasScripts; i++ ) {
						node = scripts[ i ];
						if ( rscriptType.test( node.type || "" ) &&
							!dataPriv.access( node, "globalEval" ) &&
							jQuery.contains( doc, node ) ) {
	
							if ( node.src ) {
	
								// Optional AJAX dependency, but won't run scripts if not present
								if ( jQuery._evalUrl ) {
									jQuery._evalUrl( node.src );
								}
							} else {
								DOMEval( node.textContent.replace( rcleanScript, "" ), doc );
							}
						}
					}
				}
			}
		}
	
		return collection;
	}
	
	function remove( elem, selector, keepData ) {
		var node,
			nodes = selector ? jQuery.filter( selector, elem ) : elem,
			i = 0;
	
		for ( ; ( node = nodes[ i ] ) != null; i++ ) {
			if ( !keepData && node.nodeType === 1 ) {
				jQuery.cleanData( getAll( node ) );
			}
	
			if ( node.parentNode ) {
				if ( keepData && jQuery.contains( node.ownerDocument, node ) ) {
					setGlobalEval( getAll( node, "script" ) );
				}
				node.parentNode.removeChild( node );
			}
		}
	
		return elem;
	}
	
	jQuery.extend( {
		htmlPrefilter: function( html ) {
			return html.replace( rxhtmlTag, "<$1></$2>" );
		},
	
		clone: function( elem, dataAndEvents, deepDataAndEvents ) {
			var i, l, srcElements, destElements,
				clone = elem.cloneNode( true ),
				inPage = jQuery.contains( elem.ownerDocument, elem );
	
			// Fix IE cloning issues
			if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
					!jQuery.isXMLDoc( elem ) ) {
	
				// We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
				destElements = getAll( clone );
				srcElements = getAll( elem );
	
				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					fixInput( srcElements[ i ], destElements[ i ] );
				}
			}
	
			// Copy the events from the original to the clone
			if ( dataAndEvents ) {
				if ( deepDataAndEvents ) {
					srcElements = srcElements || getAll( elem );
					destElements = destElements || getAll( clone );
	
					for ( i = 0, l = srcElements.length; i < l; i++ ) {
						cloneCopyEvent( srcElements[ i ], destElements[ i ] );
					}
				} else {
					cloneCopyEvent( elem, clone );
				}
			}
	
			// Preserve script evaluation history
			destElements = getAll( clone, "script" );
			if ( destElements.length > 0 ) {
				setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
			}
	
			// Return the cloned set
			return clone;
		},
	
		cleanData: function( elems ) {
			var data, elem, type,
				special = jQuery.event.special,
				i = 0;
	
			for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
				if ( acceptData( elem ) ) {
					if ( ( data = elem[ dataPriv.expando ] ) ) {
						if ( data.events ) {
							for ( type in data.events ) {
								if ( special[ type ] ) {
									jQuery.event.remove( elem, type );
	
								// This is a shortcut to avoid jQuery.event.remove's overhead
								} else {
									jQuery.removeEvent( elem, type, data.handle );
								}
							}
						}
	
						// Support: Chrome <=35 - 45+
						// Assign undefined instead of using delete, see Data#remove
						elem[ dataPriv.expando ] = undefined;
					}
					if ( elem[ dataUser.expando ] ) {
	
						// Support: Chrome <=35 - 45+
						// Assign undefined instead of using delete, see Data#remove
						elem[ dataUser.expando ] = undefined;
					}
				}
			}
		}
	} );
	
	jQuery.fn.extend( {
		detach: function( selector ) {
			return remove( this, selector, true );
		},
	
		remove: function( selector ) {
			return remove( this, selector );
		},
	
		text: function( value ) {
			return access( this, function( value ) {
				return value === undefined ?
					jQuery.text( this ) :
					this.empty().each( function() {
						if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
							this.textContent = value;
						}
					} );
			}, null, value, arguments.length );
		},
	
		append: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.appendChild( elem );
				}
			} );
		},
	
		prepend: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.insertBefore( elem, target.firstChild );
				}
			} );
		},
	
		before: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this );
				}
			} );
		},
	
		after: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this.nextSibling );
				}
			} );
		},
	
		empty: function() {
			var elem,
				i = 0;
	
			for ( ; ( elem = this[ i ] ) != null; i++ ) {
				if ( elem.nodeType === 1 ) {
	
					// Prevent memory leaks
					jQuery.cleanData( getAll( elem, false ) );
	
					// Remove any remaining nodes
					elem.textContent = "";
				}
			}
	
			return this;
		},
	
		clone: function( dataAndEvents, deepDataAndEvents ) {
			dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
			deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
	
			return this.map( function() {
				return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
			} );
		},
	
		html: function( value ) {
			return access( this, function( value ) {
				var elem = this[ 0 ] || {},
					i = 0,
					l = this.length;
	
				if ( value === undefined && elem.nodeType === 1 ) {
					return elem.innerHTML;
				}
	
				// See if we can take a shortcut and just use innerHTML
				if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
					!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {
	
					value = jQuery.htmlPrefilter( value );
	
					try {
						for ( ; i < l; i++ ) {
							elem = this[ i ] || {};
	
							// Remove element nodes and prevent memory leaks
							if ( elem.nodeType === 1 ) {
								jQuery.cleanData( getAll( elem, false ) );
								elem.innerHTML = value;
							}
						}
	
						elem = 0;
	
					// If using innerHTML throws an exception, use the fallback method
					} catch ( e ) {}
				}
	
				if ( elem ) {
					this.empty().append( value );
				}
			}, null, value, arguments.length );
		},
	
		replaceWith: function() {
			var ignored = [];
	
			// Make the changes, replacing each non-ignored context element with the new content
			return domManip( this, arguments, function( elem ) {
				var parent = this.parentNode;
	
				if ( jQuery.inArray( this, ignored ) < 0 ) {
					jQuery.cleanData( getAll( this ) );
					if ( parent ) {
						parent.replaceChild( elem, this );
					}
				}
	
			// Force callback invocation
			}, ignored );
		}
	} );
	
	jQuery.each( {
		appendTo: "append",
		prependTo: "prepend",
		insertBefore: "before",
		insertAfter: "after",
		replaceAll: "replaceWith"
	}, function( name, original ) {
		jQuery.fn[ name ] = function( selector ) {
			var elems,
				ret = [],
				insert = jQuery( selector ),
				last = insert.length - 1,
				i = 0;
	
			for ( ; i <= last; i++ ) {
				elems = i === last ? this : this.clone( true );
				jQuery( insert[ i ] )[ original ]( elems );
	
				// Support: Android <=4.0 only, PhantomJS 1 only
				// .get() because push.apply(_, arraylike) throws on ancient WebKit
				push.apply( ret, elems.get() );
			}
	
			return this.pushStack( ret );
		};
	} );
	var rmargin = ( /^margin/ );
	
	var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );
	
	var getStyles = function( elem ) {
	
			// Support: IE <=11 only, Firefox <=30 (#15098, #14150)
			// IE throws on elements created in popups
			// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
			var view = elem.ownerDocument.defaultView;
	
			if ( !view || !view.opener ) {
				view = window;
			}
	
			return view.getComputedStyle( elem );
		};
	
	
	
	( function() {
	
		// Executing both pixelPosition & boxSizingReliable tests require only one layout
		// so they're executed at the same time to save the second computation.
		function computeStyleTests() {
	
			// This is a singleton, we need to execute it only once
			if ( !div ) {
				return;
			}
	
			div.style.cssText =
				"box-sizing:border-box;" +
				"position:relative;display:block;" +
				"margin:auto;border:1px;padding:1px;" +
				"top:1%;width:50%";
			div.innerHTML = "";
			documentElement.appendChild( container );
	
			var divStyle = window.getComputedStyle( div );
			pixelPositionVal = divStyle.top !== "1%";
	
			// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
			reliableMarginLeftVal = divStyle.marginLeft === "2px";
			boxSizingReliableVal = divStyle.width === "4px";
	
			// Support: Android 4.0 - 4.3 only
			// Some styles come back with percentage values, even though they shouldn't
			div.style.marginRight = "50%";
			pixelMarginRightVal = divStyle.marginRight === "4px";
	
			documentElement.removeChild( container );
	
			// Nullify the div so it wouldn't be stored in the memory and
			// it will also be a sign that checks already performed
			div = null;
		}
	
		var pixelPositionVal, boxSizingReliableVal, pixelMarginRightVal, reliableMarginLeftVal,
			container = document.createElement( "div" ),
			div = document.createElement( "div" );
	
		// Finish early in limited (non-browser) environments
		if ( !div.style ) {
			return;
		}
	
		// Support: IE <=9 - 11 only
		// Style of cloned element affects source element cloned (#8908)
		div.style.backgroundClip = "content-box";
		div.cloneNode( true ).style.backgroundClip = "";
		support.clearCloneStyle = div.style.backgroundClip === "content-box";
	
		container.style.cssText = "border:0;width:8px;height:0;top:0;left:-9999px;" +
			"padding:0;margin-top:1px;position:absolute";
		container.appendChild( div );
	
		jQuery.extend( support, {
			pixelPosition: function() {
				computeStyleTests();
				return pixelPositionVal;
			},
			boxSizingReliable: function() {
				computeStyleTests();
				return boxSizingReliableVal;
			},
			pixelMarginRight: function() {
				computeStyleTests();
				return pixelMarginRightVal;
			},
			reliableMarginLeft: function() {
				computeStyleTests();
				return reliableMarginLeftVal;
			}
		} );
	} )();
	
	
	function curCSS( elem, name, computed ) {
		var width, minWidth, maxWidth, ret,
	
			// Support: Firefox 51+
			// Retrieving style before computed somehow
			// fixes an issue with getting wrong values
			// on detached elements
			style = elem.style;
	
		computed = computed || getStyles( elem );
	
		// getPropertyValue is needed for:
		//   .css('filter') (IE 9 only, #12537)
		//   .css('--customProperty) (#3144)
		if ( computed ) {
			ret = computed.getPropertyValue( name ) || computed[ name ];
	
			if ( ret === "" && !jQuery.contains( elem.ownerDocument, elem ) ) {
				ret = jQuery.style( elem, name );
			}
	
			// A tribute to the "awesome hack by Dean Edwards"
			// Android Browser returns percentage for some values,
			// but width seems to be reliably pixels.
			// This is against the CSSOM draft spec:
			// https://drafts.csswg.org/cssom/#resolved-values
			if ( !support.pixelMarginRight() && rnumnonpx.test( ret ) && rmargin.test( name ) ) {
	
				// Remember the original values
				width = style.width;
				minWidth = style.minWidth;
				maxWidth = style.maxWidth;
	
				// Put in the new values to get a computed value out
				style.minWidth = style.maxWidth = style.width = ret;
				ret = computed.width;
	
				// Revert the changed values
				style.width = width;
				style.minWidth = minWidth;
				style.maxWidth = maxWidth;
			}
		}
	
		return ret !== undefined ?
	
			// Support: IE <=9 - 11 only
			// IE returns zIndex value as an integer.
			ret + "" :
			ret;
	}
	
	
	function addGetHookIf( conditionFn, hookFn ) {
	
		// Define the hook, we'll check on the first run if it's really needed.
		return {
			get: function() {
				if ( conditionFn() ) {
	
					// Hook not needed (or it's not possible to use it due
					// to missing dependency), remove it.
					delete this.get;
					return;
				}
	
				// Hook needed; redefine it so that the support test is not executed again.
				return ( this.get = hookFn ).apply( this, arguments );
			}
		};
	}
	
	
	var
	
		// Swappable if display is none or starts with table
		// except "table", "table-cell", or "table-caption"
		// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
		rdisplayswap = /^(none|table(?!-c[ea]).+)/,
		rcustomProp = /^--/,
		cssShow = { position: "absolute", visibility: "hidden", display: "block" },
		cssNormalTransform = {
			letterSpacing: "0",
			fontWeight: "400"
		},
	
		cssPrefixes = [ "Webkit", "Moz", "ms" ],
		emptyStyle = document.createElement( "div" ).style;
	
	// Return a css property mapped to a potentially vendor prefixed property
	function vendorPropName( name ) {
	
		// Shortcut for names that are not vendor prefixed
		if ( name in emptyStyle ) {
			return name;
		}
	
		// Check for vendor prefixed names
		var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
			i = cssPrefixes.length;
	
		while ( i-- ) {
			name = cssPrefixes[ i ] + capName;
			if ( name in emptyStyle ) {
				return name;
			}
		}
	}
	
	// Return a property mapped along what jQuery.cssProps suggests or to
	// a vendor prefixed property.
	function finalPropName( name ) {
		var ret = jQuery.cssProps[ name ];
		if ( !ret ) {
			ret = jQuery.cssProps[ name ] = vendorPropName( name ) || name;
		}
		return ret;
	}
	
	function setPositiveNumber( elem, value, subtract ) {
	
		// Any relative (+/-) values have already been
		// normalized at this point
		var matches = rcssNum.exec( value );
		return matches ?
	
			// Guard against undefined "subtract", e.g., when used as in cssHooks
			Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
			value;
	}
	
	function augmentWidthOrHeight( elem, name, extra, isBorderBox, styles ) {
		var i,
			val = 0;
	
		// If we already have the right measurement, avoid augmentation
		if ( extra === ( isBorderBox ? "border" : "content" ) ) {
			i = 4;
	
		// Otherwise initialize for horizontal or vertical properties
		} else {
			i = name === "width" ? 1 : 0;
		}
	
		for ( ; i < 4; i += 2 ) {
	
			// Both box models exclude margin, so add it if we want it
			if ( extra === "margin" ) {
				val += jQuery.css( elem, extra + cssExpand[ i ], true, styles );
			}
	
			if ( isBorderBox ) {
	
				// border-box includes padding, so remove it if we want content
				if ( extra === "content" ) {
					val -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
				}
	
				// At this point, extra isn't border nor margin, so remove border
				if ( extra !== "margin" ) {
					val -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
			} else {
	
				// At this point, extra isn't content, so add padding
				val += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
	
				// At this point, extra isn't content nor padding, so add border
				if ( extra !== "padding" ) {
					val += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
			}
		}
	
		return val;
	}
	
	function getWidthOrHeight( elem, name, extra ) {
	
		// Start with computed style
		var valueIsBorderBox,
			styles = getStyles( elem ),
			val = curCSS( elem, name, styles ),
			isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";
	
		// Computed unit is not pixels. Stop here and return.
		if ( rnumnonpx.test( val ) ) {
			return val;
		}
	
		// Check for style in case a browser which returns unreliable values
		// for getComputedStyle silently falls back to the reliable elem.style
		valueIsBorderBox = isBorderBox &&
			( support.boxSizingReliable() || val === elem.style[ name ] );
	
		// Fall back to offsetWidth/Height when value is "auto"
		// This happens for inline elements with no explicit setting (gh-3571)
		if ( val === "auto" ) {
			val = elem[ "offset" + name[ 0 ].toUpperCase() + name.slice( 1 ) ];
		}
	
		// Normalize "", auto, and prepare for extra
		val = parseFloat( val ) || 0;
	
		// Use the active box-sizing model to add/subtract irrelevant styles
		return ( val +
			augmentWidthOrHeight(
				elem,
				name,
				extra || ( isBorderBox ? "border" : "content" ),
				valueIsBorderBox,
				styles
			)
		) + "px";
	}
	
	jQuery.extend( {
	
		// Add in style property hooks for overriding the default
		// behavior of getting and setting a style property
		cssHooks: {
			opacity: {
				get: function( elem, computed ) {
					if ( computed ) {
	
						// We should always get a number back from opacity
						var ret = curCSS( elem, "opacity" );
						return ret === "" ? "1" : ret;
					}
				}
			}
		},
	
		// Don't automatically add "px" to these possibly-unitless properties
		cssNumber: {
			"animationIterationCount": true,
			"columnCount": true,
			"fillOpacity": true,
			"flexGrow": true,
			"flexShrink": true,
			"fontWeight": true,
			"lineHeight": true,
			"opacity": true,
			"order": true,
			"orphans": true,
			"widows": true,
			"zIndex": true,
			"zoom": true
		},
	
		// Add in properties whose names you wish to fix before
		// setting or getting the value
		cssProps: {
			"float": "cssFloat"
		},
	
		// Get and set the style property on a DOM Node
		style: function( elem, name, value, extra ) {
	
			// Don't set styles on text and comment nodes
			if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
				return;
			}
	
			// Make sure that we're working with the right name
			var ret, type, hooks,
				origName = jQuery.camelCase( name ),
				isCustomProp = rcustomProp.test( name ),
				style = elem.style;
	
			// Make sure that we're working with the right name. We don't
			// want to query the value if it is a CSS custom property
			// since they are user-defined.
			if ( !isCustomProp ) {
				name = finalPropName( origName );
			}
	
			// Gets hook for the prefixed version, then unprefixed version
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// Check if we're setting a value
			if ( value !== undefined ) {
				type = typeof value;
	
				// Convert "+=" or "-=" to relative numbers (#7345)
				if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
					value = adjustCSS( elem, name, ret );
	
					// Fixes bug #9237
					type = "number";
				}
	
				// Make sure that null and NaN values aren't set (#7116)
				if ( value == null || value !== value ) {
					return;
				}
	
				// If a number was passed in, add the unit (except for certain CSS properties)
				if ( type === "number" ) {
					value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
				}
	
				// background-* props affect original clone's values
				if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
					style[ name ] = "inherit";
				}
	
				// If a hook was provided, use that value, otherwise just set the specified value
				if ( !hooks || !( "set" in hooks ) ||
					( value = hooks.set( elem, value, extra ) ) !== undefined ) {
	
					if ( isCustomProp ) {
						style.setProperty( name, value );
					} else {
						style[ name ] = value;
					}
				}
	
			} else {
	
				// If a hook was provided get the non-computed value from there
				if ( hooks && "get" in hooks &&
					( ret = hooks.get( elem, false, extra ) ) !== undefined ) {
	
					return ret;
				}
	
				// Otherwise just get the value from the style object
				return style[ name ];
			}
		},
	
		css: function( elem, name, extra, styles ) {
			var val, num, hooks,
				origName = jQuery.camelCase( name ),
				isCustomProp = rcustomProp.test( name );
	
			// Make sure that we're working with the right name. We don't
			// want to modify the value if it is a CSS custom property
			// since they are user-defined.
			if ( !isCustomProp ) {
				name = finalPropName( origName );
			}
	
			// Try prefixed name followed by the unprefixed name
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// If a hook was provided get the computed value from there
			if ( hooks && "get" in hooks ) {
				val = hooks.get( elem, true, extra );
			}
	
			// Otherwise, if a way to get the computed value exists, use that
			if ( val === undefined ) {
				val = curCSS( elem, name, styles );
			}
	
			// Convert "normal" to computed value
			if ( val === "normal" && name in cssNormalTransform ) {
				val = cssNormalTransform[ name ];
			}
	
			// Make numeric if forced or a qualifier was provided and val looks numeric
			if ( extra === "" || extra ) {
				num = parseFloat( val );
				return extra === true || isFinite( num ) ? num || 0 : val;
			}
	
			return val;
		}
	} );
	
	jQuery.each( [ "height", "width" ], function( i, name ) {
		jQuery.cssHooks[ name ] = {
			get: function( elem, computed, extra ) {
				if ( computed ) {
	
					// Certain elements can have dimension info if we invisibly show them
					// but it must have a current display style that would benefit
					return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&
	
						// Support: Safari 8+
						// Table columns in Safari have non-zero offsetWidth & zero
						// getBoundingClientRect().width unless display is changed.
						// Support: IE <=11 only
						// Running getBoundingClientRect on a disconnected node
						// in IE throws an error.
						( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
							swap( elem, cssShow, function() {
								return getWidthOrHeight( elem, name, extra );
							} ) :
							getWidthOrHeight( elem, name, extra );
				}
			},
	
			set: function( elem, value, extra ) {
				var matches,
					styles = extra && getStyles( elem ),
					subtract = extra && augmentWidthOrHeight(
						elem,
						name,
						extra,
						jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
						styles
					);
	
				// Convert to pixels if value adjustment is needed
				if ( subtract && ( matches = rcssNum.exec( value ) ) &&
					( matches[ 3 ] || "px" ) !== "px" ) {
	
					elem.style[ name ] = value;
					value = jQuery.css( elem, name );
				}
	
				return setPositiveNumber( elem, value, subtract );
			}
		};
	} );
	
	jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
		function( elem, computed ) {
			if ( computed ) {
				return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
					elem.getBoundingClientRect().left -
						swap( elem, { marginLeft: 0 }, function() {
							return elem.getBoundingClientRect().left;
						} )
					) + "px";
			}
		}
	);
	
	// These hooks are used by animate to expand properties
	jQuery.each( {
		margin: "",
		padding: "",
		border: "Width"
	}, function( prefix, suffix ) {
		jQuery.cssHooks[ prefix + suffix ] = {
			expand: function( value ) {
				var i = 0,
					expanded = {},
	
					// Assumes a single number if not a string
					parts = typeof value === "string" ? value.split( " " ) : [ value ];
	
				for ( ; i < 4; i++ ) {
					expanded[ prefix + cssExpand[ i ] + suffix ] =
						parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
				}
	
				return expanded;
			}
		};
	
		if ( !rmargin.test( prefix ) ) {
			jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
		}
	} );
	
	jQuery.fn.extend( {
		css: function( name, value ) {
			return access( this, function( elem, name, value ) {
				var styles, len,
					map = {},
					i = 0;
	
				if ( Array.isArray( name ) ) {
					styles = getStyles( elem );
					len = name.length;
	
					for ( ; i < len; i++ ) {
						map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
					}
	
					return map;
				}
	
				return value !== undefined ?
					jQuery.style( elem, name, value ) :
					jQuery.css( elem, name );
			}, name, value, arguments.length > 1 );
		}
	} );
	
	
	function Tween( elem, options, prop, end, easing ) {
		return new Tween.prototype.init( elem, options, prop, end, easing );
	}
	jQuery.Tween = Tween;
	
	Tween.prototype = {
		constructor: Tween,
		init: function( elem, options, prop, end, easing, unit ) {
			this.elem = elem;
			this.prop = prop;
			this.easing = easing || jQuery.easing._default;
			this.options = options;
			this.start = this.now = this.cur();
			this.end = end;
			this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
		},
		cur: function() {
			var hooks = Tween.propHooks[ this.prop ];
	
			return hooks && hooks.get ?
				hooks.get( this ) :
				Tween.propHooks._default.get( this );
		},
		run: function( percent ) {
			var eased,
				hooks = Tween.propHooks[ this.prop ];
	
			if ( this.options.duration ) {
				this.pos = eased = jQuery.easing[ this.easing ](
					percent, this.options.duration * percent, 0, 1, this.options.duration
				);
			} else {
				this.pos = eased = percent;
			}
			this.now = ( this.end - this.start ) * eased + this.start;
	
			if ( this.options.step ) {
				this.options.step.call( this.elem, this.now, this );
			}
	
			if ( hooks && hooks.set ) {
				hooks.set( this );
			} else {
				Tween.propHooks._default.set( this );
			}
			return this;
		}
	};
	
	Tween.prototype.init.prototype = Tween.prototype;
	
	Tween.propHooks = {
		_default: {
			get: function( tween ) {
				var result;
	
				// Use a property on the element directly when it is not a DOM element,
				// or when there is no matching style property that exists.
				if ( tween.elem.nodeType !== 1 ||
					tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
					return tween.elem[ tween.prop ];
				}
	
				// Passing an empty string as a 3rd parameter to .css will automatically
				// attempt a parseFloat and fallback to a string if the parse fails.
				// Simple values such as "10px" are parsed to Float;
				// complex values such as "rotate(1rad)" are returned as-is.
				result = jQuery.css( tween.elem, tween.prop, "" );
	
				// Empty strings, null, undefined and "auto" are converted to 0.
				return !result || result === "auto" ? 0 : result;
			},
			set: function( tween ) {
	
				// Use step hook for back compat.
				// Use cssHook if its there.
				// Use .style if available and use plain properties where available.
				if ( jQuery.fx.step[ tween.prop ] ) {
					jQuery.fx.step[ tween.prop ]( tween );
				} else if ( tween.elem.nodeType === 1 &&
					( tween.elem.style[ jQuery.cssProps[ tween.prop ] ] != null ||
						jQuery.cssHooks[ tween.prop ] ) ) {
					jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
				} else {
					tween.elem[ tween.prop ] = tween.now;
				}
			}
		}
	};
	
	// Support: IE <=9 only
	// Panic based approach to setting things on disconnected nodes
	Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
		set: function( tween ) {
			if ( tween.elem.nodeType && tween.elem.parentNode ) {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	};
	
	jQuery.easing = {
		linear: function( p ) {
			return p;
		},
		swing: function( p ) {
			return 0.5 - Math.cos( p * Math.PI ) / 2;
		},
		_default: "swing"
	};
	
	jQuery.fx = Tween.prototype.init;
	
	// Back compat <1.8 extension point
	jQuery.fx.step = {};
	
	
	
	
	var
		fxNow, inProgress,
		rfxtypes = /^(?:toggle|show|hide)$/,
		rrun = /queueHooks$/;
	
	function schedule() {
		if ( inProgress ) {
			if ( document.hidden === false && window.requestAnimationFrame ) {
				window.requestAnimationFrame( schedule );
			} else {
				window.setTimeout( schedule, jQuery.fx.interval );
			}
	
			jQuery.fx.tick();
		}
	}
	
	// Animations created synchronously will run synchronously
	function createFxNow() {
		window.setTimeout( function() {
			fxNow = undefined;
		} );
		return ( fxNow = jQuery.now() );
	}
	
	// Generate parameters to create a standard animation
	function genFx( type, includeWidth ) {
		var which,
			i = 0,
			attrs = { height: type };
	
		// If we include width, step value is 1 to do all cssExpand values,
		// otherwise step value is 2 to skip over Left and Right
		includeWidth = includeWidth ? 1 : 0;
		for ( ; i < 4; i += 2 - includeWidth ) {
			which = cssExpand[ i ];
			attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
		}
	
		if ( includeWidth ) {
			attrs.opacity = attrs.width = type;
		}
	
		return attrs;
	}
	
	function createTween( value, prop, animation ) {
		var tween,
			collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
			index = 0,
			length = collection.length;
		for ( ; index < length; index++ ) {
			if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {
	
				// We're done with this property
				return tween;
			}
		}
	}
	
	function defaultPrefilter( elem, props, opts ) {
		var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
			isBox = "width" in props || "height" in props,
			anim = this,
			orig = {},
			style = elem.style,
			hidden = elem.nodeType && isHiddenWithinTree( elem ),
			dataShow = dataPriv.get( elem, "fxshow" );
	
		// Queue-skipping animations hijack the fx hooks
		if ( !opts.queue ) {
			hooks = jQuery._queueHooks( elem, "fx" );
			if ( hooks.unqueued == null ) {
				hooks.unqueued = 0;
				oldfire = hooks.empty.fire;
				hooks.empty.fire = function() {
					if ( !hooks.unqueued ) {
						oldfire();
					}
				};
			}
			hooks.unqueued++;
	
			anim.always( function() {
	
				// Ensure the complete handler is called before this completes
				anim.always( function() {
					hooks.unqueued--;
					if ( !jQuery.queue( elem, "fx" ).length ) {
						hooks.empty.fire();
					}
				} );
			} );
		}
	
		// Detect show/hide animations
		for ( prop in props ) {
			value = props[ prop ];
			if ( rfxtypes.test( value ) ) {
				delete props[ prop ];
				toggle = toggle || value === "toggle";
				if ( value === ( hidden ? "hide" : "show" ) ) {
	
					// Pretend to be hidden if this is a "show" and
					// there is still data from a stopped show/hide
					if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
						hidden = true;
	
					// Ignore all other no-op show/hide data
					} else {
						continue;
					}
				}
				orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
			}
		}
	
		// Bail out if this is a no-op like .hide().hide()
		propTween = !jQuery.isEmptyObject( props );
		if ( !propTween && jQuery.isEmptyObject( orig ) ) {
			return;
		}
	
		// Restrict "overflow" and "display" styles during box animations
		if ( isBox && elem.nodeType === 1 ) {
	
			// Support: IE <=9 - 11, Edge 12 - 13
			// Record all 3 overflow attributes because IE does not infer the shorthand
			// from identically-valued overflowX and overflowY
			opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];
	
			// Identify a display type, preferring old show/hide data over the CSS cascade
			restoreDisplay = dataShow && dataShow.display;
			if ( restoreDisplay == null ) {
				restoreDisplay = dataPriv.get( elem, "display" );
			}
			display = jQuery.css( elem, "display" );
			if ( display === "none" ) {
				if ( restoreDisplay ) {
					display = restoreDisplay;
				} else {
	
					// Get nonempty value(s) by temporarily forcing visibility
					showHide( [ elem ], true );
					restoreDisplay = elem.style.display || restoreDisplay;
					display = jQuery.css( elem, "display" );
					showHide( [ elem ] );
				}
			}
	
			// Animate inline elements as inline-block
			if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
				if ( jQuery.css( elem, "float" ) === "none" ) {
	
					// Restore the original display value at the end of pure show/hide animations
					if ( !propTween ) {
						anim.done( function() {
							style.display = restoreDisplay;
						} );
						if ( restoreDisplay == null ) {
							display = style.display;
							restoreDisplay = display === "none" ? "" : display;
						}
					}
					style.display = "inline-block";
				}
			}
		}
	
		if ( opts.overflow ) {
			style.overflow = "hidden";
			anim.always( function() {
				style.overflow = opts.overflow[ 0 ];
				style.overflowX = opts.overflow[ 1 ];
				style.overflowY = opts.overflow[ 2 ];
			} );
		}
	
		// Implement show/hide animations
		propTween = false;
		for ( prop in orig ) {
	
			// General show/hide setup for this element animation
			if ( !propTween ) {
				if ( dataShow ) {
					if ( "hidden" in dataShow ) {
						hidden = dataShow.hidden;
					}
				} else {
					dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
				}
	
				// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
				if ( toggle ) {
					dataShow.hidden = !hidden;
				}
	
				// Show elements before animating them
				if ( hidden ) {
					showHide( [ elem ], true );
				}
	
				/* eslint-disable no-loop-func */
	
				anim.done( function() {
	
				/* eslint-enable no-loop-func */
	
					// The final step of a "hide" animation is actually hiding the element
					if ( !hidden ) {
						showHide( [ elem ] );
					}
					dataPriv.remove( elem, "fxshow" );
					for ( prop in orig ) {
						jQuery.style( elem, prop, orig[ prop ] );
					}
				} );
			}
	
			// Per-property setup
			propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
			if ( !( prop in dataShow ) ) {
				dataShow[ prop ] = propTween.start;
				if ( hidden ) {
					propTween.end = propTween.start;
					propTween.start = 0;
				}
			}
		}
	}
	
	function propFilter( props, specialEasing ) {
		var index, name, easing, value, hooks;
	
		// camelCase, specialEasing and expand cssHook pass
		for ( index in props ) {
			name = jQuery.camelCase( index );
			easing = specialEasing[ name ];
			value = props[ index ];
			if ( Array.isArray( value ) ) {
				easing = value[ 1 ];
				value = props[ index ] = value[ 0 ];
			}
	
			if ( index !== name ) {
				props[ name ] = value;
				delete props[ index ];
			}
	
			hooks = jQuery.cssHooks[ name ];
			if ( hooks && "expand" in hooks ) {
				value = hooks.expand( value );
				delete props[ name ];
	
				// Not quite $.extend, this won't overwrite existing keys.
				// Reusing 'index' because we have the correct "name"
				for ( index in value ) {
					if ( !( index in props ) ) {
						props[ index ] = value[ index ];
						specialEasing[ index ] = easing;
					}
				}
			} else {
				specialEasing[ name ] = easing;
			}
		}
	}
	
	function Animation( elem, properties, options ) {
		var result,
			stopped,
			index = 0,
			length = Animation.prefilters.length,
			deferred = jQuery.Deferred().always( function() {
	
				// Don't match elem in the :animated selector
				delete tick.elem;
			} ),
			tick = function() {
				if ( stopped ) {
					return false;
				}
				var currentTime = fxNow || createFxNow(),
					remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),
	
					// Support: Android 2.3 only
					// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
					temp = remaining / animation.duration || 0,
					percent = 1 - temp,
					index = 0,
					length = animation.tweens.length;
	
				for ( ; index < length; index++ ) {
					animation.tweens[ index ].run( percent );
				}
	
				deferred.notifyWith( elem, [ animation, percent, remaining ] );
	
				// If there's more to do, yield
				if ( percent < 1 && length ) {
					return remaining;
				}
	
				// If this was an empty animation, synthesize a final progress notification
				if ( !length ) {
					deferred.notifyWith( elem, [ animation, 1, 0 ] );
				}
	
				// Resolve the animation and report its conclusion
				deferred.resolveWith( elem, [ animation ] );
				return false;
			},
			animation = deferred.promise( {
				elem: elem,
				props: jQuery.extend( {}, properties ),
				opts: jQuery.extend( true, {
					specialEasing: {},
					easing: jQuery.easing._default
				}, options ),
				originalProperties: properties,
				originalOptions: options,
				startTime: fxNow || createFxNow(),
				duration: options.duration,
				tweens: [],
				createTween: function( prop, end ) {
					var tween = jQuery.Tween( elem, animation.opts, prop, end,
							animation.opts.specialEasing[ prop ] || animation.opts.easing );
					animation.tweens.push( tween );
					return tween;
				},
				stop: function( gotoEnd ) {
					var index = 0,
	
						// If we are going to the end, we want to run all the tweens
						// otherwise we skip this part
						length = gotoEnd ? animation.tweens.length : 0;
					if ( stopped ) {
						return this;
					}
					stopped = true;
					for ( ; index < length; index++ ) {
						animation.tweens[ index ].run( 1 );
					}
	
					// Resolve when we played the last frame; otherwise, reject
					if ( gotoEnd ) {
						deferred.notifyWith( elem, [ animation, 1, 0 ] );
						deferred.resolveWith( elem, [ animation, gotoEnd ] );
					} else {
						deferred.rejectWith( elem, [ animation, gotoEnd ] );
					}
					return this;
				}
			} ),
			props = animation.props;
	
		propFilter( props, animation.opts.specialEasing );
	
		for ( ; index < length; index++ ) {
			result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
			if ( result ) {
				if ( jQuery.isFunction( result.stop ) ) {
					jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
						jQuery.proxy( result.stop, result );
				}
				return result;
			}
		}
	
		jQuery.map( props, createTween, animation );
	
		if ( jQuery.isFunction( animation.opts.start ) ) {
			animation.opts.start.call( elem, animation );
		}
	
		// Attach callbacks from options
		animation
			.progress( animation.opts.progress )
			.done( animation.opts.done, animation.opts.complete )
			.fail( animation.opts.fail )
			.always( animation.opts.always );
	
		jQuery.fx.timer(
			jQuery.extend( tick, {
				elem: elem,
				anim: animation,
				queue: animation.opts.queue
			} )
		);
	
		return animation;
	}
	
	jQuery.Animation = jQuery.extend( Animation, {
	
		tweeners: {
			"*": [ function( prop, value ) {
				var tween = this.createTween( prop, value );
				adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
				return tween;
			} ]
		},
	
		tweener: function( props, callback ) {
			if ( jQuery.isFunction( props ) ) {
				callback = props;
				props = [ "*" ];
			} else {
				props = props.match( rnothtmlwhite );
			}
	
			var prop,
				index = 0,
				length = props.length;
	
			for ( ; index < length; index++ ) {
				prop = props[ index ];
				Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
				Animation.tweeners[ prop ].unshift( callback );
			}
		},
	
		prefilters: [ defaultPrefilter ],
	
		prefilter: function( callback, prepend ) {
			if ( prepend ) {
				Animation.prefilters.unshift( callback );
			} else {
				Animation.prefilters.push( callback );
			}
		}
	} );
	
	jQuery.speed = function( speed, easing, fn ) {
		var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
			complete: fn || !fn && easing ||
				jQuery.isFunction( speed ) && speed,
			duration: speed,
			easing: fn && easing || easing && !jQuery.isFunction( easing ) && easing
		};
	
		// Go to the end state if fx are off
		if ( jQuery.fx.off ) {
			opt.duration = 0;
	
		} else {
			if ( typeof opt.duration !== "number" ) {
				if ( opt.duration in jQuery.fx.speeds ) {
					opt.duration = jQuery.fx.speeds[ opt.duration ];
	
				} else {
					opt.duration = jQuery.fx.speeds._default;
				}
			}
		}
	
		// Normalize opt.queue - true/undefined/null -> "fx"
		if ( opt.queue == null || opt.queue === true ) {
			opt.queue = "fx";
		}
	
		// Queueing
		opt.old = opt.complete;
	
		opt.complete = function() {
			if ( jQuery.isFunction( opt.old ) ) {
				opt.old.call( this );
			}
	
			if ( opt.queue ) {
				jQuery.dequeue( this, opt.queue );
			}
		};
	
		return opt;
	};
	
	jQuery.fn.extend( {
		fadeTo: function( speed, to, easing, callback ) {
	
			// Show any hidden elements after setting opacity to 0
			return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()
	
				// Animate to the value specified
				.end().animate( { opacity: to }, speed, easing, callback );
		},
		animate: function( prop, speed, easing, callback ) {
			var empty = jQuery.isEmptyObject( prop ),
				optall = jQuery.speed( speed, easing, callback ),
				doAnimation = function() {
	
					// Operate on a copy of prop so per-property easing won't be lost
					var anim = Animation( this, jQuery.extend( {}, prop ), optall );
	
					// Empty animations, or finishing resolves immediately
					if ( empty || dataPriv.get( this, "finish" ) ) {
						anim.stop( true );
					}
				};
				doAnimation.finish = doAnimation;
	
			return empty || optall.queue === false ?
				this.each( doAnimation ) :
				this.queue( optall.queue, doAnimation );
		},
		stop: function( type, clearQueue, gotoEnd ) {
			var stopQueue = function( hooks ) {
				var stop = hooks.stop;
				delete hooks.stop;
				stop( gotoEnd );
			};
	
			if ( typeof type !== "string" ) {
				gotoEnd = clearQueue;
				clearQueue = type;
				type = undefined;
			}
			if ( clearQueue && type !== false ) {
				this.queue( type || "fx", [] );
			}
	
			return this.each( function() {
				var dequeue = true,
					index = type != null && type + "queueHooks",
					timers = jQuery.timers,
					data = dataPriv.get( this );
	
				if ( index ) {
					if ( data[ index ] && data[ index ].stop ) {
						stopQueue( data[ index ] );
					}
				} else {
					for ( index in data ) {
						if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
							stopQueue( data[ index ] );
						}
					}
				}
	
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this &&
						( type == null || timers[ index ].queue === type ) ) {
	
						timers[ index ].anim.stop( gotoEnd );
						dequeue = false;
						timers.splice( index, 1 );
					}
				}
	
				// Start the next in the queue if the last step wasn't forced.
				// Timers currently will call their complete callbacks, which
				// will dequeue but only if they were gotoEnd.
				if ( dequeue || !gotoEnd ) {
					jQuery.dequeue( this, type );
				}
			} );
		},
		finish: function( type ) {
			if ( type !== false ) {
				type = type || "fx";
			}
			return this.each( function() {
				var index,
					data = dataPriv.get( this ),
					queue = data[ type + "queue" ],
					hooks = data[ type + "queueHooks" ],
					timers = jQuery.timers,
					length = queue ? queue.length : 0;
	
				// Enable finishing flag on private data
				data.finish = true;
	
				// Empty the queue first
				jQuery.queue( this, type, [] );
	
				if ( hooks && hooks.stop ) {
					hooks.stop.call( this, true );
				}
	
				// Look for any active animations, and finish them
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
						timers[ index ].anim.stop( true );
						timers.splice( index, 1 );
					}
				}
	
				// Look for any animations in the old queue and finish them
				for ( index = 0; index < length; index++ ) {
					if ( queue[ index ] && queue[ index ].finish ) {
						queue[ index ].finish.call( this );
					}
				}
	
				// Turn off finishing flag
				delete data.finish;
			} );
		}
	} );
	
	jQuery.each( [ "toggle", "show", "hide" ], function( i, name ) {
		var cssFn = jQuery.fn[ name ];
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return speed == null || typeof speed === "boolean" ?
				cssFn.apply( this, arguments ) :
				this.animate( genFx( name, true ), speed, easing, callback );
		};
	} );
	
	// Generate shortcuts for custom animations
	jQuery.each( {
		slideDown: genFx( "show" ),
		slideUp: genFx( "hide" ),
		slideToggle: genFx( "toggle" ),
		fadeIn: { opacity: "show" },
		fadeOut: { opacity: "hide" },
		fadeToggle: { opacity: "toggle" }
	}, function( name, props ) {
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return this.animate( props, speed, easing, callback );
		};
	} );
	
	jQuery.timers = [];
	jQuery.fx.tick = function() {
		var timer,
			i = 0,
			timers = jQuery.timers;
	
		fxNow = jQuery.now();
	
		for ( ; i < timers.length; i++ ) {
			timer = timers[ i ];
	
			// Run the timer and safely remove it when done (allowing for external removal)
			if ( !timer() && timers[ i ] === timer ) {
				timers.splice( i--, 1 );
			}
		}
	
		if ( !timers.length ) {
			jQuery.fx.stop();
		}
		fxNow = undefined;
	};
	
	jQuery.fx.timer = function( timer ) {
		jQuery.timers.push( timer );
		jQuery.fx.start();
	};
	
	jQuery.fx.interval = 13;
	jQuery.fx.start = function() {
		if ( inProgress ) {
			return;
		}
	
		inProgress = true;
		schedule();
	};
	
	jQuery.fx.stop = function() {
		inProgress = null;
	};
	
	jQuery.fx.speeds = {
		slow: 600,
		fast: 200,
	
		// Default speed
		_default: 400
	};
	
	
	// Based off of the plugin by Clint Helfers, with permission.
	// https://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
	jQuery.fn.delay = function( time, type ) {
		time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
		type = type || "fx";
	
		return this.queue( type, function( next, hooks ) {
			var timeout = window.setTimeout( next, time );
			hooks.stop = function() {
				window.clearTimeout( timeout );
			};
		} );
	};
	
	
	( function() {
		var input = document.createElement( "input" ),
			select = document.createElement( "select" ),
			opt = select.appendChild( document.createElement( "option" ) );
	
		input.type = "checkbox";
	
		// Support: Android <=4.3 only
		// Default value for a checkbox should be "on"
		support.checkOn = input.value !== "";
	
		// Support: IE <=11 only
		// Must access selectedIndex to make default options select
		support.optSelected = opt.selected;
	
		// Support: IE <=11 only
		// An input loses its value after becoming a radio
		input = document.createElement( "input" );
		input.value = "t";
		input.type = "radio";
		support.radioValue = input.value === "t";
	} )();
	
	
	var boolHook,
		attrHandle = jQuery.expr.attrHandle;
	
	jQuery.fn.extend( {
		attr: function( name, value ) {
			return access( this, jQuery.attr, name, value, arguments.length > 1 );
		},
	
		removeAttr: function( name ) {
			return this.each( function() {
				jQuery.removeAttr( this, name );
			} );
		}
	} );
	
	jQuery.extend( {
		attr: function( elem, name, value ) {
			var ret, hooks,
				nType = elem.nodeType;
	
			// Don't get/set attributes on text, comment and attribute nodes
			if ( nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			// Fallback to prop when attributes are not supported
			if ( typeof elem.getAttribute === "undefined" ) {
				return jQuery.prop( elem, name, value );
			}
	
			// Attribute hooks are determined by the lowercase version
			// Grab necessary hook if one is defined
			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
				hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
					( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
			}
	
			if ( value !== undefined ) {
				if ( value === null ) {
					jQuery.removeAttr( elem, name );
					return;
				}
	
				if ( hooks && "set" in hooks &&
					( ret = hooks.set( elem, value, name ) ) !== undefined ) {
					return ret;
				}
	
				elem.setAttribute( name, value + "" );
				return value;
			}
	
			if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
				return ret;
			}
	
			ret = jQuery.find.attr( elem, name );
	
			// Non-existent attributes return null, we normalize to undefined
			return ret == null ? undefined : ret;
		},
	
		attrHooks: {
			type: {
				set: function( elem, value ) {
					if ( !support.radioValue && value === "radio" &&
						nodeName( elem, "input" ) ) {
						var val = elem.value;
						elem.setAttribute( "type", value );
						if ( val ) {
							elem.value = val;
						}
						return value;
					}
				}
			}
		},
	
		removeAttr: function( elem, value ) {
			var name,
				i = 0,
	
				// Attribute names can contain non-HTML whitespace characters
				// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
				attrNames = value && value.match( rnothtmlwhite );
	
			if ( attrNames && elem.nodeType === 1 ) {
				while ( ( name = attrNames[ i++ ] ) ) {
					elem.removeAttribute( name );
				}
			}
		}
	} );
	
	// Hooks for boolean attributes
	boolHook = {
		set: function( elem, value, name ) {
			if ( value === false ) {
	
				// Remove boolean attributes when set to false
				jQuery.removeAttr( elem, name );
			} else {
				elem.setAttribute( name, name );
			}
			return name;
		}
	};
	
	jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( i, name ) {
		var getter = attrHandle[ name ] || jQuery.find.attr;
	
		attrHandle[ name ] = function( elem, name, isXML ) {
			var ret, handle,
				lowercaseName = name.toLowerCase();
	
			if ( !isXML ) {
	
				// Avoid an infinite loop by temporarily removing this function from the getter
				handle = attrHandle[ lowercaseName ];
				attrHandle[ lowercaseName ] = ret;
				ret = getter( elem, name, isXML ) != null ?
					lowercaseName :
					null;
				attrHandle[ lowercaseName ] = handle;
			}
			return ret;
		};
	} );
	
	
	
	
	var rfocusable = /^(?:input|select|textarea|button)$/i,
		rclickable = /^(?:a|area)$/i;
	
	jQuery.fn.extend( {
		prop: function( name, value ) {
			return access( this, jQuery.prop, name, value, arguments.length > 1 );
		},
	
		removeProp: function( name ) {
			return this.each( function() {
				delete this[ jQuery.propFix[ name ] || name ];
			} );
		}
	} );
	
	jQuery.extend( {
		prop: function( elem, name, value ) {
			var ret, hooks,
				nType = elem.nodeType;
	
			// Don't get/set properties on text, comment and attribute nodes
			if ( nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
	
				// Fix name and attach hooks
				name = jQuery.propFix[ name ] || name;
				hooks = jQuery.propHooks[ name ];
			}
	
			if ( value !== undefined ) {
				if ( hooks && "set" in hooks &&
					( ret = hooks.set( elem, value, name ) ) !== undefined ) {
					return ret;
				}
	
				return ( elem[ name ] = value );
			}
	
			if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
				return ret;
			}
	
			return elem[ name ];
		},
	
		propHooks: {
			tabIndex: {
				get: function( elem ) {
	
					// Support: IE <=9 - 11 only
					// elem.tabIndex doesn't always return the
					// correct value when it hasn't been explicitly set
					// https://web.archive.org/web/20141116233347/http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
					// Use proper attribute retrieval(#12072)
					var tabindex = jQuery.find.attr( elem, "tabindex" );
	
					if ( tabindex ) {
						return parseInt( tabindex, 10 );
					}
	
					if (
						rfocusable.test( elem.nodeName ) ||
						rclickable.test( elem.nodeName ) &&
						elem.href
					) {
						return 0;
					}
	
					return -1;
				}
			}
		},
	
		propFix: {
			"for": "htmlFor",
			"class": "className"
		}
	} );
	
	// Support: IE <=11 only
	// Accessing the selectedIndex property
	// forces the browser to respect setting selected
	// on the option
	// The getter ensures a default option is selected
	// when in an optgroup
	// eslint rule "no-unused-expressions" is disabled for this code
	// since it considers such accessions noop
	if ( !support.optSelected ) {
		jQuery.propHooks.selected = {
			get: function( elem ) {
	
				/* eslint no-unused-expressions: "off" */
	
				var parent = elem.parentNode;
				if ( parent && parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
				return null;
			},
			set: function( elem ) {
	
				/* eslint no-unused-expressions: "off" */
	
				var parent = elem.parentNode;
				if ( parent ) {
					parent.selectedIndex;
	
					if ( parent.parentNode ) {
						parent.parentNode.selectedIndex;
					}
				}
			}
		};
	}
	
	jQuery.each( [
		"tabIndex",
		"readOnly",
		"maxLength",
		"cellSpacing",
		"cellPadding",
		"rowSpan",
		"colSpan",
		"useMap",
		"frameBorder",
		"contentEditable"
	], function() {
		jQuery.propFix[ this.toLowerCase() ] = this;
	} );
	
	
	
	
		// Strip and collapse whitespace according to HTML spec
		// https://html.spec.whatwg.org/multipage/infrastructure.html#strip-and-collapse-whitespace
		function stripAndCollapse( value ) {
			var tokens = value.match( rnothtmlwhite ) || [];
			return tokens.join( " " );
		}
	
	
	function getClass( elem ) {
		return elem.getAttribute && elem.getAttribute( "class" ) || "";
	}
	
	jQuery.fn.extend( {
		addClass: function( value ) {
			var classes, elem, cur, curValue, clazz, j, finalValue,
				i = 0;
	
			if ( jQuery.isFunction( value ) ) {
				return this.each( function( j ) {
					jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
				} );
			}
	
			if ( typeof value === "string" && value ) {
				classes = value.match( rnothtmlwhite ) || [];
	
				while ( ( elem = this[ i++ ] ) ) {
					curValue = getClass( elem );
					cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );
	
					if ( cur ) {
						j = 0;
						while ( ( clazz = classes[ j++ ] ) ) {
							if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
								cur += clazz + " ";
							}
						}
	
						// Only assign if different to avoid unneeded rendering.
						finalValue = stripAndCollapse( cur );
						if ( curValue !== finalValue ) {
							elem.setAttribute( "class", finalValue );
						}
					}
				}
			}
	
			return this;
		},
	
		removeClass: function( value ) {
			var classes, elem, cur, curValue, clazz, j, finalValue,
				i = 0;
	
			if ( jQuery.isFunction( value ) ) {
				return this.each( function( j ) {
					jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
				} );
			}
	
			if ( !arguments.length ) {
				return this.attr( "class", "" );
			}
	
			if ( typeof value === "string" && value ) {
				classes = value.match( rnothtmlwhite ) || [];
	
				while ( ( elem = this[ i++ ] ) ) {
					curValue = getClass( elem );
	
					// This expression is here for better compressibility (see addClass)
					cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );
	
					if ( cur ) {
						j = 0;
						while ( ( clazz = classes[ j++ ] ) ) {
	
							// Remove *all* instances
							while ( cur.indexOf( " " + clazz + " " ) > -1 ) {
								cur = cur.replace( " " + clazz + " ", " " );
							}
						}
	
						// Only assign if different to avoid unneeded rendering.
						finalValue = stripAndCollapse( cur );
						if ( curValue !== finalValue ) {
							elem.setAttribute( "class", finalValue );
						}
					}
				}
			}
	
			return this;
		},
	
		toggleClass: function( value, stateVal ) {
			var type = typeof value;
	
			if ( typeof stateVal === "boolean" && type === "string" ) {
				return stateVal ? this.addClass( value ) : this.removeClass( value );
			}
	
			if ( jQuery.isFunction( value ) ) {
				return this.each( function( i ) {
					jQuery( this ).toggleClass(
						value.call( this, i, getClass( this ), stateVal ),
						stateVal
					);
				} );
			}
	
			return this.each( function() {
				var className, i, self, classNames;
	
				if ( type === "string" ) {
	
					// Toggle individual class names
					i = 0;
					self = jQuery( this );
					classNames = value.match( rnothtmlwhite ) || [];
	
					while ( ( className = classNames[ i++ ] ) ) {
	
						// Check each className given, space separated list
						if ( self.hasClass( className ) ) {
							self.removeClass( className );
						} else {
							self.addClass( className );
						}
					}
	
				// Toggle whole class name
				} else if ( value === undefined || type === "boolean" ) {
					className = getClass( this );
					if ( className ) {
	
						// Store className if set
						dataPriv.set( this, "__className__", className );
					}
	
					// If the element has a class name or if we're passed `false`,
					// then remove the whole classname (if there was one, the above saved it).
					// Otherwise bring back whatever was previously saved (if anything),
					// falling back to the empty string if nothing was stored.
					if ( this.setAttribute ) {
						this.setAttribute( "class",
							className || value === false ?
							"" :
							dataPriv.get( this, "__className__" ) || ""
						);
					}
				}
			} );
		},
	
		hasClass: function( selector ) {
			var className, elem,
				i = 0;
	
			className = " " + selector + " ";
			while ( ( elem = this[ i++ ] ) ) {
				if ( elem.nodeType === 1 &&
					( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
						return true;
				}
			}
	
			return false;
		}
	} );
	
	
	
	
	var rreturn = /\r/g;
	
	jQuery.fn.extend( {
		val: function( value ) {
			var hooks, ret, isFunction,
				elem = this[ 0 ];
	
			if ( !arguments.length ) {
				if ( elem ) {
					hooks = jQuery.valHooks[ elem.type ] ||
						jQuery.valHooks[ elem.nodeName.toLowerCase() ];
	
					if ( hooks &&
						"get" in hooks &&
						( ret = hooks.get( elem, "value" ) ) !== undefined
					) {
						return ret;
					}
	
					ret = elem.value;
	
					// Handle most common string cases
					if ( typeof ret === "string" ) {
						return ret.replace( rreturn, "" );
					}
	
					// Handle cases where value is null/undef or number
					return ret == null ? "" : ret;
				}
	
				return;
			}
	
			isFunction = jQuery.isFunction( value );
	
			return this.each( function( i ) {
				var val;
	
				if ( this.nodeType !== 1 ) {
					return;
				}
	
				if ( isFunction ) {
					val = value.call( this, i, jQuery( this ).val() );
				} else {
					val = value;
				}
	
				// Treat null/undefined as ""; convert numbers to string
				if ( val == null ) {
					val = "";
	
				} else if ( typeof val === "number" ) {
					val += "";
	
				} else if ( Array.isArray( val ) ) {
					val = jQuery.map( val, function( value ) {
						return value == null ? "" : value + "";
					} );
				}
	
				hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];
	
				// If set returns undefined, fall back to normal setting
				if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
					this.value = val;
				}
			} );
		}
	} );
	
	jQuery.extend( {
		valHooks: {
			option: {
				get: function( elem ) {
	
					var val = jQuery.find.attr( elem, "value" );
					return val != null ?
						val :
	
						// Support: IE <=10 - 11 only
						// option.text throws exceptions (#14686, #14858)
						// Strip and collapse whitespace
						// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
						stripAndCollapse( jQuery.text( elem ) );
				}
			},
			select: {
				get: function( elem ) {
					var value, option, i,
						options = elem.options,
						index = elem.selectedIndex,
						one = elem.type === "select-one",
						values = one ? null : [],
						max = one ? index + 1 : options.length;
	
					if ( index < 0 ) {
						i = max;
	
					} else {
						i = one ? index : 0;
					}
	
					// Loop through all the selected options
					for ( ; i < max; i++ ) {
						option = options[ i ];
	
						// Support: IE <=9 only
						// IE8-9 doesn't update selected after form reset (#2551)
						if ( ( option.selected || i === index ) &&
	
								// Don't return options that are disabled or in a disabled optgroup
								!option.disabled &&
								( !option.parentNode.disabled ||
									!nodeName( option.parentNode, "optgroup" ) ) ) {
	
							// Get the specific value for the option
							value = jQuery( option ).val();
	
							// We don't need an array for one selects
							if ( one ) {
								return value;
							}
	
							// Multi-Selects return an array
							values.push( value );
						}
					}
	
					return values;
				},
	
				set: function( elem, value ) {
					var optionSet, option,
						options = elem.options,
						values = jQuery.makeArray( value ),
						i = options.length;
	
					while ( i-- ) {
						option = options[ i ];
	
						/* eslint-disable no-cond-assign */
	
						if ( option.selected =
							jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
						) {
							optionSet = true;
						}
	
						/* eslint-enable no-cond-assign */
					}
	
					// Force browsers to behave consistently when non-matching value is set
					if ( !optionSet ) {
						elem.selectedIndex = -1;
					}
					return values;
				}
			}
		}
	} );
	
	// Radios and checkboxes getter/setter
	jQuery.each( [ "radio", "checkbox" ], function() {
		jQuery.valHooks[ this ] = {
			set: function( elem, value ) {
				if ( Array.isArray( value ) ) {
					return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
				}
			}
		};
		if ( !support.checkOn ) {
			jQuery.valHooks[ this ].get = function( elem ) {
				return elem.getAttribute( "value" ) === null ? "on" : elem.value;
			};
		}
	} );
	
	
	
	
	// Return jQuery for attributes-only inclusion
	
	
	var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/;
	
	jQuery.extend( jQuery.event, {
	
		trigger: function( event, data, elem, onlyHandlers ) {
	
			var i, cur, tmp, bubbleType, ontype, handle, special,
				eventPath = [ elem || document ],
				type = hasOwn.call( event, "type" ) ? event.type : event,
				namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];
	
			cur = tmp = elem = elem || document;
	
			// Don't do events on text and comment nodes
			if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
				return;
			}
	
			// focus/blur morphs to focusin/out; ensure we're not firing them right now
			if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
				return;
			}
	
			if ( type.indexOf( "." ) > -1 ) {
	
				// Namespaced trigger; create a regexp to match event type in handle()
				namespaces = type.split( "." );
				type = namespaces.shift();
				namespaces.sort();
			}
			ontype = type.indexOf( ":" ) < 0 && "on" + type;
	
			// Caller can pass in a jQuery.Event object, Object, or just an event type string
			event = event[ jQuery.expando ] ?
				event :
				new jQuery.Event( type, typeof event === "object" && event );
	
			// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
			event.isTrigger = onlyHandlers ? 2 : 3;
			event.namespace = namespaces.join( "." );
			event.rnamespace = event.namespace ?
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
				null;
	
			// Clean up the event in case it is being reused
			event.result = undefined;
			if ( !event.target ) {
				event.target = elem;
			}
	
			// Clone any incoming data and prepend the event, creating the handler arg list
			data = data == null ?
				[ event ] :
				jQuery.makeArray( data, [ event ] );
	
			// Allow special events to draw outside the lines
			special = jQuery.event.special[ type ] || {};
			if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
				return;
			}
	
			// Determine event propagation path in advance, per W3C events spec (#9951)
			// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
			if ( !onlyHandlers && !special.noBubble && !jQuery.isWindow( elem ) ) {
	
				bubbleType = special.delegateType || type;
				if ( !rfocusMorph.test( bubbleType + type ) ) {
					cur = cur.parentNode;
				}
				for ( ; cur; cur = cur.parentNode ) {
					eventPath.push( cur );
					tmp = cur;
				}
	
				// Only add window if we got to document (e.g., not plain obj or detached DOM)
				if ( tmp === ( elem.ownerDocument || document ) ) {
					eventPath.push( tmp.defaultView || tmp.parentWindow || window );
				}
			}
	
			// Fire handlers on the event path
			i = 0;
			while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
	
				event.type = i > 1 ?
					bubbleType :
					special.bindType || type;
	
				// jQuery handler
				handle = ( dataPriv.get( cur, "events" ) || {} )[ event.type ] &&
					dataPriv.get( cur, "handle" );
				if ( handle ) {
					handle.apply( cur, data );
				}
	
				// Native handler
				handle = ontype && cur[ ontype ];
				if ( handle && handle.apply && acceptData( cur ) ) {
					event.result = handle.apply( cur, data );
					if ( event.result === false ) {
						event.preventDefault();
					}
				}
			}
			event.type = type;
	
			// If nobody prevented the default action, do it now
			if ( !onlyHandlers && !event.isDefaultPrevented() ) {
	
				if ( ( !special._default ||
					special._default.apply( eventPath.pop(), data ) === false ) &&
					acceptData( elem ) ) {
	
					// Call a native DOM method on the target with the same name as the event.
					// Don't do default actions on window, that's where global variables be (#6170)
					if ( ontype && jQuery.isFunction( elem[ type ] ) && !jQuery.isWindow( elem ) ) {
	
						// Don't re-trigger an onFOO event when we call its FOO() method
						tmp = elem[ ontype ];
	
						if ( tmp ) {
							elem[ ontype ] = null;
						}
	
						// Prevent re-triggering of the same event, since we already bubbled it above
						jQuery.event.triggered = type;
						elem[ type ]();
						jQuery.event.triggered = undefined;
	
						if ( tmp ) {
							elem[ ontype ] = tmp;
						}
					}
				}
			}
	
			return event.result;
		},
	
		// Piggyback on a donor event to simulate a different one
		// Used only for `focus(in | out)` events
		simulate: function( type, elem, event ) {
			var e = jQuery.extend(
				new jQuery.Event(),
				event,
				{
					type: type,
					isSimulated: true
				}
			);
	
			jQuery.event.trigger( e, null, elem );
		}
	
	} );
	
	jQuery.fn.extend( {
	
		trigger: function( type, data ) {
			return this.each( function() {
				jQuery.event.trigger( type, data, this );
			} );
		},
		triggerHandler: function( type, data ) {
			var elem = this[ 0 ];
			if ( elem ) {
				return jQuery.event.trigger( type, data, elem, true );
			}
		}
	} );
	
	
	jQuery.each( ( "blur focus focusin focusout resize scroll click dblclick " +
		"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
		"change select submit keydown keypress keyup contextmenu" ).split( " " ),
		function( i, name ) {
	
		// Handle event binding
		jQuery.fn[ name ] = function( data, fn ) {
			return arguments.length > 0 ?
				this.on( name, null, data, fn ) :
				this.trigger( name );
		};
	} );
	
	jQuery.fn.extend( {
		hover: function( fnOver, fnOut ) {
			return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
		}
	} );
	
	
	
	
	support.focusin = "onfocusin" in window;
	
	
	// Support: Firefox <=44
	// Firefox doesn't have focus(in | out) events
	// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
	//
	// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
	// focus(in | out) events fire after focus & blur events,
	// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
	// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
	if ( !support.focusin ) {
		jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {
	
			// Attach a single capturing handler on the document while someone wants focusin/focusout
			var handler = function( event ) {
				jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
			};
	
			jQuery.event.special[ fix ] = {
				setup: function() {
					var doc = this.ownerDocument || this,
						attaches = dataPriv.access( doc, fix );
	
					if ( !attaches ) {
						doc.addEventListener( orig, handler, true );
					}
					dataPriv.access( doc, fix, ( attaches || 0 ) + 1 );
				},
				teardown: function() {
					var doc = this.ownerDocument || this,
						attaches = dataPriv.access( doc, fix ) - 1;
	
					if ( !attaches ) {
						doc.removeEventListener( orig, handler, true );
						dataPriv.remove( doc, fix );
	
					} else {
						dataPriv.access( doc, fix, attaches );
					}
				}
			};
		} );
	}
	var location = window.location;
	
	var nonce = jQuery.now();
	
	var rquery = ( /\?/ );
	
	
	
	// Cross-browser xml parsing
	jQuery.parseXML = function( data ) {
		var xml;
		if ( !data || typeof data !== "string" ) {
			return null;
		}
	
		// Support: IE 9 - 11 only
		// IE throws on parseFromString with invalid input.
		try {
			xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
		} catch ( e ) {
			xml = undefined;
		}
	
		if ( !xml || xml.getElementsByTagName( "parsererror" ).length ) {
			jQuery.error( "Invalid XML: " + data );
		}
		return xml;
	};
	
	
	var
		rbracket = /\[\]$/,
		rCRLF = /\r?\n/g,
		rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
		rsubmittable = /^(?:input|select|textarea|keygen)/i;
	
	function buildParams( prefix, obj, traditional, add ) {
		var name;
	
		if ( Array.isArray( obj ) ) {
	
			// Serialize array item.
			jQuery.each( obj, function( i, v ) {
				if ( traditional || rbracket.test( prefix ) ) {
	
					// Treat each array item as a scalar.
					add( prefix, v );
	
				} else {
	
					// Item is non-scalar (array or object), encode its numeric index.
					buildParams(
						prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
						v,
						traditional,
						add
					);
				}
			} );
	
		} else if ( !traditional && jQuery.type( obj ) === "object" ) {
	
			// Serialize object item.
			for ( name in obj ) {
				buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
			}
	
		} else {
	
			// Serialize scalar item.
			add( prefix, obj );
		}
	}
	
	// Serialize an array of form elements or a set of
	// key/values into a query string
	jQuery.param = function( a, traditional ) {
		var prefix,
			s = [],
			add = function( key, valueOrFunction ) {
	
				// If value is a function, invoke it and use its return value
				var value = jQuery.isFunction( valueOrFunction ) ?
					valueOrFunction() :
					valueOrFunction;
	
				s[ s.length ] = encodeURIComponent( key ) + "=" +
					encodeURIComponent( value == null ? "" : value );
			};
	
		// If an array was passed in, assume that it is an array of form elements.
		if ( Array.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {
	
			// Serialize the form elements
			jQuery.each( a, function() {
				add( this.name, this.value );
			} );
	
		} else {
	
			// If traditional, encode the "old" way (the way 1.3.2 or older
			// did it), otherwise encode params recursively.
			for ( prefix in a ) {
				buildParams( prefix, a[ prefix ], traditional, add );
			}
		}
	
		// Return the resulting serialization
		return s.join( "&" );
	};
	
	jQuery.fn.extend( {
		serialize: function() {
			return jQuery.param( this.serializeArray() );
		},
		serializeArray: function() {
			return this.map( function() {
	
				// Can add propHook for "elements" to filter or add form elements
				var elements = jQuery.prop( this, "elements" );
				return elements ? jQuery.makeArray( elements ) : this;
			} )
			.filter( function() {
				var type = this.type;
	
				// Use .is( ":disabled" ) so that fieldset[disabled] works
				return this.name && !jQuery( this ).is( ":disabled" ) &&
					rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
					( this.checked || !rcheckableType.test( type ) );
			} )
			.map( function( i, elem ) {
				var val = jQuery( this ).val();
	
				if ( val == null ) {
					return null;
				}
	
				if ( Array.isArray( val ) ) {
					return jQuery.map( val, function( val ) {
						return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
					} );
				}
	
				return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
			} ).get();
		}
	} );
	
	
	var
		r20 = /%20/g,
		rhash = /#.*$/,
		rantiCache = /([?&])_=[^&]*/,
		rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,
	
		// #7653, #8125, #8152: local protocol detection
		rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
		rnoContent = /^(?:GET|HEAD)$/,
		rprotocol = /^\/\//,
	
		/* Prefilters
		 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
		 * 2) These are called:
		 *    - BEFORE asking for a transport
		 *    - AFTER param serialization (s.data is a string if s.processData is true)
		 * 3) key is the dataType
		 * 4) the catchall symbol "*" can be used
		 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
		 */
		prefilters = {},
	
		/* Transports bindings
		 * 1) key is the dataType
		 * 2) the catchall symbol "*" can be used
		 * 3) selection will start with transport dataType and THEN go to "*" if needed
		 */
		transports = {},
	
		// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
		allTypes = "*/".concat( "*" ),
	
		// Anchor tag for parsing the document origin
		originAnchor = document.createElement( "a" );
		originAnchor.href = location.href;
	
	// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
	function addToPrefiltersOrTransports( structure ) {
	
		// dataTypeExpression is optional and defaults to "*"
		return function( dataTypeExpression, func ) {
	
			if ( typeof dataTypeExpression !== "string" ) {
				func = dataTypeExpression;
				dataTypeExpression = "*";
			}
	
			var dataType,
				i = 0,
				dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];
	
			if ( jQuery.isFunction( func ) ) {
	
				// For each dataType in the dataTypeExpression
				while ( ( dataType = dataTypes[ i++ ] ) ) {
	
					// Prepend if requested
					if ( dataType[ 0 ] === "+" ) {
						dataType = dataType.slice( 1 ) || "*";
						( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );
	
					// Otherwise append
					} else {
						( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
					}
				}
			}
		};
	}
	
	// Base inspection function for prefilters and transports
	function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {
	
		var inspected = {},
			seekingTransport = ( structure === transports );
	
		function inspect( dataType ) {
			var selected;
			inspected[ dataType ] = true;
			jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
				var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
				if ( typeof dataTypeOrTransport === "string" &&
					!seekingTransport && !inspected[ dataTypeOrTransport ] ) {
	
					options.dataTypes.unshift( dataTypeOrTransport );
					inspect( dataTypeOrTransport );
					return false;
				} else if ( seekingTransport ) {
					return !( selected = dataTypeOrTransport );
				}
			} );
			return selected;
		}
	
		return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
	}
	
	// A special extend for ajax options
	// that takes "flat" options (not to be deep extended)
	// Fixes #9887
	function ajaxExtend( target, src ) {
		var key, deep,
			flatOptions = jQuery.ajaxSettings.flatOptions || {};
	
		for ( key in src ) {
			if ( src[ key ] !== undefined ) {
				( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
			}
		}
		if ( deep ) {
			jQuery.extend( true, target, deep );
		}
	
		return target;
	}
	
	/* Handles responses to an ajax request:
	 * - finds the right dataType (mediates between content-type and expected dataType)
	 * - returns the corresponding response
	 */
	function ajaxHandleResponses( s, jqXHR, responses ) {
	
		var ct, type, finalDataType, firstDataType,
			contents = s.contents,
			dataTypes = s.dataTypes;
	
		// Remove auto dataType and get content-type in the process
		while ( dataTypes[ 0 ] === "*" ) {
			dataTypes.shift();
			if ( ct === undefined ) {
				ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
			}
		}
	
		// Check if we're dealing with a known content-type
		if ( ct ) {
			for ( type in contents ) {
				if ( contents[ type ] && contents[ type ].test( ct ) ) {
					dataTypes.unshift( type );
					break;
				}
			}
		}
	
		// Check to see if we have a response for the expected dataType
		if ( dataTypes[ 0 ] in responses ) {
			finalDataType = dataTypes[ 0 ];
		} else {
	
			// Try convertible dataTypes
			for ( type in responses ) {
				if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
					finalDataType = type;
					break;
				}
				if ( !firstDataType ) {
					firstDataType = type;
				}
			}
	
			// Or just use first one
			finalDataType = finalDataType || firstDataType;
		}
	
		// If we found a dataType
		// We add the dataType to the list if needed
		// and return the corresponding response
		if ( finalDataType ) {
			if ( finalDataType !== dataTypes[ 0 ] ) {
				dataTypes.unshift( finalDataType );
			}
			return responses[ finalDataType ];
		}
	}
	
	/* Chain conversions given the request and the original response
	 * Also sets the responseXXX fields on the jqXHR instance
	 */
	function ajaxConvert( s, response, jqXHR, isSuccess ) {
		var conv2, current, conv, tmp, prev,
			converters = {},
	
			// Work with a copy of dataTypes in case we need to modify it for conversion
			dataTypes = s.dataTypes.slice();
	
		// Create converters map with lowercased keys
		if ( dataTypes[ 1 ] ) {
			for ( conv in s.converters ) {
				converters[ conv.toLowerCase() ] = s.converters[ conv ];
			}
		}
	
		current = dataTypes.shift();
	
		// Convert to each sequential dataType
		while ( current ) {
	
			if ( s.responseFields[ current ] ) {
				jqXHR[ s.responseFields[ current ] ] = response;
			}
	
			// Apply the dataFilter if provided
			if ( !prev && isSuccess && s.dataFilter ) {
				response = s.dataFilter( response, s.dataType );
			}
	
			prev = current;
			current = dataTypes.shift();
	
			if ( current ) {
	
				// There's only work to do if current dataType is non-auto
				if ( current === "*" ) {
	
					current = prev;
	
				// Convert response if prev dataType is non-auto and differs from current
				} else if ( prev !== "*" && prev !== current ) {
	
					// Seek a direct converter
					conv = converters[ prev + " " + current ] || converters[ "* " + current ];
	
					// If none found, seek a pair
					if ( !conv ) {
						for ( conv2 in converters ) {
	
							// If conv2 outputs current
							tmp = conv2.split( " " );
							if ( tmp[ 1 ] === current ) {
	
								// If prev can be converted to accepted input
								conv = converters[ prev + " " + tmp[ 0 ] ] ||
									converters[ "* " + tmp[ 0 ] ];
								if ( conv ) {
	
									// Condense equivalence converters
									if ( conv === true ) {
										conv = converters[ conv2 ];
	
									// Otherwise, insert the intermediate dataType
									} else if ( converters[ conv2 ] !== true ) {
										current = tmp[ 0 ];
										dataTypes.unshift( tmp[ 1 ] );
									}
									break;
								}
							}
						}
					}
	
					// Apply converter (if not an equivalence)
					if ( conv !== true ) {
	
						// Unless errors are allowed to bubble, catch and return them
						if ( conv && s.throws ) {
							response = conv( response );
						} else {
							try {
								response = conv( response );
							} catch ( e ) {
								return {
									state: "parsererror",
									error: conv ? e : "No conversion from " + prev + " to " + current
								};
							}
						}
					}
				}
			}
		}
	
		return { state: "success", data: response };
	}
	
	jQuery.extend( {
	
		// Counter for holding the number of active queries
		active: 0,
	
		// Last-Modified header cache for next request
		lastModified: {},
		etag: {},
	
		ajaxSettings: {
			url: location.href,
			type: "GET",
			isLocal: rlocalProtocol.test( location.protocol ),
			global: true,
			processData: true,
			async: true,
			contentType: "application/x-www-form-urlencoded; charset=UTF-8",
	
			/*
			timeout: 0,
			data: null,
			dataType: null,
			username: null,
			password: null,
			cache: null,
			throws: false,
			traditional: false,
			headers: {},
			*/
	
			accepts: {
				"*": allTypes,
				text: "text/plain",
				html: "text/html",
				xml: "application/xml, text/xml",
				json: "application/json, text/javascript"
			},
	
			contents: {
				xml: /\bxml\b/,
				html: /\bhtml/,
				json: /\bjson\b/
			},
	
			responseFields: {
				xml: "responseXML",
				text: "responseText",
				json: "responseJSON"
			},
	
			// Data converters
			// Keys separate source (or catchall "*") and destination types with a single space
			converters: {
	
				// Convert anything to text
				"* text": String,
	
				// Text to html (true = no transformation)
				"text html": true,
	
				// Evaluate text as a json expression
				"text json": JSON.parse,
	
				// Parse text as xml
				"text xml": jQuery.parseXML
			},
	
			// For options that shouldn't be deep extended:
			// you can add your own custom options here if
			// and when you create one that shouldn't be
			// deep extended (see ajaxExtend)
			flatOptions: {
				url: true,
				context: true
			}
		},
	
		// Creates a full fledged settings object into target
		// with both ajaxSettings and settings fields.
		// If target is omitted, writes into ajaxSettings.
		ajaxSetup: function( target, settings ) {
			return settings ?
	
				// Building a settings object
				ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :
	
				// Extending ajaxSettings
				ajaxExtend( jQuery.ajaxSettings, target );
		},
	
		ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
		ajaxTransport: addToPrefiltersOrTransports( transports ),
	
		// Main method
		ajax: function( url, options ) {
	
			// If url is an object, simulate pre-1.5 signature
			if ( typeof url === "object" ) {
				options = url;
				url = undefined;
			}
	
			// Force options to be an object
			options = options || {};
	
			var transport,
	
				// URL without anti-cache param
				cacheURL,
	
				// Response headers
				responseHeadersString,
				responseHeaders,
	
				// timeout handle
				timeoutTimer,
	
				// Url cleanup var
				urlAnchor,
	
				// Request state (becomes false upon send and true upon completion)
				completed,
	
				// To know if global events are to be dispatched
				fireGlobals,
	
				// Loop variable
				i,
	
				// uncached part of the url
				uncached,
	
				// Create the final options object
				s = jQuery.ajaxSetup( {}, options ),
	
				// Callbacks context
				callbackContext = s.context || s,
	
				// Context for global events is callbackContext if it is a DOM node or jQuery collection
				globalEventContext = s.context &&
					( callbackContext.nodeType || callbackContext.jquery ) ?
						jQuery( callbackContext ) :
						jQuery.event,
	
				// Deferreds
				deferred = jQuery.Deferred(),
				completeDeferred = jQuery.Callbacks( "once memory" ),
	
				// Status-dependent callbacks
				statusCode = s.statusCode || {},
	
				// Headers (they are sent all at once)
				requestHeaders = {},
				requestHeadersNames = {},
	
				// Default abort message
				strAbort = "canceled",
	
				// Fake xhr
				jqXHR = {
					readyState: 0,
	
					// Builds headers hashtable if needed
					getResponseHeader: function( key ) {
						var match;
						if ( completed ) {
							if ( !responseHeaders ) {
								responseHeaders = {};
								while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
									responseHeaders[ match[ 1 ].toLowerCase() ] = match[ 2 ];
								}
							}
							match = responseHeaders[ key.toLowerCase() ];
						}
						return match == null ? null : match;
					},
	
					// Raw string
					getAllResponseHeaders: function() {
						return completed ? responseHeadersString : null;
					},
	
					// Caches the header
					setRequestHeader: function( name, value ) {
						if ( completed == null ) {
							name = requestHeadersNames[ name.toLowerCase() ] =
								requestHeadersNames[ name.toLowerCase() ] || name;
							requestHeaders[ name ] = value;
						}
						return this;
					},
	
					// Overrides response content-type header
					overrideMimeType: function( type ) {
						if ( completed == null ) {
							s.mimeType = type;
						}
						return this;
					},
	
					// Status-dependent callbacks
					statusCode: function( map ) {
						var code;
						if ( map ) {
							if ( completed ) {
	
								// Execute the appropriate callbacks
								jqXHR.always( map[ jqXHR.status ] );
							} else {
	
								// Lazy-add the new callbacks in a way that preserves old ones
								for ( code in map ) {
									statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
								}
							}
						}
						return this;
					},
	
					// Cancel the request
					abort: function( statusText ) {
						var finalText = statusText || strAbort;
						if ( transport ) {
							transport.abort( finalText );
						}
						done( 0, finalText );
						return this;
					}
				};
	
			// Attach deferreds
			deferred.promise( jqXHR );
	
			// Add protocol if not provided (prefilters might expect it)
			// Handle falsy url in the settings object (#10093: consistency with old signature)
			// We also use the url parameter if available
			s.url = ( ( url || s.url || location.href ) + "" )
				.replace( rprotocol, location.protocol + "//" );
	
			// Alias method option to type as per ticket #12004
			s.type = options.method || options.type || s.method || s.type;
	
			// Extract dataTypes list
			s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];
	
			// A cross-domain request is in order when the origin doesn't match the current origin.
			if ( s.crossDomain == null ) {
				urlAnchor = document.createElement( "a" );
	
				// Support: IE <=8 - 11, Edge 12 - 13
				// IE throws exception on accessing the href property if url is malformed,
				// e.g. http://example.com:80x/
				try {
					urlAnchor.href = s.url;
	
					// Support: IE <=8 - 11 only
					// Anchor's host property isn't correctly set when s.url is relative
					urlAnchor.href = urlAnchor.href;
					s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
						urlAnchor.protocol + "//" + urlAnchor.host;
				} catch ( e ) {
	
					// If there is an error parsing the URL, assume it is crossDomain,
					// it can be rejected by the transport if it is invalid
					s.crossDomain = true;
				}
			}
	
			// Convert data if not already a string
			if ( s.data && s.processData && typeof s.data !== "string" ) {
				s.data = jQuery.param( s.data, s.traditional );
			}
	
			// Apply prefilters
			inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );
	
			// If request was aborted inside a prefilter, stop there
			if ( completed ) {
				return jqXHR;
			}
	
			// We can fire global events as of now if asked to
			// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
			fireGlobals = jQuery.event && s.global;
	
			// Watch for a new set of requests
			if ( fireGlobals && jQuery.active++ === 0 ) {
				jQuery.event.trigger( "ajaxStart" );
			}
	
			// Uppercase the type
			s.type = s.type.toUpperCase();
	
			// Determine if request has content
			s.hasContent = !rnoContent.test( s.type );
	
			// Save the URL in case we're toying with the If-Modified-Since
			// and/or If-None-Match header later on
			// Remove hash to simplify url manipulation
			cacheURL = s.url.replace( rhash, "" );
	
			// More options handling for requests with no content
			if ( !s.hasContent ) {
	
				// Remember the hash so we can put it back
				uncached = s.url.slice( cacheURL.length );
	
				// If data is available, append data to url
				if ( s.data ) {
					cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;
	
					// #9682: remove data so that it's not used in an eventual retry
					delete s.data;
				}
	
				// Add or update anti-cache param if needed
				if ( s.cache === false ) {
					cacheURL = cacheURL.replace( rantiCache, "$1" );
					uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce++ ) + uncached;
				}
	
				// Put hash and anti-cache on the URL that will be requested (gh-1732)
				s.url = cacheURL + uncached;
	
			// Change '%20' to '+' if this is encoded form body content (gh-2658)
			} else if ( s.data && s.processData &&
				( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
				s.data = s.data.replace( r20, "+" );
			}
	
			// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
			if ( s.ifModified ) {
				if ( jQuery.lastModified[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
				}
				if ( jQuery.etag[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
				}
			}
	
			// Set the correct header, if data is being sent
			if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
				jqXHR.setRequestHeader( "Content-Type", s.contentType );
			}
	
			// Set the Accepts header for the server, depending on the dataType
			jqXHR.setRequestHeader(
				"Accept",
				s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
					s.accepts[ s.dataTypes[ 0 ] ] +
						( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
					s.accepts[ "*" ]
			);
	
			// Check for headers option
			for ( i in s.headers ) {
				jqXHR.setRequestHeader( i, s.headers[ i ] );
			}
	
			// Allow custom headers/mimetypes and early abort
			if ( s.beforeSend &&
				( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {
	
				// Abort if not done already and return
				return jqXHR.abort();
			}
	
			// Aborting is no longer a cancellation
			strAbort = "abort";
	
			// Install callbacks on deferreds
			completeDeferred.add( s.complete );
			jqXHR.done( s.success );
			jqXHR.fail( s.error );
	
			// Get transport
			transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );
	
			// If no transport, we auto-abort
			if ( !transport ) {
				done( -1, "No Transport" );
			} else {
				jqXHR.readyState = 1;
	
				// Send global event
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
				}
	
				// If request was aborted inside ajaxSend, stop there
				if ( completed ) {
					return jqXHR;
				}
	
				// Timeout
				if ( s.async && s.timeout > 0 ) {
					timeoutTimer = window.setTimeout( function() {
						jqXHR.abort( "timeout" );
					}, s.timeout );
				}
	
				try {
					completed = false;
					transport.send( requestHeaders, done );
				} catch ( e ) {
	
					// Rethrow post-completion exceptions
					if ( completed ) {
						throw e;
					}
	
					// Propagate others as results
					done( -1, e );
				}
			}
	
			// Callback for when everything is done
			function done( status, nativeStatusText, responses, headers ) {
				var isSuccess, success, error, response, modified,
					statusText = nativeStatusText;
	
				// Ignore repeat invocations
				if ( completed ) {
					return;
				}
	
				completed = true;
	
				// Clear timeout if it exists
				if ( timeoutTimer ) {
					window.clearTimeout( timeoutTimer );
				}
	
				// Dereference transport for early garbage collection
				// (no matter how long the jqXHR object will be used)
				transport = undefined;
	
				// Cache response headers
				responseHeadersString = headers || "";
	
				// Set readyState
				jqXHR.readyState = status > 0 ? 4 : 0;
	
				// Determine if successful
				isSuccess = status >= 200 && status < 300 || status === 304;
	
				// Get response data
				if ( responses ) {
					response = ajaxHandleResponses( s, jqXHR, responses );
				}
	
				// Convert no matter what (that way responseXXX fields are always set)
				response = ajaxConvert( s, response, jqXHR, isSuccess );
	
				// If successful, handle type chaining
				if ( isSuccess ) {
	
					// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
					if ( s.ifModified ) {
						modified = jqXHR.getResponseHeader( "Last-Modified" );
						if ( modified ) {
							jQuery.lastModified[ cacheURL ] = modified;
						}
						modified = jqXHR.getResponseHeader( "etag" );
						if ( modified ) {
							jQuery.etag[ cacheURL ] = modified;
						}
					}
	
					// if no content
					if ( status === 204 || s.type === "HEAD" ) {
						statusText = "nocontent";
	
					// if not modified
					} else if ( status === 304 ) {
						statusText = "notmodified";
	
					// If we have data, let's convert it
					} else {
						statusText = response.state;
						success = response.data;
						error = response.error;
						isSuccess = !error;
					}
				} else {
	
					// Extract error from statusText and normalize for non-aborts
					error = statusText;
					if ( status || !statusText ) {
						statusText = "error";
						if ( status < 0 ) {
							status = 0;
						}
					}
				}
	
				// Set data for the fake xhr object
				jqXHR.status = status;
				jqXHR.statusText = ( nativeStatusText || statusText ) + "";
	
				// Success/Error
				if ( isSuccess ) {
					deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
				} else {
					deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
				}
	
				// Status-dependent callbacks
				jqXHR.statusCode( statusCode );
				statusCode = undefined;
	
				if ( fireGlobals ) {
					globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
						[ jqXHR, s, isSuccess ? success : error ] );
				}
	
				// Complete
				completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );
	
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );
	
					// Handle the global AJAX counter
					if ( !( --jQuery.active ) ) {
						jQuery.event.trigger( "ajaxStop" );
					}
				}
			}
	
			return jqXHR;
		},
	
		getJSON: function( url, data, callback ) {
			return jQuery.get( url, data, callback, "json" );
		},
	
		getScript: function( url, callback ) {
			return jQuery.get( url, undefined, callback, "script" );
		}
	} );
	
	jQuery.each( [ "get", "post" ], function( i, method ) {
		jQuery[ method ] = function( url, data, callback, type ) {
	
			// Shift arguments if data argument was omitted
			if ( jQuery.isFunction( data ) ) {
				type = type || callback;
				callback = data;
				data = undefined;
			}
	
			// The url can be an options object (which then must have .url)
			return jQuery.ajax( jQuery.extend( {
				url: url,
				type: method,
				dataType: type,
				data: data,
				success: callback
			}, jQuery.isPlainObject( url ) && url ) );
		};
	} );
	
	
	jQuery._evalUrl = function( url ) {
		return jQuery.ajax( {
			url: url,
	
			// Make this explicit, since user can override this through ajaxSetup (#11264)
			type: "GET",
			dataType: "script",
			cache: true,
			async: false,
			global: false,
			"throws": true
		} );
	};
	
	
	jQuery.fn.extend( {
		wrapAll: function( html ) {
			var wrap;
	
			if ( this[ 0 ] ) {
				if ( jQuery.isFunction( html ) ) {
					html = html.call( this[ 0 ] );
				}
	
				// The elements to wrap the target around
				wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );
	
				if ( this[ 0 ].parentNode ) {
					wrap.insertBefore( this[ 0 ] );
				}
	
				wrap.map( function() {
					var elem = this;
	
					while ( elem.firstElementChild ) {
						elem = elem.firstElementChild;
					}
	
					return elem;
				} ).append( this );
			}
	
			return this;
		},
	
		wrapInner: function( html ) {
			if ( jQuery.isFunction( html ) ) {
				return this.each( function( i ) {
					jQuery( this ).wrapInner( html.call( this, i ) );
				} );
			}
	
			return this.each( function() {
				var self = jQuery( this ),
					contents = self.contents();
	
				if ( contents.length ) {
					contents.wrapAll( html );
	
				} else {
					self.append( html );
				}
			} );
		},
	
		wrap: function( html ) {
			var isFunction = jQuery.isFunction( html );
	
			return this.each( function( i ) {
				jQuery( this ).wrapAll( isFunction ? html.call( this, i ) : html );
			} );
		},
	
		unwrap: function( selector ) {
			this.parent( selector ).not( "body" ).each( function() {
				jQuery( this ).replaceWith( this.childNodes );
			} );
			return this;
		}
	} );
	
	
	jQuery.expr.pseudos.hidden = function( elem ) {
		return !jQuery.expr.pseudos.visible( elem );
	};
	jQuery.expr.pseudos.visible = function( elem ) {
		return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
	};
	
	
	
	
	jQuery.ajaxSettings.xhr = function() {
		try {
			return new window.XMLHttpRequest();
		} catch ( e ) {}
	};
	
	var xhrSuccessStatus = {
	
			// File protocol always yields status code 0, assume 200
			0: 200,
	
			// Support: IE <=9 only
			// #1450: sometimes IE returns 1223 when it should be 204
			1223: 204
		},
		xhrSupported = jQuery.ajaxSettings.xhr();
	
	support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
	support.ajax = xhrSupported = !!xhrSupported;
	
	jQuery.ajaxTransport( function( options ) {
		var callback, errorCallback;
	
		// Cross domain only allowed if supported through XMLHttpRequest
		if ( support.cors || xhrSupported && !options.crossDomain ) {
			return {
				send: function( headers, complete ) {
					var i,
						xhr = options.xhr();
	
					xhr.open(
						options.type,
						options.url,
						options.async,
						options.username,
						options.password
					);
	
					// Apply custom fields if provided
					if ( options.xhrFields ) {
						for ( i in options.xhrFields ) {
							xhr[ i ] = options.xhrFields[ i ];
						}
					}
	
					// Override mime type if needed
					if ( options.mimeType && xhr.overrideMimeType ) {
						xhr.overrideMimeType( options.mimeType );
					}
	
					// X-Requested-With header
					// For cross-domain requests, seeing as conditions for a preflight are
					// akin to a jigsaw puzzle, we simply never set it to be sure.
					// (it can always be set on a per-request basis or even using ajaxSetup)
					// For same-domain requests, won't change header if already provided.
					if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
						headers[ "X-Requested-With" ] = "XMLHttpRequest";
					}
	
					// Set headers
					for ( i in headers ) {
						xhr.setRequestHeader( i, headers[ i ] );
					}
	
					// Callback
					callback = function( type ) {
						return function() {
							if ( callback ) {
								callback = errorCallback = xhr.onload =
									xhr.onerror = xhr.onabort = xhr.onreadystatechange = null;
	
								if ( type === "abort" ) {
									xhr.abort();
								} else if ( type === "error" ) {
	
									// Support: IE <=9 only
									// On a manual native abort, IE9 throws
									// errors on any property access that is not readyState
									if ( typeof xhr.status !== "number" ) {
										complete( 0, "error" );
									} else {
										complete(
	
											// File: protocol always yields status 0; see #8605, #14207
											xhr.status,
											xhr.statusText
										);
									}
								} else {
									complete(
										xhrSuccessStatus[ xhr.status ] || xhr.status,
										xhr.statusText,
	
										// Support: IE <=9 only
										// IE9 has no XHR2 but throws on binary (trac-11426)
										// For XHR2 non-text, let the caller handle it (gh-2498)
										( xhr.responseType || "text" ) !== "text"  ||
										typeof xhr.responseText !== "string" ?
											{ binary: xhr.response } :
											{ text: xhr.responseText },
										xhr.getAllResponseHeaders()
									);
								}
							}
						};
					};
	
					// Listen to events
					xhr.onload = callback();
					errorCallback = xhr.onerror = callback( "error" );
	
					// Support: IE 9 only
					// Use onreadystatechange to replace onabort
					// to handle uncaught aborts
					if ( xhr.onabort !== undefined ) {
						xhr.onabort = errorCallback;
					} else {
						xhr.onreadystatechange = function() {
	
							// Check readyState before timeout as it changes
							if ( xhr.readyState === 4 ) {
	
								// Allow onerror to be called first,
								// but that will not handle a native abort
								// Also, save errorCallback to a variable
								// as xhr.onerror cannot be accessed
								window.setTimeout( function() {
									if ( callback ) {
										errorCallback();
									}
								} );
							}
						};
					}
	
					// Create the abort callback
					callback = callback( "abort" );
	
					try {
	
						// Do send the request (this may raise an exception)
						xhr.send( options.hasContent && options.data || null );
					} catch ( e ) {
	
						// #14683: Only rethrow if this hasn't been notified as an error yet
						if ( callback ) {
							throw e;
						}
					}
				},
	
				abort: function() {
					if ( callback ) {
						callback();
					}
				}
			};
		}
	} );
	
	
	
	
	// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
	jQuery.ajaxPrefilter( function( s ) {
		if ( s.crossDomain ) {
			s.contents.script = false;
		}
	} );
	
	// Install script dataType
	jQuery.ajaxSetup( {
		accepts: {
			script: "text/javascript, application/javascript, " +
				"application/ecmascript, application/x-ecmascript"
		},
		contents: {
			script: /\b(?:java|ecma)script\b/
		},
		converters: {
			"text script": function( text ) {
				jQuery.globalEval( text );
				return text;
			}
		}
	} );
	
	// Handle cache's special case and crossDomain
	jQuery.ajaxPrefilter( "script", function( s ) {
		if ( s.cache === undefined ) {
			s.cache = false;
		}
		if ( s.crossDomain ) {
			s.type = "GET";
		}
	} );
	
	// Bind script tag hack transport
	jQuery.ajaxTransport( "script", function( s ) {
	
		// This transport only deals with cross domain requests
		if ( s.crossDomain ) {
			var script, callback;
			return {
				send: function( _, complete ) {
					script = jQuery( "<script>" ).prop( {
						charset: s.scriptCharset,
						src: s.url
					} ).on(
						"load error",
						callback = function( evt ) {
							script.remove();
							callback = null;
							if ( evt ) {
								complete( evt.type === "error" ? 404 : 200, evt.type );
							}
						}
					);
	
					// Use native DOM manipulation to avoid our domManip AJAX trickery
					document.head.appendChild( script[ 0 ] );
				},
				abort: function() {
					if ( callback ) {
						callback();
					}
				}
			};
		}
	} );
	
	
	
	
	var oldCallbacks = [],
		rjsonp = /(=)\?(?=&|$)|\?\?/;
	
	// Default jsonp settings
	jQuery.ajaxSetup( {
		jsonp: "callback",
		jsonpCallback: function() {
			var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce++ ) );
			this[ callback ] = true;
			return callback;
		}
	} );
	
	// Detect, normalize options and install callbacks for jsonp requests
	jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {
	
		var callbackName, overwritten, responseContainer,
			jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
				"url" :
				typeof s.data === "string" &&
					( s.contentType || "" )
						.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
					rjsonp.test( s.data ) && "data"
			);
	
		// Handle iff the expected data type is "jsonp" or we have a parameter to set
		if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {
	
			// Get callback name, remembering preexisting value associated with it
			callbackName = s.jsonpCallback = jQuery.isFunction( s.jsonpCallback ) ?
				s.jsonpCallback() :
				s.jsonpCallback;
	
			// Insert callback into url or form data
			if ( jsonProp ) {
				s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
			} else if ( s.jsonp !== false ) {
				s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
			}
	
			// Use data converter to retrieve json after script execution
			s.converters[ "script json" ] = function() {
				if ( !responseContainer ) {
					jQuery.error( callbackName + " was not called" );
				}
				return responseContainer[ 0 ];
			};
	
			// Force json dataType
			s.dataTypes[ 0 ] = "json";
	
			// Install callback
			overwritten = window[ callbackName ];
			window[ callbackName ] = function() {
				responseContainer = arguments;
			};
	
			// Clean-up function (fires after converters)
			jqXHR.always( function() {
	
				// If previous value didn't exist - remove it
				if ( overwritten === undefined ) {
					jQuery( window ).removeProp( callbackName );
	
				// Otherwise restore preexisting value
				} else {
					window[ callbackName ] = overwritten;
				}
	
				// Save back as free
				if ( s[ callbackName ] ) {
	
					// Make sure that re-using the options doesn't screw things around
					s.jsonpCallback = originalSettings.jsonpCallback;
	
					// Save the callback name for future use
					oldCallbacks.push( callbackName );
				}
	
				// Call if it was a function and we have a response
				if ( responseContainer && jQuery.isFunction( overwritten ) ) {
					overwritten( responseContainer[ 0 ] );
				}
	
				responseContainer = overwritten = undefined;
			} );
	
			// Delegate to script
			return "script";
		}
	} );
	
	
	
	
	// Support: Safari 8 only
	// In Safari 8 documents created via document.implementation.createHTMLDocument
	// collapse sibling forms: the second one becomes a child of the first one.
	// Because of that, this security measure has to be disabled in Safari 8.
	// https://bugs.webkit.org/show_bug.cgi?id=137337
	support.createHTMLDocument = ( function() {
		var body = document.implementation.createHTMLDocument( "" ).body;
		body.innerHTML = "<form></form><form></form>";
		return body.childNodes.length === 2;
	} )();
	
	
	// Argument "data" should be string of html
	// context (optional): If specified, the fragment will be created in this context,
	// defaults to document
	// keepScripts (optional): If true, will include scripts passed in the html string
	jQuery.parseHTML = function( data, context, keepScripts ) {
		if ( typeof data !== "string" ) {
			return [];
		}
		if ( typeof context === "boolean" ) {
			keepScripts = context;
			context = false;
		}
	
		var base, parsed, scripts;
	
		if ( !context ) {
	
			// Stop scripts or inline event handlers from being executed immediately
			// by using document.implementation
			if ( support.createHTMLDocument ) {
				context = document.implementation.createHTMLDocument( "" );
	
				// Set the base href for the created document
				// so any parsed elements with URLs
				// are based on the document's URL (gh-2965)
				base = context.createElement( "base" );
				base.href = document.location.href;
				context.head.appendChild( base );
			} else {
				context = document;
			}
		}
	
		parsed = rsingleTag.exec( data );
		scripts = !keepScripts && [];
	
		// Single tag
		if ( parsed ) {
			return [ context.createElement( parsed[ 1 ] ) ];
		}
	
		parsed = buildFragment( [ data ], context, scripts );
	
		if ( scripts && scripts.length ) {
			jQuery( scripts ).remove();
		}
	
		return jQuery.merge( [], parsed.childNodes );
	};
	
	
	/**
	 * Load a url into a page
	 */
	jQuery.fn.load = function( url, params, callback ) {
		var selector, type, response,
			self = this,
			off = url.indexOf( " " );
	
		if ( off > -1 ) {
			selector = stripAndCollapse( url.slice( off ) );
			url = url.slice( 0, off );
		}
	
		// If it's a function
		if ( jQuery.isFunction( params ) ) {
	
			// We assume that it's the callback
			callback = params;
			params = undefined;
	
		// Otherwise, build a param string
		} else if ( params && typeof params === "object" ) {
			type = "POST";
		}
	
		// If we have elements to modify, make the request
		if ( self.length > 0 ) {
			jQuery.ajax( {
				url: url,
	
				// If "type" variable is undefined, then "GET" method will be used.
				// Make value of this field explicit since
				// user can override it through ajaxSetup method
				type: type || "GET",
				dataType: "html",
				data: params
			} ).done( function( responseText ) {
	
				// Save response for use in complete callback
				response = arguments;
	
				self.html( selector ?
	
					// If a selector was specified, locate the right elements in a dummy div
					// Exclude scripts to avoid IE 'Permission Denied' errors
					jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :
	
					// Otherwise use the full result
					responseText );
	
			// If the request succeeds, this function gets "data", "status", "jqXHR"
			// but they are ignored because response was set above.
			// If it fails, this function gets "jqXHR", "status", "error"
			} ).always( callback && function( jqXHR, status ) {
				self.each( function() {
					callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
				} );
			} );
		}
	
		return this;
	};
	
	
	
	
	// Attach a bunch of functions for handling common AJAX events
	jQuery.each( [
		"ajaxStart",
		"ajaxStop",
		"ajaxComplete",
		"ajaxError",
		"ajaxSuccess",
		"ajaxSend"
	], function( i, type ) {
		jQuery.fn[ type ] = function( fn ) {
			return this.on( type, fn );
		};
	} );
	
	
	
	
	jQuery.expr.pseudos.animated = function( elem ) {
		return jQuery.grep( jQuery.timers, function( fn ) {
			return elem === fn.elem;
		} ).length;
	};
	
	
	
	
	jQuery.offset = {
		setOffset: function( elem, options, i ) {
			var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
				position = jQuery.css( elem, "position" ),
				curElem = jQuery( elem ),
				props = {};
	
			// Set position first, in-case top/left are set even on static elem
			if ( position === "static" ) {
				elem.style.position = "relative";
			}
	
			curOffset = curElem.offset();
			curCSSTop = jQuery.css( elem, "top" );
			curCSSLeft = jQuery.css( elem, "left" );
			calculatePosition = ( position === "absolute" || position === "fixed" ) &&
				( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;
	
			// Need to be able to calculate position if either
			// top or left is auto and position is either absolute or fixed
			if ( calculatePosition ) {
				curPosition = curElem.position();
				curTop = curPosition.top;
				curLeft = curPosition.left;
	
			} else {
				curTop = parseFloat( curCSSTop ) || 0;
				curLeft = parseFloat( curCSSLeft ) || 0;
			}
	
			if ( jQuery.isFunction( options ) ) {
	
				// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
				options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
			}
	
			if ( options.top != null ) {
				props.top = ( options.top - curOffset.top ) + curTop;
			}
			if ( options.left != null ) {
				props.left = ( options.left - curOffset.left ) + curLeft;
			}
	
			if ( "using" in options ) {
				options.using.call( elem, props );
	
			} else {
				curElem.css( props );
			}
		}
	};
	
	jQuery.fn.extend( {
		offset: function( options ) {
	
			// Preserve chaining for setter
			if ( arguments.length ) {
				return options === undefined ?
					this :
					this.each( function( i ) {
						jQuery.offset.setOffset( this, options, i );
					} );
			}
	
			var doc, docElem, rect, win,
				elem = this[ 0 ];
	
			if ( !elem ) {
				return;
			}
	
			// Return zeros for disconnected and hidden (display: none) elements (gh-2310)
			// Support: IE <=11 only
			// Running getBoundingClientRect on a
			// disconnected node in IE throws an error
			if ( !elem.getClientRects().length ) {
				return { top: 0, left: 0 };
			}
	
			rect = elem.getBoundingClientRect();
	
			doc = elem.ownerDocument;
			docElem = doc.documentElement;
			win = doc.defaultView;
	
			return {
				top: rect.top + win.pageYOffset - docElem.clientTop,
				left: rect.left + win.pageXOffset - docElem.clientLeft
			};
		},
	
		position: function() {
			if ( !this[ 0 ] ) {
				return;
			}
	
			var offsetParent, offset,
				elem = this[ 0 ],
				parentOffset = { top: 0, left: 0 };
	
			// Fixed elements are offset from window (parentOffset = {top:0, left: 0},
			// because it is its only offset parent
			if ( jQuery.css( elem, "position" ) === "fixed" ) {
	
				// Assume getBoundingClientRect is there when computed position is fixed
				offset = elem.getBoundingClientRect();
	
			} else {
	
				// Get *real* offsetParent
				offsetParent = this.offsetParent();
	
				// Get correct offsets
				offset = this.offset();
				if ( !nodeName( offsetParent[ 0 ], "html" ) ) {
					parentOffset = offsetParent.offset();
				}
	
				// Add offsetParent borders
				parentOffset = {
					top: parentOffset.top + jQuery.css( offsetParent[ 0 ], "borderTopWidth", true ),
					left: parentOffset.left + jQuery.css( offsetParent[ 0 ], "borderLeftWidth", true )
				};
			}
	
			// Subtract parent offsets and element margins
			return {
				top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
				left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
			};
		},
	
		// This method will return documentElement in the following cases:
		// 1) For the element inside the iframe without offsetParent, this method will return
		//    documentElement of the parent window
		// 2) For the hidden or detached element
		// 3) For body or html element, i.e. in case of the html node - it will return itself
		//
		// but those exceptions were never presented as a real life use-cases
		// and might be considered as more preferable results.
		//
		// This logic, however, is not guaranteed and can change at any point in the future
		offsetParent: function() {
			return this.map( function() {
				var offsetParent = this.offsetParent;
	
				while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
					offsetParent = offsetParent.offsetParent;
				}
	
				return offsetParent || documentElement;
			} );
		}
	} );
	
	// Create scrollLeft and scrollTop methods
	jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
		var top = "pageYOffset" === prop;
	
		jQuery.fn[ method ] = function( val ) {
			return access( this, function( elem, method, val ) {
	
				// Coalesce documents and windows
				var win;
				if ( jQuery.isWindow( elem ) ) {
					win = elem;
				} else if ( elem.nodeType === 9 ) {
					win = elem.defaultView;
				}
	
				if ( val === undefined ) {
					return win ? win[ prop ] : elem[ method ];
				}
	
				if ( win ) {
					win.scrollTo(
						!top ? val : win.pageXOffset,
						top ? val : win.pageYOffset
					);
	
				} else {
					elem[ method ] = val;
				}
			}, method, val, arguments.length );
		};
	} );
	
	// Support: Safari <=7 - 9.1, Chrome <=37 - 49
	// Add the top/left cssHooks using jQuery.fn.position
	// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
	// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
	// getComputedStyle returns percent when specified for top/left/bottom/right;
	// rather than make the css module depend on the offset module, just check for it here
	jQuery.each( [ "top", "left" ], function( i, prop ) {
		jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
			function( elem, computed ) {
				if ( computed ) {
					computed = curCSS( elem, prop );
	
					// If curCSS returns percentage, fallback to offset
					return rnumnonpx.test( computed ) ?
						jQuery( elem ).position()[ prop ] + "px" :
						computed;
				}
			}
		);
	} );
	
	
	// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
	jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
		jQuery.each( { padding: "inner" + name, content: type, "": "outer" + name },
			function( defaultExtra, funcName ) {
	
			// Margin is only for outerHeight, outerWidth
			jQuery.fn[ funcName ] = function( margin, value ) {
				var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
					extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );
	
				return access( this, function( elem, type, value ) {
					var doc;
	
					if ( jQuery.isWindow( elem ) ) {
	
						// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
						return funcName.indexOf( "outer" ) === 0 ?
							elem[ "inner" + name ] :
							elem.document.documentElement[ "client" + name ];
					}
	
					// Get document width or height
					if ( elem.nodeType === 9 ) {
						doc = elem.documentElement;
	
						// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
						// whichever is greatest
						return Math.max(
							elem.body[ "scroll" + name ], doc[ "scroll" + name ],
							elem.body[ "offset" + name ], doc[ "offset" + name ],
							doc[ "client" + name ]
						);
					}
	
					return value === undefined ?
	
						// Get width or height on the element, requesting but not forcing parseFloat
						jQuery.css( elem, type, extra ) :
	
						// Set width or height on the element
						jQuery.style( elem, type, value, extra );
				}, type, chainable ? margin : undefined, chainable );
			};
		} );
	} );
	
	
	jQuery.fn.extend( {
	
		bind: function( types, data, fn ) {
			return this.on( types, null, data, fn );
		},
		unbind: function( types, fn ) {
			return this.off( types, null, fn );
		},
	
		delegate: function( selector, types, data, fn ) {
			return this.on( types, selector, data, fn );
		},
		undelegate: function( selector, types, fn ) {
	
			// ( namespace ) or ( selector, types [, fn] )
			return arguments.length === 1 ?
				this.off( selector, "**" ) :
				this.off( types, selector || "**", fn );
		}
	} );
	
	jQuery.holdReady = function( hold ) {
		if ( hold ) {
			jQuery.readyWait++;
		} else {
			jQuery.ready( true );
		}
	};
	jQuery.isArray = Array.isArray;
	jQuery.parseJSON = JSON.parse;
	jQuery.nodeName = nodeName;
	
	
	
	
	// Register as a named AMD module, since jQuery can be concatenated with other
	// files that may use define, but not via a proper concatenation script that
	// understands anonymous AMD modules. A named AMD is safest and most robust
	// way to register. Lowercase jquery is used because AMD module names are
	// derived from file names, and jQuery is normally delivered in a lowercase
	// file name. Do this after creating the global so that if an AMD module wants
	// to call noConflict to hide this version of jQuery, it will work.
	
	// Note that for maximum portability, libraries that are not jQuery should
	// declare themselves as anonymous modules, and avoid setting a global if an
	// AMD loader is present. jQuery is a special case. For more information, see
	// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
	
	if ( true ) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
			return jQuery;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
	
	
	
	
	var
	
		// Map over jQuery in case of overwrite
		_jQuery = window.jQuery,
	
		// Map over the $ in case of overwrite
		_$ = window.$;
	
	jQuery.noConflict = function( deep ) {
		if ( window.$ === jQuery ) {
			window.$ = _$;
		}
	
		if ( deep && window.jQuery === jQuery ) {
			window.jQuery = _jQuery;
		}
	
		return jQuery;
	};
	
	// Expose jQuery and $ identifiers, even in AMD
	// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
	// and CommonJS for browser emulators (#13566)
	if ( !noGlobal ) {
		window.jQuery = window.$ = jQuery;
	}
	
	
	
	
	return jQuery;
	} );


/***/ },
/* 15 */
[628, 200],
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	var baseRest = __webpack_require__(33),
	    createWrap = __webpack_require__(197),
	    getHolder = __webpack_require__(87),
	    replaceHolders = __webpack_require__(53);
	
	/** Used to compose bitmasks for function metadata. */
	var WRAP_PARTIAL_RIGHT_FLAG = 64;
	
	/**
	 * This method is like `_.partial` except that partially applied arguments
	 * are appended to the arguments it receives.
	 *
	 * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
	 * builds, may be used as a placeholder for partially applied arguments.
	 *
	 * **Note:** This method doesn't set the "length" property of partially
	 * applied functions.
	 *
	 * @static
	 * @memberOf _
	 * @since 1.0.0
	 * @category Function
	 * @param {Function} func The function to partially apply arguments to.
	 * @param {...*} [partials] The arguments to be partially applied.
	 * @returns {Function} Returns the new partially applied function.
	 * @example
	 *
	 * function greet(greeting, name) {
	 *   return greeting + ' ' + name;
	 * }
	 *
	 * var greetFred = _.partialRight(greet, 'fred');
	 * greetFred('hi');
	 * // => 'hi fred'
	 *
	 * // Partially applied with placeholders.
	 * var sayHelloTo = _.partialRight(greet, 'hello', _);
	 * sayHelloTo('fred');
	 * // => 'hello fred'
	 */
	var partialRight = baseRest(function(func, partials) {
	  var holders = replaceHolders(partials, getHolder(partialRight));
	  return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
	});
	
	// Assign default placeholders.
	partialRight.placeholder = {};
	
	module.exports = partialRight;


/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var bind = __webpack_require__(158);
	var isBuffer = __webpack_require__(359);
	
	/*global toString:true*/
	
	// utils is a library of generic helper functions non-specific to axios
	
	var toString = Object.prototype.toString;
	
	/**
	 * Determine if a value is an Array
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Array, otherwise false
	 */
	function isArray(val) {
	  return toString.call(val) === '[object Array]';
	}
	
	/**
	 * Determine if a value is an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
	 */
	function isArrayBuffer(val) {
	  return toString.call(val) === '[object ArrayBuffer]';
	}
	
	/**
	 * Determine if a value is a FormData
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an FormData, otherwise false
	 */
	function isFormData(val) {
	  return (typeof FormData !== 'undefined') && (val instanceof FormData);
	}
	
	/**
	 * Determine if a value is a view on an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
	 */
	function isArrayBufferView(val) {
	  var result;
	  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
	    result = ArrayBuffer.isView(val);
	  } else {
	    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
	  }
	  return result;
	}
	
	/**
	 * Determine if a value is a String
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a String, otherwise false
	 */
	function isString(val) {
	  return typeof val === 'string';
	}
	
	/**
	 * Determine if a value is a Number
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Number, otherwise false
	 */
	function isNumber(val) {
	  return typeof val === 'number';
	}
	
	/**
	 * Determine if a value is undefined
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if the value is undefined, otherwise false
	 */
	function isUndefined(val) {
	  return typeof val === 'undefined';
	}
	
	/**
	 * Determine if a value is an Object
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Object, otherwise false
	 */
	function isObject(val) {
	  return val !== null && typeof val === 'object';
	}
	
	/**
	 * Determine if a value is a Date
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Date, otherwise false
	 */
	function isDate(val) {
	  return toString.call(val) === '[object Date]';
	}
	
	/**
	 * Determine if a value is a File
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a File, otherwise false
	 */
	function isFile(val) {
	  return toString.call(val) === '[object File]';
	}
	
	/**
	 * Determine if a value is a Blob
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Blob, otherwise false
	 */
	function isBlob(val) {
	  return toString.call(val) === '[object Blob]';
	}
	
	/**
	 * Determine if a value is a Function
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Function, otherwise false
	 */
	function isFunction(val) {
	  return toString.call(val) === '[object Function]';
	}
	
	/**
	 * Determine if a value is a Stream
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Stream, otherwise false
	 */
	function isStream(val) {
	  return isObject(val) && isFunction(val.pipe);
	}
	
	/**
	 * Determine if a value is a URLSearchParams object
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
	 */
	function isURLSearchParams(val) {
	  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
	}
	
	/**
	 * Trim excess whitespace off the beginning and end of a string
	 *
	 * @param {String} str The String to trim
	 * @returns {String} The String freed of excess whitespace
	 */
	function trim(str) {
	  return str.replace(/^\s*/, '').replace(/\s*$/, '');
	}
	
	/**
	 * Determine if we're running in a standard browser environment
	 *
	 * This allows axios to run in a web worker, and react-native.
	 * Both environments support XMLHttpRequest, but not fully standard globals.
	 *
	 * web workers:
	 *  typeof window -> undefined
	 *  typeof document -> undefined
	 *
	 * react-native:
	 *  navigator.product -> 'ReactNative'
	 */
	function isStandardBrowserEnv() {
	  if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
	    return false;
	  }
	  return (
	    typeof window !== 'undefined' &&
	    typeof document !== 'undefined'
	  );
	}
	
	/**
	 * Iterate over an Array or an Object invoking a function for each item.
	 *
	 * If `obj` is an Array callback will be called passing
	 * the value, index, and complete array for each item.
	 *
	 * If 'obj' is an Object callback will be called passing
	 * the value, key, and complete object for each property.
	 *
	 * @param {Object|Array} obj The object to iterate
	 * @param {Function} fn The callback to invoke for each item
	 */
	function forEach(obj, fn) {
	  // Don't bother if no value provided
	  if (obj === null || typeof obj === 'undefined') {
	    return;
	  }
	
	  // Force an array if not already something iterable
	  if (typeof obj !== 'object' && !isArray(obj)) {
	    /*eslint no-param-reassign:0*/
	    obj = [obj];
	  }
	
	  if (isArray(obj)) {
	    // Iterate over array values
	    for (var i = 0, l = obj.length; i < l; i++) {
	      fn.call(null, obj[i], i, obj);
	    }
	  } else {
	    // Iterate over object keys
	    for (var key in obj) {
	      if (Object.prototype.hasOwnProperty.call(obj, key)) {
	        fn.call(null, obj[key], key, obj);
	      }
	    }
	  }
	}
	
	/**
	 * Accepts varargs expecting each argument to be an object, then
	 * immutably merges the properties of each object and returns result.
	 *
	 * When multiple objects contain the same key the later object in
	 * the arguments list will take precedence.
	 *
	 * Example:
	 *
	 * ```js
	 * var result = merge({foo: 123}, {foo: 456});
	 * console.log(result.foo); // outputs 456
	 * ```
	 *
	 * @param {Object} obj1 Object to merge
	 * @returns {Object} Result of all merge properties
	 */
	function merge(/* obj1, obj2, obj3, ... */) {
	  var result = {};
	  function assignValue(val, key) {
	    if (typeof result[key] === 'object' && typeof val === 'object') {
	      result[key] = merge(result[key], val);
	    } else {
	      result[key] = val;
	    }
	  }
	
	  for (var i = 0, l = arguments.length; i < l; i++) {
	    forEach(arguments[i], assignValue);
	  }
	  return result;
	}
	
	/**
	 * Extends object a by mutably adding to it the properties of object b.
	 *
	 * @param {Object} a The object to be extended
	 * @param {Object} b The object to copy properties from
	 * @param {Object} thisArg The object to bind function to
	 * @return {Object} The resulting value of object a
	 */
	function extend(a, b, thisArg) {
	  forEach(b, function assignValue(val, key) {
	    if (thisArg && typeof val === 'function') {
	      a[key] = bind(val, thisArg);
	    } else {
	      a[key] = val;
	    }
	  });
	  return a;
	}
	
	module.exports = {
	  isArray: isArray,
	  isArrayBuffer: isArrayBuffer,
	  isBuffer: isBuffer,
	  isFormData: isFormData,
	  isArrayBufferView: isArrayBufferView,
	  isString: isString,
	  isNumber: isNumber,
	  isObject: isObject,
	  isUndefined: isUndefined,
	  isDate: isDate,
	  isFile: isFile,
	  isBlob: isBlob,
	  isFunction: isFunction,
	  isStream: isStream,
	  isURLSearchParams: isURLSearchParams,
	  isStandardBrowserEnv: isStandardBrowserEnv,
	  forEach: forEach,
	  merge: merge,
	  extend: extend,
	  trim: trim
	};


/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.BaseProps = exports.DataProps = undefined;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _victoryCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DataProps = exports.DataProps = {
	  categories: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.string), _propTypes2.default.shape({
	    x: _propTypes2.default.arrayOf(_propTypes2.default.string), y: _propTypes2.default.arrayOf(_propTypes2.default.string)
	  })]),
	  data: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.object]),
	  dataComponent: _propTypes2.default.element,
	  labelComponent: _propTypes2.default.element,
	  labels: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.array]),
	  samples: _victoryCore.PropTypes.nonNegative,
	  sortKey: _propTypes2.default.oneOfType([_propTypes2.default.func, _victoryCore.PropTypes.allOfType([_victoryCore.PropTypes.integer, _victoryCore.PropTypes.nonNegative]), _propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.string)]),
	  sortOrder: _propTypes2.default.oneOf(["ascending", "descending"]),
	  style: _propTypes2.default.shape({
	    parent: _propTypes2.default.object, data: _propTypes2.default.object, labels: _propTypes2.default.object
	  }),
	  x: _propTypes2.default.oneOfType([_propTypes2.default.func, _victoryCore.PropTypes.allOfType([_victoryCore.PropTypes.integer, _victoryCore.PropTypes.nonNegative]), _propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.string)]),
	  y: _propTypes2.default.oneOfType([_propTypes2.default.func, _victoryCore.PropTypes.allOfType([_victoryCore.PropTypes.integer, _victoryCore.PropTypes.nonNegative]), _propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.string)]),
	  y0: _propTypes2.default.oneOfType([_propTypes2.default.func, _victoryCore.PropTypes.allOfType([_victoryCore.PropTypes.integer, _victoryCore.PropTypes.nonNegative]), _propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.string)])
	};
	
	var BaseProps = exports.BaseProps = {
	  animate: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.object]),
	  containerComponent: _propTypes2.default.element,
	  domain: _propTypes2.default.oneOfType([_victoryCore.PropTypes.domain, _propTypes2.default.shape({ x: _victoryCore.PropTypes.domain, y: _victoryCore.PropTypes.domain })]),
	  domainPadding: _propTypes2.default.oneOfType([_propTypes2.default.shape({
	    x: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.arrayOf(_propTypes2.default.number)]),
	    y: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.arrayOf(_propTypes2.default.number)])
	  }), _propTypes2.default.number, _propTypes2.default.arrayOf(_propTypes2.default.number)]),
	  eventKey: _propTypes2.default.oneOfType([_propTypes2.default.func, _victoryCore.PropTypes.allOfType([_victoryCore.PropTypes.integer, _victoryCore.PropTypes.nonNegative]), _propTypes2.default.string]),
	  events: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    target: _propTypes2.default.oneOf(["data", "labels", "parent"]),
	    eventKey: _propTypes2.default.oneOfType([_propTypes2.default.array, _victoryCore.PropTypes.allOfType([_victoryCore.PropTypes.integer, _victoryCore.PropTypes.nonNegative]), _propTypes2.default.string]),
	    eventHandlers: _propTypes2.default.object
	  })),
	  groupComponent: _propTypes2.default.element,
	  height: _victoryCore.PropTypes.nonNegative,
	  name: _propTypes2.default.string,
	  origin: _propTypes2.default.shape({ x: _propTypes2.default.number, y: _propTypes2.default.number }),
	  padding: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.shape({
	    top: _propTypes2.default.number, bottom: _propTypes2.default.number,
	    left: _propTypes2.default.number, right: _propTypes2.default.number
	  })]),
	  polar: _propTypes2.default.bool,
	  range: _propTypes2.default.oneOfType([_victoryCore.PropTypes.domain, _propTypes2.default.shape({ x: _victoryCore.PropTypes.domain, y: _victoryCore.PropTypes.domain })]),
	  scale: _propTypes2.default.oneOfType([_victoryCore.PropTypes.scale, _propTypes2.default.shape({ x: _victoryCore.PropTypes.scale, y: _victoryCore.PropTypes.scale })]),
	  sharedEvents: _propTypes2.default.shape({
	    events: _propTypes2.default.array,
	    getEventState: _propTypes2.default.func
	  }),
	  standalone: _propTypes2.default.bool,
	  theme: _propTypes2.default.object,
	  width: _victoryCore.PropTypes.nonNegative
	};

/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _propTypes3 = __webpack_require__(26);
	
	var _propTypes4 = _interopRequireDefault(_propTypes3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  active: _propTypes2.default.bool,
	  className: _propTypes2.default.string,
	  data: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.object]),
	  events: _propTypes2.default.object,
	  index: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  origin: _propTypes2.default.shape({ x: _propTypes2.default.number, y: _propTypes2.default.number }),
	  polar: _propTypes2.default.bool,
	  role: _propTypes2.default.string,
	  scale: _propTypes2.default.oneOfType([_propTypes4.default.scale, _propTypes2.default.shape({ x: _propTypes4.default.scale, y: _propTypes4.default.scale })]),
	  shapeRendering: _propTypes2.default.string,
	  style: _propTypes2.default.object
	};

/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = function() {};
	
	if (false) {
	  warning = function(condition, format, args) {
	    var len = arguments.length;
	    args = new Array(len > 2 ? len - 2 : 0);
	    for (var key = 2; key < len; key++) {
	      args[key - 2] = arguments[key];
	    }
	    if (format === undefined) {
	      throw new Error(
	        '`warning(condition, format, ...args)` requires a warning ' +
	        'message argument'
	      );
	    }
	
	    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
	      throw new Error(
	        'The warning format should be able to uniquely identify this ' +
	        'warning. Please, use a more descriptive format than: ' + format
	      );
	    }
	
	    if (!condition) {
	      var argIndex = 0;
	      var message = 'Warning: ' +
	        format.replace(/%s/g, function() {
	          return args[argIndex++];
	        });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch(x) {}
	    }
	  };
	}
	
	module.exports = warning;


/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var invariant = function(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error(
	        'Minified exception occurred; use the non-minified dev environment ' +
	        'for the full error message and additional helpful warnings.'
	      );
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(
	        format.replace(/%s/g, function() { return args[argIndex++]; })
	      );
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.exports = invariant;


/***/ },
/* 22 */
/***/ function(module, exports) {

	/**
	 * This method returns the first argument it receives.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 *
	 * console.log(_.identity(object) === object);
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	module.exports = identity;


/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(7),
	    isLength = __webpack_require__(132);
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	module.exports = isArrayLike;


/***/ },
/* 24 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(40),
	    baseClone = __webpack_require__(370),
	    baseUnset = __webpack_require__(402),
	    castPath = __webpack_require__(41),
	    copyObject = __webpack_require__(29),
	    customOmitClone = __webpack_require__(430),
	    flatRest = __webpack_require__(123),
	    getAllKeysIn = __webpack_require__(202);
	
	/** Used to compose bitmasks for cloning. */
	var CLONE_DEEP_FLAG = 1,
	    CLONE_FLAT_FLAG = 2,
	    CLONE_SYMBOLS_FLAG = 4;
	
	/**
	 * The opposite of `_.pick`; this method creates an object composed of the
	 * own and inherited enumerable property paths of `object` that are not omitted.
	 *
	 * **Note:** This method is considerably slower than `_.pick`.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The source object.
	 * @param {...(string|string[])} [paths] The property paths to omit.
	 * @returns {Object} Returns the new object.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': '2', 'c': 3 };
	 *
	 * _.omit(object, ['a', 'c']);
	 * // => { 'b': '2' }
	 */
	var omit = flatRest(function(object, paths) {
	  var result = {};
	  if (object == null) {
	    return result;
	  }
	  var isDeep = false;
	  paths = arrayMap(paths, function(path) {
	    path = castPath(path, object);
	    isDeep || (isDeep = path.length > 1);
	    return path;
	  });
	  copyObject(object, getAllKeysIn(object), result);
	  if (isDeep) {
	    result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
	  }
	  var length = paths.length;
	  while (length--) {
	    baseUnset(result, paths[length]);
	  }
	  return result;
	});
	
	module.exports = omit;


/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _find2 = __webpack_require__(484);
	
	var _find3 = _interopRequireDefault(_find2);
	
	var _isFunction2 = __webpack_require__(7);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _log = __webpack_require__(98);
	
	var _log2 = _interopRequireDefault(_log);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } /*eslint no-magic-numbers: ["error", { "ignore": [-1, 0, 1, 2] }]*/
	
	
	/**
	 * Return a new validator based on `validator` but with the option to chain
	 * `isRequired` onto the validation. This is nearly identical to how React
	 * does it internally, but they don't expose their helper for us to use.
	 * @param {Function} validator Validation function.
	 * @returns {Function} Validator with `isRequired` option.
	 */
	var makeChainable = function (validator) {
	  /* eslint-disable max-params */
	  var _chainable = function (isRequired, props, propName, componentName) {
	    var value = props[propName];
	    if (typeof value === "undefined" || value === null) {
	      if (isRequired) {
	        return new Error("Required `" + propName + "` was not specified in `" + componentName + "`.");
	      }
	      return null;
	    }
	
	    for (var _len = arguments.length, rest = Array(_len > 4 ? _len - 4 : 0), _key = 4; _key < _len; _key++) {
	      rest[_key - 4] = arguments[_key];
	    }
	
	    return validator.apply(undefined, [props, propName, componentName].concat(rest));
	  };
	  var chainable = _chainable.bind(null, false);
	  chainable.isRequired = _chainable.bind(null, true);
	  return chainable;
	};
	
	var nullConstructor = function () {
	  return null;
	};
	var undefinedConstructor = function () {
	  return undefined;
	};
	
	/**
	 * Get the constructor of `value`. If `value` is null or undefined, return the
	 * special singletons `nullConstructor` or `undefinedConstructor`, respectively.
	 * @param {*} value Instance to return the constructor of.
	 * @returns {Function} Constructor of `value`.
	 */
	var getConstructor = function (value) {
	  if (typeof value === "undefined") {
	    return undefinedConstructor;
	  } else if (value === null) {
	    return nullConstructor;
	  } else {
	    return value.constructor;
	  }
	};
	
	/**
	 * Get the name of the constructor used to create `value`, using
	 * `Object.protoype.toString`. If the value is null or undefined, return
	 * "null" or "undefined", respectively.
	 * @param {*} value Instance to return the constructor name of.
	 * @returns {String} Name of the constructor.
	 */
	var getConstructorName = function (value) {
	  if (typeof value === "undefined") {
	    return "undefined";
	  } else if (value === null) {
	    return "null";
	  }
	  return Object.prototype.toString.call(value).slice(8, -1); // eslint-disable-line no-magic-numbers
	};
	
	exports.default = {
	  /**
	   * Return a new validator based on `propType` but which logs a `console.error`
	   * with `explanation` if used.
	   * @param {Function} propType The old, deprecated propType.
	   * @param {String} explanation The message to provide the user of the deprecated propType.
	   * @returns {Function} Validator which logs usage of this propType
	   */
	  deprecated: function (propType, explanation) {
	    return function (props, propName, componentName) {
	      var value = props[propName];
	      if (value !== null && value !== undefined) {
	        _log2.default.warn("\"" + propName + "\" property of \"" + componentName + "\" has been deprecated " + explanation);
	      }
	      return _propTypes2.default.checkPropTypes(_defineProperty({}, propName, propType), props, propName, componentName);
	    };
	  },
	
	
	  /**
	   * Return a new validator which returns true
	   * if and only if all validators passed as arguments return true.
	   * Like React.propTypes.oneOfType, except "all" instead of "any"
	   * @param {Array} validators Validation functions.
	   * @returns {Function} Combined validator function
	   */
	  allOfType: function (validators) {
	    return makeChainable(function (props, propName, componentName) {
	      for (var _len2 = arguments.length, rest = Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
	        rest[_key2 - 3] = arguments[_key2];
	      }
	
	      return validators.reduce(function (result, validator) {
	        return result || validator.apply(undefined, [props, propName, componentName].concat(rest));
	      }, undefined);
	    });
	  },
	
	
	  /**
	   * Check that the value is a non-negative number.
	   */
	  nonNegative: makeChainable(function (props, propName, componentName) {
	    var value = props[propName];
	    if (typeof value !== "number" || value < 0) {
	      return new Error("`" + propName + "` in `" + componentName + "` must be a non-negative number.");
	    }
	    return undefined;
	  }),
	
	  /**
	   * Check that the value is an integer.
	   */
	  integer: makeChainable(function (props, propName, componentName) {
	    var value = props[propName];
	    if (typeof value !== "number" || value % 1 !== 0) {
	      return new Error("`" + propName + "` in `" + componentName + "` must be an integer.");
	    }
	    return undefined;
	  }),
	
	  /**
	   * Check that the value is greater than zero.
	   */
	  greaterThanZero: makeChainable(function (props, propName, componentName) {
	    var value = props[propName];
	    if (typeof value !== "number" || value <= 0) {
	      return new Error("`" + propName + "` in `" + componentName + "` must be a number greater than zero.");
	    }
	    return undefined;
	  }),
	
	  /**
	   * Check that the value is an Array of two unique values.
	   */
	  domain: makeChainable(function (props, propName, componentName) {
	    var value = props[propName];
	    if (!Array.isArray(value) || value.length !== 2 || value[1] === value[0]) {
	      return new Error("`" + propName + "` in `" + componentName + "` must be an array of two unique numeric values.");
	    }
	    return undefined;
	  }),
	
	  /**
	   * Check that the value looks like a d3 `scale` function.
	   */
	  scale: makeChainable(function (props, propName, componentName) {
	    var supportedScaleStrings = ["linear", "time", "log", "sqrt"];
	    var validScale = function (scl) {
	      if ((0, _isFunction3.default)(scl)) {
	        return (0, _isFunction3.default)(scl.copy) && (0, _isFunction3.default)(scl.domain) && (0, _isFunction3.default)(scl.range);
	      } else if (typeof scl === "string") {
	        return supportedScaleStrings.indexOf(scl) !== -1;
	      }
	      return false;
	    };
	
	    var value = props[propName];
	    if (!validScale(value)) {
	      return new Error("`" + propName + "` in `" + componentName + "` must be a d3 scale.");
	    }
	    return undefined;
	  }),
	
	  /**
	   * Check that an array contains items of the same type.
	   */
	  homogeneousArray: makeChainable(function (props, propName, componentName) {
	    var values = props[propName];
	    if (!Array.isArray(values)) {
	      return new Error("`" + propName + "` in `" + componentName + "` must be an array.");
	    }
	
	    if (values.length < 2) {
	      return undefined;
	    }
	
	    var comparisonConstructor = getConstructor(values[0]);
	
	    var typeMismatchedValue = (0, _find3.default)(values, function (value) {
	      return comparisonConstructor !== getConstructor(value);
	    });
	
	    if (typeMismatchedValue) {
	      var constructorName = getConstructorName(values[0]);
	      var otherConstructorName = getConstructorName(typeMismatchedValue);
	
	      return new Error("Expected `" + propName + "` in `" + componentName + "` to be a " + ("homogeneous array, but found types `" + constructorName + "` and ") + ("`" + otherConstructorName + "`."));
	    }
	    return undefined;
	  }),
	
	  /**
	   * Check that array prop length matches props.data.length
	   */
	  matchDataLength: makeChainable(function (props, propName) {
	    if (props[propName] && Array.isArray(props[propName]) && props[propName].length !== props.data.length) {
	      return new Error("Length of data and " + propName + " arrays must match.");
	    }
	    return undefined;
	  })
	};

/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(272);

/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _imglogo = __webpack_require__(572);
	
	var _imglogo2 = _interopRequireDefault(_imglogo);
	
	var _jquery = __webpack_require__(14);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _content = __webpack_require__(46);
	
	var _content2 = _interopRequireDefault(_content);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Using: PopUp.prototype.show("your words");
	// The trigger button here in this file is display none
	
	
	var PopUp = function (_Component) {
	  _inherits(PopUp, _Component);
	
	  function PopUp() {
	    _classCallCheck(this, PopUp);
	
	    return _possibleConstructorReturn(this, (PopUp.__proto__ || Object.getPrototypeOf(PopUp)).apply(this, arguments));
	  }
	
	  _createClass(PopUp, [{
	    key: 'show',
	    value: function show(sentences) {
	      (0, _jquery2.default)('#popup-context').html("<p>" + sentences + "</p>");
	      (0, _jquery2.default)('#popup-button').click();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	
	      var data = _content2.default[0]["page"]["popup"];
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement('button', { id: 'popup-button', 'data-toggle': 'modal', 'data-target': '#popup' }),
	        _react2.default.createElement(
	          'div',
	          { id: 'popup', 'class': 'modal fade in', tabIndex: '-1', role: 'dialog', 'aria-labelledby': 'myModalLabel', 'aria-hidden': 'true' },
	          _react2.default.createElement(
	            'div',
	            { 'class': 'modal-dialog' },
	            _react2.default.createElement(
	              'div',
	              { 'class': 'fixed-card-box popup' },
	              _react2.default.createElement(
	                'button',
	                { type: 'button', 'class': 'close', 'data-dismiss': 'modal', 'aria-hidden': 'true' },
	                '\xD7'
	              ),
	              _react2.default.createElement('img', { src: _imglogo2.default, alt: 'daotoken' }),
	              _react2.default.createElement('h5', { id: 'popup-context', 'class': 'text-center' }),
	              _react2.default.createElement(
	                'div',
	                { 'class': 'pull-right' },
	                _react2.default.createElement(
	                  'button',
	                  { 'data-dismiss': 'modal', 'aria-hidden': 'true', 'class': 'btn btn-default btn-block waves-effect waves-light text-center m-b-20' },
	                  data.confirm
	                )
	              ),
	              _react2.default.createElement('div', { 'class': 'm-b-10' })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return PopUp;
	}(_react.Component);
	
	exports.default = PopUp;

/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	var assignValue = __webpack_require__(79),
	    baseAssignValue = __webpack_require__(81);
	
	/**
	 * Copies properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy properties from.
	 * @param {Array} props The property identifiers to copy.
	 * @param {Object} [object={}] The object to copy properties to.
	 * @param {Function} [customizer] The function to customize copied values.
	 * @returns {Object} Returns `object`.
	 */
	function copyObject(source, props, object, customizer) {
	  var isNew = !object;
	  object || (object = {});
	
	  var index = -1,
	      length = props.length;
	
	  while (++index < length) {
	    var key = props[index];
	
	    var newValue = customizer
	      ? customizer(object[key], source[key], key, object, source)
	      : undefined;
	
	    if (newValue === undefined) {
	      newValue = source[key];
	    }
	    if (isNew) {
	      baseAssignValue(object, key, newValue);
	    } else {
	      assignValue(object, key, newValue);
	    }
	  }
	  return object;
	}
	
	module.exports = copyObject;


/***/ },
/* 30 */
[625, 39, 434, 464],
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var stringify = __webpack_require__(512);
	var parse = __webpack_require__(511);
	var formats = __webpack_require__(229);
	
	module.exports = {
	    formats: formats,
	    parse: parse,
	    stringify: stringify
	};


/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	var baseMatches = __webpack_require__(382),
	    baseMatchesProperty = __webpack_require__(383),
	    identity = __webpack_require__(22),
	    isArray = __webpack_require__(9),
	    property = __webpack_require__(134);
	
	/**
	 * The base implementation of `_.iteratee`.
	 *
	 * @private
	 * @param {*} [value=_.identity] The value to convert to an iteratee.
	 * @returns {Function} Returns the iteratee.
	 */
	function baseIteratee(value) {
	  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	  if (typeof value == 'function') {
	    return value;
	  }
	  if (value == null) {
	    return identity;
	  }
	  if (typeof value == 'object') {
	    return isArray(value)
	      ? baseMatchesProperty(value[0], value[1])
	      : baseMatches(value);
	  }
	  return property(value);
	}
	
	module.exports = baseIteratee;


/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	var identity = __webpack_require__(22),
	    overRest = __webpack_require__(211),
	    setToString = __webpack_require__(129);
	
	/**
	 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 */
	function baseRest(func, start) {
	  return setToString(overRest(func, start, identity), func + '');
	}
	
	module.exports = baseRest;


/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsNative = __webpack_require__(378),
	    getValue = __webpack_require__(435);
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	module.exports = getNative;


/***/ },
/* 35 */
/***/ function(module, exports) {

	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	module.exports = eq;


/***/ },
/* 36 */
[629, 30, 125, 24],
/* 37 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.withRouter = exports.matchPath = exports.Switch = exports.StaticRouter = exports.Router = exports.Route = exports.Redirect = exports.Prompt = exports.NavLink = exports.MemoryRouter = exports.Link = exports.HashRouter = exports.BrowserRouter = undefined;
	
	var _BrowserRouter2 = __webpack_require__(544);
	
	var _BrowserRouter3 = _interopRequireDefault(_BrowserRouter2);
	
	var _HashRouter2 = __webpack_require__(545);
	
	var _HashRouter3 = _interopRequireDefault(_HashRouter2);
	
	var _Link2 = __webpack_require__(238);
	
	var _Link3 = _interopRequireDefault(_Link2);
	
	var _MemoryRouter2 = __webpack_require__(546);
	
	var _MemoryRouter3 = _interopRequireDefault(_MemoryRouter2);
	
	var _NavLink2 = __webpack_require__(547);
	
	var _NavLink3 = _interopRequireDefault(_NavLink2);
	
	var _Prompt2 = __webpack_require__(548);
	
	var _Prompt3 = _interopRequireDefault(_Prompt2);
	
	var _Redirect2 = __webpack_require__(549);
	
	var _Redirect3 = _interopRequireDefault(_Redirect2);
	
	var _Route2 = __webpack_require__(239);
	
	var _Route3 = _interopRequireDefault(_Route2);
	
	var _Router2 = __webpack_require__(141);
	
	var _Router3 = _interopRequireDefault(_Router2);
	
	var _StaticRouter2 = __webpack_require__(550);
	
	var _StaticRouter3 = _interopRequireDefault(_StaticRouter2);
	
	var _Switch2 = __webpack_require__(551);
	
	var _Switch3 = _interopRequireDefault(_Switch2);
	
	var _matchPath2 = __webpack_require__(552);
	
	var _matchPath3 = _interopRequireDefault(_matchPath2);
	
	var _withRouter2 = __webpack_require__(553);
	
	var _withRouter3 = _interopRequireDefault(_withRouter2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.BrowserRouter = _BrowserRouter3.default;
	exports.HashRouter = _HashRouter3.default;
	exports.Link = _Link3.default;
	exports.MemoryRouter = _MemoryRouter3.default;
	exports.NavLink = _NavLink3.default;
	exports.Prompt = _Prompt3.default;
	exports.Redirect = _Redirect3.default;
	exports.Route = _Route3.default;
	exports.Router = _Router3.default;
	exports.StaticRouter = _StaticRouter3.default;
	exports.Switch = _Switch3.default;
	exports.matchPath = _matchPath3.default;
	exports.withRouter = _withRouter3.default;

/***/ },
/* 38 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var addLeadingSlash = exports.addLeadingSlash = function addLeadingSlash(path) {
	  return path.charAt(0) === '/' ? path : '/' + path;
	};
	
	var stripLeadingSlash = exports.stripLeadingSlash = function stripLeadingSlash(path) {
	  return path.charAt(0) === '/' ? path.substr(1) : path;
	};
	
	var hasBasename = exports.hasBasename = function hasBasename(path, prefix) {
	  return new RegExp('^' + prefix + '(\\/|\\?|#|$)', 'i').test(path);
	};
	
	var stripBasename = exports.stripBasename = function stripBasename(path, prefix) {
	  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
	};
	
	var stripTrailingSlash = exports.stripTrailingSlash = function stripTrailingSlash(path) {
	  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
	};
	
	var parsePath = exports.parsePath = function parsePath(path) {
	  var pathname = path || '/';
	  var search = '';
	  var hash = '';
	
	  var hashIndex = pathname.indexOf('#');
	  if (hashIndex !== -1) {
	    hash = pathname.substr(hashIndex);
	    pathname = pathname.substr(0, hashIndex);
	  }
	
	  var searchIndex = pathname.indexOf('?');
	  if (searchIndex !== -1) {
	    search = pathname.substr(searchIndex);
	    pathname = pathname.substr(0, searchIndex);
	  }
	
	  return {
	    pathname: pathname,
	    search: search === '?' ? '' : search,
	    hash: hash === '#' ? '' : hash
	  };
	};
	
	var createPath = exports.createPath = function createPath(location) {
	  var pathname = location.pathname,
	      search = location.search,
	      hash = location.hash;
	
	
	  var path = pathname || '/';
	
	  if (search && search !== '?') path += search.charAt(0) === '?' ? search : '?' + search;
	
	  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : '#' + hash;
	
	  return path;
	};

/***/ },
/* 39 */
[624, 15],
/* 40 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.map` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}
	
	module.exports = arrayMap;


/***/ },
/* 41 */
/***/ function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(9),
	    isKey = __webpack_require__(127),
	    stringToPath = __webpack_require__(477),
	    toString = __webpack_require__(136);
	
	/**
	 * Casts `value` to a path array if it's not one.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {Array} Returns the cast property path array.
	 */
	function castPath(value, object) {
	  if (isArray(value)) {
	    return value;
	  }
	  return isKey(value, object) ? [value] : stringToPath(toString(value));
	}
	
	module.exports = castPath;


/***/ },
/* 42 */
/***/ function(module, exports, __webpack_require__) {

	var isSymbol = __webpack_require__(57);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/**
	 * Converts `value` to a string key if it's not a string or symbol.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {string|symbol} Returns the key.
	 */
	function toKey(value) {
	  if (typeof value == 'string' || isSymbol(value)) {
	    return value;
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = toKey;


/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(117);
	
	/**
	 * Performs a deep comparison between two values to determine if they are
	 * equivalent.
	 *
	 * **Note:** This method supports comparing arrays, array buffers, booleans,
	 * date objects, error objects, maps, numbers, `Object` objects, regexes,
	 * sets, strings, symbols, and typed arrays. `Object` objects are compared
	 * by their own, not inherited, enumerable properties. Functions and DOM
	 * nodes are compared by strict equality, i.e. `===`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.isEqual(object, other);
	 * // => true
	 *
	 * object === other;
	 * // => false
	 */
	function isEqual(value, other) {
	  return baseIsEqual(value, other);
	}
	
	module.exports = isEqual;


/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__(180),
	    baseKeysIn = __webpack_require__(380),
	    isArrayLike = __webpack_require__(23);
	
	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	}
	
	module.exports = keysIn;


/***/ },
/* 45 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _without2 = __webpack_require__(97);
	
	var _without3 = _interopRequireDefault(_without2);
	
	var _includes2 = __webpack_require__(94);
	
	var _includes3 = _interopRequireDefault(_includes2);
	
	var _values2 = __webpack_require__(139);
	
	var _values3 = _interopRequireDefault(_values2);
	
	var _sortBy2 = __webpack_require__(58);
	
	var _sortBy3 = _interopRequireDefault(_sortBy2);
	
	var _range2 = __webpack_require__(96);
	
	var _range3 = _interopRequireDefault(_range2);
	
	var _uniq2 = __webpack_require__(137);
	
	var _uniq3 = _interopRequireDefault(_uniq2);
	
	var _invert2 = __webpack_require__(489);
	
	var _invert3 = _interopRequireDefault(_invert2);
	
	var _isFunction2 = __webpack_require__(7);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _identity2 = __webpack_require__(22);
	
	var _identity3 = _interopRequireDefault(_identity2);
	
	var _victoryCore = __webpack_require__(3);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	exports.default = {
	  /**
	   * Returns the axis (x or y) of a particular axis component
	   * @param {Object} props: the props object.
	   * @returns {String} the dimension appropriate for the axis given its props
	   */
	  getAxis: function (props) {
	    if (props.orientation) {
	      var vertical = { top: "x", bottom: "x", left: "y", right: "y" };
	      return vertical[props.orientation];
	    }
	    return props.dependentAxis ? "y" : "x";
	  },
	
	
	  /**
	   * Returns the given axis or the opposite axis when horizontal
	   * @param {string} axis: the given axis, either "x" pr "y"
	   * @param {Boolean} horizontal: true when the chart is flipped to the horizontal orientation
	   * @returns {String} the dimension appropriate for the axis given its props "x" or "y"
	   */
	  getCurrentAxis: function (axis, horizontal) {
	    var otherAxis = axis === "x" ? "y" : "x";
	    return horizontal ? otherAxis : axis;
	  },
	
	
	  /**
	   * Returns a single axis component of the desired axis type (x or y)
	   * @param {Array} childComponents: an array of children
	   * @param {String} axis: desired axis either "x" or "y".
	   * @returns {ReactComponent} an axis component of the desired axis or undefined
	   */
	  getAxisComponent: function (childComponents, axis) {
	    var matchesAxis = function (component) {
	      var type = component.type.getAxis(component.props);
	      return type === axis;
	    };
	    return this.findAxisComponents(childComponents, matchesAxis)[0];
	  },
	
	
	  /**
	   * Returns all axis components that pass a given predicate
	   * @param {Array} childComponents: an array of children
	   * @param {Function} predicate: a predicate function that will be called with each
	   * @returns {Array} all axis components that pass the given predicate or []
	   */
	  findAxisComponents: function (childComponents, predicate) {
	    predicate = predicate || _identity3.default;
	    var findAxes = function (children) {
	      return children.reduce(function (memo, child) {
	        if (child.type && child.type.role === "axis" && predicate(child)) {
	          return memo.concat(child);
	        } else if (child.props && child.props.children) {
	          return memo.concat(findAxes(_react2.default.Children.toArray(child.props.children)));
	        }
	        return memo;
	      }, []);
	    };
	
	    return findAxes(childComponents);
	  },
	
	
	  /**
	   * Returns all axis components of the desired axis type (x or y) along with any
	   * parent components excluding VictoryChart
	   * @param {Array} childComponents: an optional array of children.
	   * @param {String} type: desired axis either "dependent" or "independent".
	   * @returns {ReactComponent} an axis component of the desired type or undefined
	   */
	  getAxisComponentsWithParent: function (childComponents, type) {
	    var matchesType = function (child) {
	      return type === "dependent" ? child.props.dependentAxis : !child.props.dependentAxis;
	    };
	
	    var findAxisComponents = function (children) {
	      return children.reduce(function (memo, child) {
	        if (child.type && child.type.role === "axis" && matchesType(child)) {
	          return memo.concat(child);
	        } else if (child.props && child.props.children) {
	          var childAxis = findAxisComponents(_react2.default.Children.toArray(child.props.children));
	          return childAxis.length > 0 ? memo.concat(child) : memo;
	        }
	        return memo;
	      }, []);
	    };
	
	    return findAxisComponents(childComponents);
	  },
	  getOrigin: function (domain) {
	    var getSingleOrigin = function (d) {
	      var domainMin = Math.min.apply(Math, _toConsumableArray(d));
	      var domainMax = Math.max.apply(Math, _toConsumableArray(d));
	      return domainMax < 0 ? domainMax : Math.max(0, domainMin);
	    };
	
	    return {
	      x: _victoryCore.Collection.containsDates(domain.x) ? new Date(Math.min.apply(Math, _toConsumableArray(domain.x))) : getSingleOrigin(domain.x),
	      y: _victoryCore.Collection.containsDates(domain.y) ? new Date(Math.min.apply(Math, _toConsumableArray(domain.y))) : getSingleOrigin(domain.y)
	    };
	  },
	  getOriginSign: function (origin, domain) {
	    var getSign = function () {
	      return origin <= 0 && Math.max.apply(Math, _toConsumableArray(domain)) <= 0 ? "negative" : "positive";
	    };
	    return _victoryCore.Collection.containsDates(domain) ? "positive" : getSign();
	  },
	
	
	  /**
	   * @param {ReactComponent} component: a victory axis component.
	   * @param {String} axis: desired axis either "x" or "y".
	   * @param {String} originSign: "positive" or "negative"
	   * @returns {String} the orientation of the axis ("top", "bottom", "left", or "right")
	   */
	  getOrientation: function (component, axis, originSign) {
	    if (component && component.props && component.props.orientation) {
	      return component.props.orientation;
	    }
	    var sign = originSign || "positive";
	    var typicalOrientations = {
	      positive: { x: "bottom", y: "left" },
	      negative: { x: "top", y: "right" }
	    };
	    var flippedOrientations = {
	      positive: { x: "left", y: "bottom" },
	      negative: { x: "right", y: "top" }
	    };
	    if (!component) {
	      return typicalOrientations[sign][axis];
	    }
	    var dependent = component.props.dependentAxis;
	    return !dependent && axis === "y" || dependent && axis === "x" ? flippedOrientations[sign][axis] : typicalOrientations[sign][axis];
	  },
	
	
	  /**
	   * @param {Object} props: axis component props
	   * @returns {Boolean} true when the axis is vertical
	   */
	  isVertical: function (props) {
	    var orientation = props.orientation || (props.dependentAxis ? "left" : "bottom");
	    var vertical = { top: false, bottom: false, left: true, right: true };
	    return vertical[orientation];
	  },
	
	
	  /**
	   * @param {Object} props: axis component props
	   * @returns {Boolean} true when tickValues contain strings
	   */
	  stringTicks: function (props) {
	    return props.tickValues !== undefined && _victoryCore.Collection.containsStrings(props.tickValues);
	  },
	  getDefaultTickFormat: function (props) {
	    var tickValues = props.tickValues,
	        stringMap = props.stringMap;
	
	    var fallbackFormat = tickValues && !_victoryCore.Collection.containsDates(tickValues) ? function (x) {
	      return x;
	    } : undefined;
	    if (!stringMap) {
	      return this.stringTicks(props) ? function (x, index) {
	        return tickValues[index];
	      } : fallbackFormat;
	    } else {
	      var invertedStringMap = stringMap && (0, _invert3.default)(stringMap);
	      var tickValueArray = (0, _sortBy3.default)((0, _values3.default)(stringMap), function (n) {
	        return n;
	      });
	      var dataNames = tickValueArray.map(function (tick) {
	        return invertedStringMap[tick];
	      });
	      // string ticks should have one tick of padding at the beginning
	      var dataTicks = [""].concat(_toConsumableArray(dataNames), [""]);
	      return function (x) {
	        return dataTicks[x];
	      };
	    }
	  },
	  getTickFormat: function (props, scale) {
	    var tickFormat = props.tickFormat,
	        stringMap = props.stringMap;
	
	    if (!tickFormat) {
	      var defaultTickFormat = this.getDefaultTickFormat(props);
	      var scaleTickFormat = scale.tickFormat && (0, _isFunction3.default)(scale.tickFormat) ? scale.tickFormat() : function (x) {
	        return x;
	      };
	      return defaultTickFormat || scaleTickFormat;
	    } else if (tickFormat && Array.isArray(tickFormat)) {
	      return function (x, index) {
	        return tickFormat[index];
	      };
	    } else if (tickFormat && (0, _isFunction3.default)(tickFormat)) {
	      var applyStringTicks = function (tick, index, ticks) {
	        var invertedStringMap = (0, _invert3.default)(stringMap);
	        var stringTickArray = ticks.map(function (t) {
	          return invertedStringMap[t];
	        });
	        return props.tickFormat(invertedStringMap[tick], index, stringTickArray);
	      };
	      return stringMap ? applyStringTicks : tickFormat;
	    } else {
	      return function (x) {
	        return x;
	      };
	    }
	  },
	  getStringTicks: function (props) {
	    var stringMap = props.stringMap,
	        categories = props.categories;
	
	    var ticksFromCategories = categories && _victoryCore.Collection.containsOnlyStrings(categories) ? categories.map(function (tick) {
	      return stringMap[tick];
	    }) : undefined;
	    var ticksFromStringMap = stringMap && (0, _values3.default)(stringMap);
	    return ticksFromCategories && ticksFromCategories.length !== 0 ? ticksFromCategories : ticksFromStringMap;
	  },
	  getTickArray: function (props) {
	    var _this = this;
	
	    var tickValues = props.tickValues,
	        tickFormat = props.tickFormat,
	        stringMap = props.stringMap;
	
	    var getTicksFromFormat = function () {
	      if (!tickFormat || !Array.isArray(tickFormat)) {
	        return undefined;
	      }
	      return _victoryCore.Collection.containsStrings(tickFormat) ? tickFormat.map(function (t, i) {
	        return i;
	      }) : tickFormat;
	    };
	
	    var ticks = tickValues;
	    if (stringMap) {
	      ticks = this.getStringTicks(props);
	    }
	    if (tickValues && _victoryCore.Collection.containsStrings(tickValues)) {
	      ticks = stringMap ? tickValues.map(function (tick) {
	        return stringMap[tick];
	      }) : (0, _range3.default)(1, tickValues.length + 1);
	    }
	    var tickArray = ticks ? (0, _uniq3.default)(ticks) : getTicksFromFormat(props);
	    var filterArray = function (arr) {
	      var axis = _this.getAxis(props);
	      var domain = props.domain && props.domain[axis] || props.domain;
	      return Array.isArray(domain) ? arr.filter(function (t) {
	        return t >= Math.min.apply(Math, _toConsumableArray(domain)) && t <= Math.max.apply(Math, _toConsumableArray(domain));
	      }) : arr;
	    };
	    return Array.isArray(tickArray) && tickArray.length ? filterArray(tickArray) : undefined;
	  },
	  downsampleTicks: function (ticks, tickCount) {
	    if (!tickCount || !Array.isArray(ticks) || ticks.length <= tickCount) {
	      return ticks;
	    }
	    var k = Math.floor(ticks.length / tickCount);
	    return ticks.filter(function (d, i) {
	      return i % k === 0;
	    });
	  },
	  getTicks: function (props, scale, filterZero) {
	    var tickCount = props.tickCount;
	
	    var tickValues = this.getTickArray(props);
	    if (tickValues) {
	      return this.downsampleTicks(tickValues, tickCount);
	    } else if (scale.ticks && (0, _isFunction3.default)(scale.ticks)) {
	      // eslint-disable-next-line no-magic-numbers
	      var defaultTickCount = tickCount || 5;
	      var scaleTicks = scale.ticks(defaultTickCount);
	      var tickArray = Array.isArray(scaleTicks) && scaleTicks.length ? scaleTicks : scale.domain();
	      var ticks = this.downsampleTicks(tickArray, tickCount);
	      if (filterZero) {
	        var filteredTicks = (0, _includes3.default)(ticks, 0) ? (0, _without3.default)(ticks, 0) : ticks;
	        return filteredTicks.length ? filteredTicks : ticks;
	      }
	      return ticks;
	    }
	    return scale.domain();
	  }
	};

/***/ },
/* 46 */
/***/ function(module, exports) {

	"use strict";
	
	var _send_transaction, _send_transaction2;
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var data = [{
	  lang: "en",
	  page: {
	    login: {
	      loginbutton: "Sign In",
	      resetpassword: "Forgot password?",
	      empty: "Your username or password cannot be none",
	      enterUsername: "Enter username",
	      enterPassword: "Enter password",
	      enterOtp: "Enter OTP token",
	      otpLabel: "If you do not have an OTP, leave it blank"
	    },
	    leftsidebar: {
	      dashboard: "Dashboard",
	      account: "Account",
	      security: "Security",
	      history: "History",
	      information: "Information",
	      tokenpage: "Tokenpage"
	    },
	    topbar: {
	      signout: "Sign Out"
	    },
	    account: {
	      email: "Email",
	      username: "Username",
	      datejoined: "Join Date",
	      lastlogin: "Latest Sign-in",
	      koreaTimezone: "Korean Time Zone",
	      status: "Status",
	      level: "Level",
	      unableWithdraw: "Unable withdraw and send ETH",
	      limitedWithdraw: "Able to send ETH, but unable to withdraw",
	      higherWithdrawLimit: "Able to withdraw",
	      highestWithdrawLimit: "Able to withdraw with highest limit",
	      changepassword: "Change password",
	      newpassword: "New password*",
	      confirmpassword: "Confirm password*",
	      pwNoMatch: "Password does not match",
	      pwLessThan8: "Your password has to be longer than 8 characters",
	      pwReset: "Your password has been updated!",
	      UnKnownResult: "Unknown result",
	      failed: "Failed"
	    },
	    history: {
	      history: "history",
	      noHistory: "You do not have withdraw history yet",
	      hereHistory: "Please refresh the page to see the most updated version your status",
	      date: "Date",
	      status: "Status",
	      token: "Token",
	      amount: "Amount",
	      address: "TransactionHash"
	    },
	    notification: {
	      whatisDao: "Q.What is Dao?",
	      explainDao: "A. DAO is a utility token. Having DAO token in this wallet can obtain the airdropped token in the future. The more DAO you have, the more airdropped token you will get.",
	      ethforWithdraw: "Q. Do I need ethereum to withdraw?",
	      explainGas: "A. Ethereum in this wallet can be deposit and withdraw freely without limit. Having small amount of ether in this wallet can give you the benefits of being able to immediate withdraw other airdropped token",
	      airdropWithdraw: "Q. Can I deposit or withdraw airdropped token?",
	      deductDao: "A. Airdrop tokens such as Cobinhood, Cybermiles and WandX are withdraw only and can not be deposit. However once you withdraw any of the airdropped token, your DAO token will be deducted based on the deduction rate (deduction rate can change over time). Less DAO means less airdropped tokens in the future.",
	      tokenName: "Token name",
	      deductionRate: "Current Dao token deduction rate",
	      noticeManualApproval: "Note: If you have enough Ethereum balance in your account that provide gas fee (0.005 ETH is enough), you can withdraw",
	      aidaopolicy: "AiDAO Sending Policy",
	      aidaosendinginfo: "AiDAO can be sent out freely without any limits. Moreover, sending AiDAO will decrease all of your airdrop token proportionally. For example, if you send out 1% of your AiDAO token. All of your airdrop token will be reduced by 1%."
	    },
	    dashboard_main_content: {
	      welcometoDao: "Welcome to Dao Wallet - Dao wallet team",
	      notification: "Important Notification: Xinfin (XDCe) has switched to its own blockchain and is abandoning their Ethereum ERC20 equivalence at March 31, 2021. Therefore, we are no longer support XDCe. XDCe page has been taken down. We will reimburse the XDCe with an airdrop of SingularityNet tokens (AGI) worth equivalent with your previous XDCe balance."
	    },
	    signup: {
	      signup: "Sign up",
	      username: "Username",
	      password: "Password",
	      enterUsername: "Enter username",
	      enterPassword: "Enter password",
	      signin: "Sign in",
	      haveAccountAlready: "I already have an account"
	    },
	    setup: {
	      reset: "Setup Your New Username and Password",
	      enterNewUsername: "Enter New Username",
	      enterNewPassword: "Enter New Password",
	      ConfirmNewPassword: "Confirm New Password",
	      pwLessThan8: "Must be at least 8 or more characters in Length",
	      save: "Save",
	      signOut: "Sign out"
	    },
	    resetpassword: {
	      sendRecoveryLink: "Send Recovery Link",
	      enterEmail: "Enter email address",
	      send: "send",
	      backtoSignin: "Back to Sign in"
	    },
	    daolevel: {
	      level: "level"
	    },
	    email_verification: {
	      sendEmail: "Send Email",
	      send: "Send",
	      activate: "Activate",
	      emailVerification: "Email Verification",
	      verifyEmail: "Verify Email",
	      sendVerificationEmail: "Send verification Email",
	      confirmEmail: "Confirm your Email",
	      enterEmail: "Enter your Email",
	      failed: "Failed"
	    },
	    otp: {
	      enabled: "Enabled",
	      failed: "Failed",
	      twoFaVerification: "Two-Factor Authentication",
	      noticeTwoFa: "Using Two-factor authentication is highly recommended. Please consider our available options for increasing the security of your account. We want to give you every opportunity to be confident that your account is secure.",
	      verifyGoogle2FA: "Verigy google 2FA",
	      googleVerification: "Google Verification",
	      firstStep: "Step 1 of 2",
	      secondStep: "Step 2 of 2",
	      scanQRcode: "Scan QR code with Google Authenticator",
	      qrcode: "QR code",
	      enterCode: "Enter the code from Google Authenticator",
	      confirm: "Confirm"
	    },
	    pending: {
	      transactionPending: "Pending transaction",
	      numberofPending: "The number of pending transaction"
	    },
	    popup: {
	      confirm: "Confirm"
	    },
	    send_transaction: (_send_transaction = {
	      withdraw: "Withdraw",
	      deductDao: "Dao token will be deducted",
	      fee: "Withdrwal Fee: ",
	      sendToken: "Token will be sent",
	      submitting: "Submitting",
	      success: "Success",
	      transacionHash: "Transaction Hash: ",
	      failed: "Failed",
	      sending: "Sending",
	      gasprice: "gasprice",
	      send: "Send",
	      sentSuccessfully: "TransacionHash",
	      gasUsed: "Used gas : ",
	      checkPending: "Check if there is any transaction pending",
	      daoToken: "Dao Token",
	      to: "To"
	    }, _defineProperty(_send_transaction, "send", "Send"), _defineProperty(_send_transaction, "notice", "Notice"), _defineProperty(_send_transaction, "withdrawDeductsDao", "DAO token will be deducted if you withdraw this token"), _defineProperty(_send_transaction, "address", "Address"), _defineProperty(_send_transaction, "amount", "Amount"), _defineProperty(_send_transaction, "gwei", "Please check current gas price from the link (https://ethgasstation.info/) and type the right amount of Gwei. We recommend to type slightly higher Gwei than the current price for a faster transaction."), _defineProperty(_send_transaction, "otpcode", "OTP code"), _defineProperty(_send_transaction, "close", "Close"), _defineProperty(_send_transaction, "send", "Send"), _defineProperty(_send_transaction, "kycRequired", "KYC is required"), _defineProperty(_send_transaction, "daoWalletTeam", "- Dao Wallet Team"), _defineProperty(_send_transaction, "kycRequiredforTransaction", "KYC approval is required to send token"), _defineProperty(_send_transaction, "aidaosendingwarning", "Withdraw AiDAO will reduce all of your airdrop tokens by the proportion that your AiDAO withdrawal. Detail see information page."), _defineProperty(_send_transaction, "deductToken", "All airdrop tokens will be deducted. Are you sure?"), _send_transaction),
	    wallet_address: {
	      addressCopied: "Address is copied to clipboard",
	      walletAddress: "Wallet Address",
	      copy: "Copy"
	    },
	    withdraw: {
	      withdraw: "Withdraw",
	      daoTokenisUtilityToken: "Dao token is utility token for dao token holders",
	      withdrawDeductsDao: "Dao token will be deducted if you withdraw this token",
	      learnMore: "Learn more"
	    },
	    aidao: {
	      balance: "balance",
	      back: "Back to token page"
	    },
	    cobinhood: {
	      balance: "balance",
	      back: "Back to token page"
	    },
	    cybermiles: {
	      balance: "balance",
	      back: "Back to token page"
	    },
	    ethereum: {
	      balance: "balance",
	      back: "Back to token page"
	    },
	    dash: {
	      balance: "balance",
	      back: "Back to token page"
	    },
	    golem: {
	      balance: "balance",
	      back: "Back to token page"
	    },
	    wandx: {
	      balance: "balance",
	      back: "Back to token page"
	    },
	    xdce: {
	      balance: "balance",
	      back: "Back to token page"
	    },
	    xyo: {
	      balance: "balance",
	      back: "Back to token page"
	    },
	    swapcenter: {
	      address: "Address",
	      amount: "Amount",
	      otpcode: "OTP code"
	    },
	    tokenpage: {}
	  }
	}, {
	  lang: "kr",
	  page: {
	    login: {
	      loginbutton: "로그인",
	      resetpassword: "비밀번호를 잊으셨나요?",
	      empty: "아이디나 비밀번호가 누락되었습니다",
	      enterUsername: "아이디를 입력하세요",
	      enterPassword: "비밀번호를 입력하세요",
	      enterOtp: "OTP",
	      otpLabel: "OTP가 없으면 빈칸으로 남겨놓으세요"
	    },
	    leftsidebar: {
	      dashboard: "대시보드",
	      account: "내 계정",
	      security: "보안센터",
	      history: "거래내역",
	      information: "정보",
	      tokenpage: "토큰 페이지"
	    },
	    topbar: {
	      signout: "로그아웃"
	    },
	    account: {
	      email: "이메일",
	      username: "아이디",
	      datejoined: "가입한 시간",
	      lastlogin: "최근 로그인한 시간",
	      koreaTimezone: "한국 표준시간대 기준",
	      status: "상태",
	      level: "레벨",
	      unableWithdraw: "ETH의 출금이나 전송 불가능",
	      limitedWithdraw: "ETH 전송 가능, 출금 불가능",
	      higherWithdrawLimit: "출금 가능",
	      highestWithdrawLimit: "최대 한도까지 출금 가능",
	      changepassword: "비밀번호 변경",
	      newpassword: "새 비밀번호",
	      confirmpassword: "새 비밀번호 확인",
	      pwNoMatch: "비밀번호가 일치하지 않습니다",
	      pwLessThan8: "비밀번호는 8자리 이상이어야합니다",
	      pwReset: "비밀번호가 재설정되었습니다",
	      UnKnownResult: "알 수 없는 결과입니다",
	      failed: "실패하였습니다"
	    },
	    history: {
	      history: "입출금내역",
	      noHistory: "아직 입출금한 내역이 없습니다",
	      hereHistory: "상태를 업데이트하려면 페이지를 새로고침하세요",
	      date: "시간",
	      status: "상태",
	      token: "토큰",
	      amount: "금액",
	      address: "트랜잭션 해시"
	    },
	    notification: {
	      whatisDao: "Q.다오가 무엇인가요?",
	      explainDao: "A. 다오는 유틸리티 토큰입니다. 다오 토큰을 가지고 있음으로서 에어드랍을 받을 수 있습니다. 에어드랍되는 토큰의 갯수는 다오토큰의 갯수에 비례합니다.",
	      ethforWithdraw: "Q. 출금하려면 이더리움이 필요한가요?",
	      explainGas: "A. 다오지갑 내에서 이더리움은 제한없이 입출금이 가능합니다. 지갑에 이더리움을 소량 입금하시면 이더리움을 사용하여 에어드랍받은 토큰을 바로 인출하실 수 있습니다.",
	      airdropWithdraw: "Q. 에어드랍된 토큰의 입출금이 가능한가요?",
	      deductDao: "A. 코빈후드, 사이버마일스, 완드엑스와 같은 에어드랍된 토큰들은 입금은 불가능합니다. 에어드랍된 토큰을 인출하는 경우에는 다오토큰이 거래수수료로서 사용되어 차감됩니다. (차감 비율은 시간에 따라 다를 수 있습니다). 다오 갯수가 적으면 추후에 에어드랍되는 토큰의 갯수도 적어집니다.",
	      tokenName: "토큰",
	      deductionRate: "현재 다오토큰 차감율",
	      noticeManualApproval: "가스(0.005 ETH 면 충분합니다)를 제공해줄 수 있는 이더리움 잔고가 있으면 출금하실 수 있습니다.",
	      aidaopolicy: "AiDAO 출금 정책",
	      aidaosendinginfo: "AiDAO를 제한없이 출금할 수 있습니다. AiDAO를 인출하게 되면 에어드랍 받은 토큰도 이에 비례하여 줄어듭니다. 예를 들어서 1%의 AiDAO토큰을 인출하면 그만큼 에어드랍된 토큰이 1% 줄어듭니다"
	    },
	    dashboard_main_content: {
	      welcometoDao: "다오지갑에 오신 것을 환영합니다 - 다오지갑 팀",
	      notification: "중요 알림 : Xinfin (XDCe)은 자체 블록 체인으로 전환했으며 2021 년 3 월 31 일에 Ethereum ERC20 토큰인 XDCe를 삭제합니다. 즉, 더 이상 XDCe를 지원하지 않습니다. 하여 AiDAO 내의 XDCe 페이지가 삭제되었습니다. 따라서 이전 XDCe 잔액을 SingularityNet 토큰 (AGI)으로 교환, 보유하신 XDCe와 AGI의 시세에 따른 비율로 에어드랍하여 XDCe를 환급할 것입니다."
	    },
	    signup: {
	      signup: "신규 가입",
	      username: "아이디",
	      password: "비밀번호",
	      enterUsername: "아이디를 입력하세요",
	      enterPassword: "비밀번호를 입력하세요",
	      signin: "로그인",
	      haveAccountAlready: "이미 계정이 있습니다"
	    },
	    setup: {
	      reset: "아이디와 비밀번호 새로 설정",
	      enterNewUsername: "새 아이디를 입력하세요",
	      enterNewPassword: "새 비밀번호를 입력하세요",
	      ConfirmNewPassword: "새 비밀번호를 한 번 더 입력하세요",
	      pwLessThan8: "비밀번호는 8자리 이상이어야합니다",
	      save: "저장",
	      signOut: "로그아웃"
	    },
	    resetpassword: {
	      sendRecoveryLink: "복구 이메일 보내기",
	      enterEmail: "이메일 주소를 입력하세요",
	      send: "보내기",
	      backtoSignin: "로그인으로 돌아가기"
	    },
	    daolevel: {
	      level: "레벨"
	    },
	    email_verification: {
	      sendEmail: "이메일 보내기",
	      send: "보내기",
	      activate: "활성화",
	      emailVerification: "이메일 인증",
	      verifyEmail: "이메일 인증하기",
	      sendVerificationEmail: "인증 이메일 보내기",
	      confirmEmail: "이메일을 확인하세요",
	      enterEmail: "이메일을 입력하세요",
	      failed: "실패하였습니다"
	    },
	    otp: {
	      enabled: "활성화되었습니다",
	      failed: "실패하였습니다",
	      twoFaVerification: "2FA 인증",
	      noticeTwoFa: "2FA 인증을 활성화 하면 보다 안전하게 다오월렛을 사용하실 수 있습니다.계정의 보안을 강화하기 위해서 가능한 옵션들을 고려하시길 바랍니다. 계정을 안전하게 사용하실 수 있도록 다오월렛 팀은 최선을 다하겠습니다.",
	      verifyGoogle2FA: "구글 2FA 인증하기",
	      googleVerification: "구글 인증",
	      firstStep: "1/2 단계",
	      secondStep: "2/2 단계",
	      scanQRcode: "구글 인증을 이용해서 QR코드를 스캔하세요",
	      qrcode: "QR 코드",
	      enterCode: "구글 인증 앱에 보이는 숫자 여섯자리를 입력하세요",
	      confirm: "확인"
	    },
	    pending: {
	      transactionPending: "보류 중인 거래 내역",
	      numberofPending: "보류 중인 거래 내역의 갯수"
	    },
	    popup: {
	      confirm: "확인"
	    },
	    send_transaction: (_send_transaction2 = {
	      withdraw: "출금",
	      deductDao: "다오 갯수가 차감됩니다",
	      fee: "인출 수수료: ",
	      sendToken: "토큰 전송이 실행됩니다",
	      submitting: "전송중",
	      success: "성공",
	      transacionHash: "전송 해시 :",
	      failed: "실패하였습니다",
	      sending: "전송중",
	      gasprice: "가스 가격",
	      send: "보내기",
	      sentSuccessfully: "성공적으로 전송하였습니다",
	      gasUsed: "사용된 가스 : ",
	      checkPending: "보류 중인 거래가 있는지 확인하세요",
	      daotoken: "Dao 토큰",
	      to: "받는 주소"
	    }, _defineProperty(_send_transaction2, "send", "보내기"), _defineProperty(_send_transaction2, "notice", "주의"), _defineProperty(_send_transaction2, "withdrawDeductsDao", "이 토큰을 출금하면 다오 토큰이 차감됩니다"), _defineProperty(_send_transaction2, "address", "주소"), _defineProperty(_send_transaction2, "amount", "금액"), _defineProperty(_send_transaction2, "gwei", "해당 링크(https://ethgasstation.info/)에서 현재 시세를 확인하고 가스 비용을 입력하세요. 빠른 전송을 위해서 현재 시세보다 조금 높은 Gwei 값을 입력할 것을 추천합니다"), _defineProperty(_send_transaction2, "otpcode", "OTP 코드"), _defineProperty(_send_transaction2, "close", "닫기"), _defineProperty(_send_transaction2, "send", "전송"), _defineProperty(_send_transaction2, "kycRequired", "KYC가 필요합니다"), _defineProperty(_send_transaction2, "daoWalletTeam", "- Dao 지갑"), _defineProperty(_send_transaction2, "kycRequiredforTransaction", "토큰을 전송하기 위해서는 KYC 승인이 필요합니다"), _defineProperty(_send_transaction2, "aidaosendingwarning", "AiDAO 출금시 이에 비례하여 모든 에어드랍된 토큰도 함께 줄어듭니다. 자세한 정보는 정보 페이지를 참고하시길 바랍니다"), _defineProperty(_send_transaction2, "deductToken", "모든 에어 드롭 토큰이 공제됩니다. 확실합니까?"), _send_transaction2),
	    wallet_address: {
	      addressCopied: "주소가 클립보드에 복사되었습니다",
	      walletAddress: "지갑 주소",
	      copy: "복사"
	    },
	    withdraw: {
	      withdraw: "출금",
	      daoTokenisUtilityToken: "토큰은 다오토큰 유저를 위한 유틸리티 토큰입니다.",
	      withdrawDeductsDao: "이 토큰을 출금하면 다오 토큰이 차감됩니다",
	      learnMore: "더 알아보기"
	    },
	    aidao: {
	      balance: "잔액",
	      back: "돌아가기"
	    },
	    cobinhood: {
	      balance: "잔액",
	      back: "돌아가가"
	    },
	    cybermiles: {
	      balance: "잔액",
	      back: "돌아가기"
	    },
	    ethereum: {
	      balance: "잔액",
	      back: "돌아가기"
	    },
	    dash: {
	      balance: "잔액",
	      back: "돌아가기"
	    },
	    golem: {
	      balance: "잔액",
	      back: "돌아가기"
	    },
	    wandx: {
	      balance: "잔액",
	      back: "돌아가기"
	    },
	    xdce: {
	      balance: "잔액",
	      back: "돌아가기"
	    },
	    xyo: {
	      balance: "잔액",
	      back: "돌아가기"
	    },
	    swapcenter: {
	      address: "주소",
	      amount: "금액",
	      otpcode: "OTP코드"
	    },
	    tokenpage: {}
	  }
	}];
	
	module.exports = data;

/***/ },
/* 47 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/Aidao.07b7877a.svg";

/***/ },
/* 48 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/Ethereum.f4fdd7ea.svg";

/***/ },
/* 49 */
/***/ function(module, exports) {

	/**
	 * A faster alternative to `Function#apply`, this function invokes `func`
	 * with the `this` binding of `thisArg` and the arguments of `args`.
	 *
	 * @private
	 * @param {Function} func The function to invoke.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} args The arguments to invoke `func` with.
	 * @returns {*} Returns the result of `func`.
	 */
	function apply(func, thisArg, args) {
	  switch (args.length) {
	    case 0: return func.call(thisArg);
	    case 1: return func.call(thisArg, args[0]);
	    case 2: return func.call(thisArg, args[0], args[1]);
	    case 3: return func.call(thisArg, args[0], args[1], args[2]);
	  }
	  return func.apply(thisArg, args);
	}
	
	module.exports = apply;


/***/ },
/* 50 */
/***/ function(module, exports, __webpack_require__) {

	var baseRest = __webpack_require__(33),
	    isIterateeCall = __webpack_require__(90);
	
	/**
	 * Creates a function like `_.assign`.
	 *
	 * @private
	 * @param {Function} assigner The function to assign values.
	 * @returns {Function} Returns the new assigner function.
	 */
	function createAssigner(assigner) {
	  return baseRest(function(object, sources) {
	    var index = -1,
	        length = sources.length,
	        customizer = length > 1 ? sources[length - 1] : undefined,
	        guard = length > 2 ? sources[2] : undefined;
	
	    customizer = (assigner.length > 3 && typeof customizer == 'function')
	      ? (length--, customizer)
	      : undefined;
	
	    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	      customizer = length < 3 ? undefined : customizer;
	      length = 1;
	    }
	    object = Object(object);
	    while (++index < length) {
	      var source = sources[index];
	      if (source) {
	        assigner(object, source, index, customizer);
	      }
	    }
	    return object;
	  });
	}
	
	module.exports = createAssigner;


/***/ },
/* 51 */
/***/ function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return !!length &&
	    (typeof value == 'number' || reIsUint.test(value)) &&
	    (value > -1 && value % 1 == 0 && value < length);
	}
	
	module.exports = isIndex;


/***/ },
/* 52 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	module.exports = isPrototype;


/***/ },
/* 53 */
/***/ function(module, exports) {

	/** Used as the internal argument placeholder. */
	var PLACEHOLDER = '__lodash_placeholder__';
	
	/**
	 * Replaces all `placeholder` elements in `array` with an internal placeholder
	 * and returns an array of their indexes.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {*} placeholder The placeholder to replace.
	 * @returns {Array} Returns the new array of placeholder indexes.
	 */
	function replaceHolders(array, placeholder) {
	  var index = -1,
	      length = array.length,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (value === placeholder || value === PLACEHOLDER) {
	      array[index] = PLACEHOLDER;
	      result[resIndex++] = index;
	    }
	  }
	  return result;
	}
	
	module.exports = replaceHolders;


/***/ },
/* 54 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsArguments = __webpack_require__(374),
	    isObjectLike = __webpack_require__(24);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	    !propertyIsEnumerable.call(value, 'callee');
	};
	
	module.exports = isArguments;


/***/ },
/* 55 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(15),
	    stubFalse = __webpack_require__(499);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;
	
	module.exports = isBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(99)(module)))

/***/ },
/* 56 */
/***/ function(module, exports, __webpack_require__) {

	var isNumber = __webpack_require__(221);
	
	/**
	 * Checks if `value` is `NaN`.
	 *
	 * **Note:** This method is based on
	 * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
	 * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
	 * `undefined` and other non-number values.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	 * @example
	 *
	 * _.isNaN(NaN);
	 * // => true
	 *
	 * _.isNaN(new Number(NaN));
	 * // => true
	 *
	 * isNaN(undefined);
	 * // => true
	 *
	 * _.isNaN(undefined);
	 * // => false
	 */
	function isNaN(value) {
	  // An `NaN` primitive is the only value that is not equal to itself.
	  // Perform the `toStringTag` check first to avoid errors with some
	  // ActiveX objects in IE.
	  return isNumber(value) && value != +value;
	}
	
	module.exports = isNaN;


/***/ },
/* 57 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(30),
	    isObjectLike = __webpack_require__(24);
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && baseGetTag(value) == symbolTag);
	}
	
	module.exports = isSymbol;


/***/ },
/* 58 */
/***/ function(module, exports, __webpack_require__) {

	var baseFlatten = __webpack_require__(184),
	    baseOrderBy = __webpack_require__(385),
	    baseRest = __webpack_require__(33),
	    isIterateeCall = __webpack_require__(90);
	
	/**
	 * Creates an array of elements, sorted in ascending order by the results of
	 * running each element in a collection thru each iteratee. This method
	 * performs a stable sort, that is, it preserves the original sort order of
	 * equal elements. The iteratees are invoked with one argument: (value).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {...(Function|Function[])} [iteratees=[_.identity]]
	 *  The iteratees to sort by.
	 * @returns {Array} Returns the new sorted array.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'fred',   'age': 48 },
	 *   { 'user': 'barney', 'age': 36 },
	 *   { 'user': 'fred',   'age': 40 },
	 *   { 'user': 'barney', 'age': 34 }
	 * ];
	 *
	 * _.sortBy(users, [function(o) { return o.user; }]);
	 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	 *
	 * _.sortBy(users, ['user', 'age']);
	 * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
	 */
	var sortBy = baseRest(function(collection, iteratees) {
	  if (collection == null) {
	    return [];
	  }
	  var length = iteratees.length;
	  if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
	    iteratees = [];
	  } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
	    iteratees = [iteratees[0]];
	  }
	  return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
	});
	
	module.exports = sortBy;


/***/ },
/* 59 */
/***/ function(module, exports, __webpack_require__) {

	var debounce = __webpack_require__(482),
	    isObject = __webpack_require__(10);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a throttled function that only invokes `func` at most once per
	 * every `wait` milliseconds. The throttled function comes with a `cancel`
	 * method to cancel delayed `func` invocations and a `flush` method to
	 * immediately invoke them. Provide `options` to indicate whether `func`
	 * should be invoked on the leading and/or trailing edge of the `wait`
	 * timeout. The `func` is invoked with the last arguments provided to the
	 * throttled function. Subsequent calls to the throttled function return the
	 * result of the last `func` invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the throttled function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.throttle` and `_.debounce`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to throttle.
	 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=true]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new throttled function.
	 * @example
	 *
	 * // Avoid excessively updating the position while scrolling.
	 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	 *
	 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	 * jQuery(element).on('click', throttled);
	 *
	 * // Cancel the trailing throttled invocation.
	 * jQuery(window).on('popstate', throttled.cancel);
	 */
	function throttle(func, wait, options) {
	  var leading = true,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  if (isObject(options)) {
	    leading = 'leading' in options ? !!options.leading : leading;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	  return debounce(func, wait, {
	    'leading': leading,
	    'maxWait': wait,
	    'trailing': trailing
	  });
	}
	
	module.exports = throttle;


/***/ },
/* 60 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.attachId = undefined;
	
	var _uniqueId2 = __webpack_require__(138);
	
	var _uniqueId3 = _interopRequireDefault(_uniqueId2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var attachId = exports.attachId = function (func) {
	  return function () {
	    return {
	      mutations: func.apply(undefined, arguments),
	      id: (0, _uniqueId3.default)("throttledEvent")
	    };
	  };
	};

/***/ },
/* 61 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _some2 = __webpack_require__(497);
	
	var _some3 = _interopRequireDefault(_some2);
	
	var _uniq2 = __webpack_require__(137);
	
	var _uniq3 = _interopRequireDefault(_uniq2);
	
	var _partialRight2 = __webpack_require__(16);
	
	var _partialRight3 = _interopRequireDefault(_partialRight2);
	
	var _isFunction2 = __webpack_require__(7);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _flatten2 = __webpack_require__(93);
	
	var _flatten3 = _interopRequireDefault(_flatten2);
	
	var _defaults2 = __webpack_require__(5);
	
	var _defaults3 = _interopRequireDefault(_defaults2);
	
	var _assign2 = __webpack_require__(4);
	
	var _assign3 = _interopRequireDefault(_assign2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _axis = __webpack_require__(45);
	
	var _axis2 = _interopRequireDefault(_axis);
	
	var _victoryCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	exports.default = {
	  getData: function (props, childComponents) {
	    if (props.data) {
	      return _victoryCore.Data.getData(props);
	    }
	    childComponents = childComponents || _react2.default.Children.toArray(props.children);
	    return this.getDataFromChildren(childComponents);
	  },
	  getDefaultDomainPadding: function (props, axis, childComponents) {
	    var horizontalChildren = childComponents.some(function (component) {
	      return component.props && component.props.horizontal;
	    });
	    var horizontal = props && props.horizontal || horizontalChildren;
	    var groupComponent = childComponents.filter(function (child) {
	      return child.type && child.type.role && child.type.role === "group";
	    });
	
	    if (groupComponent.length < 1) {
	      return undefined;
	    }
	    var _groupComponent$0$pro = groupComponent[0].props,
	        offset = _groupComponent$0$pro.offset,
	        children = _groupComponent$0$pro.children;
	
	    var defaultDomainPadding = horizontal ? { y: offset * children.length / 2 } : { x: offset * children.length / 2 };
	    return defaultDomainPadding[axis];
	  },
	  getDomain: function (props, axis, childComponents) {
	    childComponents = childComponents || _react2.default.Children.toArray(props.children);
	    var propsDomain = _victoryCore.Domain.getDomainFromProps(props, axis);
	    var domainPadding = props.polar ? 0 : this.getDefaultDomainPadding(props, axis, childComponents);
	    var domain = void 0;
	    if (propsDomain) {
	      domain = propsDomain;
	    } else {
	      var dataset = (props.data || props.y) && _victoryCore.Data.getData(props);
	      var dataDomain = dataset ? _victoryCore.Domain.getDomainFromData(props, axis, dataset) : [];
	      var childDomain = this.getDomainFromChildren(props, axis, childComponents);
	      var min = _victoryCore.Collection.getMinValue([].concat(_toConsumableArray(dataDomain), _toConsumableArray(childDomain)));
	      var max = _victoryCore.Collection.getMaxValue([].concat(_toConsumableArray(dataDomain), _toConsumableArray(childDomain)));
	      domain = [min, max];
	    }
	    var paddedDomain = _victoryCore.Domain.padDomain(domain, (0, _assign3.default)({ domainPadding: domainPadding }, props), axis);
	    return _victoryCore.Domain.cleanDomain(paddedDomain, props, axis);
	  },
	  setAnimationState: function (props, nextProps) {
	    if (!props.animate) {
	      return;
	    }
	    if (props.animate.parentState) {
	      var nodesWillExit = props.animate.parentState.nodesWillExit;
	      var oldProps = nodesWillExit ? props : null;
	      this.setState((0, _defaults3.default)({ oldProps: oldProps, nextProps: nextProps }, props.animate.parentState));
	    } else {
	      var oldChildren = _react2.default.Children.toArray(props.children);
	      var nextChildren = _react2.default.Children.toArray(nextProps.children);
	      var isContinuous = function (child) {
	        var check = function (c) {
	          return c.type && c.type.continuous;
	        };
	        return Array.isArray(child) ? (0, _some3.default)(child, check) : check(child);
	      };
	
	      var continuous = !props.polar && (0, _some3.default)(oldChildren, function (child) {
	        return isContinuous(child) || child.props.children && isContinuous(child.props.children);
	      });
	
	      var _Transitions$getIniti = _victoryCore.Transitions.getInitialTransitionState(oldChildren, nextChildren),
	          _nodesWillExit = _Transitions$getIniti.nodesWillExit,
	          nodesWillEnter = _Transitions$getIniti.nodesWillEnter,
	          childrenTransitions = _Transitions$getIniti.childrenTransitions,
	          nodesShouldEnter = _Transitions$getIniti.nodesShouldEnter;
	
	      this.setState({
	        nodesWillExit: _nodesWillExit,
	        nodesWillEnter: nodesWillEnter,
	        nodesShouldEnter: nodesShouldEnter,
	        childrenTransitions: _victoryCore.Collection.isArrayOfArrays(childrenTransitions) ? childrenTransitions[0] : childrenTransitions,
	        oldProps: _nodesWillExit ? props : null,
	        nextProps: nextProps,
	        continuous: continuous
	      });
	    }
	  },
	  getAllEvents: function (props) {
	    var components = ["groupComponent", "containerComponent", "labelComponent"];
	    this.componentEvents = _victoryCore.Events.getComponentEvents(props, components);
	    if (Array.isArray(this.componentEvents)) {
	      var _componentEvents;
	
	      return Array.isArray(props.events) ? (_componentEvents = this.componentEvents).concat.apply(_componentEvents, _toConsumableArray(props.events)) : this.componentEvents;
	    }
	    return props.events;
	  },
	  getAnimationProps: function (props, child, index) {
	    var _this = this;
	
	    if (!props.animate) {
	      return child.props.animate;
	    }
	    var getFilteredState = function () {
	      var childrenTransitions = _this.state && _this.state.childrenTransitions;
	      childrenTransitions = _victoryCore.Collection.isArrayOfArrays(childrenTransitions) ? childrenTransitions[index] : childrenTransitions;
	      return (0, _defaults3.default)({ childrenTransitions: childrenTransitions }, _this.state);
	    };
	
	    var getTransitions = props.animate && props.animate.getTransitions;
	    var state = getFilteredState();
	    var parentState = props.animate && props.animate.parentState || state;
	    if (!getTransitions) {
	      var getTransitionProps = _victoryCore.Transitions.getTransitionPropsFactory(props, state, function (newState) {
	        return _this.setState(newState);
	      });
	      getTransitions = (0, _partialRight3.default)(getTransitionProps, index);
	    }
	    return (0, _defaults3.default)({ getTransitions: getTransitions, parentState: parentState }, props.animate, child.props.animate);
	  },
	  getDomainFromChildren: function (props, axis, childComponents) {
	    // eslint-disable-line max-statements, complexity, max-len
	    var childDomains = [];
	    var childDomainsLength = 0;
	
	    var children = childComponents ? childComponents.slice(0) : _react2.default.Children.toArray(props.children);
	    var childrenLength = children.length;
	
	    var horizontalChildren = childComponents.some(function (component) {
	      return component.props && component.props.horizontal;
	    });
	    var horizontal = props && props.horizontal || horizontalChildren.length > 0;
	    var currentAxis = _axis2.default.getCurrentAxis(axis, horizontal);
	
	    var parentData = props.data ? _victoryCore.Data.getData(props, axis) : undefined;
	    var polar = props.polar,
	        startAngle = props.startAngle,
	        endAngle = props.endAngle;
	
	    var parentProps = parentData ? { data: parentData, polar: polar, startAngle: startAngle, endAngle: endAngle } : { polar: polar, startAngle: startAngle, endAngle: endAngle };
	
	    while (childrenLength > 0) {
	      var child = children[--childrenLength];
	
	      if (child.type && (0, _isFunction3.default)(child.type.getDomain)) {
	        var sharedProps = (0, _assign3.default)({}, child.props, parentProps);
	        var childDomain = child.props && child.type.getDomain(sharedProps, currentAxis);
	        if (childDomain) {
	          var childDomainLength = childDomain.length;
	          for (var index = 0; index < childDomainLength; index++) {
	            childDomains[childDomainsLength++] = childDomain[index];
	          }
	        }
	      } else if (child.props && child.props.children) {
	        var newChildren = _react2.default.Children.toArray(child.props.children);
	        var newChildrenLength = newChildren.length;
	        for (var _index = 0; _index < newChildrenLength; _index++) {
	          children[childrenLength++] = newChildren[_index];
	        }
	      }
	    }
	    var min = _victoryCore.Collection.getMinValue(childDomains);
	    var max = _victoryCore.Collection.getMaxValue(childDomains);
	    return childDomains.length === 0 ? [0, 1] : [min, max];
	  },
	  getDataFromChildren: function (props, childComponents) {
	    // eslint-disable-line max-statements
	    var getData = function (childProps) {
	      var data = _victoryCore.Data.getData(childProps);
	      return Array.isArray(data) && data.length > 0 ? data : undefined;
	    };
	
	    // Reverse the child array to maintain correct order when looping over
	    // children starting from the end of the array.
	    var children = childComponents ? childComponents.slice(0).reverse() : _react2.default.Children.toArray(props.children).reverse();
	
	    var childrenLength = children.length;
	
	    var dataArr = [];
	    var dataArrLength = 0;
	    while (childrenLength > 0) {
	      var child = children[--childrenLength];
	      if (child.type && child.type.role === "axis") {
	        dataArrLength = dataArrLength;
	      } else if (child.type && child.type.role !== "axis" && (0, _isFunction3.default)(child.type.getData)) {
	        dataArr[dataArrLength++] = child.type.getData(child.props);
	      } else if (child.props && child.props.children) {
	        var newChildren = _react2.default.Children.toArray(child.props.children);
	        var newChildrenLength = newChildren.length;
	        for (var index = 0; index < newChildrenLength; index++) {
	          children[childrenLength++] = newChildren[index];
	        }
	      } else {
	        dataArr[dataArrLength++] = getData(child.props);
	      }
	    }
	
	    return dataArr;
	  },
	  getStackedDomain: function (props, axis) {
	    var propsDomain = _victoryCore.Domain.getDomainFromProps(props, axis);
	    if (propsDomain) {
	      return propsDomain;
	    }
	    var horizontal = props.horizontal;
	
	    var ensureZero = function (domain) {
	      var isDependent = axis === "y" && !horizontal || axis === "x" && horizontal;
	      return isDependent ? [_victoryCore.Collection.getMinValue(domain, 0), _victoryCore.Collection.getMaxValue(domain, 0)] : domain;
	    };
	    var datasets = this.getDataFromChildren(props);
	    return ensureZero(_victoryCore.Domain.getDomainFromGroupedData(props, axis, datasets));
	  },
	  getColor: function (calculatedProps, child, index) {
	    // check for styles first
	    var style = calculatedProps.style;
	    var colorScale = calculatedProps.colorScale,
	        color = calculatedProps.color;
	
	    if (style && style.data && style.data.fill) {
	      return style.data.fill;
	    }
	    colorScale = child.props && child.props.colorScale ? child.props.colorScale : colorScale;
	    color = child.props && child.props.color ? child.props.color : color;
	    if (!colorScale && !color) {
	      return undefined;
	    }
	    var colors = Array.isArray(colorScale) ? colorScale : _victoryCore.Style.getColorScale(colorScale);
	    return color || colors[index % colors.length];
	  },
	  getWidth: function (props) {
	    var datasets = props.datasets,
	        scale = props.scale,
	        horizontal = props.horizontal;
	
	    var range = horizontal ? scale.y.range() : scale.x.range();
	    var extent = Math.abs(range[1] - range[0]);
	    var bars = datasets.length * (datasets[0].length || 1) + 2;
	    var barRatio = 0.5;
	    return { width: Math.round(barRatio * extent / bars) };
	  },
	  getChildStyle: function (child, index, calculatedProps) {
	    var style = calculatedProps.style,
	        role = calculatedProps.role;
	
	    var childStyle = child.props.style || {};
	    if (Array.isArray(childStyle)) {
	      return childStyle;
	    }
	    var childRole = child.type && child.type.role;
	    var defaultFill = childRole === "stack" ? undefined : this.getColor(calculatedProps, child, index);
	    var defaultColor = childRole === "line" ? { fill: "none", stroke: defaultFill } : { fill: defaultFill };
	    var dataWidth = role === "stack" ? {} : this.getWidth(calculatedProps);
	    var dataStyle = (0, _defaults3.default)({}, childStyle.data, (0, _assign3.default)({}, dataWidth, style.data, defaultColor));
	    var labelsStyle = (0, _defaults3.default)({}, childStyle.labels, style.labels);
	    return {
	      parent: style.parent,
	      data: dataStyle,
	      labels: labelsStyle
	    };
	  },
	  getStringsFromCategories: function (childComponents, axis) {
	    // eslint-disable-line max-statements
	    var strings = [];
	    var stringsLength = 0;
	
	    var children = childComponents.slice(0).reverse();
	    var childrenLength = children.length;
	
	    while (childrenLength > 0) {
	      var child = children[--childrenLength];
	
	      if (child.props && child.props.categories) {
	        var newStrings = _victoryCore.Data.getStringsFromCategories(child.props, axis);
	        var newStringsLength = newStrings.length;
	        for (var index = 0; index < newStringsLength; index++) {
	          strings[stringsLength++] = newStrings[index];
	        }
	      } else if (child.props && child.props.children) {
	        var newChildren = _react2.default.Children.toArray(child.props.children);
	        var newChildrenLength = newChildren.length;
	        for (var _index2 = 0; _index2 < newChildrenLength; _index2++) {
	          children[childrenLength++] = newChildren[_index2];
	        }
	      }
	    }
	
	    return strings;
	  },
	  getStringsFromData: function (childComponents, axis) {
	    // eslint-disable-line max-statements
	    var strings = [];
	    var stringsLength = 0;
	
	    var children = childComponents.slice(0).reverse();
	    var childrenLength = children.length;
	
	    while (childrenLength > 0) {
	      var child = children[--childrenLength];
	
	      if (child.props && child.props.data) {
	        var newStrings = _victoryCore.Data.getStringsFromData(child.props, axis);
	        var newStringsLength = newStrings.length;
	        for (var index = 0; index < newStringsLength; index++) {
	          strings[stringsLength++] = newStrings[index];
	        }
	      } else if (child.type && (0, _isFunction3.default)(child.type.getData)) {
	        var data = (0, _flatten3.default)(child.type.getData(child.props));
	        var attr = axis === "x" ? "xName" : "yName";
	        for (var _index3 = 0; _index3 < data.length; _index3++) {
	          var datum = data[_index3];
	          if (datum[attr]) {
	            strings[stringsLength++] = datum[attr];
	          }
	        }
	      } else if (child.props && child.props.children) {
	        var newChildren = _react2.default.Children.toArray(child.props.children);
	        var newChildrenLength = newChildren.length;
	        for (var _index4 = 0; _index4 < newChildrenLength; _index4++) {
	          children[childrenLength++] = newChildren[_index4];
	        }
	      }
	    }
	
	    return strings;
	  },
	  getStringsFromChildren: function (props, axis, childComponents) {
	    childComponents = childComponents || _react2.default.Children.toArray(props.children);
	    var axisComponent = _axis2.default.getAxisComponent(childComponents, axis);
	    var axisStrings = axisComponent ? _victoryCore.Data.getStringsFromAxes(axisComponent.props, axis) : [];
	    var categoryStrings = this.getStringsFromCategories(childComponents, axis);
	    var dataStrings = this.getStringsFromData(childComponents, axis);
	    return (0, _uniq3.default)((0, _flatten3.default)([].concat(_toConsumableArray(categoryStrings), _toConsumableArray(dataStrings), _toConsumableArray(axisStrings))));
	  },
	  getCategories: function (props, axis) {
	    var categories = _victoryCore.Data.getCategories(props, axis) || this.getStringsFromChildren(props, axis);
	    return categories.length > 0 ? categories : undefined;
	  },
	  getY0: function (datum, index, calculatedProps) {
	    if (datum.y0) {
	      return datum.y0;
	    }
	    var datasets = calculatedProps.datasets;
	
	    var y = datum._y;
	    var previousDataSets = datasets.slice(0, index);
	    var previousPoints = previousDataSets.reduce(function (prev, dataset) {
	      return prev.concat(dataset.filter(function (previousDatum) {
	        return datum._x instanceof Date ? previousDatum._x.getTime() === datum._x.getTime() : previousDatum._x === datum._x;
	      }).map(function (previousDatum) {
	        return previousDatum._y || 0;
	      }));
	    }, []);
	    var y0 = previousPoints.length && previousPoints.reduce(function (memo, value) {
	      var sameSign = y < 0 && value < 0 || y >= 0 && value >= 0;
	      return sameSign ? +value + memo : memo;
	    }, 0);
	    return previousPoints.some(function (point) {
	      return point instanceof Date;
	    }) ? new Date(y0) : y0;
	  }
	};

/***/ },
/* 62 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _d3Timer = __webpack_require__(342);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Timer = function () {
	  function Timer() {
	    _classCallCheck(this, Timer);
	
	    this.shouldAnimate = true;
	    this.subscribers = [];
	    this.loop = this.loop.bind(this);
	    this.timer = (0, _d3Timer.timer)(this.loop);
	  }
	
	  _createClass(Timer, [{
	    key: "bypassAnimation",
	    value: function bypassAnimation() {
	      this.shouldAnimate = false;
	    }
	  }, {
	    key: "resumeAnimation",
	    value: function resumeAnimation() {
	      this.shouldAnimate = true;
	    }
	  }, {
	    key: "loop",
	    value: function loop() {
	      this.subscribers.forEach(function (s) {
	        s.callback((0, _d3Timer.now)() - s.startTime, s.duration);
	      });
	    }
	  }, {
	    key: "start",
	    value: function start() {
	      this.timer.start();
	    }
	  }, {
	    key: "stop",
	    value: function stop() {
	      this.timer.stop();
	    }
	  }, {
	    key: "subscribe",
	    value: function subscribe(callback, duration) {
	      duration = this.shouldAnimate ? duration : 0;
	      return this.subscribers.push({
	        startTime: (0, _d3Timer.now)(),
	        callback: callback,
	        duration: duration
	      });
	    }
	  }, {
	    key: "unsubscribe",
	    value: function unsubscribe(id) {
	      if (id !== null) {
	        delete this.subscribers[id - 1];
	      }
	    }
	  }]);
	
	  return Timer;
	}();
	
	exports.default = Timer;

/***/ },
/* 63 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-shape/ Version 1.2.0. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(339)) :
		typeof define === 'function' && define.amd ? define(['exports', 'd3-path'], factory) :
		(factory((global.d3 = global.d3 || {}),global.d3));
	}(this, (function (exports,d3Path) { 'use strict';
	
	var constant = function(x) {
	  return function constant() {
	    return x;
	  };
	};
	
	var abs = Math.abs;
	var atan2 = Math.atan2;
	var cos = Math.cos;
	var max = Math.max;
	var min = Math.min;
	var sin = Math.sin;
	var sqrt = Math.sqrt;
	
	var epsilon = 1e-12;
	var pi = Math.PI;
	var halfPi = pi / 2;
	var tau = 2 * pi;
	
	function acos(x) {
	  return x > 1 ? 0 : x < -1 ? pi : Math.acos(x);
	}
	
	function asin(x) {
	  return x >= 1 ? halfPi : x <= -1 ? -halfPi : Math.asin(x);
	}
	
	function arcInnerRadius(d) {
	  return d.innerRadius;
	}
	
	function arcOuterRadius(d) {
	  return d.outerRadius;
	}
	
	function arcStartAngle(d) {
	  return d.startAngle;
	}
	
	function arcEndAngle(d) {
	  return d.endAngle;
	}
	
	function arcPadAngle(d) {
	  return d && d.padAngle; // Note: optional!
	}
	
	function intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
	  var x10 = x1 - x0, y10 = y1 - y0,
	      x32 = x3 - x2, y32 = y3 - y2,
	      t = (x32 * (y0 - y2) - y32 * (x0 - x2)) / (y32 * x10 - x32 * y10);
	  return [x0 + t * x10, y0 + t * y10];
	}
	
	// Compute perpendicular offset line of length rc.
	// http://mathworld.wolfram.com/Circle-LineIntersection.html
	function cornerTangents(x0, y0, x1, y1, r1, rc, cw) {
	  var x01 = x0 - x1,
	      y01 = y0 - y1,
	      lo = (cw ? rc : -rc) / sqrt(x01 * x01 + y01 * y01),
	      ox = lo * y01,
	      oy = -lo * x01,
	      x11 = x0 + ox,
	      y11 = y0 + oy,
	      x10 = x1 + ox,
	      y10 = y1 + oy,
	      x00 = (x11 + x10) / 2,
	      y00 = (y11 + y10) / 2,
	      dx = x10 - x11,
	      dy = y10 - y11,
	      d2 = dx * dx + dy * dy,
	      r = r1 - rc,
	      D = x11 * y10 - x10 * y11,
	      d = (dy < 0 ? -1 : 1) * sqrt(max(0, r * r * d2 - D * D)),
	      cx0 = (D * dy - dx * d) / d2,
	      cy0 = (-D * dx - dy * d) / d2,
	      cx1 = (D * dy + dx * d) / d2,
	      cy1 = (-D * dx + dy * d) / d2,
	      dx0 = cx0 - x00,
	      dy0 = cy0 - y00,
	      dx1 = cx1 - x00,
	      dy1 = cy1 - y00;
	
	  // Pick the closer of the two intersection points.
	  // TODO Is there a faster way to determine which intersection to use?
	  if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;
	
	  return {
	    cx: cx0,
	    cy: cy0,
	    x01: -ox,
	    y01: -oy,
	    x11: cx0 * (r1 / r - 1),
	    y11: cy0 * (r1 / r - 1)
	  };
	}
	
	var arc = function() {
	  var innerRadius = arcInnerRadius,
	      outerRadius = arcOuterRadius,
	      cornerRadius = constant(0),
	      padRadius = null,
	      startAngle = arcStartAngle,
	      endAngle = arcEndAngle,
	      padAngle = arcPadAngle,
	      context = null;
	
	  function arc() {
	    var buffer,
	        r,
	        r0 = +innerRadius.apply(this, arguments),
	        r1 = +outerRadius.apply(this, arguments),
	        a0 = startAngle.apply(this, arguments) - halfPi,
	        a1 = endAngle.apply(this, arguments) - halfPi,
	        da = abs(a1 - a0),
	        cw = a1 > a0;
	
	    if (!context) context = buffer = d3Path.path();
	
	    // Ensure that the outer radius is always larger than the inner radius.
	    if (r1 < r0) r = r1, r1 = r0, r0 = r;
	
	    // Is it a point?
	    if (!(r1 > epsilon)) context.moveTo(0, 0);
	
	    // Or is it a circle or annulus?
	    else if (da > tau - epsilon) {
	      context.moveTo(r1 * cos(a0), r1 * sin(a0));
	      context.arc(0, 0, r1, a0, a1, !cw);
	      if (r0 > epsilon) {
	        context.moveTo(r0 * cos(a1), r0 * sin(a1));
	        context.arc(0, 0, r0, a1, a0, cw);
	      }
	    }
	
	    // Or is it a circular or annular sector?
	    else {
	      var a01 = a0,
	          a11 = a1,
	          a00 = a0,
	          a10 = a1,
	          da0 = da,
	          da1 = da,
	          ap = padAngle.apply(this, arguments) / 2,
	          rp = (ap > epsilon) && (padRadius ? +padRadius.apply(this, arguments) : sqrt(r0 * r0 + r1 * r1)),
	          rc = min(abs(r1 - r0) / 2, +cornerRadius.apply(this, arguments)),
	          rc0 = rc,
	          rc1 = rc,
	          t0,
	          t1;
	
	      // Apply padding? Note that since r1 ≥ r0, da1 ≥ da0.
	      if (rp > epsilon) {
	        var p0 = asin(rp / r0 * sin(ap)),
	            p1 = asin(rp / r1 * sin(ap));
	        if ((da0 -= p0 * 2) > epsilon) p0 *= (cw ? 1 : -1), a00 += p0, a10 -= p0;
	        else da0 = 0, a00 = a10 = (a0 + a1) / 2;
	        if ((da1 -= p1 * 2) > epsilon) p1 *= (cw ? 1 : -1), a01 += p1, a11 -= p1;
	        else da1 = 0, a01 = a11 = (a0 + a1) / 2;
	      }
	
	      var x01 = r1 * cos(a01),
	          y01 = r1 * sin(a01),
	          x10 = r0 * cos(a10),
	          y10 = r0 * sin(a10);
	
	      // Apply rounded corners?
	      if (rc > epsilon) {
	        var x11 = r1 * cos(a11),
	            y11 = r1 * sin(a11),
	            x00 = r0 * cos(a00),
	            y00 = r0 * sin(a00);
	
	        // Restrict the corner radius according to the sector angle.
	        if (da < pi) {
	          var oc = da0 > epsilon ? intersect(x01, y01, x00, y00, x11, y11, x10, y10) : [x10, y10],
	              ax = x01 - oc[0],
	              ay = y01 - oc[1],
	              bx = x11 - oc[0],
	              by = y11 - oc[1],
	              kc = 1 / sin(acos((ax * bx + ay * by) / (sqrt(ax * ax + ay * ay) * sqrt(bx * bx + by * by))) / 2),
	              lc = sqrt(oc[0] * oc[0] + oc[1] * oc[1]);
	          rc0 = min(rc, (r0 - lc) / (kc - 1));
	          rc1 = min(rc, (r1 - lc) / (kc + 1));
	        }
	      }
	
	      // Is the sector collapsed to a line?
	      if (!(da1 > epsilon)) context.moveTo(x01, y01);
	
	      // Does the sector’s outer ring have rounded corners?
	      else if (rc1 > epsilon) {
	        t0 = cornerTangents(x00, y00, x01, y01, r1, rc1, cw);
	        t1 = cornerTangents(x11, y11, x10, y10, r1, rc1, cw);
	
	        context.moveTo(t0.cx + t0.x01, t0.cy + t0.y01);
	
	        // Have the corners merged?
	        if (rc1 < rc) context.arc(t0.cx, t0.cy, rc1, atan2(t0.y01, t0.x01), atan2(t1.y01, t1.x01), !cw);
	
	        // Otherwise, draw the two corners and the ring.
	        else {
	          context.arc(t0.cx, t0.cy, rc1, atan2(t0.y01, t0.x01), atan2(t0.y11, t0.x11), !cw);
	          context.arc(0, 0, r1, atan2(t0.cy + t0.y11, t0.cx + t0.x11), atan2(t1.cy + t1.y11, t1.cx + t1.x11), !cw);
	          context.arc(t1.cx, t1.cy, rc1, atan2(t1.y11, t1.x11), atan2(t1.y01, t1.x01), !cw);
	        }
	      }
	
	      // Or is the outer ring just a circular arc?
	      else context.moveTo(x01, y01), context.arc(0, 0, r1, a01, a11, !cw);
	
	      // Is there no inner ring, and it’s a circular sector?
	      // Or perhaps it’s an annular sector collapsed due to padding?
	      if (!(r0 > epsilon) || !(da0 > epsilon)) context.lineTo(x10, y10);
	
	      // Does the sector’s inner ring (or point) have rounded corners?
	      else if (rc0 > epsilon) {
	        t0 = cornerTangents(x10, y10, x11, y11, r0, -rc0, cw);
	        t1 = cornerTangents(x01, y01, x00, y00, r0, -rc0, cw);
	
	        context.lineTo(t0.cx + t0.x01, t0.cy + t0.y01);
	
	        // Have the corners merged?
	        if (rc0 < rc) context.arc(t0.cx, t0.cy, rc0, atan2(t0.y01, t0.x01), atan2(t1.y01, t1.x01), !cw);
	
	        // Otherwise, draw the two corners and the ring.
	        else {
	          context.arc(t0.cx, t0.cy, rc0, atan2(t0.y01, t0.x01), atan2(t0.y11, t0.x11), !cw);
	          context.arc(0, 0, r0, atan2(t0.cy + t0.y11, t0.cx + t0.x11), atan2(t1.cy + t1.y11, t1.cx + t1.x11), cw);
	          context.arc(t1.cx, t1.cy, rc0, atan2(t1.y11, t1.x11), atan2(t1.y01, t1.x01), !cw);
	        }
	      }
	
	      // Or is the inner ring just a circular arc?
	      else context.arc(0, 0, r0, a10, a00, cw);
	    }
	
	    context.closePath();
	
	    if (buffer) return context = null, buffer + "" || null;
	  }
	
	  arc.centroid = function() {
	    var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2,
	        a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - pi / 2;
	    return [cos(a) * r, sin(a) * r];
	  };
	
	  arc.innerRadius = function(_) {
	    return arguments.length ? (innerRadius = typeof _ === "function" ? _ : constant(+_), arc) : innerRadius;
	  };
	
	  arc.outerRadius = function(_) {
	    return arguments.length ? (outerRadius = typeof _ === "function" ? _ : constant(+_), arc) : outerRadius;
	  };
	
	  arc.cornerRadius = function(_) {
	    return arguments.length ? (cornerRadius = typeof _ === "function" ? _ : constant(+_), arc) : cornerRadius;
	  };
	
	  arc.padRadius = function(_) {
	    return arguments.length ? (padRadius = _ == null ? null : typeof _ === "function" ? _ : constant(+_), arc) : padRadius;
	  };
	
	  arc.startAngle = function(_) {
	    return arguments.length ? (startAngle = typeof _ === "function" ? _ : constant(+_), arc) : startAngle;
	  };
	
	  arc.endAngle = function(_) {
	    return arguments.length ? (endAngle = typeof _ === "function" ? _ : constant(+_), arc) : endAngle;
	  };
	
	  arc.padAngle = function(_) {
	    return arguments.length ? (padAngle = typeof _ === "function" ? _ : constant(+_), arc) : padAngle;
	  };
	
	  arc.context = function(_) {
	    return arguments.length ? ((context = _ == null ? null : _), arc) : context;
	  };
	
	  return arc;
	};
	
	function Linear(context) {
	  this._context = context;
	}
	
	Linear.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; // proceed
	      default: this._context.lineTo(x, y); break;
	    }
	  }
	};
	
	var curveLinear = function(context) {
	  return new Linear(context);
	};
	
	function x(p) {
	  return p[0];
	}
	
	function y(p) {
	  return p[1];
	}
	
	var line = function() {
	  var x$$1 = x,
	      y$$1 = y,
	      defined = constant(true),
	      context = null,
	      curve = curveLinear,
	      output = null;
	
	  function line(data) {
	    var i,
	        n = data.length,
	        d,
	        defined0 = false,
	        buffer;
	
	    if (context == null) output = curve(buffer = d3Path.path());
	
	    for (i = 0; i <= n; ++i) {
	      if (!(i < n && defined(d = data[i], i, data)) === defined0) {
	        if (defined0 = !defined0) output.lineStart();
	        else output.lineEnd();
	      }
	      if (defined0) output.point(+x$$1(d, i, data), +y$$1(d, i, data));
	    }
	
	    if (buffer) return output = null, buffer + "" || null;
	  }
	
	  line.x = function(_) {
	    return arguments.length ? (x$$1 = typeof _ === "function" ? _ : constant(+_), line) : x$$1;
	  };
	
	  line.y = function(_) {
	    return arguments.length ? (y$$1 = typeof _ === "function" ? _ : constant(+_), line) : y$$1;
	  };
	
	  line.defined = function(_) {
	    return arguments.length ? (defined = typeof _ === "function" ? _ : constant(!!_), line) : defined;
	  };
	
	  line.curve = function(_) {
	    return arguments.length ? (curve = _, context != null && (output = curve(context)), line) : curve;
	  };
	
	  line.context = function(_) {
	    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), line) : context;
	  };
	
	  return line;
	};
	
	var area = function() {
	  var x0 = x,
	      x1 = null,
	      y0 = constant(0),
	      y1 = y,
	      defined = constant(true),
	      context = null,
	      curve = curveLinear,
	      output = null;
	
	  function area(data) {
	    var i,
	        j,
	        k,
	        n = data.length,
	        d,
	        defined0 = false,
	        buffer,
	        x0z = new Array(n),
	        y0z = new Array(n);
	
	    if (context == null) output = curve(buffer = d3Path.path());
	
	    for (i = 0; i <= n; ++i) {
	      if (!(i < n && defined(d = data[i], i, data)) === defined0) {
	        if (defined0 = !defined0) {
	          j = i;
	          output.areaStart();
	          output.lineStart();
	        } else {
	          output.lineEnd();
	          output.lineStart();
	          for (k = i - 1; k >= j; --k) {
	            output.point(x0z[k], y0z[k]);
	          }
	          output.lineEnd();
	          output.areaEnd();
	        }
	      }
	      if (defined0) {
	        x0z[i] = +x0(d, i, data), y0z[i] = +y0(d, i, data);
	        output.point(x1 ? +x1(d, i, data) : x0z[i], y1 ? +y1(d, i, data) : y0z[i]);
	      }
	    }
	
	    if (buffer) return output = null, buffer + "" || null;
	  }
	
	  function arealine() {
	    return line().defined(defined).curve(curve).context(context);
	  }
	
	  area.x = function(_) {
	    return arguments.length ? (x0 = typeof _ === "function" ? _ : constant(+_), x1 = null, area) : x0;
	  };
	
	  area.x0 = function(_) {
	    return arguments.length ? (x0 = typeof _ === "function" ? _ : constant(+_), area) : x0;
	  };
	
	  area.x1 = function(_) {
	    return arguments.length ? (x1 = _ == null ? null : typeof _ === "function" ? _ : constant(+_), area) : x1;
	  };
	
	  area.y = function(_) {
	    return arguments.length ? (y0 = typeof _ === "function" ? _ : constant(+_), y1 = null, area) : y0;
	  };
	
	  area.y0 = function(_) {
	    return arguments.length ? (y0 = typeof _ === "function" ? _ : constant(+_), area) : y0;
	  };
	
	  area.y1 = function(_) {
	    return arguments.length ? (y1 = _ == null ? null : typeof _ === "function" ? _ : constant(+_), area) : y1;
	  };
	
	  area.lineX0 =
	  area.lineY0 = function() {
	    return arealine().x(x0).y(y0);
	  };
	
	  area.lineY1 = function() {
	    return arealine().x(x0).y(y1);
	  };
	
	  area.lineX1 = function() {
	    return arealine().x(x1).y(y0);
	  };
	
	  area.defined = function(_) {
	    return arguments.length ? (defined = typeof _ === "function" ? _ : constant(!!_), area) : defined;
	  };
	
	  area.curve = function(_) {
	    return arguments.length ? (curve = _, context != null && (output = curve(context)), area) : curve;
	  };
	
	  area.context = function(_) {
	    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), area) : context;
	  };
	
	  return area;
	};
	
	var descending = function(a, b) {
	  return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
	};
	
	var identity = function(d) {
	  return d;
	};
	
	var pie = function() {
	  var value = identity,
	      sortValues = descending,
	      sort = null,
	      startAngle = constant(0),
	      endAngle = constant(tau),
	      padAngle = constant(0);
	
	  function pie(data) {
	    var i,
	        n = data.length,
	        j,
	        k,
	        sum = 0,
	        index = new Array(n),
	        arcs = new Array(n),
	        a0 = +startAngle.apply(this, arguments),
	        da = Math.min(tau, Math.max(-tau, endAngle.apply(this, arguments) - a0)),
	        a1,
	        p = Math.min(Math.abs(da) / n, padAngle.apply(this, arguments)),
	        pa = p * (da < 0 ? -1 : 1),
	        v;
	
	    for (i = 0; i < n; ++i) {
	      if ((v = arcs[index[i] = i] = +value(data[i], i, data)) > 0) {
	        sum += v;
	      }
	    }
	
	    // Optionally sort the arcs by previously-computed values or by data.
	    if (sortValues != null) index.sort(function(i, j) { return sortValues(arcs[i], arcs[j]); });
	    else if (sort != null) index.sort(function(i, j) { return sort(data[i], data[j]); });
	
	    // Compute the arcs! They are stored in the original data's order.
	    for (i = 0, k = sum ? (da - n * pa) / sum : 0; i < n; ++i, a0 = a1) {
	      j = index[i], v = arcs[j], a1 = a0 + (v > 0 ? v * k : 0) + pa, arcs[j] = {
	        data: data[j],
	        index: i,
	        value: v,
	        startAngle: a0,
	        endAngle: a1,
	        padAngle: p
	      };
	    }
	
	    return arcs;
	  }
	
	  pie.value = function(_) {
	    return arguments.length ? (value = typeof _ === "function" ? _ : constant(+_), pie) : value;
	  };
	
	  pie.sortValues = function(_) {
	    return arguments.length ? (sortValues = _, sort = null, pie) : sortValues;
	  };
	
	  pie.sort = function(_) {
	    return arguments.length ? (sort = _, sortValues = null, pie) : sort;
	  };
	
	  pie.startAngle = function(_) {
	    return arguments.length ? (startAngle = typeof _ === "function" ? _ : constant(+_), pie) : startAngle;
	  };
	
	  pie.endAngle = function(_) {
	    return arguments.length ? (endAngle = typeof _ === "function" ? _ : constant(+_), pie) : endAngle;
	  };
	
	  pie.padAngle = function(_) {
	    return arguments.length ? (padAngle = typeof _ === "function" ? _ : constant(+_), pie) : padAngle;
	  };
	
	  return pie;
	};
	
	var curveRadialLinear = curveRadial(curveLinear);
	
	function Radial(curve) {
	  this._curve = curve;
	}
	
	Radial.prototype = {
	  areaStart: function() {
	    this._curve.areaStart();
	  },
	  areaEnd: function() {
	    this._curve.areaEnd();
	  },
	  lineStart: function() {
	    this._curve.lineStart();
	  },
	  lineEnd: function() {
	    this._curve.lineEnd();
	  },
	  point: function(a, r) {
	    this._curve.point(r * Math.sin(a), r * -Math.cos(a));
	  }
	};
	
	function curveRadial(curve) {
	
	  function radial(context) {
	    return new Radial(curve(context));
	  }
	
	  radial._curve = curve;
	
	  return radial;
	}
	
	function lineRadial(l) {
	  var c = l.curve;
	
	  l.angle = l.x, delete l.x;
	  l.radius = l.y, delete l.y;
	
	  l.curve = function(_) {
	    return arguments.length ? c(curveRadial(_)) : c()._curve;
	  };
	
	  return l;
	}
	
	var lineRadial$1 = function() {
	  return lineRadial(line().curve(curveRadialLinear));
	};
	
	var areaRadial = function() {
	  var a = area().curve(curveRadialLinear),
	      c = a.curve,
	      x0 = a.lineX0,
	      x1 = a.lineX1,
	      y0 = a.lineY0,
	      y1 = a.lineY1;
	
	  a.angle = a.x, delete a.x;
	  a.startAngle = a.x0, delete a.x0;
	  a.endAngle = a.x1, delete a.x1;
	  a.radius = a.y, delete a.y;
	  a.innerRadius = a.y0, delete a.y0;
	  a.outerRadius = a.y1, delete a.y1;
	  a.lineStartAngle = function() { return lineRadial(x0()); }, delete a.lineX0;
	  a.lineEndAngle = function() { return lineRadial(x1()); }, delete a.lineX1;
	  a.lineInnerRadius = function() { return lineRadial(y0()); }, delete a.lineY0;
	  a.lineOuterRadius = function() { return lineRadial(y1()); }, delete a.lineY1;
	
	  a.curve = function(_) {
	    return arguments.length ? c(curveRadial(_)) : c()._curve;
	  };
	
	  return a;
	};
	
	var pointRadial = function(x, y) {
	  return [(y = +y) * Math.cos(x -= Math.PI / 2), y * Math.sin(x)];
	};
	
	var slice = Array.prototype.slice;
	
	function linkSource(d) {
	  return d.source;
	}
	
	function linkTarget(d) {
	  return d.target;
	}
	
	function link(curve) {
	  var source = linkSource,
	      target = linkTarget,
	      x$$1 = x,
	      y$$1 = y,
	      context = null;
	
	  function link() {
	    var buffer, argv = slice.call(arguments), s = source.apply(this, argv), t = target.apply(this, argv);
	    if (!context) context = buffer = d3Path.path();
	    curve(context, +x$$1.apply(this, (argv[0] = s, argv)), +y$$1.apply(this, argv), +x$$1.apply(this, (argv[0] = t, argv)), +y$$1.apply(this, argv));
	    if (buffer) return context = null, buffer + "" || null;
	  }
	
	  link.source = function(_) {
	    return arguments.length ? (source = _, link) : source;
	  };
	
	  link.target = function(_) {
	    return arguments.length ? (target = _, link) : target;
	  };
	
	  link.x = function(_) {
	    return arguments.length ? (x$$1 = typeof _ === "function" ? _ : constant(+_), link) : x$$1;
	  };
	
	  link.y = function(_) {
	    return arguments.length ? (y$$1 = typeof _ === "function" ? _ : constant(+_), link) : y$$1;
	  };
	
	  link.context = function(_) {
	    return arguments.length ? ((context = _ == null ? null : _), link) : context;
	  };
	
	  return link;
	}
	
	function curveHorizontal(context, x0, y0, x1, y1) {
	  context.moveTo(x0, y0);
	  context.bezierCurveTo(x0 = (x0 + x1) / 2, y0, x0, y1, x1, y1);
	}
	
	function curveVertical(context, x0, y0, x1, y1) {
	  context.moveTo(x0, y0);
	  context.bezierCurveTo(x0, y0 = (y0 + y1) / 2, x1, y0, x1, y1);
	}
	
	function curveRadial$1(context, x0, y0, x1, y1) {
	  var p0 = pointRadial(x0, y0),
	      p1 = pointRadial(x0, y0 = (y0 + y1) / 2),
	      p2 = pointRadial(x1, y0),
	      p3 = pointRadial(x1, y1);
	  context.moveTo(p0[0], p0[1]);
	  context.bezierCurveTo(p1[0], p1[1], p2[0], p2[1], p3[0], p3[1]);
	}
	
	function linkHorizontal() {
	  return link(curveHorizontal);
	}
	
	function linkVertical() {
	  return link(curveVertical);
	}
	
	function linkRadial() {
	  var l = link(curveRadial$1);
	  l.angle = l.x, delete l.x;
	  l.radius = l.y, delete l.y;
	  return l;
	}
	
	var circle = {
	  draw: function(context, size) {
	    var r = Math.sqrt(size / pi);
	    context.moveTo(r, 0);
	    context.arc(0, 0, r, 0, tau);
	  }
	};
	
	var cross = {
	  draw: function(context, size) {
	    var r = Math.sqrt(size / 5) / 2;
	    context.moveTo(-3 * r, -r);
	    context.lineTo(-r, -r);
	    context.lineTo(-r, -3 * r);
	    context.lineTo(r, -3 * r);
	    context.lineTo(r, -r);
	    context.lineTo(3 * r, -r);
	    context.lineTo(3 * r, r);
	    context.lineTo(r, r);
	    context.lineTo(r, 3 * r);
	    context.lineTo(-r, 3 * r);
	    context.lineTo(-r, r);
	    context.lineTo(-3 * r, r);
	    context.closePath();
	  }
	};
	
	var tan30 = Math.sqrt(1 / 3);
	var tan30_2 = tan30 * 2;
	
	var diamond = {
	  draw: function(context, size) {
	    var y = Math.sqrt(size / tan30_2),
	        x = y * tan30;
	    context.moveTo(0, -y);
	    context.lineTo(x, 0);
	    context.lineTo(0, y);
	    context.lineTo(-x, 0);
	    context.closePath();
	  }
	};
	
	var ka = 0.89081309152928522810;
	var kr = Math.sin(pi / 10) / Math.sin(7 * pi / 10);
	var kx = Math.sin(tau / 10) * kr;
	var ky = -Math.cos(tau / 10) * kr;
	
	var star = {
	  draw: function(context, size) {
	    var r = Math.sqrt(size * ka),
	        x = kx * r,
	        y = ky * r;
	    context.moveTo(0, -r);
	    context.lineTo(x, y);
	    for (var i = 1; i < 5; ++i) {
	      var a = tau * i / 5,
	          c = Math.cos(a),
	          s = Math.sin(a);
	      context.lineTo(s * r, -c * r);
	      context.lineTo(c * x - s * y, s * x + c * y);
	    }
	    context.closePath();
	  }
	};
	
	var square = {
	  draw: function(context, size) {
	    var w = Math.sqrt(size),
	        x = -w / 2;
	    context.rect(x, x, w, w);
	  }
	};
	
	var sqrt3 = Math.sqrt(3);
	
	var triangle = {
	  draw: function(context, size) {
	    var y = -Math.sqrt(size / (sqrt3 * 3));
	    context.moveTo(0, y * 2);
	    context.lineTo(-sqrt3 * y, -y);
	    context.lineTo(sqrt3 * y, -y);
	    context.closePath();
	  }
	};
	
	var c = -0.5;
	var s = Math.sqrt(3) / 2;
	var k = 1 / Math.sqrt(12);
	var a = (k / 2 + 1) * 3;
	
	var wye = {
	  draw: function(context, size) {
	    var r = Math.sqrt(size / a),
	        x0 = r / 2,
	        y0 = r * k,
	        x1 = x0,
	        y1 = r * k + r,
	        x2 = -x1,
	        y2 = y1;
	    context.moveTo(x0, y0);
	    context.lineTo(x1, y1);
	    context.lineTo(x2, y2);
	    context.lineTo(c * x0 - s * y0, s * x0 + c * y0);
	    context.lineTo(c * x1 - s * y1, s * x1 + c * y1);
	    context.lineTo(c * x2 - s * y2, s * x2 + c * y2);
	    context.lineTo(c * x0 + s * y0, c * y0 - s * x0);
	    context.lineTo(c * x1 + s * y1, c * y1 - s * x1);
	    context.lineTo(c * x2 + s * y2, c * y2 - s * x2);
	    context.closePath();
	  }
	};
	
	var symbols = [
	  circle,
	  cross,
	  diamond,
	  square,
	  star,
	  triangle,
	  wye
	];
	
	var symbol = function() {
	  var type = constant(circle),
	      size = constant(64),
	      context = null;
	
	  function symbol() {
	    var buffer;
	    if (!context) context = buffer = d3Path.path();
	    type.apply(this, arguments).draw(context, +size.apply(this, arguments));
	    if (buffer) return context = null, buffer + "" || null;
	  }
	
	  symbol.type = function(_) {
	    return arguments.length ? (type = typeof _ === "function" ? _ : constant(_), symbol) : type;
	  };
	
	  symbol.size = function(_) {
	    return arguments.length ? (size = typeof _ === "function" ? _ : constant(+_), symbol) : size;
	  };
	
	  symbol.context = function(_) {
	    return arguments.length ? (context = _ == null ? null : _, symbol) : context;
	  };
	
	  return symbol;
	};
	
	var noop = function() {};
	
	function point(that, x, y) {
	  that._context.bezierCurveTo(
	    (2 * that._x0 + that._x1) / 3,
	    (2 * that._y0 + that._y1) / 3,
	    (that._x0 + 2 * that._x1) / 3,
	    (that._y0 + 2 * that._y1) / 3,
	    (that._x0 + 4 * that._x1 + x) / 6,
	    (that._y0 + 4 * that._y1 + y) / 6
	  );
	}
	
	function Basis(context) {
	  this._context = context;
	}
	
	Basis.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 =
	    this._y0 = this._y1 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 3: point(this, this._x1, this._y1); // proceed
	      case 2: this._context.lineTo(this._x1, this._y1); break;
	    }
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6); // proceed
	      default: point(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = x;
	    this._y0 = this._y1, this._y1 = y;
	  }
	};
	
	var basis = function(context) {
	  return new Basis(context);
	};
	
	function BasisClosed(context) {
	  this._context = context;
	}
	
	BasisClosed.prototype = {
	  areaStart: noop,
	  areaEnd: noop,
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 =
	    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 1: {
	        this._context.moveTo(this._x2, this._y2);
	        this._context.closePath();
	        break;
	      }
	      case 2: {
	        this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3);
	        this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3);
	        this._context.closePath();
	        break;
	      }
	      case 3: {
	        this.point(this._x2, this._y2);
	        this.point(this._x3, this._y3);
	        this.point(this._x4, this._y4);
	        break;
	      }
	    }
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._x2 = x, this._y2 = y; break;
	      case 1: this._point = 2; this._x3 = x, this._y3 = y; break;
	      case 2: this._point = 3; this._x4 = x, this._y4 = y; this._context.moveTo((this._x0 + 4 * this._x1 + x) / 6, (this._y0 + 4 * this._y1 + y) / 6); break;
	      default: point(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = x;
	    this._y0 = this._y1, this._y1 = y;
	  }
	};
	
	var basisClosed = function(context) {
	  return new BasisClosed(context);
	};
	
	function BasisOpen(context) {
	  this._context = context;
	}
	
	BasisOpen.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 =
	    this._y0 = this._y1 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; var x0 = (this._x0 + 4 * this._x1 + x) / 6, y0 = (this._y0 + 4 * this._y1 + y) / 6; this._line ? this._context.lineTo(x0, y0) : this._context.moveTo(x0, y0); break;
	      case 3: this._point = 4; // proceed
	      default: point(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = x;
	    this._y0 = this._y1, this._y1 = y;
	  }
	};
	
	var basisOpen = function(context) {
	  return new BasisOpen(context);
	};
	
	function Bundle(context, beta) {
	  this._basis = new Basis(context);
	  this._beta = beta;
	}
	
	Bundle.prototype = {
	  lineStart: function() {
	    this._x = [];
	    this._y = [];
	    this._basis.lineStart();
	  },
	  lineEnd: function() {
	    var x = this._x,
	        y = this._y,
	        j = x.length - 1;
	
	    if (j > 0) {
	      var x0 = x[0],
	          y0 = y[0],
	          dx = x[j] - x0,
	          dy = y[j] - y0,
	          i = -1,
	          t;
	
	      while (++i <= j) {
	        t = i / j;
	        this._basis.point(
	          this._beta * x[i] + (1 - this._beta) * (x0 + t * dx),
	          this._beta * y[i] + (1 - this._beta) * (y0 + t * dy)
	        );
	      }
	    }
	
	    this._x = this._y = null;
	    this._basis.lineEnd();
	  },
	  point: function(x, y) {
	    this._x.push(+x);
	    this._y.push(+y);
	  }
	};
	
	var bundle = ((function custom(beta) {
	
	  function bundle(context) {
	    return beta === 1 ? new Basis(context) : new Bundle(context, beta);
	  }
	
	  bundle.beta = function(beta) {
	    return custom(+beta);
	  };
	
	  return bundle;
	}))(0.85);
	
	function point$1(that, x, y) {
	  that._context.bezierCurveTo(
	    that._x1 + that._k * (that._x2 - that._x0),
	    that._y1 + that._k * (that._y2 - that._y0),
	    that._x2 + that._k * (that._x1 - x),
	    that._y2 + that._k * (that._y1 - y),
	    that._x2,
	    that._y2
	  );
	}
	
	function Cardinal(context, tension) {
	  this._context = context;
	  this._k = (1 - tension) / 6;
	}
	
	Cardinal.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 =
	    this._y0 = this._y1 = this._y2 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 2: this._context.lineTo(this._x2, this._y2); break;
	      case 3: point$1(this, this._x1, this._y1); break;
	    }
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; this._x1 = x, this._y1 = y; break;
	      case 2: this._point = 3; // proceed
	      default: point$1(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var cardinal = ((function custom(tension) {
	
	  function cardinal(context) {
	    return new Cardinal(context, tension);
	  }
	
	  cardinal.tension = function(tension) {
	    return custom(+tension);
	  };
	
	  return cardinal;
	}))(0);
	
	function CardinalClosed(context, tension) {
	  this._context = context;
	  this._k = (1 - tension) / 6;
	}
	
	CardinalClosed.prototype = {
	  areaStart: noop,
	  areaEnd: noop,
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 =
	    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 1: {
	        this._context.moveTo(this._x3, this._y3);
	        this._context.closePath();
	        break;
	      }
	      case 2: {
	        this._context.lineTo(this._x3, this._y3);
	        this._context.closePath();
	        break;
	      }
	      case 3: {
	        this.point(this._x3, this._y3);
	        this.point(this._x4, this._y4);
	        this.point(this._x5, this._y5);
	        break;
	      }
	    }
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._x3 = x, this._y3 = y; break;
	      case 1: this._point = 2; this._context.moveTo(this._x4 = x, this._y4 = y); break;
	      case 2: this._point = 3; this._x5 = x, this._y5 = y; break;
	      default: point$1(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var cardinalClosed = ((function custom(tension) {
	
	  function cardinal(context) {
	    return new CardinalClosed(context, tension);
	  }
	
	  cardinal.tension = function(tension) {
	    return custom(+tension);
	  };
	
	  return cardinal;
	}))(0);
	
	function CardinalOpen(context, tension) {
	  this._context = context;
	  this._k = (1 - tension) / 6;
	}
	
	CardinalOpen.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 =
	    this._y0 = this._y1 = this._y2 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2); break;
	      case 3: this._point = 4; // proceed
	      default: point$1(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var cardinalOpen = ((function custom(tension) {
	
	  function cardinal(context) {
	    return new CardinalOpen(context, tension);
	  }
	
	  cardinal.tension = function(tension) {
	    return custom(+tension);
	  };
	
	  return cardinal;
	}))(0);
	
	function point$2(that, x, y) {
	  var x1 = that._x1,
	      y1 = that._y1,
	      x2 = that._x2,
	      y2 = that._y2;
	
	  if (that._l01_a > epsilon) {
	    var a = 2 * that._l01_2a + 3 * that._l01_a * that._l12_a + that._l12_2a,
	        n = 3 * that._l01_a * (that._l01_a + that._l12_a);
	    x1 = (x1 * a - that._x0 * that._l12_2a + that._x2 * that._l01_2a) / n;
	    y1 = (y1 * a - that._y0 * that._l12_2a + that._y2 * that._l01_2a) / n;
	  }
	
	  if (that._l23_a > epsilon) {
	    var b = 2 * that._l23_2a + 3 * that._l23_a * that._l12_a + that._l12_2a,
	        m = 3 * that._l23_a * (that._l23_a + that._l12_a);
	    x2 = (x2 * b + that._x1 * that._l23_2a - x * that._l12_2a) / m;
	    y2 = (y2 * b + that._y1 * that._l23_2a - y * that._l12_2a) / m;
	  }
	
	  that._context.bezierCurveTo(x1, y1, x2, y2, that._x2, that._y2);
	}
	
	function CatmullRom(context, alpha) {
	  this._context = context;
	  this._alpha = alpha;
	}
	
	CatmullRom.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 =
	    this._y0 = this._y1 = this._y2 = NaN;
	    this._l01_a = this._l12_a = this._l23_a =
	    this._l01_2a = this._l12_2a = this._l23_2a =
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 2: this._context.lineTo(this._x2, this._y2); break;
	      case 3: this.point(this._x2, this._y2); break;
	    }
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	
	    if (this._point) {
	      var x23 = this._x2 - x,
	          y23 = this._y2 - y;
	      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
	    }
	
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; // proceed
	      default: point$2(this, x, y); break;
	    }
	
	    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
	    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var catmullRom = ((function custom(alpha) {
	
	  function catmullRom(context) {
	    return alpha ? new CatmullRom(context, alpha) : new Cardinal(context, 0);
	  }
	
	  catmullRom.alpha = function(alpha) {
	    return custom(+alpha);
	  };
	
	  return catmullRom;
	}))(0.5);
	
	function CatmullRomClosed(context, alpha) {
	  this._context = context;
	  this._alpha = alpha;
	}
	
	CatmullRomClosed.prototype = {
	  areaStart: noop,
	  areaEnd: noop,
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 =
	    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
	    this._l01_a = this._l12_a = this._l23_a =
	    this._l01_2a = this._l12_2a = this._l23_2a =
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 1: {
	        this._context.moveTo(this._x3, this._y3);
	        this._context.closePath();
	        break;
	      }
	      case 2: {
	        this._context.lineTo(this._x3, this._y3);
	        this._context.closePath();
	        break;
	      }
	      case 3: {
	        this.point(this._x3, this._y3);
	        this.point(this._x4, this._y4);
	        this.point(this._x5, this._y5);
	        break;
	      }
	    }
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	
	    if (this._point) {
	      var x23 = this._x2 - x,
	          y23 = this._y2 - y;
	      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
	    }
	
	    switch (this._point) {
	      case 0: this._point = 1; this._x3 = x, this._y3 = y; break;
	      case 1: this._point = 2; this._context.moveTo(this._x4 = x, this._y4 = y); break;
	      case 2: this._point = 3; this._x5 = x, this._y5 = y; break;
	      default: point$2(this, x, y); break;
	    }
	
	    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
	    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var catmullRomClosed = ((function custom(alpha) {
	
	  function catmullRom(context) {
	    return alpha ? new CatmullRomClosed(context, alpha) : new CardinalClosed(context, 0);
	  }
	
	  catmullRom.alpha = function(alpha) {
	    return custom(+alpha);
	  };
	
	  return catmullRom;
	}))(0.5);
	
	function CatmullRomOpen(context, alpha) {
	  this._context = context;
	  this._alpha = alpha;
	}
	
	CatmullRomOpen.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 =
	    this._y0 = this._y1 = this._y2 = NaN;
	    this._l01_a = this._l12_a = this._l23_a =
	    this._l01_2a = this._l12_2a = this._l23_2a =
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	
	    if (this._point) {
	      var x23 = this._x2 - x,
	          y23 = this._y2 - y;
	      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
	    }
	
	    switch (this._point) {
	      case 0: this._point = 1; break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2); break;
	      case 3: this._point = 4; // proceed
	      default: point$2(this, x, y); break;
	    }
	
	    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
	    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var catmullRomOpen = ((function custom(alpha) {
	
	  function catmullRom(context) {
	    return alpha ? new CatmullRomOpen(context, alpha) : new CardinalOpen(context, 0);
	  }
	
	  catmullRom.alpha = function(alpha) {
	    return custom(+alpha);
	  };
	
	  return catmullRom;
	}))(0.5);
	
	function LinearClosed(context) {
	  this._context = context;
	}
	
	LinearClosed.prototype = {
	  areaStart: noop,
	  areaEnd: noop,
	  lineStart: function() {
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._point) this._context.closePath();
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    if (this._point) this._context.lineTo(x, y);
	    else this._point = 1, this._context.moveTo(x, y);
	  }
	};
	
	var linearClosed = function(context) {
	  return new LinearClosed(context);
	};
	
	function sign(x) {
	  return x < 0 ? -1 : 1;
	}
	
	// Calculate the slopes of the tangents (Hermite-type interpolation) based on
	// the following paper: Steffen, M. 1990. A Simple Method for Monotonic
	// Interpolation in One Dimension. Astronomy and Astrophysics, Vol. 239, NO.
	// NOV(II), P. 443, 1990.
	function slope3(that, x2, y2) {
	  var h0 = that._x1 - that._x0,
	      h1 = x2 - that._x1,
	      s0 = (that._y1 - that._y0) / (h0 || h1 < 0 && -0),
	      s1 = (y2 - that._y1) / (h1 || h0 < 0 && -0),
	      p = (s0 * h1 + s1 * h0) / (h0 + h1);
	  return (sign(s0) + sign(s1)) * Math.min(Math.abs(s0), Math.abs(s1), 0.5 * Math.abs(p)) || 0;
	}
	
	// Calculate a one-sided slope.
	function slope2(that, t) {
	  var h = that._x1 - that._x0;
	  return h ? (3 * (that._y1 - that._y0) / h - t) / 2 : t;
	}
	
	// According to https://en.wikipedia.org/wiki/Cubic_Hermite_spline#Representations
	// "you can express cubic Hermite interpolation in terms of cubic Bézier curves
	// with respect to the four values p0, p0 + m0 / 3, p1 - m1 / 3, p1".
	function point$3(that, t0, t1) {
	  var x0 = that._x0,
	      y0 = that._y0,
	      x1 = that._x1,
	      y1 = that._y1,
	      dx = (x1 - x0) / 3;
	  that._context.bezierCurveTo(x0 + dx, y0 + dx * t0, x1 - dx, y1 - dx * t1, x1, y1);
	}
	
	function MonotoneX(context) {
	  this._context = context;
	}
	
	MonotoneX.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 =
	    this._y0 = this._y1 =
	    this._t0 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 2: this._context.lineTo(this._x1, this._y1); break;
	      case 3: point$3(this, this._t0, slope2(this, this._t0)); break;
	    }
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    var t1 = NaN;
	
	    x = +x, y = +y;
	    if (x === this._x1 && y === this._y1) return; // Ignore coincident points.
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; point$3(this, slope2(this, t1 = slope3(this, x, y)), t1); break;
	      default: point$3(this, this._t0, t1 = slope3(this, x, y)); break;
	    }
	
	    this._x0 = this._x1, this._x1 = x;
	    this._y0 = this._y1, this._y1 = y;
	    this._t0 = t1;
	  }
	};
	
	function MonotoneY(context) {
	  this._context = new ReflectContext(context);
	}
	
	(MonotoneY.prototype = Object.create(MonotoneX.prototype)).point = function(x, y) {
	  MonotoneX.prototype.point.call(this, y, x);
	};
	
	function ReflectContext(context) {
	  this._context = context;
	}
	
	ReflectContext.prototype = {
	  moveTo: function(x, y) { this._context.moveTo(y, x); },
	  closePath: function() { this._context.closePath(); },
	  lineTo: function(x, y) { this._context.lineTo(y, x); },
	  bezierCurveTo: function(x1, y1, x2, y2, x, y) { this._context.bezierCurveTo(y1, x1, y2, x2, y, x); }
	};
	
	function monotoneX(context) {
	  return new MonotoneX(context);
	}
	
	function monotoneY(context) {
	  return new MonotoneY(context);
	}
	
	function Natural(context) {
	  this._context = context;
	}
	
	Natural.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x = [];
	    this._y = [];
	  },
	  lineEnd: function() {
	    var x = this._x,
	        y = this._y,
	        n = x.length;
	
	    if (n) {
	      this._line ? this._context.lineTo(x[0], y[0]) : this._context.moveTo(x[0], y[0]);
	      if (n === 2) {
	        this._context.lineTo(x[1], y[1]);
	      } else {
	        var px = controlPoints(x),
	            py = controlPoints(y);
	        for (var i0 = 0, i1 = 1; i1 < n; ++i0, ++i1) {
	          this._context.bezierCurveTo(px[0][i0], py[0][i0], px[1][i0], py[1][i0], x[i1], y[i1]);
	        }
	      }
	    }
	
	    if (this._line || (this._line !== 0 && n === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	    this._x = this._y = null;
	  },
	  point: function(x, y) {
	    this._x.push(+x);
	    this._y.push(+y);
	  }
	};
	
	// See https://www.particleincell.com/2012/bezier-splines/ for derivation.
	function controlPoints(x) {
	  var i,
	      n = x.length - 1,
	      m,
	      a = new Array(n),
	      b = new Array(n),
	      r = new Array(n);
	  a[0] = 0, b[0] = 2, r[0] = x[0] + 2 * x[1];
	  for (i = 1; i < n - 1; ++i) a[i] = 1, b[i] = 4, r[i] = 4 * x[i] + 2 * x[i + 1];
	  a[n - 1] = 2, b[n - 1] = 7, r[n - 1] = 8 * x[n - 1] + x[n];
	  for (i = 1; i < n; ++i) m = a[i] / b[i - 1], b[i] -= m, r[i] -= m * r[i - 1];
	  a[n - 1] = r[n - 1] / b[n - 1];
	  for (i = n - 2; i >= 0; --i) a[i] = (r[i] - a[i + 1]) / b[i];
	  b[n - 1] = (x[n] + a[n - 1]) / 2;
	  for (i = 0; i < n - 1; ++i) b[i] = 2 * x[i + 1] - a[i + 1];
	  return [a, b];
	}
	
	var natural = function(context) {
	  return new Natural(context);
	};
	
	function Step(context, t) {
	  this._context = context;
	  this._t = t;
	}
	
	Step.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x = this._y = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (0 < this._t && this._t < 1 && this._point === 2) this._context.lineTo(this._x, this._y);
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    if (this._line >= 0) this._t = 1 - this._t, this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; // proceed
	      default: {
	        if (this._t <= 0) {
	          this._context.lineTo(this._x, y);
	          this._context.lineTo(x, y);
	        } else {
	          var x1 = this._x * (1 - this._t) + x * this._t;
	          this._context.lineTo(x1, this._y);
	          this._context.lineTo(x1, y);
	        }
	        break;
	      }
	    }
	    this._x = x, this._y = y;
	  }
	};
	
	var step = function(context) {
	  return new Step(context, 0.5);
	};
	
	function stepBefore(context) {
	  return new Step(context, 0);
	}
	
	function stepAfter(context) {
	  return new Step(context, 1);
	}
	
	var none = function(series, order) {
	  if (!((n = series.length) > 1)) return;
	  for (var i = 1, j, s0, s1 = series[order[0]], n, m = s1.length; i < n; ++i) {
	    s0 = s1, s1 = series[order[i]];
	    for (j = 0; j < m; ++j) {
	      s1[j][1] += s1[j][0] = isNaN(s0[j][1]) ? s0[j][0] : s0[j][1];
	    }
	  }
	};
	
	var none$1 = function(series) {
	  var n = series.length, o = new Array(n);
	  while (--n >= 0) o[n] = n;
	  return o;
	};
	
	function stackValue(d, key) {
	  return d[key];
	}
	
	var stack = function() {
	  var keys = constant([]),
	      order = none$1,
	      offset = none,
	      value = stackValue;
	
	  function stack(data) {
	    var kz = keys.apply(this, arguments),
	        i,
	        m = data.length,
	        n = kz.length,
	        sz = new Array(n),
	        oz;
	
	    for (i = 0; i < n; ++i) {
	      for (var ki = kz[i], si = sz[i] = new Array(m), j = 0, sij; j < m; ++j) {
	        si[j] = sij = [0, +value(data[j], ki, j, data)];
	        sij.data = data[j];
	      }
	      si.key = ki;
	    }
	
	    for (i = 0, oz = order(sz); i < n; ++i) {
	      sz[oz[i]].index = i;
	    }
	
	    offset(sz, oz);
	    return sz;
	  }
	
	  stack.keys = function(_) {
	    return arguments.length ? (keys = typeof _ === "function" ? _ : constant(slice.call(_)), stack) : keys;
	  };
	
	  stack.value = function(_) {
	    return arguments.length ? (value = typeof _ === "function" ? _ : constant(+_), stack) : value;
	  };
	
	  stack.order = function(_) {
	    return arguments.length ? (order = _ == null ? none$1 : typeof _ === "function" ? _ : constant(slice.call(_)), stack) : order;
	  };
	
	  stack.offset = function(_) {
	    return arguments.length ? (offset = _ == null ? none : _, stack) : offset;
	  };
	
	  return stack;
	};
	
	var expand = function(series, order) {
	  if (!((n = series.length) > 0)) return;
	  for (var i, n, j = 0, m = series[0].length, y; j < m; ++j) {
	    for (y = i = 0; i < n; ++i) y += series[i][j][1] || 0;
	    if (y) for (i = 0; i < n; ++i) series[i][j][1] /= y;
	  }
	  none(series, order);
	};
	
	var diverging = function(series, order) {
	  if (!((n = series.length) > 1)) return;
	  for (var i, j = 0, d, dy, yp, yn, n, m = series[order[0]].length; j < m; ++j) {
	    for (yp = yn = 0, i = 0; i < n; ++i) {
	      if ((dy = (d = series[order[i]][j])[1] - d[0]) >= 0) {
	        d[0] = yp, d[1] = yp += dy;
	      } else if (dy < 0) {
	        d[1] = yn, d[0] = yn += dy;
	      } else {
	        d[0] = yp;
	      }
	    }
	  }
	};
	
	var silhouette = function(series, order) {
	  if (!((n = series.length) > 0)) return;
	  for (var j = 0, s0 = series[order[0]], n, m = s0.length; j < m; ++j) {
	    for (var i = 0, y = 0; i < n; ++i) y += series[i][j][1] || 0;
	    s0[j][1] += s0[j][0] = -y / 2;
	  }
	  none(series, order);
	};
	
	var wiggle = function(series, order) {
	  if (!((n = series.length) > 0) || !((m = (s0 = series[order[0]]).length) > 0)) return;
	  for (var y = 0, j = 1, s0, m, n; j < m; ++j) {
	    for (var i = 0, s1 = 0, s2 = 0; i < n; ++i) {
	      var si = series[order[i]],
	          sij0 = si[j][1] || 0,
	          sij1 = si[j - 1][1] || 0,
	          s3 = (sij0 - sij1) / 2;
	      for (var k = 0; k < i; ++k) {
	        var sk = series[order[k]],
	            skj0 = sk[j][1] || 0,
	            skj1 = sk[j - 1][1] || 0;
	        s3 += skj0 - skj1;
	      }
	      s1 += sij0, s2 += s3 * sij0;
	    }
	    s0[j - 1][1] += s0[j - 1][0] = y;
	    if (s1) y -= s2 / s1;
	  }
	  s0[j - 1][1] += s0[j - 1][0] = y;
	  none(series, order);
	};
	
	var ascending = function(series) {
	  var sums = series.map(sum);
	  return none$1(series).sort(function(a, b) { return sums[a] - sums[b]; });
	};
	
	function sum(series) {
	  var s = 0, i = -1, n = series.length, v;
	  while (++i < n) if (v = +series[i][1]) s += v;
	  return s;
	}
	
	var descending$1 = function(series) {
	  return ascending(series).reverse();
	};
	
	var insideOut = function(series) {
	  var n = series.length,
	      i,
	      j,
	      sums = series.map(sum),
	      order = none$1(series).sort(function(a, b) { return sums[b] - sums[a]; }),
	      top = 0,
	      bottom = 0,
	      tops = [],
	      bottoms = [];
	
	  for (i = 0; i < n; ++i) {
	    j = order[i];
	    if (top < bottom) {
	      top += sums[j];
	      tops.push(j);
	    } else {
	      bottom += sums[j];
	      bottoms.push(j);
	    }
	  }
	
	  return bottoms.reverse().concat(tops);
	};
	
	var reverse = function(series) {
	  return none$1(series).reverse();
	};
	
	exports.arc = arc;
	exports.area = area;
	exports.line = line;
	exports.pie = pie;
	exports.areaRadial = areaRadial;
	exports.radialArea = areaRadial;
	exports.lineRadial = lineRadial$1;
	exports.radialLine = lineRadial$1;
	exports.pointRadial = pointRadial;
	exports.linkHorizontal = linkHorizontal;
	exports.linkVertical = linkVertical;
	exports.linkRadial = linkRadial;
	exports.symbol = symbol;
	exports.symbols = symbols;
	exports.symbolCircle = circle;
	exports.symbolCross = cross;
	exports.symbolDiamond = diamond;
	exports.symbolSquare = square;
	exports.symbolStar = star;
	exports.symbolTriangle = triangle;
	exports.symbolWye = wye;
	exports.curveBasisClosed = basisClosed;
	exports.curveBasisOpen = basisOpen;
	exports.curveBasis = basis;
	exports.curveBundle = bundle;
	exports.curveCardinalClosed = cardinalClosed;
	exports.curveCardinalOpen = cardinalOpen;
	exports.curveCardinal = cardinal;
	exports.curveCatmullRomClosed = catmullRomClosed;
	exports.curveCatmullRomOpen = catmullRomOpen;
	exports.curveCatmullRom = catmullRom;
	exports.curveLinearClosed = linearClosed;
	exports.curveLinear = curveLinear;
	exports.curveMonotoneX = monotoneX;
	exports.curveMonotoneY = monotoneY;
	exports.curveNatural = natural;
	exports.curveStep = step;
	exports.curveStepAfter = stepAfter;
	exports.curveStepBefore = stepBefore;
	exports.stack = stack;
	exports.stackOffsetExpand = expand;
	exports.stackOffsetDiverging = diverging;
	exports.stackOffsetNone = none;
	exports.stackOffsetSilhouette = silhouette;
	exports.stackOffsetWiggle = wiggle;
	exports.stackOrderAscending = ascending;
	exports.stackOrderDescending = descending$1;
	exports.stackOrderInsideOut = insideOut;
	exports.stackOrderNone = none$1;
	exports.stackOrderReverse = reverse;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 64 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 65 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/auto.fdf031ec.svg";

/***/ },
/* 66 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/bit.f25d35cc.svg";

/***/ },
/* 67 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/cobinhood.106a0828.svg";

/***/ },
/* 68 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/credit.b6f4dedb.svg";

/***/ },
/* 69 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ess.eb297848.svg";

/***/ },
/* 70 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ncash.1aaed2ac.svg";

/***/ },
/* 71 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/orbs-logo.6a8ca935.svg";

/***/ },
/* 72 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/singularity.ebcc3984.svg";

/***/ },
/* 73 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/stacs-logo.d15d7563.svg";

/***/ },
/* 74 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/wandx.e76e6264.svg";

/***/ },
/* 75 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/xyo.81eec9d2.svg";

/***/ },
/* 76 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.locationsAreEqual = exports.createLocation = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _resolvePathname = __webpack_require__(569);
	
	var _resolvePathname2 = _interopRequireDefault(_resolvePathname);
	
	var _valueEqual = __webpack_require__(575);
	
	var _valueEqual2 = _interopRequireDefault(_valueEqual);
	
	var _PathUtils = __webpack_require__(38);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createLocation = exports.createLocation = function createLocation(path, state, key, currentLocation) {
	  var location = void 0;
	  if (typeof path === 'string') {
	    // Two-arg form: push(path, state)
	    location = (0, _PathUtils.parsePath)(path);
	    location.state = state;
	  } else {
	    // One-arg form: push(location)
	    location = _extends({}, path);
	
	    if (location.pathname === undefined) location.pathname = '';
	
	    if (location.search) {
	      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
	    } else {
	      location.search = '';
	    }
	
	    if (location.hash) {
	      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
	    } else {
	      location.hash = '';
	    }
	
	    if (state !== undefined && location.state === undefined) location.state = state;
	  }
	
	  try {
	    location.pathname = decodeURI(location.pathname);
	  } catch (e) {
	    if (e instanceof URIError) {
	      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
	    } else {
	      throw e;
	    }
	  }
	
	  if (key) location.key = key;
	
	  if (currentLocation) {
	    // Resolve incomplete/relative pathname relative to current location.
	    if (!location.pathname) {
	      location.pathname = currentLocation.pathname;
	    } else if (location.pathname.charAt(0) !== '/') {
	      location.pathname = (0, _resolvePathname2.default)(location.pathname, currentLocation.pathname);
	    }
	  } else {
	    // When there is no prior location and pathname is empty, set it to /
	    if (!location.pathname) {
	      location.pathname = '/';
	    }
	  }
	
	  return location;
	};
	
	var locationsAreEqual = exports.locationsAreEqual = function locationsAreEqual(a, b) {
	  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, _valueEqual2.default)(a.state, b.state);
	};

/***/ },
/* 77 */
/***/ function(module, exports, __webpack_require__) {

	var listCacheClear = __webpack_require__(449),
	    listCacheDelete = __webpack_require__(450),
	    listCacheGet = __webpack_require__(451),
	    listCacheHas = __webpack_require__(452),
	    listCacheSet = __webpack_require__(453);
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	module.exports = ListCache;


/***/ },
/* 78 */
/***/ function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(77),
	    stackClear = __webpack_require__(471),
	    stackDelete = __webpack_require__(472),
	    stackGet = __webpack_require__(473),
	    stackHas = __webpack_require__(474),
	    stackSet = __webpack_require__(475);
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  var data = this.__data__ = new ListCache(entries);
	  this.size = data.size;
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	module.exports = Stack;


/***/ },
/* 79 */
/***/ function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(81),
	    eq = __webpack_require__(35);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Assigns `value` to `key` of `object` if the existing value is not equivalent
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignValue(object, key, value) {
	  var objValue = object[key];
	  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	      (value === undefined && !(key in object))) {
	    baseAssignValue(object, key, value);
	  }
	}
	
	module.exports = assignValue;


/***/ },
/* 80 */
/***/ function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(35);
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	module.exports = assocIndexOf;


/***/ },
/* 81 */
/***/ function(module, exports, __webpack_require__) {

	var defineProperty = __webpack_require__(198);
	
	/**
	 * The base implementation of `assignValue` and `assignMergeValue` without
	 * value checks.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function baseAssignValue(object, key, value) {
	  if (key == '__proto__' && defineProperty) {
	    defineProperty(object, key, {
	      'configurable': true,
	      'enumerable': true,
	      'value': value,
	      'writable': true
	    });
	  } else {
	    object[key] = value;
	  }
	}
	
	module.exports = baseAssignValue;


/***/ },
/* 82 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(10);
	
	/** Built-in value references. */
	var objectCreate = Object.create;
	
	/**
	 * The base implementation of `_.create` without support for assigning
	 * properties to the created object.
	 *
	 * @private
	 * @param {Object} proto The object to inherit from.
	 * @returns {Object} Returns the new object.
	 */
	var baseCreate = (function() {
	  function object() {}
	  return function(proto) {
	    if (!isObject(proto)) {
	      return {};
	    }
	    if (objectCreate) {
	      return objectCreate(proto);
	    }
	    object.prototype = proto;
	    var result = new object;
	    object.prototype = undefined;
	    return result;
	  };
	}());
	
	module.exports = baseCreate;


/***/ },
/* 83 */
/***/ function(module, exports, __webpack_require__) {

	var baseForOwn = __webpack_require__(116),
	    createBaseEach = __webpack_require__(417);
	
	/**
	 * The base implementation of `_.forEach` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array|Object} Returns `collection`.
	 */
	var baseEach = createBaseEach(baseForOwn);
	
	module.exports = baseEach;


/***/ },
/* 84 */
/***/ function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(41),
	    toKey = __webpack_require__(42);
	
	/**
	 * The base implementation of `_.get` without support for default values.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @returns {*} Returns the resolved value.
	 */
	function baseGet(object, path) {
	  path = castPath(path, object);
	
	  var index = 0,
	      length = path.length;
	
	  while (object != null && index < length) {
	    object = object[toKey(path[index++])];
	  }
	  return (index && index == length) ? object : undefined;
	}
	
	module.exports = baseGet;


/***/ },
/* 85 */
/***/ function(module, exports) {

	/**
	 * Copies the values of `source` to `array`.
	 *
	 * @private
	 * @param {Array} source The array to copy values from.
	 * @param {Array} [array=[]] The array to copy values to.
	 * @returns {Array} Returns `array`.
	 */
	function copyArray(source, array) {
	  var index = -1,
	      length = source.length;
	
	  array || (array = Array(length));
	  while (++index < length) {
	    array[index] = source[index];
	  }
	  return array;
	}
	
	module.exports = copyArray;


/***/ },
/* 86 */
/***/ function(module, exports, __webpack_require__) {

	var baseCreate = __webpack_require__(82),
	    isObject = __webpack_require__(10);
	
	/**
	 * Creates a function that produces an instance of `Ctor` regardless of
	 * whether it was invoked as part of a `new` expression or by `call` or `apply`.
	 *
	 * @private
	 * @param {Function} Ctor The constructor to wrap.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createCtor(Ctor) {
	  return function() {
	    // Use a `switch` statement to work with class constructors. See
	    // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
	    // for more details.
	    var args = arguments;
	    switch (args.length) {
	      case 0: return new Ctor;
	      case 1: return new Ctor(args[0]);
	      case 2: return new Ctor(args[0], args[1]);
	      case 3: return new Ctor(args[0], args[1], args[2]);
	      case 4: return new Ctor(args[0], args[1], args[2], args[3]);
	      case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
	      case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
	      case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
	    }
	    var thisBinding = baseCreate(Ctor.prototype),
	        result = Ctor.apply(thisBinding, args);
	
	    // Mimic the constructor's `return` behavior.
	    // See https://es5.github.io/#x13.2.2 for more details.
	    return isObject(result) ? result : thisBinding;
	  };
	}
	
	module.exports = createCtor;


/***/ },
/* 87 */
/***/ function(module, exports) {

	/**
	 * Gets the argument placeholder value for `func`.
	 *
	 * @private
	 * @param {Function} func The function to inspect.
	 * @returns {*} Returns the placeholder value.
	 */
	function getHolder(func) {
	  var object = func;
	  return object.placeholder;
	}
	
	module.exports = getHolder;


/***/ },
/* 88 */
/***/ function(module, exports, __webpack_require__) {

	var isKeyable = __webpack_require__(447);
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	module.exports = getMapData;


/***/ },
/* 89 */
/***/ function(module, exports, __webpack_require__) {

	var DataView = __webpack_require__(360),
	    Map = __webpack_require__(110),
	    Promise = __webpack_require__(362),
	    Set = __webpack_require__(175),
	    WeakMap = __webpack_require__(177),
	    baseGetTag = __webpack_require__(30),
	    toSource = __webpack_require__(215);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    setTag = '[object Set]',
	    weakMapTag = '[object WeakMap]';
	
	var dataViewTag = '[object DataView]';
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;
	
	// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = baseGetTag(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : '';
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	module.exports = getTag;


/***/ },
/* 90 */
/***/ function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(35),
	    isArrayLike = __webpack_require__(23),
	    isIndex = __webpack_require__(51),
	    isObject = __webpack_require__(10);
	
	/**
	 * Checks if the given arguments are from an iteratee call.
	 *
	 * @private
	 * @param {*} value The potential iteratee value argument.
	 * @param {*} index The potential iteratee index or key argument.
	 * @param {*} object The potential iteratee object argument.
	 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	 *  else `false`.
	 */
	function isIterateeCall(value, index, object) {
	  if (!isObject(object)) {
	    return false;
	  }
	  var type = typeof index;
	  if (type == 'number'
	        ? (isArrayLike(object) && isIndex(index, object.length))
	        : (type == 'string' && index in object)
	      ) {
	    return eq(object[index], value);
	  }
	  return false;
	}
	
	module.exports = isIterateeCall;


/***/ },
/* 91 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(34);
	
	/* Built-in method references that are verified to be native. */
	var nativeCreate = getNative(Object, 'create');
	
	module.exports = nativeCreate;


/***/ },
/* 92 */
/***/ function(module, exports) {

	/**
	 * Converts `set` to an array of its values.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the values.
	 */
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);
	
	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}
	
	module.exports = setToArray;


/***/ },
/* 93 */
/***/ function(module, exports, __webpack_require__) {

	var baseFlatten = __webpack_require__(184);
	
	/**
	 * Flattens `array` a single level deep.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to flatten.
	 * @returns {Array} Returns the new flattened array.
	 * @example
	 *
	 * _.flatten([1, [2, [3, [4]], 5]]);
	 * // => [1, 2, [3, [4]], 5]
	 */
	function flatten(array) {
	  var length = array == null ? 0 : array.length;
	  return length ? baseFlatten(array, 1) : [];
	}
	
	module.exports = flatten;


/***/ },
/* 94 */
/***/ function(module, exports, __webpack_require__) {

	var baseIndexOf = __webpack_require__(187),
	    isArrayLike = __webpack_require__(23),
	    isString = __webpack_require__(490),
	    toInteger = __webpack_require__(135),
	    values = __webpack_require__(139);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * Checks if `value` is in `collection`. If `collection` is a string, it's
	 * checked for a substring of `value`, otherwise
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * is used for equality comparisons. If `fromIndex` is negative, it's used as
	 * the offset from the end of `collection`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object|string} collection The collection to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} [fromIndex=0] The index to search from.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	 * @returns {boolean} Returns `true` if `value` is found, else `false`.
	 * @example
	 *
	 * _.includes([1, 2, 3], 1);
	 * // => true
	 *
	 * _.includes([1, 2, 3], 1, 2);
	 * // => false
	 *
	 * _.includes({ 'a': 1, 'b': 2 }, 1);
	 * // => true
	 *
	 * _.includes('abcd', 'bc');
	 * // => true
	 */
	function includes(collection, value, fromIndex, guard) {
	  collection = isArrayLike(collection) ? collection : values(collection);
	  fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;
	
	  var length = collection.length;
	  if (fromIndex < 0) {
	    fromIndex = nativeMax(length + fromIndex, 0);
	  }
	  return isString(collection)
	    ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
	    : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
	}
	
	module.exports = includes;


/***/ },
/* 95 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsTypedArray = __webpack_require__(379),
	    baseUnary = __webpack_require__(120),
	    nodeUtil = __webpack_require__(463);
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	module.exports = isTypedArray;


/***/ },
/* 96 */
/***/ function(module, exports, __webpack_require__) {

	var createRange = __webpack_require__(425);
	
	/**
	 * Creates an array of numbers (positive and/or negative) progressing from
	 * `start` up to, but not including, `end`. A step of `-1` is used if a negative
	 * `start` is specified without an `end` or `step`. If `end` is not specified,
	 * it's set to `start` with `start` then set to `0`.
	 *
	 * **Note:** JavaScript follows the IEEE-754 standard for resolving
	 * floating-point values which can produce unexpected results.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {number} [start=0] The start of the range.
	 * @param {number} end The end of the range.
	 * @param {number} [step=1] The value to increment or decrement by.
	 * @returns {Array} Returns the range of numbers.
	 * @see _.inRange, _.rangeRight
	 * @example
	 *
	 * _.range(4);
	 * // => [0, 1, 2, 3]
	 *
	 * _.range(-4);
	 * // => [0, -1, -2, -3]
	 *
	 * _.range(1, 5);
	 * // => [1, 2, 3, 4]
	 *
	 * _.range(0, 20, 5);
	 * // => [0, 5, 10, 15]
	 *
	 * _.range(0, -4, -1);
	 * // => [0, -1, -2, -3]
	 *
	 * _.range(1, 4, 0);
	 * // => [1, 1, 1]
	 *
	 * _.range(0);
	 * // => []
	 */
	var range = createRange();
	
	module.exports = range;


/***/ },
/* 97 */
/***/ function(module, exports, __webpack_require__) {

	var baseDifference = __webpack_require__(371),
	    baseRest = __webpack_require__(33),
	    isArrayLikeObject = __webpack_require__(220);
	
	/**
	 * Creates an array excluding all given values using
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * **Note:** Unlike `_.pull`, this method returns a new array.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to inspect.
	 * @param {...*} [values] The values to exclude.
	 * @returns {Array} Returns the new array of filtered values.
	 * @see _.difference, _.xor
	 * @example
	 *
	 * _.without([2, 1, 2, 3], 1, 2);
	 * // => [3]
	 */
	var without = baseRest(function(array, values) {
	  return isArrayLikeObject(array)
	    ? baseDifference(array, values)
	    : [];
	});
	
	module.exports = without;


/***/ },
/* 98 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/* global console */
	/* eslint-disable no-console */
	
	// TODO: Use "warning" npm module like React is switching to.
	exports.default = {
	  warn: function (message) {
	    if (false) {
	      if (console && console.warn) {
	        console.warn(message);
	      }
	    }
	  }
	};

/***/ },
/* 99 */
/***/ function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ },
/* 100 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	var utils = __webpack_require__(17);
	var normalizeHeaderName = __webpack_require__(286);
	
	var DEFAULT_CONTENT_TYPE = {
	  'Content-Type': 'application/x-www-form-urlencoded'
	};
	
	function setContentTypeIfUnset(headers, value) {
	  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
	    headers['Content-Type'] = value;
	  }
	}
	
	function getDefaultAdapter() {
	  var adapter;
	  if (typeof XMLHttpRequest !== 'undefined') {
	    // For browsers use XHR adapter
	    adapter = __webpack_require__(154);
	  } else if (typeof process !== 'undefined') {
	    // For node use HTTP adapter
	    adapter = __webpack_require__(154);
	  }
	  return adapter;
	}
	
	var defaults = {
	  adapter: getDefaultAdapter(),
	
	  transformRequest: [function transformRequest(data, headers) {
	    normalizeHeaderName(headers, 'Content-Type');
	    if (utils.isFormData(data) ||
	      utils.isArrayBuffer(data) ||
	      utils.isBuffer(data) ||
	      utils.isStream(data) ||
	      utils.isFile(data) ||
	      utils.isBlob(data)
	    ) {
	      return data;
	    }
	    if (utils.isArrayBufferView(data)) {
	      return data.buffer;
	    }
	    if (utils.isURLSearchParams(data)) {
	      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
	      return data.toString();
	    }
	    if (utils.isObject(data)) {
	      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
	      return JSON.stringify(data);
	    }
	    return data;
	  }],
	
	  transformResponse: [function transformResponse(data) {
	    /*eslint no-param-reassign:0*/
	    if (typeof data === 'string') {
	      try {
	        data = JSON.parse(data);
	      } catch (e) { /* Ignore */ }
	    }
	    return data;
	  }],
	
	  timeout: 0,
	
	  xsrfCookieName: 'XSRF-TOKEN',
	  xsrfHeaderName: 'X-XSRF-TOKEN',
	
	  maxContentLength: -1,
	
	  validateStatus: function validateStatus(status) {
	    return status >= 200 && status < 300;
	  }
	};
	
	defaults.headers = {
	  common: {
	    'Accept': 'application/json, text/plain, */*'
	  }
	};
	
	utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
	  defaults.headers[method] = {};
	});
	
	utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
	  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
	});
	
	module.exports = defaults;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(506)))

/***/ },
/* 101 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Aidao = __webpack_require__(47);
	
	var _Aidao2 = _interopRequireDefault(_Aidao);
	
	var _Ethereum = __webpack_require__(48);
	
	var _Ethereum2 = _interopRequireDefault(_Ethereum);
	
	var _cobinhood = __webpack_require__(67);
	
	var _cobinhood2 = _interopRequireDefault(_cobinhood);
	
	var _wandx = __webpack_require__(74);
	
	var _wandx2 = _interopRequireDefault(_wandx);
	
	var _Golem = __webpack_require__(168);
	
	var _Golem2 = _interopRequireDefault(_Golem);
	
	var _fuzex = __webpack_require__(103);
	
	var _fuzex2 = _interopRequireDefault(_fuzex);
	
	var _ncash = __webpack_require__(70);
	
	var _ncash2 = _interopRequireDefault(_ncash);
	
	var _xyo = __webpack_require__(75);
	
	var _xyo2 = _interopRequireDefault(_xyo);
	
	var _bit = __webpack_require__(66);
	
	var _bit2 = _interopRequireDefault(_bit);
	
	var _credit = __webpack_require__(68);
	
	var _credit2 = _interopRequireDefault(_credit);
	
	var _cybermiles = __webpack_require__(102);
	
	var _cybermiles2 = _interopRequireDefault(_cybermiles);
	
	var _ess = __webpack_require__(69);
	
	var _ess2 = _interopRequireDefault(_ess);
	
	var _singularity = __webpack_require__(72);
	
	var _singularity2 = _interopRequireDefault(_singularity);
	
	var _auto = __webpack_require__(65);
	
	var _auto2 = _interopRequireDefault(_auto);
	
	var _stacsLogo = __webpack_require__(73);
	
	var _stacsLogo2 = _interopRequireDefault(_stacsLogo);
	
	var _orbsLogo = __webpack_require__(71);
	
	var _orbsLogo2 = _interopRequireDefault(_orbsLogo);
	
	var _inco = __webpack_require__(104);
	
	var _inco2 = _interopRequireDefault(_inco);
	
	var _mon = __webpack_require__(105);
	
	var _mon2 = _interopRequireDefault(_mon);
	
	var _jquery = __webpack_require__(14);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _axios = __webpack_require__(27);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _qs = __webpack_require__(31);
	
	var _qs2 = _interopRequireDefault(_qs);
	
	var _pending = __webpack_require__(317);
	
	var _pending2 = _interopRequireDefault(_pending);
	
	var _popup = __webpack_require__(28);
	
	var _popup2 = _interopRequireDefault(_popup);
	
	var _fee = __webpack_require__(161);
	
	var _fee2 = _interopRequireDefault(_fee);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SendTransaction = function (_Component) {
	  _inherits(SendTransaction, _Component);
	
	  function SendTransaction() {
	    _classCallCheck(this, SendTransaction);
	
	    return _possibleConstructorReturn(this, (SendTransaction.__proto__ || Object.getPrototypeOf(SendTransaction)).apply(this, arguments));
	  }
	
	  _createClass(SendTransaction, [{
	    key: 'render',
	    value: function render() {
	
	      var data = this.props.data;
	
	      var kyc = window.kyc;
	      var page = this.props.name;
	      var withdraw = this.props.withdraw;
	      var otp = window.otp;
	
	      _axios2.default.defaults.xsrfCookieName = 'csrftoken';
	      _axios2.default.defaults.xsrfHeaderName = 'X-CSRFToken';
	
	      if (otp === "False") {
	        (0, _jquery2.default)(document).ready(function () {
	          (0, _jquery2.default)("#otp-block").css("display", "none");
	        });
	      }
	
	      if (withdraw === "True") {
	        (0, _jquery2.default)(document).ready(function () {
	          (0, _jquery2.default)(".title-send").html(data.withdraw);
	          (0, _jquery2.default)("#sendbutton").html(data.withdraw);
	          (0, _jquery2.default)(".withdraw-warning").css("display", "block");
	          (0, _jquery2.default)("#gas-price-block").css("display", "none");
	        });
	      }
	
	      if (page === "aidao") {
	        (0, _jquery2.default)(document).ready(function () {
	          (0, _jquery2.default)(".token-deduction-warning").css("display", "block");
	        });
	      }
	
	      var rate;
	      if (page === "cobinhood") {
	        rate = (window.cobinhoodprice / window.daoprice).toFixed(2);
	      } else if (page === "cybermiles") {
	        rate = (window.cybermilesprice / window.daoprice).toFixed(2);
	      } else if (page === "wandx") {
	        rate = (window.wandxprice / window.daoprice).toFixed(2);
	      } else if (page === "fuzex") {
	        rate = (window.fuzexprice / window.daoprice).toFixed(2);
	      } else if (page === "xyo") {
	        rate = (window.xyoprice / window.daoprice).toFixed(2);
	      } else if (page === "ncash") {
	        rate = (window.ncashprice / window.daoprice).toFixed(2);
	      } else if (page === "bitrewards") {
	        rate = (window.bitrewardsprice / window.daoprice).toFixed(2);
	      } else if (page === "essentia") {
	        rate = (window.essentiaprice / window.daoprice).toFixed(2);
	      } else if (page === "singularitynet") {
	        rate = (window.agiprice / window.daoprice).toFixed(2);
	      } else if (page === "credits") {
	        rate = (window.creditsprice / window.daoprice).toFixed(2);
	      } else if (page === "autonio") {
	        rate = (window.autonioprice / window.daoprice).toFixed(2);
	      } else if (page === "stacs") {
	        rate = (window.stacsprice / window.daoprice).toFixed(2);
	      } else if (page === "orbs") {
	        rate = (window.orbsprice / window.daoprice).toFixed(2);
	      } else if (page === "incodium") {
	        rate = (window.incodiumprice / window.daoprice).toFixed(2);
	      } else if (page === "moneynet") {
	        rate = (window.moneynetprice / window.daoprice).toFixed(2);
	      }
	
	      var send = function send() {
	        var value = parseFloat((0, _jquery2.default)('#amount-sending').val());
	
	        var words;
	        if (withdraw === "True") {
	          var deduct = value * rate;
	          words = " " + deduct.toString() + " " + data.deductDao + '\n';
	          words += data.fee + _fee2.default[page].toString() + ' ' + page;
	        } else if (page === "aidao") {
	          words = data.deductToken;
	        } else {
	          words = "";
	        }
	
	        if (confirm(data.sendToken + words) === true) {
	
	          if (value < _fee2.default[page]) {
	            alert("Failed. The fee is greater than your withdraw amount.");
	            return;
	          }
	
	          var sendTo = (0, _jquery2.default)('#receiver').val();
	          var otp = (0, _jquery2.default)('#otp-sending').val();
	          var type = page;
	          var promise;
	
	          if (withdraw === "True") {
	            (0, _jquery2.default)("#sendbutton").html(data.submitting);
	            (0, _jquery2.default)('#sendbutton').prop('disabled', true);
	
	            console.log("withdrawing");
	            promise = _axios2.default.post('/api/withdraw', _qs2.default.stringify({
	              "sendTo": sendTo,
	              "value": value,
	              "type": type,
	              "otp": otp
	            }));
	
	            promise.then(function (response) {
	              (0, _jquery2.default)("#sendbutton").html(data.withdraw);
	              (0, _jquery2.default)('#sendbutton').prop('disabled', false);
	              console.log(response.data.status);
	              if (response.data.status === false) {
	                console.log(response.data.message);
	                _popup2.default.prototype.show(response.data.message);
	              } else {
	                console.log(response.data.message);
	                _popup2.default.prototype.show(data.success + "!\n" + response.data.message);
	              }
	            });
	
	            promise.catch(function (error) {
	              _popup2.default.prototype.show(data.failed + ":\n" + error.response.data.message);
	              (0, _jquery2.default)("#sendbutton").html(data.withdraw);
	              (0, _jquery2.default)('#sendbutton').prop('disabled', false);
	            });
	          } else {
	            (0, _jquery2.default)("#sendbutton").html(data.sending);
	            (0, _jquery2.default)('#sendbutton').prop('disabled', true);
	
	            var gasprice = (0, _jquery2.default)('#gas-price').val();
	
	            promise = _axios2.default.post('/api/sendtransaction', _qs2.default.stringify({
	              "sendTo": sendTo,
	              "value": value,
	              "type": type,
	              "otp": otp,
	              "gasprice": gasprice
	            }));
	
	            promise.then(function (response) {
	              var result = response.data;
	              console.log(result);
	
	              (0, _jquery2.default)("#sendbutton").html(data.send);
	              (0, _jquery2.default)('#sendbutton').prop('disabled', false);
	              _popup2.default.prototype.show(data.sentSuccessfully + ":\n" + result.INFO);
	              (0, _jquery2.default)('#receiver').val("");
	              (0, _jquery2.default)('#amount-sending').val("");
	              window.etherbalance = result.balance.ether;
	              window.daobalance = result.balance.aidao;
	
	              // THIS IS OLD
	              window.golembalance = result.balance.golem;
	              window.cobinhoodbalance = result.balance.cobinhood;
	              (0, _jquery2.default)("#etherbalance").html(window.etherbalance);
	              (0, _jquery2.default)("#daobalance").html(window.daobalance);
	              (0, _jquery2.default)("#golembalance").html(window.golembalance);
	              (0, _jquery2.default)("#cobinhoodbalance").html(window.cobinhoodbalance);
	              // UNTIL HERE NEED TO Change
	            });
	
	            promise.catch(function (error) {
	              _popup2.default.prototype.show(data.failed + "\n" + error.response.data.message + "\n" + data.checkPending);
	              (0, _jquery2.default)("#sendbutton").html(data.send);
	              (0, _jquery2.default)('#sendbutton').prop('disabled', false);
	              _pending2.default.prototype.getpending();
	            });
	          }
	        }
	      };
	
	      var title, image;
	      if (page === 'aidao') {
	        // Master User only
	        title = data.daoToken;
	        image = _Aidao2.default;
	      } else if (page === 'ether') {
	        title = "Ether";
	        image = _Ethereum2.default;
	      } else if (page === 'golem') {
	        title = "Golem";
	        image = _Golem2.default;
	      } else if (page === 'cobinhood') {
	        title = "Cobinhood";
	        image = _cobinhood2.default;
	      } else if (page === 'cybermiles') {
	        title = "CyberMiles";
	        image = _cybermiles2.default;
	      } else if (page === 'wandx') {
	        title = "Wandx";
	        image = _wandx2.default;
	      } else if (page === 'fuzex') {
	        title = "FXT";
	        image = _fuzex2.default;
	      } else if (page === 'xyo') {
	        title = "XYO";
	        image = _xyo2.default;
	      } else if (page === 'ncash') {
	        title = "NCash";
	        image = _ncash2.default;
	      } else if (page === 'bitrewards') {
	        title = "BitRewards";
	        image = _bit2.default;
	      } else if (page === 'essentia') {
	        title = "Essentia";
	        image = _ess2.default;
	      } else if (page === 'singularitynet') {
	        title = "Singularity Net";
	        image = _singularity2.default;
	      } else if (page === 'credits') {
	        title = "Credits";
	        image = _credit2.default;
	      } else if (page === 'autonio') {
	        title = "Autonio";
	        image = _auto2.default;
	      } else if (page === 'stacs') {
	        title = "Stacs";
	        image = _stacsLogo2.default;
	      } else if (page === 'orbs') {
	        title = "Orbs";
	        image = _orbsLogo2.default;
	      } else if (page === 'incodium') {
	        title = "Incodium";
	        image = _inco2.default;
	      } else if (page === 'moneynet') {
	        title = "MoneyNet";
	        image = _mon2.default;
	      }
	
	      if (withdraw === "True" && kyc > 2 || withdraw === undefined && kyc > 1) {
	        return _react2.default.createElement(
	          'div',
	          { id: 'con-close-modal', 'class': 'modal fade in', tabIndex: '-1', role: 'dialog', 'aria-labelledby': 'myModalLabel', 'aria-hidden': 'true' },
	          _react2.default.createElement(
	            'div',
	            { 'class': 'modal-dialog' },
	            _react2.default.createElement(
	              'div',
	              { 'class': 'modal-content' },
	              _react2.default.createElement(
	                'div',
	                { 'class': 'modal-header' },
	                _react2.default.createElement(
	                  'button',
	                  { type: 'button', 'class': 'close', 'data-dismiss': 'modal', 'aria-hidden': 'true' },
	                  '\xD7'
	                ),
	                _react2.default.createElement(
	                  'h4',
	                  { 'class': 'modal-title text-left' },
	                  _react2.default.createElement('img', { src: image, 'class': 'token32', alt: 'token icon' }),
	                  '  ',
	                  _react2.default.createElement(
	                    'span',
	                    { 'class': 'title-send' },
	                    data.send
	                  ),
	                  ' ',
	                  title,
	                  ' ',
	                  data.to
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { 'class': 'modal-body' },
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'row withdraw-warning' },
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'col-md-12' },
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'panel panel-color panel-warning' },
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'panel-heading' },
	                        _react2.default.createElement(
	                          'h3',
	                          { 'class': 'panel-title' },
	                          ' ',
	                          data.notice
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'panel-body' },
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          data.withdrawDeductsDao
	                        )
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'row token-deduction-warning' },
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'col-md-12' },
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'panel panel-color panel-warning' },
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'panel-heading' },
	                        _react2.default.createElement(
	                          'h3',
	                          { 'class': 'panel-title' },
	                          ' ',
	                          data.notice
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { 'class': 'panel-body' },
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          data.aidaosendingwarning
	                        )
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'row' },
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'col-md-12' },
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'form-group' },
	                      _react2.default.createElement(
	                        'label',
	                        { 'for': 'field-3', 'class': 'control-label pull-left' },
	                        'To :'
	                      ),
	                      _react2.default.createElement('input', { type: 'text', 'class': 'form-control', id: 'receiver', placeholder: data.address })
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'row' },
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'col-md-12' },
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'form-group' },
	                      _react2.default.createElement(
	                        'label',
	                        { 'for': 'field-3', 'class': 'control-label pull-left' },
	                        'Amount :'
	                      ),
	                      _react2.default.createElement('input', { type: 'text', 'class': 'form-control', id: 'amount-sending', placeholder: data.amount })
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'row', id: 'gas-price-block' },
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'col-md-12' },
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'form-group' },
	                      _react2.default.createElement(
	                        'label',
	                        { 'for': 'field-3', 'class': 'control-label pull-left' },
	                        'Gas Price :'
	                      ),
	                      _react2.default.createElement('input', { type: 'text', 'class': 'form-control', id: 'gas-price', placeholder: data.gwei })
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'row', id: 'otp-block' },
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'col-md-12' },
	                    _react2.default.createElement(
	                      'div',
	                      { 'class': 'form-group' },
	                      _react2.default.createElement(
	                        'label',
	                        { 'for': 'field-3', 'class': 'control-label pull-left' },
	                        'OTP'
	                      ),
	                      _react2.default.createElement('input', { type: 'text', 'class': 'form-control', id: 'otp-sending', placeholder: data.otpcode })
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { 'class': 'modal-footer' },
	                _react2.default.createElement(
	                  'button',
	                  { type: 'button', 'class': 'btn btn-default waves-effect', 'data-dismiss': 'modal' },
	                  data.close
	                ),
	                _react2.default.createElement(
	                  'button',
	                  { type: 'button', id: 'sendbutton', onClick: send, 'class': 'btn btn-info waves-effect waves-light' },
	                  data.send
	                )
	              )
	            )
	          )
	        );
	      } else {
	        return _react2.default.createElement(
	          'div',
	          { id: 'con-close-modal', 'class': 'modal fade in', tabindex: '-1', role: 'dialog', 'aria-labelledby': 'myModalLabel', 'aria-hidden': 'true' },
	          _react2.default.createElement(
	            'div',
	            { 'class': 'modal-dialog' },
	            _react2.default.createElement(
	              'div',
	              { 'class': 'modal-content' },
	              _react2.default.createElement(
	                'div',
	                { 'class': 'modal-header' },
	                _react2.default.createElement(
	                  'button',
	                  { type: 'button', 'class': 'close', 'data-dismiss': 'modal', 'aria-hidden': 'true' },
	                  '\xD7'
	                ),
	                _react2.default.createElement(
	                  'h4',
	                  { 'class': 'modal-title' },
	                  data.kycRequired
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { 'class': 'modal-body' },
	                _react2.default.createElement(
	                  'p',
	                  { 'class': 'textalign' },
	                  data.kycRequiredforTransaction
	                ),
	                _react2.default.createElement(
	                  'p',
	                  { 'class': 'textalign' },
	                  data.daoWalletTeam
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { 'class': 'modal-footer' },
	                _react2.default.createElement(
	                  'button',
	                  { type: 'button', 'class': 'btn btn-default waves-effect', 'data-dismiss': 'modal' },
	                  data.close
	                )
	              )
	            )
	          )
	        );
	      }
	    }
	  }]);
	
	  return SendTransaction;
	}(_react.Component);
	
	exports.default = SendTransaction;

/***/ },
/* 102 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/cybermiles.1f13327f.svg";

/***/ },
/* 103 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/fuzex.fdd2bd68.svg";

/***/ },
/* 104 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/inco.b4779e5c.svg";

/***/ },
/* 105 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/mon.dbfc4941.svg";

/***/ },
/* 106 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _warning = __webpack_require__(20);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createTransitionManager = function createTransitionManager() {
	  var prompt = null;
	
	  var setPrompt = function setPrompt(nextPrompt) {
	    (0, _warning2.default)(prompt == null, 'A history supports only one prompt at a time');
	
	    prompt = nextPrompt;
	
	    return function () {
	      if (prompt === nextPrompt) prompt = null;
	    };
	  };
	
	  var confirmTransitionTo = function confirmTransitionTo(location, action, getUserConfirmation, callback) {
	    // TODO: If another transition starts while we're still confirming
	    // the previous one, we may end up in a weird state. Figure out the
	    // best way to handle this.
	    if (prompt != null) {
	      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;
	
	      if (typeof result === 'string') {
	        if (typeof getUserConfirmation === 'function') {
	          getUserConfirmation(result, callback);
	        } else {
	          (0, _warning2.default)(false, 'A history needs a getUserConfirmation function in order to use a prompt message');
	
	          callback(true);
	        }
	      } else {
	        // Return false from a transition hook to cancel the transition.
	        callback(result !== false);
	      }
	    } else {
	      callback(true);
	    }
	  };
	
	  var listeners = [];
	
	  var appendListener = function appendListener(fn) {
	    var isActive = true;
	
	    var listener = function listener() {
	      if (isActive) fn.apply(undefined, arguments);
	    };
	
	    listeners.push(listener);
	
	    return function () {
	      isActive = false;
	      listeners = listeners.filter(function (item) {
	        return item !== listener;
	      });
	    };
	  };
	
	  var notifyListeners = function notifyListeners() {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    listeners.forEach(function (listener) {
	      return listener.apply(undefined, args);
	    });
	  };
	
	  return {
	    setPrompt: setPrompt,
	    confirmTransitionTo: confirmTransitionTo,
	    appendListener: appendListener,
	    notifyListeners: notifyListeners
	  };
	};
	
	exports.default = createTransitionManager;

/***/ },
/* 107 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * JavaScript Cookie v2.2.0
	 * https://github.com/js-cookie/js-cookie
	 *
	 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
	 * Released under the MIT license
	 */
	;(function (factory) {
		var registeredInModuleLoader = false;
		if (true) {
			!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
			registeredInModuleLoader = true;
		}
		if (true) {
			module.exports = factory();
			registeredInModuleLoader = true;
		}
		if (!registeredInModuleLoader) {
			var OldCookies = window.Cookies;
			var api = window.Cookies = factory();
			api.noConflict = function () {
				window.Cookies = OldCookies;
				return api;
			};
		}
	}(function () {
		function extend () {
			var i = 0;
			var result = {};
			for (; i < arguments.length; i++) {
				var attributes = arguments[ i ];
				for (var key in attributes) {
					result[key] = attributes[key];
				}
			}
			return result;
		}
	
		function init (converter) {
			function api (key, value, attributes) {
				var result;
				if (typeof document === 'undefined') {
					return;
				}
	
				// Write
	
				if (arguments.length > 1) {
					attributes = extend({
						path: '/'
					}, api.defaults, attributes);
	
					if (typeof attributes.expires === 'number') {
						var expires = new Date();
						expires.setMilliseconds(expires.getMilliseconds() + attributes.expires * 864e+5);
						attributes.expires = expires;
					}
	
					// We're using "expires" because "max-age" is not supported by IE
					attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';
	
					try {
						result = JSON.stringify(value);
						if (/^[\{\[]/.test(result)) {
							value = result;
						}
					} catch (e) {}
	
					if (!converter.write) {
						value = encodeURIComponent(String(value))
							.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
					} else {
						value = converter.write(value, key);
					}
	
					key = encodeURIComponent(String(key));
					key = key.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent);
					key = key.replace(/[\(\)]/g, escape);
	
					var stringifiedAttributes = '';
	
					for (var attributeName in attributes) {
						if (!attributes[attributeName]) {
							continue;
						}
						stringifiedAttributes += '; ' + attributeName;
						if (attributes[attributeName] === true) {
							continue;
						}
						stringifiedAttributes += '=' + attributes[attributeName];
					}
					return (document.cookie = key + '=' + value + stringifiedAttributes);
				}
	
				// Read
	
				if (!key) {
					result = {};
				}
	
				// To prevent the for loop in the first place assign an empty array
				// in case there are no cookies at all. Also prevents odd result when
				// calling "get()"
				var cookies = document.cookie ? document.cookie.split('; ') : [];
				var rdecode = /(%[0-9A-Z]{2})+/g;
				var i = 0;
	
				for (; i < cookies.length; i++) {
					var parts = cookies[i].split('=');
					var cookie = parts.slice(1).join('=');
	
					if (!this.json && cookie.charAt(0) === '"') {
						cookie = cookie.slice(1, -1);
					}
	
					try {
						var name = parts[0].replace(rdecode, decodeURIComponent);
						cookie = converter.read ?
							converter.read(cookie, name) : converter(cookie, name) ||
							cookie.replace(rdecode, decodeURIComponent);
	
						if (this.json) {
							try {
								cookie = JSON.parse(cookie);
							} catch (e) {}
						}
	
						if (key === name) {
							result = cookie;
							break;
						}
	
						if (!key) {
							result[name] = cookie;
						}
					} catch (e) {}
				}
	
				return result;
			}
	
			api.set = api;
			api.get = function (key) {
				return api.call(api, key);
			};
			api.getJSON = function () {
				return api.apply({
					json: true
				}, [].slice.call(arguments));
			};
			api.defaults = {};
	
			api.remove = function (key, attributes) {
				api(key, '', extend(attributes, {
					expires: -1
				}));
			};
	
			api.withConverter = init;
	
			return api;
		}
	
		return init(function () {});
	}));


/***/ },
/* 108 */
/***/ function(module, exports, __webpack_require__) {

	var baseCreate = __webpack_require__(82),
	    baseLodash = __webpack_require__(118);
	
	/** Used as references for the maximum length and index of an array. */
	var MAX_ARRAY_LENGTH = 4294967295;
	
	/**
	 * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
	 *
	 * @private
	 * @constructor
	 * @param {*} value The value to wrap.
	 */
	function LazyWrapper(value) {
	  this.__wrapped__ = value;
	  this.__actions__ = [];
	  this.__dir__ = 1;
	  this.__filtered__ = false;
	  this.__iteratees__ = [];
	  this.__takeCount__ = MAX_ARRAY_LENGTH;
	  this.__views__ = [];
	}
	
	// Ensure `LazyWrapper` is an instance of `baseLodash`.
	LazyWrapper.prototype = baseCreate(baseLodash.prototype);
	LazyWrapper.prototype.constructor = LazyWrapper;
	
	module.exports = LazyWrapper;


/***/ },
/* 109 */
/***/ function(module, exports, __webpack_require__) {

	var baseCreate = __webpack_require__(82),
	    baseLodash = __webpack_require__(118);
	
	/**
	 * The base constructor for creating `lodash` wrapper objects.
	 *
	 * @private
	 * @param {*} value The value to wrap.
	 * @param {boolean} [chainAll] Enable explicit method chain sequences.
	 */
	function LodashWrapper(value, chainAll) {
	  this.__wrapped__ = value;
	  this.__actions__ = [];
	  this.__chain__ = !!chainAll;
	  this.__index__ = 0;
	  this.__values__ = undefined;
	}
	
	LodashWrapper.prototype = baseCreate(baseLodash.prototype);
	LodashWrapper.prototype.constructor = LodashWrapper;
	
	module.exports = LodashWrapper;


/***/ },
/* 110 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(34),
	    root = __webpack_require__(15);
	
	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map');
	
	module.exports = Map;


/***/ },
/* 111 */
/***/ function(module, exports, __webpack_require__) {

	var mapCacheClear = __webpack_require__(454),
	    mapCacheDelete = __webpack_require__(455),
	    mapCacheGet = __webpack_require__(456),
	    mapCacheHas = __webpack_require__(457),
	    mapCacheSet = __webpack_require__(458);
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	module.exports = MapCache;


/***/ },
/* 112 */
/***/ function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(111),
	    setCacheAdd = __webpack_require__(468),
	    setCacheHas = __webpack_require__(469);
	
	/**
	 *
	 * Creates an array cache object to store unique values.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var index = -1,
	      length = values == null ? 0 : values.length;
	
	  this.__data__ = new MapCache;
	  while (++index < length) {
	    this.add(values[index]);
	  }
	}
	
	// Add methods to `SetCache`.
	SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	SetCache.prototype.has = setCacheHas;
	
	module.exports = SetCache;


/***/ },
/* 113 */
/***/ function(module, exports, __webpack_require__) {

	var baseIndexOf = __webpack_require__(187);
	
	/**
	 * A specialized version of `_.includes` for arrays without support for
	 * specifying an index to search from.
	 *
	 * @private
	 * @param {Array} [array] The array to inspect.
	 * @param {*} target The value to search for.
	 * @returns {boolean} Returns `true` if `target` is found, else `false`.
	 */
	function arrayIncludes(array, value) {
	  var length = array == null ? 0 : array.length;
	  return !!length && baseIndexOf(array, value, 0) > -1;
	}
	
	module.exports = arrayIncludes;


/***/ },
/* 114 */
/***/ function(module, exports) {

	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	module.exports = arrayPush;


/***/ },
/* 115 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.reduce` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {*} [accumulator] The initial value.
	 * @param {boolean} [initAccum] Specify using the first element of `array` as
	 *  the initial value.
	 * @returns {*} Returns the accumulated value.
	 */
	function arrayReduce(array, iteratee, accumulator, initAccum) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  if (initAccum && length) {
	    accumulator = array[++index];
	  }
	  while (++index < length) {
	    accumulator = iteratee(accumulator, array[index], index, array);
	  }
	  return accumulator;
	}
	
	module.exports = arrayReduce;


/***/ },
/* 116 */
/***/ function(module, exports, __webpack_require__) {

	var baseFor = __webpack_require__(185),
	    keys = __webpack_require__(12);
	
	/**
	 * The base implementation of `_.forOwn` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForOwn(object, iteratee) {
	  return object && baseFor(object, iteratee, keys);
	}
	
	module.exports = baseForOwn;


/***/ },
/* 117 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqualDeep = __webpack_require__(375),
	    isObjectLike = __webpack_require__(24);
	
	/**
	 * The base implementation of `_.isEqual` which supports partial comparisons
	 * and tracks traversed objects.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {boolean} bitmask The bitmask flags.
	 *  1 - Unordered comparison
	 *  2 - Partial comparison
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 */
	function baseIsEqual(value, other, bitmask, customizer, stack) {
	  if (value === other) {
	    return true;
	  }
	  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	    return value !== value && other !== other;
	  }
	  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	}
	
	module.exports = baseIsEqual;


/***/ },
/* 118 */
/***/ function(module, exports) {

	/**
	 * The function whose prototype chain sequence wrappers inherit from.
	 *
	 * @private
	 */
	function baseLodash() {
	  // No operation performed.
	}
	
	module.exports = baseLodash;


/***/ },
/* 119 */
/***/ function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(78),
	    assignMergeValue = __webpack_require__(182),
	    baseFor = __webpack_require__(185),
	    baseMergeDeep = __webpack_require__(384),
	    isObject = __webpack_require__(10),
	    keysIn = __webpack_require__(44);
	
	/**
	 * The base implementation of `_.merge` without support for multiple sources.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @param {number} srcIndex The index of `source`.
	 * @param {Function} [customizer] The function to customize merged values.
	 * @param {Object} [stack] Tracks traversed source values and their merged
	 *  counterparts.
	 */
	function baseMerge(object, source, srcIndex, customizer, stack) {
	  if (object === source) {
	    return;
	  }
	  baseFor(source, function(srcValue, key) {
	    if (isObject(srcValue)) {
	      stack || (stack = new Stack);
	      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
	    }
	    else {
	      var newValue = customizer
	        ? customizer(object[key], srcValue, (key + ''), object, source, stack)
	        : undefined;
	
	      if (newValue === undefined) {
	        newValue = srcValue;
	      }
	      assignMergeValue(object, key, newValue);
	    }
	  }, keysIn);
	}
	
	module.exports = baseMerge;


/***/ },
/* 120 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	module.exports = baseUnary;


/***/ },
/* 121 */
/***/ function(module, exports) {

	/**
	 * Checks if a `cache` value for `key` exists.
	 *
	 * @private
	 * @param {Object} cache The cache to query.
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function cacheHas(cache, key) {
	  return cache.has(key);
	}
	
	module.exports = cacheHas;


/***/ },
/* 122 */
/***/ function(module, exports, __webpack_require__) {

	var Uint8Array = __webpack_require__(176);
	
	/**
	 * Creates a clone of `arrayBuffer`.
	 *
	 * @private
	 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	 * @returns {ArrayBuffer} Returns the cloned array buffer.
	 */
	function cloneArrayBuffer(arrayBuffer) {
	  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	  return result;
	}
	
	module.exports = cloneArrayBuffer;


/***/ },
/* 123 */
/***/ function(module, exports, __webpack_require__) {

	var flatten = __webpack_require__(93),
	    overRest = __webpack_require__(211),
	    setToString = __webpack_require__(129);
	
	/**
	 * A specialized version of `baseRest` which flattens the rest array.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @returns {Function} Returns the new function.
	 */
	function flatRest(func) {
	  return setToString(overRest(func, undefined, flatten), func + '');
	}
	
	module.exports = flatRest;


/***/ },
/* 124 */
/***/ function(module, exports, __webpack_require__) {

	var metaMap = __webpack_require__(209),
	    noop = __webpack_require__(223);
	
	/**
	 * Gets metadata for `func`.
	 *
	 * @private
	 * @param {Function} func The function to query.
	 * @returns {*} Returns the metadata for `func`.
	 */
	var getData = !metaMap ? noop : function(func) {
	  return metaMap.get(func);
	};
	
	module.exports = getData;


/***/ },
/* 125 */
[626, 210],
/* 126 */
/***/ function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__(366),
	    stubArray = __webpack_require__(225);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols;
	
	/**
	 * Creates an array of the own enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	  if (object == null) {
	    return [];
	  }
	  object = Object(object);
	  return arrayFilter(nativeGetSymbols(object), function(symbol) {
	    return propertyIsEnumerable.call(object, symbol);
	  });
	};
	
	module.exports = getSymbols;


/***/ },
/* 127 */
/***/ function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(9),
	    isSymbol = __webpack_require__(57);
	
	/** Used to match property names within property paths. */
	var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	    reIsPlainProp = /^\w*$/;
	
	/**
	 * Checks if `value` is a property name and not a property path.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	 */
	function isKey(value, object) {
	  if (isArray(value)) {
	    return false;
	  }
	  var type = typeof value;
	  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	      value == null || isSymbol(value)) {
	    return true;
	  }
	  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	    (object != null && value in Object(object));
	}
	
	module.exports = isKey;


/***/ },
/* 128 */
/***/ function(module, exports) {

	/**
	 * Converts `map` to its key-value pairs.
	 *
	 * @private
	 * @param {Object} map The map to convert.
	 * @returns {Array} Returns the key-value pairs.
	 */
	function mapToArray(map) {
	  var index = -1,
	      result = Array(map.size);
	
	  map.forEach(function(value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}
	
	module.exports = mapToArray;


/***/ },
/* 129 */
/***/ function(module, exports, __webpack_require__) {

	var baseSetToString = __webpack_require__(393),
	    shortOut = __webpack_require__(214);
	
	/**
	 * Sets the `toString` method of `func` to return `string`.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var setToString = shortOut(baseSetToString);
	
	module.exports = setToString;


/***/ },
/* 130 */
/***/ function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(81),
	    createAggregator = __webpack_require__(416);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates an object composed of keys generated from the results of running
	 * each element of `collection` thru `iteratee`. The order of grouped values
	 * is determined by the order they occur in `collection`. The corresponding
	 * value of each key is an array of elements responsible for generating the
	 * key. The iteratee is invoked with one argument: (value).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	 * @returns {Object} Returns the composed aggregate object.
	 * @example
	 *
	 * _.groupBy([6.1, 4.2, 6.3], Math.floor);
	 * // => { '4': [4.2], '6': [6.1, 6.3] }
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.groupBy(['one', 'two', 'three'], 'length');
	 * // => { '3': ['one', 'two'], '5': ['three'] }
	 */
	var groupBy = createAggregator(function(result, value, key) {
	  if (hasOwnProperty.call(result, key)) {
	    result[key].push(value);
	  } else {
	    baseAssignValue(result, key, [value]);
	  }
	});
	
	module.exports = groupBy;


/***/ },
/* 131 */
/***/ function(module, exports, __webpack_require__) {

	var baseKeys = __webpack_require__(188),
	    getTag = __webpack_require__(89),
	    isArguments = __webpack_require__(54),
	    isArray = __webpack_require__(9),
	    isArrayLike = __webpack_require__(23),
	    isBuffer = __webpack_require__(55),
	    isPrototype = __webpack_require__(52),
	    isTypedArray = __webpack_require__(95);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    setTag = '[object Set]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Checks if `value` is an empty object, collection, map, or set.
	 *
	 * Objects are considered empty if they have no own enumerable string keyed
	 * properties.
	 *
	 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
	 * jQuery-like collections are considered empty if they have a `length` of `0`.
	 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	 * @example
	 *
	 * _.isEmpty(null);
	 * // => true
	 *
	 * _.isEmpty(true);
	 * // => true
	 *
	 * _.isEmpty(1);
	 * // => true
	 *
	 * _.isEmpty([1, 2, 3]);
	 * // => false
	 *
	 * _.isEmpty({ 'a': 1 });
	 * // => false
	 */
	function isEmpty(value) {
	  if (value == null) {
	    return true;
	  }
	  if (isArrayLike(value) &&
	      (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
	        isBuffer(value) || isTypedArray(value) || isArguments(value))) {
	    return !value.length;
	  }
	  var tag = getTag(value);
	  if (tag == mapTag || tag == setTag) {
	    return !value.size;
	  }
	  if (isPrototype(value)) {
	    return !baseKeys(value).length;
	  }
	  for (var key in value) {
	    if (hasOwnProperty.call(value, key)) {
	      return false;
	    }
	  }
	  return true;
	}
	
	module.exports = isEmpty;


/***/ },
/* 132 */
/***/ function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	module.exports = isLength;


/***/ },
/* 133 */
/***/ function(module, exports, __webpack_require__) {

	var baseMerge = __webpack_require__(119),
	    createAssigner = __webpack_require__(50);
	
	/**
	 * This method is like `_.assign` except that it recursively merges own and
	 * inherited enumerable string keyed properties of source objects into the
	 * destination object. Source properties that resolve to `undefined` are
	 * skipped if a destination value exists. Array and plain object properties
	 * are merged recursively. Other objects and value types are overridden by
	 * assignment. Source objects are applied from left to right. Subsequent
	 * sources overwrite property assignments of previous sources.
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.5.0
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @returns {Object} Returns `object`.
	 * @example
	 *
	 * var object = {
	 *   'a': [{ 'b': 2 }, { 'd': 4 }]
	 * };
	 *
	 * var other = {
	 *   'a': [{ 'c': 3 }, { 'e': 5 }]
	 * };
	 *
	 * _.merge(object, other);
	 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
	 */
	var merge = createAssigner(function(object, source, srcIndex) {
	  baseMerge(object, source, srcIndex);
	});
	
	module.exports = merge;


/***/ },
/* 134 */
/***/ function(module, exports, __webpack_require__) {

	var baseProperty = __webpack_require__(388),
	    basePropertyDeep = __webpack_require__(389),
	    isKey = __webpack_require__(127),
	    toKey = __webpack_require__(42);
	
	/**
	 * Creates a function that returns the value at `path` of a given object.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 * @example
	 *
	 * var objects = [
	 *   { 'a': { 'b': 2 } },
	 *   { 'a': { 'b': 1 } }
	 * ];
	 *
	 * _.map(objects, _.property('a.b'));
	 * // => [2, 1]
	 *
	 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	 * // => [1, 2]
	 */
	function property(path) {
	  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	}
	
	module.exports = property;


/***/ },
/* 135 */
/***/ function(module, exports, __webpack_require__) {

	var toFinite = __webpack_require__(226);
	
	/**
	 * Converts `value` to an integer.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted integer.
	 * @example
	 *
	 * _.toInteger(3.2);
	 * // => 3
	 *
	 * _.toInteger(Number.MIN_VALUE);
	 * // => 0
	 *
	 * _.toInteger(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toInteger('3.2');
	 * // => 3
	 */
	function toInteger(value) {
	  var result = toFinite(value),
	      remainder = result % 1;
	
	  return result === result ? (remainder ? result - remainder : result) : 0;
	}
	
	module.exports = toInteger;


/***/ },
/* 136 */
/***/ function(module, exports, __webpack_require__) {

	var baseToString = __webpack_require__(401);
	
	/**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */
	function toString(value) {
	  return value == null ? '' : baseToString(value);
	}
	
	module.exports = toString;


/***/ },
/* 137 */
/***/ function(module, exports, __webpack_require__) {

	var baseUniq = __webpack_require__(190);
	
	/**
	 * Creates a duplicate-free version of an array, using
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons, in which only the first occurrence of each element
	 * is kept. The order of result values is determined by the order they occur
	 * in the array.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to inspect.
	 * @returns {Array} Returns the new duplicate free array.
	 * @example
	 *
	 * _.uniq([2, 1, 2]);
	 * // => [2, 1]
	 */
	function uniq(array) {
	  return (array && array.length) ? baseUniq(array) : [];
	}
	
	module.exports = uniq;


/***/ },
/* 138 */
/***/ function(module, exports, __webpack_require__) {

	var toString = __webpack_require__(136);
	
	/** Used to generate unique IDs. */
	var idCounter = 0;
	
	/**
	 * Generates a unique ID. If `prefix` is given, the ID is appended to it.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {string} [prefix=''] The value to prefix the ID with.
	 * @returns {string} Returns the unique ID.
	 * @example
	 *
	 * _.uniqueId('contact_');
	 * // => 'contact_104'
	 *
	 * _.uniqueId();
	 * // => '105'
	 */
	function uniqueId(prefix) {
	  var id = ++idCounter;
	  return toString(prefix) + id;
	}
	
	module.exports = uniqueId;


/***/ },
/* 139 */
/***/ function(module, exports, __webpack_require__) {

	var baseValues = __webpack_require__(403),
	    keys = __webpack_require__(12);
	
	/**
	 * Creates an array of the own enumerable string keyed property values of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property values.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.values(new Foo);
	 * // => [1, 2] (iteration order is not guaranteed)
	 *
	 * _.values('hi');
	 * // => ['h', 'i']
	 */
	function values(object) {
	  return object == null ? [] : baseValues(object, keys(object));
	}
	
	module.exports = values;


/***/ },
/* 140 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = warning;
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	}

/***/ },
/* 141 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Router = __webpack_require__(142);
	
	var _Router2 = _interopRequireDefault(_Router);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Router2.default; // Written in this round about way for babel-transform-imports

/***/ },
/* 142 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(20);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(21);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for putting history on context.
	 */
	var Router = function (_React$Component) {
	  _inherits(Router, _React$Component);
	
	  function Router() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Router);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      match: _this.computeMatch(_this.props.history.location.pathname)
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Router.prototype.getChildContext = function getChildContext() {
	    return {
	      router: _extends({}, this.context.router, {
	        history: this.props.history,
	        route: {
	          location: this.props.history.location,
	          match: this.state.match
	        }
	      })
	    };
	  };
	
	  Router.prototype.computeMatch = function computeMatch(pathname) {
	    return {
	      path: '/',
	      url: '/',
	      params: {},
	      isExact: pathname === '/'
	    };
	  };
	
	  Router.prototype.componentWillMount = function componentWillMount() {
	    var _this2 = this;
	
	    var _props = this.props,
	        children = _props.children,
	        history = _props.history;
	
	
	    (0, _invariant2.default)(children == null || _react2.default.Children.count(children) === 1, 'A <Router> may have only one child element');
	
	    // Do this here so we can setState when a <Redirect> changes the
	    // location in componentWillMount. This happens e.g. when doing
	    // server rendering using a <StaticRouter>.
	    this.unlisten = history.listen(function () {
	      _this2.setState({
	        match: _this2.computeMatch(history.location.pathname)
	      });
	    });
	  };
	
	  Router.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    (0, _warning2.default)(this.props.history === nextProps.history, 'You cannot change <Router history>');
	  };
	
	  Router.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.unlisten();
	  };
	
	  Router.prototype.render = function render() {
	    var children = this.props.children;
	
	    return children ? _react2.default.Children.only(children) : null;
	  };
	
	  return Router;
	}(_react2.default.Component);
	
	Router.propTypes = {
	  history: _propTypes2.default.object.isRequired,
	  children: _propTypes2.default.node
	};
	Router.contextTypes = {
	  router: _propTypes2.default.object
	};
	Router.childContextTypes = {
	  router: _propTypes2.default.object.isRequired
	};
	exports.default = Router;

/***/ },
/* 143 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _pathToRegexp = __webpack_require__(560);
	
	var _pathToRegexp2 = _interopRequireDefault(_pathToRegexp);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var patternCache = {};
	var cacheLimit = 10000;
	var cacheCount = 0;
	
	var compilePath = function compilePath(pattern, options) {
	  var cacheKey = '' + options.end + options.strict + options.sensitive;
	  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});
	
	  if (cache[pattern]) return cache[pattern];
	
	  var keys = [];
	  var re = (0, _pathToRegexp2.default)(pattern, keys, options);
	  var compiledPattern = { re: re, keys: keys };
	
	  if (cacheCount < cacheLimit) {
	    cache[pattern] = compiledPattern;
	    cacheCount++;
	  }
	
	  return compiledPattern;
	};
	
	/**
	 * Public API for matching a URL pathname to a path pattern.
	 */
	var matchPath = function matchPath(pathname) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  if (typeof options === 'string') options = { path: options };
	
	  var _options = options,
	      _options$path = _options.path,
	      path = _options$path === undefined ? '/' : _options$path,
	      _options$exact = _options.exact,
	      exact = _options$exact === undefined ? false : _options$exact,
	      _options$strict = _options.strict,
	      strict = _options$strict === undefined ? false : _options$strict,
	      _options$sensitive = _options.sensitive,
	      sensitive = _options$sensitive === undefined ? false : _options$sensitive;
	
	  var _compilePath = compilePath(path, { end: exact, strict: strict, sensitive: sensitive }),
	      re = _compilePath.re,
	      keys = _compilePath.keys;
	
	  var match = re.exec(pathname);
	
	  if (!match) return null;
	
	  var url = match[0],
	      values = match.slice(1);
	
	  var isExact = pathname === url;
	
	  if (exact && !isExact) return null;
	
	  return {
	    path: path, // the path pattern used to match
	    url: path === '/' && url === '' ? '/' : url, // the matched portion of the URL
	    isExact: isExact, // whether or not we matched exactly
	    params: keys.reduce(function (memo, key, index) {
	      memo[key.name] = values[index];
	      return memo;
	    }, {})
	  };
	};
	
	exports.default = matchPath;

/***/ },
/* 144 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defaults2 = __webpack_require__(5);
	
	var _defaults3 = _interopRequireDefault(_defaults2);
	
	var _isEqual2 = __webpack_require__(43);
	
	var _isEqual3 = _interopRequireDefault(_isEqual2);
	
	var _isFunction2 = __webpack_require__(7);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _throttle2 = __webpack_require__(59);
	
	var _throttle3 = _interopRequireDefault(_throttle2);
	
	var _assign2 = __webpack_require__(4);
	
	var _assign3 = _interopRequireDefault(_assign2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _victoryCore = __webpack_require__(3);
	
	var _eventHandlers = __webpack_require__(60);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var Helpers = {
	  withinBounds: function (point, bounds, padding) {
	    var x1 = bounds.x1,
	        x2 = bounds.x2,
	        y1 = bounds.y1,
	        y2 = bounds.y2;
	    var x = point.x,
	        y = point.y;
	
	    padding = padding ? padding / 2 : 0;
	    return x + padding >= Math.min(x1, x2) && x - padding <= Math.max(x1, x2) && y + padding >= Math.min(y1, y2) && y - padding <= Math.max(y1, y2);
	  },
	  getDomainBox: function (props, fullDomain, selectedDomain) {
	    var brushDimension = props.brushDimension;
	
	    fullDomain = (0, _defaults3.default)({}, fullDomain, props.domain);
	    selectedDomain = (0, _defaults3.default)({}, selectedDomain, fullDomain);
	    var fullCoords = _victoryCore.Selection.getDomainCoordinates(props, fullDomain);
	    var selectedCoords = _victoryCore.Selection.getDomainCoordinates(props, selectedDomain);
	
	    return {
	      x1: brushDimension !== "y" ? Math.min.apply(Math, _toConsumableArray(selectedCoords.x)) : Math.min.apply(Math, _toConsumableArray(fullCoords.x)),
	      x2: brushDimension !== "y" ? Math.max.apply(Math, _toConsumableArray(selectedCoords.x)) : Math.max.apply(Math, _toConsumableArray(fullCoords.x)),
	      y1: brushDimension !== "x" ? Math.min.apply(Math, _toConsumableArray(selectedCoords.y)) : Math.min.apply(Math, _toConsumableArray(fullCoords.y)),
	      y2: brushDimension !== "x" ? Math.max.apply(Math, _toConsumableArray(selectedCoords.y)) : Math.max.apply(Math, _toConsumableArray(fullCoords.y))
	    };
	  },
	  getHandles: function (props, domainBox) {
	    var x1 = domainBox.x1,
	        x2 = domainBox.x2,
	        y1 = domainBox.y1,
	        y2 = domainBox.y2;
	
	    var minX = Math.min(x1, x2);
	    var maxX = Math.max(x1, x2);
	    var minY = Math.min(y1, y2);
	    var maxY = Math.max(y1, y2);
	    var handleWidth = props.handleWidth / 2;
	    return {
	      left: { x1: minX - handleWidth, x2: minX + handleWidth, y1: y1, y2: y2 },
	      right: { x1: maxX - handleWidth, x2: maxX + handleWidth, y1: y1, y2: y2 },
	      top: { x1: x1, x2: x2, y1: minY + handleWidth, y2: minY - handleWidth },
	      bottom: { x1: x1, x2: x2, y1: maxY + handleWidth, y2: maxY - handleWidth }
	    };
	  },
	  getActiveHandles: function (point, props, domainBox) {
	    var _this = this;
	
	    var handles = this.getHandles(props, domainBox);
	    var activeHandles = ["top", "bottom", "left", "right"].reduce(function (memo, opt) {
	      memo = _this.withinBounds(point, handles[opt]) ? memo.concat(opt) : memo;
	      return memo;
	    }, []);
	    return activeHandles.length && activeHandles;
	  },
	  getResizeMutation: function (box, handles) {
	    var x1 = box.x1,
	        y1 = box.y1,
	        x2 = box.x2,
	        y2 = box.y2;
	
	    var mutations = {
	      left: { x1: Math.max(x1, x2), x2: Math.min(x1, x2), y1: y1, y2: y2 },
	      right: { x1: Math.min(x1, x2), x2: Math.max(x1, x2), y1: y1, y2: y2 },
	      top: { y1: Math.max(y1, y2), y2: Math.min(y1, y2), x1: x1, x2: x2 },
	      bottom: { y1: Math.min(y1, y2), y2: Math.max(y1, y2), x1: x1, x2: x2 }
	    };
	    return handles.reduce(function (memo, current) {
	      return (0, _assign3.default)(memo, mutations[current]);
	    }, {});
	  },
	  getMinimumDomain: function () {
	    return { x: [0, 1 / Number.MAX_SAFE_INTEGER], y: [0, 1 / Number.MAX_SAFE_INTEGER] };
	  },
	  getSelectionMutation: function (point, box, brushDimension) {
	    var x = point.x,
	        y = point.y;
	    var x1 = box.x1,
	        x2 = box.x2,
	        y1 = box.y1,
	        y2 = box.y2;
	
	    return {
	      x1: brushDimension !== "y" ? x : x1,
	      y1: brushDimension !== "x" ? y : y1,
	      x2: brushDimension !== "y" ? x : x2,
	      y2: brushDimension !== "x" ? y : y2
	    };
	  },
	  panBox: function (props, point) {
	    var brushDimension = props.brushDimension,
	        domain = props.domain,
	        startX = props.startX,
	        startY = props.startY;
	
	    var brushDomain = (0, _defaults3.default)({}, props.brushDomain, domain);
	    var fullDomain = (0, _defaults3.default)({}, props.fullDomain, domain);
	
	    var _ref = props.x1 ? props : this.getDomainBox(props, fullDomain, brushDomain),
	        x1 = _ref.x1,
	        x2 = _ref.x2,
	        y1 = _ref.y1,
	        y2 = _ref.y2;
	
	    var x = point.x,
	        y = point.y;
	
	    var delta = {
	      x: startX ? startX - x : 0,
	      y: startY ? startY - y : 0
	    };
	    return {
	      x1: brushDimension !== "y" ? Math.min(x1, x2) - delta.x : Math.min(x1, x2),
	      x2: brushDimension !== "y" ? Math.max(x1, x2) - delta.x : Math.max(x1, x2),
	      y1: brushDimension !== "x" ? Math.min(y1, y2) - delta.y : Math.min(y1, y2),
	      y2: brushDimension !== "x" ? Math.max(y1, y2) - delta.y : Math.max(y1, y2)
	    };
	  },
	  constrainBox: function (box, fullDomainBox) {
	    var x1 = fullDomainBox.x1,
	        y1 = fullDomainBox.y1,
	        x2 = fullDomainBox.x2,
	        y2 = fullDomainBox.y2;
	
	    return {
	      x1: box.x2 > x2 ? x2 - Math.abs(box.x2 - box.x1) : Math.max(box.x1, x1),
	      y1: box.y2 > y2 ? y2 - Math.abs(box.y2 - box.y1) : Math.max(box.y1, y1),
	      x2: box.x1 < x1 ? x1 + Math.abs(box.x2 - box.x1) : Math.min(box.x2, x2),
	      y2: box.y1 < y1 ? y1 + Math.abs(box.y2 - box.y1) : Math.min(box.y2, y2)
	    };
	  },
	  onMouseDown: function (evt, targetProps) {
	    var _this2 = this;
	
	    // eslint-disable-line max-statements
	    evt.preventDefault();
	    var brushDimension = targetProps.brushDimension,
	        handleWidth = targetProps.handleWidth,
	        cachedBrushDomain = targetProps.cachedBrushDomain,
	        domain = targetProps.domain,
	        allowResize = targetProps.allowResize,
	        allowDrag = targetProps.allowDrag;
	
	    // Don't trigger events for static brushes
	
	    if (!allowResize && !allowDrag) {
	      return {};
	    }
	
	    var fullDomainBox = targetProps.fullDomainBox || this.getDomainBox(targetProps, domain);
	
	    var _Selection$getSVGEven = _victoryCore.Selection.getSVGEventCoordinates(evt),
	        x = _Selection$getSVGEven.x,
	        y = _Selection$getSVGEven.y;
	
	    // Ignore events that occur outside of the maximum domain region
	
	
	    if (!this.withinBounds({ x: x, y: y }, fullDomainBox, handleWidth)) {
	      return {};
	    }
	
	    var brushDomain = (0, _defaults3.default)({}, targetProps.brushDomain, domain);
	
	    var currentDomain = (0, _isEqual3.default)(brushDomain, cachedBrushDomain) ? targetProps.currentDomain || brushDomain || domain : brushDomain || domain;
	
	    var domainBox = this.getDomainBox(targetProps, domain, currentDomain);
	
	    var activeHandles = allowResize && this.getActiveHandles({ x: x, y: y }, targetProps, domainBox);
	    // If the event occurs in any of the handle regions, start a resize
	    if (activeHandles) {
	      return [{
	        target: "parent",
	        mutation: function () {
	          return _extends({
	            isSelecting: true, domainBox: domainBox, fullDomainBox: fullDomainBox,
	            cachedBrushDomain: brushDomain, currentDomain: currentDomain
	          }, _this2.getResizeMutation(domainBox, activeHandles));
	        }
	      }];
	    } else if (this.withinBounds({ x: x, y: y }, domainBox) && !(0, _isEqual3.default)(domain, currentDomain)) {
	      // if the event occurs within a selected region start a panning event, unless the whole
	      // domain is selected
	      return [{
	        target: "parent",
	        mutation: function () {
	          return _extends({
	            isPanning: allowDrag, startX: x, startY: y, domainBox: domainBox, fullDomainBox: fullDomainBox, currentDomain: currentDomain,
	            cachedBrushDomain: brushDomain
	          }, domainBox);
	        }
	      }];
	    } else {
	      // if the event occurs outside the region, or if the whole domain is selected,
	      // start a new selection
	      return allowResize ? [{
	        target: "parent",
	        mutation: function () {
	          return _extends({
	            isSelecting: allowResize, domainBox: domainBox, fullDomainBox: fullDomainBox,
	            cachedBrushDomain: brushDomain,
	            currentDomain: _this2.getMinimumDomain()
	          }, _this2.getSelectionMutation({ x: x, y: y }, domainBox, brushDimension));
	        }
	      }] : {};
	    }
	  },
	  onMouseMove: function (evt, targetProps) {
	    // eslint-disable-line max-statements, complexity
	    // if a panning or selection has not been started, ignore the event
	    if (!targetProps.isPanning && !targetProps.isSelecting) {
	      return {};
	    }
	    var brushDimension = targetProps.brushDimension,
	        scale = targetProps.scale,
	        isPanning = targetProps.isPanning,
	        isSelecting = targetProps.isSelecting,
	        fullDomainBox = targetProps.fullDomainBox,
	        onBrushDomainChange = targetProps.onBrushDomainChange,
	        allowResize = targetProps.allowResize,
	        allowDrag = targetProps.allowDrag;
	
	    var _Selection$getSVGEven2 = _victoryCore.Selection.getSVGEventCoordinates(evt),
	        x = _Selection$getSVGEven2.x,
	        y = _Selection$getSVGEven2.y;
	    // Ignore events that occur outside of the maximum domain region
	
	
	    if (!allowResize && !allowDrag || !this.withinBounds({ x: x, y: y }, fullDomainBox)) {
	      return {};
	    }
	    if (allowDrag && isPanning) {
	      var startX = targetProps.startX,
	          startY = targetProps.startY;
	
	      var pannedBox = this.panBox(targetProps, { x: x, y: y });
	      var constrainedBox = this.constrainBox(pannedBox, fullDomainBox);
	      var currentDomain = _victoryCore.Selection.getBounds(_extends({}, constrainedBox, { scale: scale }));
	      var mutatedProps = _extends({
	        currentDomain: currentDomain,
	        startX: pannedBox.x2 >= fullDomainBox.x2 || pannedBox.x1 <= fullDomainBox.x1 ? startX : x,
	        startY: pannedBox.y2 >= fullDomainBox.y2 || pannedBox.y1 <= fullDomainBox.y1 ? startY : y
	      }, constrainedBox);
	
	      if ((0, _isFunction3.default)(onBrushDomainChange)) {
	        onBrushDomainChange(currentDomain, (0, _defaults3.default)({}, mutatedProps, targetProps));
	      }
	      return [{
	        target: "parent",
	        mutation: function () {
	          return mutatedProps;
	        }
	      }];
	    } else if (allowResize && isSelecting) {
	      var x2 = brushDimension !== "y" ? x : targetProps.x2;
	      var y2 = brushDimension !== "x" ? y : targetProps.y2;
	      var _currentDomain = _victoryCore.Selection.getBounds({ x2: x2, y2: y2, x1: targetProps.x1, y1: targetProps.y1, scale: scale });
	
	      var _mutatedProps = { x2: x2, y2: y2, currentDomain: _currentDomain };
	      if ((0, _isFunction3.default)(onBrushDomainChange)) {
	        onBrushDomainChange(_currentDomain, (0, _defaults3.default)({}, _mutatedProps, targetProps));
	      }
	      return [{
	        target: "parent",
	        mutation: function () {
	          return _mutatedProps;
	        }
	      }];
	    }
	    return {};
	  },
	  onMouseUp: function (evt, targetProps) {
	    var x1 = targetProps.x1,
	        y1 = targetProps.y1,
	        x2 = targetProps.x2,
	        y2 = targetProps.y2,
	        onBrushDomainChange = targetProps.onBrushDomainChange,
	        domain = targetProps.domain,
	        allowResize = targetProps.allowResize;
	    // if the mouse hasn't moved since a mouseDown event, select the whole domain region
	
	    if (allowResize && x1 === x2 || y1 === y2) {
	      var mutatedProps = { isPanning: false, isSelecting: false, currentDomain: domain };
	      if ((0, _isFunction3.default)(onBrushDomainChange)) {
	        onBrushDomainChange(domain, (0, _defaults3.default)({}, mutatedProps, targetProps));
	      }
	      return [{
	        target: "parent",
	        mutation: function () {
	          return mutatedProps;
	        }
	      }];
	    }
	    return [{
	      target: "parent",
	      mutation: function () {
	        return { isPanning: false, isSelecting: false };
	      }
	    }];
	  },
	  onMouseLeave: function (evt) {
	    if (evt.target.nodeName === "svg") {
	      return [{
	        target: "parent",
	        mutation: function () {
	          return { isPanning: false, isSelecting: false };
	        }
	      }];
	    }
	    return [];
	  }
	};
	
	exports.default = _extends({}, Helpers, {
	  onMouseDown: Helpers.onMouseDown.bind(Helpers),
	  onMouseUp: Helpers.onMouseUp.bind(Helpers),
	  onMouseLeave: Helpers.onMouseLeave.bind(Helpers),
	  onMouseMove: (0, _throttle3.default)((0, _eventHandlers.attachId)(Helpers.onMouseMove.bind(Helpers)), 16, // eslint-disable-line no-magic-numbers
	  { leading: true, trailing: false })
	});

/***/ },
/* 145 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _merge2 = __webpack_require__(133);
	
	var _merge3 = _interopRequireDefault(_merge2);
	
	var _assign2 = __webpack_require__(4);
	
	var _assign3 = _interopRequireDefault(_assign2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _victoryPortal = __webpack_require__(146);
	
	var _victoryPortal2 = _interopRequireDefault(_victoryPortal);
	
	var _propTypes3 = __webpack_require__(26);
	
	var _propTypes4 = _interopRequireDefault(_propTypes3);
	
	var _collection = __webpack_require__(8);
	
	var _collection2 = _interopRequireDefault(_collection);
	
	var _helpers = __webpack_require__(6);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	var _labelHelpers = __webpack_require__(150);
	
	var _labelHelpers2 = _interopRequireDefault(_labelHelpers);
	
	var _style = __webpack_require__(152);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _log = __webpack_require__(98);
	
	var _log2 = _interopRequireDefault(_log);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var defaultStyles = {
	  fill: "#252525",
	  fontSize: 14,
	  fontFamily: "'Gill Sans', 'Gill Sans MT', 'Ser­avek', 'Trebuchet MS', sans-serif",
	  stroke: "transparent"
	};
	
	var VictoryLabel = function (_React$Component) {
	  _inherits(VictoryLabel, _React$Component);
	
	  function VictoryLabel() {
	    _classCallCheck(this, VictoryLabel);
	
	    return _possibleConstructorReturn(this, (VictoryLabel.__proto__ || Object.getPrototypeOf(VictoryLabel)).apply(this, arguments));
	  }
	
	  _createClass(VictoryLabel, [{
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      this.cacheAttributes(this.calculateAttributes(this.props));
	    }
	  }, {
	    key: "shouldComponentUpdate",
	    value: function shouldComponentUpdate(nextProps) {
	      var attrs = this.calculateAttributes(nextProps);
	      var style = attrs.style,
	          dx = attrs.dx,
	          dy = attrs.dy,
	          x = attrs.x,
	          y = attrs.y,
	          content = attrs.content,
	          lineHeight = attrs.lineHeight,
	          textAnchor = attrs.textAnchor,
	          transform = attrs.transform;
	      var _props = this.props,
	          angle = _props.angle,
	          className = _props.className,
	          datum = _props.datum,
	          active = _props.active;
	
	      if (!_collection2.default.allSetsEqual([[active, nextProps.active], [angle, nextProps.angle], [className, nextProps.className], [x, this.x], [y, this.y], [dx, this.dx], [dy, this.dy], [lineHeight, this.lineHeight], [textAnchor, this.textAnchor], [transform, this.transform], [content, this.content], [style, this.style], [datum, nextProps.datum]])) {
	        this.cacheAttributes(attrs);
	        return true;
	      }
	      return false;
	    }
	  }, {
	    key: "cacheAttributes",
	    value: function cacheAttributes(attrs) {
	      var style = attrs.style,
	          dx = attrs.dx,
	          dy = attrs.dy,
	          x = attrs.x,
	          y = attrs.y,
	          content = attrs.content,
	          textAnchor = attrs.textAnchor,
	          transform = attrs.transform,
	          lineHeight = attrs.lineHeight;
	
	      this.style = style;
	      this.dx = dx;
	      this.dy = dy;
	      this.x = x;
	      this.y = y;
	      this.content = content;
	      this.textAnchor = textAnchor;
	      this.lineHeight = lineHeight;
	      this.transform = transform;
	    }
	  }, {
	    key: "calculateAttributes",
	    value: function calculateAttributes(props) {
	      var style = this.getStyles(props);
	      var lineHeight = this.getHeight(props, "lineHeight");
	      var textAnchor = props.textAnchor ? _helpers2.default.evaluateProp(props.textAnchor, props.datum) : "start";
	      var content = this.getContent(props);
	      var dx = props.dx ? _helpers2.default.evaluateProp(props.dx, props.datum) : 0;
	      var dy = this.getDy(props, style, content, lineHeight);
	      var transform = this.getTransform(props, style);
	      var x = typeof props.x !== "undefined" ? props.x : this.getPosition(props, "x");
	      var y = typeof props.y !== "undefined" ? props.y : this.getPosition(props, "y");
	      return {
	        style: style, dx: dx, dy: dy, content: content, lineHeight: lineHeight, textAnchor: textAnchor, transform: transform, x: x, y: y
	      };
	    }
	  }, {
	    key: "getPosition",
	    value: function getPosition(props, dimension) {
	      if (!props.datum) {
	        return 0;
	      }
	      var scaledPoint = _helpers2.default.scalePoint(props, props.datum);
	      return scaledPoint[dimension];
	    }
	  }, {
	    key: "getStyle",
	    value: function getStyle(props, style) {
	      style = style ? (0, _merge3.default)({}, defaultStyles, style) : defaultStyles;
	      var datum = props.datum || props.data;
	      var baseStyles = _helpers2.default.evaluateStyle(style, datum, props.active);
	      return (0, _assign3.default)({}, baseStyles, { fontSize: this.getFontSize(baseStyles) });
	    }
	  }, {
	    key: "getStyles",
	    value: function getStyles(props) {
	      var _this2 = this;
	
	      return Array.isArray(props.style) ? props.style.map(function (style) {
	        return _this2.getStyle(props, style);
	      }) : [this.getStyle(props, props.style)];
	    }
	  }, {
	    key: "getHeight",
	    value: function getHeight(props, type) {
	      var datum = props.datum || props.data;
	      return _helpers2.default.evaluateProp(props[type], datum, props.active);
	    }
	  }, {
	    key: "getContent",
	    value: function getContent(props) {
	      if (props.text === undefined || props.text === null) {
	        return [" "];
	      }
	      var datum = props.datum || props.data;
	      if (Array.isArray(props.text)) {
	        return props.text.map(function (line) {
	          return _helpers2.default.evaluateProp(line, datum, props.active);
	        });
	      }
	      var child = _helpers2.default.evaluateProp(props.text, datum, props.active);
	      return ("" + child).split("\n");
	    }
	  }, {
	    key: "getDy",
	    value: function getDy(props, style, content, lineHeight) {
	      //eslint-disable-line max-params
	      style = Array.isArray(style) ? style[0] : style;
	      var fontSize = style.fontSize;
	      var datum = props.datum || props.data;
	      var dy = props.dy ? _helpers2.default.evaluateProp(props.dy, datum) : 0;
	      var length = content.length;
	      var capHeight = this.getHeight(props, "capHeight");
	      var verticalAnchor = style.verticalAnchor || props.verticalAnchor;
	      var anchor = verticalAnchor ? _helpers2.default.evaluateProp(verticalAnchor, datum) : "middle";
	      switch (anchor) {
	        case "end":
	          return dy + (capHeight / 2 + (0.5 - length) * lineHeight) * fontSize;
	        case "middle":
	          return dy + (capHeight / 2 + (0.5 - length / 2) * lineHeight) * fontSize;
	        default:
	          return dy + (capHeight / 2 + lineHeight / 2) * fontSize;
	      }
	    }
	  }, {
	    key: "getTransform",
	    value: function getTransform(props, style) {
	      var datum = props.datum,
	          x = props.x,
	          y = props.y,
	          polar = props.polar;
	
	      var defaultAngle = polar ? _labelHelpers2.default.getPolarAngle(props) : 0;
	      var angle = style.angle || props.angle || defaultAngle;
	      var transform = props.transform || style.transform;
	      var transformPart = transform && _helpers2.default.evaluateProp(transform, datum);
	      var rotatePart = angle && { rotate: [angle, x, y] };
	      return transformPart || angle ? _style2.default.toTransformString(transformPart, rotatePart) : undefined;
	    }
	  }, {
	    key: "getFontSize",
	    value: function getFontSize(style) {
	      var baseSize = style && style.fontSize;
	      if (typeof baseSize === "number") {
	        return baseSize;
	      } else if (baseSize === undefined || baseSize === null) {
	        return defaultStyles.fontSize;
	      } else if (typeof baseSize === "string") {
	        var fontSize = +baseSize.replace("px", "");
	        if (!isNaN(fontSize)) {
	          return fontSize;
	        } else {
	          _log2.default.warn("fontSize should be expressed as a number of pixels");
	          return defaultStyles.fontSize;
	        }
	      }
	      return defaultStyles.fontSize;
	    }
	
	    // Overridden in victory-core-native
	
	  }, {
	    key: "renderElements",
	    value: function renderElements(props) {
	      var _this3 = this;
	
	      var textProps = {
	        dx: this.dx, dy: this.dy, x: this.x, y: this.y,
	        transform: this.transform, className: props.className
	      };
	      return _react2.default.createElement(
	        "text",
	        _extends({}, textProps, props.events),
	        this.props.title && _react2.default.createElement(
	          "title",
	          null,
	          this.props.title
	        ),
	        this.props.desc && _react2.default.createElement(
	          "desc",
	          null,
	          this.props.desc
	        ),
	        this.content.map(function (line, i) {
	          var style = _this3.style[i] || _this3.style[0];
	          var lastStyle = _this3.style[i - 1] || _this3.style[0];
	          var fontSize = (style.fontSize + lastStyle.fontSize) / 2;
	          var textAnchor = style.textAnchor || _this3.textAnchor;
	          var dy = i ? _this3.lineHeight * fontSize : undefined;
	          return _react2.default.createElement(
	            "tspan",
	            { key: i, x: props.x, dy: dy, dx: _this3.dx, style: style, textAnchor: textAnchor },
	            line
	          );
	        })
	      );
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var label = this.renderElements(this.props);
	      return this.props.renderInPortal ? _react2.default.createElement(
	        _victoryPortal2.default,
	        null,
	        label
	      ) : label;
	    }
	  }]);
	
	  return VictoryLabel;
	}(_react2.default.Component);
	
	VictoryLabel.displayName = "VictoryLabel";
	VictoryLabel.role = "label";
	VictoryLabel.propTypes = {
	  active: _propTypes2.default.bool,
	  angle: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  capHeight: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes4.default.nonNegative, _propTypes2.default.func]),
	  className: _propTypes2.default.string,
	  data: _propTypes2.default.array,
	  datum: _propTypes2.default.any,
	  desc: _propTypes2.default.string,
	  dx: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string, _propTypes2.default.func]),
	  dy: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string, _propTypes2.default.func]),
	  events: _propTypes2.default.object,
	  index: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  labelPlacement: _propTypes2.default.oneOf(["parallel", "perpendicular", "vertical"]),
	  lineHeight: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes4.default.nonNegative, _propTypes2.default.func]),
	  origin: _propTypes2.default.shape({ x: _propTypes4.default.nonNegative, y: _propTypes4.default.nonNegative }),
	  polar: _propTypes2.default.bool,
	  renderInPortal: _propTypes2.default.bool,
	  scale: _propTypes2.default.shape({ x: _propTypes4.default.scale, y: _propTypes4.default.scale }),
	  style: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.array]),
	  text: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.func, _propTypes2.default.array]),
	  textAnchor: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(["start", "middle", "end", "inherit"]), _propTypes2.default.func]),
	  title: _propTypes2.default.string,
	  transform: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object, _propTypes2.default.func]),
	  verticalAnchor: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(["start", "middle", "end"]), _propTypes2.default.func]),
	  x: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  y: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])
	};
	VictoryLabel.defaultProps = {
	  capHeight: 0.71, // Magic number from d3.
	  lineHeight: 1
	};
	exports.default = VictoryLabel;

/***/ },
/* 146 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _omit2 = __webpack_require__(25);
	
	var _omit3 = _interopRequireDefault(_omit2);
	
	var _defaults2 = __webpack_require__(5);
	
	var _defaults3 = _interopRequireDefault(_defaults2);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _log = __webpack_require__(98);
	
	var _log2 = _interopRequireDefault(_log);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var VictoryPortal = function (_React$Component) {
	  _inherits(VictoryPortal, _React$Component);
	
	  function VictoryPortal() {
	    _classCallCheck(this, VictoryPortal);
	
	    return _possibleConstructorReturn(this, (VictoryPortal.__proto__ || Object.getPrototypeOf(VictoryPortal)).apply(this, arguments));
	  }
	
	  _createClass(VictoryPortal, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      if (!this.checkedContext) {
	        if (typeof this.context.portalUpdate !== "function") {
	          var msg = "`renderInPortal` is not supported outside of `VictoryContainer`. " + "Component will be rendered in place";
	          _log2.default.warn(msg);
	          this.renderInPlace = true;
	        }
	        this.checkedContext = true;
	      }
	      this.forceUpdate();
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate() {
	      if (!this.renderInPlace) {
	        this.portalKey = this.portalKey || this.context.portalRegister();
	        this.context.portalUpdate(this.portalKey, this.element);
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      if (this.context && this.context.portalDeregister) {
	        this.context.portalDeregister(this.portalKey);
	      }
	    }
	
	    // Overridden in victory-core-native
	
	  }, {
	    key: "renderPortal",
	    value: function renderPortal(child) {
	      if (this.renderInPlace) {
	        return child;
	      }
	      this.element = child;
	      return null;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var children = Array.isArray(this.props.children) ? this.props.children[0] : this.props.children;
	      var groupComponent = this.props.groupComponent;
	
	      var childProps = children && children.props || {};
	      var standardProps = childProps.groupComponent ? { groupComponent: groupComponent, standalone: false } : {};
	      var newProps = (0, _defaults3.default)(standardProps, childProps, (0, _omit3.default)(this.props, ["children", "groupComponent"]));
	      var child = children && _react2.default.cloneElement(children, newProps);
	      return this.renderPortal(child);
	    }
	  }]);
	
	  return VictoryPortal;
	}(_react2.default.Component);
	
	VictoryPortal.displayName = "VictoryPortal";
	VictoryPortal.role = "portal";
	VictoryPortal.propTypes = {
	  children: _propTypes2.default.node,
	  groupComponent: _propTypes2.default.element
	};
	VictoryPortal.defaultProps = {
	  groupComponent: _react2.default.createElement("g", null)
	};
	VictoryPortal.contextTypes = {
	  portalDeregister: _propTypes2.default.func,
	  portalRegister: _propTypes2.default.func,
	  portalUpdate: _propTypes2.default.func
	};
	exports.default = VictoryPortal;

/***/ },
/* 147 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _material = __webpack_require__(614);
	
	var _material2 = _interopRequireDefault(_material);
	
	var _grayscale = __webpack_require__(613);
	
	var _grayscale2 = _interopRequireDefault(_grayscale);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  material: _material2.default,
	  grayscale: _grayscale2.default
	};

/***/ },
/* 148 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _sortBy2 = __webpack_require__(58);
	
	var _sortBy3 = _interopRequireDefault(_sortBy2);
	
	var _property2 = __webpack_require__(134);
	
	var _property3 = _interopRequireDefault(_property2);
	
	var _isFunction2 = __webpack_require__(7);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _last2 = __webpack_require__(222);
	
	var _last3 = _interopRequireDefault(_last2);
	
	var _range2 = __webpack_require__(96);
	
	var _range3 = _interopRequireDefault(_range2);
	
	var _uniq2 = __webpack_require__(137);
	
	var _uniq3 = _interopRequireDefault(_uniq2);
	
	var _assign2 = __webpack_require__(4);
	
	var _assign3 = _interopRequireDefault(_assign2);
	
	var _helpers = __webpack_require__(6);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	var _collection = __webpack_require__(8);
	
	var _collection2 = _interopRequireDefault(_collection);
	
	var _scale = __webpack_require__(151);
	
	var _scale2 = _interopRequireDefault(_scale);
	
	var _immutable = __webpack_require__(268);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	exports.default = {
	  // Some keys in each data point need to be converted to plain js
	  immutableDatumWhitelist: {
	    errorX: true,
	    errorY: true
	  },
	
	  /**
	   * Returns an array of formatted data
	   * @param {Object} props: the props object
	   * @returns {Array} an array of data
	   */
	  getData: function (props) {
	    var data = void 0;
	    if (props.data) {
	      if (this.getLength(props.data) < 1) {
	        return [];
	      } else {
	        data = this.formatData(props.data, props);
	      }
	    } else {
	      data = this.formatData(this.generateData(props), props);
	    }
	    return this.addEventKeys(props, data);
	  },
	
	
	  /**
	   * Returns generated data for a given axis based on domain and sample from props
	   * @param {Object} props: the props object
	   * @param {String} axis: the current axis
	   * @returns {Array} an array of data
	   */
	  generateDataArray: function (props, axis) {
	    var propsDomain = props.domain && Array.isArray(props.domain) ? props.domain : props.domain && props.domain[axis];
	    var domain = propsDomain || _scale2.default.getBaseScale(props, axis).domain();
	    var samples = props.samples || 1;
	    var domainMax = Math.max.apply(Math, _toConsumableArray(domain));
	    var domainMin = Math.min.apply(Math, _toConsumableArray(domain));
	    var step = (domainMax - domainMin) / samples;
	    var values = (0, _range3.default)(domainMin, domainMax, step);
	    return (0, _last3.default)(values) === domainMax ? values : values.concat(domainMax);
	  },
	
	
	  /**
	   * Returns generated x and y data based on domain and sample from props
	   * @param {Object} props: the props object
	   * @returns {Array} an array of data
	   */
	  generateData: function (props) {
	    var xValues = this.generateDataArray(props, "x");
	    var yValues = this.generateDataArray(props, "y");
	    var values = xValues.map(function (x, i) {
	      return { x: x, y: yValues[i] };
	    });
	    return values;
	  },
	
	
	  /**
	   * Returns formatted data. Data accessors are applied, and string values are replaced.
	   * @param {Array} dataset: the original domain
	   * @param {Object} props: the props object
	   * @param {Object} stringMap: a mapping of string values to numeric values
	   * @returns {Array} the formatted data
	   */
	  formatData: function (dataset, props, stringMap) {
	    var _this = this;
	
	    var isArrayOrIterable = Array.isArray(dataset) || _immutable2.default.isIterable(dataset);
	    if (!isArrayOrIterable) {
	      return [];
	    }
	
	    stringMap = stringMap || {
	      x: this.createStringMap(props, "x"),
	      y: this.createStringMap(props, "y")
	    };
	
	    var accessor = {
	      x: _helpers2.default.createAccessor(props.x !== undefined ? props.x : "x"),
	      y: _helpers2.default.createAccessor(props.y !== undefined ? props.y : "y"),
	      y0: _helpers2.default.createAccessor(props.y0 !== undefined ? props.y0 : "y0")
	    };
	
	    var data = dataset.reduce(function (dataArr, datum, index) {
	      // eslint-disable-line complexity
	      datum = _this.parseDatum(datum);
	
	      var evaluatedX = datum._x !== undefined ? datum._x : accessor.x(datum);
	      var evaluatedY = datum._y !== undefined ? datum._y : accessor.y(datum);
	      var y0 = datum._y0 !== undefined ? datum._y0 : accessor.y0(datum);
	      var x = evaluatedX !== undefined ? evaluatedX : index;
	      var y = evaluatedY !== undefined ? evaluatedY : datum;
	      var originalValues = y0 === undefined ? { x: x, y: y } : { x: x, y: y, y0: y0 };
	      var privateValues = y0 === undefined ? { _x: x, _y: y } : { _x: x, _y: y, _y0: y0 };
	
	      dataArr.push((0, _assign3.default)(originalValues, datum, privateValues,
	      // map string data to numeric values, and add names
	      typeof x === "string" ? { _x: stringMap.x[x], xName: x } : {}, typeof y === "string" ? { _y: stringMap.y[y], yName: y } : {}, typeof y0 === "string" ? { _y0: stringMap.y[y0], yName: y0 } : {}));
	
	      return dataArr;
	    }, []);
	
	    var sortedData = this.sortData(data, props.sortKey, props.sortOrder);
	
	    return this.cleanData(sortedData, props);
	  },
	
	
	  /**
	   * Returns sorted data. If no sort keys are provided, data is returned unaltered.
	   * Sort key should correspond to the `iteratees` argument in lodash `sortBy` function.
	   * @param {Array} dataset: the original dataset
	   * @param {mixed} sortKey: the sort key. Type is whatever lodash permits for `sortBy`
	   * @param {String} sortOrder: the sort Order - `ascending` (default) or `descending`
	   * @returns {Array} the sorted data
	   */
	  sortData: function (dataset, sortKey) {
	    var sortOrder = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "ascending";
	
	    if (!sortKey) {
	      return dataset;
	    }
	
	    // Ensures previous VictoryLine api for sortKey prop stays consistent
	    if (sortKey === "x" || sortKey === "y") {
	      sortKey = "_" + sortKey;
	    }
	
	    var sortedData = (0, _sortBy3.default)(dataset, sortKey);
	
	    if (sortOrder === "descending") {
	      return sortedData.reverse();
	    }
	
	    return sortedData;
	  },
	
	
	  /**
	   * Returns the cleaned data. Some scale types break when certain data is supplied.
	   * This method will remove data points that break certain scales. So far this method
	   * only removes zeroes for log scales
	   * @param {Array} dataset: the original domain
	   * @param {Object} props: the props object
	   * @returns {Array} the cleaned data
	   */
	  cleanData: function (dataset, props) {
	    var scaleType = {
	      x: _scale2.default.getScaleType(props, "x"),
	      y: _scale2.default.getScaleType(props, "y")
	    };
	    if (scaleType.x !== "log" && scaleType.y !== "log") {
	      return dataset;
	    }
	    var rules = function (datum, axis) {
	      return scaleType[axis] === "log" ? datum["_" + axis] !== 0 : true;
	    };
	    return dataset.filter(function (datum) {
	      return rules(datum, "x") && rules(datum, "y") && rules(datum, "y0");
	    });
	  },
	
	
	  // Returns a data accessor given an eventKey prop
	  getEventKey: function (key) {
	    // creates a data accessor function
	    // given a property key, path, array index, or null for identity.
	    if ((0, _isFunction3.default)(key)) {
	      return key;
	    } else if (key === null || typeof key === "undefined") {
	      return function () {
	        return undefined;
	      };
	    }
	    // otherwise, assume it is an array index, property key or path (_.property handles all three)
	    return (0, _property3.default)(key);
	  },
	
	
	  // Returns data with an eventKey prop added to each datum
	  addEventKeys: function (props, data) {
	    var eventKeyAccessor = this.getEventKey(props.eventKey);
	    return data.map(function (datum, index) {
	      var eventKey = datum.eventKey || eventKeyAccessor(datum) || index;
	      return (0, _assign3.default)({ eventKey: eventKey }, datum);
	    });
	  },
	
	
	  /**
	   * Returns an object mapping string data to numeric data
	   * @param {Object} props: the props object
	   * @param {String} axis: the current axis
	   * @returns {Object} an object mapping string data to numeric data
	   */
	  createStringMap: function (props, axis) {
	    var stringsFromAxes = this.getStringsFromAxes(props, axis);
	    var stringsFromCategories = this.getStringsFromCategories(props, axis);
	    var stringsFromData = this.getStringsFromData(props, axis);
	
	    var allStrings = (0, _uniq3.default)([].concat(_toConsumableArray(stringsFromAxes), _toConsumableArray(stringsFromCategories), _toConsumableArray(stringsFromData)));
	    return allStrings.length === 0 ? null : allStrings.reduce(function (memo, string, index) {
	      memo[string] = index + 1;
	      return memo;
	    }, {});
	  },
	
	
	  /**
	   * Returns an array of strings from data
	   * @param {Object} props: the props object
	   * @param {String} axis: the current axis
	   * @returns {Array} an array of strings
	   */
	  getStringsFromData: function (props, axis) {
	    var _this2 = this;
	
	    var isArrayOrIterable = Array.isArray(props.data) || _immutable2.default.isIterable(props.data);
	    if (!isArrayOrIterable) {
	      return [];
	    }
	
	    var key = typeof props[axis] === "undefined" ? axis : props[axis];
	    var accessor = _helpers2.default.createAccessor(key);
	
	    var dataStrings = props.data.reduce(function (dataArr, datum) {
	      datum = _this2.parseDatum(datum);
	      dataArr.push(accessor(datum));
	      return dataArr;
	    }, []).filter(function (datum) {
	      return typeof datum === "string";
	    });
	
	    // return a unique set of strings
	    return dataStrings.reduce(function (prev, curr) {
	      if (typeof curr !== "undefined" && curr !== null && prev.indexOf(curr) === -1) {
	        prev.push(curr);
	      }
	      return prev;
	    }, []);
	  },
	
	
	  /**
	   * Returns an array of strings from axis tickValues for a given axis
	   * @param {Object} props: the props object
	   * @param {String} axis: the current axis
	   * @returns {Array} an array of strings
	   */
	  getStringsFromAxes: function (props, axis) {
	    var tickValues = props.tickValues,
	        tickFormat = props.tickFormat;
	
	    var tickValueArray = void 0;
	    if (!tickValues || !Array.isArray(tickValues) && !tickValues[axis]) {
	      tickValueArray = tickFormat && Array.isArray(tickFormat) ? tickFormat : [];
	    } else {
	      tickValueArray = tickValues[axis] || tickValues;
	    }
	    return tickValueArray.filter(function (val) {
	      return typeof val === "string";
	    });
	  },
	
	
	  /**
	   * Returns an array of strings from categories for a given axis
	   * @param {Object} props: the props object
	   * @param {String} axis: the current axis
	   * @returns {Array} an array of strings
	   */
	  getStringsFromCategories: function (props, axis) {
	    if (!props.categories) {
	      return [];
	    }
	    var categories = this.getCategories(props, axis);
	    var categoryStrings = categories && categories.filter(function (val) {
	      return typeof val === "string";
	    });
	    return categoryStrings ? _collection2.default.removeUndefined(categoryStrings) : [];
	  },
	
	
	  /**
	   * Returns an array of categories for a given axis
	   * @param {Object} props: the props object
	   * @param {String} axis: the current axis
	   * @returns {Array} an array of categories
	   */
	  getCategories: function (props, axis) {
	    return props.categories && !Array.isArray(props.categories) ? props.categories[axis] : props.categories;
	  },
	
	
	  /**
	   * Reduces the size of a data array, such that it is <= maxPoints.
	   * @param {Array} data: an array of data; must be sorted
	   * @param {Number} maxPoints: maximum number of data points to return
	   * @param {Number} startingIndex: the index of the data[0] *in the entire dataset*; this function
	                     assumes `data` param is a subset of larger dataset that has been zoommed
	   * @returns {Array} an array of data, a subset of data param
	   */
	  downsample: function (data, maxPoints) {
	    var startingIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	
	    // ensures that the downampling of data while zooming looks good.
	    var dataLength = this.getLength(data);
	    if (dataLength > maxPoints) {
	      // limit k to powers of 2, e.g. 64, 128, 256
	      // so that the same points will be chosen reliably, reducing flicker on zoom
	      var k = Math.pow(2, Math.ceil(Math.log2(dataLength / maxPoints)));
	      return data.filter(
	      // ensure modulo is always calculated from same reference: i + startingIndex
	      function (d, i) {
	        return (i + startingIndex) % k === 0;
	      });
	    }
	    return data;
	  },
	  getLength: function (data) {
	    return _immutable2.default.isIterable(data) ? data.size : data.length;
	  },
	  parseDatum: function (datum) {
	    return _immutable2.default.isImmutable(datum) ? _immutable2.default.shallowToJS(datum, this.immutableDatumWhitelist) : datum;
	  }
	};

/***/ },
/* 149 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _without2 = __webpack_require__(97);
	
	var _without3 = _interopRequireDefault(_without2);
	
	var _isFunction2 = __webpack_require__(7);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _isEmpty2 = __webpack_require__(131);
	
	var _isEmpty3 = _interopRequireDefault(_isEmpty2);
	
	var _partial2 = __webpack_require__(495);
	
	var _partial3 = _interopRequireDefault(_partial2);
	
	var _merge2 = __webpack_require__(133);
	
	var _merge3 = _interopRequireDefault(_merge2);
	
	var _extend6 = __webpack_require__(483);
	
	var _extend7 = _interopRequireDefault(_extend6);
	
	var _assign2 = __webpack_require__(4);
	
	var _assign3 = _interopRequireDefault(_assign2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	exports.default = {
	  /* Returns all own and shared events that should be attached to a single target element,
	   * i.e. an individual bar specified by target: "data", eventKey: [index].
	   * Returned events are scoped to the appropriate state. Either that of the component itself
	   * (i.e. VictoryBar) in the case of own events, or that of the parent component
	   * (i.e. VictoryChart) in the case of shared events
	   */
	  getEvents: function (props, target, eventKey, getScopedEvents) {
	    var _this = this;
	
	    // Returns all events that apply to a particular target element
	    var getEventsByTarget = function (events) {
	      var getSelectedEvents = function () {
	        var targetEvents = events.reduce(function (memo, event) {
	          if (event.target !== undefined) {
	            return "" + event.target === "" + target ? memo.concat(event) : memo;
	          }
	          return memo.concat(event);
	        }, []);
	
	        if (eventKey !== undefined && target !== "parent") {
	          return targetEvents.filter(function (obj) {
	            var targetKeys = obj.eventKey;
	            var useKey = function (key) {
	              return key ? "" + key === "" + eventKey : true;
	            };
	            return Array.isArray(targetKeys) ? targetKeys.some(function (k) {
	              return useKey(k);
	            }) : useKey(targetKeys);
	          });
	        }
	        return targetEvents;
	      };
	
	      var selectedEvents = getSelectedEvents();
	      return Array.isArray(selectedEvents) && selectedEvents.reduce(function (memo, event) {
	        return event ? (0, _assign3.default)(memo, event.eventHandlers) : memo;
	      }, {});
	    };
	
	    /* Returns all events from props and defaultEvents from components. Events handlers
	     * specified in props will override handlers for the same event if they are also
	     * specified in defaultEvents of a sub-component
	     */
	    var getAllEvents = function () {
	      if (Array.isArray(_this.componentEvents)) {
	        var _componentEvents;
	
	        return Array.isArray(props.events) ? (_componentEvents = _this.componentEvents).concat.apply(_componentEvents, _toConsumableArray(props.events)) : _this.componentEvents;
	      }
	      return props.events;
	    };
	
	    var allEvents = getAllEvents();
	    var ownEvents = allEvents && (0, _isFunction3.default)(getScopedEvents) ? getScopedEvents(getEventsByTarget(allEvents), target) : undefined;
	    if (!props.sharedEvents) {
	      return ownEvents;
	    }
	    var getSharedEvents = props.sharedEvents.getEvents;
	    var sharedEvents = props.sharedEvents.events && getSharedEvents(getEventsByTarget(props.sharedEvents.events), target);
	    return (0, _assign3.default)({}, sharedEvents, ownEvents);
	  },
	
	
	  /* Returns a modified events object where each event handler is replaced by a new
	   * function that calls the original handler and then calls setState with the return
	   * of the original event handler assigned to state property that maps to the target
	   * element.
	   */
	  getScopedEvents: function (events, namespace, childType, baseProps) {
	    var _this2 = this;
	
	    if ((0, _isEmpty3.default)(events)) {
	      return {};
	    }
	
	    baseProps = baseProps || this.baseProps;
	    // returns the original base props or base state of a given target element
	    var getTargetProps = function (identifier, type) {
	      var childName = identifier.childName,
	          target = identifier.target,
	          key = identifier.key;
	
	      var baseType = type === "props" ? baseProps : _this2.state || {};
	      var base = childName === undefined || childName === null || !baseType[childName] ? baseType : baseType[childName];
	      return key === "parent" ? base.parent : base[key] && base[key][target];
	    };
	
	    // Returns the state object with the mutation caused by a given eventReturn
	    // applied to the appropriate property on the state object
	    var parseEvent = function (eventReturn, eventKey) {
	      var childNames = namespace === "parent" ? eventReturn.childName : eventReturn.childName || childType;
	      var target = eventReturn.target || namespace;
	
	      // returns all eventKeys to modify for a targeted childName
	      var getKeys = function (childName) {
	        if (eventReturn.eventKey === "all") {
	          return baseProps[childName] ? (0, _without3.default)(Object.keys(baseProps[childName]), "parent") : (0, _without3.default)(Object.keys(baseProps), "parent");
	        } else if (eventReturn.eventKey === undefined && eventKey === "parent") {
	          return baseProps[childName] ? Object.keys(baseProps[childName]) : Object.keys(baseProps);
	        }
	        return eventReturn.eventKey !== undefined ? eventReturn.eventKey : eventKey;
	      };
	
	      // returns the state object with mutated props applied for a single key
	      var getMutationObject = function (key, childName) {
	        var nullFunction = function () {
	          return null;
	        };
	        var mutationTargetProps = getTargetProps({ childName: childName, key: key, target: target }, "props");
	        var mutationTargetState = getTargetProps({ childName: childName, key: key, target: target }, "state");
	        var mutation = eventReturn.mutation || nullFunction;
	        var mutatedProps = mutation((0, _assign3.default)({}, mutationTargetProps, mutationTargetState), baseProps);
	        var baseState = _this2.state || {};
	        var childState = baseState[childName] || {};
	        var extendState = function (state) {
	          return target === "parent" ? (0, _extend7.default)(state[key], mutatedProps) : (0, _extend7.default)(state[key], _defineProperty({}, target, mutatedProps));
	        };
	        return childName !== undefined && childName !== null ? (0, _extend7.default)(baseState, _defineProperty({}, childName, (0, _extend7.default)(childState, _defineProperty({}, key, extendState(childState))))) : (0, _extend7.default)(baseState, _defineProperty({}, key, extendState(baseState)));
	      };
	
	      // returns entire mutated state for a given childName
	      var getReturnByChild = function (childName) {
	        var mutationKeys = getKeys(childName);
	        return Array.isArray(mutationKeys) ? mutationKeys.reduce(function (memo, key) {
	          return (0, _assign3.default)(memo, getMutationObject(key, childName));
	        }, {}) : getMutationObject(mutationKeys, childName);
	      };
	
	      // returns an entire mutated state for all children
	      var allChildNames = childNames === "all" ? (0, _without3.default)(Object.keys(baseProps), "parent") : childNames;
	      return Array.isArray(allChildNames) ? allChildNames.reduce(function (memo, childName) {
	        return (0, _assign3.default)(memo, getReturnByChild(childName));
	      }, {}) : getReturnByChild(allChildNames);
	    };
	
	    // Parses an array of event returns into a single state mutation
	    var parseEventReturn = function (eventReturn, eventKey) {
	      return Array.isArray(eventReturn) ? eventReturn.reduce(function (memo, props) {
	        memo = (0, _merge3.default)({}, memo, parseEvent(props, eventKey));
	        return memo;
	      }, {}) : parseEvent(eventReturn, eventKey);
	    };
	
	    var compileCallbacks = function (eventReturn) {
	      var getCallback = function (obj) {
	        return (0, _isFunction3.default)(obj.callback) && obj.callback;
	      };
	      var callbacks = Array.isArray(eventReturn) ? eventReturn.map(function (evtObj) {
	        return getCallback(evtObj);
	      }) : [getCallback(eventReturn)];
	      var callbackArray = callbacks.filter(function (callback) {
	        return callback !== false;
	      });
	      return callbackArray.length ? function () {
	        return callbackArray.forEach(function (callback) {
	          return callback();
	        });
	      } : undefined;
	    };
	
	    // A function that calls a particular event handler, parses its return
	    // into a state mutation, and calls setState
	    var onEvent = function (evt, childProps, eventKey, eventName) {
	      var eventReturn = events[eventName](evt, childProps, eventKey, _this2);
	      if (eventReturn) {
	        var callbacks = compileCallbacks(eventReturn);
	        _this2.setState(parseEventReturn(eventReturn, eventKey), callbacks);
	      }
	    };
	
	    // returns a new events object with enhanced event handlers
	    return Object.keys(events).reduce(function (memo, event) {
	      memo[event] = onEvent;
	      return memo;
	    }, {});
	  },
	
	
	  /* Returns a partially applied event handler for a specific target element
	   * This allows event handlers to have access to props controlling each element
	   */
	  getPartialEvents: function (events, eventKey, childProps) {
	    return events ? Object.keys(events).reduce(function (memo, eventName) {
	      /* eslint max-params: 0 */
	      memo[eventName] = (0, _partial3.default)(events[eventName], _partial3.default.placeholder, // evt will still be the first argument for event handlers
	      childProps, // event handlers will have access to data component props, including data
	      eventKey, // used in setting a unique state property
	      eventName // used in setting a unique state property
	      );
	      return memo;
	    }, {}) : {};
	  },
	
	
	  /* Returns the property of the state object corresponding to event changes for
	   * a particular element
	   */
	  getEventState: function (eventKey, namespace, childType) {
	    var state = this.state || {};
	    if (!childType) {
	      return eventKey === "parent" ? state[eventKey] && state[eventKey][namespace] || state[eventKey] : state[eventKey] && state[eventKey][namespace];
	    }
	    return state[childType] && state[childType][eventKey] && state[childType][eventKey][namespace];
	  },
	
	
	  /* Returns an array of defaultEvents from sub-components of a given component.
	   * i.e. any static `defaultEvents` on `labelComponent` will be returned
	  */
	  getComponentEvents: function (props, components) {
	    var events = Array.isArray(components) && components.reduce(function (memo, componentName) {
	      var _memo;
	
	      var component = props[componentName];
	      var defaultEvents = component && component.type && component.type.defaultEvents;
	      var componentEvents = (0, _isFunction3.default)(defaultEvents) ? defaultEvents(component.props) : defaultEvents;
	      memo = Array.isArray(componentEvents) ? (_memo = memo).concat.apply(_memo, _toConsumableArray(componentEvents)) : memo;
	      return memo;
	    }, []);
	    return events && events.length ? events : undefined;
	  }
	};

/***/ },
/* 150 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _helpers = __webpack_require__(6);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  getText: function (props, datum, index) {
	    if (datum.label !== undefined) {
	      return datum.label;
	    }
	    return Array.isArray(props.labels) ? props.labels[index] : props.labels;
	  },
	  getVerticalAnchor: function (props, datum) {
	    var sign = datum._y >= 0 ? 1 : -1;
	    var labelStyle = props.style && props.style.labels || {};
	    if (datum.getVerticalAnchor || labelStyle.verticalAnchor) {
	      return datum.getVerticalAnchor || labelStyle.verticalAnchor;
	    } else if (!props.horizontal) {
	      return sign >= 0 ? "end" : "start";
	    } else {
	      return "middle";
	    }
	  },
	  getTextAnchor: function (props, datum) {
	    var style = props.style,
	        horizontal = props.horizontal;
	
	    var sign = datum._y >= 0 ? 1 : -1;
	    var labelStyle = style && style.labels || {};
	    if (datum.getVerticalAnchor || labelStyle.verticalAnchor) {
	      return datum.getVerticalAnchor || labelStyle.verticalAnchor;
	    } else if (!horizontal) {
	      return "middle";
	    } else {
	      return sign >= 0 ? "start" : "end";
	    }
	  },
	  getAngle: function (props, datum) {
	    var labelStyle = props.style && props.style.labels || {};
	    return datum.angle || labelStyle.angle;
	  },
	  getPadding: function (props, datum) {
	    var horizontal = props.horizontal,
	        style = props.style,
	        active = props.active;
	
	    var labelStyle = style.labels || {};
	    var defaultPadding = _helpers2.default.evaluateProp(labelStyle.padding, datum, active) || 0;
	    var sign = datum._y < 0 ? -1 : 1;
	    return {
	      x: horizontal ? sign * defaultPadding : 0,
	      y: horizontal ? 0 : sign * defaultPadding
	    };
	  },
	  getPosition: function (props, datum) {
	    var horizontal = props.horizontal,
	        polar = props.polar;
	
	    var _Helpers$scalePoint = _helpers2.default.scalePoint(props, datum),
	        x = _Helpers$scalePoint.x,
	        y = _Helpers$scalePoint.y;
	
	    var padding = this.getPadding(props, datum);
	    if (!polar) {
	      return {
	        x: horizontal ? y + padding.x : x + padding.x,
	        y: horizontal ? x + padding.y : y - padding.y
	      };
	    } else {
	      var polarPadding = this.getPolarPadding(props, datum);
	      return {
	        x: x + polarPadding.x,
	        y: y + polarPadding.y
	      };
	    }
	  },
	  getPolarPadding: function (props, datum) {
	    var active = props.active,
	        style = props.style;
	
	    var degrees = this.getDegrees(props, datum);
	    var labelStyle = style.labels || {};
	    var padding = _helpers2.default.evaluateProp(labelStyle.padding, datum, active) || 0;
	    var angle = _helpers2.default.degreesToRadians(degrees);
	    return {
	      x: padding * Math.cos(angle), y: -padding * Math.sin(angle)
	    };
	  },
	  getLabelPlacement: function (props) {
	    var labelComponent = props.labelComponent,
	        labelPlacement = props.labelPlacement,
	        polar = props.polar;
	
	    var defaultLabelPlacement = polar ? "perpendicular" : "vertical";
	    return labelPlacement ? labelPlacement : labelComponent.props && labelComponent.props.labelPlacement || defaultLabelPlacement;
	  },
	  getPolarOrientation: function (degrees) {
	    if (degrees < 45 || degrees > 315) {
	      // eslint-disable-line no-magic-numbers
	      return "right";
	    } else if (degrees >= 45 && degrees <= 135) {
	      // eslint-disable-line no-magic-numbers
	      return "top";
	    } else if (degrees > 135 && degrees < 225) {
	      // eslint-disable-line no-magic-numbers
	      return "left";
	    } else {
	      return "bottom";
	    }
	  },
	  getPolarTextAnchor: function (props, degrees) {
	    var labelPlacement = this.getLabelPlacement(props);
	    if (labelPlacement === "perpendicular" || labelPlacement === "vertical" && (degrees === 90 || degrees === 270)) {
	      return "middle";
	    }
	    return degrees <= 90 || degrees > 270 ? "start" : "end";
	  },
	  getPolarVerticalAnchor: function (props, degrees) {
	    var labelPlacement = this.getLabelPlacement(props);
	    var orientation = this.getPolarOrientation(degrees);
	    if (labelPlacement === "parallel" || orientation === "left" || orientation === "right") {
	      return "middle";
	    }
	    return orientation === "top" ? "end" : "start";
	  },
	  getPolarAngle: function (props, baseAngle) {
	    var labelPlacement = props.labelPlacement,
	        datum = props.datum;
	
	    if (!labelPlacement || labelPlacement === "vertical") {
	      return 0;
	    }
	    var degrees = baseAngle !== undefined ? baseAngle : this.getDegrees(props, datum);
	    var sign = degrees > 90 && degrees < 180 || degrees > 270 ? 1 : -1;
	    var angle = void 0;
	    if (degrees === 0 || degrees === 180) {
	      angle = 90;
	    } else if (degrees > 0 && degrees < 180) {
	      angle = 90 - degrees;
	    } else if (degrees > 180 && degrees < 360) {
	      angle = 270 - degrees;
	    }
	    var labelRotation = labelPlacement === "perpendicular" ? 0 : 90;
	    return angle + sign * labelRotation;
	  },
	  getDegrees: function (props, datum) {
	    var _Helpers$getPoint = _helpers2.default.getPoint(datum),
	        x = _Helpers$getPoint.x;
	
	    return _helpers2.default.radiansToDegrees(props.scale.x(x));
	  },
	  getProps: function (props, index) {
	    var scale = props.scale,
	        data = props.data,
	        style = props.style,
	        horizontal = props.horizontal,
	        polar = props.polar;
	
	    var datum = data[index];
	    var degrees = this.getDegrees(props, datum);
	    var textAnchor = polar ? this.getPolarTextAnchor(props, degrees) : this.getTextAnchor(props, datum);
	    var verticalAnchor = polar ? this.getPolarVerticalAnchor(props, degrees) : this.getVerticalAnchor(props, datum);
	    var angle = this.getAngle(props, datum);
	    var text = this.getText(props, datum, index);
	    var labelPlacement = this.getLabelPlacement(props);
	
	    var _getPosition = this.getPosition(props, datum),
	        x = _getPosition.x,
	        y = _getPosition.y;
	
	    return {
	      angle: angle, data: data, datum: datum, horizontal: horizontal, index: index, polar: polar, scale: scale, labelPlacement: labelPlacement,
	      text: text, textAnchor: textAnchor, verticalAnchor: verticalAnchor, x: x, y: y, style: style.labels
	    };
	  }
	};

/***/ },
/* 151 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isFunction2 = __webpack_require__(7);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _includes2 = __webpack_require__(94);
	
	var _includes3 = _interopRequireDefault(_includes2);
	
	var _helpers = __webpack_require__(6);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	var _collection = __webpack_require__(8);
	
	var _collection2 = _interopRequireDefault(_collection);
	
	var _d3Scale = __webpack_require__(340);
	
	var d3Scale = _interopRequireWildcard(_d3Scale);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var supportedScaleStrings = ["linear", "time", "log", "sqrt"];
	
	exports.default = {
	  getDefaultScale: function () {
	    return d3Scale.scaleLinear();
	  },
	  toNewName: function (scale) {
	    // d3 scale changed the naming scheme for scale from "linear" -> "scaleLinear" etc.
	    var capitalize = function (s) {
	      return s && s[0].toUpperCase() + s.slice(1);
	    };
	    return "scale" + capitalize(scale);
	  },
	  validScale: function (scale) {
	    if (typeof scale === "function") {
	      return (0, _isFunction3.default)(scale.copy) && (0, _isFunction3.default)(scale.domain) && (0, _isFunction3.default)(scale.range);
	    } else if (typeof scale === "string") {
	      return (0, _includes3.default)(supportedScaleStrings, scale);
	    }
	    return false;
	  },
	  isScaleDefined: function (props, axis) {
	    if (!props.scale) {
	      return false;
	    } else if (props.scale.x || props.scale.y) {
	      return props.scale[axis] ? true : false;
	    }
	    return true;
	  },
	  getScaleTypeFromProps: function (props, axis) {
	    if (!this.isScaleDefined(props, axis)) {
	      return undefined;
	    }
	    var scale = props.scale[axis] || props.scale;
	    return typeof scale === "string" ? scale : this.getType(scale);
	  },
	  getScaleFromProps: function (props, axis) {
	    if (!this.isScaleDefined(props, axis)) {
	      return undefined;
	    }
	    var scale = props.scale[axis] || props.scale;
	
	    if (this.validScale(scale)) {
	      return (0, _isFunction3.default)(scale) ? scale : d3Scale[this.toNewName(scale)]();
	    }
	    return undefined;
	  },
	  getScaleTypeFromData: function (props, axis) {
	    if (!props.data) {
	      return "linear";
	    }
	    var accessor = _helpers2.default.createAccessor(props[axis]);
	    var axisData = props.data.map(accessor);
	    return _collection2.default.containsDates(axisData) ? "time" : "linear";
	  },
	  getBaseScale: function (props, axis) {
	    var scale = this.getScaleFromProps(props, axis);
	    if (scale) {
	      return scale;
	    }
	    var dataScale = this.getScaleTypeFromData(props, axis);
	    return d3Scale[this.toNewName(dataScale)]();
	  },
	  getType: function (scale) {
	    var duckTypes = [{ name: "log", method: "base" }, { name: "ordinal", method: "unknown" }, { name: "pow-sqrt", method: "exponent" }, { name: "quantile", method: "quantiles" }, { name: "quantize-threshold", method: "invertExtent" }];
	    var scaleType = duckTypes.filter(function (type) {
	      return scale[type.method] !== undefined;
	    })[0];
	    return scaleType ? scaleType.name : undefined;
	  },
	  getScaleType: function (props, axis) {
	    // if the scale was not given in props, it will be set to linear or time depending on data
	    return this.getScaleTypeFromProps(props, axis) || this.getScaleTypeFromData(props, axis);
	  }
	};

/***/ },
/* 152 */
/***/ function(module, exports) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * Given an object with CSS/SVG transform definitions, return the string value
	 * for use with the `transform` CSS property or SVG attribute. Note that we
	 * can't always guarantee the order will match the author's intended order, so
	 * authors should only use the object notation if they know that their transform
	 * is commutative or that there is only one.
	 * @param {Object} obj An object of transform definitions.
	 * @returns {String} The generated transform string.
	 */
	var toTransformString = function (obj) {
	  for (var _len = arguments.length, more = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    more[_key - 1] = arguments[_key];
	  }
	
	  if (more.length > 0) {
	    return more.reduce(function (memo, currentObj) {
	      return [memo, toTransformString(currentObj)].join(" ");
	    }, toTransformString(obj));
	  } else {
	    if (!obj || typeof obj === "string") {
	      return obj;
	    }
	    var transforms = [];
	    for (var key in obj) {
	      if (obj.hasOwnProperty(key)) {
	        var value = obj[key];
	        transforms.push(key + "(" + value + ")");
	      }
	    }
	    return transforms.join(" ");
	  }
	};
	
	exports.default = {
	
	  toTransformString: toTransformString,
	
	  /**
	   * Given the name of a color scale, getColorScale will return an array
	   * of 5 hex string values in that color scale. If no 'name' parameter
	   * is given, it will return the Victory default grayscale.
	   * @param {String} name The name of the color scale to return (optional).
	   * @returns {Array} An array of 5 hex string values composing a color scale.
	   */
	  getColorScale: function (name) {
	    var scales = {
	      grayscale: ["#cccccc", "#969696", "#636363", "#252525"],
	      qualitative: ["#334D5C", "#45B29D", "#EFC94C", "#E27A3F", "#DF5A49", "#4F7DA1", "#55DBC1", "#EFDA97", "#E2A37F", "#DF948A"],
	      heatmap: ["#428517", "#77D200", "#D6D305", "#EC8E19", "#C92B05"],
	      warm: ["#940031", "#C43343", "#DC5429", "#FF821D", "#FFAF55"],
	      cool: ["#2746B9", "#0B69D4", "#2794DB", "#31BB76", "#60E83B"],
	      red: ["#FCAE91", "#FB6A4A", "#DE2D26", "#A50F15", "#750B0E"],
	      blue: ["#002C61", "#004B8F", "#006BC9", "#3795E5", "#65B4F4"],
	      green: ["#354722", "#466631", "#649146", "#8AB25C", "#A9C97E"]
	    };
	    return name ? scales[name] : scales.grayscale;
	  }
	};

/***/ },
/* 153 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toString2 = __webpack_require__(136);
	
	var _toString3 = _interopRequireDefault(_toString2);
	
	var _defaults2 = __webpack_require__(5);
	
	var _defaults3 = _interopRequireDefault(_defaults2);
	
	var _merge2 = __webpack_require__(133);
	
	var _merge3 = _interopRequireDefault(_merge2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	// http://www.pearsonified.com/2012/01/characters-per-line.php
	/*eslint-disable no-magic-numbers */
	var fontDictionary = {
	  "American Typewriter": 2.09,
	  "Baskerville": 2.51,
	  "Georgia": 2.27,
	  "Hoefler Text": 2.39,
	  "Palatino": 2.26,
	  "Times New Roman": 2.48,
	  "Arial": 2.26,
	  "Gill Sans": 2.47,
	  "Gill Sans 300": 2.58,
	  "Helvetica Neue": 2.24,
	  "Lucida Grande": 2.05,
	  "Tahoma": 2.25,
	  "Trebuchet MS": 2.2,
	  "Verdana": 1.96,
	  "Courier New": 1.67,
	  "cursive": 1.84,
	  "fantasy": 2.09,
	  "monospace": 1.81,
	  "serif": 2.04,
	  "sans-serif": 1.89
	};
	//https://developer.mozilla.org/en/docs/Web/CSS/length
	// Absolute sizes in pixels for obsolete measurement units.
	var absoluteMeasurementUnitsToPixels = {
	  "mm": 3.8,
	  "sm": 38,
	  "pt": 1.33,
	  "pc": 16,
	  "in": 96,
	  "px": 1
	};
	var relativeMeasurementUnitsCoef = {
	  "em": 1,
	  "ex": 0.5
	};
	
	var coefficients = {
	  averageFontConstant: 2.1675, // Average pixels per glyph in existing font.
	  widthOverlapCoef: 1.25, // Coefficient for width value to prevent overlap.
	  heightOverlapCoef: 1.05, // Coefficient for height value to prevent overlap.
	  lineCapitalCoef: 1.15, // Coefficient for height value. Reserve space for capital chars.
	  lineSpaceHeightCoef: 0.2 // Coefficient for height value. Reserve space between lines.
	};
	var defaultStyle = {
	  lineHeight: 1,
	  letterSpacing: "0px",
	  fontSize: 0,
	  angle: 0,
	  fontFamily: ""
	};
	
	var _degreeToRadian = function (angle) {
	  return angle * Math.PI / 180;
	};
	
	var _getFontCharacterConstant = function (fontFamily) {
	  var firstFont = fontFamily.split(",")[0].replace(/'|"/g, "");
	  return fontDictionary[firstFont] || coefficients.averageFontConstant;
	};
	
	var _splitToLines = function (text) {
	  return Array.isArray(text) ? text : text.toString().split(/\r\n|\r|\n/g);
	};
	
	var _getSizeWithRotate = function (axisSize, dependentSize, angle) {
	  var angleInRadian = _degreeToRadian(angle);
	  return Math.abs(Math.cos(angleInRadian) * axisSize) + Math.abs(Math.sin(angleInRadian) * dependentSize);
	};
	
	/**
	 * Convert length-type parameters from specific measurement units to pixels
	 * @param  {string} length Css length string value.
	 * @param  {number} fontSize Current text font-size.
	 * @returns {number} Approximate Css length in pixels.
	*/
	var convertLengthToPixels = function (length, fontSize) {
	  var attribute = length.match(/[a-zA-Z%]+/)[0];
	  var value = length.match(/[0-9.,]+/);
	  var result = void 0;
	  if (absoluteMeasurementUnitsToPixels.hasOwnProperty(attribute)) {
	    result = value * absoluteMeasurementUnitsToPixels[attribute];
	  } else if (relativeMeasurementUnitsCoef.hasOwnProperty(attribute)) {
	    result = (fontSize ? value * fontSize : value * defaultStyle.fontSize) * relativeMeasurementUnitsCoef[attribute];
	  } else {
	    result = value;
	  }
	  return result;
	};
	
	var _prepareParams = function (inputStyle, index) {
	  var lineStyle = Array.isArray(inputStyle) ? inputStyle[index] : inputStyle;
	  var style = (0, _defaults3.default)({}, lineStyle, defaultStyle);
	  return (0, _merge3.default)({}, style, {
	    characterConstant: style.characterConstant || _getFontCharacterConstant(style.fontFamily),
	    letterSpacing: convertLengthToPixels(style.letterSpacing, style.fontSize),
	    fontSize: typeof style.fontSize === "number" ? style.fontSize : convertLengthToPixels(String(style.fontSize))
	  });
	};
	
	var _approximateTextWidthInternal = function (text, style) {
	  var widths = _splitToLines(text).map(function (line, index) {
	    var len = line.toString().length;
	
	    var _prepareParams2 = _prepareParams(style, index),
	        fontSize = _prepareParams2.fontSize,
	        characterConstant = _prepareParams2.characterConstant,
	        letterSpacing = _prepareParams2.letterSpacing;
	
	    return len * fontSize / characterConstant + letterSpacing * Math.max(len - 1, 0);
	  });
	  return Math.max.apply(Math, _toConsumableArray(widths));
	};
	
	var _approximateTextHeightInternal = function (text, style) {
	  return _splitToLines(text).reduce(function (total, line, index) {
	    var lineStyle = _prepareParams(style, index);
	    var containsCaps = (0, _toString3.default)(line).match(/[(A-Z)(0-9)]/);
	    var height = containsCaps ? lineStyle.fontSize * coefficients.lineCapitalCoef : lineStyle.fontSize;
	    var emptySpace = index === 0 ? 0 : lineStyle.fontSize * coefficients.lineSpaceHeightCoef;
	    return total + lineStyle.lineHeight * (height + emptySpace);
	  }, 0);
	};
	
	/**
	 * Predict text size by font params.
	 * @param {string} text Content for width calculation.
	 * @param {Object} style Text styles, ,fontFamily, fontSize, etc.
	 * @param {string} style.fontFamily Text fontFamily.
	 * @param {(number|string)} style.fontSize Text fontSize.
	 * @param {number} style.angle Text rotate angle.
	 * @param {string} style.letterSpacing Text letterSpacing(space between letters).
	 * @param {number} style.characterConstant Average pixels per glyph.
	 * @param {number} style.lineHeight Line height coefficient.
	 * @returns {number} Approximate text label height.
	*/
	var approximateTextSize = function (text, style) {
	  var angle = Array.isArray(style) ? style[0] && style[0].angle : style && style.angle;
	  var height = _approximateTextHeightInternal(text, style);
	  var width = _approximateTextWidthInternal(text, style);
	  var widthWithRotate = angle ? _getSizeWithRotate(width, height, angle) : width;
	  var heightWithRotate = angle ? _getSizeWithRotate(height, width, angle) : height;
	  return {
	    width: widthWithRotate * coefficients.widthOverlapCoef,
	    height: heightWithRotate * coefficients.heightOverlapCoef
	  };
	};
	
	exports.default = {
	  approximateTextSize: approximateTextSize,
	  convertLengthToPixels: convertLengthToPixels
	};

/***/ },
/* 154 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(17);
	var settle = __webpack_require__(278);
	var buildURL = __webpack_require__(281);
	var parseHeaders = __webpack_require__(287);
	var isURLSameOrigin = __webpack_require__(285);
	var createError = __webpack_require__(157);
	var btoa = (typeof window !== 'undefined' && window.btoa && window.btoa.bind(window)) || __webpack_require__(280);
	
	module.exports = function xhrAdapter(config) {
	  return new Promise(function dispatchXhrRequest(resolve, reject) {
	    var requestData = config.data;
	    var requestHeaders = config.headers;
	
	    if (utils.isFormData(requestData)) {
	      delete requestHeaders['Content-Type']; // Let the browser set it
	    }
	
	    var request = new XMLHttpRequest();
	    var loadEvent = 'onreadystatechange';
	    var xDomain = false;
	
	    // For IE 8/9 CORS support
	    // Only supports POST and GET calls and doesn't returns the response headers.
	    // DON'T do this for testing b/c XMLHttpRequest is mocked, not XDomainRequest.
	    if (!window.XMLHttpRequest &&
	        ("production") !== 'test' &&
	        typeof window !== 'undefined' &&
	        window.XDomainRequest && !('withCredentials' in request) &&
	        !isURLSameOrigin(config.url)) {
	      request = new window.XDomainRequest();
	      loadEvent = 'onload';
	      xDomain = true;
	      request.onprogress = function handleProgress() {};
	      request.ontimeout = function handleTimeout() {};
	    }
	
	    // HTTP basic authentication
	    if (config.auth) {
	      var username = config.auth.username || '';
	      var password = config.auth.password || '';
	      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
	    }
	
	    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);
	
	    // Set the request timeout in MS
	    request.timeout = config.timeout;
	
	    // Listen for ready state
	    request[loadEvent] = function handleLoad() {
	      if (!request || (request.readyState !== 4 && !xDomain)) {
	        return;
	      }
	
	      // The request errored out and we didn't get a response, this will be
	      // handled by onerror instead
	      // With one exception: request that using file: protocol, most browsers
	      // will return status as 0 even though it's a successful request
	      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
	        return;
	      }
	
	      // Prepare the response
	      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
	      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
	      var response = {
	        data: responseData,
	        // IE sends 1223 instead of 204 (https://github.com/axios/axios/issues/201)
	        status: request.status === 1223 ? 204 : request.status,
	        statusText: request.status === 1223 ? 'No Content' : request.statusText,
	        headers: responseHeaders,
	        config: config,
	        request: request
	      };
	
	      settle(resolve, reject, response);
	
	      // Clean up request
	      request = null;
	    };
	
	    // Handle low level network errors
	    request.onerror = function handleError() {
	      // Real errors are hidden from us by the browser
	      // onerror should only fire if it's a network error
	      reject(createError('Network Error', config, null, request));
	
	      // Clean up request
	      request = null;
	    };
	
	    // Handle timeout
	    request.ontimeout = function handleTimeout() {
	      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED',
	        request));
	
	      // Clean up request
	      request = null;
	    };
	
	    // Add xsrf header
	    // This is only done if running in a standard browser environment.
	    // Specifically not if we're in a web worker, or react-native.
	    if (utils.isStandardBrowserEnv()) {
	      var cookies = __webpack_require__(283);
	
	      // Add xsrf header
	      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
	          cookies.read(config.xsrfCookieName) :
	          undefined;
	
	      if (xsrfValue) {
	        requestHeaders[config.xsrfHeaderName] = xsrfValue;
	      }
	    }
	
	    // Add headers to the request
	    if ('setRequestHeader' in request) {
	      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
	        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
	          // Remove Content-Type if data is undefined
	          delete requestHeaders[key];
	        } else {
	          // Otherwise add header to the request
	          request.setRequestHeader(key, val);
	        }
	      });
	    }
	
	    // Add withCredentials to request if needed
	    if (config.withCredentials) {
	      request.withCredentials = true;
	    }
	
	    // Add responseType to request if needed
	    if (config.responseType) {
	      try {
	        request.responseType = config.responseType;
	      } catch (e) {
	        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
	        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
	        if (config.responseType !== 'json') {
	          throw e;
	        }
	      }
	    }
	
	    // Handle progress if needed
	    if (typeof config.onDownloadProgress === 'function') {
	      request.addEventListener('progress', config.onDownloadProgress);
	    }
	
	    // Not all browsers support upload events
	    if (typeof config.onUploadProgress === 'function' && request.upload) {
	      request.upload.addEventListener('progress', config.onUploadProgress);
	    }
	
	    if (config.cancelToken) {
	      // Handle cancellation
	      config.cancelToken.promise.then(function onCanceled(cancel) {
	        if (!request) {
	          return;
	        }
	
	        request.abort();
	        reject(cancel);
	        // Clean up request
	        request = null;
	      });
	    }
	
	    if (requestData === undefined) {
	      requestData = null;
	    }
	
	    // Send the request
	    request.send(requestData);
	  });
	};


/***/ },
/* 155 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * A `Cancel` is an object that is thrown when an operation is canceled.
	 *
	 * @class
	 * @param {string=} message The message.
	 */
	function Cancel(message) {
	  this.message = message;
	}
	
	Cancel.prototype.toString = function toString() {
	  return 'Cancel' + (this.message ? ': ' + this.message : '');
	};
	
	Cancel.prototype.__CANCEL__ = true;
	
	module.exports = Cancel;


/***/ },
/* 156 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function isCancel(value) {
	  return !!(value && value.__CANCEL__);
	};


/***/ },
/* 157 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var enhanceError = __webpack_require__(277);
	
	/**
	 * Create an Error with the specified message, config, error code, request and response.
	 *
	 * @param {string} message The error message.
	 * @param {Object} config The config.
	 * @param {string} [code] The error code (for example, 'ECONNABORTED').
	 * @param {Object} [request] The request.
	 * @param {Object} [response] The response.
	 * @returns {Error} The created error.
	 */
	module.exports = function createError(message, config, code, request, response) {
	  var error = new Error(message);
	  return enhanceError(error, config, code, request, response);
	};


/***/ },
/* 158 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function bind(fn, thisArg) {
	  return function wrap() {
	    var args = new Array(arguments.length);
	    for (var i = 0; i < args.length; i++) {
	      args[i] = arguments[i];
	    }
	    return fn.apply(thisArg, args);
	  };
	};


/***/ },
/* 159 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _settings = __webpack_require__(334);
	
	var _settings2 = _interopRequireDefault(_settings);
	
	var _Aidao = __webpack_require__(47);
	
	var _Aidao2 = _interopRequireDefault(_Aidao);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DAOLevel = function (_Component) {
	    _inherits(DAOLevel, _Component);
	
	    function DAOLevel() {
	        _classCallCheck(this, DAOLevel);
	
	        return _possibleConstructorReturn(this, (DAOLevel.__proto__ || Object.getPrototypeOf(DAOLevel)).apply(this, arguments));
	    }
	
	    _createClass(DAOLevel, [{
	        key: 'render',
	        value: function render() {
	            var data = this.props.data;
	
	            var daobalance = parseFloat(window.daobalance);
	            var max, level;
	
	            for (var i = 1; i < 11; i++) {
	                var current_level = _settings2.default.daolevel[i.toString()];
	                if (current_level > daobalance) {
	                    max = current_level;
	                    level = data.level + i.toString();
	                    break;
	                } else if (i === 10) {
	                    max = daobalance;
	                    level = data.level + i.toString();
	                }
	            }
	
	            var bar_style = {
	                width: parseInt(daobalance / max * 100).toString() + "%"
	            };
	
	            return _react2.default.createElement(
	                'div',
	                { 'class': 'widget-detail-2 text-right' },
	                _react2.default.createElement(
	                    'h3',
	                    { 'class': 'non-blocking pull-left' },
	                    level
	                ),
	                _react2.default.createElement(
	                    'h3',
	                    { 'class': 'non-blocking' },
	                    _react2.default.createElement('img', { src: _Aidao2.default, 'class': 'token32', alt: 'aidao logo' }),
	                    ' ',
	                    _react2.default.createElement(
	                        'span',
	                        { id: 'daobalance' },
	                        daobalance
	                    ),
	                    ' DAO '
	                ),
	                _react2.default.createElement(
	                    'p',
	                    { 'class': 'text-muted m-t-5' },
	                    '(',
	                    daobalance,
	                    '/',
	                    max,
	                    ')'
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { 'class': 'progress progress-bar-success-alt progress-md m-t-5 m-b-0' },
	                    _react2.default.createElement('div', { 'class': 'progress-bar progress-animated', id: 'dao-progress-bar', role: 'progressbar',
	                        'aria-valuenow': '100', 'aria-valuemin': '0', 'aria-valuemax': '100', style: bar_style })
	                )
	            );
	        }
	    }]);
	
	    return DAOLevel;
	}(_react.Component);
	
	exports.default = DAOLevel;

/***/ },
/* 160 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _popup = __webpack_require__(28);
	
	var _popup2 = _interopRequireDefault(_popup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var WalletAddress = function (_Component) {
	    _inherits(WalletAddress, _Component);
	
	    function WalletAddress() {
	        _classCallCheck(this, WalletAddress);
	
	        return _possibleConstructorReturn(this, (WalletAddress.__proto__ || Object.getPrototypeOf(WalletAddress)).apply(this, arguments));
	    }
	
	    _createClass(WalletAddress, [{
	        key: 'render',
	        value: function render() {
	
	            var address = window.address;
	            var data = this.props.data;
	
	            var copy = function copy() {
	
	                var copyText = document.querySelector("#address");
	                copyText.setAttribute("type", "");
	                copyText.select();
	                document.execCommand("copy");
	                copyText.setAttribute("type", "hidden");
	                _popup2.default.prototype.show(data.addressCopied);
	            };
	
	            return _react2.default.createElement(
	                'div',
	                { 'class': 'row' },
	                _react2.default.createElement(
	                    'div',
	                    { 'class': 'col-lg-12 col-md-12' },
	                    _react2.default.createElement(
	                        'div',
	                        { 'class': 'card-box' },
	                        _react2.default.createElement(
	                            'h2',
	                            { 'class': 'header-title m-t-0 m-b-30' },
	                            data.walletAddress
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { 'class': 'widget-box-2' },
	                            _react2.default.createElement(
	                                'div',
	                                { 'class': 'widget-detail-2' },
	                                _react2.default.createElement(
	                                    'p',
	                                    null,
	                                    address
	                                ),
	                                _react2.default.createElement('input', { id: 'address', value: address, type: 'hidden' }),
	                                _react2.default.createElement(
	                                    'button',
	                                    { type: 'button', onClick: copy, 'class': 'btn btn-blue waves-effect w-md waves-light m-b-5' },
	                                    data.copy
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return WalletAddress;
	}(_react.Component);
	
	exports.default = WalletAddress;

/***/ },
/* 161 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  'cobinhood': 29200,
	  'wandx': 910,
	  'xyo': 33700,
	  'ncash': 7350,
	  'bitrewards': 173200,
	  'singularitynet': 75,
	  'autonio': 80,
	  'credits': 275,
	  'orbs': 700,
	  'essentia': 3650,
	  'moneynet': 38600
	};

/***/ },
/* 162 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jsCookie = __webpack_require__(107);
	
	var _jsCookie2 = _interopRequireDefault(_jsCookie);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DjangoCSRFToken = function (_React$Component) {
	  _inherits(DjangoCSRFToken, _React$Component);
	
	  function DjangoCSRFToken() {
	    _classCallCheck(this, DjangoCSRFToken);
	
	    return _possibleConstructorReturn(this, (DjangoCSRFToken.__proto__ || Object.getPrototypeOf(DjangoCSRFToken)).apply(this, arguments));
	  }
	
	  _createClass(DjangoCSRFToken, [{
	    key: 'render',
	    value: function render() {
	
	      var csrfToken = _jsCookie2.default.get('csrftoken');
	
	      return _react2.default.createElement('input', { type: 'hidden', name: 'csrfmiddlewaretoken', value: csrfToken });
	    }
	  }]);
	
	  return DjangoCSRFToken;
	}(_react2.default.Component);
	
	exports.default = DjangoCSRFToken;

/***/ },
/* 163 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = {
	  SWITCH_LANGUAGE: 'SWITCH_LANGUAGE'
	};

/***/ },
/* 164 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-color/ Version 1.0.3. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports) :
		typeof define === 'function' && define.amd ? define(['exports'], factory) :
		(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	var define = function(constructor, factory, prototype) {
	  constructor.prototype = factory.prototype = prototype;
	  prototype.constructor = constructor;
	};
	
	function extend(parent, definition) {
	  var prototype = Object.create(parent.prototype);
	  for (var key in definition) prototype[key] = definition[key];
	  return prototype;
	}
	
	function Color() {}
	
	var darker = 0.7;
	var brighter = 1 / darker;
	
	var reI = "\\s*([+-]?\\d+)\\s*";
	var reN = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*";
	var reP = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*";
	var reHex3 = /^#([0-9a-f]{3})$/;
	var reHex6 = /^#([0-9a-f]{6})$/;
	var reRgbInteger = new RegExp("^rgb\\(" + [reI, reI, reI] + "\\)$");
	var reRgbPercent = new RegExp("^rgb\\(" + [reP, reP, reP] + "\\)$");
	var reRgbaInteger = new RegExp("^rgba\\(" + [reI, reI, reI, reN] + "\\)$");
	var reRgbaPercent = new RegExp("^rgba\\(" + [reP, reP, reP, reN] + "\\)$");
	var reHslPercent = new RegExp("^hsl\\(" + [reN, reP, reP] + "\\)$");
	var reHslaPercent = new RegExp("^hsla\\(" + [reN, reP, reP, reN] + "\\)$");
	
	var named = {
	  aliceblue: 0xf0f8ff,
	  antiquewhite: 0xfaebd7,
	  aqua: 0x00ffff,
	  aquamarine: 0x7fffd4,
	  azure: 0xf0ffff,
	  beige: 0xf5f5dc,
	  bisque: 0xffe4c4,
	  black: 0x000000,
	  blanchedalmond: 0xffebcd,
	  blue: 0x0000ff,
	  blueviolet: 0x8a2be2,
	  brown: 0xa52a2a,
	  burlywood: 0xdeb887,
	  cadetblue: 0x5f9ea0,
	  chartreuse: 0x7fff00,
	  chocolate: 0xd2691e,
	  coral: 0xff7f50,
	  cornflowerblue: 0x6495ed,
	  cornsilk: 0xfff8dc,
	  crimson: 0xdc143c,
	  cyan: 0x00ffff,
	  darkblue: 0x00008b,
	  darkcyan: 0x008b8b,
	  darkgoldenrod: 0xb8860b,
	  darkgray: 0xa9a9a9,
	  darkgreen: 0x006400,
	  darkgrey: 0xa9a9a9,
	  darkkhaki: 0xbdb76b,
	  darkmagenta: 0x8b008b,
	  darkolivegreen: 0x556b2f,
	  darkorange: 0xff8c00,
	  darkorchid: 0x9932cc,
	  darkred: 0x8b0000,
	  darksalmon: 0xe9967a,
	  darkseagreen: 0x8fbc8f,
	  darkslateblue: 0x483d8b,
	  darkslategray: 0x2f4f4f,
	  darkslategrey: 0x2f4f4f,
	  darkturquoise: 0x00ced1,
	  darkviolet: 0x9400d3,
	  deeppink: 0xff1493,
	  deepskyblue: 0x00bfff,
	  dimgray: 0x696969,
	  dimgrey: 0x696969,
	  dodgerblue: 0x1e90ff,
	  firebrick: 0xb22222,
	  floralwhite: 0xfffaf0,
	  forestgreen: 0x228b22,
	  fuchsia: 0xff00ff,
	  gainsboro: 0xdcdcdc,
	  ghostwhite: 0xf8f8ff,
	  gold: 0xffd700,
	  goldenrod: 0xdaa520,
	  gray: 0x808080,
	  green: 0x008000,
	  greenyellow: 0xadff2f,
	  grey: 0x808080,
	  honeydew: 0xf0fff0,
	  hotpink: 0xff69b4,
	  indianred: 0xcd5c5c,
	  indigo: 0x4b0082,
	  ivory: 0xfffff0,
	  khaki: 0xf0e68c,
	  lavender: 0xe6e6fa,
	  lavenderblush: 0xfff0f5,
	  lawngreen: 0x7cfc00,
	  lemonchiffon: 0xfffacd,
	  lightblue: 0xadd8e6,
	  lightcoral: 0xf08080,
	  lightcyan: 0xe0ffff,
	  lightgoldenrodyellow: 0xfafad2,
	  lightgray: 0xd3d3d3,
	  lightgreen: 0x90ee90,
	  lightgrey: 0xd3d3d3,
	  lightpink: 0xffb6c1,
	  lightsalmon: 0xffa07a,
	  lightseagreen: 0x20b2aa,
	  lightskyblue: 0x87cefa,
	  lightslategray: 0x778899,
	  lightslategrey: 0x778899,
	  lightsteelblue: 0xb0c4de,
	  lightyellow: 0xffffe0,
	  lime: 0x00ff00,
	  limegreen: 0x32cd32,
	  linen: 0xfaf0e6,
	  magenta: 0xff00ff,
	  maroon: 0x800000,
	  mediumaquamarine: 0x66cdaa,
	  mediumblue: 0x0000cd,
	  mediumorchid: 0xba55d3,
	  mediumpurple: 0x9370db,
	  mediumseagreen: 0x3cb371,
	  mediumslateblue: 0x7b68ee,
	  mediumspringgreen: 0x00fa9a,
	  mediumturquoise: 0x48d1cc,
	  mediumvioletred: 0xc71585,
	  midnightblue: 0x191970,
	  mintcream: 0xf5fffa,
	  mistyrose: 0xffe4e1,
	  moccasin: 0xffe4b5,
	  navajowhite: 0xffdead,
	  navy: 0x000080,
	  oldlace: 0xfdf5e6,
	  olive: 0x808000,
	  olivedrab: 0x6b8e23,
	  orange: 0xffa500,
	  orangered: 0xff4500,
	  orchid: 0xda70d6,
	  palegoldenrod: 0xeee8aa,
	  palegreen: 0x98fb98,
	  paleturquoise: 0xafeeee,
	  palevioletred: 0xdb7093,
	  papayawhip: 0xffefd5,
	  peachpuff: 0xffdab9,
	  peru: 0xcd853f,
	  pink: 0xffc0cb,
	  plum: 0xdda0dd,
	  powderblue: 0xb0e0e6,
	  purple: 0x800080,
	  rebeccapurple: 0x663399,
	  red: 0xff0000,
	  rosybrown: 0xbc8f8f,
	  royalblue: 0x4169e1,
	  saddlebrown: 0x8b4513,
	  salmon: 0xfa8072,
	  sandybrown: 0xf4a460,
	  seagreen: 0x2e8b57,
	  seashell: 0xfff5ee,
	  sienna: 0xa0522d,
	  silver: 0xc0c0c0,
	  skyblue: 0x87ceeb,
	  slateblue: 0x6a5acd,
	  slategray: 0x708090,
	  slategrey: 0x708090,
	  snow: 0xfffafa,
	  springgreen: 0x00ff7f,
	  steelblue: 0x4682b4,
	  tan: 0xd2b48c,
	  teal: 0x008080,
	  thistle: 0xd8bfd8,
	  tomato: 0xff6347,
	  turquoise: 0x40e0d0,
	  violet: 0xee82ee,
	  wheat: 0xf5deb3,
	  white: 0xffffff,
	  whitesmoke: 0xf5f5f5,
	  yellow: 0xffff00,
	  yellowgreen: 0x9acd32
	};
	
	define(Color, color, {
	  displayable: function() {
	    return this.rgb().displayable();
	  },
	  toString: function() {
	    return this.rgb() + "";
	  }
	});
	
	function color(format) {
	  var m;
	  format = (format + "").trim().toLowerCase();
	  return (m = reHex3.exec(format)) ? (m = parseInt(m[1], 16), new Rgb((m >> 8 & 0xf) | (m >> 4 & 0x0f0), (m >> 4 & 0xf) | (m & 0xf0), ((m & 0xf) << 4) | (m & 0xf), 1)) // #f00
	      : (m = reHex6.exec(format)) ? rgbn(parseInt(m[1], 16)) // #ff0000
	      : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
	      : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
	      : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
	      : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
	      : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
	      : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
	      : named.hasOwnProperty(format) ? rgbn(named[format])
	      : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0)
	      : null;
	}
	
	function rgbn(n) {
	  return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
	}
	
	function rgba(r, g, b, a) {
	  if (a <= 0) r = g = b = NaN;
	  return new Rgb(r, g, b, a);
	}
	
	function rgbConvert(o) {
	  if (!(o instanceof Color)) o = color(o);
	  if (!o) return new Rgb;
	  o = o.rgb();
	  return new Rgb(o.r, o.g, o.b, o.opacity);
	}
	
	function rgb(r, g, b, opacity) {
	  return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
	}
	
	function Rgb(r, g, b, opacity) {
	  this.r = +r;
	  this.g = +g;
	  this.b = +b;
	  this.opacity = +opacity;
	}
	
	define(Rgb, rgb, extend(Color, {
	  brighter: function(k) {
	    k = k == null ? brighter : Math.pow(brighter, k);
	    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
	  },
	  darker: function(k) {
	    k = k == null ? darker : Math.pow(darker, k);
	    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
	  },
	  rgb: function() {
	    return this;
	  },
	  displayable: function() {
	    return (0 <= this.r && this.r <= 255)
	        && (0 <= this.g && this.g <= 255)
	        && (0 <= this.b && this.b <= 255)
	        && (0 <= this.opacity && this.opacity <= 1);
	  },
	  toString: function() {
	    var a = this.opacity; a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
	    return (a === 1 ? "rgb(" : "rgba(")
	        + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", "
	        + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", "
	        + Math.max(0, Math.min(255, Math.round(this.b) || 0))
	        + (a === 1 ? ")" : ", " + a + ")");
	  }
	}));
	
	function hsla(h, s, l, a) {
	  if (a <= 0) h = s = l = NaN;
	  else if (l <= 0 || l >= 1) h = s = NaN;
	  else if (s <= 0) h = NaN;
	  return new Hsl(h, s, l, a);
	}
	
	function hslConvert(o) {
	  if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
	  if (!(o instanceof Color)) o = color(o);
	  if (!o) return new Hsl;
	  if (o instanceof Hsl) return o;
	  o = o.rgb();
	  var r = o.r / 255,
	      g = o.g / 255,
	      b = o.b / 255,
	      min = Math.min(r, g, b),
	      max = Math.max(r, g, b),
	      h = NaN,
	      s = max - min,
	      l = (max + min) / 2;
	  if (s) {
	    if (r === max) h = (g - b) / s + (g < b) * 6;
	    else if (g === max) h = (b - r) / s + 2;
	    else h = (r - g) / s + 4;
	    s /= l < 0.5 ? max + min : 2 - max - min;
	    h *= 60;
	  } else {
	    s = l > 0 && l < 1 ? 0 : h;
	  }
	  return new Hsl(h, s, l, o.opacity);
	}
	
	function hsl(h, s, l, opacity) {
	  return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
	}
	
	function Hsl(h, s, l, opacity) {
	  this.h = +h;
	  this.s = +s;
	  this.l = +l;
	  this.opacity = +opacity;
	}
	
	define(Hsl, hsl, extend(Color, {
	  brighter: function(k) {
	    k = k == null ? brighter : Math.pow(brighter, k);
	    return new Hsl(this.h, this.s, this.l * k, this.opacity);
	  },
	  darker: function(k) {
	    k = k == null ? darker : Math.pow(darker, k);
	    return new Hsl(this.h, this.s, this.l * k, this.opacity);
	  },
	  rgb: function() {
	    var h = this.h % 360 + (this.h < 0) * 360,
	        s = isNaN(h) || isNaN(this.s) ? 0 : this.s,
	        l = this.l,
	        m2 = l + (l < 0.5 ? l : 1 - l) * s,
	        m1 = 2 * l - m2;
	    return new Rgb(
	      hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2),
	      hsl2rgb(h, m1, m2),
	      hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2),
	      this.opacity
	    );
	  },
	  displayable: function() {
	    return (0 <= this.s && this.s <= 1 || isNaN(this.s))
	        && (0 <= this.l && this.l <= 1)
	        && (0 <= this.opacity && this.opacity <= 1);
	  }
	}));
	
	/* From FvD 13.37, CSS Color Module Level 3 */
	function hsl2rgb(h, m1, m2) {
	  return (h < 60 ? m1 + (m2 - m1) * h / 60
	      : h < 180 ? m2
	      : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60
	      : m1) * 255;
	}
	
	var deg2rad = Math.PI / 180;
	var rad2deg = 180 / Math.PI;
	
	var Kn = 18;
	var Xn = 0.950470;
	var Yn = 1;
	var Zn = 1.088830;
	var t0 = 4 / 29;
	var t1 = 6 / 29;
	var t2 = 3 * t1 * t1;
	var t3 = t1 * t1 * t1;
	
	function labConvert(o) {
	  if (o instanceof Lab) return new Lab(o.l, o.a, o.b, o.opacity);
	  if (o instanceof Hcl) {
	    var h = o.h * deg2rad;
	    return new Lab(o.l, Math.cos(h) * o.c, Math.sin(h) * o.c, o.opacity);
	  }
	  if (!(o instanceof Rgb)) o = rgbConvert(o);
	  var b = rgb2xyz(o.r),
	      a = rgb2xyz(o.g),
	      l = rgb2xyz(o.b),
	      x = xyz2lab((0.4124564 * b + 0.3575761 * a + 0.1804375 * l) / Xn),
	      y = xyz2lab((0.2126729 * b + 0.7151522 * a + 0.0721750 * l) / Yn),
	      z = xyz2lab((0.0193339 * b + 0.1191920 * a + 0.9503041 * l) / Zn);
	  return new Lab(116 * y - 16, 500 * (x - y), 200 * (y - z), o.opacity);
	}
	
	function lab(l, a, b, opacity) {
	  return arguments.length === 1 ? labConvert(l) : new Lab(l, a, b, opacity == null ? 1 : opacity);
	}
	
	function Lab(l, a, b, opacity) {
	  this.l = +l;
	  this.a = +a;
	  this.b = +b;
	  this.opacity = +opacity;
	}
	
	define(Lab, lab, extend(Color, {
	  brighter: function(k) {
	    return new Lab(this.l + Kn * (k == null ? 1 : k), this.a, this.b, this.opacity);
	  },
	  darker: function(k) {
	    return new Lab(this.l - Kn * (k == null ? 1 : k), this.a, this.b, this.opacity);
	  },
	  rgb: function() {
	    var y = (this.l + 16) / 116,
	        x = isNaN(this.a) ? y : y + this.a / 500,
	        z = isNaN(this.b) ? y : y - this.b / 200;
	    y = Yn * lab2xyz(y);
	    x = Xn * lab2xyz(x);
	    z = Zn * lab2xyz(z);
	    return new Rgb(
	      xyz2rgb( 3.2404542 * x - 1.5371385 * y - 0.4985314 * z), // D65 -> sRGB
	      xyz2rgb(-0.9692660 * x + 1.8760108 * y + 0.0415560 * z),
	      xyz2rgb( 0.0556434 * x - 0.2040259 * y + 1.0572252 * z),
	      this.opacity
	    );
	  }
	}));
	
	function xyz2lab(t) {
	  return t > t3 ? Math.pow(t, 1 / 3) : t / t2 + t0;
	}
	
	function lab2xyz(t) {
	  return t > t1 ? t * t * t : t2 * (t - t0);
	}
	
	function xyz2rgb(x) {
	  return 255 * (x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
	}
	
	function rgb2xyz(x) {
	  return (x /= 255) <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
	}
	
	function hclConvert(o) {
	  if (o instanceof Hcl) return new Hcl(o.h, o.c, o.l, o.opacity);
	  if (!(o instanceof Lab)) o = labConvert(o);
	  var h = Math.atan2(o.b, o.a) * rad2deg;
	  return new Hcl(h < 0 ? h + 360 : h, Math.sqrt(o.a * o.a + o.b * o.b), o.l, o.opacity);
	}
	
	function hcl(h, c, l, opacity) {
	  return arguments.length === 1 ? hclConvert(h) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
	}
	
	function Hcl(h, c, l, opacity) {
	  this.h = +h;
	  this.c = +c;
	  this.l = +l;
	  this.opacity = +opacity;
	}
	
	define(Hcl, hcl, extend(Color, {
	  brighter: function(k) {
	    return new Hcl(this.h, this.c, this.l + Kn * (k == null ? 1 : k), this.opacity);
	  },
	  darker: function(k) {
	    return new Hcl(this.h, this.c, this.l - Kn * (k == null ? 1 : k), this.opacity);
	  },
	  rgb: function() {
	    return labConvert(this).rgb();
	  }
	}));
	
	var A = -0.14861;
	var B = +1.78277;
	var C = -0.29227;
	var D = -0.90649;
	var E = +1.97294;
	var ED = E * D;
	var EB = E * B;
	var BC_DA = B * C - D * A;
	
	function cubehelixConvert(o) {
	  if (o instanceof Cubehelix) return new Cubehelix(o.h, o.s, o.l, o.opacity);
	  if (!(o instanceof Rgb)) o = rgbConvert(o);
	  var r = o.r / 255,
	      g = o.g / 255,
	      b = o.b / 255,
	      l = (BC_DA * b + ED * r - EB * g) / (BC_DA + ED - EB),
	      bl = b - l,
	      k = (E * (g - l) - C * bl) / D,
	      s = Math.sqrt(k * k + bl * bl) / (E * l * (1 - l)), // NaN if l=0 or l=1
	      h = s ? Math.atan2(k, bl) * rad2deg - 120 : NaN;
	  return new Cubehelix(h < 0 ? h + 360 : h, s, l, o.opacity);
	}
	
	function cubehelix(h, s, l, opacity) {
	  return arguments.length === 1 ? cubehelixConvert(h) : new Cubehelix(h, s, l, opacity == null ? 1 : opacity);
	}
	
	function Cubehelix(h, s, l, opacity) {
	  this.h = +h;
	  this.s = +s;
	  this.l = +l;
	  this.opacity = +opacity;
	}
	
	define(Cubehelix, cubehelix, extend(Color, {
	  brighter: function(k) {
	    k = k == null ? brighter : Math.pow(brighter, k);
	    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
	  },
	  darker: function(k) {
	    k = k == null ? darker : Math.pow(darker, k);
	    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
	  },
	  rgb: function() {
	    var h = isNaN(this.h) ? 0 : (this.h + 120) * deg2rad,
	        l = +this.l,
	        a = isNaN(this.s) ? 0 : this.s * l * (1 - l),
	        cosh = Math.cos(h),
	        sinh = Math.sin(h);
	    return new Rgb(
	      255 * (l + a * (A * cosh + B * sinh)),
	      255 * (l + a * (C * cosh + D * sinh)),
	      255 * (l + a * (E * cosh)),
	      this.opacity
	    );
	  }
	}));
	
	exports.color = color;
	exports.rgb = rgb;
	exports.hsl = hsl;
	exports.lab = lab;
	exports.hcl = hcl;
	exports.cubehelix = cubehelix;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 165 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-interpolate/ Version 1.1.6. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(164)) :
		typeof define === 'function' && define.amd ? define(['exports', 'd3-color'], factory) :
		(factory((global.d3 = global.d3 || {}),global.d3));
	}(this, (function (exports,d3Color) { 'use strict';
	
	function basis(t1, v0, v1, v2, v3) {
	  var t2 = t1 * t1, t3 = t2 * t1;
	  return ((1 - 3 * t1 + 3 * t2 - t3) * v0
	      + (4 - 6 * t2 + 3 * t3) * v1
	      + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2
	      + t3 * v3) / 6;
	}
	
	var basis$1 = function(values) {
	  var n = values.length - 1;
	  return function(t) {
	    var i = t <= 0 ? (t = 0) : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n),
	        v1 = values[i],
	        v2 = values[i + 1],
	        v0 = i > 0 ? values[i - 1] : 2 * v1 - v2,
	        v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
	    return basis((t - i / n) * n, v0, v1, v2, v3);
	  };
	};
	
	var basisClosed = function(values) {
	  var n = values.length;
	  return function(t) {
	    var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n),
	        v0 = values[(i + n - 1) % n],
	        v1 = values[i % n],
	        v2 = values[(i + 1) % n],
	        v3 = values[(i + 2) % n];
	    return basis((t - i / n) * n, v0, v1, v2, v3);
	  };
	};
	
	var constant = function(x) {
	  return function() {
	    return x;
	  };
	};
	
	function linear(a, d) {
	  return function(t) {
	    return a + t * d;
	  };
	}
	
	function exponential(a, b, y) {
	  return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
	    return Math.pow(a + t * b, y);
	  };
	}
	
	function hue(a, b) {
	  var d = b - a;
	  return d ? linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : constant(isNaN(a) ? b : a);
	}
	
	function gamma(y) {
	  return (y = +y) === 1 ? nogamma : function(a, b) {
	    return b - a ? exponential(a, b, y) : constant(isNaN(a) ? b : a);
	  };
	}
	
	function nogamma(a, b) {
	  var d = b - a;
	  return d ? linear(a, d) : constant(isNaN(a) ? b : a);
	}
	
	var rgb$1 = ((function rgbGamma(y) {
	  var color$$1 = gamma(y);
	
	  function rgb$$1(start, end) {
	    var r = color$$1((start = d3Color.rgb(start)).r, (end = d3Color.rgb(end)).r),
	        g = color$$1(start.g, end.g),
	        b = color$$1(start.b, end.b),
	        opacity = nogamma(start.opacity, end.opacity);
	    return function(t) {
	      start.r = r(t);
	      start.g = g(t);
	      start.b = b(t);
	      start.opacity = opacity(t);
	      return start + "";
	    };
	  }
	
	  rgb$$1.gamma = rgbGamma;
	
	  return rgb$$1;
	}))(1);
	
	function rgbSpline(spline) {
	  return function(colors) {
	    var n = colors.length,
	        r = new Array(n),
	        g = new Array(n),
	        b = new Array(n),
	        i, color$$1;
	    for (i = 0; i < n; ++i) {
	      color$$1 = d3Color.rgb(colors[i]);
	      r[i] = color$$1.r || 0;
	      g[i] = color$$1.g || 0;
	      b[i] = color$$1.b || 0;
	    }
	    r = spline(r);
	    g = spline(g);
	    b = spline(b);
	    color$$1.opacity = 1;
	    return function(t) {
	      color$$1.r = r(t);
	      color$$1.g = g(t);
	      color$$1.b = b(t);
	      return color$$1 + "";
	    };
	  };
	}
	
	var rgbBasis = rgbSpline(basis$1);
	var rgbBasisClosed = rgbSpline(basisClosed);
	
	var array = function(a, b) {
	  var nb = b ? b.length : 0,
	      na = a ? Math.min(nb, a.length) : 0,
	      x = new Array(na),
	      c = new Array(nb),
	      i;
	
	  for (i = 0; i < na; ++i) x[i] = value(a[i], b[i]);
	  for (; i < nb; ++i) c[i] = b[i];
	
	  return function(t) {
	    for (i = 0; i < na; ++i) c[i] = x[i](t);
	    return c;
	  };
	};
	
	var date = function(a, b) {
	  var d = new Date;
	  return a = +a, b -= a, function(t) {
	    return d.setTime(a + b * t), d;
	  };
	};
	
	var number = function(a, b) {
	  return a = +a, b -= a, function(t) {
	    return a + b * t;
	  };
	};
	
	var object = function(a, b) {
	  var i = {},
	      c = {},
	      k;
	
	  if (a === null || typeof a !== "object") a = {};
	  if (b === null || typeof b !== "object") b = {};
	
	  for (k in b) {
	    if (k in a) {
	      i[k] = value(a[k], b[k]);
	    } else {
	      c[k] = b[k];
	    }
	  }
	
	  return function(t) {
	    for (k in i) c[k] = i[k](t);
	    return c;
	  };
	};
	
	var reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g;
	var reB = new RegExp(reA.source, "g");
	
	function zero(b) {
	  return function() {
	    return b;
	  };
	}
	
	function one(b) {
	  return function(t) {
	    return b(t) + "";
	  };
	}
	
	var string = function(a, b) {
	  var bi = reA.lastIndex = reB.lastIndex = 0, // scan index for next number in b
	      am, // current match in a
	      bm, // current match in b
	      bs, // string preceding current number in b, if any
	      i = -1, // index in s
	      s = [], // string constants and placeholders
	      q = []; // number interpolators
	
	  // Coerce inputs to strings.
	  a = a + "", b = b + "";
	
	  // Interpolate pairs of numbers in a & b.
	  while ((am = reA.exec(a))
	      && (bm = reB.exec(b))) {
	    if ((bs = bm.index) > bi) { // a string precedes the next number in b
	      bs = b.slice(bi, bs);
	      if (s[i]) s[i] += bs; // coalesce with previous string
	      else s[++i] = bs;
	    }
	    if ((am = am[0]) === (bm = bm[0])) { // numbers in a & b match
	      if (s[i]) s[i] += bm; // coalesce with previous string
	      else s[++i] = bm;
	    } else { // interpolate non-matching numbers
	      s[++i] = null;
	      q.push({i: i, x: number(am, bm)});
	    }
	    bi = reB.lastIndex;
	  }
	
	  // Add remains of b.
	  if (bi < b.length) {
	    bs = b.slice(bi);
	    if (s[i]) s[i] += bs; // coalesce with previous string
	    else s[++i] = bs;
	  }
	
	  // Special optimization for only a single match.
	  // Otherwise, interpolate each of the numbers and rejoin the string.
	  return s.length < 2 ? (q[0]
	      ? one(q[0].x)
	      : zero(b))
	      : (b = q.length, function(t) {
	          for (var i = 0, o; i < b; ++i) s[(o = q[i]).i] = o.x(t);
	          return s.join("");
	        });
	};
	
	var value = function(a, b) {
	  var t = typeof b, c;
	  return b == null || t === "boolean" ? constant(b)
	      : (t === "number" ? number
	      : t === "string" ? ((c = d3Color.color(b)) ? (b = c, rgb$1) : string)
	      : b instanceof d3Color.color ? rgb$1
	      : b instanceof Date ? date
	      : Array.isArray(b) ? array
	      : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? object
	      : number)(a, b);
	};
	
	var round = function(a, b) {
	  return a = +a, b -= a, function(t) {
	    return Math.round(a + b * t);
	  };
	};
	
	var degrees = 180 / Math.PI;
	
	var identity = {
	  translateX: 0,
	  translateY: 0,
	  rotate: 0,
	  skewX: 0,
	  scaleX: 1,
	  scaleY: 1
	};
	
	var decompose = function(a, b, c, d, e, f) {
	  var scaleX, scaleY, skewX;
	  if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
	  if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
	  if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
	  if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
	  return {
	    translateX: e,
	    translateY: f,
	    rotate: Math.atan2(b, a) * degrees,
	    skewX: Math.atan(skewX) * degrees,
	    scaleX: scaleX,
	    scaleY: scaleY
	  };
	};
	
	var cssNode;
	var cssRoot;
	var cssView;
	var svgNode;
	
	function parseCss(value) {
	  if (value === "none") return identity;
	  if (!cssNode) cssNode = document.createElement("DIV"), cssRoot = document.documentElement, cssView = document.defaultView;
	  cssNode.style.transform = value;
	  value = cssView.getComputedStyle(cssRoot.appendChild(cssNode), null).getPropertyValue("transform");
	  cssRoot.removeChild(cssNode);
	  value = value.slice(7, -1).split(",");
	  return decompose(+value[0], +value[1], +value[2], +value[3], +value[4], +value[5]);
	}
	
	function parseSvg(value) {
	  if (value == null) return identity;
	  if (!svgNode) svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
	  svgNode.setAttribute("transform", value);
	  if (!(value = svgNode.transform.baseVal.consolidate())) return identity;
	  value = value.matrix;
	  return decompose(value.a, value.b, value.c, value.d, value.e, value.f);
	}
	
	function interpolateTransform(parse, pxComma, pxParen, degParen) {
	
	  function pop(s) {
	    return s.length ? s.pop() + " " : "";
	  }
	
	  function translate(xa, ya, xb, yb, s, q) {
	    if (xa !== xb || ya !== yb) {
	      var i = s.push("translate(", null, pxComma, null, pxParen);
	      q.push({i: i - 4, x: number(xa, xb)}, {i: i - 2, x: number(ya, yb)});
	    } else if (xb || yb) {
	      s.push("translate(" + xb + pxComma + yb + pxParen);
	    }
	  }
	
	  function rotate(a, b, s, q) {
	    if (a !== b) {
	      if (a - b > 180) b += 360; else if (b - a > 180) a += 360; // shortest path
	      q.push({i: s.push(pop(s) + "rotate(", null, degParen) - 2, x: number(a, b)});
	    } else if (b) {
	      s.push(pop(s) + "rotate(" + b + degParen);
	    }
	  }
	
	  function skewX(a, b, s, q) {
	    if (a !== b) {
	      q.push({i: s.push(pop(s) + "skewX(", null, degParen) - 2, x: number(a, b)});
	    } else if (b) {
	      s.push(pop(s) + "skewX(" + b + degParen);
	    }
	  }
	
	  function scale(xa, ya, xb, yb, s, q) {
	    if (xa !== xb || ya !== yb) {
	      var i = s.push(pop(s) + "scale(", null, ",", null, ")");
	      q.push({i: i - 4, x: number(xa, xb)}, {i: i - 2, x: number(ya, yb)});
	    } else if (xb !== 1 || yb !== 1) {
	      s.push(pop(s) + "scale(" + xb + "," + yb + ")");
	    }
	  }
	
	  return function(a, b) {
	    var s = [], // string constants and placeholders
	        q = []; // number interpolators
	    a = parse(a), b = parse(b);
	    translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
	    rotate(a.rotate, b.rotate, s, q);
	    skewX(a.skewX, b.skewX, s, q);
	    scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
	    a = b = null; // gc
	    return function(t) {
	      var i = -1, n = q.length, o;
	      while (++i < n) s[(o = q[i]).i] = o.x(t);
	      return s.join("");
	    };
	  };
	}
	
	var interpolateTransformCss = interpolateTransform(parseCss, "px, ", "px)", "deg)");
	var interpolateTransformSvg = interpolateTransform(parseSvg, ", ", ")", ")");
	
	var rho = Math.SQRT2;
	var rho2 = 2;
	var rho4 = 4;
	var epsilon2 = 1e-12;
	
	function cosh(x) {
	  return ((x = Math.exp(x)) + 1 / x) / 2;
	}
	
	function sinh(x) {
	  return ((x = Math.exp(x)) - 1 / x) / 2;
	}
	
	function tanh(x) {
	  return ((x = Math.exp(2 * x)) - 1) / (x + 1);
	}
	
	// p0 = [ux0, uy0, w0]
	// p1 = [ux1, uy1, w1]
	var zoom = function(p0, p1) {
	  var ux0 = p0[0], uy0 = p0[1], w0 = p0[2],
	      ux1 = p1[0], uy1 = p1[1], w1 = p1[2],
	      dx = ux1 - ux0,
	      dy = uy1 - uy0,
	      d2 = dx * dx + dy * dy,
	      i,
	      S;
	
	  // Special case for u0 ≅ u1.
	  if (d2 < epsilon2) {
	    S = Math.log(w1 / w0) / rho;
	    i = function(t) {
	      return [
	        ux0 + t * dx,
	        uy0 + t * dy,
	        w0 * Math.exp(rho * t * S)
	      ];
	    };
	  }
	
	  // General case.
	  else {
	    var d1 = Math.sqrt(d2),
	        b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1),
	        b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1),
	        r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0),
	        r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
	    S = (r1 - r0) / rho;
	    i = function(t) {
	      var s = t * S,
	          coshr0 = cosh(r0),
	          u = w0 / (rho2 * d1) * (coshr0 * tanh(rho * s + r0) - sinh(r0));
	      return [
	        ux0 + u * dx,
	        uy0 + u * dy,
	        w0 * coshr0 / cosh(rho * s + r0)
	      ];
	    };
	  }
	
	  i.duration = S * 1000;
	
	  return i;
	};
	
	function hsl$1(hue$$1) {
	  return function(start, end) {
	    var h = hue$$1((start = d3Color.hsl(start)).h, (end = d3Color.hsl(end)).h),
	        s = nogamma(start.s, end.s),
	        l = nogamma(start.l, end.l),
	        opacity = nogamma(start.opacity, end.opacity);
	    return function(t) {
	      start.h = h(t);
	      start.s = s(t);
	      start.l = l(t);
	      start.opacity = opacity(t);
	      return start + "";
	    };
	  }
	}
	
	var hsl$2 = hsl$1(hue);
	var hslLong = hsl$1(nogamma);
	
	function lab$1(start, end) {
	  var l = nogamma((start = d3Color.lab(start)).l, (end = d3Color.lab(end)).l),
	      a = nogamma(start.a, end.a),
	      b = nogamma(start.b, end.b),
	      opacity = nogamma(start.opacity, end.opacity);
	  return function(t) {
	    start.l = l(t);
	    start.a = a(t);
	    start.b = b(t);
	    start.opacity = opacity(t);
	    return start + "";
	  };
	}
	
	function hcl$1(hue$$1) {
	  return function(start, end) {
	    var h = hue$$1((start = d3Color.hcl(start)).h, (end = d3Color.hcl(end)).h),
	        c = nogamma(start.c, end.c),
	        l = nogamma(start.l, end.l),
	        opacity = nogamma(start.opacity, end.opacity);
	    return function(t) {
	      start.h = h(t);
	      start.c = c(t);
	      start.l = l(t);
	      start.opacity = opacity(t);
	      return start + "";
	    };
	  }
	}
	
	var hcl$2 = hcl$1(hue);
	var hclLong = hcl$1(nogamma);
	
	function cubehelix$1(hue$$1) {
	  return (function cubehelixGamma(y) {
	    y = +y;
	
	    function cubehelix$$1(start, end) {
	      var h = hue$$1((start = d3Color.cubehelix(start)).h, (end = d3Color.cubehelix(end)).h),
	          s = nogamma(start.s, end.s),
	          l = nogamma(start.l, end.l),
	          opacity = nogamma(start.opacity, end.opacity);
	      return function(t) {
	        start.h = h(t);
	        start.s = s(t);
	        start.l = l(Math.pow(t, y));
	        start.opacity = opacity(t);
	        return start + "";
	      };
	    }
	
	    cubehelix$$1.gamma = cubehelixGamma;
	
	    return cubehelix$$1;
	  })(1);
	}
	
	var cubehelix$2 = cubehelix$1(hue);
	var cubehelixLong = cubehelix$1(nogamma);
	
	var quantize = function(interpolator, n) {
	  var samples = new Array(n);
	  for (var i = 0; i < n; ++i) samples[i] = interpolator(i / (n - 1));
	  return samples;
	};
	
	exports.interpolate = value;
	exports.interpolateArray = array;
	exports.interpolateBasis = basis$1;
	exports.interpolateBasisClosed = basisClosed;
	exports.interpolateDate = date;
	exports.interpolateNumber = number;
	exports.interpolateObject = object;
	exports.interpolateRound = round;
	exports.interpolateString = string;
	exports.interpolateTransformCss = interpolateTransformCss;
	exports.interpolateTransformSvg = interpolateTransformSvg;
	exports.interpolateZoom = zoom;
	exports.interpolateRgb = rgb$1;
	exports.interpolateRgbBasis = rgbBasis;
	exports.interpolateRgbBasisClosed = rgbBasisClosed;
	exports.interpolateHsl = hsl$2;
	exports.interpolateHslLong = hslLong;
	exports.interpolateLab = lab$1;
	exports.interpolateHcl = hcl$2;
	exports.interpolateHclLong = hclLong;
	exports.interpolateCubehelix = cubehelix$2;
	exports.interpolateCubehelixLong = cubehelixLong;
	exports.quantize = quantize;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 166 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-time/ Version 1.0.8. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports) :
		typeof define === 'function' && define.amd ? define(['exports'], factory) :
		(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	var t0 = new Date;
	var t1 = new Date;
	
	function newInterval(floori, offseti, count, field) {
	
	  function interval(date) {
	    return floori(date = new Date(+date)), date;
	  }
	
	  interval.floor = interval;
	
	  interval.ceil = function(date) {
	    return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
	  };
	
	  interval.round = function(date) {
	    var d0 = interval(date),
	        d1 = interval.ceil(date);
	    return date - d0 < d1 - date ? d0 : d1;
	  };
	
	  interval.offset = function(date, step) {
	    return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
	  };
	
	  interval.range = function(start, stop, step) {
	    var range = [], previous;
	    start = interval.ceil(start);
	    step = step == null ? 1 : Math.floor(step);
	    if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
	    do range.push(previous = new Date(+start)), offseti(start, step), floori(start);
	    while (previous < start && start < stop);
	    return range;
	  };
	
	  interval.filter = function(test) {
	    return newInterval(function(date) {
	      if (date >= date) while (floori(date), !test(date)) date.setTime(date - 1);
	    }, function(date, step) {
	      if (date >= date) {
	        if (step < 0) while (++step <= 0) {
	          while (offseti(date, -1), !test(date)) {} // eslint-disable-line no-empty
	        } else while (--step >= 0) {
	          while (offseti(date, +1), !test(date)) {} // eslint-disable-line no-empty
	        }
	      }
	    });
	  };
	
	  if (count) {
	    interval.count = function(start, end) {
	      t0.setTime(+start), t1.setTime(+end);
	      floori(t0), floori(t1);
	      return Math.floor(count(t0, t1));
	    };
	
	    interval.every = function(step) {
	      step = Math.floor(step);
	      return !isFinite(step) || !(step > 0) ? null
	          : !(step > 1) ? interval
	          : interval.filter(field
	              ? function(d) { return field(d) % step === 0; }
	              : function(d) { return interval.count(0, d) % step === 0; });
	    };
	  }
	
	  return interval;
	}
	
	var millisecond = newInterval(function() {
	  // noop
	}, function(date, step) {
	  date.setTime(+date + step);
	}, function(start, end) {
	  return end - start;
	});
	
	// An optimized implementation for this simple case.
	millisecond.every = function(k) {
	  k = Math.floor(k);
	  if (!isFinite(k) || !(k > 0)) return null;
	  if (!(k > 1)) return millisecond;
	  return newInterval(function(date) {
	    date.setTime(Math.floor(date / k) * k);
	  }, function(date, step) {
	    date.setTime(+date + step * k);
	  }, function(start, end) {
	    return (end - start) / k;
	  });
	};
	
	var milliseconds = millisecond.range;
	
	var durationSecond = 1e3;
	var durationMinute = 6e4;
	var durationHour = 36e5;
	var durationDay = 864e5;
	var durationWeek = 6048e5;
	
	var second = newInterval(function(date) {
	  date.setTime(Math.floor(date / durationSecond) * durationSecond);
	}, function(date, step) {
	  date.setTime(+date + step * durationSecond);
	}, function(start, end) {
	  return (end - start) / durationSecond;
	}, function(date) {
	  return date.getUTCSeconds();
	});
	
	var seconds = second.range;
	
	var minute = newInterval(function(date) {
	  date.setTime(Math.floor(date / durationMinute) * durationMinute);
	}, function(date, step) {
	  date.setTime(+date + step * durationMinute);
	}, function(start, end) {
	  return (end - start) / durationMinute;
	}, function(date) {
	  return date.getMinutes();
	});
	
	var minutes = minute.range;
	
	var hour = newInterval(function(date) {
	  var offset = date.getTimezoneOffset() * durationMinute % durationHour;
	  if (offset < 0) offset += durationHour;
	  date.setTime(Math.floor((+date - offset) / durationHour) * durationHour + offset);
	}, function(date, step) {
	  date.setTime(+date + step * durationHour);
	}, function(start, end) {
	  return (end - start) / durationHour;
	}, function(date) {
	  return date.getHours();
	});
	
	var hours = hour.range;
	
	var day = newInterval(function(date) {
	  date.setHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setDate(date.getDate() + step);
	}, function(start, end) {
	  return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * durationMinute) / durationDay;
	}, function(date) {
	  return date.getDate() - 1;
	});
	
	var days = day.range;
	
	function weekday(i) {
	  return newInterval(function(date) {
	    date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
	    date.setHours(0, 0, 0, 0);
	  }, function(date, step) {
	    date.setDate(date.getDate() + step * 7);
	  }, function(start, end) {
	    return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * durationMinute) / durationWeek;
	  });
	}
	
	var sunday = weekday(0);
	var monday = weekday(1);
	var tuesday = weekday(2);
	var wednesday = weekday(3);
	var thursday = weekday(4);
	var friday = weekday(5);
	var saturday = weekday(6);
	
	var sundays = sunday.range;
	var mondays = monday.range;
	var tuesdays = tuesday.range;
	var wednesdays = wednesday.range;
	var thursdays = thursday.range;
	var fridays = friday.range;
	var saturdays = saturday.range;
	
	var month = newInterval(function(date) {
	  date.setDate(1);
	  date.setHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setMonth(date.getMonth() + step);
	}, function(start, end) {
	  return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
	}, function(date) {
	  return date.getMonth();
	});
	
	var months = month.range;
	
	var year = newInterval(function(date) {
	  date.setMonth(0, 1);
	  date.setHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setFullYear(date.getFullYear() + step);
	}, function(start, end) {
	  return end.getFullYear() - start.getFullYear();
	}, function(date) {
	  return date.getFullYear();
	});
	
	// An optimized implementation for this simple case.
	year.every = function(k) {
	  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : newInterval(function(date) {
	    date.setFullYear(Math.floor(date.getFullYear() / k) * k);
	    date.setMonth(0, 1);
	    date.setHours(0, 0, 0, 0);
	  }, function(date, step) {
	    date.setFullYear(date.getFullYear() + step * k);
	  });
	};
	
	var years = year.range;
	
	var utcMinute = newInterval(function(date) {
	  date.setUTCSeconds(0, 0);
	}, function(date, step) {
	  date.setTime(+date + step * durationMinute);
	}, function(start, end) {
	  return (end - start) / durationMinute;
	}, function(date) {
	  return date.getUTCMinutes();
	});
	
	var utcMinutes = utcMinute.range;
	
	var utcHour = newInterval(function(date) {
	  date.setUTCMinutes(0, 0, 0);
	}, function(date, step) {
	  date.setTime(+date + step * durationHour);
	}, function(start, end) {
	  return (end - start) / durationHour;
	}, function(date) {
	  return date.getUTCHours();
	});
	
	var utcHours = utcHour.range;
	
	var utcDay = newInterval(function(date) {
	  date.setUTCHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setUTCDate(date.getUTCDate() + step);
	}, function(start, end) {
	  return (end - start) / durationDay;
	}, function(date) {
	  return date.getUTCDate() - 1;
	});
	
	var utcDays = utcDay.range;
	
	function utcWeekday(i) {
	  return newInterval(function(date) {
	    date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
	    date.setUTCHours(0, 0, 0, 0);
	  }, function(date, step) {
	    date.setUTCDate(date.getUTCDate() + step * 7);
	  }, function(start, end) {
	    return (end - start) / durationWeek;
	  });
	}
	
	var utcSunday = utcWeekday(0);
	var utcMonday = utcWeekday(1);
	var utcTuesday = utcWeekday(2);
	var utcWednesday = utcWeekday(3);
	var utcThursday = utcWeekday(4);
	var utcFriday = utcWeekday(5);
	var utcSaturday = utcWeekday(6);
	
	var utcSundays = utcSunday.range;
	var utcMondays = utcMonday.range;
	var utcTuesdays = utcTuesday.range;
	var utcWednesdays = utcWednesday.range;
	var utcThursdays = utcThursday.range;
	var utcFridays = utcFriday.range;
	var utcSaturdays = utcSaturday.range;
	
	var utcMonth = newInterval(function(date) {
	  date.setUTCDate(1);
	  date.setUTCHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setUTCMonth(date.getUTCMonth() + step);
	}, function(start, end) {
	  return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
	}, function(date) {
	  return date.getUTCMonth();
	});
	
	var utcMonths = utcMonth.range;
	
	var utcYear = newInterval(function(date) {
	  date.setUTCMonth(0, 1);
	  date.setUTCHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setUTCFullYear(date.getUTCFullYear() + step);
	}, function(start, end) {
	  return end.getUTCFullYear() - start.getUTCFullYear();
	}, function(date) {
	  return date.getUTCFullYear();
	});
	
	// An optimized implementation for this simple case.
	utcYear.every = function(k) {
	  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : newInterval(function(date) {
	    date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
	    date.setUTCMonth(0, 1);
	    date.setUTCHours(0, 0, 0, 0);
	  }, function(date, step) {
	    date.setUTCFullYear(date.getUTCFullYear() + step * k);
	  });
	};
	
	var utcYears = utcYear.range;
	
	exports.timeInterval = newInterval;
	exports.timeMillisecond = millisecond;
	exports.timeMilliseconds = milliseconds;
	exports.utcMillisecond = millisecond;
	exports.utcMilliseconds = milliseconds;
	exports.timeSecond = second;
	exports.timeSeconds = seconds;
	exports.utcSecond = second;
	exports.utcSeconds = seconds;
	exports.timeMinute = minute;
	exports.timeMinutes = minutes;
	exports.timeHour = hour;
	exports.timeHours = hours;
	exports.timeDay = day;
	exports.timeDays = days;
	exports.timeWeek = sunday;
	exports.timeWeeks = sundays;
	exports.timeSunday = sunday;
	exports.timeSundays = sundays;
	exports.timeMonday = monday;
	exports.timeMondays = mondays;
	exports.timeTuesday = tuesday;
	exports.timeTuesdays = tuesdays;
	exports.timeWednesday = wednesday;
	exports.timeWednesdays = wednesdays;
	exports.timeThursday = thursday;
	exports.timeThursdays = thursdays;
	exports.timeFriday = friday;
	exports.timeFridays = fridays;
	exports.timeSaturday = saturday;
	exports.timeSaturdays = saturdays;
	exports.timeMonth = month;
	exports.timeMonths = months;
	exports.timeYear = year;
	exports.timeYears = years;
	exports.utcMinute = utcMinute;
	exports.utcMinutes = utcMinutes;
	exports.utcHour = utcHour;
	exports.utcHours = utcHours;
	exports.utcDay = utcDay;
	exports.utcDays = utcDays;
	exports.utcWeek = utcSunday;
	exports.utcWeeks = utcSundays;
	exports.utcSunday = utcSunday;
	exports.utcSundays = utcSundays;
	exports.utcMonday = utcMonday;
	exports.utcMondays = utcMondays;
	exports.utcTuesday = utcTuesday;
	exports.utcTuesdays = utcTuesdays;
	exports.utcWednesday = utcWednesday;
	exports.utcWednesdays = utcWednesdays;
	exports.utcThursday = utcThursday;
	exports.utcThursdays = utcThursdays;
	exports.utcFriday = utcFriday;
	exports.utcFridays = utcFridays;
	exports.utcSaturday = utcSaturday;
	exports.utcSaturdays = utcSaturdays;
	exports.utcMonth = utcMonth;
	exports.utcMonths = utcMonths;
	exports.utcYear = utcYear;
	exports.utcYears = utcYears;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 167 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-voronoi/ Version 1.1.2. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports) :
		typeof define === 'function' && define.amd ? define(['exports'], factory) :
		(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	var constant = function(x) {
	  return function() {
	    return x;
	  };
	};
	
	function x(d) {
	  return d[0];
	}
	
	function y(d) {
	  return d[1];
	}
	
	function RedBlackTree() {
	  this._ = null; // root node
	}
	
	function RedBlackNode(node) {
	  node.U = // parent node
	  node.C = // color - true for red, false for black
	  node.L = // left node
	  node.R = // right node
	  node.P = // previous node
	  node.N = null; // next node
	}
	
	RedBlackTree.prototype = {
	  constructor: RedBlackTree,
	
	  insert: function(after, node) {
	    var parent, grandpa, uncle;
	
	    if (after) {
	      node.P = after;
	      node.N = after.N;
	      if (after.N) after.N.P = node;
	      after.N = node;
	      if (after.R) {
	        after = after.R;
	        while (after.L) after = after.L;
	        after.L = node;
	      } else {
	        after.R = node;
	      }
	      parent = after;
	    } else if (this._) {
	      after = RedBlackFirst(this._);
	      node.P = null;
	      node.N = after;
	      after.P = after.L = node;
	      parent = after;
	    } else {
	      node.P = node.N = null;
	      this._ = node;
	      parent = null;
	    }
	    node.L = node.R = null;
	    node.U = parent;
	    node.C = true;
	
	    after = node;
	    while (parent && parent.C) {
	      grandpa = parent.U;
	      if (parent === grandpa.L) {
	        uncle = grandpa.R;
	        if (uncle && uncle.C) {
	          parent.C = uncle.C = false;
	          grandpa.C = true;
	          after = grandpa;
	        } else {
	          if (after === parent.R) {
	            RedBlackRotateLeft(this, parent);
	            after = parent;
	            parent = after.U;
	          }
	          parent.C = false;
	          grandpa.C = true;
	          RedBlackRotateRight(this, grandpa);
	        }
	      } else {
	        uncle = grandpa.L;
	        if (uncle && uncle.C) {
	          parent.C = uncle.C = false;
	          grandpa.C = true;
	          after = grandpa;
	        } else {
	          if (after === parent.L) {
	            RedBlackRotateRight(this, parent);
	            after = parent;
	            parent = after.U;
	          }
	          parent.C = false;
	          grandpa.C = true;
	          RedBlackRotateLeft(this, grandpa);
	        }
	      }
	      parent = after.U;
	    }
	    this._.C = false;
	  },
	
	  remove: function(node) {
	    if (node.N) node.N.P = node.P;
	    if (node.P) node.P.N = node.N;
	    node.N = node.P = null;
	
	    var parent = node.U,
	        sibling,
	        left = node.L,
	        right = node.R,
	        next,
	        red;
	
	    if (!left) next = right;
	    else if (!right) next = left;
	    else next = RedBlackFirst(right);
	
	    if (parent) {
	      if (parent.L === node) parent.L = next;
	      else parent.R = next;
	    } else {
	      this._ = next;
	    }
	
	    if (left && right) {
	      red = next.C;
	      next.C = node.C;
	      next.L = left;
	      left.U = next;
	      if (next !== right) {
	        parent = next.U;
	        next.U = node.U;
	        node = next.R;
	        parent.L = node;
	        next.R = right;
	        right.U = next;
	      } else {
	        next.U = parent;
	        parent = next;
	        node = next.R;
	      }
	    } else {
	      red = node.C;
	      node = next;
	    }
	
	    if (node) node.U = parent;
	    if (red) return;
	    if (node && node.C) { node.C = false; return; }
	
	    do {
	      if (node === this._) break;
	      if (node === parent.L) {
	        sibling = parent.R;
	        if (sibling.C) {
	          sibling.C = false;
	          parent.C = true;
	          RedBlackRotateLeft(this, parent);
	          sibling = parent.R;
	        }
	        if ((sibling.L && sibling.L.C)
	            || (sibling.R && sibling.R.C)) {
	          if (!sibling.R || !sibling.R.C) {
	            sibling.L.C = false;
	            sibling.C = true;
	            RedBlackRotateRight(this, sibling);
	            sibling = parent.R;
	          }
	          sibling.C = parent.C;
	          parent.C = sibling.R.C = false;
	          RedBlackRotateLeft(this, parent);
	          node = this._;
	          break;
	        }
	      } else {
	        sibling = parent.L;
	        if (sibling.C) {
	          sibling.C = false;
	          parent.C = true;
	          RedBlackRotateRight(this, parent);
	          sibling = parent.L;
	        }
	        if ((sibling.L && sibling.L.C)
	          || (sibling.R && sibling.R.C)) {
	          if (!sibling.L || !sibling.L.C) {
	            sibling.R.C = false;
	            sibling.C = true;
	            RedBlackRotateLeft(this, sibling);
	            sibling = parent.L;
	          }
	          sibling.C = parent.C;
	          parent.C = sibling.L.C = false;
	          RedBlackRotateRight(this, parent);
	          node = this._;
	          break;
	        }
	      }
	      sibling.C = true;
	      node = parent;
	      parent = parent.U;
	    } while (!node.C);
	
	    if (node) node.C = false;
	  }
	};
	
	function RedBlackRotateLeft(tree, node) {
	  var p = node,
	      q = node.R,
	      parent = p.U;
	
	  if (parent) {
	    if (parent.L === p) parent.L = q;
	    else parent.R = q;
	  } else {
	    tree._ = q;
	  }
	
	  q.U = parent;
	  p.U = q;
	  p.R = q.L;
	  if (p.R) p.R.U = p;
	  q.L = p;
	}
	
	function RedBlackRotateRight(tree, node) {
	  var p = node,
	      q = node.L,
	      parent = p.U;
	
	  if (parent) {
	    if (parent.L === p) parent.L = q;
	    else parent.R = q;
	  } else {
	    tree._ = q;
	  }
	
	  q.U = parent;
	  p.U = q;
	  p.L = q.R;
	  if (p.L) p.L.U = p;
	  q.R = p;
	}
	
	function RedBlackFirst(node) {
	  while (node.L) node = node.L;
	  return node;
	}
	
	function createEdge(left, right, v0, v1) {
	  var edge = [null, null],
	      index = edges.push(edge) - 1;
	  edge.left = left;
	  edge.right = right;
	  if (v0) setEdgeEnd(edge, left, right, v0);
	  if (v1) setEdgeEnd(edge, right, left, v1);
	  cells[left.index].halfedges.push(index);
	  cells[right.index].halfedges.push(index);
	  return edge;
	}
	
	function createBorderEdge(left, v0, v1) {
	  var edge = [v0, v1];
	  edge.left = left;
	  return edge;
	}
	
	function setEdgeEnd(edge, left, right, vertex) {
	  if (!edge[0] && !edge[1]) {
	    edge[0] = vertex;
	    edge.left = left;
	    edge.right = right;
	  } else if (edge.left === right) {
	    edge[1] = vertex;
	  } else {
	    edge[0] = vertex;
	  }
	}
	
	// Liang–Barsky line clipping.
	function clipEdge(edge, x0, y0, x1, y1) {
	  var a = edge[0],
	      b = edge[1],
	      ax = a[0],
	      ay = a[1],
	      bx = b[0],
	      by = b[1],
	      t0 = 0,
	      t1 = 1,
	      dx = bx - ax,
	      dy = by - ay,
	      r;
	
	  r = x0 - ax;
	  if (!dx && r > 0) return;
	  r /= dx;
	  if (dx < 0) {
	    if (r < t0) return;
	    if (r < t1) t1 = r;
	  } else if (dx > 0) {
	    if (r > t1) return;
	    if (r > t0) t0 = r;
	  }
	
	  r = x1 - ax;
	  if (!dx && r < 0) return;
	  r /= dx;
	  if (dx < 0) {
	    if (r > t1) return;
	    if (r > t0) t0 = r;
	  } else if (dx > 0) {
	    if (r < t0) return;
	    if (r < t1) t1 = r;
	  }
	
	  r = y0 - ay;
	  if (!dy && r > 0) return;
	  r /= dy;
	  if (dy < 0) {
	    if (r < t0) return;
	    if (r < t1) t1 = r;
	  } else if (dy > 0) {
	    if (r > t1) return;
	    if (r > t0) t0 = r;
	  }
	
	  r = y1 - ay;
	  if (!dy && r < 0) return;
	  r /= dy;
	  if (dy < 0) {
	    if (r > t1) return;
	    if (r > t0) t0 = r;
	  } else if (dy > 0) {
	    if (r < t0) return;
	    if (r < t1) t1 = r;
	  }
	
	  if (!(t0 > 0) && !(t1 < 1)) return true; // TODO Better check?
	
	  if (t0 > 0) edge[0] = [ax + t0 * dx, ay + t0 * dy];
	  if (t1 < 1) edge[1] = [ax + t1 * dx, ay + t1 * dy];
	  return true;
	}
	
	function connectEdge(edge, x0, y0, x1, y1) {
	  var v1 = edge[1];
	  if (v1) return true;
	
	  var v0 = edge[0],
	      left = edge.left,
	      right = edge.right,
	      lx = left[0],
	      ly = left[1],
	      rx = right[0],
	      ry = right[1],
	      fx = (lx + rx) / 2,
	      fy = (ly + ry) / 2,
	      fm,
	      fb;
	
	  if (ry === ly) {
	    if (fx < x0 || fx >= x1) return;
	    if (lx > rx) {
	      if (!v0) v0 = [fx, y0];
	      else if (v0[1] >= y1) return;
	      v1 = [fx, y1];
	    } else {
	      if (!v0) v0 = [fx, y1];
	      else if (v0[1] < y0) return;
	      v1 = [fx, y0];
	    }
	  } else {
	    fm = (lx - rx) / (ry - ly);
	    fb = fy - fm * fx;
	    if (fm < -1 || fm > 1) {
	      if (lx > rx) {
	        if (!v0) v0 = [(y0 - fb) / fm, y0];
	        else if (v0[1] >= y1) return;
	        v1 = [(y1 - fb) / fm, y1];
	      } else {
	        if (!v0) v0 = [(y1 - fb) / fm, y1];
	        else if (v0[1] < y0) return;
	        v1 = [(y0 - fb) / fm, y0];
	      }
	    } else {
	      if (ly < ry) {
	        if (!v0) v0 = [x0, fm * x0 + fb];
	        else if (v0[0] >= x1) return;
	        v1 = [x1, fm * x1 + fb];
	      } else {
	        if (!v0) v0 = [x1, fm * x1 + fb];
	        else if (v0[0] < x0) return;
	        v1 = [x0, fm * x0 + fb];
	      }
	    }
	  }
	
	  edge[0] = v0;
	  edge[1] = v1;
	  return true;
	}
	
	function clipEdges(x0, y0, x1, y1) {
	  var i = edges.length,
	      edge;
	
	  while (i--) {
	    if (!connectEdge(edge = edges[i], x0, y0, x1, y1)
	        || !clipEdge(edge, x0, y0, x1, y1)
	        || !(Math.abs(edge[0][0] - edge[1][0]) > epsilon
	            || Math.abs(edge[0][1] - edge[1][1]) > epsilon)) {
	      delete edges[i];
	    }
	  }
	}
	
	function createCell(site) {
	  return cells[site.index] = {
	    site: site,
	    halfedges: []
	  };
	}
	
	function cellHalfedgeAngle(cell, edge) {
	  var site = cell.site,
	      va = edge.left,
	      vb = edge.right;
	  if (site === vb) vb = va, va = site;
	  if (vb) return Math.atan2(vb[1] - va[1], vb[0] - va[0]);
	  if (site === va) va = edge[1], vb = edge[0];
	  else va = edge[0], vb = edge[1];
	  return Math.atan2(va[0] - vb[0], vb[1] - va[1]);
	}
	
	function cellHalfedgeStart(cell, edge) {
	  return edge[+(edge.left !== cell.site)];
	}
	
	function cellHalfedgeEnd(cell, edge) {
	  return edge[+(edge.left === cell.site)];
	}
	
	function sortCellHalfedges() {
	  for (var i = 0, n = cells.length, cell, halfedges, j, m; i < n; ++i) {
	    if ((cell = cells[i]) && (m = (halfedges = cell.halfedges).length)) {
	      var index = new Array(m),
	          array = new Array(m);
	      for (j = 0; j < m; ++j) index[j] = j, array[j] = cellHalfedgeAngle(cell, edges[halfedges[j]]);
	      index.sort(function(i, j) { return array[j] - array[i]; });
	      for (j = 0; j < m; ++j) array[j] = halfedges[index[j]];
	      for (j = 0; j < m; ++j) halfedges[j] = array[j];
	    }
	  }
	}
	
	function clipCells(x0, y0, x1, y1) {
	  var nCells = cells.length,
	      iCell,
	      cell,
	      site,
	      iHalfedge,
	      halfedges,
	      nHalfedges,
	      start,
	      startX,
	      startY,
	      end,
	      endX,
	      endY,
	      cover = true;
	
	  for (iCell = 0; iCell < nCells; ++iCell) {
	    if (cell = cells[iCell]) {
	      site = cell.site;
	      halfedges = cell.halfedges;
	      iHalfedge = halfedges.length;
	
	      // Remove any dangling clipped edges.
	      while (iHalfedge--) {
	        if (!edges[halfedges[iHalfedge]]) {
	          halfedges.splice(iHalfedge, 1);
	        }
	      }
	
	      // Insert any border edges as necessary.
	      iHalfedge = 0, nHalfedges = halfedges.length;
	      while (iHalfedge < nHalfedges) {
	        end = cellHalfedgeEnd(cell, edges[halfedges[iHalfedge]]), endX = end[0], endY = end[1];
	        start = cellHalfedgeStart(cell, edges[halfedges[++iHalfedge % nHalfedges]]), startX = start[0], startY = start[1];
	        if (Math.abs(endX - startX) > epsilon || Math.abs(endY - startY) > epsilon) {
	          halfedges.splice(iHalfedge, 0, edges.push(createBorderEdge(site, end,
	              Math.abs(endX - x0) < epsilon && y1 - endY > epsilon ? [x0, Math.abs(startX - x0) < epsilon ? startY : y1]
	              : Math.abs(endY - y1) < epsilon && x1 - endX > epsilon ? [Math.abs(startY - y1) < epsilon ? startX : x1, y1]
	              : Math.abs(endX - x1) < epsilon && endY - y0 > epsilon ? [x1, Math.abs(startX - x1) < epsilon ? startY : y0]
	              : Math.abs(endY - y0) < epsilon && endX - x0 > epsilon ? [Math.abs(startY - y0) < epsilon ? startX : x0, y0]
	              : null)) - 1);
	          ++nHalfedges;
	        }
	      }
	
	      if (nHalfedges) cover = false;
	    }
	  }
	
	  // If there weren’t any edges, have the closest site cover the extent.
	  // It doesn’t matter which corner of the extent we measure!
	  if (cover) {
	    var dx, dy, d2, dc = Infinity;
	
	    for (iCell = 0, cover = null; iCell < nCells; ++iCell) {
	      if (cell = cells[iCell]) {
	        site = cell.site;
	        dx = site[0] - x0;
	        dy = site[1] - y0;
	        d2 = dx * dx + dy * dy;
	        if (d2 < dc) dc = d2, cover = cell;
	      }
	    }
	
	    if (cover) {
	      var v00 = [x0, y0], v01 = [x0, y1], v11 = [x1, y1], v10 = [x1, y0];
	      cover.halfedges.push(
	        edges.push(createBorderEdge(site = cover.site, v00, v01)) - 1,
	        edges.push(createBorderEdge(site, v01, v11)) - 1,
	        edges.push(createBorderEdge(site, v11, v10)) - 1,
	        edges.push(createBorderEdge(site, v10, v00)) - 1
	      );
	    }
	  }
	
	  // Lastly delete any cells with no edges; these were entirely clipped.
	  for (iCell = 0; iCell < nCells; ++iCell) {
	    if (cell = cells[iCell]) {
	      if (!cell.halfedges.length) {
	        delete cells[iCell];
	      }
	    }
	  }
	}
	
	var circlePool = [];
	
	var firstCircle;
	
	function Circle() {
	  RedBlackNode(this);
	  this.x =
	  this.y =
	  this.arc =
	  this.site =
	  this.cy = null;
	}
	
	function attachCircle(arc) {
	  var lArc = arc.P,
	      rArc = arc.N;
	
	  if (!lArc || !rArc) return;
	
	  var lSite = lArc.site,
	      cSite = arc.site,
	      rSite = rArc.site;
	
	  if (lSite === rSite) return;
	
	  var bx = cSite[0],
	      by = cSite[1],
	      ax = lSite[0] - bx,
	      ay = lSite[1] - by,
	      cx = rSite[0] - bx,
	      cy = rSite[1] - by;
	
	  var d = 2 * (ax * cy - ay * cx);
	  if (d >= -epsilon2) return;
	
	  var ha = ax * ax + ay * ay,
	      hc = cx * cx + cy * cy,
	      x = (cy * ha - ay * hc) / d,
	      y = (ax * hc - cx * ha) / d;
	
	  var circle = circlePool.pop() || new Circle;
	  circle.arc = arc;
	  circle.site = cSite;
	  circle.x = x + bx;
	  circle.y = (circle.cy = y + by) + Math.sqrt(x * x + y * y); // y bottom
	
	  arc.circle = circle;
	
	  var before = null,
	      node = circles._;
	
	  while (node) {
	    if (circle.y < node.y || (circle.y === node.y && circle.x <= node.x)) {
	      if (node.L) node = node.L;
	      else { before = node.P; break; }
	    } else {
	      if (node.R) node = node.R;
	      else { before = node; break; }
	    }
	  }
	
	  circles.insert(before, circle);
	  if (!before) firstCircle = circle;
	}
	
	function detachCircle(arc) {
	  var circle = arc.circle;
	  if (circle) {
	    if (!circle.P) firstCircle = circle.N;
	    circles.remove(circle);
	    circlePool.push(circle);
	    RedBlackNode(circle);
	    arc.circle = null;
	  }
	}
	
	var beachPool = [];
	
	function Beach() {
	  RedBlackNode(this);
	  this.edge =
	  this.site =
	  this.circle = null;
	}
	
	function createBeach(site) {
	  var beach = beachPool.pop() || new Beach;
	  beach.site = site;
	  return beach;
	}
	
	function detachBeach(beach) {
	  detachCircle(beach);
	  beaches.remove(beach);
	  beachPool.push(beach);
	  RedBlackNode(beach);
	}
	
	function removeBeach(beach) {
	  var circle = beach.circle,
	      x = circle.x,
	      y = circle.cy,
	      vertex = [x, y],
	      previous = beach.P,
	      next = beach.N,
	      disappearing = [beach];
	
	  detachBeach(beach);
	
	  var lArc = previous;
	  while (lArc.circle
	      && Math.abs(x - lArc.circle.x) < epsilon
	      && Math.abs(y - lArc.circle.cy) < epsilon) {
	    previous = lArc.P;
	    disappearing.unshift(lArc);
	    detachBeach(lArc);
	    lArc = previous;
	  }
	
	  disappearing.unshift(lArc);
	  detachCircle(lArc);
	
	  var rArc = next;
	  while (rArc.circle
	      && Math.abs(x - rArc.circle.x) < epsilon
	      && Math.abs(y - rArc.circle.cy) < epsilon) {
	    next = rArc.N;
	    disappearing.push(rArc);
	    detachBeach(rArc);
	    rArc = next;
	  }
	
	  disappearing.push(rArc);
	  detachCircle(rArc);
	
	  var nArcs = disappearing.length,
	      iArc;
	  for (iArc = 1; iArc < nArcs; ++iArc) {
	    rArc = disappearing[iArc];
	    lArc = disappearing[iArc - 1];
	    setEdgeEnd(rArc.edge, lArc.site, rArc.site, vertex);
	  }
	
	  lArc = disappearing[0];
	  rArc = disappearing[nArcs - 1];
	  rArc.edge = createEdge(lArc.site, rArc.site, null, vertex);
	
	  attachCircle(lArc);
	  attachCircle(rArc);
	}
	
	function addBeach(site) {
	  var x = site[0],
	      directrix = site[1],
	      lArc,
	      rArc,
	      dxl,
	      dxr,
	      node = beaches._;
	
	  while (node) {
	    dxl = leftBreakPoint(node, directrix) - x;
	    if (dxl > epsilon) node = node.L; else {
	      dxr = x - rightBreakPoint(node, directrix);
	      if (dxr > epsilon) {
	        if (!node.R) {
	          lArc = node;
	          break;
	        }
	        node = node.R;
	      } else {
	        if (dxl > -epsilon) {
	          lArc = node.P;
	          rArc = node;
	        } else if (dxr > -epsilon) {
	          lArc = node;
	          rArc = node.N;
	        } else {
	          lArc = rArc = node;
	        }
	        break;
	      }
	    }
	  }
	
	  createCell(site);
	  var newArc = createBeach(site);
	  beaches.insert(lArc, newArc);
	
	  if (!lArc && !rArc) return;
	
	  if (lArc === rArc) {
	    detachCircle(lArc);
	    rArc = createBeach(lArc.site);
	    beaches.insert(newArc, rArc);
	    newArc.edge = rArc.edge = createEdge(lArc.site, newArc.site);
	    attachCircle(lArc);
	    attachCircle(rArc);
	    return;
	  }
	
	  if (!rArc) { // && lArc
	    newArc.edge = createEdge(lArc.site, newArc.site);
	    return;
	  }
	
	  // else lArc !== rArc
	  detachCircle(lArc);
	  detachCircle(rArc);
	
	  var lSite = lArc.site,
	      ax = lSite[0],
	      ay = lSite[1],
	      bx = site[0] - ax,
	      by = site[1] - ay,
	      rSite = rArc.site,
	      cx = rSite[0] - ax,
	      cy = rSite[1] - ay,
	      d = 2 * (bx * cy - by * cx),
	      hb = bx * bx + by * by,
	      hc = cx * cx + cy * cy,
	      vertex = [(cy * hb - by * hc) / d + ax, (bx * hc - cx * hb) / d + ay];
	
	  setEdgeEnd(rArc.edge, lSite, rSite, vertex);
	  newArc.edge = createEdge(lSite, site, null, vertex);
	  rArc.edge = createEdge(site, rSite, null, vertex);
	  attachCircle(lArc);
	  attachCircle(rArc);
	}
	
	function leftBreakPoint(arc, directrix) {
	  var site = arc.site,
	      rfocx = site[0],
	      rfocy = site[1],
	      pby2 = rfocy - directrix;
	
	  if (!pby2) return rfocx;
	
	  var lArc = arc.P;
	  if (!lArc) return -Infinity;
	
	  site = lArc.site;
	  var lfocx = site[0],
	      lfocy = site[1],
	      plby2 = lfocy - directrix;
	
	  if (!plby2) return lfocx;
	
	  var hl = lfocx - rfocx,
	      aby2 = 1 / pby2 - 1 / plby2,
	      b = hl / plby2;
	
	  if (aby2) return (-b + Math.sqrt(b * b - 2 * aby2 * (hl * hl / (-2 * plby2) - lfocy + plby2 / 2 + rfocy - pby2 / 2))) / aby2 + rfocx;
	
	  return (rfocx + lfocx) / 2;
	}
	
	function rightBreakPoint(arc, directrix) {
	  var rArc = arc.N;
	  if (rArc) return leftBreakPoint(rArc, directrix);
	  var site = arc.site;
	  return site[1] === directrix ? site[0] : Infinity;
	}
	
	var epsilon = 1e-6;
	var epsilon2 = 1e-12;
	var beaches;
	var cells;
	var circles;
	var edges;
	
	function triangleArea(a, b, c) {
	  return (a[0] - c[0]) * (b[1] - a[1]) - (a[0] - b[0]) * (c[1] - a[1]);
	}
	
	function lexicographic(a, b) {
	  return b[1] - a[1]
	      || b[0] - a[0];
	}
	
	function Diagram(sites, extent) {
	  var site = sites.sort(lexicographic).pop(),
	      x,
	      y,
	      circle;
	
	  edges = [];
	  cells = new Array(sites.length);
	  beaches = new RedBlackTree;
	  circles = new RedBlackTree;
	
	  while (true) {
	    circle = firstCircle;
	    if (site && (!circle || site[1] < circle.y || (site[1] === circle.y && site[0] < circle.x))) {
	      if (site[0] !== x || site[1] !== y) {
	        addBeach(site);
	        x = site[0], y = site[1];
	      }
	      site = sites.pop();
	    } else if (circle) {
	      removeBeach(circle.arc);
	    } else {
	      break;
	    }
	  }
	
	  sortCellHalfedges();
	
	  if (extent) {
	    var x0 = +extent[0][0],
	        y0 = +extent[0][1],
	        x1 = +extent[1][0],
	        y1 = +extent[1][1];
	    clipEdges(x0, y0, x1, y1);
	    clipCells(x0, y0, x1, y1);
	  }
	
	  this.edges = edges;
	  this.cells = cells;
	
	  beaches =
	  circles =
	  edges =
	  cells = null;
	}
	
	Diagram.prototype = {
	  constructor: Diagram,
	
	  polygons: function() {
	    var edges = this.edges;
	
	    return this.cells.map(function(cell) {
	      var polygon = cell.halfedges.map(function(i) { return cellHalfedgeStart(cell, edges[i]); });
	      polygon.data = cell.site.data;
	      return polygon;
	    });
	  },
	
	  triangles: function() {
	    var triangles = [],
	        edges = this.edges;
	
	    this.cells.forEach(function(cell, i) {
	      if (!(m = (halfedges = cell.halfedges).length)) return;
	      var site = cell.site,
	          halfedges,
	          j = -1,
	          m,
	          s0,
	          e1 = edges[halfedges[m - 1]],
	          s1 = e1.left === site ? e1.right : e1.left;
	
	      while (++j < m) {
	        s0 = s1;
	        e1 = edges[halfedges[j]];
	        s1 = e1.left === site ? e1.right : e1.left;
	        if (s0 && s1 && i < s0.index && i < s1.index && triangleArea(site, s0, s1) < 0) {
	          triangles.push([site.data, s0.data, s1.data]);
	        }
	      }
	    });
	
	    return triangles;
	  },
	
	  links: function() {
	    return this.edges.filter(function(edge) {
	      return edge.right;
	    }).map(function(edge) {
	      return {
	        source: edge.left.data,
	        target: edge.right.data
	      };
	    });
	  },
	
	  find: function(x, y, radius) {
	    var that = this, i0, i1 = that._found || 0, n = that.cells.length, cell;
	
	    // Use the previously-found cell, or start with an arbitrary one.
	    while (!(cell = that.cells[i1])) if (++i1 >= n) return null;
	    var dx = x - cell.site[0], dy = y - cell.site[1], d2 = dx * dx + dy * dy;
	
	    // Traverse the half-edges to find a closer cell, if any.
	    do {
	      cell = that.cells[i0 = i1], i1 = null;
	      cell.halfedges.forEach(function(e) {
	        var edge = that.edges[e], v = edge.left;
	        if ((v === cell.site || !v) && !(v = edge.right)) return;
	        var vx = x - v[0], vy = y - v[1], v2 = vx * vx + vy * vy;
	        if (v2 < d2) d2 = v2, i1 = v.index;
	      });
	    } while (i1 !== null);
	
	    that._found = i0;
	
	    return radius == null || d2 <= radius * radius ? cell.site : null;
	  }
	};
	
	var voronoi = function() {
	  var x$$1 = x,
	      y$$1 = y,
	      extent = null;
	
	  function voronoi(data) {
	    return new Diagram(data.map(function(d, i) {
	      var s = [Math.round(x$$1(d, i, data) / epsilon) * epsilon, Math.round(y$$1(d, i, data) / epsilon) * epsilon];
	      s.index = i;
	      s.data = d;
	      return s;
	    }), extent);
	  }
	
	  voronoi.polygons = function(data) {
	    return voronoi(data).polygons();
	  };
	
	  voronoi.links = function(data) {
	    return voronoi(data).links();
	  };
	
	  voronoi.triangles = function(data) {
	    return voronoi(data).triangles();
	  };
	
	  voronoi.x = function(_) {
	    return arguments.length ? (x$$1 = typeof _ === "function" ? _ : constant(+_), voronoi) : x$$1;
	  };
	
	  voronoi.y = function(_) {
	    return arguments.length ? (y$$1 = typeof _ === "function" ? _ : constant(+_), voronoi) : y$$1;
	  };
	
	  voronoi.extent = function(_) {
	    return arguments.length ? (extent = _ == null ? null : [[+_[0][0], +_[0][1]], [+_[1][0], +_[1][1]]], voronoi) : extent && [[extent[0][0], extent[0][1]], [extent[1][0], extent[1][1]]];
	  };
	
	  voronoi.size = function(_) {
	    return arguments.length ? (extent = _ == null ? null : [[0, 0], [+_[0], +_[1]]], voronoi) : extent && [extent[1][0] - extent[0][0], extent[1][1] - extent[0][1]];
	  };
	
	  return voronoi;
	};
	
	exports.voronoi = voronoi;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 168 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/Golem.68a82413.svg";

/***/ },
/* 169 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/dicet1.dd849d71.svg";

/***/ },
/* 170 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/nbr.d372fe5a.svg";

/***/ },
/* 171 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	var addEventListener = exports.addEventListener = function addEventListener(node, event, listener) {
	  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
	};
	
	var removeEventListener = exports.removeEventListener = function removeEventListener(node, event, listener) {
	  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
	};
	
	var getConfirmation = exports.getConfirmation = function getConfirmation(message, callback) {
	  return callback(window.confirm(message));
	}; // eslint-disable-line no-alert
	
	/**
	 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
	 *
	 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
	 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
	 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
	 */
	var supportsHistory = exports.supportsHistory = function supportsHistory() {
	  var ua = window.navigator.userAgent;
	
	  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
	
	  return window.history && 'pushState' in window.history;
	};
	
	/**
	 * Returns true if browser fires popstate on hash change.
	 * IE10 and IE11 do not.
	 */
	var supportsPopStateOnHashChange = exports.supportsPopStateOnHashChange = function supportsPopStateOnHashChange() {
	  return window.navigator.userAgent.indexOf('Trident') === -1;
	};
	
	/**
	 * Returns false if using go(n) with hash history causes a full page reload.
	 */
	var supportsGoWithoutReloadUsingHash = exports.supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
	  return window.navigator.userAgent.indexOf('Firefox') === -1;
	};
	
	/**
	 * Returns true if a given popstate event is an extraneous WebKit event.
	 * Accounts for the fact that Chrome on iOS fires real popstate events
	 * containing undefined state when pressing the back button.
	 */
	var isExtraneousPopstateEvent = exports.isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
	  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
	};

/***/ },
/* 172 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(20);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(21);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _LocationUtils = __webpack_require__(76);
	
	var _PathUtils = __webpack_require__(38);
	
	var _createTransitionManager = __webpack_require__(106);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _DOMUtils = __webpack_require__(171);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PopStateEvent = 'popstate';
	var HashChangeEvent = 'hashchange';
	
	var getHistoryState = function getHistoryState() {
	  try {
	    return window.history.state || {};
	  } catch (e) {
	    // IE 11 sometimes throws when accessing window.history.state
	    // See https://github.com/ReactTraining/history/pull/289
	    return {};
	  }
	};
	
	/**
	 * Creates a history object that uses the HTML5 history API including
	 * pushState, replaceState, and the popstate event.
	 */
	var createBrowserHistory = function createBrowserHistory() {
	  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  (0, _invariant2.default)(_DOMUtils.canUseDOM, 'Browser history needs a DOM');
	
	  var globalHistory = window.history;
	  var canUseHistory = (0, _DOMUtils.supportsHistory)();
	  var needsHashChangeListener = !(0, _DOMUtils.supportsPopStateOnHashChange)();
	
	  var _props$forceRefresh = props.forceRefresh,
	      forceRefresh = _props$forceRefresh === undefined ? false : _props$forceRefresh,
	      _props$getUserConfirm = props.getUserConfirmation,
	      getUserConfirmation = _props$getUserConfirm === undefined ? _DOMUtils.getConfirmation : _props$getUserConfirm,
	      _props$keyLength = props.keyLength,
	      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;
	
	  var basename = props.basename ? (0, _PathUtils.stripTrailingSlash)((0, _PathUtils.addLeadingSlash)(props.basename)) : '';
	
	  var getDOMLocation = function getDOMLocation(historyState) {
	    var _ref = historyState || {},
	        key = _ref.key,
	        state = _ref.state;
	
	    var _window$location = window.location,
	        pathname = _window$location.pathname,
	        search = _window$location.search,
	        hash = _window$location.hash;
	
	
	    var path = pathname + search + hash;
	
	    (0, _warning2.default)(!basename || (0, _PathUtils.hasBasename)(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');
	
	    if (basename) path = (0, _PathUtils.stripBasename)(path, basename);
	
	    return (0, _LocationUtils.createLocation)(path, state, key);
	  };
	
	  var createKey = function createKey() {
	    return Math.random().toString(36).substr(2, keyLength);
	  };
	
	  var transitionManager = (0, _createTransitionManager2.default)();
	
	  var setState = function setState(nextState) {
	    _extends(history, nextState);
	
	    history.length = globalHistory.length;
	
	    transitionManager.notifyListeners(history.location, history.action);
	  };
	
	  var handlePopState = function handlePopState(event) {
	    // Ignore extraneous popstate events in WebKit.
	    if ((0, _DOMUtils.isExtraneousPopstateEvent)(event)) return;
	
	    handlePop(getDOMLocation(event.state));
	  };
	
	  var handleHashChange = function handleHashChange() {
	    handlePop(getDOMLocation(getHistoryState()));
	  };
	
	  var forceNextPop = false;
	
	  var handlePop = function handlePop(location) {
	    if (forceNextPop) {
	      forceNextPop = false;
	      setState();
	    } else {
	      var action = 'POP';
	
	      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	        if (ok) {
	          setState({ action: action, location: location });
	        } else {
	          revertPop(location);
	        }
	      });
	    }
	  };
	
	  var revertPop = function revertPop(fromLocation) {
	    var toLocation = history.location;
	
	    // TODO: We could probably make this more reliable by
	    // keeping a list of keys we've seen in sessionStorage.
	    // Instead, we just default to 0 for keys we don't know.
	
	    var toIndex = allKeys.indexOf(toLocation.key);
	
	    if (toIndex === -1) toIndex = 0;
	
	    var fromIndex = allKeys.indexOf(fromLocation.key);
	
	    if (fromIndex === -1) fromIndex = 0;
	
	    var delta = toIndex - fromIndex;
	
	    if (delta) {
	      forceNextPop = true;
	      go(delta);
	    }
	  };
	
	  var initialLocation = getDOMLocation(getHistoryState());
	  var allKeys = [initialLocation.key];
	
	  // Public interface
	
	  var createHref = function createHref(location) {
	    return basename + (0, _PathUtils.createPath)(location);
	  };
	
	  var push = function push(path, state) {
	    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');
	
	    var action = 'PUSH';
	    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);
	
	    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	      if (!ok) return;
	
	      var href = createHref(location);
	      var key = location.key,
	          state = location.state;
	
	
	      if (canUseHistory) {
	        globalHistory.pushState({ key: key, state: state }, null, href);
	
	        if (forceRefresh) {
	          window.location.href = href;
	        } else {
	          var prevIndex = allKeys.indexOf(history.location.key);
	          var nextKeys = allKeys.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);
	
	          nextKeys.push(location.key);
	          allKeys = nextKeys;
	
	          setState({ action: action, location: location });
	        }
	      } else {
	        (0, _warning2.default)(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history');
	
	        window.location.href = href;
	      }
	    });
	  };
	
	  var replace = function replace(path, state) {
	    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');
	
	    var action = 'REPLACE';
	    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);
	
	    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	      if (!ok) return;
	
	      var href = createHref(location);
	      var key = location.key,
	          state = location.state;
	
	
	      if (canUseHistory) {
	        globalHistory.replaceState({ key: key, state: state }, null, href);
	
	        if (forceRefresh) {
	          window.location.replace(href);
	        } else {
	          var prevIndex = allKeys.indexOf(history.location.key);
	
	          if (prevIndex !== -1) allKeys[prevIndex] = location.key;
	
	          setState({ action: action, location: location });
	        }
	      } else {
	        (0, _warning2.default)(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history');
	
	        window.location.replace(href);
	      }
	    });
	  };
	
	  var go = function go(n) {
	    globalHistory.go(n);
	  };
	
	  var goBack = function goBack() {
	    return go(-1);
	  };
	
	  var goForward = function goForward() {
	    return go(1);
	  };
	
	  var listenerCount = 0;
	
	  var checkDOMListeners = function checkDOMListeners(delta) {
	    listenerCount += delta;
	
	    if (listenerCount === 1) {
	      (0, _DOMUtils.addEventListener)(window, PopStateEvent, handlePopState);
	
	      if (needsHashChangeListener) (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
	    } else if (listenerCount === 0) {
	      (0, _DOMUtils.removeEventListener)(window, PopStateEvent, handlePopState);
	
	      if (needsHashChangeListener) (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
	    }
	  };
	
	  var isBlocked = false;
	
	  var block = function block() {
	    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	    var unblock = transitionManager.setPrompt(prompt);
	
	    if (!isBlocked) {
	      checkDOMListeners(1);
	      isBlocked = true;
	    }
	
	    return function () {
	      if (isBlocked) {
	        isBlocked = false;
	        checkDOMListeners(-1);
	      }
	
	      return unblock();
	    };
	  };
	
	  var listen = function listen(listener) {
	    var unlisten = transitionManager.appendListener(listener);
	    checkDOMListeners(1);
	
	    return function () {
	      checkDOMListeners(-1);
	      unlisten();
	    };
	  };
	
	  var history = {
	    length: globalHistory.length,
	    action: 'POP',
	    location: initialLocation,
	    createHref: createHref,
	    push: push,
	    replace: replace,
	    go: go,
	    goBack: goBack,
	    goForward: goForward,
	    block: block,
	    listen: listen
	  };
	
	  return history;
	};
	
	exports.default = createBrowserHistory;

/***/ },
/* 173 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(20);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(21);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _LocationUtils = __webpack_require__(76);
	
	var _PathUtils = __webpack_require__(38);
	
	var _createTransitionManager = __webpack_require__(106);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _DOMUtils = __webpack_require__(171);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HashChangeEvent = 'hashchange';
	
	var HashPathCoders = {
	  hashbang: {
	    encodePath: function encodePath(path) {
	      return path.charAt(0) === '!' ? path : '!/' + (0, _PathUtils.stripLeadingSlash)(path);
	    },
	    decodePath: function decodePath(path) {
	      return path.charAt(0) === '!' ? path.substr(1) : path;
	    }
	  },
	  noslash: {
	    encodePath: _PathUtils.stripLeadingSlash,
	    decodePath: _PathUtils.addLeadingSlash
	  },
	  slash: {
	    encodePath: _PathUtils.addLeadingSlash,
	    decodePath: _PathUtils.addLeadingSlash
	  }
	};
	
	var getHashPath = function getHashPath() {
	  // We can't use window.location.hash here because it's not
	  // consistent across browsers - Firefox will pre-decode it!
	  var href = window.location.href;
	  var hashIndex = href.indexOf('#');
	  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
	};
	
	var pushHashPath = function pushHashPath(path) {
	  return window.location.hash = path;
	};
	
	var replaceHashPath = function replaceHashPath(path) {
	  var hashIndex = window.location.href.indexOf('#');
	
	  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
	};
	
	var createHashHistory = function createHashHistory() {
	  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  (0, _invariant2.default)(_DOMUtils.canUseDOM, 'Hash history needs a DOM');
	
	  var globalHistory = window.history;
	  var canGoWithoutReload = (0, _DOMUtils.supportsGoWithoutReloadUsingHash)();
	
	  var _props$getUserConfirm = props.getUserConfirmation,
	      getUserConfirmation = _props$getUserConfirm === undefined ? _DOMUtils.getConfirmation : _props$getUserConfirm,
	      _props$hashType = props.hashType,
	      hashType = _props$hashType === undefined ? 'slash' : _props$hashType;
	
	  var basename = props.basename ? (0, _PathUtils.stripTrailingSlash)((0, _PathUtils.addLeadingSlash)(props.basename)) : '';
	
	  var _HashPathCoders$hashT = HashPathCoders[hashType],
	      encodePath = _HashPathCoders$hashT.encodePath,
	      decodePath = _HashPathCoders$hashT.decodePath;
	
	
	  var getDOMLocation = function getDOMLocation() {
	    var path = decodePath(getHashPath());
	
	    (0, _warning2.default)(!basename || (0, _PathUtils.hasBasename)(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');
	
	    if (basename) path = (0, _PathUtils.stripBasename)(path, basename);
	
	    return (0, _LocationUtils.createLocation)(path);
	  };
	
	  var transitionManager = (0, _createTransitionManager2.default)();
	
	  var setState = function setState(nextState) {
	    _extends(history, nextState);
	
	    history.length = globalHistory.length;
	
	    transitionManager.notifyListeners(history.location, history.action);
	  };
	
	  var forceNextPop = false;
	  var ignorePath = null;
	
	  var handleHashChange = function handleHashChange() {
	    var path = getHashPath();
	    var encodedPath = encodePath(path);
	
	    if (path !== encodedPath) {
	      // Ensure we always have a properly-encoded hash.
	      replaceHashPath(encodedPath);
	    } else {
	      var location = getDOMLocation();
	      var prevLocation = history.location;
	
	      if (!forceNextPop && (0, _LocationUtils.locationsAreEqual)(prevLocation, location)) return; // A hashchange doesn't always == location change.
	
	      if (ignorePath === (0, _PathUtils.createPath)(location)) return; // Ignore this change; we already setState in push/replace.
	
	      ignorePath = null;
	
	      handlePop(location);
	    }
	  };
	
	  var handlePop = function handlePop(location) {
	    if (forceNextPop) {
	      forceNextPop = false;
	      setState();
	    } else {
	      var action = 'POP';
	
	      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	        if (ok) {
	          setState({ action: action, location: location });
	        } else {
	          revertPop(location);
	        }
	      });
	    }
	  };
	
	  var revertPop = function revertPop(fromLocation) {
	    var toLocation = history.location;
	
	    // TODO: We could probably make this more reliable by
	    // keeping a list of paths we've seen in sessionStorage.
	    // Instead, we just default to 0 for paths we don't know.
	
	    var toIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(toLocation));
	
	    if (toIndex === -1) toIndex = 0;
	
	    var fromIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(fromLocation));
	
	    if (fromIndex === -1) fromIndex = 0;
	
	    var delta = toIndex - fromIndex;
	
	    if (delta) {
	      forceNextPop = true;
	      go(delta);
	    }
	  };
	
	  // Ensure the hash is encoded properly before doing anything else.
	  var path = getHashPath();
	  var encodedPath = encodePath(path);
	
	  if (path !== encodedPath) replaceHashPath(encodedPath);
	
	  var initialLocation = getDOMLocation();
	  var allPaths = [(0, _PathUtils.createPath)(initialLocation)];
	
	  // Public interface
	
	  var createHref = function createHref(location) {
	    return '#' + encodePath(basename + (0, _PathUtils.createPath)(location));
	  };
	
	  var push = function push(path, state) {
	    (0, _warning2.default)(state === undefined, 'Hash history cannot push state; it is ignored');
	
	    var action = 'PUSH';
	    var location = (0, _LocationUtils.createLocation)(path, undefined, undefined, history.location);
	
	    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	      if (!ok) return;
	
	      var path = (0, _PathUtils.createPath)(location);
	      var encodedPath = encodePath(basename + path);
	      var hashChanged = getHashPath() !== encodedPath;
	
	      if (hashChanged) {
	        // We cannot tell if a hashchange was caused by a PUSH, so we'd
	        // rather setState here and ignore the hashchange. The caveat here
	        // is that other hash histories in the page will consider it a POP.
	        ignorePath = path;
	        pushHashPath(encodedPath);
	
	        var prevIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(history.location));
	        var nextPaths = allPaths.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);
	
	        nextPaths.push(path);
	        allPaths = nextPaths;
	
	        setState({ action: action, location: location });
	      } else {
	        (0, _warning2.default)(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack');
	
	        setState();
	      }
	    });
	  };
	
	  var replace = function replace(path, state) {
	    (0, _warning2.default)(state === undefined, 'Hash history cannot replace state; it is ignored');
	
	    var action = 'REPLACE';
	    var location = (0, _LocationUtils.createLocation)(path, undefined, undefined, history.location);
	
	    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	      if (!ok) return;
	
	      var path = (0, _PathUtils.createPath)(location);
	      var encodedPath = encodePath(basename + path);
	      var hashChanged = getHashPath() !== encodedPath;
	
	      if (hashChanged) {
	        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
	        // rather setState here and ignore the hashchange. The caveat here
	        // is that other hash histories in the page will consider it a POP.
	        ignorePath = path;
	        replaceHashPath(encodedPath);
	      }
	
	      var prevIndex = allPaths.indexOf((0, _PathUtils.createPath)(history.location));
	
	      if (prevIndex !== -1) allPaths[prevIndex] = path;
	
	      setState({ action: action, location: location });
	    });
	  };
	
	  var go = function go(n) {
	    (0, _warning2.default)(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser');
	
	    globalHistory.go(n);
	  };
	
	  var goBack = function goBack() {
	    return go(-1);
	  };
	
	  var goForward = function goForward() {
	    return go(1);
	  };
	
	  var listenerCount = 0;
	
	  var checkDOMListeners = function checkDOMListeners(delta) {
	    listenerCount += delta;
	
	    if (listenerCount === 1) {
	      (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
	    } else if (listenerCount === 0) {
	      (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
	    }
	  };
	
	  var isBlocked = false;
	
	  var block = function block() {
	    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	    var unblock = transitionManager.setPrompt(prompt);
	
	    if (!isBlocked) {
	      checkDOMListeners(1);
	      isBlocked = true;
	    }
	
	    return function () {
	      if (isBlocked) {
	        isBlocked = false;
	        checkDOMListeners(-1);
	      }
	
	      return unblock();
	    };
	  };
	
	  var listen = function listen(listener) {
	    var unlisten = transitionManager.appendListener(listener);
	    checkDOMListeners(1);
	
	    return function () {
	      checkDOMListeners(-1);
	      unlisten();
	    };
	  };
	
	  var history = {
	    length: globalHistory.length,
	    action: 'POP',
	    location: initialLocation,
	    createHref: createHref,
	    push: push,
	    replace: replace,
	    go: go,
	    goBack: goBack,
	    goForward: goForward,
	    block: block,
	    listen: listen
	  };
	
	  return history;
	};
	
	exports.default = createHashHistory;

/***/ },
/* 174 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(20);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _PathUtils = __webpack_require__(38);
	
	var _LocationUtils = __webpack_require__(76);
	
	var _createTransitionManager = __webpack_require__(106);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var clamp = function clamp(n, lowerBound, upperBound) {
	  return Math.min(Math.max(n, lowerBound), upperBound);
	};
	
	/**
	 * Creates a history object that stores locations in memory.
	 */
	var createMemoryHistory = function createMemoryHistory() {
	  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var getUserConfirmation = props.getUserConfirmation,
	      _props$initialEntries = props.initialEntries,
	      initialEntries = _props$initialEntries === undefined ? ['/'] : _props$initialEntries,
	      _props$initialIndex = props.initialIndex,
	      initialIndex = _props$initialIndex === undefined ? 0 : _props$initialIndex,
	      _props$keyLength = props.keyLength,
	      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;
	
	
	  var transitionManager = (0, _createTransitionManager2.default)();
	
	  var setState = function setState(nextState) {
	    _extends(history, nextState);
	
	    history.length = history.entries.length;
	
	    transitionManager.notifyListeners(history.location, history.action);
	  };
	
	  var createKey = function createKey() {
	    return Math.random().toString(36).substr(2, keyLength);
	  };
	
	  var index = clamp(initialIndex, 0, initialEntries.length - 1);
	  var entries = initialEntries.map(function (entry) {
	    return typeof entry === 'string' ? (0, _LocationUtils.createLocation)(entry, undefined, createKey()) : (0, _LocationUtils.createLocation)(entry, undefined, entry.key || createKey());
	  });
	
	  // Public interface
	
	  var createHref = _PathUtils.createPath;
	
	  var push = function push(path, state) {
	    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');
	
	    var action = 'PUSH';
	    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);
	
	    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	      if (!ok) return;
	
	      var prevIndex = history.index;
	      var nextIndex = prevIndex + 1;
	
	      var nextEntries = history.entries.slice(0);
	      if (nextEntries.length > nextIndex) {
	        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
	      } else {
	        nextEntries.push(location);
	      }
	
	      setState({
	        action: action,
	        location: location,
	        index: nextIndex,
	        entries: nextEntries
	      });
	    });
	  };
	
	  var replace = function replace(path, state) {
	    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');
	
	    var action = 'REPLACE';
	    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);
	
	    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	      if (!ok) return;
	
	      history.entries[history.index] = location;
	
	      setState({ action: action, location: location });
	    });
	  };
	
	  var go = function go(n) {
	    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);
	
	    var action = 'POP';
	    var location = history.entries[nextIndex];
	
	    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	      if (ok) {
	        setState({
	          action: action,
	          location: location,
	          index: nextIndex
	        });
	      } else {
	        // Mimic the behavior of DOM histories by
	        // causing a render after a cancelled POP.
	        setState();
	      }
	    });
	  };
	
	  var goBack = function goBack() {
	    return go(-1);
	  };
	
	  var goForward = function goForward() {
	    return go(1);
	  };
	
	  var canGo = function canGo(n) {
	    var nextIndex = history.index + n;
	    return nextIndex >= 0 && nextIndex < history.entries.length;
	  };
	
	  var block = function block() {
	    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	    return transitionManager.setPrompt(prompt);
	  };
	
	  var listen = function listen(listener) {
	    return transitionManager.appendListener(listener);
	  };
	
	  var history = {
	    length: entries.length,
	    action: 'POP',
	    location: entries[index],
	    index: index,
	    entries: entries,
	    createHref: createHref,
	    push: push,
	    replace: replace,
	    go: go,
	    goBack: goBack,
	    goForward: goForward,
	    canGo: canGo,
	    block: block,
	    listen: listen
	  };
	
	  return history;
	};
	
	exports.default = createMemoryHistory;

/***/ },
/* 175 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(34),
	    root = __webpack_require__(15);
	
	/* Built-in method references that are verified to be native. */
	var Set = getNative(root, 'Set');
	
	module.exports = Set;


/***/ },
/* 176 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(15);
	
	/** Built-in value references. */
	var Uint8Array = root.Uint8Array;
	
	module.exports = Uint8Array;


/***/ },
/* 177 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(34),
	    root = __webpack_require__(15);
	
	/* Built-in method references that are verified to be native. */
	var WeakMap = getNative(root, 'WeakMap');
	
	module.exports = WeakMap;


/***/ },
/* 178 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.forEach` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns `array`.
	 */
	function arrayEach(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (iteratee(array[index], index, array) === false) {
	      break;
	    }
	  }
	  return array;
	}
	
	module.exports = arrayEach;


/***/ },
/* 179 */
/***/ function(module, exports) {

	/**
	 * This function is like `arrayIncludes` except that it accepts a comparator.
	 *
	 * @private
	 * @param {Array} [array] The array to inspect.
	 * @param {*} target The value to search for.
	 * @param {Function} comparator The comparator invoked per element.
	 * @returns {boolean} Returns `true` if `target` is found, else `false`.
	 */
	function arrayIncludesWith(array, value, comparator) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (comparator(value, array[index])) {
	      return true;
	    }
	  }
	  return false;
	}
	
	module.exports = arrayIncludesWith;


/***/ },
/* 180 */
/***/ function(module, exports, __webpack_require__) {

	var baseTimes = __webpack_require__(399),
	    isArguments = __webpack_require__(54),
	    isArray = __webpack_require__(9),
	    isBuffer = __webpack_require__(55),
	    isIndex = __webpack_require__(51),
	    isTypedArray = __webpack_require__(95);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  var isArr = isArray(value),
	      isArg = !isArr && isArguments(value),
	      isBuff = !isArr && !isArg && isBuffer(value),
	      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	      skipIndexes = isArr || isArg || isBuff || isType,
	      result = skipIndexes ? baseTimes(value.length, String) : [],
	      length = result.length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (
	           // Safari 9 has enumerable `arguments.length` in strict mode.
	           key == 'length' ||
	           // Node.js 0.10 has enumerable non-index properties on buffers.
	           (isBuff && (key == 'offset' || key == 'parent')) ||
	           // PhantomJS 2 has enumerable non-index properties on typed arrays.
	           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	           // Skip index properties.
	           isIndex(key, length)
	        ))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = arrayLikeKeys;


/***/ },
/* 181 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.some` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function arraySome(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (predicate(array[index], index, array)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	module.exports = arraySome;


/***/ },
/* 182 */
/***/ function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(81),
	    eq = __webpack_require__(35);
	
	/**
	 * This function is like `assignValue` except that it doesn't assign
	 * `undefined` values.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignMergeValue(object, key, value) {
	  if ((value !== undefined && !eq(object[key], value)) ||
	      (value === undefined && !(key in object))) {
	    baseAssignValue(object, key, value);
	  }
	}
	
	module.exports = assignMergeValue;


/***/ },
/* 183 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.findIndex` and `_.findLastIndex` without
	 * support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Function} predicate The function invoked per iteration.
	 * @param {number} fromIndex The index to search from.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseFindIndex(array, predicate, fromIndex, fromRight) {
	  var length = array.length,
	      index = fromIndex + (fromRight ? 1 : -1);
	
	  while ((fromRight ? index-- : ++index < length)) {
	    if (predicate(array[index], index, array)) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = baseFindIndex;


/***/ },
/* 184 */
/***/ function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(114),
	    isFlattenable = __webpack_require__(446);
	
	/**
	 * The base implementation of `_.flatten` with support for restricting flattening.
	 *
	 * @private
	 * @param {Array} array The array to flatten.
	 * @param {number} depth The maximum recursion depth.
	 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	 * @param {Array} [result=[]] The initial result value.
	 * @returns {Array} Returns the new flattened array.
	 */
	function baseFlatten(array, depth, predicate, isStrict, result) {
	  var index = -1,
	      length = array.length;
	
	  predicate || (predicate = isFlattenable);
	  result || (result = []);
	
	  while (++index < length) {
	    var value = array[index];
	    if (depth > 0 && predicate(value)) {
	      if (depth > 1) {
	        // Recursively flatten arrays (susceptible to call stack limits).
	        baseFlatten(value, depth - 1, predicate, isStrict, result);
	      } else {
	        arrayPush(result, value);
	      }
	    } else if (!isStrict) {
	      result[result.length] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = baseFlatten;


/***/ },
/* 185 */
/***/ function(module, exports, __webpack_require__) {

	var createBaseFor = __webpack_require__(418);
	
	/**
	 * The base implementation of `baseForOwn` which iterates over `object`
	 * properties returned by `keysFunc` and invokes `iteratee` for each property.
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();
	
	module.exports = baseFor;


/***/ },
/* 186 */
/***/ function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(114),
	    isArray = __webpack_require__(9);
	
	/**
	 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @param {Function} symbolsFunc The function to get the symbols of `object`.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	  var result = keysFunc(object);
	  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	}
	
	module.exports = baseGetAllKeys;


/***/ },
/* 187 */
/***/ function(module, exports, __webpack_require__) {

	var baseFindIndex = __webpack_require__(183),
	    baseIsNaN = __webpack_require__(377),
	    strictIndexOf = __webpack_require__(476);
	
	/**
	 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseIndexOf(array, value, fromIndex) {
	  return value === value
	    ? strictIndexOf(array, value, fromIndex)
	    : baseFindIndex(array, baseIsNaN, fromIndex);
	}
	
	module.exports = baseIndexOf;


/***/ },
/* 188 */
/***/ function(module, exports, __webpack_require__) {

	var isPrototype = __webpack_require__(52),
	    nativeKeys = __webpack_require__(461);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeys;


/***/ },
/* 189 */
/***/ function(module, exports, __webpack_require__) {

	var identity = __webpack_require__(22),
	    metaMap = __webpack_require__(209);
	
	/**
	 * The base implementation of `setData` without support for hot loop shorting.
	 *
	 * @private
	 * @param {Function} func The function to associate metadata with.
	 * @param {*} data The metadata.
	 * @returns {Function} Returns `func`.
	 */
	var baseSetData = !metaMap ? identity : function(func, data) {
	  metaMap.set(func, data);
	  return func;
	};
	
	module.exports = baseSetData;


/***/ },
/* 190 */
/***/ function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(112),
	    arrayIncludes = __webpack_require__(113),
	    arrayIncludesWith = __webpack_require__(179),
	    cacheHas = __webpack_require__(121),
	    createSet = __webpack_require__(426),
	    setToArray = __webpack_require__(92);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Function} [iteratee] The iteratee invoked per element.
	 * @param {Function} [comparator] The comparator invoked per element.
	 * @returns {Array} Returns the new duplicate free array.
	 */
	function baseUniq(array, iteratee, comparator) {
	  var index = -1,
	      includes = arrayIncludes,
	      length = array.length,
	      isCommon = true,
	      result = [],
	      seen = result;
	
	  if (comparator) {
	    isCommon = false;
	    includes = arrayIncludesWith;
	  }
	  else if (length >= LARGE_ARRAY_SIZE) {
	    var set = iteratee ? null : createSet(array);
	    if (set) {
	      return setToArray(set);
	    }
	    isCommon = false;
	    includes = cacheHas;
	    seen = new SetCache;
	  }
	  else {
	    seen = iteratee ? [] : result;
	  }
	  outer:
	  while (++index < length) {
	    var value = array[index],
	        computed = iteratee ? iteratee(value) : value;
	
	    value = (comparator || value !== 0) ? value : 0;
	    if (isCommon && computed === computed) {
	      var seenIndex = seen.length;
	      while (seenIndex--) {
	        if (seen[seenIndex] === computed) {
	          continue outer;
	        }
	      }
	      if (iteratee) {
	        seen.push(computed);
	      }
	      result.push(value);
	    }
	    else if (!includes(seen, computed, comparator)) {
	      if (seen !== result) {
	        seen.push(computed);
	      }
	      result.push(value);
	    }
	  }
	  return result;
	}
	
	module.exports = baseUniq;


/***/ },
/* 191 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(15);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined,
	    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
	
	/**
	 * Creates a clone of  `buffer`.
	 *
	 * @private
	 * @param {Buffer} buffer The buffer to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Buffer} Returns the cloned buffer.
	 */
	function cloneBuffer(buffer, isDeep) {
	  if (isDeep) {
	    return buffer.slice();
	  }
	  var length = buffer.length,
	      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
	
	  buffer.copy(result);
	  return result;
	}
	
	module.exports = cloneBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(99)(module)))

/***/ },
/* 192 */
/***/ function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(122);
	
	/**
	 * Creates a clone of `typedArray`.
	 *
	 * @private
	 * @param {Object} typedArray The typed array to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned typed array.
	 */
	function cloneTypedArray(typedArray, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	}
	
	module.exports = cloneTypedArray;


/***/ },
/* 193 */
/***/ function(module, exports) {

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * Creates an array that is the composition of partially applied arguments,
	 * placeholders, and provided arguments into a single array of arguments.
	 *
	 * @private
	 * @param {Array} args The provided arguments.
	 * @param {Array} partials The arguments to prepend to those provided.
	 * @param {Array} holders The `partials` placeholder indexes.
	 * @params {boolean} [isCurried] Specify composing for a curried function.
	 * @returns {Array} Returns the new array of composed arguments.
	 */
	function composeArgs(args, partials, holders, isCurried) {
	  var argsIndex = -1,
	      argsLength = args.length,
	      holdersLength = holders.length,
	      leftIndex = -1,
	      leftLength = partials.length,
	      rangeLength = nativeMax(argsLength - holdersLength, 0),
	      result = Array(leftLength + rangeLength),
	      isUncurried = !isCurried;
	
	  while (++leftIndex < leftLength) {
	    result[leftIndex] = partials[leftIndex];
	  }
	  while (++argsIndex < holdersLength) {
	    if (isUncurried || argsIndex < argsLength) {
	      result[holders[argsIndex]] = args[argsIndex];
	    }
	  }
	  while (rangeLength--) {
	    result[leftIndex++] = args[argsIndex++];
	  }
	  return result;
	}
	
	module.exports = composeArgs;


/***/ },
/* 194 */
/***/ function(module, exports) {

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * This function is like `composeArgs` except that the arguments composition
	 * is tailored for `_.partialRight`.
	 *
	 * @private
	 * @param {Array} args The provided arguments.
	 * @param {Array} partials The arguments to append to those provided.
	 * @param {Array} holders The `partials` placeholder indexes.
	 * @params {boolean} [isCurried] Specify composing for a curried function.
	 * @returns {Array} Returns the new array of composed arguments.
	 */
	function composeArgsRight(args, partials, holders, isCurried) {
	  var argsIndex = -1,
	      argsLength = args.length,
	      holdersIndex = -1,
	      holdersLength = holders.length,
	      rightIndex = -1,
	      rightLength = partials.length,
	      rangeLength = nativeMax(argsLength - holdersLength, 0),
	      result = Array(rangeLength + rightLength),
	      isUncurried = !isCurried;
	
	  while (++argsIndex < rangeLength) {
	    result[argsIndex] = args[argsIndex];
	  }
	  var offset = argsIndex;
	  while (++rightIndex < rightLength) {
	    result[offset + rightIndex] = partials[rightIndex];
	  }
	  while (++holdersIndex < holdersLength) {
	    if (isUncurried || argsIndex < argsLength) {
	      result[offset + holders[holdersIndex]] = args[argsIndex++];
	    }
	  }
	  return result;
	}
	
	module.exports = composeArgsRight;


/***/ },
/* 195 */
/***/ function(module, exports, __webpack_require__) {

	var composeArgs = __webpack_require__(193),
	    composeArgsRight = __webpack_require__(194),
	    countHolders = __webpack_require__(415),
	    createCtor = __webpack_require__(86),
	    createRecurry = __webpack_require__(196),
	    getHolder = __webpack_require__(87),
	    reorder = __webpack_require__(467),
	    replaceHolders = __webpack_require__(53),
	    root = __webpack_require__(15);
	
	/** Used to compose bitmasks for function metadata. */
	var WRAP_BIND_FLAG = 1,
	    WRAP_BIND_KEY_FLAG = 2,
	    WRAP_CURRY_FLAG = 8,
	    WRAP_CURRY_RIGHT_FLAG = 16,
	    WRAP_ARY_FLAG = 128,
	    WRAP_FLIP_FLAG = 512;
	
	/**
	 * Creates a function that wraps `func` to invoke it with optional `this`
	 * binding of `thisArg`, partial application, and currying.
	 *
	 * @private
	 * @param {Function|string} func The function or method name to wrap.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @param {*} [thisArg] The `this` binding of `func`.
	 * @param {Array} [partials] The arguments to prepend to those provided to
	 *  the new function.
	 * @param {Array} [holders] The `partials` placeholder indexes.
	 * @param {Array} [partialsRight] The arguments to append to those provided
	 *  to the new function.
	 * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
	 * @param {Array} [argPos] The argument positions of the new function.
	 * @param {number} [ary] The arity cap of `func`.
	 * @param {number} [arity] The arity of `func`.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
	  var isAry = bitmask & WRAP_ARY_FLAG,
	      isBind = bitmask & WRAP_BIND_FLAG,
	      isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
	      isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
	      isFlip = bitmask & WRAP_FLIP_FLAG,
	      Ctor = isBindKey ? undefined : createCtor(func);
	
	  function wrapper() {
	    var length = arguments.length,
	        args = Array(length),
	        index = length;
	
	    while (index--) {
	      args[index] = arguments[index];
	    }
	    if (isCurried) {
	      var placeholder = getHolder(wrapper),
	          holdersCount = countHolders(args, placeholder);
	    }
	    if (partials) {
	      args = composeArgs(args, partials, holders, isCurried);
	    }
	    if (partialsRight) {
	      args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
	    }
	    length -= holdersCount;
	    if (isCurried && length < arity) {
	      var newHolders = replaceHolders(args, placeholder);
	      return createRecurry(
	        func, bitmask, createHybrid, wrapper.placeholder, thisArg,
	        args, newHolders, argPos, ary, arity - length
	      );
	    }
	    var thisBinding = isBind ? thisArg : this,
	        fn = isBindKey ? thisBinding[func] : func;
	
	    length = args.length;
	    if (argPos) {
	      args = reorder(args, argPos);
	    } else if (isFlip && length > 1) {
	      args.reverse();
	    }
	    if (isAry && ary < length) {
	      args.length = ary;
	    }
	    if (this && this !== root && this instanceof wrapper) {
	      fn = Ctor || createCtor(fn);
	    }
	    return fn.apply(thisBinding, args);
	  }
	  return wrapper;
	}
	
	module.exports = createHybrid;


/***/ },
/* 196 */
/***/ function(module, exports, __webpack_require__) {

	var isLaziable = __webpack_require__(206),
	    setData = __webpack_require__(212),
	    setWrapToString = __webpack_require__(213);
	
	/** Used to compose bitmasks for function metadata. */
	var WRAP_BIND_FLAG = 1,
	    WRAP_BIND_KEY_FLAG = 2,
	    WRAP_CURRY_BOUND_FLAG = 4,
	    WRAP_CURRY_FLAG = 8,
	    WRAP_PARTIAL_FLAG = 32,
	    WRAP_PARTIAL_RIGHT_FLAG = 64;
	
	/**
	 * Creates a function that wraps `func` to continue currying.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @param {Function} wrapFunc The function to create the `func` wrapper.
	 * @param {*} placeholder The placeholder value.
	 * @param {*} [thisArg] The `this` binding of `func`.
	 * @param {Array} [partials] The arguments to prepend to those provided to
	 *  the new function.
	 * @param {Array} [holders] The `partials` placeholder indexes.
	 * @param {Array} [argPos] The argument positions of the new function.
	 * @param {number} [ary] The arity cap of `func`.
	 * @param {number} [arity] The arity of `func`.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
	  var isCurry = bitmask & WRAP_CURRY_FLAG,
	      newHolders = isCurry ? holders : undefined,
	      newHoldersRight = isCurry ? undefined : holders,
	      newPartials = isCurry ? partials : undefined,
	      newPartialsRight = isCurry ? undefined : partials;
	
	  bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
	  bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
	
	  if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
	    bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
	  }
	  var newData = [
	    func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
	    newHoldersRight, argPos, ary, arity
	  ];
	
	  var result = wrapFunc.apply(undefined, newData);
	  if (isLaziable(func)) {
	    setData(result, newData);
	  }
	  result.placeholder = placeholder;
	  return setWrapToString(result, func, bitmask);
	}
	
	module.exports = createRecurry;


/***/ },
/* 197 */
/***/ function(module, exports, __webpack_require__) {

	var baseSetData = __webpack_require__(189),
	    createBind = __webpack_require__(419),
	    createCurry = __webpack_require__(420),
	    createHybrid = __webpack_require__(195),
	    createPartial = __webpack_require__(424),
	    getData = __webpack_require__(124),
	    mergeData = __webpack_require__(460),
	    setData = __webpack_require__(212),
	    setWrapToString = __webpack_require__(213),
	    toInteger = __webpack_require__(135);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/** Used to compose bitmasks for function metadata. */
	var WRAP_BIND_FLAG = 1,
	    WRAP_BIND_KEY_FLAG = 2,
	    WRAP_CURRY_FLAG = 8,
	    WRAP_CURRY_RIGHT_FLAG = 16,
	    WRAP_PARTIAL_FLAG = 32,
	    WRAP_PARTIAL_RIGHT_FLAG = 64;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * Creates a function that either curries or invokes `func` with optional
	 * `this` binding and partially applied arguments.
	 *
	 * @private
	 * @param {Function|string} func The function or method name to wrap.
	 * @param {number} bitmask The bitmask flags.
	 *    1 - `_.bind`
	 *    2 - `_.bindKey`
	 *    4 - `_.curry` or `_.curryRight` of a bound function
	 *    8 - `_.curry`
	 *   16 - `_.curryRight`
	 *   32 - `_.partial`
	 *   64 - `_.partialRight`
	 *  128 - `_.rearg`
	 *  256 - `_.ary`
	 *  512 - `_.flip`
	 * @param {*} [thisArg] The `this` binding of `func`.
	 * @param {Array} [partials] The arguments to be partially applied.
	 * @param {Array} [holders] The `partials` placeholder indexes.
	 * @param {Array} [argPos] The argument positions of the new function.
	 * @param {number} [ary] The arity cap of `func`.
	 * @param {number} [arity] The arity of `func`.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
	  var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
	  if (!isBindKey && typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var length = partials ? partials.length : 0;
	  if (!length) {
	    bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
	    partials = holders = undefined;
	  }
	  ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
	  arity = arity === undefined ? arity : toInteger(arity);
	  length -= holders ? holders.length : 0;
	
	  if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
	    var partialsRight = partials,
	        holdersRight = holders;
	
	    partials = holders = undefined;
	  }
	  var data = isBindKey ? undefined : getData(func);
	
	  var newData = [
	    func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
	    argPos, ary, arity
	  ];
	
	  if (data) {
	    mergeData(newData, data);
	  }
	  func = newData[0];
	  bitmask = newData[1];
	  thisArg = newData[2];
	  partials = newData[3];
	  holders = newData[4];
	  arity = newData[9] = newData[9] === undefined
	    ? (isBindKey ? 0 : func.length)
	    : nativeMax(newData[9] - length, 0);
	
	  if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
	    bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
	  }
	  if (!bitmask || bitmask == WRAP_BIND_FLAG) {
	    var result = createBind(func, bitmask, thisArg);
	  } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
	    result = createCurry(func, bitmask, arity);
	  } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
	    result = createPartial(func, bitmask, thisArg, partials);
	  } else {
	    result = createHybrid.apply(undefined, newData);
	  }
	  var setter = data ? baseSetData : setData;
	  return setWrapToString(setter(result, newData), func, bitmask);
	}
	
	module.exports = createWrap;


/***/ },
/* 198 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(34);
	
	var defineProperty = (function() {
	  try {
	    var func = getNative(Object, 'defineProperty');
	    func({}, '', {});
	    return func;
	  } catch (e) {}
	}());
	
	module.exports = defineProperty;


/***/ },
/* 199 */
/***/ function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(112),
	    arraySome = __webpack_require__(181),
	    cacheHas = __webpack_require__(121);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for arrays with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Array} array The array to compare.
	 * @param {Array} other The other array to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `array` and `other` objects.
	 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	 */
	function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      arrLength = array.length,
	      othLength = other.length;
	
	  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	    return false;
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(array);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var index = -1,
	      result = true,
	      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	  stack.set(array, other);
	  stack.set(other, array);
	
	  // Ignore non-index properties.
	  while (++index < arrLength) {
	    var arrValue = array[index],
	        othValue = other[index];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, arrValue, index, other, array, stack)
	        : customizer(arrValue, othValue, index, array, other, stack);
	    }
	    if (compared !== undefined) {
	      if (compared) {
	        continue;
	      }
	      result = false;
	      break;
	    }
	    // Recursively compare arrays (susceptible to call stack limits).
	    if (seen) {
	      if (!arraySome(other, function(othValue, othIndex) {
	            if (!cacheHas(seen, othIndex) &&
	                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	              return seen.push(othIndex);
	            }
	          })) {
	        result = false;
	        break;
	      }
	    } else if (!(
	          arrValue === othValue ||
	            equalFunc(arrValue, othValue, bitmask, customizer, stack)
	        )) {
	      result = false;
	      break;
	    }
	  }
	  stack['delete'](array);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalArrays;


/***/ },
/* 200 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	module.exports = freeGlobal;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 201 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetAllKeys = __webpack_require__(186),
	    getSymbols = __webpack_require__(126),
	    keys = __webpack_require__(12);
	
	/**
	 * Creates an array of own enumerable property names and symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeys(object) {
	  return baseGetAllKeys(object, keys, getSymbols);
	}
	
	module.exports = getAllKeys;


/***/ },
/* 202 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetAllKeys = __webpack_require__(186),
	    getSymbolsIn = __webpack_require__(204),
	    keysIn = __webpack_require__(44);
	
	/**
	 * Creates an array of own and inherited enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeysIn(object) {
	  return baseGetAllKeys(object, keysIn, getSymbolsIn);
	}
	
	module.exports = getAllKeysIn;


/***/ },
/* 203 */
/***/ function(module, exports, __webpack_require__) {

	var realNames = __webpack_require__(466);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Gets the name of `func`.
	 *
	 * @private
	 * @param {Function} func The function to query.
	 * @returns {string} Returns the function name.
	 */
	function getFuncName(func) {
	  var result = (func.name + ''),
	      array = realNames[result],
	      length = hasOwnProperty.call(realNames, result) ? array.length : 0;
	
	  while (length--) {
	    var data = array[length],
	        otherFunc = data.func;
	    if (otherFunc == null || otherFunc == func) {
	      return data.name;
	    }
	  }
	  return result;
	}
	
	module.exports = getFuncName;


/***/ },
/* 204 */
/***/ function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(114),
	    getPrototype = __webpack_require__(125),
	    getSymbols = __webpack_require__(126),
	    stubArray = __webpack_require__(225);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols;
	
	/**
	 * Creates an array of the own and inherited enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
	  var result = [];
	  while (object) {
	    arrayPush(result, getSymbols(object));
	    object = getPrototype(object);
	  }
	  return result;
	};
	
	module.exports = getSymbolsIn;


/***/ },
/* 205 */
/***/ function(module, exports, __webpack_require__) {

	var baseCreate = __webpack_require__(82),
	    getPrototype = __webpack_require__(125),
	    isPrototype = __webpack_require__(52);
	
	/**
	 * Initializes an object clone.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneObject(object) {
	  return (typeof object.constructor == 'function' && !isPrototype(object))
	    ? baseCreate(getPrototype(object))
	    : {};
	}
	
	module.exports = initCloneObject;


/***/ },
/* 206 */
/***/ function(module, exports, __webpack_require__) {

	var LazyWrapper = __webpack_require__(108),
	    getData = __webpack_require__(124),
	    getFuncName = __webpack_require__(203),
	    lodash = __webpack_require__(504);
	
	/**
	 * Checks if `func` has a lazy counterpart.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
	 *  else `false`.
	 */
	function isLaziable(func) {
	  var funcName = getFuncName(func),
	      other = lodash[funcName];
	
	  if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
	    return false;
	  }
	  if (func === other) {
	    return true;
	  }
	  var data = getData(other);
	  return !!data && func === data[0];
	}
	
	module.exports = isLaziable;


/***/ },
/* 207 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(10);
	
	/**
	 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` if suitable for strict
	 *  equality comparisons, else `false`.
	 */
	function isStrictComparable(value) {
	  return value === value && !isObject(value);
	}
	
	module.exports = isStrictComparable;


/***/ },
/* 208 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `matchesProperty` for source values suitable
	 * for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function matchesStrictComparable(key, srcValue) {
	  return function(object) {
	    if (object == null) {
	      return false;
	    }
	    return object[key] === srcValue &&
	      (srcValue !== undefined || (key in Object(object)));
	  };
	}
	
	module.exports = matchesStrictComparable;


/***/ },
/* 209 */
/***/ function(module, exports, __webpack_require__) {

	var WeakMap = __webpack_require__(177);
	
	/** Used to store function metadata. */
	var metaMap = WeakMap && new WeakMap;
	
	module.exports = metaMap;


/***/ },
/* 210 */
/***/ function(module, exports) {

	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	module.exports = overArg;


/***/ },
/* 211 */
/***/ function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(49);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * A specialized version of `baseRest` which transforms the rest array.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @param {Function} transform The rest array transform.
	 * @returns {Function} Returns the new function.
	 */
	function overRest(func, start, transform) {
	  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        array = Array(length);
	
	    while (++index < length) {
	      array[index] = args[start + index];
	    }
	    index = -1;
	    var otherArgs = Array(start + 1);
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = transform(array);
	    return apply(func, this, otherArgs);
	  };
	}
	
	module.exports = overRest;


/***/ },
/* 212 */
/***/ function(module, exports, __webpack_require__) {

	var baseSetData = __webpack_require__(189),
	    shortOut = __webpack_require__(214);
	
	/**
	 * Sets metadata for `func`.
	 *
	 * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
	 * period of time, it will trip its breaker and transition to an identity
	 * function to avoid garbage collection pauses in V8. See
	 * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
	 * for more details.
	 *
	 * @private
	 * @param {Function} func The function to associate metadata with.
	 * @param {*} data The metadata.
	 * @returns {Function} Returns `func`.
	 */
	var setData = shortOut(baseSetData);
	
	module.exports = setData;


/***/ },
/* 213 */
/***/ function(module, exports, __webpack_require__) {

	var getWrapDetails = __webpack_require__(436),
	    insertWrapDetails = __webpack_require__(445),
	    setToString = __webpack_require__(129),
	    updateWrapDetails = __webpack_require__(478);
	
	/**
	 * Sets the `toString` method of `wrapper` to mimic the source of `reference`
	 * with wrapper details in a comment at the top of the source body.
	 *
	 * @private
	 * @param {Function} wrapper The function to modify.
	 * @param {Function} reference The reference function.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @returns {Function} Returns `wrapper`.
	 */
	function setWrapToString(wrapper, reference, bitmask) {
	  var source = (reference + '');
	  return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
	}
	
	module.exports = setWrapToString;


/***/ },
/* 214 */
/***/ function(module, exports) {

	/** Used to detect hot functions by number of calls within a span of milliseconds. */
	var HOT_COUNT = 800,
	    HOT_SPAN = 16;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeNow = Date.now;
	
	/**
	 * Creates a function that'll short out and invoke `identity` instead
	 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	 * milliseconds.
	 *
	 * @private
	 * @param {Function} func The function to restrict.
	 * @returns {Function} Returns the new shortable function.
	 */
	function shortOut(func) {
	  var count = 0,
	      lastCalled = 0;
	
	  return function() {
	    var stamp = nativeNow(),
	        remaining = HOT_SPAN - (stamp - lastCalled);
	
	    lastCalled = stamp;
	    if (remaining > 0) {
	      if (++count >= HOT_COUNT) {
	        return arguments[0];
	      }
	    } else {
	      count = 0;
	    }
	    return func.apply(undefined, arguments);
	  };
	}
	
	module.exports = shortOut;


/***/ },
/* 215 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var funcProto = Function.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to convert.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	module.exports = toSource;


/***/ },
/* 216 */
/***/ function(module, exports) {

	/**
	 * Creates a function that returns `value`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {*} value The value to return from the new function.
	 * @returns {Function} Returns the new constant function.
	 * @example
	 *
	 * var objects = _.times(2, _.constant({ 'a': 1 }));
	 *
	 * console.log(objects);
	 * // => [{ 'a': 1 }, { 'a': 1 }]
	 *
	 * console.log(objects[0] === objects[1]);
	 * // => true
	 */
	function constant(value) {
	  return function() {
	    return value;
	  };
	}
	
	module.exports = constant;


/***/ },
/* 217 */
/***/ function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(49),
	    baseRest = __webpack_require__(33),
	    customDefaultsMerge = __webpack_require__(429),
	    mergeWith = __webpack_require__(493);
	
	/**
	 * This method is like `_.defaults` except that it recursively assigns
	 * default properties.
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.10.0
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @returns {Object} Returns `object`.
	 * @see _.defaults
	 * @example
	 *
	 * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
	 * // => { 'a': { 'b': 2, 'c': 3 } }
	 */
	var defaultsDeep = baseRest(function(args) {
	  args.push(undefined, customDefaultsMerge);
	  return apply(mergeWith, undefined, args);
	});
	
	module.exports = defaultsDeep;


/***/ },
/* 218 */
/***/ function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(84);
	
	/**
	 * Gets the value at `path` of `object`. If the resolved value is
	 * `undefined`, the `defaultValue` is returned in its place.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.7.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	 * @returns {*} Returns the resolved value.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	 *
	 * _.get(object, 'a[0].b.c');
	 * // => 3
	 *
	 * _.get(object, ['a', '0', 'b', 'c']);
	 * // => 3
	 *
	 * _.get(object, 'a.b.c', 'default');
	 * // => 'default'
	 */
	function get(object, path, defaultValue) {
	  var result = object == null ? undefined : baseGet(object, path);
	  return result === undefined ? defaultValue : result;
	}
	
	module.exports = get;


/***/ },
/* 219 */
/***/ function(module, exports, __webpack_require__) {

	var baseHasIn = __webpack_require__(372),
	    hasPath = __webpack_require__(437);
	
	/**
	 * Checks if `path` is a direct or inherited property of `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 * @example
	 *
	 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	 *
	 * _.hasIn(object, 'a');
	 * // => true
	 *
	 * _.hasIn(object, 'a.b');
	 * // => true
	 *
	 * _.hasIn(object, ['a', 'b']);
	 * // => true
	 *
	 * _.hasIn(object, 'b');
	 * // => false
	 */
	function hasIn(object, path) {
	  return object != null && hasPath(object, path, baseHasIn);
	}
	
	module.exports = hasIn;


/***/ },
/* 220 */
/***/ function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(23),
	    isObjectLike = __webpack_require__(24);
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	module.exports = isArrayLikeObject;


/***/ },
/* 221 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(30),
	    isObjectLike = __webpack_require__(24);
	
	/** `Object#toString` result references. */
	var numberTag = '[object Number]';
	
	/**
	 * Checks if `value` is classified as a `Number` primitive or object.
	 *
	 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
	 * classified as numbers, use the `_.isFinite` method.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
	 * @example
	 *
	 * _.isNumber(3);
	 * // => true
	 *
	 * _.isNumber(Number.MIN_VALUE);
	 * // => true
	 *
	 * _.isNumber(Infinity);
	 * // => true
	 *
	 * _.isNumber('3');
	 * // => false
	 */
	function isNumber(value) {
	  return typeof value == 'number' ||
	    (isObjectLike(value) && baseGetTag(value) == numberTag);
	}
	
	module.exports = isNumber;


/***/ },
/* 222 */
/***/ function(module, exports) {

	/**
	 * Gets the last element of `array`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to query.
	 * @returns {*} Returns the last element of `array`.
	 * @example
	 *
	 * _.last([1, 2, 3]);
	 * // => 3
	 */
	function last(array) {
	  var length = array == null ? 0 : array.length;
	  return length ? array[length - 1] : undefined;
	}
	
	module.exports = last;


/***/ },
/* 223 */
/***/ function(module, exports) {

	/**
	 * This method returns `undefined`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.3.0
	 * @category Util
	 * @example
	 *
	 * _.times(2, _.noop);
	 * // => [undefined, undefined]
	 */
	function noop() {
	  // No operation performed.
	}
	
	module.exports = noop;


/***/ },
/* 224 */
/***/ function(module, exports, __webpack_require__) {

	var basePick = __webpack_require__(386),
	    flatRest = __webpack_require__(123);
	
	/**
	 * Creates an object composed of the picked `object` properties.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The source object.
	 * @param {...(string|string[])} [paths] The property paths to pick.
	 * @returns {Object} Returns the new object.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': '2', 'c': 3 };
	 *
	 * _.pick(object, ['a', 'c']);
	 * // => { 'a': 1, 'c': 3 }
	 */
	var pick = flatRest(function(object, paths) {
	  return object == null ? {} : basePick(object, paths);
	});
	
	module.exports = pick;


/***/ },
/* 225 */
/***/ function(module, exports) {

	/**
	 * This method returns a new empty array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {Array} Returns the new empty array.
	 * @example
	 *
	 * var arrays = _.times(2, _.stubArray);
	 *
	 * console.log(arrays);
	 * // => [[], []]
	 *
	 * console.log(arrays[0] === arrays[1]);
	 * // => false
	 */
	function stubArray() {
	  return [];
	}
	
	module.exports = stubArray;


/***/ },
/* 226 */
/***/ function(module, exports, __webpack_require__) {

	var toNumber = __webpack_require__(227);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0,
	    MAX_INTEGER = 1.7976931348623157e+308;
	
	/**
	 * Converts `value` to a finite number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.12.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted number.
	 * @example
	 *
	 * _.toFinite(3.2);
	 * // => 3.2
	 *
	 * _.toFinite(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toFinite(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toFinite('3.2');
	 * // => 3.2
	 */
	function toFinite(value) {
	  if (!value) {
	    return value === 0 ? value : 0;
	  }
	  value = toNumber(value);
	  if (value === INFINITY || value === -INFINITY) {
	    var sign = (value < 0 ? -1 : 1);
	    return sign * MAX_INTEGER;
	  }
	  return value === value ? value : 0;
	}
	
	module.exports = toFinite;


/***/ },
/* 227 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(10),
	    isSymbol = __webpack_require__(57);
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = toNumber;


/***/ },
/* 228 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var asap = __webpack_require__(271);
	
	function noop() {}
	
	// States:
	//
	// 0 - pending
	// 1 - fulfilled with _value
	// 2 - rejected with _value
	// 3 - adopted the state of another promise, _value
	//
	// once the state is no longer pending (0) it is immutable
	
	// All `_` prefixed properties will be reduced to `_{random number}`
	// at build time to obfuscate them and discourage their use.
	// We don't use symbols or Object.defineProperty to fully hide them
	// because the performance isn't good enough.
	
	
	// to avoid using try/catch inside critical functions, we
	// extract them to here.
	var LAST_ERROR = null;
	var IS_ERROR = {};
	function getThen(obj) {
	  try {
	    return obj.then;
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	function tryCallOne(fn, a) {
	  try {
	    return fn(a);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	function tryCallTwo(fn, a, b) {
	  try {
	    fn(a, b);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	module.exports = Promise;
	
	function Promise(fn) {
	  if (typeof this !== 'object') {
	    throw new TypeError('Promises must be constructed via new');
	  }
	  if (typeof fn !== 'function') {
	    throw new TypeError('not a function');
	  }
	  this._45 = 0;
	  this._81 = 0;
	  this._65 = null;
	  this._54 = null;
	  if (fn === noop) return;
	  doResolve(fn, this);
	}
	Promise._10 = null;
	Promise._97 = null;
	Promise._61 = noop;
	
	Promise.prototype.then = function(onFulfilled, onRejected) {
	  if (this.constructor !== Promise) {
	    return safeThen(this, onFulfilled, onRejected);
	  }
	  var res = new Promise(noop);
	  handle(this, new Handler(onFulfilled, onRejected, res));
	  return res;
	};
	
	function safeThen(self, onFulfilled, onRejected) {
	  return new self.constructor(function (resolve, reject) {
	    var res = new Promise(noop);
	    res.then(resolve, reject);
	    handle(self, new Handler(onFulfilled, onRejected, res));
	  });
	};
	function handle(self, deferred) {
	  while (self._81 === 3) {
	    self = self._65;
	  }
	  if (Promise._10) {
	    Promise._10(self);
	  }
	  if (self._81 === 0) {
	    if (self._45 === 0) {
	      self._45 = 1;
	      self._54 = deferred;
	      return;
	    }
	    if (self._45 === 1) {
	      self._45 = 2;
	      self._54 = [self._54, deferred];
	      return;
	    }
	    self._54.push(deferred);
	    return;
	  }
	  handleResolved(self, deferred);
	}
	
	function handleResolved(self, deferred) {
	  asap(function() {
	    var cb = self._81 === 1 ? deferred.onFulfilled : deferred.onRejected;
	    if (cb === null) {
	      if (self._81 === 1) {
	        resolve(deferred.promise, self._65);
	      } else {
	        reject(deferred.promise, self._65);
	      }
	      return;
	    }
	    var ret = tryCallOne(cb, self._65);
	    if (ret === IS_ERROR) {
	      reject(deferred.promise, LAST_ERROR);
	    } else {
	      resolve(deferred.promise, ret);
	    }
	  });
	}
	function resolve(self, newValue) {
	  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
	  if (newValue === self) {
	    return reject(
	      self,
	      new TypeError('A promise cannot be resolved with itself.')
	    );
	  }
	  if (
	    newValue &&
	    (typeof newValue === 'object' || typeof newValue === 'function')
	  ) {
	    var then = getThen(newValue);
	    if (then === IS_ERROR) {
	      return reject(self, LAST_ERROR);
	    }
	    if (
	      then === self.then &&
	      newValue instanceof Promise
	    ) {
	      self._81 = 3;
	      self._65 = newValue;
	      finale(self);
	      return;
	    } else if (typeof then === 'function') {
	      doResolve(then.bind(newValue), self);
	      return;
	    }
	  }
	  self._81 = 1;
	  self._65 = newValue;
	  finale(self);
	}
	
	function reject(self, newValue) {
	  self._81 = 2;
	  self._65 = newValue;
	  if (Promise._97) {
	    Promise._97(self, newValue);
	  }
	  finale(self);
	}
	function finale(self) {
	  if (self._45 === 1) {
	    handle(self, self._54);
	    self._54 = null;
	  }
	  if (self._45 === 2) {
	    for (var i = 0; i < self._54.length; i++) {
	      handle(self, self._54[i]);
	    }
	    self._54 = null;
	  }
	}
	
	function Handler(onFulfilled, onRejected, promise){
	  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
	  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
	  this.promise = promise;
	}
	
	/**
	 * Take a potentially misbehaving resolver function and make sure
	 * onFulfilled and onRejected are only called once.
	 *
	 * Makes no guarantees about asynchrony.
	 */
	function doResolve(fn, promise) {
	  var done = false;
	  var res = tryCallTwo(fn, function (value) {
	    if (done) return;
	    done = true;
	    resolve(promise, value);
	  }, function (reason) {
	    if (done) return;
	    done = true;
	    reject(promise, reason);
	  })
	  if (!done && res === IS_ERROR) {
	    done = true;
	    reject(promise, LAST_ERROR);
	  }
	}


/***/ },
/* 229 */
/***/ function(module, exports) {

	'use strict';
	
	var replace = String.prototype.replace;
	var percentTwenties = /%20/g;
	
	module.exports = {
	    'default': 'RFC3986',
	    formatters: {
	        RFC1738: function (value) {
	            return replace.call(value, percentTwenties, '+');
	        },
	        RFC3986: function (value) {
	            return value;
	        }
	    },
	    RFC1738: 'RFC1738',
	    RFC3986: 'RFC3986'
	};


/***/ },
/* 230 */
/***/ function(module, exports) {

	'use strict';
	
	var has = Object.prototype.hasOwnProperty;
	
	var hexTable = (function () {
	    var array = [];
	    for (var i = 0; i < 256; ++i) {
	        array.push('%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase());
	    }
	
	    return array;
	}());
	
	var compactQueue = function compactQueue(queue) {
	    var obj;
	
	    while (queue.length) {
	        var item = queue.pop();
	        obj = item.obj[item.prop];
	
	        if (Array.isArray(obj)) {
	            var compacted = [];
	
	            for (var j = 0; j < obj.length; ++j) {
	                if (typeof obj[j] !== 'undefined') {
	                    compacted.push(obj[j]);
	                }
	            }
	
	            item.obj[item.prop] = compacted;
	        }
	    }
	
	    return obj;
	};
	
	exports.arrayToObject = function arrayToObject(source, options) {
	    var obj = options && options.plainObjects ? Object.create(null) : {};
	    for (var i = 0; i < source.length; ++i) {
	        if (typeof source[i] !== 'undefined') {
	            obj[i] = source[i];
	        }
	    }
	
	    return obj;
	};
	
	exports.merge = function merge(target, source, options) {
	    if (!source) {
	        return target;
	    }
	
	    if (typeof source !== 'object') {
	        if (Array.isArray(target)) {
	            target.push(source);
	        } else if (typeof target === 'object') {
	            if (options.plainObjects || options.allowPrototypes || !has.call(Object.prototype, source)) {
	                target[source] = true;
	            }
	        } else {
	            return [target, source];
	        }
	
	        return target;
	    }
	
	    if (typeof target !== 'object') {
	        return [target].concat(source);
	    }
	
	    var mergeTarget = target;
	    if (Array.isArray(target) && !Array.isArray(source)) {
	        mergeTarget = exports.arrayToObject(target, options);
	    }
	
	    if (Array.isArray(target) && Array.isArray(source)) {
	        source.forEach(function (item, i) {
	            if (has.call(target, i)) {
	                if (target[i] && typeof target[i] === 'object') {
	                    target[i] = exports.merge(target[i], item, options);
	                } else {
	                    target.push(item);
	                }
	            } else {
	                target[i] = item;
	            }
	        });
	        return target;
	    }
	
	    return Object.keys(source).reduce(function (acc, key) {
	        var value = source[key];
	
	        if (has.call(acc, key)) {
	            acc[key] = exports.merge(acc[key], value, options);
	        } else {
	            acc[key] = value;
	        }
	        return acc;
	    }, mergeTarget);
	};
	
	exports.assign = function assignSingleSource(target, source) {
	    return Object.keys(source).reduce(function (acc, key) {
	        acc[key] = source[key];
	        return acc;
	    }, target);
	};
	
	exports.decode = function (str) {
	    try {
	        return decodeURIComponent(str.replace(/\+/g, ' '));
	    } catch (e) {
	        return str;
	    }
	};
	
	exports.encode = function encode(str) {
	    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
	    // It has been adapted here for stricter adherence to RFC 3986
	    if (str.length === 0) {
	        return str;
	    }
	
	    var string = typeof str === 'string' ? str : String(str);
	
	    var out = '';
	    for (var i = 0; i < string.length; ++i) {
	        var c = string.charCodeAt(i);
	
	        if (
	            c === 0x2D // -
	            || c === 0x2E // .
	            || c === 0x5F // _
	            || c === 0x7E // ~
	            || (c >= 0x30 && c <= 0x39) // 0-9
	            || (c >= 0x41 && c <= 0x5A) // a-z
	            || (c >= 0x61 && c <= 0x7A) // A-Z
	        ) {
	            out += string.charAt(i);
	            continue;
	        }
	
	        if (c < 0x80) {
	            out = out + hexTable[c];
	            continue;
	        }
	
	        if (c < 0x800) {
	            out = out + (hexTable[0xC0 | (c >> 6)] + hexTable[0x80 | (c & 0x3F)]);
	            continue;
	        }
	
	        if (c < 0xD800 || c >= 0xE000) {
	            out = out + (hexTable[0xE0 | (c >> 12)] + hexTable[0x80 | ((c >> 6) & 0x3F)] + hexTable[0x80 | (c & 0x3F)]);
	            continue;
	        }
	
	        i += 1;
	        c = 0x10000 + (((c & 0x3FF) << 10) | (string.charCodeAt(i) & 0x3FF));
	        out += hexTable[0xF0 | (c >> 18)]
	            + hexTable[0x80 | ((c >> 12) & 0x3F)]
	            + hexTable[0x80 | ((c >> 6) & 0x3F)]
	            + hexTable[0x80 | (c & 0x3F)];
	    }
	
	    return out;
	};
	
	exports.compact = function compact(value) {
	    var queue = [{ obj: { o: value }, prop: 'o' }];
	    var refs = [];
	
	    for (var i = 0; i < queue.length; ++i) {
	        var item = queue[i];
	        var obj = item.obj[item.prop];
	
	        var keys = Object.keys(obj);
	        for (var j = 0; j < keys.length; ++j) {
	            var key = keys[j];
	            var val = obj[key];
	            if (typeof val === 'object' && val !== null && refs.indexOf(val) === -1) {
	                queue.push({ obj: obj, prop: key });
	                refs.push(val);
	            }
	        }
	    }
	
	    return compactQueue(queue);
	};
	
	exports.isRegExp = function isRegExp(obj) {
	    return Object.prototype.toString.call(obj) === '[object RegExp]';
	};
	
	exports.isBuffer = function isBuffer(obj) {
	    if (obj === null || typeof obj === 'undefined') {
	        return false;
	    }
	
	    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
	};


/***/ },
/* 231 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ },
/* 232 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = connectAdvanced;
	
	var _hoistNonReactStatics = __webpack_require__(534);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _invariant = __webpack_require__(21);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _Subscription = __webpack_require__(532);
	
	var _Subscription2 = _interopRequireDefault(_Subscription);
	
	var _PropTypes = __webpack_require__(235);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var hotReloadingVersion = 0;
	var dummyState = {};
	function noop() {}
	function makeSelectorStateful(sourceSelector, store) {
	  // wrap the selector in an object that tracks its results between runs.
	  var selector = {
	    run: function runComponentSelector(props) {
	      try {
	        var nextProps = sourceSelector(store.getState(), props);
	        if (nextProps !== selector.props || selector.error) {
	          selector.shouldComponentUpdate = true;
	          selector.props = nextProps;
	          selector.error = null;
	        }
	      } catch (error) {
	        selector.shouldComponentUpdate = true;
	        selector.error = error;
	      }
	    }
	  };
	
	  return selector;
	}
	
	function connectAdvanced(
	/*
	  selectorFactory is a func that is responsible for returning the selector function used to
	  compute new props from state, props, and dispatch. For example:
	     export default connectAdvanced((dispatch, options) => (state, props) => ({
	      thing: state.things[props.thingId],
	      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
	    }))(YourComponent)
	   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
	  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
	  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
	   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
	  props. Do not use connectAdvanced directly without memoizing results between calls to your
	  selector, otherwise the Connect component will re-render on every state or props change.
	*/
	selectorFactory) {
	  var _contextTypes, _childContextTypes;
	
	  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      _ref$getDisplayName = _ref.getDisplayName,
	      getDisplayName = _ref$getDisplayName === undefined ? function (name) {
	    return 'ConnectAdvanced(' + name + ')';
	  } : _ref$getDisplayName,
	      _ref$methodName = _ref.methodName,
	      methodName = _ref$methodName === undefined ? 'connectAdvanced' : _ref$methodName,
	      _ref$renderCountProp = _ref.renderCountProp,
	      renderCountProp = _ref$renderCountProp === undefined ? undefined : _ref$renderCountProp,
	      _ref$shouldHandleStat = _ref.shouldHandleStateChanges,
	      shouldHandleStateChanges = _ref$shouldHandleStat === undefined ? true : _ref$shouldHandleStat,
	      _ref$storeKey = _ref.storeKey,
	      storeKey = _ref$storeKey === undefined ? 'store' : _ref$storeKey,
	      _ref$withRef = _ref.withRef,
	      withRef = _ref$withRef === undefined ? false : _ref$withRef,
	      connectOptions = _objectWithoutProperties(_ref, ['getDisplayName', 'methodName', 'renderCountProp', 'shouldHandleStateChanges', 'storeKey', 'withRef']);
	
	  var subscriptionKey = storeKey + 'Subscription';
	  var version = hotReloadingVersion++;
	
	  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = _PropTypes.storeShape, _contextTypes[subscriptionKey] = _PropTypes.subscriptionShape, _contextTypes);
	  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = _PropTypes.subscriptionShape, _childContextTypes);
	
	  return function wrapWithConnect(WrappedComponent) {
	    (0, _invariant2.default)(typeof WrappedComponent == 'function', 'You must pass a component to the function returned by ' + (methodName + '. Instead received ' + JSON.stringify(WrappedComponent)));
	
	    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
	
	    var displayName = getDisplayName(wrappedComponentName);
	
	    var selectorFactoryOptions = _extends({}, connectOptions, {
	      getDisplayName: getDisplayName,
	      methodName: methodName,
	      renderCountProp: renderCountProp,
	      shouldHandleStateChanges: shouldHandleStateChanges,
	      storeKey: storeKey,
	      withRef: withRef,
	      displayName: displayName,
	      wrappedComponentName: wrappedComponentName,
	      WrappedComponent: WrappedComponent
	    });
	
	    var Connect = function (_Component) {
	      _inherits(Connect, _Component);
	
	      function Connect(props, context) {
	        _classCallCheck(this, Connect);
	
	        var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	        _this.version = version;
	        _this.state = {};
	        _this.renderCount = 0;
	        _this.store = props[storeKey] || context[storeKey];
	        _this.propsMode = Boolean(props[storeKey]);
	        _this.setWrappedInstance = _this.setWrappedInstance.bind(_this);
	
	        (0, _invariant2.default)(_this.store, 'Could not find "' + storeKey + '" in either the context or props of ' + ('"' + displayName + '". Either wrap the root component in a <Provider>, ') + ('or explicitly pass "' + storeKey + '" as a prop to "' + displayName + '".'));
	
	        _this.initSelector();
	        _this.initSubscription();
	        return _this;
	      }
	
	      Connect.prototype.getChildContext = function getChildContext() {
	        var _ref2;
	
	        // If this component received store from props, its subscription should be transparent
	        // to any descendants receiving store+subscription from context; it passes along
	        // subscription passed to it. Otherwise, it shadows the parent subscription, which allows
	        // Connect to control ordering of notifications to flow top-down.
	        var subscription = this.propsMode ? null : this.subscription;
	        return _ref2 = {}, _ref2[subscriptionKey] = subscription || this.context[subscriptionKey], _ref2;
	      };
	
	      Connect.prototype.componentDidMount = function componentDidMount() {
	        if (!shouldHandleStateChanges) return;
	
	        // componentWillMount fires during server side rendering, but componentDidMount and
	        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
	        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
	        // To handle the case where a child component may have triggered a state change by
	        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
	        // re-render.
	        this.subscription.trySubscribe();
	        this.selector.run(this.props);
	        if (this.selector.shouldComponentUpdate) this.forceUpdate();
	      };
	
	      Connect.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	        this.selector.run(nextProps);
	      };
	
	      Connect.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
	        return this.selector.shouldComponentUpdate;
	      };
	
	      Connect.prototype.componentWillUnmount = function componentWillUnmount() {
	        if (this.subscription) this.subscription.tryUnsubscribe();
	        this.subscription = null;
	        this.notifyNestedSubs = noop;
	        this.store = null;
	        this.selector.run = noop;
	        this.selector.shouldComponentUpdate = false;
	      };
	
	      Connect.prototype.getWrappedInstance = function getWrappedInstance() {
	        (0, _invariant2.default)(withRef, 'To access the wrapped instance, you need to specify ' + ('{ withRef: true } in the options argument of the ' + methodName + '() call.'));
	        return this.wrappedInstance;
	      };
	
	      Connect.prototype.setWrappedInstance = function setWrappedInstance(ref) {
	        this.wrappedInstance = ref;
	      };
	
	      Connect.prototype.initSelector = function initSelector() {
	        var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
	        this.selector = makeSelectorStateful(sourceSelector, this.store);
	        this.selector.run(this.props);
	      };
	
	      Connect.prototype.initSubscription = function initSubscription() {
	        if (!shouldHandleStateChanges) return;
	
	        // parentSub's source should match where store came from: props vs. context. A component
	        // connected to the store via props shouldn't use subscription from context, or vice versa.
	        var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
	        this.subscription = new _Subscription2.default(this.store, parentSub, this.onStateChange.bind(this));
	
	        // `notifyNestedSubs` is duplicated to handle the case where the component is  unmounted in
	        // the middle of the notification loop, where `this.subscription` will then be null. An
	        // extra null check every change can be avoided by copying the method onto `this` and then
	        // replacing it with a no-op on unmount. This can probably be avoided if Subscription's
	        // listeners logic is changed to not call listeners that have been unsubscribed in the
	        // middle of the notification loop.
	        this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
	      };
	
	      Connect.prototype.onStateChange = function onStateChange() {
	        this.selector.run(this.props);
	
	        if (!this.selector.shouldComponentUpdate) {
	          this.notifyNestedSubs();
	        } else {
	          this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
	          this.setState(dummyState);
	        }
	      };
	
	      Connect.prototype.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
	        // `componentDidUpdate` is conditionally implemented when `onStateChange` determines it
	        // needs to notify nested subs. Once called, it unimplements itself until further state
	        // changes occur. Doing it this way vs having a permanent `componentDidUpdate` that does
	        // a boolean check every time avoids an extra method call most of the time, resulting
	        // in some perf boost.
	        this.componentDidUpdate = undefined;
	        this.notifyNestedSubs();
	      };
	
	      Connect.prototype.isSubscribed = function isSubscribed() {
	        return Boolean(this.subscription) && this.subscription.isSubscribed();
	      };
	
	      Connect.prototype.addExtraProps = function addExtraProps(props) {
	        if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props;
	        // make a shallow copy so that fields added don't leak to the original selector.
	        // this is especially important for 'ref' since that's a reference back to the component
	        // instance. a singleton memoized selector would then be holding a reference to the
	        // instance, preventing the instance from being garbage collected, and that would be bad
	        var withExtras = _extends({}, props);
	        if (withRef) withExtras.ref = this.setWrappedInstance;
	        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
	        if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
	        return withExtras;
	      };
	
	      Connect.prototype.render = function render() {
	        var selector = this.selector;
	        selector.shouldComponentUpdate = false;
	
	        if (selector.error) {
	          throw selector.error;
	        } else {
	          return (0, _react.createElement)(WrappedComponent, this.addExtraProps(selector.props));
	        }
	      };
	
	      return Connect;
	    }(_react.Component);
	
	    Connect.WrappedComponent = WrappedComponent;
	    Connect.displayName = displayName;
	    Connect.childContextTypes = childContextTypes;
	    Connect.contextTypes = contextTypes;
	    Connect.propTypes = contextTypes;
	
	    if (false) {
	      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
	        var _this2 = this;
	
	        // We are hot reloading!
	        if (this.version !== version) {
	          this.version = version;
	          this.initSelector();
	
	          // If any connected descendants don't hot reload (and resubscribe in the process), their
	          // listeners will be lost when we unsubscribe. Unfortunately, by copying over all
	          // listeners, this does mean that the old versions of connected descendants will still be
	          // notified of state changes; however, their onStateChange function is a no-op so this
	          // isn't a huge deal.
	          var oldListeners = [];
	
	          if (this.subscription) {
	            oldListeners = this.subscription.listeners.get();
	            this.subscription.tryUnsubscribe();
	          }
	          this.initSubscription();
	          if (shouldHandleStateChanges) {
	            this.subscription.trySubscribe();
	            oldListeners.forEach(function (listener) {
	              return _this2.subscription.listeners.subscribe(listener);
	            });
	          }
	        }
	      };
	    }
	
	    return (0, _hoistNonReactStatics2.default)(Connect, WrappedComponent);
	  };
	}

/***/ },
/* 233 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.wrapMapToPropsConstant = wrapMapToPropsConstant;
	exports.getDependsOnOwnProps = getDependsOnOwnProps;
	exports.wrapMapToPropsFunc = wrapMapToPropsFunc;
	
	var _verifyPlainObject = __webpack_require__(236);
	
	var _verifyPlainObject2 = _interopRequireDefault(_verifyPlainObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function wrapMapToPropsConstant(getConstant) {
	  return function initConstantSelector(dispatch, options) {
	    var constant = getConstant(dispatch, options);
	
	    function constantSelector() {
	      return constant;
	    }
	    constantSelector.dependsOnOwnProps = false;
	    return constantSelector;
	  };
	}
	
	// dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
	// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
	// whether mapToProps needs to be invoked when props have changed.
	// 
	// A length of one signals that mapToProps does not depend on props from the parent component.
	// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
	// therefore not reporting its length accurately..
	function getDependsOnOwnProps(mapToProps) {
	  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
	}
	
	// Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
	// this function wraps mapToProps in a proxy function which does several things:
	// 
	//  * Detects whether the mapToProps function being called depends on props, which
	//    is used by selectorFactory to decide if it should reinvoke on props changes.
	//    
	//  * On first call, handles mapToProps if returns another function, and treats that
	//    new function as the true mapToProps for subsequent calls.
	//    
	//  * On first call, verifies the first result is a plain object, in order to warn
	//    the developer that their mapToProps function is not returning a valid result.
	//    
	function wrapMapToPropsFunc(mapToProps, methodName) {
	  return function initProxySelector(dispatch, _ref) {
	    var displayName = _ref.displayName;
	
	    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
	      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
	    };
	
	    // allow detectFactoryAndVerify to get ownProps
	    proxy.dependsOnOwnProps = true;
	
	    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
	      proxy.mapToProps = mapToProps;
	      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
	      var props = proxy(stateOrDispatch, ownProps);
	
	      if (typeof props === 'function') {
	        proxy.mapToProps = props;
	        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
	        props = proxy(stateOrDispatch, ownProps);
	      }
	
	      if (false) (0, _verifyPlainObject2.default)(props, displayName, methodName);
	
	      return props;
	    };
	
	    return proxy;
	  };
	}

/***/ },
/* 234 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.connect = exports.connectAdvanced = exports.createProvider = exports.Provider = undefined;
	
	var _Provider = __webpack_require__(525);
	
	var _Provider2 = _interopRequireDefault(_Provider);
	
	var _connectAdvanced = __webpack_require__(232);
	
	var _connectAdvanced2 = _interopRequireDefault(_connectAdvanced);
	
	var _connect = __webpack_require__(526);
	
	var _connect2 = _interopRequireDefault(_connect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Provider = _Provider2.default;
	exports.createProvider = _Provider.createProvider;
	exports.connectAdvanced = _connectAdvanced2.default;
	exports.connect = _connect2.default;

/***/ },
/* 235 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.storeShape = exports.subscriptionShape = undefined;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var subscriptionShape = exports.subscriptionShape = _propTypes2.default.shape({
	  trySubscribe: _propTypes2.default.func.isRequired,
	  tryUnsubscribe: _propTypes2.default.func.isRequired,
	  notifyNestedSubs: _propTypes2.default.func.isRequired,
	  isSubscribed: _propTypes2.default.func.isRequired
	});
	
	var storeShape = exports.storeShape = _propTypes2.default.shape({
	  subscribe: _propTypes2.default.func.isRequired,
	  dispatch: _propTypes2.default.func.isRequired,
	  getState: _propTypes2.default.func.isRequired
	});

/***/ },
/* 236 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = verifyPlainObject;
	
	var _isPlainObject = __webpack_require__(543);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _warning = __webpack_require__(140);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function verifyPlainObject(value, displayName, methodName) {
	  if (!(0, _isPlainObject2.default)(value)) {
	    (0, _warning2.default)(methodName + '() in ' + displayName + ' must return a plain object. Instead received ' + value + '.');
	  }
	}

/***/ },
/* 237 */
[624, 541],
/* 238 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _invariant = __webpack_require__(21);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var isModifiedEvent = function isModifiedEvent(event) {
	  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
	};
	
	/**
	 * The public API for rendering a history-aware <a>.
	 */
	
	var Link = function (_React$Component) {
	  _inherits(Link, _React$Component);
	
	  function Link() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Link);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
	      if (_this.props.onClick) _this.props.onClick(event);
	
	      if (!event.defaultPrevented && // onClick prevented default
	      event.button === 0 && // ignore right clicks
	      !_this.props.target && // let browser handle "target=_blank" etc.
	      !isModifiedEvent(event) // ignore clicks with modifier keys
	      ) {
	          event.preventDefault();
	
	          var history = _this.context.router.history;
	          var _this$props = _this.props,
	              replace = _this$props.replace,
	              to = _this$props.to;
	
	
	          if (replace) {
	            history.replace(to);
	          } else {
	            history.push(to);
	          }
	        }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Link.prototype.render = function render() {
	    var _props = this.props,
	        replace = _props.replace,
	        to = _props.to,
	        innerRef = _props.innerRef,
	        props = _objectWithoutProperties(_props, ['replace', 'to', 'innerRef']); // eslint-disable-line no-unused-vars
	
	    (0, _invariant2.default)(this.context.router, 'You should not use <Link> outside a <Router>');
	
	    var href = this.context.router.history.createHref(typeof to === 'string' ? { pathname: to } : to);
	
	    return _react2.default.createElement('a', _extends({}, props, { onClick: this.handleClick, href: href, ref: innerRef }));
	  };
	
	  return Link;
	}(_react2.default.Component);
	
	Link.propTypes = {
	  onClick: _propTypes2.default.func,
	  target: _propTypes2.default.string,
	  replace: _propTypes2.default.bool,
	  to: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]).isRequired,
	  innerRef: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func])
	};
	Link.defaultProps = {
	  replace: false
	};
	Link.contextTypes = {
	  router: _propTypes2.default.shape({
	    history: _propTypes2.default.shape({
	      push: _propTypes2.default.func.isRequired,
	      replace: _propTypes2.default.func.isRequired,
	      createHref: _propTypes2.default.func.isRequired
	    }).isRequired
	  }).isRequired
	};
	exports.default = Link;

/***/ },
/* 239 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Route = __webpack_require__(240);
	
	var _Route2 = _interopRequireDefault(_Route);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Route2.default; // Written in this round about way for babel-transform-imports

/***/ },
/* 240 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(20);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(21);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _matchPath = __webpack_require__(143);
	
	var _matchPath2 = _interopRequireDefault(_matchPath);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var isEmptyChildren = function isEmptyChildren(children) {
	  return _react2.default.Children.count(children) === 0;
	};
	
	/**
	 * The public API for matching a single path and rendering.
	 */
	
	var Route = function (_React$Component) {
	  _inherits(Route, _React$Component);
	
	  function Route() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Route);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      match: _this.computeMatch(_this.props, _this.context.router)
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Route.prototype.getChildContext = function getChildContext() {
	    return {
	      router: _extends({}, this.context.router, {
	        route: {
	          location: this.props.location || this.context.router.route.location,
	          match: this.state.match
	        }
	      })
	    };
	  };
	
	  Route.prototype.computeMatch = function computeMatch(_ref, router) {
	    var computedMatch = _ref.computedMatch,
	        location = _ref.location,
	        path = _ref.path,
	        strict = _ref.strict,
	        exact = _ref.exact,
	        sensitive = _ref.sensitive;
	
	    if (computedMatch) return computedMatch; // <Switch> already computed the match for us
	
	    (0, _invariant2.default)(router, 'You should not use <Route> or withRouter() outside a <Router>');
	
	    var route = router.route;
	
	    var pathname = (location || route.location).pathname;
	
	    return path ? (0, _matchPath2.default)(pathname, { path: path, strict: strict, exact: exact, sensitive: sensitive }) : route.match;
	  };
	
	  Route.prototype.componentWillMount = function componentWillMount() {
	    (0, _warning2.default)(!(this.props.component && this.props.render), 'You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored');
	
	    (0, _warning2.default)(!(this.props.component && this.props.children && !isEmptyChildren(this.props.children)), 'You should not use <Route component> and <Route children> in the same route; <Route children> will be ignored');
	
	    (0, _warning2.default)(!(this.props.render && this.props.children && !isEmptyChildren(this.props.children)), 'You should not use <Route render> and <Route children> in the same route; <Route children> will be ignored');
	  };
	
	  Route.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
	    (0, _warning2.default)(!(nextProps.location && !this.props.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');
	
	    (0, _warning2.default)(!(!nextProps.location && this.props.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
	
	    this.setState({
	      match: this.computeMatch(nextProps, nextContext.router)
	    });
	  };
	
	  Route.prototype.render = function render() {
	    var match = this.state.match;
	    var _props = this.props,
	        children = _props.children,
	        component = _props.component,
	        render = _props.render;
	    var _context$router = this.context.router,
	        history = _context$router.history,
	        route = _context$router.route,
	        staticContext = _context$router.staticContext;
	
	    var location = this.props.location || route.location;
	    var props = { match: match, location: location, history: history, staticContext: staticContext };
	
	    return component ? // component prop gets first priority, only called if there's a match
	    match ? _react2.default.createElement(component, props) : null : render ? // render prop is next, only called if there's a match
	    match ? render(props) : null : children ? // children come last, always called
	    typeof children === 'function' ? children(props) : !isEmptyChildren(children) ? _react2.default.Children.only(children) : null : null;
	  };
	
	  return Route;
	}(_react2.default.Component);
	
	Route.propTypes = {
	  computedMatch: _propTypes2.default.object, // private, from <Switch>
	  path: _propTypes2.default.string,
	  exact: _propTypes2.default.bool,
	  strict: _propTypes2.default.bool,
	  sensitive: _propTypes2.default.bool,
	  component: _propTypes2.default.func,
	  render: _propTypes2.default.func,
	  children: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.node]),
	  location: _propTypes2.default.object
	};
	Route.contextTypes = {
	  router: _propTypes2.default.shape({
	    history: _propTypes2.default.object.isRequired,
	    route: _propTypes2.default.object.isRequired,
	    staticContext: _propTypes2.default.object
	  })
	};
	Route.childContextTypes = {
	  router: _propTypes2.default.object.isRequired
	};
	exports.default = Route;

/***/ },
/* 241 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = compose;
	/**
	 * Composes single-argument functions from right to left. The rightmost
	 * function can take multiple arguments as it provides the signature for
	 * the resulting composite function.
	 *
	 * @param {...Function} funcs The functions to compose.
	 * @returns {Function} A function obtained by composing the argument functions
	 * from right to left. For example, compose(f, g, h) is identical to doing
	 * (...args) => f(g(h(...args))).
	 */
	
	function compose() {
	  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  if (funcs.length === 0) {
	    return function (arg) {
	      return arg;
	    };
	  }
	
	  if (funcs.length === 1) {
	    return funcs[0];
	  }
	
	  return funcs.reduce(function (a, b) {
	    return function () {
	      return a(b.apply(undefined, arguments));
	    };
	  });
	}

/***/ },
/* 242 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ActionTypes = undefined;
	exports['default'] = createStore;
	
	var _isPlainObject = __webpack_require__(36);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _symbolObservable = __webpack_require__(570);
	
	var _symbolObservable2 = _interopRequireDefault(_symbolObservable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * These are private action types reserved by Redux.
	 * For any unknown actions, you must return the current state.
	 * If the current state is undefined, you must return the initial state.
	 * Do not reference these action types directly in your code.
	 */
	var ActionTypes = exports.ActionTypes = {
	  INIT: '@@redux/INIT'
	
	  /**
	   * Creates a Redux store that holds the state tree.
	   * The only way to change the data in the store is to call `dispatch()` on it.
	   *
	   * There should only be a single store in your app. To specify how different
	   * parts of the state tree respond to actions, you may combine several reducers
	   * into a single reducer function by using `combineReducers`.
	   *
	   * @param {Function} reducer A function that returns the next state tree, given
	   * the current state tree and the action to handle.
	   *
	   * @param {any} [preloadedState] The initial state. You may optionally specify it
	   * to hydrate the state from the server in universal apps, or to restore a
	   * previously serialized user session.
	   * If you use `combineReducers` to produce the root reducer function, this must be
	   * an object with the same shape as `combineReducers` keys.
	   *
	   * @param {Function} [enhancer] The store enhancer. You may optionally specify it
	   * to enhance the store with third-party capabilities such as middleware,
	   * time travel, persistence, etc. The only store enhancer that ships with Redux
	   * is `applyMiddleware()`.
	   *
	   * @returns {Store} A Redux store that lets you read the state, dispatch actions
	   * and subscribe to changes.
	   */
	};function createStore(reducer, preloadedState, enhancer) {
	  var _ref2;
	
	  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
	    enhancer = preloadedState;
	    preloadedState = undefined;
	  }
	
	  if (typeof enhancer !== 'undefined') {
	    if (typeof enhancer !== 'function') {
	      throw new Error('Expected the enhancer to be a function.');
	    }
	
	    return enhancer(createStore)(reducer, preloadedState);
	  }
	
	  if (typeof reducer !== 'function') {
	    throw new Error('Expected the reducer to be a function.');
	  }
	
	  var currentReducer = reducer;
	  var currentState = preloadedState;
	  var currentListeners = [];
	  var nextListeners = currentListeners;
	  var isDispatching = false;
	
	  function ensureCanMutateNextListeners() {
	    if (nextListeners === currentListeners) {
	      nextListeners = currentListeners.slice();
	    }
	  }
	
	  /**
	   * Reads the state tree managed by the store.
	   *
	   * @returns {any} The current state tree of your application.
	   */
	  function getState() {
	    return currentState;
	  }
	
	  /**
	   * Adds a change listener. It will be called any time an action is dispatched,
	   * and some part of the state tree may potentially have changed. You may then
	   * call `getState()` to read the current state tree inside the callback.
	   *
	   * You may call `dispatch()` from a change listener, with the following
	   * caveats:
	   *
	   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
	   * If you subscribe or unsubscribe while the listeners are being invoked, this
	   * will not have any effect on the `dispatch()` that is currently in progress.
	   * However, the next `dispatch()` call, whether nested or not, will use a more
	   * recent snapshot of the subscription list.
	   *
	   * 2. The listener should not expect to see all state changes, as the state
	   * might have been updated multiple times during a nested `dispatch()` before
	   * the listener is called. It is, however, guaranteed that all subscribers
	   * registered before the `dispatch()` started will be called with the latest
	   * state by the time it exits.
	   *
	   * @param {Function} listener A callback to be invoked on every dispatch.
	   * @returns {Function} A function to remove this change listener.
	   */
	  function subscribe(listener) {
	    if (typeof listener !== 'function') {
	      throw new Error('Expected listener to be a function.');
	    }
	
	    var isSubscribed = true;
	
	    ensureCanMutateNextListeners();
	    nextListeners.push(listener);
	
	    return function unsubscribe() {
	      if (!isSubscribed) {
	        return;
	      }
	
	      isSubscribed = false;
	
	      ensureCanMutateNextListeners();
	      var index = nextListeners.indexOf(listener);
	      nextListeners.splice(index, 1);
	    };
	  }
	
	  /**
	   * Dispatches an action. It is the only way to trigger a state change.
	   *
	   * The `reducer` function, used to create the store, will be called with the
	   * current state tree and the given `action`. Its return value will
	   * be considered the **next** state of the tree, and the change listeners
	   * will be notified.
	   *
	   * The base implementation only supports plain object actions. If you want to
	   * dispatch a Promise, an Observable, a thunk, or something else, you need to
	   * wrap your store creating function into the corresponding middleware. For
	   * example, see the documentation for the `redux-thunk` package. Even the
	   * middleware will eventually dispatch plain object actions using this method.
	   *
	   * @param {Object} action A plain object representing “what changed”. It is
	   * a good idea to keep actions serializable so you can record and replay user
	   * sessions, or use the time travelling `redux-devtools`. An action must have
	   * a `type` property which may not be `undefined`. It is a good idea to use
	   * string constants for action types.
	   *
	   * @returns {Object} For convenience, the same action object you dispatched.
	   *
	   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
	   * return something else (for example, a Promise you can await).
	   */
	  function dispatch(action) {
	    if (!(0, _isPlainObject2['default'])(action)) {
	      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
	    }
	
	    if (typeof action.type === 'undefined') {
	      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
	    }
	
	    if (isDispatching) {
	      throw new Error('Reducers may not dispatch actions.');
	    }
	
	    try {
	      isDispatching = true;
	      currentState = currentReducer(currentState, action);
	    } finally {
	      isDispatching = false;
	    }
	
	    var listeners = currentListeners = nextListeners;
	    for (var i = 0; i < listeners.length; i++) {
	      var listener = listeners[i];
	      listener();
	    }
	
	    return action;
	  }
	
	  /**
	   * Replaces the reducer currently used by the store to calculate the state.
	   *
	   * You might need this if your app implements code splitting and you want to
	   * load some of the reducers dynamically. You might also need this if you
	   * implement a hot reloading mechanism for Redux.
	   *
	   * @param {Function} nextReducer The reducer for the store to use instead.
	   * @returns {void}
	   */
	  function replaceReducer(nextReducer) {
	    if (typeof nextReducer !== 'function') {
	      throw new Error('Expected the nextReducer to be a function.');
	    }
	
	    currentReducer = nextReducer;
	    dispatch({ type: ActionTypes.INIT });
	  }
	
	  /**
	   * Interoperability point for observable/reactive libraries.
	   * @returns {observable} A minimal observable of state changes.
	   * For more information, see the observable proposal:
	   * https://github.com/tc39/proposal-observable
	   */
	  function observable() {
	    var _ref;
	
	    var outerSubscribe = subscribe;
	    return _ref = {
	      /**
	       * The minimal observable subscription method.
	       * @param {Object} observer Any object that can be used as an observer.
	       * The observer object should have a `next` method.
	       * @returns {subscription} An object with an `unsubscribe` method that can
	       * be used to unsubscribe the observable from the store, and prevent further
	       * emission of values from the observable.
	       */
	      subscribe: function subscribe(observer) {
	        if (typeof observer !== 'object') {
	          throw new TypeError('Expected the observer to be an object.');
	        }
	
	        function observeState() {
	          if (observer.next) {
	            observer.next(getState());
	          }
	        }
	
	        observeState();
	        var unsubscribe = outerSubscribe(observeState);
	        return { unsubscribe: unsubscribe };
	      }
	    }, _ref[_symbolObservable2['default']] = function () {
	      return this;
	    }, _ref;
	  }
	
	  // When a store is created, an "INIT" action is dispatched so that every
	  // reducer returns their initial state. This effectively populates
	  // the initial state tree.
	  dispatch({ type: ActionTypes.INIT });
	
	  return _ref2 = {
	    dispatch: dispatch,
	    subscribe: subscribe,
	    getState: getState,
	    replaceReducer: replaceReducer
	  }, _ref2[_symbolObservable2['default']] = observable, _ref2;
	}

/***/ },
/* 243 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.compose = exports.applyMiddleware = exports.bindActionCreators = exports.combineReducers = exports.createStore = undefined;
	
	var _createStore = __webpack_require__(242);
	
	var _createStore2 = _interopRequireDefault(_createStore);
	
	var _combineReducers = __webpack_require__(568);
	
	var _combineReducers2 = _interopRequireDefault(_combineReducers);
	
	var _bindActionCreators = __webpack_require__(567);
	
	var _bindActionCreators2 = _interopRequireDefault(_bindActionCreators);
	
	var _applyMiddleware = __webpack_require__(566);
	
	var _applyMiddleware2 = _interopRequireDefault(_applyMiddleware);
	
	var _compose = __webpack_require__(241);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _warning = __webpack_require__(244);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/*
	* This is a dummy function to check if the function name has been altered by minification.
	* If the function has been minified and NODE_ENV !== 'production', warn the user.
	*/
	function isCrushed() {}
	
	if (false) {
	  (0, _warning2['default'])('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
	}
	
	exports.createStore = _createStore2['default'];
	exports.combineReducers = _combineReducers2['default'];
	exports.bindActionCreators = _bindActionCreators2['default'];
	exports.applyMiddleware = _applyMiddleware2['default'];
	exports.compose = _compose2['default'];

/***/ },
/* 244 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = warning;
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	}

/***/ },
/* 245 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 246 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/kick.7013e7f4.png";

/***/ },
/* 247 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isFunction2 = __webpack_require__(7);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _throttle2 = __webpack_require__(59);
	
	var _throttle3 = _interopRequireDefault(_throttle2);
	
	var _victoryCore = __webpack_require__(3);
	
	var _eventHandlers = __webpack_require__(60);
	
	var _brushHelpers = __webpack_require__(144);
	
	var _brushHelpers2 = _interopRequireDefault(_brushHelpers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CursorHelpers = {
	  onMouseMove: function (evt, targetProps) {
	    var onCursorChange = targetProps.onCursorChange,
	        cursorDimension = targetProps.cursorDimension,
	        domain = targetProps.domain;
	
	    var cursorSVGPosition = _victoryCore.Selection.getSVGEventCoordinates(evt);
	    var cursorValue = _victoryCore.Selection.getDataCoordinates(targetProps, targetProps.scale, cursorSVGPosition.x, cursorSVGPosition.y);
	
	    var inBounds = _brushHelpers2.default.withinBounds(cursorValue, {
	      x1: domain.x[0],
	      x2: domain.x[1],
	      y1: domain.y[0],
	      y2: domain.y[1]
	    });
	
	    if (!inBounds) {
	      cursorValue = null;
	    }
	
	    if ((0, _isFunction3.default)(onCursorChange)) {
	      if (inBounds) {
	        var value = cursorDimension ? cursorValue[cursorDimension] : cursorValue;
	        onCursorChange(value, targetProps);
	      } else if (cursorValue !== targetProps.cursorValue) {
	        onCursorChange(targetProps.defaultCursorValue || null, targetProps);
	      }
	    }
	
	    return [{
	      target: "parent",
	      eventKey: "parent",
	      mutation: function () {
	        return { cursorValue: cursorValue };
	      }
	    }];
	  }
	};
	
	exports.default = {
	  onMouseMove: (0, _throttle3.default)((0, _eventHandlers.attachId)(CursorHelpers.onMouseMove.bind(CursorHelpers)), 32, // eslint-disable-line no-magic-numbers
	  { leading: true, trailing: false })
	};

/***/ },
/* 248 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isFunction2 = __webpack_require__(7);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _throttle2 = __webpack_require__(59);
	
	var _throttle3 = _interopRequireDefault(_throttle2);
	
	var _defaults2 = __webpack_require__(5);
	
	var _defaults3 = _interopRequireDefault(_defaults2);
	
	var _assign2 = __webpack_require__(4);
	
	var _assign3 = _interopRequireDefault(_assign2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _victoryCore = __webpack_require__(3);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _eventHandlers = __webpack_require__(60);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SelectionHelpers = {
	  getDatasets: function (props) {
	    if (props.data) {
	      return [{ data: props.data }];
	    }
	
	    var getData = function (childProps) {
	      var data = _victoryCore.Data.getData(childProps);
	      return Array.isArray(data) && data.length > 0 ? data : undefined;
	    };
	
	    var iteratee = function (child, childName, parent) {
	      if (child.type && child.type.role === "axis") {
	        return null;
	      } else if (child.type && (0, _isFunction3.default)(child.type.getData)) {
	        child = parent ? _react2.default.cloneElement(child, parent.props) : child;
	        var childData = child.props && child.type.getData(child.props);
	        return childData ? { childName: childName, data: childData } : null;
	      } else {
	        var _childData = getData(child.props);
	        return _childData ? { childName: childName, data: _childData } : null;
	      }
	    };
	    return _victoryCore.Helpers.reduceChildren(_react2.default.Children.toArray(props.children), iteratee);
	  },
	  filterDatasets: function (props, datasets, bounds) {
	    var _this = this;
	
	    var filtered = datasets.reduce(function (memo, dataset) {
	      var selectedData = _this.getSelectedData(props, dataset.data, bounds);
	      memo = selectedData ? memo.concat({
	        childName: dataset.childName, eventKey: selectedData.eventKey, data: selectedData.data
	      }) : memo;
	      return memo;
	    }, []);
	    return filtered.length ? filtered : null;
	  },
	  getSelectedData: function (props, dataset) {
	    var x1 = props.x1,
	        y1 = props.y1,
	        x2 = props.x2,
	        y2 = props.y2;
	
	    var withinBounds = function (d) {
	      var scaledPoint = _victoryCore.Helpers.scalePoint(props, d);
	      return scaledPoint.x >= Math.min(x1, x2) && scaledPoint.x <= Math.max(x1, x2) && scaledPoint.y >= Math.min(y1, y2) && scaledPoint.y <= Math.max(y1, y2);
	    };
	    var eventKey = [];
	    var data = [];
	    var count = 0;
	    for (var index = 0, len = dataset.length; index < len; index++) {
	      var datum = dataset[index];
	      if (withinBounds(datum)) {
	        data[count] = datum;
	        eventKey[count] = datum.eventKey === undefined ? index : datum.eventKey;
	        count++;
	      }
	    }
	    return count > 0 ? { eventKey: eventKey, data: data } : null;
	  },
	
	
	  // eslint-disable-next-line complexity
	  onMouseDown: function (evt, targetProps) {
	    evt.preventDefault();
	    var allowSelection = targetProps.allowSelection,
	        polar = targetProps.polar;
	
	    if (!allowSelection) {
	      return {};
	    }
	    var dimension = targetProps.selectionDimension;
	    var datasets = targetProps.datasets || [];
	
	    var _Selection$getSVGEven = _victoryCore.Selection.getSVGEventCoordinates(evt),
	        x = _Selection$getSVGEven.x,
	        y = _Selection$getSVGEven.y;
	
	    var x1 = polar || dimension !== "y" ? x : _victoryCore.Selection.getDomainCoordinates(targetProps).x[0];
	    var y1 = polar || dimension !== "x" ? y : _victoryCore.Selection.getDomainCoordinates(targetProps).y[0];
	    var x2 = polar || dimension !== "y" ? x : _victoryCore.Selection.getDomainCoordinates(targetProps).x[1];
	    var y2 = polar || dimension !== "x" ? y : _victoryCore.Selection.getDomainCoordinates(targetProps).y[1];
	
	    var mutatedProps = { x1: x1, y1: y1, select: true, x2: x2, y2: y2 };
	    if ((0, _isFunction3.default)(targetProps.onSelectionCleared)) {
	      targetProps.onSelectionCleared((0, _defaults3.default)({}, mutatedProps, targetProps));
	    }
	    return [{
	      target: "parent",
	      mutation: function () {
	        return mutatedProps;
	      }
	    }, {
	      target: "data",
	      childName: targetProps.children || datasets.length ? "all" : undefined,
	      eventKey: "all",
	      mutation: function () {
	        return null;
	      }
	    }];
	  },
	  onMouseMove: function (evt, targetProps) {
	    var allowSelection = targetProps.allowSelection,
	        select = targetProps.select,
	        polar = targetProps.polar;
	
	    var dimension = targetProps.selectionDimension;
	    if (!allowSelection || !select) {
	      return {};
	    } else {
	      var _Selection$getSVGEven2 = _victoryCore.Selection.getSVGEventCoordinates(evt),
	          x = _Selection$getSVGEven2.x,
	          y = _Selection$getSVGEven2.y;
	
	      var x2 = polar || dimension !== "y" ? x : _victoryCore.Selection.getDomainCoordinates(targetProps).x[1];
	      var y2 = polar || dimension !== "x" ? y : _victoryCore.Selection.getDomainCoordinates(targetProps).y[1];
	      return {
	        target: "parent",
	        mutation: function () {
	          return { x2: x2, y2: y2 };
	        }
	      };
	    }
	  },
	  onMouseUp: function (evt, targetProps) {
	    var allowSelection = targetProps.allowSelection,
	        x2 = targetProps.x2,
	        y2 = targetProps.y2;
	
	    if (!allowSelection) {
	      return {};
	    }
	    if (!x2 || !y2) {
	      return [{
	        target: "parent",
	        mutation: function () {
	          return { select: false, x1: null, x2: null, y1: null, y2: null };
	        }
	      }];
	    }
	    var datasets = this.getDatasets(targetProps);
	    var bounds = _victoryCore.Selection.getBounds(targetProps);
	    var selectedData = this.filterDatasets(targetProps, datasets, bounds);
	    var mutatedProps = { datasets: datasets, select: false, x1: null, x2: null, y1: null, y2: null };
	    var callbackMutation = selectedData && (0, _isFunction3.default)(targetProps.onSelection) ? targetProps.onSelection(selectedData, bounds, (0, _defaults3.default)({}, mutatedProps, targetProps)) : {};
	    var parentMutation = [{
	      target: "parent",
	      mutation: function () {
	        return mutatedProps;
	      }
	    }];
	
	    var dataMutation = selectedData ? selectedData.map(function (d) {
	      return {
	        childName: d.childName, eventKey: d.eventKey, target: "data",
	        mutation: function () {
	          return (0, _assign3.default)({ active: true }, callbackMutation);
	        }
	      };
	    }) : [];
	
	    return parentMutation.concat(dataMutation);
	  }
	};
	
	exports.default = _extends({}, SelectionHelpers, {
	  onMouseDown: SelectionHelpers.onMouseDown.bind(SelectionHelpers),
	  onMouseUp: SelectionHelpers.onMouseUp.bind(SelectionHelpers),
	  onMouseMove: (0, _throttle3.default)((0, _eventHandlers.attachId)(SelectionHelpers.onMouseMove.bind(SelectionHelpers)), 16, // eslint-disable-line no-magic-numbers
	  { leading: true, trailing: false })
	});

/***/ },
/* 249 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.brushContainerMixin = undefined;
	
	var _isEqual2 = __webpack_require__(43);
	
	var _isEqual3 = _interopRequireDefault(_isEqual2);
	
	var _defaults2 = __webpack_require__(5);
	
	var _defaults3 = _interopRequireDefault(_defaults2);
	
	var _assign2 = __webpack_require__(4);
	
	var _assign3 = _interopRequireDefault(_assign2);
	
	var _this2 = this;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _victoryCore = __webpack_require__(3);
	
	var _brushHelpers = __webpack_require__(144);
	
	var _brushHelpers2 = _interopRequireDefault(_brushHelpers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var brushContainerMixin = exports.brushContainerMixin = function (base) {
	  var _class, _temp;
	
	  return _temp = _class = function (_base) {
	    _inherits(VictoryBrushContainer, _base);
	
	    function VictoryBrushContainer() {
	      _classCallCheck(this, VictoryBrushContainer);
	
	      return _possibleConstructorReturn(this, (VictoryBrushContainer.__proto__ || Object.getPrototypeOf(VictoryBrushContainer)).apply(this, arguments));
	    }
	
	    _createClass(VictoryBrushContainer, [{
	      key: "getSelectBox",
	      value: function getSelectBox(props, coordinates) {
	        var x = coordinates.x,
	            y = coordinates.y;
	        var brushStyle = props.brushStyle,
	            brushComponent = props.brushComponent;
	
	        var brushComponentStyle = brushComponent.props && brushComponent.props.style;
	        return x[0] !== x[1] && y[0] !== y[1] ? _react2.default.cloneElement(brushComponent, {
	          width: Math.abs(x[1] - x[0]) || 1,
	          height: Math.abs(y[1] - y[0]) || 1,
	          x: Math.min(x[0], x[1]),
	          y: Math.min(y[0], y[1]),
	          cursor: "move",
	          style: (0, _defaults3.default)({}, brushComponentStyle, brushStyle)
	        }) : null;
	      }
	    }, {
	      key: "getHandles",
	      value: function getHandles(props, coordinates) {
	        var brushDimension = props.brushDimension,
	            handleWidth = props.handleWidth,
	            handleStyle = props.handleStyle,
	            handleComponent = props.handleComponent;
	        var x = coordinates.x,
	            y = coordinates.y;
	
	        var width = Math.abs(x[1] - x[0]) || 1;
	        var height = Math.abs(y[1] - y[0]) || 1;
	        var handleComponentStyle = handleComponent.props && handleComponent.props.style || {};
	        var style = (0, _defaults3.default)({}, handleComponentStyle, handleStyle);
	        var yProps = { style: style, width: width, height: handleWidth, cursor: "ns-resize" };
	        var xProps = { style: style, width: handleWidth, height: height, cursor: "ew-resize" };
	        var handleProps = {
	          top: brushDimension !== "x" && (0, _assign3.default)({ x: x[0], y: y[1] - handleWidth / 2 }, yProps),
	          bottom: brushDimension !== "x" && (0, _assign3.default)({ x: x[0], y: y[0] - handleWidth / 2 }, yProps),
	          left: brushDimension !== "y" && (0, _assign3.default)({ y: y[1], x: x[0] - handleWidth / 2 }, xProps),
	          right: brushDimension !== "y" && (0, _assign3.default)({ y: y[1], x: x[1] - handleWidth / 2 }, xProps)
	        };
	        var handles = ["top", "bottom", "left", "right"].reduce(function (memo, curr) {
	          memo = handleProps[curr] ? memo.concat(_react2.default.cloneElement(handleComponent, (0, _assign3.default)({ key: "handle-" + curr }, handleProps[curr]))) : memo;
	          return memo;
	        }, []);
	        return handles.length ? handles : null;
	      }
	    }, {
	      key: "getRect",
	      value: function getRect(props) {
	        var currentDomain = props.currentDomain,
	            cachedBrushDomain = props.cachedBrushDomain;
	
	        var brushDomain = (0, _defaults3.default)({}, props.brushDomain, props.domain);
	        var domain = (0, _isEqual3.default)(brushDomain, cachedBrushDomain) ? (0, _defaults3.default)({}, currentDomain, brushDomain) : brushDomain;
	        var coordinates = _victoryCore.Selection.getDomainCoordinates(props, domain);
	        var selectBox = this.getSelectBox(props, coordinates);
	        return selectBox ? _react2.default.createElement(
	          "g",
	          null,
	          selectBox,
	          this.getHandles(props, coordinates)
	        ) : null;
	      }
	
	      // Overrides method in VictoryContainer
	
	    }, {
	      key: "getChildren",
	      value: function getChildren(props) {
	        var children = _react2.default.Children.toArray(props.children);
	        return [].concat(_toConsumableArray(children), [this.getRect(props)]).map(function (component, i) {
	          return component ? _react2.default.cloneElement(component, { key: i }) : null;
	        });
	      }
	    }]);
	
	    return VictoryBrushContainer;
	  }(base), _class.displayName = "VictoryBrushContainer", _class.propTypes = _extends({}, _victoryCore.VictoryContainer.propTypes, {
	    allowDrag: _propTypes2.default.bool,
	    allowResize: _propTypes2.default.bool,
	    brushComponent: _propTypes2.default.element,
	    brushDimension: _propTypes2.default.oneOf(["x", "y"]),
	    brushDomain: _propTypes2.default.shape({
	      x: _propTypes2.default.array,
	      y: _propTypes2.default.array
	    }),
	    brushStyle: _propTypes2.default.object,
	    handleComponent: _propTypes2.default.element,
	    handleStyle: _propTypes2.default.object,
	    handleWidth: _propTypes2.default.number,
	    onBrushDomainChange: _propTypes2.default.func
	  }), _class.defaultProps = _extends({}, _victoryCore.VictoryContainer.defaultProps, {
	    allowDrag: true,
	    allowResize: true,
	    brushComponent: _react2.default.createElement("rect", null),
	    brushStyle: {
	      stroke: "transparent",
	      fill: "black",
	      fillOpacity: 0.1
	    },
	    handleComponent: _react2.default.createElement("rect", null),
	    handleStyle: {
	      stroke: "transparent",
	      fill: "transparent"
	    },
	    handleWidth: 8
	  }), _class.defaultEvents = [{
	    target: "parent",
	    eventHandlers: {
	      onMouseDown: function (evt, targetProps) {
	        return _brushHelpers2.default.onMouseDown(evt, targetProps);
	      },
	      onTouchStart: function (evt, targetProps) {
	        return _brushHelpers2.default.onMouseDown(evt, targetProps);
	      },
	      onMouseMove: function (evt, targetProps) {
	        var mutations = _brushHelpers2.default.onMouseMove(evt, targetProps);
	
	        if (mutations.id !== _this2.mouseMoveMutationId) {
	          // eslint-disable-line
	          _this2.mouseMoveMutationId = mutations.id; // eslint-disable-line
	          return mutations.mutations;
	        }
	
	        return undefined;
	      },
	      onTouchMove: function (evt, targetProps) {
	        var mutations = _brushHelpers2.default.onMouseMove(evt, targetProps);
	
	        if (mutations.id !== _this2.mouseMoveMutationId) {
	          // eslint-disable-line
	          _this2.mouseMoveMutationId = mutations.id; // eslint-disable-line
	          return mutations.mutations;
	        }
	
	        return undefined;
	      },
	      onMouseUp: function (evt, targetProps) {
	        return _brushHelpers2.default.onMouseUp(evt, targetProps);
	      },
	      onTouchEnd: function (evt, targetProps) {
	        return _brushHelpers2.default.onMouseUp(evt, targetProps);
	      },
	      onMouseLeave: function (evt, targetProps) {
	        return _brushHelpers2.default.onMouseLeave(evt, targetProps);
	      },
	      onTouchCancel: function (evt, targetProps) {
	        return _brushHelpers2.default.onMouseLeave(evt, targetProps);
	      }
	    }
	  }], _temp;
	};
	
	exports.default = brushContainerMixin(_victoryCore.VictoryContainer);

/***/ },
/* 250 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.cursorContainerMixin = undefined;
	
	var _isObject2 = __webpack_require__(10);
	
	var _isObject3 = _interopRequireDefault(_isObject2);
	
	var _isUndefined2 = __webpack_require__(491);
	
	var _isUndefined3 = _interopRequireDefault(_isUndefined2);
	
	var _isNumber2 = __webpack_require__(221);
	
	var _isNumber3 = _interopRequireDefault(_isNumber2);
	
	var _defaults2 = __webpack_require__(5);
	
	var _defaults3 = _interopRequireDefault(_defaults2);
	
	var _this2 = this;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _victoryCore = __webpack_require__(3);
	
	var _cursorHelpers = __webpack_require__(247);
	
	var _cursorHelpers2 = _interopRequireDefault(_cursorHelpers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var cursorContainerMixin = exports.cursorContainerMixin = function (base) {
	  var _class, _temp;
	
	  return _temp = _class = function (_base) {
	    _inherits(VictoryCursorContainer, _base);
	
	    function VictoryCursorContainer() {
	      _classCallCheck(this, VictoryCursorContainer);
	
	      return _possibleConstructorReturn(this, (VictoryCursorContainer.__proto__ || Object.getPrototypeOf(VictoryCursorContainer)).apply(this, arguments));
	    }
	
	    _createClass(VictoryCursorContainer, [{
	      key: "getCursorPosition",
	      value: function getCursorPosition(props) {
	        var cursorValue = props.cursorValue,
	            defaultCursorValue = props.defaultCursorValue,
	            cursorDimension = props.cursorDimension,
	            domain = props.domain;
	
	        if (cursorValue) {
	          return cursorValue;
	        }
	
	        if ((0, _isNumber3.default)(defaultCursorValue)) {
	          return _defineProperty({
	            x: (domain.x[0] + domain.x[1]) / 2,
	            y: (domain.y[0] + domain.y[1]) / 2
	          }, cursorDimension, defaultCursorValue);
	        }
	
	        return defaultCursorValue;
	      }
	    }, {
	      key: "getCursorLabelOffset",
	      value: function getCursorLabelOffset(props) {
	        var cursorLabelOffset = props.cursorLabelOffset;
	
	
	        if ((0, _isNumber3.default)(cursorLabelOffset)) {
	          return {
	            x: cursorLabelOffset,
	            y: cursorLabelOffset
	          };
	        }
	
	        return cursorLabelOffset;
	      }
	    }, {
	      key: "getPadding",
	      value: function getPadding(props) {
	        if ((0, _isUndefined3.default)(props.padding)) {
	          var child = props.children.find(function (c) {
	            return (0, _isObject3.default)(c.props) && !(0, _isUndefined3.default)(c.props.padding);
	          });
	          return _victoryCore.Helpers.getPadding(child.props);
	        } else {
	          return _victoryCore.Helpers.getPadding(props);
	        }
	      }
	    }, {
	      key: "getCursorElements",
	      value: function getCursorElements(props) {
	        var scale = props.scale,
	            cursorDimension = props.cursorDimension,
	            cursorLabelComponent = props.cursorLabelComponent,
	            cursorLabel = props.cursorLabel,
	            cursorComponent = props.cursorComponent,
	            width = props.width,
	            height = props.height;
	
	        var cursorValue = this.getCursorPosition(props);
	        var cursorLabelOffset = this.getCursorLabelOffset(props);
	
	        if (!cursorValue) {
	          return [];
	        }
	
	        var newElements = [];
	        var padding = this.getPadding(props);
	        var cursorCoordinates = {
	          x: scale.x(cursorValue.x),
	          y: scale.y(cursorValue.y)
	        };
	        if (cursorLabel) {
	          newElements.push(_react2.default.cloneElement(cursorLabelComponent, (0, _defaults3.default)({ active: true }, cursorLabelComponent.props, {
	            x: cursorCoordinates.x + cursorLabelOffset.x,
	            y: cursorCoordinates.y + cursorLabelOffset.y,
	            text: _victoryCore.Helpers.evaluateProp(cursorLabel, cursorValue, true),
	            active: true,
	            key: "cursor-label"
	          })));
	        }
	
	        if (cursorDimension === "x" || cursorDimension === undefined) {
	          newElements.push(_react2.default.cloneElement(cursorComponent, {
	            key: "x-cursor",
	            x1: cursorCoordinates.x,
	            x2: cursorCoordinates.x,
	            y1: padding.top,
	            y2: height - padding.bottom
	          }));
	        }
	        if (cursorDimension === "y" || cursorDimension === undefined) {
	          newElements.push(_react2.default.cloneElement(cursorComponent, {
	            key: "y-cursor",
	            x1: padding.left,
	            x2: width - padding.right,
	            y1: cursorCoordinates.y,
	            y2: cursorCoordinates.y
	          }));
	        }
	        return newElements;
	      }
	
	      // Overrides method in VictoryContainer
	
	    }, {
	      key: "getChildren",
	      value: function getChildren(props) {
	        return [].concat(_toConsumableArray(_react2.default.Children.toArray(props.children)), _toConsumableArray(this.getCursorElements(props)));
	      }
	    }]);
	
	    return VictoryCursorContainer;
	  }(base), _class.displayName = "VictoryCursorContainer", _class.propTypes = _extends({}, _victoryCore.VictoryContainer.propTypes, {
	    cursorDimension: _propTypes2.default.oneOf(["x", "y"]),
	    cursorLabel: _propTypes2.default.func,
	    cursorLabelComponent: _propTypes2.default.element,
	    cursorLabelOffset: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.shape({
	      x: _propTypes2.default.number,
	      y: _propTypes2.default.number
	    })]),
	    defaultCursorValue: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.shape({
	      x: _propTypes2.default.number,
	      y: _propTypes2.default.number
	    })]),
	    onCursorChange: _propTypes2.default.func
	  }), _class.defaultProps = _extends({}, _victoryCore.VictoryContainer.defaultProps, {
	    cursorLabelComponent: _react2.default.createElement(_victoryCore.VictoryLabel, null),
	    cursorLabelOffset: {
	      x: 5,
	      y: -10
	    },
	    cursorComponent: _react2.default.createElement(_victoryCore.Line, null)
	  }), _class.defaultEvents = [{
	    target: "parent",
	    eventHandlers: {
	      onMouseLeave: function () {
	        return [];
	      },
	      onTouchCancel: function () {
	        return [];
	      },
	      onMouseMove: function (evt, targetProps) {
	        var mutations = _cursorHelpers2.default.onMouseMove(evt, targetProps);
	
	        if (mutations.id !== _this2.mouseMoveMutationId) {
	          // eslint-disable-line
	          _this2.mouseMoveMutationId = mutations.id; // eslint-disable-line
	          return mutations.mutations;
	        }
	
	        return [];
	      },
	      onTouchMove: function (evt, targetProps) {
	        var mutations = _cursorHelpers2.default.onMouseMove(evt, targetProps);
	
	        if (mutations.id !== _this2.mouseMoveMutationId) {
	          // eslint-disable-line
	          _this2.mouseMoveMutationId = mutations.id; // eslint-disable-line
	          return mutations.mutations;
	        }
	
	        return [];
	      }
	    }
	  }], _temp;
	};
	
	exports.default = cursorContainerMixin(_victoryCore.VictoryContainer);

/***/ },
/* 251 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.selectionContainerMixin = undefined;
	
	var _this2 = this;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _victoryCore = __webpack_require__(3);
	
	var _selectionHelpers = __webpack_require__(248);
	
	var _selectionHelpers2 = _interopRequireDefault(_selectionHelpers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var selectionContainerMixin = exports.selectionContainerMixin = function (base) {
	  var _class, _temp;
	
	  return _temp = _class = function (_base) {
	    _inherits(VictorySelectionContainer, _base);
	
	    function VictorySelectionContainer() {
	      _classCallCheck(this, VictorySelectionContainer);
	
	      return _possibleConstructorReturn(this, (VictorySelectionContainer.__proto__ || Object.getPrototypeOf(VictorySelectionContainer)).apply(this, arguments));
	    }
	
	    _createClass(VictorySelectionContainer, [{
	      key: "getRect",
	      value: function getRect(props) {
	        var x1 = props.x1,
	            x2 = props.x2,
	            y1 = props.y1,
	            y2 = props.y2,
	            selectionStyle = props.selectionStyle,
	            selectionComponent = props.selectionComponent;
	
	        var width = Math.abs(x2 - x1) || 1;
	        var height = Math.abs(y2 - y1) || 1;
	        var x = Math.min(x1, x2);
	        var y = Math.min(y1, y2);
	        return y2 && x2 && x1 && y1 ? _react2.default.cloneElement(selectionComponent, { x: x, y: y, width: width, height: height, style: selectionStyle }) : null;
	      }
	
	      // Overrides method in VictoryContainer
	
	    }, {
	      key: "getChildren",
	      value: function getChildren(props) {
	        var children = _react2.default.Children.toArray(props.children);
	        return [].concat(_toConsumableArray(children), [this.getRect(props)]).map(function (component, i) {
	          return component ? _react2.default.cloneElement(component, { key: i }) : null;
	        });
	      }
	    }]);
	
	    return VictorySelectionContainer;
	  }(base), _class.displayName = "VictorySelectionContainer", _class.propTypes = _extends({}, _victoryCore.VictoryContainer.propTypes, {
	    allowSelection: _propTypes2.default.bool,
	    onSelection: _propTypes2.default.func,
	    onSelectionCleared: _propTypes2.default.func,
	    selectionComponent: _propTypes2.default.element,
	    selectionDimension: _propTypes2.default.oneOf(["x", "y"]),
	    selectionStyle: _propTypes2.default.object
	  }), _class.defaultProps = _extends({}, _victoryCore.VictoryContainer.defaultProps, {
	    allowSelection: true,
	    selectionComponent: _react2.default.createElement("rect", null),
	    selectionStyle: {
	      stroke: "transparent",
	      fill: "black",
	      fillOpacity: 0.1
	    }
	  }), _class.defaultEvents = [{
	    target: "parent",
	    eventHandlers: {
	      onMouseDown: function (evt, targetProps) {
	        return _selectionHelpers2.default.onMouseDown(evt, targetProps);
	      },
	      onTouchStart: function (evt, targetProps) {
	        return _selectionHelpers2.default.onMouseDown(evt, targetProps);
	      },
	      onMouseMove: function (evt, targetProps) {
	        var mutations = _selectionHelpers2.default.onMouseMove(evt, targetProps);
	
	        if (mutations.id !== _this2.mouseMoveMutationId) {
	          // eslint-disable-line
	          _this2.mouseMoveMutationId = mutations.id; // eslint-disable-line
	          return mutations.mutations;
	        }
	
	        return undefined;
	      },
	      onTouchMove: function (evt, targetProps) {
	        var mutations = _selectionHelpers2.default.onMouseMove(evt, targetProps);
	
	        if (mutations.id !== _this2.mouseMoveMutationId) {
	          // eslint-disable-line
	          _this2.mouseMoveMutationId = mutations.id; // eslint-disable-line
	          return mutations.mutations;
	        }
	
	        return undefined;
	      },
	      onMouseUp: function (evt, targetProps) {
	        return _selectionHelpers2.default.onMouseUp(evt, targetProps);
	      },
	      onTouchEnd: function (evt, targetProps) {
	        return _selectionHelpers2.default.onMouseUp(evt, targetProps);
	      }
	    }
	  }], _temp;
	};
	
	exports.default = selectionContainerMixin(_victoryCore.VictoryContainer);

/***/ },
/* 252 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.voronoiContainerMixin = undefined;
	
	var _defaults2 = __webpack_require__(5);
	
	var _defaults3 = _interopRequireDefault(_defaults2);
	
	var _omit2 = __webpack_require__(25);
	
	var _omit3 = _interopRequireDefault(_omit2);
	
	var _this2 = this;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _victoryCore = __webpack_require__(3);
	
	var _voronoiHelpers = __webpack_require__(254);
	
	var _voronoiHelpers2 = _interopRequireDefault(_voronoiHelpers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var voronoiContainerMixin = exports.voronoiContainerMixin = function (base) {
	  var _class, _temp;
	
	  return _temp = _class = function (_base) {
	    _inherits(VictoryVoronoiContainer, _base);
	
	    function VictoryVoronoiContainer() {
	      _classCallCheck(this, VictoryVoronoiContainer);
	
	      return _possibleConstructorReturn(this, (VictoryVoronoiContainer.__proto__ || Object.getPrototypeOf(VictoryVoronoiContainer)).apply(this, arguments));
	    }
	
	    _createClass(VictoryVoronoiContainer, [{
	      key: "getLabelPadding",
	      value: function getLabelPadding(style) {
	        if (!style) {
	          return 0;
	        }
	        var paddings = Array.isArray(style) ? style.map(function (s) {
	          return s.padding;
	        }) : [style.padding];
	        return Math.max.apply(Math, _toConsumableArray(paddings).concat([0]));
	      }
	    }, {
	      key: "getFlyoutSize",
	      value: function getFlyoutSize(labelComponent, text, style) {
	        var padding = this.getLabelPadding(style);
	        var textSize = _victoryCore.TextSize.approximateTextSize(text, style);
	        return {
	          x: labelComponent.width || textSize.width + padding,
	          y: labelComponent.height || textSize.height + padding
	        };
	      }
	    }, {
	      key: "getLabelCornerRadius",
	      value: function getLabelCornerRadius(props, labelProps) {
	        if (typeof labelProps.cornerRadius !== "undefined") {
	          return labelProps.cornerRadius;
	        }
	        var theme = props.theme || labelProps.theme;
	        return theme.tooltip && theme.tooltip.cornerRadius || 0;
	      }
	    }, {
	      key: "getFlyoutExtent",
	      value: function getFlyoutExtent(position, props, labelProps) {
	        var text = labelProps.text,
	            style = labelProps.style;
	        var orientation = labelProps.orientation,
	            _labelProps$dx = labelProps.dx,
	            dx = _labelProps$dx === undefined ? 0 : _labelProps$dx,
	            _labelProps$dy = labelProps.dy,
	            dy = _labelProps$dy === undefined ? 0 : _labelProps$dy;
	
	        var flyoutSize = this.getFlyoutSize(props.labelComponent, text, style);
	        var cornerRadius = this.getLabelCornerRadius(props, labelProps);
	        var x = position.x + dx + 2 * cornerRadius;
	        var y = position.y + dy + 2 * cornerRadius;
	        var width = orientation === "top" || orientation === "bottom" ? flyoutSize.x / 2 : flyoutSize.x;
	        var horizontalSign = orientation === "left" ? -1 : 1;
	        var verticalSign = orientation === "bottom" ? 1 : -1;
	        var extent = {};
	        if (orientation === "top" || orientation === "bottom") {
	          extent.x = [x - width, x + width];
	        } else {
	          extent.x = [x, x + horizontalSign * width];
	        }
	        extent.y = [y, y + verticalSign * flyoutSize.y];
	        return {
	          x: [Math.min.apply(Math, _toConsumableArray(extent.x)), Math.max.apply(Math, _toConsumableArray(extent.x))],
	          y: [Math.min.apply(Math, _toConsumableArray(extent.y)), Math.max.apply(Math, _toConsumableArray(extent.y))]
	        };
	      }
	    }, {
	      key: "getLabelPosition",
	      value: function getLabelPosition(props, points, labelProps) {
	        var mousePosition = props.mousePosition,
	            voronoiDimension = props.voronoiDimension,
	            scale = props.scale,
	            voronoiPadding = props.voronoiPadding;
	
	        var basePosition = _victoryCore.Helpers.scalePoint(props, (0, _omit3.default)(points[0], ["_voronoiX", "_voronoiY"]));
	        if (!voronoiDimension || points.length < 2) {
	          return basePosition;
	        }
	
	        var x = voronoiDimension === "y" ? mousePosition.x : basePosition.x;
	        var y = voronoiDimension === "x" ? mousePosition.y : basePosition.y;
	        if (props.polar) {
	          // TODO: Should multi-point tooltips be constrained within a circular chart?
	          return { x: x, y: y };
	        }
	        var range = { x: scale.x.range(), y: scale.y.range() };
	        var extent = {
	          x: [Math.min.apply(Math, _toConsumableArray(range.x)) + voronoiPadding, Math.max.apply(Math, _toConsumableArray(range.x)) - voronoiPadding],
	          y: [Math.min.apply(Math, _toConsumableArray(range.y)) + voronoiPadding, Math.max.apply(Math, _toConsumableArray(range.y)) - voronoiPadding]
	        };
	        var flyoutExtent = this.getFlyoutExtent({ x: x, y: y }, props, labelProps);
	        var adjustments = {
	          x: [flyoutExtent.x[0] < extent.x[0] ? extent.x[0] - flyoutExtent.x[0] : 0, flyoutExtent.x[1] > extent.x[1] ? flyoutExtent.x[1] - extent.x[1] : 0],
	          y: [flyoutExtent.y[0] < extent.y[0] ? extent.y[0] - flyoutExtent.y[0] : 0, flyoutExtent.y[1] > extent.y[1] ? flyoutExtent.y[1] - extent.y[1] : 0]
	        };
	        return {
	          x: Math.round(x + adjustments.x[0] - adjustments.x[1]),
	          y: Math.round(y + adjustments.y[0] - adjustments.y[1])
	        };
	      }
	    }, {
	      key: "getStyle",
	      value: function getStyle(props, points, type) {
	        var labels = props.labels,
	            labelComponent = props.labelComponent,
	            theme = props.theme;
	
	        var componentProps = labelComponent.props || {};
	        var themeStyles = theme && theme.voronoi && theme.voronoi.style ? theme.voronoi.style : {};
	        var componentStyleArray = type === "flyout" ? componentProps.flyoutStyle : componentProps.style;
	        return points.reduce(function (memo, point, index) {
	          var text = _victoryCore.Helpers.evaluateProp(labels, point, true);
	          var textArray = text ? ("" + text).split("\n") : [];
	          var baseStyle = point.style && point.style[type] || {};
	          var componentStyle = Array.isArray(componentStyleArray) ? componentStyleArray[index] : componentStyleArray;
	          var style = _victoryCore.Helpers.evaluateStyle((0, _defaults3.default)({}, componentStyle, baseStyle, themeStyles[type]), point, true);
	          var styleArray = textArray.length ? textArray.map(function () {
	            return style;
	          }) : [style];
	          memo = memo.concat(styleArray);
	          return memo;
	        }, []);
	      }
	    }, {
	      key: "getDefaultLabelProps",
	      value: function getDefaultLabelProps(props, points) {
	        var voronoiDimension = props.voronoiDimension;
	
	        var multiPoint = voronoiDimension && points.length > 1;
	        return {
	          orientation: multiPoint ? "top" : undefined,
	          pointerLength: multiPoint ? 0 : undefined
	        };
	      }
	    }, {
	      key: "getLabelProps",
	      value: function getLabelProps(props, points) {
	        var labels = props.labels,
	            scale = props.scale,
	            labelComponent = props.labelComponent,
	            theme = props.theme;
	
	        var text = points.reduce(function (memo, point) {
	          var t = _victoryCore.Helpers.evaluateProp(labels, point, true);
	          if (t === null || t === undefined) {
	            return memo;
	          }
	          memo = memo.concat(("" + t).split("\n"));
	          return memo;
	        }, []);
	        var componentProps = labelComponent.props || {};
	        var style = this.getStyle(props, points, "labels");
	
	        var labelProps = (0, _defaults3.default)({
	          active: true,
	          datum: (0, _omit3.default)(points[0], ["childName", "style", "continuous"]),
	          flyoutStyle: this.getStyle(props, points, "flyout")[0],
	          renderInPortal: false,
	          scale: scale, style: style, theme: theme, text: text
	        }, componentProps, this.getDefaultLabelProps(props, points));
	        var labelPosition = this.getLabelPosition(props, points, labelProps);
	        return _extends({}, labelPosition, labelProps);
	      }
	    }, {
	      key: "getTooltip",
	      value: function getTooltip(props) {
	        var labels = props.labels,
	            activePoints = props.activePoints,
	            labelComponent = props.labelComponent;
	
	        if (!labels) {
	          return null;
	        }
	        if (Array.isArray(activePoints) && activePoints.length) {
	          return _react2.default.cloneElement(labelComponent, this.getLabelProps(props, activePoints));
	        } else {
	          return null;
	        }
	      }
	
	      // Overrides method in VictoryContainer
	
	    }, {
	      key: "getChildren",
	      value: function getChildren(props) {
	        var children = _react2.default.Children.toArray(props.children);
	        return [].concat(_toConsumableArray(children), [this.getTooltip(props)]).map(function (component, i) {
	          return component ? _react2.default.cloneElement(component, { key: i }) : null;
	        });
	      }
	    }]);
	
	    return VictoryVoronoiContainer;
	  }(base), _class.displayName = "VictoryVoronoiContainer", _class.propTypes = _extends({}, _victoryCore.VictoryContainer.propTypes, {
	    labelComponent: _propTypes2.default.element,
	    labels: _propTypes2.default.func,
	    onActivated: _propTypes2.default.func,
	    onDeactivated: _propTypes2.default.func,
	    radius: _propTypes2.default.number,
	    voronoiDimension: _propTypes2.default.oneOf(["x", "y"]),
	    voronoiPadding: _propTypes2.default.number
	  }), _class.defaultProps = _extends({}, _victoryCore.VictoryContainer.defaultProps, {
	    labelComponent: _react2.default.createElement(_victoryCore.VictoryTooltip, null),
	    voronoiPadding: 5
	  }), _class.defaultEvents = [{
	    target: "parent",
	    eventHandlers: {
	      onMouseLeave: function (evt, targetProps) {
	        return _voronoiHelpers2.default.onMouseLeave(evt, targetProps);
	      },
	      onTouchCancel: function (evt, targetProps) {
	        return _voronoiHelpers2.default.onMouseLeave(evt, targetProps);
	      },
	      onMouseMove: function (evt, targetProps) {
	        var mutations = _voronoiHelpers2.default.onMouseMove(evt, targetProps);
	
	        if (mutations.id !== _this2.mouseMoveMutationId) {
	          // eslint-disable-line
	          _this2.mouseMoveMutationId = mutations.id; // eslint-disable-line
	          return mutations.mutations;
	        }
	
	        return undefined;
	      },
	      onTouchMove: function (evt, targetProps) {
	        var mutations = _voronoiHelpers2.default.onMouseMove(evt, targetProps);
	
	        if (mutations.id !== _this2.mouseMoveMutationId) {
	          // eslint-disable-line
	          _this2.mouseMoveMutationId = mutations.id; // eslint-disable-line
	          return mutations.mutations;
	        }
	
	        return undefined;
	      }
	    }
	  }, {
	    target: "data",
	    eventHandlers: {
	      onMouseOver: function () {
	        return null;
	      },
	      onMouseOut: function () {
	        return null;
	      },
	      onMouseMove: function () {
	        return null;
	      }
	    }
	  }], _temp;
	};
	
	exports.default = voronoiContainerMixin(_victoryCore.VictoryContainer);

/***/ },
/* 253 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.zoomContainerMixin = undefined;
	
	var _get2 = __webpack_require__(218);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _defaults2 = __webpack_require__(5);
	
	var _defaults3 = _interopRequireDefault(_defaults2);
	
	var _this3 = this;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _zoomHelpers = __webpack_require__(255);
	
	var _zoomHelpers2 = _interopRequireDefault(_zoomHelpers);
	
	var _victoryCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DEFAULT_DOWNSAMPLE = 150;
	
	var zoomContainerMixin = exports.zoomContainerMixin = function (base) {
	  var _class, _temp;
	
	  return _temp = _class = function (_base) {
	    _inherits(VictoryZoomContainer, _base);
	
	    function VictoryZoomContainer() {
	      _classCallCheck(this, VictoryZoomContainer);
	
	      return _possibleConstructorReturn(this, (VictoryZoomContainer.__proto__ || Object.getPrototypeOf(VictoryZoomContainer)).apply(this, arguments));
	    }
	
	    _createClass(VictoryZoomContainer, [{
	      key: "clipDataComponents",
	      value: function clipDataComponents(children, props) {
	        var scale = props.scale,
	            clipContainerComponent = props.clipContainerComponent,
	            polar = props.polar,
	            origin = props.origin;
	
	        var rangeX = scale.x.range();
	        var rangeY = scale.y.range();
	        var plottableWidth = Math.abs(rangeX[0] - rangeX[1]);
	        var plottableHeight = Math.abs(rangeY[0] - rangeY[1]);
	        var radius = Math.max.apply(Math, _toConsumableArray(rangeY));
	        var groupComponent = _react2.default.cloneElement(clipContainerComponent, _extends({
	          clipWidth: plottableWidth,
	          clipHeight: plottableHeight,
	          translateX: Math.min.apply(Math, _toConsumableArray(rangeX)),
	          translateY: Math.min.apply(Math, _toConsumableArray(rangeY)),
	          polar: polar,
	          origin: polar ? origin : undefined,
	          radius: polar ? radius : undefined
	        }, clipContainerComponent.props));
	        return _react2.default.Children.toArray(children).map(function (child) {
	          var role = child && child.type && child.type.role;
	          if (role === "axis" || role === "legend" || role === "label") {
	            return child;
	          } else {
	            return _react2.default.cloneElement(child, { groupComponent: groupComponent });
	          }
	        });
	      }
	    }, {
	      key: "modifyPolarDomain",
	      value: function modifyPolarDomain(domain, originalDomain) {
	        // Only zoom the radius of polar charts. Zooming angles is very confusing
	        return {
	          x: originalDomain.x,
	          y: [0, domain.y[1]]
	        };
	      }
	    }, {
	      key: "downsampleZoomData",
	      value: function downsampleZoomData(props, childProps, domain) {
	        var downsample = props.downsample;
	
	        var rawData = (0, _get3.default)(childProps, "data");
	        // return undefined if downsample is not run, then default() will replace with child.props.data
	        if (!downsample || !rawData || !domain) {
	          return undefined;
	        }
	
	        // if data accessors are not used, skip calling expensive Data.formatData
	        var data = childProps.x || childProps.y ? _victoryCore.Data.formatData(rawData, childProps) : rawData;
	        var maxPoints = downsample === true ? DEFAULT_DOWNSAMPLE : downsample;
	        var dimension = props.zoomDimension || "x";
	
	        // important: assumes data is ordered by dimension
	        // get the start and end of the data that is in the current visible domain
	        var startIndex = data.findIndex(function (d) {
	          return d[dimension] >= domain[dimension][0];
	        });
	        var endIndex = data.findIndex(function (d) {
	          return d[dimension] > domain[dimension][1];
	        });
	        // pick one more point (if available) at each end so that VictoryLine, VictoryArea connect
	        if (startIndex !== 0) {
	          startIndex -= 1;
	        }
	        if (endIndex !== -1) {
	          endIndex += 1;
	        }
	
	        var visibleData = data.slice(startIndex, endIndex);
	
	        return _victoryCore.Data.downsample(visibleData, maxPoints, startIndex);
	      }
	    }, {
	      key: "modifyChildren",
	      value: function modifyChildren(props) {
	        var _this2 = this;
	
	        var childComponents = _react2.default.Children.toArray(props.children);
	
	        //eslint-disable-next-line max-statements
	        return childComponents.map(function (child) {
	          var role = child && child.type && child.type.role;
	          var currentChild = child;
	          var currentDomain = props.currentDomain,
	              zoomActive = props.zoomActive,
	              allowZoom = props.allowZoom;
	
	          var originalDomain = (0, _defaults3.default)({}, props.originalDomain, props.domain);
	          var zoomDomain = (0, _defaults3.default)({}, props.zoomDomain, props.domain);
	          var cachedZoomDomain = (0, _defaults3.default)({}, props.cachedZoomDomain, props.domain);
	          var checkDomainEquality = function (a, b) {
	            return +a.x[0] === +b.x[0] && +a.x[1] === +b.x[1] && +a.y[0] === +b.y[0] && +a.y[1] === +b.y[1];
	          };
	          var domain = void 0;
	          if (!checkDomainEquality(zoomDomain, cachedZoomDomain)) {
	            // if zoomDomain has been changed, use it
	            domain = zoomDomain;
	          } else if (allowZoom && !zoomActive) {
	            // if user has zoomed all the way out, use the child domain
	            domain = currentChild.props.domain;
	          } else {
	            // default: use currentDomain, set by the event handlers
	            domain = (0, _defaults3.default)({}, currentDomain, originalDomain);
	          }
	
	          var newDomain = props.polar ? _this2.modifyPolarDomain(domain, originalDomain) : domain;
	          if (newDomain && props.zoomDimension) {
	            // if zooming is restricted to a dimension, don't squash changes to zoomDomain in other dim
	            newDomain = _extends({}, zoomDomain, _defineProperty({}, props.zoomDimension, newDomain[props.zoomDimension]));
	          }
	          var newChild = _react2.default.cloneElement(currentChild, (0, _defaults3.default)({
	            domain: newDomain,
	            data: role === "legend" ? undefined : _this2.downsampleZoomData(props, currentChild.props, newDomain)
	          }, currentChild.props));
	          return newChild;
	        });
	      }
	
	      // Overrides method in VictoryContainer
	
	    }, {
	      key: "getChildren",
	      value: function getChildren(props) {
	        var children = this.modifyChildren(props);
	        return this.clipDataComponents(children, props);
	      }
	    }]);
	
	    return VictoryZoomContainer;
	  }(base), _class.displayName = "VictoryZoomContainer", _class.propTypes = _extends({}, _victoryCore.VictoryContainer.propTypes, {
	    allowPan: _propTypes2.default.bool,
	    allowZoom: _propTypes2.default.bool,
	    clipContainerComponent: _propTypes2.default.element.isRequired,
	    downsample: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.number]),
	    minimumZoom: _propTypes2.default.shape({
	      x: _propTypes2.default.number,
	      y: _propTypes2.default.number
	    }),
	    onZoomDomainChange: _propTypes2.default.func,
	    zoomDimension: _propTypes2.default.oneOf(["x", "y"]),
	    zoomDomain: _propTypes2.default.shape({
	      x: _victoryCore.PropTypes.domain,
	      y: _victoryCore.PropTypes.domain
	    })
	  }), _class.defaultProps = _extends({}, _victoryCore.VictoryContainer.defaultProps, {
	    clipContainerComponent: _react2.default.createElement(_victoryCore.VictoryClipContainer, null),
	    allowPan: true,
	    allowZoom: true,
	    zoomActive: false
	  }), _class.defaultEvents = [{
	    target: "parent",
	    eventHandlers: {
	      onMouseDown: function (evt, targetProps) {
	        return _zoomHelpers2.default.onMouseDown(evt, targetProps);
	      },
	      onTouchStart: function (evt, targetProps) {
	        return _zoomHelpers2.default.onMouseDown(evt, targetProps);
	      },
	      onMouseUp: function (evt, targetProps) {
	        return _zoomHelpers2.default.onMouseUp(evt, targetProps);
	      },
	      onTouchEnd: function (evt, targetProps) {
	        return _zoomHelpers2.default.onMouseUp(evt, targetProps);
	      },
	      onMouseLeave: function (evt, targetProps) {
	        return _zoomHelpers2.default.onMouseLeave(evt, targetProps);
	      },
	      onTouchCancel: function (evt, targetProps) {
	        return _zoomHelpers2.default.onMouseLeave(evt, targetProps);
	      },
	      onMouseMove: function (evt, targetProps, eventKey, ctx) {
	        // eslint-disable-line max-params
	        evt.preventDefault();
	        var mutations = _zoomHelpers2.default.onMouseMove(evt, targetProps, eventKey, ctx);
	
	        if (mutations.id !== _this3.mouseMoveMutationId) {
	          // eslint-disable-line
	          _this3.mouseMoveMutationId = mutations.id; // eslint-disable-line
	          return mutations.mutations;
	        }
	
	        return undefined;
	      },
	      onTouchMove: function (evt, targetProps, eventKey, ctx) {
	        // eslint-disable-line max-params
	        evt.preventDefault();
	        var mutations = _zoomHelpers2.default.onMouseMove(evt, targetProps, eventKey, ctx);
	
	        if (mutations.id !== _this3.mouseMoveMutationId) {
	          // eslint-disable-line
	          _this3.mouseMoveMutationId = mutations.id; // eslint-disable-line
	          return mutations.mutations;
	        }
	
	        return undefined;
	      },
	      onWheel: function (evt, targetProps, eventKey, ctx) {
	        // eslint-disable-line max-params
	        if (targetProps.allowZoom) {
	          evt.preventDefault();
	        }
	
	        var mutations = _zoomHelpers2.default.onWheel(evt, targetProps, eventKey, ctx);
	
	        if (mutations.id !== _this3.wheelMutationId) {
	          // eslint-disable-line
	          _this3.wheelMutationId = mutations.id; // eslint-disable-line
	          return mutations.mutations;
	        }
	
	        return undefined;
	      }
	    }
	  }], _temp;
	};
	
	exports.default = zoomContainerMixin(_victoryCore.VictoryContainer);

/***/ },
/* 254 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isEqual2 = __webpack_require__(43);
	
	var _isEqual3 = _interopRequireDefault(_isEqual2);
	
	var _keys2 = __webpack_require__(12);
	
	var _keys3 = _interopRequireDefault(_keys2);
	
	var _groupBy2 = __webpack_require__(130);
	
	var _groupBy3 = _interopRequireDefault(_groupBy2);
	
	var _isFunction2 = __webpack_require__(7);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _throttle2 = __webpack_require__(59);
	
	var _throttle3 = _interopRequireDefault(_throttle2);
	
	var _assign2 = __webpack_require__(4);
	
	var _assign3 = _interopRequireDefault(_assign2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _victoryCore = __webpack_require__(3);
	
	var _d3Voronoi = __webpack_require__(167);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _eventHandlers = __webpack_require__(60);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var VoronoiHelpers = {
	  withinBounds: function (props, point) {
	    var width = props.width,
	        height = props.height,
	        voronoiPadding = props.voronoiPadding,
	        polar = props.polar,
	        origin = props.origin,
	        scale = props.scale;
	
	    var padding = voronoiPadding || 0;
	    var x = point.x,
	        y = point.y;
	
	    if (polar) {
	      var distanceSquared = Math.pow(x - origin.x, 2) + Math.pow(y - origin.y, 2);
	      var radius = Math.max.apply(Math, _toConsumableArray(scale.y.range()));
	      return distanceSquared < Math.pow(radius, 2);
	    } else {
	      return x >= padding && x <= width - padding && y >= padding && y <= height - padding;
	    }
	  },
	  getDatasets: function (props) {
	    var addMeta = function (data, name, child) {
	      var continuous = child && child.type && child.type.continuous;
	      var style = child ? child.props && child.props.style : props.style;
	      return data.map(function (datum, index) {
	        var _Helpers$getPoint = _victoryCore.Helpers.getPoint(datum),
	            x = _Helpers$getPoint.x,
	            y = _Helpers$getPoint.y;
	
	        return (0, _assign3.default)({
	          _voronoiX: props.voronoiDimension === "y" ? 0 : x,
	          _voronoiY: props.voronoiDimension === "x" ? 0 : y,
	          childName: name, eventKey: index, continuous: continuous, style: style
	        }, datum);
	      });
	    };
	
	    if (props.data) {
	      return addMeta(props.data);
	    }
	
	    var getData = function (childProps) {
	      var data = _victoryCore.Data.getData(childProps);
	      return Array.isArray(data) && data.length > 0 ? data : undefined;
	    };
	
	    var iteratee = function (child, childName, parent) {
	      var role = child.type && child.type.role;
	      if (role === "axis" || role === "legend" || role === "label") {
	        return null;
	      } else if (child.type && (0, _isFunction3.default)(child.type.getData)) {
	        child = parent ? _react2.default.cloneElement(child, parent.props) : child;
	        var childData = child.props && child.type.getData(_extends({}, child.props, { domain: props.domain }));
	        return childData ? addMeta(childData, childName, child) : null;
	      } else {
	        var _childData = getData(_extends({}, child.props, { domain: props.domain }));
	        return _childData ? addMeta(_childData, childName, child) : null;
	      }
	    };
	    return _victoryCore.Helpers.reduceChildren(_react2.default.Children.toArray(props.children), iteratee);
	  },
	
	
	  // returns an array of objects with point and data where point is an x, y coordinate, and data is
	  // an array of points belonging to that coordinate
	  mergeDatasets: function (props, datasets) {
	    var points = (0, _groupBy3.default)(datasets, function (datum) {
	      var _Helpers$scalePoint = _victoryCore.Helpers.scalePoint(props, datum),
	          x = _Helpers$scalePoint.x,
	          y = _Helpers$scalePoint.y;
	
	      return x + "," + y;
	    });
	    return (0, _keys3.default)(points).map(function (key) {
	      var point = key.split(",");
	      return {
	        x: +point[0],
	        y: +point[1],
	        points: points[key]
	      };
	    });
	  },
	  getVoronoi: function (props, mousePosition) {
	    var width = props.width,
	        height = props.height,
	        voronoiPadding = props.voronoiPadding;
	
	    var padding = voronoiPadding || 0;
	    var voronoiFunction = (0, _d3Voronoi.voronoi)().x(function (d) {
	      return d.x;
	    }).y(function (d) {
	      return d.y;
	    }).extent([[padding, padding], [width - padding, height - padding]]);
	    var datasets = this.getDatasets(props);
	    var voronoi = voronoiFunction(this.mergeDatasets(props, datasets));
	    var size = props.voronoiDimension ? undefined : props.radius;
	    return voronoi.find(mousePosition.x, mousePosition.y, size);
	  },
	  getActiveMutations: function (props, point) {
	    var childName = point.childName,
	        continuous = point.continuous;
	
	    var targets = props.labels ? ["data"] : ["data", "labels"];
	    return targets.map(function (target) {
	      var eventKey = continuous === true && target === "data" ? "all" : point.eventKey;
	      return {
	        childName: childName, eventKey: eventKey, target: target, mutation: function () {
	          return { active: true };
	        }
	      };
	    });
	  },
	  getInactiveMutations: function (props, point) {
	    var childName = point.childName,
	        continuous = point.continuous;
	
	    var targets = props.labels ? ["data"] : ["data", "labels"];
	    return targets.map(function (target) {
	      var eventKey = continuous && target === "data" ? "all" : point.eventKey;
	      return {
	        childName: childName, eventKey: eventKey, target: target, mutation: function () {
	          return null;
	        }
	      };
	    });
	  },
	  getParentMutation: function (activePoints, mousePosition) {
	    return [{
	      target: "parent",
	      eventKey: "parent",
	      mutation: function () {
	        return { activePoints: activePoints, mousePosition: mousePosition };
	      }
	    }];
	  },
	  onActivated: function (props, points) {
	    if ((0, _isFunction3.default)(props.onActivated)) {
	      props.onActivated(points, props);
	    }
	  },
	  onDeactivated: function (props, points) {
	    if ((0, _isFunction3.default)(props.onDeactivated)) {
	      props.onDeactivated(points, props);
	    }
	  },
	  onMouseLeave: function (evt, targetProps) {
	    var _this = this,
	        _getParentMutation;
	
	    var activePoints = targetProps.activePoints || [];
	    this.onDeactivated(targetProps, activePoints);
	    var inactiveMutations = activePoints.length ? activePoints.map(function (point) {
	      return _this.getInactiveMutations(targetProps, point);
	    }) : [];
	    return (_getParentMutation = this.getParentMutation([])).concat.apply(_getParentMutation, _toConsumableArray(inactiveMutations));
	  },
	  onMouseMove: function (evt, targetProps) {
	    var _this2 = this;
	
	    // eslint-disable-line max-statements
	    var activePoints = targetProps.activePoints || [];
	    var mousePosition = _victoryCore.Selection.getSVGEventCoordinates(evt);
	    if (!this.withinBounds(targetProps, mousePosition)) {
	      var _getParentMutation2;
	
	      this.onDeactivated(targetProps, activePoints);
	      var inactiveMutations = activePoints.length ? activePoints.map(function (point) {
	        return _this2.getInactiveMutations(targetProps, point);
	      }) : [];
	      return (_getParentMutation2 = this.getParentMutation([], mousePosition)).concat.apply(_getParentMutation2, _toConsumableArray(inactiveMutations));
	    }
	    var nearestVoronoi = this.getVoronoi(targetProps, mousePosition);
	    var points = nearestVoronoi ? nearestVoronoi.data.points : [];
	    var parentMutations = this.getParentMutation(points, mousePosition);
	    if (activePoints.length && (0, _isEqual3.default)(points, activePoints)) {
	      return parentMutations;
	    } else {
	      this.onActivated(targetProps, points);
	      this.onDeactivated(targetProps, activePoints);
	      var activeMutations = points.length ? points.map(function (point) {
	        return _this2.getActiveMutations(targetProps, point);
	      }) : [];
	      var _inactiveMutations = activePoints.length ? activePoints.map(function (point) {
	        return _this2.getInactiveMutations(targetProps, point);
	      }) : [];
	      return parentMutations.concat.apply(parentMutations, _toConsumableArray(_inactiveMutations).concat(_toConsumableArray(activeMutations)));
	    }
	  }
	};
	
	exports.default = {
	  onMouseLeave: VoronoiHelpers.onMouseLeave.bind(VoronoiHelpers),
	  onMouseMove: (0, _throttle3.default)((0, _eventHandlers.attachId)(VoronoiHelpers.onMouseMove.bind(VoronoiHelpers)), 32, // eslint-disable-line no-magic-numbers
	  { leading: true, trailing: false })
	};

/***/ },
/* 255 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.RawZoomHelpers = undefined;
	
	var _isEqual2 = __webpack_require__(43);
	
	var _isEqual3 = _interopRequireDefault(_isEqual2);
	
	var _defaults2 = __webpack_require__(5);
	
	var _defaults3 = _interopRequireDefault(_defaults2);
	
	var _isFunction2 = __webpack_require__(7);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _throttle2 = __webpack_require__(59);
	
	var _throttle3 = _interopRequireDefault(_throttle2);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /*eslint no-magic-numbers: ["error", { "ignore": [-1, 0, 1, 2, 1000] }]*/
	
	
	var _react = __webpack_require__(1);
	
	var _victoryCore = __webpack_require__(3);
	
	var _eventHandlers = __webpack_require__(60);
	
	var _wrapper = __webpack_require__(61);
	
	var _wrapper2 = _interopRequireDefault(_wrapper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var Helpers = {
	  checkDomainEquality: function (a, b) {
	    var checkDimension = function (dim) {
	      var val1 = a && a[dim];
	      var val2 = b && b[dim];
	      if (!val1 && !val2) {
	        return true;
	      } else if (!val1 || !val2) {
	        return false;
	      }
	      return +val1[0] === +val2[0] && +val1[1] === +val2[1];
	    };
	    return checkDimension("x") && checkDimension("y");
	  },
	
	  /**
	   * Generates a new domain scaled by factor and constrained by the original domain.
	   * @param  {[Number, Number]} currentDomain  The domain to be scaled.
	   * @param  {Object} evt the event object
	   * @param  {Object} props the props of the targeted component
	   * @param  {String} axis the desired dimension (either x or y)
	   * @return {[Number, Number]}                The scale domain
	   */
	  scale: function (currentDomain, evt, props, axis) {
	    // eslint-disable-line max-params
	    var _currentDomain = _slicedToArray(currentDomain, 2),
	        from = _currentDomain[0],
	        to = _currentDomain[1];
	
	    var range = Math.abs(to - from);
	    var minimumZoom = props.minimumZoom && props.minimumZoom[axis];
	    var factor = this.getScaleFactor(evt);
	    if (minimumZoom && range <= minimumZoom && factor < 1) {
	      return currentDomain;
	    }
	
	    var _getDomain$axis = _slicedToArray(this.getDomain(props)[axis], 2),
	        fromBound = _getDomain$axis[0],
	        toBound = _getDomain$axis[1];
	
	    var percent = this.getScalePercent(evt, props, axis);
	    var point = factor * from + percent * (factor * range);
	    var minDomain = this.getMinimumDomain(point, props, axis);
	
	    var _getScaledDomain = this.getScaledDomain(currentDomain, factor, percent),
	        _getScaledDomain2 = _slicedToArray(_getScaledDomain, 2),
	        newMin = _getScaledDomain2[0],
	        newMax = _getScaledDomain2[1];
	
	    var newDomain = [newMin > fromBound && newMin < toBound ? newMin : fromBound, newMax < toBound && newMax > fromBound ? newMax : toBound];
	    var domain = Math.abs(minDomain[1] - minDomain[0]) > Math.abs(newDomain[1] - newDomain[0]) ? minDomain : newDomain;
	    return _victoryCore.Collection.containsDates([fromBound, toBound]) ? [new Date(domain[0]), new Date(domain[1])] : domain;
	  },
	  getScaledDomain: function (currentDomain, factor, percent) {
	    var _currentDomain2 = _slicedToArray(currentDomain, 2),
	        from = _currentDomain2[0],
	        to = _currentDomain2[1];
	
	    var range = Math.abs(to - from);
	    var diff = range - range * factor;
	    var newMin = +from + diff * percent;
	    var newMax = +to - diff * (1 - percent);
	    return [Math.min(newMin, newMax), Math.max(newMin, newMax)];
	  },
	  getMinimumDomain: function (point, props, axis) {
	    var minimumZoom = props.minimumZoom;
	
	    var originalDomain = this.getDomain(props)[axis];
	
	    var _originalDomain = _slicedToArray(originalDomain, 2),
	        from = _originalDomain[0],
	        to = _originalDomain[1];
	
	    var defaultMin = Math.abs(from - to) / 1000;
	    var extent = minimumZoom ? minimumZoom[axis] || defaultMin : defaultMin;
	    var minExtent = point - extent / 2;
	    var maxExtent = point + extent / 2;
	    return [minExtent > from && minExtent < to ? minExtent : from, maxExtent < to && maxExtent > from ? maxExtent : +from + extent / 2];
	  },
	  zoommingOut: function (evt) {
	    return evt.deltaY > 0;
	  },
	  getScaleFactor: function (evt) {
	    var sign = this.zoommingOut(evt) ? 1 : -1;
	    // eslint-disable-next-line no-magic-numbers
	    var delta = Math.min(Math.abs(evt.deltaY / 300), 0.5); // TODO: Check scale factor
	    return Math.abs(1 + sign * delta);
	  },
	  getScalePercent: function (evt, props, axis) {
	    var originalDomain = this.getDomain(props);
	
	    var _originalDomain$axis = _slicedToArray(originalDomain[axis], 2),
	        from = _originalDomain$axis[0],
	        to = _originalDomain$axis[1];
	
	    var position = this.getPosition(evt, props, originalDomain);
	    return (position[axis] - from) / Math.abs(to - from);
	  },
	  getPosition: function (evt, props, originalDomain) {
	    var _Selection$getSVGEven = _victoryCore.Selection.getSVGEventCoordinates(evt),
	        x = _Selection$getSVGEven.x,
	        y = _Selection$getSVGEven.y;
	
	    var originalScale = {
	      x: props.scale.x.domain(originalDomain.x),
	      y: props.scale.y.domain(originalDomain.y)
	    };
	    return _victoryCore.Selection.getDataCoordinates(props, originalScale, x, y);
	  },
	
	
	  /**
	   * Generate a new domain translated by the delta and constrained by the original domain.
	   * @param  {[Number, Number]} currentDomain  The domain to be translated.
	   * @param  {[Number, Number]} originalDomain The original domain for the data set.
	   * @param  {Number}           delta          The delta to translate by
	   * @return {[Number, Number]}                The translated domain
	   */
	  pan: function (currentDomain, originalDomain, delta) {
	    var _currentDomain$map = currentDomain.map(function (val) {
	      return +val;
	    }),
	        _currentDomain$map2 = _slicedToArray(_currentDomain$map, 2),
	        fromCurrent = _currentDomain$map2[0],
	        toCurrent = _currentDomain$map2[1];
	
	    var _originalDomain$map = originalDomain.map(function (val) {
	      return +val;
	    }),
	        _originalDomain$map2 = _slicedToArray(_originalDomain$map, 2),
	        fromOriginal = _originalDomain$map2[0],
	        toOriginal = _originalDomain$map2[1];
	
	    var lowerBound = fromCurrent + delta;
	    var upperBound = toCurrent + delta;
	    var newDomain = void 0;
	    if (lowerBound > fromOriginal && upperBound < toOriginal) {
	      newDomain = [lowerBound, upperBound];
	    } else if (lowerBound < fromOriginal) {
	      // Clamp to lower limit
	      var dx = toCurrent - fromCurrent;
	      newDomain = [fromOriginal, fromOriginal + dx];
	    } else if (upperBound > toOriginal) {
	      // Clamp to upper limit
	      var _dx = toCurrent - fromCurrent;
	      newDomain = [toOriginal - _dx, toOriginal];
	    } else {
	      newDomain = currentDomain;
	    }
	    return _victoryCore.Collection.containsDates(currentDomain) || _victoryCore.Collection.containsDates(originalDomain) ? newDomain.map(function (val) {
	      return new Date(val);
	    }) : newDomain;
	  },
	  getDomainScale: function (domain, scale, axis) {
	    var axisDomain = Array.isArray(domain) ? domain : domain[axis];
	
	    var _axisDomain = _slicedToArray(axisDomain, 2),
	        from = _axisDomain[0],
	        to = _axisDomain[1];
	
	    var range = scale[axis].range();
	    var plottableWidth = Math.abs(range[0] - range[1]);
	    return plottableWidth / (to - from);
	  },
	  handleAnimation: function (ctx) {
	    var getTimer = (0, _isFunction3.default)(ctx.getTimer) && ctx.getTimer.bind(ctx);
	    if (getTimer && (0, _isFunction3.default)(getTimer().bypassAnimation)) {
	      getTimer().bypassAnimation();
	      return (0, _isFunction3.default)(getTimer().resumeAnimation) ? function () {
	        return getTimer().resumeAnimation();
	      } : undefined;
	    }
	    return undefined;
	  },
	  getLastDomain: function (targetProps, originalDomain) {
	    var zoomDomain = targetProps.zoomDomain,
	        cachedZoomDomain = targetProps.cachedZoomDomain,
	        currentDomain = targetProps.currentDomain,
	        domain = targetProps.domain;
	
	    if (zoomDomain && !this.checkDomainEquality(zoomDomain, cachedZoomDomain)) {
	      return (0, _defaults3.default)({}, zoomDomain, domain);
	    }
	    return (0, _defaults3.default)({}, currentDomain || zoomDomain || originalDomain, domain);
	  },
	  getDomain: function (props) {
	    var originalDomain = props.originalDomain,
	        domain = props.domain,
	        children = props.children,
	        zoomDimension = props.zoomDimension;
	
	    var childComponents = _react.Children.toArray(children);
	    var childrenDomain = {};
	    if (childComponents.length) {
	      childrenDomain = zoomDimension ? _defineProperty({}, zoomDimension, _wrapper2.default.getDomainFromChildren(props, zoomDimension, childComponents)) : {
	        x: _wrapper2.default.getDomainFromChildren(props, "x", childComponents),
	        y: _wrapper2.default.getDomainFromChildren(props, "y", childComponents)
	      };
	    }
	    return (0, _defaults3.default)({}, childrenDomain, originalDomain, domain);
	  },
	  onMouseDown: function (evt, targetProps) {
	    evt.preventDefault();
	    if (!targetProps.allowPan) {
	      return undefined;
	    }
	
	    var _Selection$getSVGEven2 = _victoryCore.Selection.getSVGEventCoordinates(evt),
	        x = _Selection$getSVGEven2.x,
	        y = _Selection$getSVGEven2.y;
	
	    return [{
	      target: "parent",
	      mutation: function () {
	        return {
	          startX: x, startY: y, panning: true,
	          parentControlledProps: ["domain"]
	        };
	      }
	    }];
	  },
	  onMouseUp: function (evt, targetProps) {
	    if (!targetProps.allowPan) {
	      return undefined;
	    }
	    return [{
	      target: "parent",
	      mutation: function () {
	        return { panning: false };
	      }
	    }];
	  },
	  onMouseLeave: function (evt, targetProps) {
	    if (!targetProps.allowPan) {
	      return undefined;
	    }
	    return [{
	      target: "parent",
	      mutation: function () {
	        return { panning: false };
	      }
	    }];
	  },
	  onMouseMove: function (evt, targetProps, eventKey, ctx) {
	    // eslint-disable-line max-params
	    if (targetProps.panning && targetProps.allowPan) {
	      var scale = targetProps.scale,
	          startX = targetProps.startX,
	          startY = targetProps.startY,
	          onZoomDomainChange = targetProps.onZoomDomainChange,
	          zoomDimension = targetProps.zoomDimension,
	          zoomDomain = targetProps.zoomDomain;
	
	      var _Selection$getSVGEven3 = _victoryCore.Selection.getSVGEventCoordinates(evt),
	          x = _Selection$getSVGEven3.x,
	          y = _Selection$getSVGEven3.y;
	
	      var originalDomain = this.getDomain(targetProps);
	      var lastDomain = this.getLastDomain(targetProps, originalDomain);
	      var dx = (startX - x) / this.getDomainScale(lastDomain, scale, "x");
	      var dy = (y - startY) / this.getDomainScale(lastDomain, scale, "y");
	      var currentDomain = {
	        x: zoomDimension === "y" ? originalDomain.x : this.pan(lastDomain.x, originalDomain.x, dx),
	        y: zoomDimension === "x" ? originalDomain.y : this.pan(lastDomain.y, originalDomain.y, dy)
	      };
	      var resumeAnimation = this.handleAnimation(ctx);
	      var mutatedProps = {
	        parentControlledProps: ["domain"], startX: x, startY: y,
	        domain: currentDomain, currentDomain: currentDomain, originalDomain: originalDomain, cachedZoomDomain: zoomDomain
	      };
	      if ((0, _isFunction3.default)(onZoomDomainChange)) {
	        onZoomDomainChange(currentDomain, (0, _defaults3.default)({}, mutatedProps, targetProps));
	      }
	      return [{
	        target: "parent",
	        callback: resumeAnimation,
	        mutation: function () {
	          return mutatedProps;
	        }
	      }];
	    }
	    return undefined;
	  },
	  onWheel: function (evt, targetProps, eventKey, ctx) {
	    // eslint-disable-line max-params
	    if (!targetProps.allowZoom) {
	      return undefined;
	    }
	    var onZoomDomainChange = targetProps.onZoomDomainChange,
	        zoomDimension = targetProps.zoomDimension,
	        zoomDomain = targetProps.zoomDomain;
	
	    var originalDomain = this.getDomain(targetProps);
	    var lastDomain = this.getLastDomain(targetProps, originalDomain);
	    var x = lastDomain.x,
	        y = lastDomain.y;
	
	    var currentDomain = {
	      x: zoomDimension === "y" ? lastDomain.x : this.scale(x, evt, targetProps, "x"),
	      y: zoomDimension === "x" ? lastDomain.y : this.scale(y, evt, targetProps, "y")
	    };
	    var resumeAnimation = this.handleAnimation(ctx);
	
	    var zoomActive = !this.zoommingOut(evt) // if zoomming in or
	    // if zoomActive is already set AND user hasn't zoommed out all the way
	    || targetProps.zoomActive && !(0, _isEqual3.default)(originalDomain, lastDomain);
	
	    var mutatedProps = {
	      domain: currentDomain, currentDomain: currentDomain, originalDomain: originalDomain, cachedZoomDomain: zoomDomain,
	      parentControlledProps: ["domain"], panning: false, zoomActive: zoomActive
	    };
	
	    if ((0, _isFunction3.default)(onZoomDomainChange)) {
	      onZoomDomainChange(currentDomain, (0, _defaults3.default)({}, mutatedProps, targetProps));
	    }
	
	    return [{
	      target: "parent",
	      callback: resumeAnimation,
	      mutation: function () {
	        return mutatedProps;
	      }
	    }];
	  }
	};
	
	exports.RawZoomHelpers = Helpers; // allow victory-native to extend these helpers
	
	exports.default = {
	  onMouseDown: Helpers.onMouseDown.bind(Helpers),
	  onMouseUp: Helpers.onMouseUp.bind(Helpers),
	  onMouseLeave: Helpers.onMouseLeave.bind(Helpers),
	  onMouseMove: (0, _throttle3.default)((0, _eventHandlers.attachId)(Helpers.onMouseMove.bind(Helpers)), 16, // eslint-disable-line no-magic-numbers
	  { leading: true, trailing: false }),
	  onWheel: (0, _throttle3.default)((0, _eventHandlers.attachId)(Helpers.onWheel.bind(Helpers)), 16, // eslint-disable-line no-magic-numbers
	  { leading: true, trailing: false })
	};

/***/ },
/* 256 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _partialRight2 = __webpack_require__(16);
	
	var _partialRight3 = _interopRequireDefault(_partialRight2);
	
	var _assign2 = __webpack_require__(4);
	
	var _assign3 = _interopRequireDefault(_assign2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _victoryCore = __webpack_require__(3);
	
	var _helperMethods = __webpack_require__(579);
	
	var _helperMethods2 = _interopRequireDefault(_helperMethods);
	
	var _axis = __webpack_require__(45);
	
	var _axis2 = _interopRequireDefault(_axis);
	
	var _commonProps = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var fallbackProps = {
	  width: 450,
	  height: 300,
	  padding: 50
	};
	
	var animationWhitelist = ["style", "domain", "range", "tickCount", "tickValues", "offsetX", "offsetY", "padding", "width", "height"];
	
	var options = {
	  components: [{ name: "axis", index: 0 }, { name: "axisLabel", index: 0 }, { name: "grid" }, { name: "parent", index: "parent" }, { name: "ticks" }, { name: "tickLabels" }]
	};
	
	var VictoryAxis = function (_React$Component) {
	  _inherits(VictoryAxis, _React$Component);
	
	  function VictoryAxis() {
	    _classCallCheck(this, VictoryAxis);
	
	    return _possibleConstructorReturn(this, (VictoryAxis.__proto__ || Object.getPrototypeOf(VictoryAxis)).apply(this, arguments));
	  }
	
	  _createClass(VictoryAxis, [{
	    key: "renderLine",
	    value: function renderLine(props) {
	      var axisComponent = props.axisComponent;
	
	      var axisProps = this.getComponentProps(axisComponent, "axis", 0);
	      return _react2.default.cloneElement(axisComponent, axisProps);
	    }
	  }, {
	    key: "renderLabel",
	    value: function renderLabel(props) {
	      var axisLabelComponent = props.axisLabelComponent,
	          label = props.label;
	
	      if (!label) {
	        return null;
	      }
	      var axisLabelProps = this.getComponentProps(axisLabelComponent, "axisLabel", 0);
	      return _react2.default.cloneElement(axisLabelComponent, axisLabelProps);
	    }
	  }, {
	    key: "renderGridAndTicks",
	    value: function renderGridAndTicks(props) {
	      var _this2 = this;
	
	      var tickComponent = props.tickComponent,
	          tickLabelComponent = props.tickLabelComponent,
	          gridComponent = props.gridComponent;
	
	
	      return this.dataKeys.map(function (key, index) {
	        var tickProps = _this2.getComponentProps(tickComponent, "ticks", index);
	        var TickComponent = _react2.default.cloneElement(tickComponent, tickProps);
	        var gridProps = _this2.getComponentProps(gridComponent, "grid", index);
	        var GridComponent = _react2.default.cloneElement(gridComponent, gridProps);
	        var tickLabelProps = _this2.getComponentProps(tickLabelComponent, "tickLabels", index);
	        var TickLabel = _react2.default.cloneElement(tickLabelComponent, tickLabelProps);
	
	        return _react2.default.cloneElement(props.groupComponent, { key: "tick-group-" + key }, GridComponent, TickComponent, TickLabel);
	      });
	    }
	  }, {
	    key: "fixLabelOverlap",
	    value: function fixLabelOverlap(gridAndTicks, props) {
	      var isVertical = _victoryCore.Helpers.isVertical(props);
	      var size = isVertical ? props.height : props.width;
	      var isVictoryLabel = function (child) {
	        return child.type && child.type.role === "label";
	      };
	      var labels = gridAndTicks.map(function (gridAndTick) {
	        return gridAndTick.props.children;
	      }).reduce(function (accumulator, childArr) {
	        return accumulator.concat(childArr);
	      }).filter(isVictoryLabel).map(function (child) {
	        return child.props;
	      });
	      var paddingToObject = function (padding) {
	        return typeof padding === "object" ? (0, _assign3.default)({}, { top: 0, right: 0, bottom: 0, left: 0 }, padding) : { top: padding, right: padding, bottom: padding, left: padding };
	      };
	      var labelsSumSize = labels.reduce(function (sum, label) {
	        var padding = paddingToObject(label.style.padding);
	        var labelSize = _victoryCore.TextSize.approximateTextSize(label.text, {
	          angle: label.angle,
	          fontSize: label.style.fontSize,
	          letterSpacing: label.style.letterSpacing,
	          fontFamily: label.style.fontFamily
	        });
	        return sum + (isVertical ? labelSize.height + padding.top + padding.bottom : labelSize.width + padding.right + padding.left);
	      }, 0);
	      var availiableLabelCount = Math.floor(size * gridAndTicks.length / labelsSumSize);
	      var divider = Math.ceil(gridAndTicks.length / availiableLabelCount) || 1;
	      var getLabelCoord = function (gridAndTick) {
	        return gridAndTick.props.children.filter(isVictoryLabel).reduce(function (prev, child) {
	          return (isVertical ? child.props.y : child.props.x) || 0;
	        }, 0);
	      };
	      var sorted = gridAndTicks.sort(function (a, b) {
	        return isVertical ? getLabelCoord(b) - getLabelCoord(a) //ordinat axis has top-bottom orientation
	        : getLabelCoord(a) - getLabelCoord(b);
	      } //ordinat axis has left-right orientation
	      );
	      return sorted.filter(function (gridAndTick, index) {
	        return index % divider === 0;
	      });
	    }
	
	    // Overridden in native versions
	
	  }, {
	    key: "shouldAnimate",
	    value: function shouldAnimate() {
	      return !!this.props.animate;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var props = _victoryCore.Helpers.modifyProps(this.props, fallbackProps, "axis");
	      if (this.shouldAnimate()) {
	        return this.animateComponent(props, animationWhitelist);
	      }
	
	      var gridAndTicks = this.renderGridAndTicks(props);
	      var modifiedGridAndTicks = props.fixLabelOverlap ? this.fixLabelOverlap(gridAndTicks, props) : gridAndTicks;
	      var children = [this.renderLine(props), this.renderLabel(props)].concat(_toConsumableArray(modifiedGridAndTicks));
	      return props.standalone ? this.renderContainer(props.containerComponent, children) : _react2.default.cloneElement(props.groupComponent, {}, children);
	    }
	  }]);
	
	  return VictoryAxis;
	}(_react2.default.Component);
	
	VictoryAxis.displayName = "VictoryAxis";
	VictoryAxis.role = "axis";
	VictoryAxis.defaultTransitions = {
	  onExit: {
	    duration: 500
	  },
	  onEnter: {
	    duration: 500
	  }
	};
	VictoryAxis.propTypes = _extends({}, _commonProps.BaseProps, {
	  axisComponent: _propTypes2.default.element,
	  axisLabelComponent: _propTypes2.default.element,
	  categories: _propTypes2.default.arrayOf(_propTypes2.default.string),
	  crossAxis: _propTypes2.default.bool,
	  dependentAxis: _propTypes2.default.bool,
	  events: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    target: _propTypes2.default.oneOf(["axis", "axisLabel", "grid", "ticks", "tickLabels"]),
	    eventKey: _propTypes2.default.oneOfType([_propTypes2.default.array, _victoryCore.PropTypes.allOfType([_victoryCore.PropTypes.integer, _victoryCore.PropTypes.nonNegative]), _propTypes2.default.string]),
	    eventHandlers: _propTypes2.default.object
	  })),
	  fixLabelOverlap: _propTypes2.default.bool,
	  gridComponent: _propTypes2.default.element,
	  groupComponent: _propTypes2.default.element,
	  invertAxis: _propTypes2.default.bool,
	  label: _propTypes2.default.any,
	  offsetX: _propTypes2.default.number,
	  offsetY: _propTypes2.default.number,
	  orientation: _propTypes2.default.oneOf(["top", "bottom", "left", "right"]),
	  origin: _propTypes2.default.shape({ x: _propTypes2.default.number, y: _propTypes2.default.number }),
	  stringMap: _propTypes2.default.object,
	  style: _propTypes2.default.shape({
	    parent: _propTypes2.default.object, axis: _propTypes2.default.object, axisLabel: _propTypes2.default.object,
	    grid: _propTypes2.default.object, ticks: _propTypes2.default.object, tickLabels: _propTypes2.default.object
	  }),
	  tickComponent: _propTypes2.default.element,
	  tickCount: _victoryCore.PropTypes.allOfType([_victoryCore.PropTypes.integer, _victoryCore.PropTypes.greaterThanZero]),
	  tickFormat: _propTypes2.default.oneOfType([_propTypes2.default.func, _victoryCore.PropTypes.homogeneousArray]),
	  tickLabelComponent: _propTypes2.default.element,
	  tickValues: _victoryCore.PropTypes.homogeneousArray
	});
	VictoryAxis.defaultProps = {
	  axisComponent: _react2.default.createElement(_victoryCore.Line, { type: "axis" }),
	  axisLabelComponent: _react2.default.createElement(_victoryCore.VictoryLabel, null),
	  tickLabelComponent: _react2.default.createElement(_victoryCore.VictoryLabel, null),
	  tickComponent: _react2.default.createElement(_victoryCore.Line, { type: "tick" }),
	  gridComponent: _react2.default.createElement(_victoryCore.Line, { type: "grid" }),
	  scale: "linear",
	  standalone: true,
	  theme: _victoryCore.VictoryTheme.grayscale,
	  containerComponent: _react2.default.createElement(_victoryCore.VictoryContainer, null),
	  groupComponent: _react2.default.createElement("g", { role: "presentation" }),
	  fixLabelOverlap: false
	};
	VictoryAxis.getDomain = _helperMethods2.default.getDomain.bind(_helperMethods2.default);
	VictoryAxis.getAxis = _axis2.default.getAxis.bind(_axis2.default);
	VictoryAxis.getScale = _helperMethods2.default.getScale.bind(_helperMethods2.default);
	VictoryAxis.getStyles = (0, _partialRight3.default)(_helperMethods2.default.getStyles.bind(_helperMethods2.default), fallbackProps.style);
	VictoryAxis.getBaseProps = (0, _partialRight3.default)(_helperMethods2.default.getBaseProps.bind(_helperMethods2.default), fallbackProps);
	VictoryAxis.expectedComponents = ["axisComponent", "axisLabelComponent", "groupComponent", "containerComponent", "tickComponent", "tickLabelComponent", "gridComponent"];
	exports.default = (0, _victoryCore.addEvents)(VictoryAxis, options);

/***/ },
/* 257 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _partialRight2 = __webpack_require__(16);
	
	var _partialRight3 = _interopRequireDefault(_partialRight2);
	
	var _assign2 = __webpack_require__(4);
	
	var _assign3 = _interopRequireDefault(_assign2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _victoryCore = __webpack_require__(3);
	
	var _helperMethods = __webpack_require__(591);
	
	var _helperMethods2 = _interopRequireDefault(_helperMethods);
	
	var _commonProps = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var fallbackProps = {
	  width: 450,
	  height: 300,
	  padding: 50
	};
	
	var animationWhitelist = ["style", "domain", "range", "tickCount", "tickValues", "padding", "width", "height"];
	
	var options = {
	  components: [{ name: "axis", index: 0 }, { name: "axisLabel", index: 0 }, { name: "grid" }, { name: "parent", index: "parent" }, { name: "ticks" }, { name: "tickLabels" }]
	};
	
	var VictoryPolarAxis = function (_React$Component) {
	  _inherits(VictoryPolarAxis, _React$Component);
	
	  function VictoryPolarAxis() {
	    _classCallCheck(this, VictoryPolarAxis);
	
	    return _possibleConstructorReturn(this, (VictoryPolarAxis.__proto__ || Object.getPrototypeOf(VictoryPolarAxis)).apply(this, arguments));
	  }
	
	  _createClass(VictoryPolarAxis, [{
	    key: "renderAxisLine",
	    value: function renderAxisLine(props) {
	      var dependentAxis = props.dependentAxis;
	
	      var axisComponent = dependentAxis ? props.axisComponent : props.circularAxisComponent;
	      var axisProps = this.getComponentProps(axisComponent, "axis", 0);
	      return _react2.default.cloneElement(axisComponent, axisProps);
	    }
	  }, {
	    key: "renderLabel",
	    value: function renderLabel(props) {
	      var axisLabelComponent = props.axisLabelComponent,
	          dependentAxis = props.dependentAxis,
	          label = props.label;
	
	      if (!label || !dependentAxis) {
	        return null;
	      }
	      var axisLabelProps = this.getComponentProps(axisLabelComponent, "axisLabel", 0);
	      return _react2.default.cloneElement(axisLabelComponent, axisLabelProps);
	    }
	  }, {
	    key: "renderAxis",
	    value: function renderAxis(props) {
	      var _this2 = this;
	
	      var tickComponent = props.tickComponent,
	          tickLabelComponent = props.tickLabelComponent;
	
	      var axisType = props.dependentAxis ? "radial" : "angular";
	      var gridComponent = axisType === "radial" ? props.circularGridComponent : props.gridComponent;
	      var tickComponents = this.dataKeys.map(function (key, index) {
	        var tickProps = (0, _assign3.default)({ key: "tick-" + key }, _this2.getComponentProps(tickComponent, "ticks", index));
	        return _react2.default.cloneElement(tickComponent, tickProps);
	      });
	
	      var gridComponents = this.dataKeys.map(function (key, index) {
	        var gridProps = (0, _assign3.default)({ key: "grid-" + key }, _this2.getComponentProps(gridComponent, "grid", index));
	        return _react2.default.cloneElement(gridComponent, gridProps);
	      });
	
	      var tickLabelComponents = this.dataKeys.map(function (key, index) {
	        var tickLabelProps = (0, _assign3.default)({ key: "tick-" + key }, _this2.getComponentProps(tickLabelComponent, "tickLabels", index));
	        return _react2.default.cloneElement(tickLabelComponent, tickLabelProps);
	      });
	      var axis = this.renderAxisLine(props);
	      var axisLabel = this.renderLabel(props);
	      var children = [axis, axisLabel].concat(_toConsumableArray(tickComponents), _toConsumableArray(gridComponents), _toConsumableArray(tickLabelComponents));
	      return this.renderGroup(props, children);
	    }
	
	    // Overridden in victory-native
	
	  }, {
	    key: "renderGroup",
	    value: function renderGroup(props, children) {
	      var groupComponent = props.groupComponent;
	
	      var groupComponentProps = groupComponent.props || {};
	      var origin = _victoryCore.Helpers.getPolarOrigin(props);
	      var transform = groupComponentProps.transform || "translate(" + origin.x + ", " + origin.y + ")";
	      return _react2.default.cloneElement(groupComponent, { transform: transform }, children);
	    }
	  }, {
	    key: "shouldAnimate",
	    value: function shouldAnimate() {
	      return !!this.props.animate;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var props = _victoryCore.Helpers.modifyProps(this.props, fallbackProps, "axis");
	      if (this.shouldAnimate()) {
	        return this.animateComponent(props, animationWhitelist);
	      }
	      var children = this.renderAxis(props);
	      return props.standalone ? this.renderContainer(props.containerComponent, children) : children;
	    }
	  }]);
	
	  return VictoryPolarAxis;
	}(_react2.default.Component);
	
	VictoryPolarAxis.displayName = "VictoryAxis";
	VictoryPolarAxis.role = "axis";
	VictoryPolarAxis.defaultTransitions = {
	  onExit: {
	    duration: 500
	  },
	  onEnter: {
	    duration: 500
	  }
	};
	VictoryPolarAxis.propTypes = _extends({}, _commonProps.BaseProps, {
	  axisAngle: _propTypes2.default.number,
	  axisComponent: _propTypes2.default.element,
	  axisLabelComponent: _propTypes2.default.element,
	  axisValue: _propTypes2.default.number,
	  categories: _propTypes2.default.arrayOf(_propTypes2.default.string),
	  circularAxisComponent: _propTypes2.default.element,
	  circularGridComponent: _propTypes2.default.element,
	  containerComponent: _propTypes2.default.element,
	  dependentAxis: _propTypes2.default.bool,
	  endAngle: _propTypes2.default.number,
	  events: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    target: _propTypes2.default.oneOf(["axis", "axisLabel", "grid", "ticks", "tickLabels"]),
	    eventKey: _propTypes2.default.oneOfType([_propTypes2.default.array, _victoryCore.PropTypes.allOfType([_victoryCore.PropTypes.integer, _victoryCore.PropTypes.nonNegative]), _propTypes2.default.string]),
	    eventHandlers: _propTypes2.default.object
	  })),
	  gridComponent: _propTypes2.default.element,
	  innerRadius: _victoryCore.PropTypes.nonNegative,
	  labelPlacement: _propTypes2.default.oneOf(["parallel", "perpendicular", "vertical"]),
	  startAngle: _propTypes2.default.number,
	  stringMap: _propTypes2.default.object,
	  style: _propTypes2.default.shape({
	    parent: _propTypes2.default.object, axis: _propTypes2.default.object, axisLabel: _propTypes2.default.object,
	    grid: _propTypes2.default.object, ticks: _propTypes2.default.object, tickLabels: _propTypes2.default.object
	  }),
	  tickComponent: _propTypes2.default.element,
	  tickCount: _victoryCore.PropTypes.allOfType([_victoryCore.PropTypes.integer, _victoryCore.PropTypes.greaterThanZero]),
	  tickFormat: _propTypes2.default.oneOfType([_propTypes2.default.func, _victoryCore.PropTypes.homogeneousArray]),
	  tickLabelComponent: _propTypes2.default.element,
	  tickValues: _victoryCore.PropTypes.homogeneousArray
	});
	VictoryPolarAxis.defaultProps = {
	  axisComponent: _react2.default.createElement(_victoryCore.Line, { type: "axis" }),
	  axisLabelComponent: _react2.default.createElement(_victoryCore.VictoryLabel, null),
	  circularAxisComponent: _react2.default.createElement(_victoryCore.Arc, { type: "axis" }),
	  circularGridComponent: _react2.default.createElement(_victoryCore.Arc, { type: "grid" }),
	  containerComponent: _react2.default.createElement(_victoryCore.VictoryContainer, null),
	  endAngle: 360,
	  gridComponent: _react2.default.createElement(_victoryCore.Line, { type: "grid" }),
	  groupComponent: _react2.default.createElement("g", { role: "presentation" }),
	  labelPlacement: "parallel",
	  scale: "linear",
	  startAngle: 0,
	  standalone: true,
	  theme: _victoryCore.VictoryTheme.grayscale,
	  tickComponent: _react2.default.createElement(_victoryCore.Line, { type: "tick" }),
	  tickLabelComponent: _react2.default.createElement(_victoryCore.VictoryLabel, null)
	};
	VictoryPolarAxis.getDomain = _helperMethods2.default.getDomain.bind(_helperMethods2.default);
	VictoryPolarAxis.getAxis = _helperMethods2.default.getAxis.bind(_helperMethods2.default);
	VictoryPolarAxis.getScale = _helperMethods2.default.getScale.bind(_helperMethods2.default);
	VictoryPolarAxis.getStyles = (0, _partialRight3.default)(_helperMethods2.default.getStyles.bind(_helperMethods2.default), fallbackProps.style);
	VictoryPolarAxis.getBaseProps = (0, _partialRight3.default)(_helperMethods2.default.getBaseProps.bind(_helperMethods2.default), fallbackProps);
	VictoryPolarAxis.expectedComponents = ["axisComponent", "circularAxisComponent", "groupComponent", "containerComponent", "tickComponent", "tickLabelComponent", "gridComponent", "circularGridComponent"];
	exports.default = (0, _victoryCore.addEvents)(VictoryPolarAxis, options);

/***/ },
/* 258 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _d3Ease = __webpack_require__(337);
	
	var d3Ease = _interopRequireWildcard(_d3Ease);
	
	var _util = __webpack_require__(598);
	
	var _timer = __webpack_require__(62);
	
	var _timer2 = _interopRequireDefault(_timer);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*global setTimeout:false */
	
	
	var VictoryAnimation = function (_React$Component) {
	  _inherits(VictoryAnimation, _React$Component);
	
	  function VictoryAnimation(props) {
	    _classCallCheck(this, VictoryAnimation);
	
	    /* defaults */
	    var _this = _possibleConstructorReturn(this, (VictoryAnimation.__proto__ || Object.getPrototypeOf(VictoryAnimation)).call(this, props));
	
	    _this.state = {
	      data: Array.isArray(_this.props.data) ? _this.props.data[0] : _this.props.data,
	      animationInfo: {
	        progress: 0,
	        animating: false
	      }
	    };
	    _this.interpolator = null;
	    _this.queue = Array.isArray(_this.props.data) ? _this.props.data.slice(1) : [];
	    /* build easing function */
	    _this.ease = d3Ease[_this.toNewName(_this.props.easing)];
	    /*
	      There is no autobinding of this in ES6 classes
	      so we bind functionToBeRunEachFrame to current instance of victory animation class
	    */
	    _this.functionToBeRunEachFrame = _this.functionToBeRunEachFrame.bind(_this);
	    _this.getTimer = _this.getTimer.bind(_this);
	    return _this;
	  }
	
	  _createClass(VictoryAnimation, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      // Length check prevents us from triggering `onEnd` in `traverseQueue`.
	      if (this.queue.length) {
	        this.traverseQueue();
	      }
	    }
	
	    /* lifecycle */
	
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      /* cancel existing loop if it exists */
	      this.getTimer().unsubscribe(this.loopID);
	
	      /* If an object was supplied */
	      if (!Array.isArray(nextProps.data)) {
	        // Replace the tween queue. Could set `this.queue = [nextProps.data]`,
	        // but let's reuse the same array.
	        this.queue.length = 0;
	        this.queue.push(nextProps.data);
	        /* If an array was supplied */
	      } else {
	        var _queue;
	
	        /* Extend the tween queue */
	        (_queue = this.queue).push.apply(_queue, _toConsumableArray(nextProps.data));
	      }
	      /* Start traversing the tween queue */
	      this.traverseQueue();
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      if (this.loopID) {
	        this.getTimer().unsubscribe(this.loopID);
	      } else {
	        this.getTimer().stop();
	      }
	    }
	  }, {
	    key: "getTimer",
	    value: function getTimer() {
	      if (this.context.getTimer) {
	        return this.context.getTimer();
	      }
	      if (!this.timer) {
	        this.timer = new _timer2.default();
	      }
	      return this.timer;
	    }
	  }, {
	    key: "toNewName",
	    value: function toNewName(ease) {
	      // d3-ease changed the naming scheme for ease from "linear" -> "easeLinear" etc.
	      var capitalize = function (s) {
	        return s && s[0].toUpperCase() + s.slice(1);
	      };
	      return "ease" + capitalize(ease);
	    }
	
	    /* Traverse the tween queue */
	
	  }, {
	    key: "traverseQueue",
	    value: function traverseQueue() {
	      var _this2 = this;
	
	      if (this.queue.length) {
	        /* Get the next index */
	        var data = this.queue[0];
	        /* compare cached version to next props */
	        this.interpolator = (0, _util.victoryInterpolator)(this.state.data, data);
	        /* reset step to zero */
	        if (this.props.delay) {
	          setTimeout(function () {
	            _this2.loopID = _this2.getTimer().subscribe(_this2.functionToBeRunEachFrame, _this2.props.duration);
	          }, this.props.delay);
	        } else {
	          this.loopID = this.getTimer().subscribe(this.functionToBeRunEachFrame, this.props.duration);
	        }
	      } else if (this.props.onEnd) {
	        this.props.onEnd();
	      }
	    }
	    /* every frame we... */
	
	  }, {
	    key: "functionToBeRunEachFrame",
	    value: function functionToBeRunEachFrame(elapsed, duration) {
	      /*
	        step can generate imprecise values, sometimes greater than 1
	        if this happens set the state to 1 and return, cancelling the timer
	      */
	      duration = duration !== undefined ? duration : this.props.duration;
	      var step = duration ? elapsed / duration : 1;
	      if (step >= 1) {
	        this.setState({
	          data: this.interpolator(1),
	          animationInfo: {
	            progress: 1,
	            animating: false
	          }
	        });
	        if (this.loopID) {
	          this.getTimer().unsubscribe(this.loopID);
	        }
	        this.queue.shift();
	        this.traverseQueue();
	        return;
	      }
	      /*
	        if we're not at the end of the timer, set the state by passing
	        current step value that's transformed by the ease function to the
	        interpolator, which is cached for performance whenever props are received
	      */
	      this.setState({
	        data: this.interpolator(this.ease(step)),
	        animationInfo: {
	          progress: step,
	          animating: step < 1
	        }
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return this.props.children(this.state.data, this.state.animationInfo);
	    }
	  }]);
	
	  return VictoryAnimation;
	}(_react2.default.Component);
	
	VictoryAnimation.displayName = "VictoryAnimation";
	VictoryAnimation.propTypes = {
	  children: _propTypes2.default.func,
	  data: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.array]),
	  delay: _propTypes2.default.number,
	  duration: _propTypes2.default.number,
	  easing: _propTypes2.default.oneOf(["back", "backIn", "backOut", "backInOut", "bounce", "bounceIn", "bounceOut", "bounceInOut", "circle", "circleIn", "circleOut", "circleInOut", "linear", "linearIn", "linearOut", "linearInOut", "cubic", "cubicIn", "cubicOut", "cubicInOut", "elastic", "elasticIn", "elasticOut", "elasticInOut", "exp", "expIn", "expOut", "expInOut", "poly", "polyIn", "polyOut", "polyInOut", "quad", "quadIn", "quadOut", "quadInOut", "sin", "sinIn", "sinOut", "sinInOut"]),
	  onEnd: _propTypes2.default.func
	};
	VictoryAnimation.defaultProps = {
	  data: {},
	  delay: 0,
	  duration: 1000,
	  easing: "quadInOut"
	};
	VictoryAnimation.contextTypes = {
	  getTimer: _propTypes2.default.func
	};
	exports.default = VictoryAnimation;

/***/ },
/* 259 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isObject2 = __webpack_require__(10);
	
	var _isObject3 = _interopRequireDefault(_isObject2);
	
	var _uniqueId2 = __webpack_require__(138);
	
	var _uniqueId3 = _interopRequireDefault(_uniqueId2);
	
	var _defaults2 = __webpack_require__(5);
	
	var _defaults3 = _interopRequireDefault(_defaults2);
	
	var _omit2 = __webpack_require__(25);
	
	var _omit3 = _interopRequireDefault(_omit2);
	
	var _assign2 = __webpack_require__(4);
	
	var _assign3 = _interopRequireDefault(_assign2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _propTypes3 = __webpack_require__(26);
	
	var _propTypes4 = _interopRequireDefault(_propTypes3);
	
	var _portal = __webpack_require__(260);
	
	var _portal2 = _interopRequireDefault(_portal);
	
	var _timer = __webpack_require__(62);
	
	var _timer2 = _interopRequireDefault(_timer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var VictoryContainer = function (_React$Component) {
	  _inherits(VictoryContainer, _React$Component);
	
	  function VictoryContainer(props) {
	    _classCallCheck(this, VictoryContainer);
	
	    var _this = _possibleConstructorReturn(this, (VictoryContainer.__proto__ || Object.getPrototypeOf(VictoryContainer)).call(this, props));
	
	    _this.getTimer = _this.getTimer.bind(_this);
	    _this.containerId = !(0, _isObject3.default)(props) || typeof props.containerId === "undefined" ? (0, _uniqueId3.default)("victory-container-") : props.containerId;
	    return _this;
	  }
	
	  _createClass(VictoryContainer, [{
	    key: "getChildContext",
	    value: function getChildContext() {
	      return {
	        portalUpdate: this.portalUpdate,
	        portalRegister: this.portalRegister,
	        portalDeregister: this.portalDeregister,
	        getTimer: this.getTimer
	      };
	    }
	  }, {
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      var _this2 = this;
	
	      this.savePortalRef = function (portal) {
	        _this2.portalRef = portal;
	        return portal;
	      };
	      this.portalUpdate = function (key, el) {
	        return _this2.portalRef.portalUpdate(key, el);
	      };
	      this.portalRegister = function () {
	        return _this2.portalRef.portalRegister();
	      };
	      this.portalDeregister = function (key) {
	        return _this2.portalRef.portalDeregister(key);
	      };
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      if (!this.context.getTimer) {
	        this.getTimer().stop();
	      }
	    }
	  }, {
	    key: "getTimer",
	    value: function getTimer() {
	      if (this.context.getTimer) {
	        return this.context.getTimer();
	      }
	      if (!this.timer) {
	        this.timer = new _timer2.default();
	      }
	      return this.timer;
	    }
	  }, {
	    key: "getIdForElement",
	    value: function getIdForElement(elementName) {
	      return this.containerId + "-" + elementName;
	    }
	
	    // overridden in custom containers
	
	  }, {
	    key: "getChildren",
	    value: function getChildren(props) {
	      return props.children;
	    }
	  }, {
	    key: "renderContainer",
	    value: function renderContainer(props, svgProps, style) {
	      var title = props.title,
	          desc = props.desc,
	          portalComponent = props.portalComponent,
	          className = props.className,
	          width = props.width,
	          height = props.height,
	          portalZIndex = props.portalZIndex,
	          responsive = props.responsive;
	
	      var children = this.getChildren(props);
	      var dimensions = responsive ? { width: "100%", height: "100%" } : { width: width, height: height };
	      var divStyle = (0, _assign3.default)({ pointerEvents: "none", touchAction: "none", position: "relative" }, dimensions);
	      var portalDivStyle = (0, _assign3.default)({ zIndex: portalZIndex, position: "absolute", top: 0, left: 0 }, dimensions);
	      var svgStyle = (0, _assign3.default)({ pointerEvents: "all" }, dimensions);
	      var portalSvgStyle = (0, _assign3.default)({ overflow: "visible" }, dimensions);
	      var portalProps = {
	        width: width, height: height, viewBox: svgProps.viewBox, style: portalSvgStyle
	      };
	      return _react2.default.createElement(
	        "div",
	        { style: (0, _defaults3.default)({}, style, divStyle), className: className, ref: props.containerRef },
	        _react2.default.createElement(
	          "svg",
	          _extends({}, svgProps, { style: svgStyle }),
	          title ? _react2.default.createElement(
	            "title",
	            { id: this.getIdForElement("title") },
	            title
	          ) : null,
	          desc ? _react2.default.createElement(
	            "desc",
	            { id: this.getIdForElement("desc") },
	            desc
	          ) : null,
	          children
	        ),
	        _react2.default.createElement(
	          "div",
	          { style: portalDivStyle },
	          _react2.default.cloneElement(portalComponent, _extends({}, portalProps, { ref: this.savePortalRef }))
	        )
	      );
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          width = _props.width,
	          height = _props.height,
	          responsive = _props.responsive,
	          events = _props.events;
	
	      var style = responsive ? this.props.style : (0, _omit3.default)(this.props.style, ["height", "width"]);
	      var svgProps = (0, _assign3.default)({
	        width: width, height: height, role: "img",
	        "aria-labelledby": this.getIdForElement("title") + " " + this.getIdForElement("desc"),
	        viewBox: responsive ? "0 0 " + width + " " + height : undefined
	      }, events);
	      return this.renderContainer(this.props, svgProps, style);
	    }
	  }]);
	
	  return VictoryContainer;
	}(_react2.default.Component);
	
	VictoryContainer.displayName = "VictoryContainer";
	VictoryContainer.role = "container";
	VictoryContainer.propTypes = {
	  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	  className: _propTypes2.default.string,
	  containerId: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  containerRef: _propTypes2.default.func,
	  desc: _propTypes2.default.string,
	  events: _propTypes2.default.object,
	  height: _propTypes4.default.nonNegative,
	  origin: _propTypes2.default.shape({ x: _propTypes4.default.nonNegative, y: _propTypes4.default.nonNegative }),
	  polar: _propTypes2.default.bool,
	  portalComponent: _propTypes2.default.element,
	  portalZIndex: _propTypes4.default.integer,
	  responsive: _propTypes2.default.bool,
	  style: _propTypes2.default.object,
	  theme: _propTypes2.default.object,
	  title: _propTypes2.default.string,
	  width: _propTypes4.default.nonNegative
	};
	VictoryContainer.defaultProps = {
	  className: "VictoryContainer",
	  portalComponent: _react2.default.createElement(_portal2.default, null),
	  portalZIndex: 99,
	  responsive: true
	};
	VictoryContainer.contextTypes = {
	  getTimer: _propTypes2.default.func
	};
	VictoryContainer.childContextTypes = {
	  portalUpdate: _propTypes2.default.func,
	  portalRegister: _propTypes2.default.func,
	  portalDeregister: _propTypes2.default.func,
	  getTimer: _propTypes2.default.func
	};
	exports.default = VictoryContainer;

/***/ },
/* 260 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _propTypes3 = __webpack_require__(26);
	
	var _propTypes4 = _interopRequireDefault(_propTypes3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Portal = function (_React$Component) {
	  _inherits(Portal, _React$Component);
	
	  function Portal(props) {
	    _classCallCheck(this, Portal);
	
	    var _this = _possibleConstructorReturn(this, (Portal.__proto__ || Object.getPrototypeOf(Portal)).call(this, props));
	
	    _this.map = {};
	    _this.index = 1;
	    _this.portalUpdate = _this.portalUpdate.bind(_this);
	    _this.portalRegister = _this.portalRegister.bind(_this);
	    _this.portalDeregister = _this.portalDeregister.bind(_this);
	    return _this;
	  }
	
	  _createClass(Portal, [{
	    key: "portalRegister",
	    value: function portalRegister() {
	      return ++this.index;
	    }
	  }, {
	    key: "portalUpdate",
	    value: function portalUpdate(key, element) {
	      this.map[key] = element;
	      this.forceUpdate();
	    }
	  }, {
	    key: "portalDeregister",
	    value: function portalDeregister(key) {
	      delete this.map[key];
	    }
	  }, {
	    key: "getChildren",
	    value: function getChildren() {
	      var _this2 = this;
	
	      return Object.keys(this.map).map(function (key) {
	        var el = _this2.map[key];
	        return el ? _react2.default.cloneElement(el, { key: key }) : el;
	      });
	    }
	
	    // Overridden in victory-core-native
	
	  }, {
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(
	        "svg",
	        this.props,
	        this.getChildren()
	      );
	    }
	  }]);
	
	  return Portal;
	}(_react2.default.Component);
	
	Portal.displayName = "Portal";
	Portal.propTypes = {
	  className: _propTypes2.default.string,
	  height: _propTypes4.default.nonNegative,
	  style: _propTypes2.default.object,
	  viewBox: _propTypes2.default.string,
	  width: _propTypes4.default.nonNegative
	};
	exports.default = Portal;

/***/ },
/* 261 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign2 = __webpack_require__(4);
	
	var _assign3 = _interopRequireDefault(_assign2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _helpers = __webpack_require__(6);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	var _collection = __webpack_require__(8);
	
	var _collection2 = _interopRequireDefault(_collection);
	
	var _commonProps = __webpack_require__(19);
	
	var _commonProps2 = _interopRequireDefault(_commonProps);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Line = function (_React$Component) {
	  _inherits(Line, _React$Component);
	
	  function Line() {
	    _classCallCheck(this, Line);
	
	    return _possibleConstructorReturn(this, (Line.__proto__ || Object.getPrototypeOf(Line)).apply(this, arguments));
	  }
	
	  _createClass(Line, [{
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      this.style = this.getStyle(this.props);
	    }
	  }, {
	    key: "shouldComponentUpdate",
	    value: function shouldComponentUpdate(nextProps) {
	      var _props = this.props,
	          className = _props.className,
	          x = _props.x,
	          y = _props.y;
	
	      var style = this.getStyle(nextProps);
	      if (!_collection2.default.allSetsEqual([[className, nextProps.className], [x, nextProps.x], [y, nextProps.y], [style, this.style]])) {
	        this.style = style;
	        return true;
	      }
	      return false;
	    }
	  }, {
	    key: "getStyle",
	    value: function getStyle(props) {
	      var style = props.style,
	          datum = props.datum,
	          active = props.active;
	
	      return _helpers2.default.evaluateStyle((0, _assign3.default)({ fill: "none" }, style), datum, active);
	    }
	
	    // Overridden in victory-core-native
	
	  }, {
	    key: "renderBorder",
	    value: function renderBorder(props, style, events) {
	      var _props2 = this.props,
	          role = _props2.role,
	          shapeRendering = _props2.shapeRendering,
	          className = _props2.className;
	
	      return _react2.default.createElement("rect", _extends({}, props, {
	        className: className,
	        style: style,
	        role: role || "presentation",
	        shapeRendering: shapeRendering || "auto",
	        vectorEffect: "non-scaling-stroke"
	      }, events));
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _props3 = this.props,
	          x = _props3.x,
	          y = _props3.y,
	          width = _props3.width,
	          height = _props3.height,
	          events = _props3.events;
	
	      return this.renderBorder({ x: x, y: y, width: width, height: height }, this.style, events);
	    }
	  }]);
	
	  return Line;
	}(_react2.default.Component);
	
	Line.propTypes = _extends({}, _commonProps2.default, {
	  height: _propTypes2.default.number,
	  width: _propTypes2.default.number,
	  x: _propTypes2.default.number,
	  y: _propTypes2.default.number
	});
	exports.default = Line;

/***/ },
/* 262 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _propTypes3 = __webpack_require__(26);
	
	var _propTypes4 = _interopRequireDefault(_propTypes3);
	
	var _helpers = __webpack_require__(6);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	var _collection = __webpack_require__(8);
	
	var _collection2 = _interopRequireDefault(_collection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ClipPath = function (_React$Component) {
	  _inherits(ClipPath, _React$Component);
	
	  function ClipPath() {
	    _classCallCheck(this, ClipPath);
	
	    return _possibleConstructorReturn(this, (ClipPath.__proto__ || Object.getPrototypeOf(ClipPath)).apply(this, arguments));
	  }
	
	  _createClass(ClipPath, [{
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      Object.assign(this, this.calculateAttributes(this.props));
	    }
	  }, {
	    key: "shouldComponentUpdate",
	    value: function shouldComponentUpdate(nextProps) {
	      var calculatedAttributes = this.calculateAttributes(nextProps);
	      var _props = this.props,
	          className = _props.className,
	          clipId = _props.clipId,
	          clipWidth = _props.clipWidth,
	          translateX = _props.translateX,
	          translateY = _props.translateY;
	
	      if (!_collection2.default.allSetsEqual([[className, nextProps.className], [clipId, nextProps.clipId], [clipWidth, nextProps.clipWidth], [translateX, nextProps.translateX], [translateY, nextProps.translateY], [this.x, calculatedAttributes.x], [this.y, calculatedAttributes.y], [this.height, calculatedAttributes.height], [this.width, calculatedAttributes.width]])) {
	        Object.assign(this, calculatedAttributes);
	        return true;
	      }
	      return false;
	    }
	  }, {
	    key: "calculateAttributes",
	    value: function calculateAttributes(props) {
	      var polar = props.polar,
	          origin = props.origin,
	          _props$clipWidth = props.clipWidth,
	          clipWidth = _props$clipWidth === undefined ? 0 : _props$clipWidth,
	          _props$clipHeight = props.clipHeight,
	          clipHeight = _props$clipHeight === undefined ? 0 : _props$clipHeight,
	          _props$translateX = props.translateX,
	          translateX = _props$translateX === undefined ? 0 : _props$translateX,
	          _props$translateY = props.translateY,
	          translateY = _props$translateY === undefined ? 0 : _props$translateY;
	
	      var clipPadding = _helpers2.default.getPadding({ padding: props.clipPadding });
	      var radius = props.radius || _helpers2.default.getRadius(props);
	      return {
	        x: (polar ? origin.x : translateX) - clipPadding.left,
	        y: (polar ? origin.y : translateY) - clipPadding.top,
	        width: Math.max((polar ? radius : clipWidth) + clipPadding.left + clipPadding.right, 0),
	        height: Math.max((polar ? radius : clipHeight) + clipPadding.top + clipPadding.bottom, 0)
	      };
	    }
	
	    // Overridden in victory-core-native
	
	  }, {
	    key: "renderClipPath",
	    value: function renderClipPath(props, id) {
	      return _react2.default.createElement(
	        "defs",
	        null,
	        _react2.default.createElement(
	          "clipPath",
	          { id: id },
	          _react2.default.createElement("rect", props)
	        )
	      );
	    }
	  }, {
	    key: "renderPolarClipPath",
	    value: function renderPolarClipPath(props, id) {
	      return _react2.default.createElement(
	        "defs",
	        null,
	        _react2.default.createElement(
	          "clipPath",
	          { id: id },
	          _react2.default.createElement("circle", props)
	        )
	      );
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _props2 = this.props,
	          clipId = _props2.clipId,
	          className = _props2.className,
	          polar = _props2.polar;
	
	      var clipProps = polar ? { className: className, cx: this.x, cy: this.y, r: Math.max(this.width, this.height) } : { className: className, x: this.x, y: this.y, width: this.width, height: this.height };
	      return polar ? this.renderPolarClipPath(clipProps, clipId) : this.renderClipPath(clipProps, clipId);
	    }
	  }]);
	
	  return ClipPath;
	}(_react2.default.Component);
	
	ClipPath.propTypes = {
	  className: _propTypes2.default.string,
	  clipHeight: _propTypes4.default.nonNegative,
	  clipId: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  clipPadding: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.shape({
	    top: _propTypes2.default.number,
	    bottom: _propTypes2.default.number,
	    left: _propTypes2.default.number,
	    right: _propTypes2.default.number
	  })]),
	  clipWidth: _propTypes4.default.nonNegative,
	  origin: _propTypes2.default.shape({ x: _propTypes2.default.number, y: _propTypes2.default.number }),
	  polar: _propTypes2.default.bool,
	  radius: _propTypes2.default.number,
	  translateX: _propTypes2.default.number,
	  translateY: _propTypes2.default.number
	};
	exports.default = ClipPath;

/***/ },
/* 263 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _helpers = __webpack_require__(6);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	var _collection = __webpack_require__(8);
	
	var _collection2 = _interopRequireDefault(_collection);
	
	var _commonProps = __webpack_require__(19);
	
	var _commonProps2 = _interopRequireDefault(_commonProps);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*eslint no-magic-numbers: ["error", { "ignore": [-1, 0, 1, 2] }]*/
	
	
	var Flyout = function (_React$Component) {
	  _inherits(Flyout, _React$Component);
	
	  function Flyout() {
	    _classCallCheck(this, Flyout);
	
	    return _possibleConstructorReturn(this, (Flyout.__proto__ || Object.getPrototypeOf(Flyout)).apply(this, arguments));
	  }
	
	  _createClass(Flyout, [{
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      var _calculateAttributes = this.calculateAttributes(this.props),
	          style = _calculateAttributes.style,
	          path = _calculateAttributes.path;
	
	      this.style = style;
	      this.path = path;
	    }
	  }, {
	    key: "shouldComponentUpdate",
	    value: function shouldComponentUpdate(nextProps) {
	      var _calculateAttributes2 = this.calculateAttributes(nextProps),
	          style = _calculateAttributes2.style,
	          path = _calculateAttributes2.path;
	
	      var _props = this.props,
	          className = _props.className,
	          cornerRadius = _props.cornerRadius,
	          datum = _props.datum,
	          dx = _props.dx,
	          dy = _props.dy,
	          height = _props.height,
	          width = _props.width,
	          orientation = _props.orientation,
	          pointerLength = _props.pointerLength,
	          pointerWidth = _props.pointerWidth,
	          x = _props.x,
	          y = _props.y;
	
	      if (!_collection2.default.allSetsEqual([[className, nextProps.className], [cornerRadius, nextProps.cornerRadius], [dx, nextProps.dx], [dy, nextProps.dy], [x, nextProps.x], [y, nextProps.y], [height, nextProps.height], [width, nextProps.width], [orientation, nextProps.orientation], [pointerLength, nextProps.pointerLength], [pointerWidth, nextProps.pointerWidth], [path, this.path], [style, this.style], [datum, nextProps.datum]])) {
	        this.style = style;
	        this.path = path;
	        return true;
	      }
	      return false;
	    }
	  }, {
	    key: "calculateAttributes",
	    value: function calculateAttributes(props) {
	      var datum = props.datum,
	          active = props.active,
	          style = props.style;
	
	      return {
	        style: _helpers2.default.evaluateStyle(style, datum, active),
	        path: this.getFlyoutPath(props)
	      };
	    }
	  }, {
	    key: "getVerticalPath",
	    value: function getVerticalPath(props) {
	      var pointerLength = props.pointerLength,
	          pointerWidth = props.pointerWidth,
	          cornerRadius = props.cornerRadius,
	          orientation = props.orientation,
	          width = props.width,
	          height = props.height;
	
	      var sign = orientation === "top" ? 1 : -1;
	      var x = props.x + (props.dx || 0);
	      var y = props.y - sign * (props.dy || 0);
	      var pointerEdge = y - sign * pointerLength;
	      var oppositeEdge = y - sign * pointerLength - sign * height;
	      var rightEdge = x + width / 2;
	      var leftEdge = x - width / 2;
	      var direction = orientation === "top" ? "0 0 0" : "0 0 1";
	      var arc = cornerRadius + " " + cornerRadius + " " + direction;
	      return "M " + (x - pointerWidth / 2) + ", " + pointerEdge + "\n      L " + x + ", " + y + "\n      L " + (x + pointerWidth / 2) + ", " + pointerEdge + "\n      L " + (rightEdge - cornerRadius) + ", " + pointerEdge + "\n      A " + arc + " " + rightEdge + ", " + (pointerEdge - sign * cornerRadius) + "\n      L " + rightEdge + ", " + (oppositeEdge + sign * cornerRadius) + "\n      A " + arc + " " + (rightEdge - cornerRadius) + ", " + oppositeEdge + "\n      L " + (leftEdge + cornerRadius) + ", " + oppositeEdge + "\n      A " + arc + " " + leftEdge + ", " + (oppositeEdge + sign * cornerRadius) + "\n      L " + leftEdge + ", " + (pointerEdge - sign * cornerRadius) + "\n      A " + arc + " " + (leftEdge + cornerRadius) + ", " + pointerEdge + "\n      z";
	    }
	  }, {
	    key: "getHorizontalPath",
	    value: function getHorizontalPath(props) {
	      var pointerLength = props.pointerLength,
	          pointerWidth = props.pointerWidth,
	          cornerRadius = props.cornerRadius,
	          orientation = props.orientation,
	          width = props.width,
	          height = props.height;
	
	      var sign = orientation === "right" ? 1 : -1;
	      var x = props.x + sign * (props.dx || 0);
	      var y = props.y - (props.dy || 0);
	      var pointerEdge = x + sign * pointerLength;
	      var oppositeEdge = x + sign * pointerLength + sign * width;
	      var bottomEdge = y + height / 2;
	      var topEdge = y - height / 2;
	      var direction = orientation === "right" ? "0 0 0" : "0 0 1";
	      var arc = cornerRadius + " " + cornerRadius + " " + direction;
	      return "M " + pointerEdge + ", " + (y - pointerWidth / 2) + "\n      L " + x + ", " + y + "\n      L " + pointerEdge + ", " + (y + pointerWidth / 2) + "\n      L " + pointerEdge + ", " + (bottomEdge - cornerRadius) + "\n      A " + arc + " " + (pointerEdge + sign * cornerRadius) + ", " + bottomEdge + "\n      L " + (oppositeEdge - sign * cornerRadius) + ", " + bottomEdge + "\n      A " + arc + " " + oppositeEdge + ", " + (bottomEdge - cornerRadius) + "\n      L " + oppositeEdge + ", " + (topEdge + cornerRadius) + "\n      A " + arc + " " + (oppositeEdge - sign * cornerRadius) + ", " + topEdge + "\n      L " + (pointerEdge + sign * cornerRadius) + ", " + topEdge + "\n      A " + arc + " " + pointerEdge + ", " + (topEdge + cornerRadius) + "\n      z";
	    }
	  }, {
	    key: "getFlyoutPath",
	    value: function getFlyoutPath(props) {
	      var orientation = props.orientation || "top";
	      return orientation === "left" || orientation === "right" ? this.getHorizontalPath(props) : this.getVerticalPath(props);
	    }
	
	    // Overridden in victory-core-native
	
	  }, {
	    key: "renderFlyout",
	    value: function renderFlyout(path, style, events) {
	      var _props2 = this.props,
	          role = _props2.role,
	          shapeRendering = _props2.shapeRendering,
	          className = _props2.className;
	
	      return _react2.default.createElement("path", _extends({
	        className: className,
	        d: path,
	        style: style,
	        shapeRendering: shapeRendering || "auto",
	        role: role || "presentation"
	      }, events));
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return this.renderFlyout(this.path, this.style, this.props.events);
	    }
	  }]);
	
	  return Flyout;
	}(_react2.default.Component);
	
	Flyout.propTypes = _extends({}, _commonProps2.default, {
	  cornerRadius: _propTypes2.default.number,
	  datum: _propTypes2.default.object,
	  dx: _propTypes2.default.number,
	  dy: _propTypes2.default.number,
	  height: _propTypes2.default.number,
	  orientation: _propTypes2.default.oneOf(["top", "bottom", "left", "right"]),
	  pointerLength: _propTypes2.default.number,
	  pointerWidth: _propTypes2.default.number,
	  width: _propTypes2.default.number,
	  x: _propTypes2.default.number,
	  y: _propTypes2.default.number
	});
	exports.default = Flyout;

/***/ },
/* 264 */
/***/ function(module, exports) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var defined = function (d) {
	  var y = d._y1 !== undefined ? d._y1 : d._y;
	  return y !== null && y !== undefined && d._y0 !== null;
	};
	
	var getXAccessor = function (scale) {
	  return function (d) {
	    return scale.x(d._x1 !== undefined ? d._x1 : d._x);
	  };
	};
	
	var getYAccessor = function (scale) {
	  return function (d) {
	    return scale.y(d._y1 !== undefined ? d._y1 : d._y);
	  };
	};
	
	var getY0Accessor = function (scale) {
	  return function (d) {
	    return scale.y(d._y0);
	  };
	};
	
	var getAngleAccessor = function (scale) {
	  return function (d) {
	    var x = scale.x(d._x1 !== undefined ? d._x1 : d._x);
	    return -1 * x + Math.PI / 2;
	  };
	};
	
	exports.defined = defined;
	exports.getXAccessor = getXAccessor;
	exports.getYAccessor = getYAccessor;
	exports.getY0Accessor = getY0Accessor;
	exports.getAngleAccessor = getAngleAccessor;

/***/ },
/* 265 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _helpers = __webpack_require__(6);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	var _collection = __webpack_require__(8);
	
	var _collection2 = _interopRequireDefault(_collection);
	
	var _pathHelpers = __webpack_require__(609);
	
	var _pathHelpers2 = _interopRequireDefault(_pathHelpers);
	
	var _commonProps = __webpack_require__(19);
	
	var _commonProps2 = _interopRequireDefault(_commonProps);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Point = function (_React$Component) {
	  _inherits(Point, _React$Component);
	
	  function Point() {
	    _classCallCheck(this, Point);
	
	    return _possibleConstructorReturn(this, (Point.__proto__ || Object.getPrototypeOf(Point)).apply(this, arguments));
	  }
	
	  _createClass(Point, [{
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      var _calculateAttributes = this.calculateAttributes(this.props),
	          style = _calculateAttributes.style,
	          path = _calculateAttributes.path;
	
	      this.style = style;
	      this.path = path;
	    }
	  }, {
	    key: "shouldComponentUpdate",
	    value: function shouldComponentUpdate(nextProps) {
	      var _calculateAttributes2 = this.calculateAttributes(nextProps),
	          style = _calculateAttributes2.style,
	          path = _calculateAttributes2.path;
	
	      var _props = this.props,
	          className = _props.className,
	          datum = _props.datum,
	          x = _props.x,
	          y = _props.y,
	          size = _props.size,
	          symbol = _props.symbol;
	
	      if (!_collection2.default.allSetsEqual([[className, nextProps.className], [x, nextProps.x], [y, nextProps.y], [size, nextProps.size], [symbol, nextProps.symbol], [path, this.path], [style, this.style], [datum, nextProps.datum]])) {
	        this.style = style;
	        this.path = path;
	        return true;
	      }
	      return false;
	    }
	  }, {
	    key: "calculateAttributes",
	    value: function calculateAttributes(props) {
	      var style = props.style,
	          datum = props.datum,
	          active = props.active;
	
	      return {
	        style: _helpers2.default.evaluateStyle(style, datum, active),
	        path: this.getPath(props)
	      };
	    }
	  }, {
	    key: "getPath",
	    value: function getPath(props) {
	      var datum = props.datum,
	          active = props.active,
	          x = props.x,
	          y = props.y;
	
	      var size = _helpers2.default.evaluateProp(props.size, datum, active);
	      if (props.getPath) {
	        return props.getPath(x, y, size);
	      }
	      var pathFunctions = {
	        circle: _pathHelpers2.default.circle,
	        square: _pathHelpers2.default.square,
	        diamond: _pathHelpers2.default.diamond,
	        triangleDown: _pathHelpers2.default.triangleDown,
	        triangleUp: _pathHelpers2.default.triangleUp,
	        plus: _pathHelpers2.default.plus,
	        star: _pathHelpers2.default.star
	      };
	      var symbol = _helpers2.default.evaluateProp(props.symbol, datum, active);
	      var symbolFunction = typeof pathFunctions[symbol] === "function" ? pathFunctions[symbol] : pathFunctions.circle;
	      return symbolFunction(x, y, size);
	    }
	
	    // Overridden in victory-core-native
	
	  }, {
	    key: "renderPoint",
	    value: function renderPoint(path, style, events) {
	      var _props2 = this.props,
	          role = _props2.role,
	          shapeRendering = _props2.shapeRendering,
	          className = _props2.className;
	
	      return _react2.default.createElement("path", _extends({}, events, {
	        d: path,
	        className: className,
	        role: role || "presentation",
	        shapeRendering: shapeRendering || "auto",
	        style: style
	      }));
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return this.renderPoint(this.path, this.style, this.props.events);
	    }
	  }]);
	
	  return Point;
	}(_react2.default.Component);
	
	Point.propTypes = _extends({}, _commonProps2.default, {
	  datum: _propTypes2.default.object,
	  getPath: _propTypes2.default.func,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.func]),
	  symbol: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(["circle", "diamond", "plus", "square", "star", "triangleDown", "triangleUp"]), _propTypes2.default.func]),
	  x: _propTypes2.default.number,
	  y: _propTypes2.default.number
	});
	exports.default = Point;

/***/ },
/* 266 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isObject2 = __webpack_require__(10);
	
	var _isObject3 = _interopRequireDefault(_isObject2);
	
	var _pick2 = __webpack_require__(224);
	
	var _pick3 = _interopRequireDefault(_pick2);
	
	var _isFunction2 = __webpack_require__(7);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _defaults2 = __webpack_require__(5);
	
	var _defaults3 = _interopRequireDefault(_defaults2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _victoryAnimation = __webpack_require__(258);
	
	var _victoryAnimation2 = _interopRequireDefault(_victoryAnimation);
	
	var _collection = __webpack_require__(8);
	
	var _collection2 = _interopRequireDefault(_collection);
	
	var _helpers = __webpack_require__(6);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	var _timer = __webpack_require__(62);
	
	var _timer2 = _interopRequireDefault(_timer);
	
	var _transitions = __webpack_require__(269);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var VictoryTransition = function (_React$Component) {
	  _inherits(VictoryTransition, _React$Component);
	
	  function VictoryTransition(props) {
	    _classCallCheck(this, VictoryTransition);
	
	    var _this = _possibleConstructorReturn(this, (VictoryTransition.__proto__ || Object.getPrototypeOf(VictoryTransition)).call(this, props));
	
	    _this.state = {
	      nodesShouldLoad: false,
	      nodesDoneLoad: false
	    };
	    var child = _this.props.children;
	    var polar = child.props.polar;
	    _this.continuous = !polar && child.type && child.type.continuous === true;
	    _this.getTransitionState = _this.getTransitionState.bind(_this);
	    _this.getTimer = _this.getTimer.bind(_this);
	    return _this;
	  }
	
	  _createClass(VictoryTransition, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.setState({ nodesShouldLoad: true }); //eslint-disable-line react/no-did-mount-set-state
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      this.getTimer().bypassAnimation();
	      this.setState(this.getTransitionState(this.props, nextProps), function () {
	        return _this2.getTimer().resumeAnimation();
	      });
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.getTimer().stop();
	    }
	  }, {
	    key: "getTimer",
	    value: function getTimer() {
	      if (this.context.getTimer) {
	        return this.context.getTimer();
	      }
	      if (!this.timer) {
	        this.timer = new _timer2.default();
	      }
	      return this.timer;
	    }
	  }, {
	    key: "getTransitionState",
	    value: function getTransitionState(props, nextProps) {
	      var animate = props.animate;
	
	      if (!animate) {
	        return {};
	      } else if (animate.parentState) {
	        var state = animate.parentState;
	        var oldProps = state.nodesWillExit ? props : null;
	        return { oldProps: oldProps, nextProps: nextProps };
	      } else {
	        var oldChildren = _react2.default.Children.toArray(props.children);
	        var nextChildren = _react2.default.Children.toArray(nextProps.children);
	
	        var _Transitions$getIniti = _transitions2.default.getInitialTransitionState(oldChildren, nextChildren),
	            nodesWillExit = _Transitions$getIniti.nodesWillExit,
	            nodesWillEnter = _Transitions$getIniti.nodesWillEnter,
	            childrenTransitions = _Transitions$getIniti.childrenTransitions,
	            nodesShouldEnter = _Transitions$getIniti.nodesShouldEnter;
	
	        return {
	          nodesWillExit: nodesWillExit,
	          nodesWillEnter: nodesWillEnter,
	          childrenTransitions: childrenTransitions,
	          nodesShouldEnter: nodesShouldEnter,
	          oldProps: nodesWillExit ? props : null,
	          nextProps: nextProps
	        };
	      }
	    }
	  }, {
	    key: "getDomainFromChildren",
	    value: function getDomainFromChildren(props, axis) {
	      var getChildDomains = function (children) {
	        return children.reduce(function (memo, child) {
	          if (child.type && (0, _isFunction3.default)(child.type.getDomain)) {
	            var childDomain = child.props && child.type.getDomain(child.props, axis);
	            return childDomain ? memo.concat(childDomain) : memo;
	          } else if (child.props && child.props.children) {
	            return memo.concat(getChildDomains(_react2.default.Children.toArray(child.props.children)));
	          }
	          return memo;
	        }, []);
	      };
	
	      var child = _react2.default.Children.toArray(props.children)[0];
	      var childProps = child.props || {};
	      var domain = Array.isArray(childProps.domain) ? childProps.domain : childProps.domain && childProps.domain[axis];
	      if (!childProps.children && domain) {
	        return domain;
	      } else {
	        var childDomains = getChildDomains([child]);
	        return childDomains.length === 0 ? [0, 1] : [_collection2.default.getMinValue(childDomains), _collection2.default.getMaxValue(childDomains)];
	      }
	    }
	  }, {
	    key: "pickProps",
	    value: function pickProps() {
	      if (!this.state) {
	        return this.props;
	      }
	      return this.state.nodesWillExit ? this.state.oldProps || this.props : this.props;
	    }
	  }, {
	    key: "pickDomainProps",
	    value: function pickDomainProps(props) {
	      var parentState = (0, _isObject3.default)(props.animate) && props.animate.parentState;
	      if (parentState && parentState.nodesWillExit) {
	        return this.continous || parentState.continuous ? parentState.nextProps || this.state.nextProps || props : props;
	      }
	      return this.continuous && this.state.nodesWillExit ? this.state.nextProps || props : props;
	    }
	  }, {
	    key: "getClipWidth",
	    value: function getClipWidth(props, child) {
	      var getDefaultClipWidth = function () {
	        var range = _helpers2.default.getRange(child.props, "x");
	        return range ? Math.abs(range[1] - range[0]) : props.width;
	      };
	      var clipWidth = this.transitionProps ? this.transitionProps.clipWidth : undefined;
	      return clipWidth !== undefined ? clipWidth : getDefaultClipWidth();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      var props = this.pickProps();
	      var getTransitionProps = (0, _isObject3.default)(this.props.animate) && this.props.animate.getTransitions ? this.props.animate.getTransitions : _transitions2.default.getTransitionPropsFactory(props, this.state, function (newState) {
	        return _this3.setState(newState);
	      });
	      var child = _react2.default.Children.toArray(props.children)[0];
	      var transitionProps = getTransitionProps(child);
	      this.transitionProps = transitionProps;
	      var domain = {
	        x: this.getDomainFromChildren(this.pickDomainProps(props), "x"),
	        y: this.getDomainFromChildren(props, "y")
	      };
	      var clipWidth = this.getClipWidth(props, child);
	      var combinedProps = (0, _defaults3.default)({ domain: domain, clipWidth: clipWidth }, transitionProps, child.props);
	      var animationWhitelist = props.animationWhitelist || [];
	      var whitelist = animationWhitelist.concat(["clipWidth"]);
	      var propsToAnimate = whitelist.length ? (0, _pick3.default)(combinedProps, whitelist) : combinedProps;
	      return _react2.default.createElement(
	        _victoryAnimation2.default,
	        _extends({}, combinedProps.animate, { data: propsToAnimate }),
	        function (newProps) {
	          if (child.props.groupComponent) {
	            var groupComponent = _this3.continuous ? _react2.default.cloneElement(child.props.groupComponent, { clipWidth: newProps.clipWidth || 0 }) : child.props.groupComponent;
	            return _react2.default.cloneElement(child, (0, _defaults3.default)({ animate: null, animating: true, groupComponent: groupComponent }, newProps, combinedProps));
	          }
	          return _react2.default.cloneElement(child, (0, _defaults3.default)({ animate: null, animating: true }, newProps, combinedProps));
	        }
	      );
	    }
	  }]);
	
	  return VictoryTransition;
	}(_react2.default.Component);
	
	VictoryTransition.displayName = "VictoryTransition";
	VictoryTransition.propTypes = {
	  animate: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.object]),
	  animationWhitelist: _propTypes2.default.array,
	  children: _propTypes2.default.node
	};
	exports.default = VictoryTransition;

/***/ },
/* 267 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isEmpty2 = __webpack_require__(131);
	
	var _isEmpty3 = _interopRequireDefault(_isEmpty2);
	
	var _without2 = __webpack_require__(97);
	
	var _without3 = _interopRequireDefault(_without2);
	
	var _pick2 = __webpack_require__(224);
	
	var _pick3 = _interopRequireDefault(_pick2);
	
	var _partialRight2 = __webpack_require__(16);
	
	var _partialRight3 = _interopRequireDefault(_partialRight2);
	
	var _isFunction2 = __webpack_require__(7);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _keys2 = __webpack_require__(12);
	
	var _keys3 = _interopRequireDefault(_keys2);
	
	var _assign2 = __webpack_require__(4);
	
	var _assign3 = _interopRequireDefault(_assign2);
	
	var _defaults2 = __webpack_require__(5);
	
	var _defaults3 = _interopRequireDefault(_defaults2);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _events = __webpack_require__(149);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _collection = __webpack_require__(8);
	
	var _collection2 = _interopRequireDefault(_collection);
	
	var _victoryTransition = __webpack_require__(266);
	
	var _victoryTransition2 = _interopRequireDefault(_victoryTransition);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//  used for checking state changes. Expected components can be passed in via options
	var defaultComponents = [{ name: "parent", index: "parent" }, { name: "data" }, { name: "labels" }];
	
	exports.default = function (WrappedComponent, options) {
	  return function (_WrappedComponent) {
	    _inherits(addEvents, _WrappedComponent);
	
	    function addEvents() {
	      _classCallCheck(this, addEvents);
	
	      return _possibleConstructorReturn(this, (addEvents.__proto__ || Object.getPrototypeOf(addEvents)).apply(this, arguments));
	    }
	
	    _createClass(addEvents, [{
	      key: "componentWillMount",
	      value: function componentWillMount() {
	        if ((0, _isFunction3.default)(_get(addEvents.prototype.__proto__ || Object.getPrototypeOf(addEvents.prototype), "componentWillMount", this))) {
	          _get(addEvents.prototype.__proto__ || Object.getPrototypeOf(addEvents.prototype), "componentWillMount", this).call(this);
	        }
	        var getScopedEvents = _events2.default.getScopedEvents.bind(this);
	        this.getEvents = (0, _partialRight3.default)(_events2.default.getEvents.bind(this), getScopedEvents);
	        this.getEventState = _events2.default.getEventState.bind(this);
	        var calculatedValues = this.getCalculatedValues(this.props);
	        this.cacheValues(calculatedValues);
	        this.stateChanges = this.getStateChanges(this.props, calculatedValues);
	      }
	    }, {
	      key: "shouldComponentUpdate",
	      value: function shouldComponentUpdate(nextProps) {
	        var calculatedValues = this.getCalculatedValues(nextProps);
	
	        // re-render without additional checks when component is animated
	        if (this.props.animate || this.props.animating) {
	          this.cacheValues(calculatedValues);
	          return true;
	        }
	
	        // check for any state changes triggered by events or shared events
	        var calculatedState = this.getStateChanges(nextProps, calculatedValues);
	        if (!_collection2.default.areVictoryPropsEqual(this.calculatedState, calculatedState)) {
	          this.cacheValues(calculatedValues);
	          this.calculatedState = calculatedState;
	          return true;
	        }
	
	        // check whether props have changed
	        if (!_collection2.default.areVictoryPropsEqual(this.props, nextProps)) {
	          this.cacheValues(calculatedValues);
	          return true;
	        }
	
	        return false;
	      }
	
	      // compile all state changes from own and parent state. Order doesn't matter, as any state
	      // state change should trigger a re-render
	
	    }, {
	      key: "getStateChanges",
	      value: function getStateChanges(props, calculatedValues) {
	        var _this2 = this;
	
	        var hasEvents = calculatedValues.hasEvents,
	            getSharedEventState = calculatedValues.getSharedEventState;
	
	        if (!hasEvents) {
	          return {};
	        }
	
	        var getState = function (key, type) {
	          var result = (0, _defaults3.default)({}, _this2.getEventState(key, type), getSharedEventState(key, type));
	          return (0, _isEmpty3.default)(result) ? undefined : result;
	        };
	
	        options = options || {};
	        var components = options.components || defaultComponents;
	        return components.map(function (component) {
	          if (!props.standalone && component.name === "parent") {
	            // don't check for changes on parent props for non-standalone components
	            return undefined;
	          } else {
	            return typeof component.index !== "undefined" ? getState(component.index, component.name) : calculatedValues.dataKeys.map(function (key) {
	              return getState(key, component.name);
	            });
	          }
	        }).filter(Boolean);
	      }
	    }, {
	      key: "getCalculatedValues",
	      value: function getCalculatedValues(props) {
	        var sharedEvents = props.sharedEvents;
	
	        var components = WrappedComponent.expectedComponents;
	        var componentEvents = _events2.default.getComponentEvents(props, components);
	        var getSharedEventState = sharedEvents && (0, _isFunction3.default)(sharedEvents.getEventState) ? sharedEvents.getEventState : function () {
	          return undefined;
	        };
	        var baseProps = this.getBaseProps(props, getSharedEventState);
	        var dataKeys = (0, _keys3.default)(baseProps).filter(function (key) {
	          return key !== "parent";
	        });
	        var hasEvents = props.events || props.sharedEvents || componentEvents;
	        var events = this.getAllEvents(props);
	        return {
	          componentEvents: componentEvents, getSharedEventState: getSharedEventState, baseProps: baseProps, dataKeys: dataKeys, hasEvents: hasEvents, events: events
	        };
	      }
	    }, {
	      key: "cacheValues",
	      value: function cacheValues(obj) {
	        var _this3 = this;
	
	        (0, _keys3.default)(obj).forEach(function (key) {
	          _this3[key] = obj[key];
	        });
	      }
	    }, {
	      key: "getBaseProps",
	      value: function getBaseProps(props, getSharedEventState) {
	        getSharedEventState = getSharedEventState || this.getSharedEventState;
	        var sharedParentState = getSharedEventState("parent", "parent");
	        var parentState = this.getEventState("parent", "parent");
	        var baseParentProps = (0, _defaults3.default)({}, parentState, sharedParentState);
	        var parentPropsList = baseParentProps.parentControlledProps;
	        var parentProps = parentPropsList ? (0, _pick3.default)(baseParentProps, parentPropsList) : {};
	        var modifiedProps = (0, _defaults3.default)({}, parentProps, props);
	        return (0, _isFunction3.default)(WrappedComponent.getBaseProps) ? WrappedComponent.getBaseProps(modifiedProps) : {};
	      }
	    }, {
	      key: "getAllEvents",
	      value: function getAllEvents(props) {
	        if (Array.isArray(this.componentEvents)) {
	          var _componentEvents;
	
	          return Array.isArray(props.events) ? (_componentEvents = this.componentEvents).concat.apply(_componentEvents, _toConsumableArray(props.events)) : this.componentEvents;
	        }
	        return props.events;
	      }
	    }, {
	      key: "getComponentProps",
	      value: function getComponentProps(component, type, index) {
	        var role = WrappedComponent.role;
	
	        var key = this.dataKeys && this.dataKeys[index] || index;
	        var baseProps = this.baseProps[key][type] || this.baseProps[key];
	        if (!baseProps && !this.hasEvents) {
	          return undefined;
	        }
	        if (this.hasEvents) {
	          var baseEvents = this.getEvents(this.props, type, key);
	          var componentProps = (0, _defaults3.default)({ index: index, key: role + "-" + type + "-" + key }, this.getEventState(key, type), this.getSharedEventState(key, type), component.props, baseProps);
	          var events = (0, _defaults3.default)({}, _events2.default.getPartialEvents(baseEvents, key, componentProps), componentProps.events);
	          return (0, _assign3.default)({}, componentProps, { events: events });
	        }
	        return (0, _defaults3.default)({ index: index, key: role + "-" + type + "-" + key }, component.props, baseProps);
	      }
	    }, {
	      key: "renderContainer",
	      value: function renderContainer(component, children) {
	        var isContainer = component.type && component.type.role === "container";
	        var parentProps = isContainer ? this.getComponentProps(component, "parent", "parent") : {};
	        return _react2.default.cloneElement(component, parentProps, children);
	      }
	    }, {
	      key: "animateComponent",
	      value: function animateComponent(props, animationWhitelist) {
	        return _react2.default.createElement(
	          _victoryTransition2.default,
	          { animate: props.animate, animationWhitelist: animationWhitelist },
	          _react2.default.createElement(this.constructor, props)
	        );
	      }
	
	      // Used by `VictoryLine` and `VictoryArea`
	
	    }, {
	      key: "renderContinuousData",
	      value: function renderContinuousData(props) {
	        var _this4 = this;
	
	        var dataComponent = props.dataComponent,
	            labelComponent = props.labelComponent,
	            groupComponent = props.groupComponent;
	
	        var dataKeys = (0, _without3.default)(this.dataKeys, "all");
	        var labelComponents = dataKeys.reduce(function (memo, key) {
	          var labelProps = _this4.getComponentProps(labelComponent, "labels", key);
	          if (labelProps && typeof labelProps.text !== "undefined" && labelProps.text !== null) {
	            memo = memo.concat(_react2.default.cloneElement(labelComponent, labelProps));
	          }
	          return memo;
	        }, []);
	        var dataProps = this.getComponentProps(dataComponent, "data", "all");
	        var children = [_react2.default.cloneElement(dataComponent, dataProps)].concat(_toConsumableArray(labelComponents));
	        return this.renderContainer(groupComponent, children);
	      }
	    }, {
	      key: "renderData",
	      value: function renderData(props) {
	        var _this5 = this;
	
	        var dataComponent = props.dataComponent,
	            labelComponent = props.labelComponent,
	            groupComponent = props.groupComponent;
	
	        var dataComponents = this.dataKeys.map(function (_dataKey, index) {
	          var dataProps = _this5.getComponentProps(dataComponent, "data", index);
	          return _react2.default.cloneElement(dataComponent, dataProps);
	        });
	
	        var labelComponents = this.dataKeys.map(function (_dataKey, index) {
	          var labelProps = _this5.getComponentProps(labelComponent, "labels", index);
	          if (typeof labelProps.text !== "undefined" && labelProps.text !== null) {
	            return _react2.default.cloneElement(labelComponent, labelProps);
	          }
	          return undefined;
	        }).filter(Boolean);
	
	        var children = [].concat(_toConsumableArray(dataComponents), _toConsumableArray(labelComponents));
	        return this.renderContainer(groupComponent, children);
	      }
	    }]);
	
	    return addEvents;
	  }(WrappedComponent);
	};

/***/ },
/* 268 */
/***/ function(module, exports) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  IMMUTABLE_ITERABLE: "@@__IMMUTABLE_ITERABLE__@@",
	  IMMUTABLE_RECORD: "@@__IMMUTABLE_RECORD__@@",
	  IMMUTABLE_LIST: "@@__IMMUTABLE_LIST__@@",
	  IMMUTABLE_MAP: "@@__IMMUTABLE_MAP__@@",
	
	  isImmutable: function (x) {
	    return this.isIterable(x) || this.isRecord(x);
	  },
	  isIterable: function (x) {
	    return !!(x && x[this.IMMUTABLE_ITERABLE]);
	  },
	  isRecord: function (x) {
	    return !!(x && x[this.IMMUTABLE_RECORD]);
	  },
	  isList: function (x) {
	    return !!(x && x[this.IMMUTABLE_LIST]);
	  },
	  isMap: function (x) {
	    return !!(x && x[this.IMMUTABLE_MAP]);
	  },
	  shallowToJS: function (x, whitelist) {
	    var _this = this;
	
	    return this.isIterable(x) ? x.reduce(function (prev, curr, key) {
	      if (whitelist && whitelist[key]) {
	        curr = _this.shallowToJS(curr);
	      }
	      prev[key] = curr;
	      return prev;
	    }, this.isList(x) ? [] : {}) : x;
	  }
	};

/***/ },
/* 269 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _identity2 = __webpack_require__(22);
	
	var _identity3 = _interopRequireDefault(_identity2);
	
	var _defaults2 = __webpack_require__(5);
	
	var _defaults3 = _interopRequireDefault(_defaults2);
	
	var _assign2 = __webpack_require__(4);
	
	var _assign3 = _interopRequireDefault(_assign2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getDatumKey(datum, idx) {
	  return (datum.key || idx).toString();
	} /* eslint-disable func-style */
	
	
	function getKeyedData(data) {
	  return data.reduce(function (keyedData, datum, idx) {
	    var key = getDatumKey(datum, idx);
	    keyedData[key] = datum;
	    return keyedData;
	  }, {});
	}
	
	function getKeyedDataDifference(a, b) {
	  var hasDifference = false;
	  var difference = Object.keys(a).reduce(function (_difference, key) {
	    if (!(key in b)) {
	      hasDifference = true;
	      _difference[key] = true;
	    }
	    return _difference;
	  }, {});
	  return hasDifference && difference;
	}
	
	/**
	 * Calculate which data-points exist in oldData and not nextData -
	 * these are the `exiting` data-points.  Also calculate which
	 * data-points exist in nextData and not oldData - these are the
	 * `entering` data-points.
	 *
	 * @param  {Array} oldData   this.props.data Array
	 * @param  {Array} nextData  this.props.data Array
	 *
	 * @return {Object}          Object with `entering` and `exiting` properties.
	 *                           entering[datum.key] will be true if the data is
	 *                           entering, and similarly for `exiting`.
	 */
	function getNodeTransitions(oldData, nextData) {
	  var oldDataKeyed = oldData && getKeyedData(oldData);
	  var nextDataKeyed = nextData && getKeyedData(nextData);
	
	  return {
	    entering: oldDataKeyed && getKeyedDataDifference(nextDataKeyed, oldDataKeyed),
	    exiting: nextDataKeyed && getKeyedDataDifference(oldDataKeyed, nextDataKeyed)
	  };
	}
	
	function getChildData(child) {
	  if (child.type && child.type.getData) {
	    return child.type.getData(child.props);
	  }
	  return child.props && child.props.data || false;
	}
	
	/**
	 * If a parent component has animation enabled, calculate the transitions
	 * for any data of any child component that supports data transitions
	 * Data transitions are defined as any two datasets where data nodes exist
	 * in the first set and not the second, in the second and not the first,
	 * or both.
	 *
	 * @param  {Children}  oldChildren   this.props.children from old props
	 * @param  {Children}  nextChildren  this.props.children from next props
	 *
	 * @return {Object}                  Object with the following properties:
	 *                                    - nodesWillExit
	 *                                    - nodesWillEnter
	 *                                    - childrenTransitions
	 *                                    - nodesShouldEnter
	 */
	function getInitialTransitionState(oldChildren, nextChildren) {
	  var nodesWillExit = false;
	  var nodesWillEnter = false;
	
	  var getTransition = function (oldChild, newChild) {
	    if (!newChild || oldChild.type !== newChild.type) {
	      return {};
	    }
	
	    var _ref = getNodeTransitions(getChildData(oldChild), getChildData(newChild)) || {},
	        entering = _ref.entering,
	        exiting = _ref.exiting;
	
	    nodesWillExit = nodesWillExit || !!exiting;
	    nodesWillEnter = nodesWillEnter || !!entering;
	
	    return { entering: entering || false, exiting: exiting || false };
	  };
	
	  var getTransitionsFromChildren = function (old, next) {
	    return old.map(function (child, idx) {
	      if (child && child.props && child.props.children) {
	        return getTransitionsFromChildren(_react2.default.Children.toArray(old[idx].props.children), _react2.default.Children.toArray(next[idx].props.children));
	      }
	      // get Transition entering and exiting nodes
	      return getTransition(child, next[idx]);
	    });
	  };
	
	  var childrenTransitions = getTransitionsFromChildren(_react2.default.Children.toArray(oldChildren), _react2.default.Children.toArray(nextChildren));
	  return {
	    nodesWillExit: nodesWillExit,
	    nodesWillEnter: nodesWillEnter,
	    childrenTransitions: childrenTransitions,
	    // TODO: This may need to be refactored for the following situation.
	    //       The component receives new props, and the data provided
	    //       is a perfect match for the previous data and domain except
	    //       for new nodes. In this case, we wouldn't want a delay before
	    //       the new nodes appear.
	    nodesShouldEnter: false
	  };
	}
	
	function getInitialChildProps(animate, data) {
	  var after = animate.onEnter && animate.onEnter.after ? animate.onEnter.after : _identity3.default;
	  return {
	    data: data.map(function (datum, idx) {
	      return (0, _assign3.default)({}, datum, after(datum, idx, data));
	    })
	  };
	}
	
	function getChildBeforeLoad(animate, child, data, cb) {
	  // eslint-disable-line max-params
	  animate = (0, _assign3.default)({}, animate, { onEnd: cb });
	  if (animate && animate.onLoad && !animate.onLoad.duration) {
	    return { animate: animate, data: data };
	  }
	  var before = animate.onLoad && animate.onLoad.before ? animate.onLoad.before : _identity3.default;
	  // If nodes need to exit, transform them with the provided onLoad.before function.
	  data = data.map(function (datum, idx) {
	    return (0, _assign3.default)({}, datum, before(datum, idx, data));
	  });
	
	  return { animate: animate, data: data, clipWidth: 0 };
	}
	
	function getChildOnLoad(animate, data, cb) {
	  // eslint-disable-line max-params
	  animate = (0, _assign3.default)({}, animate, { onEnd: cb });
	  if (animate && animate.onLoad && !animate.onLoad.duration) {
	    return { animate: animate, data: data };
	  }
	  var after = animate.onLoad && animate.onLoad.after ? animate.onLoad.after : _identity3.default;
	  // If nodes need to exit, transform them with the provided onLoad.after function.
	  data = data.map(function (datum, idx) {
	    return (0, _assign3.default)({}, datum, after(datum, idx, data));
	  });
	
	  return { animate: animate, data: data };
	}
	
	function getChildPropsOnExit(animate, child, data, exitingNodes, cb) {
	  // eslint-disable-line max-params, max-len
	  // Whether or not _this_ child has exiting nodes, we want the exit-
	  // transition for all children to have the same duration, delay, etc.
	  var onExit = animate && animate.onExit;
	  animate = (0, _assign3.default)({}, animate, onExit);
	
	  if (exitingNodes) {
	    // After the exit transition occurs, trigger the animations for
	    // nodes that are neither exiting or entering.
	    animate.onEnd = cb;
	    var before = animate.onExit && animate.onExit.before ? animate.onExit.before : _identity3.default;
	    // If nodes need to exit, transform them with the provided onExit.before function.
	    data = data.map(function (datum, idx) {
	      var key = (datum.key || idx).toString();
	      return exitingNodes[key] ? (0, _assign3.default)({}, datum, before(datum, idx, data)) : datum;
	    });
	  }
	
	  return { animate: animate, data: data };
	}
	
	function getChildPropsBeforeEnter(animate, child, data, enteringNodes, cb) {
	  // eslint-disable-line max-params,max-len
	  if (enteringNodes) {
	    // Perform a normal animation here, except - when it finishes - trigger
	    // the transition for entering nodes.
	    animate = (0, _assign3.default)({}, animate, { onEnd: cb });
	    var before = animate.onEnter && animate.onEnter.before ? animate.onEnter.before : _identity3.default;
	    // We want the entering nodes to be included in the transition target
	    // domain.  However, we may not want these nodes to be displayed initially,
	    // so perform the `onEnter.before` transformation on each node.
	    data = data.map(function (datum, idx) {
	      var key = (datum.key || idx).toString();
	      return enteringNodes[key] ? (0, _assign3.default)({}, datum, before(datum, idx, data)) : datum;
	    });
	  }
	
	  return { animate: animate, data: data };
	}
	
	function getChildPropsOnEnter(animate, data, enteringNodes, cb) {
	  // eslint-disable-line max-params, max-len
	  // Whether or not _this_ child has entering nodes, we want the entering-
	  // transition for all children to have the same duration, delay, etc.
	  var onEnter = animate && animate.onEnter;
	  animate = (0, _assign3.default)({}, animate, onEnter);
	
	  if (enteringNodes) {
	    // Old nodes have been transitioned to their new values, and the
	    // domain should encompass the nodes that will now enter. So perform
	    // the `onEnter.after` transformation on each node.
	    animate.onEnd = cb;
	    var after = animate.onEnter && animate.onEnter.after ? animate.onEnter.after : _identity3.default;
	    data = data.map(function (datum, idx) {
	      var key = getDatumKey(datum, idx);
	      return enteringNodes[key] ? (0, _assign3.default)({}, datum, after(datum, idx, data)) : datum;
	    });
	  }
	  return { animate: animate, data: data };
	}
	
	/**
	 * getTransitionPropsFactory - putting the Java in JavaScript.  This will return a
	 * function that returns prop transformations for a child, given that child's props
	 * and its index in the parent's children array.
	 *
	 * In particular, this will include an `animate` object that is set appropriately
	 * so that each child will be synchoronized for each stage of a transition
	 * animation.  It will also include a transformed `data` object, where each datum
	 * is transformed by `animate.onExit` and `animate.onEnter` `before` and `after`
	 * functions.
	 *
	 * @param  {Object}  props       `this.props` for the parent component.
	 * @param  {Object} state        `this.state` for the parent component.
	 * @param  {Function} setState    Function that, when called, will `this.setState` on
	 *                                 the parent component with the provided object.
	 *
	 * @return {Function}              Child-prop transformation function.
	 */
	function getTransitionPropsFactory(props, state, setState) {
	  var nodesWillExit = state && state.nodesWillExit;
	  var nodesWillEnter = state && state.nodesWillEnter;
	  var nodesShouldEnter = state && state.nodesShouldEnter;
	  var nodesShouldLoad = state && state.nodesShouldLoad;
	  var nodesDoneLoad = state && state.nodesDoneLoad;
	  var childrenTransitions = state && state.childrenTransitions || [];
	  var transitionDurations = {
	    enter: props.animate && props.animate.onEnter && props.animate.onEnter.duration,
	    exit: props.animate && props.animate.onExit && props.animate.onExit.duration,
	    load: props.animate && props.animate.onLoad && props.animate.onLoad.duration,
	    move: props.animate && props.animate.duration
	  };
	
	  var onLoad = function (child, data, animate) {
	    if (nodesShouldLoad) {
	      return getChildOnLoad(animate, data, function () {
	        setState({ nodesShouldLoad: false, nodesDoneLoad: true });
	      });
	    }
	
	    return getChildBeforeLoad(animate, child, data, function () {
	      setState({ nodesDoneLoad: true });
	    });
	  };
	
	  var onExit = function (nodes, child, data, animate) {
	    // eslint-disable-line max-params
	    return getChildPropsOnExit(animate, child, data, nodes, function () {
	      setState({ nodesWillExit: false });
	    });
	  };
	
	  var onEnter = function (nodes, child, data, animate) {
	    // eslint-disable-line max-params
	    if (nodesShouldEnter) {
	      return getChildPropsOnEnter(animate, data, nodes, function () {
	        setState({ nodesWillEnter: false });
	      });
	    }
	
	    return getChildPropsBeforeEnter(animate, child, data, nodes, function () {
	      setState({ nodesShouldEnter: true });
	    });
	  };
	
	  var getChildTransitionDuration = function (child, type) {
	    var animate = child.props.animate;
	    if (!child.type) {
	      return {};
	    }
	    var defaultTransitions = child.props && child.props.polar ? child.type.defaultPolarTransitions || child.type.defaultTransitions : child.type.defaultTransitions;
	    if (defaultTransitions) {
	      var animationDuration = animate[type] && animate[type].duration;
	      return animationDuration !== undefined ? animationDuration : defaultTransitions[type] && defaultTransitions[type].duration;
	    } else {
	      return {};
	    }
	  };
	
	  return function getTransitionProps(child, index) {
	    // eslint-disable-line max-statements, complexity, max-len
	    var data = getChildData(child) || [];
	    var animate = (0, _defaults3.default)({}, props.animate, child.props.animate);
	    var defaultTransitions = child.props.polar ? child.type.defaultPolarTransitions || child.type.defaultTransitions : child.type.defaultTransitions;
	
	    animate.onExit = (0, _defaults3.default)({}, animate.onExit, defaultTransitions && defaultTransitions.onExit);
	    animate.onEnter = (0, _defaults3.default)({}, animate.onEnter, defaultTransitions && defaultTransitions.onEnter);
	    animate.onLoad = (0, _defaults3.default)({}, animate.onLoad, defaultTransitions && defaultTransitions.onLoad);
	
	    var childTransitions = childrenTransitions[index] || childrenTransitions[0];
	    if (!nodesDoneLoad) {
	      // should do onLoad animation
	      var load = transitionDurations.load !== undefined ? transitionDurations.load : getChildTransitionDuration(child, "onLoad");
	      var animation = { duration: load };
	      return onLoad(child, data, (0, _assign3.default)({}, animate, animation));
	    } else if (nodesWillExit) {
	      var exitingNodes = childTransitions && childTransitions.exiting;
	      var exit = transitionDurations.exit !== undefined ? transitionDurations.exit : getChildTransitionDuration(child, "onExit");
	      // if nodesWillExit, but this child has no exiting nodes, set a delay instead of a duration
	      var _animation = exitingNodes ? { duration: exit } : { delay: exit };
	      return onExit(exitingNodes, child, data, (0, _assign3.default)({}, animate, _animation));
	    } else if (nodesWillEnter) {
	      var enteringNodes = childTransitions && childTransitions.entering;
	      var enter = transitionDurations.enter !== undefined ? transitionDurations.enter : getChildTransitionDuration(child, "onEnter");
	      var move = transitionDurations.move !== undefined ? transitionDurations.move : child.props.animate && child.props.animate.duration;
	      var _animation2 = { duration: nodesShouldEnter && enteringNodes ? enter : move };
	      return onEnter(enteringNodes, child, data, (0, _assign3.default)({}, animate, _animation2));
	    } else if (!state && animate && animate.onExit) {
	      // This is the initial render, and nodes may enter when props change. Because
	      // animation interpolation is determined by old- and next- props, data may need
	      // to be augmented with certain properties.
	      //
	      // For example, it may be desired that exiting nodes go from `opacity: 1` to
	      // `opacity: 0`. Without setting this on a per-datum basis, the interpolation
	      // might go from `opacity: undefined` to `opacity: 0`, which would result in
	      // interpolated `opacity: NaN` values.
	      //
	      return getInitialChildProps(animate, data);
	    }
	    return { animate: animate, data: data };
	  };
	}
	
	exports.default = {
	  getInitialTransitionState: getInitialTransitionState,
	  getTransitionPropsFactory: getTransitionPropsFactory
	};

/***/ },
/* 270 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (typeof Promise === 'undefined') {
	  // Rejection tracking prevents a common issue where React gets into an
	  // inconsistent state due to an error, but it gets swallowed by a Promise,
	  // and the user has no idea what causes React's erratic future behavior.
	  __webpack_require__(508).enable();
	  window.Promise = __webpack_require__(507);
	}
	
	// fetch() polyfill for making API calls.
	__webpack_require__(623);
	
	// Object.assign() is commonly used with React.
	// It will use the native implementation if it's present and isn't buggy.
	Object.assign = __webpack_require__(505);


/***/ },
/* 271 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	// Use the fastest means possible to execute a task in its own turn, with
	// priority over other events including IO, animation, reflow, and redraw
	// events in browsers.
	//
	// An exception thrown by a task will permanently interrupt the processing of
	// subsequent tasks. The higher level `asap` function ensures that if an
	// exception is thrown by a task, that the task queue will continue flushing as
	// soon as possible, but if you use `rawAsap` directly, you are responsible to
	// either ensure that no exceptions are thrown from your task, or to manually
	// call `rawAsap.requestFlush` if an exception is thrown.
	module.exports = rawAsap;
	function rawAsap(task) {
	    if (!queue.length) {
	        requestFlush();
	        flushing = true;
	    }
	    // Equivalent to push, but avoids a function call.
	    queue[queue.length] = task;
	}
	
	var queue = [];
	// Once a flush has been requested, no further calls to `requestFlush` are
	// necessary until the next `flush` completes.
	var flushing = false;
	// `requestFlush` is an implementation-specific method that attempts to kick
	// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
	// the event queue before yielding to the browser's own event loop.
	var requestFlush;
	// The position of the next task to execute in the task queue. This is
	// preserved between calls to `flush` so that it can be resumed if
	// a task throws an exception.
	var index = 0;
	// If a task schedules additional tasks recursively, the task queue can grow
	// unbounded. To prevent memory exhaustion, the task queue will periodically
	// truncate already-completed tasks.
	var capacity = 1024;
	
	// The flush function processes all tasks that have been scheduled with
	// `rawAsap` unless and until one of those tasks throws an exception.
	// If a task throws an exception, `flush` ensures that its state will remain
	// consistent and will resume where it left off when called again.
	// However, `flush` does not make any arrangements to be called again if an
	// exception is thrown.
	function flush() {
	    while (index < queue.length) {
	        var currentIndex = index;
	        // Advance the index before calling the task. This ensures that we will
	        // begin flushing on the next task the task throws an error.
	        index = index + 1;
	        queue[currentIndex].call();
	        // Prevent leaking memory for long chains of recursive calls to `asap`.
	        // If we call `asap` within tasks scheduled by `asap`, the queue will
	        // grow, but to avoid an O(n) walk for every task we execute, we don't
	        // shift tasks off the queue after they have been executed.
	        // Instead, we periodically shift 1024 tasks off the queue.
	        if (index > capacity) {
	            // Manually shift all values starting at the index back to the
	            // beginning of the queue.
	            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
	                queue[scan] = queue[scan + index];
	            }
	            queue.length -= index;
	            index = 0;
	        }
	    }
	    queue.length = 0;
	    index = 0;
	    flushing = false;
	}
	
	// `requestFlush` is implemented using a strategy based on data collected from
	// every available SauceLabs Selenium web driver worker at time of writing.
	// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593
	
	// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
	// have WebKitMutationObserver but not un-prefixed MutationObserver.
	// Must use `global` or `self` instead of `window` to work in both frames and web
	// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.
	
	/* globals self */
	var scope = typeof global !== "undefined" ? global : self;
	var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;
	
	// MutationObservers are desirable because they have high priority and work
	// reliably everywhere they are implemented.
	// They are implemented in all modern browsers.
	//
	// - Android 4-4.3
	// - Chrome 26-34
	// - Firefox 14-29
	// - Internet Explorer 11
	// - iPad Safari 6-7.1
	// - iPhone Safari 7-7.1
	// - Safari 6-7
	if (typeof BrowserMutationObserver === "function") {
	    requestFlush = makeRequestCallFromMutationObserver(flush);
	
	// MessageChannels are desirable because they give direct access to the HTML
	// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
	// 11-12, and in web workers in many engines.
	// Although message channels yield to any queued rendering and IO tasks, they
	// would be better than imposing the 4ms delay of timers.
	// However, they do not work reliably in Internet Explorer or Safari.
	
	// Internet Explorer 10 is the only browser that has setImmediate but does
	// not have MutationObservers.
	// Although setImmediate yields to the browser's renderer, it would be
	// preferrable to falling back to setTimeout since it does not have
	// the minimum 4ms penalty.
	// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
	// Desktop to a lesser extent) that renders both setImmediate and
	// MessageChannel useless for the purposes of ASAP.
	// https://github.com/kriskowal/q/issues/396
	
	// Timers are implemented universally.
	// We fall back to timers in workers in most engines, and in foreground
	// contexts in the following browsers.
	// However, note that even this simple case requires nuances to operate in a
	// broad spectrum of browsers.
	//
	// - Firefox 3-13
	// - Internet Explorer 6-9
	// - iPad Safari 4.3
	// - Lynx 2.8.7
	} else {
	    requestFlush = makeRequestCallFromTimer(flush);
	}
	
	// `requestFlush` requests that the high priority event queue be flushed as
	// soon as possible.
	// This is useful to prevent an error thrown in a task from stalling the event
	// queue if the exception handled by Node.js’s
	// `process.on("uncaughtException")` or by a domain.
	rawAsap.requestFlush = requestFlush;
	
	// To request a high priority event, we induce a mutation observer by toggling
	// the text of a text node between "1" and "-1".
	function makeRequestCallFromMutationObserver(callback) {
	    var toggle = 1;
	    var observer = new BrowserMutationObserver(callback);
	    var node = document.createTextNode("");
	    observer.observe(node, {characterData: true});
	    return function requestCall() {
	        toggle = -toggle;
	        node.data = toggle;
	    };
	}
	
	// The message channel technique was discovered by Malte Ubl and was the
	// original foundation for this library.
	// http://www.nonblocking.io/2011/06/windownexttick.html
	
	// Safari 6.0.5 (at least) intermittently fails to create message ports on a
	// page's first load. Thankfully, this version of Safari supports
	// MutationObservers, so we don't need to fall back in that case.
	
	// function makeRequestCallFromMessageChannel(callback) {
	//     var channel = new MessageChannel();
	//     channel.port1.onmessage = callback;
	//     return function requestCall() {
	//         channel.port2.postMessage(0);
	//     };
	// }
	
	// For reasons explained above, we are also unable to use `setImmediate`
	// under any circumstances.
	// Even if we were, there is another bug in Internet Explorer 10.
	// It is not sufficient to assign `setImmediate` to `requestFlush` because
	// `setImmediate` must be called *by name* and therefore must be wrapped in a
	// closure.
	// Never forget.
	
	// function makeRequestCallFromSetImmediate(callback) {
	//     return function requestCall() {
	//         setImmediate(callback);
	//     };
	// }
	
	// Safari 6.0 has a problem where timers will get lost while the user is
	// scrolling. This problem does not impact ASAP because Safari 6.0 supports
	// mutation observers, so that implementation is used instead.
	// However, if we ever elect to use timers in Safari, the prevalent work-around
	// is to add a scroll event listener that calls for a flush.
	
	// `setTimeout` does not call the passed callback if the delay is less than
	// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
	// even then.
	
	function makeRequestCallFromTimer(callback) {
	    return function requestCall() {
	        // We dispatch a timeout with a specified delay of 0 for engines that
	        // can reliably accommodate that request. This will usually be snapped
	        // to a 4 milisecond delay, but once we're flushing, there's no delay
	        // between events.
	        var timeoutHandle = setTimeout(handleTimer, 0);
	        // However, since this timer gets frequently dropped in Firefox
	        // workers, we enlist an interval handle that will try to fire
	        // an event 20 times per second until it succeeds.
	        var intervalHandle = setInterval(handleTimer, 50);
	
	        function handleTimer() {
	            // Whichever timer succeeds will cancel both timers and
	            // execute the callback.
	            clearTimeout(timeoutHandle);
	            clearInterval(intervalHandle);
	            callback();
	        }
	    };
	}
	
	// This is for `asap.js` only.
	// Its name will be periodically randomized to break any code that depends on
	// its existence.
	rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;
	
	// ASAP was originally a nextTick shim included in Q. This was factored out
	// into this ASAP package. It was later adapted to RSVP which made further
	// amendments. These decisions, particularly to marginalize MessageChannel and
	// to capture the MutationObserver implementation in a closure, were integrated
	// back into ASAP proper.
	// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 272 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(17);
	var bind = __webpack_require__(158);
	var Axios = __webpack_require__(274);
	var defaults = __webpack_require__(100);
	
	/**
	 * Create an instance of Axios
	 *
	 * @param {Object} defaultConfig The default config for the instance
	 * @return {Axios} A new instance of Axios
	 */
	function createInstance(defaultConfig) {
	  var context = new Axios(defaultConfig);
	  var instance = bind(Axios.prototype.request, context);
	
	  // Copy axios.prototype to instance
	  utils.extend(instance, Axios.prototype, context);
	
	  // Copy context to instance
	  utils.extend(instance, context);
	
	  return instance;
	}
	
	// Create the default instance to be exported
	var axios = createInstance(defaults);
	
	// Expose Axios class to allow class inheritance
	axios.Axios = Axios;
	
	// Factory for creating new instances
	axios.create = function create(instanceConfig) {
	  return createInstance(utils.merge(defaults, instanceConfig));
	};
	
	// Expose Cancel & CancelToken
	axios.Cancel = __webpack_require__(155);
	axios.CancelToken = __webpack_require__(273);
	axios.isCancel = __webpack_require__(156);
	
	// Expose all/spread
	axios.all = function all(promises) {
	  return Promise.all(promises);
	};
	axios.spread = __webpack_require__(288);
	
	module.exports = axios;
	
	// Allow use of default import syntax in TypeScript
	module.exports.default = axios;


/***/ },
/* 273 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Cancel = __webpack_require__(155);
	
	/**
	 * A `CancelToken` is an object that can be used to request cancellation of an operation.
	 *
	 * @class
	 * @param {Function} executor The executor function.
	 */
	function CancelToken(executor) {
	  if (typeof executor !== 'function') {
	    throw new TypeError('executor must be a function.');
	  }
	
	  var resolvePromise;
	  this.promise = new Promise(function promiseExecutor(resolve) {
	    resolvePromise = resolve;
	  });
	
	  var token = this;
	  executor(function cancel(message) {
	    if (token.reason) {
	      // Cancellation has already been requested
	      return;
	    }
	
	    token.reason = new Cancel(message);
	    resolvePromise(token.reason);
	  });
	}
	
	/**
	 * Throws a `Cancel` if cancellation has been requested.
	 */
	CancelToken.prototype.throwIfRequested = function throwIfRequested() {
	  if (this.reason) {
	    throw this.reason;
	  }
	};
	
	/**
	 * Returns an object that contains a new `CancelToken` and a function that, when called,
	 * cancels the `CancelToken`.
	 */
	CancelToken.source = function source() {
	  var cancel;
	  var token = new CancelToken(function executor(c) {
	    cancel = c;
	  });
	  return {
	    token: token,
	    cancel: cancel
	  };
	};
	
	module.exports = CancelToken;


/***/ },
/* 274 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var defaults = __webpack_require__(100);
	var utils = __webpack_require__(17);
	var InterceptorManager = __webpack_require__(275);
	var dispatchRequest = __webpack_require__(276);
	
	/**
	 * Create a new instance of Axios
	 *
	 * @param {Object} instanceConfig The default config for the instance
	 */
	function Axios(instanceConfig) {
	  this.defaults = instanceConfig;
	  this.interceptors = {
	    request: new InterceptorManager(),
	    response: new InterceptorManager()
	  };
	}
	
	/**
	 * Dispatch a request
	 *
	 * @param {Object} config The config specific for this request (merged with this.defaults)
	 */
	Axios.prototype.request = function request(config) {
	  /*eslint no-param-reassign:0*/
	  // Allow for axios('example/url'[, config]) a la fetch API
	  if (typeof config === 'string') {
	    config = utils.merge({
	      url: arguments[0]
	    }, arguments[1]);
	  }
	
	  config = utils.merge(defaults, this.defaults, { method: 'get' }, config);
	  config.method = config.method.toLowerCase();
	
	  // Hook up interceptors middleware
	  var chain = [dispatchRequest, undefined];
	  var promise = Promise.resolve(config);
	
	  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
	    chain.unshift(interceptor.fulfilled, interceptor.rejected);
	  });
	
	  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
	    chain.push(interceptor.fulfilled, interceptor.rejected);
	  });
	
	  while (chain.length) {
	    promise = promise.then(chain.shift(), chain.shift());
	  }
	
	  return promise;
	};
	
	// Provide aliases for supported request methods
	utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
	  /*eslint func-names:0*/
	  Axios.prototype[method] = function(url, config) {
	    return this.request(utils.merge(config || {}, {
	      method: method,
	      url: url
	    }));
	  };
	});
	
	utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
	  /*eslint func-names:0*/
	  Axios.prototype[method] = function(url, data, config) {
	    return this.request(utils.merge(config || {}, {
	      method: method,
	      url: url,
	      data: data
	    }));
	  };
	});
	
	module.exports = Axios;


/***/ },
/* 275 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(17);
	
	function InterceptorManager() {
	  this.handlers = [];
	}
	
	/**
	 * Add a new interceptor to the stack
	 *
	 * @param {Function} fulfilled The function to handle `then` for a `Promise`
	 * @param {Function} rejected The function to handle `reject` for a `Promise`
	 *
	 * @return {Number} An ID used to remove interceptor later
	 */
	InterceptorManager.prototype.use = function use(fulfilled, rejected) {
	  this.handlers.push({
	    fulfilled: fulfilled,
	    rejected: rejected
	  });
	  return this.handlers.length - 1;
	};
	
	/**
	 * Remove an interceptor from the stack
	 *
	 * @param {Number} id The ID that was returned by `use`
	 */
	InterceptorManager.prototype.eject = function eject(id) {
	  if (this.handlers[id]) {
	    this.handlers[id] = null;
	  }
	};
	
	/**
	 * Iterate over all the registered interceptors
	 *
	 * This method is particularly useful for skipping over any
	 * interceptors that may have become `null` calling `eject`.
	 *
	 * @param {Function} fn The function to call for each interceptor
	 */
	InterceptorManager.prototype.forEach = function forEach(fn) {
	  utils.forEach(this.handlers, function forEachHandler(h) {
	    if (h !== null) {
	      fn(h);
	    }
	  });
	};
	
	module.exports = InterceptorManager;


/***/ },
/* 276 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(17);
	var transformData = __webpack_require__(279);
	var isCancel = __webpack_require__(156);
	var defaults = __webpack_require__(100);
	var isAbsoluteURL = __webpack_require__(284);
	var combineURLs = __webpack_require__(282);
	
	/**
	 * Throws a `Cancel` if cancellation has been requested.
	 */
	function throwIfCancellationRequested(config) {
	  if (config.cancelToken) {
	    config.cancelToken.throwIfRequested();
	  }
	}
	
	/**
	 * Dispatch a request to the server using the configured adapter.
	 *
	 * @param {object} config The config that is to be used for the request
	 * @returns {Promise} The Promise to be fulfilled
	 */
	module.exports = function dispatchRequest(config) {
	  throwIfCancellationRequested(config);
	
	  // Support baseURL config
	  if (config.baseURL && !isAbsoluteURL(config.url)) {
	    config.url = combineURLs(config.baseURL, config.url);
	  }
	
	  // Ensure headers exist
	  config.headers = config.headers || {};
	
	  // Transform request data
	  config.data = transformData(
	    config.data,
	    config.headers,
	    config.transformRequest
	  );
	
	  // Flatten headers
	  config.headers = utils.merge(
	    config.headers.common || {},
	    config.headers[config.method] || {},
	    config.headers || {}
	  );
	
	  utils.forEach(
	    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
	    function cleanHeaderConfig(method) {
	      delete config.headers[method];
	    }
	  );
	
	  var adapter = config.adapter || defaults.adapter;
	
	  return adapter(config).then(function onAdapterResolution(response) {
	    throwIfCancellationRequested(config);
	
	    // Transform response data
	    response.data = transformData(
	      response.data,
	      response.headers,
	      config.transformResponse
	    );
	
	    return response;
	  }, function onAdapterRejection(reason) {
	    if (!isCancel(reason)) {
	      throwIfCancellationRequested(config);
	
	      // Transform response data
	      if (reason && reason.response) {
	        reason.response.data = transformData(
	          reason.response.data,
	          reason.response.headers,
	          config.transformResponse
	        );
	      }
	    }
	
	    return Promise.reject(reason);
	  });
	};


/***/ },
/* 277 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Update an Error with the specified config, error code, and response.
	 *
	 * @param {Error} error The error to update.
	 * @param {Object} config The config.
	 * @param {string} [code] The error code (for example, 'ECONNABORTED').
	 * @param {Object} [request] The request.
	 * @param {Object} [response] The response.
	 * @returns {Error} The error.
	 */
	module.exports = function enhanceError(error, config, code, request, response) {
	  error.config = config;
	  if (code) {
	    error.code = code;
	  }
	  error.request = request;
	  error.response = response;
	  return error;
	};


/***/ },
/* 278 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var createError = __webpack_require__(157);
	
	/**
	 * Resolve or reject a Promise based on response status.
	 *
	 * @param {Function} resolve A function that resolves the promise.
	 * @param {Function} reject A function that rejects the promise.
	 * @param {object} response The response.
	 */
	module.exports = function settle(resolve, reject, response) {
	  var validateStatus = response.config.validateStatus;
	  // Note: status is not exposed by XDomainRequest
	  if (!response.status || !validateStatus || validateStatus(response.status)) {
	    resolve(response);
	  } else {
	    reject(createError(
	      'Request failed with status code ' + response.status,
	      response.config,
	      null,
	      response.request,
	      response
	    ));
	  }
	};


/***/ },
/* 279 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(17);
	
	/**
	 * Transform the data for a request or a response
	 *
	 * @param {Object|String} data The data to be transformed
	 * @param {Array} headers The headers for the request or response
	 * @param {Array|Function} fns A single function or Array of functions
	 * @returns {*} The resulting transformed data
	 */
	module.exports = function transformData(data, headers, fns) {
	  /*eslint no-param-reassign:0*/
	  utils.forEach(fns, function transform(fn) {
	    data = fn(data, headers);
	  });
	
	  return data;
	};


/***/ },
/* 280 */
/***/ function(module, exports) {

	'use strict';
	
	// btoa polyfill for IE<10 courtesy https://github.com/davidchambers/Base64.js
	
	var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
	
	function E() {
	  this.message = 'String contains an invalid character';
	}
	E.prototype = new Error;
	E.prototype.code = 5;
	E.prototype.name = 'InvalidCharacterError';
	
	function btoa(input) {
	  var str = String(input);
	  var output = '';
	  for (
	    // initialize result and counter
	    var block, charCode, idx = 0, map = chars;
	    // if the next str index does not exist:
	    //   change the mapping table to "="
	    //   check if d has no fractional digits
	    str.charAt(idx | 0) || (map = '=', idx % 1);
	    // "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
	    output += map.charAt(63 & block >> 8 - idx % 1 * 8)
	  ) {
	    charCode = str.charCodeAt(idx += 3 / 4);
	    if (charCode > 0xFF) {
	      throw new E();
	    }
	    block = block << 8 | charCode;
	  }
	  return output;
	}
	
	module.exports = btoa;


/***/ },
/* 281 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(17);
	
	function encode(val) {
	  return encodeURIComponent(val).
	    replace(/%40/gi, '@').
	    replace(/%3A/gi, ':').
	    replace(/%24/g, '$').
	    replace(/%2C/gi, ',').
	    replace(/%20/g, '+').
	    replace(/%5B/gi, '[').
	    replace(/%5D/gi, ']');
	}
	
	/**
	 * Build a URL by appending params to the end
	 *
	 * @param {string} url The base of the url (e.g., http://www.google.com)
	 * @param {object} [params] The params to be appended
	 * @returns {string} The formatted url
	 */
	module.exports = function buildURL(url, params, paramsSerializer) {
	  /*eslint no-param-reassign:0*/
	  if (!params) {
	    return url;
	  }
	
	  var serializedParams;
	  if (paramsSerializer) {
	    serializedParams = paramsSerializer(params);
	  } else if (utils.isURLSearchParams(params)) {
	    serializedParams = params.toString();
	  } else {
	    var parts = [];
	
	    utils.forEach(params, function serialize(val, key) {
	      if (val === null || typeof val === 'undefined') {
	        return;
	      }
	
	      if (utils.isArray(val)) {
	        key = key + '[]';
	      }
	
	      if (!utils.isArray(val)) {
	        val = [val];
	      }
	
	      utils.forEach(val, function parseValue(v) {
	        if (utils.isDate(v)) {
	          v = v.toISOString();
	        } else if (utils.isObject(v)) {
	          v = JSON.stringify(v);
	        }
	        parts.push(encode(key) + '=' + encode(v));
	      });
	    });
	
	    serializedParams = parts.join('&');
	  }
	
	  if (serializedParams) {
	    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
	  }
	
	  return url;
	};


/***/ },
/* 282 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Creates a new URL by combining the specified URLs
	 *
	 * @param {string} baseURL The base URL
	 * @param {string} relativeURL The relative URL
	 * @returns {string} The combined URL
	 */
	module.exports = function combineURLs(baseURL, relativeURL) {
	  return relativeURL
	    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
	    : baseURL;
	};


/***/ },
/* 283 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(17);
	
	module.exports = (
	  utils.isStandardBrowserEnv() ?
	
	  // Standard browser envs support document.cookie
	  (function standardBrowserEnv() {
	    return {
	      write: function write(name, value, expires, path, domain, secure) {
	        var cookie = [];
	        cookie.push(name + '=' + encodeURIComponent(value));
	
	        if (utils.isNumber(expires)) {
	          cookie.push('expires=' + new Date(expires).toGMTString());
	        }
	
	        if (utils.isString(path)) {
	          cookie.push('path=' + path);
	        }
	
	        if (utils.isString(domain)) {
	          cookie.push('domain=' + domain);
	        }
	
	        if (secure === true) {
	          cookie.push('secure');
	        }
	
	        document.cookie = cookie.join('; ');
	      },
	
	      read: function read(name) {
	        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
	        return (match ? decodeURIComponent(match[3]) : null);
	      },
	
	      remove: function remove(name) {
	        this.write(name, '', Date.now() - 86400000);
	      }
	    };
	  })() :
	
	  // Non standard browser env (web workers, react-native) lack needed support.
	  (function nonStandardBrowserEnv() {
	    return {
	      write: function write() {},
	      read: function read() { return null; },
	      remove: function remove() {}
	    };
	  })()
	);


/***/ },
/* 284 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Determines whether the specified URL is absolute
	 *
	 * @param {string} url The URL to test
	 * @returns {boolean} True if the specified URL is absolute, otherwise false
	 */
	module.exports = function isAbsoluteURL(url) {
	  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
	  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
	  // by any combination of letters, digits, plus, period, or hyphen.
	  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
	};


/***/ },
/* 285 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(17);
	
	module.exports = (
	  utils.isStandardBrowserEnv() ?
	
	  // Standard browser envs have full support of the APIs needed to test
	  // whether the request URL is of the same origin as current location.
	  (function standardBrowserEnv() {
	    var msie = /(msie|trident)/i.test(navigator.userAgent);
	    var urlParsingNode = document.createElement('a');
	    var originURL;
	
	    /**
	    * Parse a URL to discover it's components
	    *
	    * @param {String} url The URL to be parsed
	    * @returns {Object}
	    */
	    function resolveURL(url) {
	      var href = url;
	
	      if (msie) {
	        // IE needs attribute set twice to normalize properties
	        urlParsingNode.setAttribute('href', href);
	        href = urlParsingNode.href;
	      }
	
	      urlParsingNode.setAttribute('href', href);
	
	      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
	      return {
	        href: urlParsingNode.href,
	        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
	        host: urlParsingNode.host,
	        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
	        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
	        hostname: urlParsingNode.hostname,
	        port: urlParsingNode.port,
	        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
	                  urlParsingNode.pathname :
	                  '/' + urlParsingNode.pathname
	      };
	    }
	
	    originURL = resolveURL(window.location.href);
	
	    /**
	    * Determine if a URL shares the same origin as the current location
	    *
	    * @param {String} requestURL The URL to test
	    * @returns {boolean} True if URL shares the same origin, otherwise false
	    */
	    return function isURLSameOrigin(requestURL) {
	      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
	      return (parsed.protocol === originURL.protocol &&
	            parsed.host === originURL.host);
	    };
	  })() :
	
	  // Non standard browser envs (web workers, react-native) lack needed support.
	  (function nonStandardBrowserEnv() {
	    return function isURLSameOrigin() {
	      return true;
	    };
	  })()
	);


/***/ },
/* 286 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(17);
	
	module.exports = function normalizeHeaderName(headers, normalizedName) {
	  utils.forEach(headers, function processHeader(value, name) {
	    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
	      headers[normalizedName] = value;
	      delete headers[name];
	    }
	  });
	};


/***/ },
/* 287 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(17);
	
	// Headers whose duplicates are ignored by node
	// c.f. https://nodejs.org/api/http.html#http_message_headers
	var ignoreDuplicateOf = [
	  'age', 'authorization', 'content-length', 'content-type', 'etag',
	  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
	  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
	  'referer', 'retry-after', 'user-agent'
	];
	
	/**
	 * Parse headers into an object
	 *
	 * ```
	 * Date: Wed, 27 Aug 2014 08:58:49 GMT
	 * Content-Type: application/json
	 * Connection: keep-alive
	 * Transfer-Encoding: chunked
	 * ```
	 *
	 * @param {String} headers Headers needing to be parsed
	 * @returns {Object} Headers parsed into an object
	 */
	module.exports = function parseHeaders(headers) {
	  var parsed = {};
	  var key;
	  var val;
	  var i;
	
	  if (!headers) { return parsed; }
	
	  utils.forEach(headers.split('\n'), function parser(line) {
	    i = line.indexOf(':');
	    key = utils.trim(line.substr(0, i)).toLowerCase();
	    val = utils.trim(line.substr(i + 1));
	
	    if (key) {
	      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
	        return;
	      }
	      if (key === 'set-cookie') {
	        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
	      } else {
	        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
	      }
	    }
	  });
	
	  return parsed;
	};


/***/ },
/* 288 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Syntactic sugar for invoking a function and expanding an array for arguments.
	 *
	 * Common use case would be to use `Function.prototype.apply`.
	 *
	 *  ```js
	 *  function f(x, y, z) {}
	 *  var args = [1, 2, 3];
	 *  f.apply(null, args);
	 *  ```
	 *
	 * With `spread` this example can be re-written.
	 *
	 *  ```js
	 *  spread(function(x, y, z) {})([1, 2, 3]);
	 *  ```
	 *
	 * @param {Function} callback
	 * @returns {Function}
	 */
	module.exports = function spread(callback) {
	  return function wrap(arr) {
	    return callback.apply(null, arr);
	  };
	};


/***/ },
/* 289 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(64);
	
	__webpack_require__(343);
	
	var _login = __webpack_require__(329);
	
	var _login2 = _interopRequireDefault(_login);
	
	var _setup = __webpack_require__(332);
	
	var _setup2 = _interopRequireDefault(_setup);
	
	var _resetpassword = __webpack_require__(331);
	
	var _resetpassword2 = _interopRequireDefault(_resetpassword);
	
	var _dashboard = __webpack_require__(313);
	
	var _dashboard2 = _interopRequireDefault(_dashboard);
	
	var _redirect = __webpack_require__(330);
	
	var _redirect2 = _interopRequireDefault(_redirect);
	
	var _reactRouterDom = __webpack_require__(37);
	
	var _popup = __webpack_require__(28);
	
	var _popup2 = _interopRequireDefault(_popup);
	
	var _actions = __webpack_require__(326);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import Signup from './components/signup.js';
	
	
	var ReactRedux = __webpack_require__(234);
	
	var App = function (_Component) {
	  _inherits(App, _Component);
	
	  function App() {
	    _classCallCheck(this, App);
	
	    return _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).apply(this, arguments));
	  }
	
	  _createClass(App, [{
	    key: 'render',
	    value: function render() {
	      var reset = window.reset;
	      if (reset) {
	        window.history.pushState('', '', '/setup');
	      }
	
	      window.kyc = parseInt(window.kyc);
	
	      var content = this.props.content;
	      var switchLanguage = this.props.switchLanguage;
	
	      return _react2.default.createElement(
	        _reactRouterDom.BrowserRouter,
	        null,
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_reactRouterDom.Route, { path: '/', exact: true, component: _login2.default }),
	          _react2.default.createElement(_reactRouterDom.Route, { path: '/dashboard', exact: true, render: function render(_ref) {
	              var match = _ref.match;
	              return _react2.default.createElement(_dashboard2.default, { data: content, switchLanguage: switchLanguage, page: match });
	            } }),
	          _react2.default.createElement(_reactRouterDom.Route, { path: '/setup', component: _setup2.default }),
	          _react2.default.createElement(_reactRouterDom.Route, { path: '/resetpassword', component: _resetpassword2.default }),
	          _react2.default.createElement(_reactRouterDom.Route, { path: '/emailverification', component: _redirect2.default }),
	          _react2.default.createElement(_reactRouterDom.Route, { path: '/dashboard/:name', render: function render(_ref2) {
	              var match = _ref2.match;
	              return _react2.default.createElement(_dashboard2.default, { data: content, switchLanguage: switchLanguage, page: match });
	            } }),
	          _react2.default.createElement(_popup2.default, null)
	        )
	      );
	    }
	  }]);
	
	  return App;
	}(_react.Component);
	
	module.exports = ReactRedux.connect(function (state) {
	  return { content: state.content };
	}, function (dispatch) {
	  return { switchLanguage: function switchLanguage(lang) {
	      return dispatch(_actions2.default.switchLanguage(lang));
	    } };
	})(App);

/***/ },
/* 290 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _popup = __webpack_require__(28);
	
	var _popup2 = _interopRequireDefault(_popup);
	
	var _kyc_upload = __webpack_require__(315);
	
	var _kyc_upload2 = _interopRequireDefault(_kyc_upload);
	
	var _jquery = __webpack_require__(14);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _axios = __webpack_require__(27);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _qs = __webpack_require__(31);
	
	var _qs2 = _interopRequireDefault(_qs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Account = function (_Component) {
	  _inherits(Account, _Component);
	
	  function Account() {
	    _classCallCheck(this, Account);
	
	    return _possibleConstructorReturn(this, (Account.__proto__ || Object.getPrototypeOf(Account)).apply(this, arguments));
	  }
	
	  _createClass(Account, [{
	    key: 'render',
	    value: function render() {
	
	      var email = window.email;
	      var username = window.username;
	      var last_login = window.last_login;
	      var date_joined = window.date_joined;
	      var kyc = window.kyc;
	
	      _axios2.default.defaults.xsrfCookieName = 'csrftoken';
	      _axios2.default.defaults.xsrfHeaderName = 'X-CSRFToken';
	
	      var data = this.props.data;
	
	      var changepassword = function changepassword() {
	
	        var password1 = (0, _jquery2.default)('#passWord1').val();
	        var password2 = (0, _jquery2.default)("#passWord2").val();
	        if (password1 !== password2) {
	          _popup2.default.prototype.show(data.pwNoMatch);
	        } else if (password1.length < 8) {
	          _popup2.default.prototype.show(data.pwLessThan8);
	        } else {
	          _axios2.default.post('/api/loginchangepassword', _qs2.default.stringify({
	            "password": password1
	          })).then(function (response) {
	            if (response.data.status === 'saved') {
	              _popup2.default.prototype.show(data.pwReset);
	            } else {
	              _popup2.default.prototype.show();
	            }
	          }).catch(function (error) {
	            _popup2.default.prototype.show(data.failed + ":\n" + error.response.data.message);
	          });
	        }
	        (0, _jquery2.default)('#passWord1').val("");
	        (0, _jquery2.default)("#passWord2").val("");
	      };
	
	      var show_changePassword = function show_changePassword() {
	        var accordion = (0, _jquery2.default)(".changePassword");
	        var panel = accordion.next();
	        if (panel.css("maxHeight") !== "0px") {
	          panel.css("maxHeight", "0px");
	        } else {
	          panel.css("maxHeight", panel.prop('scrollHeight') + "0px");
	        }
	      };
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { 'class': 'row' },
	          _react2.default.createElement(
	            'div',
	            { 'class': 'col-lg-12 col-md-12' },
	            _react2.default.createElement(
	              'div',
	              { 'class': 'card-box task-detail' },
	              _react2.default.createElement(
	                'div',
	                { 'class': 'media m-b-20 m-t-0' },
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'media-body' },
	                  _react2.default.createElement(
	                    'h4',
	                    { 'class': 'media-heading m-b-0' },
	                    ' ',
	                    data.email,
	                    ': ',
	                    email,
	                    ' '
	                  ),
	                  _react2.default.createElement(
	                    'h4',
	                    { 'class': 'media-heading m-b-0' },
	                    ' ',
	                    data.username,
	                    ': ',
	                    username,
	                    ' '
	                  )
	                ),
	                _react2.default.createElement(
	                  'ul',
	                  { 'class': 'list-inline task-dates m-b-0 m-t-20' },
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                      'h5',
	                      { 'class': 'font-600 m-b-5' },
	                      data.datejoined
	                    ),
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      ' ',
	                      date_joined
	                    ),
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      ' ',
	                      data.koreaTimezone,
	                      ' '
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                      'h5',
	                      { 'class': 'font-600 m-b-5' },
	                      data.lastlogin
	                    ),
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      ' ',
	                      last_login
	                    ),
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      ' ',
	                      data.koreaTimezone,
	                      ' '
	                    )
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { 'class': 'row' },
	          _react2.default.createElement(
	            'div',
	            { 'class': 'col-lg-12 col-md-12' },
	            _react2.default.createElement(
	              'div',
	              { 'class': 'card-box task-detail' },
	              _react2.default.createElement(
	                'div',
	                { 'class': 'media m-b-20 m-t-0' },
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'media-body' },
	                  _react2.default.createElement(
	                    'h4',
	                    { 'class': 'media-heading m-b-0' },
	                    ' KYC'
	                  ),
	                  _react2.default.createElement(
	                    'h4',
	                    { 'class': 'media-heading m-b-0' },
	                    ' KYC ',
	                    data.status,
	                    ': ',
	                    data.level,
	                    ' ',
	                    kyc,
	                    ' '
	                  )
	                ),
	                _react2.default.createElement('div', { 'class': 'm-t-10' }),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'KYC ',
	                  data.level,
	                  ' 1: ',
	                  data.unableWithdraw
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'KYC ',
	                  data.level,
	                  ' 2: ',
	                  data.limitedWithdraw
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'KYC ',
	                  data.level,
	                  ' 3: ',
	                  data.higherWithdrawLimit
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_kyc_upload2.default, null),
	        _react2.default.createElement(
	          'div',
	          { 'class': 'row' },
	          _react2.default.createElement(
	            'div',
	            { 'class': 'col-lg-12' },
	            _react2.default.createElement(
	              'button',
	              { 'class': 'changePassword accordion_green btn-block text-left active', onClick: show_changePassword },
	              data.changepassword
	            ),
	            _react2.default.createElement(
	              'div',
	              { 'class': 'accordion_panel' },
	              _react2.default.createElement('div', { 'class': 'm-t-20' }),
	              _react2.default.createElement(
	                'div',
	                { 'class': 'form-group' },
	                _react2.default.createElement(
	                  'label',
	                  { 'for': 'pass1' },
	                  data.newpassword,
	                  '*'
	                ),
	                _react2.default.createElement('input', { id: 'passWord1', type: 'password', name: 'inputPassword', pattern: '.{8,}', placeholder: 'Password', 'class': 'form-control', 'data-parsley-id': '8', required: true })
	              ),
	              _react2.default.createElement(
	                'div',
	                { 'class': 'form-group' },
	                _react2.default.createElement(
	                  'label',
	                  { 'for': 'passWord2' },
	                  data.confirmpassword,
	                  '*'
	                ),
	                _react2.default.createElement('input', { 'data-parsley-equalto': '#pass1', name: 'inputConfirmPassword', pattern: '.{8,}', type: 'password', placeholder: 'Password', 'class': 'form-control', id: 'passWord2', 'data-parsley-id': '10', required: true })
	              ),
	              _react2.default.createElement(
	                'button',
	                { type: 'submit', onClick: changepassword, 'class': 'btn btn-green w-md waves-effect waves-light' },
	                'Save'
	              ),
	              _react2.default.createElement('div', { 'class': 'm-b-20' })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Account;
	}(_react.Component);
	
	exports.default = Account;

/***/ },
/* 291 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(14);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _wallet_address = __webpack_require__(160);
	
	var _wallet_address2 = _interopRequireDefault(_wallet_address);
	
	var _send_transaction = __webpack_require__(101);
	
	var _send_transaction2 = _interopRequireDefault(_send_transaction);
	
	var _daolevel = __webpack_require__(159);
	
	var _daolevel2 = _interopRequireDefault(_daolevel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AiDAO = function (_Component) {
	    _inherits(AiDAO, _Component);
	
	    function AiDAO() {
	        _classCallCheck(this, AiDAO);
	
	        return _possibleConstructorReturn(this, (AiDAO.__proto__ || Object.getPrototypeOf(AiDAO)).apply(this, arguments));
	    }
	
	    _createClass(AiDAO, [{
	        key: 'render',
	        value: function render() {
	            var kyc = window.kyc;
	            var pass = window.pass;
	            var limit = window.allowance;
	            var data = this.props.data.aidao;
	
	            // cancel the && pass === "True" to enable everyone dao sending
	            if (kyc > 2) {
	                (0, _jquery2.default)(document).ready(function () {
	                    (0, _jquery2.default)("#dao-page-card").html('<button class="btn btn-green w-md waves-effect waves-light" data-toggle="modal" data-target="#con-close-modal">Send</button>');
	
	                    //$("#limit-allowance").html(`Your monthly AiDAO sending limit is ` + limit + ` AiDAO`);
	                });
	            }
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { 'class': 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { 'class': 'col-lg-12 col-md-12' },
	                        _react2.default.createElement(
	                            'div',
	                            { 'class': 'card-box' },
	                            _react2.default.createElement(
	                                'h4',
	                                { 'class': 'header-title m-t-0 m-b-30' },
	                                'AiDAO ',
	                                data.balance
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { 'class': 'widget-box-2' },
	                                _react2.default.createElement(_daolevel2.default, { data: this.props.data.daolevel }),
	                                _react2.default.createElement('div', { id: 'dao-page-card', 'class': 'text-right m-t-10' }),
	                                _react2.default.createElement('div', { id: 'limit-allowance' }),
	                                _react2.default.createElement(_send_transaction2.default, { name: 'aidao', data: this.props.data.send_transaction })
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(_wallet_address2.default, { data: this.props.data.wallet_address })
	            );
	        }
	    }]);
	
	    return AiDAO;
	}(_react.Component);
	
	exports.default = AiDAO;

/***/ },
/* 292 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _auto = __webpack_require__(65);
	
	var _auto2 = _interopRequireDefault(_auto);
	
	var _withdraw = __webpack_require__(13);
	
	var _withdraw2 = _interopRequireDefault(_withdraw);
	
	var _goback = __webpack_require__(11);
	
	var _goback2 = _interopRequireDefault(_goback);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Autonio = function (_Component) {
	  _inherits(Autonio, _Component);
	
	  function Autonio() {
	    _classCallCheck(this, Autonio);
	
	    return _possibleConstructorReturn(this, (Autonio.__proto__ || Object.getPrototypeOf(Autonio)).apply(this, arguments));
	  }
	
	  _createClass(Autonio, [{
	    key: "render",
	    value: function render() {
	      var autoniobalance = window.autoniobalance;
	
	      var data = this.props.data.cobinhood;
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "div",
	          { "class": "row" },
	          _react2.default.createElement(
	            "div",
	            { "class": "col-lg-12 col-md-12" },
	            _react2.default.createElement(
	              "div",
	              { "class": "card-box" },
	              _react2.default.createElement(
	                "h4",
	                { "class": "header-title m-t-0 m-b-30" },
	                "Autonio ",
	                data.balance
	              ),
	              _react2.default.createElement(
	                "div",
	                { "class": "widget-box-2" },
	                _react2.default.createElement(
	                  "div",
	                  { "class": "widget-detail-2" },
	                  _react2.default.createElement(
	                    "h2",
	                    { "class": "m-b-0" },
	                    _react2.default.createElement("img", { src: _auto2.default, "class": "token64", alt: "autonio logo" }),
	                    " ",
	                    _react2.default.createElement(
	                      "span",
	                      { id: "cobinhoodbalance" },
	                      autoniobalance
	                    ),
	                    " "
	                  ),
	                  _react2.default.createElement(
	                    "p",
	                    { "class": "text-muted m-b-25" },
	                    "NIO"
	                  ),
	                  _react2.default.createElement(_goback2.default, { data: data })
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_withdraw2.default, { name: "autonio", data: this.props.data.withdraw, sendtransaction: this.props.data.send_transaction })
	      );
	    }
	  }]);
	
	  return Autonio;
	}(_react.Component);
	
	exports.default = Autonio;

/***/ },
/* 293 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bit = __webpack_require__(66);
	
	var _bit2 = _interopRequireDefault(_bit);
	
	var _withdraw = __webpack_require__(13);
	
	var _withdraw2 = _interopRequireDefault(_withdraw);
	
	var _goback = __webpack_require__(11);
	
	var _goback2 = _interopRequireDefault(_goback);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BitRewards = function (_Component) {
	  _inherits(BitRewards, _Component);
	
	  function BitRewards() {
	    _classCallCheck(this, BitRewards);
	
	    return _possibleConstructorReturn(this, (BitRewards.__proto__ || Object.getPrototypeOf(BitRewards)).apply(this, arguments));
	  }
	
	  _createClass(BitRewards, [{
	    key: "render",
	    value: function render() {
	      var bitrewardsbalance = window.bitrewardsbalance;
	
	      var data = this.props.data.cobinhood;
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "div",
	          { "class": "row" },
	          _react2.default.createElement(
	            "div",
	            { "class": "col-lg-12 col-md-12" },
	            _react2.default.createElement(
	              "div",
	              { "class": "card-box" },
	              _react2.default.createElement(
	                "h4",
	                { "class": "header-title m-t-0 m-b-30" },
	                "BitRewards ",
	                data.balance
	              ),
	              _react2.default.createElement(
	                "div",
	                { "class": "widget-box-2" },
	                _react2.default.createElement(
	                  "div",
	                  { "class": "widget-detail-2" },
	                  _react2.default.createElement(
	                    "h2",
	                    { "class": "m-b-0" },
	                    _react2.default.createElement("img", { src: _bit2.default, "class": "token64", alt: "bitrewards logo" }),
	                    " ",
	                    _react2.default.createElement(
	                      "span",
	                      { id: "cobinhoodbalance" },
	                      bitrewardsbalance
	                    ),
	                    " "
	                  ),
	                  _react2.default.createElement(
	                    "p",
	                    { "class": "text-muted m-b-25" },
	                    "BIT"
	                  ),
	                  _react2.default.createElement(_goback2.default, { data: data })
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_withdraw2.default, {
	          name: "bitrewards",
	          data: this.props.data.withdraw,
	          sendtransaction: this.props.data.send_transaction
	        })
	      );
	    }
	  }]);
	
	  return BitRewards;
	}(_react.Component);
	
	exports.default = BitRewards;

/***/ },
/* 294 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _cobinhood = __webpack_require__(67);
	
	var _cobinhood2 = _interopRequireDefault(_cobinhood);
	
	var _withdraw = __webpack_require__(13);
	
	var _withdraw2 = _interopRequireDefault(_withdraw);
	
	var _goback = __webpack_require__(11);
	
	var _goback2 = _interopRequireDefault(_goback);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Cobinhood = function (_Component) {
	  _inherits(Cobinhood, _Component);
	
	  function Cobinhood() {
	    _classCallCheck(this, Cobinhood);
	
	    return _possibleConstructorReturn(this, (Cobinhood.__proto__ || Object.getPrototypeOf(Cobinhood)).apply(this, arguments));
	  }
	
	  _createClass(Cobinhood, [{
	    key: "render",
	    value: function render() {
	      var cobinhoodbalance = window.cobinhoodbalance;
	
	      var data = this.props.data.cobinhood;
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "div",
	          { "class": "row" },
	          _react2.default.createElement(
	            "div",
	            { "class": "col-lg-12 col-md-12" },
	            _react2.default.createElement(
	              "div",
	              { "class": "card-box" },
	              _react2.default.createElement(
	                "h4",
	                { "class": "header-title m-t-0 m-b-30" },
	                "Cobinhood ",
	                data.balance
	              ),
	              _react2.default.createElement(
	                "div",
	                { "class": "widget-box-2" },
	                _react2.default.createElement(
	                  "div",
	                  { "class": "widget-detail-2" },
	                  _react2.default.createElement(
	                    "h2",
	                    { "class": "m-b-0" },
	                    _react2.default.createElement("img", { src: _cobinhood2.default, "class": "token64", alt: "cobinhood logo" }),
	                    " ",
	                    _react2.default.createElement(
	                      "span",
	                      { id: "cobinhoodbalance" },
	                      cobinhoodbalance
	                    ),
	                    " "
	                  ),
	                  _react2.default.createElement(
	                    "p",
	                    { "class": "text-muted m-b-25" },
	                    "COB"
	                  ),
	                  _react2.default.createElement(_goback2.default, { data: data })
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_withdraw2.default, {
	          name: "cobinhood",
	          data: this.props.data.withdraw,
	          sendtransaction: this.props.data.send_transaction
	        })
	      );
	    }
	  }]);
	
	  return Cobinhood;
	}(_react.Component);
	
	exports.default = Cobinhood;

/***/ },
/* 295 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _credit = __webpack_require__(68);
	
	var _credit2 = _interopRequireDefault(_credit);
	
	var _withdraw = __webpack_require__(13);
	
	var _withdraw2 = _interopRequireDefault(_withdraw);
	
	var _goback = __webpack_require__(11);
	
	var _goback2 = _interopRequireDefault(_goback);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Credits = function (_Component) {
	  _inherits(Credits, _Component);
	
	  function Credits() {
	    _classCallCheck(this, Credits);
	
	    return _possibleConstructorReturn(this, (Credits.__proto__ || Object.getPrototypeOf(Credits)).apply(this, arguments));
	  }
	
	  _createClass(Credits, [{
	    key: "render",
	    value: function render() {
	      var creditsbalance = window.creditsbalance;
	
	      var data = this.props.data.cybermiles;
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "div",
	          { "class": "row" },
	          _react2.default.createElement(
	            "div",
	            { "class": "col-lg-12 col-md-12" },
	            _react2.default.createElement(
	              "div",
	              { "class": "card-box" },
	              _react2.default.createElement(
	                "h4",
	                { "class": "header-title m-t-0 m-b-30" },
	                "Credits ",
	                data.balance
	              ),
	              _react2.default.createElement(
	                "div",
	                { "class": "widget-box-2" },
	                _react2.default.createElement(
	                  "div",
	                  { "class": "widget-detail-2" },
	                  _react2.default.createElement(
	                    "h2",
	                    { "class": "m-b-0" },
	                    _react2.default.createElement("img", { src: _credit2.default, "class": "token64", alt: "credit logo" }),
	                    " ",
	                    _react2.default.createElement(
	                      "span",
	                      { id: "daobalance" },
	                      creditsbalance
	                    ),
	                    " "
	                  ),
	                  _react2.default.createElement(
	                    "p",
	                    { "class": "text-muted m-b-25" },
	                    "CS"
	                  )
	                ),
	                _react2.default.createElement(_goback2.default, { data: data })
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_withdraw2.default, { name: "credits", data: this.props.data.withdraw, sendtransaction: this.props.data.send_transaction })
	      );
	    }
	  }]);
	
	  return Credits;
	}(_react.Component);
	
	exports.default = Credits;

/***/ },
/* 296 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _cybermiles = __webpack_require__(102);
	
	var _cybermiles2 = _interopRequireDefault(_cybermiles);
	
	var _withdraw = __webpack_require__(13);
	
	var _withdraw2 = _interopRequireDefault(_withdraw);
	
	var _goback = __webpack_require__(11);
	
	var _goback2 = _interopRequireDefault(_goback);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CyberMiles = function (_Component) {
	  _inherits(CyberMiles, _Component);
	
	  function CyberMiles() {
	    _classCallCheck(this, CyberMiles);
	
	    return _possibleConstructorReturn(this, (CyberMiles.__proto__ || Object.getPrototypeOf(CyberMiles)).apply(this, arguments));
	  }
	
	  _createClass(CyberMiles, [{
	    key: "render",
	    value: function render() {
	      var cybermilesbalance = window.cybermilesbalance;
	
	      var data = this.props.data.cybermiles;
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "div",
	          { "class": "row" },
	          _react2.default.createElement(
	            "div",
	            { "class": "col-lg-12 col-md-12" },
	            _react2.default.createElement(
	              "div",
	              { "class": "card-box" },
	              _react2.default.createElement(
	                "h4",
	                { "class": "header-title m-t-0 m-b-30" },
	                "Cybermiles ",
	                data.balance
	              ),
	              _react2.default.createElement(
	                "div",
	                { "class": "widget-box-2" },
	                _react2.default.createElement(
	                  "div",
	                  { "class": "widget-detail-2" },
	                  _react2.default.createElement(
	                    "h2",
	                    { "class": "m-b-0" },
	                    _react2.default.createElement("img", { src: _cybermiles2.default, "class": "token64", alt: "aidao logo" }),
	                    " ",
	                    _react2.default.createElement(
	                      "span",
	                      { id: "daobalance" },
	                      cybermilesbalance
	                    ),
	                    " "
	                  ),
	                  _react2.default.createElement(
	                    "p",
	                    { "class": "text-muted m-b-25" },
	                    "CMT"
	                  )
	                ),
	                _react2.default.createElement(_goback2.default, { data: data })
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_withdraw2.default, {
	          name: "cybermiles",
	          data: this.props.data.withdraw,
	          sendtransaction: this.props.data.send_transaction
	        })
	      );
	    }
	  }]);
	
	  return CyberMiles;
	}(_react.Component);
	
	exports.default = CyberMiles;

/***/ },
/* 297 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Ethereum = __webpack_require__(48);
	
	var _Ethereum2 = _interopRequireDefault(_Ethereum);
	
	var _cobinhood = __webpack_require__(67);
	
	var _cobinhood2 = _interopRequireDefault(_cobinhood);
	
	var _wandx = __webpack_require__(74);
	
	var _wandx2 = _interopRequireDefault(_wandx);
	
	var _ess = __webpack_require__(69);
	
	var _ess2 = _interopRequireDefault(_ess);
	
	var _ncash = __webpack_require__(70);
	
	var _ncash2 = _interopRequireDefault(_ncash);
	
	var _xyo = __webpack_require__(75);
	
	var _xyo2 = _interopRequireDefault(_xyo);
	
	var _auto = __webpack_require__(65);
	
	var _auto2 = _interopRequireDefault(_auto);
	
	var _bit = __webpack_require__(66);
	
	var _bit2 = _interopRequireDefault(_bit);
	
	var _credit = __webpack_require__(68);
	
	var _credit2 = _interopRequireDefault(_credit);
	
	var _stacsLogo = __webpack_require__(73);
	
	var _stacsLogo2 = _interopRequireDefault(_stacsLogo);
	
	var _singularity = __webpack_require__(72);
	
	var _singularity2 = _interopRequireDefault(_singularity);
	
	var _orbsLogo = __webpack_require__(71);
	
	var _orbsLogo2 = _interopRequireDefault(_orbsLogo);
	
	var _victory = __webpack_require__(622);
	
	var _daolevel = __webpack_require__(159);
	
	var _daolevel2 = _interopRequireDefault(_daolevel);
	
	var _reactRouterDom = __webpack_require__(37);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // This file in the crypto folder for the import convenience.
	
	
	var DashboardMainContent = function (_Component) {
	  _inherits(DashboardMainContent, _Component);
	
	  function DashboardMainContent() {
	    _classCallCheck(this, DashboardMainContent);
	
	    return _possibleConstructorReturn(this, (DashboardMainContent.__proto__ || Object.getPrototypeOf(DashboardMainContent)).apply(this, arguments));
	  }
	
	  _createClass(DashboardMainContent, [{
	    key: "render",
	    value: function render() {
	      var precision = 4;
	      var etherbalance = parseFloat(window.etherbalance).toFixed(5);
	      var cobinhoodbalance = parseFloat(window.cobinhoodbalance).toFixed(precision);
	      var wandxbalance = parseFloat(window.wandxbalance).toFixed(precision);
	      var xyobalance = parseFloat(window.xyobalance).toFixed(precision);
	      var ncashbalance = parseFloat(window.ncashbalance).toFixed(precision);
	      var essentiabalance = parseFloat(window.essentiabalance).toFixed(precision);
	      var singularitybalance = parseFloat(window.agibalance).toFixed(precision);
	      var autoniobalance = parseFloat(window.autoniobalance).toFixed(precision);
	      var bitrewardsbalance = parseFloat(window.bitrewardsbalance).toFixed(precision);
	      var creditsbalance = parseFloat(window.creditsbalance).toFixed(precision);
	      var stacsbalance = parseFloat(window.stacsbalance).toFixed(precision);
	      var orbsbalance = parseFloat(window.orbsbalance).toFixed(precision);
	
	      var ethprice = parseFloat(window.ethprice);
	      var cobinhoodprice = parseFloat(window.cobinhoodprice);
	      var wandxprice = parseFloat(window.wandxprice);
	      var xyoprice = parseFloat(window.xyoprice);
	      var ncashprice = parseFloat(window.ncashprice);
	      var essentiaprice = parseFloat(window.essentiaprice);
	      var singularityprice = parseFloat(window.agiprice);
	      var autonioprice = parseFloat(window.autonioprice);
	      var creditsprice = parseFloat(window.creditsprice);
	      var bitrewardsprice = parseFloat(window.bitrewardsprice);
	      var stacsprice = parseFloat(window.stacsprice);
	      var orbsprice = parseFloat(window.orbsprice);
	      var data = this.props.data;
	
	      // var total = (
	      //   cobinhoodbalance * cobinhoodprice +
	      //   cybermilesbalance * cybermilesprice +
	      //   wandxbalance * wandxprice +
	      //   etherbalance * ethprice
	      // ).toFixed(2);
	
	      var sampledata = [{ x: 1, y: etherbalance * ethprice }, { x: 1, y: cobinhoodbalance * cobinhoodprice }, { x: 1, y: wandxbalance * wandxprice }, { x: 1, y: xyobalance * xyoprice }, { x: 1, y: ncashbalance * ncashprice }, { x: 1, y: essentiabalance * essentiaprice }, { x: 1, y: singularitybalance * singularityprice }, { x: 1, y: autoniobalance * autonioprice }, { x: 1, y: bitrewardsbalance * bitrewardsprice }, { x: 1, y: creditsbalance * creditsprice }, { x: 1, y: stacsbalance * stacsprice }, { x: 1, y: orbsbalance * orbsprice }];
	
	      console.log(sampledata);
	      var colors = ["#6d76b5", "#19b491", "#156763", "#8e90c7", "#337AB7", "#678fffe3", "#40BCFF", "#3abbb9", "EF682D", "#dddddd", '#188ae2', '#cedff7ba'];
	
	      //<p class="pull-right m-t-20 m-b-20" id="inline">{ethprice} USD</p>
	      // <p>{data.dashboard_main_content.notification} </p>
	      var kyc_level = window.kyc;
	      var belongs = window.belongs;
	      if (kyc_level < 3 && belongs === 'Mr.Cho') {
	        return _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            "div",
	            { "class": "row" },
	            _react2.default.createElement(
	              "div",
	              { "class": "col-md-12" },
	              _react2.default.createElement(
	                "div",
	                { "class": "card-box" },
	                _react2.default.createElement(
	                  "div",
	                  { "class": "widget-box-2" },
	                  _react2.default.createElement(
	                    "div",
	                    { "class": "widget-detail-2 m-b-20 m-t-0 m-l-10 m-r-10" },
	                    _react2.default.createElement(_daolevel2.default, { data: data.daolevel })
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { "class": "row" },
	            _react2.default.createElement(
	              "div",
	              { "class": "col-md-12" },
	              _react2.default.createElement(
	                "div",
	                { "class": "card-box" },
	                _react2.default.createElement(
	                  "div",
	                  { "class": "kyc-command" },
	                  "We require everyone to pass identification (KYC) in order to receive and withdraw airdrop tokens. Please do so before December 25, 2021. However, You do not need to pass KYC to send and receive ETH or AiDAO Token"
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { "class": "kyc-command" },
	                  "\uC5D0\uC5B4\uB4DC\uB86D \uD1A0\uD070\uC744 \uBC1B\uACE0 \uCD9C\uAE08\uD558\uAE30 \uC704\uD574\uC11C\uB294 \uBAA8\uB4E0 \uC0AC\uB78C\uC774 \uC2E0\uBD84\uC99D(KYC)\uC744 \uD1B5\uACFC\uD574\uC57C \uD569\uB2C8\uB2E4. 2021\uB144 12\uC6D4 25\uC77C \uC774\uC804\uC5D0 \uD574\uC8FC\uC138\uC694. \uADF8\uB7EC\uB098 ETH \uB610\uB294 AiDAO \uD1A0\uD070\uC744 \uBCF4\uB0B4\uACE0 \uBC1B\uAE30 \uC704\uD574 KYC\uB97C \uD1B5\uACFC\uD560 \uD544\uC694\uAC00 \uC5C6\uC2B5\uB2C8\uB2E4."
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { "class": "kyc-command" },
	                  "If you have submitted KYC before but did not pass the KYC, you can now re-submit your documents."
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { "class": "kyc-command" },
	                  "\uC774\uC804\uC5D0 KYC\uB97C \uC81C\uCD9C\uD588\uC9C0\uB9CC KYC\uB97C \uD1B5\uACFC\uD558\uC9C0 \uBABB\uD55C \uACBD\uC6B0 \uC774\uC81C \uBB38\uC11C\uB97C \uB2E4\uC2DC \uC81C\uCD9C\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4."
	                ),
	                _react2.default.createElement(
	                  _reactRouterDom.Link,
	                  { "class": "kyc-command", to: { pathname: "/dashboard/account" } },
	                  "Go to Account Page to do KYC"
	                ),
	                _react2.default.createElement(
	                  _reactRouterDom.Link,
	                  { "class": "kyc-command", to: { pathname: "/dashboard/account" } },
	                  "\uACC4\uC815 \uD398\uC774\uC9C0\uB85C \uC774\uB3D9\uD558\uC5EC KYC \uC218\uD589"
	                )
	              )
	            )
	          )
	        );
	      }
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "div",
	          { "class": "row" },
	          _react2.default.createElement(
	            "div",
	            { "class": "col-md-12" },
	            _react2.default.createElement(
	              "div",
	              { "class": "card-box" },
	              _react2.default.createElement(
	                "div",
	                { "class": "widget-box-2" },
	                _react2.default.createElement(
	                  "div",
	                  { "class": "widget-detail-2 m-b-20 m-t-0 m-l-10 m-r-10" },
	                  _react2.default.createElement(
	                    "p",
	                    null,
	                    "Important Notification: we are enforcing a fee upon airdrop token withdrawals. You can check the fee for each token in the information page. "
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { "class": "row" },
	          _react2.default.createElement(
	            "div",
	            { "class": "col-md-12" },
	            _react2.default.createElement(
	              "div",
	              { "class": "card-box" },
	              _react2.default.createElement(
	                "div",
	                { "class": "widget-box-2" },
	                _react2.default.createElement(
	                  "div",
	                  { "class": "widget-detail-2 m-b-20 m-t-0 m-l-10 m-r-10" },
	                  _react2.default.createElement(_daolevel2.default, { data: data.daolevel })
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { "class": "card-box" },
	          _react2.default.createElement(
	            "div",
	            { "class": "row" },
	            _react2.default.createElement(
	              "div",
	              { "class": "col-md-12 no-padding" },
	              _react2.default.createElement(
	                "div",
	                { "class": "widget-chart text-center" },
	                _react2.default.createElement(
	                  "div",
	                  { id: "graphcontainer" },
	                  _react2.default.createElement(_victory.VictoryPie, {
	                    innerRadius: 100,
	                    style: {
	                      labels: {
	                        opacity: 0
	                      }
	                    },
	                    colorScale: colors,
	                    data: sampledata
	                  })
	                ),
	                _react2.default.createElement(
	                  "ul",
	                  { "class": "list-inline chart-detail-list m-b-0" },
	                  _react2.default.createElement(
	                    "li",
	                    null,
	                    _react2.default.createElement(
	                      "h5",
	                      { "class": "h5-class-1" },
	                      _react2.default.createElement("i", { "class": "fa fa-circle m-r-5" }),
	                      "ETH"
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "li",
	                    null,
	                    _react2.default.createElement(
	                      "h5",
	                      { "class": "h5-class-2" },
	                      _react2.default.createElement("i", { "class": "fa fa-circle m-r-5" }),
	                      "COB"
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "li",
	                    null,
	                    _react2.default.createElement(
	                      "h5",
	                      { "class": "h5-class-4" },
	                      _react2.default.createElement("i", { "class": "fa fa-circle m-r-5" }),
	                      "WAND"
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "li",
	                    null,
	                    _react2.default.createElement(
	                      "h5",
	                      { "class": "h5-class-6" },
	                      _react2.default.createElement("i", { "class": "fa fa-circle m-r-5" }),
	                      "XYO"
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "li",
	                    null,
	                    _react2.default.createElement(
	                      "h5",
	                      { "class": "h5-class-7" },
	                      _react2.default.createElement("i", { "class": "fa fa-circle m-r-5" }),
	                      "NCASH"
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "li",
	                    null,
	                    _react2.default.createElement(
	                      "h5",
	                      { "class": "h5-class-8" },
	                      _react2.default.createElement("i", { "class": "fa fa-circle m-r-5" }),
	                      "ESS"
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "li",
	                    null,
	                    _react2.default.createElement(
	                      "h5",
	                      { "class": "h5-class-9" },
	                      _react2.default.createElement("i", { "class": "fa fa-circle m-r-5" }),
	                      "AGI"
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "li",
	                    null,
	                    _react2.default.createElement(
	                      "h5",
	                      { "class": "h5-class-10" },
	                      _react2.default.createElement("i", { "class": "fa fa-circle m-r-5" }),
	                      "NIO"
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "li",
	                    null,
	                    _react2.default.createElement(
	                      "h5",
	                      { "class": "h5-class-11" },
	                      _react2.default.createElement("i", { "class": "fa fa-circle m-r-5" }),
	                      "BIT"
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "li",
	                    null,
	                    _react2.default.createElement(
	                      "h5",
	                      { "class": "h5-class-12" },
	                      _react2.default.createElement("i", { "class": "fa fa-circle m-r-5" }),
	                      "CS"
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "li",
	                    null,
	                    _react2.default.createElement(
	                      "h5",
	                      { "class": "h5-class-13" },
	                      _react2.default.createElement("i", { "class": "fa fa-circle m-r-5" }),
	                      "STACS"
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "li",
	                    null,
	                    _react2.default.createElement(
	                      "h5",
	                      { "class": "h5-class-14" },
	                      _react2.default.createElement("i", { "class": "fa fa-circle m-r-5" }),
	                      "ORBS"
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { "class": "row m-t-20" },
	            _react2.default.createElement(
	              "div",
	              { "class": "col-lg-3 col-md-6 col-sm-12" },
	              _react2.default.createElement(
	                _reactRouterDom.Link,
	                { to: { pathname: "/dashboard/ethereum" } },
	                _react2.default.createElement(
	                  "div",
	                  { "class": "widget-detail-2", id: "ethereum" },
	                  _react2.default.createElement(
	                    "h5",
	                    { "class": "m-b-0" },
	                    "Ethereum"
	                  ),
	                  _react2.default.createElement("div", { "class": "word-break m-b-0" }),
	                  _react2.default.createElement(
	                    "h3",
	                    { "class": "token-account m-b-0", id: "inline" },
	                    _react2.default.createElement("img", { src: _Ethereum2.default, alt: "ether icon", "class": "token32" }),
	                    " ",
	                    etherbalance,
	                    " ETH"
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { "class": "col-lg-3 col-md-6 col-sm-12" },
	              _react2.default.createElement(
	                _reactRouterDom.Link,
	                { to: { pathname: "/dashboard/cobinhood" } },
	                _react2.default.createElement(
	                  "div",
	                  { "class": "widget-detail-2", id: "cobinhood" },
	                  _react2.default.createElement(
	                    "h5",
	                    { "class": "m-b-0" },
	                    "Cobinhood"
	                  ),
	                  _react2.default.createElement("div", { "class": "word-break m-b-0" }),
	                  _react2.default.createElement(
	                    "h3",
	                    { "class": "token-account m-b-0", id: "inline" },
	                    _react2.default.createElement("img", { src: _cobinhood2.default, alt: "cobinhood icon", "class": "token32" }),
	                    " ",
	                    cobinhoodbalance,
	                    " COB"
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { "class": "col-lg-3 col-md-6 col-sm-12" },
	              _react2.default.createElement(
	                _reactRouterDom.Link,
	                { to: { pathname: "/dashboard/wandx" } },
	                _react2.default.createElement(
	                  "div",
	                  { "class": "widget-detail-2", id: "wandx" },
	                  _react2.default.createElement(
	                    "h5",
	                    { "class": "m-b-0" },
	                    "Wandx"
	                  ),
	                  _react2.default.createElement("div", { "class": "word-break m-b-0" }),
	                  _react2.default.createElement(
	                    "h3",
	                    { "class": "token-account m-b-0", id: "inline" },
	                    _react2.default.createElement("img", { src: _wandx2.default, alt: "wandx icon", "class": "token32" }),
	                    " ",
	                    wandxbalance,
	                    " WAND"
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { "class": "col-lg-3 col-md-6 col-sm-12" },
	              _react2.default.createElement(
	                _reactRouterDom.Link,
	                { to: { pathname: "/dashboard/xyo" } },
	                _react2.default.createElement(
	                  "div",
	                  { "class": "widget-detail-2", id: "xyo" },
	                  _react2.default.createElement(
	                    "h5",
	                    { "class": "m-b-0" },
	                    "XYO"
	                  ),
	                  _react2.default.createElement("div", { "class": "word-break m-b-0" }),
	                  _react2.default.createElement(
	                    "h3",
	                    { "class": "token-account m-b-0", id: "inline" },
	                    _react2.default.createElement("img", { src: _xyo2.default, alt: "xyo icon", "class": "token32" }),
	                    " ",
	                    xyobalance,
	                    " XYO"
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { "class": "col-lg-3 col-md-6 col-sm-12" },
	              _react2.default.createElement(
	                _reactRouterDom.Link,
	                { to: { pathname: "/dashboard/ncash" } },
	                _react2.default.createElement(
	                  "div",
	                  { "class": "widget-detail-2", id: "ncash" },
	                  _react2.default.createElement(
	                    "h5",
	                    { "class": "m-b-0" },
	                    "NCash"
	                  ),
	                  _react2.default.createElement("div", { "class": "word-break m-b-0" }),
	                  _react2.default.createElement(
	                    "h3",
	                    { "class": "token-account m-b-0", id: "inline" },
	                    _react2.default.createElement("img", { src: _ncash2.default, alt: "ncash icon", "class": "token32" }),
	                    " ",
	                    ncashbalance,
	                    " Ncash"
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { "class": "col-lg-3 col-md-6 col-sm-12" },
	              _react2.default.createElement(
	                _reactRouterDom.Link,
	                { to: { pathname: "/dashboard/essentia" } },
	                _react2.default.createElement(
	                  "div",
	                  { "class": "widget-detail-2", id: "essentia" },
	                  _react2.default.createElement(
	                    "h5",
	                    { "class": "m-b-0" },
	                    "Essentia"
	                  ),
	                  _react2.default.createElement("div", { "class": "word-break m-b-0" }),
	                  _react2.default.createElement(
	                    "h3",
	                    { "class": "token-account m-b-0", id: "inline" },
	                    _react2.default.createElement("img", { src: _ess2.default, alt: "essentia icon", "class": "token32" }),
	                    " ",
	                    essentiabalance,
	                    " ESS"
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { "class": "col-lg-3 col-md-6 col-sm-12" },
	              _react2.default.createElement(
	                _reactRouterDom.Link,
	                { to: { pathname: "/dashboard/singularitynet" } },
	                _react2.default.createElement(
	                  "div",
	                  { "class": "widget-detail-2", id: "singularitynet" },
	                  _react2.default.createElement(
	                    "h5",
	                    { "class": "m-b-0" },
	                    "SingularityNet"
	                  ),
	                  _react2.default.createElement("div", { "class": "word-break m-b-0" }),
	                  _react2.default.createElement(
	                    "h3",
	                    { "class": "token-account m-b-0", id: "inline" },
	                    _react2.default.createElement("img", { src: _singularity2.default, alt: "singularitynet icon", "class": "token32" }),
	                    " ",
	                    singularitybalance,
	                    " AGI"
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { "class": "col-lg-3 col-md-6 col-sm-12" },
	              _react2.default.createElement(
	                _reactRouterDom.Link,
	                { to: { pathname: "/dashboard/autonio" } },
	                _react2.default.createElement(
	                  "div",
	                  { "class": "widget-detail-2", id: "autonio" },
	                  _react2.default.createElement(
	                    "h5",
	                    { "class": "m-b-0" },
	                    "Autonio"
	                  ),
	                  _react2.default.createElement("div", { "class": "word-break m-b-0" }),
	                  _react2.default.createElement(
	                    "h3",
	                    { "class": "token-account m-b-0", id: "inline" },
	                    _react2.default.createElement("img", { src: _auto2.default, alt: "autonio icon", "class": "token32" }),
	                    " ",
	                    autoniobalance,
	                    " NIO"
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { "class": "col-lg-3 col-md-6 col-sm-12" },
	              _react2.default.createElement(
	                _reactRouterDom.Link,
	                { to: { pathname: "/dashboard/bitrewards" } },
	                _react2.default.createElement(
	                  "div",
	                  { "class": "widget-detail-2", id: "bitrewards" },
	                  _react2.default.createElement(
	                    "h5",
	                    { "class": "m-b-0" },
	                    "BitRewards"
	                  ),
	                  _react2.default.createElement("div", { "class": "word-break m-b-0" }),
	                  _react2.default.createElement(
	                    "h3",
	                    { "class": "token-account m-b-0", id: "inline" },
	                    _react2.default.createElement("img", { src: _bit2.default, alt: "bitrewards icon", "class": "token32" }),
	                    " ",
	                    bitrewardsbalance,
	                    " BIT"
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { "class": "col-lg-3 col-md-6 col-sm-12" },
	              _react2.default.createElement(
	                _reactRouterDom.Link,
	                { to: { pathname: "/dashboard/credits" } },
	                _react2.default.createElement(
	                  "div",
	                  { "class": "widget-detail-2", id: "credits" },
	                  _react2.default.createElement(
	                    "h5",
	                    { "class": "m-b-0" },
	                    "Credits"
	                  ),
	                  _react2.default.createElement("div", { "class": "word-break m-b-0" }),
	                  _react2.default.createElement(
	                    "h3",
	                    { "class": "token-account m-b-0", id: "inline" },
	                    _react2.default.createElement("img", { src: _credit2.default, alt: "credits icon", "class": "token32" }),
	                    " ",
	                    creditsbalance,
	                    " CS"
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { "class": "col-lg-3 col-md-6 col-sm-12" },
	              _react2.default.createElement(
	                _reactRouterDom.Link,
	                { to: { pathname: "/dashboard/stacs" } },
	                _react2.default.createElement(
	                  "div",
	                  { "class": "widget-detail-2", id: "stacs" },
	                  _react2.default.createElement(
	                    "h5",
	                    { "class": "m-b-0" },
	                    "Stacs"
	                  ),
	                  _react2.default.createElement("div", { "class": "word-break m-b-0" }),
	                  _react2.default.createElement(
	                    "h3",
	                    { "class": "token-account m-b-0", id: "inline" },
	                    _react2.default.createElement("img", { src: _stacsLogo2.default, alt: "stacs icon", "class": "token32" }),
	                    " ",
	                    stacsbalance,
	                    " STACS"
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { "class": "col-lg-3 col-md-6 col-sm-12" },
	              _react2.default.createElement(
	                _reactRouterDom.Link,
	                { to: { pathname: "/dashboard/orbs" } },
	                _react2.default.createElement(
	                  "div",
	                  { "class": "widget-detail-2", id: "orbs" },
	                  _react2.default.createElement(
	                    "h5",
	                    { "class": "m-b-0" },
	                    "Orbs"
	                  ),
	                  _react2.default.createElement("div", { "class": "word-break m-b-0" }),
	                  _react2.default.createElement(
	                    "h3",
	                    { "class": "token-account m-b-0", id: "inline" },
	                    _react2.default.createElement("img", { src: _orbsLogo2.default, alt: "orbs icon", "class": "token32" }),
	                    " ",
	                    orbsbalance,
	                    " ORBS"
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return DashboardMainContent;
	}(_react.Component);
	
	exports.default = DashboardMainContent;

/***/ },
/* 298 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _dicet = __webpack_require__(169);
	
	var _dicet2 = _interopRequireDefault(_dicet);
	
	var _goback = __webpack_require__(11);
	
	var _goback2 = _interopRequireDefault(_goback);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Dicet = function (_Component) {
	  _inherits(Dicet, _Component);
	
	  function Dicet() {
	    _classCallCheck(this, Dicet);
	
	    return _possibleConstructorReturn(this, (Dicet.__proto__ || Object.getPrototypeOf(Dicet)).apply(this, arguments));
	  }
	
	  _createClass(Dicet, [{
	    key: "render",
	    value: function render() {
	      var dicebalance = window.dicebalance;
	
	      var data = this.props.data.cybermiles;
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "div",
	          { "class": "row" },
	          _react2.default.createElement(
	            "div",
	            { "class": "col-lg-12 col-md-12" },
	            _react2.default.createElement(
	              "div",
	              { "class": "card-box" },
	              _react2.default.createElement(
	                "h4",
	                { "class": "header-title m-t-0 m-b-30" },
	                "Dicet ",
	                data.balance
	              ),
	              _react2.default.createElement(
	                "div",
	                { "class": "widget-box-2" },
	                _react2.default.createElement(
	                  "div",
	                  { "class": "widget-detail-2" },
	                  _react2.default.createElement(
	                    "h2",
	                    { "class": "m-b-0" },
	                    _react2.default.createElement("img", { src: _dicet2.default, "class": "token64", alt: "dicet logo" }),
	                    " ",
	                    _react2.default.createElement(
	                      "span",
	                      { id: "daobalance" },
	                      dicebalance
	                    ),
	                    " "
	                  ),
	                  _react2.default.createElement(
	                    "p",
	                    { "class": "text-muted m-b-25" },
	                    "CET"
	                  )
	                ),
	                _react2.default.createElement(_goback2.default, { data: data })
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Dicet;
	}(_react.Component);
	
	exports.default = Dicet;

/***/ },
/* 299 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ess = __webpack_require__(69);
	
	var _ess2 = _interopRequireDefault(_ess);
	
	var _withdraw = __webpack_require__(13);
	
	var _withdraw2 = _interopRequireDefault(_withdraw);
	
	var _goback = __webpack_require__(11);
	
	var _goback2 = _interopRequireDefault(_goback);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Essentia = function (_Component) {
	  _inherits(Essentia, _Component);
	
	  function Essentia() {
	    _classCallCheck(this, Essentia);
	
	    return _possibleConstructorReturn(this, (Essentia.__proto__ || Object.getPrototypeOf(Essentia)).apply(this, arguments));
	  }
	
	  _createClass(Essentia, [{
	    key: "render",
	    value: function render() {
	      var essentiabalance = window.essentiabalance;
	
	      var data = this.props.data.cybermiles;
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "div",
	          { "class": "row" },
	          _react2.default.createElement(
	            "div",
	            { "class": "col-lg-12 col-md-12" },
	            _react2.default.createElement(
	              "div",
	              { "class": "card-box" },
	              _react2.default.createElement(
	                "h4",
	                { "class": "header-title m-t-0 m-b-30" },
	                "Essentia ",
	                data.balance
	              ),
	              _react2.default.createElement(
	                "div",
	                { "class": "widget-box-2" },
	                _react2.default.createElement(
	                  "div",
	                  { "class": "widget-detail-2" },
	                  _react2.default.createElement(
	                    "h2",
	                    { "class": "m-b-0" },
	                    _react2.default.createElement("img", { src: _ess2.default, "class": "token64", alt: "Essentia logo" }),
	                    " ",
	                    _react2.default.createElement(
	                      "span",
	                      { id: "daobalance" },
	                      essentiabalance
	                    ),
	                    " "
	                  ),
	                  _react2.default.createElement(
	                    "p",
	                    { "class": "text-muted m-b-25" },
	                    "ESS"
	                  )
	                ),
	                _react2.default.createElement(_goback2.default, { data: data })
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_withdraw2.default, {
	          name: "essentia",
	          data: this.props.data.withdraw,
	          sendtransaction: this.props.data.send_transaction
	        })
	      );
	    }
	  }]);
	
	  return Essentia;
	}(_react.Component);
	
	exports.default = Essentia;

/***/ },
/* 300 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Ethereum = __webpack_require__(48);
	
	var _Ethereum2 = _interopRequireDefault(_Ethereum);
	
	var _wallet_address = __webpack_require__(160);
	
	var _wallet_address2 = _interopRequireDefault(_wallet_address);
	
	var _send_transaction = __webpack_require__(101);
	
	var _send_transaction2 = _interopRequireDefault(_send_transaction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Ethereum = function (_Component) {
	    _inherits(Ethereum, _Component);
	
	    function Ethereum() {
	        _classCallCheck(this, Ethereum);
	
	        return _possibleConstructorReturn(this, (Ethereum.__proto__ || Object.getPrototypeOf(Ethereum)).apply(this, arguments));
	    }
	
	    _createClass(Ethereum, [{
	        key: 'render',
	        value: function render() {
	
	            var etherbalance = window.etherbalance;
	
	            var data = this.props.data.ethereum;
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { 'class': 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { 'class': 'col-lg-12 col-md-12' },
	                        _react2.default.createElement(
	                            'div',
	                            { 'class': 'card-box' },
	                            _react2.default.createElement(
	                                'h4',
	                                { 'class': 'header-title m-t-0 m-b-30' },
	                                'Ethereum ',
	                                data.balance
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { 'class': 'widget-box-2' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'widget-detail-2' },
	                                    _react2.default.createElement(
	                                        'h2',
	                                        { 'class': 'm-b-0' },
	                                        _react2.default.createElement('img', { src: _Ethereum2.default, 'class': 'token64', alt: 'ethereum logo' }),
	                                        ' ',
	                                        _react2.default.createElement(
	                                            'span',
	                                            { id: 'etherbalance' },
	                                            etherbalance
	                                        ),
	                                        ' '
	                                    ),
	                                    _react2.default.createElement(
	                                        'p',
	                                        { 'class': 'text-muted m-b-25' },
	                                        'ETHEREUM'
	                                    ),
	                                    _react2.default.createElement(
	                                        'button',
	                                        { 'class': 'btn btn-green w-md waves-effect waves-light', 'data-toggle': 'modal', 'data-target': '#con-close-modal' },
	                                        'Send'
	                                    ),
	                                    _react2.default.createElement(_send_transaction2.default, { name: 'ether', data: this.props.data.send_transaction })
	                                )
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(_wallet_address2.default, { data: this.props.data.wallet_address })
	            );
	        }
	    }]);
	
	    return Ethereum;
	}(_react.Component);
	
	exports.default = Ethereum;

/***/ },
/* 301 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _fuzex = __webpack_require__(103);
	
	var _fuzex2 = _interopRequireDefault(_fuzex);
	
	var _withdraw = __webpack_require__(13);
	
	var _withdraw2 = _interopRequireDefault(_withdraw);
	
	var _goback = __webpack_require__(11);
	
	var _goback2 = _interopRequireDefault(_goback);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FuzeX = function (_Component) {
	  _inherits(FuzeX, _Component);
	
	  function FuzeX() {
	    _classCallCheck(this, FuzeX);
	
	    return _possibleConstructorReturn(this, (FuzeX.__proto__ || Object.getPrototypeOf(FuzeX)).apply(this, arguments));
	  }
	
	  _createClass(FuzeX, [{
	    key: "render",
	    value: function render() {
	      var fuzexbalance = window.fuzexbalance;
	
	      var data = this.props.data.xdce;
	      //<Withdraw name="fuzex" data={this.props.data.withdraw} sendtransaction={this.props.data.send_transaction}/>
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "div",
	          { "class": "row" },
	          _react2.default.createElement(
	            "div",
	            { "class": "col-lg-12 col-md-12" },
	            _react2.default.createElement(
	              "div",
	              { "class": "card-box" },
	              _react2.default.createElement(
	                "h4",
	                { "class": "header-title m-t-0 m-b-30" },
	                "FuzeX ",
	                data.balance
	              ),
	              _react2.default.createElement(
	                "div",
	                { "class": "widget-box-2" },
	                _react2.default.createElement(
	                  "div",
	                  { "class": "widget-detail-2" },
	                  _react2.default.createElement(
	                    "h2",
	                    { "class": "m-b-0" },
	                    _react2.default.createElement("img", { src: _fuzex2.default, "class": "token64", alt: "fuzex logo" }),
	                    " ",
	                    _react2.default.createElement(
	                      "span",
	                      { id: "cobinhoodbalance" },
	                      fuzexbalance
	                    ),
	                    " "
	                  ),
	                  _react2.default.createElement(
	                    "p",
	                    { "class": "text-muted m-b-25" },
	                    "FXT"
	                  )
	                ),
	                _react2.default.createElement(_goback2.default, { data: data })
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return FuzeX;
	}(_react.Component);
	
	exports.default = FuzeX;

/***/ },
/* 302 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Golem = __webpack_require__(168);
	
	var _Golem2 = _interopRequireDefault(_Golem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Golem = function (_Component) {
	    _inherits(Golem, _Component);
	
	    function Golem() {
	        _classCallCheck(this, Golem);
	
	        return _possibleConstructorReturn(this, (Golem.__proto__ || Object.getPrototypeOf(Golem)).apply(this, arguments));
	    }
	
	    _createClass(Golem, [{
	        key: 'render',
	        value: function render() {
	            var golembalance = window.golembalance;
	
	            var data = this.props.data;
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { 'class': 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { 'class': 'col-lg-12 col-md-12' },
	                        _react2.default.createElement(
	                            'div',
	                            { 'class': 'card-box' },
	                            _react2.default.createElement(
	                                'h4',
	                                { 'class': 'header-title m-t-0 m-b-30' },
	                                'Golem ',
	                                data.balance
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { 'class': 'widget-box-2' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'widget-detail-2' },
	                                    _react2.default.createElement(
	                                        'h2',
	                                        { 'class': 'm-b-0' },
	                                        _react2.default.createElement('img', { src: _Golem2.default, 'class': 'token64', alt: 'golem logo' }),
	                                        ' ',
	                                        _react2.default.createElement(
	                                            'span',
	                                            { id: 'golembalance' },
	                                            golembalance
	                                        ),
	                                        ' '
	                                    ),
	                                    _react2.default.createElement(
	                                        'p',
	                                        { 'class': 'text-muted m-b-25' },
	                                        'GNO'
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return Golem;
	}(_react.Component);
	
	exports.default = Golem;

/***/ },
/* 303 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _inco = __webpack_require__(104);
	
	var _inco2 = _interopRequireDefault(_inco);
	
	var _withdraw = __webpack_require__(13);
	
	var _withdraw2 = _interopRequireDefault(_withdraw);
	
	var _goback = __webpack_require__(11);
	
	var _goback2 = _interopRequireDefault(_goback);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Incodium = function (_Component) {
	  _inherits(Incodium, _Component);
	
	  function Incodium() {
	    _classCallCheck(this, Incodium);
	
	    return _possibleConstructorReturn(this, (Incodium.__proto__ || Object.getPrototypeOf(Incodium)).apply(this, arguments));
	  }
	
	  _createClass(Incodium, [{
	    key: "render",
	    value: function render() {
	      var incodiumbalance = window.incodiumbalance;
	
	      var data = this.props.data.xdce;
	      //<Withdraw name="ncash" data={this.props.data.withdraw} sendtransaction={this.props.data.send_transaction}/>
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "div",
	          { "class": "row" },
	          _react2.default.createElement(
	            "div",
	            { "class": "col-lg-12 col-md-12" },
	            _react2.default.createElement(
	              "div",
	              { "class": "card-box" },
	              _react2.default.createElement(
	                "h4",
	                { "class": "header-title m-t-0 m-b-30" },
	                "Incodium ",
	                data.balance
	              ),
	              _react2.default.createElement(
	                "div",
	                { "class": "widget-box-2" },
	                _react2.default.createElement(
	                  "div",
	                  { "class": "widget-detail-2" },
	                  _react2.default.createElement(
	                    "h2",
	                    { "class": "m-b-0" },
	                    _react2.default.createElement("img", { src: _inco2.default, "class": "token64", alt: "incodium logo" }),
	                    " ",
	                    _react2.default.createElement(
	                      "span",
	                      { id: "cobinhoodbalance" },
	                      incodiumbalance
	                    ),
	                    " "
	                  ),
	                  _react2.default.createElement(
	                    "p",
	                    { "class": "text-muted m-b-25" },
	                    "INCO"
	                  )
	                ),
	                _react2.default.createElement(_goback2.default, { data: data })
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_withdraw2.default, {
	          name: "incodium",
	          data: this.props.data.withdraw,
	          sendtransaction: this.props.data.send_transaction
	        })
	      );
	    }
	  }]);
	
	  return Incodium;
	}(_react.Component);
	
	exports.default = Incodium;

/***/ },
/* 304 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _kick = __webpack_require__(246);
	
	var _kick2 = _interopRequireDefault(_kick);
	
	var _withdraw = __webpack_require__(13);
	
	var _withdraw2 = _interopRequireDefault(_withdraw);
	
	var _goback = __webpack_require__(11);
	
	var _goback2 = _interopRequireDefault(_goback);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var KickToken = function (_Component) {
	  _inherits(KickToken, _Component);
	
	  function KickToken() {
	    _classCallCheck(this, KickToken);
	
	    return _possibleConstructorReturn(this, (KickToken.__proto__ || Object.getPrototypeOf(KickToken)).apply(this, arguments));
	  }
	
	  _createClass(KickToken, [{
	    key: "render",
	    value: function render() {
	      var kickbalance = window.kickbalance;
	
	      var data = this.props.data.xdce;
	      //<Withdraw name="kicktoken" data={this.props.data.withdraw} sendtransaction={this.props.data.send_transaction}/>
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "div",
	          { "class": "row" },
	          _react2.default.createElement(
	            "div",
	            { "class": "col-lg-12 col-md-12" },
	            _react2.default.createElement(
	              "div",
	              { "class": "card-box" },
	              _react2.default.createElement(
	                "h4",
	                { "class": "header-title m-t-0 m-b-30" },
	                "KickToken ",
	                data.balance
	              ),
	              _react2.default.createElement(
	                "div",
	                { "class": "widget-box-2" },
	                _react2.default.createElement(
	                  "div",
	                  { "class": "widget-detail-2" },
	                  _react2.default.createElement(
	                    "h2",
	                    { "class": "m-b-0" },
	                    _react2.default.createElement("img", { src: _kick2.default, "class": "token64", alt: "kicktoken logo" }),
	                    " ",
	                    _react2.default.createElement(
	                      "span",
	                      { id: "cobinhoodbalance" },
	                      kickbalance
	                    ),
	                    " "
	                  ),
	                  _react2.default.createElement(
	                    "p",
	                    { "class": "text-muted m-b-25" },
	                    "KICK"
	                  )
	                ),
	                _react2.default.createElement(_goback2.default, { data: data })
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return KickToken;
	}(_react.Component);
	
	exports.default = KickToken;

/***/ },
/* 305 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mon = __webpack_require__(105);
	
	var _mon2 = _interopRequireDefault(_mon);
	
	var _withdraw = __webpack_require__(13);
	
	var _withdraw2 = _interopRequireDefault(_withdraw);
	
	var _goback = __webpack_require__(11);
	
	var _goback2 = _interopRequireDefault(_goback);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MoneyNet = function (_Component) {
	  _inherits(MoneyNet, _Component);
	
	  function MoneyNet() {
	    _classCallCheck(this, MoneyNet);
	
	    return _possibleConstructorReturn(this, (MoneyNet.__proto__ || Object.getPrototypeOf(MoneyNet)).apply(this, arguments));
	  }
	
	  _createClass(MoneyNet, [{
	    key: "render",
	    value: function render() {
	      var moneynetbalance = window.moneynetbalance;
	
	      var data = this.props.data.cobinhood;
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "div",
	          { "class": "row" },
	          _react2.default.createElement(
	            "div",
	            { "class": "col-lg-12 col-md-12" },
	            _react2.default.createElement(
	              "div",
	              { "class": "card-box" },
	              _react2.default.createElement(
	                "h4",
	                { "class": "header-title m-t-0 m-b-30" },
	                "MoneyNet ",
	                data.balance
	              ),
	              _react2.default.createElement(
	                "div",
	                { "class": "widget-box-2" },
	                _react2.default.createElement(
	                  "div",
	                  { "class": "widget-detail-2" },
	                  _react2.default.createElement(
	                    "h2",
	                    { "class": "m-b-0" },
	                    _react2.default.createElement("img", { src: _mon2.default, "class": "token64", alt: "moneynet logo" }),
	                    " ",
	                    _react2.default.createElement(
	                      "span",
	                      { id: "cobinhoodbalance" },
	                      moneynetbalance
	                    ),
	                    " "
	                  ),
	                  _react2.default.createElement(
	                    "p",
	                    { "class": "text-muted m-b-25" },
	                    "MNC"
	                  ),
	                  _react2.default.createElement(_goback2.default, { data: data })
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_withdraw2.default, {
	          name: "moneynet",
	          data: this.props.data.withdraw,
	          sendtransaction: this.props.data.send_transaction
	        })
	      );
	    }
	  }]);
	
	  return MoneyNet;
	}(_react.Component);
	
	exports.default = MoneyNet;

/***/ },
/* 306 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _nbr = __webpack_require__(170);
	
	var _nbr2 = _interopRequireDefault(_nbr);
	
	var _goback = __webpack_require__(11);
	
	var _goback2 = _interopRequireDefault(_goback);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//import Withdraw from './../functions/withdraw.js';
	
	
	var NOBAR = function (_Component) {
	  _inherits(NOBAR, _Component);
	
	  function NOBAR() {
	    _classCallCheck(this, NOBAR);
	
	    return _possibleConstructorReturn(this, (NOBAR.__proto__ || Object.getPrototypeOf(NOBAR)).apply(this, arguments));
	  }
	
	  _createClass(NOBAR, [{
	    key: "render",
	    value: function render() {
	      var nbrbalance = window.nbrbalance;
	
	      var data = this.props.data.xdce;
	      //<Withdraw name="nbr" data={this.props.data.withdraw} sendtransaction={this.props.data.send_transaction}/>
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "div",
	          { "class": "row" },
	          _react2.default.createElement(
	            "div",
	            { "class": "col-lg-12 col-md-12" },
	            _react2.default.createElement(
	              "div",
	              { "class": "card-box" },
	              _react2.default.createElement(
	                "h4",
	                { "class": "header-title m-t-0 m-b-30" },
	                "NOBAR ",
	                data.balance
	              ),
	              _react2.default.createElement(
	                "div",
	                { "class": "widget-box-2" },
	                _react2.default.createElement(
	                  "div",
	                  { "class": "widget-detail-2" },
	                  _react2.default.createElement(
	                    "h2",
	                    { "class": "m-b-0" },
	                    _react2.default.createElement("img", { src: _nbr2.default, "class": "token64", alt: "nbr logo" }),
	                    " ",
	                    _react2.default.createElement(
	                      "span",
	                      { id: "cobinhoodbalance" },
	                      nbrbalance
	                    ),
	                    " "
	                  ),
	                  _react2.default.createElement(
	                    "p",
	                    { "class": "text-muted m-b-25" },
	                    "NBR"
	                  )
	                ),
	                _react2.default.createElement(_goback2.default, { data: data })
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return NOBAR;
	}(_react.Component);
	
	exports.default = NOBAR;

/***/ },
/* 307 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ncash = __webpack_require__(70);
	
	var _ncash2 = _interopRequireDefault(_ncash);
	
	var _withdraw = __webpack_require__(13);
	
	var _withdraw2 = _interopRequireDefault(_withdraw);
	
	var _goback = __webpack_require__(11);
	
	var _goback2 = _interopRequireDefault(_goback);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NCash = function (_Component) {
	  _inherits(NCash, _Component);
	
	  function NCash() {
	    _classCallCheck(this, NCash);
	
	    return _possibleConstructorReturn(this, (NCash.__proto__ || Object.getPrototypeOf(NCash)).apply(this, arguments));
	  }
	
	  _createClass(NCash, [{
	    key: "render",
	    value: function render() {
	      var ncashbalance = window.ncashbalance;
	
	      var data = this.props.data.xdce;
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "div",
	          { "class": "row" },
	          _react2.default.createElement(
	            "div",
	            { "class": "col-lg-12 col-md-12" },
	            _react2.default.createElement(
	              "div",
	              { "class": "card-box" },
	              _react2.default.createElement(
	                "h4",
	                { "class": "header-title m-t-0 m-b-30" },
	                "NCash ",
	                data.balance
	              ),
	              _react2.default.createElement(
	                "div",
	                { "class": "widget-box-2" },
	                _react2.default.createElement(
	                  "div",
	                  { "class": "widget-detail-2" },
	                  _react2.default.createElement(
	                    "h2",
	                    { "class": "m-b-0" },
	                    _react2.default.createElement("img", { src: _ncash2.default, "class": "token64", alt: "ncash logo" }),
	                    " ",
	                    _react2.default.createElement(
	                      "span",
	                      { id: "cobinhoodbalance" },
	                      ncashbalance
	                    ),
	                    " "
	                  ),
	                  _react2.default.createElement(
	                    "p",
	                    { "class": "text-muted m-b-25" },
	                    "NCASH"
	                  )
	                ),
	                _react2.default.createElement(_goback2.default, { data: data })
	              )
	            ),
	            _react2.default.createElement(_withdraw2.default, { name: "ncash", data: this.props.data.withdraw, sendtransaction: this.props.data.send_transaction })
	          )
	        )
	      );
	    }
	  }]);
	
	  return NCash;
	}(_react.Component);
	
	exports.default = NCash;

/***/ },
/* 308 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _orbsLogo = __webpack_require__(71);
	
	var _orbsLogo2 = _interopRequireDefault(_orbsLogo);
	
	var _withdraw = __webpack_require__(13);
	
	var _withdraw2 = _interopRequireDefault(_withdraw);
	
	var _goback = __webpack_require__(11);
	
	var _goback2 = _interopRequireDefault(_goback);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Orbs = function (_Component) {
	  _inherits(Orbs, _Component);
	
	  function Orbs() {
	    _classCallCheck(this, Orbs);
	
	    return _possibleConstructorReturn(this, (Orbs.__proto__ || Object.getPrototypeOf(Orbs)).apply(this, arguments));
	  }
	
	  _createClass(Orbs, [{
	    key: "render",
	    value: function render() {
	      var orbsbalance = window.orbsbalance;
	
	      var data = this.props.data.wandx;
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "div",
	          { "class": "row" },
	          _react2.default.createElement(
	            "div",
	            { "class": "col-lg-12 col-md-12" },
	            _react2.default.createElement(
	              "div",
	              { "class": "card-box" },
	              _react2.default.createElement(
	                "h4",
	                { "class": "header-title m-t-0 m-b-30" },
	                "Orbs ",
	                data.balance
	              ),
	              _react2.default.createElement(
	                "div",
	                { "class": "widget-box-2" },
	                _react2.default.createElement(
	                  "div",
	                  { "class": "widget-detail-2" },
	                  _react2.default.createElement(
	                    "h2",
	                    { "class": "m-b-0" },
	                    _react2.default.createElement("img", { src: _orbsLogo2.default, "class": "token64", alt: "orbs logo" }),
	                    " ",
	                    _react2.default.createElement(
	                      "span",
	                      { id: "cobinhoodbalance" },
	                      orbsbalance
	                    ),
	                    " "
	                  ),
	                  _react2.default.createElement(
	                    "p",
	                    { "class": "text-muted m-b-25" },
	                    "ORBS"
	                  )
	                ),
	                _react2.default.createElement(_goback2.default, { data: data })
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_withdraw2.default, {
	          name: "orbs",
	          data: this.props.data.withdraw,
	          sendtransaction: this.props.data.send_transaction
	        })
	      );
	    }
	  }]);
	
	  return Orbs;
	}(_react.Component);
	
	exports.default = Orbs;

/***/ },
/* 309 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _singularity = __webpack_require__(72);
	
	var _singularity2 = _interopRequireDefault(_singularity);
	
	var _withdraw = __webpack_require__(13);
	
	var _withdraw2 = _interopRequireDefault(_withdraw);
	
	var _goback = __webpack_require__(11);
	
	var _goback2 = _interopRequireDefault(_goback);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SingularityNet = function (_Component) {
	  _inherits(SingularityNet, _Component);
	
	  function SingularityNet() {
	    _classCallCheck(this, SingularityNet);
	
	    return _possibleConstructorReturn(this, (SingularityNet.__proto__ || Object.getPrototypeOf(SingularityNet)).apply(this, arguments));
	  }
	
	  _createClass(SingularityNet, [{
	    key: "render",
	    value: function render() {
	      var agibalance = window.agibalance;
	
	      var data = this.props.data.xdce;
	      //            <Withdraw name="ncash" data={this.props.data.withdraw} sendtransaction={this.props.data.send_transaction}/>
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "div",
	          { "class": "row" },
	          _react2.default.createElement(
	            "div",
	            { "class": "col-lg-12 col-md-12" },
	            _react2.default.createElement(
	              "div",
	              { "class": "card-box" },
	              _react2.default.createElement(
	                "h4",
	                { "class": "header-title m-t-0 m-b-30" },
	                "SingularityNet ",
	                data.balance
	              ),
	              _react2.default.createElement(
	                "div",
	                { "class": "widget-box-2" },
	                _react2.default.createElement(
	                  "div",
	                  { "class": "widget-detail-2" },
	                  _react2.default.createElement(
	                    "h2",
	                    { "class": "m-b-0" },
	                    _react2.default.createElement("img", { src: _singularity2.default, "class": "token64", alt: "SingularityNet logo" }),
	                    " ",
	                    _react2.default.createElement(
	                      "span",
	                      { id: "cobinhoodbalance" },
	                      agibalance
	                    ),
	                    " "
	                  ),
	                  _react2.default.createElement(
	                    "p",
	                    { "class": "text-muted m-b-25" },
	                    "AGI"
	                  )
	                ),
	                _react2.default.createElement(_goback2.default, { data: data })
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_withdraw2.default, {
	          name: "singularitynet",
	          data: this.props.data.withdraw,
	          sendtransaction: this.props.data.send_transaction
	        })
	      );
	    }
	  }]);
	
	  return SingularityNet;
	}(_react.Component);
	
	exports.default = SingularityNet;

/***/ },
/* 310 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _stacsLogo = __webpack_require__(73);
	
	var _stacsLogo2 = _interopRequireDefault(_stacsLogo);
	
	var _withdraw = __webpack_require__(13);
	
	var _withdraw2 = _interopRequireDefault(_withdraw);
	
	var _goback = __webpack_require__(11);
	
	var _goback2 = _interopRequireDefault(_goback);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Stacs = function (_Component) {
	  _inherits(Stacs, _Component);
	
	  function Stacs() {
	    _classCallCheck(this, Stacs);
	
	    return _possibleConstructorReturn(this, (Stacs.__proto__ || Object.getPrototypeOf(Stacs)).apply(this, arguments));
	  }
	
	  _createClass(Stacs, [{
	    key: "render",
	    value: function render() {
	      var stacsbalance = window.stacsbalance;
	
	      var data = this.props.data.wandx;
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "div",
	          { "class": "row" },
	          _react2.default.createElement(
	            "div",
	            { "class": "col-lg-12 col-md-12" },
	            _react2.default.createElement(
	              "div",
	              { "class": "card-box" },
	              _react2.default.createElement(
	                "h4",
	                { "class": "header-title m-t-0 m-b-30" },
	                "Stacs ",
	                data.balance
	              ),
	              _react2.default.createElement(
	                "div",
	                { "class": "widget-box-2" },
	                _react2.default.createElement(
	                  "div",
	                  { "class": "widget-detail-2" },
	                  _react2.default.createElement(
	                    "h2",
	                    { "class": "m-b-0" },
	                    _react2.default.createElement("img", { src: _stacsLogo2.default, "class": "token64", alt: "stacs logo" }),
	                    " ",
	                    _react2.default.createElement(
	                      "span",
	                      { id: "cobinhoodbalance" },
	                      stacsbalance
	                    ),
	                    " "
	                  ),
	                  _react2.default.createElement(
	                    "p",
	                    { "class": "text-muted m-b-25" },
	                    "STACS"
	                  )
	                ),
	                _react2.default.createElement(_goback2.default, { data: data })
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_withdraw2.default, {
	          name: "stacs",
	          data: this.props.data.withdraw,
	          sendtransaction: this.props.data.send_transaction
	        })
	      );
	    }
	  }]);
	
	  return Stacs;
	}(_react.Component);
	
	exports.default = Stacs;

/***/ },
/* 311 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _wandx = __webpack_require__(74);
	
	var _wandx2 = _interopRequireDefault(_wandx);
	
	var _withdraw = __webpack_require__(13);
	
	var _withdraw2 = _interopRequireDefault(_withdraw);
	
	var _goback = __webpack_require__(11);
	
	var _goback2 = _interopRequireDefault(_goback);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var WandX = function (_Component) {
	  _inherits(WandX, _Component);
	
	  function WandX() {
	    _classCallCheck(this, WandX);
	
	    return _possibleConstructorReturn(this, (WandX.__proto__ || Object.getPrototypeOf(WandX)).apply(this, arguments));
	  }
	
	  _createClass(WandX, [{
	    key: "render",
	    value: function render() {
	      var wandxbalance = window.wandxbalance;
	
	      var data = this.props.data.wandx;
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "div",
	          { "class": "row" },
	          _react2.default.createElement(
	            "div",
	            { "class": "col-lg-12 col-md-12" },
	            _react2.default.createElement(
	              "div",
	              { "class": "card-box" },
	              _react2.default.createElement(
	                "h4",
	                { "class": "header-title m-t-0 m-b-30" },
	                "WandX ",
	                data.balance
	              ),
	              _react2.default.createElement(
	                "div",
	                { "class": "widget-box-2" },
	                _react2.default.createElement(
	                  "div",
	                  { "class": "widget-detail-2" },
	                  _react2.default.createElement(
	                    "h2",
	                    { "class": "m-b-0" },
	                    _react2.default.createElement("img", { src: _wandx2.default, "class": "token64", alt: "wandx logo" }),
	                    " ",
	                    _react2.default.createElement(
	                      "span",
	                      { id: "cobinhoodbalance" },
	                      wandxbalance
	                    ),
	                    " "
	                  ),
	                  _react2.default.createElement(
	                    "p",
	                    { "class": "text-muted m-b-25" },
	                    "WAND"
	                  )
	                ),
	                _react2.default.createElement(_goback2.default, { data: data })
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_withdraw2.default, {
	          name: "wandx",
	          data: this.props.data.withdraw,
	          sendtransaction: this.props.data.send_transaction
	        })
	      );
	    }
	  }]);
	
	  return WandX;
	}(_react.Component);
	
	exports.default = WandX;

/***/ },
/* 312 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _xyo = __webpack_require__(75);
	
	var _xyo2 = _interopRequireDefault(_xyo);
	
	var _withdraw = __webpack_require__(13);
	
	var _withdraw2 = _interopRequireDefault(_withdraw);
	
	var _goback = __webpack_require__(11);
	
	var _goback2 = _interopRequireDefault(_goback);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var XYO = function (_Component) {
	  _inherits(XYO, _Component);
	
	  function XYO() {
	    _classCallCheck(this, XYO);
	
	    return _possibleConstructorReturn(this, (XYO.__proto__ || Object.getPrototypeOf(XYO)).apply(this, arguments));
	  }
	
	  _createClass(XYO, [{
	    key: "render",
	    value: function render() {
	      var xyobalance = window.xyobalance;
	
	      var data = this.props.data.xdce;
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "div",
	          { "class": "row" },
	          _react2.default.createElement(
	            "div",
	            { "class": "col-lg-12 col-md-12" },
	            _react2.default.createElement(
	              "div",
	              { "class": "card-box" },
	              _react2.default.createElement(
	                "h4",
	                { "class": "header-title m-t-0 m-b-30" },
	                "XYO ",
	                data.balance
	              ),
	              _react2.default.createElement(
	                "div",
	                { "class": "widget-box-2" },
	                _react2.default.createElement(
	                  "div",
	                  { "class": "widget-detail-2" },
	                  _react2.default.createElement(
	                    "h2",
	                    { "class": "m-b-0" },
	                    _react2.default.createElement("img", { src: _xyo2.default, "class": "token64", alt: "xyo logo" }),
	                    " ",
	                    _react2.default.createElement(
	                      "span",
	                      { id: "cobinhoodbalance" },
	                      xyobalance
	                    ),
	                    " "
	                  ),
	                  _react2.default.createElement(
	                    "p",
	                    { "class": "text-muted m-b-25" },
	                    "XYO"
	                  )
	                ),
	                _react2.default.createElement(_goback2.default, { data: data })
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_withdraw2.default, { name: "xyo", data: this.props.data.withdraw, sendtransaction: this.props.data.send_transaction })
	      );
	    }
	  }]);
	
	  return XYO;
	}(_react.Component);
	
	exports.default = XYO;

/***/ },
/* 313 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _topbar = __webpack_require__(325);
	
	var _topbar2 = _interopRequireDefault(_topbar);
	
	var _leftsidebar = __webpack_require__(319);
	
	var _leftsidebar2 = _interopRequireDefault(_leftsidebar);
	
	var _rightcontent = __webpack_require__(321);
	
	var _rightcontent2 = _interopRequireDefault(_rightcontent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Dashboard = function (_Component) {
	  _inherits(Dashboard, _Component);
	
	  function Dashboard() {
	    _classCallCheck(this, Dashboard);
	
	    return _possibleConstructorReturn(this, (Dashboard.__proto__ || Object.getPrototypeOf(Dashboard)).apply(this, arguments));
	  }
	
	  _createClass(Dashboard, [{
	    key: 'render',
	    value: function render() {
	      var data = this.props.data;
	      var switchLanguage = this.props.switchLanguage;
	
	      return _react2.default.createElement(
	        'div',
	        { id: 'wrapper' },
	        _react2.default.createElement(_topbar2.default, { data: data.topbar, switchLanguage: switchLanguage }),
	        _react2.default.createElement(_leftsidebar2.default, { data: data.leftsidebar }),
	        _react2.default.createElement(_rightcontent2.default, { name: this.props.page.params.name, data: data })
	      );
	    }
	  }]);
	
	  return Dashboard;
	}(_react.Component);
	
	exports.default = Dashboard;

/***/ },
/* 314 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Aidao = __webpack_require__(47);
	
	var _Aidao2 = _interopRequireDefault(_Aidao);
	
	var _popup = __webpack_require__(28);
	
	var _popup2 = _interopRequireDefault(_popup);
	
	var _jquery = __webpack_require__(14);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _axios = __webpack_require__(27);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _qs = __webpack_require__(31);
	
	var _qs2 = _interopRequireDefault(_qs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EmailVerification = function (_Component) {
	  _inherits(EmailVerification, _Component);
	
	  function EmailVerification() {
	    _classCallCheck(this, EmailVerification);
	
	    return _possibleConstructorReturn(this, (EmailVerification.__proto__ || Object.getPrototypeOf(EmailVerification)).apply(this, arguments));
	  }
	
	  _createClass(EmailVerification, [{
	    key: 'render',
	    value: function render() {
	
	      var data = this.props.data;
	      var email_verified = window.email_verified;
	
	      var openup = function openup() {
	        (0, _jquery2.default)("#email-verification-button").html(data.sendEmail);
	        (0, _jquery2.default)('#email-verification-button').prop('disabled', false);
	        (0, _jquery2.default)('#email-verifcation-close').click();
	      };
	
	      var emailsent = function emailsent() {
	        _axios2.default.defaults.xsrfCookieName = 'csrftoken';
	        _axios2.default.defaults.xsrfHeaderName = 'X-CSRFToken';
	
	        (0, _jquery2.default)("#email-verification-button").html(data.send);
	        (0, _jquery2.default)('#email-verification-button').prop('disabled', true);
	
	        var request = _axios2.default.post('/api/emailverification', _qs2.default.stringify({
	          "email": (0, _jquery2.default)("#email-verification-input").val()
	        }));
	        request.then(function (response) {
	          _popup2.default.prototype.show(response.data.status);
	          openup();
	        });
	        request.catch(function (error) {
	          _popup2.default.prototype.show(data.failed + ":\n" + error.response.data.message);
	          openup();
	        });
	      };
	
	      if (email_verified === "True") {
	        (0, _jquery2.default)(document).ready(function () {
	          (0, _jquery2.default)('#sending-email-verification-button').html(data.activate);
	          (0, _jquery2.default)('#sending-email-verification-button').prop('disabled', true);
	          (0, _jquery2.default)('#sending-email-verification-button').removeClass('btn-default');
	          (0, _jquery2.default)('#sending-email-verification-button').addClass('btn-success');
	        });
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { 'class': 'row' },
	        _react2.default.createElement(
	          'div',
	          { 'class': 'col-md-12' },
	          _react2.default.createElement(
	            'div',
	            { 'class': 'card-box' },
	            _react2.default.createElement(
	              'div',
	              { 'class': 'text-left m-t-20' },
	              _react2.default.createElement(
	                'h4',
	                { 'class': 'header-title m-t-0 m-b-30' },
	                data.emailVerification
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                data.verifyEmail
	              ),
	              _react2.default.createElement(
	                'div',
	                { 'class': 'm-b-20 ' },
	                _react2.default.createElement(
	                  'button',
	                  { id: 'sending-email-verification-button', type: 'button', 'data-toggle': 'modal', 'data-target': '#email-verification-modal', 'class': 'btn btn-default btn-lg waves-effect waves-light' },
	                  data.sendVerificationEmail
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { id: 'email-verification-modal', 'class': 'modal fade in', tabIndex: '-1', role: 'dialog', 'aria-labelledby': 'myModalLabel', 'aria-hidden': 'true' },
	          _react2.default.createElement(
	            'div',
	            { 'class': 'modal-dialog' },
	            _react2.default.createElement(
	              'div',
	              { 'class': 'fixed-card-box' },
	              _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'button',
	                  { id: 'email-verifcation-close', type: 'button', 'class': 'close', 'data-dismiss': 'modal', 'aria-hidden': 'true' },
	                  '\xD7'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { 'class': 'otp-icon-center' },
	                _react2.default.createElement('img', { src: _Aidao2.default, alt: 'aidao', 'class': 'token64' })
	              ),
	              _react2.default.createElement(
	                'h3',
	                { 'class': 'm-t-10 m-b-20 text-center' },
	                data.confirmEmail
	              ),
	              _react2.default.createElement(
	                'p',
	                { 'class': 'text-center m-b-20' },
	                data.enterEmail
	              ),
	              _react2.default.createElement(
	                'div',
	                { 'class': 'half-center' },
	                _react2.default.createElement('input', { 'class': 'form-control center-input', id: 'email-verification-input', name: '2fa type=text' }),
	                _react2.default.createElement('div', { 'class': 'm-b-20' }),
	                _react2.default.createElement(
	                  'button',
	                  { id: 'email-verification-button', 'class': 'btn btn-default btn-block waves-effect waves-light text-center', onClick: emailsent },
	                  data.sendEmail
	                ),
	                _react2.default.createElement('div', { 'class': 'm-b-20' })
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return EmailVerification;
	}(_react.Component);
	
	exports.default = EmailVerification;

/***/ },
/* 315 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _formData = __webpack_require__(356);
	
	var _formData2 = _interopRequireDefault(_formData);
	
	var _jquery = __webpack_require__(14);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _axios = __webpack_require__(27);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _passport = __webpack_require__(573);
	
	var _passport2 = _interopRequireDefault(_passport);
	
	var _selfie = __webpack_require__(574);
	
	var _selfie2 = _interopRequireDefault(_selfie);
	
	var _popup = __webpack_require__(28);
	
	var _popup2 = _interopRequireDefault(_popup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var KYCUpload = function (_Component) {
	  _inherits(KYCUpload, _Component);
	
	  function KYCUpload() {
	    _classCallCheck(this, KYCUpload);
	
	    return _possibleConstructorReturn(this, (KYCUpload.__proto__ || Object.getPrototypeOf(KYCUpload)).apply(this, arguments));
	  }
	
	  _createClass(KYCUpload, [{
	    key: 'render',
	    value: function render() {
	      var kycprogress = window.kycprogress;
	
	      (0, _jquery2.default)(document).ready(function () {
	        var accordion;
	        if (kycprogress === "approved") {
	          accordion = (0, _jquery2.default)('#kyc_document_accordion');
	          accordion.html("Your KYC has been approved");
	        } else if (kycprogress === "waiting") {
	          accordion = (0, _jquery2.default)('#kyc_document_accordion');
	          accordion.html("Your documents has been uploaded. To re-upload, please contact us at admin@daotoken.io");
	        }
	      });
	
	      var show_kycUpgrade = function show_kycUpgrade() {
	        var show_accordion = (0, _jquery2.default)(".kycUpgrade");
	        var panel = show_accordion.next();
	        if (panel.css("maxHeight") !== "0px") {
	          panel.css("maxHeight", "0px");
	        } else {
	          panel.css("maxHeight", panel.prop('scrollHeight') + "0px");
	        }
	      };
	
	      var uploaded_passport = function uploaded_passport() {
	        var passport = (0, _jquery2.default)('#passport-file');
	        (0, _jquery2.default)('#passport-name').html(passport.prop("files")[0].name);
	      };
	
	      var uploaded_photo = function uploaded_photo() {
	        var photo = (0, _jquery2.default)('#kyc-photo');
	        (0, _jquery2.default)('#photo-name').html(photo.prop("files")[0].name);
	      };
	
	      var kycfiles = function kycfiles() {
	
	        var config = {
	          headers: { 'content-type': 'multipart/form-data' }
	        };
	
	        _axios2.default.defaults.xsrfCookieName = 'csrftoken';
	        _axios2.default.defaults.xsrfHeaderName = 'X-CSRFToken';
	
	        var form = new _formData2.default();
	        var passport = (0, _jquery2.default)('#passport-file').prop("files")[0];
	        var photo = (0, _jquery2.default)('#kyc-photo').prop("files")[0];
	
	        console.log(passport);
	        console.log(photo);
	
	        if (passport && photo) {
	
	          if (passport.size < 1048576 && photo.size < 1048576) {
	
	            if (passport.type.includes("image/") && photo.type.includes("image/")) {
	              form.append("passport", passport, passport.name);
	              form.append("photo", photo, photo.name);
	
	              _axios2.default.post('/api/kycfiles', form, config).then(function (response) {
	                _popup2.default.prototype.show("Successfully uploaded, please wait for the approval");
	                var accordion = (0, _jquery2.default)('#kyc_document_accordion');
	                accordion.html("Your documents has been uploaded. To re-upload, please contact us at admin@daotoken.io");
	              }).catch(function (error) {
	                _popup2.default.prototype.show("failed");
	              });
	            } else {
	              _popup2.default.prototype.show("You have to upload image files");
	            }
	          } else {
	            _popup2.default.prototype.show("The files you uploaded more than 1 megabyte");
	          }
	        } else {
	          _popup2.default.prototype.show("You have to submit both documents");
	        }
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { 'class': 'row' },
	        _react2.default.createElement(
	          'div',
	          { 'class': 'col-lg-12 col-md-12 m-b-20', id: 'kyc_document_accordion' },
	          _react2.default.createElement(
	            'button',
	            { 'class': 'kycUpgrade accordion_green btn-block text-left active', onClick: show_kycUpgrade },
	            'Upgrade your kyc level'
	          ),
	          _react2.default.createElement(
	            'div',
	            { 'class': 'accordion_panel' },
	            _react2.default.createElement(
	              'div',
	              { 'class': 'row' },
	              _react2.default.createElement(
	                'p',
	                { 'class': 'm-s-20', id: 'information' },
	                'Upload image of your passport and selfie holding your passport to upgrade your kyc level'
	              ),
	              _react2.default.createElement(
	                'div',
	                { 'class': 'col-lg-6 col-md-6' },
	                _react2.default.createElement('div', { 'class': 'm-t-20' }),
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  _react2.default.createElement(
	                    'h5',
	                    null,
	                    'Passport Photo:'
	                  ),
	                  _react2.default.createElement('input', { onChange: uploaded_passport, 'class': 'visuallyhidden passport', type: 'file', name: 'passport', id: 'passport-file' }),
	                  _react2.default.createElement(
	                    'label',
	                    { 'for': 'passport-file', 'class': 'm-r-10 btn btn-blue w-md waves-effect waves-light' },
	                    _react2.default.createElement(
	                      'strong',
	                      null,
	                      'Choose a file'
	                    ),
	                    _react2.default.createElement('span', { 'class': 'box__dragndrop' })
	                  ),
	                  _react2.default.createElement('p', { id: 'passport-name', 'class': 'm-t-20' })
	                )
	              ),
	              _react2.default.createElement('div', { 'class': 'm-b-20' }),
	              _react2.default.createElement(
	                'div',
	                { 'class': 'col-lg-6 col-md-6' },
	                _react2.default.createElement('img', { src: _passport2.default, alt: 'passport example', 'class': 'kyc_example_img' })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { 'class': 'row' },
	              _react2.default.createElement(
	                'div',
	                { 'class': 'col-lg-6 col-md-6' },
	                _react2.default.createElement('div', { 'class': 'm-t-20' }),
	                _react2.default.createElement(
	                  'h5',
	                  null,
	                  'Personal Photo:'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  _react2.default.createElement('input', { onChange: uploaded_photo, id: 'kyc-photo', 'class': 'visuallyhidden', type: 'file', name: 'photo' }),
	                  _react2.default.createElement(
	                    'label',
	                    { 'for': 'kyc-photo', 'class': 'm-r-10 btn btn-blue w-md waves-effect waves-light' },
	                    _react2.default.createElement(
	                      'strong',
	                      null,
	                      'Choose a file'
	                    ),
	                    _react2.default.createElement('span', { 'class': 'box__dragndrop' })
	                  ),
	                  _react2.default.createElement('p', { id: 'photo-name', 'class': 'm-t-20' })
	                ),
	                _react2.default.createElement('div', { 'class': 'm-t-20' }),
	                _react2.default.createElement(
	                  'button',
	                  { id: 'upload-button', 'class': 'btn-green w-md waves-effect waves-light', onClick: kycfiles },
	                  'Upload'
	                )
	              ),
	              _react2.default.createElement('div', { 'class': 'm-b-20' }),
	              _react2.default.createElement(
	                'div',
	                { 'class': 'col-lg-6 col-md-6' },
	                _react2.default.createElement('img', { src: _selfie2.default, alt: 'selfie with passport example', 'class': 'kyc_example_img' })
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              { 'class': 'm-t-20 m-b-20' },
	              'Upload both of photos and wait for approval. Pending will take 5-10 working days.'
	            ),
	            _react2.default.createElement(
	              'p',
	              { 'class': 'm-t-20 m-b-20' },
	              'If you have any questions, please contact us through daotokenwallet@gmail.com'
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return KYCUpload;
	}(_react.Component);
	
	exports.default = KYCUpload;

/***/ },
/* 316 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Aidao = __webpack_require__(47);
	
	var _Aidao2 = _interopRequireDefault(_Aidao);
	
	var _popup = __webpack_require__(28);
	
	var _popup2 = _interopRequireDefault(_popup);
	
	var _jquery = __webpack_require__(14);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _axios = __webpack_require__(27);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _qs = __webpack_require__(31);
	
	var _qs2 = _interopRequireDefault(_qs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var OTP = function (_Component) {
	  _inherits(OTP, _Component);
	
	  function OTP() {
	    _classCallCheck(this, OTP);
	
	    return _possibleConstructorReturn(this, (OTP.__proto__ || Object.getPrototypeOf(OTP)).apply(this, arguments));
	  }
	
	  _createClass(OTP, [{
	    key: 'render',
	    value: function render() {
	
	      var data = this.props.data;
	
	      var otp = window.otp;
	      if (otp === "True") {
	        (0, _jquery2.default)(document).ready(function () {
	          (0, _jquery2.default)('#google-authenticator').html(data.enabled);
	          (0, _jquery2.default)('#google-authenticator').prop('disabled', true);
	          (0, _jquery2.default)('#google-authenticator').removeClass('btn-default');
	          (0, _jquery2.default)('#google-authenticator').addClass('btn-success');
	        });
	      }
	
	      var getqrcode = function getqrcode() {
	        _axios2.default.defaults.xsrfCookieName = 'csrftoken';
	        _axios2.default.defaults.xsrfHeaderName = 'X-CSRFToken';
	        var request = _axios2.default.get('/api/addopt');
	        request.then(function (response) {
	          (0, _jquery2.default)("#insert-qr-image").html(response.data.image);
	        });
	        request.catch(function (error) {
	          _popup2.default.prototype.show(data.failed + ":\n" + error.response.data.message);
	        });
	      };
	
	      var confirmqrcode = function confirmqrcode() {
	        _axios2.default.defaults.xsrfCookieName = 'csrftoken';
	        _axios2.default.defaults.xsrfHeaderName = 'X-CSRFToken';
	        console.log((0, _jquery2.default)("#confirm-token").val());
	        var request = _axios2.default.post('/api/addopt', _qs2.default.stringify({
	          "token": (0, _jquery2.default)("#confirm-token").val()
	        }));
	        request.then(function (response) {
	          _popup2.default.prototype.show(response.data.status);
	          window.location.reload();
	        });
	        request.catch(function (error) {
	          _popup2.default.prototype.show(data.failed + ":\n" + error.response.data.message);
	        });
	      };
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { 'class': 'row' },
	          _react2.default.createElement(
	            'div',
	            { 'class': 'col-md-12' },
	            _react2.default.createElement(
	              'div',
	              { 'class': 'card-box' },
	              _react2.default.createElement(
	                'div',
	                { 'class': 'text-left m-t-20' },
	                _react2.default.createElement(
	                  'h4',
	                  { 'class': 'header-title m-t-0 m-b-30' },
	                  data.twoFaVerification
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  data.noticeTwoFa
	                ),
	                _react2.default.createElement('div', { 'class': 'm-b-20' }),
	                _react2.default.createElement(
	                  'button',
	                  { id: 'google-authenticator', 'class': 'btn btn-default btn-lg waves-effect waves-light', 'data-toggle': 'modal', 'data-target': '#otp-modal', onClick: getqrcode },
	                  data.verifyGoogle2FA
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { id: 'otp-modal', 'class': 'modal fade in', tabIndex: '-1', role: 'dialog', 'aria-labelledby': 'myModalLabel', 'aria-hidden': 'true' },
	          _react2.default.createElement(
	            'div',
	            { 'class': 'modal-dialog' },
	            _react2.default.createElement(
	              'div',
	              { 'class': 'fixed-card-box' },
	              _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'button',
	                  { type: 'button', 'class': 'close', 'data-dismiss': 'modal', 'aria-hidden': 'true' },
	                  '\xD7'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { 'class': 'otp-icon-center' },
	                _react2.default.createElement('img', { src: _Aidao2.default, alt: 'aidao', 'class': 'token64' })
	              ),
	              _react2.default.createElement(
	                'h3',
	                { 'class': 'm-t-10 m-b-20 text-center' },
	                data.googleVerification
	              ),
	              _react2.default.createElement(
	                'h5',
	                { 'class': 'm-t-10 m-b-20 text-center' },
	                data.firstStep
	              ),
	              _react2.default.createElement(
	                'p',
	                { 'class': 'text-center m-b-20' },
	                data.scanQRcode
	              ),
	              _react2.default.createElement(
	                'div',
	                { 'class': 'qr_code', id: 'insert-qr-image' },
	                data.qrcode
	              ),
	              _react2.default.createElement('div', { 'class': 'm-t-20' }),
	              _react2.default.createElement(
	                'h5',
	                { 'class': 'm-t-10 m-b-20 text-center' },
	                data.secondStep
	              ),
	              _react2.default.createElement('p', { 'class': 'text-center m-b-20' }),
	              _react2.default.createElement(
	                'div',
	                { 'class': 'half-center' },
	                _react2.default.createElement('input', { 'class': 'form-control center-input', id: 'confirm-token', name: '2fa type=text' }),
	                _react2.default.createElement('div', { 'class': 'm-b-20' }),
	                _react2.default.createElement(
	                  'button',
	                  { 'class': 'btn btn-default btn-block waves-effect waves-light text-center', onClick: confirmqrcode },
	                  data.confirm
	                ),
	                _react2.default.createElement('div', { 'class': 'm-b-20' })
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return OTP;
	}(_react.Component);
	
	exports.default = OTP;

/***/ },
/* 317 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(14);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _axios = __webpack_require__(27);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _qs = __webpack_require__(31);
	
	var _qs2 = _interopRequireDefault(_qs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Pending = function (_Component) {
	  _inherits(Pending, _Component);
	
	  function Pending() {
	    _classCallCheck(this, Pending);
	
	    return _possibleConstructorReturn(this, (Pending.__proto__ || Object.getPrototypeOf(Pending)).apply(this, arguments));
	  }
	
	  _createClass(Pending, [{
	    key: 'getpending',
	    value: function getpending() {
	      _axios2.default.defaults.xsrfCookieName = 'csrftoken';
	      _axios2.default.defaults.xsrfHeaderName = 'X-CSRFToken';
	
	      _axios2.default.post('/api/pendingcount', _qs2.default.stringify({
	        "address": window.address
	      })).then(function (response) {
	        if (response.data.excess > 0) {
	          (0, _jquery2.default)(".pending-transaction").html(response.data.excess);
	        } else {
	          (0, _jquery2.default)(".pending-transaction").html("0");
	        }
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	
	      var data = this.props.data;
	
	      this.getpending();
	
	      return _react2.default.createElement(
	        'div',
	        { 'class': 'row' },
	        _react2.default.createElement(
	          'div',
	          { 'class': 'col-lg-12 col-md-12' },
	          _react2.default.createElement(
	            'div',
	            { 'class': 'card-box' },
	            _react2.default.createElement(
	              'h2',
	              { 'class': 'header-title m-t-0 m-b-30' },
	              data.transactionPending
	            ),
	            _react2.default.createElement(
	              'h5',
	              null,
	              data.numberofPending,
	              ':',
	              _react2.default.createElement('span', { 'class': 'badge badge-success pending-transaction pull-right' })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Pending;
	}(_react.Component);
	
	exports.default = Pending;

/***/ },
/* 318 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(14);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _axios = __webpack_require__(27);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _qs = __webpack_require__(31);
	
	var _qs2 = _interopRequireDefault(_qs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var History = function (_Component) {
	    _inherits(History, _Component);
	
	    function History() {
	        _classCallCheck(this, History);
	
	        return _possibleConstructorReturn(this, (History.__proto__ || Object.getPrototypeOf(History)).apply(this, arguments));
	    }
	
	    _createClass(History, [{
	        key: 'render',
	        value: function render() {
	
	            var data = this.props.data;
	
	            _axios2.default.defaults.xsrfCookieName = 'csrftoken';
	            _axios2.default.defaults.xsrfHeaderName = 'X-CSRFToken';
	
	            _axios2.default.post('/api/history', _qs2.default.stringify({
	                "address": window.address
	            })).then(function (response) {
	                var histories = response.data.info;
	                var active = "";
	                if (histories.length === 0) {
	                    (0, _jquery2.default)("#history-table").html("");
	                    (0, _jquery2.default)("#history-indication").html(data.noHistory);
	                }
	
	                histories = histories.slice(0, 10);
	
	                (0, _jquery2.default)("#history-tbody").html("");
	                histories.map(function (history) {
	                    if (active) {
	                        active = "";
	                    } else {
	                        active = "active";
	                    }
	                    (0, _jquery2.default)("#history-tbody").append('<tr class=' + active + '>\n                    <th scope="row">' + history.date + '</th>\n                    <td class="word-break">' + history.status + '</td>\n                    <td class="word-break">' + history.token + '</td>\n                    <td class="word-break">' + history.amount + '</td>\n                    <td class="word-break">' + history.transactionhash + '</td>\n                </tr>');
	                    return null;
	                });
	            });
	
	            return _react2.default.createElement(
	                'div',
	                { 'class': 'row' },
	                _react2.default.createElement(
	                    'div',
	                    { 'class': 'col-lg-12 col-md-12' },
	                    _react2.default.createElement(
	                        'div',
	                        { 'class': 'card-box' },
	                        _react2.default.createElement(
	                            'h4',
	                            { 'class': 'header-title m-t-0 m-b-30' },
	                            data.history
	                        ),
	                        _react2.default.createElement(
	                            'h4',
	                            { 'class': 'header-title m-t-0 m-b-30' },
	                            'We only show the latest 10 outgoing transaction histories. Incoming transaction history will not show up here.'
	                        ),
	                        _react2.default.createElement(
	                            'p',
	                            { 'class': 'text-muted font-13 m-b-15', id: 'history-indication' },
	                            data.hereHistory
	                        ),
	                        _react2.default.createElement('p', null),
	                        _react2.default.createElement(
	                            'div',
	                            { 'class': 'table-responsive' },
	                            _react2.default.createElement(
	                                'table',
	                                { 'class': 'table m-b-0', id: 'history-table' },
	                                _react2.default.createElement(
	                                    'thead',
	                                    null,
	                                    _react2.default.createElement(
	                                        'tr',
	                                        null,
	                                        _react2.default.createElement(
	                                            'th',
	                                            null,
	                                            data.date
	                                        ),
	                                        _react2.default.createElement(
	                                            'th',
	                                            null,
	                                            data.status
	                                        ),
	                                        _react2.default.createElement(
	                                            'th',
	                                            null,
	                                            data.token
	                                        ),
	                                        _react2.default.createElement(
	                                            'th',
	                                            null,
	                                            data.amount
	                                        ),
	                                        _react2.default.createElement(
	                                            'th',
	                                            null,
	                                            data.address
	                                        )
	                                    )
	                                ),
	                                _react2.default.createElement('tbody', { id: 'history-tbody' })
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return History;
	}(_react.Component);
	
	exports.default = History;

/***/ },
/* 319 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Aidao_navy = __webpack_require__(349);
	
	var _Aidao_navy2 = _interopRequireDefault(_Aidao_navy);
	
	var _Ethereum = __webpack_require__(48);
	
	var _Ethereum2 = _interopRequireDefault(_Ethereum);
	
	var _reactRouterDom = __webpack_require__(37);
	
	var _jquery = __webpack_require__(14);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LeftSideBar = function (_Component) {
	  _inherits(LeftSideBar, _Component);
	
	  function LeftSideBar() {
	    _classCallCheck(this, LeftSideBar);
	
	    return _possibleConstructorReturn(this, (LeftSideBar.__proto__ || Object.getPrototypeOf(LeftSideBar)).apply(this, arguments));
	  }
	
	  _createClass(LeftSideBar, [{
	    key: "render",
	    value: function render() {
	
	      var username = window.username;
	
	      (0, _jquery2.default)("#sidebar-menu a").each(function () {
	        if (this.href === window.location.href) {
	          (0, _jquery2.default)(this).addClass("active");
	          (0, _jquery2.default)(this).parent().addClass("active"); // add active to li of the current link
	        } else if ((0, _jquery2.default)(this).hasClass("active")) {
	          (0, _jquery2.default)(this).removeClass("active");
	          (0, _jquery2.default)(this).parent().removeClass("active"); // add active to li of the current link
	        }
	      });
	
	      var data = this.props.data;
	
	      return _react2.default.createElement(
	        "div",
	        { "class": "left side-menu" },
	        _react2.default.createElement(
	          "div",
	          { "class": "sidebar-inner slimscrollleft" },
	          _react2.default.createElement(
	            "div",
	            { "class": "slimscrollbar" },
	            _react2.default.createElement(
	              "div",
	              { "class": "user-box" },
	              _react2.default.createElement(
	                "h5",
	                null,
	                "Welcome back, ",
	                _react2.default.createElement(
	                  "a",
	                  null,
	                  " ",
	                  username,
	                  " "
	                ),
	                " "
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { id: "sidebar-menu" },
	              _react2.default.createElement(
	                "ul",
	                null,
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  _react2.default.createElement(
	                    _reactRouterDom.Link,
	                    { to: { pathname: "/dashboard" }, "class": "waves-effect" },
	                    _react2.default.createElement("i", { "class": "fa fa-home" }),
	                    " ",
	                    _react2.default.createElement(
	                      "span",
	                      null,
	                      " ",
	                      data.dashboard,
	                      " "
	                    ),
	                    " "
	                  )
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  _react2.default.createElement(
	                    _reactRouterDom.Link,
	                    {
	                      to: { pathname: "/dashboard/account" },
	                      "class": "waves-effect"
	                    },
	                    _react2.default.createElement("i", { "class": "fa fa-lock" }),
	                    " ",
	                    _react2.default.createElement(
	                      "span",
	                      null,
	                      " ",
	                      data.account,
	                      " "
	                    ),
	                    " "
	                  )
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  _react2.default.createElement(
	                    _reactRouterDom.Link,
	                    {
	                      to: { pathname: "/dashboard/security" },
	                      "class": "waves-effect"
	                    },
	                    _react2.default.createElement("i", { "class": "fa fa-key" }),
	                    _react2.default.createElement(
	                      "span",
	                      null,
	                      " ",
	                      data.security,
	                      " "
	                    ),
	                    " "
	                  )
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  _react2.default.createElement(
	                    _reactRouterDom.Link,
	                    {
	                      to: { pathname: "/dashboard/notification" },
	                      "class": "waves-effect"
	                    },
	                    _react2.default.createElement("i", { "class": "fa fa-book" }),
	                    " ",
	                    _react2.default.createElement(
	                      "span",
	                      null,
	                      " ",
	                      data.information,
	                      " "
	                    ),
	                    " "
	                  )
	                ),
	                _react2.default.createElement("li", null),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  _react2.default.createElement(
	                    _reactRouterDom.Link,
	                    { to: { pathname: '/dashboard/swapcenter' }, "class": "waves-effect" },
	                    _react2.default.createElement("i", { "class": "fa fa-exchange" }),
	                    " ",
	                    _react2.default.createElement(
	                      "span",
	                      null,
	                      " Swap Center "
	                    ),
	                    " "
	                  )
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  _react2.default.createElement(
	                    _reactRouterDom.Link,
	                    {
	                      to: { pathname: "/dashboard/history" },
	                      "class": "waves-effect"
	                    },
	                    _react2.default.createElement("i", { "class": "fa fa-history" }),
	                    " ",
	                    _react2.default.createElement(
	                      "span",
	                      null,
	                      " ",
	                      data.history,
	                      " "
	                    ),
	                    " "
	                  )
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  _react2.default.createElement(
	                    _reactRouterDom.Link,
	                    {
	                      to: { pathname: "/dashboard/tokenpage" },
	                      "class": "waves-effect"
	                    },
	                    _react2.default.createElement("i", { "class": "fa fa-cubes" }),
	                    " ",
	                    _react2.default.createElement(
	                      "span",
	                      null,
	                      " ",
	                      data.tokenpage,
	                      " "
	                    ),
	                    " "
	                  )
	                ),
	                _react2.default.createElement("li", { "class": "menu-title" }),
	                _react2.default.createElement(
	                  "li",
	                  { "class": "token-list" },
	                  _react2.default.createElement(
	                    _reactRouterDom.Link,
	                    {
	                      to: { pathname: "/dashboard/aidao" },
	                      "class": "waves-effect"
	                    },
	                    _react2.default.createElement("img", { src: _Aidao_navy2.default, alt: "aidao icon" }),
	                    _react2.default.createElement(
	                      "span",
	                      null,
	                      " DAO"
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "li",
	                  { "class": "token-list" },
	                  _react2.default.createElement(
	                    _reactRouterDom.Link,
	                    {
	                      to: { pathname: "/dashboard/ethereum" },
	                      "class": "waves-effect"
	                    },
	                    _react2.default.createElement("img", { src: _Ethereum2.default, alt: "ether icon" }),
	                    _react2.default.createElement(
	                      "span",
	                      null,
	                      " Ethereum"
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement("div", { "class": "clearfix" })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return LeftSideBar;
	}(_react.Component);
	
	exports.default = LeftSideBar;

/***/ },
/* 320 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _fee = __webpack_require__(161);
	
	var _fee2 = _interopRequireDefault(_fee);
	
	var _jquery = __webpack_require__(14);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Notification = function (_Component) {
	    _inherits(Notification, _Component);
	
	    function Notification() {
	        _classCallCheck(this, Notification);
	
	        return _possibleConstructorReturn(this, (Notification.__proto__ || Object.getPrototypeOf(Notification)).apply(this, arguments));
	    }
	
	    _createClass(Notification, [{
	        key: 'render',
	        value: function render() {
	            var token = [];
	            var data = this.props.data;
	
	            token['cobinhood'] = (window.cobinhoodprice / window.daoprice).toFixed(2);
	            token['cybermiles'] = (window.cybermilesprice / window.daoprice).toFixed(2);
	            token['wandx'] = (window.wandxprice / window.daoprice).toFixed(2);
	            token['xyo'] = (window.xyoprice / window.daoprice).toFixed(2);
	            token['ncash'] = (window.ncashprice / window.daoprice).toFixed(2);
	            token['bitrewards'] = (window.bitrewardsprice / window.daoprice).toFixed(2);
	            token['stacs'] = (window.stacsprice / window.daoprice).toFixed(2);
	            token['orbs'] = (window.orbsprice / window.daoprice).toFixed(2);
	
	            var active;
	            (0, _jquery2.default)(document).ready(function () {
	                (0, _jquery2.default)("#history-tbody").html("");
	
	                for (var name in token) {
	                    if (active) {
	                        active = "";
	                    } else {
	                        active = "active";
	                    }
	                    (0, _jquery2.default)("#history-tbody").append('<tr class=' + active + '>\n                <th scope="row">' + name + '</th>\n                <td class="word-break">' + token[name] + '</td>\n            </tr>');
	                }
	                for (var _name in _fee2.default) {
	                    if (active) {
	                        active = "";
	                    } else {
	                        active = "active";
	                    }
	                    (0, _jquery2.default)("#fee-tbody").append('<tr class=' + active + '>\n                <th scope="row">' + _name + '</th>\n                <td class="word-break">' + _fee2.default[_name] + '</td>\n            </tr>');
	                }
	            });
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { 'class': 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { 'class': 'col-lg-12 col-md-12' },
	                        _react2.default.createElement(
	                            'div',
	                            { 'class': 'card-box' },
	                            _react2.default.createElement(
	                                'h4',
	                                { 'class': 'header-title m-t-0 m-b-30' },
	                                data.whatisDao
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { 'class': 'widget-box-2' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'widget-detail-2' },
	                                    _react2.default.createElement(
	                                        'h4',
	                                        { 'class': 'text-left' },
	                                        ' ',
	                                        data.explainDao
	                                    )
	                                )
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { 'class': 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { 'class': 'col-lg-12 col-md-12' },
	                        _react2.default.createElement(
	                            'div',
	                            { 'class': 'card-box' },
	                            _react2.default.createElement(
	                                'h4',
	                                { 'class': 'header-title m-t-0 m-b-30' },
	                                data.ethforWithdraw,
	                                ' '
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { 'class': 'widget-box-2' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'widget-detail-2' },
	                                    _react2.default.createElement(
	                                        'h4',
	                                        { 'class': 'text-left' },
	                                        ' ',
	                                        data.explainGas
	                                    )
	                                )
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { 'class': 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { 'class': 'col-lg-12 col-md-12' },
	                        _react2.default.createElement(
	                            'div',
	                            { 'class': 'card-box' },
	                            _react2.default.createElement(
	                                'h4',
	                                { 'class': 'header-title m-t-0 m-b-30' },
	                                'Q. ',
	                                data.aidaopolicy,
	                                ' '
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { 'class': 'widget-box-2' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'widget-detail-2' },
	                                    _react2.default.createElement(
	                                        'h4',
	                                        { 'class': 'text-left' },
	                                        data.aidaosendinginfo
	                                    )
	                                )
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { 'class': 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { 'class': 'col-lg-12 col-md-12' },
	                        _react2.default.createElement(
	                            'div',
	                            { 'class': 'card-box' },
	                            _react2.default.createElement(
	                                'h4',
	                                { 'class': 'header-title m-t-0 m-b-30' },
	                                data.airdropWithdraw
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { 'class': 'widget-box-2' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'widget-detail-2' },
	                                    _react2.default.createElement(
	                                        'h4',
	                                        { 'class': 'text-left' },
	                                        ' ',
	                                        data.deductDao
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'table-responsive' },
	                                        _react2.default.createElement(
	                                            'table',
	                                            { 'class': 'table m-b-0', id: 'history-table' },
	                                            _react2.default.createElement(
	                                                'thead',
	                                                null,
	                                                _react2.default.createElement(
	                                                    'tr',
	                                                    null,
	                                                    _react2.default.createElement(
	                                                        'th',
	                                                        null,
	                                                        data.tokenName
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'th',
	                                                        null,
	                                                        data.deductionRate
	                                                    )
	                                                )
	                                            ),
	                                            _react2.default.createElement('tbody', { id: 'history-tbody' })
	                                        )
	                                    ),
	                                    _react2.default.createElement('div', { 'class': 'm-t-20' }),
	                                    _react2.default.createElement(
	                                        'h4',
	                                        { 'class': 'text-left' },
	                                        ' ',
	                                        data.noticeManualApproval
	                                    )
	                                )
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { 'class': 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { 'class': 'col-lg-12 col-md-12' },
	                        _react2.default.createElement(
	                            'div',
	                            { 'class': 'card-box' },
	                            _react2.default.createElement(
	                                'h4',
	                                { 'class': 'header-title m-t-0 m-b-30' },
	                                'Fee Rate'
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { 'class': 'widget-box-2' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'widget-detail-2' },
	                                    _react2.default.createElement(
	                                        'h4',
	                                        { 'class': 'text-left' },
	                                        'We deduct some amount of the token to reimburse the high gas fee sending token to you'
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { 'class': 'table-responsive' },
	                                        _react2.default.createElement(
	                                            'table',
	                                            { 'class': 'table m-b-0', id: 'history-table' },
	                                            _react2.default.createElement(
	                                                'thead',
	                                                null,
	                                                _react2.default.createElement(
	                                                    'tr',
	                                                    null,
	                                                    _react2.default.createElement(
	                                                        'th',
	                                                        null,
	                                                        data.tokenName
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'th',
	                                                        null,
	                                                        'Amount'
	                                                    )
	                                                )
	                                            ),
	                                            _react2.default.createElement('tbody', { id: 'fee-tbody' })
	                                        )
	                                    ),
	                                    _react2.default.createElement('div', { 'class': 'm-t-20' })
	                                )
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { 'class': 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { 'class': 'col-lg-12 col-md-12' },
	                        _react2.default.createElement(
	                            'div',
	                            { 'class': 'card-box', id: 'swapcenterinfo' },
	                            _react2.default.createElement(
	                                'h4',
	                                { 'class': 'header-title m-t-0 m-b-30' },
	                                'Q. What is Swap Center '
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { 'class': 'widget-box-2' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'widget-detail-2' },
	                                    _react2.default.createElement(
	                                        'h4',
	                                        { 'class': 'text-left' },
	                                        ' Swap center integrated with decentralized exchange to provide liquidity to convert your airdropped tokens. Note that we have minimum of 0.055 ether equivalent token conversion. Beside the fee charged by decentralized exchange, we also charge 0.2% of the fee. We are in beta period and currently only offer conversion to ether. Note that in current beta version, there is a maximum of token you can convert each time. It depends on the market, but in general if you convert less than 0.15 ether equivalent of token, it should not impact your conversion. When you convert token to ether, the converted ether will be sent to your DAO wallet ether address.'
	                                    ),
	                                    _react2.default.createElement(
	                                        'h4',
	                                        { 'class': 'text-left' },
	                                        ' The token to token beta-version swaping is also available.'
	                                    ),
	                                    _react2.default.createElement(
	                                        'h4',
	                                        { 'class': 'text-left' },
	                                        ' Radar Relay and ERCDEX Integration allow swaping your ETH to anther tokens In that case, you will need to provide some eth as gas.'
	                                    ),
	                                    _react2.default.createElement(
	                                        'h4',
	                                        { 'class': 'text-left' },
	                                        ' Radar Relay and ERCDEX beta-version both offer ETH/DAI swapping, you can click on the icon to switch which DEX you want to swap in. Mininum swap from ERCDEX is 0.05 ether'
	                                    ),
	                                    _react2.default.createElement(
	                                        'h4',
	                                        { 'class': 'text-left' },
	                                        ' Morph Integration beta-version both offer ETH/BTC swapping. Mininum swap from ERCDEX is 0.15 ether'
	                                    )
	                                )
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { 'class': 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { 'class': 'col-lg-12 col-md-12' },
	                        _react2.default.createElement(
	                            'div',
	                            { 'class': 'card-box' },
	                            _react2.default.createElement(
	                                'h4',
	                                { 'class': 'header-title m-t-0 m-b-30' },
	                                'Q. How to Contact us '
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { 'class': 'widget-box-2' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { 'class': 'widget-detail-2' },
	                                    _react2.default.createElement(
	                                        'h4',
	                                        { 'class': 'text-left' },
	                                        ' Email daotokenwallet@gmail.com'
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return Notification;
	}(_react.Component);
	
	exports.default = Notification;

/***/ },
/* 321 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(346);
	
	var _dashboard_main_content = __webpack_require__(297);
	
	var _dashboard_main_content2 = _interopRequireDefault(_dashboard_main_content);
	
	var _aidao = __webpack_require__(291);
	
	var _aidao2 = _interopRequireDefault(_aidao);
	
	var _ethereum = __webpack_require__(300);
	
	var _ethereum2 = _interopRequireDefault(_ethereum);
	
	var _golem = __webpack_require__(302);
	
	var _golem2 = _interopRequireDefault(_golem);
	
	var _cobinhood = __webpack_require__(294);
	
	var _cobinhood2 = _interopRequireDefault(_cobinhood);
	
	var _cybermiles = __webpack_require__(296);
	
	var _cybermiles2 = _interopRequireDefault(_cybermiles);
	
	var _essentia = __webpack_require__(299);
	
	var _essentia2 = _interopRequireDefault(_essentia);
	
	var _wandx = __webpack_require__(311);
	
	var _wandx2 = _interopRequireDefault(_wandx);
	
	var _xyo = __webpack_require__(312);
	
	var _xyo2 = _interopRequireDefault(_xyo);
	
	var _fuzex = __webpack_require__(301);
	
	var _fuzex2 = _interopRequireDefault(_fuzex);
	
	var _nbr = __webpack_require__(306);
	
	var _nbr2 = _interopRequireDefault(_nbr);
	
	var _orbs = __webpack_require__(308);
	
	var _orbs2 = _interopRequireDefault(_orbs);
	
	var _bitrewards = __webpack_require__(293);
	
	var _bitrewards2 = _interopRequireDefault(_bitrewards);
	
	var _singularitynet = __webpack_require__(309);
	
	var _singularitynet2 = _interopRequireDefault(_singularitynet);
	
	var _incodium = __webpack_require__(303);
	
	var _incodium2 = _interopRequireDefault(_incodium);
	
	var _autonio = __webpack_require__(292);
	
	var _autonio2 = _interopRequireDefault(_autonio);
	
	var _credits = __webpack_require__(295);
	
	var _credits2 = _interopRequireDefault(_credits);
	
	var _ncash = __webpack_require__(307);
	
	var _ncash2 = _interopRequireDefault(_ncash);
	
	var _kicktoken = __webpack_require__(304);
	
	var _kicktoken2 = _interopRequireDefault(_kicktoken);
	
	var _stacs = __webpack_require__(310);
	
	var _stacs2 = _interopRequireDefault(_stacs);
	
	var _dice = __webpack_require__(298);
	
	var _dice2 = _interopRequireDefault(_dice);
	
	var _moneynet = __webpack_require__(305);
	
	var _moneynet2 = _interopRequireDefault(_moneynet);
	
	var _account = __webpack_require__(290);
	
	var _account2 = _interopRequireDefault(_account);
	
	var _notification = __webpack_require__(320);
	
	var _notification2 = _interopRequireDefault(_notification);
	
	var _securitycenter = __webpack_require__(322);
	
	var _securitycenter2 = _interopRequireDefault(_securitycenter);
	
	var _history = __webpack_require__(318);
	
	var _history2 = _interopRequireDefault(_history);
	
	var _swapcenter = __webpack_require__(323);
	
	var _swapcenter2 = _interopRequireDefault(_swapcenter);
	
	var _tokenpage = __webpack_require__(324);
	
	var _tokenpage2 = _interopRequireDefault(_tokenpage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RightContent = function (_Component) {
	  _inherits(RightContent, _Component);
	
	  function RightContent() {
	    _classCallCheck(this, RightContent);
	
	    return _possibleConstructorReturn(this, (RightContent.__proto__ || Object.getPrototypeOf(RightContent)).apply(this, arguments));
	  }
	
	  _createClass(RightContent, [{
	    key: 'render',
	    value: function render() {
	
	      var data = this.props.data;
	      var content;
	      if (this.props.name === "account") {
	        content = _react2.default.createElement(_account2.default, { data: data.account });
	      } else if (this.props.name === "security") {
	        content = _react2.default.createElement(_securitycenter2.default, { data: data });
	      } else if (this.props.name === "history") {
	        content = _react2.default.createElement(_history2.default, { data: data.history });
	      } else if (this.props.name === "notification") {
	        content = _react2.default.createElement(_notification2.default, { data: data.notification });
	      } else if (this.props.name === "swapcenter") {
	        content = _react2.default.createElement(_swapcenter2.default, { data: data });
	      } else if (this.props.name === "tokenpage") {
	        content = _react2.default.createElement(_tokenpage2.default, { data: data });
	      } else if (this.props.name === "aidao") {
	        content = _react2.default.createElement(_aidao2.default, { data: data });
	      } else if (this.props.name === "ethereum") {
	        content = _react2.default.createElement(_ethereum2.default, { data: data });
	      } else if (this.props.name === "golem") {
	        content = _react2.default.createElement(_golem2.default, { data: data });
	      } else if (this.props.name === "cobinhood") {
	        content = _react2.default.createElement(_cobinhood2.default, { data: data });
	      } else if (this.props.name === "wandx") {
	        content = _react2.default.createElement(_wandx2.default, { data: data });
	      } else if (this.props.name === "xyo") {
	        content = _react2.default.createElement(_xyo2.default, { data: data });
	      } else if (this.props.name === "fuzex") {
	        content = _react2.default.createElement(_fuzex2.default, { data: data });
	      } else if (this.props.name === "nbr") {
	        content = _react2.default.createElement(_nbr2.default, { data: data });
	      } else if (this.props.name === "bitrewards") {
	        content = _react2.default.createElement(_bitrewards2.default, { data: data });
	      } else if (this.props.name === "ncash") {
	        content = _react2.default.createElement(_ncash2.default, { data: data });
	      } else if (this.props.name === "essentia") {
	        content = _react2.default.createElement(_essentia2.default, { data: data });
	      } else if (this.props.name === "singularitynet") {
	        content = _react2.default.createElement(_singularitynet2.default, { data: data });
	      } else if (this.props.name === "incodium") {
	        content = _react2.default.createElement(_incodium2.default, { data: data });
	      } else if (this.props.name === "autonio") {
	        content = _react2.default.createElement(_autonio2.default, { data: data });
	      } else if (this.props.name === "dicet") {
	        content = _react2.default.createElement(_dice2.default, { data: data });
	      } else if (this.props.name === "credits") {
	        content = _react2.default.createElement(_credits2.default, { data: data });
	      } else if (this.props.name === "moneynet") {
	        content = _react2.default.createElement(_moneynet2.default, { data: data });
	      } else if (this.props.name === "stacs") {
	        content = _react2.default.createElement(_stacs2.default, { data: data });
	      } else if (this.props.name === "orbs") {
	        content = _react2.default.createElement(_orbs2.default, { data: data });
	      } else if (this.props.name === "kick") {
	        content = _react2.default.createElement(_kicktoken2.default, { data: data });
	      } else {
	        content = _react2.default.createElement(_dashboard_main_content2.default, { data: data });
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { 'class': 'content-page' },
	        _react2.default.createElement(
	          'div',
	          { 'class': 'content' },
	          _react2.default.createElement(
	            'div',
	            { 'class': 'container' },
	            content
	          )
	        )
	      );
	    }
	  }]);
	
	  return RightContent;
	}(_react.Component);
	
	exports.default = RightContent;

/***/ },
/* 322 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _otp = __webpack_require__(316);
	
	var _otp2 = _interopRequireDefault(_otp);
	
	var _email_verification = __webpack_require__(314);
	
	var _email_verification2 = _interopRequireDefault(_email_verification);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SecurityCenter = function (_Component) {
	  _inherits(SecurityCenter, _Component);
	
	  function SecurityCenter() {
	    _classCallCheck(this, SecurityCenter);
	
	    return _possibleConstructorReturn(this, (SecurityCenter.__proto__ || Object.getPrototypeOf(SecurityCenter)).apply(this, arguments));
	  }
	
	  _createClass(SecurityCenter, [{
	    key: 'render',
	    value: function render() {
	
	      var data = this.props.data;
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_email_verification2.default, { data: data.email_verification }),
	        _react2.default.createElement(_otp2.default, { data: data.otp })
	      );
	    }
	  }]);
	
	  return SecurityCenter;
	}(_react.Component);
	
	exports.default = SecurityCenter;

/***/ },
/* 323 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(14);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _axios = __webpack_require__(27);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _qs = __webpack_require__(31);
	
	var _qs2 = _interopRequireDefault(_qs);
	
	var _popup = __webpack_require__(28);
	
	var _popup2 = _interopRequireDefault(_popup);
	
	var _reactRouterDom = __webpack_require__(37);
	
	var _idex = __webpack_require__(352);
	
	var _idex2 = _interopRequireDefault(_idex);
	
	var _radar = __webpack_require__(354);
	
	var _radar2 = _interopRequireDefault(_radar);
	
	var _ercdex = __webpack_require__(351);
	
	var _ercdex2 = _interopRequireDefault(_ercdex);
	
	var _morph = __webpack_require__(353);
	
	var _morph2 = _interopRequireDefault(_morph);
	
	__webpack_require__(345);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SwapCenter = function (_Component) {
	  _inherits(SwapCenter, _Component);
	
	  function SwapCenter() {
	    _classCallCheck(this, SwapCenter);
	
	    return _possibleConstructorReturn(this, (SwapCenter.__proto__ || Object.getPrototypeOf(SwapCenter)).apply(this, arguments));
	  }
	
	  _createClass(SwapCenter, [{
	    key: 'render',
	    value: function render() {
	
	      var data = this.props.data;
	      var otp = window.otp;
	      var essentiabalance = window.essentiabalance;
	      var etherbalance = window.etherbalance;
	      var ethprice = window.ethprice;
	
	      _axios2.default.defaults.xsrfCookieName = 'csrftoken';
	      _axios2.default.defaults.xsrfHeaderName = 'X-CSRFToken';
	
	      if (otp === "False") {
	        (0, _jquery2.default)(document).ready(function () {
	          (0, _jquery2.default)("#otp-block").css("display", "none");
	        });
	      }
	
	      var getprice = function getprice() {
	        // Temporary
	        var from_token = "ESS";
	        var to_token = "ETH";
	
	        _axios2.default.post('/api/idex/price', _qs2.default.stringify({
	          "from_token": from_token,
	          "to_token": to_token,
	          "direction": "bids"
	        })).then(function (response) {
	          (0, _jquery2.default)("#swapprice").html(response.data.price);
	          var conversion = 0.06 / response.data.price;
	          (0, _jquery2.default)("#miniconversion").html(conversion.toFixed(8));
	        });
	      };
	
	      getprice();
	
	      var getmorphprice = function getmorphprice(from_token, to_token) {
	
	        _axios2.default.post('/api/morph/price', _qs2.default.stringify({
	          "from_token": from_token,
	          "to_token": to_token
	        })).then(function (response) {
	          (0, _jquery2.default)("#swapprice").html(response.data.price);
	        });
	      };
	
	      var combination = {
	        "ESS": {
	          "ETH": ["IDEX"],
	          "XYO": ["IDEX"]
	        },
	        "ETH": {
	          "DAI": ["RADAR", "ERCDEX"],
	          "BTC": ["MORPH"],
	          "LTC": ["MORPH"]
	        } // the inner object has no actual use for now
	
	      };var remove_all_active = function remove_all_active() {
	        var radar_logo = (0, _jquery2.default)("#radar-logo");
	        if (radar_logo.hasClass("active")) {
	          radar_logo.removeClass("active");
	        }
	
	        var ercdex_logo = (0, _jquery2.default)("#ercdex-logo");
	        if (ercdex_logo.hasClass("active")) {
	          ercdex_logo.removeClass("active");
	        }
	
	        var idex_logo = (0, _jquery2.default)("#idex-logo");
	        if (idex_logo.hasClass("active")) {
	          idex_logo.removeClass("active");
	        }
	
	        var morph_logo = (0, _jquery2.default)("#morph-logo");
	        if (morph_logo.hasClass("active")) {
	          morph_logo.removeClass("active");
	        }
	      };
	
	      var get_eth_token_price = function get_eth_token_price(from_token) {
	        // for token to token swap
	        var to_token = "ETH";
	
	        _axios2.default.post('/api/idex/price', _qs2.default.stringify({
	          "from_token": from_token,
	          "to_token": to_token,
	          "direction": "asks"
	        })).then(function (response) {
	          (0, _jquery2.default)("#swapprice2").html(response.data.price);
	        });
	      };
	      var from_token_change = function from_token_change() {
	        var to_token = (0, _jquery2.default)("#swap-to").val();
	        token_selection_changed(to_token, true);
	      };
	
	      var to_token_change = function to_token_change() {
	        var to_token = (0, _jquery2.default)("#swap-to").val();
	        token_selection_changed(to_token, false);
	      };
	
	      var token_selection_changed = function token_selection_changed(to_token, change) {
	        var from_token = (0, _jquery2.default)("#swap-from").val();
	        var to_token_options = combination[from_token];
	        remove_all_active();
	
	        (0, _jquery2.default)("#swap-to").html(""); // clear everything
	        if (from_token === "ETH") {
	
	          Object.keys(to_token_options).forEach(function (key, index) {
	            (0, _jquery2.default)("#swap-to").append("<option value='" + key + "'>" + key + "</option>");
	          });
	
	          // having receiving address
	          (0, _jquery2.default)("#receiving_address").css("display", "block");
	          (0, _jquery2.default)("#convert-eth").css("display", "none");
	
	          // make sure this is none
	          (0, _jquery2.default)("#token-to-token-price").css("display", "none");
	          (0, _jquery2.default)("#currently-have").html(etherbalance + " ETH");
	          (0, _jquery2.default)("#miniconversion-unit").html("ETH");
	
	          // TODO: make use of the object to_token_options to select exchanges
	          if (change) {
	            var to_token = (0, _jquery2.default)("#swap-to").val();
	          }
	          if (to_token == "DAI") {
	            (0, _jquery2.default)("#radar-logo").addClass("active");
	            (0, _jquery2.default)("#swapprice").html(ethprice);
	            // opacity rather than display so the space will be reserved
	            (0, _jquery2.default)("#miniconversion").html("0.05");
	          } else if (to_token == "BTC") {
	            // morph multiasset swap
	            (0, _jquery2.default)("#swap-to option[value=BTC]").attr('selected', true);
	            (0, _jquery2.default)("#morph-logo").addClass("active");
	            (0, _jquery2.default)("#miniconversion").html("0.3");
	            getmorphprice(from_token, to_token);
	          } else if (to_token == "LTC") {
	            (0, _jquery2.default)("#swap-to option[value=LTC]").attr('selected', true);
	            (0, _jquery2.default)("#morph-logo").addClass("active");
	            (0, _jquery2.default)("#miniconversion").html("0.3");
	            getmorphprice(from_token, to_token);
	          }
	        } else if (from_token === "ESS") {
	          (0, _jquery2.default)("#idex-logo").addClass("active");
	
	          Object.keys(to_token_options).forEach(function (key, index) {
	            (0, _jquery2.default)("#swap-to").append("<option value='" + key + "'>" + key + "</option>");
	          });
	          (0, _jquery2.default)("#currently-have").html(essentiabalance + " ESS");
	          (0, _jquery2.default)("#miniconversion-unit").html("ESS");
	
	          if (change) {
	            var to_token = (0, _jquery2.default)("#swap-to").val();
	          }
	          if (to_token == "ETH") {
	            (0, _jquery2.default)("#receiving_address").css("display", "none");
	            (0, _jquery2.default)("#convert-eth").css("display", "block");
	            (0, _jquery2.default)("#token-to-token-price").css("display", "none");
	            (0, _jquery2.default)("#miniconversion").html("0");
	          } else {
	            (0, _jquery2.default)("#receiving_address").css("display", "block");
	            (0, _jquery2.default)("#convert-eth").css("display", "none");
	            //Temporary solution
	            (0, _jquery2.default)("#swap-to option[value=XYO]").attr('selected', true);
	            (0, _jquery2.default)("#token-to-token-price").css("display", "block");
	            get_eth_token_price(from_token);
	          }
	          (0, _jquery2.default)("#swapprice").html("0");
	          getprice();
	        } else {
	          _popup2.default.prototype.show("Error: \n No exist swap from option");
	        }
	        estimation();
	      };
	
	      var to_ercdex = function to_ercdex() {
	        var from_token = (0, _jquery2.default)("#swap-from").val();
	        var to_token = (0, _jquery2.default)("#swap-to").val();
	        if (from_token === "ETH" && to_token !== "BTC" && to_token !== "LTC") {
	          (0, _jquery2.default)("#radar-logo").removeClass("active");
	          (0, _jquery2.default)("#ercdex-logo").addClass("active");
	        }
	      };
	
	      var to_radar = function to_radar() {
	        var from_token = (0, _jquery2.default)("#swap-from").val();
	        var to_token = (0, _jquery2.default)("#swap-to").val();
	        if (from_token === "ETH" && to_token !== "BTC" && to_token !== "LTC") {
	          (0, _jquery2.default)("#radar-logo").addClass("active");
	          (0, _jquery2.default)("#ercdex-logo").removeClass("active");
	        }
	      };
	
	      var estimation = function estimation() {
	        var amount = (0, _jquery2.default)("#amount-swap").val();
	        if (amount) {
	          var ethrate = parseFloat((0, _jquery2.default)("#swapprice").html());
	          var eth_estimate = ethrate * parseFloat(amount);
	
	          if ((0, _jquery2.default)("#swap-to").val() !== "ETH" && (0, _jquery2.default)("#swap-from").val() !== "ETH") {
	            var tokenrate = parseFloat((0, _jquery2.default)("#swapprice2").html());
	            var token_estimate = eth_estimate / tokenrate;
	            (0, _jquery2.default)("#estimated-swap").val(token_estimate.toFixed(10));
	          } else {
	            (0, _jquery2.default)("#estimated-swap").val(eth_estimate.toFixed(10));
	          }
	        } else {
	          (0, _jquery2.default)("#estimated-swap").val("Estimated amount");
	        }
	      };
	
	      // help facilitate diffferent dex swap
	      var swap_request_pattern = function swap_request_pattern(words, from_token, amount, url) {
	        var to_token = (0, _jquery2.default)("#swap-to").val();
	        var sendTo = (0, _jquery2.default)('#receiver').val();
	        var otp = (0, _jquery2.default)('#otp-sending').val();
	        var receiving_address = (0, _jquery2.default)('#receiving_address').val();
	
	        if (confirm(words) === true) {
	          if (from_token === to_token) {
	            _popup2.default.prototype.show("You can't swap the same token");
	          } else {
	            var promise;
	            promise = _axios2.default.post(url, _qs2.default.stringify({
	              "from_token": from_token,
	              "to_token": to_token,
	              "amount": amount,
	              "sendTo": sendTo,
	              "otp": otp,
	              "receiving_address": receiving_address
	            }));
	
	            (0, _jquery2.default)("#swap-button").html("Swaping");
	            (0, _jquery2.default)('#swap-button').prop('disabled', true);
	
	            promise.then(function (response) {
	              console.log(response);
	
	              (0, _jquery2.default)("#swap-button").html("Swap");
	              (0, _jquery2.default)('#swap-button').prop('disabled', false);
	              _popup2.default.prototype.show("Success!\n Check the process in the history page");
	            });
	
	            promise.catch(function (error) {
	              console.log(error.response.data);
	              _popup2.default.prototype.show("Failed:\n" + error.response.data.message);
	              (0, _jquery2.default)("#swap-button").html("Swap");
	              (0, _jquery2.default)('#swap-button').prop('disabled', false);
	            });
	          }
	        }
	      };
	
	      // trigger swapping 
	      var smart_swap = function smart_swap() {
	        var amount = (0, _jquery2.default)("#amount-swap").val();
	        var from_token = (0, _jquery2.default)("#swap-from").val();
	        var words;
	
	        if (from_token !== "ETH") {
	          // case of IDEX
	          words = "Swap has the same effect as withdraw for DAO deduction. ";
	          var rate = (window.essentiaprice / window.daoprice).toFixed(2);
	          var deduct = amount * rate;
	          words = words + deduct.toString() + " DAO will be deducted.";
	          swap_request_pattern(words, from_token, amount, "/api/idex/trade");
	        } else {
	          // case of radar relay
	          words = "Are you sure to swap your Ether?";
	          if ((0, _jquery2.default)("#ercdex-logo").hasClass("active")) {
	            swap_request_pattern(words, from_token, amount, "/api/ercdex/transact");
	          } else if ((0, _jquery2.default)("#radar-logo").hasClass("active")) {
	            swap_request_pattern(words, from_token, amount, "/api/radarrelay/transact");
	          } else if ((0, _jquery2.default)("#morph-logo").hasClass("active")) {
	            swap_request_pattern(words, from_token, amount, "/api/morph/transact");
	          } else {
	            _popup2.default.prototype.show("Error: \n Swap exchange unknown");
	          }
	        }
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { 'class': 'container' },
	        _react2.default.createElement(
	          'div',
	          { 'class': 'swappp' },
	          _react2.default.createElement(
	            'div',
	            { 'class': 'card-box', id: 'padding-side' },
	            _react2.default.createElement(
	              'div',
	              { 'class': 'align-center' },
	              _react2.default.createElement('img', { src: _idex2.default, id: 'idex-logo', 'class': 'dex_icon inline-dev active' }),
	              _react2.default.createElement('img', { src: _radar2.default, onClick: to_radar, id: 'radar-logo', 'class': 'dex_icon inline-dev' }),
	              _react2.default.createElement('img', { src: _ercdex2.default, onClick: to_ercdex, id: 'ercdex-logo', 'class': 'dex_icon inline-dev' }),
	              _react2.default.createElement('img', { src: _morph2.default, id: 'morph-logo', 'class': 'dex_icon inline-dev' })
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'h5',
	                { 'class': 'price align-center' },
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'Estimated Price: ',
	                  _react2.default.createElement(
	                    'span',
	                    { id: 'swapprice' },
	                    '0'
	                  )
	                ),
	                _react2.default.createElement(
	                  'p',
	                  { id: 'token-to-token-price' },
	                  'Estimated Price For ETH to Your Target Token: ',
	                  _react2.default.createElement(
	                    'span',
	                    { id: 'swapprice2' },
	                    '0'
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { 'class': 'swap-bar m-b-0' },
	              _react2.default.createElement(
	                'div',
	                { 'class': 'inline-div' },
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'token-amount inline-div m-r-10' },
	                    _react2.default.createElement('input', { type: 'text', 'class': 'form-control inline-div', id: 'amount-swap', placeholder: 'Amount', onChange: estimation })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'token-select inline-div' },
	                    _react2.default.createElement(
	                      'select',
	                      { 'class': 'form-control inline-div', id: 'swap-from', onChange: from_token_change },
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'ESS' },
	                        'ESS'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'ETH' },
	                        'ETH'
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  'You currently have ',
	                  _react2.default.createElement(
	                    'span',
	                    { id: 'currently-have' },
	                    essentiabalance,
	                    ' ESS '
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'p',
	                { id: 'arrow', 'class': 'inline-div' },
	                _react2.default.createElement('i', { 'class': 'fa fa-arrow-right fa-2x' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { 'class': 'inline-div' },
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'token-amount inline-div m-r-10' },
	                    _react2.default.createElement('input', { type: 'text', 'class': 'form-control inline-div', id: 'estimated-swap', placeholder: 'Estimated amount', disabled: true })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { 'class': 'token-select inline-div' },
	                    _react2.default.createElement(
	                      'select',
	                      { id: 'swap-to', 'class': 'form-control inline-div', onChange: to_token_change },
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'ETH' },
	                        'ETH'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'XYO' },
	                        'XYO'
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { id: 'miniconversion-div' },
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    'Minimum conversion: ',
	                    _react2.default.createElement(
	                      'span',
	                      { id: 'miniconversion' },
	                      '0'
	                    ),
	                    ' ',
	                    _react2.default.createElement(
	                      'span',
	                      { id: 'miniconversion-unit' },
	                      'ESS'
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { 'class': 'address-input m-t-30' },
	              _react2.default.createElement('input', { type: 'text', 'class': 'form-control', id: 'receiving_address', placeholder: 'Type receiving address here' }),
	              _react2.default.createElement(
	                'p',
	                { id: 'convert-eth' },
	                'Convert Ethereum will automatically send to your DAO wallet address.'
	              ),
	              _react2.default.createElement(
	                'div',
	                { id: 'otp-block' },
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'form-group' },
	                  _react2.default.createElement('input', { type: 'text', 'class': 'form-control', id: 'otp-sending', placeholder: 'OTP Code' })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { 'class': 'm-t-10' },
	                'More in ',
	                _react2.default.createElement(
	                  'a',
	                  { href: '/dashboard/notification' },
	                  'information'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { 'class': 'row m-t-80 m-b-30' },
	              _react2.default.createElement(
	                'p',
	                null,
	                _react2.default.createElement(
	                  'button',
	                  { id: 'swap-button', 'class': 'btn-lg btn-blue', onClick: smart_swap },
	                  'Convert'
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return SwapCenter;
	}(_react.Component);
	
	exports.default = SwapCenter;

/***/ },
/* 324 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(14);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _Aidao = __webpack_require__(47);
	
	var _Aidao2 = _interopRequireDefault(_Aidao);
	
	var _Ethereum = __webpack_require__(48);
	
	var _Ethereum2 = _interopRequireDefault(_Ethereum);
	
	var _cobinhood = __webpack_require__(67);
	
	var _cobinhood2 = _interopRequireDefault(_cobinhood);
	
	var _cybermiles = __webpack_require__(102);
	
	var _cybermiles2 = _interopRequireDefault(_cybermiles);
	
	var _wandx = __webpack_require__(74);
	
	var _wandx2 = _interopRequireDefault(_wandx);
	
	var _credit = __webpack_require__(68);
	
	var _credit2 = _interopRequireDefault(_credit);
	
	var _ncash = __webpack_require__(70);
	
	var _ncash2 = _interopRequireDefault(_ncash);
	
	var _xinfin = __webpack_require__(355);
	
	var _xinfin2 = _interopRequireDefault(_xinfin);
	
	var _xyo = __webpack_require__(75);
	
	var _xyo2 = _interopRequireDefault(_xyo);
	
	var _inco = __webpack_require__(104);
	
	var _inco2 = _interopRequireDefault(_inco);
	
	var _fuzex = __webpack_require__(103);
	
	var _fuzex2 = _interopRequireDefault(_fuzex);
	
	var _auto = __webpack_require__(65);
	
	var _auto2 = _interopRequireDefault(_auto);
	
	var _ess = __webpack_require__(69);
	
	var _ess2 = _interopRequireDefault(_ess);
	
	var _dicet = __webpack_require__(169);
	
	var _dicet2 = _interopRequireDefault(_dicet);
	
	var _mon = __webpack_require__(105);
	
	var _mon2 = _interopRequireDefault(_mon);
	
	var _nbr = __webpack_require__(170);
	
	var _nbr2 = _interopRequireDefault(_nbr);
	
	var _bit = __webpack_require__(66);
	
	var _bit2 = _interopRequireDefault(_bit);
	
	var _singularity = __webpack_require__(72);
	
	var _singularity2 = _interopRequireDefault(_singularity);
	
	var _stacsLogo = __webpack_require__(73);
	
	var _stacsLogo2 = _interopRequireDefault(_stacsLogo);
	
	var _orbsLogo = __webpack_require__(71);
	
	var _orbsLogo2 = _interopRequireDefault(_orbsLogo);
	
	var _kick = __webpack_require__(246);
	
	var _kick2 = _interopRequireDefault(_kick);
	
	var _reactRouterDom = __webpack_require__(37);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TokenPage = function (_Component) {
	  _inherits(TokenPage, _Component);
	
	  function TokenPage() {
	    _classCallCheck(this, TokenPage);
	
	    return _possibleConstructorReturn(this, (TokenPage.__proto__ || Object.getPrototypeOf(TokenPage)).apply(this, arguments));
	  }
	
	  _createClass(TokenPage, [{
	    key: "render",
	    value: function render() {
	      var precision = 3;
	      var cobinhoodbalance = parseFloat(window.cobinhoodbalance).toFixed(precision);
	      var wandxbalance = parseFloat(window.wandxbalance).toFixed(precision);
	      var xyobalance = parseFloat(window.xyobalance).toFixed(precision);
	      var nbrbalance = parseFloat(window.nbrbalance).toFixed(precision);
	      var bitrewardsbalance = parseFloat(window.bitrewardsbalance).toFixed(precision);
	      var creditsbalance = parseFloat(window.creditsbalance).toFixed(precision);
	      var ncashbalance = parseFloat(window.ncashbalance).toFixed(precision);
	      var essentiabalance = parseFloat(window.essentiabalance).toFixed(precision);
	      var singularitynetbalance = parseFloat(window.agibalance).toFixed(precision);
	      var incodiumbalance = parseFloat(window.incodiumbalance).toFixed(precision);
	      var autoniobalance = parseFloat(window.autoniobalance).toFixed(precision);
	      var dicebalance = parseFloat(window.dicebalance).toFixed(precision);
	      var moneynetbalance = parseFloat(window.moneynetbalance).toFixed(precision);
	      var stacsbalance = parseFloat(window.stacsbalance).toFixed(precision);
	      var orbsbalance = parseFloat(window.orbsbalance).toFixed(precision);
	      var kickbalance = parseFloat(window.kickbalance).toFixed(precision);
	
	      var noprice = "No Price Available";
	
	      var kyc_level = window.kyc;
	      var belongs = window.belongs;
	      if (kyc_level < 3 && belongs === 'Mr.Cho') {
	        return _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            "div",
	            { "class": "row" },
	            _react2.default.createElement(
	              "div",
	              { "class": "kyc-command" },
	              "Please do KYC First in order to view this page. We require everyone to pass identification (KYC) in order to receive and withdraw airdrop tokens. Please do so before December 25, 2021 in order to further access token page. However, You do not need to pass KYC to send and receive ETH or AiDAO Token"
	            ),
	            _react2.default.createElement(
	              "div",
	              { "class": "kyc-command" },
	              "\uC774 \uD398\uC774\uC9C0\uB97C \uBCF4\uB824\uBA74 \uBA3C\uC800 KYC\uB97C \uC218\uD589\uD558\uC2ED\uC2DC\uC624. \uC5D0\uC5B4\uB4DC\uB86D \uD1A0\uD070\uC744 \uBC1B\uACE0 \uCD9C\uAE08\uD558\uAE30 \uC704\uD574\uC11C\uB294 \uBAA8\uB4E0 \uC0AC\uB78C\uC774 \uC2E0\uBD84\uC99D(KYC)\uC744 \uD1B5\uACFC\uD574\uC57C \uD569\uB2C8\uB2E4. \uC774 \uD398\uC774\uC9C0\uC5D0 \uC561\uC138\uC2A4\uD558\uB824\uBA74 2021\uB144 12\uC6D4 25\uC77C \uC774\uC804\uC5D0 \uADF8\uB807\uAC8C \uD558\uC2ED\uC2DC\uC624. \uADF8\uB7EC\uB098 ETH \uB610\uB294 AiDAO \uD1A0\uD070\uC744 \uBCF4\uB0B4\uACE0 \uBC1B\uAE30 \uC704\uD574 KYC\uB97C \uD1B5\uACFC\uD560 \uD544\uC694\uAC00 \uC5C6\uC2B5\uB2C8\uB2E4."
	            ),
	            _react2.default.createElement(
	              "div",
	              { "class": "kyc-command" },
	              "If you have submitted KYC before but did not pass the KYC, you can now re-submit your documents."
	            ),
	            _react2.default.createElement(
	              "div",
	              { "class": "kyc-command" },
	              "\uC774\uC804\uC5D0 KYC\uB97C \uC81C\uCD9C\uD588\uC9C0\uB9CC KYC\uB97C \uD1B5\uACFC\uD558\uC9C0 \uBABB\uD55C \uACBD\uC6B0 \uC774\uC81C \uBB38\uC11C\uB97C \uB2E4\uC2DC \uC81C\uCD9C\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4."
	            ),
	            _react2.default.createElement(
	              _reactRouterDom.Link,
	              { "class": "kyc-command", to: { pathname: "/dashboard/account" } },
	              "Go to Account Page to do KYC"
	            ),
	            _react2.default.createElement(
	              _reactRouterDom.Link,
	              { "class": "kyc-command", to: { pathname: "/dashboard/account" } },
	              "\uACC4\uC815 \uD398\uC774\uC9C0\uB85C \uC774\uB3D9\uD558\uC5EC KYC \uC218\uD589"
	            )
	          )
	        );
	      }
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "div",
	          { "class": "row" },
	          _react2.default.createElement(
	            "div",
	            { "class": "col-lg-3 col-md-6 col-sm-12" },
	            _react2.default.createElement(
	              "div",
	              { "class": "card-box", id: "cobinhood" },
	              _react2.default.createElement(
	                _reactRouterDom.Link,
	                { to: { pathname: "/dashboard/cobinhood" } },
	                _react2.default.createElement(
	                  "div",
	                  { "class": "widget-detail-2" },
	                  _react2.default.createElement(
	                    "h3",
	                    { "class": "m-b-0" },
	                    _react2.default.createElement("img", {
	                      src: _cobinhood2.default,
	                      alt: "cobinhood icon",
	                      "class": "token64 m-b-10"
	                    }),
	                    _react2.default.createElement("div", { "class": "word-break" }),
	                    cobinhoodbalance,
	                    " COB"
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { "class": "col-lg-3 col-md-6 col-sm-12" },
	            _react2.default.createElement(
	              "div",
	              { "class": "card-box", id: "wandx" },
	              _react2.default.createElement(
	                _reactRouterDom.Link,
	                { to: { pathname: "/dashboard/wandx" } },
	                _react2.default.createElement(
	                  "div",
	                  { "class": "widget-detail-2" },
	                  _react2.default.createElement(
	                    "h3",
	                    { "class": "m-b-0" },
	                    _react2.default.createElement("img", { src: _wandx2.default, alt: "wandx icon", "class": "token64 m-b-10" }),
	                    _react2.default.createElement("div", { "class": "word-break" }),
	                    wandxbalance,
	                    " WAND"
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { "class": "col-lg-3 col-md-6 col-sm-12" },
	            _react2.default.createElement(
	              "div",
	              { "class": "card-box", id: "xyo" },
	              _react2.default.createElement(
	                _reactRouterDom.Link,
	                { to: { pathname: "/dashboard/xyo" } },
	                _react2.default.createElement(
	                  "div",
	                  { "class": "widget-detail-2" },
	                  _react2.default.createElement(
	                    "h3",
	                    { "class": "m-b-0" },
	                    _react2.default.createElement("img", { src: _xyo2.default, alt: "xyo icon", "class": "token64 m-b-10" }),
	                    _react2.default.createElement("div", { "class": "word-break" }),
	                    xyobalance,
	                    " XYO"
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { "class": "col-lg-3 col-md-6 col-sm-12" },
	            _react2.default.createElement(
	              "div",
	              { "class": "card-box", id: "kick" },
	              _react2.default.createElement(
	                _reactRouterDom.Link,
	                { to: { pathname: "/dashboard/kick" } },
	                _react2.default.createElement(
	                  "div",
	                  { "class": "widget-detail-2" },
	                  _react2.default.createElement(
	                    "h3",
	                    { "class": "m-b-0" },
	                    _react2.default.createElement("img", {
	                      src: _kick2.default,
	                      alt: "kick icon",
	                      "class": "token64 m-b-10"
	                    }),
	                    _react2.default.createElement("div", { "class": "word-break" }),
	                    kickbalance,
	                    " KICK"
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { "class": "row" },
	          _react2.default.createElement(
	            "div",
	            { "class": "col-lg-3 col-md-6 col-sm-12" },
	            _react2.default.createElement(
	              "div",
	              { "class": "card-box", id: "nbr" },
	              _react2.default.createElement(
	                _reactRouterDom.Link,
	                { to: { pathname: "/dashboard/nbr" } },
	                _react2.default.createElement(
	                  "div",
	                  { "class": "widget-detail-2" },
	                  _react2.default.createElement(
	                    "h3",
	                    { "class": "m-b-0" },
	                    _react2.default.createElement("img", {
	                      src: _nbr2.default,
	                      alt: "nbr icon",
	                      "class": "token64 m-b-10"
	                    }),
	                    _react2.default.createElement("div", { "class": "word-break" }),
	                    nbrbalance,
	                    " NBR"
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { "class": "col-lg-3 col-md-6 col-sm-12" },
	            _react2.default.createElement(
	              "div",
	              { "class": "card-box", id: "bitrewards" },
	              _react2.default.createElement(
	                _reactRouterDom.Link,
	                { to: { pathname: "/dashboard/bitrewards" } },
	                _react2.default.createElement(
	                  "div",
	                  { "class": "widget-detail-2" },
	                  _react2.default.createElement(
	                    "h3",
	                    { "class": "m-b-0" },
	                    _react2.default.createElement("img", {
	                      src: _bit2.default,
	                      alt: "bitrewards icon",
	                      "class": "token64 m-b-10"
	                    }),
	                    _react2.default.createElement("div", { "class": "word-break" }),
	                    bitrewardsbalance,
	                    " BIT"
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { "class": "col-lg-3 col-md-6 col-sm-12" },
	            _react2.default.createElement(
	              "div",
	              { "class": "card-box", id: "ncash" },
	              _react2.default.createElement(
	                _reactRouterDom.Link,
	                { to: { pathname: "/dashboard/ncash" } },
	                _react2.default.createElement(
	                  "div",
	                  { "class": "widget-detail-2" },
	                  _react2.default.createElement(
	                    "h3",
	                    { "class": "m-b-0" },
	                    _react2.default.createElement("img", {
	                      src: _ncash2.default,
	                      alt: "ncash icon",
	                      "class": "token64 m-b-10"
	                    }),
	                    _react2.default.createElement("div", { "class": "word-break" }),
	                    ncashbalance,
	                    " NCASH"
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { "class": "col-lg-3 col-md-6 col-sm-12" },
	            _react2.default.createElement(
	              "div",
	              { "class": "card-box", id: "essentia" },
	              _react2.default.createElement(
	                _reactRouterDom.Link,
	                { to: { pathname: "/dashboard/essentia" } },
	                _react2.default.createElement(
	                  "div",
	                  { "class": "widget-detail-2" },
	                  _react2.default.createElement(
	                    "h3",
	                    { "class": "m-b-0" },
	                    _react2.default.createElement("img", {
	                      src: _ess2.default,
	                      alt: "essentia icon",
	                      "class": "token64 m-b-10"
	                    }),
	                    _react2.default.createElement("div", { "class": "word-break" }),
	                    essentiabalance,
	                    " ESS"
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { "class": "col-lg-3 col-md-6 col-sm-12" },
	            _react2.default.createElement(
	              "div",
	              { "class": "card-box", id: "singularitynet" },
	              _react2.default.createElement(
	                _reactRouterDom.Link,
	                { to: { pathname: "/dashboard/singularitynet" } },
	                _react2.default.createElement(
	                  "div",
	                  { "class": "widget-detail-2" },
	                  _react2.default.createElement(
	                    "h3",
	                    { "class": "m-b-0" },
	                    _react2.default.createElement("img", {
	                      src: _singularity2.default,
	                      alt: "singularitynet icon",
	                      "class": "token64 m-b-10"
	                    }),
	                    _react2.default.createElement("div", { "class": "word-break" }),
	                    singularitynetbalance,
	                    " AGI"
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { "class": "col-lg-3 col-md-6 col-sm-12" },
	            _react2.default.createElement(
	              "div",
	              { "class": "card-box", id: "incodium" },
	              _react2.default.createElement(
	                _reactRouterDom.Link,
	                { to: { pathname: "/dashboard/incodium" } },
	                _react2.default.createElement(
	                  "div",
	                  { "class": "widget-detail-2" },
	                  _react2.default.createElement(
	                    "h3",
	                    { "class": "m-b-0" },
	                    _react2.default.createElement("img", {
	                      src: _inco2.default,
	                      alt: "incodium icon",
	                      "class": "token64 m-b-10"
	                    }),
	                    _react2.default.createElement("div", { "class": "word-break" }),
	                    incodiumbalance,
	                    " INCO"
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { "class": "col-lg-3 col-md-6 col-sm-12" },
	            _react2.default.createElement(
	              "div",
	              { "class": "card-box", id: "autonio" },
	              _react2.default.createElement(
	                _reactRouterDom.Link,
	                { to: { pathname: "/dashboard/autonio" } },
	                _react2.default.createElement(
	                  "div",
	                  { "class": "widget-detail-2" },
	                  _react2.default.createElement(
	                    "h3",
	                    { "class": "m-b-0" },
	                    _react2.default.createElement("img", {
	                      src: _auto2.default,
	                      alt: "autonio icon",
	                      "class": "token64 m-b-10"
	                    }),
	                    _react2.default.createElement("div", { "class": "word-break" }),
	                    autoniobalance,
	                    " NIO"
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { "class": "col-lg-3 col-md-6 col-sm-12" },
	            _react2.default.createElement(
	              "div",
	              { "class": "card-box", id: "credits" },
	              _react2.default.createElement(
	                _reactRouterDom.Link,
	                { to: { pathname: "/dashboard/credits" } },
	                _react2.default.createElement(
	                  "div",
	                  { "class": "widget-detail-2" },
	                  _react2.default.createElement(
	                    "h3",
	                    { "class": "m-b-0" },
	                    _react2.default.createElement("img", {
	                      src: _credit2.default,
	                      alt: "credits icon",
	                      "class": "token64 m-b-10"
	                    }),
	                    _react2.default.createElement("div", { "class": "word-break" }),
	                    creditsbalance,
	                    " CS"
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { "class": "col-lg-3 col-md-6 col-sm-12" },
	            _react2.default.createElement(
	              "div",
	              { "class": "card-box", id: "dicet" },
	              _react2.default.createElement(
	                _reactRouterDom.Link,
	                { to: { pathname: "/dashboard/dicet" } },
	                _react2.default.createElement(
	                  "div",
	                  { "class": "widget-detail-2" },
	                  _react2.default.createElement(
	                    "h3",
	                    { "class": "m-b-0" },
	                    _react2.default.createElement("img", {
	                      src: _dicet2.default,
	                      alt: "dicet icon",
	                      "class": "token64 m-b-10"
	                    }),
	                    _react2.default.createElement("div", { "class": "word-break" }),
	                    dicebalance,
	                    " CET"
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { "class": "col-lg-3 col-md-6 col-sm-12" },
	            _react2.default.createElement(
	              "div",
	              { "class": "card-box", id: "moneynet" },
	              _react2.default.createElement(
	                _reactRouterDom.Link,
	                { to: { pathname: "/dashboard/moneynet" } },
	                _react2.default.createElement(
	                  "div",
	                  { "class": "widget-detail-2" },
	                  _react2.default.createElement(
	                    "h3",
	                    { "class": "m-b-0" },
	                    _react2.default.createElement("img", {
	                      src: _mon2.default,
	                      alt: "moneynet icon",
	                      "class": "token64 m-b-10"
	                    }),
	                    _react2.default.createElement("div", { "class": "word-break" }),
	                    moneynetbalance,
	                    " MNC"
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { "class": "col-lg-3 col-md-6 col-sm-12" },
	            _react2.default.createElement(
	              "div",
	              { "class": "card-box", id: "stacs" },
	              _react2.default.createElement(
	                _reactRouterDom.Link,
	                { to: { pathname: "/dashboard/stacs" } },
	                _react2.default.createElement(
	                  "div",
	                  { "class": "widget-detail-2" },
	                  _react2.default.createElement(
	                    "h3",
	                    { "class": "m-b-0" },
	                    _react2.default.createElement("img", {
	                      src: _stacsLogo2.default,
	                      alt: "stacs icon",
	                      "class": "token64 m-b-10"
	                    }),
	                    _react2.default.createElement("div", { "class": "word-break" }),
	                    stacsbalance,
	                    " STACS"
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { "class": "col-lg-3 col-md-6 col-sm-12" },
	            _react2.default.createElement(
	              "div",
	              { "class": "card-box", id: "orbs" },
	              _react2.default.createElement(
	                _reactRouterDom.Link,
	                { to: { pathname: "/dashboard/orbs" } },
	                _react2.default.createElement(
	                  "div",
	                  { "class": "widget-detail-2" },
	                  _react2.default.createElement(
	                    "h3",
	                    { "class": "m-b-0" },
	                    _react2.default.createElement("img", {
	                      src: _orbsLogo2.default,
	                      alt: "orbs icon",
	                      "class": "token64 m-b-10"
	                    }),
	                    _react2.default.createElement("div", { "class": "word-break" }),
	                    orbsbalance,
	                    " ORBS"
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return TokenPage;
	}(_react.Component);
	
	exports.default = TokenPage;

/***/ },
/* 325 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(14);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _jsCookie = __webpack_require__(107);
	
	var _jsCookie2 = _interopRequireDefault(_jsCookie);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TopBar = function (_Component) {
	  _inherits(TopBar, _Component);
	
	  function TopBar() {
	    _classCallCheck(this, TopBar);
	
	    return _possibleConstructorReturn(this, (TopBar.__proto__ || Object.getPrototypeOf(TopBar)).apply(this, arguments));
	  }
	
	  _createClass(TopBar, [{
	    key: 'render',
	    value: function render() {
	      var data = this.props.data;
	      var switchLanguage = this.props.switchLanguage;
	
	      (0, _jquery2.default)(document).ready(function () {
	        var lang = _jsCookie2.default.get('language');
	        console.log(lang);
	        if (lang === "en") {
	          (0, _jquery2.default)("#english").attr("selected", true);
	          (0, _jquery2.default)("#korean").attr("selected", false);
	        } else if (lang === "kr") {
	          (0, _jquery2.default)("#korean").attr("selected", true);
	          (0, _jquery2.default)("#english").attr("selected", false);
	        }
	      });
	
	      var changelanguage = function changelanguage(event) {
	        if (event.target.value === "english") {
	          _jsCookie2.default.set('language', "en");
	          switchLanguage("en");
	        } else if (event.target.value === "korean") {
	          _jsCookie2.default.set('language', "kr");
	          switchLanguage("kr");
	        }
	      };
	
	      var toggleSideBar = function toggleSideBar() {
	        (0, _jquery2.default)("#wrapper").toggleClass("enlarged");
	        (0, _jquery2.default)("#wrapper").toggleClass("forced");
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { 'class': 'topbar' },
	        _react2.default.createElement(
	          'div',
	          { 'class': 'topbar-left' },
	          _react2.default.createElement(
	            'a',
	            { href: '/dashboard' },
	            _react2.default.createElement('div', { 'class': 'logo' })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { 'class': 'navbar navbar-default', role: 'navigation' },
	          _react2.default.createElement(
	            'div',
	            { 'class': 'container' },
	            _react2.default.createElement(
	              'ul',
	              { 'class': 'nav navbar-nav navbar-left' },
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'button',
	                  { onClick: toggleSideBar, 'class': 'button-menu-mobile open-left height-control' },
	                  _react2.default.createElement('i', { 'class': 'fa fa-bars', 'aria-hidden': 'true' })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'select',
	              { onChange: changelanguage, id: 'language_selection' },
	              _react2.default.createElement(
	                'option',
	                { value: 'english', id: 'english' },
	                'English'
	              ),
	              _react2.default.createElement(
	                'option',
	                { value: 'korean', id: 'korean' },
	                '\uD55C\uAD6D\uC5B4'
	              )
	            ),
	            _react2.default.createElement(
	              'ul',
	              { 'class': 'nav navbar-nav navbar-right' },
	              _react2.default.createElement(
	                'li',
	                { 'class': 'visuallyhidden' },
	                _react2.default.createElement(
	                  'a',
	                  { href: '/logout' },
	                  _react2.default.createElement(
	                    'h4',
	                    null,
	                    data.signout
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'a',
	                  { href: '/logout', 'class': 'right-bar-toggle height-control' },
	                  _react2.default.createElement(
	                    'h4',
	                    null,
	                    _react2.default.createElement('i', { 'class': 'fa fa-sign-out', 'aria-hidden': 'true' })
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return TopBar;
	}(_react.Component);
	
	exports.default = TopBar;

/***/ },
/* 326 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var action_types = __webpack_require__(163);
	
	var actions = {
	  switchLanguage: function switchLanguage(language) {
	    return {
	      type: action_types.SWITCH_LANGUAGE,
	      language: language
	    };
	  }
	};
	
	module.exports = actions;

/***/ },
/* 327 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var content = __webpack_require__(46);
	
	var api = {
	  getContent: function getContent() {
	    var language = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'en';
	
	    return content.filter(function (obj) {
	      return obj.lang === language;
	    })[0]["page"];
	  }
	};
	
	module.exports = api;

/***/ },
/* 328 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var action_types = __webpack_require__(163);
	var api = __webpack_require__(327);
	var Cookies = __webpack_require__(107);
	
	var lang = Cookies.get('language');
	var initialState;
	
	if (lang === "en") {
	  initialState = {
	    content: api.getContent("en")
	  };
	} else if (lang === "kr") {
	  initialState = {
	    content: api.getContent("kr")
	  };
	} else {
	  initialState = {
	    content: api.getContent() // Loads default language content (en) as an initial state
	  };
	  Cookies.set('language', "en");
	}
	
	var reducer = function reducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case action_types.SWITCH_LANGUAGE:
	      return {
	        content: api.getContent(action.language)
	      };
	    default:
	      return state;
	  }
	};
	
	module.exports = reducer;

/***/ },
/* 329 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(64);
	
	var _dao_token_letter = __webpack_require__(350);
	
	var _dao_token_letter2 = _interopRequireDefault(_dao_token_letter);
	
	var _popup = __webpack_require__(28);
	
	var _popup2 = _interopRequireDefault(_popup);
	
	var _content = __webpack_require__(46);
	
	var _content2 = _interopRequireDefault(_content);
	
	var _jquery = __webpack_require__(14);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _axios = __webpack_require__(27);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _qs = __webpack_require__(31);
	
	var _qs2 = _interopRequireDefault(_qs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Login = function (_Component) {
	  _inherits(Login, _Component);
	
	  function Login() {
	    _classCallCheck(this, Login);
	
	    return _possibleConstructorReturn(this, (Login.__proto__ || Object.getPrototypeOf(Login)).apply(this, arguments));
	  }
	
	  _createClass(Login, [{
	    key: 'render',
	    value: function render() {
	
	      _axios2.default.defaults.xsrfCookieName = 'csrftoken';
	      _axios2.default.defaults.xsrfHeaderName = 'X-CSRFToken';
	
	      var data = _content2.default[0]["page"]["login"];
	
	      var login = function login() {
	        var username = (0, _jquery2.default)("#username-login").val();
	        var password = (0, _jquery2.default)("#password-login").val();
	        var recaptcha = (0, _jquery2.default)("#g-recaptcha-response").val();
	
	        if (username === "" || password === "") {
	          _popup2.default.prototype.show(data["empty"]);
	        } else {
	          var request = _axios2.default.post('/api/login', _qs2.default.stringify({
	            "username": username,
	            "password": password,
	            "token": (0, _jquery2.default)("#otp-login").val(),
	            "g-recaptcha-response": recaptcha
	          }));
	          request.then(function (response) {
	            if (response.data.status === "success") {
	              window.location.href = "/dashboard";
	            } else if (response.data.status === "otp_required") {
	              _popup2.default.prototype.show("Failed:\n you are required to enter opt tokens");
	            }
	          });
	          request.catch(function (error) {
	            _popup2.default.prototype.show("Failed:\n" + error.response.data.message);
	          });
	        }
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { id: 'wrapper' },
	        _react2.default.createElement(
	          'div',
	          { 'class': 'container' },
	          _react2.default.createElement(
	            'div',
	            { 'class': 'fixed-card-box' },
	            _react2.default.createElement(
	              'div',
	              { 'class': 'logo m-t-30 m-b-30' },
	              _react2.default.createElement('img', { src: _dao_token_letter2.default, alt: 'AiDAO logo', 'class': 'login_logo' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { 'class': 'form-group' },
	              _react2.default.createElement('input', { type: 'text', placeholder: data.enterUsername, 'class': 'form-control', id: 'username-login', required: true })
	            ),
	            _react2.default.createElement(
	              'div',
	              { 'class': 'form-group' },
	              _react2.default.createElement('input', { id: 'password-login', type: 'password', placeholder: data.enterPassword, 'class': 'form-control', required: true })
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              data.otpLabel
	            ),
	            _react2.default.createElement(
	              'div',
	              { 'class': 'form-group otp-form-login' },
	              _react2.default.createElement('input', { id: 'otp-login', type: 'text', placeholder: data.enterOtp, 'class': 'form-control', required: true })
	            ),
	            _react2.default.createElement(
	              'div',
	              { 'class': 'center' },
	              _react2.default.createElement('div', { 'class': 'g-recaptcha distance', 'data-sitekey': '6LcrwD0UAAAAAOvi683E0yW6qkjkrWUZNWRYEWZk' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { 'class': 'grey_btn m-b-20' },
	              _react2.default.createElement(
	                'button',
	                { onClick: login, 'class': 'btn btn-block btn-default waves-effect waves-light btn-md p-t-5 p-b-5' },
	                data.loginbutton
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              { 'class': 'text-right' },
	              _react2.default.createElement(
	                'a',
	                { href: '/resetpassword' },
	                data.resetpassword
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Login;
	}(_react.Component);
	
	exports.default = Login;

/***/ },
/* 330 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Redirect = function (_Component) {
	  _inherits(Redirect, _Component);
	
	  function Redirect(props) {
	    _classCallCheck(this, Redirect);
	
	    var _this = _possibleConstructorReturn(this, (Redirect.__proto__ || Object.getPrototypeOf(Redirect)).call(this, props));
	
	    window.location.replace('/dashboard/security');
	    return _this;
	  }
	
	  _createClass(Redirect, [{
	    key: 'render',
	    value: function render() {
	
	      return _react2.default.createElement('div', null);
	    }
	  }]);
	
	  return Redirect;
	}(_react.Component);
	
	exports.default = Redirect;

/***/ },
/* 331 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(64);
	
	var _djangocrsf = __webpack_require__(162);
	
	var _djangocrsf2 = _interopRequireDefault(_djangocrsf);
	
	var _aidao_outlined_grey = __webpack_require__(245);
	
	var _aidao_outlined_grey2 = _interopRequireDefault(_aidao_outlined_grey);
	
	var _content = __webpack_require__(46);
	
	var _content2 = _interopRequireDefault(_content);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ResetPassword = function (_Component) {
	  _inherits(ResetPassword, _Component);
	
	  function ResetPassword() {
	    _classCallCheck(this, ResetPassword);
	
	    return _possibleConstructorReturn(this, (ResetPassword.__proto__ || Object.getPrototypeOf(ResetPassword)).apply(this, arguments));
	  }
	
	  _createClass(ResetPassword, [{
	    key: 'render',
	    value: function render() {
	
	      var data = _content2.default[1]["page"]["resetpassword"];
	
	      return _react2.default.createElement(
	        'div',
	        { id: 'wrapper' },
	        _react2.default.createElement(
	          'div',
	          { 'class': 'container' },
	          _react2.default.createElement(
	            'div',
	            { 'class': 'fixed-card-box' },
	            _react2.default.createElement(
	              'div',
	              { 'class': 'logo m-t-30 m-b-30' },
	              _react2.default.createElement('img', { src: _aidao_outlined_grey2.default, alt: 'AiDAO logo' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { 'class': 'text-left' },
	              _react2.default.createElement(
	                'h4',
	                { 'class': 'header-title m-t-0 m-b-30' },
	                data.sendRecoveryLink
	              ),
	              _react2.default.createElement(
	                'form',
	                { method: 'post' },
	                _react2.default.createElement(_djangocrsf2.default, null),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'form-group' },
	                  _react2.default.createElement('input', { id: 'pass1', name: 'inputEmail', type: 'email', placeholder: data.enterEmail, 'class': 'form-control', 'data-parsley-id': '8', required: true })
	                ),
	                _react2.default.createElement('div', { 'class': 'g-recaptcha distance', 'data-sitekey': '6LcrwD0UAAAAAOvi683E0yW6qkjkrWUZNWRYEWZk' }),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'grey_btn m-b-20 m-t-10' },
	                  _react2.default.createElement(
	                    'button',
	                    { type: 'submit', 'class': 'btn btn-block btn-default waves-effect waves-light btn-md p-t-5 p-b-5' },
	                    data.send
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'forgotpassword' },
	                  _react2.default.createElement(
	                    'a',
	                    { href: '/' },
	                    data.backtoSignin
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return ResetPassword;
	}(_react.Component);
	
	exports.default = ResetPassword;

/***/ },
/* 332 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _djangocrsf = __webpack_require__(162);
	
	var _djangocrsf2 = _interopRequireDefault(_djangocrsf);
	
	__webpack_require__(64);
	
	var _aidao_outlined_grey = __webpack_require__(245);
	
	var _aidao_outlined_grey2 = _interopRequireDefault(_aidao_outlined_grey);
	
	var _content = __webpack_require__(46);
	
	var _content2 = _interopRequireDefault(_content);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Setup = function (_Component) {
	  _inherits(Setup, _Component);
	
	  function Setup() {
	    _classCallCheck(this, Setup);
	
	    return _possibleConstructorReturn(this, (Setup.__proto__ || Object.getPrototypeOf(Setup)).apply(this, arguments));
	  }
	
	  _createClass(Setup, [{
	    key: 'render',
	    value: function render() {
	
	      var data = _content2.default[0]["page"]["setup"];
	
	      var email = window.email;
	      console.log(email);
	      var token = "";
	      var uidb64 = "";
	      if (window.reset) {
	        token = window.token;
	        uidb64 = window.user;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { 'class': 'container' },
	          _react2.default.createElement(
	            'div',
	            { 'class': 'fixed-card-box' },
	            _react2.default.createElement(
	              'div',
	              { 'class': 'logo m-t-30 m-b-30' },
	              _react2.default.createElement('img', { src: _aidao_outlined_grey2.default, alt: 'aidao logo' })
	            ),
	            _react2.default.createElement(
	              'form',
	              { method: 'post', action: '/setup' },
	              _react2.default.createElement(_djangocrsf2.default, null),
	              _react2.default.createElement(
	                'h3',
	                { 'class': 'm-t-20 m-b-20 text-center' },
	                data.reset
	              ),
	              _react2.default.createElement(
	                'h4',
	                { 'class': 'm-t-10 m-b-20 text-center' },
	                email
	              ),
	              _react2.default.createElement(
	                'div',
	                { 'class': 'form-group' },
	                _react2.default.createElement('input', { type: 'text', 'class': 'form-control', name: 'inputUser', id: 'username', placeholder: data.enterNewUsername, 'parsley-trigger': 'change', 'data-parsley-id': '6', required: true })
	              ),
	              _react2.default.createElement(
	                'div',
	                { 'class': 'form-group' },
	                _react2.default.createElement('input', { type: 'password', 'class': 'form-control', name: 'inputPassword', id: 'pass1', placeholder: data.enterNewPassword, 'data-parsley-id': '8', required: true })
	              ),
	              _react2.default.createElement(
	                'div',
	                { 'class': 'form-group' },
	                _react2.default.createElement('input', { type: 'password', 'class': 'form-control', name: 'confirmPassword', id: 'confirmPassword', placeholder: data.ConfirmNewPassword, pattern: '.{8,}', title: data.pwLessThan8, required: true })
	              ),
	              _react2.default.createElement('input', { type: 'hidden', name: 'token', id: 'token', value: token }),
	              _react2.default.createElement('input', { type: 'hidden', name: 'uidb64', id: 'uidb64', value: uidb64 }),
	              _react2.default.createElement(
	                'div',
	                { 'class': 'grey_btn m-b-20' },
	                _react2.default.createElement(
	                  'button',
	                  { type: 'submit', 'class': 'btn btn-block btn-default waves-effect waves-light btn-md p-t-5 p-b-5' },
	                  data.save
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              { 'class': 'text-right' },
	              _react2.default.createElement(
	                'a',
	                { href: '/logout' },
	                data.signOut
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Setup;
	}(_react.Component);
	
	exports.default = Setup;

/***/ },
/* 333 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(514);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _App = __webpack_require__(289);
	
	var _App2 = _interopRequireDefault(_App);
	
	__webpack_require__(344);
	
	var _reducer = __webpack_require__(328);
	
	var _reducer2 = _interopRequireDefault(_reducer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createStore = __webpack_require__(243).createStore;
	var Provider = __webpack_require__(234).Provider;
	
	var store = createStore(_reducer2.default);
	
	_reactDom2.default.render(_react2.default.createElement(
	  Provider,
	  { store: store },
	  _react2.default.createElement(_App2.default, null)
	), document.getElementById('root'));

/***/ },
/* 334 */
/***/ function(module, exports) {

	"use strict";
	
	// Rule of Level DAO
	var DAO_LEVEL_TABLE = {
	  "10": 100000000,
	  "9": 50000000,
	  "8": 10000000,
	  "7": 5000000,
	  "6": 1000000,
	  "5": 500000,
	  "4": 100000,
	  "3": 10000,
	  "2": 1000,
	  "1": 99
	};
	
	module.exports = {
	  "daolevel": DAO_LEVEL_TABLE
	};

/***/ },
/* 335 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-array/ Version 1.2.1. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports) :
		typeof define === 'function' && define.amd ? define(['exports'], factory) :
		(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	var ascending = function(a, b) {
	  return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
	};
	
	var bisector = function(compare) {
	  if (compare.length === 1) compare = ascendingComparator(compare);
	  return {
	    left: function(a, x, lo, hi) {
	      if (lo == null) lo = 0;
	      if (hi == null) hi = a.length;
	      while (lo < hi) {
	        var mid = lo + hi >>> 1;
	        if (compare(a[mid], x) < 0) lo = mid + 1;
	        else hi = mid;
	      }
	      return lo;
	    },
	    right: function(a, x, lo, hi) {
	      if (lo == null) lo = 0;
	      if (hi == null) hi = a.length;
	      while (lo < hi) {
	        var mid = lo + hi >>> 1;
	        if (compare(a[mid], x) > 0) hi = mid;
	        else lo = mid + 1;
	      }
	      return lo;
	    }
	  };
	};
	
	function ascendingComparator(f) {
	  return function(d, x) {
	    return ascending(f(d), x);
	  };
	}
	
	var ascendingBisect = bisector(ascending);
	var bisectRight = ascendingBisect.right;
	var bisectLeft = ascendingBisect.left;
	
	var pairs = function(array, f) {
	  if (f == null) f = pair;
	  var i = 0, n = array.length - 1, p = array[0], pairs = new Array(n < 0 ? 0 : n);
	  while (i < n) pairs[i] = f(p, p = array[++i]);
	  return pairs;
	};
	
	function pair(a, b) {
	  return [a, b];
	}
	
	var cross = function(values0, values1, reduce) {
	  var n0 = values0.length,
	      n1 = values1.length,
	      values = new Array(n0 * n1),
	      i0,
	      i1,
	      i,
	      value0;
	
	  if (reduce == null) reduce = pair;
	
	  for (i0 = i = 0; i0 < n0; ++i0) {
	    for (value0 = values0[i0], i1 = 0; i1 < n1; ++i1, ++i) {
	      values[i] = reduce(value0, values1[i1]);
	    }
	  }
	
	  return values;
	};
	
	var descending = function(a, b) {
	  return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
	};
	
	var number = function(x) {
	  return x === null ? NaN : +x;
	};
	
	var variance = function(values, valueof) {
	  var n = values.length,
	      m = 0,
	      i = -1,
	      mean = 0,
	      value,
	      delta,
	      sum = 0;
	
	  if (valueof == null) {
	    while (++i < n) {
	      if (!isNaN(value = number(values[i]))) {
	        delta = value - mean;
	        mean += delta / ++m;
	        sum += delta * (value - mean);
	      }
	    }
	  }
	
	  else {
	    while (++i < n) {
	      if (!isNaN(value = number(valueof(values[i], i, values)))) {
	        delta = value - mean;
	        mean += delta / ++m;
	        sum += delta * (value - mean);
	      }
	    }
	  }
	
	  if (m > 1) return sum / (m - 1);
	};
	
	var deviation = function(array, f) {
	  var v = variance(array, f);
	  return v ? Math.sqrt(v) : v;
	};
	
	var extent = function(values, valueof) {
	  var n = values.length,
	      i = -1,
	      value,
	      min,
	      max;
	
	  if (valueof == null) {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = values[i]) != null && value >= value) {
	        min = max = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = values[i]) != null) {
	            if (min > value) min = value;
	            if (max < value) max = value;
	          }
	        }
	      }
	    }
	  }
	
	  else {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = valueof(values[i], i, values)) != null && value >= value) {
	        min = max = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = valueof(values[i], i, values)) != null) {
	            if (min > value) min = value;
	            if (max < value) max = value;
	          }
	        }
	      }
	    }
	  }
	
	  return [min, max];
	};
	
	var array = Array.prototype;
	
	var slice = array.slice;
	var map = array.map;
	
	var constant = function(x) {
	  return function() {
	    return x;
	  };
	};
	
	var identity = function(x) {
	  return x;
	};
	
	var range = function(start, stop, step) {
	  start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;
	
	  var i = -1,
	      n = Math.max(0, Math.ceil((stop - start) / step)) | 0,
	      range = new Array(n);
	
	  while (++i < n) {
	    range[i] = start + i * step;
	  }
	
	  return range;
	};
	
	var e10 = Math.sqrt(50);
	var e5 = Math.sqrt(10);
	var e2 = Math.sqrt(2);
	
	var ticks = function(start, stop, count) {
	  var reverse,
	      i = -1,
	      n,
	      ticks,
	      step;
	
	  stop = +stop, start = +start, count = +count;
	  if (start === stop && count > 0) return [start];
	  if (reverse = stop < start) n = start, start = stop, stop = n;
	  if ((step = tickIncrement(start, stop, count)) === 0 || !isFinite(step)) return [];
	
	  if (step > 0) {
	    start = Math.ceil(start / step);
	    stop = Math.floor(stop / step);
	    ticks = new Array(n = Math.ceil(stop - start + 1));
	    while (++i < n) ticks[i] = (start + i) * step;
	  } else {
	    start = Math.floor(start * step);
	    stop = Math.ceil(stop * step);
	    ticks = new Array(n = Math.ceil(start - stop + 1));
	    while (++i < n) ticks[i] = (start - i) / step;
	  }
	
	  if (reverse) ticks.reverse();
	
	  return ticks;
	};
	
	function tickIncrement(start, stop, count) {
	  var step = (stop - start) / Math.max(0, count),
	      power = Math.floor(Math.log(step) / Math.LN10),
	      error = step / Math.pow(10, power);
	  return power >= 0
	      ? (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1) * Math.pow(10, power)
	      : -Math.pow(10, -power) / (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1);
	}
	
	function tickStep(start, stop, count) {
	  var step0 = Math.abs(stop - start) / Math.max(0, count),
	      step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)),
	      error = step0 / step1;
	  if (error >= e10) step1 *= 10;
	  else if (error >= e5) step1 *= 5;
	  else if (error >= e2) step1 *= 2;
	  return stop < start ? -step1 : step1;
	}
	
	var sturges = function(values) {
	  return Math.ceil(Math.log(values.length) / Math.LN2) + 1;
	};
	
	var histogram = function() {
	  var value = identity,
	      domain = extent,
	      threshold = sturges;
	
	  function histogram(data) {
	    var i,
	        n = data.length,
	        x,
	        values = new Array(n);
	
	    for (i = 0; i < n; ++i) {
	      values[i] = value(data[i], i, data);
	    }
	
	    var xz = domain(values),
	        x0 = xz[0],
	        x1 = xz[1],
	        tz = threshold(values, x0, x1);
	
	    // Convert number of thresholds into uniform thresholds.
	    if (!Array.isArray(tz)) {
	      tz = tickStep(x0, x1, tz);
	      tz = range(Math.ceil(x0 / tz) * tz, Math.floor(x1 / tz) * tz, tz); // exclusive
	    }
	
	    // Remove any thresholds outside the domain.
	    var m = tz.length;
	    while (tz[0] <= x0) tz.shift(), --m;
	    while (tz[m - 1] > x1) tz.pop(), --m;
	
	    var bins = new Array(m + 1),
	        bin;
	
	    // Initialize bins.
	    for (i = 0; i <= m; ++i) {
	      bin = bins[i] = [];
	      bin.x0 = i > 0 ? tz[i - 1] : x0;
	      bin.x1 = i < m ? tz[i] : x1;
	    }
	
	    // Assign data to bins by value, ignoring any outside the domain.
	    for (i = 0; i < n; ++i) {
	      x = values[i];
	      if (x0 <= x && x <= x1) {
	        bins[bisectRight(tz, x, 0, m)].push(data[i]);
	      }
	    }
	
	    return bins;
	  }
	
	  histogram.value = function(_) {
	    return arguments.length ? (value = typeof _ === "function" ? _ : constant(_), histogram) : value;
	  };
	
	  histogram.domain = function(_) {
	    return arguments.length ? (domain = typeof _ === "function" ? _ : constant([_[0], _[1]]), histogram) : domain;
	  };
	
	  histogram.thresholds = function(_) {
	    return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? constant(slice.call(_)) : constant(_), histogram) : threshold;
	  };
	
	  return histogram;
	};
	
	var quantile = function(values, p, valueof) {
	  if (valueof == null) valueof = number;
	  if (!(n = values.length)) return;
	  if ((p = +p) <= 0 || n < 2) return +valueof(values[0], 0, values);
	  if (p >= 1) return +valueof(values[n - 1], n - 1, values);
	  var n,
	      i = (n - 1) * p,
	      i0 = Math.floor(i),
	      value0 = +valueof(values[i0], i0, values),
	      value1 = +valueof(values[i0 + 1], i0 + 1, values);
	  return value0 + (value1 - value0) * (i - i0);
	};
	
	var freedmanDiaconis = function(values, min, max) {
	  values = map.call(values, number).sort(ascending);
	  return Math.ceil((max - min) / (2 * (quantile(values, 0.75) - quantile(values, 0.25)) * Math.pow(values.length, -1 / 3)));
	};
	
	var scott = function(values, min, max) {
	  return Math.ceil((max - min) / (3.5 * deviation(values) * Math.pow(values.length, -1 / 3)));
	};
	
	var max = function(values, valueof) {
	  var n = values.length,
	      i = -1,
	      value,
	      max;
	
	  if (valueof == null) {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = values[i]) != null && value >= value) {
	        max = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = values[i]) != null && value > max) {
	            max = value;
	          }
	        }
	      }
	    }
	  }
	
	  else {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = valueof(values[i], i, values)) != null && value >= value) {
	        max = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = valueof(values[i], i, values)) != null && value > max) {
	            max = value;
	          }
	        }
	      }
	    }
	  }
	
	  return max;
	};
	
	var mean = function(values, valueof) {
	  var n = values.length,
	      m = n,
	      i = -1,
	      value,
	      sum = 0;
	
	  if (valueof == null) {
	    while (++i < n) {
	      if (!isNaN(value = number(values[i]))) sum += value;
	      else --m;
	    }
	  }
	
	  else {
	    while (++i < n) {
	      if (!isNaN(value = number(valueof(values[i], i, values)))) sum += value;
	      else --m;
	    }
	  }
	
	  if (m) return sum / m;
	};
	
	var median = function(values, valueof) {
	  var n = values.length,
	      i = -1,
	      value,
	      numbers = [];
	
	  if (valueof == null) {
	    while (++i < n) {
	      if (!isNaN(value = number(values[i]))) {
	        numbers.push(value);
	      }
	    }
	  }
	
	  else {
	    while (++i < n) {
	      if (!isNaN(value = number(valueof(values[i], i, values)))) {
	        numbers.push(value);
	      }
	    }
	  }
	
	  return quantile(numbers.sort(ascending), 0.5);
	};
	
	var merge = function(arrays) {
	  var n = arrays.length,
	      m,
	      i = -1,
	      j = 0,
	      merged,
	      array;
	
	  while (++i < n) j += arrays[i].length;
	  merged = new Array(j);
	
	  while (--n >= 0) {
	    array = arrays[n];
	    m = array.length;
	    while (--m >= 0) {
	      merged[--j] = array[m];
	    }
	  }
	
	  return merged;
	};
	
	var min = function(values, valueof) {
	  var n = values.length,
	      i = -1,
	      value,
	      min;
	
	  if (valueof == null) {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = values[i]) != null && value >= value) {
	        min = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = values[i]) != null && min > value) {
	            min = value;
	          }
	        }
	      }
	    }
	  }
	
	  else {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = valueof(values[i], i, values)) != null && value >= value) {
	        min = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = valueof(values[i], i, values)) != null && min > value) {
	            min = value;
	          }
	        }
	      }
	    }
	  }
	
	  return min;
	};
	
	var permute = function(array, indexes) {
	  var i = indexes.length, permutes = new Array(i);
	  while (i--) permutes[i] = array[indexes[i]];
	  return permutes;
	};
	
	var scan = function(values, compare) {
	  if (!(n = values.length)) return;
	  var n,
	      i = 0,
	      j = 0,
	      xi,
	      xj = values[j];
	
	  if (compare == null) compare = ascending;
	
	  while (++i < n) {
	    if (compare(xi = values[i], xj) < 0 || compare(xj, xj) !== 0) {
	      xj = xi, j = i;
	    }
	  }
	
	  if (compare(xj, xj) === 0) return j;
	};
	
	var shuffle = function(array, i0, i1) {
	  var m = (i1 == null ? array.length : i1) - (i0 = i0 == null ? 0 : +i0),
	      t,
	      i;
	
	  while (m) {
	    i = Math.random() * m-- | 0;
	    t = array[m + i0];
	    array[m + i0] = array[i + i0];
	    array[i + i0] = t;
	  }
	
	  return array;
	};
	
	var sum = function(values, valueof) {
	  var n = values.length,
	      i = -1,
	      value,
	      sum = 0;
	
	  if (valueof == null) {
	    while (++i < n) {
	      if (value = +values[i]) sum += value; // Note: zero and null are equivalent.
	    }
	  }
	
	  else {
	    while (++i < n) {
	      if (value = +valueof(values[i], i, values)) sum += value;
	    }
	  }
	
	  return sum;
	};
	
	var transpose = function(matrix) {
	  if (!(n = matrix.length)) return [];
	  for (var i = -1, m = min(matrix, length), transpose = new Array(m); ++i < m;) {
	    for (var j = -1, n, row = transpose[i] = new Array(n); ++j < n;) {
	      row[j] = matrix[j][i];
	    }
	  }
	  return transpose;
	};
	
	function length(d) {
	  return d.length;
	}
	
	var zip = function() {
	  return transpose(arguments);
	};
	
	exports.bisect = bisectRight;
	exports.bisectRight = bisectRight;
	exports.bisectLeft = bisectLeft;
	exports.ascending = ascending;
	exports.bisector = bisector;
	exports.cross = cross;
	exports.descending = descending;
	exports.deviation = deviation;
	exports.extent = extent;
	exports.histogram = histogram;
	exports.thresholdFreedmanDiaconis = freedmanDiaconis;
	exports.thresholdScott = scott;
	exports.thresholdSturges = sturges;
	exports.max = max;
	exports.mean = mean;
	exports.median = median;
	exports.merge = merge;
	exports.min = min;
	exports.pairs = pairs;
	exports.permute = permute;
	exports.quantile = quantile;
	exports.range = range;
	exports.scan = scan;
	exports.shuffle = shuffle;
	exports.sum = sum;
	exports.ticks = ticks;
	exports.tickIncrement = tickIncrement;
	exports.tickStep = tickStep;
	exports.transpose = transpose;
	exports.variance = variance;
	exports.zip = zip;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 336 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-collection/ Version 1.0.4. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports) :
		typeof define === 'function' && define.amd ? define(['exports'], factory) :
		(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	var prefix = "$";
	
	function Map() {}
	
	Map.prototype = map.prototype = {
	  constructor: Map,
	  has: function(key) {
	    return (prefix + key) in this;
	  },
	  get: function(key) {
	    return this[prefix + key];
	  },
	  set: function(key, value) {
	    this[prefix + key] = value;
	    return this;
	  },
	  remove: function(key) {
	    var property = prefix + key;
	    return property in this && delete this[property];
	  },
	  clear: function() {
	    for (var property in this) if (property[0] === prefix) delete this[property];
	  },
	  keys: function() {
	    var keys = [];
	    for (var property in this) if (property[0] === prefix) keys.push(property.slice(1));
	    return keys;
	  },
	  values: function() {
	    var values = [];
	    for (var property in this) if (property[0] === prefix) values.push(this[property]);
	    return values;
	  },
	  entries: function() {
	    var entries = [];
	    for (var property in this) if (property[0] === prefix) entries.push({key: property.slice(1), value: this[property]});
	    return entries;
	  },
	  size: function() {
	    var size = 0;
	    for (var property in this) if (property[0] === prefix) ++size;
	    return size;
	  },
	  empty: function() {
	    for (var property in this) if (property[0] === prefix) return false;
	    return true;
	  },
	  each: function(f) {
	    for (var property in this) if (property[0] === prefix) f(this[property], property.slice(1), this);
	  }
	};
	
	function map(object, f) {
	  var map = new Map;
	
	  // Copy constructor.
	  if (object instanceof Map) object.each(function(value, key) { map.set(key, value); });
	
	  // Index array by numeric index or specified key function.
	  else if (Array.isArray(object)) {
	    var i = -1,
	        n = object.length,
	        o;
	
	    if (f == null) while (++i < n) map.set(i, object[i]);
	    else while (++i < n) map.set(f(o = object[i], i, object), o);
	  }
	
	  // Convert object to map.
	  else if (object) for (var key in object) map.set(key, object[key]);
	
	  return map;
	}
	
	var nest = function() {
	  var keys = [],
	      sortKeys = [],
	      sortValues,
	      rollup,
	      nest;
	
	  function apply(array, depth, createResult, setResult) {
	    if (depth >= keys.length) {
	      if (sortValues != null) array.sort(sortValues);
	      return rollup != null ? rollup(array) : array;
	    }
	
	    var i = -1,
	        n = array.length,
	        key = keys[depth++],
	        keyValue,
	        value,
	        valuesByKey = map(),
	        values,
	        result = createResult();
	
	    while (++i < n) {
	      if (values = valuesByKey.get(keyValue = key(value = array[i]) + "")) {
	        values.push(value);
	      } else {
	        valuesByKey.set(keyValue, [value]);
	      }
	    }
	
	    valuesByKey.each(function(values, key) {
	      setResult(result, key, apply(values, depth, createResult, setResult));
	    });
	
	    return result;
	  }
	
	  function entries(map$$1, depth) {
	    if (++depth > keys.length) return map$$1;
	    var array, sortKey = sortKeys[depth - 1];
	    if (rollup != null && depth >= keys.length) array = map$$1.entries();
	    else array = [], map$$1.each(function(v, k) { array.push({key: k, values: entries(v, depth)}); });
	    return sortKey != null ? array.sort(function(a, b) { return sortKey(a.key, b.key); }) : array;
	  }
	
	  return nest = {
	    object: function(array) { return apply(array, 0, createObject, setObject); },
	    map: function(array) { return apply(array, 0, createMap, setMap); },
	    entries: function(array) { return entries(apply(array, 0, createMap, setMap), 0); },
	    key: function(d) { keys.push(d); return nest; },
	    sortKeys: function(order) { sortKeys[keys.length - 1] = order; return nest; },
	    sortValues: function(order) { sortValues = order; return nest; },
	    rollup: function(f) { rollup = f; return nest; }
	  };
	};
	
	function createObject() {
	  return {};
	}
	
	function setObject(object, key, value) {
	  object[key] = value;
	}
	
	function createMap() {
	  return map();
	}
	
	function setMap(map$$1, key, value) {
	  map$$1.set(key, value);
	}
	
	function Set() {}
	
	var proto = map.prototype;
	
	Set.prototype = set.prototype = {
	  constructor: Set,
	  has: proto.has,
	  add: function(value) {
	    value += "";
	    this[prefix + value] = value;
	    return this;
	  },
	  remove: proto.remove,
	  clear: proto.clear,
	  values: proto.keys,
	  size: proto.size,
	  empty: proto.empty,
	  each: proto.each
	};
	
	function set(object, f) {
	  var set = new Set;
	
	  // Copy constructor.
	  if (object instanceof Set) object.each(function(value) { set.add(value); });
	
	  // Otherwise, assume it’s an array.
	  else if (object) {
	    var i = -1, n = object.length;
	    if (f == null) while (++i < n) set.add(object[i]);
	    else while (++i < n) set.add(f(object[i], i, object));
	  }
	
	  return set;
	}
	
	var keys = function(map) {
	  var keys = [];
	  for (var key in map) keys.push(key);
	  return keys;
	};
	
	var values = function(map) {
	  var values = [];
	  for (var key in map) values.push(map[key]);
	  return values;
	};
	
	var entries = function(map) {
	  var entries = [];
	  for (var key in map) entries.push({key: key, value: map[key]});
	  return entries;
	};
	
	exports.nest = nest;
	exports.set = set;
	exports.map = map;
	exports.keys = keys;
	exports.values = values;
	exports.entries = entries;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 337 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-ease/ Version 1.0.3. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports) :
		typeof define === 'function' && define.amd ? define(['exports'], factory) :
		(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	function linear(t) {
	  return +t;
	}
	
	function quadIn(t) {
	  return t * t;
	}
	
	function quadOut(t) {
	  return t * (2 - t);
	}
	
	function quadInOut(t) {
	  return ((t *= 2) <= 1 ? t * t : --t * (2 - t) + 1) / 2;
	}
	
	function cubicIn(t) {
	  return t * t * t;
	}
	
	function cubicOut(t) {
	  return --t * t * t + 1;
	}
	
	function cubicInOut(t) {
	  return ((t *= 2) <= 1 ? t * t * t : (t -= 2) * t * t + 2) / 2;
	}
	
	var exponent = 3;
	
	var polyIn = (function custom(e) {
	  e = +e;
	
	  function polyIn(t) {
	    return Math.pow(t, e);
	  }
	
	  polyIn.exponent = custom;
	
	  return polyIn;
	})(exponent);
	
	var polyOut = (function custom(e) {
	  e = +e;
	
	  function polyOut(t) {
	    return 1 - Math.pow(1 - t, e);
	  }
	
	  polyOut.exponent = custom;
	
	  return polyOut;
	})(exponent);
	
	var polyInOut = (function custom(e) {
	  e = +e;
	
	  function polyInOut(t) {
	    return ((t *= 2) <= 1 ? Math.pow(t, e) : 2 - Math.pow(2 - t, e)) / 2;
	  }
	
	  polyInOut.exponent = custom;
	
	  return polyInOut;
	})(exponent);
	
	var pi = Math.PI;
	var halfPi = pi / 2;
	
	function sinIn(t) {
	  return 1 - Math.cos(t * halfPi);
	}
	
	function sinOut(t) {
	  return Math.sin(t * halfPi);
	}
	
	function sinInOut(t) {
	  return (1 - Math.cos(pi * t)) / 2;
	}
	
	function expIn(t) {
	  return Math.pow(2, 10 * t - 10);
	}
	
	function expOut(t) {
	  return 1 - Math.pow(2, -10 * t);
	}
	
	function expInOut(t) {
	  return ((t *= 2) <= 1 ? Math.pow(2, 10 * t - 10) : 2 - Math.pow(2, 10 - 10 * t)) / 2;
	}
	
	function circleIn(t) {
	  return 1 - Math.sqrt(1 - t * t);
	}
	
	function circleOut(t) {
	  return Math.sqrt(1 - --t * t);
	}
	
	function circleInOut(t) {
	  return ((t *= 2) <= 1 ? 1 - Math.sqrt(1 - t * t) : Math.sqrt(1 - (t -= 2) * t) + 1) / 2;
	}
	
	var b1 = 4 / 11;
	var b2 = 6 / 11;
	var b3 = 8 / 11;
	var b4 = 3 / 4;
	var b5 = 9 / 11;
	var b6 = 10 / 11;
	var b7 = 15 / 16;
	var b8 = 21 / 22;
	var b9 = 63 / 64;
	var b0 = 1 / b1 / b1;
	
	function bounceIn(t) {
	  return 1 - bounceOut(1 - t);
	}
	
	function bounceOut(t) {
	  return (t = +t) < b1 ? b0 * t * t : t < b3 ? b0 * (t -= b2) * t + b4 : t < b6 ? b0 * (t -= b5) * t + b7 : b0 * (t -= b8) * t + b9;
	}
	
	function bounceInOut(t) {
	  return ((t *= 2) <= 1 ? 1 - bounceOut(1 - t) : bounceOut(t - 1) + 1) / 2;
	}
	
	var overshoot = 1.70158;
	
	var backIn = (function custom(s) {
	  s = +s;
	
	  function backIn(t) {
	    return t * t * ((s + 1) * t - s);
	  }
	
	  backIn.overshoot = custom;
	
	  return backIn;
	})(overshoot);
	
	var backOut = (function custom(s) {
	  s = +s;
	
	  function backOut(t) {
	    return --t * t * ((s + 1) * t + s) + 1;
	  }
	
	  backOut.overshoot = custom;
	
	  return backOut;
	})(overshoot);
	
	var backInOut = (function custom(s) {
	  s = +s;
	
	  function backInOut(t) {
	    return ((t *= 2) < 1 ? t * t * ((s + 1) * t - s) : (t -= 2) * t * ((s + 1) * t + s) + 2) / 2;
	  }
	
	  backInOut.overshoot = custom;
	
	  return backInOut;
	})(overshoot);
	
	var tau = 2 * Math.PI;
	var amplitude = 1;
	var period = 0.3;
	
	var elasticIn = (function custom(a, p) {
	  var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= tau);
	
	  function elasticIn(t) {
	    return a * Math.pow(2, 10 * --t) * Math.sin((s - t) / p);
	  }
	
	  elasticIn.amplitude = function(a) { return custom(a, p * tau); };
	  elasticIn.period = function(p) { return custom(a, p); };
	
	  return elasticIn;
	})(amplitude, period);
	
	var elasticOut = (function custom(a, p) {
	  var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= tau);
	
	  function elasticOut(t) {
	    return 1 - a * Math.pow(2, -10 * (t = +t)) * Math.sin((t + s) / p);
	  }
	
	  elasticOut.amplitude = function(a) { return custom(a, p * tau); };
	  elasticOut.period = function(p) { return custom(a, p); };
	
	  return elasticOut;
	})(amplitude, period);
	
	var elasticInOut = (function custom(a, p) {
	  var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= tau);
	
	  function elasticInOut(t) {
	    return ((t = t * 2 - 1) < 0
	        ? a * Math.pow(2, 10 * t) * Math.sin((s - t) / p)
	        : 2 - a * Math.pow(2, -10 * t) * Math.sin((s + t) / p)) / 2;
	  }
	
	  elasticInOut.amplitude = function(a) { return custom(a, p * tau); };
	  elasticInOut.period = function(p) { return custom(a, p); };
	
	  return elasticInOut;
	})(amplitude, period);
	
	exports.easeLinear = linear;
	exports.easeQuad = quadInOut;
	exports.easeQuadIn = quadIn;
	exports.easeQuadOut = quadOut;
	exports.easeQuadInOut = quadInOut;
	exports.easeCubic = cubicInOut;
	exports.easeCubicIn = cubicIn;
	exports.easeCubicOut = cubicOut;
	exports.easeCubicInOut = cubicInOut;
	exports.easePoly = polyInOut;
	exports.easePolyIn = polyIn;
	exports.easePolyOut = polyOut;
	exports.easePolyInOut = polyInOut;
	exports.easeSin = sinInOut;
	exports.easeSinIn = sinIn;
	exports.easeSinOut = sinOut;
	exports.easeSinInOut = sinInOut;
	exports.easeExp = expInOut;
	exports.easeExpIn = expIn;
	exports.easeExpOut = expOut;
	exports.easeExpInOut = expInOut;
	exports.easeCircle = circleInOut;
	exports.easeCircleIn = circleIn;
	exports.easeCircleOut = circleOut;
	exports.easeCircleInOut = circleInOut;
	exports.easeBounce = bounceOut;
	exports.easeBounceIn = bounceIn;
	exports.easeBounceOut = bounceOut;
	exports.easeBounceInOut = bounceInOut;
	exports.easeBack = backInOut;
	exports.easeBackIn = backIn;
	exports.easeBackOut = backOut;
	exports.easeBackInOut = backInOut;
	exports.easeElastic = elasticOut;
	exports.easeElasticIn = elasticIn;
	exports.easeElasticOut = elasticOut;
	exports.easeElasticInOut = elasticInOut;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 338 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-format/ Version 1.2.1. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports) :
		typeof define === 'function' && define.amd ? define(['exports'], factory) :
		(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	// Computes the decimal coefficient and exponent of the specified number x with
	// significant digits p, where x is positive and p is in [1, 21] or undefined.
	// For example, formatDecimal(1.23) returns ["123", 0].
	var formatDecimal = function(x, p) {
	  if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
	  var i, coefficient = x.slice(0, i);
	
	  // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
	  // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
	  return [
	    coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
	    +x.slice(i + 1)
	  ];
	};
	
	var exponent = function(x) {
	  return x = formatDecimal(Math.abs(x)), x ? x[1] : NaN;
	};
	
	var formatGroup = function(grouping, thousands) {
	  return function(value, width) {
	    var i = value.length,
	        t = [],
	        j = 0,
	        g = grouping[0],
	        length = 0;
	
	    while (i > 0 && g > 0) {
	      if (length + g + 1 > width) g = Math.max(1, width - length);
	      t.push(value.substring(i -= g, i + g));
	      if ((length += g + 1) > width) break;
	      g = grouping[j = (j + 1) % grouping.length];
	    }
	
	    return t.reverse().join(thousands);
	  };
	};
	
	var formatNumerals = function(numerals) {
	  return function(value) {
	    return value.replace(/[0-9]/g, function(i) {
	      return numerals[+i];
	    });
	  };
	};
	
	var formatDefault = function(x, p) {
	  x = x.toPrecision(p);
	
	  out: for (var n = x.length, i = 1, i0 = -1, i1; i < n; ++i) {
	    switch (x[i]) {
	      case ".": i0 = i1 = i; break;
	      case "0": if (i0 === 0) i0 = i; i1 = i; break;
	      case "e": break out;
	      default: if (i0 > 0) i0 = 0; break;
	    }
	  }
	
	  return i0 > 0 ? x.slice(0, i0) + x.slice(i1 + 1) : x;
	};
	
	var prefixExponent;
	
	var formatPrefixAuto = function(x, p) {
	  var d = formatDecimal(x, p);
	  if (!d) return x + "";
	  var coefficient = d[0],
	      exponent = d[1],
	      i = exponent - (prefixExponent = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1,
	      n = coefficient.length;
	  return i === n ? coefficient
	      : i > n ? coefficient + new Array(i - n + 1).join("0")
	      : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i)
	      : "0." + new Array(1 - i).join("0") + formatDecimal(x, Math.max(0, p + i - 1))[0]; // less than 1y!
	};
	
	var formatRounded = function(x, p) {
	  var d = formatDecimal(x, p);
	  if (!d) return x + "";
	  var coefficient = d[0],
	      exponent = d[1];
	  return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient
	      : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1)
	      : coefficient + new Array(exponent - coefficient.length + 2).join("0");
	};
	
	var formatTypes = {
	  "": formatDefault,
	  "%": function(x, p) { return (x * 100).toFixed(p); },
	  "b": function(x) { return Math.round(x).toString(2); },
	  "c": function(x) { return x + ""; },
	  "d": function(x) { return Math.round(x).toString(10); },
	  "e": function(x, p) { return x.toExponential(p); },
	  "f": function(x, p) { return x.toFixed(p); },
	  "g": function(x, p) { return x.toPrecision(p); },
	  "o": function(x) { return Math.round(x).toString(8); },
	  "p": function(x, p) { return formatRounded(x * 100, p); },
	  "r": formatRounded,
	  "s": formatPrefixAuto,
	  "X": function(x) { return Math.round(x).toString(16).toUpperCase(); },
	  "x": function(x) { return Math.round(x).toString(16); }
	};
	
	// [[fill]align][sign][symbol][0][width][,][.precision][type]
	var re = /^(?:(.)?([<>=^]))?([+\-\( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?([a-z%])?$/i;
	
	function formatSpecifier(specifier) {
	  return new FormatSpecifier(specifier);
	}
	
	formatSpecifier.prototype = FormatSpecifier.prototype; // instanceof
	
	function FormatSpecifier(specifier) {
	  if (!(match = re.exec(specifier))) throw new Error("invalid format: " + specifier);
	
	  var match,
	      fill = match[1] || " ",
	      align = match[2] || ">",
	      sign = match[3] || "-",
	      symbol = match[4] || "",
	      zero = !!match[5],
	      width = match[6] && +match[6],
	      comma = !!match[7],
	      precision = match[8] && +match[8].slice(1),
	      type = match[9] || "";
	
	  // The "n" type is an alias for ",g".
	  if (type === "n") comma = true, type = "g";
	
	  // Map invalid types to the default format.
	  else if (!formatTypes[type]) type = "";
	
	  // If zero fill is specified, padding goes after sign and before digits.
	  if (zero || (fill === "0" && align === "=")) zero = true, fill = "0", align = "=";
	
	  this.fill = fill;
	  this.align = align;
	  this.sign = sign;
	  this.symbol = symbol;
	  this.zero = zero;
	  this.width = width;
	  this.comma = comma;
	  this.precision = precision;
	  this.type = type;
	}
	
	FormatSpecifier.prototype.toString = function() {
	  return this.fill
	      + this.align
	      + this.sign
	      + this.symbol
	      + (this.zero ? "0" : "")
	      + (this.width == null ? "" : Math.max(1, this.width | 0))
	      + (this.comma ? "," : "")
	      + (this.precision == null ? "" : "." + Math.max(0, this.precision | 0))
	      + this.type;
	};
	
	var identity = function(x) {
	  return x;
	};
	
	var prefixes = ["y","z","a","f","p","n","µ","m","","k","M","G","T","P","E","Z","Y"];
	
	var formatLocale = function(locale) {
	  var group = locale.grouping && locale.thousands ? formatGroup(locale.grouping, locale.thousands) : identity,
	      currency = locale.currency,
	      decimal = locale.decimal,
	      numerals = locale.numerals ? formatNumerals(locale.numerals) : identity,
	      percent = locale.percent || "%";
	
	  function newFormat(specifier) {
	    specifier = formatSpecifier(specifier);
	
	    var fill = specifier.fill,
	        align = specifier.align,
	        sign = specifier.sign,
	        symbol = specifier.symbol,
	        zero = specifier.zero,
	        width = specifier.width,
	        comma = specifier.comma,
	        precision = specifier.precision,
	        type = specifier.type;
	
	    // Compute the prefix and suffix.
	    // For SI-prefix, the suffix is lazily computed.
	    var prefix = symbol === "$" ? currency[0] : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "",
	        suffix = symbol === "$" ? currency[1] : /[%p]/.test(type) ? percent : "";
	
	    // What format function should we use?
	    // Is this an integer type?
	    // Can this type generate exponential notation?
	    var formatType = formatTypes[type],
	        maybeSuffix = !type || /[defgprs%]/.test(type);
	
	    // Set the default precision if not specified,
	    // or clamp the specified precision to the supported range.
	    // For significant precision, it must be in [1, 21].
	    // For fixed precision, it must be in [0, 20].
	    precision = precision == null ? (type ? 6 : 12)
	        : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision))
	        : Math.max(0, Math.min(20, precision));
	
	    function format(value) {
	      var valuePrefix = prefix,
	          valueSuffix = suffix,
	          i, n, c;
	
	      if (type === "c") {
	        valueSuffix = formatType(value) + valueSuffix;
	        value = "";
	      } else {
	        value = +value;
	
	        // Perform the initial formatting.
	        var valueNegative = value < 0;
	        value = formatType(Math.abs(value), precision);
	
	        // If a negative value rounds to zero during formatting, treat as positive.
	        if (valueNegative && +value === 0) valueNegative = false;
	
	        // Compute the prefix and suffix.
	        valuePrefix = (valueNegative ? (sign === "(" ? sign : "-") : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
	        valueSuffix = valueSuffix + (type === "s" ? prefixes[8 + prefixExponent / 3] : "") + (valueNegative && sign === "(" ? ")" : "");
	
	        // Break the formatted value into the integer “value” part that can be
	        // grouped, and fractional or exponential “suffix” part that is not.
	        if (maybeSuffix) {
	          i = -1, n = value.length;
	          while (++i < n) {
	            if (c = value.charCodeAt(i), 48 > c || c > 57) {
	              valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
	              value = value.slice(0, i);
	              break;
	            }
	          }
	        }
	      }
	
	      // If the fill character is not "0", grouping is applied before padding.
	      if (comma && !zero) value = group(value, Infinity);
	
	      // Compute the padding.
	      var length = valuePrefix.length + value.length + valueSuffix.length,
	          padding = length < width ? new Array(width - length + 1).join(fill) : "";
	
	      // If the fill character is "0", grouping is applied after padding.
	      if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";
	
	      // Reconstruct the final output based on the desired alignment.
	      switch (align) {
	        case "<": value = valuePrefix + value + valueSuffix + padding; break;
	        case "=": value = valuePrefix + padding + value + valueSuffix; break;
	        case "^": value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length); break;
	        default: value = padding + valuePrefix + value + valueSuffix; break;
	      }
	
	      return numerals(value);
	    }
	
	    format.toString = function() {
	      return specifier + "";
	    };
	
	    return format;
	  }
	
	  function formatPrefix(specifier, value) {
	    var f = newFormat((specifier = formatSpecifier(specifier), specifier.type = "f", specifier)),
	        e = Math.max(-8, Math.min(8, Math.floor(exponent(value) / 3))) * 3,
	        k = Math.pow(10, -e),
	        prefix = prefixes[8 + e / 3];
	    return function(value) {
	      return f(k * value) + prefix;
	    };
	  }
	
	  return {
	    format: newFormat,
	    formatPrefix: formatPrefix
	  };
	};
	
	var locale;
	
	
	
	defaultLocale({
	  decimal: ".",
	  thousands: ",",
	  grouping: [3],
	  currency: ["$", ""]
	});
	
	function defaultLocale(definition) {
	  locale = formatLocale(definition);
	  exports.format = locale.format;
	  exports.formatPrefix = locale.formatPrefix;
	  return locale;
	}
	
	var precisionFixed = function(step) {
	  return Math.max(0, -exponent(Math.abs(step)));
	};
	
	var precisionPrefix = function(step, value) {
	  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(exponent(value) / 3))) * 3 - exponent(Math.abs(step)));
	};
	
	var precisionRound = function(step, max) {
	  step = Math.abs(step), max = Math.abs(max) - step;
	  return Math.max(0, exponent(max) - exponent(step)) + 1;
	};
	
	exports.formatDefaultLocale = defaultLocale;
	exports.formatLocale = formatLocale;
	exports.formatSpecifier = formatSpecifier;
	exports.precisionFixed = precisionFixed;
	exports.precisionPrefix = precisionPrefix;
	exports.precisionRound = precisionRound;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 339 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-path/ Version 1.0.5. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports) :
		typeof define === 'function' && define.amd ? define(['exports'], factory) :
		(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	var pi = Math.PI;
	var tau = 2 * pi;
	var epsilon = 1e-6;
	var tauEpsilon = tau - epsilon;
	
	function Path() {
	  this._x0 = this._y0 = // start of current subpath
	  this._x1 = this._y1 = null; // end of current subpath
	  this._ = "";
	}
	
	function path() {
	  return new Path;
	}
	
	Path.prototype = path.prototype = {
	  constructor: Path,
	  moveTo: function(x, y) {
	    this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y);
	  },
	  closePath: function() {
	    if (this._x1 !== null) {
	      this._x1 = this._x0, this._y1 = this._y0;
	      this._ += "Z";
	    }
	  },
	  lineTo: function(x, y) {
	    this._ += "L" + (this._x1 = +x) + "," + (this._y1 = +y);
	  },
	  quadraticCurveTo: function(x1, y1, x, y) {
	    this._ += "Q" + (+x1) + "," + (+y1) + "," + (this._x1 = +x) + "," + (this._y1 = +y);
	  },
	  bezierCurveTo: function(x1, y1, x2, y2, x, y) {
	    this._ += "C" + (+x1) + "," + (+y1) + "," + (+x2) + "," + (+y2) + "," + (this._x1 = +x) + "," + (this._y1 = +y);
	  },
	  arcTo: function(x1, y1, x2, y2, r) {
	    x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
	    var x0 = this._x1,
	        y0 = this._y1,
	        x21 = x2 - x1,
	        y21 = y2 - y1,
	        x01 = x0 - x1,
	        y01 = y0 - y1,
	        l01_2 = x01 * x01 + y01 * y01;
	
	    // Is the radius negative? Error.
	    if (r < 0) throw new Error("negative radius: " + r);
	
	    // Is this path empty? Move to (x1,y1).
	    if (this._x1 === null) {
	      this._ += "M" + (this._x1 = x1) + "," + (this._y1 = y1);
	    }
	
	    // Or, is (x1,y1) coincident with (x0,y0)? Do nothing.
	    else if (!(l01_2 > epsilon)) {}
	
	    // Or, are (x0,y0), (x1,y1) and (x2,y2) collinear?
	    // Equivalently, is (x1,y1) coincident with (x2,y2)?
	    // Or, is the radius zero? Line to (x1,y1).
	    else if (!(Math.abs(y01 * x21 - y21 * x01) > epsilon) || !r) {
	      this._ += "L" + (this._x1 = x1) + "," + (this._y1 = y1);
	    }
	
	    // Otherwise, draw an arc!
	    else {
	      var x20 = x2 - x0,
	          y20 = y2 - y0,
	          l21_2 = x21 * x21 + y21 * y21,
	          l20_2 = x20 * x20 + y20 * y20,
	          l21 = Math.sqrt(l21_2),
	          l01 = Math.sqrt(l01_2),
	          l = r * Math.tan((pi - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2),
	          t01 = l / l01,
	          t21 = l / l21;
	
	      // If the start tangent is not coincident with (x0,y0), line to.
	      if (Math.abs(t01 - 1) > epsilon) {
	        this._ += "L" + (x1 + t01 * x01) + "," + (y1 + t01 * y01);
	      }
	
	      this._ += "A" + r + "," + r + ",0,0," + (+(y01 * x20 > x01 * y20)) + "," + (this._x1 = x1 + t21 * x21) + "," + (this._y1 = y1 + t21 * y21);
	    }
	  },
	  arc: function(x, y, r, a0, a1, ccw) {
	    x = +x, y = +y, r = +r;
	    var dx = r * Math.cos(a0),
	        dy = r * Math.sin(a0),
	        x0 = x + dx,
	        y0 = y + dy,
	        cw = 1 ^ ccw,
	        da = ccw ? a0 - a1 : a1 - a0;
	
	    // Is the radius negative? Error.
	    if (r < 0) throw new Error("negative radius: " + r);
	
	    // Is this path empty? Move to (x0,y0).
	    if (this._x1 === null) {
	      this._ += "M" + x0 + "," + y0;
	    }
	
	    // Or, is (x0,y0) not coincident with the previous point? Line to (x0,y0).
	    else if (Math.abs(this._x1 - x0) > epsilon || Math.abs(this._y1 - y0) > epsilon) {
	      this._ += "L" + x0 + "," + y0;
	    }
	
	    // Is this arc empty? We’re done.
	    if (!r) return;
	
	    // Does the angle go the wrong way? Flip the direction.
	    if (da < 0) da = da % tau + tau;
	
	    // Is this a complete circle? Draw two arcs to complete the circle.
	    if (da > tauEpsilon) {
	      this._ += "A" + r + "," + r + ",0,1," + cw + "," + (x - dx) + "," + (y - dy) + "A" + r + "," + r + ",0,1," + cw + "," + (this._x1 = x0) + "," + (this._y1 = y0);
	    }
	
	    // Is this arc non-empty? Draw an arc!
	    else if (da > epsilon) {
	      this._ += "A" + r + "," + r + ",0," + (+(da >= pi)) + "," + cw + "," + (this._x1 = x + r * Math.cos(a1)) + "," + (this._y1 = y + r * Math.sin(a1));
	    }
	  },
	  rect: function(x, y, w, h) {
	    this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y) + "h" + (+w) + "v" + (+h) + "h" + (-w) + "Z";
	  },
	  toString: function() {
	    return this._;
	  }
	};
	
	exports.path = path;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 340 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-scale/ Version 1.0.7. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(335), __webpack_require__(336), __webpack_require__(165), __webpack_require__(338), __webpack_require__(166), __webpack_require__(341), __webpack_require__(164)) :
		typeof define === 'function' && define.amd ? define(['exports', 'd3-array', 'd3-collection', 'd3-interpolate', 'd3-format', 'd3-time', 'd3-time-format', 'd3-color'], factory) :
		(factory((global.d3 = global.d3 || {}),global.d3,global.d3,global.d3,global.d3,global.d3,global.d3,global.d3));
	}(this, (function (exports,d3Array,d3Collection,d3Interpolate,d3Format,d3Time,d3TimeFormat,d3Color) { 'use strict';
	
	var array = Array.prototype;
	
	var map$1 = array.map;
	var slice = array.slice;
	
	var implicit = {name: "implicit"};
	
	function ordinal(range$$1) {
	  var index = d3Collection.map(),
	      domain = [],
	      unknown = implicit;
	
	  range$$1 = range$$1 == null ? [] : slice.call(range$$1);
	
	  function scale(d) {
	    var key = d + "", i = index.get(key);
	    if (!i) {
	      if (unknown !== implicit) return unknown;
	      index.set(key, i = domain.push(d));
	    }
	    return range$$1[(i - 1) % range$$1.length];
	  }
	
	  scale.domain = function(_) {
	    if (!arguments.length) return domain.slice();
	    domain = [], index = d3Collection.map();
	    var i = -1, n = _.length, d, key;
	    while (++i < n) if (!index.has(key = (d = _[i]) + "")) index.set(key, domain.push(d));
	    return scale;
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (range$$1 = slice.call(_), scale) : range$$1.slice();
	  };
	
	  scale.unknown = function(_) {
	    return arguments.length ? (unknown = _, scale) : unknown;
	  };
	
	  scale.copy = function() {
	    return ordinal()
	        .domain(domain)
	        .range(range$$1)
	        .unknown(unknown);
	  };
	
	  return scale;
	}
	
	function band() {
	  var scale = ordinal().unknown(undefined),
	      domain = scale.domain,
	      ordinalRange = scale.range,
	      range$$1 = [0, 1],
	      step,
	      bandwidth,
	      round = false,
	      paddingInner = 0,
	      paddingOuter = 0,
	      align = 0.5;
	
	  delete scale.unknown;
	
	  function rescale() {
	    var n = domain().length,
	        reverse = range$$1[1] < range$$1[0],
	        start = range$$1[reverse - 0],
	        stop = range$$1[1 - reverse];
	    step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
	    if (round) step = Math.floor(step);
	    start += (stop - start - step * (n - paddingInner)) * align;
	    bandwidth = step * (1 - paddingInner);
	    if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
	    var values = d3Array.range(n).map(function(i) { return start + step * i; });
	    return ordinalRange(reverse ? values.reverse() : values);
	  }
	
	  scale.domain = function(_) {
	    return arguments.length ? (domain(_), rescale()) : domain();
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (range$$1 = [+_[0], +_[1]], rescale()) : range$$1.slice();
	  };
	
	  scale.rangeRound = function(_) {
	    return range$$1 = [+_[0], +_[1]], round = true, rescale();
	  };
	
	  scale.bandwidth = function() {
	    return bandwidth;
	  };
	
	  scale.step = function() {
	    return step;
	  };
	
	  scale.round = function(_) {
	    return arguments.length ? (round = !!_, rescale()) : round;
	  };
	
	  scale.padding = function(_) {
	    return arguments.length ? (paddingInner = paddingOuter = Math.max(0, Math.min(1, _)), rescale()) : paddingInner;
	  };
	
	  scale.paddingInner = function(_) {
	    return arguments.length ? (paddingInner = Math.max(0, Math.min(1, _)), rescale()) : paddingInner;
	  };
	
	  scale.paddingOuter = function(_) {
	    return arguments.length ? (paddingOuter = Math.max(0, Math.min(1, _)), rescale()) : paddingOuter;
	  };
	
	  scale.align = function(_) {
	    return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
	  };
	
	  scale.copy = function() {
	    return band()
	        .domain(domain())
	        .range(range$$1)
	        .round(round)
	        .paddingInner(paddingInner)
	        .paddingOuter(paddingOuter)
	        .align(align);
	  };
	
	  return rescale();
	}
	
	function pointish(scale) {
	  var copy = scale.copy;
	
	  scale.padding = scale.paddingOuter;
	  delete scale.paddingInner;
	  delete scale.paddingOuter;
	
	  scale.copy = function() {
	    return pointish(copy());
	  };
	
	  return scale;
	}
	
	function point() {
	  return pointish(band().paddingInner(1));
	}
	
	var constant = function(x) {
	  return function() {
	    return x;
	  };
	};
	
	var number = function(x) {
	  return +x;
	};
	
	var unit = [0, 1];
	
	function deinterpolateLinear(a, b) {
	  return (b -= (a = +a))
	      ? function(x) { return (x - a) / b; }
	      : constant(b);
	}
	
	function deinterpolateClamp(deinterpolate) {
	  return function(a, b) {
	    var d = deinterpolate(a = +a, b = +b);
	    return function(x) { return x <= a ? 0 : x >= b ? 1 : d(x); };
	  };
	}
	
	function reinterpolateClamp(reinterpolate) {
	  return function(a, b) {
	    var r = reinterpolate(a = +a, b = +b);
	    return function(t) { return t <= 0 ? a : t >= 1 ? b : r(t); };
	  };
	}
	
	function bimap(domain, range$$1, deinterpolate, reinterpolate) {
	  var d0 = domain[0], d1 = domain[1], r0 = range$$1[0], r1 = range$$1[1];
	  if (d1 < d0) d0 = deinterpolate(d1, d0), r0 = reinterpolate(r1, r0);
	  else d0 = deinterpolate(d0, d1), r0 = reinterpolate(r0, r1);
	  return function(x) { return r0(d0(x)); };
	}
	
	function polymap(domain, range$$1, deinterpolate, reinterpolate) {
	  var j = Math.min(domain.length, range$$1.length) - 1,
	      d = new Array(j),
	      r = new Array(j),
	      i = -1;
	
	  // Reverse descending domains.
	  if (domain[j] < domain[0]) {
	    domain = domain.slice().reverse();
	    range$$1 = range$$1.slice().reverse();
	  }
	
	  while (++i < j) {
	    d[i] = deinterpolate(domain[i], domain[i + 1]);
	    r[i] = reinterpolate(range$$1[i], range$$1[i + 1]);
	  }
	
	  return function(x) {
	    var i = d3Array.bisect(domain, x, 1, j) - 1;
	    return r[i](d[i](x));
	  };
	}
	
	function copy(source, target) {
	  return target
	      .domain(source.domain())
	      .range(source.range())
	      .interpolate(source.interpolate())
	      .clamp(source.clamp());
	}
	
	// deinterpolate(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
	// reinterpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding domain value x in [a,b].
	function continuous(deinterpolate, reinterpolate) {
	  var domain = unit,
	      range$$1 = unit,
	      interpolate$$1 = d3Interpolate.interpolate,
	      clamp = false,
	      piecewise,
	      output,
	      input;
	
	  function rescale() {
	    piecewise = Math.min(domain.length, range$$1.length) > 2 ? polymap : bimap;
	    output = input = null;
	    return scale;
	  }
	
	  function scale(x) {
	    return (output || (output = piecewise(domain, range$$1, clamp ? deinterpolateClamp(deinterpolate) : deinterpolate, interpolate$$1)))(+x);
	  }
	
	  scale.invert = function(y) {
	    return (input || (input = piecewise(range$$1, domain, deinterpolateLinear, clamp ? reinterpolateClamp(reinterpolate) : reinterpolate)))(+y);
	  };
	
	  scale.domain = function(_) {
	    return arguments.length ? (domain = map$1.call(_, number), rescale()) : domain.slice();
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (range$$1 = slice.call(_), rescale()) : range$$1.slice();
	  };
	
	  scale.rangeRound = function(_) {
	    return range$$1 = slice.call(_), interpolate$$1 = d3Interpolate.interpolateRound, rescale();
	  };
	
	  scale.clamp = function(_) {
	    return arguments.length ? (clamp = !!_, rescale()) : clamp;
	  };
	
	  scale.interpolate = function(_) {
	    return arguments.length ? (interpolate$$1 = _, rescale()) : interpolate$$1;
	  };
	
	  return rescale();
	}
	
	var tickFormat = function(domain, count, specifier) {
	  var start = domain[0],
	      stop = domain[domain.length - 1],
	      step = d3Array.tickStep(start, stop, count == null ? 10 : count),
	      precision;
	  specifier = d3Format.formatSpecifier(specifier == null ? ",f" : specifier);
	  switch (specifier.type) {
	    case "s": {
	      var value = Math.max(Math.abs(start), Math.abs(stop));
	      if (specifier.precision == null && !isNaN(precision = d3Format.precisionPrefix(step, value))) specifier.precision = precision;
	      return d3Format.formatPrefix(specifier, value);
	    }
	    case "":
	    case "e":
	    case "g":
	    case "p":
	    case "r": {
	      if (specifier.precision == null && !isNaN(precision = d3Format.precisionRound(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
	      break;
	    }
	    case "f":
	    case "%": {
	      if (specifier.precision == null && !isNaN(precision = d3Format.precisionFixed(step))) specifier.precision = precision - (specifier.type === "%") * 2;
	      break;
	    }
	  }
	  return d3Format.format(specifier);
	};
	
	function linearish(scale) {
	  var domain = scale.domain;
	
	  scale.ticks = function(count) {
	    var d = domain();
	    return d3Array.ticks(d[0], d[d.length - 1], count == null ? 10 : count);
	  };
	
	  scale.tickFormat = function(count, specifier) {
	    return tickFormat(domain(), count, specifier);
	  };
	
	  scale.nice = function(count) {
	    if (count == null) count = 10;
	
	    var d = domain(),
	        i0 = 0,
	        i1 = d.length - 1,
	        start = d[i0],
	        stop = d[i1],
	        step;
	
	    if (stop < start) {
	      step = start, start = stop, stop = step;
	      step = i0, i0 = i1, i1 = step;
	    }
	
	    step = d3Array.tickIncrement(start, stop, count);
	
	    if (step > 0) {
	      start = Math.floor(start / step) * step;
	      stop = Math.ceil(stop / step) * step;
	      step = d3Array.tickIncrement(start, stop, count);
	    } else if (step < 0) {
	      start = Math.ceil(start * step) / step;
	      stop = Math.floor(stop * step) / step;
	      step = d3Array.tickIncrement(start, stop, count);
	    }
	
	    if (step > 0) {
	      d[i0] = Math.floor(start / step) * step;
	      d[i1] = Math.ceil(stop / step) * step;
	      domain(d);
	    } else if (step < 0) {
	      d[i0] = Math.ceil(start * step) / step;
	      d[i1] = Math.floor(stop * step) / step;
	      domain(d);
	    }
	
	    return scale;
	  };
	
	  return scale;
	}
	
	function linear() {
	  var scale = continuous(deinterpolateLinear, d3Interpolate.interpolateNumber);
	
	  scale.copy = function() {
	    return copy(scale, linear());
	  };
	
	  return linearish(scale);
	}
	
	function identity() {
	  var domain = [0, 1];
	
	  function scale(x) {
	    return +x;
	  }
	
	  scale.invert = scale;
	
	  scale.domain = scale.range = function(_) {
	    return arguments.length ? (domain = map$1.call(_, number), scale) : domain.slice();
	  };
	
	  scale.copy = function() {
	    return identity().domain(domain);
	  };
	
	  return linearish(scale);
	}
	
	var nice = function(domain, interval) {
	  domain = domain.slice();
	
	  var i0 = 0,
	      i1 = domain.length - 1,
	      x0 = domain[i0],
	      x1 = domain[i1],
	      t;
	
	  if (x1 < x0) {
	    t = i0, i0 = i1, i1 = t;
	    t = x0, x0 = x1, x1 = t;
	  }
	
	  domain[i0] = interval.floor(x0);
	  domain[i1] = interval.ceil(x1);
	  return domain;
	};
	
	function deinterpolate(a, b) {
	  return (b = Math.log(b / a))
	      ? function(x) { return Math.log(x / a) / b; }
	      : constant(b);
	}
	
	function reinterpolate(a, b) {
	  return a < 0
	      ? function(t) { return -Math.pow(-b, t) * Math.pow(-a, 1 - t); }
	      : function(t) { return Math.pow(b, t) * Math.pow(a, 1 - t); };
	}
	
	function pow10(x) {
	  return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
	}
	
	function powp(base) {
	  return base === 10 ? pow10
	      : base === Math.E ? Math.exp
	      : function(x) { return Math.pow(base, x); };
	}
	
	function logp(base) {
	  return base === Math.E ? Math.log
	      : base === 10 && Math.log10
	      || base === 2 && Math.log2
	      || (base = Math.log(base), function(x) { return Math.log(x) / base; });
	}
	
	function reflect(f) {
	  return function(x) {
	    return -f(-x);
	  };
	}
	
	function log() {
	  var scale = continuous(deinterpolate, reinterpolate).domain([1, 10]),
	      domain = scale.domain,
	      base = 10,
	      logs = logp(10),
	      pows = powp(10);
	
	  function rescale() {
	    logs = logp(base), pows = powp(base);
	    if (domain()[0] < 0) logs = reflect(logs), pows = reflect(pows);
	    return scale;
	  }
	
	  scale.base = function(_) {
	    return arguments.length ? (base = +_, rescale()) : base;
	  };
	
	  scale.domain = function(_) {
	    return arguments.length ? (domain(_), rescale()) : domain();
	  };
	
	  scale.ticks = function(count) {
	    var d = domain(),
	        u = d[0],
	        v = d[d.length - 1],
	        r;
	
	    if (r = v < u) i = u, u = v, v = i;
	
	    var i = logs(u),
	        j = logs(v),
	        p,
	        k,
	        t,
	        n = count == null ? 10 : +count,
	        z = [];
	
	    if (!(base % 1) && j - i < n) {
	      i = Math.round(i) - 1, j = Math.round(j) + 1;
	      if (u > 0) for (; i < j; ++i) {
	        for (k = 1, p = pows(i); k < base; ++k) {
	          t = p * k;
	          if (t < u) continue;
	          if (t > v) break;
	          z.push(t);
	        }
	      } else for (; i < j; ++i) {
	        for (k = base - 1, p = pows(i); k >= 1; --k) {
	          t = p * k;
	          if (t < u) continue;
	          if (t > v) break;
	          z.push(t);
	        }
	      }
	    } else {
	      z = d3Array.ticks(i, j, Math.min(j - i, n)).map(pows);
	    }
	
	    return r ? z.reverse() : z;
	  };
	
	  scale.tickFormat = function(count, specifier) {
	    if (specifier == null) specifier = base === 10 ? ".0e" : ",";
	    if (typeof specifier !== "function") specifier = d3Format.format(specifier);
	    if (count === Infinity) return specifier;
	    if (count == null) count = 10;
	    var k = Math.max(1, base * count / scale.ticks().length); // TODO fast estimate?
	    return function(d) {
	      var i = d / pows(Math.round(logs(d)));
	      if (i * base < base - 0.5) i *= base;
	      return i <= k ? specifier(d) : "";
	    };
	  };
	
	  scale.nice = function() {
	    return domain(nice(domain(), {
	      floor: function(x) { return pows(Math.floor(logs(x))); },
	      ceil: function(x) { return pows(Math.ceil(logs(x))); }
	    }));
	  };
	
	  scale.copy = function() {
	    return copy(scale, log().base(base));
	  };
	
	  return scale;
	}
	
	function raise(x, exponent) {
	  return x < 0 ? -Math.pow(-x, exponent) : Math.pow(x, exponent);
	}
	
	function pow() {
	  var exponent = 1,
	      scale = continuous(deinterpolate, reinterpolate),
	      domain = scale.domain;
	
	  function deinterpolate(a, b) {
	    return (b = raise(b, exponent) - (a = raise(a, exponent)))
	        ? function(x) { return (raise(x, exponent) - a) / b; }
	        : constant(b);
	  }
	
	  function reinterpolate(a, b) {
	    b = raise(b, exponent) - (a = raise(a, exponent));
	    return function(t) { return raise(a + b * t, 1 / exponent); };
	  }
	
	  scale.exponent = function(_) {
	    return arguments.length ? (exponent = +_, domain(domain())) : exponent;
	  };
	
	  scale.copy = function() {
	    return copy(scale, pow().exponent(exponent));
	  };
	
	  return linearish(scale);
	}
	
	function sqrt() {
	  return pow().exponent(0.5);
	}
	
	function quantile$1() {
	  var domain = [],
	      range$$1 = [],
	      thresholds = [];
	
	  function rescale() {
	    var i = 0, n = Math.max(1, range$$1.length);
	    thresholds = new Array(n - 1);
	    while (++i < n) thresholds[i - 1] = d3Array.quantile(domain, i / n);
	    return scale;
	  }
	
	  function scale(x) {
	    if (!isNaN(x = +x)) return range$$1[d3Array.bisect(thresholds, x)];
	  }
	
	  scale.invertExtent = function(y) {
	    var i = range$$1.indexOf(y);
	    return i < 0 ? [NaN, NaN] : [
	      i > 0 ? thresholds[i - 1] : domain[0],
	      i < thresholds.length ? thresholds[i] : domain[domain.length - 1]
	    ];
	  };
	
	  scale.domain = function(_) {
	    if (!arguments.length) return domain.slice();
	    domain = [];
	    for (var i = 0, n = _.length, d; i < n; ++i) if (d = _[i], d != null && !isNaN(d = +d)) domain.push(d);
	    domain.sort(d3Array.ascending);
	    return rescale();
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (range$$1 = slice.call(_), rescale()) : range$$1.slice();
	  };
	
	  scale.quantiles = function() {
	    return thresholds.slice();
	  };
	
	  scale.copy = function() {
	    return quantile$1()
	        .domain(domain)
	        .range(range$$1);
	  };
	
	  return scale;
	}
	
	function quantize() {
	  var x0 = 0,
	      x1 = 1,
	      n = 1,
	      domain = [0.5],
	      range$$1 = [0, 1];
	
	  function scale(x) {
	    if (x <= x) return range$$1[d3Array.bisect(domain, x, 0, n)];
	  }
	
	  function rescale() {
	    var i = -1;
	    domain = new Array(n);
	    while (++i < n) domain[i] = ((i + 1) * x1 - (i - n) * x0) / (n + 1);
	    return scale;
	  }
	
	  scale.domain = function(_) {
	    return arguments.length ? (x0 = +_[0], x1 = +_[1], rescale()) : [x0, x1];
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (n = (range$$1 = slice.call(_)).length - 1, rescale()) : range$$1.slice();
	  };
	
	  scale.invertExtent = function(y) {
	    var i = range$$1.indexOf(y);
	    return i < 0 ? [NaN, NaN]
	        : i < 1 ? [x0, domain[0]]
	        : i >= n ? [domain[n - 1], x1]
	        : [domain[i - 1], domain[i]];
	  };
	
	  scale.copy = function() {
	    return quantize()
	        .domain([x0, x1])
	        .range(range$$1);
	  };
	
	  return linearish(scale);
	}
	
	function threshold() {
	  var domain = [0.5],
	      range$$1 = [0, 1],
	      n = 1;
	
	  function scale(x) {
	    if (x <= x) return range$$1[d3Array.bisect(domain, x, 0, n)];
	  }
	
	  scale.domain = function(_) {
	    return arguments.length ? (domain = slice.call(_), n = Math.min(domain.length, range$$1.length - 1), scale) : domain.slice();
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (range$$1 = slice.call(_), n = Math.min(domain.length, range$$1.length - 1), scale) : range$$1.slice();
	  };
	
	  scale.invertExtent = function(y) {
	    var i = range$$1.indexOf(y);
	    return [domain[i - 1], domain[i]];
	  };
	
	  scale.copy = function() {
	    return threshold()
	        .domain(domain)
	        .range(range$$1);
	  };
	
	  return scale;
	}
	
	var durationSecond = 1000;
	var durationMinute = durationSecond * 60;
	var durationHour = durationMinute * 60;
	var durationDay = durationHour * 24;
	var durationWeek = durationDay * 7;
	var durationMonth = durationDay * 30;
	var durationYear = durationDay * 365;
	
	function date(t) {
	  return new Date(t);
	}
	
	function number$1(t) {
	  return t instanceof Date ? +t : +new Date(+t);
	}
	
	function calendar(year, month, week, day, hour, minute, second, millisecond, format$$1) {
	  var scale = continuous(deinterpolateLinear, d3Interpolate.interpolateNumber),
	      invert = scale.invert,
	      domain = scale.domain;
	
	  var formatMillisecond = format$$1(".%L"),
	      formatSecond = format$$1(":%S"),
	      formatMinute = format$$1("%I:%M"),
	      formatHour = format$$1("%I %p"),
	      formatDay = format$$1("%a %d"),
	      formatWeek = format$$1("%b %d"),
	      formatMonth = format$$1("%B"),
	      formatYear = format$$1("%Y");
	
	  var tickIntervals = [
	    [second,  1,      durationSecond],
	    [second,  5,  5 * durationSecond],
	    [second, 15, 15 * durationSecond],
	    [second, 30, 30 * durationSecond],
	    [minute,  1,      durationMinute],
	    [minute,  5,  5 * durationMinute],
	    [minute, 15, 15 * durationMinute],
	    [minute, 30, 30 * durationMinute],
	    [  hour,  1,      durationHour  ],
	    [  hour,  3,  3 * durationHour  ],
	    [  hour,  6,  6 * durationHour  ],
	    [  hour, 12, 12 * durationHour  ],
	    [   day,  1,      durationDay   ],
	    [   day,  2,  2 * durationDay   ],
	    [  week,  1,      durationWeek  ],
	    [ month,  1,      durationMonth ],
	    [ month,  3,  3 * durationMonth ],
	    [  year,  1,      durationYear  ]
	  ];
	
	  function tickFormat(date) {
	    return (second(date) < date ? formatMillisecond
	        : minute(date) < date ? formatSecond
	        : hour(date) < date ? formatMinute
	        : day(date) < date ? formatHour
	        : month(date) < date ? (week(date) < date ? formatDay : formatWeek)
	        : year(date) < date ? formatMonth
	        : formatYear)(date);
	  }
	
	  function tickInterval(interval, start, stop, step) {
	    if (interval == null) interval = 10;
	
	    // If a desired tick count is specified, pick a reasonable tick interval
	    // based on the extent of the domain and a rough estimate of tick size.
	    // Otherwise, assume interval is already a time interval and use it.
	    if (typeof interval === "number") {
	      var target = Math.abs(stop - start) / interval,
	          i = d3Array.bisector(function(i) { return i[2]; }).right(tickIntervals, target);
	      if (i === tickIntervals.length) {
	        step = d3Array.tickStep(start / durationYear, stop / durationYear, interval);
	        interval = year;
	      } else if (i) {
	        i = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
	        step = i[1];
	        interval = i[0];
	      } else {
	        step = Math.max(d3Array.tickStep(start, stop, interval), 1);
	        interval = millisecond;
	      }
	    }
	
	    return step == null ? interval : interval.every(step);
	  }
	
	  scale.invert = function(y) {
	    return new Date(invert(y));
	  };
	
	  scale.domain = function(_) {
	    return arguments.length ? domain(map$1.call(_, number$1)) : domain().map(date);
	  };
	
	  scale.ticks = function(interval, step) {
	    var d = domain(),
	        t0 = d[0],
	        t1 = d[d.length - 1],
	        r = t1 < t0,
	        t;
	    if (r) t = t0, t0 = t1, t1 = t;
	    t = tickInterval(interval, t0, t1, step);
	    t = t ? t.range(t0, t1 + 1) : []; // inclusive stop
	    return r ? t.reverse() : t;
	  };
	
	  scale.tickFormat = function(count, specifier) {
	    return specifier == null ? tickFormat : format$$1(specifier);
	  };
	
	  scale.nice = function(interval, step) {
	    var d = domain();
	    return (interval = tickInterval(interval, d[0], d[d.length - 1], step))
	        ? domain(nice(d, interval))
	        : scale;
	  };
	
	  scale.copy = function() {
	    return copy(scale, calendar(year, month, week, day, hour, minute, second, millisecond, format$$1));
	  };
	
	  return scale;
	}
	
	var time = function() {
	  return calendar(d3Time.timeYear, d3Time.timeMonth, d3Time.timeWeek, d3Time.timeDay, d3Time.timeHour, d3Time.timeMinute, d3Time.timeSecond, d3Time.timeMillisecond, d3TimeFormat.timeFormat).domain([new Date(2000, 0, 1), new Date(2000, 0, 2)]);
	};
	
	var utcTime = function() {
	  return calendar(d3Time.utcYear, d3Time.utcMonth, d3Time.utcWeek, d3Time.utcDay, d3Time.utcHour, d3Time.utcMinute, d3Time.utcSecond, d3Time.utcMillisecond, d3TimeFormat.utcFormat).domain([Date.UTC(2000, 0, 1), Date.UTC(2000, 0, 2)]);
	};
	
	var colors = function(s) {
	  return s.match(/.{6}/g).map(function(x) {
	    return "#" + x;
	  });
	};
	
	var category10 = colors("1f77b4ff7f0e2ca02cd627289467bd8c564be377c27f7f7fbcbd2217becf");
	
	var category20b = colors("393b795254a36b6ecf9c9ede6379398ca252b5cf6bcedb9c8c6d31bd9e39e7ba52e7cb94843c39ad494ad6616be7969c7b4173a55194ce6dbdde9ed6");
	
	var category20c = colors("3182bd6baed69ecae1c6dbefe6550dfd8d3cfdae6bfdd0a231a35474c476a1d99bc7e9c0756bb19e9ac8bcbddcdadaeb636363969696bdbdbdd9d9d9");
	
	var category20 = colors("1f77b4aec7e8ff7f0effbb782ca02c98df8ad62728ff98969467bdc5b0d58c564bc49c94e377c2f7b6d27f7f7fc7c7c7bcbd22dbdb8d17becf9edae5");
	
	var cubehelix$1 = d3Interpolate.interpolateCubehelixLong(d3Color.cubehelix(300, 0.5, 0.0), d3Color.cubehelix(-240, 0.5, 1.0));
	
	var warm = d3Interpolate.interpolateCubehelixLong(d3Color.cubehelix(-100, 0.75, 0.35), d3Color.cubehelix(80, 1.50, 0.8));
	
	var cool = d3Interpolate.interpolateCubehelixLong(d3Color.cubehelix(260, 0.75, 0.35), d3Color.cubehelix(80, 1.50, 0.8));
	
	var rainbow = d3Color.cubehelix();
	
	var rainbow$1 = function(t) {
	  if (t < 0 || t > 1) t -= Math.floor(t);
	  var ts = Math.abs(t - 0.5);
	  rainbow.h = 360 * t - 100;
	  rainbow.s = 1.5 - 1.5 * ts;
	  rainbow.l = 0.8 - 0.9 * ts;
	  return rainbow + "";
	};
	
	function ramp(range$$1) {
	  var n = range$$1.length;
	  return function(t) {
	    return range$$1[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
	  };
	}
	
	var viridis = ramp(colors("44015444025645045745055946075a46085c460a5d460b5e470d60470e6147106347116447136548146748166848176948186a481a6c481b6d481c6e481d6f481f70482071482173482374482475482576482677482878482979472a7a472c7a472d7b472e7c472f7d46307e46327e46337f463480453581453781453882443983443a83443b84433d84433e85423f854240864241864142874144874045884046883f47883f48893e49893e4a893e4c8a3d4d8a3d4e8a3c4f8a3c508b3b518b3b528b3a538b3a548c39558c39568c38588c38598c375a8c375b8d365c8d365d8d355e8d355f8d34608d34618d33628d33638d32648e32658e31668e31678e31688e30698e306a8e2f6b8e2f6c8e2e6d8e2e6e8e2e6f8e2d708e2d718e2c718e2c728e2c738e2b748e2b758e2a768e2a778e2a788e29798e297a8e297b8e287c8e287d8e277e8e277f8e27808e26818e26828e26828e25838e25848e25858e24868e24878e23888e23898e238a8d228b8d228c8d228d8d218e8d218f8d21908d21918c20928c20928c20938c1f948c1f958b1f968b1f978b1f988b1f998a1f9a8a1e9b8a1e9c891e9d891f9e891f9f881fa0881fa1881fa1871fa28720a38620a48621a58521a68522a78522a88423a98324aa8325ab8225ac8226ad8127ad8128ae8029af7f2ab07f2cb17e2db27d2eb37c2fb47c31b57b32b67a34b67935b77937b87838b9773aba763bbb753dbc743fbc7340bd7242be7144bf7046c06f48c16e4ac16d4cc26c4ec36b50c46a52c56954c56856c66758c7655ac8645cc8635ec96260ca6063cb5f65cb5e67cc5c69cd5b6ccd5a6ece5870cf5773d05675d05477d1537ad1517cd2507fd34e81d34d84d44b86d54989d5488bd6468ed64590d74393d74195d84098d83e9bd93c9dd93ba0da39a2da37a5db36a8db34aadc32addc30b0dd2fb2dd2db5de2bb8de29bade28bddf26c0df25c2df23c5e021c8e020cae11fcde11dd0e11cd2e21bd5e21ad8e219dae319dde318dfe318e2e418e5e419e7e419eae51aece51befe51cf1e51df4e61ef6e620f8e621fbe723fde725"));
	
	var magma = ramp(colors("00000401000501010601010802010902020b02020d03030f03031204041405041606051806051a07061c08071e0907200a08220b09240c09260d0a290e0b2b100b2d110c2f120d31130d34140e36150e38160f3b180f3d19103f1a10421c10441d11471e114920114b21114e22115024125325125527125829115a2a115c2c115f2d11612f116331116533106734106936106b38106c390f6e3b0f703d0f713f0f72400f74420f75440f764510774710784910784a10794c117a4e117b4f127b51127c52137c54137d56147d57157e59157e5a167e5c167f5d177f5f187f601880621980641a80651a80671b80681c816a1c816b1d816d1d816e1e81701f81721f817320817521817621817822817922827b23827c23827e24828025828125818326818426818627818827818928818b29818c29818e2a81902a81912b81932b80942c80962c80982d80992d809b2e7f9c2e7f9e2f7fa02f7fa1307ea3307ea5317ea6317da8327daa337dab337cad347cae347bb0357bb2357bb3367ab5367ab73779b83779ba3878bc3978bd3977bf3a77c03a76c23b75c43c75c53c74c73d73c83e73ca3e72cc3f71cd4071cf4070d0416fd2426fd3436ed5446dd6456cd8456cd9466bdb476adc4869de4968df4a68e04c67e24d66e34e65e44f64e55064e75263e85362e95462ea5661eb5760ec5860ed5a5fee5b5eef5d5ef05f5ef1605df2625df2645cf3655cf4675cf4695cf56b5cf66c5cf66e5cf7705cf7725cf8745cf8765cf9785df9795df97b5dfa7d5efa7f5efa815ffb835ffb8560fb8761fc8961fc8a62fc8c63fc8e64fc9065fd9266fd9467fd9668fd9869fd9a6afd9b6bfe9d6cfe9f6dfea16efea36ffea571fea772fea973feaa74feac76feae77feb078feb27afeb47bfeb67cfeb77efeb97ffebb81febd82febf84fec185fec287fec488fec68afec88cfeca8dfecc8ffecd90fecf92fed194fed395fed597fed799fed89afdda9cfddc9efddea0fde0a1fde2a3fde3a5fde5a7fde7a9fde9aafdebacfcecaefceeb0fcf0b2fcf2b4fcf4b6fcf6b8fcf7b9fcf9bbfcfbbdfcfdbf"));
	
	var inferno = ramp(colors("00000401000501010601010802010a02020c02020e03021004031204031405041706041907051b08051d09061f0a07220b07240c08260d08290e092b10092d110a30120a32140b34150b37160b39180c3c190c3e1b0c411c0c431e0c451f0c48210c4a230c4c240c4f260c51280b53290b552b0b572d0b592f0a5b310a5c320a5e340a5f3609613809623909633b09643d09653e0966400a67420a68440a68450a69470b6a490b6a4a0c6b4c0c6b4d0d6c4f0d6c510e6c520e6d540f6d550f6d57106e59106e5a116e5c126e5d126e5f136e61136e62146e64156e65156e67166e69166e6a176e6c186e6d186e6f196e71196e721a6e741a6e751b6e771c6d781c6d7a1d6d7c1d6d7d1e6d7f1e6c801f6c82206c84206b85216b87216b88226a8a226a8c23698d23698f24699025689225689326679526679727669827669a28659b29649d29649f2a63a02a63a22b62a32c61a52c60a62d60a82e5fa92e5eab2f5ead305dae305cb0315bb1325ab3325ab43359b63458b73557b93556ba3655bc3754bd3853bf3952c03a51c13a50c33b4fc43c4ec63d4dc73e4cc83f4bca404acb4149cc4248ce4347cf4446d04545d24644d34743d44842d54a41d74b3fd84c3ed94d3dda4e3cdb503bdd513ade5238df5337e05536e15635e25734e35933e45a31e55c30e65d2fe75e2ee8602de9612bea632aeb6429eb6628ec6726ed6925ee6a24ef6c23ef6e21f06f20f1711ff1731df2741cf3761bf37819f47918f57b17f57d15f67e14f68013f78212f78410f8850ff8870ef8890cf98b0bf98c0af98e09fa9008fa9207fa9407fb9606fb9706fb9906fb9b06fb9d07fc9f07fca108fca309fca50afca60cfca80dfcaa0ffcac11fcae12fcb014fcb216fcb418fbb61afbb81dfbba1ffbbc21fbbe23fac026fac228fac42afac62df9c72ff9c932f9cb35f8cd37f8cf3af7d13df7d340f6d543f6d746f5d949f5db4cf4dd4ff4df53f4e156f3e35af3e55df2e661f2e865f2ea69f1ec6df1ed71f1ef75f1f179f2f27df2f482f3f586f3f68af4f88ef5f992f6fa96f8fb9af9fc9dfafda1fcffa4"));
	
	var plasma = ramp(colors("0d088710078813078916078a19068c1b068d1d068e20068f2206902406912605912805922a05932c05942e05952f059631059733059735049837049938049a3a049a3c049b3e049c3f049c41049d43039e44039e46039f48039f4903a04b03a14c02a14e02a25002a25102a35302a35502a45601a45801a45901a55b01a55c01a65e01a66001a66100a76300a76400a76600a76700a86900a86a00a86c00a86e00a86f00a87100a87201a87401a87501a87701a87801a87a02a87b02a87d03a87e03a88004a88104a78305a78405a78606a68707a68808a68a09a58b0aa58d0ba58e0ca48f0da4910ea3920fa39410a29511a19613a19814a099159f9a169f9c179e9d189d9e199da01a9ca11b9ba21d9aa31e9aa51f99a62098a72197a82296aa2395ab2494ac2694ad2793ae2892b02991b12a90b22b8fb32c8eb42e8db52f8cb6308bb7318ab83289ba3388bb3488bc3587bd3786be3885bf3984c03a83c13b82c23c81c33d80c43e7fc5407ec6417dc7427cc8437bc9447aca457acb4679cc4778cc4977cd4a76ce4b75cf4c74d04d73d14e72d24f71d35171d45270d5536fd5546ed6556dd7566cd8576bd9586ada5a6ada5b69db5c68dc5d67dd5e66de5f65de6164df6263e06363e16462e26561e26660e3685fe4695ee56a5de56b5de66c5ce76e5be76f5ae87059e97158e97257ea7457eb7556eb7655ec7754ed7953ed7a52ee7b51ef7c51ef7e50f07f4ff0804ef1814df1834cf2844bf3854bf3874af48849f48948f58b47f58c46f68d45f68f44f79044f79143f79342f89441f89540f9973ff9983ef99a3efa9b3dfa9c3cfa9e3bfb9f3afba139fba238fca338fca537fca636fca835fca934fdab33fdac33fdae32fdaf31fdb130fdb22ffdb42ffdb52efeb72dfeb82cfeba2cfebb2bfebd2afebe2afec029fdc229fdc328fdc527fdc627fdc827fdca26fdcb26fccd25fcce25fcd025fcd225fbd324fbd524fbd724fad824fada24f9dc24f9dd25f8df25f8e125f7e225f7e425f6e626f6e826f5e926f5eb27f4ed27f3ee27f3f027f2f227f1f426f1f525f0f724f0f921"));
	
	function sequential(interpolator) {
	  var x0 = 0,
	      x1 = 1,
	      clamp = false;
	
	  function scale(x) {
	    var t = (x - x0) / (x1 - x0);
	    return interpolator(clamp ? Math.max(0, Math.min(1, t)) : t);
	  }
	
	  scale.domain = function(_) {
	    return arguments.length ? (x0 = +_[0], x1 = +_[1], scale) : [x0, x1];
	  };
	
	  scale.clamp = function(_) {
	    return arguments.length ? (clamp = !!_, scale) : clamp;
	  };
	
	  scale.interpolator = function(_) {
	    return arguments.length ? (interpolator = _, scale) : interpolator;
	  };
	
	  scale.copy = function() {
	    return sequential(interpolator).domain([x0, x1]).clamp(clamp);
	  };
	
	  return linearish(scale);
	}
	
	exports.scaleBand = band;
	exports.scalePoint = point;
	exports.scaleIdentity = identity;
	exports.scaleLinear = linear;
	exports.scaleLog = log;
	exports.scaleOrdinal = ordinal;
	exports.scaleImplicit = implicit;
	exports.scalePow = pow;
	exports.scaleSqrt = sqrt;
	exports.scaleQuantile = quantile$1;
	exports.scaleQuantize = quantize;
	exports.scaleThreshold = threshold;
	exports.scaleTime = time;
	exports.scaleUtc = utcTime;
	exports.schemeCategory10 = category10;
	exports.schemeCategory20b = category20b;
	exports.schemeCategory20c = category20c;
	exports.schemeCategory20 = category20;
	exports.interpolateCubehelixDefault = cubehelix$1;
	exports.interpolateRainbow = rainbow$1;
	exports.interpolateWarm = warm;
	exports.interpolateCool = cool;
	exports.interpolateViridis = viridis;
	exports.interpolateMagma = magma;
	exports.interpolateInferno = inferno;
	exports.interpolatePlasma = plasma;
	exports.scaleSequential = sequential;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 341 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-time-format/ Version 2.1.1. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(166)) :
		typeof define === 'function' && define.amd ? define(['exports', 'd3-time'], factory) :
		(factory((global.d3 = global.d3 || {}),global.d3));
	}(this, (function (exports,d3Time) { 'use strict';
	
	function localDate(d) {
	  if (0 <= d.y && d.y < 100) {
	    var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
	    date.setFullYear(d.y);
	    return date;
	  }
	  return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
	}
	
	function utcDate(d) {
	  if (0 <= d.y && d.y < 100) {
	    var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
	    date.setUTCFullYear(d.y);
	    return date;
	  }
	  return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
	}
	
	function newYear(y) {
	  return {y: y, m: 0, d: 1, H: 0, M: 0, S: 0, L: 0};
	}
	
	function formatLocale(locale) {
	  var locale_dateTime = locale.dateTime,
	      locale_date = locale.date,
	      locale_time = locale.time,
	      locale_periods = locale.periods,
	      locale_weekdays = locale.days,
	      locale_shortWeekdays = locale.shortDays,
	      locale_months = locale.months,
	      locale_shortMonths = locale.shortMonths;
	
	  var periodRe = formatRe(locale_periods),
	      periodLookup = formatLookup(locale_periods),
	      weekdayRe = formatRe(locale_weekdays),
	      weekdayLookup = formatLookup(locale_weekdays),
	      shortWeekdayRe = formatRe(locale_shortWeekdays),
	      shortWeekdayLookup = formatLookup(locale_shortWeekdays),
	      monthRe = formatRe(locale_months),
	      monthLookup = formatLookup(locale_months),
	      shortMonthRe = formatRe(locale_shortMonths),
	      shortMonthLookup = formatLookup(locale_shortMonths);
	
	  var formats = {
	    "a": formatShortWeekday,
	    "A": formatWeekday,
	    "b": formatShortMonth,
	    "B": formatMonth,
	    "c": null,
	    "d": formatDayOfMonth,
	    "e": formatDayOfMonth,
	    "f": formatMicroseconds,
	    "H": formatHour24,
	    "I": formatHour12,
	    "j": formatDayOfYear,
	    "L": formatMilliseconds,
	    "m": formatMonthNumber,
	    "M": formatMinutes,
	    "p": formatPeriod,
	    "Q": formatUnixTimestamp,
	    "s": formatUnixTimestampSeconds,
	    "S": formatSeconds,
	    "u": formatWeekdayNumberMonday,
	    "U": formatWeekNumberSunday,
	    "V": formatWeekNumberISO,
	    "w": formatWeekdayNumberSunday,
	    "W": formatWeekNumberMonday,
	    "x": null,
	    "X": null,
	    "y": formatYear,
	    "Y": formatFullYear,
	    "Z": formatZone,
	    "%": formatLiteralPercent
	  };
	
	  var utcFormats = {
	    "a": formatUTCShortWeekday,
	    "A": formatUTCWeekday,
	    "b": formatUTCShortMonth,
	    "B": formatUTCMonth,
	    "c": null,
	    "d": formatUTCDayOfMonth,
	    "e": formatUTCDayOfMonth,
	    "f": formatUTCMicroseconds,
	    "H": formatUTCHour24,
	    "I": formatUTCHour12,
	    "j": formatUTCDayOfYear,
	    "L": formatUTCMilliseconds,
	    "m": formatUTCMonthNumber,
	    "M": formatUTCMinutes,
	    "p": formatUTCPeriod,
	    "Q": formatUnixTimestamp,
	    "s": formatUnixTimestampSeconds,
	    "S": formatUTCSeconds,
	    "u": formatUTCWeekdayNumberMonday,
	    "U": formatUTCWeekNumberSunday,
	    "V": formatUTCWeekNumberISO,
	    "w": formatUTCWeekdayNumberSunday,
	    "W": formatUTCWeekNumberMonday,
	    "x": null,
	    "X": null,
	    "y": formatUTCYear,
	    "Y": formatUTCFullYear,
	    "Z": formatUTCZone,
	    "%": formatLiteralPercent
	  };
	
	  var parses = {
	    "a": parseShortWeekday,
	    "A": parseWeekday,
	    "b": parseShortMonth,
	    "B": parseMonth,
	    "c": parseLocaleDateTime,
	    "d": parseDayOfMonth,
	    "e": parseDayOfMonth,
	    "f": parseMicroseconds,
	    "H": parseHour24,
	    "I": parseHour24,
	    "j": parseDayOfYear,
	    "L": parseMilliseconds,
	    "m": parseMonthNumber,
	    "M": parseMinutes,
	    "p": parsePeriod,
	    "Q": parseUnixTimestamp,
	    "s": parseUnixTimestampSeconds,
	    "S": parseSeconds,
	    "u": parseWeekdayNumberMonday,
	    "U": parseWeekNumberSunday,
	    "V": parseWeekNumberISO,
	    "w": parseWeekdayNumberSunday,
	    "W": parseWeekNumberMonday,
	    "x": parseLocaleDate,
	    "X": parseLocaleTime,
	    "y": parseYear,
	    "Y": parseFullYear,
	    "Z": parseZone,
	    "%": parseLiteralPercent
	  };
	
	  // These recursive directive definitions must be deferred.
	  formats.x = newFormat(locale_date, formats);
	  formats.X = newFormat(locale_time, formats);
	  formats.c = newFormat(locale_dateTime, formats);
	  utcFormats.x = newFormat(locale_date, utcFormats);
	  utcFormats.X = newFormat(locale_time, utcFormats);
	  utcFormats.c = newFormat(locale_dateTime, utcFormats);
	
	  function newFormat(specifier, formats) {
	    return function(date) {
	      var string = [],
	          i = -1,
	          j = 0,
	          n = specifier.length,
	          c,
	          pad,
	          format;
	
	      if (!(date instanceof Date)) date = new Date(+date);
	
	      while (++i < n) {
	        if (specifier.charCodeAt(i) === 37) {
	          string.push(specifier.slice(j, i));
	          if ((pad = pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
	          else pad = c === "e" ? " " : "0";
	          if (format = formats[c]) c = format(date, pad);
	          string.push(c);
	          j = i + 1;
	        }
	      }
	
	      string.push(specifier.slice(j, i));
	      return string.join("");
	    };
	  }
	
	  function newParse(specifier, newDate) {
	    return function(string) {
	      var d = newYear(1900),
	          i = parseSpecifier(d, specifier, string += "", 0),
	          week, day;
	      if (i != string.length) return null;
	
	      // If a UNIX timestamp is specified, return it.
	      if ("Q" in d) return new Date(d.Q);
	
	      // The am-pm flag is 0 for AM, and 1 for PM.
	      if ("p" in d) d.H = d.H % 12 + d.p * 12;
	
	      // Convert day-of-week and week-of-year to day-of-year.
	      if ("V" in d) {
	        if (d.V < 1 || d.V > 53) return null;
	        if (!("w" in d)) d.w = 1;
	        if ("Z" in d) {
	          week = utcDate(newYear(d.y)), day = week.getUTCDay();
	          week = day > 4 || day === 0 ? d3Time.utcMonday.ceil(week) : d3Time.utcMonday(week);
	          week = d3Time.utcDay.offset(week, (d.V - 1) * 7);
	          d.y = week.getUTCFullYear();
	          d.m = week.getUTCMonth();
	          d.d = week.getUTCDate() + (d.w + 6) % 7;
	        } else {
	          week = newDate(newYear(d.y)), day = week.getDay();
	          week = day > 4 || day === 0 ? d3Time.timeMonday.ceil(week) : d3Time.timeMonday(week);
	          week = d3Time.timeDay.offset(week, (d.V - 1) * 7);
	          d.y = week.getFullYear();
	          d.m = week.getMonth();
	          d.d = week.getDate() + (d.w + 6) % 7;
	        }
	      } else if ("W" in d || "U" in d) {
	        if (!("w" in d)) d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
	        day = "Z" in d ? utcDate(newYear(d.y)).getUTCDay() : newDate(newYear(d.y)).getDay();
	        d.m = 0;
	        d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
	      }
	
	      // If a time zone is specified, all fields are interpreted as UTC and then
	      // offset according to the specified time zone.
	      if ("Z" in d) {
	        d.H += d.Z / 100 | 0;
	        d.M += d.Z % 100;
	        return utcDate(d);
	      }
	
	      // Otherwise, all fields are in local time.
	      return newDate(d);
	    };
	  }
	
	  function parseSpecifier(d, specifier, string, j) {
	    var i = 0,
	        n = specifier.length,
	        m = string.length,
	        c,
	        parse;
	
	    while (i < n) {
	      if (j >= m) return -1;
	      c = specifier.charCodeAt(i++);
	      if (c === 37) {
	        c = specifier.charAt(i++);
	        parse = parses[c in pads ? specifier.charAt(i++) : c];
	        if (!parse || ((j = parse(d, string, j)) < 0)) return -1;
	      } else if (c != string.charCodeAt(j++)) {
	        return -1;
	      }
	    }
	
	    return j;
	  }
	
	  function parsePeriod(d, string, i) {
	    var n = periodRe.exec(string.slice(i));
	    return n ? (d.p = periodLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseShortWeekday(d, string, i) {
	    var n = shortWeekdayRe.exec(string.slice(i));
	    return n ? (d.w = shortWeekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseWeekday(d, string, i) {
	    var n = weekdayRe.exec(string.slice(i));
	    return n ? (d.w = weekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseShortMonth(d, string, i) {
	    var n = shortMonthRe.exec(string.slice(i));
	    return n ? (d.m = shortMonthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseMonth(d, string, i) {
	    var n = monthRe.exec(string.slice(i));
	    return n ? (d.m = monthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseLocaleDateTime(d, string, i) {
	    return parseSpecifier(d, locale_dateTime, string, i);
	  }
	
	  function parseLocaleDate(d, string, i) {
	    return parseSpecifier(d, locale_date, string, i);
	  }
	
	  function parseLocaleTime(d, string, i) {
	    return parseSpecifier(d, locale_time, string, i);
	  }
	
	  function formatShortWeekday(d) {
	    return locale_shortWeekdays[d.getDay()];
	  }
	
	  function formatWeekday(d) {
	    return locale_weekdays[d.getDay()];
	  }
	
	  function formatShortMonth(d) {
	    return locale_shortMonths[d.getMonth()];
	  }
	
	  function formatMonth(d) {
	    return locale_months[d.getMonth()];
	  }
	
	  function formatPeriod(d) {
	    return locale_periods[+(d.getHours() >= 12)];
	  }
	
	  function formatUTCShortWeekday(d) {
	    return locale_shortWeekdays[d.getUTCDay()];
	  }
	
	  function formatUTCWeekday(d) {
	    return locale_weekdays[d.getUTCDay()];
	  }
	
	  function formatUTCShortMonth(d) {
	    return locale_shortMonths[d.getUTCMonth()];
	  }
	
	  function formatUTCMonth(d) {
	    return locale_months[d.getUTCMonth()];
	  }
	
	  function formatUTCPeriod(d) {
	    return locale_periods[+(d.getUTCHours() >= 12)];
	  }
	
	  return {
	    format: function(specifier) {
	      var f = newFormat(specifier += "", formats);
	      f.toString = function() { return specifier; };
	      return f;
	    },
	    parse: function(specifier) {
	      var p = newParse(specifier += "", localDate);
	      p.toString = function() { return specifier; };
	      return p;
	    },
	    utcFormat: function(specifier) {
	      var f = newFormat(specifier += "", utcFormats);
	      f.toString = function() { return specifier; };
	      return f;
	    },
	    utcParse: function(specifier) {
	      var p = newParse(specifier, utcDate);
	      p.toString = function() { return specifier; };
	      return p;
	    }
	  };
	}
	
	var pads = {"-": "", "_": " ", "0": "0"};
	var numberRe = /^\s*\d+/;
	var percentRe = /^%/;
	var requoteRe = /[\\^$*+?|[\]().{}]/g;
	
	function pad(value, fill, width) {
	  var sign = value < 0 ? "-" : "",
	      string = (sign ? -value : value) + "",
	      length = string.length;
	  return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
	}
	
	function requote(s) {
	  return s.replace(requoteRe, "\\$&");
	}
	
	function formatRe(names) {
	  return new RegExp("^(?:" + names.map(requote).join("|") + ")", "i");
	}
	
	function formatLookup(names) {
	  var map = {}, i = -1, n = names.length;
	  while (++i < n) map[names[i].toLowerCase()] = i;
	  return map;
	}
	
	function parseWeekdayNumberSunday(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 1));
	  return n ? (d.w = +n[0], i + n[0].length) : -1;
	}
	
	function parseWeekdayNumberMonday(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 1));
	  return n ? (d.u = +n[0], i + n[0].length) : -1;
	}
	
	function parseWeekNumberSunday(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.U = +n[0], i + n[0].length) : -1;
	}
	
	function parseWeekNumberISO(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.V = +n[0], i + n[0].length) : -1;
	}
	
	function parseWeekNumberMonday(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.W = +n[0], i + n[0].length) : -1;
	}
	
	function parseFullYear(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 4));
	  return n ? (d.y = +n[0], i + n[0].length) : -1;
	}
	
	function parseYear(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
	}
	
	function parseZone(d, string, i) {
	  var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
	  return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
	}
	
	function parseMonthNumber(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
	}
	
	function parseDayOfMonth(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.d = +n[0], i + n[0].length) : -1;
	}
	
	function parseDayOfYear(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 3));
	  return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
	}
	
	function parseHour24(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.H = +n[0], i + n[0].length) : -1;
	}
	
	function parseMinutes(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.M = +n[0], i + n[0].length) : -1;
	}
	
	function parseSeconds(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.S = +n[0], i + n[0].length) : -1;
	}
	
	function parseMilliseconds(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 3));
	  return n ? (d.L = +n[0], i + n[0].length) : -1;
	}
	
	function parseMicroseconds(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 6));
	  return n ? (d.L = Math.floor(n[0] / 1000), i + n[0].length) : -1;
	}
	
	function parseLiteralPercent(d, string, i) {
	  var n = percentRe.exec(string.slice(i, i + 1));
	  return n ? i + n[0].length : -1;
	}
	
	function parseUnixTimestamp(d, string, i) {
	  var n = numberRe.exec(string.slice(i));
	  return n ? (d.Q = +n[0], i + n[0].length) : -1;
	}
	
	function parseUnixTimestampSeconds(d, string, i) {
	  var n = numberRe.exec(string.slice(i));
	  return n ? (d.Q = (+n[0]) * 1000, i + n[0].length) : -1;
	}
	
	function formatDayOfMonth(d, p) {
	  return pad(d.getDate(), p, 2);
	}
	
	function formatHour24(d, p) {
	  return pad(d.getHours(), p, 2);
	}
	
	function formatHour12(d, p) {
	  return pad(d.getHours() % 12 || 12, p, 2);
	}
	
	function formatDayOfYear(d, p) {
	  return pad(1 + d3Time.timeDay.count(d3Time.timeYear(d), d), p, 3);
	}
	
	function formatMilliseconds(d, p) {
	  return pad(d.getMilliseconds(), p, 3);
	}
	
	function formatMicroseconds(d, p) {
	  return formatMilliseconds(d, p) + "000";
	}
	
	function formatMonthNumber(d, p) {
	  return pad(d.getMonth() + 1, p, 2);
	}
	
	function formatMinutes(d, p) {
	  return pad(d.getMinutes(), p, 2);
	}
	
	function formatSeconds(d, p) {
	  return pad(d.getSeconds(), p, 2);
	}
	
	function formatWeekdayNumberMonday(d) {
	  var day = d.getDay();
	  return day === 0 ? 7 : day;
	}
	
	function formatWeekNumberSunday(d, p) {
	  return pad(d3Time.timeSunday.count(d3Time.timeYear(d), d), p, 2);
	}
	
	function formatWeekNumberISO(d, p) {
	  var day = d.getDay();
	  d = (day >= 4 || day === 0) ? d3Time.timeThursday(d) : d3Time.timeThursday.ceil(d);
	  return pad(d3Time.timeThursday.count(d3Time.timeYear(d), d) + (d3Time.timeYear(d).getDay() === 4), p, 2);
	}
	
	function formatWeekdayNumberSunday(d) {
	  return d.getDay();
	}
	
	function formatWeekNumberMonday(d, p) {
	  return pad(d3Time.timeMonday.count(d3Time.timeYear(d), d), p, 2);
	}
	
	function formatYear(d, p) {
	  return pad(d.getFullYear() % 100, p, 2);
	}
	
	function formatFullYear(d, p) {
	  return pad(d.getFullYear() % 10000, p, 4);
	}
	
	function formatZone(d) {
	  var z = d.getTimezoneOffset();
	  return (z > 0 ? "-" : (z *= -1, "+"))
	      + pad(z / 60 | 0, "0", 2)
	      + pad(z % 60, "0", 2);
	}
	
	function formatUTCDayOfMonth(d, p) {
	  return pad(d.getUTCDate(), p, 2);
	}
	
	function formatUTCHour24(d, p) {
	  return pad(d.getUTCHours(), p, 2);
	}
	
	function formatUTCHour12(d, p) {
	  return pad(d.getUTCHours() % 12 || 12, p, 2);
	}
	
	function formatUTCDayOfYear(d, p) {
	  return pad(1 + d3Time.utcDay.count(d3Time.utcYear(d), d), p, 3);
	}
	
	function formatUTCMilliseconds(d, p) {
	  return pad(d.getUTCMilliseconds(), p, 3);
	}
	
	function formatUTCMicroseconds(d, p) {
	  return formatUTCMilliseconds(d, p) + "000";
	}
	
	function formatUTCMonthNumber(d, p) {
	  return pad(d.getUTCMonth() + 1, p, 2);
	}
	
	function formatUTCMinutes(d, p) {
	  return pad(d.getUTCMinutes(), p, 2);
	}
	
	function formatUTCSeconds(d, p) {
	  return pad(d.getUTCSeconds(), p, 2);
	}
	
	function formatUTCWeekdayNumberMonday(d) {
	  var dow = d.getUTCDay();
	  return dow === 0 ? 7 : dow;
	}
	
	function formatUTCWeekNumberSunday(d, p) {
	  return pad(d3Time.utcSunday.count(d3Time.utcYear(d), d), p, 2);
	}
	
	function formatUTCWeekNumberISO(d, p) {
	  var day = d.getUTCDay();
	  d = (day >= 4 || day === 0) ? d3Time.utcThursday(d) : d3Time.utcThursday.ceil(d);
	  return pad(d3Time.utcThursday.count(d3Time.utcYear(d), d) + (d3Time.utcYear(d).getUTCDay() === 4), p, 2);
	}
	
	function formatUTCWeekdayNumberSunday(d) {
	  return d.getUTCDay();
	}
	
	function formatUTCWeekNumberMonday(d, p) {
	  return pad(d3Time.utcMonday.count(d3Time.utcYear(d), d), p, 2);
	}
	
	function formatUTCYear(d, p) {
	  return pad(d.getUTCFullYear() % 100, p, 2);
	}
	
	function formatUTCFullYear(d, p) {
	  return pad(d.getUTCFullYear() % 10000, p, 4);
	}
	
	function formatUTCZone() {
	  return "+0000";
	}
	
	function formatLiteralPercent() {
	  return "%";
	}
	
	function formatUnixTimestamp(d) {
	  return +d;
	}
	
	function formatUnixTimestampSeconds(d) {
	  return Math.floor(+d / 1000);
	}
	
	var locale;
	
	
	
	
	
	defaultLocale({
	  dateTime: "%x, %X",
	  date: "%-m/%-d/%Y",
	  time: "%-I:%M:%S %p",
	  periods: ["AM", "PM"],
	  days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
	  shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
	  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
	  shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
	});
	
	function defaultLocale(definition) {
	  locale = formatLocale(definition);
	  exports.timeFormat = locale.format;
	  exports.timeParse = locale.parse;
	  exports.utcFormat = locale.utcFormat;
	  exports.utcParse = locale.utcParse;
	  return locale;
	}
	
	var isoSpecifier = "%Y-%m-%dT%H:%M:%S.%LZ";
	
	function formatIsoNative(date) {
	  return date.toISOString();
	}
	
	var formatIso = Date.prototype.toISOString
	    ? formatIsoNative
	    : exports.utcFormat(isoSpecifier);
	
	function parseIsoNative(string) {
	  var date = new Date(string);
	  return isNaN(date) ? null : date;
	}
	
	var parseIso = +new Date("2000-01-01T00:00:00.000Z")
	    ? parseIsoNative
	    : exports.utcParse(isoSpecifier);
	
	exports.timeFormatDefaultLocale = defaultLocale;
	exports.timeFormatLocale = formatLocale;
	exports.isoFormat = formatIso;
	exports.isoParse = parseIso;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 342 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-timer/ Version 1.0.7. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports) :
		typeof define === 'function' && define.amd ? define(['exports'], factory) :
		(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	var frame = 0;
	var timeout = 0;
	var interval = 0;
	var pokeDelay = 1000;
	var taskHead;
	var taskTail;
	var clockLast = 0;
	var clockNow = 0;
	var clockSkew = 0;
	var clock = typeof performance === "object" && performance.now ? performance : Date;
	var setFrame = typeof window === "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function(f) { setTimeout(f, 17); };
	
	function now() {
	  return clockNow || (setFrame(clearNow), clockNow = clock.now() + clockSkew);
	}
	
	function clearNow() {
	  clockNow = 0;
	}
	
	function Timer() {
	  this._call =
	  this._time =
	  this._next = null;
	}
	
	Timer.prototype = timer.prototype = {
	  constructor: Timer,
	  restart: function(callback, delay, time) {
	    if (typeof callback !== "function") throw new TypeError("callback is not a function");
	    time = (time == null ? now() : +time) + (delay == null ? 0 : +delay);
	    if (!this._next && taskTail !== this) {
	      if (taskTail) taskTail._next = this;
	      else taskHead = this;
	      taskTail = this;
	    }
	    this._call = callback;
	    this._time = time;
	    sleep();
	  },
	  stop: function() {
	    if (this._call) {
	      this._call = null;
	      this._time = Infinity;
	      sleep();
	    }
	  }
	};
	
	function timer(callback, delay, time) {
	  var t = new Timer;
	  t.restart(callback, delay, time);
	  return t;
	}
	
	function timerFlush() {
	  now(); // Get the current time, if not already set.
	  ++frame; // Pretend we’ve set an alarm, if we haven’t already.
	  var t = taskHead, e;
	  while (t) {
	    if ((e = clockNow - t._time) >= 0) t._call.call(null, e);
	    t = t._next;
	  }
	  --frame;
	}
	
	function wake() {
	  clockNow = (clockLast = clock.now()) + clockSkew;
	  frame = timeout = 0;
	  try {
	    timerFlush();
	  } finally {
	    frame = 0;
	    nap();
	    clockNow = 0;
	  }
	}
	
	function poke() {
	  var now = clock.now(), delay = now - clockLast;
	  if (delay > pokeDelay) clockSkew -= delay, clockLast = now;
	}
	
	function nap() {
	  var t0, t1 = taskHead, t2, time = Infinity;
	  while (t1) {
	    if (t1._call) {
	      if (time > t1._time) time = t1._time;
	      t0 = t1, t1 = t1._next;
	    } else {
	      t2 = t1._next, t1._next = null;
	      t1 = t0 ? t0._next = t2 : taskHead = t2;
	    }
	  }
	  taskTail = t0;
	  sleep(time);
	}
	
	function sleep(time) {
	  if (frame) return; // Soonest alarm already set, or will be.
	  if (timeout) timeout = clearTimeout(timeout);
	  var delay = time - clockNow; // Strictly less than if we recomputed clockNow.
	  if (delay > 24) {
	    if (time < Infinity) timeout = setTimeout(wake, time - clock.now() - clockSkew);
	    if (interval) interval = clearInterval(interval);
	  } else {
	    if (!interval) clockLast = clock.now(), interval = setInterval(poke, pokeDelay);
	    frame = 1, setFrame(wake);
	  }
	}
	
	var timeout$1 = function(callback, delay, time) {
	  var t = new Timer;
	  delay = delay == null ? 0 : +delay;
	  t.restart(function(elapsed) {
	    t.stop();
	    callback(elapsed + delay);
	  }, delay, time);
	  return t;
	};
	
	var interval$1 = function(callback, delay, time) {
	  var t = new Timer, total = delay;
	  if (delay == null) return t.restart(callback, delay, time), t;
	  delay = +delay, time = time == null ? now() : +time;
	  t.restart(function tick(elapsed) {
	    elapsed += total;
	    t.restart(tick, total += delay, time);
	    callback(elapsed);
	  }, delay, time);
	  return t;
	};
	
	exports.now = now;
	exports.timer = timer;
	exports.timerFlush = timerFlush;
	exports.timeout = timeout$1;
	exports.interval = interval$1;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 343 */
64,
/* 344 */
64,
/* 345 */
64,
/* 346 */
64,
/* 347 */
231,
/* 348 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;

/***/ },
/* 349 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/Aidao_navy.295a9702.svg";

/***/ },
/* 350 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/dao_token_letter.675759d5.svg";

/***/ },
/* 351 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ercdex.1aa86f98.svg";

/***/ },
/* 352 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/idex.52ca26ca.svg";

/***/ },
/* 353 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/morph.2d716273.svg";

/***/ },
/* 354 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/radar.921d3eb6.svg";

/***/ },
/* 355 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/xinfin.7631e838.svg";

/***/ },
/* 356 */
/***/ function(module, exports) {

	/* eslint-env browser */
	module.exports = typeof self == 'object' ? self.FormData : window.FormData;


/***/ },
/* 357 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.createPath = exports.parsePath = exports.locationsAreEqual = exports.createLocation = exports.createMemoryHistory = exports.createHashHistory = exports.createBrowserHistory = undefined;
	
	var _LocationUtils = __webpack_require__(76);
	
	Object.defineProperty(exports, 'createLocation', {
	  enumerable: true,
	  get: function get() {
	    return _LocationUtils.createLocation;
	  }
	});
	Object.defineProperty(exports, 'locationsAreEqual', {
	  enumerable: true,
	  get: function get() {
	    return _LocationUtils.locationsAreEqual;
	  }
	});
	
	var _PathUtils = __webpack_require__(38);
	
	Object.defineProperty(exports, 'parsePath', {
	  enumerable: true,
	  get: function get() {
	    return _PathUtils.parsePath;
	  }
	});
	Object.defineProperty(exports, 'createPath', {
	  enumerable: true,
	  get: function get() {
	    return _PathUtils.createPath;
	  }
	});
	
	var _createBrowserHistory2 = __webpack_require__(172);
	
	var _createBrowserHistory3 = _interopRequireDefault(_createBrowserHistory2);
	
	var _createHashHistory2 = __webpack_require__(173);
	
	var _createHashHistory3 = _interopRequireDefault(_createHashHistory2);
	
	var _createMemoryHistory2 = __webpack_require__(174);
	
	var _createMemoryHistory3 = _interopRequireDefault(_createMemoryHistory2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.createBrowserHistory = _createBrowserHistory3.default;
	exports.createHashHistory = _createHashHistory3.default;
	exports.createMemoryHistory = _createMemoryHistory3.default;

/***/ },
/* 358 */
/***/ function(module, exports) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	'use strict';
	
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	  name: true,
	  length: true,
	  prototype: true,
	  caller: true,
	  callee: true,
	  arguments: true,
	  arity: true
	};
	
	var defineProperty = Object.defineProperty;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
	
	module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	
	        if (objectPrototype) {
	            var inheritedComponent = getPrototypeOf(sourceComponent);
	            if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	            }
	        }
	
	        var keys = getOwnPropertyNames(sourceComponent);
	
	        if (getOwnPropertySymbols) {
	            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            var key = keys[i];
	            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
	                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                try { // Avoid failures from read-only properties
	                    defineProperty(targetComponent, key, descriptor);
	                } catch (e) {}
	            }
	        }
	
	        return targetComponent;
	    }
	
	    return targetComponent;
	};


/***/ },
/* 359 */
/***/ function(module, exports) {

	/*!
	 * Determine if an object is a Buffer
	 *
	 * @author   Feross Aboukhadijeh <https://feross.org>
	 * @license  MIT
	 */
	
	// The _isBuffer check is for Safari 5-7 support, because it's missing
	// Object.prototype.constructor. Remove this eventually
	module.exports = function (obj) {
	  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
	}
	
	function isBuffer (obj) {
	  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
	}
	
	// For Node v0.10 support. Remove this eventually.
	function isSlowBuffer (obj) {
	  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
	}


/***/ },
/* 360 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(34),
	    root = __webpack_require__(15);
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView');
	
	module.exports = DataView;


/***/ },
/* 361 */
/***/ function(module, exports, __webpack_require__) {

	var hashClear = __webpack_require__(438),
	    hashDelete = __webpack_require__(439),
	    hashGet = __webpack_require__(440),
	    hashHas = __webpack_require__(441),
	    hashSet = __webpack_require__(442);
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	module.exports = Hash;


/***/ },
/* 362 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(34),
	    root = __webpack_require__(15);
	
	/* Built-in method references that are verified to be native. */
	var Promise = getNative(root, 'Promise');
	
	module.exports = Promise;


/***/ },
/* 363 */
/***/ function(module, exports) {

	/**
	 * Adds the key-value `pair` to `map`.
	 *
	 * @private
	 * @param {Object} map The map to modify.
	 * @param {Array} pair The key-value pair to add.
	 * @returns {Object} Returns `map`.
	 */
	function addMapEntry(map, pair) {
	  // Don't return `map.set` because it's not chainable in IE 11.
	  map.set(pair[0], pair[1]);
	  return map;
	}
	
	module.exports = addMapEntry;


/***/ },
/* 364 */
/***/ function(module, exports) {

	/**
	 * Adds `value` to `set`.
	 *
	 * @private
	 * @param {Object} set The set to modify.
	 * @param {*} value The value to add.
	 * @returns {Object} Returns `set`.
	 */
	function addSetEntry(set, value) {
	  // Don't return `set.add` because it's not chainable in IE 11.
	  set.add(value);
	  return set;
	}
	
	module.exports = addSetEntry;


/***/ },
/* 365 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `baseAggregator` for arrays.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} setter The function to set `accumulator` values.
	 * @param {Function} iteratee The iteratee to transform keys.
	 * @param {Object} accumulator The initial aggregated object.
	 * @returns {Function} Returns `accumulator`.
	 */
	function arrayAggregator(array, setter, iteratee, accumulator) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    var value = array[index];
	    setter(accumulator, value, iteratee(value), array);
	  }
	  return accumulator;
	}
	
	module.exports = arrayAggregator;


/***/ },
/* 366 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.filter` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function arrayFilter(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (predicate(value, index, array)) {
	      result[resIndex++] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = arrayFilter;


/***/ },
/* 367 */
/***/ function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(83);
	
	/**
	 * Aggregates elements of `collection` on `accumulator` with keys transformed
	 * by `iteratee` and values set by `setter`.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} setter The function to set `accumulator` values.
	 * @param {Function} iteratee The iteratee to transform keys.
	 * @param {Object} accumulator The initial aggregated object.
	 * @returns {Function} Returns `accumulator`.
	 */
	function baseAggregator(collection, setter, iteratee, accumulator) {
	  baseEach(collection, function(value, key, collection) {
	    setter(accumulator, value, iteratee(value), collection);
	  });
	  return accumulator;
	}
	
	module.exports = baseAggregator;


/***/ },
/* 368 */
/***/ function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(29),
	    keys = __webpack_require__(12);
	
	/**
	 * The base implementation of `_.assign` without support for multiple sources
	 * or `customizer` functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @returns {Object} Returns `object`.
	 */
	function baseAssign(object, source) {
	  return object && copyObject(source, keys(source), object);
	}
	
	module.exports = baseAssign;


/***/ },
/* 369 */
/***/ function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(29),
	    keysIn = __webpack_require__(44);
	
	/**
	 * The base implementation of `_.assignIn` without support for multiple sources
	 * or `customizer` functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @returns {Object} Returns `object`.
	 */
	function baseAssignIn(object, source) {
	  return object && copyObject(source, keysIn(source), object);
	}
	
	module.exports = baseAssignIn;


/***/ },
/* 370 */
/***/ function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(78),
	    arrayEach = __webpack_require__(178),
	    assignValue = __webpack_require__(79),
	    baseAssign = __webpack_require__(368),
	    baseAssignIn = __webpack_require__(369),
	    cloneBuffer = __webpack_require__(191),
	    copyArray = __webpack_require__(85),
	    copySymbols = __webpack_require__(412),
	    copySymbolsIn = __webpack_require__(413),
	    getAllKeys = __webpack_require__(201),
	    getAllKeysIn = __webpack_require__(202),
	    getTag = __webpack_require__(89),
	    initCloneArray = __webpack_require__(443),
	    initCloneByTag = __webpack_require__(444),
	    initCloneObject = __webpack_require__(205),
	    isArray = __webpack_require__(9),
	    isBuffer = __webpack_require__(55),
	    isObject = __webpack_require__(10),
	    keys = __webpack_require__(12);
	
	/** Used to compose bitmasks for cloning. */
	var CLONE_DEEP_FLAG = 1,
	    CLONE_FLAT_FLAG = 2,
	    CLONE_SYMBOLS_FLAG = 4;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values supported by `_.clone`. */
	var cloneableTags = {};
	cloneableTags[argsTag] = cloneableTags[arrayTag] =
	cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	cloneableTags[boolTag] = cloneableTags[dateTag] =
	cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	cloneableTags[int32Tag] = cloneableTags[mapTag] =
	cloneableTags[numberTag] = cloneableTags[objectTag] =
	cloneableTags[regexpTag] = cloneableTags[setTag] =
	cloneableTags[stringTag] = cloneableTags[symbolTag] =
	cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	cloneableTags[errorTag] = cloneableTags[funcTag] =
	cloneableTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	 * traversed objects.
	 *
	 * @private
	 * @param {*} value The value to clone.
	 * @param {boolean} bitmask The bitmask flags.
	 *  1 - Deep clone
	 *  2 - Flatten inherited properties
	 *  4 - Clone symbols
	 * @param {Function} [customizer] The function to customize cloning.
	 * @param {string} [key] The key of `value`.
	 * @param {Object} [object] The parent object of `value`.
	 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	 * @returns {*} Returns the cloned value.
	 */
	function baseClone(value, bitmask, customizer, key, object, stack) {
	  var result,
	      isDeep = bitmask & CLONE_DEEP_FLAG,
	      isFlat = bitmask & CLONE_FLAT_FLAG,
	      isFull = bitmask & CLONE_SYMBOLS_FLAG;
	
	  if (customizer) {
	    result = object ? customizer(value, key, object, stack) : customizer(value);
	  }
	  if (result !== undefined) {
	    return result;
	  }
	  if (!isObject(value)) {
	    return value;
	  }
	  var isArr = isArray(value);
	  if (isArr) {
	    result = initCloneArray(value);
	    if (!isDeep) {
	      return copyArray(value, result);
	    }
	  } else {
	    var tag = getTag(value),
	        isFunc = tag == funcTag || tag == genTag;
	
	    if (isBuffer(value)) {
	      return cloneBuffer(value, isDeep);
	    }
	    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	      result = (isFlat || isFunc) ? {} : initCloneObject(value);
	      if (!isDeep) {
	        return isFlat
	          ? copySymbolsIn(value, baseAssignIn(result, value))
	          : copySymbols(value, baseAssign(result, value));
	      }
	    } else {
	      if (!cloneableTags[tag]) {
	        return object ? value : {};
	      }
	      result = initCloneByTag(value, tag, baseClone, isDeep);
	    }
	  }
	  // Check for circular references and return its corresponding clone.
	  stack || (stack = new Stack);
	  var stacked = stack.get(value);
	  if (stacked) {
	    return stacked;
	  }
	  stack.set(value, result);
	
	  var keysFunc = isFull
	    ? (isFlat ? getAllKeysIn : getAllKeys)
	    : (isFlat ? keysIn : keys);
	
	  var props = isArr ? undefined : keysFunc(value);
	  arrayEach(props || value, function(subValue, key) {
	    if (props) {
	      key = subValue;
	      subValue = value[key];
	    }
	    // Recursively populate clone (susceptible to call stack limits).
	    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
	  });
	  return result;
	}
	
	module.exports = baseClone;


/***/ },
/* 371 */
/***/ function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(112),
	    arrayIncludes = __webpack_require__(113),
	    arrayIncludesWith = __webpack_require__(179),
	    arrayMap = __webpack_require__(40),
	    baseUnary = __webpack_require__(120),
	    cacheHas = __webpack_require__(121);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * The base implementation of methods like `_.difference` without support
	 * for excluding multiple arrays or iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Array} values The values to exclude.
	 * @param {Function} [iteratee] The iteratee invoked per element.
	 * @param {Function} [comparator] The comparator invoked per element.
	 * @returns {Array} Returns the new array of filtered values.
	 */
	function baseDifference(array, values, iteratee, comparator) {
	  var index = -1,
	      includes = arrayIncludes,
	      isCommon = true,
	      length = array.length,
	      result = [],
	      valuesLength = values.length;
	
	  if (!length) {
	    return result;
	  }
	  if (iteratee) {
	    values = arrayMap(values, baseUnary(iteratee));
	  }
	  if (comparator) {
	    includes = arrayIncludesWith;
	    isCommon = false;
	  }
	  else if (values.length >= LARGE_ARRAY_SIZE) {
	    includes = cacheHas;
	    isCommon = false;
	    values = new SetCache(values);
	  }
	  outer:
	  while (++index < length) {
	    var value = array[index],
	        computed = iteratee == null ? value : iteratee(value);
	
	    value = (comparator || value !== 0) ? value : 0;
	    if (isCommon && computed === computed) {
	      var valuesIndex = valuesLength;
	      while (valuesIndex--) {
	        if (values[valuesIndex] === computed) {
	          continue outer;
	        }
	      }
	      result.push(value);
	    }
	    else if (!includes(values, computed, comparator)) {
	      result.push(value);
	    }
	  }
	  return result;
	}
	
	module.exports = baseDifference;


/***/ },
/* 372 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.hasIn` without support for deep paths.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {Array|string} key The key to check.
	 * @returns {boolean} Returns `true` if `key` exists, else `false`.
	 */
	function baseHasIn(object, key) {
	  return object != null && key in Object(object);
	}
	
	module.exports = baseHasIn;


/***/ },
/* 373 */
/***/ function(module, exports, __webpack_require__) {

	var baseForOwn = __webpack_require__(116);
	
	/**
	 * The base implementation of `_.invert` and `_.invertBy` which inverts
	 * `object` with values transformed by `iteratee` and set by `setter`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} setter The function to set `accumulator` values.
	 * @param {Function} iteratee The iteratee to transform values.
	 * @param {Object} accumulator The initial inverted object.
	 * @returns {Function} Returns `accumulator`.
	 */
	function baseInverter(object, setter, iteratee, accumulator) {
	  baseForOwn(object, function(value, key, object) {
	    setter(accumulator, iteratee(value), key, object);
	  });
	  return accumulator;
	}
	
	module.exports = baseInverter;


/***/ },
/* 374 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(30),
	    isObjectLike = __webpack_require__(24);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]';
	
	/**
	 * The base implementation of `_.isArguments`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 */
	function baseIsArguments(value) {
	  return isObjectLike(value) && baseGetTag(value) == argsTag;
	}
	
	module.exports = baseIsArguments;


/***/ },
/* 375 */
/***/ function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(78),
	    equalArrays = __webpack_require__(199),
	    equalByTag = __webpack_require__(431),
	    equalObjects = __webpack_require__(432),
	    getTag = __webpack_require__(89),
	    isArray = __webpack_require__(9),
	    isBuffer = __webpack_require__(55),
	    isTypedArray = __webpack_require__(95);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqual` for arrays and objects which performs
	 * deep comparisons and tracks traversed objects enabling objects with circular
	 * references to be compared.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	  var objIsArr = isArray(object),
	      othIsArr = isArray(other),
	      objTag = objIsArr ? arrayTag : getTag(object),
	      othTag = othIsArr ? arrayTag : getTag(other);
	
	  objTag = objTag == argsTag ? objectTag : objTag;
	  othTag = othTag == argsTag ? objectTag : othTag;
	
	  var objIsObj = objTag == objectTag,
	      othIsObj = othTag == objectTag,
	      isSameTag = objTag == othTag;
	
	  if (isSameTag && isBuffer(object)) {
	    if (!isBuffer(other)) {
	      return false;
	    }
	    objIsArr = true;
	    objIsObj = false;
	  }
	  if (isSameTag && !objIsObj) {
	    stack || (stack = new Stack);
	    return (objIsArr || isTypedArray(object))
	      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	  }
	  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	    if (objIsWrapped || othIsWrapped) {
	      var objUnwrapped = objIsWrapped ? object.value() : object,
	          othUnwrapped = othIsWrapped ? other.value() : other;
	
	      stack || (stack = new Stack);
	      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	    }
	  }
	  if (!isSameTag) {
	    return false;
	  }
	  stack || (stack = new Stack);
	  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	}
	
	module.exports = baseIsEqualDeep;


/***/ },
/* 376 */
/***/ function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(78),
	    baseIsEqual = __webpack_require__(117);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * The base implementation of `_.isMatch` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to inspect.
	 * @param {Object} source The object of property values to match.
	 * @param {Array} matchData The property names, values, and compare flags to match.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	 */
	function baseIsMatch(object, source, matchData, customizer) {
	  var index = matchData.length,
	      length = index,
	      noCustomizer = !customizer;
	
	  if (object == null) {
	    return !length;
	  }
	  object = Object(object);
	  while (index--) {
	    var data = matchData[index];
	    if ((noCustomizer && data[2])
	          ? data[1] !== object[data[0]]
	          : !(data[0] in object)
	        ) {
	      return false;
	    }
	  }
	  while (++index < length) {
	    data = matchData[index];
	    var key = data[0],
	        objValue = object[key],
	        srcValue = data[1];
	
	    if (noCustomizer && data[2]) {
	      if (objValue === undefined && !(key in object)) {
	        return false;
	      }
	    } else {
	      var stack = new Stack;
	      if (customizer) {
	        var result = customizer(objValue, srcValue, key, object, source, stack);
	      }
	      if (!(result === undefined
	            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
	            : result
	          )) {
	        return false;
	      }
	    }
	  }
	  return true;
	}
	
	module.exports = baseIsMatch;


/***/ },
/* 377 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.isNaN` without support for number objects.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	 */
	function baseIsNaN(value) {
	  return value !== value;
	}
	
	module.exports = baseIsNaN;


/***/ },
/* 378 */
/***/ function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(7),
	    isMasked = __webpack_require__(448),
	    isObject = __webpack_require__(10),
	    toSource = __webpack_require__(215);
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	module.exports = baseIsNative;


/***/ },
/* 379 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(30),
	    isLength = __webpack_require__(132),
	    isObjectLike = __webpack_require__(24);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	}
	
	module.exports = baseIsTypedArray;


/***/ },
/* 380 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(10),
	    isPrototype = __webpack_require__(52),
	    nativeKeysIn = __webpack_require__(462);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeysIn(object) {
	  if (!isObject(object)) {
	    return nativeKeysIn(object);
	  }
	  var isProto = isPrototype(object),
	      result = [];
	
	  for (var key in object) {
	    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeysIn;


/***/ },
/* 381 */
/***/ function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(83),
	    isArrayLike = __webpack_require__(23);
	
	/**
	 * The base implementation of `_.map` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function baseMap(collection, iteratee) {
	  var index = -1,
	      result = isArrayLike(collection) ? Array(collection.length) : [];
	
	  baseEach(collection, function(value, key, collection) {
	    result[++index] = iteratee(value, key, collection);
	  });
	  return result;
	}
	
	module.exports = baseMap;


/***/ },
/* 382 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsMatch = __webpack_require__(376),
	    getMatchData = __webpack_require__(433),
	    matchesStrictComparable = __webpack_require__(208);
	
	/**
	 * The base implementation of `_.matches` which doesn't clone `source`.
	 *
	 * @private
	 * @param {Object} source The object of property values to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatches(source) {
	  var matchData = getMatchData(source);
	  if (matchData.length == 1 && matchData[0][2]) {
	    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	  }
	  return function(object) {
	    return object === source || baseIsMatch(object, source, matchData);
	  };
	}
	
	module.exports = baseMatches;


/***/ },
/* 383 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(117),
	    get = __webpack_require__(218),
	    hasIn = __webpack_require__(219),
	    isKey = __webpack_require__(127),
	    isStrictComparable = __webpack_require__(207),
	    matchesStrictComparable = __webpack_require__(208),
	    toKey = __webpack_require__(42);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	 *
	 * @private
	 * @param {string} path The path of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatchesProperty(path, srcValue) {
	  if (isKey(path) && isStrictComparable(srcValue)) {
	    return matchesStrictComparable(toKey(path), srcValue);
	  }
	  return function(object) {
	    var objValue = get(object, path);
	    return (objValue === undefined && objValue === srcValue)
	      ? hasIn(object, path)
	      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
	  };
	}
	
	module.exports = baseMatchesProperty;


/***/ },
/* 384 */
/***/ function(module, exports, __webpack_require__) {

	var assignMergeValue = __webpack_require__(182),
	    cloneBuffer = __webpack_require__(191),
	    cloneTypedArray = __webpack_require__(192),
	    copyArray = __webpack_require__(85),
	    initCloneObject = __webpack_require__(205),
	    isArguments = __webpack_require__(54),
	    isArray = __webpack_require__(9),
	    isArrayLikeObject = __webpack_require__(220),
	    isBuffer = __webpack_require__(55),
	    isFunction = __webpack_require__(7),
	    isObject = __webpack_require__(10),
	    isPlainObject = __webpack_require__(36),
	    isTypedArray = __webpack_require__(95),
	    toPlainObject = __webpack_require__(502);
	
	/**
	 * A specialized version of `baseMerge` for arrays and objects which performs
	 * deep merges and tracks traversed objects enabling objects with circular
	 * references to be merged.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @param {string} key The key of the value to merge.
	 * @param {number} srcIndex The index of `source`.
	 * @param {Function} mergeFunc The function to merge values.
	 * @param {Function} [customizer] The function to customize assigned values.
	 * @param {Object} [stack] Tracks traversed source values and their merged
	 *  counterparts.
	 */
	function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
	  var objValue = object[key],
	      srcValue = source[key],
	      stacked = stack.get(srcValue);
	
	  if (stacked) {
	    assignMergeValue(object, key, stacked);
	    return;
	  }
	  var newValue = customizer
	    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
	    : undefined;
	
	  var isCommon = newValue === undefined;
	
	  if (isCommon) {
	    var isArr = isArray(srcValue),
	        isBuff = !isArr && isBuffer(srcValue),
	        isTyped = !isArr && !isBuff && isTypedArray(srcValue);
	
	    newValue = srcValue;
	    if (isArr || isBuff || isTyped) {
	      if (isArray(objValue)) {
	        newValue = objValue;
	      }
	      else if (isArrayLikeObject(objValue)) {
	        newValue = copyArray(objValue);
	      }
	      else if (isBuff) {
	        isCommon = false;
	        newValue = cloneBuffer(srcValue, true);
	      }
	      else if (isTyped) {
	        isCommon = false;
	        newValue = cloneTypedArray(srcValue, true);
	      }
	      else {
	        newValue = [];
	      }
	    }
	    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	      newValue = objValue;
	      if (isArguments(objValue)) {
	        newValue = toPlainObject(objValue);
	      }
	      else if (!isObject(objValue) || (srcIndex && isFunction(objValue))) {
	        newValue = initCloneObject(srcValue);
	      }
	    }
	    else {
	      isCommon = false;
	    }
	  }
	  if (isCommon) {
	    // Recursively merge objects and arrays (susceptible to call stack limits).
	    stack.set(srcValue, newValue);
	    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
	    stack['delete'](srcValue);
	  }
	  assignMergeValue(object, key, newValue);
	}
	
	module.exports = baseMergeDeep;


/***/ },
/* 385 */
/***/ function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(40),
	    baseIteratee = __webpack_require__(32),
	    baseMap = __webpack_require__(381),
	    baseSortBy = __webpack_require__(396),
	    baseUnary = __webpack_require__(120),
	    compareMultiple = __webpack_require__(411),
	    identity = __webpack_require__(22);
	
	/**
	 * The base implementation of `_.orderBy` without param guards.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	 * @param {string[]} orders The sort orders of `iteratees`.
	 * @returns {Array} Returns the new sorted array.
	 */
	function baseOrderBy(collection, iteratees, orders) {
	  var index = -1;
	  iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(baseIteratee));
	
	  var result = baseMap(collection, function(value, key, collection) {
	    var criteria = arrayMap(iteratees, function(iteratee) {
	      return iteratee(value);
	    });
	    return { 'criteria': criteria, 'index': ++index, 'value': value };
	  });
	
	  return baseSortBy(result, function(object, other) {
	    return compareMultiple(object, other, orders);
	  });
	}
	
	module.exports = baseOrderBy;


/***/ },
/* 386 */
/***/ function(module, exports, __webpack_require__) {

	var basePickBy = __webpack_require__(387),
	    hasIn = __webpack_require__(219);
	
	/**
	 * The base implementation of `_.pick` without support for individual
	 * property identifiers.
	 *
	 * @private
	 * @param {Object} object The source object.
	 * @param {string[]} paths The property paths to pick.
	 * @returns {Object} Returns the new object.
	 */
	function basePick(object, paths) {
	  return basePickBy(object, paths, function(value, path) {
	    return hasIn(object, path);
	  });
	}
	
	module.exports = basePick;


/***/ },
/* 387 */
/***/ function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(84),
	    baseSet = __webpack_require__(392),
	    castPath = __webpack_require__(41);
	
	/**
	 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The source object.
	 * @param {string[]} paths The property paths to pick.
	 * @param {Function} predicate The function invoked per property.
	 * @returns {Object} Returns the new object.
	 */
	function basePickBy(object, paths, predicate) {
	  var index = -1,
	      length = paths.length,
	      result = {};
	
	  while (++index < length) {
	    var path = paths[index],
	        value = baseGet(object, path);
	
	    if (predicate(value, path)) {
	      baseSet(result, castPath(path, object), value);
	    }
	  }
	  return result;
	}
	
	module.exports = basePickBy;


/***/ },
/* 388 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	module.exports = baseProperty;


/***/ },
/* 389 */
/***/ function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(84);
	
	/**
	 * A specialized version of `baseProperty` which supports deep paths.
	 *
	 * @private
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function basePropertyDeep(path) {
	  return function(object) {
	    return baseGet(object, path);
	  };
	}
	
	module.exports = basePropertyDeep;


/***/ },
/* 390 */
/***/ function(module, exports) {

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeCeil = Math.ceil,
	    nativeMax = Math.max;
	
	/**
	 * The base implementation of `_.range` and `_.rangeRight` which doesn't
	 * coerce arguments.
	 *
	 * @private
	 * @param {number} start The start of the range.
	 * @param {number} end The end of the range.
	 * @param {number} step The value to increment or decrement by.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Array} Returns the range of numbers.
	 */
	function baseRange(start, end, step, fromRight) {
	  var index = -1,
	      length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
	      result = Array(length);
	
	  while (length--) {
	    result[fromRight ? length : ++index] = start;
	    start += step;
	  }
	  return result;
	}
	
	module.exports = baseRange;


/***/ },
/* 391 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.reduce` and `_.reduceRight`, without support
	 * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {*} accumulator The initial value.
	 * @param {boolean} initAccum Specify using the first or last element of
	 *  `collection` as the initial value.
	 * @param {Function} eachFunc The function to iterate over `collection`.
	 * @returns {*} Returns the accumulated value.
	 */
	function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
	  eachFunc(collection, function(value, index, collection) {
	    accumulator = initAccum
	      ? (initAccum = false, value)
	      : iteratee(accumulator, value, index, collection);
	  });
	  return accumulator;
	}
	
	module.exports = baseReduce;


/***/ },
/* 392 */
/***/ function(module, exports, __webpack_require__) {

	var assignValue = __webpack_require__(79),
	    castPath = __webpack_require__(41),
	    isIndex = __webpack_require__(51),
	    isObject = __webpack_require__(10),
	    toKey = __webpack_require__(42);
	
	/**
	 * The base implementation of `_.set`.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {Array|string} path The path of the property to set.
	 * @param {*} value The value to set.
	 * @param {Function} [customizer] The function to customize path creation.
	 * @returns {Object} Returns `object`.
	 */
	function baseSet(object, path, value, customizer) {
	  if (!isObject(object)) {
	    return object;
	  }
	  path = castPath(path, object);
	
	  var index = -1,
	      length = path.length,
	      lastIndex = length - 1,
	      nested = object;
	
	  while (nested != null && ++index < length) {
	    var key = toKey(path[index]),
	        newValue = value;
	
	    if (index != lastIndex) {
	      var objValue = nested[key];
	      newValue = customizer ? customizer(objValue, key, nested) : undefined;
	      if (newValue === undefined) {
	        newValue = isObject(objValue)
	          ? objValue
	          : (isIndex(path[index + 1]) ? [] : {});
	      }
	    }
	    assignValue(nested, key, newValue);
	    nested = nested[key];
	  }
	  return object;
	}
	
	module.exports = baseSet;


/***/ },
/* 393 */
/***/ function(module, exports, __webpack_require__) {

	var constant = __webpack_require__(216),
	    defineProperty = __webpack_require__(198),
	    identity = __webpack_require__(22);
	
	/**
	 * The base implementation of `setToString` without support for hot loop shorting.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var baseSetToString = !defineProperty ? identity : function(func, string) {
	  return defineProperty(func, 'toString', {
	    'configurable': true,
	    'enumerable': false,
	    'value': constant(string),
	    'writable': true
	  });
	};
	
	module.exports = baseSetToString;


/***/ },
/* 394 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.slice` without an iteratee call guard.
	 *
	 * @private
	 * @param {Array} array The array to slice.
	 * @param {number} [start=0] The start position.
	 * @param {number} [end=array.length] The end position.
	 * @returns {Array} Returns the slice of `array`.
	 */
	function baseSlice(array, start, end) {
	  var index = -1,
	      length = array.length;
	
	  if (start < 0) {
	    start = -start > length ? 0 : (length + start);
	  }
	  end = end > length ? length : end;
	  if (end < 0) {
	    end += length;
	  }
	  length = start > end ? 0 : ((end - start) >>> 0);
	  start >>>= 0;
	
	  var result = Array(length);
	  while (++index < length) {
	    result[index] = array[index + start];
	  }
	  return result;
	}
	
	module.exports = baseSlice;


/***/ },
/* 395 */
/***/ function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(83);
	
	/**
	 * The base implementation of `_.some` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function baseSome(collection, predicate) {
	  var result;
	
	  baseEach(collection, function(value, index, collection) {
	    result = predicate(value, index, collection);
	    return !result;
	  });
	  return !!result;
	}
	
	module.exports = baseSome;


/***/ },
/* 396 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.sortBy` which uses `comparer` to define the
	 * sort order of `array` and replaces criteria objects with their corresponding
	 * values.
	 *
	 * @private
	 * @param {Array} array The array to sort.
	 * @param {Function} comparer The function to define sort order.
	 * @returns {Array} Returns `array`.
	 */
	function baseSortBy(array, comparer) {
	  var length = array.length;
	
	  array.sort(comparer);
	  while (length--) {
	    array[length] = array[length].value;
	  }
	  return array;
	}
	
	module.exports = baseSortBy;


/***/ },
/* 397 */
/***/ function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(35);
	
	/**
	 * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
	 * support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Function} [iteratee] The iteratee invoked per element.
	 * @returns {Array} Returns the new duplicate free array.
	 */
	function baseSortedUniq(array, iteratee) {
	  var index = -1,
	      length = array.length,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index],
	        computed = iteratee ? iteratee(value) : value;
	
	    if (!index || !eq(computed, seen)) {
	      var seen = computed;
	      result[resIndex++] = value === 0 ? 0 : value;
	    }
	  }
	  return result;
	}
	
	module.exports = baseSortedUniq;


/***/ },
/* 398 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.sum` and `_.sumBy` without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {number} Returns the sum.
	 */
	function baseSum(array, iteratee) {
	  var result,
	      index = -1,
	      length = array.length;
	
	  while (++index < length) {
	    var current = iteratee(array[index]);
	    if (current !== undefined) {
	      result = result === undefined ? current : (result + current);
	    }
	  }
	  return result;
	}
	
	module.exports = baseSum;


/***/ },
/* 399 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	module.exports = baseTimes;


/***/ },
/* 400 */
/***/ function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(40);
	
	/**
	 * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
	 * of key-value pairs for `object` corresponding to the property names of `props`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array} props The property names to get values for.
	 * @returns {Object} Returns the key-value pairs.
	 */
	function baseToPairs(object, props) {
	  return arrayMap(props, function(key) {
	    return [key, object[key]];
	  });
	}
	
	module.exports = baseToPairs;


/***/ },
/* 401 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(39),
	    arrayMap = __webpack_require__(40),
	    isArray = __webpack_require__(9),
	    isSymbol = __webpack_require__(57);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	/**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  // Exit early for strings to avoid a performance hit in some environments.
	  if (typeof value == 'string') {
	    return value;
	  }
	  if (isArray(value)) {
	    // Recursively convert values (susceptible to call stack limits).
	    return arrayMap(value, baseToString) + '';
	  }
	  if (isSymbol(value)) {
	    return symbolToString ? symbolToString.call(value) : '';
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = baseToString;


/***/ },
/* 402 */
/***/ function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(41),
	    last = __webpack_require__(222),
	    parent = __webpack_require__(465),
	    toKey = __webpack_require__(42);
	
	/**
	 * The base implementation of `_.unset`.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {Array|string} path The property path to unset.
	 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	 */
	function baseUnset(object, path) {
	  path = castPath(path, object);
	  object = parent(object, path);
	  return object == null || delete object[toKey(last(path))];
	}
	
	module.exports = baseUnset;


/***/ },
/* 403 */
/***/ function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(40);
	
	/**
	 * The base implementation of `_.values` and `_.valuesIn` which creates an
	 * array of `object` property values corresponding to the property names
	 * of `props`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array} props The property names to get values for.
	 * @returns {Object} Returns the array of property values.
	 */
	function baseValues(object, props) {
	  return arrayMap(props, function(key) {
	    return object[key];
	  });
	}
	
	module.exports = baseValues;


/***/ },
/* 404 */
/***/ function(module, exports, __webpack_require__) {

	var identity = __webpack_require__(22);
	
	/**
	 * Casts `value` to `identity` if it's not a function.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {Function} Returns cast function.
	 */
	function castFunction(value) {
	  return typeof value == 'function' ? value : identity;
	}
	
	module.exports = castFunction;


/***/ },
/* 405 */
/***/ function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(122);
	
	/**
	 * Creates a clone of `dataView`.
	 *
	 * @private
	 * @param {Object} dataView The data view to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned data view.
	 */
	function cloneDataView(dataView, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	}
	
	module.exports = cloneDataView;


/***/ },
/* 406 */
/***/ function(module, exports, __webpack_require__) {

	var addMapEntry = __webpack_require__(363),
	    arrayReduce = __webpack_require__(115),
	    mapToArray = __webpack_require__(128);
	
	/** Used to compose bitmasks for cloning. */
	var CLONE_DEEP_FLAG = 1;
	
	/**
	 * Creates a clone of `map`.
	 *
	 * @private
	 * @param {Object} map The map to clone.
	 * @param {Function} cloneFunc The function to clone values.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned map.
	 */
	function cloneMap(map, isDeep, cloneFunc) {
	  var array = isDeep ? cloneFunc(mapToArray(map), CLONE_DEEP_FLAG) : mapToArray(map);
	  return arrayReduce(array, addMapEntry, new map.constructor);
	}
	
	module.exports = cloneMap;


/***/ },
/* 407 */
/***/ function(module, exports) {

	/** Used to match `RegExp` flags from their coerced string values. */
	var reFlags = /\w*$/;
	
	/**
	 * Creates a clone of `regexp`.
	 *
	 * @private
	 * @param {Object} regexp The regexp to clone.
	 * @returns {Object} Returns the cloned regexp.
	 */
	function cloneRegExp(regexp) {
	  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	  result.lastIndex = regexp.lastIndex;
	  return result;
	}
	
	module.exports = cloneRegExp;


/***/ },
/* 408 */
/***/ function(module, exports, __webpack_require__) {

	var addSetEntry = __webpack_require__(364),
	    arrayReduce = __webpack_require__(115),
	    setToArray = __webpack_require__(92);
	
	/** Used to compose bitmasks for cloning. */
	var CLONE_DEEP_FLAG = 1;
	
	/**
	 * Creates a clone of `set`.
	 *
	 * @private
	 * @param {Object} set The set to clone.
	 * @param {Function} cloneFunc The function to clone values.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned set.
	 */
	function cloneSet(set, isDeep, cloneFunc) {
	  var array = isDeep ? cloneFunc(setToArray(set), CLONE_DEEP_FLAG) : setToArray(set);
	  return arrayReduce(array, addSetEntry, new set.constructor);
	}
	
	module.exports = cloneSet;


/***/ },
/* 409 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(39);
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * Creates a clone of the `symbol` object.
	 *
	 * @private
	 * @param {Object} symbol The symbol object to clone.
	 * @returns {Object} Returns the cloned symbol object.
	 */
	function cloneSymbol(symbol) {
	  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	}
	
	module.exports = cloneSymbol;


/***/ },
/* 410 */
/***/ function(module, exports, __webpack_require__) {

	var isSymbol = __webpack_require__(57);
	
	/**
	 * Compares values to sort them in ascending order.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {number} Returns the sort order indicator for `value`.
	 */
	function compareAscending(value, other) {
	  if (value !== other) {
	    var valIsDefined = value !== undefined,
	        valIsNull = value === null,
	        valIsReflexive = value === value,
	        valIsSymbol = isSymbol(value);
	
	    var othIsDefined = other !== undefined,
	        othIsNull = other === null,
	        othIsReflexive = other === other,
	        othIsSymbol = isSymbol(other);
	
	    if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
	        (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
	        (valIsNull && othIsDefined && othIsReflexive) ||
	        (!valIsDefined && othIsReflexive) ||
	        !valIsReflexive) {
	      return 1;
	    }
	    if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
	        (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
	        (othIsNull && valIsDefined && valIsReflexive) ||
	        (!othIsDefined && valIsReflexive) ||
	        !othIsReflexive) {
	      return -1;
	    }
	  }
	  return 0;
	}
	
	module.exports = compareAscending;


/***/ },
/* 411 */
/***/ function(module, exports, __webpack_require__) {

	var compareAscending = __webpack_require__(410);
	
	/**
	 * Used by `_.orderBy` to compare multiple properties of a value to another
	 * and stable sort them.
	 *
	 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
	 * specify an order of "desc" for descending or "asc" for ascending sort order
	 * of corresponding values.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {boolean[]|string[]} orders The order to sort by for each property.
	 * @returns {number} Returns the sort order indicator for `object`.
	 */
	function compareMultiple(object, other, orders) {
	  var index = -1,
	      objCriteria = object.criteria,
	      othCriteria = other.criteria,
	      length = objCriteria.length,
	      ordersLength = orders.length;
	
	  while (++index < length) {
	    var result = compareAscending(objCriteria[index], othCriteria[index]);
	    if (result) {
	      if (index >= ordersLength) {
	        return result;
	      }
	      var order = orders[index];
	      return result * (order == 'desc' ? -1 : 1);
	    }
	  }
	  // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	  // that causes it, under certain circumstances, to provide the same value for
	  // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	  // for more details.
	  //
	  // This also ensures a stable sort in V8 and other engines.
	  // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
	  return object.index - other.index;
	}
	
	module.exports = compareMultiple;


/***/ },
/* 412 */
/***/ function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(29),
	    getSymbols = __webpack_require__(126);
	
	/**
	 * Copies own symbols of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy symbols from.
	 * @param {Object} [object={}] The object to copy symbols to.
	 * @returns {Object} Returns `object`.
	 */
	function copySymbols(source, object) {
	  return copyObject(source, getSymbols(source), object);
	}
	
	module.exports = copySymbols;


/***/ },
/* 413 */
/***/ function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(29),
	    getSymbolsIn = __webpack_require__(204);
	
	/**
	 * Copies own and inherited symbols of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy symbols from.
	 * @param {Object} [object={}] The object to copy symbols to.
	 * @returns {Object} Returns `object`.
	 */
	function copySymbolsIn(source, object) {
	  return copyObject(source, getSymbolsIn(source), object);
	}
	
	module.exports = copySymbolsIn;


/***/ },
/* 414 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(15);
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	module.exports = coreJsData;


/***/ },
/* 415 */
/***/ function(module, exports) {

	/**
	 * Gets the number of `placeholder` occurrences in `array`.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} placeholder The placeholder to search for.
	 * @returns {number} Returns the placeholder count.
	 */
	function countHolders(array, placeholder) {
	  var length = array.length,
	      result = 0;
	
	  while (length--) {
	    if (array[length] === placeholder) {
	      ++result;
	    }
	  }
	  return result;
	}
	
	module.exports = countHolders;


/***/ },
/* 416 */
/***/ function(module, exports, __webpack_require__) {

	var arrayAggregator = __webpack_require__(365),
	    baseAggregator = __webpack_require__(367),
	    baseIteratee = __webpack_require__(32),
	    isArray = __webpack_require__(9);
	
	/**
	 * Creates a function like `_.groupBy`.
	 *
	 * @private
	 * @param {Function} setter The function to set accumulator values.
	 * @param {Function} [initializer] The accumulator object initializer.
	 * @returns {Function} Returns the new aggregator function.
	 */
	function createAggregator(setter, initializer) {
	  return function(collection, iteratee) {
	    var func = isArray(collection) ? arrayAggregator : baseAggregator,
	        accumulator = initializer ? initializer() : {};
	
	    return func(collection, setter, baseIteratee(iteratee, 2), accumulator);
	  };
	}
	
	module.exports = createAggregator;


/***/ },
/* 417 */
/***/ function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(23);
	
	/**
	 * Creates a `baseEach` or `baseEachRight` function.
	 *
	 * @private
	 * @param {Function} eachFunc The function to iterate over a collection.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseEach(eachFunc, fromRight) {
	  return function(collection, iteratee) {
	    if (collection == null) {
	      return collection;
	    }
	    if (!isArrayLike(collection)) {
	      return eachFunc(collection, iteratee);
	    }
	    var length = collection.length,
	        index = fromRight ? length : -1,
	        iterable = Object(collection);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (iteratee(iterable[index], index, iterable) === false) {
	        break;
	      }
	    }
	    return collection;
	  };
	}
	
	module.exports = createBaseEach;


/***/ },
/* 418 */
/***/ function(module, exports) {

	/**
	 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var index = -1,
	        iterable = Object(object),
	        props = keysFunc(object),
	        length = props.length;
	
	    while (length--) {
	      var key = props[fromRight ? length : ++index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}
	
	module.exports = createBaseFor;


/***/ },
/* 419 */
/***/ function(module, exports, __webpack_require__) {

	var createCtor = __webpack_require__(86),
	    root = __webpack_require__(15);
	
	/** Used to compose bitmasks for function metadata. */
	var WRAP_BIND_FLAG = 1;
	
	/**
	 * Creates a function that wraps `func` to invoke it with the optional `this`
	 * binding of `thisArg`.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @param {*} [thisArg] The `this` binding of `func`.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createBind(func, bitmask, thisArg) {
	  var isBind = bitmask & WRAP_BIND_FLAG,
	      Ctor = createCtor(func);
	
	  function wrapper() {
	    var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	    return fn.apply(isBind ? thisArg : this, arguments);
	  }
	  return wrapper;
	}
	
	module.exports = createBind;


/***/ },
/* 420 */
/***/ function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(49),
	    createCtor = __webpack_require__(86),
	    createHybrid = __webpack_require__(195),
	    createRecurry = __webpack_require__(196),
	    getHolder = __webpack_require__(87),
	    replaceHolders = __webpack_require__(53),
	    root = __webpack_require__(15);
	
	/**
	 * Creates a function that wraps `func` to enable currying.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @param {number} arity The arity of `func`.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createCurry(func, bitmask, arity) {
	  var Ctor = createCtor(func);
	
	  function wrapper() {
	    var length = arguments.length,
	        args = Array(length),
	        index = length,
	        placeholder = getHolder(wrapper);
	
	    while (index--) {
	      args[index] = arguments[index];
	    }
	    var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
	      ? []
	      : replaceHolders(args, placeholder);
	
	    length -= holders.length;
	    if (length < arity) {
	      return createRecurry(
	        func, bitmask, createHybrid, wrapper.placeholder, undefined,
	        args, holders, undefined, undefined, arity - length);
	    }
	    var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	    return apply(fn, this, args);
	  }
	  return wrapper;
	}
	
	module.exports = createCurry;


/***/ },
/* 421 */
/***/ function(module, exports, __webpack_require__) {

	var baseIteratee = __webpack_require__(32),
	    isArrayLike = __webpack_require__(23),
	    keys = __webpack_require__(12);
	
	/**
	 * Creates a `_.find` or `_.findLast` function.
	 *
	 * @private
	 * @param {Function} findIndexFunc The function to find the collection index.
	 * @returns {Function} Returns the new find function.
	 */
	function createFind(findIndexFunc) {
	  return function(collection, predicate, fromIndex) {
	    var iterable = Object(collection);
	    if (!isArrayLike(collection)) {
	      var iteratee = baseIteratee(predicate, 3);
	      collection = keys(collection);
	      predicate = function(key) { return iteratee(iterable[key], key, iterable); };
	    }
	    var index = findIndexFunc(collection, predicate, fromIndex);
	    return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
	  };
	}
	
	module.exports = createFind;


/***/ },
/* 422 */
/***/ function(module, exports, __webpack_require__) {

	var LodashWrapper = __webpack_require__(109),
	    flatRest = __webpack_require__(123),
	    getData = __webpack_require__(124),
	    getFuncName = __webpack_require__(203),
	    isArray = __webpack_require__(9),
	    isLaziable = __webpack_require__(206);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/** Used to compose bitmasks for function metadata. */
	var WRAP_CURRY_FLAG = 8,
	    WRAP_PARTIAL_FLAG = 32,
	    WRAP_ARY_FLAG = 128,
	    WRAP_REARG_FLAG = 256;
	
	/**
	 * Creates a `_.flow` or `_.flowRight` function.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new flow function.
	 */
	function createFlow(fromRight) {
	  return flatRest(function(funcs) {
	    var length = funcs.length,
	        index = length,
	        prereq = LodashWrapper.prototype.thru;
	
	    if (fromRight) {
	      funcs.reverse();
	    }
	    while (index--) {
	      var func = funcs[index];
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
	        var wrapper = new LodashWrapper([], true);
	      }
	    }
	    index = wrapper ? index : length;
	    while (++index < length) {
	      func = funcs[index];
	
	      var funcName = getFuncName(func),
	          data = funcName == 'wrapper' ? getData(func) : undefined;
	
	      if (data && isLaziable(data[0]) &&
	            data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
	            !data[4].length && data[9] == 1
	          ) {
	        wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
	      } else {
	        wrapper = (func.length == 1 && isLaziable(func))
	          ? wrapper[funcName]()
	          : wrapper.thru(func);
	      }
	    }
	    return function() {
	      var args = arguments,
	          value = args[0];
	
	      if (wrapper && args.length == 1 && isArray(value)) {
	        return wrapper.plant(value).value();
	      }
	      var index = 0,
	          result = length ? funcs[index].apply(this, args) : value;
	
	      while (++index < length) {
	        result = funcs[index].call(this, result);
	      }
	      return result;
	    };
	  });
	}
	
	module.exports = createFlow;


/***/ },
/* 423 */
/***/ function(module, exports, __webpack_require__) {

	var baseInverter = __webpack_require__(373);
	
	/**
	 * Creates a function like `_.invertBy`.
	 *
	 * @private
	 * @param {Function} setter The function to set accumulator values.
	 * @param {Function} toIteratee The function to resolve iteratees.
	 * @returns {Function} Returns the new inverter function.
	 */
	function createInverter(setter, toIteratee) {
	  return function(object, iteratee) {
	    return baseInverter(object, setter, toIteratee(iteratee), {});
	  };
	}
	
	module.exports = createInverter;


/***/ },
/* 424 */
/***/ function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(49),
	    createCtor = __webpack_require__(86),
	    root = __webpack_require__(15);
	
	/** Used to compose bitmasks for function metadata. */
	var WRAP_BIND_FLAG = 1;
	
	/**
	 * Creates a function that wraps `func` to invoke it with the `this` binding
	 * of `thisArg` and `partials` prepended to the arguments it receives.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} partials The arguments to prepend to those provided to
	 *  the new function.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createPartial(func, bitmask, thisArg, partials) {
	  var isBind = bitmask & WRAP_BIND_FLAG,
	      Ctor = createCtor(func);
	
	  function wrapper() {
	    var argsIndex = -1,
	        argsLength = arguments.length,
	        leftIndex = -1,
	        leftLength = partials.length,
	        args = Array(leftLength + argsLength),
	        fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	
	    while (++leftIndex < leftLength) {
	      args[leftIndex] = partials[leftIndex];
	    }
	    while (argsLength--) {
	      args[leftIndex++] = arguments[++argsIndex];
	    }
	    return apply(fn, isBind ? thisArg : this, args);
	  }
	  return wrapper;
	}
	
	module.exports = createPartial;


/***/ },
/* 425 */
/***/ function(module, exports, __webpack_require__) {

	var baseRange = __webpack_require__(390),
	    isIterateeCall = __webpack_require__(90),
	    toFinite = __webpack_require__(226);
	
	/**
	 * Creates a `_.range` or `_.rangeRight` function.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new range function.
	 */
	function createRange(fromRight) {
	  return function(start, end, step) {
	    if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
	      end = step = undefined;
	    }
	    // Ensure the sign of `-0` is preserved.
	    start = toFinite(start);
	    if (end === undefined) {
	      end = start;
	      start = 0;
	    } else {
	      end = toFinite(end);
	    }
	    step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
	    return baseRange(start, end, step, fromRight);
	  };
	}
	
	module.exports = createRange;


/***/ },
/* 426 */
/***/ function(module, exports, __webpack_require__) {

	var Set = __webpack_require__(175),
	    noop = __webpack_require__(223),
	    setToArray = __webpack_require__(92);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/**
	 * Creates a set object of `values`.
	 *
	 * @private
	 * @param {Array} values The values to add to the set.
	 * @returns {Object} Returns the new set.
	 */
	var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
	  return new Set(values);
	};
	
	module.exports = createSet;


/***/ },
/* 427 */
/***/ function(module, exports, __webpack_require__) {

	var baseToPairs = __webpack_require__(400),
	    getTag = __webpack_require__(89),
	    mapToArray = __webpack_require__(128),
	    setToPairs = __webpack_require__(470);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    setTag = '[object Set]';
	
	/**
	 * Creates a `_.toPairs` or `_.toPairsIn` function.
	 *
	 * @private
	 * @param {Function} keysFunc The function to get the keys of a given object.
	 * @returns {Function} Returns the new pairs function.
	 */
	function createToPairs(keysFunc) {
	  return function(object) {
	    var tag = getTag(object);
	    if (tag == mapTag) {
	      return mapToArray(object);
	    }
	    if (tag == setTag) {
	      return setToPairs(object);
	    }
	    return baseToPairs(object, keysFunc(object));
	  };
	}
	
	module.exports = createToPairs;


/***/ },
/* 428 */
/***/ function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(35);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
	 * of source objects to the destination object for all destination properties
	 * that resolve to `undefined`.
	 *
	 * @private
	 * @param {*} objValue The destination value.
	 * @param {*} srcValue The source value.
	 * @param {string} key The key of the property to assign.
	 * @param {Object} object The parent object of `objValue`.
	 * @returns {*} Returns the value to assign.
	 */
	function customDefaultsAssignIn(objValue, srcValue, key, object) {
	  if (objValue === undefined ||
	      (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	    return srcValue;
	  }
	  return objValue;
	}
	
	module.exports = customDefaultsAssignIn;


/***/ },
/* 429 */
/***/ function(module, exports, __webpack_require__) {

	var baseMerge = __webpack_require__(119),
	    isObject = __webpack_require__(10);
	
	/**
	 * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
	 * objects into destination objects that are passed thru.
	 *
	 * @private
	 * @param {*} objValue The destination value.
	 * @param {*} srcValue The source value.
	 * @param {string} key The key of the property to merge.
	 * @param {Object} object The parent object of `objValue`.
	 * @param {Object} source The parent object of `srcValue`.
	 * @param {Object} [stack] Tracks traversed source values and their merged
	 *  counterparts.
	 * @returns {*} Returns the value to assign.
	 */
	function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
	  if (isObject(objValue) && isObject(srcValue)) {
	    // Recursively merge objects and arrays (susceptible to call stack limits).
	    stack.set(srcValue, objValue);
	    baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
	    stack['delete'](srcValue);
	  }
	  return objValue;
	}
	
	module.exports = customDefaultsMerge;


/***/ },
/* 430 */
/***/ function(module, exports, __webpack_require__) {

	var isPlainObject = __webpack_require__(36);
	
	/**
	 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
	 * objects.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @param {string} key The key of the property to inspect.
	 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
	 */
	function customOmitClone(value) {
	  return isPlainObject(value) ? undefined : value;
	}
	
	module.exports = customOmitClone;


/***/ },
/* 431 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(39),
	    Uint8Array = __webpack_require__(176),
	    eq = __webpack_require__(35),
	    equalArrays = __webpack_require__(199),
	    mapToArray = __webpack_require__(128),
	    setToArray = __webpack_require__(92);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]';
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for comparing objects of
	 * the same `toStringTag`.
	 *
	 * **Note:** This function only supports comparing values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {string} tag The `toStringTag` of the objects to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	  switch (tag) {
	    case dataViewTag:
	      if ((object.byteLength != other.byteLength) ||
	          (object.byteOffset != other.byteOffset)) {
	        return false;
	      }
	      object = object.buffer;
	      other = other.buffer;
	
	    case arrayBufferTag:
	      if ((object.byteLength != other.byteLength) ||
	          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	        return false;
	      }
	      return true;
	
	    case boolTag:
	    case dateTag:
	    case numberTag:
	      // Coerce booleans to `1` or `0` and dates to milliseconds.
	      // Invalid dates are coerced to `NaN`.
	      return eq(+object, +other);
	
	    case errorTag:
	      return object.name == other.name && object.message == other.message;
	
	    case regexpTag:
	    case stringTag:
	      // Coerce regexes to strings and treat strings, primitives and objects,
	      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	      // for more details.
	      return object == (other + '');
	
	    case mapTag:
	      var convert = mapToArray;
	
	    case setTag:
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	      convert || (convert = setToArray);
	
	      if (object.size != other.size && !isPartial) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked) {
	        return stacked == other;
	      }
	      bitmask |= COMPARE_UNORDERED_FLAG;
	
	      // Recursively compare objects (susceptible to call stack limits).
	      stack.set(object, other);
	      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	      stack['delete'](object);
	      return result;
	
	    case symbolTag:
	      if (symbolValueOf) {
	        return symbolValueOf.call(object) == symbolValueOf.call(other);
	      }
	  }
	  return false;
	}
	
	module.exports = equalByTag;


/***/ },
/* 432 */
/***/ function(module, exports, __webpack_require__) {

	var getAllKeys = __webpack_require__(201);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for objects with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      objProps = getAllKeys(object),
	      objLength = objProps.length,
	      othProps = getAllKeys(other),
	      othLength = othProps.length;
	
	  if (objLength != othLength && !isPartial) {
	    return false;
	  }
	  var index = objLength;
	  while (index--) {
	    var key = objProps[index];
	    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	      return false;
	    }
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(object);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var result = true;
	  stack.set(object, other);
	  stack.set(other, object);
	
	  var skipCtor = isPartial;
	  while (++index < objLength) {
	    key = objProps[index];
	    var objValue = object[key],
	        othValue = other[key];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, objValue, key, other, object, stack)
	        : customizer(objValue, othValue, key, object, other, stack);
	    }
	    // Recursively compare objects (susceptible to call stack limits).
	    if (!(compared === undefined
	          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	          : compared
	        )) {
	      result = false;
	      break;
	    }
	    skipCtor || (skipCtor = key == 'constructor');
	  }
	  if (result && !skipCtor) {
	    var objCtor = object.constructor,
	        othCtor = other.constructor;
	
	    // Non `Object` object instances with different constructors are not equal.
	    if (objCtor != othCtor &&
	        ('constructor' in object && 'constructor' in other) &&
	        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	      result = false;
	    }
	  }
	  stack['delete'](object);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalObjects;


/***/ },
/* 433 */
/***/ function(module, exports, __webpack_require__) {

	var isStrictComparable = __webpack_require__(207),
	    keys = __webpack_require__(12);
	
	/**
	 * Gets the property names, values, and compare flags of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the match data of `object`.
	 */
	function getMatchData(object) {
	  var result = keys(object),
	      length = result.length;
	
	  while (length--) {
	    var key = result[length],
	        value = object[key];
	
	    result[length] = [key, value, isStrictComparable(value)];
	  }
	  return result;
	}
	
	module.exports = getMatchData;


/***/ },
/* 434 */
[627, 39],
/* 435 */
/***/ function(module, exports) {

	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	module.exports = getValue;


/***/ },
/* 436 */
/***/ function(module, exports) {

	/** Used to match wrap detail comments. */
	var reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
	    reSplitDetails = /,? & /;
	
	/**
	 * Extracts wrapper details from the `source` body comment.
	 *
	 * @private
	 * @param {string} source The source to inspect.
	 * @returns {Array} Returns the wrapper details.
	 */
	function getWrapDetails(source) {
	  var match = source.match(reWrapDetails);
	  return match ? match[1].split(reSplitDetails) : [];
	}
	
	module.exports = getWrapDetails;


/***/ },
/* 437 */
/***/ function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(41),
	    isArguments = __webpack_require__(54),
	    isArray = __webpack_require__(9),
	    isIndex = __webpack_require__(51),
	    isLength = __webpack_require__(132),
	    toKey = __webpack_require__(42);
	
	/**
	 * Checks if `path` exists on `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @param {Function} hasFunc The function to check properties.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 */
	function hasPath(object, path, hasFunc) {
	  path = castPath(path, object);
	
	  var index = -1,
	      length = path.length,
	      result = false;
	
	  while (++index < length) {
	    var key = toKey(path[index]);
	    if (!(result = object != null && hasFunc(object, key))) {
	      break;
	    }
	    object = object[key];
	  }
	  if (result || ++index != length) {
	    return result;
	  }
	  length = object == null ? 0 : object.length;
	  return !!length && isLength(length) && isIndex(key, length) &&
	    (isArray(object) || isArguments(object));
	}
	
	module.exports = hasPath;


/***/ },
/* 438 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(91);
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	  this.size = 0;
	}
	
	module.exports = hashClear;


/***/ },
/* 439 */
/***/ function(module, exports) {

	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  var result = this.has(key) && delete this.__data__[key];
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = hashDelete;


/***/ },
/* 440 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(91);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	module.exports = hashGet;


/***/ },
/* 441 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(91);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	}
	
	module.exports = hashHas;


/***/ },
/* 442 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(91);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  this.size += this.has(key) ? 0 : 1;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	module.exports = hashSet;


/***/ },
/* 443 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Initializes an array clone.
	 *
	 * @private
	 * @param {Array} array The array to clone.
	 * @returns {Array} Returns the initialized clone.
	 */
	function initCloneArray(array) {
	  var length = array.length,
	      result = array.constructor(length);
	
	  // Add properties assigned by `RegExp#exec`.
	  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	    result.index = array.index;
	    result.input = array.input;
	  }
	  return result;
	}
	
	module.exports = initCloneArray;


/***/ },
/* 444 */
/***/ function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(122),
	    cloneDataView = __webpack_require__(405),
	    cloneMap = __webpack_require__(406),
	    cloneRegExp = __webpack_require__(407),
	    cloneSet = __webpack_require__(408),
	    cloneSymbol = __webpack_require__(409),
	    cloneTypedArray = __webpack_require__(192);
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/**
	 * Initializes an object clone based on its `toStringTag`.
	 *
	 * **Note:** This function only supports cloning values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @param {string} tag The `toStringTag` of the object to clone.
	 * @param {Function} cloneFunc The function to clone values.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneByTag(object, tag, cloneFunc, isDeep) {
	  var Ctor = object.constructor;
	  switch (tag) {
	    case arrayBufferTag:
	      return cloneArrayBuffer(object);
	
	    case boolTag:
	    case dateTag:
	      return new Ctor(+object);
	
	    case dataViewTag:
	      return cloneDataView(object, isDeep);
	
	    case float32Tag: case float64Tag:
	    case int8Tag: case int16Tag: case int32Tag:
	    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	      return cloneTypedArray(object, isDeep);
	
	    case mapTag:
	      return cloneMap(object, isDeep, cloneFunc);
	
	    case numberTag:
	    case stringTag:
	      return new Ctor(object);
	
	    case regexpTag:
	      return cloneRegExp(object);
	
	    case setTag:
	      return cloneSet(object, isDeep, cloneFunc);
	
	    case symbolTag:
	      return cloneSymbol(object);
	  }
	}
	
	module.exports = initCloneByTag;


/***/ },
/* 445 */
/***/ function(module, exports) {

	/** Used to match wrap detail comments. */
	var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/;
	
	/**
	 * Inserts wrapper `details` in a comment at the top of the `source` body.
	 *
	 * @private
	 * @param {string} source The source to modify.
	 * @returns {Array} details The details to insert.
	 * @returns {string} Returns the modified source.
	 */
	function insertWrapDetails(source, details) {
	  var length = details.length;
	  if (!length) {
	    return source;
	  }
	  var lastIndex = length - 1;
	  details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
	  details = details.join(length > 2 ? ', ' : ' ');
	  return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
	}
	
	module.exports = insertWrapDetails;


/***/ },
/* 446 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(39),
	    isArguments = __webpack_require__(54),
	    isArray = __webpack_require__(9);
	
	/** Built-in value references. */
	var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;
	
	/**
	 * Checks if `value` is a flattenable `arguments` object or array.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	 */
	function isFlattenable(value) {
	  return isArray(value) || isArguments(value) ||
	    !!(spreadableSymbol && value && value[spreadableSymbol]);
	}
	
	module.exports = isFlattenable;


/***/ },
/* 447 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	module.exports = isKeyable;


/***/ },
/* 448 */
/***/ function(module, exports, __webpack_require__) {

	var coreJsData = __webpack_require__(414);
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	module.exports = isMasked;


/***/ },
/* 449 */
/***/ function(module, exports) {

	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	  this.size = 0;
	}
	
	module.exports = listCacheClear;


/***/ },
/* 450 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(80);
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype;
	
	/** Built-in value references. */
	var splice = arrayProto.splice;
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  --this.size;
	  return true;
	}
	
	module.exports = listCacheDelete;


/***/ },
/* 451 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(80);
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	module.exports = listCacheGet;


/***/ },
/* 452 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(80);
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	module.exports = listCacheHas;


/***/ },
/* 453 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(80);
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    ++this.size;
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	module.exports = listCacheSet;


/***/ },
/* 454 */
/***/ function(module, exports, __webpack_require__) {

	var Hash = __webpack_require__(361),
	    ListCache = __webpack_require__(77),
	    Map = __webpack_require__(110);
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.size = 0;
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	module.exports = mapCacheClear;


/***/ },
/* 455 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(88);
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  var result = getMapData(this, key)['delete'](key);
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = mapCacheDelete;


/***/ },
/* 456 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(88);
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	module.exports = mapCacheGet;


/***/ },
/* 457 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(88);
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	module.exports = mapCacheHas;


/***/ },
/* 458 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(88);
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  var data = getMapData(this, key),
	      size = data.size;
	
	  data.set(key, value);
	  this.size += data.size == size ? 0 : 1;
	  return this;
	}
	
	module.exports = mapCacheSet;


/***/ },
/* 459 */
/***/ function(module, exports, __webpack_require__) {

	var memoize = __webpack_require__(492);
	
	/** Used as the maximum memoize cache size. */
	var MAX_MEMOIZE_SIZE = 500;
	
	/**
	 * A specialized version of `_.memoize` which clears the memoized function's
	 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	 *
	 * @private
	 * @param {Function} func The function to have its output memoized.
	 * @returns {Function} Returns the new memoized function.
	 */
	function memoizeCapped(func) {
	  var result = memoize(func, function(key) {
	    if (cache.size === MAX_MEMOIZE_SIZE) {
	      cache.clear();
	    }
	    return key;
	  });
	
	  var cache = result.cache;
	  return result;
	}
	
	module.exports = memoizeCapped;


/***/ },
/* 460 */
/***/ function(module, exports, __webpack_require__) {

	var composeArgs = __webpack_require__(193),
	    composeArgsRight = __webpack_require__(194),
	    replaceHolders = __webpack_require__(53);
	
	/** Used as the internal argument placeholder. */
	var PLACEHOLDER = '__lodash_placeholder__';
	
	/** Used to compose bitmasks for function metadata. */
	var WRAP_BIND_FLAG = 1,
	    WRAP_BIND_KEY_FLAG = 2,
	    WRAP_CURRY_BOUND_FLAG = 4,
	    WRAP_CURRY_FLAG = 8,
	    WRAP_ARY_FLAG = 128,
	    WRAP_REARG_FLAG = 256;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMin = Math.min;
	
	/**
	 * Merges the function metadata of `source` into `data`.
	 *
	 * Merging metadata reduces the number of wrappers used to invoke a function.
	 * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
	 * may be applied regardless of execution order. Methods like `_.ary` and
	 * `_.rearg` modify function arguments, making the order in which they are
	 * executed important, preventing the merging of metadata. However, we make
	 * an exception for a safe combined case where curried functions have `_.ary`
	 * and or `_.rearg` applied.
	 *
	 * @private
	 * @param {Array} data The destination metadata.
	 * @param {Array} source The source metadata.
	 * @returns {Array} Returns `data`.
	 */
	function mergeData(data, source) {
	  var bitmask = data[1],
	      srcBitmask = source[1],
	      newBitmask = bitmask | srcBitmask,
	      isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
	
	  var isCombo =
	    ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
	    ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
	    ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));
	
	  // Exit early if metadata can't be merged.
	  if (!(isCommon || isCombo)) {
	    return data;
	  }
	  // Use source `thisArg` if available.
	  if (srcBitmask & WRAP_BIND_FLAG) {
	    data[2] = source[2];
	    // Set when currying a bound function.
	    newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
	  }
	  // Compose partial arguments.
	  var value = source[3];
	  if (value) {
	    var partials = data[3];
	    data[3] = partials ? composeArgs(partials, value, source[4]) : value;
	    data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
	  }
	  // Compose partial right arguments.
	  value = source[5];
	  if (value) {
	    partials = data[5];
	    data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
	    data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
	  }
	  // Use source `argPos` if available.
	  value = source[7];
	  if (value) {
	    data[7] = value;
	  }
	  // Use source `ary` if it's smaller.
	  if (srcBitmask & WRAP_ARY_FLAG) {
	    data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
	  }
	  // Use source `arity` if one is not provided.
	  if (data[9] == null) {
	    data[9] = source[9];
	  }
	  // Use source `func` and merge bitmasks.
	  data[0] = source[0];
	  data[1] = newBitmask;
	
	  return data;
	}
	
	module.exports = mergeData;


/***/ },
/* 461 */
/***/ function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(210);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys = overArg(Object.keys, Object);
	
	module.exports = nativeKeys;


/***/ },
/* 462 */
/***/ function(module, exports) {

	/**
	 * This function is like
	 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * except that it includes inherited enumerable properties.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function nativeKeysIn(object) {
	  var result = [];
	  if (object != null) {
	    for (var key in Object(object)) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = nativeKeysIn;


/***/ },
/* 463 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(200);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    return freeProcess && freeProcess.binding && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	module.exports = nodeUtil;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(99)(module)))

/***/ },
/* 464 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	module.exports = objectToString;


/***/ },
/* 465 */
/***/ function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(84),
	    baseSlice = __webpack_require__(394);
	
	/**
	 * Gets the parent value at `path` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array} path The path to get the parent value of.
	 * @returns {*} Returns the parent value.
	 */
	function parent(object, path) {
	  return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
	}
	
	module.exports = parent;


/***/ },
/* 466 */
/***/ function(module, exports) {

	/** Used to lookup unminified function names. */
	var realNames = {};
	
	module.exports = realNames;


/***/ },
/* 467 */
/***/ function(module, exports, __webpack_require__) {

	var copyArray = __webpack_require__(85),
	    isIndex = __webpack_require__(51);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMin = Math.min;
	
	/**
	 * Reorder `array` according to the specified indexes where the element at
	 * the first index is assigned as the first element, the element at
	 * the second index is assigned as the second element, and so on.
	 *
	 * @private
	 * @param {Array} array The array to reorder.
	 * @param {Array} indexes The arranged array indexes.
	 * @returns {Array} Returns `array`.
	 */
	function reorder(array, indexes) {
	  var arrLength = array.length,
	      length = nativeMin(indexes.length, arrLength),
	      oldArray = copyArray(array);
	
	  while (length--) {
	    var index = indexes[length];
	    array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
	  }
	  return array;
	}
	
	module.exports = reorder;


/***/ },
/* 468 */
/***/ function(module, exports) {

	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Adds `value` to the array cache.
	 *
	 * @private
	 * @name add
	 * @memberOf SetCache
	 * @alias push
	 * @param {*} value The value to cache.
	 * @returns {Object} Returns the cache instance.
	 */
	function setCacheAdd(value) {
	  this.__data__.set(value, HASH_UNDEFINED);
	  return this;
	}
	
	module.exports = setCacheAdd;


/***/ },
/* 469 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is in the array cache.
	 *
	 * @private
	 * @name has
	 * @memberOf SetCache
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `true` if `value` is found, else `false`.
	 */
	function setCacheHas(value) {
	  return this.__data__.has(value);
	}
	
	module.exports = setCacheHas;


/***/ },
/* 470 */
/***/ function(module, exports) {

	/**
	 * Converts `set` to its value-value pairs.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the value-value pairs.
	 */
	function setToPairs(set) {
	  var index = -1,
	      result = Array(set.size);
	
	  set.forEach(function(value) {
	    result[++index] = [value, value];
	  });
	  return result;
	}
	
	module.exports = setToPairs;


/***/ },
/* 471 */
/***/ function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(77);
	
	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	  this.size = 0;
	}
	
	module.exports = stackClear;


/***/ },
/* 472 */
/***/ function(module, exports) {

	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  var data = this.__data__,
	      result = data['delete'](key);
	
	  this.size = data.size;
	  return result;
	}
	
	module.exports = stackDelete;


/***/ },
/* 473 */
/***/ function(module, exports) {

	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}
	
	module.exports = stackGet;


/***/ },
/* 474 */
/***/ function(module, exports) {

	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}
	
	module.exports = stackHas;


/***/ },
/* 475 */
/***/ function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(77),
	    Map = __webpack_require__(110),
	    MapCache = __webpack_require__(111);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var data = this.__data__;
	  if (data instanceof ListCache) {
	    var pairs = data.__data__;
	    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      this.size = ++data.size;
	      return this;
	    }
	    data = this.__data__ = new MapCache(pairs);
	  }
	  data.set(key, value);
	  this.size = data.size;
	  return this;
	}
	
	module.exports = stackSet;


/***/ },
/* 476 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.indexOf` which performs strict equality
	 * comparisons of values, i.e. `===`.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function strictIndexOf(array, value, fromIndex) {
	  var index = fromIndex - 1,
	      length = array.length;
	
	  while (++index < length) {
	    if (array[index] === value) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = strictIndexOf;


/***/ },
/* 477 */
/***/ function(module, exports, __webpack_require__) {

	var memoizeCapped = __webpack_require__(459);
	
	/** Used to match property names within property paths. */
	var reLeadingDot = /^\./,
	    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	/** Used to match backslashes in property paths. */
	var reEscapeChar = /\\(\\)?/g;
	
	/**
	 * Converts `string` to a property path array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the property path array.
	 */
	var stringToPath = memoizeCapped(function(string) {
	  var result = [];
	  if (reLeadingDot.test(string)) {
	    result.push('');
	  }
	  string.replace(rePropName, function(match, number, quote, string) {
	    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
	  });
	  return result;
	});
	
	module.exports = stringToPath;


/***/ },
/* 478 */
/***/ function(module, exports, __webpack_require__) {

	var arrayEach = __webpack_require__(178),
	    arrayIncludes = __webpack_require__(113);
	
	/** Used to compose bitmasks for function metadata. */
	var WRAP_BIND_FLAG = 1,
	    WRAP_BIND_KEY_FLAG = 2,
	    WRAP_CURRY_FLAG = 8,
	    WRAP_CURRY_RIGHT_FLAG = 16,
	    WRAP_PARTIAL_FLAG = 32,
	    WRAP_PARTIAL_RIGHT_FLAG = 64,
	    WRAP_ARY_FLAG = 128,
	    WRAP_REARG_FLAG = 256,
	    WRAP_FLIP_FLAG = 512;
	
	/** Used to associate wrap methods with their bit flags. */
	var wrapFlags = [
	  ['ary', WRAP_ARY_FLAG],
	  ['bind', WRAP_BIND_FLAG],
	  ['bindKey', WRAP_BIND_KEY_FLAG],
	  ['curry', WRAP_CURRY_FLAG],
	  ['curryRight', WRAP_CURRY_RIGHT_FLAG],
	  ['flip', WRAP_FLIP_FLAG],
	  ['partial', WRAP_PARTIAL_FLAG],
	  ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
	  ['rearg', WRAP_REARG_FLAG]
	];
	
	/**
	 * Updates wrapper `details` based on `bitmask` flags.
	 *
	 * @private
	 * @returns {Array} details The details to modify.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @returns {Array} Returns `details`.
	 */
	function updateWrapDetails(details, bitmask) {
	  arrayEach(wrapFlags, function(pair) {
	    var value = '_.' + pair[0];
	    if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
	      details.push(value);
	    }
	  });
	  return details.sort();
	}
	
	module.exports = updateWrapDetails;


/***/ },
/* 479 */
/***/ function(module, exports, __webpack_require__) {

	var LazyWrapper = __webpack_require__(108),
	    LodashWrapper = __webpack_require__(109),
	    copyArray = __webpack_require__(85);
	
	/**
	 * Creates a clone of `wrapper`.
	 *
	 * @private
	 * @param {Object} wrapper The wrapper to clone.
	 * @returns {Object} Returns the cloned wrapper.
	 */
	function wrapperClone(wrapper) {
	  if (wrapper instanceof LazyWrapper) {
	    return wrapper.clone();
	  }
	  var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
	  result.__actions__ = copyArray(wrapper.__actions__);
	  result.__index__  = wrapper.__index__;
	  result.__values__ = wrapper.__values__;
	  return result;
	}
	
	module.exports = wrapperClone;


/***/ },
/* 480 */
/***/ function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(29),
	    createAssigner = __webpack_require__(50),
	    keysIn = __webpack_require__(44);
	
	/**
	 * This method is like `_.assign` except that it iterates over own and
	 * inherited source properties.
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @alias extend
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @returns {Object} Returns `object`.
	 * @see _.assign
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * function Bar() {
	 *   this.c = 3;
	 * }
	 *
	 * Foo.prototype.b = 2;
	 * Bar.prototype.d = 4;
	 *
	 * _.assignIn({ 'a': 0 }, new Foo, new Bar);
	 * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
	 */
	var assignIn = createAssigner(function(object, source) {
	  copyObject(source, keysIn(source), object);
	});
	
	module.exports = assignIn;


/***/ },
/* 481 */
/***/ function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(29),
	    createAssigner = __webpack_require__(50),
	    keysIn = __webpack_require__(44);
	
	/**
	 * This method is like `_.assignIn` except that it accepts `customizer`
	 * which is invoked to produce the assigned values. If `customizer` returns
	 * `undefined`, assignment is handled by the method instead. The `customizer`
	 * is invoked with five arguments: (objValue, srcValue, key, object, source).
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @alias extendWith
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} sources The source objects.
	 * @param {Function} [customizer] The function to customize assigned values.
	 * @returns {Object} Returns `object`.
	 * @see _.assignWith
	 * @example
	 *
	 * function customizer(objValue, srcValue) {
	 *   return _.isUndefined(objValue) ? srcValue : objValue;
	 * }
	 *
	 * var defaults = _.partialRight(_.assignInWith, customizer);
	 *
	 * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	 * // => { 'a': 1, 'b': 2 }
	 */
	var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
	  copyObject(source, keysIn(source), object, customizer);
	});
	
	module.exports = assignInWith;


/***/ },
/* 482 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(10),
	    now = __webpack_require__(494),
	    toNumber = __webpack_require__(227);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max,
	    nativeMin = Math.min;
	
	/**
	 * Creates a debounced function that delays invoking `func` until after `wait`
	 * milliseconds have elapsed since the last time the debounced function was
	 * invoked. The debounced function comes with a `cancel` method to cancel
	 * delayed `func` invocations and a `flush` method to immediately invoke them.
	 * Provide `options` to indicate whether `func` should be invoked on the
	 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	 * with the last arguments provided to the debounced function. Subsequent
	 * calls to the debounced function return the result of the last `func`
	 * invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the debounced function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.debounce` and `_.throttle`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to debounce.
	 * @param {number} [wait=0] The number of milliseconds to delay.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=false]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {number} [options.maxWait]
	 *  The maximum time `func` is allowed to be delayed before it's invoked.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new debounced function.
	 * @example
	 *
	 * // Avoid costly calculations while the window size is in flux.
	 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	 *
	 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	 * jQuery(element).on('click', _.debounce(sendMail, 300, {
	 *   'leading': true,
	 *   'trailing': false
	 * }));
	 *
	 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	 * var source = new EventSource('/stream');
	 * jQuery(source).on('message', debounced);
	 *
	 * // Cancel the trailing debounced invocation.
	 * jQuery(window).on('popstate', debounced.cancel);
	 */
	function debounce(func, wait, options) {
	  var lastArgs,
	      lastThis,
	      maxWait,
	      result,
	      timerId,
	      lastCallTime,
	      lastInvokeTime = 0,
	      leading = false,
	      maxing = false,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  wait = toNumber(wait) || 0;
	  if (isObject(options)) {
	    leading = !!options.leading;
	    maxing = 'maxWait' in options;
	    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	
	  function invokeFunc(time) {
	    var args = lastArgs,
	        thisArg = lastThis;
	
	    lastArgs = lastThis = undefined;
	    lastInvokeTime = time;
	    result = func.apply(thisArg, args);
	    return result;
	  }
	
	  function leadingEdge(time) {
	    // Reset any `maxWait` timer.
	    lastInvokeTime = time;
	    // Start the timer for the trailing edge.
	    timerId = setTimeout(timerExpired, wait);
	    // Invoke the leading edge.
	    return leading ? invokeFunc(time) : result;
	  }
	
	  function remainingWait(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime,
	        result = wait - timeSinceLastCall;
	
	    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
	  }
	
	  function shouldInvoke(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime;
	
	    // Either this is the first call, activity has stopped and we're at the
	    // trailing edge, the system time has gone backwards and we're treating
	    // it as the trailing edge, or we've hit the `maxWait` limit.
	    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	  }
	
	  function timerExpired() {
	    var time = now();
	    if (shouldInvoke(time)) {
	      return trailingEdge(time);
	    }
	    // Restart the timer.
	    timerId = setTimeout(timerExpired, remainingWait(time));
	  }
	
	  function trailingEdge(time) {
	    timerId = undefined;
	
	    // Only invoke if we have `lastArgs` which means `func` has been
	    // debounced at least once.
	    if (trailing && lastArgs) {
	      return invokeFunc(time);
	    }
	    lastArgs = lastThis = undefined;
	    return result;
	  }
	
	  function cancel() {
	    if (timerId !== undefined) {
	      clearTimeout(timerId);
	    }
	    lastInvokeTime = 0;
	    lastArgs = lastCallTime = lastThis = timerId = undefined;
	  }
	
	  function flush() {
	    return timerId === undefined ? result : trailingEdge(now());
	  }
	
	  function debounced() {
	    var time = now(),
	        isInvoking = shouldInvoke(time);
	
	    lastArgs = arguments;
	    lastThis = this;
	    lastCallTime = time;
	
	    if (isInvoking) {
	      if (timerId === undefined) {
	        return leadingEdge(lastCallTime);
	      }
	      if (maxing) {
	        // Handle invocations in a tight loop.
	        timerId = setTimeout(timerExpired, wait);
	        return invokeFunc(lastCallTime);
	      }
	    }
	    if (timerId === undefined) {
	      timerId = setTimeout(timerExpired, wait);
	    }
	    return result;
	  }
	  debounced.cancel = cancel;
	  debounced.flush = flush;
	  return debounced;
	}
	
	module.exports = debounce;


/***/ },
/* 483 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(480);


/***/ },
/* 484 */
/***/ function(module, exports, __webpack_require__) {

	var createFind = __webpack_require__(421),
	    findIndex = __webpack_require__(485);
	
	/**
	 * Iterates over elements of `collection`, returning the first element
	 * `predicate` returns truthy for. The predicate is invoked with three
	 * arguments: (value, index|key, collection).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to inspect.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @param {number} [fromIndex=0] The index to search from.
	 * @returns {*} Returns the matched element, else `undefined`.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney',  'age': 36, 'active': true },
	 *   { 'user': 'fred',    'age': 40, 'active': false },
	 *   { 'user': 'pebbles', 'age': 1,  'active': true }
	 * ];
	 *
	 * _.find(users, function(o) { return o.age < 40; });
	 * // => object for 'barney'
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.find(users, { 'age': 1, 'active': true });
	 * // => object for 'pebbles'
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.find(users, ['active', false]);
	 * // => object for 'fred'
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.find(users, 'active');
	 * // => object for 'barney'
	 */
	var find = createFind(findIndex);
	
	module.exports = find;


/***/ },
/* 485 */
/***/ function(module, exports, __webpack_require__) {

	var baseFindIndex = __webpack_require__(183),
	    baseIteratee = __webpack_require__(32),
	    toInteger = __webpack_require__(135);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * This method is like `_.find` except that it returns the index of the first
	 * element `predicate` returns truthy for instead of the element itself.
	 *
	 * @static
	 * @memberOf _
	 * @since 1.1.0
	 * @category Array
	 * @param {Array} array The array to inspect.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @param {number} [fromIndex=0] The index to search from.
	 * @returns {number} Returns the index of the found element, else `-1`.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney',  'active': false },
	 *   { 'user': 'fred',    'active': false },
	 *   { 'user': 'pebbles', 'active': true }
	 * ];
	 *
	 * _.findIndex(users, function(o) { return o.user == 'barney'; });
	 * // => 0
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.findIndex(users, { 'user': 'fred', 'active': false });
	 * // => 1
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.findIndex(users, ['active', false]);
	 * // => 0
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.findIndex(users, 'active');
	 * // => 2
	 */
	function findIndex(array, predicate, fromIndex) {
	  var length = array == null ? 0 : array.length;
	  if (!length) {
	    return -1;
	  }
	  var index = fromIndex == null ? 0 : toInteger(fromIndex);
	  if (index < 0) {
	    index = nativeMax(length + index, 0);
	  }
	  return baseFindIndex(array, baseIteratee(predicate, 3), index);
	}
	
	module.exports = findIndex;


/***/ },
/* 486 */
/***/ function(module, exports, __webpack_require__) {

	var createFlow = __webpack_require__(422);
	
	/**
	 * Creates a function that returns the result of invoking the given functions
	 * with the `this` binding of the created function, where each successive
	 * invocation is supplied the return value of the previous.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Util
	 * @param {...(Function|Function[])} [funcs] The functions to invoke.
	 * @returns {Function} Returns the new composite function.
	 * @see _.flowRight
	 * @example
	 *
	 * function square(n) {
	 *   return n * n;
	 * }
	 *
	 * var addSquare = _.flow([_.add, square]);
	 * addSquare(1, 2);
	 * // => 9
	 */
	var flow = createFlow();
	
	module.exports = flow;


/***/ },
/* 487 */
/***/ function(module, exports, __webpack_require__) {

	var baseForOwn = __webpack_require__(116),
	    castFunction = __webpack_require__(404);
	
	/**
	 * Iterates over own enumerable string keyed properties of an object and
	 * invokes `iteratee` for each property. The iteratee is invoked with three
	 * arguments: (value, key, object). Iteratee functions may exit iteration
	 * early by explicitly returning `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.3.0
	 * @category Object
	 * @param {Object} object The object to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 * @see _.forOwnRight
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.forOwn(new Foo, function(value, key) {
	 *   console.log(key);
	 * });
	 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	 */
	function forOwn(object, iteratee) {
	  return object && baseForOwn(object, castFunction(iteratee));
	}
	
	module.exports = forOwn;


/***/ },
/* 488 */
/***/ function(module, exports) {

	/**
	 * The inverse of `_.toPairs`; this method returns an object composed
	 * from key-value `pairs`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Array
	 * @param {Array} pairs The key-value pairs.
	 * @returns {Object} Returns the new object.
	 * @example
	 *
	 * _.fromPairs([['a', 1], ['b', 2]]);
	 * // => { 'a': 1, 'b': 2 }
	 */
	function fromPairs(pairs) {
	  var index = -1,
	      length = pairs == null ? 0 : pairs.length,
	      result = {};
	
	  while (++index < length) {
	    var pair = pairs[index];
	    result[pair[0]] = pair[1];
	  }
	  return result;
	}
	
	module.exports = fromPairs;


/***/ },
/* 489 */
/***/ function(module, exports, __webpack_require__) {

	var constant = __webpack_require__(216),
	    createInverter = __webpack_require__(423),
	    identity = __webpack_require__(22);
	
	/**
	 * Creates an object composed of the inverted keys and values of `object`.
	 * If `object` contains duplicate values, subsequent values overwrite
	 * property assignments of previous values.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.7.0
	 * @category Object
	 * @param {Object} object The object to invert.
	 * @returns {Object} Returns the new inverted object.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2, 'c': 1 };
	 *
	 * _.invert(object);
	 * // => { '1': 'c', '2': 'b' }
	 */
	var invert = createInverter(function(result, value, key) {
	  result[value] = key;
	}, constant(identity));
	
	module.exports = invert;


/***/ },
/* 490 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(30),
	    isArray = __webpack_require__(9),
	    isObjectLike = __webpack_require__(24);
	
	/** `Object#toString` result references. */
	var stringTag = '[object String]';
	
	/**
	 * Checks if `value` is classified as a `String` primitive or object.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
	 * @example
	 *
	 * _.isString('abc');
	 * // => true
	 *
	 * _.isString(1);
	 * // => false
	 */
	function isString(value) {
	  return typeof value == 'string' ||
	    (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
	}
	
	module.exports = isString;


/***/ },
/* 491 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is `undefined`.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
	 * @example
	 *
	 * _.isUndefined(void 0);
	 * // => true
	 *
	 * _.isUndefined(null);
	 * // => false
	 */
	function isUndefined(value) {
	  return value === undefined;
	}
	
	module.exports = isUndefined;


/***/ },
/* 492 */
/***/ function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(111);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a function that memoizes the result of `func`. If `resolver` is
	 * provided, it determines the cache key for storing the result based on the
	 * arguments provided to the memoized function. By default, the first argument
	 * provided to the memoized function is used as the map cache key. The `func`
	 * is invoked with the `this` binding of the memoized function.
	 *
	 * **Note:** The cache is exposed as the `cache` property on the memoized
	 * function. Its creation may be customized by replacing the `_.memoize.Cache`
	 * constructor with one whose instances implement the
	 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to have its output memoized.
	 * @param {Function} [resolver] The function to resolve the cache key.
	 * @returns {Function} Returns the new memoized function.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2 };
	 * var other = { 'c': 3, 'd': 4 };
	 *
	 * var values = _.memoize(_.values);
	 * values(object);
	 * // => [1, 2]
	 *
	 * values(other);
	 * // => [3, 4]
	 *
	 * object.a = 2;
	 * values(object);
	 * // => [1, 2]
	 *
	 * // Modify the result cache.
	 * values.cache.set(object, ['a', 'b']);
	 * values(object);
	 * // => ['a', 'b']
	 *
	 * // Replace `_.memoize.Cache`.
	 * _.memoize.Cache = WeakMap;
	 */
	function memoize(func, resolver) {
	  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var memoized = function() {
	    var args = arguments,
	        key = resolver ? resolver.apply(this, args) : args[0],
	        cache = memoized.cache;
	
	    if (cache.has(key)) {
	      return cache.get(key);
	    }
	    var result = func.apply(this, args);
	    memoized.cache = cache.set(key, result) || cache;
	    return result;
	  };
	  memoized.cache = new (memoize.Cache || MapCache);
	  return memoized;
	}
	
	// Expose `MapCache`.
	memoize.Cache = MapCache;
	
	module.exports = memoize;


/***/ },
/* 493 */
/***/ function(module, exports, __webpack_require__) {

	var baseMerge = __webpack_require__(119),
	    createAssigner = __webpack_require__(50);
	
	/**
	 * This method is like `_.merge` except that it accepts `customizer` which
	 * is invoked to produce the merged values of the destination and source
	 * properties. If `customizer` returns `undefined`, merging is handled by the
	 * method instead. The `customizer` is invoked with six arguments:
	 * (objValue, srcValue, key, object, source, stack).
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} sources The source objects.
	 * @param {Function} customizer The function to customize assigned values.
	 * @returns {Object} Returns `object`.
	 * @example
	 *
	 * function customizer(objValue, srcValue) {
	 *   if (_.isArray(objValue)) {
	 *     return objValue.concat(srcValue);
	 *   }
	 * }
	 *
	 * var object = { 'a': [1], 'b': [2] };
	 * var other = { 'a': [3], 'b': [4] };
	 *
	 * _.mergeWith(object, other, customizer);
	 * // => { 'a': [1, 3], 'b': [2, 4] }
	 */
	var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
	  baseMerge(object, source, srcIndex, customizer);
	});
	
	module.exports = mergeWith;


/***/ },
/* 494 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(15);
	
	/**
	 * Gets the timestamp of the number of milliseconds that have elapsed since
	 * the Unix epoch (1 January 1970 00:00:00 UTC).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Date
	 * @returns {number} Returns the timestamp.
	 * @example
	 *
	 * _.defer(function(stamp) {
	 *   console.log(_.now() - stamp);
	 * }, _.now());
	 * // => Logs the number of milliseconds it took for the deferred invocation.
	 */
	var now = function() {
	  return root.Date.now();
	};
	
	module.exports = now;


/***/ },
/* 495 */
/***/ function(module, exports, __webpack_require__) {

	var baseRest = __webpack_require__(33),
	    createWrap = __webpack_require__(197),
	    getHolder = __webpack_require__(87),
	    replaceHolders = __webpack_require__(53);
	
	/** Used to compose bitmasks for function metadata. */
	var WRAP_PARTIAL_FLAG = 32;
	
	/**
	 * Creates a function that invokes `func` with `partials` prepended to the
	 * arguments it receives. This method is like `_.bind` except it does **not**
	 * alter the `this` binding.
	 *
	 * The `_.partial.placeholder` value, which defaults to `_` in monolithic
	 * builds, may be used as a placeholder for partially applied arguments.
	 *
	 * **Note:** This method doesn't set the "length" property of partially
	 * applied functions.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.2.0
	 * @category Function
	 * @param {Function} func The function to partially apply arguments to.
	 * @param {...*} [partials] The arguments to be partially applied.
	 * @returns {Function} Returns the new partially applied function.
	 * @example
	 *
	 * function greet(greeting, name) {
	 *   return greeting + ' ' + name;
	 * }
	 *
	 * var sayHelloTo = _.partial(greet, 'hello');
	 * sayHelloTo('fred');
	 * // => 'hello fred'
	 *
	 * // Partially applied with placeholders.
	 * var greetFred = _.partial(greet, _, 'fred');
	 * greetFred('hi');
	 * // => 'hi fred'
	 */
	var partial = baseRest(function(func, partials) {
	  var holders = replaceHolders(partials, getHolder(partial));
	  return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
	});
	
	// Assign default placeholders.
	partial.placeholder = {};
	
	module.exports = partial;


/***/ },
/* 496 */
/***/ function(module, exports, __webpack_require__) {

	var arrayReduce = __webpack_require__(115),
	    baseEach = __webpack_require__(83),
	    baseIteratee = __webpack_require__(32),
	    baseReduce = __webpack_require__(391),
	    isArray = __webpack_require__(9);
	
	/**
	 * Reduces `collection` to a value which is the accumulated result of running
	 * each element in `collection` thru `iteratee`, where each successive
	 * invocation is supplied the return value of the previous. If `accumulator`
	 * is not given, the first element of `collection` is used as the initial
	 * value. The iteratee is invoked with four arguments:
	 * (accumulator, value, index|key, collection).
	 *
	 * Many lodash methods are guarded to work as iteratees for methods like
	 * `_.reduce`, `_.reduceRight`, and `_.transform`.
	 *
	 * The guarded methods are:
	 * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
	 * and `sortBy`
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @param {*} [accumulator] The initial value.
	 * @returns {*} Returns the accumulated value.
	 * @see _.reduceRight
	 * @example
	 *
	 * _.reduce([1, 2], function(sum, n) {
	 *   return sum + n;
	 * }, 0);
	 * // => 3
	 *
	 * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	 *   (result[value] || (result[value] = [])).push(key);
	 *   return result;
	 * }, {});
	 * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
	 */
	function reduce(collection, iteratee, accumulator) {
	  var func = isArray(collection) ? arrayReduce : baseReduce,
	      initAccum = arguments.length < 3;
	
	  return func(collection, baseIteratee(iteratee, 4), accumulator, initAccum, baseEach);
	}
	
	module.exports = reduce;


/***/ },
/* 497 */
/***/ function(module, exports, __webpack_require__) {

	var arraySome = __webpack_require__(181),
	    baseIteratee = __webpack_require__(32),
	    baseSome = __webpack_require__(395),
	    isArray = __webpack_require__(9),
	    isIterateeCall = __webpack_require__(90);
	
	/**
	 * Checks if `predicate` returns truthy for **any** element of `collection`.
	 * Iteration is stopped once `predicate` returns truthy. The predicate is
	 * invoked with three arguments: (value, index|key, collection).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 * @example
	 *
	 * _.some([null, 0, 'yes', false], Boolean);
	 * // => true
	 *
	 * var users = [
	 *   { 'user': 'barney', 'active': true },
	 *   { 'user': 'fred',   'active': false }
	 * ];
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.some(users, { 'user': 'barney', 'active': false });
	 * // => false
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.some(users, ['active', false]);
	 * // => true
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.some(users, 'active');
	 * // => true
	 */
	function some(collection, predicate, guard) {
	  var func = isArray(collection) ? arraySome : baseSome;
	  if (guard && isIterateeCall(collection, predicate, guard)) {
	    predicate = undefined;
	  }
	  return func(collection, baseIteratee(predicate, 3));
	}
	
	module.exports = some;


/***/ },
/* 498 */
/***/ function(module, exports, __webpack_require__) {

	var baseSortedUniq = __webpack_require__(397);
	
	/**
	 * This method is like `_.uniq` except that it's designed and optimized
	 * for sorted arrays.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Array
	 * @param {Array} array The array to inspect.
	 * @returns {Array} Returns the new duplicate free array.
	 * @example
	 *
	 * _.sortedUniq([1, 1, 2]);
	 * // => [1, 2]
	 */
	function sortedUniq(array) {
	  return (array && array.length)
	    ? baseSortedUniq(array)
	    : [];
	}
	
	module.exports = sortedUniq;


/***/ },
/* 499 */
/***/ function(module, exports) {

	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}
	
	module.exports = stubFalse;


/***/ },
/* 500 */
/***/ function(module, exports, __webpack_require__) {

	var baseSum = __webpack_require__(398),
	    identity = __webpack_require__(22);
	
	/**
	 * Computes the sum of the values in `array`.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.4.0
	 * @category Math
	 * @param {Array} array The array to iterate over.
	 * @returns {number} Returns the sum.
	 * @example
	 *
	 * _.sum([4, 2, 8, 6]);
	 * // => 20
	 */
	function sum(array) {
	  return (array && array.length)
	    ? baseSum(array, identity)
	    : 0;
	}
	
	module.exports = sum;


/***/ },
/* 501 */
/***/ function(module, exports, __webpack_require__) {

	var createToPairs = __webpack_require__(427),
	    keys = __webpack_require__(12);
	
	/**
	 * Creates an array of own enumerable string keyed-value pairs for `object`
	 * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
	 * entries are returned.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @alias entries
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the key-value pairs.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.toPairs(new Foo);
	 * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
	 */
	var toPairs = createToPairs(keys);
	
	module.exports = toPairs;


/***/ },
/* 502 */
/***/ function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(29),
	    keysIn = __webpack_require__(44);
	
	/**
	 * Converts `value` to a plain object flattening inherited enumerable string
	 * keyed properties of `value` to own properties of the plain object.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {Object} Returns the converted plain object.
	 * @example
	 *
	 * function Foo() {
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.assign({ 'a': 1 }, new Foo);
	 * // => { 'a': 1, 'b': 2 }
	 *
	 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	 * // => { 'a': 1, 'b': 2, 'c': 3 }
	 */
	function toPlainObject(value) {
	  return copyObject(value, keysIn(value));
	}
	
	module.exports = toPlainObject;


/***/ },
/* 503 */
/***/ function(module, exports, __webpack_require__) {

	var baseIteratee = __webpack_require__(32),
	    baseUniq = __webpack_require__(190);
	
	/**
	 * This method is like `_.uniq` except that it accepts `iteratee` which is
	 * invoked for each element in `array` to generate the criterion by which
	 * uniqueness is computed. The order of result values is determined by the
	 * order they occur in the array. The iteratee is invoked with one argument:
	 * (value).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Array
	 * @param {Array} array The array to inspect.
	 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	 * @returns {Array} Returns the new duplicate free array.
	 * @example
	 *
	 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
	 * // => [2.1, 1.2]
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
	 * // => [{ 'x': 1 }, { 'x': 2 }]
	 */
	function uniqBy(array, iteratee) {
	  return (array && array.length) ? baseUniq(array, baseIteratee(iteratee, 2)) : [];
	}
	
	module.exports = uniqBy;


/***/ },
/* 504 */
/***/ function(module, exports, __webpack_require__) {

	var LazyWrapper = __webpack_require__(108),
	    LodashWrapper = __webpack_require__(109),
	    baseLodash = __webpack_require__(118),
	    isArray = __webpack_require__(9),
	    isObjectLike = __webpack_require__(24),
	    wrapperClone = __webpack_require__(479);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates a `lodash` object which wraps `value` to enable implicit method
	 * chain sequences. Methods that operate on and return arrays, collections,
	 * and functions can be chained together. Methods that retrieve a single value
	 * or may return a primitive value will automatically end the chain sequence
	 * and return the unwrapped value. Otherwise, the value must be unwrapped
	 * with `_#value`.
	 *
	 * Explicit chain sequences, which must be unwrapped with `_#value`, may be
	 * enabled using `_.chain`.
	 *
	 * The execution of chained methods is lazy, that is, it's deferred until
	 * `_#value` is implicitly or explicitly called.
	 *
	 * Lazy evaluation allows several methods to support shortcut fusion.
	 * Shortcut fusion is an optimization to merge iteratee calls; this avoids
	 * the creation of intermediate arrays and can greatly reduce the number of
	 * iteratee executions. Sections of a chain sequence qualify for shortcut
	 * fusion if the section is applied to an array and iteratees accept only
	 * one argument. The heuristic for whether a section qualifies for shortcut
	 * fusion is subject to change.
	 *
	 * Chaining is supported in custom builds as long as the `_#value` method is
	 * directly or indirectly included in the build.
	 *
	 * In addition to lodash methods, wrappers have `Array` and `String` methods.
	 *
	 * The wrapper `Array` methods are:
	 * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
	 *
	 * The wrapper `String` methods are:
	 * `replace` and `split`
	 *
	 * The wrapper methods that support shortcut fusion are:
	 * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
	 * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
	 * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
	 *
	 * The chainable wrapper methods are:
	 * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
	 * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
	 * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
	 * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
	 * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
	 * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
	 * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
	 * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
	 * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
	 * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
	 * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
	 * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
	 * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
	 * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
	 * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
	 * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
	 * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
	 * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
	 * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
	 * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
	 * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
	 * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
	 * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
	 * `zipObject`, `zipObjectDeep`, and `zipWith`
	 *
	 * The wrapper methods that are **not** chainable by default are:
	 * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
	 * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
	 * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
	 * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
	 * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
	 * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
	 * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
	 * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
	 * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
	 * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
	 * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
	 * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
	 * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
	 * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
	 * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
	 * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
	 * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
	 * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
	 * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
	 * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
	 * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
	 * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
	 * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
	 * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
	 * `upperFirst`, `value`, and `words`
	 *
	 * @name _
	 * @constructor
	 * @category Seq
	 * @param {*} value The value to wrap in a `lodash` instance.
	 * @returns {Object} Returns the new `lodash` wrapper instance.
	 * @example
	 *
	 * function square(n) {
	 *   return n * n;
	 * }
	 *
	 * var wrapped = _([1, 2, 3]);
	 *
	 * // Returns an unwrapped value.
	 * wrapped.reduce(_.add);
	 * // => 6
	 *
	 * // Returns a wrapped value.
	 * var squares = wrapped.map(square);
	 *
	 * _.isArray(squares);
	 * // => false
	 *
	 * _.isArray(squares.value());
	 * // => true
	 */
	function lodash(value) {
	  if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
	    if (value instanceof LodashWrapper) {
	      return value;
	    }
	    if (hasOwnProperty.call(value, '__wrapped__')) {
	      return wrapperClone(value);
	    }
	  }
	  return new LodashWrapper(value);
	}
	
	// Ensure wrappers are instances of `baseLodash`.
	lodash.prototype = baseLodash.prototype;
	lodash.prototype.constructor = lodash;
	
	module.exports = lodash;


/***/ },
/* 505 */
/***/ function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ },
/* 506 */
/***/ function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ },
/* 507 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	//This file contains the ES6 extensions to the core Promises/A+ API
	
	var Promise = __webpack_require__(228);
	
	module.exports = Promise;
	
	/* Static Functions */
	
	var TRUE = valuePromise(true);
	var FALSE = valuePromise(false);
	var NULL = valuePromise(null);
	var UNDEFINED = valuePromise(undefined);
	var ZERO = valuePromise(0);
	var EMPTYSTRING = valuePromise('');
	
	function valuePromise(value) {
	  var p = new Promise(Promise._61);
	  p._81 = 1;
	  p._65 = value;
	  return p;
	}
	Promise.resolve = function (value) {
	  if (value instanceof Promise) return value;
	
	  if (value === null) return NULL;
	  if (value === undefined) return UNDEFINED;
	  if (value === true) return TRUE;
	  if (value === false) return FALSE;
	  if (value === 0) return ZERO;
	  if (value === '') return EMPTYSTRING;
	
	  if (typeof value === 'object' || typeof value === 'function') {
	    try {
	      var then = value.then;
	      if (typeof then === 'function') {
	        return new Promise(then.bind(value));
	      }
	    } catch (ex) {
	      return new Promise(function (resolve, reject) {
	        reject(ex);
	      });
	    }
	  }
	  return valuePromise(value);
	};
	
	Promise.all = function (arr) {
	  var args = Array.prototype.slice.call(arr);
	
	  return new Promise(function (resolve, reject) {
	    if (args.length === 0) return resolve([]);
	    var remaining = args.length;
	    function res(i, val) {
	      if (val && (typeof val === 'object' || typeof val === 'function')) {
	        if (val instanceof Promise && val.then === Promise.prototype.then) {
	          while (val._81 === 3) {
	            val = val._65;
	          }
	          if (val._81 === 1) return res(i, val._65);
	          if (val._81 === 2) reject(val._65);
	          val.then(function (val) {
	            res(i, val);
	          }, reject);
	          return;
	        } else {
	          var then = val.then;
	          if (typeof then === 'function') {
	            var p = new Promise(then.bind(val));
	            p.then(function (val) {
	              res(i, val);
	            }, reject);
	            return;
	          }
	        }
	      }
	      args[i] = val;
	      if (--remaining === 0) {
	        resolve(args);
	      }
	    }
	    for (var i = 0; i < args.length; i++) {
	      res(i, args[i]);
	    }
	  });
	};
	
	Promise.reject = function (value) {
	  return new Promise(function (resolve, reject) {
	    reject(value);
	  });
	};
	
	Promise.race = function (values) {
	  return new Promise(function (resolve, reject) {
	    values.forEach(function(value){
	      Promise.resolve(value).then(resolve, reject);
	    });
	  });
	};
	
	/* Prototype Methods */
	
	Promise.prototype['catch'] = function (onRejected) {
	  return this.then(null, onRejected);
	};


/***/ },
/* 508 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Promise = __webpack_require__(228);
	
	var DEFAULT_WHITELIST = [
	  ReferenceError,
	  TypeError,
	  RangeError
	];
	
	var enabled = false;
	exports.disable = disable;
	function disable() {
	  enabled = false;
	  Promise._10 = null;
	  Promise._97 = null;
	}
	
	exports.enable = enable;
	function enable(options) {
	  options = options || {};
	  if (enabled) disable();
	  enabled = true;
	  var id = 0;
	  var displayId = 0;
	  var rejections = {};
	  Promise._10 = function (promise) {
	    if (
	      promise._81 === 2 && // IS REJECTED
	      rejections[promise._72]
	    ) {
	      if (rejections[promise._72].logged) {
	        onHandled(promise._72);
	      } else {
	        clearTimeout(rejections[promise._72].timeout);
	      }
	      delete rejections[promise._72];
	    }
	  };
	  Promise._97 = function (promise, err) {
	    if (promise._45 === 0) { // not yet handled
	      promise._72 = id++;
	      rejections[promise._72] = {
	        displayId: null,
	        error: err,
	        timeout: setTimeout(
	          onUnhandled.bind(null, promise._72),
	          // For reference errors and type errors, this almost always
	          // means the programmer made a mistake, so log them after just
	          // 100ms
	          // otherwise, wait 2 seconds to see if they get handled
	          matchWhitelist(err, DEFAULT_WHITELIST)
	            ? 100
	            : 2000
	        ),
	        logged: false
	      };
	    }
	  };
	  function onUnhandled(id) {
	    if (
	      options.allRejections ||
	      matchWhitelist(
	        rejections[id].error,
	        options.whitelist || DEFAULT_WHITELIST
	      )
	    ) {
	      rejections[id].displayId = displayId++;
	      if (options.onUnhandled) {
	        rejections[id].logged = true;
	        options.onUnhandled(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      } else {
	        rejections[id].logged = true;
	        logError(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      }
	    }
	  }
	  function onHandled(id) {
	    if (rejections[id].logged) {
	      if (options.onHandled) {
	        options.onHandled(rejections[id].displayId, rejections[id].error);
	      } else if (!rejections[id].onUnhandled) {
	        console.warn(
	          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
	        );
	        console.warn(
	          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
	          rejections[id].displayId + '.'
	        );
	      }
	    }
	  }
	}
	
	function logError(id, error) {
	  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
	  var errStr = (error && (error.stack || error)) + '';
	  errStr.split('\n').forEach(function (line) {
	    console.warn('  ' + line);
	  });
	}
	
	function matchWhitelist(error, list) {
	  return list.some(function (cls) {
	    return error instanceof cls;
	  });
	}

/***/ },
/* 509 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(347);
	var invariant = __webpack_require__(348);
	var ReactPropTypesSecret = __webpack_require__(510);
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    invariant(
	      false,
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim
	  };
	
	  ReactPropTypes.checkPropTypes = emptyFunction;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ },
/* 510 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ },
/* 511 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(230);
	
	var has = Object.prototype.hasOwnProperty;
	
	var defaults = {
	    allowDots: false,
	    allowPrototypes: false,
	    arrayLimit: 20,
	    decoder: utils.decode,
	    delimiter: '&',
	    depth: 5,
	    parameterLimit: 1000,
	    plainObjects: false,
	    strictNullHandling: false
	};
	
	var parseValues = function parseQueryStringValues(str, options) {
	    var obj = {};
	    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
	    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
	    var parts = cleanStr.split(options.delimiter, limit);
	
	    for (var i = 0; i < parts.length; ++i) {
	        var part = parts[i];
	
	        var bracketEqualsPos = part.indexOf(']=');
	        var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;
	
	        var key, val;
	        if (pos === -1) {
	            key = options.decoder(part, defaults.decoder);
	            val = options.strictNullHandling ? null : '';
	        } else {
	            key = options.decoder(part.slice(0, pos), defaults.decoder);
	            val = options.decoder(part.slice(pos + 1), defaults.decoder);
	        }
	        if (has.call(obj, key)) {
	            obj[key] = [].concat(obj[key]).concat(val);
	        } else {
	            obj[key] = val;
	        }
	    }
	
	    return obj;
	};
	
	var parseObject = function (chain, val, options) {
	    var leaf = val;
	
	    for (var i = chain.length - 1; i >= 0; --i) {
	        var obj;
	        var root = chain[i];
	
	        if (root === '[]') {
	            obj = [];
	            obj = obj.concat(leaf);
	        } else {
	            obj = options.plainObjects ? Object.create(null) : {};
	            var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
	            var index = parseInt(cleanRoot, 10);
	            if (
	                !isNaN(index)
	                && root !== cleanRoot
	                && String(index) === cleanRoot
	                && index >= 0
	                && (options.parseArrays && index <= options.arrayLimit)
	            ) {
	                obj = [];
	                obj[index] = leaf;
	            } else {
	                obj[cleanRoot] = leaf;
	            }
	        }
	
	        leaf = obj;
	    }
	
	    return leaf;
	};
	
	var parseKeys = function parseQueryStringKeys(givenKey, val, options) {
	    if (!givenKey) {
	        return;
	    }
	
	    // Transform dot notation to bracket notation
	    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey;
	
	    // The regex chunks
	
	    var brackets = /(\[[^[\]]*])/;
	    var child = /(\[[^[\]]*])/g;
	
	    // Get the parent
	
	    var segment = brackets.exec(key);
	    var parent = segment ? key.slice(0, segment.index) : key;
	
	    // Stash the parent if it exists
	
	    var keys = [];
	    if (parent) {
	        // If we aren't using plain objects, optionally prefix keys
	        // that would overwrite object prototype properties
	        if (!options.plainObjects && has.call(Object.prototype, parent)) {
	            if (!options.allowPrototypes) {
	                return;
	            }
	        }
	
	        keys.push(parent);
	    }
	
	    // Loop through children appending to the array until we hit depth
	
	    var i = 0;
	    while ((segment = child.exec(key)) !== null && i < options.depth) {
	        i += 1;
	        if (!options.plainObjects && has.call(Object.prototype, segment[1].slice(1, -1))) {
	            if (!options.allowPrototypes) {
	                return;
	            }
	        }
	        keys.push(segment[1]);
	    }
	
	    // If there's a remainder, just add whatever is left
	
	    if (segment) {
	        keys.push('[' + key.slice(segment.index) + ']');
	    }
	
	    return parseObject(keys, val, options);
	};
	
	module.exports = function (str, opts) {
	    var options = opts ? utils.assign({}, opts) : {};
	
	    if (options.decoder !== null && options.decoder !== undefined && typeof options.decoder !== 'function') {
	        throw new TypeError('Decoder has to be a function.');
	    }
	
	    options.ignoreQueryPrefix = options.ignoreQueryPrefix === true;
	    options.delimiter = typeof options.delimiter === 'string' || utils.isRegExp(options.delimiter) ? options.delimiter : defaults.delimiter;
	    options.depth = typeof options.depth === 'number' ? options.depth : defaults.depth;
	    options.arrayLimit = typeof options.arrayLimit === 'number' ? options.arrayLimit : defaults.arrayLimit;
	    options.parseArrays = options.parseArrays !== false;
	    options.decoder = typeof options.decoder === 'function' ? options.decoder : defaults.decoder;
	    options.allowDots = typeof options.allowDots === 'boolean' ? options.allowDots : defaults.allowDots;
	    options.plainObjects = typeof options.plainObjects === 'boolean' ? options.plainObjects : defaults.plainObjects;
	    options.allowPrototypes = typeof options.allowPrototypes === 'boolean' ? options.allowPrototypes : defaults.allowPrototypes;
	    options.parameterLimit = typeof options.parameterLimit === 'number' ? options.parameterLimit : defaults.parameterLimit;
	    options.strictNullHandling = typeof options.strictNullHandling === 'boolean' ? options.strictNullHandling : defaults.strictNullHandling;
	
	    if (str === '' || str === null || typeof str === 'undefined') {
	        return options.plainObjects ? Object.create(null) : {};
	    }
	
	    var tempObj = typeof str === 'string' ? parseValues(str, options) : str;
	    var obj = options.plainObjects ? Object.create(null) : {};
	
	    // Iterate over the keys and setup the new object
	
	    var keys = Object.keys(tempObj);
	    for (var i = 0; i < keys.length; ++i) {
	        var key = keys[i];
	        var newObj = parseKeys(key, tempObj[key], options);
	        obj = utils.merge(obj, newObj, options);
	    }
	
	    return utils.compact(obj);
	};


/***/ },
/* 512 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(230);
	var formats = __webpack_require__(229);
	
	var arrayPrefixGenerators = {
	    brackets: function brackets(prefix) { // eslint-disable-line func-name-matching
	        return prefix + '[]';
	    },
	    indices: function indices(prefix, key) { // eslint-disable-line func-name-matching
	        return prefix + '[' + key + ']';
	    },
	    repeat: function repeat(prefix) { // eslint-disable-line func-name-matching
	        return prefix;
	    }
	};
	
	var toISO = Date.prototype.toISOString;
	
	var defaults = {
	    delimiter: '&',
	    encode: true,
	    encoder: utils.encode,
	    encodeValuesOnly: false,
	    serializeDate: function serializeDate(date) { // eslint-disable-line func-name-matching
	        return toISO.call(date);
	    },
	    skipNulls: false,
	    strictNullHandling: false
	};
	
	var stringify = function stringify( // eslint-disable-line func-name-matching
	    object,
	    prefix,
	    generateArrayPrefix,
	    strictNullHandling,
	    skipNulls,
	    encoder,
	    filter,
	    sort,
	    allowDots,
	    serializeDate,
	    formatter,
	    encodeValuesOnly
	) {
	    var obj = object;
	    if (typeof filter === 'function') {
	        obj = filter(prefix, obj);
	    } else if (obj instanceof Date) {
	        obj = serializeDate(obj);
	    } else if (obj === null) {
	        if (strictNullHandling) {
	            return encoder && !encodeValuesOnly ? encoder(prefix, defaults.encoder) : prefix;
	        }
	
	        obj = '';
	    }
	
	    if (typeof obj === 'string' || typeof obj === 'number' || typeof obj === 'boolean' || utils.isBuffer(obj)) {
	        if (encoder) {
	            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, defaults.encoder);
	            return [formatter(keyValue) + '=' + formatter(encoder(obj, defaults.encoder))];
	        }
	        return [formatter(prefix) + '=' + formatter(String(obj))];
	    }
	
	    var values = [];
	
	    if (typeof obj === 'undefined') {
	        return values;
	    }
	
	    var objKeys;
	    if (Array.isArray(filter)) {
	        objKeys = filter;
	    } else {
	        var keys = Object.keys(obj);
	        objKeys = sort ? keys.sort(sort) : keys;
	    }
	
	    for (var i = 0; i < objKeys.length; ++i) {
	        var key = objKeys[i];
	
	        if (skipNulls && obj[key] === null) {
	            continue;
	        }
	
	        if (Array.isArray(obj)) {
	            values = values.concat(stringify(
	                obj[key],
	                generateArrayPrefix(prefix, key),
	                generateArrayPrefix,
	                strictNullHandling,
	                skipNulls,
	                encoder,
	                filter,
	                sort,
	                allowDots,
	                serializeDate,
	                formatter,
	                encodeValuesOnly
	            ));
	        } else {
	            values = values.concat(stringify(
	                obj[key],
	                prefix + (allowDots ? '.' + key : '[' + key + ']'),
	                generateArrayPrefix,
	                strictNullHandling,
	                skipNulls,
	                encoder,
	                filter,
	                sort,
	                allowDots,
	                serializeDate,
	                formatter,
	                encodeValuesOnly
	            ));
	        }
	    }
	
	    return values;
	};
	
	module.exports = function (object, opts) {
	    var obj = object;
	    var options = opts ? utils.assign({}, opts) : {};
	
	    if (options.encoder !== null && options.encoder !== undefined && typeof options.encoder !== 'function') {
	        throw new TypeError('Encoder has to be a function.');
	    }
	
	    var delimiter = typeof options.delimiter === 'undefined' ? defaults.delimiter : options.delimiter;
	    var strictNullHandling = typeof options.strictNullHandling === 'boolean' ? options.strictNullHandling : defaults.strictNullHandling;
	    var skipNulls = typeof options.skipNulls === 'boolean' ? options.skipNulls : defaults.skipNulls;
	    var encode = typeof options.encode === 'boolean' ? options.encode : defaults.encode;
	    var encoder = typeof options.encoder === 'function' ? options.encoder : defaults.encoder;
	    var sort = typeof options.sort === 'function' ? options.sort : null;
	    var allowDots = typeof options.allowDots === 'undefined' ? false : options.allowDots;
	    var serializeDate = typeof options.serializeDate === 'function' ? options.serializeDate : defaults.serializeDate;
	    var encodeValuesOnly = typeof options.encodeValuesOnly === 'boolean' ? options.encodeValuesOnly : defaults.encodeValuesOnly;
	    if (typeof options.format === 'undefined') {
	        options.format = formats['default'];
	    } else if (!Object.prototype.hasOwnProperty.call(formats.formatters, options.format)) {
	        throw new TypeError('Unknown format option provided.');
	    }
	    var formatter = formats.formatters[options.format];
	    var objKeys;
	    var filter;
	
	    if (typeof options.filter === 'function') {
	        filter = options.filter;
	        obj = filter('', obj);
	    } else if (Array.isArray(options.filter)) {
	        filter = options.filter;
	        objKeys = filter;
	    }
	
	    var keys = [];
	
	    if (typeof obj !== 'object' || obj === null) {
	        return '';
	    }
	
	    var arrayFormat;
	    if (options.arrayFormat in arrayPrefixGenerators) {
	        arrayFormat = options.arrayFormat;
	    } else if ('indices' in options) {
	        arrayFormat = options.indices ? 'indices' : 'repeat';
	    } else {
	        arrayFormat = 'indices';
	    }
	
	    var generateArrayPrefix = arrayPrefixGenerators[arrayFormat];
	
	    if (!objKeys) {
	        objKeys = Object.keys(obj);
	    }
	
	    if (sort) {
	        objKeys.sort(sort);
	    }
	
	    for (var i = 0; i < objKeys.length; ++i) {
	        var key = objKeys[i];
	
	        if (skipNulls && obj[key] === null) {
	            continue;
	        }
	
	        keys = keys.concat(stringify(
	            obj[key],
	            key,
	            generateArrayPrefix,
	            strictNullHandling,
	            skipNulls,
	            encode ? encoder : null,
	            filter,
	            sort,
	            allowDots,
	            serializeDate,
	            formatter,
	            encodeValuesOnly
	        ));
	    }
	
	    var joined = keys.join(delimiter);
	    var prefix = options.addQueryPrefix === true ? '?' : '';
	
	    return joined.length > 0 ? prefix + joined : '';
	};


/***/ },
/* 513 */
/***/ function(module, exports, __webpack_require__) {

	/** @license React v16.1.0
	 * react-dom.production.min.js
	 *
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	/*
	 Modernizr 3.0.0pre (Custom Build) | MIT
	*/
	'use strict';var aa=__webpack_require__(1),m=__webpack_require__(516),A=__webpack_require__(524),B=__webpack_require__(231),ca=__webpack_require__(515),da=__webpack_require__(520),ea=__webpack_require__(523),ha=__webpack_require__(517),ia=__webpack_require__(519),C=__webpack_require__(518);
	function D(a){for(var b=arguments.length-1,c="Minified React error #"+a+"; visit http://facebook.github.io/react/docs/error-decoder.html?invariant\x3d"+a,d=0;d<b;d++)c+="\x26args[]\x3d"+encodeURIComponent(arguments[d+1]);b=Error(c+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings.");b.name="Invariant Violation";b.framesToPop=1;throw b;}aa?void 0:D("227");
	var la={children:!0,dangerouslySetInnerHTML:!0,defaultValue:!0,defaultChecked:!0,innerHTML:!0,suppressContentEditableWarning:!0,suppressHydrationWarning:!0,style:!0};function qa(a,b){return(a&b)===b}
	var ra={MUST_USE_PROPERTY:1,HAS_BOOLEAN_VALUE:4,HAS_NUMERIC_VALUE:8,HAS_POSITIVE_NUMERIC_VALUE:24,HAS_OVERLOADED_BOOLEAN_VALUE:32,HAS_STRING_BOOLEAN_VALUE:64,injectDOMPropertyConfig:function(a){var b=ra,c=a.Properties||{},d=a.DOMAttributeNamespaces||{},e=a.DOMAttributeNames||{};a=a.DOMMutationMethods||{};for(var f in c){sa.hasOwnProperty(f)?D("48",f):void 0;var g=f.toLowerCase(),k=c[f];g={attributeName:g,attributeNamespace:null,propertyName:f,mutationMethod:null,mustUseProperty:qa(k,b.MUST_USE_PROPERTY),
	hasBooleanValue:qa(k,b.HAS_BOOLEAN_VALUE),hasNumericValue:qa(k,b.HAS_NUMERIC_VALUE),hasPositiveNumericValue:qa(k,b.HAS_POSITIVE_NUMERIC_VALUE),hasOverloadedBooleanValue:qa(k,b.HAS_OVERLOADED_BOOLEAN_VALUE),hasStringBooleanValue:qa(k,b.HAS_STRING_BOOLEAN_VALUE)};1>=g.hasBooleanValue+g.hasNumericValue+g.hasOverloadedBooleanValue?void 0:D("50",f);e.hasOwnProperty(f)&&(g.attributeName=e[f]);d.hasOwnProperty(f)&&(g.attributeNamespace=d[f]);a.hasOwnProperty(f)&&(g.mutationMethod=a[f]);sa[f]=g}}},sa={};
	function ta(a,b){if(la.hasOwnProperty(a)||2<a.length&&("o"===a[0]||"O"===a[0])&&("n"===a[1]||"N"===a[1]))return!1;if(null===b)return!0;switch(typeof b){case "boolean":return la.hasOwnProperty(a)?a=!0:(b=ua(a))?a=b.hasBooleanValue||b.hasStringBooleanValue||b.hasOverloadedBooleanValue:(a=a.toLowerCase().slice(0,5),a="data-"===a||"aria-"===a),a;case "undefined":case "number":case "string":case "object":return!0;default:return!1}}function ua(a){return sa.hasOwnProperty(a)?sa[a]:null}
	var va=ra,wa=va.MUST_USE_PROPERTY,H=va.HAS_BOOLEAN_VALUE,xa=va.HAS_NUMERIC_VALUE,ya=va.HAS_POSITIVE_NUMERIC_VALUE,za=va.HAS_STRING_BOOLEAN_VALUE,Aa={Properties:{allowFullScreen:H,autoFocus:za,async:H,autoPlay:H,capture:H,checked:wa|H,cols:ya,contentEditable:za,controls:H,"default":H,defer:H,disabled:H,download:va.HAS_OVERLOADED_BOOLEAN_VALUE,draggable:za,formNoValidate:H,hidden:H,loop:H,multiple:wa|H,muted:wa|H,noValidate:H,open:H,playsInline:H,readOnly:H,required:H,reversed:H,rows:ya,rowSpan:xa,
	scoped:H,seamless:H,selected:wa|H,size:ya,start:xa,span:ya,spellCheck:za,style:0,tabIndex:0,itemScope:H,acceptCharset:0,className:0,htmlFor:0,httpEquiv:0,value:za},DOMAttributeNames:{acceptCharset:"accept-charset",className:"class",htmlFor:"for",httpEquiv:"http-equiv"},DOMMutationMethods:{value:function(a,b){if(null==b)return a.removeAttribute("value");"number"!==a.type||!1===a.hasAttribute("value")?a.setAttribute("value",""+b):a.validity&&!a.validity.badInput&&a.ownerDocument.activeElement!==a&&
	a.setAttribute("value",""+b)}}},Ba=va.HAS_STRING_BOOLEAN_VALUE,K={xlink:"http://www.w3.org/1999/xlink",xml:"http://www.w3.org/XML/1998/namespace"},Ca={Properties:{autoReverse:Ba,externalResourcesRequired:Ba,preserveAlpha:Ba},DOMAttributeNames:{autoReverse:"autoReverse",externalResourcesRequired:"externalResourcesRequired",preserveAlpha:"preserveAlpha"},DOMAttributeNamespaces:{xlinkActuate:K.xlink,xlinkArcrole:K.xlink,xlinkHref:K.xlink,xlinkRole:K.xlink,xlinkShow:K.xlink,xlinkTitle:K.xlink,xlinkType:K.xlink,
	xmlBase:K.xml,xmlLang:K.xml,xmlSpace:K.xml}},Da=/[\-\:]([a-z])/g;function Ea(a){return a[1].toUpperCase()}
	"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode x-height xlink:actuate xlink:arcrole xlink:href xlink:role xlink:show xlink:title xlink:type xml:base xmlns:xlink xml:lang xml:space".split(" ").forEach(function(a){var b=a.replace(Da,
	Ea);Ca.Properties[b]=0;Ca.DOMAttributeNames[b]=a});va.injectDOMPropertyConfig(Aa);va.injectDOMPropertyConfig(Ca);
	var N={_caughtError:null,_hasCaughtError:!1,_rethrowError:null,_hasRethrowError:!1,injection:{injectErrorUtils:function(a){"function"!==typeof a.invokeGuardedCallback?D("197"):void 0;Ha=a.invokeGuardedCallback}},invokeGuardedCallback:function(a,b,c,d,e,f,g,k,h){Ha.apply(N,arguments)},invokeGuardedCallbackAndCatchFirstError:function(a,b,c,d,e,f,g,k,h){N.invokeGuardedCallback.apply(this,arguments);if(N.hasCaughtError()){var r=N.clearCaughtError();N._hasRethrowError||(N._hasRethrowError=!0,N._rethrowError=
	r)}},rethrowCaughtError:function(){return Ia.apply(N,arguments)},hasCaughtError:function(){return N._hasCaughtError},clearCaughtError:function(){if(N._hasCaughtError){var a=N._caughtError;N._caughtError=null;N._hasCaughtError=!1;return a}D("198")}};function Ha(a,b,c,d,e,f,g,k,h){N._hasCaughtError=!1;N._caughtError=null;var r=Array.prototype.slice.call(arguments,3);try{b.apply(c,r)}catch(n){N._caughtError=n,N._hasCaughtError=!0}}
	function Ia(){if(N._hasRethrowError){var a=N._rethrowError;N._rethrowError=null;N._hasRethrowError=!1;throw a;}}var Ja=null,Ka={};
	function La(){if(Ja)for(var a in Ka){var b=Ka[a],c=Ja.indexOf(a);-1<c?void 0:D("96",a);if(!Ma[c]){b.extractEvents?void 0:D("97",a);Ma[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,k=d;Na.hasOwnProperty(k)?D("99",k):void 0;Na[k]=f;var h=f.phasedRegistrationNames;if(h){for(e in h)h.hasOwnProperty(e)&&Oa(h[e],g,k);e=!0}else f.registrationName?(Oa(f.registrationName,g,k),e=!0):e=!1;e?void 0:D("98",d,a)}}}}
	function Oa(a,b,c){Pa[a]?D("100",a):void 0;Pa[a]=b;Qa[a]=b.eventTypes[c].dependencies}var Ma=[],Na={},Pa={},Qa={};function Ra(a){Ja?D("101"):void 0;Ja=Array.prototype.slice.call(a);La()}function Sa(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];Ka.hasOwnProperty(c)&&Ka[c]===d||(Ka[c]?D("102",c):void 0,Ka[c]=d,b=!0)}b&&La()}
	var Ta=Object.freeze({plugins:Ma,eventNameDispatchConfigs:Na,registrationNameModules:Pa,registrationNameDependencies:Qa,possibleRegistrationNames:null,injectEventPluginOrder:Ra,injectEventPluginsByName:Sa}),Ua=null,Va=null,Wa=null;function Xa(a,b,c,d){b=a.type||"unknown-event";a.currentTarget=Wa(d);N.invokeGuardedCallbackAndCatchFirstError(b,c,void 0,a);a.currentTarget=null}
	function Ya(a,b){null==b?D("30"):void 0;if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}function Za(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var $a=null;
	function ab(a,b){if(a){var c=a._dispatchListeners,d=a._dispatchInstances;if(Array.isArray(c))for(var e=0;e<c.length&&!a.isPropagationStopped();e++)Xa(a,b,c[e],d[e]);else c&&Xa(a,b,c,d);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function bb(a){return ab(a,!0)}function cb(a){return ab(a,!1)}var db={injectEventPluginOrder:Ra,injectEventPluginsByName:Sa};
	function eb(a,b){var c=a.stateNode;if(!c)return null;var d=Ua(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;c&&"function"!==typeof c?D("231",b,typeof c):void 0;
	return c}function jb(a,b,c,d){for(var e,f=0;f<Ma.length;f++){var g=Ma[f];g&&(g=g.extractEvents(a,b,c,d))&&(e=Ya(e,g))}return e}function kb(a){a&&($a=Ya($a,a))}function lb(a){var b=$a;$a=null;a?Za(b,bb):Za(b,cb);$a?D("95"):void 0;N.rethrowCaughtError()}var mb=Object.freeze({injection:db,getListener:eb,extractEvents:jb,enqueueEvents:kb,processEventQueue:lb}),nb=Math.random().toString(36).slice(2),O="__reactInternalInstance$"+nb,ob="__reactEventHandlers$"+nb;
	function pb(a){if(a[O])return a[O];for(var b=[];!a[O];)if(b.push(a),a.parentNode)a=a.parentNode;else return null;var c=void 0,d=a[O];if(5===d.tag||6===d.tag)return d;for(;a&&(d=a[O]);a=b.pop())c=d;return c}function qb(a){if(5===a.tag||6===a.tag)return a.stateNode;D("33")}function rb(a){return a[ob]||null}
	var sb=Object.freeze({precacheFiberNode:function(a,b){b[O]=a},getClosestInstanceFromNode:pb,getInstanceFromNode:function(a){a=a[O];return!a||5!==a.tag&&6!==a.tag?null:a},getNodeFromInstance:qb,getFiberCurrentPropsFromNode:rb,updateFiberProps:function(a,b){a[ob]=b}});function Q(a){do a=a["return"];while(a&&5!==a.tag);return a?a:null}function tb(a,b,c){for(var d=[];a;)d.push(a),a=Q(a);for(a=d.length;0<a--;)b(d[a],"captured",c);for(a=0;a<d.length;a++)b(d[a],"bubbled",c)}
	function ub(a,b,c){if(b=eb(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=Ya(c._dispatchListeners,b),c._dispatchInstances=Ya(c._dispatchInstances,a)}function vb(a){a&&a.dispatchConfig.phasedRegistrationNames&&tb(a._targetInst,ub,a)}function wb(a){if(a&&a.dispatchConfig.phasedRegistrationNames){var b=a._targetInst;b=b?Q(b):null;tb(b,ub,a)}}
	function xb(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=eb(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=Ya(c._dispatchListeners,b),c._dispatchInstances=Ya(c._dispatchInstances,a))}function yb(a){a&&a.dispatchConfig.registrationName&&xb(a._targetInst,null,a)}function zb(a){Za(a,vb)}
	function Ab(a,b,c,d){if(c&&d)a:{var e=c;for(var f=d,g=0,k=e;k;k=Q(k))g++;k=0;for(var h=f;h;h=Q(h))k++;for(;0<g-k;)e=Q(e),g--;for(;0<k-g;)f=Q(f),k--;for(;g--;){if(e===f||e===f.alternate)break a;e=Q(e);f=Q(f)}e=null}else e=null;f=e;for(e=[];c&&c!==f;){g=c.alternate;if(null!==g&&g===f)break;e.push(c);c=Q(c)}for(c=[];d&&d!==f;){g=d.alternate;if(null!==g&&g===f)break;c.push(d);d=Q(d)}for(d=0;d<e.length;d++)xb(e[d],"bubbled",a);for(a=c.length;0<a--;)xb(c[a],"captured",b)}
	var Bb=Object.freeze({accumulateTwoPhaseDispatches:zb,accumulateTwoPhaseDispatchesSkipTarget:function(a){Za(a,wb)},accumulateEnterLeaveDispatches:Ab,accumulateDirectDispatches:function(a){Za(a,yb)}}),Cb=null;function Db(){!Cb&&m.canUseDOM&&(Cb="textContent"in document.documentElement?"textContent":"innerText");return Cb}var R={_root:null,_startText:null,_fallbackText:null};
	function Eb(){if(R._fallbackText)return R._fallbackText;var a,b=R._startText,c=b.length,d,e=Fb(),f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);R._fallbackText=e.slice(a,1<d?1-d:void 0);return R._fallbackText}function Fb(){return"value"in R._root?R._root.value:R._root[Db()]}
	var Gb="dispatchConfig _targetInst nativeEvent isDefaultPrevented isPropagationStopped _dispatchListeners _dispatchInstances".split(" "),Hb={type:null,target:null,currentTarget:B.thatReturnsNull,eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
	function S(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?B.thatReturnsTrue:B.thatReturnsFalse;this.isPropagationStopped=B.thatReturnsFalse;return this}
	A(S.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=B.thatReturnsTrue)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=B.thatReturnsTrue)},persist:function(){this.isPersistent=B.thatReturnsTrue},isPersistent:B.thatReturnsFalse,
	destructor:function(){var a=this.constructor.Interface,b;for(b in a)this[b]=null;for(a=0;a<Gb.length;a++)this[Gb[a]]=null}});S.Interface=Hb;S.augmentClass=function(a,b){function c(){}c.prototype=this.prototype;var d=new c;A(d,a.prototype);a.prototype=d;a.prototype.constructor=a;a.Interface=A({},this.Interface,b);a.augmentClass=this.augmentClass;Ib(a)};Ib(S);function Jb(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}
	function Qb(a){a instanceof this?void 0:D("223");a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function Ib(a){a.eventPool=[];a.getPooled=Jb;a.release=Qb}function Rb(a,b,c,d){return S.call(this,a,b,c,d)}S.augmentClass(Rb,{data:null});function Sb(a,b,c,d){return S.call(this,a,b,c,d)}S.augmentClass(Sb,{data:null});var Tb=[9,13,27,32],Ub=m.canUseDOM&&"CompositionEvent"in window,Vb=null;m.canUseDOM&&"documentMode"in document&&(Vb=document.documentMode);var Wb;
	if(Wb=m.canUseDOM&&"TextEvent"in window&&!Vb){var Xb=window.opera;Wb=!("object"===typeof Xb&&"function"===typeof Xb.version&&12>=parseInt(Xb.version(),10))}
	var Yb=Wb,Zb=m.canUseDOM&&(!Ub||Vb&&8<Vb&&11>=Vb),$b=String.fromCharCode(32),ac={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["topCompositionEnd","topKeyPress","topTextInput","topPaste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"topBlur topCompositionEnd topKeyDown topKeyPress topKeyUp topMouseDown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
	captured:"onCompositionStartCapture"},dependencies:"topBlur topCompositionStart topKeyDown topKeyPress topKeyUp topMouseDown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"topBlur topCompositionUpdate topKeyDown topKeyPress topKeyUp topMouseDown".split(" ")}},bc=!1;
	function cc(a,b){switch(a){case "topKeyUp":return-1!==Tb.indexOf(b.keyCode);case "topKeyDown":return 229!==b.keyCode;case "topKeyPress":case "topMouseDown":case "topBlur":return!0;default:return!1}}function dc(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var ec=!1;function fc(a,b){switch(a){case "topCompositionEnd":return dc(b);case "topKeyPress":if(32!==b.which)return null;bc=!0;return $b;case "topTextInput":return a=b.data,a===$b&&bc?null:a;default:return null}}
	function gc(a,b){if(ec)return"topCompositionEnd"===a||!Ub&&cc(a,b)?(a=Eb(),R._root=null,R._startText=null,R._fallbackText=null,ec=!1,a):null;switch(a){case "topPaste":return null;case "topKeyPress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "topCompositionEnd":return Zb?null:b.data;default:return null}}
	var hc={eventTypes:ac,extractEvents:function(a,b,c,d){var e;if(Ub)b:{switch(a){case "topCompositionStart":var f=ac.compositionStart;break b;case "topCompositionEnd":f=ac.compositionEnd;break b;case "topCompositionUpdate":f=ac.compositionUpdate;break b}f=void 0}else ec?cc(a,c)&&(f=ac.compositionEnd):"topKeyDown"===a&&229===c.keyCode&&(f=ac.compositionStart);f?(Zb&&(ec||f!==ac.compositionStart?f===ac.compositionEnd&&ec&&(e=Eb()):(R._root=d,R._startText=Fb(),ec=!0)),f=Rb.getPooled(f,b,c,d),e?f.data=
	e:(e=dc(c),null!==e&&(f.data=e)),zb(f),e=f):e=null;(a=Yb?fc(a,c):gc(a,c))?(b=Sb.getPooled(ac.beforeInput,b,c,d),b.data=a,zb(b)):b=null;return[e,b]}},ic=null,jc=null,kc=null;function lc(a){if(a=Va(a)){ic&&"function"===typeof ic.restoreControlledState?void 0:D("194");var b=Ua(a.stateNode);ic.restoreControlledState(a.stateNode,a.type,b)}}var mc={injectFiberControlledHostComponent:function(a){ic=a}};function nc(a){jc?kc?kc.push(a):kc=[a]:jc=a}
	function oc(){if(jc){var a=jc,b=kc;kc=jc=null;lc(a);if(b)for(a=0;a<b.length;a++)lc(b[a])}}var pc=Object.freeze({injection:mc,enqueueStateRestore:nc,restoreStateIfNeeded:oc});function qc(a,b){return a(b)}var rc=!1;function sc(a,b){if(rc)return qc(a,b);rc=!0;try{return qc(a,b)}finally{rc=!1,oc()}}var tc={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};
	function uc(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!tc[a.type]:"textarea"===b?!0:!1}function vc(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}var wc;m.canUseDOM&&(wc=document.implementation&&document.implementation.hasFeature&&!0!==document.implementation.hasFeature("",""));
	function xc(a,b){if(!m.canUseDOM||b&&!("addEventListener"in document))return!1;b="on"+a;var c=b in document;c||(c=document.createElement("div"),c.setAttribute(b,"return;"),c="function"===typeof c[b]);!c&&wc&&"wheel"===a&&(c=document.implementation.hasFeature("Events.wheel","3.0"));return c}function yc(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
	function zc(a){var b=yc(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"function"===typeof c.get&&"function"===typeof c.set)return Object.defineProperty(a,b,{enumerable:c.enumerable,configurable:!0,get:function(){return c.get.call(this)},set:function(a){d=""+a;c.set.call(this,a)}}),{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=null;delete a[b]}}}
	function Ac(a){a._valueTracker||(a._valueTracker=zc(a))}function Bc(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=yc(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}var Cc={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"topBlur topChange topClick topFocus topInput topKeyDown topKeyUp topSelectionChange".split(" ")}};
	function Dc(a,b,c){a=S.getPooled(Cc.change,a,b,c);a.type="change";nc(c);zb(a);return a}var Ec=null,Fc=null;function Gc(a){kb(a);lb(!1)}function Hc(a){var b=qb(a);if(Bc(b))return a}function Ic(a,b){if("topChange"===a)return b}var Jc=!1;m.canUseDOM&&(Jc=xc("input")&&(!document.documentMode||9<document.documentMode));function Qc(){Ec&&(Ec.detachEvent("onpropertychange",Rc),Fc=Ec=null)}function Rc(a){"value"===a.propertyName&&Hc(Fc)&&(a=Dc(Fc,a,vc(a)),sc(Gc,a))}
	function Sc(a,b,c){"topFocus"===a?(Qc(),Ec=b,Fc=c,Ec.attachEvent("onpropertychange",Rc)):"topBlur"===a&&Qc()}function Tc(a){if("topSelectionChange"===a||"topKeyUp"===a||"topKeyDown"===a)return Hc(Fc)}function Uc(a,b){if("topClick"===a)return Hc(b)}function Vc(a,b){if("topInput"===a||"topChange"===a)return Hc(b)}
	var Wc={eventTypes:Cc,_isInputEventSupported:Jc,extractEvents:function(a,b,c,d){var e=b?qb(b):window,f=e.nodeName&&e.nodeName.toLowerCase();if("select"===f||"input"===f&&"file"===e.type)var g=Ic;else if(uc(e))if(Jc)g=Vc;else{g=Tc;var k=Sc}else f=e.nodeName,!f||"input"!==f.toLowerCase()||"checkbox"!==e.type&&"radio"!==e.type||(g=Uc);if(g&&(g=g(a,b)))return Dc(g,c,d);k&&k(a,e,b);"topBlur"===a&&null!=b&&(a=b._wrapperState||e._wrapperState)&&a.controlled&&"number"===e.type&&(a=""+e.value,e.getAttribute("value")!==
	a&&e.setAttribute("value",a))}};function Xc(a,b,c,d){return S.call(this,a,b,c,d)}S.augmentClass(Xc,{view:null,detail:null});var Yc={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function Zc(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=Yc[a])?!!b[a]:!1}function $c(){return Zc}function ad(a,b,c,d){return S.call(this,a,b,c,d)}
	Xc.augmentClass(ad,{screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:$c,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)}});
	var bd={mouseEnter:{registrationName:"onMouseEnter",dependencies:["topMouseOut","topMouseOver"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["topMouseOut","topMouseOver"]}},cd={eventTypes:bd,extractEvents:function(a,b,c,d){if("topMouseOver"===a&&(c.relatedTarget||c.fromElement)||"topMouseOut"!==a&&"topMouseOver"!==a)return null;var e=d.window===d?d:(e=d.ownerDocument)?e.defaultView||e.parentWindow:window;"topMouseOut"===a?(a=b,b=(b=c.relatedTarget||c.toElement)?pb(b):null):a=null;if(a===
	b)return null;var f=null==a?e:qb(a);e=null==b?e:qb(b);var g=ad.getPooled(bd.mouseLeave,a,c,d);g.type="mouseleave";g.target=f;g.relatedTarget=e;c=ad.getPooled(bd.mouseEnter,b,c,d);c.type="mouseenter";c.target=e;c.relatedTarget=f;Ab(g,c,a,b);return[g,c]}},dd=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner;function ed(a){a=a.type;return"string"===typeof a?a:"function"===typeof a?a.displayName||a.name:null}
	function fd(a){var b=a;if(a.alternate)for(;b["return"];)b=b["return"];else{if(0!==(b.effectTag&2))return 1;for(;b["return"];)if(b=b["return"],0!==(b.effectTag&2))return 1}return 3===b.tag?2:3}function gd(a){return(a=a._reactInternalFiber)?2===fd(a):!1}function hd(a){2!==fd(a)?D("188"):void 0}
	function id(a){var b=a.alternate;if(!b)return b=fd(a),3===b?D("188"):void 0,1===b?null:a;for(var c=a,d=b;;){var e=c["return"],f=e?e.alternate:null;if(!e||!f)break;if(e.child===f.child){for(var g=e.child;g;){if(g===c)return hd(e),a;if(g===d)return hd(e),b;g=g.sibling}D("188")}if(c["return"]!==d["return"])c=e,d=f;else{g=!1;for(var k=e.child;k;){if(k===c){g=!0;c=e;d=f;break}if(k===d){g=!0;d=e;c=f;break}k=k.sibling}if(!g){for(k=f.child;k;){if(k===c){g=!0;c=f;d=e;break}if(k===d){g=!0;d=f;c=e;break}k=k.sibling}g?
	void 0:D("189")}}c.alternate!==d?D("190"):void 0}3!==c.tag?D("188"):void 0;return c.stateNode.current===c?a:b}function jd(a){a=id(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child["return"]=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b["return"]||b["return"]===a)return null;b=b["return"]}b.sibling["return"]=b["return"];b=b.sibling}}return null}
	function kd(a){a=id(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child&&4!==b.tag)b.child["return"]=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b["return"]||b["return"]===a)return null;b=b["return"]}b.sibling["return"]=b["return"];b=b.sibling}}return null}var ld=[];
	function md(a){var b=a.targetInst;do{if(!b){a.ancestors.push(b);break}var c;for(c=b;c["return"];)c=c["return"];c=3!==c.tag?null:c.stateNode.containerInfo;if(!c)break;a.ancestors.push(b);b=pb(c)}while(b);for(c=0;c<a.ancestors.length;c++)b=a.ancestors[c],nd(a.topLevelType,b,a.nativeEvent,vc(a.nativeEvent))}var od=!0,nd=void 0;function pd(a){od=!!a}function U(a,b,c){return c?ca.listen(c,b,qd.bind(null,a)):null}function rd(a,b,c){return c?ca.capture(c,b,qd.bind(null,a)):null}
	function qd(a,b){if(od){var c=vc(b);c=pb(c);null===c||"number"!==typeof c.tag||2===fd(c)||(c=null);if(ld.length){var d=ld.pop();d.topLevelType=a;d.nativeEvent=b;d.targetInst=c;a=d}else a={topLevelType:a,nativeEvent:b,targetInst:c,ancestors:[]};try{sc(md,a)}finally{a.topLevelType=null,a.nativeEvent=null,a.targetInst=null,a.ancestors.length=0,10>ld.length&&ld.push(a)}}}
	var sd=Object.freeze({get _enabled(){return od},get _handleTopLevel(){return nd},setHandleTopLevel:function(a){nd=a},setEnabled:pd,isEnabled:function(){return od},trapBubbledEvent:U,trapCapturedEvent:rd,dispatchEvent:qd});function td(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;c["ms"+a]="MS"+b;c["O"+a]="o"+b.toLowerCase();return c}
	var ud={animationend:td("Animation","AnimationEnd"),animationiteration:td("Animation","AnimationIteration"),animationstart:td("Animation","AnimationStart"),transitionend:td("Transition","TransitionEnd")},vd={},wd={};m.canUseDOM&&(wd=document.createElement("div").style,"AnimationEvent"in window||(delete ud.animationend.animation,delete ud.animationiteration.animation,delete ud.animationstart.animation),"TransitionEvent"in window||delete ud.transitionend.transition);
	function xd(a){if(vd[a])return vd[a];if(!ud[a])return a;var b=ud[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in wd)return vd[a]=b[c];return""}
	var yd={topAbort:"abort",topAnimationEnd:xd("animationend")||"animationend",topAnimationIteration:xd("animationiteration")||"animationiteration",topAnimationStart:xd("animationstart")||"animationstart",topBlur:"blur",topCancel:"cancel",topCanPlay:"canplay",topCanPlayThrough:"canplaythrough",topChange:"change",topClick:"click",topClose:"close",topCompositionEnd:"compositionend",topCompositionStart:"compositionstart",topCompositionUpdate:"compositionupdate",topContextMenu:"contextmenu",topCopy:"copy",
	topCut:"cut",topDoubleClick:"dblclick",topDrag:"drag",topDragEnd:"dragend",topDragEnter:"dragenter",topDragExit:"dragexit",topDragLeave:"dragleave",topDragOver:"dragover",topDragStart:"dragstart",topDrop:"drop",topDurationChange:"durationchange",topEmptied:"emptied",topEncrypted:"encrypted",topEnded:"ended",topError:"error",topFocus:"focus",topInput:"input",topKeyDown:"keydown",topKeyPress:"keypress",topKeyUp:"keyup",topLoadedData:"loadeddata",topLoad:"load",topLoadedMetadata:"loadedmetadata",topLoadStart:"loadstart",
	topMouseDown:"mousedown",topMouseMove:"mousemove",topMouseOut:"mouseout",topMouseOver:"mouseover",topMouseUp:"mouseup",topPaste:"paste",topPause:"pause",topPlay:"play",topPlaying:"playing",topProgress:"progress",topRateChange:"ratechange",topScroll:"scroll",topSeeked:"seeked",topSeeking:"seeking",topSelectionChange:"selectionchange",topStalled:"stalled",topSuspend:"suspend",topTextInput:"textInput",topTimeUpdate:"timeupdate",topToggle:"toggle",topTouchCancel:"touchcancel",topTouchEnd:"touchend",topTouchMove:"touchmove",
	topTouchStart:"touchstart",topTransitionEnd:xd("transitionend")||"transitionend",topVolumeChange:"volumechange",topWaiting:"waiting",topWheel:"wheel"},zd={},Ad=0,Bd="_reactListenersID"+(""+Math.random()).slice(2);function Cd(a){Object.prototype.hasOwnProperty.call(a,Bd)||(a[Bd]=Ad++,zd[a[Bd]]={});return zd[a[Bd]]}function Dd(a){for(;a&&a.firstChild;)a=a.firstChild;return a}
	function Ed(a,b){var c=Dd(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=Dd(c)}}function Fd(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&"text"===a.type||"textarea"===b||"true"===a.contentEditable)}
	var Gd=m.canUseDOM&&"documentMode"in document&&11>=document.documentMode,Hd={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"topBlur topContextMenu topFocus topKeyDown topKeyUp topMouseDown topMouseUp topSelectionChange".split(" ")}},Id=null,Jd=null,Kd=null,Ld=!1;
	function Md(a,b){if(Ld||null==Id||Id!==da())return null;var c=Id;"selectionStart"in c&&Fd(c)?c={start:c.selectionStart,end:c.selectionEnd}:window.getSelection?(c=window.getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset}):c=void 0;return Kd&&ea(Kd,c)?null:(Kd=c,a=S.getPooled(Hd.select,Jd,a,b),a.type="select",a.target=Id,zb(a),a)}
	var Nd={eventTypes:Hd,extractEvents:function(a,b,c,d){var e=d.window===d?d.document:9===d.nodeType?d:d.ownerDocument,f;if(!(f=!e)){a:{e=Cd(e);f=Qa.onSelect;for(var g=0;g<f.length;g++){var k=f[g];if(!e.hasOwnProperty(k)||!e[k]){e=!1;break a}}e=!0}f=!e}if(f)return null;e=b?qb(b):window;switch(a){case "topFocus":if(uc(e)||"true"===e.contentEditable)Id=e,Jd=b,Kd=null;break;case "topBlur":Kd=Jd=Id=null;break;case "topMouseDown":Ld=!0;break;case "topContextMenu":case "topMouseUp":return Ld=!1,Md(c,d);case "topSelectionChange":if(Gd)break;
	case "topKeyDown":case "topKeyUp":return Md(c,d)}return null}};function Od(a,b,c,d){return S.call(this,a,b,c,d)}S.augmentClass(Od,{animationName:null,elapsedTime:null,pseudoElement:null});function Pd(a,b,c,d){return S.call(this,a,b,c,d)}S.augmentClass(Pd,{clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}});function Qd(a,b,c,d){return S.call(this,a,b,c,d)}Xc.augmentClass(Qd,{relatedTarget:null});
	function Rd(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;return 32<=a||13===a?a:0}
	var Sd={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},Td={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
	116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"};function Ud(a,b,c,d){return S.call(this,a,b,c,d)}
	Xc.augmentClass(Ud,{key:function(a){if(a.key){var b=Sd[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=Rd(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?Td[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:$c,charCode:function(a){return"keypress"===a.type?Rd(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===
	a.type?Rd(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}});function Vd(a,b,c,d){return S.call(this,a,b,c,d)}ad.augmentClass(Vd,{dataTransfer:null});function Wd(a,b,c,d){return S.call(this,a,b,c,d)}Xc.augmentClass(Wd,{touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:$c});function Xd(a,b,c,d){return S.call(this,a,b,c,d)}S.augmentClass(Xd,{propertyName:null,elapsedTime:null,pseudoElement:null});
	function Yd(a,b,c,d){return S.call(this,a,b,c,d)}ad.augmentClass(Yd,{deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null});var Zd={},$d={};
	"abort animationEnd animationIteration animationStart blur cancel canPlay canPlayThrough click close contextMenu copy cut doubleClick drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error focus input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing progress rateChange reset scroll seeked seeking stalled submit suspend timeUpdate toggle touchCancel touchEnd touchMove touchStart transitionEnd volumeChange waiting wheel".split(" ").forEach(function(a){var b=a[0].toUpperCase()+
	a.slice(1),c="on"+b;b="top"+b;c={phasedRegistrationNames:{bubbled:c,captured:c+"Capture"},dependencies:[b]};Zd[a]=c;$d[b]=c});
	var ae={eventTypes:Zd,extractEvents:function(a,b,c,d){var e=$d[a];if(!e)return null;switch(a){case "topKeyPress":if(0===Rd(c))return null;case "topKeyDown":case "topKeyUp":a=Ud;break;case "topBlur":case "topFocus":a=Qd;break;case "topClick":if(2===c.button)return null;case "topDoubleClick":case "topMouseDown":case "topMouseMove":case "topMouseUp":case "topMouseOut":case "topMouseOver":case "topContextMenu":a=ad;break;case "topDrag":case "topDragEnd":case "topDragEnter":case "topDragExit":case "topDragLeave":case "topDragOver":case "topDragStart":case "topDrop":a=
	Vd;break;case "topTouchCancel":case "topTouchEnd":case "topTouchMove":case "topTouchStart":a=Wd;break;case "topAnimationEnd":case "topAnimationIteration":case "topAnimationStart":a=Od;break;case "topTransitionEnd":a=Xd;break;case "topScroll":a=Xc;break;case "topWheel":a=Yd;break;case "topCopy":case "topCut":case "topPaste":a=Pd;break;default:a=S}b=a.getPooled(e,b,c,d);zb(b);return b}};nd=function(a,b,c,d){a=jb(a,b,c,d);kb(a);lb(!1)};db.injectEventPluginOrder("ResponderEventPlugin SimpleEventPlugin TapEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));
	Ua=sb.getFiberCurrentPropsFromNode;Va=sb.getInstanceFromNode;Wa=sb.getNodeFromInstance;db.injectEventPluginsByName({SimpleEventPlugin:ae,EnterLeaveEventPlugin:cd,ChangeEventPlugin:Wc,SelectEventPlugin:Nd,BeforeInputEventPlugin:hc});var be=[],ce=-1;function V(a){0>ce||(a.current=be[ce],be[ce]=null,ce--)}function W(a,b){ce++;be[ce]=a.current;a.current=b}new Set;var de={current:C},X={current:!1},ee=C;function fe(a){return ge(a)?ee:de.current}
	function he(a,b){var c=a.type.contextTypes;if(!c)return C;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function ge(a){return 2===a.tag&&null!=a.type.childContextTypes}function ie(a){ge(a)&&(V(X,a),V(de,a))}
	function je(a,b,c){null!=de.cursor?D("168"):void 0;W(de,b,a);W(X,c,a)}function ke(a,b){var c=a.stateNode,d=a.type.childContextTypes;if("function"!==typeof c.getChildContext)return b;c=c.getChildContext();for(var e in c)e in d?void 0:D("108",ed(a)||"Unknown",e);return A({},b,c)}function le(a){if(!ge(a))return!1;var b=a.stateNode;b=b&&b.__reactInternalMemoizedMergedChildContext||C;ee=de.current;W(de,b,a);W(X,X.current,a);return!0}
	function me(a,b){var c=a.stateNode;c?void 0:D("169");if(b){var d=ke(a,ee);c.__reactInternalMemoizedMergedChildContext=d;V(X,a);V(de,a);W(de,d,a)}else V(X,a);W(X,b,a)}
	function Y(a,b,c){this.tag=a;this.key=b;this.stateNode=this.type=null;this.sibling=this.child=this["return"]=null;this.index=0;this.memoizedState=this.updateQueue=this.memoizedProps=this.pendingProps=this.ref=null;this.internalContextTag=c;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.expirationTime=0;this.alternate=null}
	function ne(a,b,c){var d=a.alternate;null===d?(d=new Y(a.tag,a.key,a.internalContextTag),d.type=a.type,d.stateNode=a.stateNode,d.alternate=a,a.alternate=d):(d.effectTag=0,d.nextEffect=null,d.firstEffect=null,d.lastEffect=null);d.expirationTime=c;d.pendingProps=b;d.child=a.child;d.memoizedProps=a.memoizedProps;d.memoizedState=a.memoizedState;d.updateQueue=a.updateQueue;d.sibling=a.sibling;d.index=a.index;d.ref=a.ref;return d}
	function oe(a,b,c){var d=void 0,e=a.type,f=a.key;"function"===typeof e?(d=e.prototype&&e.prototype.isReactComponent?new Y(2,f,b):new Y(0,f,b),d.type=e,d.pendingProps=a.props):"string"===typeof e?(d=new Y(5,f,b),d.type=e,d.pendingProps=a.props):"object"===typeof e&&null!==e&&"number"===typeof e.tag?(d=e,d.pendingProps=a.props):D("130",null==e?e:typeof e,"");d.expirationTime=c;return d}function pe(a,b,c,d){b=new Y(10,d,b);b.pendingProps=a;b.expirationTime=c;return b}
	function qe(a,b,c){b=new Y(6,null,b);b.pendingProps=a;b.expirationTime=c;return b}function re(a,b,c){b=new Y(7,a.key,b);b.type=a.handler;b.pendingProps=a;b.expirationTime=c;return b}function se(a,b,c){a=new Y(9,null,b);a.expirationTime=c;return a}function te(a,b,c){b=new Y(4,a.key,b);b.pendingProps=a.children||[];b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}var ue=null,ve=null;
	function we(a){return function(b){try{return a(b)}catch(c){}}}function xe(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);ue=we(function(a){return b.onCommitFiberRoot(c,a)});ve=we(function(a){return b.onCommitFiberUnmount(c,a)})}catch(d){}return!0}function ye(a){"function"===typeof ue&&ue(a)}function ze(a){"function"===typeof ve&&ve(a)}
	function Ae(a){return{baseState:a,expirationTime:0,first:null,last:null,callbackList:null,hasForceUpdate:!1,isInitialized:!1}}function Be(a,b){null===a.last?a.first=a.last=b:(a.last.next=b,a.last=b);if(0===a.expirationTime||a.expirationTime>b.expirationTime)a.expirationTime=b.expirationTime}
	function Ce(a,b){var c=a.alternate,d=a.updateQueue;null===d&&(d=a.updateQueue=Ae(null));null!==c?(a=c.updateQueue,null===a&&(a=c.updateQueue=Ae(null))):a=null;a=a!==d?a:null;null===a?Be(d,b):null===d.last||null===a.last?(Be(d,b),Be(a,b)):(Be(d,b),a.last=b)}function De(a,b,c,d){a=a.partialState;return"function"===typeof a?a.call(b,c,d):a}
	function Ke(a,b,c,d,e,f){null!==a&&a.updateQueue===c&&(c=b.updateQueue={baseState:c.baseState,expirationTime:c.expirationTime,first:c.first,last:c.last,isInitialized:c.isInitialized,callbackList:null,hasForceUpdate:!1});c.expirationTime=0;c.isInitialized?a=c.baseState:(a=c.baseState=b.memoizedState,c.isInitialized=!0);for(var g=!0,k=c.first,h=!1;null!==k;){var r=k.expirationTime;if(r>f){var n=c.expirationTime;if(0===n||n>r)c.expirationTime=r;h||(h=!0,c.baseState=a)}else{h||(c.first=k.next,null===
	c.first&&(c.last=null));if(k.isReplace)a=De(k,d,a,e),g=!0;else if(r=De(k,d,a,e))a=g?A({},a,r):A(a,r),g=!1;k.isForced&&(c.hasForceUpdate=!0);null!==k.callback&&(r=c.callbackList,null===r&&(r=c.callbackList=[]),r.push(k))}k=k.next}null!==c.callbackList?b.effectTag|=32:null!==c.first||c.hasForceUpdate||(b.updateQueue=null);h||(c.baseState=a);return a}
	function Le(a,b){var c=a.callbackList;if(null!==c)for(a.callbackList=null,a=0;a<c.length;a++){var d=c[a],e=d.callback;d.callback=null;"function"!==typeof e?D("191",e):void 0;e.call(b)}}
	function Me(a,b,c,d){function e(a,b){b.updater=f;a.stateNode=b;b._reactInternalFiber=a}var f={isMounted:gd,enqueueSetState:function(c,d,e){c=c._reactInternalFiber;e=void 0===e?null:e;var g=b(c);Ce(c,{expirationTime:g,partialState:d,callback:e,isReplace:!1,isForced:!1,nextCallback:null,next:null});a(c,g)},enqueueReplaceState:function(c,d,e){c=c._reactInternalFiber;e=void 0===e?null:e;var f=b(c);Ce(c,{expirationTime:f,partialState:d,callback:e,isReplace:!0,isForced:!1,nextCallback:null,next:null});
	a(c,f)},enqueueForceUpdate:function(c,d){c=c._reactInternalFiber;d=void 0===d?null:d;var e=b(c);Ce(c,{expirationTime:e,partialState:null,callback:d,isReplace:!1,isForced:!0,nextCallback:null,next:null});a(c,e)}};return{adoptClassInstance:e,constructClassInstance:function(a,b){var c=a.type,d=fe(a),f=2===a.tag&&null!=a.type.contextTypes,g=f?he(a,d):C;b=new c(b,g);e(a,b);f&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=d,a.__reactInternalMemoizedMaskedChildContext=g);return b},mountClassInstance:function(a,
	b){var c=a.alternate,d=a.stateNode,e=d.state||null,g=a.pendingProps;g?void 0:D("158");var k=fe(a);d.props=g;d.state=a.memoizedState=e;d.refs=C;d.context=he(a,k);null!=a.type&&null!=a.type.prototype&&!0===a.type.prototype.unstable_isAsyncReactComponent&&(a.internalContextTag|=1);"function"===typeof d.componentWillMount&&(e=d.state,d.componentWillMount(),e!==d.state&&f.enqueueReplaceState(d,d.state,null),e=a.updateQueue,null!==e&&(d.state=Ke(c,a,e,d,g,b)));"function"===typeof d.componentDidMount&&(a.effectTag|=
	4)},updateClassInstance:function(a,b,e){var g=b.stateNode;g.props=b.memoizedProps;g.state=b.memoizedState;var k=b.memoizedProps,h=b.pendingProps;h||(h=k,null==h?D("159"):void 0);var u=g.context,x=fe(b);x=he(b,x);"function"!==typeof g.componentWillReceiveProps||k===h&&u===x||(u=g.state,g.componentWillReceiveProps(h,x),g.state!==u&&f.enqueueReplaceState(g,g.state,null));u=b.memoizedState;e=null!==b.updateQueue?Ke(a,b,b.updateQueue,g,h,e):u;if(!(k!==h||u!==e||X.current||null!==b.updateQueue&&b.updateQueue.hasForceUpdate))return"function"!==
	typeof g.componentDidUpdate||k===a.memoizedProps&&u===a.memoizedState||(b.effectTag|=4),!1;var F=h;if(null===k||null!==b.updateQueue&&b.updateQueue.hasForceUpdate)F=!0;else{var L=b.stateNode,G=b.type;F="function"===typeof L.shouldComponentUpdate?L.shouldComponentUpdate(F,e,x):G.prototype&&G.prototype.isPureReactComponent?!ea(k,F)||!ea(u,e):!0}F?("function"===typeof g.componentWillUpdate&&g.componentWillUpdate(h,e,x),"function"===typeof g.componentDidUpdate&&(b.effectTag|=4)):("function"!==typeof g.componentDidUpdate||
	k===a.memoizedProps&&u===a.memoizedState||(b.effectTag|=4),c(b,h),d(b,e));g.props=h;g.state=e;g.context=x;return F}}}var Ne="function"===typeof Symbol&&Symbol["for"]&&Symbol["for"]("react.portal")||60106;function Oe(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:Ne,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}var Pe=Array.isArray,Qe="function"===typeof Symbol&&Symbol.iterator,Re,Se,Te,Ue;
	"function"===typeof Symbol&&Symbol["for"]?(Re=Symbol["for"]("react.element"),Se=Symbol["for"]("react.call"),Te=Symbol["for"]("react.return"),Ue=Symbol["for"]("react.fragment")):(Re=60103,Se=60104,Te=60105,Ue=60107);function Ve(a){if(null===a||"undefined"===typeof a)return null;a=Qe&&a[Qe]||a["@@iterator"];return"function"===typeof a?a:null}
	function We(a,b){var c=b.ref;if(null!==c&&"function"!==typeof c){if(b._owner){b=b._owner;var d=void 0;b&&(2!==b.tag?D("110"):void 0,d=b.stateNode);d?void 0:D("147",c);var e=""+c;if(null!==a&&null!==a.ref&&a.ref._stringRef===e)return a.ref;a=function(a){var b=d.refs===C?d.refs={}:d.refs;null===a?delete b[e]:b[e]=a};a._stringRef=e;return a}"string"!==typeof c?D("148"):void 0;b._owner?void 0:D("149",c)}return c}
	function Xe(a,b){"textarea"!==a.type&&D("31","[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,"")}
	function Ye(a,b){function c(c,d){if(b){if(!a){if(null===d.alternate)return;d=d.alternate}var p=c.lastEffect;null!==p?(p.nextEffect=d,c.lastEffect=d):c.firstEffect=c.lastEffect=d;d.nextEffect=null;d.effectTag=8}}function d(a,d){if(!b)return null;for(;null!==d;)c(a,d),d=d.sibling;return null}function e(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function f(b,c,d){if(a)return b=ne(b,c,d),b.index=0,b.sibling=null,b;b.expirationTime=d;b.effectTag=0;b.index=
	0;b.sibling=null;b.pendingProps=c;return b}function g(a,c,d){a.index=d;if(!b)return c;d=a.alternate;if(null!==d)return d=d.index,d<c?(a.effectTag=2,c):d;a.effectTag=2;return c}function k(a){b&&null===a.alternate&&(a.effectTag=2);return a}function h(a,b,c,d){if(null===b||6!==b.tag)return b=qe(c,a.internalContextTag,d),b["return"]=a,b;b=f(b,c,d);b["return"]=a;return b}function r(a,b,c,d){if(null!==b&&b.type===c.type)return d=f(b,c.props,d),d.ref=We(b,c),d["return"]=a,d;d=oe(c,a.internalContextTag,d);
	d.ref=We(b,c);d["return"]=a;return d}function n(a,b,c,d){if(null===b||7!==b.tag)return b=re(c,a.internalContextTag,d),b["return"]=a,b;b=f(b,c,d);b["return"]=a;return b}function y(a,b,c,d){if(null===b||9!==b.tag)return b=se(c,a.internalContextTag,d),b.type=c.value,b["return"]=a,b;b=f(b,null,d);b.type=c.value;b["return"]=a;return b}function u(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==c.implementation)return b=te(c,a.internalContextTag,
	d),b["return"]=a,b;b=f(b,c.children||[],d);b["return"]=a;return b}function x(a,b,c,d,e){if(null===b||10!==b.tag)return b=pe(c,a.internalContextTag,d,e),b["return"]=a,b;b=f(b,c,d);b["return"]=a;return b}function F(a,b,c){if("string"===typeof b||"number"===typeof b)return b=qe(""+b,a.internalContextTag,c),b["return"]=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case Re:if(b.type===Ue)return b=pe(b.props.children,a.internalContextTag,c,b.key),b["return"]=a,b;c=oe(b,a.internalContextTag,c);
	c.ref=We(null,b);c["return"]=a;return c;case Se:return b=re(b,a.internalContextTag,c),b["return"]=a,b;case Te:return c=se(b,a.internalContextTag,c),c.type=b.value,c["return"]=a,c;case Ne:return b=te(b,a.internalContextTag,c),b["return"]=a,b}if(Pe(b)||Ve(b))return b=pe(b,a.internalContextTag,c,null),b["return"]=a,b;Xe(a,b)}return null}function L(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case Re:return c.key===
	e?c.type===Ue?x(a,b,c.props.children,d,e):r(a,b,c,d):null;case Se:return c.key===e?n(a,b,c,d):null;case Te:return null===e?y(a,b,c,d):null;case Ne:return c.key===e?u(a,b,c,d):null}if(Pe(c)||Ve(c))return null!==e?null:x(a,b,c,d,null);Xe(a,c)}return null}function G(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=a.get(c)||null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case Re:return a=a.get(null===d.key?c:d.key)||null,d.type===Ue?x(b,a,d.props.children,e,d.key):
	r(b,a,d,e);case Se:return a=a.get(null===d.key?c:d.key)||null,n(b,a,d,e);case Te:return a=a.get(c)||null,y(b,a,d,e);case Ne:return a=a.get(null===d.key?c:d.key)||null,u(b,a,d,e)}if(Pe(d)||Ve(d))return a=a.get(c)||null,x(b,a,d,e,null);Xe(b,d)}return null}function T(a,f,v,k){for(var p=null,z=null,l=f,h=f=0,t=null;null!==l&&h<v.length;h++){l.index>h?(t=l,l=null):t=l.sibling;var w=L(a,l,v[h],k);if(null===w){null===l&&(l=t);break}b&&l&&null===w.alternate&&c(a,l);f=g(w,f,h);null===z?p=w:z.sibling=w;z=w;
	l=t}if(h===v.length)return d(a,l),p;if(null===l){for(;h<v.length;h++)if(l=F(a,v[h],k))f=g(l,f,h),null===z?p=l:z.sibling=l,z=l;return p}for(l=e(a,l);h<v.length;h++)if(t=G(l,a,h,v[h],k)){if(b&&null!==t.alternate)l["delete"](null===t.key?h:t.key);f=g(t,f,h);null===z?p=t:z.sibling=t;z=t}b&&l.forEach(function(b){return c(a,b)});return p}function I(a,f,v,k){var p=Ve(v);"function"!==typeof p?D("150"):void 0;v=p.call(v);null==v?D("151"):void 0;for(var h=p=null,l=f,z=f=0,t=null,w=v.next();null!==l&&!w.done;z++,
	w=v.next()){l.index>z?(t=l,l=null):t=l.sibling;var n=L(a,l,w.value,k);if(null===n){l||(l=t);break}b&&l&&null===n.alternate&&c(a,l);f=g(n,f,z);null===h?p=n:h.sibling=n;h=n;l=t}if(w.done)return d(a,l),p;if(null===l){for(;!w.done;z++,w=v.next())w=F(a,w.value,k),null!==w&&(f=g(w,f,z),null===h?p=w:h.sibling=w,h=w);return p}for(l=e(a,l);!w.done;z++,w=v.next())if(w=G(l,a,z,w.value,k),null!==w){if(b&&null!==w.alternate)l["delete"](null===w.key?z:w.key);f=g(w,f,z);null===h?p=w:h.sibling=w;h=w}b&&l.forEach(function(b){return c(a,
	b)});return p}return function(a,b,e,g){var h="object"===typeof e&&null!==e;if(h)switch(e.$$typeof){case Re:a:{var v=e.key;for(h=b;null!==h;){if(h.key===v)if(10===h.tag?e.type===Ue:h.type===e.type){d(a,h.sibling);b=f(h,e.type===Ue?e.props.children:e.props,g);b.ref=We(h,e);b["return"]=a;a=b;break a}else{d(a,h);break}else c(a,h);h=h.sibling}e.type===Ue?(e=pe(e.props.children,a.internalContextTag,g,e.key),e["return"]=a,a=e):(g=oe(e,a.internalContextTag,g),g.ref=We(b,e),g["return"]=a,a=g)}return k(a);
	case Se:a:{for(h=e.key;null!==b;){if(b.key===h)if(7===b.tag){d(a,b.sibling);e=f(b,e,g);e["return"]=a;a=e;break a}else{d(a,b);break}else c(a,b);b=b.sibling}e=re(e,a.internalContextTag,g);e["return"]=a;a=e}return k(a);case Te:a:{if(null!==b)if(9===b.tag){d(a,b.sibling);b=f(b,null,g);b.type=e.value;b["return"]=a;a=b;break a}else d(a,b);b=se(e,a.internalContextTag,g);b.type=e.value;b["return"]=a;a=b}return k(a);case Ne:a:{for(h=e.key;null!==b;){if(b.key===h)if(4===b.tag&&b.stateNode.containerInfo===e.containerInfo&&
	b.stateNode.implementation===e.implementation){d(a,b.sibling);e=f(b,e.children||[],g);e["return"]=a;a=e;break a}else{d(a,b);break}else c(a,b);b=b.sibling}e=te(e,a.internalContextTag,g);e["return"]=a;a=e}return k(a)}if("string"===typeof e||"number"===typeof e)return e=""+e,null!==b&&6===b.tag?(d(a,b.sibling),e=f(b,e,g)):(d(a,b),e=qe(e,a.internalContextTag,g)),e["return"]=a,a=e,k(a);if(Pe(e))return T(a,b,e,g);if(Ve(e))return I(a,b,e,g);h&&Xe(a,e);if("undefined"===typeof e)switch(a.tag){case 2:case 1:e=
	a.type,D("152",e.displayName||e.name||"Component")}return d(a,b)}}var Ze=Ye(!0,!0),$e=Ye(!1,!0),af=Ye(!1,!1);
	function bf(a,b,c,d,e){function f(a,b,c){g(a,b,c,b.expirationTime)}function g(a,b,c,d){b.child=null===a?af(b,b.child,c,d):a.child===b.child?Ze(b,b.child,c,d):$e(b,b.child,c,d)}function k(a,b){var c=b.ref;null===c||a&&a.ref===c||(b.effectTag|=128)}function h(a,b,c,d){k(a,b);if(!c)return d&&me(b,!1),n(a,b);c=b.stateNode;dd.current=b;var e=c.render();b.effectTag|=1;f(a,b,e);b.memoizedState=c.state;b.memoizedProps=c.props;d&&me(b,!0);return b.child}function r(a){var b=a.stateNode;b.pendingContext?je(a,
	b.pendingContext,b.pendingContext!==b.context):b.context&&je(a,b.context,!1);G(a,b.containerInfo)}function n(a,b){null!==a&&b.child!==a.child?D("153"):void 0;if(null!==b.child){a=b.child;var c=ne(a,a.pendingProps,a.expirationTime);b.child=c;for(c["return"]=b;null!==a.sibling;)a=a.sibling,c=c.sibling=ne(a,a.pendingProps,a.expirationTime),c["return"]=b;c.sibling=null}return b.child}function y(a,b){switch(b.tag){case 3:r(b);break;case 2:le(b);break;case 4:G(b,b.stateNode.containerInfo)}return null}var u=
	a.shouldSetTextContent,x=a.useSyncScheduling,F=a.shouldDeprioritizeSubtree,L=b.pushHostContext,G=b.pushHostContainer,T=c.enterHydrationState,I=c.resetHydrationState,z=c.tryToClaimNextHydratableInstance;a=Me(d,e,function(a,b){a.memoizedProps=b},function(a,b){a.memoizedState=b});var p=a.adoptClassInstance,v=a.constructClassInstance,t=a.mountClassInstance,Kb=a.updateClassInstance;return{beginWork:function(a,b,c){if(0===b.expirationTime||b.expirationTime>c)return y(a,b);switch(b.tag){case 0:null!==a?
	D("155"):void 0;var d=b.type,e=b.pendingProps,g=fe(b);g=he(b,g);d=d(e,g);b.effectTag|=1;"object"===typeof d&&null!==d&&"function"===typeof d.render?(b.tag=2,e=le(b),p(b,d),t(b,c),b=h(a,b,!0,e)):(b.tag=1,f(a,b,d),b.memoizedProps=e,b=b.child);return b;case 1:a:{e=b.type;c=b.pendingProps;d=b.memoizedProps;if(X.current)null===c&&(c=d);else if(null===c||d===c){b=n(a,b);break a}d=fe(b);d=he(b,d);e=e(c,d);b.effectTag|=1;f(a,b,e);b.memoizedProps=c;b=b.child}return b;case 2:return e=le(b),d=void 0,null===
	a?b.stateNode?D("153"):(v(b,b.pendingProps),t(b,c),d=!0):d=Kb(a,b,c),h(a,b,d,e);case 3:return r(b),e=b.updateQueue,null!==e?(d=b.memoizedState,e=Ke(a,b,e,null,null,c),d===e?(I(),b=n(a,b)):(d=e.element,g=b.stateNode,(null===a||null===a.child)&&g.hydrate&&T(b)?(b.effectTag|=2,b.child=af(b,b.child,d,c)):(I(),f(a,b,d)),b.memoizedState=e,b=b.child)):(I(),b=n(a,b)),b;case 5:L(b);null===a&&z(b);e=b.type;var l=b.memoizedProps;d=b.pendingProps;null===d&&(d=l,null===d?D("154"):void 0);g=null!==a?a.memoizedProps:
	null;X.current||null!==d&&l!==d?(l=d.children,u(e,d)?l=null:g&&u(e,g)&&(b.effectTag|=16),k(a,b),2147483647!==c&&!x&&F(e,d)?(b.expirationTime=2147483647,b=null):(f(a,b,l),b.memoizedProps=d,b=b.child)):b=n(a,b);return b;case 6:return null===a&&z(b),a=b.pendingProps,null===a&&(a=b.memoizedProps),b.memoizedProps=a,null;case 8:b.tag=7;case 7:e=b.pendingProps;if(X.current)null===e&&(e=a&&a.memoizedProps,null===e?D("154"):void 0);else if(null===e||b.memoizedProps===e)e=b.memoizedProps;d=e.children;b.stateNode=
	null===a?af(b,b.stateNode,d,c):a.child===b.child?Ze(b,b.stateNode,d,c):$e(b,b.stateNode,d,c);b.memoizedProps=e;return b.stateNode;case 9:return null;case 4:a:{G(b,b.stateNode.containerInfo);e=b.pendingProps;if(X.current)null===e&&(e=a&&a.memoizedProps,null==e?D("154"):void 0);else if(null===e||b.memoizedProps===e){b=n(a,b);break a}null===a?b.child=$e(b,b.child,e,c):f(a,b,e);b.memoizedProps=e;b=b.child}return b;case 10:a:{c=b.pendingProps;if(X.current)null===c&&(c=b.memoizedProps);else if(null===c||
	b.memoizedProps===c){b=n(a,b);break a}f(a,b,c);b.memoizedProps=c;b=b.child}return b;default:D("156")}},beginFailedWork:function(a,b,c){switch(b.tag){case 2:le(b);break;case 3:r(b);break;default:D("157")}b.effectTag|=64;null===a?b.child=null:b.child!==a.child&&(b.child=a.child);if(0===b.expirationTime||b.expirationTime>c)return y(a,b);b.firstEffect=null;b.lastEffect=null;g(a,b,null,c);2===b.tag&&(a=b.stateNode,b.memoizedProps=a.props,b.memoizedState=a.state);return b.child}}}
	function cf(a,b,c){function d(a){a.effectTag|=4}var e=a.createInstance,f=a.createTextInstance,g=a.appendInitialChild,k=a.finalizeInitialChildren,h=a.prepareUpdate,r=a.persistence,n=b.getRootHostContainer,y=b.popHostContext,u=b.getHostContext,x=b.popHostContainer,F=c.prepareToHydrateHostInstance,L=c.prepareToHydrateHostTextInstance,G=c.popHydrationState,T=void 0,I=void 0,z=void 0;a.mutation?(T=function(){},I=function(a,b,c){(b.updateQueue=c)&&d(b)},z=function(a,b,c,e){c!==e&&d(b)}):r?D("235"):D("236");
	return{completeWork:function(a,b,c){var p=b.pendingProps;if(null===p)p=b.memoizedProps;else if(2147483647!==b.expirationTime||2147483647===c)b.pendingProps=null;switch(b.tag){case 1:return null;case 2:return ie(b),null;case 3:x(b);V(X,b);V(de,b);p=b.stateNode;p.pendingContext&&(p.context=p.pendingContext,p.pendingContext=null);if(null===a||null===a.child)G(b),b.effectTag&=-3;T(b);return null;case 5:y(b);c=n();var v=b.type;if(null!==a&&null!=b.stateNode){var l=a.memoizedProps,t=b.stateNode,r=u();t=
	h(t,v,l,p,c,r);I(a,b,t,v,l,p,c);a.ref!==b.ref&&(b.effectTag|=128)}else{if(!p)return null===b.stateNode?D("166"):void 0,null;a=u();if(G(b))F(b,c,a)&&d(b);else{a=e(v,p,c,a,b);a:for(l=b.child;null!==l;){if(5===l.tag||6===l.tag)g(a,l.stateNode);else if(4!==l.tag&&null!==l.child){l.child["return"]=l;l=l.child;continue}if(l===b)break;for(;null===l.sibling;){if(null===l["return"]||l["return"]===b)break a;l=l["return"]}l.sibling["return"]=l["return"];l=l.sibling}k(a,v,p,c)&&d(b);b.stateNode=a}null!==b.ref&&
	(b.effectTag|=128)}return null;case 6:if(a&&null!=b.stateNode)z(a,b,a.memoizedProps,p);else{if("string"!==typeof p)return null===b.stateNode?D("166"):void 0,null;a=n();c=u();G(b)?L(b)&&d(b):b.stateNode=f(p,a,c,b)}return null;case 7:(p=b.memoizedProps)?void 0:D("165");b.tag=8;v=[];a:for((l=b.stateNode)&&(l["return"]=b);null!==l;){if(5===l.tag||6===l.tag||4===l.tag)D("247");else if(9===l.tag)v.push(l.type);else if(null!==l.child){l.child["return"]=l;l=l.child;continue}for(;null===l.sibling;){if(null===
	l["return"]||l["return"]===b)break a;l=l["return"]}l.sibling["return"]=l["return"];l=l.sibling}l=p.handler;p=l(p.props,v);b.child=Ze(b,null!==a?a.child:null,p,c);return b.child;case 8:return b.tag=7,null;case 9:return null;case 10:return null;case 4:return x(b),T(b),null;case 0:D("167");default:D("156")}}}}
	function df(a,b){function c(a){var c=a.ref;if(null!==c)try{c(null)}catch(v){b(a,v)}}function d(a){"function"===typeof ze&&ze(a);switch(a.tag){case 2:c(a);var d=a.stateNode;if("function"===typeof d.componentWillUnmount)try{d.props=a.memoizedProps,d.state=a.memoizedState,d.componentWillUnmount()}catch(v){b(a,v)}break;case 5:c(a);break;case 7:e(a.stateNode);break;case 4:h&&g(a)}}function e(a){for(var b=a;;)if(d(b),null===b.child||h&&4===b.tag){if(b===a)break;for(;null===b.sibling;){if(null===b["return"]||
	b["return"]===a)return;b=b["return"]}b.sibling["return"]=b["return"];b=b.sibling}else b.child["return"]=b,b=b.child}function f(a){return 5===a.tag||3===a.tag||4===a.tag}function g(a){for(var b=a,c=!1,f=void 0,g=void 0;;){if(!c){c=b["return"];a:for(;;){null===c?D("160"):void 0;switch(c.tag){case 5:f=c.stateNode;g=!1;break a;case 3:f=c.stateNode.containerInfo;g=!0;break a;case 4:f=c.stateNode.containerInfo;g=!0;break a}c=c["return"]}c=!0}if(5===b.tag||6===b.tag)e(b),g?I(f,b.stateNode):T(f,b.stateNode);
	else if(4===b.tag?f=b.stateNode.containerInfo:d(b),null!==b.child){b.child["return"]=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b["return"]||b["return"]===a)return;b=b["return"];4===b.tag&&(c=!1)}b.sibling["return"]=b["return"];b=b.sibling}}var k=a.getPublicInstance,h=a.mutation;a=a.persistence;h||(a?D("235"):D("236"));var r=h.commitMount,n=h.commitUpdate,y=h.resetTextContent,u=h.commitTextUpdate,x=h.appendChild,F=h.appendChildToContainer,L=h.insertBefore,G=h.insertInContainerBefore,
	T=h.removeChild,I=h.removeChildFromContainer;return{commitResetTextContent:function(a){y(a.stateNode)},commitPlacement:function(a){a:{for(var b=a["return"];null!==b;){if(f(b)){var c=b;break a}b=b["return"]}D("160");c=void 0}var d=b=void 0;switch(c.tag){case 5:b=c.stateNode;d=!1;break;case 3:b=c.stateNode.containerInfo;d=!0;break;case 4:b=c.stateNode.containerInfo;d=!0;break;default:D("161")}c.effectTag&16&&(y(b),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c["return"]||f(c["return"])){c=
	null;break a}c=c["return"]}c.sibling["return"]=c["return"];for(c=c.sibling;5!==c.tag&&6!==c.tag;){if(c.effectTag&2)continue b;if(null===c.child||4===c.tag)continue b;else c.child["return"]=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}for(var e=a;;){if(5===e.tag||6===e.tag)c?d?G(b,e.stateNode,c):L(b,e.stateNode,c):d?F(b,e.stateNode):x(b,e.stateNode);else if(4!==e.tag&&null!==e.child){e.child["return"]=e;e=e.child;continue}if(e===a)break;for(;null===e.sibling;){if(null===e["return"]||e["return"]===
	a)return;e=e["return"]}e.sibling["return"]=e["return"];e=e.sibling}},commitDeletion:function(a){g(a);a["return"]=null;a.child=null;a.alternate&&(a.alternate.child=null,a.alternate["return"]=null)},commitWork:function(a,b){switch(b.tag){case 2:break;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps;a=null!==a?a.memoizedProps:d;var e=b.type,f=b.updateQueue;b.updateQueue=null;null!==f&&n(c,f,e,a,d,b)}break;case 6:null===b.stateNode?D("162"):void 0;c=b.memoizedProps;u(b.stateNode,null!==a?a.memoizedProps:
	c,c);break;case 3:break;default:D("163")}},commitLifeCycles:function(a,b){switch(b.tag){case 2:var c=b.stateNode;if(b.effectTag&4)if(null===a)c.props=b.memoizedProps,c.state=b.memoizedState,c.componentDidMount();else{var d=a.memoizedProps;a=a.memoizedState;c.props=b.memoizedProps;c.state=b.memoizedState;c.componentDidUpdate(d,a)}b=b.updateQueue;null!==b&&Le(b,c);break;case 3:c=b.updateQueue;null!==c&&Le(c,null!==b.child?b.child.stateNode:null);break;case 5:c=b.stateNode;null===a&&b.effectTag&4&&r(c,
	b.type,b.memoizedProps,b);break;case 6:break;case 4:break;default:D("163")}},commitAttachRef:function(a){var b=a.ref;if(null!==b){var c=a.stateNode;switch(a.tag){case 5:b(k(c));break;default:b(c)}}},commitDetachRef:function(a){a=a.ref;null!==a&&a(null)}}}var ef={};
	function ff(a){function b(a){a===ef?D("174"):void 0;return a}var c=a.getChildHostContext,d=a.getRootHostContext,e={current:ef},f={current:ef},g={current:ef};return{getHostContext:function(){return b(e.current)},getRootHostContainer:function(){return b(g.current)},popHostContainer:function(a){V(e,a);V(f,a);V(g,a)},popHostContext:function(a){f.current===a&&(V(e,a),V(f,a))},pushHostContainer:function(a,b){W(g,b,a);b=d(b);W(f,a,a);W(e,b,a)},pushHostContext:function(a){var d=b(g.current),k=b(e.current);
	d=c(k,a.type,d);k!==d&&(W(f,a,a),W(e,d,a))},resetHostContainer:function(){e.current=ef;g.current=ef}}}
	function gf(a){function b(a,b){var c=new Y(5,null,0);c.type="DELETED";c.stateNode=b;c["return"]=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}function c(a,b){switch(a.tag){case 5:return f(b,a.type,a.pendingProps);case 6:return g(b,a.pendingProps);default:return!1}}function d(a){for(a=a["return"];null!==a&&5!==a.tag&&3!==a.tag;)a=a["return"];y=a}var e=a.shouldSetTextContent;a=a.hydration;if(!a)return{enterHydrationState:function(){return!1},
	resetHydrationState:function(){},tryToClaimNextHydratableInstance:function(){},prepareToHydrateHostInstance:function(){D("175")},prepareToHydrateHostTextInstance:function(){D("176")},popHydrationState:function(){return!1}};var f=a.canHydrateInstance,g=a.canHydrateTextInstance,k=a.getNextHydratableSibling,h=a.getFirstHydratableChild,r=a.hydrateInstance,n=a.hydrateTextInstance,y=null,u=null,x=!1;return{enterHydrationState:function(a){u=h(a.stateNode.containerInfo);y=a;return x=!0},resetHydrationState:function(){u=
	y=null;x=!1},tryToClaimNextHydratableInstance:function(a){if(x){var d=u;if(d){if(!c(a,d)){d=k(d);if(!d||!c(a,d)){a.effectTag|=2;x=!1;y=a;return}b(y,u)}a.stateNode=d;y=a;u=h(d)}else a.effectTag|=2,x=!1,y=a}},prepareToHydrateHostInstance:function(a,b,c){b=r(a.stateNode,a.type,a.memoizedProps,b,c,a);a.updateQueue=b;return null!==b?!0:!1},prepareToHydrateHostTextInstance:function(a){return n(a.stateNode,a.memoizedProps,a)},popHydrationState:function(a){if(a!==y)return!1;if(!x)return d(a),x=!0,!1;var c=
	a.type;if(5!==a.tag||"head"!==c&&"body"!==c&&!e(c,a.memoizedProps))for(c=u;c;)b(a,c),c=k(c);d(a);u=y?k(a.stateNode):null;return!0}}}
	function hf(a){function b(a){Lb=ma=!0;var b=a.stateNode;b.current===a?D("177"):void 0;b.isReadyForCommit=!1;dd.current=null;if(1<a.effectTag)if(null!==a.lastEffect){a.lastEffect.nextEffect=a;var c=a.firstEffect}else c=a;else c=a.firstEffect;ug();for(q=c;null!==q;){var d=!1,e=void 0;try{for(;null!==q;){var f=q.effectTag;f&16&&vg(q);if(f&128){var g=q.alternate;null!==g&&wg(g)}switch(f&-242){case 2:Ge(q);q.effectTag&=-3;break;case 6:Ge(q);q.effectTag&=-3;He(q.alternate,q);break;case 4:He(q.alternate,
	q);break;case 8:Lc=!0,xg(q),Lc=!1}q=q.nextEffect}}catch(Mc){d=!0,e=Mc}d&&(null===q?D("178"):void 0,k(q,e),null!==q&&(q=q.nextEffect))}yg();b.current=a;for(q=c;null!==q;){c=!1;d=void 0;try{for(;null!==q;){var h=q.effectTag;h&36&&zg(q.alternate,q);h&128&&Ag(q);if(h&64)switch(e=q,f=void 0,null!==P&&(f=P.get(e),P["delete"](e),null==f&&null!==e.alternate&&(e=e.alternate,f=P.get(e),P["delete"](e))),null==f?D("184"):void 0,e.tag){case 2:e.stateNode.componentDidCatch(f.error,{componentStack:f.componentStack});
	break;case 3:null===ba&&(ba=f.error);break;default:D("157")}var Fa=q.nextEffect;q.nextEffect=null;q=Fa}}catch(Mc){c=!0,d=Mc}c&&(null===q?D("178"):void 0,k(q,d),null!==q&&(q=q.nextEffect))}ma=Lb=!1;"function"===typeof ye&&ye(a.stateNode);fa&&(fa.forEach(F),fa=null);null!==ba&&(a=ba,ba=null,v(a));b=b.current.expirationTime;0===b&&(na=P=null);return b}function c(a){for(;;){var b=ng(a.alternate,a,J),c=a["return"],d=a.sibling;var e=a;if(2147483647===J||2147483647!==e.expirationTime){if(2!==e.tag&&3!==
	e.tag)var f=0;else f=e.updateQueue,f=null===f?0:f.expirationTime;for(var g=e.child;null!==g;)0!==g.expirationTime&&(0===f||f>g.expirationTime)&&(f=g.expirationTime),g=g.sibling;e.expirationTime=f}if(null!==b)return b;null!==c&&(null===c.firstEffect&&(c.firstEffect=a.firstEffect),null!==a.lastEffect&&(null!==c.lastEffect&&(c.lastEffect.nextEffect=a.firstEffect),c.lastEffect=a.lastEffect),1<a.effectTag&&(null!==c.lastEffect?c.lastEffect.nextEffect=a:c.firstEffect=a,c.lastEffect=a));if(null!==d)return d;
	if(null!==c)a=c;else{a.stateNode.isReadyForCommit=!0;break}}return null}function d(a){var b=w(a.alternate,a,J);null===b&&(b=c(a));dd.current=null;return b}function e(a){var b=mg(a.alternate,a,J);null===b&&(b=c(a));dd.current=null;return b}function f(a){if(null!==P){if(!(0===J||J>a))if(J<=Nc)for(;null!==E;)E=h(E)?e(E):d(E);else for(;null!==E&&!p();)E=h(E)?e(E):d(E)}else if(!(0===J||J>a))if(J<=Nc)for(;null!==E;)E=d(E);else for(;null!==E&&!p();)E=d(E)}function g(a,b){ma?D("243"):void 0;ma=!0;a.isReadyForCommit=
	!1;if(a!==fb||b!==J||null===E){for(;-1<ce;)be[ce]=null,ce--;ee=C;de.current=C;X.current=!1;lg();fb=a;J=b;E=ne(fb.current,null,b)}var c=!1,d=null;try{f(b)}catch(Kc){c=!0,d=Kc}for(;c;){if(gb){ba=d;break}var g=E;if(null===g)gb=!0;else{var h=k(g,d);null===h?D("183"):void 0;if(!gb){try{c=h;d=b;for(h=c;null!==g;){switch(g.tag){case 2:ie(g);break;case 5:l(g);break;case 3:Ee(g);break;case 4:Ee(g)}if(g===h||g.alternate===h)break;g=g["return"]}E=e(c);f(d)}catch(Kc){c=!0;d=Kc;continue}break}}}b=ba;gb=ma=!1;
	ba=null;null!==b&&v(b);return a.isReadyForCommit?a.current.alternate:null}function k(a,b){var c=dd.current=null,d=!1,e=!1,f=null;if(3===a.tag)c=a,r(a)&&(gb=!0);else for(var g=a["return"];null!==g&&null===c;){2===g.tag?"function"===typeof g.stateNode.componentDidCatch&&(d=!0,f=ed(g),c=g,e=!0):3===g.tag&&(c=g);if(r(g)){if(Lc||null!==fa&&(fa.has(g)||null!==g.alternate&&fa.has(g.alternate)))return null;c=null;e=!1}g=g["return"]}if(null!==c){null===na&&(na=new Set);na.add(c);var h="";g=a;do{a:switch(g.tag){case 0:case 1:case 2:case 5:var k=
	g._debugOwner,l=g._debugSource;var Fa=ed(g);var n=null;k&&(n=ed(k));k=l;Fa="\n    in "+(Fa||"Unknown")+(k?" (at "+k.fileName.replace(/^.*[\\\/]/,"")+":"+k.lineNumber+")":n?" (created by "+n+")":"");break a;default:Fa=""}h+=Fa;g=g["return"]}while(g);g=h;a=ed(a);null===P&&(P=new Map);b={componentName:a,componentStack:g,error:b,errorBoundary:d?c.stateNode:null,errorBoundaryFound:d,errorBoundaryName:f,willRetry:e};P.set(c,b);try{console.error(b.error)}catch(Bg){console.error(Bg)}Lb?(null===fa&&(fa=new Set),
	fa.add(c)):F(c);return c}null===ba&&(ba=b);return null}function h(a){return null!==P&&(P.has(a)||null!==a.alternate&&P.has(a.alternate))}function r(a){return null!==na&&(na.has(a)||null!==a.alternate&&na.has(a.alternate))}function n(){return 20*(((L()+100)/20|0)+1)}function y(a){return 0!==ja?ja:ma?Lb?1:J:!Cg||a.internalContextTag&1?n():1}function u(a,b){return x(a,b,!1)}function x(a,b){for(;null!==a;){if(0===a.expirationTime||a.expirationTime>b)a.expirationTime=b;null!==a.alternate&&(0===a.alternate.expirationTime||
	a.alternate.expirationTime>b)&&(a.alternate.expirationTime=b);if(null===a["return"])if(3===a.tag){var c=a.stateNode;!ma&&c===fb&&b<=J&&(E=fb=null,J=0);var d=b;Mb>Dg&&D("185");if(null===c.nextScheduledRoot)c.remainingExpirationTime=d,null===M?(oa=M=c,c.nextScheduledRoot=c):(M=M.nextScheduledRoot=c,M.nextScheduledRoot=oa);else{var e=c.remainingExpirationTime;if(0===e||d<e)c.remainingExpirationTime=d}Ga||(ka?Nb&&z(c,1):1===d?I(1,null):hb||(hb=!0,Ie(T)))}else break;a=a["return"]}}function F(a){x(a,1,
	!0)}function L(){return Nc=((Je()-Eg)/10|0)+2}function G(){var a=0,b=null;if(null!==M)for(var c=M,d=oa;null!==d;){var e=d.remainingExpirationTime;if(0===e){null===c||null===M?D("244"):void 0;if(d===d.nextScheduledRoot){oa=M=d.nextScheduledRoot=null;break}else if(d===oa)oa=e=d.nextScheduledRoot,M.nextScheduledRoot=e,d.nextScheduledRoot=null;else if(d===M){M=c;M.nextScheduledRoot=oa;d.nextScheduledRoot=null;break}else c.nextScheduledRoot=d.nextScheduledRoot,d.nextScheduledRoot=null;d=c.nextScheduledRoot}else{if(0===
	a||e<a)a=e,b=d;if(d===M)break;c=d;d=d.nextScheduledRoot}}c=pa;null!==c&&c===b?Mb++:Mb=0;pa=b;Ob=a}function T(a){I(0,a)}function I(a,b){ib=b;for(G();null!==pa&&0!==Ob&&(0===a||Ob<=a)&&!Oc;)z(pa,Ob),G();null!==ib&&(hb=!1);null===pa||hb||(hb=!0,Ie(T));ib=null;Oc=!1;Mb=0;if(Pb)throw a=Pc,Pc=null,Pb=!1,a;}function z(a,c){Ga?D("245"):void 0;Ga=!0;if(c<=L()){var d=a.finishedWork;null!==d?(a.finishedWork=null,a.remainingExpirationTime=b(d)):(a.finishedWork=null,d=g(a,c),null!==d&&(a.remainingExpirationTime=
	b(d)))}else d=a.finishedWork,null!==d?(a.finishedWork=null,a.remainingExpirationTime=b(d)):(a.finishedWork=null,d=g(a,c),null!==d&&(p()?a.finishedWork=d:a.remainingExpirationTime=b(d)));Ga=!1}function p(){return null===ib||ib.timeRemaining()>Fg?!1:Oc=!0}function v(a){null===pa?D("246"):void 0;pa.remainingExpirationTime=0;Pb||(Pb=!0,Pc=a)}var t=ff(a),Kb=gf(a),Ee=t.popHostContainer,l=t.popHostContext,lg=t.resetHostContainer,Fe=bf(a,t,Kb,u,y),w=Fe.beginWork,mg=Fe.beginFailedWork,ng=cf(a,t,Kb).completeWork;
	t=df(a,k);var vg=t.commitResetTextContent,Ge=t.commitPlacement,xg=t.commitDeletion,He=t.commitWork,zg=t.commitLifeCycles,Ag=t.commitAttachRef,wg=t.commitDetachRef,Je=a.now,Ie=a.scheduleDeferredCallback,Cg=a.useSyncScheduling,ug=a.prepareForCommit,yg=a.resetAfterCommit,Eg=Je(),Nc=2,ja=0,ma=!1,E=null,fb=null,J=0,q=null,P=null,na=null,fa=null,ba=null,gb=!1,Lb=!1,Lc=!1,oa=null,M=null,hb=!1,Ga=!1,pa=null,Ob=0,Oc=!1,Pb=!1,Pc=null,ib=null,ka=!1,Nb=!1,Dg=1E3,Mb=0,Fg=1;return{computeAsyncExpiration:n,computeExpirationForFiber:y,
	scheduleWork:u,batchedUpdates:function(a,b){var c=ka;ka=!0;try{return a(b)}finally{(ka=c)||Ga||I(1,null)}},unbatchedUpdates:function(a){if(ka&&!Nb){Nb=!0;try{return a()}finally{Nb=!1}}return a()},flushSync:function(a){var b=ka;ka=!0;try{a:{var c=ja;ja=1;try{var d=a();break a}finally{ja=c}d=void 0}return d}finally{ka=b,Ga?D("187"):void 0,I(1,null)}},deferredUpdates:function(a){var b=ja;ja=n();try{return a()}finally{ja=b}}}}
	function jf(a){function b(a){a=jd(a);return null===a?null:a.stateNode}var c=a.getPublicInstance;a=hf(a);var d=a.computeAsyncExpiration,e=a.computeExpirationForFiber,f=a.scheduleWork;return{createContainer:function(a,b){var c=new Y(3,null,0);a={current:c,containerInfo:a,pendingChildren:null,remainingExpirationTime:0,isReadyForCommit:!1,finishedWork:null,context:null,pendingContext:null,hydrate:b,nextScheduledRoot:null};return c.stateNode=a},updateContainer:function(a,b,c,r){var g=b.current;if(c){c=
	c._reactInternalFiber;var h;b:{2===fd(c)&&2===c.tag?void 0:D("170");for(h=c;3!==h.tag;){if(ge(h)){h=h.stateNode.__reactInternalMemoizedMergedChildContext;break b}(h=h["return"])?void 0:D("171")}h=h.stateNode.context}c=ge(c)?ke(c,h):h}else c=C;null===b.context?b.context=c:b.pendingContext=c;b=r;b=void 0===b?null:b;r=null!=a&&null!=a.type&&null!=a.type.prototype&&!0===a.type.prototype.unstable_isAsyncReactComponent?d():e(g);Ce(g,{expirationTime:r,partialState:{element:a},callback:b,isReplace:!1,isForced:!1,
	nextCallback:null,next:null});f(g,r)},batchedUpdates:a.batchedUpdates,unbatchedUpdates:a.unbatchedUpdates,deferredUpdates:a.deferredUpdates,flushSync:a.flushSync,getPublicRootInstance:function(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return c(a.child.stateNode);default:return a.child.stateNode}},findHostInstance:b,findHostInstanceWithNoPortals:function(a){a=kd(a);return null===a?null:a.stateNode},injectIntoDevTools:function(a){var c=a.findFiberByHostInstance;return xe(A({},
	a,{findHostInstanceByFiber:function(a){return b(a)},findFiberByHostInstance:function(a){return c?c(a):null}}))}}}var kf=Object.freeze({default:jf}),lf=kf&&jf||kf,mf=lf["default"]?lf["default"]:lf,nf="object"===typeof performance&&"function"===typeof performance.now,of=void 0;of=nf?function(){return performance.now()}:function(){return Date.now()};var pf=void 0;
	if(m.canUseDOM)if("function"!==typeof requestIdleCallback){var qf=null,rf=!1,sf=!1,tf=0,uf=33,vf=33,wf;wf=nf?{timeRemaining:function(){return tf-performance.now()}}:{timeRemaining:function(){return tf-Date.now()}};var xf="__reactIdleCallback$"+Math.random().toString(36).slice(2);window.addEventListener("message",function(a){a.source===window&&a.data===xf&&(rf=!1,a=qf,qf=null,null!==a&&a(wf))},!1);var yf=function(a){sf=!1;var b=a-tf+vf;b<vf&&uf<vf?(8>b&&(b=8),vf=b<uf?uf:b):uf=b;tf=a+vf;rf||(rf=!0,
	window.postMessage(xf,"*"))};pf=function(a){qf=a;sf||(sf=!0,requestAnimationFrame(yf));return 0}}else pf=requestIdleCallback;else pf=function(a){setTimeout(function(){a({timeRemaining:function(){return Infinity}})});return 0};
	var zf=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,Af={},Bf={};function Cf(a){if(Bf.hasOwnProperty(a))return!0;if(Af.hasOwnProperty(a))return!1;if(zf.test(a))return Bf[a]=!0;Af[a]=!0;return!1}
	function Df(a,b,c){var d=ua(b);if(d&&ta(b,c)){var e=d.mutationMethod;e?e(a,c):null==c||d.hasBooleanValue&&!c||d.hasNumericValue&&isNaN(c)||d.hasPositiveNumericValue&&1>c||d.hasOverloadedBooleanValue&&!1===c?Ef(a,b):d.mustUseProperty?a[d.propertyName]=c:(b=d.attributeName,(e=d.attributeNamespace)?a.setAttributeNS(e,b,""+c):d.hasBooleanValue||d.hasOverloadedBooleanValue&&!0===c?a.setAttribute(b,""):a.setAttribute(b,""+c))}else Ff(a,b,ta(b,c)?c:null)}
	function Ff(a,b,c){Cf(b)&&(null==c?a.removeAttribute(b):a.setAttribute(b,""+c))}function Ef(a,b){var c=ua(b);c?(b=c.mutationMethod)?b(a,void 0):c.mustUseProperty?a[c.propertyName]=c.hasBooleanValue?!1:"":a.removeAttribute(c.attributeName):a.removeAttribute(b)}
	function Gf(a,b){var c=b.value,d=b.checked;return A({type:void 0,step:void 0,min:void 0,max:void 0},b,{defaultChecked:void 0,defaultValue:void 0,value:null!=c?c:a._wrapperState.initialValue,checked:null!=d?d:a._wrapperState.initialChecked})}function Hf(a,b){var c=b.defaultValue;a._wrapperState={initialChecked:null!=b.checked?b.checked:b.defaultChecked,initialValue:null!=b.value?b.value:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}
	function If(a,b){var c=b.checked;null!=c&&Df(a,"checked",c||!1);c=b.value;if(null!=c)if(0===c&&""===a.value)a.value="0";else if("number"===b.type){if(b=parseFloat(a.value)||0,c!=b||c==b&&a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else null==b.value&&null!=b.defaultValue&&a.defaultValue!==""+b.defaultValue&&(a.defaultValue=""+b.defaultValue),null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
	function Jf(a,b){switch(b.type){case "submit":case "reset":break;case "color":case "date":case "datetime":case "datetime-local":case "month":case "time":case "week":a.value="";a.value=a.defaultValue;break;default:a.value=a.value}b=a.name;""!==b&&(a.name="");a.defaultChecked=!a.defaultChecked;a.defaultChecked=!a.defaultChecked;""!==b&&(a.name=b)}function Kf(a){var b="";aa.Children.forEach(a,function(a){null==a||"string"!==typeof a&&"number"!==typeof a||(b+=a)});return b}
	function Lf(a,b){a=A({children:void 0},b);if(b=Kf(b.children))a.children=b;return a}function Mf(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+c;b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
	function Nf(a,b){var c=b.value;a._wrapperState={initialValue:null!=c?c:b.defaultValue,wasMultiple:!!b.multiple}}function Of(a,b){null!=b.dangerouslySetInnerHTML?D("91"):void 0;return A({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function Pf(a,b){var c=b.value,d=c;null==c&&(c=b.defaultValue,b=b.children,null!=b&&(null!=c?D("92"):void 0,Array.isArray(b)&&(1>=b.length?void 0:D("93"),b=b[0]),c=""+b),null==c&&(c=""),d=c);a._wrapperState={initialValue:""+d}}
	function Qf(a,b){var c=b.value;null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&(a.defaultValue=c));null!=b.defaultValue&&(a.defaultValue=b.defaultValue)}function Rf(a){var b=a.textContent;b===a._wrapperState.initialValue&&(a.value=b)}var Sf={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
	function Tf(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function Uf(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?Tf(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
	var Vf=void 0,Wf=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Sf.svg||"innerHTML"in a)a.innerHTML=b;else{Vf=Vf||document.createElement("div");Vf.innerHTML="\x3csvg\x3e"+b+"\x3c/svg\x3e";for(b=Vf.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}}),Xf=/["'&<>]/;
	function Yf(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}
	m.canUseDOM&&("textContent"in document.documentElement||(Yf=function(a,b){if(3===a.nodeType)a.nodeValue=b;else{if("boolean"===typeof b||"number"===typeof b)b=""+b;else{b=""+b;var c=Xf.exec(b);if(c){var d="",e,f=0;for(e=c.index;e<b.length;e++){switch(b.charCodeAt(e)){case 34:c="\x26quot;";break;case 38:c="\x26amp;";break;case 39:c="\x26#x27;";break;case 60:c="\x26lt;";break;case 62:c="\x26gt;";break;default:continue}f!==e&&(d+=b.substring(f,e));f=e+1;d+=c}b=f!==e?d+b.substring(f,e):d}}Wf(a,b)}}));
	var Zf=Yf,$f={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,
	floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},ag=["Webkit","ms","Moz","O"];Object.keys($f).forEach(function(a){ag.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);$f[b]=$f[a]})});
	function bg(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--");var e=c;var f=b[c];e=null==f||"boolean"===typeof f||""===f?"":d||"number"!==typeof f||0===f||$f.hasOwnProperty(e)&&$f[e]?(""+f).trim():f+"px";"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var cg=A({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
	function dg(a,b,c){b&&(cg[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML?D("137",a,c()):void 0),null!=b.dangerouslySetInnerHTML&&(null!=b.children?D("60"):void 0,"object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML?void 0:D("61")),null!=b.style&&"object"!==typeof b.style?D("62",c()):void 0)}
	function eg(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}var fg=Sf.html,gg=B.thatReturns("");
	function hg(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=Cd(a);b=Qa[b];for(var d=0;d<b.length;d++){var e=b[d];c.hasOwnProperty(e)&&c[e]||("topWheel"===e?xc("wheel")?U("topWheel","wheel",a):xc("mousewheel")?U("topWheel","mousewheel",a):U("topWheel","DOMMouseScroll",a):"topScroll"===e?rd("topScroll","scroll",a):"topFocus"===e||"topBlur"===e?(rd("topFocus","focus",a),rd("topBlur","blur",a),c.topBlur=!0,c.topFocus=!0):"topCancel"===e?(xc("cancel",!0)&&rd("topCancel","cancel",a),c.topCancel=
	!0):"topClose"===e?(xc("close",!0)&&rd("topClose","close",a),c.topClose=!0):yd.hasOwnProperty(e)&&U(e,yd[e],a),c[e]=!0)}}
	var ig={topAbort:"abort",topCanPlay:"canplay",topCanPlayThrough:"canplaythrough",topDurationChange:"durationchange",topEmptied:"emptied",topEncrypted:"encrypted",topEnded:"ended",topError:"error",topLoadedData:"loadeddata",topLoadedMetadata:"loadedmetadata",topLoadStart:"loadstart",topPause:"pause",topPlay:"play",topPlaying:"playing",topProgress:"progress",topRateChange:"ratechange",topSeeked:"seeked",topSeeking:"seeking",topStalled:"stalled",topSuspend:"suspend",topTimeUpdate:"timeupdate",topVolumeChange:"volumechange",
	topWaiting:"waiting"};function jg(a,b,c,d){c=9===c.nodeType?c:c.ownerDocument;d===fg&&(d=Tf(a));d===fg?"script"===a?(a=c.createElement("div"),a.innerHTML="\x3cscript\x3e\x3c/script\x3e",a=a.removeChild(a.firstChild)):a="string"===typeof b.is?c.createElement(a,{is:b.is}):c.createElement(a):a=c.createElementNS(d,a);return a}function kg(a,b){return(9===b.nodeType?b:b.ownerDocument).createTextNode(a)}
	function og(a,b,c,d){var e=eg(b,c);switch(b){case "iframe":case "object":U("topLoad","load",a);var f=c;break;case "video":case "audio":for(f in ig)ig.hasOwnProperty(f)&&U(f,ig[f],a);f=c;break;case "source":U("topError","error",a);f=c;break;case "img":case "image":U("topError","error",a);U("topLoad","load",a);f=c;break;case "form":U("topReset","reset",a);U("topSubmit","submit",a);f=c;break;case "details":U("topToggle","toggle",a);f=c;break;case "input":Hf(a,c);f=Gf(a,c);U("topInvalid","invalid",a);
	hg(d,"onChange");break;case "option":f=Lf(a,c);break;case "select":Nf(a,c);f=A({},c,{value:void 0});U("topInvalid","invalid",a);hg(d,"onChange");break;case "textarea":Pf(a,c);f=Of(a,c);U("topInvalid","invalid",a);hg(d,"onChange");break;default:f=c}dg(b,f,gg);var g=f,k;for(k in g)if(g.hasOwnProperty(k)){var h=g[k];"style"===k?bg(a,h,gg):"dangerouslySetInnerHTML"===k?(h=h?h.__html:void 0,null!=h&&Wf(a,h)):"children"===k?"string"===typeof h?("textarea"!==b||""!==h)&&Zf(a,h):"number"===typeof h&&Zf(a,
	""+h):"suppressContentEditableWarning"!==k&&"suppressHydrationWarning"!==k&&"autoFocus"!==k&&(Pa.hasOwnProperty(k)?null!=h&&hg(d,k):e?Ff(a,k,h):null!=h&&Df(a,k,h))}switch(b){case "input":Ac(a);Jf(a,c);break;case "textarea":Ac(a);Rf(a,c);break;case "option":null!=c.value&&a.setAttribute("value",c.value);break;case "select":a.multiple=!!c.multiple;b=c.value;null!=b?Mf(a,!!c.multiple,b,!1):null!=c.defaultValue&&Mf(a,!!c.multiple,c.defaultValue,!0);break;default:"function"===typeof f.onClick&&(a.onclick=
	B)}}
	function pg(a,b,c,d,e){var f=null;switch(b){case "input":c=Gf(a,c);d=Gf(a,d);f=[];break;case "option":c=Lf(a,c);d=Lf(a,d);f=[];break;case "select":c=A({},c,{value:void 0});d=A({},d,{value:void 0});f=[];break;case "textarea":c=Of(a,c);d=Of(a,d);f=[];break;default:"function"!==typeof c.onClick&&"function"===typeof d.onClick&&(a.onclick=B)}dg(b,d,gg);var g,k;a=null;for(g in c)if(!d.hasOwnProperty(g)&&c.hasOwnProperty(g)&&null!=c[g])if("style"===g)for(k in b=c[g],b)b.hasOwnProperty(k)&&(a||(a={}),a[k]=
	"");else"dangerouslySetInnerHTML"!==g&&"children"!==g&&"suppressContentEditableWarning"!==g&&"suppressHydrationWarning"!==g&&"autoFocus"!==g&&(Pa.hasOwnProperty(g)?f||(f=[]):(f=f||[]).push(g,null));for(g in d){var h=d[g];b=null!=c?c[g]:void 0;if(d.hasOwnProperty(g)&&h!==b&&(null!=h||null!=b))if("style"===g)if(b){for(k in b)!b.hasOwnProperty(k)||h&&h.hasOwnProperty(k)||(a||(a={}),a[k]="");for(k in h)h.hasOwnProperty(k)&&b[k]!==h[k]&&(a||(a={}),a[k]=h[k])}else a||(f||(f=[]),f.push(g,a)),a=h;else"dangerouslySetInnerHTML"===
	g?(h=h?h.__html:void 0,b=b?b.__html:void 0,null!=h&&b!==h&&(f=f||[]).push(g,""+h)):"children"===g?b===h||"string"!==typeof h&&"number"!==typeof h||(f=f||[]).push(g,""+h):"suppressContentEditableWarning"!==g&&"suppressHydrationWarning"!==g&&(Pa.hasOwnProperty(g)?(null!=h&&hg(e,g),f||b===h||(f=[])):(f=f||[]).push(g,h))}a&&(f=f||[]).push("style",a);return f}
	function qg(a,b,c,d,e){eg(c,d);d=eg(c,e);for(var f=0;f<b.length;f+=2){var g=b[f],k=b[f+1];"style"===g?bg(a,k,gg):"dangerouslySetInnerHTML"===g?Wf(a,k):"children"===g?Zf(a,k):d?null!=k?Ff(a,g,k):a.removeAttribute(g):null!=k?Df(a,g,k):Ef(a,g)}switch(c){case "input":If(a,e);Bc(a);break;case "textarea":Qf(a,e);break;case "select":a._wrapperState.initialValue=void 0,b=a._wrapperState.wasMultiple,a._wrapperState.wasMultiple=!!e.multiple,c=e.value,null!=c?Mf(a,!!e.multiple,c,!1):b!==!!e.multiple&&(null!=
	e.defaultValue?Mf(a,!!e.multiple,e.defaultValue,!0):Mf(a,!!e.multiple,e.multiple?[]:"",!1))}}
	function rg(a,b,c,d,e){switch(b){case "iframe":case "object":U("topLoad","load",a);break;case "video":case "audio":for(var f in ig)ig.hasOwnProperty(f)&&U(f,ig[f],a);break;case "source":U("topError","error",a);break;case "img":case "image":U("topError","error",a);U("topLoad","load",a);break;case "form":U("topReset","reset",a);U("topSubmit","submit",a);break;case "details":U("topToggle","toggle",a);break;case "input":Hf(a,c);U("topInvalid","invalid",a);hg(e,"onChange");break;case "select":Nf(a,c);
	U("topInvalid","invalid",a);hg(e,"onChange");break;case "textarea":Pf(a,c),U("topInvalid","invalid",a),hg(e,"onChange")}dg(b,c,gg);d=null;for(var g in c)c.hasOwnProperty(g)&&(f=c[g],"children"===g?"string"===typeof f?a.textContent!==f&&(d=["children",f]):"number"===typeof f&&a.textContent!==""+f&&(d=["children",""+f]):Pa.hasOwnProperty(g)&&null!=f&&hg(e,g));switch(b){case "input":Ac(a);Jf(a,c);break;case "textarea":Ac(a);Rf(a,c);break;case "select":case "option":break;default:"function"===typeof c.onClick&&
	(a.onclick=B)}return d}function sg(a,b){return a.nodeValue!==b}
	var tg=Object.freeze({createElement:jg,createTextNode:kg,setInitialProperties:og,diffProperties:pg,updateProperties:qg,diffHydratedProperties:rg,diffHydratedText:sg,warnForUnmatchedText:function(){},warnForDeletedHydratableElement:function(){},warnForDeletedHydratableText:function(){},warnForInsertedHydratedElement:function(){},warnForInsertedHydratedText:function(){},restoreControlledState:function(a,b,c){switch(b){case "input":If(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=
	c.parentNode;c=c.querySelectorAll("input[name\x3d"+JSON.stringify(""+b)+'][type\x3d"radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=rb(d);e?void 0:D("90");If(d,e)}}}break;case "textarea":Qf(a,c);break;case "select":b=c.value,null!=b&&Mf(a,!!c.multiple,b,!1)}}});mc.injectFiberControlledHostComponent(tg);var Gg=null,Hg=null;function Ig(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}
	function Jg(a){a=a?9===a.nodeType?a.documentElement:a.firstChild:null;return!(!a||1!==a.nodeType||!a.hasAttribute("data-reactroot"))}
	var Z=mf({getRootHostContext:function(a){var b=a.nodeType;switch(b){case 9:case 11:a=(a=a.documentElement)?a.namespaceURI:Uf(null,"");break;default:b=8===b?a.parentNode:a,a=b.namespaceURI||null,b=b.tagName,a=Uf(a,b)}return a},getChildHostContext:function(a,b){return Uf(a,b)},getPublicInstance:function(a){return a},prepareForCommit:function(){Gg=od;var a=da();if(Fd(a)){if("selectionStart"in a)var b={start:a.selectionStart,end:a.selectionEnd};else a:{var c=window.getSelection&&window.getSelection();
	if(c&&0!==c.rangeCount){b=c.anchorNode;var d=c.anchorOffset,e=c.focusNode;c=c.focusOffset;try{b.nodeType,e.nodeType}catch(x){b=null;break a}var f=0,g=-1,k=-1,h=0,r=0,n=a,y=null;b:for(;;){for(var u;;){n!==b||0!==d&&3!==n.nodeType||(g=f+d);n!==e||0!==c&&3!==n.nodeType||(k=f+c);3===n.nodeType&&(f+=n.nodeValue.length);if(null===(u=n.firstChild))break;y=n;n=u}for(;;){if(n===a)break b;y===b&&++h===d&&(g=f);y===e&&++r===c&&(k=f);if(null!==(u=n.nextSibling))break;n=y;y=n.parentNode}n=u}b=-1===g||-1===k?null:
	{start:g,end:k}}else b=null}b=b||{start:0,end:0}}else b=null;Hg={focusedElem:a,selectionRange:b};pd(!1)},resetAfterCommit:function(){var a=Hg,b=da(),c=a.focusedElem,d=a.selectionRange;if(b!==c&&ha(document.documentElement,c)){if(Fd(c))if(b=d.start,a=d.end,void 0===a&&(a=b),"selectionStart"in c)c.selectionStart=b,c.selectionEnd=Math.min(a,c.value.length);else if(window.getSelection){b=window.getSelection();var e=c[Db()].length;a=Math.min(d.start,e);d=void 0===d.end?a:Math.min(d.end,e);!b.extend&&a>
	d&&(e=d,d=a,a=e);e=Ed(c,a);var f=Ed(c,d);if(e&&f&&(1!==b.rangeCount||b.anchorNode!==e.node||b.anchorOffset!==e.offset||b.focusNode!==f.node||b.focusOffset!==f.offset)){var g=document.createRange();g.setStart(e.node,e.offset);b.removeAllRanges();a>d?(b.addRange(g),b.extend(f.node,f.offset)):(g.setEnd(f.node,f.offset),b.addRange(g))}}b=[];for(a=c;a=a.parentNode;)1===a.nodeType&&b.push({element:a,left:a.scrollLeft,top:a.scrollTop});ia(c);for(c=0;c<b.length;c++)a=b[c],a.element.scrollLeft=a.left,a.element.scrollTop=
	a.top}Hg=null;pd(Gg);Gg=null},createInstance:function(a,b,c,d,e){a=jg(a,b,c,d);a[O]=e;a[ob]=b;return a},appendInitialChild:function(a,b){a.appendChild(b)},finalizeInitialChildren:function(a,b,c,d){og(a,b,c,d);a:{switch(b){case "button":case "input":case "select":case "textarea":a=!!c.autoFocus;break a}a=!1}return a},prepareUpdate:function(a,b,c,d,e){return pg(a,b,c,d,e)},shouldSetTextContent:function(a,b){return"textarea"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===
	typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&"string"===typeof b.dangerouslySetInnerHTML.__html},shouldDeprioritizeSubtree:function(a,b){return!!b.hidden},createTextInstance:function(a,b,c,d){a=kg(a,b);a[O]=d;return a},now:of,mutation:{commitMount:function(a){a.focus()},commitUpdate:function(a,b,c,d,e){a[ob]=e;qg(a,b,c,d,e)},resetTextContent:function(a){a.textContent=""},commitTextUpdate:function(a,b,c){a.nodeValue=c},appendChild:function(a,b){a.appendChild(b)},appendChildToContainer:function(a,
	b){8===a.nodeType?a.parentNode.insertBefore(b,a):a.appendChild(b)},insertBefore:function(a,b,c){a.insertBefore(b,c)},insertInContainerBefore:function(a,b,c){8===a.nodeType?a.parentNode.insertBefore(b,c):a.insertBefore(b,c)},removeChild:function(a,b){a.removeChild(b)},removeChildFromContainer:function(a,b){8===a.nodeType?a.parentNode.removeChild(b):a.removeChild(b)}},hydration:{canHydrateInstance:function(a,b){return 1===a.nodeType&&b.toLowerCase()===a.nodeName.toLowerCase()},canHydrateTextInstance:function(a,
	b){return""===b?!1:3===a.nodeType},getNextHydratableSibling:function(a){for(a=a.nextSibling;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a},getFirstHydratableChild:function(a){for(a=a.firstChild;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a},hydrateInstance:function(a,b,c,d,e,f){a[O]=f;a[ob]=c;return rg(a,b,c,e,d)},hydrateTextInstance:function(a,b,c){a[O]=c;return sg(a,b)},didNotMatchHydratedContainerTextInstance:function(){},didNotMatchHydratedTextInstance:function(){},
	didNotHydrateContainerInstance:function(){},didNotHydrateInstance:function(){},didNotFindHydratableContainerInstance:function(){},didNotFindHydratableContainerTextInstance:function(){},didNotFindHydratableInstance:function(){},didNotFindHydratableTextInstance:function(){}},scheduleDeferredCallback:pf,useSyncScheduling:!0});qc=Z.batchedUpdates;
	function Kg(a,b,c,d,e){Ig(c)?void 0:D("200");var f=c._reactRootContainer;if(f)Z.updateContainer(b,f,a,e);else{d=d||Jg(c);if(!d)for(f=void 0;f=c.lastChild;)c.removeChild(f);var g=Z.createContainer(c,d);f=c._reactRootContainer=g;Z.unbatchedUpdates(function(){Z.updateContainer(b,g,a,e)})}return Z.getPublicRootInstance(f)}function Lg(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;Ig(b)?void 0:D("200");return Oe(a,b,null,c)}
	function Mg(a,b){this._reactRootContainer=Z.createContainer(a,b)}Mg.prototype.render=function(a,b){Z.updateContainer(a,this._reactRootContainer,null,b)};Mg.prototype.unmount=function(a){Z.updateContainer(null,this._reactRootContainer,null,a)};
	var Ng={createPortal:Lg,findDOMNode:function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternalFiber;if(b)return Z.findHostInstance(b);"function"===typeof a.render?D("188"):D("213",Object.keys(a))},hydrate:function(a,b,c){return Kg(null,a,b,!0,c)},render:function(a,b,c){return Kg(null,a,b,!1,c)},unstable_renderSubtreeIntoContainer:function(a,b,c,d){null==a||void 0===a._reactInternalFiber?D("38"):void 0;return Kg(a,b,c,!1,d)},unmountComponentAtNode:function(a){Ig(a)?void 0:
	D("40");return a._reactRootContainer?(Z.unbatchedUpdates(function(){Kg(null,null,a,!1,function(){a._reactRootContainer=null})}),!0):!1},unstable_createPortal:Lg,unstable_batchedUpdates:sc,unstable_deferredUpdates:Z.deferredUpdates,flushSync:Z.flushSync,__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{EventPluginHub:mb,EventPluginRegistry:Ta,EventPropagators:Bb,ReactControlledComponent:pc,ReactDOMComponentTree:sb,ReactDOMEventListener:sd}};
	Z.injectIntoDevTools({findFiberByHostInstance:pb,bundleType:0,version:"16.1.0",rendererPackageName:"react-dom"});var Og=Object.freeze({default:Ng}),Pg=Og&&Ng||Og;module.exports=Pg["default"]?Pg["default"]:Pg;


/***/ },
/* 514 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function checkDCE() {
	  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
	  if (
	    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
	    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
	  ) {
	    return;
	  }
	  if (false) {
	    // This branch is unreachable because this function is only called
	    // in production, but the condition is true only in development.
	    // Therefore if the branch is still here, dead code elimination wasn't
	    // properly applied.
	    // Don't change the message. React DevTools relies on it. Also make sure
	    // this message doesn't occur elsewhere in this function, or it will cause
	    // a false positive.
	    throw new Error('^_^');
	  }
	  try {
	    // Verify that the code above has been dead code eliminated (DCE'd).
	    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
	  } catch (err) {
	    // DevTools shouldn't crash React, no matter what.
	    // We should still report in case we break this code.
	    console.error(err);
	  }
	}
	
	if (true) {
	  // DCE check should happen before ReactDOM bundle executes so that
	  // DevTools can report bad minification during injection.
	  checkDCE();
	  module.exports = __webpack_require__(513);
	} else {
	  module.exports = require('./cjs/react-dom.development.js');
	}


/***/ },
/* 515 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var emptyFunction = __webpack_require__(231);
	
	/**
	 * Upstream version of event listener. Does not take into account specific
	 * nature of platform.
	 */
	var EventListener = {
	  /**
	   * Listen to DOM events during the bubble phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  listen: function listen(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, false);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, false);
	        }
	      };
	    } else if (target.attachEvent) {
	      target.attachEvent('on' + eventType, callback);
	      return {
	        remove: function remove() {
	          target.detachEvent('on' + eventType, callback);
	        }
	      };
	    }
	  },
	
	  /**
	   * Listen to DOM events during the capture phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  capture: function capture(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, true);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, true);
	        }
	      };
	    } else {
	      if (false) {
	        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
	      }
	      return {
	        remove: emptyFunction
	      };
	    }
	  },
	
	  registerDefault: function registerDefault() {}
	};
	
	module.exports = EventListener;

/***/ },
/* 516 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	/**
	 * Simple, lightweight module assisting with the detection and context of
	 * Worker. Helps avoid circular dependencies and allows code to reason about
	 * whether or not they are in a Worker, even if they never include the main
	 * `ReactWorker` dependency.
	 */
	var ExecutionEnvironment = {
	
	  canUseDOM: canUseDOM,
	
	  canUseWorkers: typeof Worker !== 'undefined',
	
	  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
	
	  canUseViewport: canUseDOM && !!window.screen,
	
	  isInWorker: !canUseDOM // For now, this is true - might change in the future.
	
	};
	
	module.exports = ExecutionEnvironment;

/***/ },
/* 517 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	var isTextNode = __webpack_require__(522);
	
	/*eslint-disable no-bitwise */
	
	/**
	 * Checks if a given DOM node contains or is another DOM node.
	 */
	function containsNode(outerNode, innerNode) {
	  if (!outerNode || !innerNode) {
	    return false;
	  } else if (outerNode === innerNode) {
	    return true;
	  } else if (isTextNode(outerNode)) {
	    return false;
	  } else if (isTextNode(innerNode)) {
	    return containsNode(outerNode, innerNode.parentNode);
	  } else if ('contains' in outerNode) {
	    return outerNode.contains(innerNode);
	  } else if (outerNode.compareDocumentPosition) {
	    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
	  } else {
	    return false;
	  }
	}
	
	module.exports = containsNode;

/***/ },
/* 518 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyObject = {};
	
	if (false) {
	  Object.freeze(emptyObject);
	}
	
	module.exports = emptyObject;

/***/ },
/* 519 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * @param {DOMElement} node input/textarea to focus
	 */
	
	function focusNode(node) {
	  // IE8 can throw "Can't move focus to the control because it is invisible,
	  // not enabled, or of a type that does not accept the focus." for all kinds of
	  // reasons that are too expensive and fragile to test.
	  try {
	    node.focus();
	  } catch (e) {}
	}
	
	module.exports = focusNode;

/***/ },
/* 520 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/* eslint-disable fb-www/typeof-undefined */
	
	/**
	 * Same as document.activeElement but wraps in a try-catch block. In IE it is
	 * not safe to call document.activeElement if there is nothing focused.
	 *
	 * The activeElement will be null only if the document or document body is not
	 * yet defined.
	 *
	 * @param {?DOMDocument} doc Defaults to current document.
	 * @return {?DOMElement}
	 */
	function getActiveElement(doc) /*?DOMElement*/{
	  doc = doc || (typeof document !== 'undefined' ? document : undefined);
	  if (typeof doc === 'undefined') {
	    return null;
	  }
	  try {
	    return doc.activeElement || doc.body;
	  } catch (e) {
	    return doc.body;
	  }
	}
	
	module.exports = getActiveElement;

/***/ },
/* 521 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM node.
	 */
	function isNode(object) {
	  var doc = object ? object.ownerDocument || object : document;
	  var defaultView = doc.defaultView || window;
	  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
	}
	
	module.exports = isNode;

/***/ },
/* 522 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var isNode = __webpack_require__(521);
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM text node.
	 */
	function isTextNode(object) {
	  return isNode(object) && object.nodeType == 3;
	}
	
	module.exports = isTextNode;

/***/ },
/* 523 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 * 
	 */
	
	/*eslint-disable no-self-compare */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	function is(x, y) {
	  // SameValue algorithm
	  if (x === y) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    // Added the nonzero y check to make Flow happy, but it is redundant
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    // Step 6.a: NaN == NaN
	    return x !== x && y !== y;
	  }
	}
	
	/**
	 * Performs equality by iterating through keys on an object and returning false
	 * when any key has values which are not strictly equal between the arguments.
	 * Returns true when the values of all keys are strictly equal.
	 */
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) {
	    return true;
	  }
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = shallowEqual;

/***/ },
/* 524 */
505,
/* 525 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.createProvider = createProvider;
	
	var _react = __webpack_require__(1);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PropTypes = __webpack_require__(235);
	
	var _warning = __webpack_require__(140);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var didWarnAboutReceivingStore = false;
	function warnAboutReceivingStore() {
	  if (didWarnAboutReceivingStore) {
	    return;
	  }
	  didWarnAboutReceivingStore = true;
	
	  (0, _warning2.default)('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reactjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
	}
	
	function createProvider() {
	  var _Provider$childContex;
	
	  var storeKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'store';
	  var subKey = arguments[1];
	
	  var subscriptionKey = subKey || storeKey + 'Subscription';
	
	  var Provider = function (_Component) {
	    _inherits(Provider, _Component);
	
	    Provider.prototype.getChildContext = function getChildContext() {
	      var _ref;
	
	      return _ref = {}, _ref[storeKey] = this[storeKey], _ref[subscriptionKey] = null, _ref;
	    };
	
	    function Provider(props, context) {
	      _classCallCheck(this, Provider);
	
	      var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	      _this[storeKey] = props.store;
	      return _this;
	    }
	
	    Provider.prototype.render = function render() {
	      return _react.Children.only(this.props.children);
	    };
	
	    return Provider;
	  }(_react.Component);
	
	  if (false) {
	    Provider.prototype.componentWillReceiveProps = function (nextProps) {
	      if (this[storeKey] !== nextProps.store) {
	        warnAboutReceivingStore();
	      }
	    };
	  }
	
	  Provider.propTypes = {
	    store: _PropTypes.storeShape.isRequired,
	    children: _propTypes2.default.element.isRequired
	  };
	  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[storeKey] = _PropTypes.storeShape.isRequired, _Provider$childContex[subscriptionKey] = _PropTypes.subscriptionShape, _Provider$childContex);
	
	  return Provider;
	}
	
	exports.default = createProvider();

/***/ },
/* 526 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.createConnect = createConnect;
	
	var _connectAdvanced = __webpack_require__(232);
	
	var _connectAdvanced2 = _interopRequireDefault(_connectAdvanced);
	
	var _shallowEqual = __webpack_require__(533);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _mapDispatchToProps = __webpack_require__(527);
	
	var _mapDispatchToProps2 = _interopRequireDefault(_mapDispatchToProps);
	
	var _mapStateToProps = __webpack_require__(528);
	
	var _mapStateToProps2 = _interopRequireDefault(_mapStateToProps);
	
	var _mergeProps = __webpack_require__(529);
	
	var _mergeProps2 = _interopRequireDefault(_mergeProps);
	
	var _selectorFactory = __webpack_require__(530);
	
	var _selectorFactory2 = _interopRequireDefault(_selectorFactory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/*
	  connect is a facade over connectAdvanced. It turns its args into a compatible
	  selectorFactory, which has the signature:
	
	    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
	  
	  connect passes its args to connectAdvanced as options, which will in turn pass them to
	  selectorFactory each time a Connect component instance is instantiated or hot reloaded.
	
	  selectorFactory returns a final props selector from its mapStateToProps,
	  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
	  mergePropsFactories, and pure args.
	
	  The resulting final props selector is called by the Connect component instance whenever
	  it receives new props or store state.
	 */
	
	function match(arg, factories, name) {
	  for (var i = factories.length - 1; i >= 0; i--) {
	    var result = factories[i](arg);
	    if (result) return result;
	  }
	
	  return function (dispatch, options) {
	    throw new Error('Invalid value of type ' + typeof arg + ' for ' + name + ' argument when connecting component ' + options.wrappedComponentName + '.');
	  };
	}
	
	function strictEqual(a, b) {
	  return a === b;
	}
	
	// createConnect with default args builds the 'official' connect behavior. Calling it with
	// different options opens up some testing and extensibility scenarios
	function createConnect() {
	  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      _ref$connectHOC = _ref.connectHOC,
	      connectHOC = _ref$connectHOC === undefined ? _connectAdvanced2.default : _ref$connectHOC,
	      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
	      mapStateToPropsFactories = _ref$mapStateToPropsF === undefined ? _mapStateToProps2.default : _ref$mapStateToPropsF,
	      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
	      mapDispatchToPropsFactories = _ref$mapDispatchToPro === undefined ? _mapDispatchToProps2.default : _ref$mapDispatchToPro,
	      _ref$mergePropsFactor = _ref.mergePropsFactories,
	      mergePropsFactories = _ref$mergePropsFactor === undefined ? _mergeProps2.default : _ref$mergePropsFactor,
	      _ref$selectorFactory = _ref.selectorFactory,
	      selectorFactory = _ref$selectorFactory === undefined ? _selectorFactory2.default : _ref$selectorFactory;
	
	  return function connect(mapStateToProps, mapDispatchToProps, mergeProps) {
	    var _ref2 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
	        _ref2$pure = _ref2.pure,
	        pure = _ref2$pure === undefined ? true : _ref2$pure,
	        _ref2$areStatesEqual = _ref2.areStatesEqual,
	        areStatesEqual = _ref2$areStatesEqual === undefined ? strictEqual : _ref2$areStatesEqual,
	        _ref2$areOwnPropsEqua = _ref2.areOwnPropsEqual,
	        areOwnPropsEqual = _ref2$areOwnPropsEqua === undefined ? _shallowEqual2.default : _ref2$areOwnPropsEqua,
	        _ref2$areStatePropsEq = _ref2.areStatePropsEqual,
	        areStatePropsEqual = _ref2$areStatePropsEq === undefined ? _shallowEqual2.default : _ref2$areStatePropsEq,
	        _ref2$areMergedPropsE = _ref2.areMergedPropsEqual,
	        areMergedPropsEqual = _ref2$areMergedPropsE === undefined ? _shallowEqual2.default : _ref2$areMergedPropsE,
	        extraOptions = _objectWithoutProperties(_ref2, ['pure', 'areStatesEqual', 'areOwnPropsEqual', 'areStatePropsEqual', 'areMergedPropsEqual']);
	
	    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
	    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
	    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');
	
	    return connectHOC(selectorFactory, _extends({
	      // used in error messages
	      methodName: 'connect',
	
	      // used to compute Connect's displayName from the wrapped component's displayName.
	      getDisplayName: function getDisplayName(name) {
	        return 'Connect(' + name + ')';
	      },
	
	      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
	      shouldHandleStateChanges: Boolean(mapStateToProps),
	
	      // passed through to selectorFactory
	      initMapStateToProps: initMapStateToProps,
	      initMapDispatchToProps: initMapDispatchToProps,
	      initMergeProps: initMergeProps,
	      pure: pure,
	      areStatesEqual: areStatesEqual,
	      areOwnPropsEqual: areOwnPropsEqual,
	      areStatePropsEqual: areStatePropsEqual,
	      areMergedPropsEqual: areMergedPropsEqual
	
	    }, extraOptions));
	  };
	}
	
	exports.default = createConnect();

/***/ },
/* 527 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.whenMapDispatchToPropsIsFunction = whenMapDispatchToPropsIsFunction;
	exports.whenMapDispatchToPropsIsMissing = whenMapDispatchToPropsIsMissing;
	exports.whenMapDispatchToPropsIsObject = whenMapDispatchToPropsIsObject;
	
	var _redux = __webpack_require__(243);
	
	var _wrapMapToProps = __webpack_require__(233);
	
	function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
	  return typeof mapDispatchToProps === 'function' ? (0, _wrapMapToProps.wrapMapToPropsFunc)(mapDispatchToProps, 'mapDispatchToProps') : undefined;
	}
	
	function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
	  return !mapDispatchToProps ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function (dispatch) {
	    return { dispatch: dispatch };
	  }) : undefined;
	}
	
	function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
	  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function (dispatch) {
	    return (0, _redux.bindActionCreators)(mapDispatchToProps, dispatch);
	  }) : undefined;
	}
	
	exports.default = [whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject];

/***/ },
/* 528 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.whenMapStateToPropsIsFunction = whenMapStateToPropsIsFunction;
	exports.whenMapStateToPropsIsMissing = whenMapStateToPropsIsMissing;
	
	var _wrapMapToProps = __webpack_require__(233);
	
	function whenMapStateToPropsIsFunction(mapStateToProps) {
	  return typeof mapStateToProps === 'function' ? (0, _wrapMapToProps.wrapMapToPropsFunc)(mapStateToProps, 'mapStateToProps') : undefined;
	}
	
	function whenMapStateToPropsIsMissing(mapStateToProps) {
	  return !mapStateToProps ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function () {
	    return {};
	  }) : undefined;
	}
	
	exports.default = [whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing];

/***/ },
/* 529 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.defaultMergeProps = defaultMergeProps;
	exports.wrapMergePropsFunc = wrapMergePropsFunc;
	exports.whenMergePropsIsFunction = whenMergePropsIsFunction;
	exports.whenMergePropsIsOmitted = whenMergePropsIsOmitted;
	
	var _verifyPlainObject = __webpack_require__(236);
	
	var _verifyPlainObject2 = _interopRequireDefault(_verifyPlainObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function defaultMergeProps(stateProps, dispatchProps, ownProps) {
	  return _extends({}, ownProps, stateProps, dispatchProps);
	}
	
	function wrapMergePropsFunc(mergeProps) {
	  return function initMergePropsProxy(dispatch, _ref) {
	    var displayName = _ref.displayName,
	        pure = _ref.pure,
	        areMergedPropsEqual = _ref.areMergedPropsEqual;
	
	    var hasRunOnce = false;
	    var mergedProps = void 0;
	
	    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
	      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	
	      if (hasRunOnce) {
	        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
	      } else {
	        hasRunOnce = true;
	        mergedProps = nextMergedProps;
	
	        if (false) (0, _verifyPlainObject2.default)(mergedProps, displayName, 'mergeProps');
	      }
	
	      return mergedProps;
	    };
	  };
	}
	
	function whenMergePropsIsFunction(mergeProps) {
	  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
	}
	
	function whenMergePropsIsOmitted(mergeProps) {
	  return !mergeProps ? function () {
	    return defaultMergeProps;
	  } : undefined;
	}
	
	exports.default = [whenMergePropsIsFunction, whenMergePropsIsOmitted];

/***/ },
/* 530 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.impureFinalPropsSelectorFactory = impureFinalPropsSelectorFactory;
	exports.pureFinalPropsSelectorFactory = pureFinalPropsSelectorFactory;
	exports.default = finalPropsSelectorFactory;
	
	var _verifySubselectors = __webpack_require__(531);
	
	var _verifySubselectors2 = _interopRequireDefault(_verifySubselectors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
	  return function impureFinalPropsSelector(state, ownProps) {
	    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
	  };
	}
	
	function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
	  var areStatesEqual = _ref.areStatesEqual,
	      areOwnPropsEqual = _ref.areOwnPropsEqual,
	      areStatePropsEqual = _ref.areStatePropsEqual;
	
	  var hasRunAtLeastOnce = false;
	  var state = void 0;
	  var ownProps = void 0;
	  var stateProps = void 0;
	  var dispatchProps = void 0;
	  var mergedProps = void 0;
	
	  function handleFirstCall(firstState, firstOwnProps) {
	    state = firstState;
	    ownProps = firstOwnProps;
	    stateProps = mapStateToProps(state, ownProps);
	    dispatchProps = mapDispatchToProps(dispatch, ownProps);
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    hasRunAtLeastOnce = true;
	    return mergedProps;
	  }
	
	  function handleNewPropsAndNewState() {
	    stateProps = mapStateToProps(state, ownProps);
	
	    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
	
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    return mergedProps;
	  }
	
	  function handleNewProps() {
	    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
	
	    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
	
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    return mergedProps;
	  }
	
	  function handleNewState() {
	    var nextStateProps = mapStateToProps(state, ownProps);
	    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
	    stateProps = nextStateProps;
	
	    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	
	    return mergedProps;
	  }
	
	  function handleSubsequentCalls(nextState, nextOwnProps) {
	    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
	    var stateChanged = !areStatesEqual(nextState, state);
	    state = nextState;
	    ownProps = nextOwnProps;
	
	    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
	    if (propsChanged) return handleNewProps();
	    if (stateChanged) return handleNewState();
	    return mergedProps;
	  }
	
	  return function pureFinalPropsSelector(nextState, nextOwnProps) {
	    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
	  };
	}
	
	// TODO: Add more comments
	
	// If pure is true, the selector returned by selectorFactory will memoize its results,
	// allowing connectAdvanced's shouldComponentUpdate to return false if final
	// props have not changed. If false, the selector will always return a new
	// object and shouldComponentUpdate will always return true.
	
	function finalPropsSelectorFactory(dispatch, _ref2) {
	  var initMapStateToProps = _ref2.initMapStateToProps,
	      initMapDispatchToProps = _ref2.initMapDispatchToProps,
	      initMergeProps = _ref2.initMergeProps,
	      options = _objectWithoutProperties(_ref2, ['initMapStateToProps', 'initMapDispatchToProps', 'initMergeProps']);
	
	  var mapStateToProps = initMapStateToProps(dispatch, options);
	  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
	  var mergeProps = initMergeProps(dispatch, options);
	
	  if (false) {
	    (0, _verifySubselectors2.default)(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
	  }
	
	  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;
	
	  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
	}

/***/ },
/* 531 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = verifySubselectors;
	
	var _warning = __webpack_require__(140);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function verify(selector, methodName, displayName) {
	  if (!selector) {
	    throw new Error('Unexpected value for ' + methodName + ' in ' + displayName + '.');
	  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
	    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
	      (0, _warning2.default)('The selector for ' + methodName + ' of ' + displayName + ' did not specify a value for dependsOnOwnProps.');
	    }
	  }
	}
	
	function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
	  verify(mapStateToProps, 'mapStateToProps', displayName);
	  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
	  verify(mergeProps, 'mergeProps', displayName);
	}

/***/ },
/* 532 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	// encapsulates the subscription logic for connecting a component to the redux store, as
	// well as nesting subscriptions of descendant components, so that we can ensure the
	// ancestor components re-render before descendants
	
	var CLEARED = null;
	var nullListeners = {
	  notify: function notify() {}
	};
	
	function createListenerCollection() {
	  // the current/next pattern is copied from redux's createStore code.
	  // TODO: refactor+expose that code to be reusable here?
	  var current = [];
	  var next = [];
	
	  return {
	    clear: function clear() {
	      next = CLEARED;
	      current = CLEARED;
	    },
	    notify: function notify() {
	      var listeners = current = next;
	      for (var i = 0; i < listeners.length; i++) {
	        listeners[i]();
	      }
	    },
	    get: function get() {
	      return next;
	    },
	    subscribe: function subscribe(listener) {
	      var isSubscribed = true;
	      if (next === current) next = current.slice();
	      next.push(listener);
	
	      return function unsubscribe() {
	        if (!isSubscribed || current === CLEARED) return;
	        isSubscribed = false;
	
	        if (next === current) next = current.slice();
	        next.splice(next.indexOf(listener), 1);
	      };
	    }
	  };
	}
	
	var Subscription = function () {
	  function Subscription(store, parentSub, onStateChange) {
	    _classCallCheck(this, Subscription);
	
	    this.store = store;
	    this.parentSub = parentSub;
	    this.onStateChange = onStateChange;
	    this.unsubscribe = null;
	    this.listeners = nullListeners;
	  }
	
	  Subscription.prototype.addNestedSub = function addNestedSub(listener) {
	    this.trySubscribe();
	    return this.listeners.subscribe(listener);
	  };
	
	  Subscription.prototype.notifyNestedSubs = function notifyNestedSubs() {
	    this.listeners.notify();
	  };
	
	  Subscription.prototype.isSubscribed = function isSubscribed() {
	    return Boolean(this.unsubscribe);
	  };
	
	  Subscription.prototype.trySubscribe = function trySubscribe() {
	    if (!this.unsubscribe) {
	      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);
	
	      this.listeners = createListenerCollection();
	    }
	  };
	
	  Subscription.prototype.tryUnsubscribe = function tryUnsubscribe() {
	    if (this.unsubscribe) {
	      this.unsubscribe();
	      this.unsubscribe = null;
	      this.listeners.clear();
	      this.listeners = nullListeners;
	    }
	  };
	
	  return Subscription;
	}();
	
	exports.default = Subscription;

/***/ },
/* 533 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = shallowEqual;
	var hasOwn = Object.prototype.hasOwnProperty;
	
	function is(x, y) {
	  if (x === y) {
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    return x !== x && y !== y;
	  }
	}
	
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) return true;
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) return false;
	
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}

/***/ },
/* 534 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    (global.hoistNonReactStatics = factory());
	}(this, (function () {
	    'use strict';
	    
	    var REACT_STATICS = {
	        childContextTypes: true,
	        contextTypes: true,
	        defaultProps: true,
	        displayName: true,
	        getDefaultProps: true,
	        getDerivedStateFromProps: true,
	        mixins: true,
	        propTypes: true,
	        type: true
	    };
	    
	    var KNOWN_STATICS = {
	        name: true,
	        length: true,
	        prototype: true,
	        caller: true,
	        callee: true,
	        arguments: true,
	        arity: true
	    };
	    
	    var defineProperty = Object.defineProperty;
	    var getOwnPropertyNames = Object.getOwnPropertyNames;
	    var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	    var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	    var getPrototypeOf = Object.getPrototypeOf;
	    var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
	    
	    return function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	        if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	            
	            if (objectPrototype) {
	                var inheritedComponent = getPrototypeOf(sourceComponent);
	                if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                    hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	                }
	            }
	            
	            var keys = getOwnPropertyNames(sourceComponent);
	            
	            if (getOwnPropertySymbols) {
	                keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	            }
	            
	            for (var i = 0; i < keys.length; ++i) {
	                var key = keys[i];
	                if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
	                    var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                    try { // Avoid failures from read-only properties
	                        defineProperty(targetComponent, key, descriptor);
	                    } catch (e) {}
	                }
	            }
	            
	            return targetComponent;
	        }
	        
	        return targetComponent;
	    };
	})));


/***/ },
/* 535 */
[625, 237, 538, 539],
/* 536 */
200,
/* 537 */
[626, 540],
/* 538 */
[627, 237],
/* 539 */
464,
/* 540 */
210,
/* 541 */
[628, 536],
/* 542 */
24,
/* 543 */
[629, 535, 537, 542],
/* 544 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _warning = __webpack_require__(20);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createBrowserHistory = __webpack_require__(172);
	
	var _createBrowserHistory2 = _interopRequireDefault(_createBrowserHistory);
	
	var _Router = __webpack_require__(141);
	
	var _Router2 = _interopRequireDefault(_Router);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for a <Router> that uses HTML5 history.
	 */
	var BrowserRouter = function (_React$Component) {
	  _inherits(BrowserRouter, _React$Component);
	
	  function BrowserRouter() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, BrowserRouter);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = (0, _createBrowserHistory2.default)(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  BrowserRouter.prototype.componentWillMount = function componentWillMount() {
	    (0, _warning2.default)(!this.props.history, '<BrowserRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { BrowserRouter as Router }`.');
	  };
	
	  BrowserRouter.prototype.render = function render() {
	    return _react2.default.createElement(_Router2.default, { history: this.history, children: this.props.children });
	  };
	
	  return BrowserRouter;
	}(_react2.default.Component);
	
	BrowserRouter.propTypes = {
	  basename: _propTypes2.default.string,
	  forceRefresh: _propTypes2.default.bool,
	  getUserConfirmation: _propTypes2.default.func,
	  keyLength: _propTypes2.default.number,
	  children: _propTypes2.default.node
	};
	exports.default = BrowserRouter;

/***/ },
/* 545 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _warning = __webpack_require__(20);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createHashHistory = __webpack_require__(173);
	
	var _createHashHistory2 = _interopRequireDefault(_createHashHistory);
	
	var _Router = __webpack_require__(141);
	
	var _Router2 = _interopRequireDefault(_Router);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for a <Router> that uses window.location.hash.
	 */
	var HashRouter = function (_React$Component) {
	  _inherits(HashRouter, _React$Component);
	
	  function HashRouter() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, HashRouter);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = (0, _createHashHistory2.default)(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  HashRouter.prototype.componentWillMount = function componentWillMount() {
	    (0, _warning2.default)(!this.props.history, '<HashRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { HashRouter as Router }`.');
	  };
	
	  HashRouter.prototype.render = function render() {
	    return _react2.default.createElement(_Router2.default, { history: this.history, children: this.props.children });
	  };
	
	  return HashRouter;
	}(_react2.default.Component);
	
	HashRouter.propTypes = {
	  basename: _propTypes2.default.string,
	  getUserConfirmation: _propTypes2.default.func,
	  hashType: _propTypes2.default.oneOf(['hashbang', 'noslash', 'slash']),
	  children: _propTypes2.default.node
	};
	exports.default = HashRouter;

/***/ },
/* 546 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _MemoryRouter = __webpack_require__(554);
	
	var _MemoryRouter2 = _interopRequireDefault(_MemoryRouter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _MemoryRouter2.default; // Written in this round about way for babel-transform-imports

/***/ },
/* 547 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Route = __webpack_require__(239);
	
	var _Route2 = _interopRequireDefault(_Route);
	
	var _Link = __webpack_require__(238);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/**
	 * A <Link> wrapper that knows if it's "active" or not.
	 */
	var NavLink = function NavLink(_ref) {
	  var to = _ref.to,
	      exact = _ref.exact,
	      strict = _ref.strict,
	      location = _ref.location,
	      activeClassName = _ref.activeClassName,
	      className = _ref.className,
	      activeStyle = _ref.activeStyle,
	      style = _ref.style,
	      getIsActive = _ref.isActive,
	      ariaCurrent = _ref.ariaCurrent,
	      rest = _objectWithoutProperties(_ref, ['to', 'exact', 'strict', 'location', 'activeClassName', 'className', 'activeStyle', 'style', 'isActive', 'ariaCurrent']);
	
	  return _react2.default.createElement(_Route2.default, {
	    path: (typeof to === 'undefined' ? 'undefined' : _typeof(to)) === 'object' ? to.pathname : to,
	    exact: exact,
	    strict: strict,
	    location: location,
	    children: function children(_ref2) {
	      var location = _ref2.location,
	          match = _ref2.match;
	
	      var isActive = !!(getIsActive ? getIsActive(match, location) : match);
	
	      return _react2.default.createElement(_Link2.default, _extends({
	        to: to,
	        className: isActive ? [className, activeClassName].filter(function (i) {
	          return i;
	        }).join(' ') : className,
	        style: isActive ? _extends({}, style, activeStyle) : style,
	        'aria-current': isActive && ariaCurrent
	      }, rest));
	    }
	  });
	};
	
	NavLink.propTypes = {
	  to: _Link2.default.propTypes.to,
	  exact: _propTypes2.default.bool,
	  strict: _propTypes2.default.bool,
	  location: _propTypes2.default.object,
	  activeClassName: _propTypes2.default.string,
	  className: _propTypes2.default.string,
	  activeStyle: _propTypes2.default.object,
	  style: _propTypes2.default.object,
	  isActive: _propTypes2.default.func,
	  ariaCurrent: _propTypes2.default.oneOf(['page', 'step', 'location', 'true'])
	};
	
	NavLink.defaultProps = {
	  activeClassName: 'active',
	  ariaCurrent: 'true'
	};
	
	exports.default = NavLink;

/***/ },
/* 548 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Prompt = __webpack_require__(555);
	
	var _Prompt2 = _interopRequireDefault(_Prompt);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Prompt2.default; // Written in this round about way for babel-transform-imports

/***/ },
/* 549 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Redirect = __webpack_require__(556);
	
	var _Redirect2 = _interopRequireDefault(_Redirect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Redirect2.default; // Written in this round about way for babel-transform-imports

/***/ },
/* 550 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _StaticRouter = __webpack_require__(557);
	
	var _StaticRouter2 = _interopRequireDefault(_StaticRouter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _StaticRouter2.default; // Written in this round about way for babel-transform-imports

/***/ },
/* 551 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Switch = __webpack_require__(558);
	
	var _Switch2 = _interopRequireDefault(_Switch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Switch2.default; // Written in this round about way for babel-transform-imports

/***/ },
/* 552 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _matchPath = __webpack_require__(143);
	
	var _matchPath2 = _interopRequireDefault(_matchPath);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _matchPath2.default; // Written in this round about way for babel-transform-imports

/***/ },
/* 553 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _withRouter = __webpack_require__(561);
	
	var _withRouter2 = _interopRequireDefault(_withRouter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _withRouter2.default; // Written in this round about way for babel-transform-imports

/***/ },
/* 554 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _warning = __webpack_require__(20);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createMemoryHistory = __webpack_require__(174);
	
	var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);
	
	var _Router = __webpack_require__(142);
	
	var _Router2 = _interopRequireDefault(_Router);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for a <Router> that stores location in memory.
	 */
	var MemoryRouter = function (_React$Component) {
	  _inherits(MemoryRouter, _React$Component);
	
	  function MemoryRouter() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, MemoryRouter);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = (0, _createMemoryHistory2.default)(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  MemoryRouter.prototype.componentWillMount = function componentWillMount() {
	    (0, _warning2.default)(!this.props.history, '<MemoryRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { MemoryRouter as Router }`.');
	  };
	
	  MemoryRouter.prototype.render = function render() {
	    return _react2.default.createElement(_Router2.default, { history: this.history, children: this.props.children });
	  };
	
	  return MemoryRouter;
	}(_react2.default.Component);
	
	MemoryRouter.propTypes = {
	  initialEntries: _propTypes2.default.array,
	  initialIndex: _propTypes2.default.number,
	  getUserConfirmation: _propTypes2.default.func,
	  keyLength: _propTypes2.default.number,
	  children: _propTypes2.default.node
	};
	exports.default = MemoryRouter;

/***/ },
/* 555 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _invariant = __webpack_require__(21);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for prompting the user before navigating away
	 * from a screen with a component.
	 */
	var Prompt = function (_React$Component) {
	  _inherits(Prompt, _React$Component);
	
	  function Prompt() {
	    _classCallCheck(this, Prompt);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Prompt.prototype.enable = function enable(message) {
	    if (this.unblock) this.unblock();
	
	    this.unblock = this.context.router.history.block(message);
	  };
	
	  Prompt.prototype.disable = function disable() {
	    if (this.unblock) {
	      this.unblock();
	      this.unblock = null;
	    }
	  };
	
	  Prompt.prototype.componentWillMount = function componentWillMount() {
	    (0, _invariant2.default)(this.context.router, 'You should not use <Prompt> outside a <Router>');
	
	    if (this.props.when) this.enable(this.props.message);
	  };
	
	  Prompt.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (nextProps.when) {
	      if (!this.props.when || this.props.message !== nextProps.message) this.enable(nextProps.message);
	    } else {
	      this.disable();
	    }
	  };
	
	  Prompt.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.disable();
	  };
	
	  Prompt.prototype.render = function render() {
	    return null;
	  };
	
	  return Prompt;
	}(_react2.default.Component);
	
	Prompt.propTypes = {
	  when: _propTypes2.default.bool,
	  message: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]).isRequired
	};
	Prompt.defaultProps = {
	  when: true
	};
	Prompt.contextTypes = {
	  router: _propTypes2.default.shape({
	    history: _propTypes2.default.shape({
	      block: _propTypes2.default.func.isRequired
	    }).isRequired
	  }).isRequired
	};
	exports.default = Prompt;

/***/ },
/* 556 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__(20);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(21);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _history = __webpack_require__(357);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for updating the location programmatically
	 * with a component.
	 */
	var Redirect = function (_React$Component) {
	  _inherits(Redirect, _React$Component);
	
	  function Redirect() {
	    _classCallCheck(this, Redirect);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Redirect.prototype.isStatic = function isStatic() {
	    return this.context.router && this.context.router.staticContext;
	  };
	
	  Redirect.prototype.componentWillMount = function componentWillMount() {
	    (0, _invariant2.default)(this.context.router, 'You should not use <Redirect> outside a <Router>');
	
	    if (this.isStatic()) this.perform();
	  };
	
	  Redirect.prototype.componentDidMount = function componentDidMount() {
	    if (!this.isStatic()) this.perform();
	  };
	
	  Redirect.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    var prevTo = (0, _history.createLocation)(prevProps.to);
	    var nextTo = (0, _history.createLocation)(this.props.to);
	
	    if ((0, _history.locationsAreEqual)(prevTo, nextTo)) {
	      (0, _warning2.default)(false, 'You tried to redirect to the same route you\'re currently on: ' + ('"' + nextTo.pathname + nextTo.search + '"'));
	      return;
	    }
	
	    this.perform();
	  };
	
	  Redirect.prototype.perform = function perform() {
	    var history = this.context.router.history;
	    var _props = this.props,
	        push = _props.push,
	        to = _props.to;
	
	
	    if (push) {
	      history.push(to);
	    } else {
	      history.replace(to);
	    }
	  };
	
	  Redirect.prototype.render = function render() {
	    return null;
	  };
	
	  return Redirect;
	}(_react2.default.Component);
	
	Redirect.propTypes = {
	  push: _propTypes2.default.bool,
	  from: _propTypes2.default.string,
	  to: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]).isRequired
	};
	Redirect.defaultProps = {
	  push: false
	};
	Redirect.contextTypes = {
	  router: _propTypes2.default.shape({
	    history: _propTypes2.default.shape({
	      push: _propTypes2.default.func.isRequired,
	      replace: _propTypes2.default.func.isRequired
	    }).isRequired,
	    staticContext: _propTypes2.default.object
	  }).isRequired
	};
	exports.default = Redirect;

/***/ },
/* 557 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(20);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(21);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PathUtils = __webpack_require__(38);
	
	var _Router = __webpack_require__(142);
	
	var _Router2 = _interopRequireDefault(_Router);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var normalizeLocation = function normalizeLocation(object) {
	  var _object$pathname = object.pathname,
	      pathname = _object$pathname === undefined ? '/' : _object$pathname,
	      _object$search = object.search,
	      search = _object$search === undefined ? '' : _object$search,
	      _object$hash = object.hash,
	      hash = _object$hash === undefined ? '' : _object$hash;
	
	
	  return {
	    pathname: pathname,
	    search: search === '?' ? '' : search,
	    hash: hash === '#' ? '' : hash
	  };
	};
	
	var addBasename = function addBasename(basename, location) {
	  if (!basename) return location;
	
	  return _extends({}, location, {
	    pathname: (0, _PathUtils.addLeadingSlash)(basename) + location.pathname
	  });
	};
	
	var stripBasename = function stripBasename(basename, location) {
	  if (!basename) return location;
	
	  var base = (0, _PathUtils.addLeadingSlash)(basename);
	
	  if (location.pathname.indexOf(base) !== 0) return location;
	
	  return _extends({}, location, {
	    pathname: location.pathname.substr(base.length)
	  });
	};
	
	var createLocation = function createLocation(location) {
	  return typeof location === 'string' ? (0, _PathUtils.parsePath)(location) : normalizeLocation(location);
	};
	
	var createURL = function createURL(location) {
	  return typeof location === 'string' ? location : (0, _PathUtils.createPath)(location);
	};
	
	var staticHandler = function staticHandler(methodName) {
	  return function () {
	    (0, _invariant2.default)(false, 'You cannot %s with <StaticRouter>', methodName);
	  };
	};
	
	var noop = function noop() {};
	
	/**
	 * The public top-level API for a "static" <Router>, so-called because it
	 * can't actually change the current location. Instead, it just records
	 * location changes in a context object. Useful mainly in testing and
	 * server-rendering scenarios.
	 */
	
	var StaticRouter = function (_React$Component) {
	  _inherits(StaticRouter, _React$Component);
	
	  function StaticRouter() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, StaticRouter);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.createHref = function (path) {
	      return (0, _PathUtils.addLeadingSlash)(_this.props.basename + createURL(path));
	    }, _this.handlePush = function (location) {
	      var _this$props = _this.props,
	          basename = _this$props.basename,
	          context = _this$props.context;
	
	      context.action = 'PUSH';
	      context.location = addBasename(basename, createLocation(location));
	      context.url = createURL(context.location);
	    }, _this.handleReplace = function (location) {
	      var _this$props2 = _this.props,
	          basename = _this$props2.basename,
	          context = _this$props2.context;
	
	      context.action = 'REPLACE';
	      context.location = addBasename(basename, createLocation(location));
	      context.url = createURL(context.location);
	    }, _this.handleListen = function () {
	      return noop;
	    }, _this.handleBlock = function () {
	      return noop;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  StaticRouter.prototype.getChildContext = function getChildContext() {
	    return {
	      router: {
	        staticContext: this.props.context
	      }
	    };
	  };
	
	  StaticRouter.prototype.componentWillMount = function componentWillMount() {
	    (0, _warning2.default)(!this.props.history, '<StaticRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { StaticRouter as Router }`.');
	  };
	
	  StaticRouter.prototype.render = function render() {
	    var _props = this.props,
	        basename = _props.basename,
	        context = _props.context,
	        location = _props.location,
	        props = _objectWithoutProperties(_props, ['basename', 'context', 'location']);
	
	    var history = {
	      createHref: this.createHref,
	      action: 'POP',
	      location: stripBasename(basename, createLocation(location)),
	      push: this.handlePush,
	      replace: this.handleReplace,
	      go: staticHandler('go'),
	      goBack: staticHandler('goBack'),
	      goForward: staticHandler('goForward'),
	      listen: this.handleListen,
	      block: this.handleBlock
	    };
	
	    return _react2.default.createElement(_Router2.default, _extends({}, props, { history: history }));
	  };
	
	  return StaticRouter;
	}(_react2.default.Component);
	
	StaticRouter.propTypes = {
	  basename: _propTypes2.default.string,
	  context: _propTypes2.default.object.isRequired,
	  location: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object])
	};
	StaticRouter.defaultProps = {
	  basename: '',
	  location: '/'
	};
	StaticRouter.childContextTypes = {
	  router: _propTypes2.default.object.isRequired
	};
	exports.default = StaticRouter;

/***/ },
/* 558 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__(20);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(21);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _matchPath = __webpack_require__(143);
	
	var _matchPath2 = _interopRequireDefault(_matchPath);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for rendering the first <Route> that matches.
	 */
	var Switch = function (_React$Component) {
	  _inherits(Switch, _React$Component);
	
	  function Switch() {
	    _classCallCheck(this, Switch);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Switch.prototype.componentWillMount = function componentWillMount() {
	    (0, _invariant2.default)(this.context.router, 'You should not use <Switch> outside a <Router>');
	  };
	
	  Switch.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    (0, _warning2.default)(!(nextProps.location && !this.props.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');
	
	    (0, _warning2.default)(!(!nextProps.location && this.props.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
	  };
	
	  Switch.prototype.render = function render() {
	    var route = this.context.router.route;
	    var children = this.props.children;
	
	    var location = this.props.location || route.location;
	
	    var match = void 0,
	        child = void 0;
	    _react2.default.Children.forEach(children, function (element) {
	      if (!_react2.default.isValidElement(element)) return;
	
	      var _element$props = element.props,
	          pathProp = _element$props.path,
	          exact = _element$props.exact,
	          strict = _element$props.strict,
	          sensitive = _element$props.sensitive,
	          from = _element$props.from;
	
	      var path = pathProp || from;
	
	      if (match == null) {
	        child = element;
	        match = path ? (0, _matchPath2.default)(location.pathname, { path: path, exact: exact, strict: strict, sensitive: sensitive }) : route.match;
	      }
	    });
	
	    return match ? _react2.default.cloneElement(child, { location: location, computedMatch: match }) : null;
	  };
	
	  return Switch;
	}(_react2.default.Component);
	
	Switch.contextTypes = {
	  router: _propTypes2.default.shape({
	    route: _propTypes2.default.object.isRequired
	  }).isRequired
	};
	Switch.propTypes = {
	  children: _propTypes2.default.node,
	  location: _propTypes2.default.object
	};
	exports.default = Switch;

/***/ },
/* 559 */
/***/ function(module, exports) {

	module.exports = Array.isArray || function (arr) {
	  return Object.prototype.toString.call(arr) == '[object Array]';
	};


/***/ },
/* 560 */
/***/ function(module, exports, __webpack_require__) {

	var isarray = __webpack_require__(559)
	
	/**
	 * Expose `pathToRegexp`.
	 */
	module.exports = pathToRegexp
	module.exports.parse = parse
	module.exports.compile = compile
	module.exports.tokensToFunction = tokensToFunction
	module.exports.tokensToRegExp = tokensToRegExp
	
	/**
	 * The main path matching regexp utility.
	 *
	 * @type {RegExp}
	 */
	var PATH_REGEXP = new RegExp([
	  // Match escaped characters that would otherwise appear in future matches.
	  // This allows the user to escape special characters that won't transform.
	  '(\\\\.)',
	  // Match Express-style parameters and un-named parameters with a prefix
	  // and optional suffixes. Matches appear as:
	  //
	  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
	  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
	  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
	  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
	].join('|'), 'g')
	
	/**
	 * Parse a string for the raw tokens.
	 *
	 * @param  {string}  str
	 * @param  {Object=} options
	 * @return {!Array}
	 */
	function parse (str, options) {
	  var tokens = []
	  var key = 0
	  var index = 0
	  var path = ''
	  var defaultDelimiter = options && options.delimiter || '/'
	  var res
	
	  while ((res = PATH_REGEXP.exec(str)) != null) {
	    var m = res[0]
	    var escaped = res[1]
	    var offset = res.index
	    path += str.slice(index, offset)
	    index = offset + m.length
	
	    // Ignore already escaped sequences.
	    if (escaped) {
	      path += escaped[1]
	      continue
	    }
	
	    var next = str[index]
	    var prefix = res[2]
	    var name = res[3]
	    var capture = res[4]
	    var group = res[5]
	    var modifier = res[6]
	    var asterisk = res[7]
	
	    // Push the current path onto the tokens.
	    if (path) {
	      tokens.push(path)
	      path = ''
	    }
	
	    var partial = prefix != null && next != null && next !== prefix
	    var repeat = modifier === '+' || modifier === '*'
	    var optional = modifier === '?' || modifier === '*'
	    var delimiter = res[2] || defaultDelimiter
	    var pattern = capture || group
	
	    tokens.push({
	      name: name || key++,
	      prefix: prefix || '',
	      delimiter: delimiter,
	      optional: optional,
	      repeat: repeat,
	      partial: partial,
	      asterisk: !!asterisk,
	      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
	    })
	  }
	
	  // Match any characters still remaining.
	  if (index < str.length) {
	    path += str.substr(index)
	  }
	
	  // If the path exists, push it onto the end.
	  if (path) {
	    tokens.push(path)
	  }
	
	  return tokens
	}
	
	/**
	 * Compile a string to a template function for the path.
	 *
	 * @param  {string}             str
	 * @param  {Object=}            options
	 * @return {!function(Object=, Object=)}
	 */
	function compile (str, options) {
	  return tokensToFunction(parse(str, options))
	}
	
	/**
	 * Prettier encoding of URI path segments.
	 *
	 * @param  {string}
	 * @return {string}
	 */
	function encodeURIComponentPretty (str) {
	  return encodeURI(str).replace(/[\/?#]/g, function (c) {
	    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
	  })
	}
	
	/**
	 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
	 *
	 * @param  {string}
	 * @return {string}
	 */
	function encodeAsterisk (str) {
	  return encodeURI(str).replace(/[?#]/g, function (c) {
	    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
	  })
	}
	
	/**
	 * Expose a method for transforming tokens into the path function.
	 */
	function tokensToFunction (tokens) {
	  // Compile all the tokens into regexps.
	  var matches = new Array(tokens.length)
	
	  // Compile all the patterns before compilation.
	  for (var i = 0; i < tokens.length; i++) {
	    if (typeof tokens[i] === 'object') {
	      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$')
	    }
	  }
	
	  return function (obj, opts) {
	    var path = ''
	    var data = obj || {}
	    var options = opts || {}
	    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent
	
	    for (var i = 0; i < tokens.length; i++) {
	      var token = tokens[i]
	
	      if (typeof token === 'string') {
	        path += token
	
	        continue
	      }
	
	      var value = data[token.name]
	      var segment
	
	      if (value == null) {
	        if (token.optional) {
	          // Prepend partial segment prefixes.
	          if (token.partial) {
	            path += token.prefix
	          }
	
	          continue
	        } else {
	          throw new TypeError('Expected "' + token.name + '" to be defined')
	        }
	      }
	
	      if (isarray(value)) {
	        if (!token.repeat) {
	          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
	        }
	
	        if (value.length === 0) {
	          if (token.optional) {
	            continue
	          } else {
	            throw new TypeError('Expected "' + token.name + '" to not be empty')
	          }
	        }
	
	        for (var j = 0; j < value.length; j++) {
	          segment = encode(value[j])
	
	          if (!matches[i].test(segment)) {
	            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
	          }
	
	          path += (j === 0 ? token.prefix : token.delimiter) + segment
	        }
	
	        continue
	      }
	
	      segment = token.asterisk ? encodeAsterisk(value) : encode(value)
	
	      if (!matches[i].test(segment)) {
	        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
	      }
	
	      path += token.prefix + segment
	    }
	
	    return path
	  }
	}
	
	/**
	 * Escape a regular expression string.
	 *
	 * @param  {string} str
	 * @return {string}
	 */
	function escapeString (str) {
	  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
	}
	
	/**
	 * Escape the capturing group by escaping special characters and meaning.
	 *
	 * @param  {string} group
	 * @return {string}
	 */
	function escapeGroup (group) {
	  return group.replace(/([=!:$\/()])/g, '\\$1')
	}
	
	/**
	 * Attach the keys as a property of the regexp.
	 *
	 * @param  {!RegExp} re
	 * @param  {Array}   keys
	 * @return {!RegExp}
	 */
	function attachKeys (re, keys) {
	  re.keys = keys
	  return re
	}
	
	/**
	 * Get the flags for a regexp from the options.
	 *
	 * @param  {Object} options
	 * @return {string}
	 */
	function flags (options) {
	  return options.sensitive ? '' : 'i'
	}
	
	/**
	 * Pull out keys from a regexp.
	 *
	 * @param  {!RegExp} path
	 * @param  {!Array}  keys
	 * @return {!RegExp}
	 */
	function regexpToRegexp (path, keys) {
	  // Use a negative lookahead to match only capturing groups.
	  var groups = path.source.match(/\((?!\?)/g)
	
	  if (groups) {
	    for (var i = 0; i < groups.length; i++) {
	      keys.push({
	        name: i,
	        prefix: null,
	        delimiter: null,
	        optional: false,
	        repeat: false,
	        partial: false,
	        asterisk: false,
	        pattern: null
	      })
	    }
	  }
	
	  return attachKeys(path, keys)
	}
	
	/**
	 * Transform an array into a regexp.
	 *
	 * @param  {!Array}  path
	 * @param  {Array}   keys
	 * @param  {!Object} options
	 * @return {!RegExp}
	 */
	function arrayToRegexp (path, keys, options) {
	  var parts = []
	
	  for (var i = 0; i < path.length; i++) {
	    parts.push(pathToRegexp(path[i], keys, options).source)
	  }
	
	  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))
	
	  return attachKeys(regexp, keys)
	}
	
	/**
	 * Create a path regexp from string input.
	 *
	 * @param  {string}  path
	 * @param  {!Array}  keys
	 * @param  {!Object} options
	 * @return {!RegExp}
	 */
	function stringToRegexp (path, keys, options) {
	  return tokensToRegExp(parse(path, options), keys, options)
	}
	
	/**
	 * Expose a function for taking tokens and returning a RegExp.
	 *
	 * @param  {!Array}          tokens
	 * @param  {(Array|Object)=} keys
	 * @param  {Object=}         options
	 * @return {!RegExp}
	 */
	function tokensToRegExp (tokens, keys, options) {
	  if (!isarray(keys)) {
	    options = /** @type {!Object} */ (keys || options)
	    keys = []
	  }
	
	  options = options || {}
	
	  var strict = options.strict
	  var end = options.end !== false
	  var route = ''
	
	  // Iterate over the tokens and create our regexp string.
	  for (var i = 0; i < tokens.length; i++) {
	    var token = tokens[i]
	
	    if (typeof token === 'string') {
	      route += escapeString(token)
	    } else {
	      var prefix = escapeString(token.prefix)
	      var capture = '(?:' + token.pattern + ')'
	
	      keys.push(token)
	
	      if (token.repeat) {
	        capture += '(?:' + prefix + capture + ')*'
	      }
	
	      if (token.optional) {
	        if (!token.partial) {
	          capture = '(?:' + prefix + '(' + capture + '))?'
	        } else {
	          capture = prefix + '(' + capture + ')?'
	        }
	      } else {
	        capture = prefix + '(' + capture + ')'
	      }
	
	      route += capture
	    }
	  }
	
	  var delimiter = escapeString(options.delimiter || '/')
	  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter
	
	  // In non-strict mode we allow a slash at the end of match. If the path to
	  // match already ends with a slash, we remove it for consistency. The slash
	  // is valid at the end of a path match, not in the middle. This is important
	  // in non-ending mode, where "/test/" shouldn't match "/test//route".
	  if (!strict) {
	    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
	  }
	
	  if (end) {
	    route += '$'
	  } else {
	    // In non-ending mode, we need the capturing groups to match as much as
	    // possible by using a positive lookahead to the end or next path segment.
	    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
	  }
	
	  return attachKeys(new RegExp('^' + route, flags(options)), keys)
	}
	
	/**
	 * Normalize the given path string, returning a regular expression.
	 *
	 * An empty array can be passed in for the keys, which will hold the
	 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
	 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
	 *
	 * @param  {(string|RegExp|Array)} path
	 * @param  {(Array|Object)=}       keys
	 * @param  {Object=}               options
	 * @return {!RegExp}
	 */
	function pathToRegexp (path, keys, options) {
	  if (!isarray(keys)) {
	    options = /** @type {!Object} */ (keys || options)
	    keys = []
	  }
	
	  options = options || {}
	
	  if (path instanceof RegExp) {
	    return regexpToRegexp(path, /** @type {!Array} */ (keys))
	  }
	
	  if (isarray(path)) {
	    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
	  }
	
	  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
	}


/***/ },
/* 561 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _hoistNonReactStatics = __webpack_require__(358);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _Route = __webpack_require__(240);
	
	var _Route2 = _interopRequireDefault(_Route);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/**
	 * A public higher-order component to access the imperative API
	 */
	var withRouter = function withRouter(Component) {
	  var C = function C(props) {
	    var wrappedComponentRef = props.wrappedComponentRef,
	        remainingProps = _objectWithoutProperties(props, ['wrappedComponentRef']);
	
	    return _react2.default.createElement(_Route2.default, { render: function render(routeComponentProps) {
	        return _react2.default.createElement(Component, _extends({}, remainingProps, routeComponentProps, { ref: wrappedComponentRef }));
	      } });
	  };
	
	  C.displayName = 'withRouter(' + (Component.displayName || Component.name) + ')';
	  C.WrappedComponent = Component;
	  C.propTypes = {
	    wrappedComponentRef: _propTypes2.default.func
	  };
	
	  return (0, _hoistNonReactStatics2.default)(C, Component);
	};
	
	exports.default = withRouter;

/***/ },
/* 562 */
/***/ function(module, exports, __webpack_require__) {

	/** @license React v16.1.0
	 * react.production.min.js
	 *
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	'use strict';var m=__webpack_require__(565),n=__webpack_require__(564),p=__webpack_require__(563);
	function q(a){for(var b=arguments.length-1,e="Minified React error #"+a+"; visit http://facebook.github.io/react/docs/error-decoder.html?invariant\x3d"+a,d=0;d<b;d++)e+="\x26args[]\x3d"+encodeURIComponent(arguments[d+1]);b=Error(e+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings.");b.name="Invariant Violation";b.framesToPop=1;throw b;}
	var r={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}};function t(a,b,e){this.props=a;this.context=b;this.refs=n;this.updater=e||r}t.prototype.isReactComponent={};t.prototype.setState=function(a,b){"object"!==typeof a&&"function"!==typeof a&&null!=a?q("85"):void 0;this.updater.enqueueSetState(this,a,b,"setState")};t.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};
	function u(a,b,e){this.props=a;this.context=b;this.refs=n;this.updater=e||r}function v(){}v.prototype=t.prototype;var w=u.prototype=new v;w.constructor=u;m(w,t.prototype);w.isPureReactComponent=!0;function x(a,b,e){this.props=a;this.context=b;this.refs=n;this.updater=e||r}var y=x.prototype=new v;y.constructor=x;m(y,t.prototype);y.unstable_isAsyncReactComponent=!0;y.render=function(){return this.props.children};
	var z={current:null},A=Object.prototype.hasOwnProperty,B="function"===typeof Symbol&&Symbol["for"]&&Symbol["for"]("react.element")||60103,C={key:!0,ref:!0,__self:!0,__source:!0};
	function D(a,b,e){var d,c={},h=null,k=null;if(null!=b)for(d in void 0!==b.ref&&(k=b.ref),void 0!==b.key&&(h=""+b.key),b)A.call(b,d)&&!C.hasOwnProperty(d)&&(c[d]=b[d]);var f=arguments.length-2;if(1===f)c.children=e;else if(1<f){for(var g=Array(f),l=0;l<f;l++)g[l]=arguments[l+2];c.children=g}if(a&&a.defaultProps)for(d in f=a.defaultProps,f)void 0===c[d]&&(c[d]=f[d]);return{$$typeof:B,type:a,key:h,ref:k,props:c,_owner:z.current}}function E(a){return"object"===typeof a&&null!==a&&a.$$typeof===B}
	var F="function"===typeof Symbol&&Symbol.iterator,G="function"===typeof Symbol&&Symbol["for"]&&Symbol["for"]("react.element")||60103,H="function"===typeof Symbol&&Symbol["for"]&&Symbol["for"]("react.portal")||60106;function escape(a){var b={"\x3d":"\x3d0",":":"\x3d2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var I=/\/+/g,J=[];
	function K(a,b,e,d){if(J.length){var c=J.pop();c.result=a;c.keyPrefix=b;c.func=e;c.context=d;c.count=0;return c}return{result:a,keyPrefix:b,func:e,context:d,count:0}}function L(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>J.length&&J.push(a)}
	function M(a,b,e,d){var c=typeof a;if("undefined"===c||"boolean"===c)a=null;if(null===a||"string"===c||"number"===c||"object"===c&&a.$$typeof===G||"object"===c&&a.$$typeof===H)return e(d,a,""===b?"."+N(a,0):b),1;var h=0;b=""===b?".":b+":";if(Array.isArray(a))for(var k=0;k<a.length;k++){c=a[k];var f=b+N(c,k);h+=M(c,f,e,d)}else if(f=F&&a[F]||a["@@iterator"],"function"===typeof f)for(a=f.call(a),k=0;!(c=a.next()).done;)c=c.value,f=b+N(c,k++),h+=M(c,f,e,d);else"object"===c&&(e=""+a,q("31","[object Object]"===
	e?"object with keys {"+Object.keys(a).join(", ")+"}":e,""));return h}function N(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function O(a,b){a.func.call(a.context,b,a.count++)}
	function P(a,b,e){var d=a.result,c=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?Q(a,d,e,p.thatReturnsArgument):null!=a&&(E(a)&&(b=c+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(I,"$\x26/")+"/")+e,a={$$typeof:B,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}),d.push(a))}function Q(a,b,e,d,c){var h="";null!=e&&(h=(""+e).replace(I,"$\x26/")+"/");b=K(b,h,d,c);null==a||M(a,"",P,b);L(b)}"function"===typeof Symbol&&Symbol["for"]&&Symbol["for"]("react.fragment");
	var R={Children:{map:function(a,b,e){if(null==a)return a;var d=[];Q(a,d,null,b,e);return d},forEach:function(a,b,e){if(null==a)return a;b=K(null,null,b,e);null==a||M(a,"",O,b);L(b)},count:function(a){return null==a?0:M(a,"",p.thatReturnsNull,null)},toArray:function(a){var b=[];Q(a,b,null,p.thatReturnsArgument);return b},only:function(a){E(a)?void 0:q("143");return a}},Component:t,PureComponent:u,unstable_AsyncComponent:x,createElement:D,cloneElement:function(a,b,e){var d=m({},a.props),c=a.key,h=a.ref,
	k=a._owner;if(null!=b){void 0!==b.ref&&(h=b.ref,k=z.current);void 0!==b.key&&(c=""+b.key);if(a.type&&a.type.defaultProps)var f=a.type.defaultProps;for(g in b)A.call(b,g)&&!C.hasOwnProperty(g)&&(d[g]=void 0===b[g]&&void 0!==f?f[g]:b[g])}var g=arguments.length-2;if(1===g)d.children=e;else if(1<g){f=Array(g);for(var l=0;l<g;l++)f[l]=arguments[l+2];d.children=f}return{$$typeof:B,type:a.type,key:c,ref:h,props:d,_owner:k}},createFactory:function(a){var b=D.bind(null,a);b.type=a;return b},isValidElement:E,
	version:"16.1.0",__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{ReactCurrentOwner:z,assign:m}},S=Object.freeze({default:R}),T=S&&R||S;module.exports=T["default"]?T["default"]:T;


/***/ },
/* 563 */
231,
/* 564 */
518,
/* 565 */
505,
/* 566 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = applyMiddleware;
	
	var _compose = __webpack_require__(241);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * Creates a store enhancer that applies middleware to the dispatch method
	 * of the Redux store. This is handy for a variety of tasks, such as expressing
	 * asynchronous actions in a concise manner, or logging every action payload.
	 *
	 * See `redux-thunk` package as an example of the Redux middleware.
	 *
	 * Because middleware is potentially asynchronous, this should be the first
	 * store enhancer in the composition chain.
	 *
	 * Note that each middleware will be given the `dispatch` and `getState` functions
	 * as named arguments.
	 *
	 * @param {...Function} middlewares The middleware chain to be applied.
	 * @returns {Function} A store enhancer applying the middleware.
	 */
	function applyMiddleware() {
	  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  return function (createStore) {
	    return function (reducer, preloadedState, enhancer) {
	      var store = createStore(reducer, preloadedState, enhancer);
	      var _dispatch = store.dispatch;
	      var chain = [];
	
	      var middlewareAPI = {
	        getState: store.getState,
	        dispatch: function dispatch(action) {
	          return _dispatch(action);
	        }
	      };
	      chain = middlewares.map(function (middleware) {
	        return middleware(middlewareAPI);
	      });
	      _dispatch = _compose2['default'].apply(undefined, chain)(store.dispatch);
	
	      return _extends({}, store, {
	        dispatch: _dispatch
	      });
	    };
	  };
	}

/***/ },
/* 567 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = bindActionCreators;
	function bindActionCreator(actionCreator, dispatch) {
	  return function () {
	    return dispatch(actionCreator.apply(undefined, arguments));
	  };
	}
	
	/**
	 * Turns an object whose values are action creators, into an object with the
	 * same keys, but with every function wrapped into a `dispatch` call so they
	 * may be invoked directly. This is just a convenience method, as you can call
	 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
	 *
	 * For convenience, you can also pass a single function as the first argument,
	 * and get a function in return.
	 *
	 * @param {Function|Object} actionCreators An object whose values are action
	 * creator functions. One handy way to obtain it is to use ES6 `import * as`
	 * syntax. You may also pass a single function.
	 *
	 * @param {Function} dispatch The `dispatch` function available on your Redux
	 * store.
	 *
	 * @returns {Function|Object} The object mimicking the original object, but with
	 * every action creator wrapped into the `dispatch` call. If you passed a
	 * function as `actionCreators`, the return value will also be a single
	 * function.
	 */
	function bindActionCreators(actionCreators, dispatch) {
	  if (typeof actionCreators === 'function') {
	    return bindActionCreator(actionCreators, dispatch);
	  }
	
	  if (typeof actionCreators !== 'object' || actionCreators === null) {
	    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
	  }
	
	  var keys = Object.keys(actionCreators);
	  var boundActionCreators = {};
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    var actionCreator = actionCreators[key];
	    if (typeof actionCreator === 'function') {
	      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
	    }
	  }
	  return boundActionCreators;
	}

/***/ },
/* 568 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = combineReducers;
	
	var _createStore = __webpack_require__(242);
	
	var _isPlainObject = __webpack_require__(36);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _warning = __webpack_require__(244);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function getUndefinedStateErrorMessage(key, action) {
	  var actionType = action && action.type;
	  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';
	
	  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
	}
	
	function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
	  var reducerKeys = Object.keys(reducers);
	  var argumentName = action && action.type === _createStore.ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
	
	  if (reducerKeys.length === 0) {
	    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
	  }
	
	  if (!(0, _isPlainObject2['default'])(inputState)) {
	    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
	  }
	
	  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
	    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
	  });
	
	  unexpectedKeys.forEach(function (key) {
	    unexpectedKeyCache[key] = true;
	  });
	
	  if (unexpectedKeys.length > 0) {
	    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
	  }
	}
	
	function assertReducerShape(reducers) {
	  Object.keys(reducers).forEach(function (key) {
	    var reducer = reducers[key];
	    var initialState = reducer(undefined, { type: _createStore.ActionTypes.INIT });
	
	    if (typeof initialState === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
	    }
	
	    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
	    if (typeof reducer(undefined, { type: type }) === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + _createStore.ActionTypes.INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
	    }
	  });
	}
	
	/**
	 * Turns an object whose values are different reducer functions, into a single
	 * reducer function. It will call every child reducer, and gather their results
	 * into a single state object, whose keys correspond to the keys of the passed
	 * reducer functions.
	 *
	 * @param {Object} reducers An object whose values correspond to different
	 * reducer functions that need to be combined into one. One handy way to obtain
	 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
	 * undefined for any action. Instead, they should return their initial state
	 * if the state passed to them was undefined, and the current state for any
	 * unrecognized action.
	 *
	 * @returns {Function} A reducer function that invokes every reducer inside the
	 * passed object, and builds a state object with the same shape.
	 */
	function combineReducers(reducers) {
	  var reducerKeys = Object.keys(reducers);
	  var finalReducers = {};
	  for (var i = 0; i < reducerKeys.length; i++) {
	    var key = reducerKeys[i];
	
	    if (false) {
	      if (typeof reducers[key] === 'undefined') {
	        (0, _warning2['default'])('No reducer provided for key "' + key + '"');
	      }
	    }
	
	    if (typeof reducers[key] === 'function') {
	      finalReducers[key] = reducers[key];
	    }
	  }
	  var finalReducerKeys = Object.keys(finalReducers);
	
	  var unexpectedKeyCache = void 0;
	  if (false) {
	    unexpectedKeyCache = {};
	  }
	
	  var shapeAssertionError = void 0;
	  try {
	    assertReducerShape(finalReducers);
	  } catch (e) {
	    shapeAssertionError = e;
	  }
	
	  return function combination() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var action = arguments[1];
	
	    if (shapeAssertionError) {
	      throw shapeAssertionError;
	    }
	
	    if (false) {
	      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
	      if (warningMessage) {
	        (0, _warning2['default'])(warningMessage);
	      }
	    }
	
	    var hasChanged = false;
	    var nextState = {};
	    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
	      var _key = finalReducerKeys[_i];
	      var reducer = finalReducers[_key];
	      var previousStateForKey = state[_key];
	      var nextStateForKey = reducer(previousStateForKey, action);
	      if (typeof nextStateForKey === 'undefined') {
	        var errorMessage = getUndefinedStateErrorMessage(_key, action);
	        throw new Error(errorMessage);
	      }
	      nextState[_key] = nextStateForKey;
	      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
	    }
	    return hasChanged ? nextState : state;
	  };
	}

/***/ },
/* 569 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	function isAbsolute(pathname) {
	  return pathname.charAt(0) === '/';
	}
	
	// About 1.5x faster than the two-arg version of Array#splice()
	function spliceOne(list, index) {
	  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
	    list[i] = list[k];
	  }
	
	  list.pop();
	}
	
	// This implementation is based heavily on node's url.parse
	function resolvePathname(to) {
	  var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	
	  var toParts = to && to.split('/') || [];
	  var fromParts = from && from.split('/') || [];
	
	  var isToAbs = to && isAbsolute(to);
	  var isFromAbs = from && isAbsolute(from);
	  var mustEndAbs = isToAbs || isFromAbs;
	
	  if (to && isAbsolute(to)) {
	    // to is absolute
	    fromParts = toParts;
	  } else if (toParts.length) {
	    // to is relative, drop the filename
	    fromParts.pop();
	    fromParts = fromParts.concat(toParts);
	  }
	
	  if (!fromParts.length) return '/';
	
	  var hasTrailingSlash = void 0;
	  if (fromParts.length) {
	    var last = fromParts[fromParts.length - 1];
	    hasTrailingSlash = last === '.' || last === '..' || last === '';
	  } else {
	    hasTrailingSlash = false;
	  }
	
	  var up = 0;
	  for (var i = fromParts.length; i >= 0; i--) {
	    var part = fromParts[i];
	
	    if (part === '.') {
	      spliceOne(fromParts, i);
	    } else if (part === '..') {
	      spliceOne(fromParts, i);
	      up++;
	    } else if (up) {
	      spliceOne(fromParts, i);
	      up--;
	    }
	  }
	
	  if (!mustEndAbs) for (; up--; up) {
	    fromParts.unshift('..');
	  }if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !isAbsolute(fromParts[0]))) fromParts.unshift('');
	
	  var result = fromParts.join('/');
	
	  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';
	
	  return result;
	}
	
	exports.default = resolvePathname;
	module.exports = exports['default'];

/***/ },
/* 570 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, module) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ponyfill = __webpack_require__(571);
	
	var _ponyfill2 = _interopRequireDefault(_ponyfill);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var root; /* global window */
	
	
	if (typeof self !== 'undefined') {
	  root = self;
	} else if (typeof window !== 'undefined') {
	  root = window;
	} else if (typeof global !== 'undefined') {
	  root = global;
	} else if (true) {
	  root = module;
	} else {
	  root = Function('return this')();
	}
	
	var result = (0, _ponyfill2['default'])(root);
	exports['default'] = result;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(99)(module)))

/***/ },
/* 571 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports['default'] = symbolObservablePonyfill;
	function symbolObservablePonyfill(root) {
		var result;
		var _Symbol = root.Symbol;
	
		if (typeof _Symbol === 'function') {
			if (_Symbol.observable) {
				result = _Symbol.observable;
			} else {
				result = _Symbol('observable');
				_Symbol.observable = result;
			}
		} else {
			result = '@@observable';
		}
	
		return result;
	};

/***/ },
/* 572 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 573 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/passport.a2a0404c.png";

/***/ },
/* 574 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/selfie.2dfbe418.png";

/***/ },
/* 575 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function valueEqual(a, b) {
	  if (a === b) return true;
	
	  if (a == null || b == null) return false;
	
	  if (Array.isArray(a)) {
	    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
	      return valueEqual(item, b[index]);
	    });
	  }
	
	  var aType = typeof a === 'undefined' ? 'undefined' : _typeof(a);
	  var bType = typeof b === 'undefined' ? 'undefined' : _typeof(b);
	
	  if (aType !== bType) return false;
	
	  if (aType === 'object') {
	    var aValue = a.valueOf();
	    var bValue = b.valueOf();
	
	    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);
	
	    var aKeys = Object.keys(a);
	    var bKeys = Object.keys(b);
	
	    if (aKeys.length !== bKeys.length) return false;
	
	    return aKeys.every(function (key) {
	      return valueEqual(a[key], b[key]);
	    });
	  }
	
	  return false;
	}
	
	exports.default = valueEqual;
	module.exports = exports['default'];

/***/ },
/* 576 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.makeCreateContainerFunction = exports.combineContainerMixins = undefined;
	
	var _flow2 = __webpack_require__(486);
	
	var _flow3 = _interopRequireDefault(_flow2);
	
	var _includes2 = __webpack_require__(94);
	
	var _includes3 = _interopRequireDefault(_includes2);
	
	var _forOwn2 = __webpack_require__(487);
	
	var _forOwn3 = _interopRequireDefault(_forOwn2);
	
	var _groupBy2 = __webpack_require__(130);
	
	var _groupBy3 = _interopRequireDefault(_groupBy2);
	
	var _toPairs2 = __webpack_require__(501);
	
	var _toPairs3 = _interopRequireDefault(_toPairs2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _victoryCore = __webpack_require__(3);
	
	var _victoryVoronoiContainer = __webpack_require__(252);
	
	var _victoryZoomContainer = __webpack_require__(253);
	
	var _victorySelectionContainer = __webpack_require__(251);
	
	var _victoryBrushContainer = __webpack_require__(249);
	
	var _victoryCursorContainer = __webpack_require__(250);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ensureArray = function (thing) {
	  if (!thing) {
	    return [];
	  } else if (!Array.isArray(thing)) {
	    return [thing];
	  } else {
	    return thing;
	  }
	};
	
	var combineEventHandlers = function (eventHandlersArray) {
	  // takes an array of event handler objects and produces one eventHandlers object
	  // creates a custom combinedHandler() for events with multiple conflicting handlers
	  return eventHandlersArray.reduce(function (localHandlers, finalHandlers) {
	    (0, _forOwn3.default)(localHandlers, function (localHandler, eventName) {
	      var existingHandler = finalHandlers[eventName];
	      if (existingHandler) {
	        // create new handler for event that concats the existing handler's mutations with new ones
	        finalHandlers[eventName] = function combinedHandler() {
	          // named for debug clarity
	          // sometimes handlers return undefined; use empty array instead, for concat()
	          var existingMutations = ensureArray(existingHandler.apply(undefined, arguments));
	          var localMutations = ensureArray(localHandler.apply(undefined, arguments));
	          return existingMutations.concat(localMutations);
	        };
	      } else {
	        finalHandlers[eventName] = localHandler;
	      }
	    });
	    return finalHandlers;
	  });
	};
	
	var combineDefaultEvents = function (defaultEvents) {
	  // takes a defaultEvents array and returns one equal or lesser length,
	  // by combining any events that have the same target
	  var eventsByTarget = (0, _groupBy3.default)(defaultEvents, "target");
	  return (0, _toPairs3.default)(eventsByTarget).map(function (_ref) {
	    var _ref2 = _slicedToArray(_ref, 2),
	        target = _ref2[0],
	        eventsArray = _ref2[1];
	
	    return {
	      target: target,
	      eventHandlers: combineEventHandlers(eventsArray.map(function (event) {
	        return event.eventHandlers;
	      }))
	      // note: does not currently handle eventKey or childName
	    };
	  });
	};
	
	var combineContainerMixins = exports.combineContainerMixins = function (mixins, Container) {
	  var _class, _temp;
	
	  // similar to Object.assign(A, B), this function will decide conflicts in favor mixinB.
	  // this applies to propTypes and defaultProps.
	  // getChildren will call A's getChildren() and pass the resulting children to B's.
	  // defaultEvents attempts to resolve any conflicts between A and B's defaultEvents.
	
	  var Classes = mixins.map(function (mixin) {
	    return mixin(Container);
	  });
	  var instances = Classes.map(function (Class) {
	    return new Class();
	  });
	  var NaiveCombinedContainer = (0, _flow3.default)(mixins)(Container);
	
	  var displayType = Classes.map(function (Class) {
	    var match = Class.displayName.match(/Victory(.*)Container/);
	    return match[1] || "";
	  }).join("");
	
	  return _temp = _class = function (_NaiveCombinedContain) {
	    _inherits(VictoryCombinedContainer, _NaiveCombinedContain);
	
	    function VictoryCombinedContainer() {
	      _classCallCheck(this, VictoryCombinedContainer);
	
	      return _possibleConstructorReturn(this, (VictoryCombinedContainer.__proto__ || Object.getPrototypeOf(VictoryCombinedContainer)).apply(this, arguments));
	    }
	
	    _createClass(VictoryCombinedContainer, [{
	      key: "getChildren",
	      value: function getChildren(props) {
	        return instances.reduce(function (children, instance) {
	          return instance.getChildren(_extends({}, props, { children: children }));
	        }, props.children);
	      }
	    }]);
	
	    return VictoryCombinedContainer;
	  }(NaiveCombinedContainer), _class.displayName = "Victory" + displayType + "Container", _class.propTypes = Classes.reduce(function (propTypes, Class) {
	    return _extends({}, propTypes, Class.propTypes);
	  }, {}), _class.defaultProps = Classes.reduce(function (defaultProps, Class) {
	    return _extends({}, defaultProps, Class.defaultProps);
	  }, {}), _class.defaultEvents = combineDefaultEvents(Classes.reduce(function (defaultEvents, Class) {
	    return [].concat(_toConsumableArray(defaultEvents), _toConsumableArray(Class.defaultEvents));
	  }, [])), _temp;
	};
	
	var checkBehaviorName = function (behavior, behaviors) {
	  if (behavior && !(0, _includes3.default)(behaviors, behavior)) {
	    _victoryCore.Log.warn("\"" + behavior + "\" is not a valid behavior. Choose from [" + behaviors.join(", ") + "].");
	  }
	};
	
	var makeCreateContainerFunction = exports.makeCreateContainerFunction = function (mixinMap, Container) {
	  return function (behaviorA, behaviorB) {
	    // eslint-disable-line
	    var behaviors = Object.keys(mixinMap);
	
	    checkBehaviorName(behaviorA, behaviors);
	    checkBehaviorName(behaviorB, behaviors);
	
	    if (arguments.length <= 2 ? 0 : arguments.length - 2) {
	      _victoryCore.Log.warn("too many arguments given to createContainer (maximum accepted: 2).");
	    }
	
	    var firstMixins = mixinMap[behaviorA];
	    var secondMixins = mixinMap[behaviorB] || [];
	
	    if (!firstMixins) {
	      return Container;
	    }
	
	    return combineContainerMixins([].concat(_toConsumableArray(firstMixins), _toConsumableArray(secondMixins)), Container);
	  };
	};
	
	exports.default = makeCreateContainerFunction({
	  zoom: [_victoryZoomContainer.zoomContainerMixin],
	  voronoi: [_victoryVoronoiContainer.voronoiContainerMixin],
	  selection: [_victorySelectionContainer.selectionContainerMixin],
	  cursor: [_victoryCursorContainer.cursorContainerMixin],
	  brush: [_victoryBrushContainer.brushContainerMixin]
	}, _victoryCore.VictoryContainer);

/***/ },
/* 577 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign2 = __webpack_require__(4);
	
	var _assign3 = _interopRequireDefault(_assign2);
	
	var _victoryCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	exports.default = {
	  getBaseProps: function (props, fallbackProps) {
	    var modifiedProps = _victoryCore.Helpers.modifyProps(props, fallbackProps, "area");
	    props = (0, _assign3.default)({}, modifiedProps, this.getCalculatedValues(modifiedProps));
	    var _props = props,
	        data = _props.data,
	        domain = _props.domain,
	        events = _props.events,
	        groupComponent = _props.groupComponent,
	        height = _props.height,
	        interpolation = _props.interpolation,
	        origin = _props.origin,
	        padding = _props.padding,
	        polar = _props.polar,
	        scale = _props.scale,
	        sharedEvents = _props.sharedEvents,
	        standalone = _props.standalone,
	        style = _props.style,
	        theme = _props.theme,
	        width = _props.width;
	
	    var initialChildProps = {
	      parent: {
	        style: style.parent, width: width, height: height, scale: scale, data: data, domain: domain,
	        standalone: standalone, theme: theme, polar: polar, origin: origin, padding: padding
	      },
	      all: {
	        data: { polar: polar, origin: origin, scale: scale, data: data, interpolation: interpolation, groupComponent: groupComponent, style: style.data }
	      }
	    };
	    return data.reduce(function (childProps, datum, index) {
	      var text = _victoryCore.LabelHelpers.getText(props, datum, index);
	      if (text !== undefined && text !== null || events || sharedEvents) {
	        var eventKey = datum.eventKey || index;
	        childProps[eventKey] = { labels: _victoryCore.LabelHelpers.getProps(props, index) };
	      }
	      return childProps;
	    }, initialChildProps);
	  },
	  getCalculatedValues: function (props) {
	    var theme = props.theme,
	        polar = props.polar;
	
	    var defaultStyles = theme && theme.area && theme.area.style ? theme.area.style : {};
	    var style = _victoryCore.Helpers.getStyles(props.style, defaultStyles);
	    var range = {
	      x: _victoryCore.Helpers.getRange(props, "x"),
	      y: _victoryCore.Helpers.getRange(props, "y")
	    };
	    var domain = {
	      x: _victoryCore.Domain.getDomainWithZero(props, "x"),
	      y: _victoryCore.Domain.getDomainWithZero(props, "y")
	    };
	    var scale = {
	      x: _victoryCore.Scale.getBaseScale(props, "x").domain(domain.x).range(range.x),
	      y: _victoryCore.Scale.getBaseScale(props, "y").domain(domain.y).range(range.y)
	    };
	    var origin = polar ? props.origin || _victoryCore.Helpers.getPolarOrigin(props) : undefined;
	    var data = this.getDataWithBaseline(props, scale);
	    return { style: style, data: data, scale: scale, domain: domain, origin: origin };
	  },
	  getDataWithBaseline: function (props, scale) {
	    var data = _victoryCore.Data.getData(props);
	
	    if (data.length < 2) {
	      data = [];
	    }
	    var defaultMin = _victoryCore.Scale.getType(scale.y) === "log" ? 1 / Number.MAX_SAFE_INTEGER : 0;
	    var domainY = scale.y.domain();
	    var minY = Math.min.apply(Math, _toConsumableArray(domainY)) > 0 ? Math.min.apply(Math, _toConsumableArray(domainY)) : defaultMin;
	
	    return data.map(function (datum) {
	      var _y1 = datum._y1 !== undefined ? datum._y1 : datum._y;
	      var _y0 = datum._y0 !== undefined ? datum._y0 : minY;
	      return (0, _assign3.default)({}, datum, { _y0: _y0, _y1: _y1 });
	    });
	  }
	};

/***/ },
/* 578 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _partialRight2 = __webpack_require__(16);
	
	var _partialRight3 = _interopRequireDefault(_partialRight2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _helperMethods = __webpack_require__(577);
	
	var _helperMethods2 = _interopRequireDefault(_helperMethods);
	
	var _victoryCore = __webpack_require__(3);
	
	var _commonProps = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var fallbackProps = {
	  width: 450,
	  height: 300,
	  padding: 50,
	  interpolation: "linear"
	};
	
	var options = {
	  components: [{ name: "parent", index: "parent" }, { name: "data", index: "all" }, { name: "labels" }]
	};
	
	var animationWhitelist = ["data", "domain", "height", "padding", "style", "width"];
	
	var VictoryArea = function (_React$Component) {
	  _inherits(VictoryArea, _React$Component);
	
	  function VictoryArea() {
	    _classCallCheck(this, VictoryArea);
	
	    return _possibleConstructorReturn(this, (VictoryArea.__proto__ || Object.getPrototypeOf(VictoryArea)).apply(this, arguments));
	  }
	
	  _createClass(VictoryArea, [{
	    key: "shouldAnimate",
	
	
	    // Overridden in native versions
	    value: function shouldAnimate() {
	      return !!this.props.animate;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var role = this.constructor.role;
	
	      var props = _victoryCore.Helpers.modifyProps(this.props, fallbackProps, role);
	
	      if (this.shouldAnimate()) {
	        return this.animateComponent(props, animationWhitelist);
	      }
	      var children = this.renderContinuousData(props);
	      return props.standalone ? this.renderContainer(props.containerComponent, children) : children;
	    }
	  }]);
	
	  return VictoryArea;
	}(_react2.default.Component);
	
	VictoryArea.propTypes = _extends({}, _commonProps.BaseProps, _commonProps.DataProps, {
	  interpolation: _propTypes2.default.oneOf(["basis", "cardinal", "catmullRom", "linear", "monotoneX", "monotoneY", "natural", "step", "stepAfter", "stepBefore"]),
	  label: _victoryCore.PropTypes.deprecated(_propTypes2.default.string, "Use `labels` instead for individual data labels")
	});
	VictoryArea.defaultProps = {
	  containerComponent: _react2.default.createElement(_victoryCore.VictoryContainer, null),
	  dataComponent: _react2.default.createElement(_victoryCore.Area, null),
	  groupComponent: _react2.default.createElement(_victoryCore.VictoryClipContainer, null),
	  labelComponent: _react2.default.createElement(_victoryCore.VictoryLabel, { renderInPortal: true }),
	  samples: 50,
	  scale: "linear",
	  sortKey: "x",
	  sortOrder: "ascending",
	  standalone: true,
	  theme: _victoryCore.VictoryTheme.grayscale
	};
	VictoryArea.displayName = "VictoryArea";
	VictoryArea.role = "area";
	VictoryArea.continuous = true;
	VictoryArea.defaultTransitions = _victoryCore.DefaultTransitions.continuousTransitions();
	VictoryArea.defaultPolarTransitions = _victoryCore.DefaultTransitions.continuousPolarTransitions();
	VictoryArea.getDomain = _victoryCore.Domain.getDomainWithZero.bind(_victoryCore.Domain);
	VictoryArea.getData = _victoryCore.Data.getData.bind(_victoryCore.Data);
	VictoryArea.getBaseProps = (0, _partialRight3.default)(_helperMethods2.default.getBaseProps.bind(_helperMethods2.default), fallbackProps);
	VictoryArea.expectedComponents = ["dataComponent", "labelComponent", "groupComponent", "containerComponent"];
	exports.default = (0, _victoryCore.addEvents)(VictoryArea, options);

/***/ },
/* 579 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isFunction2 = __webpack_require__(7);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _defaultsDeep2 = __webpack_require__(217);
	
	var _defaultsDeep3 = _interopRequireDefault(_defaultsDeep2);
	
	var _defaults2 = __webpack_require__(5);
	
	var _defaults3 = _interopRequireDefault(_defaults2);
	
	var _axis = __webpack_require__(45);
	
	var _axis2 = _interopRequireDefault(_axis);
	
	var _victoryCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var orientationSign = {
	  top: -1,
	  left: -1,
	  right: 1,
	  bottom: 1
	};
	
	exports.default = {
	  evaluateProp: function (prop, data, index) {
	    return (0, _isFunction3.default)(prop) ? prop(data, index) : prop;
	  },
	  evaluateStyle: function (style, data, index) {
	    var _this = this;
	
	    if (!style || !Object.keys(style).some(function (value) {
	      return (0, _isFunction3.default)(style[value]);
	    })) {
	      return style;
	    }
	    return Object.keys(style).reduce(function (prev, curr) {
	      prev[curr] = _this.evaluateProp(style[curr], data, index);
	      return prev;
	    }, {});
	  },
	
	
	  // exposed for use by VictoryChart
	  getDomain: function (props, axis) {
	    var inherentAxis = this.getAxis(props);
	    if (axis && axis !== inherentAxis) {
	      return undefined;
	    }
	    var domain = void 0;
	    if (Array.isArray(props.domain)) {
	      domain = props.domain;
	    } else if (props.domain && props.domain[inherentAxis]) {
	      domain = props.domain[inherentAxis];
	    } else if (Array.isArray(props.tickValues) && props.tickValues.length > 1) {
	      domain = _victoryCore.Domain.getDomainFromTickValues(props, axis);
	    }
	    var paddedDomain = _victoryCore.Domain.padDomain(domain, props, inherentAxis);
	    return domain ? _victoryCore.Domain.cleanDomain(paddedDomain, props, inherentAxis) : undefined;
	  },
	
	
	  // exposed for use by VictoryChart
	  getAxis: function (props, flipped) {
	    if (props.orientation) {
	      var vertical = { top: "x", bottom: "x", left: "y", right: "y" };
	      return vertical[props.orientation];
	    }
	    var axisType = props.dependentAxis ? "dependent" : "independent";
	    var flippedAxis = { dependent: "x", independent: "y" };
	    var normalAxis = { independent: "x", dependent: "y" };
	    return flipped ? flippedAxis[axisType] : normalAxis[axisType];
	  },
	
	
	  // exposed for use by VictoryChart
	  getScale: function (props) {
	    var axis = this.getAxis(props);
	    var scale = _victoryCore.Scale.getBaseScale(props, axis);
	    var domain = this.getDomain(props) || scale.domain();
	    scale.range(_victoryCore.Helpers.getRange(props, axis));
	    scale.domain(domain);
	    return scale;
	  },
	  getStyleObject: function (props) {
	    var theme = props.theme,
	        dependentAxis = props.dependentAxis;
	
	    var generalAxisStyle = theme && theme.axis && theme.axis.style;
	    var axisType = dependentAxis ? "dependentAxis" : "independentAxis";
	    var specificAxisStyle = theme && theme[axisType] && theme[axisType].style;
	
	    return generalAxisStyle && specificAxisStyle ? (0, _defaultsDeep3.default)({}, specificAxisStyle, generalAxisStyle) : specificAxisStyle || generalAxisStyle;
	  },
	  getStyles: function (props, styleObject) {
	    var style = props.style || {};
	    styleObject = styleObject || {};
	    var parentStyleProps = { height: "100%", width: "100%" };
	    return {
	      parent: (0, _defaults3.default)(style.parent, styleObject.parent, parentStyleProps),
	      axis: (0, _defaults3.default)({}, style.axis, styleObject.axis),
	      axisLabel: (0, _defaults3.default)({}, style.axisLabel, styleObject.axisLabel),
	      grid: (0, _defaults3.default)({}, style.grid, styleObject.grid),
	      ticks: (0, _defaults3.default)({}, style.ticks, styleObject.ticks),
	      tickLabels: (0, _defaults3.default)({}, style.tickLabels, styleObject.tickLabels)
	    };
	  },
	  getTickProps: function (layout, style, datum) {
	    var position = layout.position,
	        transform = layout.transform;
	
	    return {
	      x1: transform.x,
	      y1: transform.y,
	      x2: transform.x + position.x2,
	      y2: transform.y + position.y2,
	      style: style,
	      datum: datum
	    };
	  },
	  getTickLabelProps: function (layout, style, anchors, datum, text) {
	    // eslint-disable-line max-params
	    var position = layout.position,
	        transform = layout.transform;
	
	    return {
	      style: style,
	      x: transform.x + position.x,
	      y: transform.y + position.y,
	      verticalAnchor: anchors.verticalAnchor,
	      textAnchor: anchors.textAnchor,
	      angle: style.angle,
	      text: text,
	      datum: datum
	    };
	  },
	  getGridProps: function (layout, style, datum) {
	    var edge = layout.edge,
	        transform = layout.transform;
	
	    return {
	      x1: transform.x,
	      y1: transform.y,
	      x2: edge.x + transform.x,
	      y2: edge.y + transform.y,
	      style: style,
	      datum: datum
	    };
	  },
	  getAxisProps: function (modifiedProps, calculatedValues, globalTransform) {
	    var style = calculatedValues.style,
	        padding = calculatedValues.padding,
	        isVertical = calculatedValues.isVertical;
	    var width = modifiedProps.width,
	        height = modifiedProps.height;
	
	    return {
	      style: style.axis,
	      x1: isVertical ? globalTransform.x : padding.left + globalTransform.x,
	      x2: isVertical ? globalTransform.x : width - padding.right + globalTransform.x,
	      y1: isVertical ? padding.top + globalTransform.y : globalTransform.y,
	      y2: isVertical ? height - padding.bottom + globalTransform.y : globalTransform.y
	    };
	  },
	  getLayoutProps: function (modifiedProps, calculatedValues) {
	    var offset = this.getOffset(modifiedProps, calculatedValues);
	    return {
	      globalTransform: this.getTransform(modifiedProps, calculatedValues, offset),
	      gridOffset: this.getGridOffset(modifiedProps, calculatedValues, offset),
	      gridEdge: this.getGridEdge(modifiedProps, calculatedValues)
	    };
	  },
	  getEvaluatedStyles: function (style, tick, index) {
	    return {
	      tickStyle: this.evaluateStyle(style.ticks, tick, index),
	      labelStyle: this.evaluateStyle(style.tickLabels, tick, index),
	      gridStyle: this.evaluateStyle(style.grid, tick, index)
	    };
	  },
	  getRole: function (props) {
	    if (props.dependentAxis) {
	      return props.theme && props.theme.dependentAxis ? "dependentAxis" : "axis";
	    }
	
	    return props.theme && props.theme.independentAxis ? "independentAxis" : "axis";
	  },
	  getShallowMergedThemeProps: function (props, role) {
	    var axisTheme = props.theme.axis || {};
	    return (0, _defaults3.default)({}, props.theme[role], axisTheme);
	  },
	  modifyProps: function (props, fallbackProps, role) {
	    if (role !== "axis") {
	      props.theme[role] = this.getShallowMergedThemeProps(props, role);
	    }
	    return _victoryCore.Helpers.modifyProps(props, fallbackProps, role);
	  },
	  getBaseProps: function (props, fallbackProps) {
	    var _this2 = this;
	
	    var role = this.getRole(props);
	    props = this.modifyProps(props, fallbackProps, role);
	    var calculatedValues = this.getCalculatedValues(props);
	    var style = calculatedValues.style,
	        orientation = calculatedValues.orientation,
	        isVertical = calculatedValues.isVertical,
	        scale = calculatedValues.scale,
	        ticks = calculatedValues.ticks,
	        tickFormat = calculatedValues.tickFormat,
	        anchors = calculatedValues.anchors,
	        domain = calculatedValues.domain,
	        stringTicks = calculatedValues.stringTicks;
	    var _props = props,
	        width = _props.width,
	        height = _props.height,
	        standalone = _props.standalone,
	        theme = _props.theme,
	        polar = _props.polar,
	        padding = _props.padding;
	
	    var _getLayoutProps = this.getLayoutProps(props, calculatedValues),
	        globalTransform = _getLayoutProps.globalTransform,
	        gridOffset = _getLayoutProps.gridOffset,
	        gridEdge = _getLayoutProps.gridEdge;
	
	    var axisProps = this.getAxisProps(props, calculatedValues, globalTransform);
	    var axisLabelProps = this.getAxisLabelProps(props, calculatedValues, globalTransform);
	    var initialChildProps = { parent: {
	        style: style.parent, ticks: ticks, scale: scale, width: width, height: height, domain: domain, standalone: standalone, theme: theme, polar: polar, padding: padding
	      } };
	
	    return ticks.reduce(function (childProps, tick, index) {
	      var originalTick = stringTicks ? stringTicks[index] : tick;
	      var styles = _this2.getEvaluatedStyles(style, originalTick, index);
	      var tickLayout = {
	        position: _this2.getTickPosition(styles, orientation, isVertical),
	        transform: _this2.getTickTransform(scale(tick), globalTransform, isVertical)
	      };
	
	      var gridLayout = {
	        edge: gridEdge,
	        transform: {
	          x: isVertical ? -gridOffset.x + globalTransform.x : scale(tick) + globalTransform.x,
	          y: isVertical ? scale(tick) + globalTransform.y : gridOffset.y + globalTransform.y
	        }
	      };
	      childProps[index] = {
	        axis: axisProps,
	        axisLabel: axisLabelProps,
	        ticks: _this2.getTickProps(tickLayout, styles.tickStyle, tick),
	        tickLabels: _this2.getTickLabelProps(tickLayout, styles.labelStyle, anchors, tick, tickFormat(tick, index, ticks)),
	        grid: _this2.getGridProps(gridLayout, styles.gridStyle, tick)
	      };
	
	      return childProps;
	    }, initialChildProps);
	  },
	  getCalculatedValues: function (props) {
	    var defaultStyles = this.getStyleObject(props);
	    var style = this.getStyles(props, defaultStyles);
	    var padding = _victoryCore.Helpers.getPadding(props);
	    var orientation = props.orientation || (props.dependentAxis ? "left" : "bottom");
	    var isVertical = _victoryCore.Helpers.isVertical(props);
	    var labelPadding = this.getLabelPadding(props, style);
	    var stringTicks = _victoryCore.Helpers.stringTicks(props) ? props.tickValues : undefined;
	    var scale = this.getScale(props);
	    var domain = this.getDomain(props);
	    var ticks = _axis2.default.getTicks(props, scale, props.crossAxis);
	    var tickFormat = _axis2.default.getTickFormat(props, scale);
	    var anchors = this.getAnchors(orientation, isVertical);
	
	    return {
	      style: style, padding: padding, orientation: orientation, isVertical: isVertical, labelPadding: labelPadding, stringTicks: stringTicks,
	      anchors: anchors, scale: scale, ticks: ticks, tickFormat: tickFormat, domain: domain
	    };
	  },
	  getAxisLabelProps: function (props, calculatedValues, globalTransform) {
	    var style = calculatedValues.style,
	        orientation = calculatedValues.orientation,
	        padding = calculatedValues.padding,
	        labelPadding = calculatedValues.labelPadding,
	        isVertical = calculatedValues.isVertical;
	
	    var sign = orientationSign[orientation];
	    var hPadding = padding.left + padding.right;
	    var vPadding = padding.top + padding.bottom;
	    var verticalAnchor = sign < 0 ? "end" : "start";
	    var labelStyle = style.axisLabel;
	    var angle = isVertical ? -90 : 0; // eslint-disable-line no-magic-numbers
	    var x = isVertical ? globalTransform.x + sign * labelPadding : (props.width - hPadding) / 2 + padding.left + globalTransform.x;
	    var y = isVertical ? (props.height - vPadding) / 2 + padding.top + globalTransform.y : sign * labelPadding + globalTransform.y;
	
	    return {
	      x: x,
	      y: y,
	      verticalAnchor: labelStyle.verticalAnchor || verticalAnchor,
	      textAnchor: labelStyle.textAnchor || "middle",
	      angle: labelStyle.angle || angle,
	      style: labelStyle,
	      text: props.label
	    };
	  },
	  getAnchors: function (orientation, isVertical) {
	    var anchorOrientation = { top: "end", left: "end", right: "start", bottom: "start" };
	    var anchor = anchorOrientation[orientation];
	    return {
	      textAnchor: isVertical ? anchor : "middle",
	      verticalAnchor: isVertical ? "middle" : anchor
	    };
	  },
	  getLabelPadding: function (props, style) {
	    var labelStyle = style.axisLabel || {};
	    if (typeof labelStyle.padding !== "undefined" && labelStyle.padding !== null) {
	      return labelStyle.padding;
	    }
	    var isVertical = _victoryCore.Helpers.isVertical(props);
	    // TODO: magic numbers
	    /*eslint-disable no-magic-numbers*/
	    var fontSize = labelStyle.fontSize || 14;
	    return props.label ? fontSize * (isVertical ? 2.3 : 1.6) : 0;
	    /*eslint-enable no-magic-numbers*/
	  },
	  getOffset: function (props, calculatedValues) {
	    var _this3 = this;
	
	    var style = calculatedValues.style,
	        padding = calculatedValues.padding,
	        isVertical = calculatedValues.isVertical,
	        orientation = calculatedValues.orientation,
	        labelPadding = calculatedValues.labelPadding,
	        stringTicks = calculatedValues.stringTicks,
	        ticks = calculatedValues.ticks;
	
	    var xPadding = orientation === "right" ? padding.right : padding.left;
	    var yPadding = orientation === "top" ? padding.top : padding.bottom;
	    var fontSize = style.axisLabel.fontSize || 14; // eslint-disable-line no-magic-numbers
	    var offsetX = props.offsetX !== null && props.offsetX !== undefined ? props.offsetX : xPadding;
	    var offsetY = props.offsetY !== null && props.offsetY !== undefined ? props.offsetY : yPadding;
	    var tickSizes = ticks.map(function (data) {
	      var tick = stringTicks ? props.tickValues[data - 1] : data;
	      var tickStyle = _this3.evaluateStyle(style.ticks, tick);
	      return tickStyle.size || 0;
	    });
	    var totalPadding = fontSize + 2 * Math.max.apply(Math, _toConsumableArray(tickSizes)) + labelPadding;
	    var minimumPadding = 1.2 * fontSize; // eslint-disable-line no-magic-numbers
	    var x = isVertical ? totalPadding : minimumPadding;
	    var y = isVertical ? minimumPadding : totalPadding;
	    return {
	      x: offsetX !== null && offsetX !== undefined ? offsetX : x,
	      y: offsetY !== null && offsetY !== undefined ? offsetY : y
	    };
	  },
	  getTransform: function (props, calculatedValues, offset) {
	    var orientation = calculatedValues.orientation;
	
	    return {
	      top: { x: 0, y: offset.y },
	      bottom: { x: 0, y: props.height - offset.y },
	      left: { x: offset.x, y: 0 },
	      right: { x: props.width - offset.x, y: 0 }
	    }[orientation];
	  },
	  getTickPosition: function (style, orientation, isVertical) {
	    var tickStyle = style.tickStyle,
	        labelStyle = style.labelStyle;
	
	    var size = tickStyle.size || 0;
	    var tickPadding = tickStyle.padding || 0;
	    var labelPadding = labelStyle.padding || 0;
	    var tickSpacing = size + tickPadding + labelPadding;
	    var sign = orientationSign[orientation];
	    return {
	      x: isVertical ? sign * tickSpacing : 0,
	      x2: isVertical ? sign * size : 0,
	      y: isVertical ? 0 : sign * tickSpacing,
	      y2: isVertical ? 0 : sign * size
	    };
	  },
	  getTickTransform: function (tick, globalTransform, isVertical) {
	    return {
	      x: isVertical ? globalTransform.x : tick + globalTransform.x,
	      y: isVertical ? tick + globalTransform.y : globalTransform.y
	    };
	  },
	  getGridEdge: function (props, calculatedValues) {
	    var orientation = calculatedValues.orientation,
	        padding = calculatedValues.padding,
	        isVertical = calculatedValues.isVertical;
	
	    var sign = -orientationSign[orientation];
	    var x = isVertical ? sign * (props.width - (padding.left + padding.right)) : 0;
	    var y = isVertical ? 0 : sign * (props.height - (padding.top + padding.bottom));
	    return { x: x, y: y };
	  },
	  getGridOffset: function (props, calculatedValues, offset) {
	    var padding = calculatedValues.padding,
	        orientation = calculatedValues.orientation;
	
	    var xPadding = orientation === "right" ? padding.right : padding.left;
	    var yPadding = orientation === "top" ? padding.top : padding.bottom;
	    return {
	      x: props.crossAxis ? offset.x - xPadding : 0,
	      y: props.crossAxis ? offset.y - yPadding : 0
	    };
	  }
	};

/***/ },
/* 580 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isNaN2 = __webpack_require__(56);
	
	var _isNaN3 = _interopRequireDefault(_isNaN2);
	
	var _omit2 = __webpack_require__(25);
	
	var _omit3 = _interopRequireDefault(_omit2);
	
	var _keys2 = __webpack_require__(12);
	
	var _keys3 = _interopRequireDefault(_keys2);
	
	var _defaults2 = __webpack_require__(5);
	
	var _defaults3 = _interopRequireDefault(_defaults2);
	
	var _assign2 = __webpack_require__(4);
	
	var _assign3 = _interopRequireDefault(_assign2);
	
	var _victoryCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	exports.default = {
	  getBarPosition: function (props, datum) {
	    var getDefaultMin = function (axis) {
	      var defaultMin = _victoryCore.Scale.getType(props.scale[axis]) === "log" ? 1 / Number.MAX_SAFE_INTEGER : 0;
	      return datum["_" + axis] instanceof Date ? new Date(defaultMin) : defaultMin;
	    };
	    var _y0 = datum._y0 !== undefined ? datum._y0 : getDefaultMin("y");
	    var _x0 = datum._x0 !== undefined ? datum._x0 : getDefaultMin("x");
	    return _victoryCore.Helpers.scalePoint(props, (0, _assign3.default)({}, datum, { _y0: _y0, _x0: _x0 }));
	  },
	  getBarStyle: function (datum, baseStyle) {
	    var numKeys = (0, _keys3.default)(datum).filter(function (k) {
	      return (0, _isNaN3.default)(k);
	    });
	    var omitKeys = ["x", "y", "y0", "_x", "_y", "_y0", "name", "label", "eventKey"];
	    var styleData = (0, _omit3.default)(datum, [].concat(omitKeys, _toConsumableArray(numKeys)));
	    return (0, _defaults3.default)({}, styleData, baseStyle);
	  },
	  getCalculatedValues: function (props) {
	    var theme = props.theme,
	        horizontal = props.horizontal,
	        polar = props.polar;
	
	    var defaultStyles = theme && theme.bar && theme.bar.style ? theme.bar.style : {};
	    var style = _victoryCore.Helpers.getStyles(props.style, defaultStyles);
	    var data = _victoryCore.Data.getData(props);
	    var range = {
	      x: _victoryCore.Helpers.getRange(props, "x"),
	      y: _victoryCore.Helpers.getRange(props, "y")
	    };
	    var domain = {
	      x: _victoryCore.Domain.getDomainWithZero(props, "x"),
	      y: _victoryCore.Domain.getDomainWithZero(props, "y")
	    };
	    var xScale = _victoryCore.Scale.getBaseScale(props, "x").domain(domain.x).range(range.x);
	    var yScale = _victoryCore.Scale.getBaseScale(props, "y").domain(domain.y).range(range.y);
	    var scale = {
	      x: horizontal ? yScale : xScale,
	      y: horizontal ? xScale : yScale
	    };
	    var origin = polar ? props.origin || _victoryCore.Helpers.getPolarOrigin(props) : undefined;
	    return { style: style, data: data, scale: scale, domain: domain, origin: origin };
	  },
	  getBaseProps: function (props, fallbackProps) {
	    var _this = this;
	
	    var modifiedProps = _victoryCore.Helpers.modifyProps(props, fallbackProps, "bar");
	    props = (0, _assign3.default)({}, modifiedProps, this.getCalculatedValues(modifiedProps));
	    var _props = props,
	        alignment = _props.alignment,
	        barRatio = _props.barRatio,
	        cornerRadius = _props.cornerRadius,
	        data = _props.data,
	        domain = _props.domain,
	        events = _props.events,
	        height = _props.height,
	        horizontal = _props.horizontal,
	        origin = _props.origin,
	        padding = _props.padding,
	        polar = _props.polar,
	        scale = _props.scale,
	        sharedEvents = _props.sharedEvents,
	        standalone = _props.standalone,
	        style = _props.style,
	        theme = _props.theme,
	        width = _props.width;
	
	    var initialChildProps = { parent: {
	        domain: domain, scale: scale, width: width, height: height, data: data, standalone: standalone,
	        theme: theme, polar: polar, origin: origin, padding: padding, style: style.parent
	      } };
	
	    return data.reduce(function (childProps, datum, index) {
	      var eventKey = datum.eventKey || index;
	
	      var _getBarPosition = _this.getBarPosition(props, datum),
	          x = _getBarPosition.x,
	          y = _getBarPosition.y,
	          y0 = _getBarPosition.y0,
	          x0 = _getBarPosition.x0;
	
	      var barStyle = _this.getBarStyle(datum, style.data);
	      var dataProps = {
	        alignment: alignment, barRatio: barRatio, cornerRadius: cornerRadius, data: data, datum: datum, horizontal: horizontal, index: index, padding: padding, polar: polar, origin: origin,
	        scale: scale, style: barStyle, width: width, height: height, x: x, y: y, y0: y0, x0: x0
	      };
	
	      childProps[eventKey] = {
	        data: dataProps
	      };
	
	      var text = _victoryCore.LabelHelpers.getText(props, datum, index);
	      if (text !== undefined && text !== null || events || sharedEvents) {
	        childProps[eventKey].labels = _victoryCore.LabelHelpers.getProps(props, index);
	      }
	      return childProps;
	    }, initialChildProps);
	  }
	};

/***/ },
/* 581 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _partialRight2 = __webpack_require__(16);
	
	var _partialRight3 = _interopRequireDefault(_partialRight2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _helperMethods = __webpack_require__(580);
	
	var _helperMethods2 = _interopRequireDefault(_helperMethods);
	
	var _victoryCore = __webpack_require__(3);
	
	var _commonProps = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var fallbackProps = {
	  width: 450,
	  height: 300,
	  padding: 50
	};
	
	var defaultData = [{ x: 1, y: 1 }, { x: 2, y: 2 }, { x: 3, y: 3 }, { x: 4, y: 4 }];
	
	var animationWhitelist = ["data", "domain", "height", "padding", "style", "width"];
	
	var VictoryBar = function (_React$Component) {
	  _inherits(VictoryBar, _React$Component);
	
	  function VictoryBar() {
	    _classCallCheck(this, VictoryBar);
	
	    return _possibleConstructorReturn(this, (VictoryBar.__proto__ || Object.getPrototypeOf(VictoryBar)).apply(this, arguments));
	  }
	
	  _createClass(VictoryBar, [{
	    key: "shouldAnimate",
	
	
	    // Overridden in native versions
	    value: function shouldAnimate() {
	      return !!this.props.animate;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var role = this.constructor.role;
	
	      var props = _victoryCore.Helpers.modifyProps(this.props, fallbackProps, role);
	      if (this.shouldAnimate()) {
	        return this.animateComponent(props, animationWhitelist);
	      }
	      var children = this.renderData(props);
	      return props.standalone ? this.renderContainer(props.containerComponent, children) : children;
	    }
	  }]);
	
	  return VictoryBar;
	}(_react2.default.Component);
	
	VictoryBar.displayName = "VictoryBar";
	VictoryBar.role = "bar";
	VictoryBar.defaultTransitions = {
	  onLoad: {
	    duration: 2000,
	    before: function () {
	      return { _y: 0, _y1: 0, _y0: 0 };
	    },
	    after: function (datum) {
	      return { _y: datum._y, _y1: datum._y1, _y0: datum._y0 };
	    }
	  },
	  onExit: {
	    duration: 500,
	    before: function () {
	      return { _y: 0, yOffset: 0 };
	    }
	  },
	  onEnter: {
	    duration: 500,
	    before: function () {
	      return { _y: 0, _y1: 0, _y0: 0 };
	    },
	    after: function (datum) {
	      return { _y: datum._y, _y1: datum._y1, _y0: datum._y0 };
	    }
	  }
	};
	VictoryBar.propTypes = _extends({}, _commonProps.BaseProps, _commonProps.DataProps, {
	  alignment: _propTypes2.default.oneOf(["start", "middle", "end"]),
	  barRatio: _propTypes2.default.number,
	  cornerRadius: _propTypes2.default.number,
	  horizontal: _propTypes2.default.bool
	});
	VictoryBar.defaultProps = {
	  containerComponent: _react2.default.createElement(_victoryCore.VictoryContainer, null),
	  data: defaultData,
	  dataComponent: _react2.default.createElement(_victoryCore.Bar, null),
	  groupComponent: _react2.default.createElement("g", { role: "presentation" }),
	  labelComponent: _react2.default.createElement(_victoryCore.VictoryLabel, null),
	  samples: 50,
	  scale: "linear",
	  sortOrder: "ascending",
	  standalone: true,
	  theme: _victoryCore.VictoryTheme.grayscale
	};
	VictoryBar.getDomain = _victoryCore.Domain.getDomainWithZero.bind(_victoryCore.Domain);
	VictoryBar.getData = _victoryCore.Data.getData.bind(_victoryCore.Data);
	VictoryBar.getBaseProps = (0, _partialRight3.default)(_helperMethods2.default.getBaseProps.bind(_helperMethods2.default), fallbackProps);
	VictoryBar.expectedComponents = ["dataComponent", "labelComponent", "groupComponent", "containerComponent"];
	exports.default = (0, _victoryCore.addEvents)(VictoryBar);

/***/ },
/* 582 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isNaN2 = __webpack_require__(56);
	
	var _isNaN3 = _interopRequireDefault(_isNaN2);
	
	var _defaults2 = __webpack_require__(5);
	
	var _defaults3 = _interopRequireDefault(_defaults2);
	
	var _omit2 = __webpack_require__(25);
	
	var _omit3 = _interopRequireDefault(_omit2);
	
	var _keys2 = __webpack_require__(12);
	
	var _keys3 = _interopRequireDefault(_keys2);
	
	var _sortBy2 = __webpack_require__(58);
	
	var _sortBy3 = _interopRequireDefault(_sortBy2);
	
	var _assign2 = __webpack_require__(4);
	
	var _assign3 = _interopRequireDefault(_assign2);
	
	var _victoryCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	exports.default = {
	  getBaseProps: function (props, fallbackProps) {
	    var _this = this;
	
	    // eslint-disable-line max-statements
	    props = _victoryCore.Helpers.modifyProps(props, fallbackProps, "candlestick");
	    var calculatedValues = this.getCalculatedValues(props);
	    var data = calculatedValues.data,
	        style = calculatedValues.style,
	        scale = calculatedValues.scale,
	        domain = calculatedValues.domain,
	        origin = calculatedValues.origin;
	    var _props = props,
	        groupComponent = _props.groupComponent,
	        width = _props.width,
	        height = _props.height,
	        padding = _props.padding,
	        standalone = _props.standalone,
	        theme = _props.theme,
	        polar = _props.polar;
	
	    var initialChildProps = { parent: {
	        domain: domain, scale: scale, width: width, height: height, data: data, standalone: standalone, theme: theme, polar: polar, origin: origin,
	        style: style.parent, padding: padding
	      } };
	
	    return data.reduce(function (childProps, datum, index) {
	      var eventKey = datum.eventKey || index;
	      var x = scale.x(datum._x1 !== undefined ? datum._x1 : datum._x);
	      var y1 = scale.y(datum._high);
	      var y2 = scale.y(datum._low);
	      var candleHeight = Math.abs(scale.y(datum._open) - scale.y(datum._close));
	      var y = scale.y(Math.max(datum._open, datum._close));
	      var dataStyle = _this.getDataStyles(datum, style.data, props);
	      var dataProps = {
	        x: x, y: y, y1: y1, y2: y2, candleHeight: candleHeight, scale: scale, data: data, datum: datum, groupComponent: groupComponent,
	        index: index, style: dataStyle, padding: padding, width: width, polar: polar, origin: origin
	      };
	
	      childProps[eventKey] = {
	        data: dataProps
	      };
	      var text = _victoryCore.LabelHelpers.getText(props, datum, index);
	      if (text !== undefined && text !== null || props.events || props.sharedEvents) {
	        childProps[eventKey].labels = _this.getLabelProps(dataProps, text, style);
	      }
	
	      return childProps;
	    }, initialChildProps);
	  },
	  getLabelProps: function (dataProps, text, style) {
	    var x = dataProps.x,
	        y1 = dataProps.y1,
	        index = dataProps.index,
	        scale = dataProps.scale,
	        datum = dataProps.datum,
	        data = dataProps.data;
	
	    var labelStyle = style.labels || {};
	    return {
	      style: labelStyle,
	      y: y1 - (labelStyle.padding || 0),
	      x: x,
	      text: text,
	      index: index,
	      scale: scale,
	      datum: datum,
	      data: data,
	      textAnchor: labelStyle.textAnchor,
	      verticalAnchor: labelStyle.verticalAnchor || "end",
	      angle: labelStyle.angle
	    };
	  },
	  getCalculatedValues: function (props) {
	    var theme = props.theme,
	        polar = props.polar;
	
	    var defaultStyle = theme && theme.candlestick && theme.candlestick.style ? theme.candlestick.style : {};
	    var style = _victoryCore.Helpers.getStyles(props.style, defaultStyle);
	    var data = _victoryCore.Data.addEventKeys(props, this.getData(props));
	    var range = {
	      x: _victoryCore.Helpers.getRange(props, "x"),
	      y: _victoryCore.Helpers.getRange(props, "y")
	    };
	    var domain = {
	      x: this.getDomain(props, "x"),
	      y: this.getDomain(props, "y")
	    };
	    var scale = {
	      x: _victoryCore.Scale.getBaseScale(props, "x").domain(domain.x).range(range.x),
	      y: _victoryCore.Scale.getBaseScale(props, "y").domain(domain.y).range(range.y)
	    };
	    var origin = polar ? props.origin || _victoryCore.Helpers.getPolarOrigin(props) : undefined;
	    return { domain: domain, data: data, scale: scale, style: style, origin: origin };
	  },
	  getData: function (props) {
	    if (!props.data || _victoryCore.Data.getLength(props.data) < 1) {
	      return [];
	    }
	    var stringMap = {
	      x: _victoryCore.Data.createStringMap(props, "x")
	    };
	
	    var accessor = {
	      x: _victoryCore.Helpers.createAccessor(props.x !== undefined ? props.x : "x"),
	      open: _victoryCore.Helpers.createAccessor(props.open !== undefined ? props.open : "open"),
	      close: _victoryCore.Helpers.createAccessor(props.close !== undefined ? props.close : "close"),
	      high: _victoryCore.Helpers.createAccessor(props.high !== undefined ? props.high : "high"),
	      low: _victoryCore.Helpers.createAccessor(props.low !== undefined ? props.low : "low")
	    };
	
	    var formattedData = props.data.reduce(function (dataArr, datum, index) {
	      datum = _victoryCore.Data.parseDatum(datum);
	
	      var evaluatedX = accessor.x(datum);
	      var _x = evaluatedX !== undefined ? evaluatedX : index;
	      var _open = accessor.open(datum);
	      var _close = accessor.close(datum);
	      var _high = accessor.high(datum);
	      var _low = accessor.low(datum);
	      var _y = [_open, _close, _high, _low];
	
	      dataArr.push((0, _assign3.default)({}, datum, { _x: _x, _y: _y, _open: _open, _close: _close, _high: _high, _low: _low }, typeof _x === "string" ? { _x: stringMap.x[_x], x: _x } : {}));
	
	      return dataArr;
	    }, []);
	
	    return this.sortData(formattedData, props.sortKey, props.sortOrder);
	  },
	  sortData: function (dataset, sortKey) {
	    var sortOrder = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "ascending";
	
	    if (!sortKey) {
	      return dataset;
	    }
	
	    if (sortKey === "x" || sortKey === "y") {
	      sortKey = "_" + sortKey;
	    }
	
	    var sortedData = (0, _sortBy3.default)(dataset, sortKey);
	
	    if (sortOrder === "descending") {
	      return sortedData.reverse();
	    }
	
	    return sortedData;
	  },
	  getDomain: function (props, axis) {
	    var domain = void 0;
	    if (props.domain && props.domain[axis]) {
	      domain = props.domain[axis];
	    } else if (props.domain && Array.isArray(props.domain)) {
	      domain = props.domain;
	    } else {
	      var dataset = this.getData(props);
	      var allData = dataset.reduce(function (memo, datum) {
	        return Array.isArray(datum["_" + axis]) ? memo.concat.apply(memo, _toConsumableArray(datum["_" + axis])) : memo.concat(datum["_" + axis]);
	      }, []);
	
	      if (allData.length < 1) {
	        return _victoryCore.Scale.getBaseScale(props, axis).domain();
	      }
	
	      var min = Math.min.apply(Math, _toConsumableArray(allData));
	      var max = Math.max.apply(Math, _toConsumableArray(allData));
	      if (+min === +max) {
	        return _victoryCore.Domain.getSinglePointDomain(max);
	      }
	      domain = [min, max];
	    }
	    return _victoryCore.Domain.cleanDomain(_victoryCore.Domain.padDomain(domain, props, axis), props);
	  },
	  isTransparent: function (attr) {
	    return attr === "none" || attr === "transparent";
	  },
	  getDataStyles: function (datum, style, props) {
	    style = style || {};
	    var numKeys = (0, _keys3.default)(datum).filter(function (k) {
	      return (0, _isNaN3.default)(k);
	    });
	    var omitKeys = ["x", "_x", "_y", "_y0", "size", "name", "label", "open", "close", "high", "low", "eventKey"];
	    var stylesFromData = (0, _omit3.default)(datum, [].concat(omitKeys, _toConsumableArray(numKeys)));
	    var candleColor = datum.open > datum.close ? props.candleColors.negative : props.candleColors.positive;
	    var fill = datum.fill || style.fill || candleColor;
	    var strokeColor = datum.stroke || style.stroke;
	    var stroke = this.isTransparent(strokeColor) ? fill : strokeColor || "black";
	    return (0, _defaults3.default)({}, stylesFromData, { stroke: stroke, fill: fill }, style);
	  }
	};

/***/ },
/* 583 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _partialRight2 = __webpack_require__(16);
	
	var _partialRight3 = _interopRequireDefault(_partialRight2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _victoryCore = __webpack_require__(3);
	
	var _helperMethods = __webpack_require__(582);
	
	var _helperMethods2 = _interopRequireDefault(_helperMethods);
	
	var _commonProps = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/*eslint-disable no-magic-numbers */
	var fallbackProps = {
	  width: 450,
	  height: 300,
	  padding: 50,
	  candleColors: {
	    positive: "#ffffff",
	    negative: "#252525"
	  }
	};
	
	var defaultData = [{ x: new Date(2016, 6, 1), open: 5, close: 10, high: 15, low: 0 }, { x: new Date(2016, 6, 2), open: 10, close: 15, high: 20, low: 5 }, { x: new Date(2016, 6, 3), open: 15, close: 20, high: 25, low: 10 }, { x: new Date(2016, 6, 4), open: 20, close: 25, high: 30, low: 15 }, { x: new Date(2016, 6, 5), open: 25, close: 30, high: 35, low: 20 }, { x: new Date(2016, 6, 6), open: 30, close: 35, high: 40, low: 25 }, { x: new Date(2016, 6, 7), open: 35, close: 40, high: 45, low: 30 }, { x: new Date(2016, 6, 8), open: 40, close: 45, high: 50, low: 35 }];
	/*eslint-enable no-magic-numbers */
	
	var animationWhitelist = ["data", "domain", "height", "padding", "samples", "size", "style", "width"];
	
	var VictoryCandlestick = function (_React$Component) {
	  _inherits(VictoryCandlestick, _React$Component);
	
	  function VictoryCandlestick() {
	    _classCallCheck(this, VictoryCandlestick);
	
	    return _possibleConstructorReturn(this, (VictoryCandlestick.__proto__ || Object.getPrototypeOf(VictoryCandlestick)).apply(this, arguments));
	  }
	
	  _createClass(VictoryCandlestick, [{
	    key: "shouldAnimate",
	
	
	    // Overridden in native versions
	    value: function shouldAnimate() {
	      return !!this.props.animate;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var role = this.constructor.role;
	
	      var props = _victoryCore.Helpers.modifyProps(this.props, fallbackProps, role);
	      if (this.shouldAnimate()) {
	        return this.animateComponent(props, animationWhitelist);
	      }
	      var children = this.renderData(props);
	      return props.standalone ? this.renderContainer(props.containerComponent, children) : children;
	    }
	  }]);
	
	  return VictoryCandlestick;
	}(_react2.default.Component);
	
	VictoryCandlestick.displayName = "VictoryCandlestick";
	VictoryCandlestick.role = "candlestick";
	VictoryCandlestick.defaultTransitions = _victoryCore.DefaultTransitions.discreteTransitions();
	VictoryCandlestick.propTypes = _extends({}, _commonProps.BaseProps, _commonProps.DataProps, {
	  candleColors: _propTypes2.default.shape({ positive: _propTypes2.default.string, negative: _propTypes2.default.string }),
	  close: _propTypes2.default.oneOfType([_propTypes2.default.func, _victoryCore.PropTypes.allOfType([_victoryCore.PropTypes.integer, _victoryCore.PropTypes.nonNegative]), _propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.string)]),
	  high: _propTypes2.default.oneOfType([_propTypes2.default.func, _victoryCore.PropTypes.allOfType([_victoryCore.PropTypes.integer, _victoryCore.PropTypes.nonNegative]), _propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.string)]),
	  low: _propTypes2.default.oneOfType([_propTypes2.default.func, _victoryCore.PropTypes.allOfType([_victoryCore.PropTypes.integer, _victoryCore.PropTypes.nonNegative]), _propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.string)]),
	  open: _propTypes2.default.oneOfType([_propTypes2.default.func, _victoryCore.PropTypes.allOfType([_victoryCore.PropTypes.integer, _victoryCore.PropTypes.nonNegative]), _propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.string)])
	});
	VictoryCandlestick.defaultProps = {
	  containerComponent: _react2.default.createElement(_victoryCore.VictoryContainer, null),
	  data: defaultData,
	  dataComponent: _react2.default.createElement(_victoryCore.Candle, null),
	  groupComponent: _react2.default.createElement("g", { role: "presentation" }),
	  labelComponent: _react2.default.createElement(_victoryCore.VictoryLabel, null),
	  samples: 50,
	  scale: "linear",
	  sortOrder: "ascending",
	  standalone: true,
	  theme: _victoryCore.VictoryTheme.grayscale
	};
	VictoryCandlestick.getDomain = _helperMethods2.default.getDomain.bind(_helperMethods2.default);
	VictoryCandlestick.getData = _helperMethods2.default.getData.bind(_helperMethods2.default);
	VictoryCandlestick.getBaseProps = (0, _partialRight3.default)(_helperMethods2.default.getBaseProps.bind(_helperMethods2.default), fallbackProps);
	VictoryCandlestick.expectedComponents = ["dataComponent", "labelComponent", "groupComponent", "containerComponent"];
	exports.default = (0, _victoryCore.addEvents)(VictoryCandlestick);

/***/ },
/* 584 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _axis = __webpack_require__(45);
	
	var _axis2 = _interopRequireDefault(_axis);
	
	var _wrapper = __webpack_require__(61);
	
	var _wrapper2 = _interopRequireDefault(_wrapper);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _victoryCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	exports.default = {
	  getChildComponents: function (props, defaultAxes) {
	    var childComponents = _react2.default.Children.toArray(props.children);
	    if (childComponents.length === 0) {
	      return [defaultAxes.independent, defaultAxes.dependent];
	    }
	
	    var axisComponents = {
	      dependent: _axis2.default.getAxisComponentsWithParent(childComponents, "dependent"),
	      independent: _axis2.default.getAxisComponentsWithParent(childComponents, "independent")
	    };
	
	    if (axisComponents.dependent.length === 0 && axisComponents.independent.length === 0) {
	      return childComponents.concat([defaultAxes.independent, defaultAxes.dependent]);
	    }
	    if (axisComponents.independent.length > 1) {
	      var msg = "Only one independent VictoryAxis component is allowed when " + "using the VictoryChart wrapper. Only the first axis will be used. Please compose " + "multi-axis charts manually";
	      _victoryCore.Log.warn(msg);
	      var dataComponents = this.getDataComponents(childComponents);
	      return _victoryCore.Collection.removeUndefined(dataComponents.concat([].concat(_toConsumableArray(axisComponents.dependent), [axisComponents.independent[0]])));
	    }
	    return childComponents;
	  },
	  getDefaultDomainPadding: function (childComponents, horizontal) {
	    var groupComponent = childComponents.filter(function (child) {
	      return child.type && child.type.role && child.type.role === "group-wrapper";
	    });
	
	    if (groupComponent.length < 1) {
	      return undefined;
	    }
	
	    var _groupComponent$0$pro = groupComponent[0].props,
	        offset = _groupComponent$0$pro.offset,
	        children = _groupComponent$0$pro.children;
	
	    return horizontal ? { y: offset * children.length / 2 } : { x: offset * children.length / 2 };
	  },
	  getDataComponents: function (childComponents) {
	    var findDataComponents = function (children) {
	      return children.reduce(function (memo, child) {
	        if (child.type && child.type.role === "axis") {
	          return memo;
	        } else if (child.props && child.props.children) {
	          return memo.concat(findDataComponents(_react2.default.Children.toArray(child.props.children)));
	        }
	        return memo.concat(child);
	      }, []);
	    };
	
	    return findDataComponents(childComponents);
	  },
	  getDomain: function (props, axis, childComponents) {
	    childComponents = childComponents || _react2.default.Children.toArray(props.children);
	    var domain = _wrapper2.default.getDomain(props, axis, childComponents);
	    var axisComponent = _axis2.default.getAxisComponent(childComponents, axis);
	    var invertDomain = axisComponent && axisComponent.props && axisComponent.props.invertAxis;
	    return invertDomain ? domain.concat().reverse() : domain;
	  },
	
	
	  // eslint-disable-next-line complexity
	  getAxisOffset: function (props, calculatedProps) {
	    var axisComponents = calculatedProps.axisComponents,
	        scale = calculatedProps.scale,
	        origin = calculatedProps.origin,
	        domain = calculatedProps.domain,
	        originSign = calculatedProps.originSign,
	        padding = calculatedProps.padding;
	    var top = padding.top,
	        bottom = padding.bottom,
	        left = padding.left,
	        right = padding.right;
	    // make the axes line up, and cross when appropriate
	
	    var axisOrientations = {
	      x: _axis2.default.getOrientation(axisComponents.x, "x", originSign.y),
	      y: _axis2.default.getOrientation(axisComponents.y, "y", originSign.x)
	    };
	    var orientationOffset = {
	      y: axisOrientations.x === "bottom" ? bottom : top,
	      x: axisOrientations.y === "left" ? left : right
	    };
	    var originOffset = {
	      x: axisOrientations.y === "left" ? 0 : props.width,
	      y: axisOrientations.x === "bottom" ? props.height : 0
	    };
	    var originPosition = {
	      x: origin.x === domain.x[0] || origin.x === domain.x[1] ? 0 : scale.x(origin.x),
	      y: origin.y === domain.y[0] || origin.y === domain.y[1] ? 0 : scale.y(origin.y)
	    };
	    var calculatedOffset = {
	      x: originPosition.x ? Math.abs(originOffset.x - originPosition.x) : orientationOffset.x,
	      y: originPosition.y ? Math.abs(originOffset.y - originPosition.y) : orientationOffset.y
	    };
	
	    return {
	      x: axisComponents.x && axisComponents.x.offsetX !== undefined ? axisComponents.x.offsetX : calculatedOffset.x,
	      y: axisComponents.y && axisComponents.y.offsetY !== undefined ? axisComponents.y.offsetY : calculatedOffset.y
	    };
	  },
	  createStringMap: function (props, axis, childComponents) {
	    var allStrings = _wrapper2.default.getStringsFromChildren(props, axis, childComponents);
	    return allStrings.length === 0 ? null : allStrings.reduce(function (memo, string, index) {
	      memo[string] = index + 1;
	      return memo;
	    }, {});
	  }
	};

/***/ },
/* 585 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defaults2 = __webpack_require__(5);
	
	var _defaults3 = _interopRequireDefault(_defaults2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _victoryCore = __webpack_require__(3);
	
	var _victoryAxis = __webpack_require__(256);
	
	var _victoryAxis2 = _interopRequireDefault(_victoryAxis);
	
	var _victoryPolarAxis = __webpack_require__(257);
	
	var _victoryPolarAxis2 = _interopRequireDefault(_victoryPolarAxis);
	
	var _helperMethods = __webpack_require__(584);
	
	var _helperMethods2 = _interopRequireDefault(_helperMethods);
	
	var _axis = __webpack_require__(45);
	
	var _axis2 = _interopRequireDefault(_axis);
	
	var _wrapper = __webpack_require__(61);
	
	var _wrapper2 = _interopRequireDefault(_wrapper);
	
	var _commonProps = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var fallbackProps = {
	  width: 450,
	  height: 300,
	  padding: 50
	};
	
	var VictoryChart = function (_React$Component) {
	  _inherits(VictoryChart, _React$Component);
	
	  function VictoryChart(props) {
	    _classCallCheck(this, VictoryChart);
	
	    var _this = _possibleConstructorReturn(this, (VictoryChart.__proto__ || Object.getPrototypeOf(VictoryChart)).call(this, props));
	
	    _this.state = {};
	    if (props.animate) {
	      _this.state = {
	        nodesShouldLoad: false,
	        nodesDoneLoad: false,
	        animating: true
	      };
	    }
	    _this.setAnimationState = _wrapper2.default.setAnimationState.bind(_this);
	    _this.events = _wrapper2.default.getAllEvents(props);
	    return _this;
	  }
	
	  _createClass(VictoryChart, [{
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      this.events = _wrapper2.default.getAllEvents(this.props);
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.animate) {
	        this.setAnimationState(this.props, nextProps);
	      }
	      this.events = _wrapper2.default.getAllEvents(nextProps);
	    }
	  }, {
	    key: "getStyles",
	    value: function getStyles(props) {
	      var styleProps = props.style && props.style.parent;
	      return {
	        parent: (0, _defaults3.default)({}, styleProps, {
	          height: "100%",
	          width: "100%",
	          userSelect: "none"
	        }) };
	    }
	  }, {
	    key: "getAxisProps",
	    value: function getAxisProps(child, props, calculatedProps) {
	      var domain = calculatedProps.domain,
	          scale = calculatedProps.scale,
	          originSign = calculatedProps.originSign,
	          stringMap = calculatedProps.stringMap,
	          categories = calculatedProps.categories,
	          horizontal = calculatedProps.horizontal;
	
	      var childProps = child.props || {};
	      var axis = child.type.getAxis(childProps);
	      var currentAxis = _axis2.default.getCurrentAxis(axis, horizontal);
	      var otherAxis = axis === "x" ? "y" : "x";
	      var axisOffset = _helperMethods2.default.getAxisOffset(props, calculatedProps);
	      var offsetY = axis === "y" ? undefined : axisOffset.y;
	      var offsetX = axis === "x" ? undefined : axisOffset.x;
	      var crossAxis = childProps.crossAxis === false ? false : true;
	      var orientation = _axis2.default.getOrientation(child, axis, originSign[otherAxis]);
	      return {
	        stringMap: stringMap[currentAxis],
	        categories: categories[currentAxis],
	        startAngle: props.startAngle,
	        endAngle: props.endAngle,
	        innerRadius: props.innerRadius,
	        domain: domain,
	        scale: scale,
	        offsetY: childProps.offsetY !== undefined ? childProps.offsetY : offsetY,
	        offsetX: childProps.offsetX !== undefined ? childProps.offsetX : offsetX,
	        crossAxis: crossAxis,
	        orientation: orientation
	      };
	    }
	  }, {
	    key: "getChildProps",
	    value: function getChildProps(child, props, calculatedProps) {
	      var axisChild = _axis2.default.findAxisComponents([child]);
	      if (axisChild.length > 0) {
	        return this.getAxisProps(axisChild[0], props, calculatedProps);
	      }
	      var categories = calculatedProps.categories,
	          domain = calculatedProps.domain,
	          range = calculatedProps.range,
	          scale = calculatedProps.scale;
	
	      return { categories: categories, domain: domain, range: range, scale: scale };
	    }
	  }, {
	    key: "getCalculatedProps",
	    value: function getCalculatedProps(props, childComponents) {
	      var style = this.getStyles(props);
	      var horizontal = childComponents.some(function (component) {
	        return component.props && component.props.horizontal;
	      });
	      var axisComponents = {
	        x: _axis2.default.getAxisComponent(childComponents, "x"),
	        y: _axis2.default.getAxisComponent(childComponents, "y")
	      };
	      var domain = {
	        x: _helperMethods2.default.getDomain(props, "x", childComponents),
	        y: _helperMethods2.default.getDomain(props, "y", childComponents)
	      };
	      var range = {
	        x: props.polar ? _victoryCore.Helpers.getPolarRange(props, "x") : _victoryCore.Helpers.getRange(props, "x"),
	        y: props.polar ? _victoryCore.Helpers.getPolarRange(props, "y") : _victoryCore.Helpers.getRange(props, "y")
	      };
	      var baseScale = {
	        x: _victoryCore.Scale.getScaleFromProps(props, "x") || axisComponents.x && axisComponents.x.type.getScale(axisComponents.x.props) || _victoryCore.Scale.getDefaultScale(),
	        y: _victoryCore.Scale.getScaleFromProps(props, "y") || axisComponents.y && axisComponents.y.type.getScale(axisComponents.y.props) || _victoryCore.Scale.getDefaultScale()
	      };
	      var scale = {
	        x: baseScale.x.domain(domain.x).range(range.x),
	        y: baseScale.y.domain(domain.y).range(range.y)
	      };
	
	      var origin = props.polar ? _victoryCore.Helpers.getPolarOrigin(props) : _axis2.default.getOrigin(domain);
	
	      var originSign = {
	        x: _axis2.default.getOriginSign(origin.x, domain.x),
	        y: _axis2.default.getOriginSign(origin.y, domain.y)
	      };
	
	      // TODO: check
	      var categories = {
	        x: _wrapper2.default.getCategories(props, "x", childComponents),
	        y: _wrapper2.default.getCategories(props, "y", childComponents)
	      };
	
	      var stringMap = {
	        x: _helperMethods2.default.createStringMap(props, "x", childComponents),
	        y: _helperMethods2.default.createStringMap(props, "y", childComponents)
	      };
	
	      var defaultDomainPadding = _helperMethods2.default.getDefaultDomainPadding(childComponents, horizontal);
	
	      var padding = _victoryCore.Helpers.getPadding(props);
	
	      return {
	        axisComponents: axisComponents, categories: categories, domain: domain, range: range, horizontal: horizontal, scale: scale, stringMap: stringMap,
	        style: style, origin: origin, originSign: originSign, defaultDomainPadding: defaultDomainPadding, padding: padding
	      };
	    }
	  }, {
	    key: "getNewChildren",
	    value: function getNewChildren(props, childComponents, calculatedProps) {
	      var _this2 = this;
	
	      var baseStyle = calculatedProps.style.parent;
	      var getAnimationProps = _wrapper2.default.getAnimationProps.bind(this);
	      var height = props.height,
	          polar = props.polar,
	          theme = props.theme,
	          width = props.width;
	      var origin = calculatedProps.origin;
	
	      return childComponents.map(function (child, index) {
	        var style = Array.isArray(child.props.style) ? child.props.style : (0, _defaults3.default)({}, child.props.style, { parent: baseStyle });
	        var childProps = _this2.getChildProps(child, props, calculatedProps);
	        var newProps = (0, _defaults3.default)({
	          height: height, polar: polar, theme: theme, width: width, style: style,
	          origin: polar ? origin : undefined,
	          animate: getAnimationProps(props, child, index),
	          padding: calculatedProps.padding,
	          key: index,
	          standalone: false
	        }, childProps);
	
	        return _react2.default.cloneElement(child, newProps);
	      });
	    }
	  }, {
	    key: "renderContainer",
	    value: function renderContainer(containerComponent, props) {
	      var containerProps = (0, _defaults3.default)({}, containerComponent.props, props);
	      return _react2.default.cloneElement(containerComponent, containerProps);
	    }
	  }, {
	    key: "getContainerProps",
	    value: function getContainerProps(props, calculatedProps) {
	      var width = props.width,
	          height = props.height,
	          standalone = props.standalone,
	          theme = props.theme,
	          polar = props.polar;
	      var domain = calculatedProps.domain,
	          scale = calculatedProps.scale,
	          style = calculatedProps.style,
	          origin = calculatedProps.origin,
	          radius = calculatedProps.radius;
	
	      return {
	        domain: domain, scale: scale, width: width, height: height, standalone: standalone, theme: theme, style: style.parent, polar: polar, radius: radius,
	        origin: polar ? origin : undefined
	      };
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var props = this.state && this.state.nodesWillExit ? this.state.oldProps || this.props : this.props;
	      var modifiedProps = _victoryCore.Helpers.modifyProps(props, fallbackProps, "chart");
	      var eventKey = modifiedProps.eventKey,
	          containerComponent = modifiedProps.containerComponent,
	          groupComponent = modifiedProps.groupComponent,
	          standalone = modifiedProps.standalone;
	
	      var axes = props.polar ? modifiedProps.defaultPolarAxes : modifiedProps.defaultAxes;
	      var childComponents = _helperMethods2.default.getChildComponents(modifiedProps, axes);
	      var calculatedProps = this.getCalculatedProps(modifiedProps, childComponents);
	      var newChildren = this.getNewChildren(modifiedProps, childComponents, calculatedProps);
	      var containerProps = standalone ? this.getContainerProps(modifiedProps, calculatedProps) : {};
	      var container = standalone ? this.renderContainer(containerComponent, containerProps) : groupComponent;
	      if (this.events) {
	        return _react2.default.createElement(
	          _victoryCore.VictorySharedEvents,
	          { events: this.events, eventKey: eventKey, container: container },
	          newChildren
	        );
	      }
	      return _react2.default.cloneElement(container, container.props, newChildren);
	    }
	  }]);
	
	  return VictoryChart;
	}(_react2.default.Component);
	
	VictoryChart.displayName = "VictoryChart";
	VictoryChart.propTypes = _extends({}, _commonProps.BaseProps, {
	  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	  defaultAxes: _propTypes2.default.shape({
	    independent: _propTypes2.default.element,
	    dependent: _propTypes2.default.element
	  }),
	  defaultPolarAxes: _propTypes2.default.shape({
	    independent: _propTypes2.default.element,
	    dependent: _propTypes2.default.element
	  }),
	  endAngle: _propTypes2.default.number,
	  innerRadius: _victoryCore.PropTypes.nonNegative,
	  startAngle: _propTypes2.default.number
	});
	VictoryChart.defaultProps = {
	  containerComponent: _react2.default.createElement(_victoryCore.VictoryContainer, null),
	  defaultAxes: {
	    independent: _react2.default.createElement(_victoryAxis2.default, null),
	    dependent: _react2.default.createElement(_victoryAxis2.default, { dependentAxis: true })
	  },
	  defaultPolarAxes: {
	    independent: _react2.default.createElement(_victoryPolarAxis2.default, null),
	    dependent: _react2.default.createElement(_victoryPolarAxis2.default, { dependentAxis: true })
	  },
	  groupComponent: _react2.default.createElement("g", null),
	  standalone: true,
	  theme: _victoryCore.VictoryTheme.grayscale
	};
	VictoryChart.expectedComponents = ["groupComponent", "containerComponent"];
	exports.default = VictoryChart;

/***/ },
/* 586 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isNaN2 = __webpack_require__(56);
	
	var _isNaN3 = _interopRequireDefault(_isNaN2);
	
	var _sortBy2 = __webpack_require__(58);
	
	var _sortBy3 = _interopRequireDefault(_sortBy2);
	
	var _flatten2 = __webpack_require__(93);
	
	var _flatten3 = _interopRequireDefault(_flatten2);
	
	var _isArray2 = __webpack_require__(9);
	
	var _isArray3 = _interopRequireDefault(_isArray2);
	
	var _defaults2 = __webpack_require__(5);
	
	var _defaults3 = _interopRequireDefault(_defaults2);
	
	var _omit2 = __webpack_require__(25);
	
	var _omit3 = _interopRequireDefault(_omit2);
	
	var _keys2 = __webpack_require__(12);
	
	var _keys3 = _interopRequireDefault(_keys2);
	
	var _assign2 = __webpack_require__(4);
	
	var _assign3 = _interopRequireDefault(_assign2);
	
	var _victoryCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	exports.default = {
	  getBaseProps: function (props, fallbackProps) {
	    var _this = this;
	
	    props = _victoryCore.Helpers.modifyProps(props, fallbackProps, "errorbar");
	
	    var _getCalculatedValues = this.getCalculatedValues(props, fallbackProps),
	        data = _getCalculatedValues.data,
	        style = _getCalculatedValues.style,
	        scale = _getCalculatedValues.scale,
	        domain = _getCalculatedValues.domain,
	        origin = _getCalculatedValues.origin;
	
	    var _props = props,
	        groupComponent = _props.groupComponent,
	        height = _props.height,
	        width = _props.width,
	        borderWidth = _props.borderWidth,
	        standalone = _props.standalone,
	        theme = _props.theme,
	        polar = _props.polar,
	        padding = _props.padding;
	
	    var initialChildProps = { parent: {
	        domain: domain, scale: scale, data: data, height: height, width: width, standalone: standalone, theme: theme, polar: polar, origin: origin,
	        padding: padding, style: style.parent
	      } };
	
	    return data.reduce(function (childProps, datum, index) {
	      var eventKey = datum.eventKey || index;
	      var x = scale.x(datum._x1 !== undefined ? datum._x1 : datum._x);
	      var y = scale.y(datum._y1 !== undefined ? datum._y1 : datum._y);
	
	      var dataProps = {
	        x: x, y: y, scale: scale, datum: datum, data: data, index: index, groupComponent: groupComponent, borderWidth: borderWidth,
	        style: _this.getDataStyles(datum, style.data),
	        errorX: _this.getErrors(datum, scale, "x"),
	        errorY: _this.getErrors(datum, scale, "y")
	      };
	
	      childProps[eventKey] = {
	        data: dataProps
	      };
	      var text = _victoryCore.LabelHelpers.getText(props, datum, index);
	      if (text !== undefined && text !== null || props.events || props.sharedEvents) {
	        childProps[eventKey].labels = _this.getLabelProps(dataProps, text, style);
	      }
	
	      return childProps;
	    }, initialChildProps);
	  },
	  getLabelProps: function (dataProps, text, style) {
	    var x = dataProps.x,
	        index = dataProps.index,
	        scale = dataProps.scale,
	        errorY = dataProps.errorY;
	
	    var error = errorY && Array.isArray(errorY) ? errorY[0] : errorY;
	    var y = error || dataProps.y;
	    var labelStyle = style.labels || {};
	    return {
	      style: labelStyle,
	      y: y - (labelStyle.padding || 0),
	      x: x,
	      text: text,
	      index: index,
	      scale: scale,
	      datum: dataProps.datum,
	      data: dataProps.data,
	      textAnchor: labelStyle.textAnchor,
	      verticalAnchor: labelStyle.verticalAnchor || "end",
	      angle: labelStyle.angle
	    };
	  },
	  getErrorData: function (props) {
	    if (props.data) {
	      if (_victoryCore.Data.getLength(props.data) < 1) {
	        return [];
	      }
	
	      return this.formatErrorData(props.data, props);
	    } else {
	      var generatedData = (props.errorX || props.errorY) && this.generateData(props);
	      return this.formatErrorData(generatedData, props);
	    }
	  },
	  getErrors: function (datum, scale, axis) {
	    /**
	     * check if it is asymmetric error or symmetric error, asymmetric error should be an array
	     * and the first value is the positive error, the second is the negative error
	     * @param  {Boolean} isArray(errorX)
	     * @return {String or Array}
	     */
	
	    var errorNames = { x: "errorX", y: "errorY" };
	    var errors = datum[errorNames[axis]];
	    if (errors === 0) {
	      return false;
	    }
	
	    return (0, _isArray3.default)(errors) ? [errors[0] === 0 ? false : scale[axis](errors[0] + datum["_" + axis]), errors[1] === 0 ? false : scale[axis](datum["_" + axis] - errors[1])] : [scale[axis](errors + datum["_" + axis]), scale[axis](datum["_" + axis] - errors)];
	  },
	  formatErrorData: function (dataset, props) {
	    if (!dataset || _victoryCore.Data.getLength(dataset) < 1) {
	      return [];
	    }
	    var accessor = {
	      x: _victoryCore.Helpers.createAccessor(props.x !== undefined ? props.x : "x"),
	      y: _victoryCore.Helpers.createAccessor(props.y !== undefined ? props.y : "y"),
	      errorX: _victoryCore.Helpers.createAccessor(props.errorX !== undefined ? props.errorX : "errorX"),
	      errorY: _victoryCore.Helpers.createAccessor(props.errorY !== undefined ? props.errorY : "errorY")
	    };
	
	    var replaceNegatives = function (errors) {
	      // check if the value is negative, if it is set to 0
	      var replaceNeg = function (val) {
	        return !val || val < 0 ? 0 : val;
	      };
	      return (0, _isArray3.default)(errors) ? errors.map(function (err) {
	        return replaceNeg(err);
	      }) : replaceNeg(errors);
	    };
	
	    var stringMap = {
	      x: _victoryCore.Data.createStringMap(props, "x"),
	      y: _victoryCore.Data.createStringMap(props, "y")
	    };
	
	    var formattedData = dataset.reduce(function (dataArr, datum, index) {
	      datum = _victoryCore.Data.parseDatum(datum);
	
	      var evaluatedX = accessor.x(datum);
	      var evaluatedY = accessor.y(datum);
	      var _x = evaluatedX !== undefined ? evaluatedX : index;
	      var _y = evaluatedY !== undefined ? evaluatedY : datum;
	      var errorX = replaceNegatives(accessor.errorX(datum));
	      var errorY = replaceNegatives(accessor.errorY(datum));
	
	      dataArr.push((0, _assign3.default)({}, datum, { _x: _x, _y: _y, errorX: errorX, errorY: errorY },
	      // map string data to numeric values, and add names
	      typeof _x === "string" ? { _x: stringMap.x[_x], x: _x } : {}, typeof _y === "string" ? { _y: stringMap.y[_y], y: _y } : {}));
	
	      return dataArr;
	    }, []);
	
	    return this.sortData(formattedData, props.sortKey, props.sortOrder);
	  },
	  sortData: function (dataset, sortKey) {
	    var sortOrder = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "ascending";
	
	    if (!sortKey) {
	      return dataset;
	    }
	
	    if (sortKey === "x" || sortKey === "y") {
	      sortKey = "_" + sortKey;
	    }
	
	    var sortedData = (0, _sortBy3.default)(dataset, sortKey);
	
	    if (sortOrder === "descending") {
	      return sortedData.reverse();
	    }
	
	    return sortedData;
	  },
	  getDomain: function (props, axis) {
	    var propsDomain = _victoryCore.Domain.getDomainFromProps(props, axis);
	    if (propsDomain) {
	      return _victoryCore.Domain.padDomain(propsDomain, props, axis);
	    }
	    var categoryDomain = _victoryCore.Domain.getDomainFromCategories(props, axis);
	    if (categoryDomain) {
	      return _victoryCore.Domain.padDomain(categoryDomain, props, axis);
	    }
	    var dataset = this.getErrorData(props);
	
	    if (dataset.length < 1) {
	      return _victoryCore.Scale.getBaseScale(props, axis).domain();
	    }
	
	    var domain = this.getDomainFromData(props, axis, dataset);
	    return _victoryCore.Domain.cleanDomain(_victoryCore.Domain.padDomain(domain, props, axis), props);
	  },
	  getDomainFromData: function (props, axis, dataset) {
	    var currentAxis = _victoryCore.Helpers.getCurrentAxis(axis, props.horizontal);
	    var error = void 0;
	    if (currentAxis === "x") {
	      error = "errorX";
	    } else if (currentAxis === "y") {
	      error = "errorY";
	    }
	    var axisData = (0, _flatten3.default)(dataset).map(function (datum) {
	      return datum["_" + currentAxis];
	    });
	    var errorData = (0, _flatten3.default)((0, _flatten3.default)(dataset).map(function (datum) {
	      var errorMax = void 0;
	      var errorMin = void 0;
	      if ((0, _isArray3.default)(datum[error])) {
	        errorMax = datum[error][0] + datum["_" + currentAxis];
	        errorMin = datum["_" + currentAxis] - datum[error][1];
	      } else {
	        errorMax = datum[error] + datum["_" + currentAxis];
	        errorMin = datum["_" + currentAxis] - datum[error];
	      }
	      return [errorMax, errorMin];
	    }));
	
	    var allData = axisData.concat(errorData);
	    var min = Math.min.apply(Math, _toConsumableArray(allData));
	    var max = Math.max.apply(Math, _toConsumableArray(allData));
	    // TODO: is this the correct behavior, or should we just error. How do we
	    // handle charts with just one data point?
	    if (+min === +max) {
	      return _victoryCore.Domain.getSinglePointDomain(max);
	    }
	    return [min, max];
	  },
	  getCalculatedValues: function (props) {
	    var defaultStyles = props.theme && props.theme.errorbar && props.theme.errorbar.style ? props.theme.errorbar.style : {};
	    var style = _victoryCore.Helpers.getStyles(props.style, defaultStyles) || {};
	    var dataWithErrors = (0, _assign3.default)(_victoryCore.Data.getData(props), this.getErrorData(props));
	    var data = _victoryCore.Data.addEventKeys(props, dataWithErrors);
	    var range = {
	      x: _victoryCore.Helpers.getRange(props, "x"),
	      y: _victoryCore.Helpers.getRange(props, "y")
	    };
	    var domain = {
	      x: this.getDomain(props, "x"),
	      y: this.getDomain(props, "y")
	    };
	    var scale = {
	      x: _victoryCore.Scale.getBaseScale(props, "x").domain(domain.x).range(range.x),
	      y: _victoryCore.Scale.getBaseScale(props, "y").domain(domain.y).range(range.y)
	    };
	    var origin = props.polar ? props.origin || _victoryCore.Helpers.getPolarOrigin(props) : undefined;
	    return { domain: domain, data: data, scale: scale, style: style, origin: origin };
	  },
	  getDataStyles: function (datum, style) {
	    var numKeys = (0, _keys3.default)(datum).filter(function (k) {
	      return (0, _isNaN3.default)(k);
	    });
	    var omitKeys = ["x", "y", "_x", "_y", "name", "errorX", "errorY", "eventKey", "label"];
	    var stylesFromData = (0, _omit3.default)(datum, [].concat(omitKeys, _toConsumableArray(numKeys)));
	    return (0, _defaults3.default)({}, stylesFromData, style);
	  }
	};

/***/ },
/* 587 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _partialRight2 = __webpack_require__(16);
	
	var _partialRight3 = _interopRequireDefault(_partialRight2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _victoryCore = __webpack_require__(3);
	
	var _helperMethods = __webpack_require__(586);
	
	var _helperMethods2 = _interopRequireDefault(_helperMethods);
	
	var _commonProps = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var fallbackProps = {
	  width: 450,
	  height: 300,
	  padding: 50
	};
	
	var defaultData = [{ x: 1, y: 1, errorX: 0.1, errorY: 0.1 }, { x: 2, y: 2, errorX: 0.2, errorY: 0.2 }, { x: 3, y: 3, errorX: 0.3, errorY: 0.3 }, { x: 4, y: 4, errorX: 0.4, errorY: 0.4 }];
	
	var animationWhitelist = ["data", "domain", "height", "padding", "samples", "style", "width", "errorX", "errorY", "borderWidth"];
	
	var VictoryErrorBar = function (_React$Component) {
	  _inherits(VictoryErrorBar, _React$Component);
	
	  function VictoryErrorBar() {
	    _classCallCheck(this, VictoryErrorBar);
	
	    return _possibleConstructorReturn(this, (VictoryErrorBar.__proto__ || Object.getPrototypeOf(VictoryErrorBar)).apply(this, arguments));
	  }
	
	  _createClass(VictoryErrorBar, [{
	    key: "shouldAnimate",
	
	
	    // Overridden in native versions
	    value: function shouldAnimate() {
	      return !!this.props.animate;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var role = this.constructor.role;
	
	      var props = _victoryCore.Helpers.modifyProps(this.props, fallbackProps, role);
	      if (this.shouldAnimate()) {
	        return this.animateComponent(props, animationWhitelist);
	      }
	      var children = this.renderData(props);
	      return props.standalone ? this.renderContainer(props.containerComponent, children) : children;
	    }
	  }]);
	
	  return VictoryErrorBar;
	}(_react2.default.Component);
	
	VictoryErrorBar.displayName = "VictoryErrorBar";
	VictoryErrorBar.role = "errorBar";
	VictoryErrorBar.defaultTransitions = _victoryCore.DefaultTransitions.discreteTransitions();
	VictoryErrorBar.propTypes = _extends({}, _commonProps.BaseProps, _commonProps.DataProps, {
	  borderWidth: _propTypes2.default.number,
	  errorX: _propTypes2.default.oneOfType([_propTypes2.default.func, _victoryCore.PropTypes.allOfType([_victoryCore.PropTypes.integer, _victoryCore.PropTypes.nonNegative]), _propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.string)]),
	  errorY: _propTypes2.default.oneOfType([_propTypes2.default.func, _victoryCore.PropTypes.allOfType([_victoryCore.PropTypes.integer, _victoryCore.PropTypes.nonNegative]), _propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.string)]),
	  horizontal: _propTypes2.default.bool
	});
	VictoryErrorBar.defaultProps = {
	  containerComponent: _react2.default.createElement(_victoryCore.VictoryContainer, null),
	  data: defaultData,
	  dataComponent: _react2.default.createElement(_victoryCore.ErrorBar, null),
	  labelComponent: _react2.default.createElement(_victoryCore.VictoryLabel, null),
	  groupComponent: _react2.default.createElement("g", { role: "presentation" }),
	  samples: 50,
	  scale: "linear",
	  sortOrder: "ascending",
	  standalone: true,
	  theme: _victoryCore.VictoryTheme.grayscale
	};
	VictoryErrorBar.getDomain = _helperMethods2.default.getDomain.bind(_helperMethods2.default);
	VictoryErrorBar.getData = _victoryCore.Data.getData.bind(_victoryCore.Data);
	VictoryErrorBar.getBaseProps = (0, _partialRight3.default)(_helperMethods2.default.getBaseProps.bind(_helperMethods2.default), fallbackProps);
	VictoryErrorBar.expectedComponents = ["dataComponent", "labelComponent", "groupComponent", "containerComponent"];
	exports.default = (0, _victoryCore.addEvents)(VictoryErrorBar);

/***/ },
/* 588 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defaults2 = __webpack_require__(5);
	
	var _defaults3 = _interopRequireDefault(_defaults2);
	
	var _assign2 = __webpack_require__(4);
	
	var _assign3 = _interopRequireDefault(_assign2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _victoryCore = __webpack_require__(3);
	
	var _wrapper = __webpack_require__(61);
	
	var _wrapper2 = _interopRequireDefault(_wrapper);
	
	var _commonProps = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var fallbackProps = {
	  width: 450,
	  height: 300,
	  padding: 50,
	  offset: 0
	};
	
	var VictoryGroup = function (_React$Component) {
	  _inherits(VictoryGroup, _React$Component);
	
	  function VictoryGroup(props) {
	    _classCallCheck(this, VictoryGroup);
	
	    var _this = _possibleConstructorReturn(this, (VictoryGroup.__proto__ || Object.getPrototypeOf(VictoryGroup)).call(this, props));
	
	    if (props.animate) {
	      _this.state = {
	        nodesShouldLoad: false,
	        nodesDoneLoad: false,
	        animating: true
	      };
	      _this.setAnimationState = _wrapper2.default.setAnimationState.bind(_this);
	      _this.events = _wrapper2.default.getAllEvents(props);
	    }
	    return _this;
	  }
	
	  _createClass(VictoryGroup, [{
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      this.events = _wrapper2.default.getAllEvents(this.props);
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.animate) {
	        this.setAnimationState(this.props, nextProps);
	      }
	      this.events = _wrapper2.default.getAllEvents(nextProps);
	    }
	
	    // eslint-disable-next-line max-statements
	
	  }, {
	    key: "getCalculatedProps",
	    value: function getCalculatedProps(props, childComponents) {
	      var role = this.constructor.role;
	
	      var style = this.getStyle(props.theme, props.style, role);
	      var modifiedProps = _victoryCore.Helpers.modifyProps(props, fallbackProps);
	      var offset = modifiedProps.offset,
	          colorScale = modifiedProps.colorScale,
	          color = modifiedProps.color,
	          polar = modifiedProps.polar;
	
	      var horizontal = modifiedProps.horizontal || childComponents.every(function (component) {
	        return component.props && component.props.horizontal;
	      });
	      var datasets = _wrapper2.default.getDataFromChildren(modifiedProps);
	      var domain = {
	        x: _wrapper2.default.getDomain(modifiedProps, "x", childComponents),
	        y: _wrapper2.default.getDomain(modifiedProps, "y", childComponents)
	      };
	      var range = {
	        x: _victoryCore.Helpers.getRange(modifiedProps, "x"),
	        y: _victoryCore.Helpers.getRange(modifiedProps, "y")
	      };
	      var baseScale = {
	        x: _victoryCore.Scale.getScaleFromProps(modifiedProps, "x") || _victoryCore.Scale.getDefaultScale(),
	        y: _victoryCore.Scale.getScaleFromProps(modifiedProps, "y") || _victoryCore.Scale.getDefaultScale()
	      };
	      var xScale = baseScale.x.domain(domain.x).range(range.x);
	      var yScale = baseScale.y.domain(domain.y).range(range.y);
	      var scale = {
	        x: horizontal ? yScale : xScale,
	        y: horizontal ? xScale : yScale
	      };
	      var categories = {
	        x: _wrapper2.default.getCategories(modifiedProps, "x"),
	        y: _wrapper2.default.getCategories(modifiedProps, "y")
	      };
	      var origin = polar ? props.origin : _victoryCore.Helpers.getPolarOrigin(modifiedProps);
	      var padding = _victoryCore.Helpers.getPadding(props);
	      return {
	        datasets: datasets, categories: categories, range: range, domain: domain, horizontal: horizontal,
	        scale: scale, style: style, colorScale: colorScale, color: color, offset: offset, origin: origin, padding: padding
	      };
	    }
	  }, {
	    key: "pixelsToValue",
	    value: function pixelsToValue(props, axis, calculatedProps) {
	      if (!props.offset) {
	        return 0;
	      }
	      var childComponents = _react2.default.Children.toArray(props.children);
	      var horizontalChildren = childComponents.some(function (child) {
	        return child.props.horizontal;
	      });
	      var horizontal = props && props.horizontal || horizontalChildren.length > 0;
	      var currentAxis = _victoryCore.Helpers.getCurrentAxis(axis, horizontal);
	      var domain = calculatedProps.domain[currentAxis];
	      var range = calculatedProps.range[currentAxis];
	      var domainExtent = Math.max.apply(Math, _toConsumableArray(domain)) - Math.min.apply(Math, _toConsumableArray(domain));
	      var rangeExtent = Math.max.apply(Math, _toConsumableArray(range)) - Math.min.apply(Math, _toConsumableArray(range));
	      return domainExtent / rangeExtent * props.offset;
	    }
	  }, {
	    key: "getX0",
	    value: function getX0(props, calculatedProps, index) {
	      var center = (calculatedProps.datasets.length - 1) / 2;
	      var totalWidth = this.pixelsToValue(props, "x", calculatedProps);
	      return (index - center) * totalWidth;
	    }
	  }, {
	    key: "getPolarX0",
	    value: function getPolarX0(props, calculatedProps, index) {
	      var center = (calculatedProps.datasets.length - 1) / 2;
	      var width = this.getAngularWidth(props, calculatedProps);
	      return (index - center) * width;
	    }
	  }, {
	    key: "getAngularWidth",
	    value: function getAngularWidth(props, calculatedProps) {
	      var range = calculatedProps.range;
	
	      var angularRange = Math.abs(range.x[1] - range.x[0]);
	      var r = Math.max.apply(Math, _toConsumableArray(range.y));
	      return props.offset / (2 * Math.PI * r) * angularRange;
	    }
	  }, {
	    key: "getLabels",
	    value: function getLabels(props, datasets, index) {
	      if (!props.labels) {
	        return undefined;
	      }
	      return Math.floor(datasets.length / 2) === index ? props.labels : undefined;
	    }
	  }, {
	    key: "getChildProps",
	    value: function getChildProps(props, calculatedProps) {
	      var categories = calculatedProps.categories,
	          domain = calculatedProps.domain,
	          range = calculatedProps.range,
	          scale = calculatedProps.scale,
	          horizontal = calculatedProps.horizontal,
	          origin = calculatedProps.origin,
	          padding = calculatedProps.padding;
	      var width = props.width,
	          height = props.height,
	          theme = props.theme,
	          polar = props.polar;
	
	      return {
	        height: height, width: width, theme: theme, polar: polar, origin: origin, categories: categories, domain: domain, range: range, scale: scale, horizontal: horizontal, padding: padding,
	        standalone: false
	      };
	    }
	  }, {
	    key: "getColorScale",
	    value: function getColorScale(props, child) {
	      var role = child.type && child.type.role;
	      var colorScaleOptions = child.props.colorScale || props.colorScale;
	      if (role !== "group" && role !== "stack") {
	        return undefined;
	      }
	      return props.theme && props.theme.group ? colorScaleOptions || props.theme.group.colorScale : colorScaleOptions;
	    }
	  }, {
	    key: "getDataWithOffset",
	    value: function getDataWithOffset(props, defaultDataset, offset) {
	      var dataset = props.data || props.y ? _victoryCore.Data.getData(props) : defaultDataset;
	      var xOffset = offset || 0;
	      return dataset.map(function (datum) {
	        var _x1 = datum._x instanceof Date ? new Date(datum._x.getTime() + xOffset) : datum._x + xOffset;
	
	        return (0, _assign3.default)({}, datum, { _x1: _x1 });
	      });
	    }
	
	    // the old ones were bad
	
	  }, {
	    key: "getNewChildren",
	    value: function getNewChildren(props, childComponents, calculatedProps) {
	      var _this2 = this;
	
	      var datasets = calculatedProps.datasets;
	      var labelComponent = props.labelComponent,
	          polar = props.polar;
	
	      var childProps = this.getChildProps(props, calculatedProps);
	      var getAnimationProps = _wrapper2.default.getAnimationProps.bind(this);
	
	      return childComponents.map(function (child, index) {
	        var role = child.type && child.type.role;
	        var xOffset = polar ? _this2.getPolarX0(props, calculatedProps, index) : _this2.getX0(props, calculatedProps, index);
	        var style = role === "voronoi" || role === "tooltip" || role === "label" ? child.props.style : _wrapper2.default.getChildStyle(child, index, calculatedProps);
	        var labels = props.labels ? _this2.getLabels(props, datasets, index) : child.props.labels;
	        return _react2.default.cloneElement(child, (0, _assign3.default)({
	          labels: labels, style: style, key: index,
	          data: _this2.getDataWithOffset(props, datasets[index], xOffset),
	          animate: getAnimationProps(props, child, index),
	          colorScale: _this2.getColorScale(props, child),
	          labelComponent: labelComponent || child.props.labelComponent,
	          xOffset: role === "stack" ? xOffset : undefined
	        }, childProps));
	      });
	    }
	  }, {
	    key: "renderContainer",
	    value: function renderContainer(containerComponent, props) {
	      var containerProps = (0, _defaults3.default)({}, containerComponent.props, props);
	      return _react2.default.cloneElement(containerComponent, containerProps);
	    }
	  }, {
	    key: "getContainerProps",
	    value: function getContainerProps(props, calculatedProps) {
	      var width = props.width,
	          height = props.height,
	          standalone = props.standalone,
	          theme = props.theme,
	          polar = props.polar;
	      var domain = calculatedProps.domain,
	          scale = calculatedProps.scale,
	          style = calculatedProps.style,
	          origin = calculatedProps.origin;
	
	      return {
	        domain: domain, scale: scale, width: width, height: height, standalone: standalone, theme: theme, style: style.parent, polar: polar, origin: origin
	      };
	    }
	  }, {
	    key: "getStyle",
	    value: function getStyle(theme, style, role) {
	      var defaultStyle = theme && theme[role] && theme[role].style ? theme[role].style : {};
	      return _victoryCore.Helpers.getStyles(style, defaultStyle);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var role = this.constructor.role;
	
	      var props = this.state && this.state.nodesWillExit ? this.state.oldProps || this.props : this.props;
	      var modifiedProps = _victoryCore.Helpers.modifyProps(props, fallbackProps, role);
	      var eventKey = modifiedProps.eventKey,
	          containerComponent = modifiedProps.containerComponent,
	          standalone = modifiedProps.standalone,
	          groupComponent = modifiedProps.groupComponent;
	
	      var childComponents = _react2.default.Children.toArray(modifiedProps.children);
	      var calculatedProps = this.getCalculatedProps(modifiedProps, childComponents);
	      var newChildren = this.getNewChildren(modifiedProps, childComponents, calculatedProps);
	      var containerProps = standalone ? this.getContainerProps(modifiedProps, calculatedProps) : {};
	      var container = standalone ? this.renderContainer(containerComponent, containerProps) : groupComponent;
	      if (this.events) {
	        return _react2.default.createElement(
	          _victoryCore.VictorySharedEvents,
	          { events: this.events, eventKey: eventKey, container: container },
	          newChildren
	        );
	      }
	      return _react2.default.cloneElement(container, container.props, newChildren);
	    }
	  }]);
	
	  return VictoryGroup;
	}(_react2.default.Component);
	
	VictoryGroup.displayName = "VictoryGroup";
	VictoryGroup.role = "group";
	VictoryGroup.propTypes = _extends({}, _commonProps.BaseProps, _commonProps.DataProps, {
	  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	  color: _propTypes2.default.string,
	  colorScale: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.string), _propTypes2.default.oneOf(["grayscale", "qualitative", "heatmap", "warm", "cool", "red", "green", "blue"])]),
	  horizontal: _propTypes2.default.bool,
	  offset: _propTypes2.default.number
	});
	VictoryGroup.defaultProps = {
	  containerComponent: _react2.default.createElement(_victoryCore.VictoryContainer, null),
	  groupComponent: _react2.default.createElement("g", null),
	  samples: 50,
	  scale: "linear",
	  sortOrder: "ascending",
	  standalone: true,
	  theme: _victoryCore.VictoryTheme.grayscale
	};
	VictoryGroup.expectedComponents = ["groupComponent", "containerComponent", "labelComponent"];
	VictoryGroup.getDomain = _wrapper2.default.getDomain.bind(_wrapper2.default);
	VictoryGroup.getData = _wrapper2.default.getData.bind(_wrapper2.default);
	exports.default = VictoryGroup;

/***/ },
/* 589 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign2 = __webpack_require__(4);
	
	var _assign3 = _interopRequireDefault(_assign2);
	
	var _victoryCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  getBaseProps: function (props, fallbackProps) {
	    var modifiedProps = _victoryCore.Helpers.modifyProps(props, fallbackProps, "line");
	    props = (0, _assign3.default)({}, modifiedProps, this.getCalculatedValues(modifiedProps));
	    var _props = props,
	        data = _props.data,
	        domain = _props.domain,
	        events = _props.events,
	        groupComponent = _props.groupComponent,
	        height = _props.height,
	        interpolation = _props.interpolation,
	        origin = _props.origin,
	        padding = _props.padding,
	        polar = _props.polar,
	        scale = _props.scale,
	        sharedEvents = _props.sharedEvents,
	        standalone = _props.standalone,
	        style = _props.style,
	        theme = _props.theme,
	        width = _props.width;
	
	    var initialChildProps = {
	      parent: {
	        style: style.parent, scale: scale, data: data, height: height, width: width, domain: domain, standalone: standalone, polar: polar, origin: origin, padding: padding
	      },
	      all: { data: { polar: polar, origin: origin, scale: scale, data: data, interpolation: interpolation, groupComponent: groupComponent, theme: theme, style: style.data }
	      }
	    };
	    return data.reduce(function (childProps, datum, index) {
	      var text = _victoryCore.LabelHelpers.getText(props, datum, index);
	      if (text !== undefined && text !== null || events || sharedEvents) {
	        var eventKey = datum.eventKey || index;
	        childProps[eventKey] = { labels: _victoryCore.LabelHelpers.getProps(props, index) };
	      }
	      return childProps;
	    }, initialChildProps);
	  },
	  getCalculatedValues: function (props) {
	    var data = _victoryCore.Data.getData(props);
	
	    if (data.length < 2) {
	      data = [];
	    }
	
	    var range = {
	      x: _victoryCore.Helpers.getRange(props, "x"),
	      y: _victoryCore.Helpers.getRange(props, "y")
	    };
	    var domain = {
	      x: _victoryCore.Domain.getDomain(props, "x"),
	      y: _victoryCore.Domain.getDomain(props, "y")
	    };
	    var scale = {
	      x: _victoryCore.Scale.getBaseScale(props, "x").domain(domain.x).range(range.x),
	      y: _victoryCore.Scale.getBaseScale(props, "y").domain(domain.y).range(range.y)
	    };
	    var origin = props.polar ? props.origin || _victoryCore.Helpers.getPolarOrigin(props) : undefined;
	    var defaultStyles = props.theme && props.theme.line && props.theme.line.style ? props.theme.line.style : {};
	    var style = _victoryCore.Helpers.getStyles(props.style, defaultStyles);
	
	    return { domain: domain, data: data, scale: scale, style: style, origin: origin };
	  }
	};

/***/ },
/* 590 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _partialRight2 = __webpack_require__(16);
	
	var _partialRight3 = _interopRequireDefault(_partialRight2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _helperMethods = __webpack_require__(589);
	
	var _helperMethods2 = _interopRequireDefault(_helperMethods);
	
	var _victoryCore = __webpack_require__(3);
	
	var _commonProps = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var fallbackProps = {
	  width: 450,
	  height: 300,
	  padding: 50,
	  interpolation: "linear"
	};
	
	var options = {
	  components: [{ name: "parent", index: "parent" }, { name: "data", index: "all" }, { name: "labels" }]
	};
	
	var animationWhitelist = ["data", "domain", "height", "padding", "samples", "style", "width"];
	
	var VictoryLine = function (_React$Component) {
	  _inherits(VictoryLine, _React$Component);
	
	  function VictoryLine() {
	    _classCallCheck(this, VictoryLine);
	
	    return _possibleConstructorReturn(this, (VictoryLine.__proto__ || Object.getPrototypeOf(VictoryLine)).apply(this, arguments));
	  }
	
	  _createClass(VictoryLine, [{
	    key: "shouldAnimate",
	
	
	    // Overridden in native versions
	    value: function shouldAnimate() {
	      return !!this.props.animate;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var role = this.constructor.role;
	
	      var props = _victoryCore.Helpers.modifyProps(this.props, fallbackProps, role);
	      if (this.shouldAnimate()) {
	        return this.animateComponent(props, animationWhitelist);
	      }
	      var children = this.renderContinuousData(props);
	      return props.standalone ? this.renderContainer(props.containerComponent, children) : children;
	    }
	  }]);
	
	  return VictoryLine;
	}(_react2.default.Component);
	
	VictoryLine.displayName = "VictoryLine";
	VictoryLine.role = "line";
	VictoryLine.defaultTransitions = _victoryCore.DefaultTransitions.continuousTransitions();
	VictoryLine.defaultPolarTransitions = _victoryCore.DefaultTransitions.continuousPolarTransitions();
	VictoryLine.continuous = true;
	VictoryLine.propTypes = _extends({}, _commonProps.BaseProps, _commonProps.DataProps, {
	  interpolation: _propTypes2.default.oneOf(["basis", "bundle", "cardinal", "catmullRom", "linear", "monotoneX", "monotoneY", "natural", "step", "stepAfter", "stepBefore"]),
	  label: _victoryCore.PropTypes.deprecated(_propTypes2.default.string, "Use `labels` instead for individual data labels")
	});
	VictoryLine.defaultProps = {
	  containerComponent: _react2.default.createElement(_victoryCore.VictoryContainer, null),
	  dataComponent: _react2.default.createElement(_victoryCore.Curve, null),
	  labelComponent: _react2.default.createElement(_victoryCore.VictoryLabel, { renderInPortal: true }),
	  groupComponent: _react2.default.createElement(_victoryCore.VictoryClipContainer, null),
	  samples: 50,
	  scale: "linear",
	  sortKey: "x",
	  sortOrder: "ascending",
	  standalone: true,
	  theme: _victoryCore.VictoryTheme.grayscale
	};
	VictoryLine.getDomain = _victoryCore.Domain.getDomain.bind(_victoryCore.Domain);
	VictoryLine.getData = _victoryCore.Data.getData.bind(_victoryCore.Data);
	VictoryLine.getBaseProps = (0, _partialRight3.default)(_helperMethods2.default.getBaseProps.bind(_helperMethods2.default), fallbackProps);
	VictoryLine.expectedComponents = ["dataComponent", "labelComponent", "groupComponent", "containerComponent"];
	exports.default = (0, _victoryCore.addEvents)(VictoryLine, options);

/***/ },
/* 591 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isFunction2 = __webpack_require__(7);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _defaultsDeep2 = __webpack_require__(217);
	
	var _defaultsDeep3 = _interopRequireDefault(_defaultsDeep2);
	
	var _defaults2 = __webpack_require__(5);
	
	var _defaults3 = _interopRequireDefault(_defaults2);
	
	var _uniqBy2 = __webpack_require__(503);
	
	var _uniqBy3 = _interopRequireDefault(_uniqBy2);
	
	var _assign2 = __webpack_require__(4);
	
	var _assign3 = _interopRequireDefault(_assign2);
	
	var _axis = __webpack_require__(45);
	
	var _axis2 = _interopRequireDefault(_axis);
	
	var _victoryCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  getCalculatedValues: function (props) {
	    var defaultStyles = this.getStyleObject(props);
	    var style = this.getStyles(props, defaultStyles);
	    var padding = _victoryCore.Helpers.getPadding(props);
	    var axis = this.getAxis(props);
	    var axisType = this.getAxisType(props);
	    var stringTicks = _victoryCore.Helpers.stringTicks(props) ? props.tickValues : undefined;
	    var domain = this.getDomain(props, axis);
	    var range = this.getRange(props, axis);
	    var scale = this.getScale(props);
	    var initialTicks = _axis2.default.getTicks(props, scale);
	    var ticks = axisType === "angular" ? this.filterTicks(initialTicks, scale) : initialTicks;
	    var tickFormat = _axis2.default.getTickFormat(props, scale);
	    var radius = this.getRadius(props);
	    return {
	      axis: axis, style: style, padding: padding, stringTicks: stringTicks, axisType: axisType, scale: scale, ticks: ticks, tickFormat: tickFormat, domain: domain, range: range, radius: radius
	    };
	  },
	  evaluateProp: function (prop, data, index) {
	    return (0, _isFunction3.default)(prop) ? prop(data, index) : prop;
	  },
	  evaluateStyle: function (style, data, index) {
	    var _this = this;
	
	    if (!style || !Object.keys(style).some(function (value) {
	      return (0, _isFunction3.default)(style[value]);
	    })) {
	      return style;
	    }
	    return Object.keys(style).reduce(function (prev, curr) {
	      prev[curr] = _this.evaluateProp(style[curr], data, index);
	      return prev;
	    }, {});
	  },
	
	
	  // exposed for use by VictoryChart
	  getDomain: function (props, axis) {
	    var inherentAxis = this.getAxis(props);
	    if (axis && axis !== inherentAxis) {
	      return undefined;
	    }
	    var domain = void 0;
	    if (Array.isArray(props.domain)) {
	      domain = props.domain;
	    } else if (props.domain && props.domain[inherentAxis]) {
	      domain = props.domain[inherentAxis];
	    } else if (Array.isArray(props.tickValues) && props.tickValues.length > 1) {
	      domain = this.getDomainFromTickValues(props, axis);
	    }
	    var paddedDomain = _victoryCore.Domain.padDomain(domain, props, inherentAxis);
	    return domain ? _victoryCore.Domain.cleanDomain(paddedDomain, props, inherentAxis) : undefined;
	  },
	  getDomainFromTickValues: function (props, axis) {
	    var tickValues = props.tickValues,
	        _props$startAngle = props.startAngle,
	        startAngle = _props$startAngle === undefined ? 0 : _props$startAngle,
	        _props$endAngle = props.endAngle,
	        endAngle = _props$endAngle === undefined ? 360 : _props$endAngle;
	
	    if (_victoryCore.Helpers.stringTicks(props)) {
	      return [1, tickValues.length];
	    } else {
	      var ticks = tickValues.map(function (value) {
	        return +value;
	      });
	      var domain = [_victoryCore.Collection.getMinValue(ticks), _victoryCore.Collection.getMaxValue(ticks)];
	      return axis === "x" && Math.abs(startAngle - endAngle) === 360 ? _victoryCore.Domain.getSymmetricDomain(domain, ticks) : domain;
	    }
	  },
	  getRadius: function (props) {
	    var _Helpers$getPadding = _victoryCore.Helpers.getPadding(props),
	        left = _Helpers$getPadding.left,
	        right = _Helpers$getPadding.right,
	        top = _Helpers$getPadding.top,
	        bottom = _Helpers$getPadding.bottom;
	
	    var width = props.width,
	        height = props.height;
	
	    return Math.min(width - left - right, height - top - bottom) / 2;
	  },
	  getRange: function (props, axis) {
	    // Return the range from props if one is given.
	    if (props.range && props.range[axis]) {
	      return props.range[axis];
	    } else if (props.range && Array.isArray(props.range)) {
	      return props.range;
	    }
	    var axisType = this.getAxisType(props);
	    if (axisType === "angular") {
	      var startAngle = _victoryCore.Helpers.degreesToRadians(props.startAngle);
	      var endAngle = _victoryCore.Helpers.degreesToRadians(props.endAngle);
	      return [startAngle, endAngle];
	    }
	    var radius = this.getRadius(props);
	    return [props.innerRadius || 0, radius];
	  },
	
	
	  // exposed for use by VictoryChart
	  getAxis: function (props, flipped) {
	    var typicalAxis = props.dependentAxis ? "y" : "x";
	    var invertedAxis = typicalAxis === "x" ? "y" : "x";
	    return flipped ? invertedAxis : typicalAxis;
	  },
	  getAxisType: function (props) {
	    var typicalType = props.dependentAxis ? "radial" : "angular";
	    var invertedType = typicalType === "angular" ? "radial" : "angular";
	    return props.horizontal ? invertedType : typicalType;
	  },
	
	
	  // exposed for use by VictoryChart (necessary?)
	  getScale: function (props) {
	    var axis = this.getAxis(props);
	    var scale = _victoryCore.Scale.getBaseScale(props, axis);
	    var domain = this.getDomain(props, axis) || scale.domain();
	    var range = this.getRange(props, axis);
	    scale.range(range);
	    scale.domain(domain);
	    return scale;
	  },
	  getStyleObject: function (props) {
	    var theme = props.theme,
	        dependentAxis = props.dependentAxis;
	
	    var generalAxisStyle = theme && theme.axis && theme.axis.style;
	    var axisType = dependentAxis ? "dependentAxis" : "independentAxis";
	    var specificAxisStyle = theme && theme[axisType] && theme[axisType].style;
	
	    return generalAxisStyle && specificAxisStyle ? (0, _defaultsDeep3.default)({}, specificAxisStyle, generalAxisStyle) : specificAxisStyle || generalAxisStyle;
	  },
	  getStyles: function (props, styleObject) {
	    var style = props.style || {};
	    styleObject = styleObject || {};
	    var parentStyleProps = { height: "auto", width: "100%" };
	    return {
	      parent: (0, _defaults3.default)(parentStyleProps, style.parent, styleObject.parent),
	      axis: (0, _defaults3.default)({}, style.axis, styleObject.axis),
	      axisLabel: (0, _defaults3.default)({}, style.axisLabel, styleObject.axisLabel),
	      grid: (0, _defaults3.default)({}, style.grid, styleObject.grid),
	      ticks: (0, _defaults3.default)({}, style.ticks, styleObject.ticks),
	      tickLabels: (0, _defaults3.default)({}, style.tickLabels, styleObject.tickLabels)
	    };
	  },
	  getAxisAngle: function (props) {
	    var axisAngle = props.axisAngle,
	        startAngle = props.startAngle,
	        axisValue = props.axisValue,
	        dependentAxis = props.dependentAxis,
	        scale = props.scale;
	
	    var otherAxis = this.getAxis(props) === "y" ? "x" : "y";
	    if (axisValue === undefined || !dependentAxis || scale[otherAxis] === undefined) {
	      return axisAngle || startAngle;
	    }
	    return _victoryCore.Helpers.radiansToDegrees(scale.x(axisValue));
	  },
	  getTickProps: function (props, calculatedValues, tick, index) {
	    //eslint-disable-line max-params
	    var axisType = calculatedValues.axisType,
	        radius = calculatedValues.radius,
	        scale = calculatedValues.scale,
	        style = calculatedValues.style,
	        stringTicks = calculatedValues.stringTicks;
	
	    var originalTick = stringTicks ? stringTicks[index] : tick;
	
	    var _getEvaluatedStyles = this.getEvaluatedStyles(style, originalTick, index),
	        tickStyle = _getEvaluatedStyles.tickStyle;
	
	    var tickPadding = tickStyle.padding || 0;
	    var angularPadding = tickPadding; // TODO: do some geometry
	    var axisAngle = axisType === "radial" ? this.getAxisAngle(props, scale) : undefined;
	    return axisType === "angular" ? {
	      index: index, datum: tick, style: tickStyle,
	      x1: radius * Math.cos(scale(tick)),
	      y1: -radius * Math.sin(scale(tick)),
	      x2: (radius + tickPadding) * Math.cos(scale(tick)),
	      y2: -(radius + tickPadding) * Math.sin(scale(tick))
	    } : {
	      style: style, index: index, datum: tick,
	      x1: scale(tick) / 2 * Math.cos(axisAngle - angularPadding),
	      x2: scale(tick) / 2 * Math.cos(axisAngle + angularPadding),
	      y1: -(scale(tick) / 2) * Math.sin(axisAngle - angularPadding),
	      y2: -(scale(tick) / 2) * Math.sin(axisAngle + angularPadding)
	    };
	  },
	  getTickLabelProps: function (props, calculatedValues, tick, index) {
	    //eslint-disable-line max-params
	    var axisType = calculatedValues.axisType,
	        radius = calculatedValues.radius,
	        tickFormat = calculatedValues.tickFormat,
	        style = calculatedValues.style,
	        scale = calculatedValues.scale,
	        ticks = calculatedValues.ticks,
	        stringTicks = calculatedValues.stringTicks;
	
	    var originalTick = stringTicks ? stringTicks[index] : tick;
	
	    var _getEvaluatedStyles2 = this.getEvaluatedStyles(style, originalTick, index),
	        labelStyle = _getEvaluatedStyles2.labelStyle;
	
	    var tickLabelComponent = props.tickLabelComponent;
	
	    var labelPlacement = tickLabelComponent.props && tickLabelComponent.props.labelPlacement ? tickLabelComponent.props.labelPlacement : props.labelPlacement;
	    var tickPadding = labelStyle.padding || 0;
	    var angularPadding = 0; // TODO: do some geometry
	    var axisAngle = axisType === "radial" ? this.getAxisAngle(props, scale) : undefined;
	    var labelAngle = axisType === "angular" ? _victoryCore.Helpers.radiansToDegrees(scale(tick)) : axisAngle + angularPadding;
	    var textAngle = labelStyle.angle || _victoryCore.LabelHelpers.getPolarAngle((0, _assign3.default)({}, props, { labelPlacement: labelPlacement }), labelAngle);
	    var labelRadius = axisType === "angular" ? radius + tickPadding : scale(tick);
	    var textAnchor = labelStyle.textAnchor || _victoryCore.LabelHelpers.getPolarTextAnchor((0, _assign3.default)({}, props, { labelPlacement: labelPlacement }), labelAngle);
	    return {
	      index: index, datum: tick, style: labelStyle,
	      angle: textAngle,
	      textAnchor: textAnchor,
	      text: tickFormat(tick, index, ticks),
	      x: labelRadius * Math.cos(_victoryCore.Helpers.degreesToRadians(labelAngle)),
	      y: -labelRadius * Math.sin(_victoryCore.Helpers.degreesToRadians(labelAngle))
	    };
	  },
	  getGridProps: function (props, calculatedValues, tick, index) {
	    //eslint-disable-line max-params
	    var axisType = calculatedValues.axisType,
	        radius = calculatedValues.radius,
	        style = calculatedValues.style,
	        scale = calculatedValues.scale,
	        stringTicks = calculatedValues.stringTicks;
	    var startAngle = props.startAngle,
	        endAngle = props.endAngle,
	        _props$innerRadius = props.innerRadius,
	        innerRadius = _props$innerRadius === undefined ? 0 : _props$innerRadius;
	
	    var originalTick = stringTicks ? stringTicks[index] : tick;
	
	    var _getEvaluatedStyles3 = this.getEvaluatedStyles(style, originalTick, index),
	        gridStyle = _getEvaluatedStyles3.gridStyle;
	
	    var angle = scale(tick);
	    return axisType === "angular" ? {
	      index: index, datum: tick, style: gridStyle,
	      x1: this.getPosition(radius, angle, "x"),
	      y1: this.getPosition(radius, angle, "y"),
	      x2: this.getPosition(innerRadius, angle, "x"),
	      y2: this.getPosition(innerRadius, angle, "y")
	    } : {
	      style: gridStyle, index: index, datum: tick,
	      cx: 0, cy: 0, r: scale(tick), startAngle: startAngle, endAngle: endAngle
	    };
	  },
	  getAxisLabelProps: function (props, calculatedValues) {
	    var axisType = calculatedValues.axisType,
	        radius = calculatedValues.radius,
	        style = calculatedValues.style,
	        scale = calculatedValues.scale;
	    var axisLabelComponent = props.axisLabelComponent;
	
	    if (axisType !== "radial") {
	      return {};
	    }
	    var labelPlacement = axisLabelComponent.props && axisLabelComponent.props.labelPlacement ? axisLabelComponent.props.labelPlacement : props.labelPlacement;
	    var labelStyle = style && style.axisLabel || {};
	    var axisAngle = axisType === "radial" ? this.getAxisAngle(props, scale) : undefined;
	    var textAngle = labelStyle.angle || _victoryCore.LabelHelpers.getPolarAngle((0, _assign3.default)({}, props, { labelPlacement: labelPlacement }), axisAngle);
	    var labelRadius = radius + (labelStyle.padding || 0);
	    var textAnchor = labelStyle.textAnchor || _victoryCore.LabelHelpers.getTextPolarAnchor((0, _assign3.default)({}, props, { labelPlacement: labelPlacement }), axisAngle);
	    var verticalAnchor = labelStyle.verticalAnchor || _victoryCore.LabelHelpers.getPolarVerticalAnchor((0, _assign3.default)({}, props, { labelPlacement: labelPlacement }), axisAngle);
	    return {
	      style: labelStyle,
	      angle: textAngle,
	      textAnchor: textAnchor,
	      verticalAnchor: verticalAnchor,
	      text: props.label,
	      x: this.getPosition(labelRadius, _victoryCore.Helpers.degreesToRadians(axisAngle), "x"),
	      y: this.getPosition(labelRadius, _victoryCore.Helpers.degreesToRadians(axisAngle), "y")
	    };
	  },
	  getPosition: function (r, angle, axis) {
	    return axis === "x" ? r * Math.cos(angle) : -r * Math.sin(angle);
	  },
	  getAxisProps: function (modifiedProps, calculatedValues) {
	    var style = calculatedValues.style,
	        axisType = calculatedValues.axisType,
	        radius = calculatedValues.radius,
	        scale = calculatedValues.scale;
	    var startAngle = modifiedProps.startAngle,
	        endAngle = modifiedProps.endAngle,
	        _modifiedProps$innerR = modifiedProps.innerRadius,
	        innerRadius = _modifiedProps$innerR === undefined ? 0 : _modifiedProps$innerR;
	
	    var axisAngle = axisType === "radial" ? _victoryCore.Helpers.degreesToRadians(this.getAxisAngle(modifiedProps, scale)) : undefined;
	    return axisType === "radial" ? {
	      style: style.axis,
	      x1: this.getPosition(innerRadius, axisAngle, "x"),
	      x2: this.getPosition(radius, axisAngle, "x"),
	      y1: this.getPosition(innerRadius, axisAngle, "y"),
	      y2: this.getPosition(radius, axisAngle, "y")
	    } : {
	      style: style.axis,
	      cx: 0, cy: 0, r: radius, startAngle: startAngle, endAngle: endAngle
	    };
	  },
	  getEvaluatedStyles: function (style, tick, index) {
	    return {
	      tickStyle: this.evaluateStyle(style.ticks, tick, index),
	      labelStyle: this.evaluateStyle(style.tickLabels, tick, index),
	      gridStyle: this.evaluateStyle(style.grid, tick, index)
	    };
	  },
	  getRole: function (props) {
	    if (props.dependentAxis) {
	      return props.theme && props.theme.dependentAxis ? "dependentAxis" : "axis";
	    }
	
	    return props.theme && props.theme.independentAxis ? "independentAxis" : "axis";
	  },
	  getShallowMergedThemeProps: function (props, role) {
	    var axisTheme = props.theme.axis || {};
	    return (0, _defaults3.default)({}, props.theme[role], axisTheme);
	  },
	  modifyProps: function (props, fallbackProps, role) {
	    if (role !== "axis") {
	      props.theme[role] = this.getShallowMergedThemeProps(props, role);
	    }
	    return _victoryCore.Helpers.modifyProps(props, fallbackProps, role);
	  },
	  getBaseProps: function (props, fallbackProps) {
	    var _this2 = this;
	
	    var role = this.getRole(props);
	    props = this.modifyProps(props, fallbackProps, role);
	    var calculatedValues = this.getCalculatedValues(props);
	    var style = calculatedValues.style,
	        scale = calculatedValues.scale,
	        ticks = calculatedValues.ticks,
	        domain = calculatedValues.domain;
	    var _props = props,
	        width = _props.width,
	        height = _props.height,
	        standalone = _props.standalone,
	        theme = _props.theme;
	
	    var axisProps = this.getAxisProps(props, calculatedValues);
	    var axisLabelProps = this.getAxisLabelProps(props, calculatedValues);
	    var initialChildProps = { parent: { style: style.parent, ticks: ticks, scale: scale, width: width, height: height, domain: domain, standalone: standalone, theme: theme }
	    };
	
	    return ticks.reduce(function (childProps, tick, index) {
	      childProps[index] = {
	        axis: axisProps,
	        axisLabel: axisLabelProps,
	        ticks: _this2.getTickProps(props, calculatedValues, tick, index),
	        tickLabels: _this2.getTickLabelProps(props, calculatedValues, tick, index),
	        grid: _this2.getGridProps(props, calculatedValues, tick, index)
	      };
	
	      return childProps;
	    }, initialChildProps);
	  },
	  filterTicks: function (ticks, scale) {
	    var compareTicks = function (t) {
	      return scale(t) % (2 * Math.PI);
	    };
	    return (0, _uniqBy3.default)(ticks, compareTicks);
	  }
	};

/***/ },
/* 592 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isNaN2 = __webpack_require__(56);
	
	var _isNaN3 = _interopRequireDefault(_isNaN2);
	
	var _defaults2 = __webpack_require__(5);
	
	var _defaults3 = _interopRequireDefault(_defaults2);
	
	var _omit2 = __webpack_require__(25);
	
	var _omit3 = _interopRequireDefault(_omit2);
	
	var _values2 = __webpack_require__(139);
	
	var _values3 = _interopRequireDefault(_values2);
	
	var _keys2 = __webpack_require__(12);
	
	var _keys3 = _interopRequireDefault(_keys2);
	
	var _assign2 = __webpack_require__(4);
	
	var _assign3 = _interopRequireDefault(_assign2);
	
	var _victoryCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	exports.default = {
	  getBaseProps: function (props, fallbackProps) {
	    var _this = this;
	
	    var modifiedProps = _victoryCore.Helpers.modifyProps(props, fallbackProps, "scatter");
	    props = (0, _assign3.default)({}, modifiedProps, this.getCalculatedValues(modifiedProps));
	    var _props = props,
	        data = _props.data,
	        domain = _props.domain,
	        events = _props.events,
	        height = _props.height,
	        origin = _props.origin,
	        padding = _props.padding,
	        polar = _props.polar,
	        scale = _props.scale,
	        sharedEvents = _props.sharedEvents,
	        standalone = _props.standalone,
	        style = _props.style,
	        theme = _props.theme,
	        width = _props.width;
	
	    var initialChildProps = { parent: {
	        style: style.parent, scale: scale, domain: domain, data: data, height: height, width: width, standalone: standalone, theme: theme,
	        origin: origin, polar: polar, padding: padding
	      } };
	
	    return data.reduce(function (childProps, datum, index) {
	      var eventKey = datum.eventKey;
	
	      var _Helpers$scalePoint = _victoryCore.Helpers.scalePoint(props, datum),
	          x = _Helpers$scalePoint.x,
	          y = _Helpers$scalePoint.y;
	
	      var dataProps = {
	        x: x, y: y, datum: datum, data: data, index: index, scale: scale, polar: polar, origin: origin,
	        size: _this.getSize(datum, props),
	        symbol: _this.getSymbol(datum, props),
	        style: _this.getDataStyles(datum, style.data)
	      };
	
	      childProps[eventKey] = { data: dataProps };
	      var text = _victoryCore.LabelHelpers.getText(props, datum, index);
	      if (text !== undefined && text !== null || events || sharedEvents) {
	        childProps[eventKey].labels = _victoryCore.LabelHelpers.getProps(props, index);
	      }
	
	      return childProps;
	    }, initialChildProps);
	  },
	  getCalculatedValues: function (props) {
	    var defaultStyles = props.theme && props.theme.scatter && props.theme.scatter.style ? props.theme.scatter.style : {};
	    var style = _victoryCore.Helpers.getStyles(props.style, defaultStyles);
	    var data = _victoryCore.Data.getData(props);
	    var range = {
	      x: _victoryCore.Helpers.getRange(props, "x"),
	      y: _victoryCore.Helpers.getRange(props, "y")
	    };
	    var domain = {
	      x: _victoryCore.Domain.getDomain(props, "x"),
	      y: _victoryCore.Domain.getDomain(props, "y")
	    };
	    var scale = {
	      x: _victoryCore.Scale.getBaseScale(props, "x").domain(domain.x).range(range.x),
	      y: _victoryCore.Scale.getBaseScale(props, "y").domain(domain.y).range(range.y)
	    };
	    var origin = props.polar ? props.origin || _victoryCore.Helpers.getPolarOrigin(props) : undefined;
	    var z = props.bubbleProperty || "z";
	    return { domain: domain, data: data, scale: scale, style: style, origin: origin, z: z };
	  },
	  getDataStyles: function (datum, style) {
	    var numKeys = (0, _keys3.default)(datum).filter(function (k) {
	      return (0, _isNaN3.default)(k);
	    });
	    var omitKeys = ["x", "y", "_x", "_y", "z", "size", "symbol", "eventKey", "label"];
	    var stylesFromData = (0, _omit3.default)(datum, [].concat(omitKeys, _toConsumableArray(numKeys)));
	    return (0, _defaults3.default)({}, stylesFromData, style);
	  },
	  getSymbol: function (data, props) {
	    if (props.bubbleProperty) {
	      return "circle";
	    }
	    return data.symbol || props.symbol;
	  },
	  getBubbleSize: function (datum, props) {
	    var data = props.data,
	        z = props.z,
	        maxBubbleSize = props.maxBubbleSize,
	        minBubbleSize = props.minBubbleSize;
	
	    var zData = data.map(function (point) {
	      return point[z];
	    });
	    var zMin = Math.min.apply(Math, _toConsumableArray(zData));
	    var zMax = Math.max.apply(Math, _toConsumableArray(zData));
	    var getMaxRadius = function () {
	      var minPadding = Math.min.apply(Math, _toConsumableArray((0, _values3.default)(_victoryCore.Helpers.getPadding(props))));
	      return Math.max(minPadding, 5); // eslint-disable-line no-magic-numbers
	    };
	    var maxRadius = maxBubbleSize || getMaxRadius();
	    var minRadius = minBubbleSize || maxRadius * 0.1; // eslint-disable-line no-magic-numbers
	    if (zMax === zMin) {
	      return Math.max(minRadius, 1);
	    }
	    var maxArea = Math.PI * Math.pow(maxRadius, 2);
	    var minArea = Math.PI * Math.pow(minRadius, 2);
	    var pointArea = (datum[z] - zMin) / (zMax - zMin) * maxArea;
	    var area = Math.max(pointArea, minArea);
	    var radius = Math.sqrt(area / Math.PI);
	    return Math.max(radius, 1);
	  },
	  getSize: function (datum, props) {
	    var size = props.size,
	        z = props.z;
	
	    if (datum.size) {
	      return typeof datum.size === "function" ? datum.size : Math.max(datum.size, 1);
	    } else if (typeof props.size === "function") {
	      return size;
	    } else if (datum[z]) {
	      return this.getBubbleSize(datum, props);
	    } else {
	      return Math.max(size || 0, 1);
	    }
	  }
	};

/***/ },
/* 593 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _partialRight2 = __webpack_require__(16);
	
	var _partialRight3 = _interopRequireDefault(_partialRight2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _victoryCore = __webpack_require__(3);
	
	var _helperMethods = __webpack_require__(592);
	
	var _helperMethods2 = _interopRequireDefault(_helperMethods);
	
	var _commonProps = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var fallbackProps = {
	  width: 450,
	  height: 300,
	  padding: 50,
	  size: 3,
	  symbol: "circle"
	};
	
	var animationWhitelist = ["data", "domain", "height", "maxBubbleSize", "padding", "samples", "size", "style", "width"];
	
	var VictoryScatter = function (_React$Component) {
	  _inherits(VictoryScatter, _React$Component);
	
	  function VictoryScatter() {
	    _classCallCheck(this, VictoryScatter);
	
	    return _possibleConstructorReturn(this, (VictoryScatter.__proto__ || Object.getPrototypeOf(VictoryScatter)).apply(this, arguments));
	  }
	
	  _createClass(VictoryScatter, [{
	    key: "shouldAnimate",
	
	
	    // Overridden in native versions
	    value: function shouldAnimate() {
	      return !!this.props.animate;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var role = this.constructor.role;
	
	      var props = _victoryCore.Helpers.modifyProps(this.props, fallbackProps, role);
	      if (this.shouldAnimate()) {
	        return this.animateComponent(props, animationWhitelist);
	      }
	      var children = this.renderData(props);
	      return props.standalone ? this.renderContainer(props.containerComponent, children) : children;
	    }
	  }]);
	
	  return VictoryScatter;
	}(_react2.default.Component);
	
	VictoryScatter.displayName = "VictoryScatter";
	VictoryScatter.role = "scatter";
	VictoryScatter.defaultTransitions = _victoryCore.DefaultTransitions.discreteTransitions();
	VictoryScatter.propTypes = _extends({}, _commonProps.BaseProps, _commonProps.DataProps, {
	  bubbleProperty: _propTypes2.default.string,
	  maxBubbleSize: _victoryCore.PropTypes.nonNegative,
	  minBubbleSize: _victoryCore.PropTypes.nonNegative,
	  size: _propTypes2.default.oneOfType([_victoryCore.PropTypes.nonNegative, _propTypes2.default.func]),
	  symbol: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(["circle", "diamond", "plus", "square", "star", "triangleDown", "triangleUp"]), _propTypes2.default.func])
	});
	VictoryScatter.defaultProps = {
	  containerComponent: _react2.default.createElement(_victoryCore.VictoryContainer, null),
	  dataComponent: _react2.default.createElement(_victoryCore.Point, null),
	  labelComponent: _react2.default.createElement(_victoryCore.VictoryLabel, null),
	  groupComponent: _react2.default.createElement("g", null),
	  samples: 50,
	  scale: "linear",
	  sortOrder: "ascending",
	  standalone: true,
	  theme: _victoryCore.VictoryTheme.grayscale
	};
	VictoryScatter.getDomain = _victoryCore.Domain.getDomain.bind(_victoryCore.Domain);
	VictoryScatter.getData = _victoryCore.Data.getData.bind(_victoryCore.Data);
	VictoryScatter.getBaseProps = (0, _partialRight3.default)(_helperMethods2.default.getBaseProps.bind(_helperMethods2.default), fallbackProps);
	VictoryScatter.expectedComponents = ["dataComponent", "labelComponent", "groupComponent", "containerComponent"];
	exports.default = (0, _victoryCore.addEvents)(VictoryScatter);

/***/ },
/* 594 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defaults2 = __webpack_require__(5);
	
	var _defaults3 = _interopRequireDefault(_defaults2);
	
	var _assign2 = __webpack_require__(4);
	
	var _assign3 = _interopRequireDefault(_assign2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _victoryCore = __webpack_require__(3);
	
	var _wrapper = __webpack_require__(61);
	
	var _wrapper2 = _interopRequireDefault(_wrapper);
	
	var _commonProps = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var fallbackProps = {
	  width: 450,
	  height: 300,
	  padding: 50
	};
	
	var VictoryStack = function (_React$Component) {
	  _inherits(VictoryStack, _React$Component);
	
	  function VictoryStack(props) {
	    _classCallCheck(this, VictoryStack);
	
	    var _this = _possibleConstructorReturn(this, (VictoryStack.__proto__ || Object.getPrototypeOf(VictoryStack)).call(this, props));
	
	    if (props.animate) {
	      _this.state = {
	        nodesShouldLoad: false,
	        nodesDoneLoad: false,
	        animating: true
	      };
	      _this.setAnimationState = _wrapper2.default.setAnimationState.bind(_this);
	      _this.events = _wrapper2.default.getAllEvents(props);
	    }
	    return _this;
	  }
	
	  _createClass(VictoryStack, [{
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      this.events = _wrapper2.default.getAllEvents(this.props);
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.animate) {
	        this.setAnimationState(this.props, nextProps);
	      }
	      this.events = _wrapper2.default.getAllEvents(nextProps);
	    }
	  }, {
	    key: "getCalculatedProps",
	    value: function getCalculatedProps(props, childComponents) {
	      var role = this.constructor.role;
	
	      var style = this.getStyle(props.theme, props.style, role);
	      var horizontal = props.horizontal || childComponents.every(function (component) {
	        return component.props.horizontal;
	      });
	      var datasets = _wrapper2.default.getDataFromChildren(props);
	      var domain = {
	        x: _wrapper2.default.getStackedDomain(props, "x", datasets),
	        y: _wrapper2.default.getStackedDomain(props, "y", datasets)
	      };
	      var range = {
	        x: _victoryCore.Helpers.getRange(props, "x"),
	        y: _victoryCore.Helpers.getRange(props, "y")
	      };
	      var baseScale = {
	        x: _victoryCore.Scale.getScaleFromProps(props, "x") || _victoryCore.Scale.getDefaultScale(),
	        y: _victoryCore.Scale.getScaleFromProps(props, "y") || _victoryCore.Scale.getDefaultScale()
	      };
	      var xScale = baseScale.x.domain(domain.x).range(range.x);
	      var yScale = baseScale.y.domain(domain.y).range(range.y);
	      var scale = {
	        x: horizontal ? yScale : xScale,
	        y: horizontal ? xScale : yScale
	      };
	      var categories = {
	        x: _wrapper2.default.getCategories(props, "x"),
	        y: _wrapper2.default.getCategories(props, "y")
	      };
	      var colorScale = props.colorScale;
	      return { datasets: datasets, categories: categories, range: range, domain: domain, horizontal: horizontal, scale: scale, style: style, colorScale: colorScale, role: role };
	    }
	  }, {
	    key: "addLayoutData",
	    value: function addLayoutData(props, calculatedProps, datasets, index) {
	      // eslint-disable-line max-params
	      var xOffset = props.xOffset || 0;
	      return datasets[index].map(function (datum) {
	        var yOffset = _wrapper2.default.getY0(datum, index, calculatedProps) || 0;
	        return (0, _assign3.default)({}, datum, {
	          _y0: datum._y instanceof Date ? yOffset && new Date(yOffset) || datum._y : yOffset,
	          _y1: datum._y instanceof Date ? new Date(+datum._y + +yOffset) : datum._y + yOffset,
	          _x1: datum._x instanceof Date ? new Date(+datum._x + +xOffset) : datum._x + xOffset
	        });
	      });
	    }
	  }, {
	    key: "getLabels",
	    value: function getLabels(props, datasets, index) {
	      if (!props.labels) {
	        return undefined;
	      }
	      return datasets.length === index + 1 ? props.labels : undefined;
	    }
	  }, {
	    key: "getChildProps",
	    value: function getChildProps(props, calculatedProps) {
	      var categories = calculatedProps.categories,
	          domain = calculatedProps.domain,
	          range = calculatedProps.range,
	          scale = calculatedProps.scale,
	          horizontal = calculatedProps.horizontal;
	
	      return {
	        height: props.height,
	        width: props.width,
	        padding: _victoryCore.Helpers.getPadding(props),
	        standalone: false,
	        theme: props.theme,
	        categories: categories,
	        domain: domain,
	        range: range,
	        scale: scale,
	        horizontal: horizontal
	      };
	    }
	  }, {
	    key: "getColorScale",
	    value: function getColorScale(props, child) {
	      var role = child.type && child.type.role;
	      var colorScaleOptions = child.props.colorScale || props.colorScale;
	      if (role !== "group" && role !== "stack") {
	        return undefined;
	      }
	      return props.theme ? colorScaleOptions || props.theme.props.colorScale : colorScaleOptions;
	    }
	
	    // the old ones were bad
	
	  }, {
	    key: "getNewChildren",
	    value: function getNewChildren(props, childComponents, calculatedProps) {
	      var _this2 = this;
	
	      var datasets = calculatedProps.datasets;
	
	      var childProps = this.getChildProps(props, calculatedProps);
	      var getAnimationProps = _wrapper2.default.getAnimationProps.bind(this);
	
	      return childComponents.map(function (child, index) {
	        var data = _this2.addLayoutData(props, calculatedProps, datasets, index);
	        var style = _wrapper2.default.getChildStyle(child, index, calculatedProps);
	        var labels = props.labels ? _this2.getLabels(props, datasets, index) : child.props.labels;
	
	        return _react2.default.cloneElement(child, (0, _assign3.default)({
	          animate: getAnimationProps(props, child, index),
	          key: index,
	          labels: labels,
	          domainPadding: child.props.domainPadding || props.domainPadding,
	          theme: props.theme,
	          labelComponent: props.labelComponent || child.props.labelComponent,
	          style: style,
	          colorScale: _this2.getColorScale(props, child),
	          data: data,
	          polar: props.polar
	        }, childProps));
	      });
	    }
	  }, {
	    key: "renderContainer",
	    value: function renderContainer(containerComponent, props) {
	      var containerProps = (0, _defaults3.default)({}, containerComponent.props, props);
	      return _react2.default.cloneElement(containerComponent, containerProps);
	    }
	  }, {
	    key: "getContainerProps",
	    value: function getContainerProps(props, calculatedProps) {
	      var width = props.width,
	          height = props.height,
	          standalone = props.standalone,
	          theme = props.theme,
	          polar = props.polar;
	      var domain = calculatedProps.domain,
	          scale = calculatedProps.scale,
	          style = calculatedProps.style,
	          origin = calculatedProps.origin;
	
	      return {
	        domain: domain, scale: scale, width: width, height: height, standalone: standalone, theme: theme, style: style.parent, polar: polar, origin: origin
	      };
	    }
	  }, {
	    key: "getStyle",
	    value: function getStyle(theme, style, role) {
	      var defaultStyle = theme && theme[role] && theme[role].style ? theme[role].style : {};
	      return _victoryCore.Helpers.getStyles(style, defaultStyle);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var role = this.constructor.role;
	
	      var props = this.state && this.state.nodesWillExit ? this.state.oldProps || this.props : this.props;
	      var modifiedProps = _victoryCore.Helpers.modifyProps(props, fallbackProps, role);
	      var eventKey = modifiedProps.eventKey,
	          containerComponent = modifiedProps.containerComponent,
	          standalone = modifiedProps.standalone,
	          groupComponent = modifiedProps.groupComponent;
	
	      var childComponents = _react2.default.Children.toArray(modifiedProps.children);
	      var calculatedProps = this.getCalculatedProps(modifiedProps, childComponents);
	      var newChildren = this.getNewChildren(modifiedProps, childComponents, calculatedProps);
	      var containerProps = standalone ? this.getContainerProps(modifiedProps, calculatedProps) : {};
	      var container = standalone ? this.renderContainer(containerComponent, containerProps) : groupComponent;
	      if (this.events) {
	        return _react2.default.createElement(
	          _victoryCore.VictorySharedEvents,
	          { events: this.events, eventKey: eventKey, container: container },
	          newChildren
	        );
	      }
	
	      return _react2.default.cloneElement(container, container.props, newChildren);
	    }
	  }]);
	
	  return VictoryStack;
	}(_react2.default.Component);
	
	VictoryStack.displayName = "VictoryStack";
	VictoryStack.role = "stack";
	VictoryStack.propTypes = _extends({}, _commonProps.BaseProps, {
	  categories: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.string), _propTypes2.default.shape({
	    x: _propTypes2.default.arrayOf(_propTypes2.default.string), y: _propTypes2.default.arrayOf(_propTypes2.default.string)
	  })]),
	  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	  colorScale: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.string), _propTypes2.default.oneOf(["grayscale", "qualitative", "heatmap", "warm", "cool", "red", "green", "blue"])]),
	  horizontal: _propTypes2.default.bool,
	  labelComponent: _propTypes2.default.element,
	  labels: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.array]),
	  style: _propTypes2.default.shape({
	    parent: _propTypes2.default.object, data: _propTypes2.default.object, labels: _propTypes2.default.object
	  }),
	  xOffset: _propTypes2.default.number
	});
	VictoryStack.defaultProps = {
	  containerComponent: _react2.default.createElement(_victoryCore.VictoryContainer, null),
	  groupComponent: _react2.default.createElement("g", null),
	  scale: "linear",
	  standalone: true,
	  theme: _victoryCore.VictoryTheme.grayscale
	};
	VictoryStack.expectedComponents = ["groupComponent", "containerComponent", "labelComponent"];
	VictoryStack.getDomain = _wrapper2.default.getStackedDomain.bind(_wrapper2.default);
	VictoryStack.getData = _wrapper2.default.getData.bind(_wrapper2.default);
	exports.default = VictoryStack;

/***/ },
/* 595 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isNaN2 = __webpack_require__(56);
	
	var _isNaN3 = _interopRequireDefault(_isNaN2);
	
	var _without2 = __webpack_require__(97);
	
	var _without3 = _interopRequireDefault(_without2);
	
	var _defaults2 = __webpack_require__(5);
	
	var _defaults3 = _interopRequireDefault(_defaults2);
	
	var _omit2 = __webpack_require__(25);
	
	var _omit3 = _interopRequireDefault(_omit2);
	
	var _keys2 = __webpack_require__(12);
	
	var _keys3 = _interopRequireDefault(_keys2);
	
	var _assign2 = __webpack_require__(4);
	
	var _assign3 = _interopRequireDefault(_assign2);
	
	var _victoryCore = __webpack_require__(3);
	
	var _d3Voronoi = __webpack_require__(167);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	exports.default = {
	  getBaseProps: function (props, fallbackProps) {
	    var _this = this;
	
	    var modifiedProps = _victoryCore.Helpers.modifyProps(props, fallbackProps, "scatter");
	    props = (0, _assign3.default)({}, modifiedProps, this.getCalculatedValues(modifiedProps));
	    var _props = props,
	        data = _props.data,
	        domain = _props.domain,
	        events = _props.events,
	        height = _props.height,
	        origin = _props.origin,
	        padding = _props.padding,
	        polar = _props.polar,
	        polygons = _props.polygons,
	        scale = _props.scale,
	        sharedEvents = _props.sharedEvents,
	        standalone = _props.standalone,
	        style = _props.style,
	        theme = _props.theme,
	        width = _props.width;
	
	    var initialChildProps = { parent: {
	        style: style.parent, scale: scale, domain: domain, data: data, standalone: standalone, height: height, width: width, theme: theme,
	        origin: origin, polar: polar, padding: padding
	      } };
	
	    return data.reduce(function (childProps, datum, index) {
	      var polygon = (0, _without3.default)(polygons[index], "data");
	      var eventKey = datum.eventKey;
	
	      var _Helpers$scalePoint = _victoryCore.Helpers.scalePoint(props, datum),
	          x = _Helpers$scalePoint.x,
	          y = _Helpers$scalePoint.y;
	
	      var dataProps = {
	        x: x, y: y, datum: datum, data: data, index: index, scale: scale, polygon: polygon, origin: origin,
	        size: props.size,
	        style: _this.getDataStyles(datum, style.data)
	      };
	
	      childProps[eventKey] = { data: dataProps };
	      var text = _victoryCore.LabelHelpers.getText(props, datum, index);
	      if (text !== undefined && text !== null || events || sharedEvents) {
	        childProps[eventKey].labels = _victoryCore.LabelHelpers.getProps(props, index);
	      }
	
	      return childProps;
	    }, initialChildProps);
	  },
	  getCalculatedValues: function (props) {
	    var defaultStyles = props.theme && props.theme.voronoi && props.theme.voronoi.style ? props.theme.voronoi.style : {};
	    var style = _victoryCore.Helpers.getStyles(props.style, defaultStyles);
	    var data = _victoryCore.Data.getData(props);
	    var range = {
	      x: _victoryCore.Helpers.getRange(props, "x"),
	      y: _victoryCore.Helpers.getRange(props, "y")
	    };
	    var domain = {
	      x: _victoryCore.Domain.getDomain(props, "x"),
	      y: _victoryCore.Domain.getDomain(props, "y")
	    };
	    var scale = {
	      x: _victoryCore.Scale.getBaseScale(props, "x").domain(domain.x).range(range.x),
	      y: _victoryCore.Scale.getBaseScale(props, "y").domain(domain.y).range(range.y)
	    };
	    var voronoi = this.getVoronoi(props, range, scale);
	    var polygons = voronoi.polygons(data);
	    var origin = props.polar ? props.origin || _victoryCore.Helpers.getPolarOrigin(props) : undefined;
	    return { domain: domain, data: data, scale: scale, style: style, polygons: polygons, origin: origin };
	  },
	  getVoronoi: function (props, range, scale) {
	    var minRange = [Math.min.apply(Math, _toConsumableArray(range.x)), Math.min.apply(Math, _toConsumableArray(range.y))];
	    var maxRange = [Math.max.apply(Math, _toConsumableArray(range.x)), Math.max.apply(Math, _toConsumableArray(range.y))];
	    var angleAccessor = function (d) {
	      var x = scale.x(d._x1 !== undefined ? d._x1 : d._x);
	      return -1 * x + Math.PI / 2;
	    };
	    var xAccessor = function (d) {
	      return scale.x(d._x1 !== undefined ? d._x1 : d._x);
	    };
	    return (0, _d3Voronoi.voronoi)().x(function (d) {
	      return props.polar ? angleAccessor(d) : xAccessor(d);
	    }).y(function (d) {
	      return scale.y(d._y1 !== undefined ? d._y1 : d._y);
	    }).extent([minRange, maxRange]);
	  },
	  getDataStyles: function (datum, style) {
	    var numKeys = (0, _keys3.default)(datum).filter(function (k) {
	      return (0, _isNaN3.default)(k);
	    });
	    var omitKeys = ["x", "y", "_x", "_y", "eventKey", "label"];
	    var stylesFromData = (0, _omit3.default)(datum, [].concat(omitKeys, _toConsumableArray(numKeys)));
	    return (0, _defaults3.default)({}, stylesFromData, style);
	  }
	};

/***/ },
/* 596 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _partialRight2 = __webpack_require__(16);
	
	var _partialRight3 = _interopRequireDefault(_partialRight2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _victoryCore = __webpack_require__(3);
	
	var _helperMethods = __webpack_require__(595);
	
	var _helperMethods2 = _interopRequireDefault(_helperMethods);
	
	var _commonProps = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var fallbackProps = {
	  width: 450,
	  height: 300,
	  padding: 50
	};
	
	var animationWhitelist = ["data", "domain", "height", "padding", "samples", "size", "style", "width"];
	
	var VictoryVoronoi = function (_React$Component) {
	  _inherits(VictoryVoronoi, _React$Component);
	
	  function VictoryVoronoi() {
	    _classCallCheck(this, VictoryVoronoi);
	
	    return _possibleConstructorReturn(this, (VictoryVoronoi.__proto__ || Object.getPrototypeOf(VictoryVoronoi)).apply(this, arguments));
	  }
	
	  _createClass(VictoryVoronoi, [{
	    key: "shouldAnimate",
	
	
	    // Overridden in native versions
	    value: function shouldAnimate() {
	      return !!this.props.animate;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var role = this.constructor.role;
	
	      var props = _victoryCore.Helpers.modifyProps(this.props, fallbackProps, role);
	      if (this.shouldAnimate()) {
	        return this.animateComponent(props, animationWhitelist);
	      }
	      var children = this.renderData(props);
	      return props.standalone ? this.renderContainer(props.containerComponent, children) : children;
	    }
	  }]);
	
	  return VictoryVoronoi;
	}(_react2.default.Component);
	
	VictoryVoronoi.displayName = "VictoryVoronoi";
	VictoryVoronoi.role = "voronoi";
	VictoryVoronoi.defaultTransitions = _victoryCore.DefaultTransitions.discreteTransitions();
	VictoryVoronoi.propTypes = _extends({}, _commonProps.BaseProps, _commonProps.DataProps, {
	  size: _victoryCore.PropTypes.nonNegative
	});
	VictoryVoronoi.defaultProps = {
	  containerComponent: _react2.default.createElement(_victoryCore.VictoryContainer, null),
	  dataComponent: _react2.default.createElement(_victoryCore.Voronoi, null),
	  labelComponent: _react2.default.createElement(_victoryCore.VictoryLabel, null),
	  groupComponent: _react2.default.createElement("g", { role: "presentation" }),
	  samples: 50,
	  scale: "linear",
	  sortOrder: "ascending",
	  standalone: true,
	  theme: _victoryCore.VictoryTheme.grayscale
	};
	VictoryVoronoi.getDomain = _victoryCore.Domain.getDomain.bind(_victoryCore.Domain);
	VictoryVoronoi.getData = _victoryCore.Data.getData.bind(_victoryCore.Data);
	VictoryVoronoi.getBaseProps = (0, _partialRight3.default)(_helperMethods2.default.getBaseProps.bind(_helperMethods2.default), fallbackProps);
	VictoryVoronoi.expectedComponents = ["dataComponent", "labelComponent", "groupComponent", "containerComponent"];
	exports.default = (0, _victoryCore.addEvents)(VictoryVoronoi);

/***/ },
/* 597 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _victoryChart = __webpack_require__(585);
	
	Object.defineProperty(exports, "VictoryChart", {
	  enumerable: true,
	  get: function () {
	    return _interopRequireDefault(_victoryChart).default;
	  }
	});
	
	var _victoryLine = __webpack_require__(590);
	
	Object.defineProperty(exports, "VictoryLine", {
	  enumerable: true,
	  get: function () {
	    return _interopRequireDefault(_victoryLine).default;
	  }
	});
	
	var _victoryAxis = __webpack_require__(256);
	
	Object.defineProperty(exports, "VictoryAxis", {
	  enumerable: true,
	  get: function () {
	    return _interopRequireDefault(_victoryAxis).default;
	  }
	});
	
	var _victoryPolarAxis = __webpack_require__(257);
	
	Object.defineProperty(exports, "VictoryPolarAxis", {
	  enumerable: true,
	  get: function () {
	    return _interopRequireDefault(_victoryPolarAxis).default;
	  }
	});
	
	var _victoryArea = __webpack_require__(578);
	
	Object.defineProperty(exports, "VictoryArea", {
	  enumerable: true,
	  get: function () {
	    return _interopRequireDefault(_victoryArea).default;
	  }
	});
	
	var _victoryBar = __webpack_require__(581);
	
	Object.defineProperty(exports, "VictoryBar", {
	  enumerable: true,
	  get: function () {
	    return _interopRequireDefault(_victoryBar).default;
	  }
	});
	
	var _victoryScatter = __webpack_require__(593);
	
	Object.defineProperty(exports, "VictoryScatter", {
	  enumerable: true,
	  get: function () {
	    return _interopRequireDefault(_victoryScatter).default;
	  }
	});
	
	var _victoryGroup = __webpack_require__(588);
	
	Object.defineProperty(exports, "VictoryGroup", {
	  enumerable: true,
	  get: function () {
	    return _interopRequireDefault(_victoryGroup).default;
	  }
	});
	
	var _victoryStack = __webpack_require__(594);
	
	Object.defineProperty(exports, "VictoryStack", {
	  enumerable: true,
	  get: function () {
	    return _interopRequireDefault(_victoryStack).default;
	  }
	});
	
	var _victoryErrorbar = __webpack_require__(587);
	
	Object.defineProperty(exports, "VictoryErrorBar", {
	  enumerable: true,
	  get: function () {
	    return _interopRequireDefault(_victoryErrorbar).default;
	  }
	});
	
	var _victoryVoronoi = __webpack_require__(596);
	
	Object.defineProperty(exports, "VictoryVoronoi", {
	  enumerable: true,
	  get: function () {
	    return _interopRequireDefault(_victoryVoronoi).default;
	  }
	});
	
	var _victoryCandlestick = __webpack_require__(583);
	
	Object.defineProperty(exports, "VictoryCandlestick", {
	  enumerable: true,
	  get: function () {
	    return _interopRequireDefault(_victoryCandlestick).default;
	  }
	});
	
	var _victorySelectionContainer = __webpack_require__(251);
	
	Object.defineProperty(exports, "selectionContainerMixin", {
	  enumerable: true,
	  get: function () {
	    return _victorySelectionContainer.selectionContainerMixin;
	  }
	});
	Object.defineProperty(exports, "VictorySelectionContainer", {
	  enumerable: true,
	  get: function () {
	    return _interopRequireDefault(_victorySelectionContainer).default;
	  }
	});
	
	var _victoryBrushContainer = __webpack_require__(249);
	
	Object.defineProperty(exports, "brushContainerMixin", {
	  enumerable: true,
	  get: function () {
	    return _victoryBrushContainer.brushContainerMixin;
	  }
	});
	Object.defineProperty(exports, "VictoryBrushContainer", {
	  enumerable: true,
	  get: function () {
	    return _interopRequireDefault(_victoryBrushContainer).default;
	  }
	});
	
	var _victoryVoronoiContainer = __webpack_require__(252);
	
	Object.defineProperty(exports, "voronoiContainerMixin", {
	  enumerable: true,
	  get: function () {
	    return _victoryVoronoiContainer.voronoiContainerMixin;
	  }
	});
	Object.defineProperty(exports, "VictoryVoronoiContainer", {
	  enumerable: true,
	  get: function () {
	    return _interopRequireDefault(_victoryVoronoiContainer).default;
	  }
	});
	
	var _victoryCursorContainer = __webpack_require__(250);
	
	Object.defineProperty(exports, "cursorContainerMixin", {
	  enumerable: true,
	  get: function () {
	    return _victoryCursorContainer.cursorContainerMixin;
	  }
	});
	Object.defineProperty(exports, "VictoryCursorContainer", {
	  enumerable: true,
	  get: function () {
	    return _interopRequireDefault(_victoryCursorContainer).default;
	  }
	});
	
	var _victoryZoomContainer = __webpack_require__(253);
	
	Object.defineProperty(exports, "zoomContainerMixin", {
	  enumerable: true,
	  get: function () {
	    return _victoryZoomContainer.zoomContainerMixin;
	  }
	});
	Object.defineProperty(exports, "VictoryZoomContainer", {
	  enumerable: true,
	  get: function () {
	    return _interopRequireDefault(_victoryZoomContainer).default;
	  }
	});
	
	var _createContainer = __webpack_require__(576);
	
	Object.defineProperty(exports, "combineContainerMixins", {
	  enumerable: true,
	  get: function () {
	    return _createContainer.combineContainerMixins;
	  }
	});
	Object.defineProperty(exports, "makeCreateContainerFunction", {
	  enumerable: true,
	  get: function () {
	    return _createContainer.makeCreateContainerFunction;
	  }
	});
	Object.defineProperty(exports, "createContainer", {
	  enumerable: true,
	  get: function () {
	    return _interopRequireDefault(_createContainer).default;
	  }
	});
	
	var _brushHelpers = __webpack_require__(144);
	
	Object.defineProperty(exports, "BrushHelpers", {
	  enumerable: true,
	  get: function () {
	    return _interopRequireDefault(_brushHelpers).default;
	  }
	});
	
	var _cursorHelpers = __webpack_require__(247);
	
	Object.defineProperty(exports, "CursorHelpers", {
	  enumerable: true,
	  get: function () {
	    return _interopRequireDefault(_cursorHelpers).default;
	  }
	});
	
	var _selectionHelpers = __webpack_require__(248);
	
	Object.defineProperty(exports, "SelectionHelpers", {
	  enumerable: true,
	  get: function () {
	    return _interopRequireDefault(_selectionHelpers).default;
	  }
	});
	
	var _voronoiHelpers = __webpack_require__(254);
	
	Object.defineProperty(exports, "VoronoiHelpers", {
	  enumerable: true,
	  get: function () {
	    return _interopRequireDefault(_voronoiHelpers).default;
	  }
	});
	
	var _zoomHelpers = __webpack_require__(255);
	
	Object.defineProperty(exports, "ZoomHelpers", {
	  enumerable: true,
	  get: function () {
	    return _interopRequireDefault(_zoomHelpers).default;
	  }
	});
	Object.defineProperty(exports, "RawZoomHelpers", {
	  enumerable: true,
	  get: function () {
	    return _zoomHelpers.RawZoomHelpers;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 598 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.victoryInterpolator = exports.interpolateString = exports.interpolateObject = exports.interpolateFunction = exports.interpolateImmediate = exports.isInterpolatable = undefined;
	
	var _sortBy2 = __webpack_require__(58);
	
	var _sortBy3 = _interopRequireDefault(_sortBy2);
	
	var _isPlainObject2 = __webpack_require__(36);
	
	var _isPlainObject3 = _interopRequireDefault(_isPlainObject2);
	
	var _d3Interpolate = __webpack_require__(165);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isInterpolatable = exports.isInterpolatable = function (obj) {
	  // d3 turns null into 0 and undefined into NaN, which we don't want.
	  if (obj !== null) {
	    switch (typeof obj) {
	      case "undefined":
	        return false;
	      case "number":
	        // The standard `isNaN` is fine in this case since we already know the
	        // type is number.
	        return !isNaN(obj) && obj !== Number.POSITIVE_INFINITY && obj !== Number.NEGATIVE_INFINITY;
	      case "string":
	        // d3 might not *actually* be able to interpolate the string, but it
	        // won't cause any issues to let it try.
	        return true;
	      case "boolean":
	        // d3 turns Booleans into integers, which we don't want. Sure, we could
	        // interpolate from 0 -> 1, but we'd be sending a non-Boolean to
	        // something expecting a Boolean.
	        return false;
	      case "object":
	        // Don't try to interpolate class instances (except Date or Array).
	        return obj instanceof Date || Array.isArray(obj) || (0, _isPlainObject3.default)(obj);
	      case "function":
	        // Careful! There may be extra properties on function objects that the
	        // component expects to access - for instance, it may be a `d3.scale()`
	        // function, which has its own methods attached. We don't know if the
	        // component is only going to call the function (in which case it's
	        // safely interpolatable) or if it's going to access special properties
	        // (in which case our function generated from `interpolateFunction` will
	        // most likely cause an error. We could check for enumerable properties
	        // on the function object here to see if it's a "plain" function, but
	        // let's just require that components prevent such function props from
	        // being animated in the first place.
	        return true;
	    }
	  }
	  return false;
	};
	
	/**
	 * Interpolate immediately to the end value at the given step `when`.
	 * Some nicer default behavior might be to jump at the halfway point or return
	 * `a` if `t` is 0 (instead of always returning `b`). But d3's default
	 * interpolator does not do these things:
	 *
	 *   d3.interpolate('aaa', 'bbb')(0) === 'bbb'
	 *
	 * ...and things might get wonky if we don't replicate that behavior.
	 *
	 * @param {any} a - Start value.
	 * @param {any} b - End value.
	 * @param {Number} when - Step value (0 to 1) at which to jump to `b`.
	 * @returns {Function} An interpolation function.
	 */
	var interpolateImmediate = exports.interpolateImmediate = function (a, b) {
	  var when = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	
	  return function (t) {
	    return t < when ? a : b;
	  };
	};
	
	/**
	 * Interpolate to or from a function. The interpolated value will be a function
	 * that calls `a` (if it's a function) and `b` (if it's a function) and calls
	 * `d3.interpolate` on the resulting values. Note that our function won't
	 * necessarily be called (that's up to the component this eventually gets
	 * passed to) - but if it does get called, it will return an appropriately
	 * interpolated value.
	 *
	 * @param {any} a - Start value.
	 * @param {any} b - End value.
	 * @returns {Function} An interpolation function.
	 */
	var interpolateFunction = exports.interpolateFunction = function (a, b) {
	  return function (t) {
	    if (t >= 1) {
	      return b;
	    }
	    return function () {
	      /* eslint-disable no-invalid-this */
	      var aval = typeof a === "function" ? a.apply(this, arguments) : a;
	      var bval = typeof b === "function" ? b.apply(this, arguments) : b;
	      return (0, _d3Interpolate.interpolate)(aval, bval)(t);
	    };
	  };
	};
	
	/**
	 * Interpolate to or from an object. This method is a modification of the object interpolator in
	 * d3-interpolate https://github.com/d3/d3-interpolate/blob/master/src/object.js. This interpolator
	 * differs in that it uses our custom interpolators when interpolating the value of each property in
	 * an object. This allows the correct interpolation of nested objects, including styles
	 *
	 * @param {any} a - Start value.
	 * @param {any} b - End value.
	 * @returns {Function} An interpolation function.
	 */
	var interpolateObject = exports.interpolateObject = function (a, b) {
	  var interpolateTypes = function (x, y) {
	    if (x === y || !isInterpolatable(x) || !isInterpolatable(y)) {
	      return interpolateImmediate(x, y);
	    }
	    if (typeof x === "function" || typeof y === "function") {
	      return interpolateFunction(x, y);
	    }
	    if (typeof x === "object" && (0, _isPlainObject3.default)(x) || typeof y === "object" && (0, _isPlainObject3.default)(y)) {
	      return interpolateObject(x, y);
	    }
	    return (0, _d3Interpolate.interpolate)(x, y);
	  };
	
	  // When the value is an array, attempt to sort by "key" so that animating nodes may be identified
	  // based on "key" instead of index
	  var keyData = function (val) {
	    return Array.isArray(val) ? (0, _sortBy3.default)(val, "key") : val;
	  };
	
	  var i = {};
	  var c = {};
	  var k = void 0;
	
	  if (a === null || typeof a !== "object") {
	    a = {};
	  }
	  if (b === null || typeof b !== "object") {
	    b = {};
	  }
	
	  for (k in b) {
	    if (k in a) {
	      i[k] = interpolateTypes(keyData(a[k]), keyData(b[k]));
	    } else {
	      c[k] = b[k];
	    }
	  }
	
	  return function (t) {
	    for (k in i) {
	      c[k] = i[k](t);
	    }
	    return c;
	  };
	};
	
	var interpolateString = exports.interpolateString = function (a, b) {
	  var format = function (val) {
	    return typeof val === "string" ? val.replace(/,/g, "") : val;
	  };
	
	  return (0, _d3Interpolate.interpolate)(format(a), format(b));
	};
	
	/**
	 * By default, the list of interpolators used by `d3.interpolate` has a few
	 * downsides:
	 *
	 * - `null` values get turned into 0.
	 * - `undefined`, `function`, and some other value types get turned into NaN.
	 * - Boolean types get turned into numbers, which probably will be meaningless
	 *   to whatever is consuming them.
	 * - It tries to interpolate between identical start and end values, doing
	 *   unnecessary calculations that sometimes result in floating point rounding
	 *   errors.
	 *
	 * If only the default interpolators are used, `VictoryAnimation` will happily
	 * pass down NaN (and other bad) values as props to the wrapped component.
	 * The component will then either use the incorrect values or complain that it
	 * was passed props of the incorrect type. This custom interpolator is added
	 * using the `d3.interpolators` API, and prevents such cases from happening
	 * for most values.
	 *
	 * @param {any} a - Start value.
	 * @param {any} b - End value.
	 * @returns {Function|undefined} An interpolation function, if necessary.
	 */
	var victoryInterpolator = exports.victoryInterpolator = function (a, b) {
	  // If the values are strictly equal, or either value is not interpolatable,
	  // just use either the start value `a` or end value `b` at every step, as
	  // there is no reasonable in-between value.
	  if (a === b || !isInterpolatable(a) || !isInterpolatable(b)) {
	    return interpolateImmediate(a, b);
	  }
	  if (typeof a === "function" || typeof b === "function") {
	    return interpolateFunction(a, b);
	  }
	  if ((0, _isPlainObject3.default)(a) || (0, _isPlainObject3.default)(b)) {
	    return interpolateObject(a, b);
	  }
	  if (typeof a === "string" || typeof b === "string") {
	    return interpolateString(a, b);
	  }
	  return (0, _d3Interpolate.interpolate)(a, b);
	};

/***/ },
/* 599 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _uniqueId2 = __webpack_require__(138);
	
	var _uniqueId3 = _interopRequireDefault(_uniqueId2);
	
	var _isObject2 = __webpack_require__(10);
	
	var _isObject3 = _interopRequireDefault(_isObject2);
	
	var _isFunction2 = __webpack_require__(7);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _defaults2 = __webpack_require__(5);
	
	var _defaults3 = _interopRequireDefault(_defaults2);
	
	var _assign2 = __webpack_require__(4);
	
	var _assign3 = _interopRequireDefault(_assign2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _propTypes3 = __webpack_require__(26);
	
	var _propTypes4 = _interopRequireDefault(_propTypes3);
	
	var _clipPath = __webpack_require__(262);
	
	var _clipPath2 = _interopRequireDefault(_clipPath);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var VictoryClipContainer = function (_React$Component) {
	  _inherits(VictoryClipContainer, _React$Component);
	
	  function VictoryClipContainer(props) {
	    _classCallCheck(this, VictoryClipContainer);
	
	    var _this = _possibleConstructorReturn(this, (VictoryClipContainer.__proto__ || Object.getPrototypeOf(VictoryClipContainer)).call(this, props));
	
	    _this.clipId = !(0, _isObject3.default)(props) || typeof props.clipId === "undefined" ? (0, _uniqueId3.default)("victory-clip-") : props.clipId;
	    return _this;
	  }
	
	  // Overridden in victory-core-native
	
	
	  _createClass(VictoryClipContainer, [{
	    key: "renderClippedGroup",
	    value: function renderClippedGroup(props, clipId) {
	      var style = props.style,
	          events = props.events,
	          transform = props.transform,
	          children = props.children,
	          className = props.className;
	
	      var clipComponent = this.renderClipComponent(props, clipId);
	      return _react2.default.createElement(
	        "g",
	        _extends({
	          className: className,
	          style: style
	        }, events, {
	          transform: transform
	        }),
	        clipComponent,
	        _react2.default.createElement(
	          "g",
	          { clipPath: "url(#" + clipId + ")" },
	          children
	        )
	      );
	    }
	
	    // Overridden in victory-core-native
	
	  }, {
	    key: "renderGroup",
	    value: function renderGroup(props) {
	      var style = props.style,
	          events = props.events,
	          transform = props.transform,
	          children = props.children,
	          className = props.className;
	
	      return _react2.default.createElement(
	        "g",
	        _extends({
	          className: className,
	          style: style
	        }, events, {
	          transform: transform
	        }),
	        children
	      );
	    }
	
	    // Overridden in victory-core-native
	
	  }, {
	    key: "renderClipComponent",
	    value: function renderClipComponent(props, clipId) {
	      return _react2.default.cloneElement(props.clipPathComponent, (0, _assign3.default)({}, props, { clipId: clipId }));
	    }
	  }, {
	    key: "getClipValue",
	    value: function getClipValue(props, axis) {
	      var clipValues = { x: props.clipWidth, y: props.clipHeight };
	      if (clipValues[axis] !== undefined) {
	        return clipValues[axis];
	      }
	      var range = this.getRange(props, axis);
	      return range ? Math.abs(range[0] - range[1]) || undefined : undefined;
	    }
	  }, {
	    key: "getTranslateValue",
	    value: function getTranslateValue(props, axis) {
	      var translateValues = { x: props.translateX, y: props.translateY };
	      if (translateValues[axis] !== undefined) {
	        return translateValues[axis];
	      }
	      var range = this.getRange(props, axis);
	      return range ? Math.min.apply(Math, _toConsumableArray(range)) : undefined;
	    }
	  }, {
	    key: "getRange",
	    value: function getRange(props, axis) {
	      var scale = props.scale || {};
	      if (!scale[axis]) {
	        return undefined;
	      }
	      return (0, _isFunction3.default)(scale[axis].range) ? scale[axis].range() : undefined;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var clipHeight = this.getClipValue(this.props, "y");
	      var clipWidth = this.getClipValue(this.props, "x");
	      if (clipWidth === undefined || clipHeight === undefined) {
	        return this.renderGroup(this.props);
	      }
	      var translateX = this.getTranslateValue(this.props, "x");
	      var translateY = this.getTranslateValue(this.props, "y");
	      var clipProps = (0, _defaults3.default)({}, this.props, { clipHeight: clipHeight, clipWidth: clipWidth, translateX: translateX, translateY: translateY });
	      return this.renderClippedGroup(clipProps, this.clipId);
	    }
	  }]);
	
	  return VictoryClipContainer;
	}(_react2.default.Component);
	
	VictoryClipContainer.displayName = "VictoryClipContainer";
	VictoryClipContainer.role = "container";
	VictoryClipContainer.propTypes = {
	  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	  className: _propTypes2.default.string,
	  clipHeight: _propTypes4.default.nonNegative,
	  clipId: _propTypes2.default.number,
	  clipPadding: _propTypes2.default.shape({
	    top: _propTypes2.default.number, bottom: _propTypes2.default.number,
	    left: _propTypes2.default.number, right: _propTypes2.default.number
	  }),
	  clipPathComponent: _propTypes2.default.element,
	  clipWidth: _propTypes4.default.nonNegative,
	  events: _propTypes2.default.object,
	  origin: _propTypes2.default.shape({ x: _propTypes4.default.nonNegative, y: _propTypes4.default.nonNegative }),
	  polar: _propTypes2.default.bool,
	  radius: _propTypes4.default.nonNegative,
	  style: _propTypes2.default.object,
	  transform: _propTypes2.default.string,
	  translateX: _propTypes2.default.number,
	  translateY: _propTypes2.default.number
	};
	VictoryClipContainer.defaultProps = {
	  clipPathComponent: _react2.default.createElement(_clipPath2.default, null)
	};
	exports.default = VictoryClipContainer;

/***/ },
/* 600 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _range2 = __webpack_require__(96);
	
	var _range3 = _interopRequireDefault(_range2);
	
	var _sum2 = __webpack_require__(500);
	
	var _sum3 = _interopRequireDefault(_sum2);
	
	var _keys2 = __webpack_require__(12);
	
	var _keys3 = _interopRequireDefault(_keys2);
	
	var _groupBy2 = __webpack_require__(130);
	
	var _groupBy3 = _interopRequireDefault(_groupBy2);
	
	var _assign2 = __webpack_require__(4);
	
	var _assign3 = _interopRequireDefault(_assign2);
	
	var _defaults2 = __webpack_require__(5);
	
	var _defaults3 = _interopRequireDefault(_defaults2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _helpers = __webpack_require__(6);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	var _style = __webpack_require__(152);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _textsize = __webpack_require__(153);
	
	var _textsize2 = _interopRequireDefault(_textsize);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var getColorScale = function (props) {
	  var colorScale = props.colorScale;
	
	  return typeof colorScale === "string" ? _style2.default.getColorScale(colorScale) : colorScale || [];
	};
	
	var getLabelStyles = function (props) {
	  var data = props.data,
	      style = props.style;
	
	  return data.map(function (datum) {
	    var baseLabelStyles = (0, _defaults3.default)({}, datum.labels, style.labels);
	    return _helpers2.default.evaluateStyle(baseLabelStyles, datum);
	  });
	};
	
	var getStyles = function (props, styleObject) {
	  var style = props.style || {};
	  styleObject = styleObject || {};
	  var parentStyleProps = { height: "100%", width: "100%" };
	  return {
	    parent: (0, _defaults3.default)(style.parent, styleObject.parent, parentStyleProps),
	    data: (0, _defaults3.default)({}, style.data, styleObject.data),
	    labels: (0, _defaults3.default)({}, style.labels, styleObject.labels),
	    border: (0, _defaults3.default)({}, style.border, styleObject.border),
	    title: (0, _defaults3.default)({}, style.title, styleObject.title)
	  };
	};
	
	var getCalculatedValues = function (props) {
	  var orientation = props.orientation,
	      theme = props.theme;
	
	  var defaultStyles = theme && theme.legend && theme.legend.style ? theme.legend.style : {};
	  var style = getStyles(props, defaultStyles);
	  var colorScale = getColorScale(props);
	  var isHorizontal = orientation === "horizontal";
	  var borderPadding = _helpers2.default.formatPadding(props.borderPadding);
	  return (0, _assign3.default)({}, props, { style: style, isHorizontal: isHorizontal, colorScale: colorScale, borderPadding: borderPadding });
	};
	
	var getColumn = function (props, index) {
	  var itemsPerRow = props.itemsPerRow,
	      isHorizontal = props.isHorizontal;
	
	  if (!itemsPerRow) {
	    return isHorizontal ? index : 0;
	  }
	  return isHorizontal ? index % itemsPerRow : Math.floor(index / itemsPerRow);
	};
	
	var getRow = function (props, index) {
	  var itemsPerRow = props.itemsPerRow,
	      isHorizontal = props.isHorizontal;
	
	  if (!itemsPerRow) {
	    return isHorizontal ? 0 : index;
	  }
	  return isHorizontal ? Math.floor(index / itemsPerRow) : index % itemsPerRow;
	};
	
	var groupData = function (props) {
	  var data = props.data;
	
	  var style = props.style && props.style.data || {};
	  var labelStyles = getLabelStyles(props);
	  return data.map(function (datum, index) {
	    var symbol = datum.symbol || {};
	    var fontSize = labelStyles[index].fontSize;
	    // eslint-disable-next-line no-magic-numbers
	
	    var size = symbol.size || style.size || fontSize / 2.5;
	    var symbolSpacer = props.symbolSpacer || Math.max(size, fontSize);
	    return _extends({}, datum, { size: size, symbolSpacer: symbolSpacer, fontSize: fontSize,
	      textSize: _textsize2.default.approximateTextSize(datum.name, labelStyles[index]),
	      column: getColumn(props, index),
	      row: getRow(props, index)
	    });
	  });
	};
	
	var getColumnWidths = function (props, data) {
	  var gutter = props.gutter || {};
	  var gutterWidth = typeof gutter === "object" ? (gutter.left || 0) + (gutter.right || 0) : gutter || 0;
	  var dataByColumn = (0, _groupBy3.default)(data, "column");
	  var columns = (0, _keys3.default)(dataByColumn);
	  return columns.reduce(function (memo, curr, index) {
	    var lengths = dataByColumn[curr].map(function (d) {
	      return d.textSize.width + d.size + d.symbolSpacer + gutterWidth;
	    });
	    memo[index] = Math.max.apply(Math, _toConsumableArray(lengths));
	    return memo;
	  }, []);
	};
	
	var getRowHeights = function (props, data) {
	  var gutter = props.rowGutter || {};
	  var gutterHeight = typeof gutter === "object" ? (gutter.top || 0) + (gutter.bottom || 0) : gutter || 0;
	  var dataByRow = (0, _groupBy3.default)(data, "row");
	  return (0, _keys3.default)(dataByRow).reduce(function (memo, curr, index) {
	    var rows = dataByRow[curr];
	    var lengths = rows.map(function (d) {
	      return d.textSize.height + d.symbolSpacer + gutterHeight;
	    });
	    memo[index] = Math.max.apply(Math, _toConsumableArray(lengths));
	    return memo;
	  }, []);
	};
	
	var getTitleDimensions = function (props) {
	  var style = props.style && props.style.title || {};
	  var textSize = _textsize2.default.approximateTextSize(props.title, style);
	  var padding = style.padding || 0;
	  return { height: textSize.height + 2 * padding || 0, width: textSize.width + 2 * padding || 0 };
	};
	
	var getOffset = function (datum, rowHeights, columnWidths) {
	  var column = datum.column,
	      row = datum.row;
	
	  return {
	    x: (0, _range3.default)(column).reduce(function (memo, curr) {
	      memo += columnWidths[curr];
	      return memo;
	    }, 0),
	    y: (0, _range3.default)(row).reduce(function (memo, curr) {
	      memo += rowHeights[curr];
	      return memo;
	    }, 0)
	  };
	};
	
	var getAnchors = function (titleOrientation, centerTitle) {
	  var standardAnchors = {
	    textAnchor: titleOrientation === "right" ? "end" : "start",
	    verticalAnchor: titleOrientation === "bottom" ? "end" : "start"
	  };
	  if (centerTitle) {
	    var horizontal = titleOrientation === "top" || titleOrientation === "bottom";
	    return {
	      textAnchor: horizontal ? "middle" : standardAnchors.textAnchor,
	      verticalAnchor: horizontal ? standardAnchors.verticalAnchor : "middle"
	    };
	  } else {
	    return standardAnchors;
	  }
	};
	
	var getTitleStyle = function (props) {
	  var titleOrientation = props.titleOrientation,
	      centerTitle = props.centerTitle,
	      titleComponent = props.titleComponent;
	
	  var baseStyle = props.style && props.style.title || {};
	  var componentStyle = titleComponent.props && titleComponent.props.style || {};
	  var anchors = getAnchors(titleOrientation, centerTitle);
	  return Array.isArray(componentStyle) ? componentStyle.map(function (obj) {
	    return (0, _defaults3.default)({}, obj, baseStyle, anchors);
	  }) : (0, _defaults3.default)({}, componentStyle, baseStyle, anchors);
	};
	
	// eslint-disable-next-line complexity
	var getTitleProps = function (props, borderProps) {
	  var title = props.title,
	      titleOrientation = props.titleOrientation,
	      centerTitle = props.centerTitle,
	      borderPadding = props.borderPadding;
	  var height = borderProps.height,
	      width = borderProps.width;
	
	  var style = getTitleStyle(props);
	  var padding = Array.isArray(style) ? style[0].padding : style.padding;
	  var horizontal = titleOrientation === "top" || titleOrientation === "bottom";
	  var xOrientation = titleOrientation === "bottom" ? "bottom" : "top";
	  var yOrientation = titleOrientation === "right" ? "right" : "left";
	  var standardPadding = {
	    x: centerTitle ? width / 2 : borderPadding[xOrientation] + (padding || 0),
	    y: centerTitle ? height / 2 : borderPadding[yOrientation] + (padding || 0)
	  };
	  var getPadding = function () {
	    return borderPadding[titleOrientation] + (padding || 0);
	  };
	  var xOffset = horizontal ? standardPadding.x : getPadding();
	  var yOffset = horizontal ? getPadding() : standardPadding.y;
	
	  return {
	    x: titleOrientation === "right" ? props.x + width - xOffset : props.x + xOffset,
	    y: titleOrientation === "bottom" ? props.y + height - yOffset : props.y + yOffset,
	    style: style,
	    text: title
	  };
	};
	
	var getBorderProps = function (props, contentHeight, contentWidth) {
	  var x = props.x,
	      y = props.y,
	      borderPadding = props.borderPadding,
	      style = props.style;
	
	  var height = contentHeight + borderPadding.top + borderPadding.bottom;
	  var width = contentWidth + borderPadding.left + borderPadding.right;
	  return { x: x, y: y, height: height, width: width, style: style.border };
	};
	
	// eslint-disable-next-line max-statements, complexity
	
	exports.default = function (props, fallbackProps) {
	  var modifiedProps = _helpers2.default.modifyProps(props, fallbackProps, "legend");
	  props = (0, _assign3.default)({}, modifiedProps, getCalculatedValues(modifiedProps));
	  var _props = props,
	      data = _props.data,
	      standalone = _props.standalone,
	      theme = _props.theme,
	      padding = _props.padding,
	      style = _props.style,
	      colorScale = _props.colorScale,
	      gutter = _props.gutter,
	      rowGutter = _props.rowGutter,
	      borderPadding = _props.borderPadding,
	      title = _props.title,
	      titleOrientation = _props.titleOrientation,
	      _props$x = _props.x,
	      x = _props$x === undefined ? 0 : _props$x,
	      _props$y = _props.y,
	      y = _props$y === undefined ? 0 : _props$y;
	
	  var groupedData = groupData(props);
	  var columnWidths = getColumnWidths(props, groupedData);
	  var rowHeights = getRowHeights(props, groupedData);
	  var labelStyles = getLabelStyles(props);
	  var titleDimensions = title ? getTitleDimensions(props) : { height: 0, width: 0 };
	  var titleOffset = {
	    x: titleOrientation === "left" ? titleDimensions.width : 0,
	    y: titleOrientation === "top" ? titleDimensions.height : 0
	  };
	  var gutterOffset = {
	    x: gutter && typeof gutter === "object" ? gutter.left || 0 : 0,
	    y: rowGutter && typeof rowGutter === "object" ? rowGutter.top || 0 : 0
	  };
	
	  var contentHeight = titleOrientation === "left" || titleOrientation === "right" ? Math.max((0, _sum3.default)(rowHeights), titleDimensions.height) : (0, _sum3.default)(rowHeights) + titleDimensions.height;
	  var contentWidth = titleOrientation === "left" || titleOrientation === "right" ? (0, _sum3.default)(columnWidths) + titleDimensions.width : Math.max((0, _sum3.default)(columnWidths), titleDimensions.width);
	
	  var initialProps = {
	    parent: {
	      data: data, standalone: standalone, theme: theme, padding: padding,
	      height: props.height,
	      width: props.width,
	      style: style.parent
	    }
	  };
	  var borderProps = getBorderProps(props, contentHeight, contentWidth);
	  var titleProps = getTitleProps(props, borderProps);
	  return groupedData.reduce(function (childProps, datum, i) {
	    var color = colorScale[i % colorScale.length];
	    var dataStyle = (0, _defaults3.default)({}, datum.symbol, style.data, { fill: color });
	    var eventKey = datum.eventKey || i;
	    var offset = getOffset(datum, rowHeights, columnWidths);
	    var originY = y + borderPadding.top + datum.symbolSpacer;
	    var originX = x + borderPadding.left + datum.symbolSpacer;
	    var dataProps = {
	      index: i,
	      data: data, datum: datum,
	      key: "legend-symbol-" + i,
	      symbol: dataStyle.type || dataStyle.symbol || "circle",
	      size: datum.size,
	      style: dataStyle,
	      y: originY + offset.y + titleOffset.y + gutterOffset.y,
	      x: originX + offset.x + titleOffset.x + gutterOffset.x
	    };
	
	    var labelProps = {
	      datum: datum, data: data,
	      key: "legend-label-" + i,
	      text: datum.name,
	      style: labelStyles[i],
	      y: dataProps.y,
	      x: dataProps.x + datum.symbolSpacer + datum.size / 2
	    };
	    childProps[eventKey] = eventKey === 0 ? { data: dataProps, labels: labelProps, border: borderProps, title: titleProps } : { data: dataProps, labels: labelProps };
	
	    return childProps;
	  }, initialProps);
	};

/***/ },
/* 601 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _partialRight2 = __webpack_require__(16);
	
	var _partialRight3 = _interopRequireDefault(_partialRight2);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _helperMethods = __webpack_require__(600);
	
	var _helperMethods2 = _interopRequireDefault(_helperMethods);
	
	var _propTypes3 = __webpack_require__(26);
	
	var _propTypes4 = _interopRequireDefault(_propTypes3);
	
	var _addEvents = __webpack_require__(267);
	
	var _addEvents2 = _interopRequireDefault(_addEvents);
	
	var _helpers = __webpack_require__(6);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	var _victoryLabel = __webpack_require__(145);
	
	var _victoryLabel2 = _interopRequireDefault(_victoryLabel);
	
	var _victoryContainer = __webpack_require__(259);
	
	var _victoryContainer2 = _interopRequireDefault(_victoryContainer);
	
	var _victoryTheme = __webpack_require__(147);
	
	var _victoryTheme2 = _interopRequireDefault(_victoryTheme);
	
	var _point = __webpack_require__(265);
	
	var _point2 = _interopRequireDefault(_point);
	
	var _border = __webpack_require__(261);
	
	var _border2 = _interopRequireDefault(_border);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var fallbackProps = {
	  orientation: "vertical",
	  width: 450,
	  height: 300,
	  x: 0,
	  y: 0
	};
	
	var defaultLegendData = [{ name: "Series 1" }, { name: "Series 2" }];
	
	var VictoryLegend = function (_React$Component) {
	  _inherits(VictoryLegend, _React$Component);
	
	  function VictoryLegend() {
	    _classCallCheck(this, VictoryLegend);
	
	    return _possibleConstructorReturn(this, (VictoryLegend.__proto__ || Object.getPrototypeOf(VictoryLegend)).apply(this, arguments));
	  }
	
	  _createClass(VictoryLegend, [{
	    key: "renderChildren",
	    value: function renderChildren(props) {
	      var _this2 = this;
	
	      var dataComponent = props.dataComponent,
	          labelComponent = props.labelComponent,
	          title = props.title;
	
	      var dataComponents = this.dataKeys.map(function (_dataKey, index) {
	        var dataProps = _this2.getComponentProps(dataComponent, "data", index);
	        return _react2.default.cloneElement(dataComponent, dataProps);
	      });
	
	      var labelComponents = this.dataKeys.map(function (_dataKey, index) {
	        var labelProps = _this2.getComponentProps(labelComponent, "labels", index);
	        if (typeof labelProps.text !== "undefined" && labelProps.text !== null) {
	          return _react2.default.cloneElement(labelComponent, labelProps);
	        }
	        return undefined;
	      }).filter(Boolean);
	
	      var borderProps = this.getComponentProps(props.borderComponent, "border", 0);
	      var borderComponent = _react2.default.cloneElement(props.borderComponent, borderProps);
	      if (title) {
	        var titleProps = this.getComponentProps(props.title, "title", 0);
	        var titleComponent = _react2.default.cloneElement(props.titleComponent, titleProps);
	        return [borderComponent].concat(_toConsumableArray(dataComponents), [titleComponent], _toConsumableArray(labelComponents));
	      }
	      return [borderComponent].concat(_toConsumableArray(dataComponents), _toConsumableArray(labelComponents));
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var role = this.constructor.role;
	
	      var props = _helpers2.default.modifyProps(this.props, fallbackProps, role);
	      var children = [this.renderChildren(props)];
	      return props.standalone ? this.renderContainer(props.containerComponent, children) : _react2.default.cloneElement(props.groupComponent, {}, children);
	    }
	  }]);
	
	  return VictoryLegend;
	}(_react2.default.Component);
	
	VictoryLegend.displayName = "VictoryLegend";
	VictoryLegend.role = "legend";
	VictoryLegend.propTypes = {
	  borderComponent: _propTypes2.default.element,
	  borderPadding: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.shape({
	    top: _propTypes2.default.number,
	    bottom: _propTypes2.default.number,
	    left: _propTypes2.default.number,
	    right: _propTypes2.default.number
	  })]),
	  centerTitle: _propTypes2.default.bool,
	  colorScale: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.string), _propTypes2.default.oneOf(["grayscale", "qualitative", "heatmap", "warm", "cool", "red", "green", "blue"])]),
	  containerComponent: _propTypes2.default.element,
	  data: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    name: _propTypes2.default.string.isRequired,
	    label: _propTypes2.default.object,
	    symbol: _propTypes2.default.object
	  })),
	  dataComponent: _propTypes2.default.element,
	  eventKey: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes4.default.allOfType([_propTypes4.default.integer, _propTypes4.default.nonNegative]), _propTypes2.default.string]),
	  events: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    target: _propTypes2.default.oneOf(["data", "labels", "parent"]),
	    eventKey: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes4.default.allOfType([_propTypes4.default.integer, _propTypes4.default.nonNegative]), _propTypes2.default.string]),
	    eventHandlers: _propTypes2.default.object
	  })),
	  groupComponent: _propTypes2.default.element,
	  gutter: _propTypes2.default.oneOfType([_propTypes4.default.nonNegative, _propTypes2.default.shape({
	    left: _propTypes4.default.nonNegative,
	    right: _propTypes4.default.nonNegative
	  })]),
	  height: _propTypes4.default.nonNegative,
	  itemsPerRow: _propTypes4.default.nonNegative,
	  labelComponent: _propTypes2.default.element,
	  orientation: _propTypes2.default.oneOf(["horizontal", "vertical"]),
	  padding: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.shape({
	    top: _propTypes2.default.number,
	    bottom: _propTypes2.default.number,
	    left: _propTypes2.default.number,
	    right: _propTypes2.default.number
	  })]),
	  rowGutter: _propTypes2.default.oneOfType([_propTypes4.default.nonNegative, _propTypes2.default.shape({
	    top: _propTypes4.default.nonNegative,
	    bottom: _propTypes4.default.nonNegative
	  })]),
	  sharedEvents: _propTypes2.default.shape({
	    events: _propTypes2.default.array,
	    getEventState: _propTypes2.default.func
	  }),
	  standalone: _propTypes2.default.bool,
	  style: _propTypes2.default.shape({
	    border: _propTypes2.default.object,
	    data: _propTypes2.default.object,
	    labels: _propTypes2.default.object,
	    parent: _propTypes2.default.object,
	    title: _propTypes2.default.object
	  }),
	  symbolSpacer: _propTypes2.default.number,
	  theme: _propTypes2.default.object,
	  title: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.array]),
	  titleComponent: _propTypes2.default.element,
	  titleOrientation: _propTypes2.default.oneOf(["top", "bottom", "left", "right"]),
	  width: _propTypes4.default.nonNegative,
	  x: _propTypes4.default.nonNegative,
	  y: _propTypes4.default.nonNegative
	};
	VictoryLegend.defaultProps = {
	  borderComponent: _react2.default.createElement(_border2.default, null),
	  data: defaultLegendData,
	  containerComponent: _react2.default.createElement(_victoryContainer2.default, null),
	  dataComponent: _react2.default.createElement(_point2.default, null),
	  groupComponent: _react2.default.createElement("g", null),
	  labelComponent: _react2.default.createElement(_victoryLabel2.default, null),
	  standalone: true,
	  theme: _victoryTheme2.default.grayscale,
	  titleComponent: _react2.default.createElement(_victoryLabel2.default, null)
	};
	VictoryLegend.getBaseProps = (0, _partialRight3.default)(_helperMethods2.default, fallbackProps);
	VictoryLegend.expectedComponents = ["borderComponent", "containerComponent", "dataComponent", "groupComponent", "labelComponent", "titleComponent"];
	exports.default = (0, _addEvents2.default)(VictoryLegend);

/***/ },
/* 602 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isEqual2 = __webpack_require__(43);
	
	var _isEqual3 = _interopRequireDefault(_isEqual2);
	
	var _assign2 = __webpack_require__(4);
	
	var _assign3 = _interopRequireDefault(_assign2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _helpers = __webpack_require__(6);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	var _commonProps = __webpack_require__(19);
	
	var _commonProps2 = _interopRequireDefault(_commonProps);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*eslint no-magic-numbers: ["error", { "ignore": [0, 1, 2, 180] }]*/
	
	
	var Arc = function (_React$Component) {
	  _inherits(Arc, _React$Component);
	
	  function Arc() {
	    _classCallCheck(this, Arc);
	
	    return _possibleConstructorReturn(this, (Arc.__proto__ || Object.getPrototypeOf(Arc)).apply(this, arguments));
	  }
	
	  _createClass(Arc, [{
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      this.style = this.getStyle(this.props);
	    }
	  }, {
	    key: "shouldComponentUpdate",
	    value: function shouldComponentUpdate(nextProps) {
	      var _props = this.props,
	          cx = _props.cx,
	          cy = _props.cy,
	          r = _props.r;
	
	      var style = this.getStyle(nextProps);
	      if (cx !== nextProps.cx || cy !== nextProps.cy || r !== nextProps.r) {
	        this.style = style;
	        return true;
	      }
	      if (!(0, _isEqual3.default)(style, this.style)) {
	        this.style = style;
	        return true;
	      }
	      return false;
	    }
	  }, {
	    key: "getStyle",
	    value: function getStyle(props) {
	      var style = props.style,
	          datum = props.datum,
	          active = props.active;
	
	      return _helpers2.default.evaluateStyle((0, _assign3.default)({ stroke: "black", fill: "none" }, style), datum, active);
	    }
	  }, {
	    key: "getArcPath",
	    value: function getArcPath(props) {
	      var cx = props.cx,
	          cy = props.cy,
	          r = props.r,
	          startAngle = props.startAngle,
	          endAngle = props.endAngle,
	          closedPath = props.closedPath;
	      // Always draw the path as two arcs so that complete circles may be rendered.
	
	      var halfAngle = Math.abs(endAngle - startAngle) / 2 + startAngle;
	      var x1 = cx + r * Math.cos(_helpers2.default.degreesToRadians(startAngle));
	      var y1 = cy - r * Math.sin(_helpers2.default.degreesToRadians(startAngle));
	      var x2 = cx + r * Math.cos(_helpers2.default.degreesToRadians(halfAngle));
	      var y2 = cy - r * Math.sin(_helpers2.default.degreesToRadians(halfAngle));
	      var x3 = cx + r * Math.cos(_helpers2.default.degreesToRadians(endAngle));
	      var y3 = cy - r * Math.sin(_helpers2.default.degreesToRadians(endAngle));
	      var largerArcFlag1 = halfAngle - startAngle <= 180 ? 0 : 1;
	      var largerArcFlag2 = endAngle - halfAngle <= 180 ? 0 : 1;
	      var arcStart = closedPath ? " M " + cx + ", " + cy + " L " + x1 + ", " + y1 : "M " + x1 + ", " + y1;
	      var arc1 = "A " + r + ", " + r + ", 0, " + largerArcFlag1 + ", 0, " + x2 + ", " + y2;
	      var arc2 = "A " + r + ", " + r + ", 0, " + largerArcFlag2 + ", 0, " + x3 + ", " + y3;
	      var arcEnd = closedPath ? "Z" : "";
	      return arcStart + " " + arc1 + " " + arc2 + " " + arcEnd;
	    }
	
	    // Overridden in victory-core-native
	
	  }, {
	    key: "renderAxisLine",
	    value: function renderAxisLine(props, style, events) {
	      var role = props.role,
	          shapeRendering = props.shapeRendering,
	          className = props.className;
	
	      var path = this.getArcPath(props);
	      return _react2.default.createElement("path", _extends({ className: className,
	        d: path,
	        style: style,
	        role: role || "presentation",
	        shapeRendering: shapeRendering || "auto"
	      }, events));
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return this.renderAxisLine(this.props, this.style, this.props.events);
	    }
	  }]);
	
	  return Arc;
	}(_react2.default.Component);
	
	Arc.propTypes = _extends({}, _commonProps2.default, {
	  closedPath: _propTypes2.default.bool,
	  cx: _propTypes2.default.number,
	  cy: _propTypes2.default.number,
	  datum: _propTypes2.default.any,
	  endAngle: _propTypes2.default.number,
	  r: _propTypes2.default.number,
	  startAngle: _propTypes2.default.number
	});
	exports.default = Arc;

/***/ },
/* 603 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign2 = __webpack_require__(4);
	
	var _assign3 = _interopRequireDefault(_assign2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _collection = __webpack_require__(8);
	
	var _collection2 = _interopRequireDefault(_collection);
	
	var _helpers = __webpack_require__(6);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	var _helpers3 = __webpack_require__(264);
	
	var _d3Shape = __webpack_require__(63);
	
	var d3Shape = _interopRequireWildcard(_d3Shape);
	
	var _commonProps = __webpack_require__(19);
	
	var _commonProps2 = _interopRequireDefault(_commonProps);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*eslint no-magic-numbers: ["error", { "ignore": [-1, 0, 1, 2] }]*/
	
	
	var Area = function (_React$Component) {
	  _inherits(Area, _React$Component);
	
	  function Area() {
	    _classCallCheck(this, Area);
	
	    return _possibleConstructorReturn(this, (Area.__proto__ || Object.getPrototypeOf(Area)).apply(this, arguments));
	  }
	
	  _createClass(Area, [{
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      var _calculateAttributes = this.calculateAttributes(this.props),
	          style = _calculateAttributes.style,
	          areaPath = _calculateAttributes.areaPath,
	          linePath = _calculateAttributes.linePath;
	
	      this.style = style;
	      this.areaPath = areaPath;
	      this.linePath = linePath;
	    }
	  }, {
	    key: "shouldComponentUpdate",
	    value: function shouldComponentUpdate(nextProps) {
	      var _calculateAttributes2 = this.calculateAttributes(nextProps),
	          style = _calculateAttributes2.style,
	          areaPath = _calculateAttributes2.areaPath,
	          linePath = _calculateAttributes2.linePath;
	
	      var _props = this.props,
	          className = _props.className,
	          interpolation = _props.interpolation;
	
	      if (!_collection2.default.allSetsEqual([[className, nextProps.className], [interpolation, nextProps.interpolation], [linePath, this.linePath], [areaPath, this.areaPath], [style, this.style]])) {
	        this.style = style;
	        this.areaPath = areaPath;
	        this.linePath = linePath;
	        return true;
	      }
	      return false;
	    }
	  }, {
	    key: "getLineFunction",
	    value: function getLineFunction(props) {
	      var polar = props.polar,
	          scale = props.scale;
	
	      var interpolation = this.toNewName(props.interpolation);
	      return polar ? d3Shape.lineRadial().defined(_helpers3.defined).curve(d3Shape[interpolation + "Closed"]).angle((0, _helpers3.getAngleAccessor)(scale)).radius((0, _helpers3.getY0Accessor)(scale)) : d3Shape.line().defined(_helpers3.defined).curve(d3Shape[interpolation]).x((0, _helpers3.getXAccessor)(scale)).y((0, _helpers3.getYAccessor)(scale));
	    }
	  }, {
	    key: "getAreaFunction",
	    value: function getAreaFunction(props) {
	      var polar = props.polar,
	          scale = props.scale;
	
	      var interpolation = this.toNewName(props.interpolation);
	      return polar ? d3Shape.radialArea().defined(_helpers3.defined).curve(d3Shape[interpolation + "Closed"]).angle((0, _helpers3.getAngleAccessor)(scale)).outerRadius((0, _helpers3.getYAccessor)(scale)).innerRadius((0, _helpers3.getY0Accessor)(scale)) : d3Shape.area().defined(_helpers3.defined).curve(d3Shape[interpolation]).x((0, _helpers3.getXAccessor)(scale)).y1((0, _helpers3.getYAccessor)(scale)).y0((0, _helpers3.getY0Accessor)(scale));
	    }
	  }, {
	    key: "calculateAttributes",
	    value: function calculateAttributes(props) {
	      var style = props.style,
	          data = props.data,
	          active = props.active;
	
	      var areaFunction = this.getAreaFunction(props);
	      var lineFunction = this.getLineFunction(props);
	      return {
	        style: _helpers2.default.evaluateStyle((0, _assign3.default)({ fill: "black" }, style), data, active),
	        areaPath: areaFunction(data),
	        linePath: lineFunction(data)
	      };
	    }
	  }, {
	    key: "toNewName",
	    value: function toNewName(interpolation) {
	      // d3 shape changed the naming scheme for interpolators from "basis" -> "curveBasis" etc.
	      var capitalize = function (s) {
	        return s && s[0].toUpperCase() + s.slice(1);
	      };
	      return "curve" + capitalize(interpolation);
	    }
	
	    // Overridden in victory-core-native
	
	  }, {
	    key: "renderArea",
	    value: function renderArea(path, style, events) {
	      var areaStroke = style.stroke ? "none" : style.fill;
	      var areaStyle = (0, _assign3.default)({}, style, { stroke: areaStroke });
	      var _props2 = this.props,
	          role = _props2.role,
	          shapeRendering = _props2.shapeRendering,
	          className = _props2.className,
	          polar = _props2.polar,
	          origin = _props2.origin;
	
	      var transform = polar && origin ? "translate(" + origin.x + ", " + origin.y + ")" : undefined;
	      return _react2.default.createElement("path", _extends({
	        key: "area",
	        style: areaStyle,
	        shapeRendering: shapeRendering || "auto",
	        role: role || "presentation",
	        d: path,
	        transform: transform,
	        className: className
	      }, events));
	    }
	
	    // Overridden in victory-core-native
	
	  }, {
	    key: "renderLine",
	    value: function renderLine(path, style, events) {
	      if (!style.stroke || style.stroke === "none" || style.stroke === "transparent") {
	        return null;
	      }
	      var _props3 = this.props,
	          role = _props3.role,
	          shapeRendering = _props3.shapeRendering,
	          className = _props3.className,
	          polar = _props3.polar,
	          origin = _props3.origin;
	
	      var transform = polar && origin ? "translate(" + origin.x + ", " + origin.y + ")" : undefined;
	      var lineStyle = (0, _assign3.default)({}, style, { fill: "none" });
	      return _react2.default.createElement("path", _extends({
	        key: "area-stroke",
	        style: lineStyle,
	        shapeRendering: shapeRendering || "auto",
	        role: role || "presentation",
	        d: path,
	        transform: transform,
	        className: className
	      }, events));
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _props4 = this.props,
	          events = _props4.events,
	          groupComponent = _props4.groupComponent;
	
	      var area = this.renderArea(this.areaPath, this.style, events);
	      var line = this.renderLine(this.linePath, this.style, events);
	
	      if (!line) {
	        return area;
	      }
	      var children = [area, line].map(function (el, i) {
	        return _react2.default.cloneElement(el, { key: i });
	      });
	      return _react2.default.cloneElement(groupComponent, {}, children);
	    }
	  }]);
	
	  return Area;
	}(_react2.default.Component);
	
	Area.propTypes = _extends({}, _commonProps2.default, {
	  groupComponent: _propTypes2.default.element,
	  interpolation: _propTypes2.default.string
	});
	Area.defaultProps = {
	  groupComponent: _react2.default.createElement("g", null)
	};
	exports.default = Area;

/***/ },
/* 604 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign2 = __webpack_require__(4);
	
	var _assign3 = _interopRequireDefault(_assign2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _helpers = __webpack_require__(6);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	var _collection = __webpack_require__(8);
	
	var _collection2 = _interopRequireDefault(_collection);
	
	var _commonProps = __webpack_require__(19);
	
	var _commonProps2 = _interopRequireDefault(_commonProps);
	
	var _d3Shape = __webpack_require__(63);
	
	var d3Shape = _interopRequireWildcard(_d3Shape);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Bar = function (_React$Component) {
	  _inherits(Bar, _React$Component);
	
	  function Bar() {
	    _classCallCheck(this, Bar);
	
	    return _possibleConstructorReturn(this, (Bar.__proto__ || Object.getPrototypeOf(Bar)).apply(this, arguments));
	  }
	
	  _createClass(Bar, [{
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      var _calculateAttributes = this.calculateAttributes(this.props),
	          style = _calculateAttributes.style,
	          path = _calculateAttributes.path;
	
	      this.style = style;
	      this.path = path;
	    }
	  }, {
	    key: "shouldComponentUpdate",
	    value: function shouldComponentUpdate(nextProps) {
	      var _calculateAttributes2 = this.calculateAttributes(nextProps),
	          style = _calculateAttributes2.style,
	          path = _calculateAttributes2.path;
	
	      var _props = this.props,
	          className = _props.className,
	          datum = _props.datum,
	          horizontal = _props.horizontal,
	          x = _props.x,
	          y = _props.y,
	          y0 = _props.y0;
	
	      if (!_collection2.default.allSetsEqual([[className, nextProps.className], [x, nextProps.x], [y, nextProps.y], [y0, nextProps.y0], [horizontal, nextProps.horizontal], [path, this.path], [style, this.style], [datum, nextProps.datum]])) {
	        this.style = style;
	        this.path = path;
	        return true;
	      }
	      return false;
	    }
	  }, {
	    key: "calculateAttributes",
	    value: function calculateAttributes(props) {
	      var datum = props.datum,
	          active = props.active,
	          polar = props.polar;
	
	      var stroke = props.style && props.style.fill || "black";
	      var baseStyle = { fill: "black", stroke: stroke };
	      var style = _helpers2.default.evaluateStyle((0, _assign3.default)(baseStyle, props.style), datum, active);
	      var width = this.getBarWidth(props, style);
	      var path = polar ? this.getPolarBarPath(props, width) : this.getBarPath(props, width);
	      return { style: style, path: path };
	    }
	  }, {
	    key: "getPosition",
	    value: function getPosition(props, width) {
	      var x = props.x,
	          y = props.y,
	          y0 = props.y0,
	          horizontal = props.horizontal;
	
	      var alignment = props.alignment || "middle";
	      var size = alignment === "middle" ? width / 2 : width;
	      var sign = horizontal ? -1 : 1;
	      return {
	        x0: alignment === "start" ? x : x - sign * size,
	        x1: alignment === "end" ? x : x + sign * size,
	        y0: y0,
	        y1: y
	      };
	    }
	  }, {
	    key: "getVerticalBarPath",
	    value: function getVerticalBarPath(props, width) {
	      var _getPosition = this.getPosition(props, width),
	          x0 = _getPosition.x0,
	          x1 = _getPosition.x1,
	          y0 = _getPosition.y0,
	          y1 = _getPosition.y1;
	
	      var cornerRadius = props.cornerRadius || 0;
	      var sign = y0 > y1 ? 1 : -1;
	      var direction = sign > 0 ? "0 0 1" : "0 0 0";
	      var arc = cornerRadius + " " + cornerRadius + " " + direction;
	      return "M " + x0 + ", " + y0 + "\n      L " + x0 + ", " + (y1 + sign * cornerRadius) + "\n      A " + arc + ", " + (x0 + cornerRadius) + ", " + y1 + "\n      L " + (x1 - cornerRadius) + ", " + y1 + "\n      A " + arc + ", " + x1 + ", " + (y1 + sign * cornerRadius) + "\n      L " + x1 + ", " + y0 + "\n      L " + x0 + ", " + y0 + "\n      z";
	    }
	  }, {
	    key: "getHorizontalBarPath",
	    value: function getHorizontalBarPath(props, width) {
	      var _getPosition2 = this.getPosition(props, width),
	          x0 = _getPosition2.x0,
	          x1 = _getPosition2.x1,
	          y0 = _getPosition2.y0,
	          y1 = _getPosition2.y1;
	
	      var cornerRadius = props.cornerRadius || 0;
	      var sign = y1 > y0 ? 1 : -1;
	      var direction = sign > 0 ? "0 0 1" : "0 0 0";
	      var arc = cornerRadius + " " + cornerRadius + " " + direction;
	      return "M " + y0 + ", " + x0 + "\n      L " + y0 + ", " + x1 + "\n      L " + (y1 - sign * cornerRadius) + ", " + x1 + "\n      A " + arc + ", " + y1 + ", " + (x1 + cornerRadius) + "\n      L " + y1 + ", " + (x0 - cornerRadius) + "\n      A " + arc + ", " + (y1 - sign * cornerRadius) + ", " + x0 + "\n      L " + y0 + ", " + x0 + "\n      z";
	    }
	  }, {
	    key: "transformAngle",
	    value: function transformAngle(angle) {
	      return -1 * angle + Math.PI / 2;
	    }
	  }, {
	    key: "getAngularWidth",
	    value: function getAngularWidth(props, width) {
	      var scale = props.scale;
	
	      var range = scale.y.range();
	      var r = Math.max.apply(Math, _toConsumableArray(range));
	      var angularRange = Math.abs(scale.x.range()[1] - scale.x.range()[0]);
	      return width / (2 * Math.PI * r) * angularRange;
	    }
	  }, {
	    key: "getAngle",
	    value: function getAngle(props, index) {
	      var data = props.data,
	          scale = props.scale;
	
	      var x = data[index]._x1 === undefined ? "_x" : "_x1";
	      return scale.x(data[index][x]);
	    }
	  }, {
	    key: "getStartAngle",
	    value: function getStartAngle(props, index) {
	      var data = props.data,
	          scale = props.scale,
	          alignment = props.alignment;
	
	      var currentAngle = this.getAngle(props, index);
	      var angularRange = Math.abs(scale.x.range()[1] - scale.x.range()[0]);
	      var previousAngle = index === 0 ? this.getAngle(props, data.length - 1) - Math.PI * 2 : this.getAngle(props, index - 1);
	      if (index === 0 && angularRange < 2 * Math.PI) {
	        return scale.x.range()[0];
	      } else if (alignment === "start" || alignment === "end") {
	        return alignment === "start" ? previousAngle : currentAngle;
	      } else {
	        return (currentAngle + previousAngle) / 2;
	      }
	    }
	  }, {
	    key: "getEndAngle",
	    value: function getEndAngle(props, index) {
	      var data = props.data,
	          scale = props.scale,
	          alignment = props.alignment;
	
	      var currentAngle = this.getAngle(props, index);
	      var angularRange = Math.abs(scale.x.range()[1] - scale.x.range()[0]);
	      var lastAngle = scale.x.range()[1] === 2 * Math.PI ? this.getAngle(props, 0) + Math.PI * 2 : scale.x.range()[1];
	      var nextAngle = index === data.length - 1 ? this.getAngle(props, 0) + Math.PI * 2 : this.getAngle(props, index + 1);
	      if (index === data.length - 1 && angularRange < 2 * Math.PI) {
	        return lastAngle;
	      } else if (alignment === "start" || alignment === "end") {
	        return alignment === "start" ? currentAngle : nextAngle;
	      } else {
	        return (currentAngle + nextAngle) / 2;
	      }
	    }
	  }, {
	    key: "getPathMoves",
	    value: function getPathMoves(path) {
	      var moves = path.match(/[A-Z]/g);
	      var coords = path.split(/[A-Z]/);
	      return moves.map(function (m, i) {
	        return { command: m, coords: coords[i + 1].split(",") };
	      });
	    }
	  }, {
	    key: "getVerticalPolarBarPath",
	    value: function getVerticalPolarBarPath(props) {
	      // eslint-disable-line max-statements
	      var datum = props.datum,
	          scale = props.scale,
	          style = props.style,
	          index = props.index,
	          alignment = props.alignment;
	
	      var r1 = scale.y(datum._y0 || 0);
	      var r2 = scale.y(datum._y1 !== undefined ? datum._y1 : datum._y);
	      var currentAngle = scale.x(datum._x1 !== undefined ? datum._x1 : datum._x);
	      var start = void 0;
	      var end = void 0;
	      if (style.width) {
	        var width = this.getAngularWidth(props, style.width);
	        var size = alignment === "middle" ? width / 2 : width;
	        start = alignment === "start" ? currentAngle : currentAngle - size;
	        end = alignment === "end" ? currentAngle : currentAngle + size;
	      } else {
	        start = this.getStartAngle(props, index);
	        end = this.getEndAngle(props, index);
	      }
	      var cornerRadius = props.cornerRadius || 0;
	      var path = d3Shape.arc().innerRadius(r1).outerRadius(r2).startAngle(this.transformAngle(start)).endAngle(this.transformAngle(end));
	      if (cornerRadius) {
	        var withCorners = d3Shape.arc().innerRadius(r1).outerRadius(r2).startAngle(this.transformAngle(start)).endAngle(this.transformAngle(end)).cornerRadius(cornerRadius);
	        var moves = this.getPathMoves(path());
	        var cornerMoves = this.getPathMoves(withCorners());
	        // eslint-disable-next-line no-magic-numbers
	        var totalMoves = cornerMoves.slice(0, 4).concat(moves.slice(2));
	        return totalMoves.reduce(function (memo, move) {
	          memo += move.command + " " + move.coords.join();
	          return memo;
	        }, "");
	      }
	      return path();
	    }
	  }, {
	    key: "getBarPath",
	    value: function getBarPath(props, width) {
	      return this.props.horizontal ? this.getHorizontalBarPath(props, width) : this.getVerticalBarPath(props, width);
	    }
	  }, {
	    key: "getPolarBarPath",
	    value: function getPolarBarPath(props) {
	      // TODO Radial bars
	      return this.getVerticalPolarBarPath(props);
	    }
	  }, {
	    key: "getBarWidth",
	    value: function getBarWidth(props, style) {
	      if (style.width) {
	        return style.width;
	      }
	      var scale = props.scale,
	          data = props.data;
	
	      var range = scale.x.range();
	      var extent = Math.abs(range[1] - range[0]);
	      var bars = data.length + 2;
	      var barRatio = props.barRatio || 0.5;
	      // eslint-disable-next-line no-magic-numbers
	      var defaultWidth = data.length < 2 ? 8 : barRatio * extent / bars;
	      return Math.max(1, defaultWidth);
	    }
	
	    // Overridden in victory-core-native
	
	  }, {
	    key: "renderBar",
	    value: function renderBar(path, style, events) {
	      var _props2 = this.props,
	          role = _props2.role,
	          shapeRendering = _props2.shapeRendering,
	          className = _props2.className,
	          origin = _props2.origin,
	          polar = _props2.polar;
	
	      var transform = polar && origin ? "translate(" + origin.x + ", " + origin.y + ")" : undefined;
	      return _react2.default.createElement("path", _extends({
	        d: path,
	        transform: transform,
	        className: className,
	        style: style,
	        role: role || "presentation",
	        shapeRendering: shapeRendering || "auto"
	      }, events));
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return this.renderBar(this.path, this.style, this.props.events);
	    }
	  }]);
	
	  return Bar;
	}(_react2.default.Component);
	
	Bar.propTypes = _extends({}, _commonProps2.default, {
	  alignment: _propTypes2.default.oneOf(["start", "middle", "end"]),
	  barRatio: _propTypes2.default.number,
	  cornerRadius: _propTypes2.default.number,
	  datum: _propTypes2.default.object,
	  horizontal: _propTypes2.default.bool,
	  padding: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.object]),
	  width: _propTypes2.default.number,
	  x: _propTypes2.default.number,
	  y: _propTypes2.default.number,
	  y0: _propTypes2.default.number
	});
	exports.default = Bar;

/***/ },
/* 605 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign2 = __webpack_require__(4);
	
	var _assign3 = _interopRequireDefault(_assign2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _helpers = __webpack_require__(6);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	var _collection = __webpack_require__(8);
	
	var _collection2 = _interopRequireDefault(_collection);
	
	var _commonProps = __webpack_require__(19);
	
	var _commonProps2 = _interopRequireDefault(_commonProps);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*eslint no-magic-numbers: ["error", { "ignore": [0.5, 2] }]*/
	
	
	var Candle = function (_React$Component) {
	  _inherits(Candle, _React$Component);
	
	  function Candle() {
	    _classCallCheck(this, Candle);
	
	    return _possibleConstructorReturn(this, (Candle.__proto__ || Object.getPrototypeOf(Candle)).apply(this, arguments));
	  }
	
	  _createClass(Candle, [{
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      var _calculateAttributes = this.calculateAttributes(this.props),
	          style = _calculateAttributes.style,
	          candleWidth = _calculateAttributes.candleWidth;
	
	      this.style = style;
	      this.candleWidth = candleWidth;
	    }
	  }, {
	    key: "shouldComponentUpdate",
	    value: function shouldComponentUpdate(nextProps) {
	      var _props = this.props,
	          className = _props.className,
	          candleHeight = _props.candleHeight,
	          datum = _props.datum,
	          x = _props.x,
	          y = _props.y,
	          y1 = _props.y1,
	          y2 = _props.y2;
	
	      var _calculateAttributes2 = this.calculateAttributes(nextProps),
	          style = _calculateAttributes2.style,
	          candleWidth = _calculateAttributes2.candleWidth;
	
	      if (!_collection2.default.allSetsEqual([[className, nextProps.className], [candleHeight, nextProps.candleHeight], [x, nextProps.x], [y, nextProps.y], [y1, nextProps.y1], [y2, nextProps.y2], [candleWidth, this.candleWidth], [style, this.style], [datum, nextProps.datum]])) {
	        this.style = style;
	        this.candleWidth = candleWidth;
	        return true;
	      }
	      return false;
	    }
	  }, {
	    key: "calculateAttributes",
	    value: function calculateAttributes(props) {
	      var data = props.data,
	          datum = props.datum,
	          active = props.active,
	          width = props.width;
	
	      var style = _helpers2.default.evaluateStyle((0, _assign3.default)({ stroke: "black" }, props.style), datum, active);
	      var padding = props.padding.left || props.padding;
	      var candleWidth = style.width || 0.5 * (width - 2 * padding) / data.length;
	      return { style: style, candleWidth: candleWidth };
	    }
	
	    // Overridden in victory-core-native
	
	  }, {
	    key: "renderWick",
	    value: function renderWick(wickProps) {
	      return _react2.default.createElement("line", wickProps);
	    }
	
	    // Overridden in victory-core-native
	
	  }, {
	    key: "renderCandle",
	    value: function renderCandle(candleProps) {
	      return _react2.default.createElement("rect", candleProps);
	    }
	  }, {
	    key: "getCandleProps",
	    value: function getCandleProps(props) {
	      var candleHeight = props.candleHeight,
	          x = props.x,
	          y = props.y,
	          events = props.events,
	          role = props.role,
	          className = props.className;
	
	      var shapeRendering = props.shapeRendering || "auto";
	      var candleX = x - this.candleWidth / 2;
	      return (0, _assign3.default)({
	        x: candleX, y: y, style: this.style, role: role, width: this.candleWidth, height: candleHeight,
	        shapeRendering: shapeRendering, className: className
	      }, events);
	    }
	  }, {
	    key: "getWickProps",
	    value: function getWickProps(props) {
	      var x = props.x,
	          y1 = props.y1,
	          y2 = props.y2,
	          events = props.events,
	          className = props.className;
	
	      var shapeRendering = props.shapeRendering || "auto";
	      var role = props.role || "presentation";
	      return (0, _assign3.default)({ x1: x, x2: x, y1: y1, y2: y2, style: this.style, role: role, shapeRendering: shapeRendering, className: className }, events);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var candleProps = this.getCandleProps(this.props);
	      var wickProps = this.getWickProps(this.props);
	      return _react2.default.cloneElement(this.props.groupComponent, {}, this.renderWick(wickProps), this.renderCandle(candleProps));
	    }
	  }]);
	
	  return Candle;
	}(_react2.default.Component);
	
	Candle.propTypes = _extends({}, _commonProps2.default, {
	  candleHeight: _propTypes2.default.number,
	  datum: _propTypes2.default.object,
	  groupComponent: _propTypes2.default.element,
	  padding: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.object]),
	  width: _propTypes2.default.number,
	  x: _propTypes2.default.number,
	  y: _propTypes2.default.number,
	  y1: _propTypes2.default.number,
	  y2: _propTypes2.default.number
	});
	Candle.defaultProps = {
	  groupComponent: _react2.default.createElement("g", null)
	};
	exports.default = Candle;

/***/ },
/* 606 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign2 = __webpack_require__(4);
	
	var _assign3 = _interopRequireDefault(_assign2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _helpers = __webpack_require__(6);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	var _helpers3 = __webpack_require__(264);
	
	var _collection = __webpack_require__(8);
	
	var _collection2 = _interopRequireDefault(_collection);
	
	var _d3Shape = __webpack_require__(63);
	
	var d3Shape = _interopRequireWildcard(_d3Shape);
	
	var _commonProps = __webpack_require__(19);
	
	var _commonProps2 = _interopRequireDefault(_commonProps);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*eslint no-magic-numbers: ["error", { "ignore": [-1, 0, 1, 2] }]*/
	
	
	var Curve = function (_React$Component) {
	  _inherits(Curve, _React$Component);
	
	  function Curve() {
	    _classCallCheck(this, Curve);
	
	    return _possibleConstructorReturn(this, (Curve.__proto__ || Object.getPrototypeOf(Curve)).apply(this, arguments));
	  }
	
	  _createClass(Curve, [{
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      var _calculateAttributes = this.calculateAttributes(this.props),
	          style = _calculateAttributes.style,
	          path = _calculateAttributes.path;
	
	      this.style = style;
	      this.path = path;
	    }
	  }, {
	    key: "shouldComponentUpdate",
	    value: function shouldComponentUpdate(nextProps) {
	      var _calculateAttributes2 = this.calculateAttributes(nextProps),
	          style = _calculateAttributes2.style,
	          path = _calculateAttributes2.path;
	
	      var _props = this.props,
	          className = _props.className,
	          interpolation = _props.interpolation;
	
	      if (!_collection2.default.allSetsEqual([[className, nextProps.className], [interpolation, nextProps.interpolation], [path, this.path], [style, this.style]])) {
	        this.style = style;
	        this.path = path;
	        return true;
	      }
	      return false;
	    }
	  }, {
	    key: "getLineFunction",
	    value: function getLineFunction(props) {
	      var polar = props.polar,
	          scale = props.scale,
	          openCurve = props.openCurve;
	
	      var interpolation = polar && !openCurve ? this.toNewName(props.interpolation) + "Closed" : this.toNewName(props.interpolation);
	      return polar ? d3Shape.lineRadial().defined(_helpers3.defined).curve(d3Shape[interpolation]).angle((0, _helpers3.getAngleAccessor)(scale)).radius((0, _helpers3.getYAccessor)(scale)) : d3Shape.line().defined(_helpers3.defined).curve(d3Shape[interpolation]).x((0, _helpers3.getXAccessor)(scale)).y((0, _helpers3.getYAccessor)(scale));
	    }
	  }, {
	    key: "calculateAttributes",
	    value: function calculateAttributes(props) {
	      var style = props.style,
	          data = props.data,
	          active = props.active;
	
	      var lineFunction = this.getLineFunction(props);
	      return {
	        style: _helpers2.default.evaluateStyle((0, _assign3.default)({ fill: "none", stroke: "black" }, style), data, active),
	        path: lineFunction(data)
	      };
	    }
	  }, {
	    key: "toNewName",
	    value: function toNewName(interpolation) {
	      // d3 shape changed the naming scheme for interpolators from "basis" -> "curveBasis" etc.
	      var capitalize = function (s) {
	        return s && s[0].toUpperCase() + s.slice(1);
	      };
	      return "curve" + capitalize(interpolation);
	    }
	
	    // Overridden in victory-core-native
	
	  }, {
	    key: "renderLine",
	    value: function renderLine(path, style, events) {
	      var _props2 = this.props,
	          role = _props2.role,
	          shapeRendering = _props2.shapeRendering,
	          className = _props2.className,
	          polar = _props2.polar,
	          origin = _props2.origin;
	
	      var transform = polar && origin ? "translate(" + origin.x + ", " + origin.y + ")" : undefined;
	      return _react2.default.createElement("path", _extends({
	        style: style,
	        shapeRendering: shapeRendering || "auto",
	        role: role || "presentation",
	        d: path,
	        transform: transform,
	        className: className
	      }, events));
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var events = this.props.events;
	
	      return this.renderLine(this.path, this.style, events);
	    }
	  }]);
	
	  return Curve;
	}(_react2.default.Component);
	
	Curve.propTypes = _extends({}, _commonProps2.default, {
	  interpolation: _propTypes2.default.string,
	  openCurve: _propTypes2.default.bool,
	  origin: _propTypes2.default.object,
	  polar: _propTypes2.default.bool
	});
	exports.default = Curve;

/***/ },
/* 607 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign2 = __webpack_require__(4);
	
	var _assign3 = _interopRequireDefault(_assign2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _helpers = __webpack_require__(6);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	var _collection = __webpack_require__(8);
	
	var _collection2 = _interopRequireDefault(_collection);
	
	var _commonProps = __webpack_require__(19);
	
	var _commonProps2 = _interopRequireDefault(_commonProps);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable max-statements */
	
	
	var ErrorBar = function (_React$Component) {
	  _inherits(ErrorBar, _React$Component);
	
	  function ErrorBar(props) {
	    _classCallCheck(this, ErrorBar);
	
	    return _possibleConstructorReturn(this, (ErrorBar.__proto__ || Object.getPrototypeOf(ErrorBar)).call(this, props));
	  }
	
	  _createClass(ErrorBar, [{
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      this.style = this.getStyle(this.props);
	    }
	  }, {
	    key: "shouldComponentUpdate",
	    value: function shouldComponentUpdate(nextProps) {
	      var _props = this.props,
	          borderWidth = _props.borderWidth,
	          className = _props.className,
	          datum = _props.datum,
	          x = _props.x,
	          y = _props.y,
	          errorX = _props.errorX,
	          errorY = _props.errorY;
	
	      var nextStyle = this.getStyle(nextProps);
	
	      if (!_collection2.default.allSetsEqual([[borderWidth, nextProps.borderWidth], [className, nextProps.className], [x, nextProps.x], [y, nextProps.y], [errorX, nextProps.errorX], [errorY, nextProps.errorY], [this.style, nextStyle], [datum, nextProps.datum]])) {
	        this.style = nextStyle;
	        return true;
	      }
	
	      return false;
	    }
	  }, {
	    key: "getStyle",
	    value: function getStyle(props) {
	      var style = props.style,
	          datum = props.datum,
	          active = props.active;
	
	      return _helpers2.default.evaluateStyle((0, _assign3.default)({ stroke: "black" }, style), datum, active);
	    }
	
	    // Overridden in victory-core-native
	
	  }, {
	    key: "renderLine",
	    value: function renderLine(props, style, events) {
	      return _react2.default.createElement("line", _extends({}, props, { style: style }, events));
	    }
	  }, {
	    key: "renderBorder",
	    value: function renderBorder(props, error, type) {
	      var x = props.x,
	          y = props.y,
	          borderWidth = props.borderWidth,
	          events = props.events,
	          style = props.style,
	          role = props.role,
	          shapeRendering = props.shapeRendering,
	          className = props.className;
	
	      var vertical = type === "Right" || type === "Left";
	      var errorPortion = error["error" + type];
	      var borderProps = {
	        role: role, shapeRendering: shapeRendering, className: className,
	        key: "border" + type,
	        x1: vertical ? errorPortion : x - borderWidth,
	        x2: vertical ? errorPortion : x + borderWidth,
	        y1: vertical ? y - borderWidth : errorPortion,
	        y2: vertical ? y + borderWidth : errorPortion
	      };
	      return this.renderLine(borderProps, style, events);
	    }
	  }, {
	    key: "renderCross",
	    value: function renderCross(props, error, type) {
	      var x = props.x,
	          y = props.y,
	          events = props.events,
	          style = props.style,
	          role = props.role,
	          shapeRendering = props.shapeRendering,
	          className = props.className;
	
	      var vertical = type === "Top" || type === "Bottom";
	      var errorPortion = error["error" + type];
	      var borderProps = {
	        role: role, shapeRendering: shapeRendering, className: className,
	        key: "cross" + type,
	        x1: x,
	        x2: vertical ? x : errorPortion,
	        y1: y,
	        y2: vertical ? errorPortion : y
	      };
	      return this.renderLine(borderProps, style, events);
	    }
	  }, {
	    key: "renderErrorBar",
	    value: function renderErrorBar(error, props) {
	      var groupComponent = props.groupComponent;
	
	      return _react2.default.cloneElement(groupComponent, {}, error.errorRight ? this.renderBorder(props, error, "Right") : null, error.errorLeft ? this.renderBorder(props, error, "Left") : null, error.errorBottom ? this.renderBorder(props, error, "Bottom") : null, error.errorTop ? this.renderBorder(props, error, "Top") : null, error.errorRight ? this.renderCross(props, error, "Right") : null, error.errorLeft ? this.renderCross(props, error, "Left") : null, error.errorBottom ? this.renderCross(props, error, "Bottom") : null, error.errorTop ? this.renderCross(props, error, "Top") : null);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _props2 = this.props,
	          x = _props2.x,
	          y = _props2.y,
	          borderWidth = _props2.borderWidth,
	          groupComponent = _props2.groupComponent,
	          events = _props2.events,
	          errorX = _props2.errorX,
	          errorY = _props2.errorY,
	          scale = _props2.scale,
	          role = _props2.role,
	          shapeRendering = _props2.shapeRendering,
	          className = _props2.className;
	
	      var rangeX = void 0;
	      var rangeY = void 0;
	      var positiveErrorX = void 0;
	      var negativeErrorX = void 0;
	      var positiveErrorY = void 0;
	      var negativeErrorY = void 0;
	      var errorTop = void 0;
	      var errorBottom = void 0;
	      var errorRight = void 0;
	      var errorLeft = void 0;
	
	      if (errorX) {
	        rangeX = scale.x.range();
	        positiveErrorX = errorX[0];
	        negativeErrorX = errorX[1];
	        errorRight = positiveErrorX >= rangeX[1] ? rangeX[1] : positiveErrorX;
	        errorLeft = negativeErrorX <= rangeX[0] ? rangeX[0] : negativeErrorX;
	      }
	
	      if (errorY) {
	        rangeY = scale.y.range();
	        positiveErrorY = errorY[1];
	        negativeErrorY = errorY[0];
	        errorTop = positiveErrorY >= rangeY[0] ? rangeY[0] : positiveErrorY;
	        errorBottom = negativeErrorY <= rangeY[1] ? rangeY[1] : negativeErrorY;
	      }
	      var props = {
	        x: x, y: y, borderWidth: borderWidth, groupComponent: groupComponent, events: events, className: className,
	        role: role || "presentation",
	        shapeRendering: shapeRendering || "auto",
	        style: this.style
	      };
	      return _react2.default.cloneElement(this.props.groupComponent, {}, this.renderErrorBar({ errorTop: errorTop, errorBottom: errorBottom, errorRight: errorRight, errorLeft: errorLeft }, props));
	    }
	  }]);
	
	  return ErrorBar;
	}(_react2.default.Component);
	
	ErrorBar.propTypes = _extends({}, _commonProps2.default, {
	  borderWidth: _propTypes2.default.number,
	  datum: _propTypes2.default.object,
	  errorX: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.array, _propTypes2.default.bool]),
	  errorY: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.array, _propTypes2.default.bool]),
	  groupComponent: _propTypes2.default.element,
	  x: _propTypes2.default.number,
	  y: _propTypes2.default.number
	});
	ErrorBar.defaultProps = {
	  groupComponent: _react2.default.createElement("g", null)
	};
	exports.default = ErrorBar;

/***/ },
/* 608 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign2 = __webpack_require__(4);
	
	var _assign3 = _interopRequireDefault(_assign2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _helpers = __webpack_require__(6);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	var _collection = __webpack_require__(8);
	
	var _collection2 = _interopRequireDefault(_collection);
	
	var _commonProps = __webpack_require__(19);
	
	var _commonProps2 = _interopRequireDefault(_commonProps);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Line = function (_React$Component) {
	  _inherits(Line, _React$Component);
	
	  function Line() {
	    _classCallCheck(this, Line);
	
	    return _possibleConstructorReturn(this, (Line.__proto__ || Object.getPrototypeOf(Line)).apply(this, arguments));
	  }
	
	  _createClass(Line, [{
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      this.style = this.getStyle(this.props);
	    }
	  }, {
	    key: "shouldComponentUpdate",
	    value: function shouldComponentUpdate(nextProps) {
	      var _props = this.props,
	          className = _props.className,
	          datum = _props.datum,
	          x1 = _props.x1,
	          x2 = _props.x2,
	          y1 = _props.y1,
	          y2 = _props.y2;
	
	      var style = this.getStyle(nextProps);
	      if (!_collection2.default.allSetsEqual([[className, nextProps.className], [x1, nextProps.x1], [x2, nextProps.x2], [y1, nextProps.y1], [y2, nextProps.y2], [style, this.style], [datum, nextProps.datum]])) {
	        this.style = style;
	        return true;
	      }
	      return false;
	    }
	  }, {
	    key: "getStyle",
	    value: function getStyle(props) {
	      var style = props.style,
	          datum = props.datum,
	          active = props.active;
	
	      return _helpers2.default.evaluateStyle((0, _assign3.default)({ stroke: "black" }, style), datum, active);
	    }
	
	    // Overridden in victory-core-native
	
	  }, {
	    key: "renderAxisLine",
	    value: function renderAxisLine(props, style, events) {
	      var _props2 = this.props,
	          role = _props2.role,
	          shapeRendering = _props2.shapeRendering,
	          className = _props2.className;
	
	      return _react2.default.createElement("line", _extends({}, props, {
	        className: className,
	        style: style,
	        role: role || "presentation",
	        shapeRendering: shapeRendering || "auto",
	        vectorEffect: "non-scaling-stroke"
	      }, events));
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _props3 = this.props,
	          x1 = _props3.x1,
	          x2 = _props3.x2,
	          y1 = _props3.y1,
	          y2 = _props3.y2,
	          events = _props3.events;
	
	      return this.renderAxisLine({ x1: x1, x2: x2, y1: y1, y2: y2 }, this.style, events);
	    }
	  }]);
	
	  return Line;
	}(_react2.default.Component);
	
	Line.propTypes = _extends({}, _commonProps2.default, {
	  datum: _propTypes2.default.any,
	  x1: _propTypes2.default.number,
	  x2: _propTypes2.default.number,
	  y1: _propTypes2.default.number,
	  y2: _propTypes2.default.number
	});
	exports.default = Line;

/***/ },
/* 609 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _range2 = __webpack_require__(96);
	
	var _range3 = _interopRequireDefault(_range2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*eslint no-magic-numbers: ["error", { "ignore": [0, 1, 2, 2.5, 3] }]*/
	exports.default = {
	  circle: function (x, y, size) {
	    return "M " + x + ", " + y + "\n      m " + -size + ", 0\n      a " + size + ", " + size + " 0 1,0 " + size * 2 + ",0\n      a " + size + ", " + size + " 0 1,0 " + -size * 2 + ",0";
	  },
	  square: function (x, y, size) {
	    var baseSize = 0.87 * size; // eslint-disable-line no-magic-numbers
	    var x0 = x - baseSize;
	    var y1 = y + baseSize;
	    var distance = x + baseSize - x0;
	    return "M " + x0 + ", " + y1 + "\n      h" + distance + "\n      v-" + distance + "\n      h-" + distance + "\n      z";
	  },
	  diamond: function (x, y, size) {
	    var baseSize = 0.87 * size; // eslint-disable-line no-magic-numbers
	    var length = Math.sqrt(2 * (baseSize * baseSize));
	    return "M " + x + ", " + (y + length) + "\n      l " + length + ", -" + length + "\n      l -" + length + ", -" + length + "\n      l -" + length + ", " + length + "\n      l " + length + ", " + length + "\n      z";
	  },
	  triangleDown: function (x, y, size) {
	    var height = size / 2 * Math.sqrt(3);
	    var x0 = x - size;
	    var x1 = x + size;
	    var y0 = y - size;
	    var y1 = y + height;
	    return "M " + x0 + ", " + y0 + "\n      L " + x1 + ", " + y0 + "\n      L " + x + ", " + y1 + "\n      z";
	  },
	  triangleUp: function (x, y, size) {
	    var height = size / 2 * Math.sqrt(3);
	    var x0 = x - size;
	    var x1 = x + size;
	    var y0 = y - height;
	    var y1 = y + size;
	    return "M " + x0 + ", " + y1 + "\n      L " + x1 + ", " + y1 + "\n      L " + x + ", " + y0 + "\n      z";
	  },
	  plus: function (x, y, size) {
	    var baseSize = 1.1 * size; // eslint-disable-line no-magic-numbers
	    var distance = baseSize / 1.5; // eslint-disable-line no-magic-numbers
	    return "\n      M " + (x - distance / 2) + ", " + (y + baseSize) + "\n      v-" + distance + "\n      h-" + distance + "\n      v-" + distance + "\n      h" + distance + "\n      v-" + distance + "\n      h" + distance + "\n      v" + distance + "\n      h" + distance + "\n      v" + distance + "\n      h-" + distance + "\n      v" + distance + "\n      z";
	  },
	  star: function (x, y, size) {
	    var baseSize = 1.35 * size; // eslint-disable-line no-magic-numbers
	    var angle = Math.PI / 5; // eslint-disable-line no-magic-numbers
	    var starCoords = (0, _range3.default)(10).map(function (index) {
	      // eslint-disable-line no-magic-numbers
	      var length = index % 2 === 0 ? baseSize : baseSize / 2;
	      return length * Math.sin(angle * (index + 1)) + x + ",\n        " + (length * Math.cos(angle * (index + 1)) + y);
	    });
	    return "M " + starCoords.join("L") + " z";
	  }
	};

/***/ },
/* 610 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _helpers = __webpack_require__(6);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	var _collection = __webpack_require__(8);
	
	var _collection2 = _interopRequireDefault(_collection);
	
	var _commonProps = __webpack_require__(19);
	
	var _commonProps2 = _interopRequireDefault(_commonProps);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Slice = function (_React$Component) {
	  _inherits(Slice, _React$Component);
	
	  function Slice() {
	    _classCallCheck(this, Slice);
	
	    return _possibleConstructorReturn(this, (Slice.__proto__ || Object.getPrototypeOf(Slice)).apply(this, arguments));
	  }
	
	  _createClass(Slice, [{
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      var _calculateAttributes = this.calculateAttributes(this.props),
	          style = _calculateAttributes.style,
	          path = _calculateAttributes.path;
	
	      this.style = style;
	      this.path = path;
	    }
	  }, {
	    key: "shouldComponentUpdate",
	    value: function shouldComponentUpdate(nextProps) {
	      var _calculateAttributes2 = this.calculateAttributes(nextProps),
	          style = _calculateAttributes2.style,
	          path = _calculateAttributes2.path;
	
	      var _props = this.props,
	          className = _props.className,
	          datum = _props.datum,
	          slice = _props.slice;
	
	      if (!_collection2.default.allSetsEqual([[className, nextProps.className], [path, this.path], [style, this.style], [datum, nextProps.datum], [slice, nextProps.slice]])) {
	        this.style = style;
	        this.path = path;
	        return true;
	      }
	      return false;
	    }
	  }, {
	    key: "calculateAttributes",
	    value: function calculateAttributes(props) {
	      var style = props.style,
	          datum = props.datum,
	          active = props.active,
	          pathFunction = props.pathFunction,
	          slice = props.slice;
	
	      return {
	        style: _helpers2.default.evaluateStyle(style, datum, active),
	        path: pathFunction(slice)
	      };
	    }
	
	    // Overridden in victory-core-native
	
	  }, {
	    key: "renderSlice",
	    value: function renderSlice(path, style, events) {
	      var _props2 = this.props,
	          role = _props2.role,
	          shapeRendering = _props2.shapeRendering,
	          className = _props2.className,
	          origin = _props2.origin;
	
	      var transform = origin ? "translate(" + origin.x + ", " + origin.y + ")" : undefined;
	      return _react2.default.createElement("path", _extends({
	        d: path,
	        className: className,
	        role: role || "presentation",
	        style: style,
	        transform: transform,
	        shapeRendering: shapeRendering || "auto"
	      }, events));
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return this.renderSlice(this.path, this.style, this.props.events);
	    }
	  }]);
	
	  return Slice;
	}(_react2.default.Component);
	
	Slice.propTypes = _extends({}, _commonProps2.default, {
	  datum: _propTypes2.default.object,
	  pathFunction: _propTypes2.default.func,
	  slice: _propTypes2.default.object
	});
	exports.default = Slice;

/***/ },
/* 611 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _helpers = __webpack_require__(6);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	var _collection = __webpack_require__(8);
	
	var _collection2 = _interopRequireDefault(_collection);
	
	var _commonProps = __webpack_require__(19);
	
	var _commonProps2 = _interopRequireDefault(_commonProps);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*eslint no-magic-numbers: ["error", { "ignore": [2] }]*/
	
	
	var Voronoi = function (_React$Component) {
	  _inherits(Voronoi, _React$Component);
	
	  function Voronoi() {
	    _classCallCheck(this, Voronoi);
	
	    return _possibleConstructorReturn(this, (Voronoi.__proto__ || Object.getPrototypeOf(Voronoi)).apply(this, arguments));
	  }
	
	  _createClass(Voronoi, [{
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      var _calculateAttributes = this.calculateAttributes(this.props),
	          style = _calculateAttributes.style,
	          circle = _calculateAttributes.circle,
	          voronoi = _calculateAttributes.voronoi;
	
	      this.style = style;
	      this.circle = circle;
	      this.voronoi = voronoi;
	    }
	  }, {
	    key: "shouldComponentUpdate",
	    value: function shouldComponentUpdate(nextProps) {
	      var _calculateAttributes2 = this.calculateAttributes(nextProps),
	          style = _calculateAttributes2.style,
	          circle = _calculateAttributes2.circle,
	          voronoi = _calculateAttributes2.voronoi;
	
	      var _props = this.props,
	          className = _props.className,
	          x = _props.x,
	          y = _props.y,
	          datum = _props.datum;
	
	      if (!_collection2.default.allSetsEqual([[className, nextProps.className], [x, nextProps.x], [y, nextProps.y], [circle, this.circle], [voronoi, this.voronoi], [style, this.style], [datum, nextProps.datum]])) {
	        this.style = style;
	        this.circle = circle;
	        this.voronoi = voronoi;
	        return true;
	      }
	      return false;
	    }
	  }, {
	    key: "calculateAttributes",
	    value: function calculateAttributes(props) {
	      var style = props.style,
	          datum = props.datum,
	          active = props.active;
	
	      return {
	        style: _helpers2.default.evaluateStyle(style, datum, active),
	        circle: this.getCirclePath(props),
	        voronoi: this.getVoronoiPath(props)
	      };
	    }
	  }, {
	    key: "getVoronoiPath",
	    value: function getVoronoiPath(props) {
	      var polygon = props.polygon;
	
	      return Array.isArray(polygon) && polygon.length ? "M " + props.polygon.join("L") + " Z" : "";
	    }
	  }, {
	    key: "getCirclePath",
	    value: function getCirclePath(props) {
	      if (!props.size) {
	        return null;
	      }
	      var x = props.x,
	          y = props.y,
	          datum = props.datum,
	          active = props.active;
	
	      var size = _helpers2.default.evaluateProp(props.size, datum, active);
	      return "M " + x + ", " + y + " m " + -size + ", 0\n      a " + size + ", " + size + " 0 1,0 " + size * 2 + ",0\n      a " + size + ", " + size + " 0 1,0 " + -size * 2 + ",0";
	    }
	
	    // Overridden in victory-core-native
	
	  }, {
	    key: "renderPoint",
	    value: function renderPoint(paths, style, events) {
	      var clipId = paths.circle && "clipPath-" + Math.random();
	      var clipPath = paths.circle ? "url(#" + clipId + ")" : undefined;
	      var _props2 = this.props,
	          role = _props2.role,
	          shapeRendering = _props2.shapeRendering,
	          className = _props2.className;
	
	      var voronoiPath = _react2.default.createElement("path", _extends({
	        d: paths.circle || paths.voronoi,
	        className: className,
	        clipPath: clipPath,
	        style: style,
	        role: role || "presentation",
	        shapeRendering: shapeRendering || "auto"
	      }, events));
	      return paths.circle ? _react2.default.createElement(
	        "g",
	        null,
	        _react2.default.createElement(
	          "defs",
	          null,
	          _react2.default.createElement(
	            "clipPath",
	            { id: clipId },
	            _react2.default.createElement("path", { d: paths.voronoi, className: className })
	          )
	        ),
	        voronoiPath
	      ) : voronoiPath;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var paths = {
	        circle: this.circle,
	        voronoi: this.voronoi
	      };
	      return this.renderPoint(paths, this.style, this.props.events);
	    }
	  }]);
	
	  return Voronoi;
	}(_react2.default.Component);
	
	Voronoi.propTypes = _extends({}, _commonProps2.default, {
	  datum: _propTypes2.default.object,
	  polygon: _propTypes2.default.array,
	  size: _propTypes2.default.number,
	  x: _propTypes2.default.number,
	  y: _propTypes2.default.number
	});
	exports.default = Voronoi;

/***/ },
/* 612 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _fromPairs2 = __webpack_require__(488);
	
	var _fromPairs3 = _interopRequireDefault(_fromPairs2);
	
	var _defaults2 = __webpack_require__(5);
	
	var _defaults3 = _interopRequireDefault(_defaults2);
	
	var _partialRight2 = __webpack_require__(16);
	
	var _partialRight3 = _interopRequireDefault(_partialRight2);
	
	var _isFunction2 = __webpack_require__(7);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _assign2 = __webpack_require__(4);
	
	var _assign3 = _interopRequireDefault(_assign2);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _propTypes3 = __webpack_require__(26);
	
	var _propTypes4 = _interopRequireDefault(_propTypes3);
	
	var _events = __webpack_require__(149);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _helpers = __webpack_require__(6);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	var _timer = __webpack_require__(62);
	
	var _timer2 = _interopRequireDefault(_timer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var VictorySharedEvents = function (_React$Component) {
	  _inherits(VictorySharedEvents, _React$Component);
	
	  function VictorySharedEvents() {
	    _classCallCheck(this, VictorySharedEvents);
	
	    var _this = _possibleConstructorReturn(this, (VictorySharedEvents.__proto__ || Object.getPrototypeOf(VictorySharedEvents)).call(this));
	
	    _this.state = _this.state || {};
	    _this.getScopedEvents = _events2.default.getScopedEvents.bind(_this);
	    _this.getEventState = _events2.default.getEventState.bind(_this);
	    _this.getTimer = _this.getTimer.bind(_this);
	    return _this;
	  }
	
	  _createClass(VictorySharedEvents, [{
	    key: "getChildContext",
	    value: function getChildContext() {
	      return {
	        getTimer: this.getTimer
	      };
	    }
	  }, {
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      this.setUpChildren(this.props);
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(newProps) {
	      this.setUpChildren(newProps);
	    }
	  }, {
	    key: "getTimer",
	    value: function getTimer() {
	      if (this.context.getTimer) {
	        return this.context.getTimer();
	      }
	      if (!this.timer) {
	        this.timer = new _timer2.default();
	      }
	      return this.timer;
	    }
	  }, {
	    key: "getAllEvents",
	    value: function getAllEvents(props) {
	      var components = ["container", "groupComponent"];
	      this.componentEvents = _events2.default.getComponentEvents(props, components);
	      if (Array.isArray(this.componentEvents)) {
	        var _componentEvents;
	
	        return Array.isArray(props.events) ? (_componentEvents = this.componentEvents).concat.apply(_componentEvents, _toConsumableArray(props.events)) : this.componentEvents;
	      }
	      return props.events;
	    }
	  }, {
	    key: "setUpChildren",
	    value: function setUpChildren(props) {
	      this.events = this.getAllEvents(props);
	      if (this.events) {
	        this.childComponents = _react2.default.Children.toArray(props.children);
	        var childBaseProps = this.getBasePropsFromChildren(this.childComponents);
	        var parentBaseProps = props.container ? props.container.props : {};
	        this.baseProps = (0, _assign3.default)({}, childBaseProps, { parent: parentBaseProps });
	      }
	    }
	  }, {
	    key: "getBasePropsFromChildren",
	    value: function getBasePropsFromChildren(childComponents) {
	      var iteratee = function (child, childName, parent) {
	        if (child.type && (0, _isFunction3.default)(child.type.getBaseProps)) {
	          child = parent ? _react2.default.cloneElement(child, parent.props) : child;
	          var _baseProps = child.props && child.type.getBaseProps(child.props);
	          return _baseProps ? [[childName, _baseProps]] : null;
	        } else {
	          return null;
	        }
	      };
	
	      var baseProps = _helpers2.default.reduceChildren(childComponents, iteratee);
	      return (0, _fromPairs3.default)(baseProps);
	    }
	  }, {
	    key: "getNewChildren",
	    value: function getNewChildren(props) {
	      var _this2 = this;
	
	      var events = props.events,
	          eventKey = props.eventKey;
	
	      var childNames = Object.keys(this.baseProps);
	      var alterChildren = function (children) {
	        return children.reduce(function (memo, child, index) {
	          if (child.props.children) {
	            return memo.concat(_react2.default.cloneElement(child, child.props, alterChildren(_react2.default.Children.toArray(child.props.children))));
	          } else if (child.type && (0, _isFunction3.default)(child.type.getBaseProps)) {
	            var name = child.props.name || childNames.shift() || index;
	            var childEvents = Array.isArray(events) && events.filter(function (event) {
	              if (event.target === "parent") {
	                return false;
	              }
	              return Array.isArray(event.childName) ? event.childName.indexOf(name) > -1 : event.childName === name || event.childName === "all";
	            });
	            var sharedEvents = {
	              events: childEvents,
	              getEvents: (0, _partialRight3.default)(_this2.getScopedEvents, name, _this2.baseProps),
	              getEventState: (0, _partialRight3.default)(_this2.getEventState, name)
	            };
	            return memo.concat(_react2.default.cloneElement(child, (0, _assign3.default)({ key: "events-" + name, sharedEvents: sharedEvents, eventKey: eventKey }, child.props)));
	          } else {
	            return memo.concat(child);
	          }
	        }, []);
	      };
	
	      return alterChildren(this.childComponents);
	    }
	  }, {
	    key: "getContainer",
	    value: function getContainer(props, children) {
	      var parents = Array.isArray(this.events) && this.events.filter(function (event) {
	        return event.target === "parent";
	      });
	      var sharedEvents = parents.length > 0 ? {
	        events: parents,
	        getEvents: (0, _partialRight3.default)(this.getScopedEvents, null, this.baseProps),
	        getEventState: (0, _partialRight3.default)(this.getEventState, null)
	      } : null;
	      var container = this.props.container || this.props.groupComponent;
	      var role = container.type && container.type.role;
	      var containerProps = container.props || {};
	      var boundGetEvents = _events2.default.getEvents.bind(this);
	      var parentEvents = sharedEvents && boundGetEvents({ sharedEvents: sharedEvents }, "parent");
	      var parentProps = (0, _defaults3.default)({}, this.getEventState("parent", "parent"), containerProps, this.baseProps.parent, { children: children });
	      var events = (0, _defaults3.default)({}, _events2.default.getPartialEvents(parentEvents, "parent", parentProps), containerProps.events);
	      return role === "container" ? _react2.default.cloneElement(container, (0, _assign3.default)({}, parentProps, { events: events })) : _react2.default.cloneElement(container, events, children);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      if (this.events) {
	        var children = this.getNewChildren(this.props);
	        return this.getContainer(this.props, children);
	      }
	      return _react2.default.cloneElement(this.props.container, { children: this.props.children });
	    }
	  }]);
	
	  return VictorySharedEvents;
	}(_react2.default.Component);
	
	VictorySharedEvents.displayName = "VictorySharedEvents";
	VictorySharedEvents.role = "shared-event-wrapper";
	VictorySharedEvents.propTypes = {
	  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	  container: _propTypes2.default.node,
	  eventKey: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.func, _propTypes4.default.allOfType([_propTypes4.default.integer, _propTypes4.default.nonNegative]), _propTypes2.default.string]),
	  events: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    childName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.array]),
	    eventHandlers: _propTypes2.default.object,
	    eventKey: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.func, _propTypes4.default.allOfType([_propTypes4.default.integer, _propTypes4.default.nonNegative]), _propTypes2.default.string]),
	    target: _propTypes2.default.string
	  })),
	  groupComponent: _propTypes2.default.node
	};
	VictorySharedEvents.defaultProps = {
	  groupComponent: _react2.default.createElement("g", null)
	};
	VictorySharedEvents.contextTypes = {
	  getTimer: _propTypes2.default.func
	};
	VictorySharedEvents.childContextTypes = {
	  getTimer: _propTypes2.default.func
	};
	exports.default = VictorySharedEvents;

/***/ },
/* 613 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign2 = __webpack_require__(4);
	
	var _assign3 = _interopRequireDefault(_assign2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// *
	// * Colors
	// *
	var colors = ["#252525", "#525252", "#737373", "#969696", "#bdbdbd", "#d9d9d9", "#f0f0f0"];
	
	var charcoal = "#252525";
	// *
	// * Typography
	// *
	var sansSerif = "'Gill Sans', 'Gill Sans MT', 'Ser­avek', 'Trebuchet MS', sans-serif";
	var letterSpacing = "normal";
	var fontSize = 14;
	// *
	// * Layout
	// *
	var baseProps = {
	  width: 450,
	  height: 300,
	  padding: 50,
	  colorScale: colors
	};
	// *
	// * Labels
	// *
	var baseLabelStyles = {
	  fontFamily: sansSerif,
	  fontSize: fontSize,
	  letterSpacing: letterSpacing,
	  padding: 10,
	  fill: charcoal,
	  stroke: "transparent"
	};
	
	var centeredLabelStyles = (0, _assign3.default)({ textAnchor: "middle" }, baseLabelStyles);
	// *
	// * Strokes
	// *
	var strokeLinecap = "round";
	var strokeLinejoin = "round";
	
	exports.default = {
	  area: (0, _assign3.default)({
	    style: {
	      data: {
	        fill: charcoal
	      },
	      labels: centeredLabelStyles
	    }
	  }, baseProps),
	  axis: (0, _assign3.default)({
	    style: {
	      axis: {
	        fill: "transparent",
	        stroke: charcoal,
	        strokeWidth: 1,
	        strokeLinecap: strokeLinecap,
	        strokeLinejoin: strokeLinejoin
	      },
	      axisLabel: (0, _assign3.default)({}, centeredLabelStyles, {
	        padding: 25
	      }),
	      grid: {
	        fill: "none",
	        stroke: "none",
	        pointerEvents: "visible"
	      },
	      ticks: {
	        fill: "transparent",
	        size: 1,
	        stroke: "transparent"
	      },
	      tickLabels: baseLabelStyles
	    }
	  }, baseProps),
	  bar: (0, _assign3.default)({
	    style: {
	      data: {
	        fill: charcoal,
	        padding: 8,
	        strokeWidth: 0
	      },
	      labels: baseLabelStyles
	    }
	  }, baseProps),
	  candlestick: (0, _assign3.default)({
	    style: {
	      data: {
	        stroke: charcoal,
	        strokeWidth: 1
	      },
	      labels: centeredLabelStyles
	    },
	    candleColors: {
	      positive: "#ffffff",
	      negative: charcoal
	    }
	  }, baseProps),
	  chart: baseProps,
	  errorbar: (0, _assign3.default)({
	    borderWidth: 8,
	    style: {
	      data: {
	        fill: "transparent",
	        stroke: charcoal,
	        strokeWidth: 2
	      },
	      labels: centeredLabelStyles
	    }
	  }, baseProps),
	  group: (0, _assign3.default)({
	    colorScale: colors
	  }, baseProps),
	  line: (0, _assign3.default)({
	    style: {
	      data: {
	        fill: "transparent",
	        stroke: charcoal,
	        strokeWidth: 2
	      },
	      labels: centeredLabelStyles
	    }
	  }, baseProps),
	  pie: {
	    style: {
	      data: {
	        padding: 10,
	        stroke: "transparent",
	        strokeWidth: 1
	      },
	      labels: (0, _assign3.default)({}, baseLabelStyles, { padding: 20 })
	    },
	    colorScale: colors,
	    width: 400,
	    height: 400,
	    padding: 50
	  },
	  scatter: (0, _assign3.default)({
	    style: {
	      data: {
	        fill: charcoal,
	        stroke: "transparent",
	        strokeWidth: 0
	      },
	      labels: centeredLabelStyles
	    }
	  }, baseProps),
	  stack: (0, _assign3.default)({
	    colorScale: colors
	  }, baseProps),
	  tooltip: {
	    style: (0, _assign3.default)({}, centeredLabelStyles, { padding: 5, pointerEvents: "none" }),
	    flyoutStyle: {
	      stroke: charcoal,
	      strokeWidth: 1,
	      fill: "#f0f0f0",
	      pointerEvents: "none"
	    },
	    cornerRadius: 5,
	    pointerLength: 10
	  },
	  voronoi: (0, _assign3.default)({
	    style: {
	      data: {
	        fill: "transparent",
	        stroke: "transparent",
	        strokeWidth: 0
	      },
	      labels: (0, _assign3.default)({}, centeredLabelStyles, { padding: 5, pointerEvents: "none" }),
	      flyout: {
	        stroke: charcoal,
	        strokeWidth: 1,
	        fill: "#f0f0f0",
	        pointerEvents: "none"
	      }
	    }
	  }, baseProps),
	  legend: {
	    colorScale: colors,
	    gutter: 10,
	    orientation: "vertical",
	    titleOrientation: "top",
	    style: {
	      data: {
	        type: "circle"
	      },
	      labels: baseLabelStyles,
	      title: (0, _assign3.default)({}, baseLabelStyles, { padding: 5 })
	    }
	  }
	};

/***/ },
/* 614 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign2 = __webpack_require__(4);
	
	var _assign3 = _interopRequireDefault(_assign2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// *
	// * Colors
	// *
	var yellow200 = "#FFF59D";
	var deepOrange600 = "#F4511E";
	var lime300 = "#DCE775";
	var lightGreen500 = "#8BC34A";
	var teal700 = "#00796B";
	var cyan900 = "#006064";
	var colors = [deepOrange600, yellow200, lime300, lightGreen500, teal700, cyan900];
	var blueGrey50 = "#ECEFF1";
	var blueGrey300 = "#90A4AE";
	var blueGrey700 = "#455A64";
	var grey900 = "#212121";
	// *
	// * Typography
	// *
	var sansSerif = "'Roboto', 'Helvetica Neue', Helvetica, sans-serif";
	var letterSpacing = "normal";
	var fontSize = 12;
	// *
	// * Layout
	// *
	var padding = 8;
	var baseProps = {
	  width: 350,
	  height: 350,
	  padding: 50
	};
	// *
	// * Labels
	// *
	var baseLabelStyles = {
	  fontFamily: sansSerif,
	  fontSize: fontSize,
	  letterSpacing: letterSpacing,
	  padding: padding,
	  fill: blueGrey700,
	  stroke: "transparent",
	  strokeWidth: 0
	};
	
	var centeredLabelStyles = (0, _assign3.default)({ textAnchor: "middle" }, baseLabelStyles);
	// *
	// * Strokes
	// *
	var strokeDasharray = "10, 5";
	var strokeLinecap = "round";
	var strokeLinejoin = "round";
	
	exports.default = {
	  area: (0, _assign3.default)({
	    style: {
	      data: {
	        fill: grey900
	      },
	      labels: centeredLabelStyles
	    }
	  }, baseProps),
	  axis: (0, _assign3.default)({
	    style: {
	      axis: {
	        fill: "transparent",
	        stroke: blueGrey300,
	        strokeWidth: 2,
	        strokeLinecap: strokeLinecap,
	        strokeLinejoin: strokeLinejoin
	      },
	      axisLabel: (0, _assign3.default)({}, centeredLabelStyles, {
	        padding: padding,
	        stroke: "transparent"
	      }),
	      grid: {
	        fill: "none",
	        stroke: blueGrey50,
	        strokeDasharray: strokeDasharray,
	        strokeLinecap: strokeLinecap,
	        strokeLinejoin: strokeLinejoin,
	        pointerEvents: "visible"
	      },
	      ticks: {
	        fill: "transparent",
	        size: 5,
	        stroke: blueGrey300,
	        strokeWidth: 1,
	        strokeLinecap: strokeLinecap,
	        strokeLinejoin: strokeLinejoin
	      },
	      tickLabels: (0, _assign3.default)({}, baseLabelStyles, {
	        fill: blueGrey700
	      })
	    }
	  }, baseProps),
	  bar: (0, _assign3.default)({
	    style: {
	      data: {
	        fill: blueGrey700,
	        padding: padding,
	        strokeWidth: 0
	      },
	      labels: baseLabelStyles
	    }
	  }, baseProps),
	  candlestick: (0, _assign3.default)({
	    style: {
	      data: {
	        stroke: blueGrey700
	      },
	      labels: centeredLabelStyles
	    },
	    candleColors: {
	      positive: "#ffffff",
	      negative: blueGrey700
	    }
	  }, baseProps),
	  chart: baseProps,
	  errorbar: (0, _assign3.default)({
	    borderWidth: 8,
	    style: {
	      data: {
	        fill: "transparent",
	        opacity: 1,
	        stroke: blueGrey700,
	        strokeWidth: 2
	      },
	      labels: centeredLabelStyles
	    }
	  }, baseProps),
	  group: (0, _assign3.default)({
	    colorScale: colors
	  }, baseProps),
	  line: (0, _assign3.default)({
	    style: {
	      data: {
	        fill: "transparent",
	        opacity: 1,
	        stroke: blueGrey700,
	        strokeWidth: 2
	      },
	      labels: centeredLabelStyles
	    }
	  }, baseProps),
	  pie: (0, _assign3.default)({
	    colorScale: colors,
	    style: {
	      data: {
	        padding: padding,
	        stroke: blueGrey50,
	        strokeWidth: 1
	      },
	      labels: (0, _assign3.default)({}, baseLabelStyles, { padding: 20 })
	    }
	  }, baseProps),
	  scatter: (0, _assign3.default)({
	    style: {
	      data: {
	        fill: blueGrey700,
	        opacity: 1,
	        stroke: "transparent",
	        strokeWidth: 0
	      },
	      labels: centeredLabelStyles
	    }
	  }, baseProps),
	  stack: (0, _assign3.default)({
	    colorScale: colors
	  }, baseProps),
	  tooltip: {
	    style: (0, _assign3.default)({}, centeredLabelStyles, { padding: 5, pointerEvents: "none" }),
	    flyoutStyle: {
	      stroke: grey900,
	      strokeWidth: 1,
	      fill: "#f0f0f0",
	      pointerEvents: "none"
	    },
	    cornerRadius: 5,
	    pointerLength: 10
	  },
	  voronoi: (0, _assign3.default)({
	    style: {
	      data: {
	        fill: "transparent",
	        stroke: "transparent",
	        strokeWidth: 0
	      },
	      labels: (0, _assign3.default)({}, centeredLabelStyles, { padding: 5, pointerEvents: "none" }),
	      flyout: {
	        stroke: grey900,
	        strokeWidth: 1,
	        fill: "#f0f0f0",
	        pointerEvents: "none"
	      }
	    }
	  }, baseProps),
	  legend: {
	    colorScale: colors,
	    gutter: 10,
	    orientation: "vertical",
	    titleOrientation: "top",
	    style: {
	      data: {
	        type: "circle"
	      },
	      labels: baseLabelStyles,
	      title: (0, _assign3.default)({}, baseLabelStyles, { padding: 5 })
	    }
	  }
	};

/***/ },
/* 615 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defaults2 = __webpack_require__(5);
	
	var _defaults3 = _interopRequireDefault(_defaults2);
	
	var _assign2 = __webpack_require__(4);
	
	var _assign3 = _interopRequireDefault(_assign2);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _propTypes3 = __webpack_require__(26);
	
	var _propTypes4 = _interopRequireDefault(_propTypes3);
	
	var _textsize = __webpack_require__(153);
	
	var _textsize2 = _interopRequireDefault(_textsize);
	
	var _helpers = __webpack_require__(6);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	var _collection = __webpack_require__(8);
	
	var _collection2 = _interopRequireDefault(_collection);
	
	var _labelHelpers = __webpack_require__(150);
	
	var _labelHelpers2 = _interopRequireDefault(_labelHelpers);
	
	var _victoryLabel = __webpack_require__(145);
	
	var _victoryLabel2 = _interopRequireDefault(_victoryLabel);
	
	var _victoryTheme = __webpack_require__(147);
	
	var _victoryTheme2 = _interopRequireDefault(_victoryTheme);
	
	var _flyout = __webpack_require__(263);
	
	var _flyout2 = _interopRequireDefault(_flyout);
	
	var _victoryPortal = __webpack_require__(146);
	
	var _victoryPortal2 = _interopRequireDefault(_victoryPortal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var fallbackProps = {
	  cornerRadius: 5,
	  pointerLength: 10,
	  pointerWidth: 10
	};
	
	var VictoryTooltip = function (_React$Component) {
	  _inherits(VictoryTooltip, _React$Component);
	
	  function VictoryTooltip() {
	    _classCallCheck(this, VictoryTooltip);
	
	    return _possibleConstructorReturn(this, (VictoryTooltip.__proto__ || Object.getPrototypeOf(VictoryTooltip)).apply(this, arguments));
	  }
	
	  _createClass(VictoryTooltip, [{
	    key: "shouldComponentUpdate",
	    value: function shouldComponentUpdate(nextProps) {
	      return !_collection2.default.areVictoryPropsEqual(this.props, nextProps);
	    }
	  }, {
	    key: "getDefaultOrientation",
	    value: function getDefaultOrientation(props) {
	      var datum = props.datum,
	          horizontal = props.horizontal,
	          polar = props.polar;
	
	      if (!polar) {
	        var positive = horizontal ? "right" : "top";
	        var negative = horizontal ? "left" : "bottom";
	        return datum && datum.y < 0 ? negative : positive;
	      } else {
	        return this.getPolarOrientation(props, datum);
	      }
	    }
	  }, {
	    key: "getPolarOrientation",
	    value: function getPolarOrientation(props, datum) {
	      var degrees = _labelHelpers2.default.getDegrees(props, datum);
	      var placement = props.labelPlacement || "vertical";
	      if (placement === " vertical") {
	        return this.getVerticalOrientations(degrees);
	      } else if (placement === "parallel") {
	        return degrees < 90 || degrees > 270 ? "right" : "left";
	      } else {
	        return degrees > 180 ? "bottom" : "top";
	      }
	    }
	  }, {
	    key: "getVerticalOrientations",
	    value: function getVerticalOrientations(degrees) {
	      if (degrees < 45 || degrees > 315) {
	        // eslint-disable-line no-magic-numbers
	        return "right";
	      } else if (degrees >= 45 && degrees <= 135) {
	        // eslint-disable-line no-magic-numbers
	        return "top";
	      } else if (degrees > 135 && degrees < 225) {
	        // eslint-disable-line no-magic-numbers
	        return "left";
	      } else {
	        return "bottom";
	      }
	    }
	  }, {
	    key: "getEvaluatedProps",
	    value: function getEvaluatedProps(props) {
	      var horizontal = props.horizontal,
	          datum = props.datum,
	          pointerLength = props.pointerLength,
	          pointerWidth = props.pointerWidth,
	          cornerRadius = props.cornerRadius,
	          width = props.width,
	          height = props.height,
	          dx = props.dx,
	          dy = props.dy,
	          text = props.text,
	          active = props.active;
	
	
	      var style = Array.isArray(props.style) ? props.style.map(function (s) {
	        return _helpers2.default.evaluateStyle(s, datum, active);
	      }) : _helpers2.default.evaluateStyle(props.style, datum, active);
	      var flyoutStyle = _helpers2.default.evaluateStyle(props.flyoutStyle, datum, active);
	      var padding = flyoutStyle && flyoutStyle.padding || 0;
	      var defaultDx = horizontal ? padding : 0;
	      var defaultDy = horizontal ? 0 : padding;
	      var orientation = _helpers2.default.evaluateProp(props.orientation, datum, active) || this.getDefaultOrientation(props);
	      return (0, _assign3.default)({}, props, {
	        style: style,
	        flyoutStyle: flyoutStyle,
	        orientation: orientation,
	        dx: dx !== undefined ? _helpers2.default.evaluateProp(dx, datum, active) : defaultDx,
	        dy: dy !== undefined ? _helpers2.default.evaluateProp(dy, datum, active) : defaultDy,
	        cornerRadius: _helpers2.default.evaluateProp(cornerRadius, datum, active),
	        pointerLength: _helpers2.default.evaluateProp(pointerLength, datum, active),
	        pointerWidth: _helpers2.default.evaluateProp(pointerWidth, datum, active),
	        width: _helpers2.default.evaluateProp(width, datum, active),
	        height: _helpers2.default.evaluateProp(height, datum, active),
	        active: _helpers2.default.evaluateProp(active, datum, active),
	        text: _helpers2.default.evaluateProp(text, datum, active)
	      });
	    }
	  }, {
	    key: "getCalculatedValues",
	    value: function getCalculatedValues(props) {
	      var style = props.style,
	          text = props.text,
	          datum = props.datum,
	          active = props.active;
	
	      var theme = props.theme || _victoryTheme2.default.grayscale;
	      var defaultLabelStyles = theme && theme.tooltip && theme.tooltip.style ? theme.tooltip.style : {};
	      var baseLabelStyle = Array.isArray(style) ? style.map(function (s) {
	        return (0, _defaults3.default)({}, s, defaultLabelStyles);
	      }) : (0, _defaults3.default)({}, style, defaultLabelStyles);
	      var defaultFlyoutStyles = theme && theme.tooltip && theme.tooltip.flyoutStyle ? theme.tooltip.flyoutStyle : {};
	      var flyoutStyle = props.flyoutStyle ? (0, _defaults3.default)({}, props.flyoutStyle, defaultFlyoutStyles) : defaultFlyoutStyles;
	      var labelStyle = Array.isArray(baseLabelStyle) ? baseLabelStyle.map(function (s) {
	        return _helpers2.default.evaluateStyle(s, datum, active);
	      }) : _helpers2.default.evaluateStyle(baseLabelStyle, datum, active);
	      var labelSize = _textsize2.default.approximateTextSize(text, labelStyle);
	      var flyoutDimensions = this.getDimensions(props, labelSize, labelStyle);
	      var flyoutCenter = this.getFlyoutCenter(props, flyoutDimensions);
	      var transform = this.getTransform(props);
	      return { labelStyle: labelStyle, flyoutStyle: flyoutStyle, labelSize: labelSize, flyoutDimensions: flyoutDimensions, flyoutCenter: flyoutCenter, transform: transform };
	    }
	  }, {
	    key: "getTransform",
	    value: function getTransform(props) {
	      var x = props.x,
	          y = props.y,
	          style = props.style;
	
	      var labelStyle = style || {};
	      var angle = labelStyle.angle || props.angle || this.getDefaultAngle(props);
	      return angle ? "rotate(" + angle + " " + x + " " + y + ")" : undefined;
	    }
	
	    // eslint-disable-next-line complexity
	
	  }, {
	    key: "getDefaultAngle",
	    value: function getDefaultAngle(props) {
	      var polar = props.polar,
	          labelPlacement = props.labelPlacement,
	          orientation = props.orientation,
	          datum = props.datum;
	
	      if (!polar || !labelPlacement || labelPlacement === "vertical") {
	        return 0;
	      }
	      var degrees = _labelHelpers2.default.getDegrees(props, datum);
	      var sign = degrees > 90 && degrees < 180 || degrees > 270 ? 1 : -1;
	      var labelRotation = labelPlacement === "perpendicular" ? 0 : 90;
	      var angle = void 0;
	      if (degrees === 0 || degrees === 180) {
	        angle = orientation === "top" && degrees === 180 ? 270 : 90;
	      } else if (degrees > 0 && degrees < 180) {
	        angle = 90 - degrees;
	      } else if (degrees > 180 && degrees < 360) {
	        angle = 270 - degrees;
	      }
	      return angle + sign * labelRotation;
	    }
	  }, {
	    key: "getFlyoutCenter",
	    value: function getFlyoutCenter(props, dimensions) {
	      var x = props.x,
	          y = props.y,
	          dx = props.dx,
	          dy = props.dy,
	          pointerLength = props.pointerLength,
	          orientation = props.orientation;
	      var height = dimensions.height,
	          width = dimensions.width;
	
	      var xSign = orientation === "left" ? -1 : 1;
	      var ySign = orientation === "bottom" ? -1 : 1;
	      return {
	        x: orientation === "left" || orientation === "right" ? x + xSign * (pointerLength + width / 2 + dx) : x + dx,
	        y: orientation === "top" || orientation === "bottom" ? y - ySign * (pointerLength + height / 2 + dy) : y - dy
	      };
	    }
	  }, {
	    key: "getLabelPadding",
	    value: function getLabelPadding(style) {
	      if (!style) {
	        return 0;
	      }
	      var paddings = Array.isArray(style) ? style.map(function (s) {
	        return s.padding;
	      }) : [style.padding];
	      return Math.max.apply(Math, _toConsumableArray(paddings).concat([0]));
	    }
	  }, {
	    key: "getDimensions",
	    value: function getDimensions(props, labelSize, labelStyle) {
	      var orientation = props.orientation,
	          cornerRadius = props.cornerRadius,
	          pointerLength = props.pointerLength,
	          pointerWidth = props.pointerWidth;
	
	      var padding = this.getLabelPadding(labelStyle);
	      var getHeight = function () {
	        var calculatedHeight = labelSize.height + padding;
	        var minHeight = orientation === "top" || orientation === "bottom" ? 2 * cornerRadius : 2 * cornerRadius + pointerWidth;
	        return Math.max(minHeight, calculatedHeight);
	      };
	      var getWidth = function () {
	        var calculatedWidth = labelSize.width + padding;
	        var minWidth = orientation === "left" || orientation === "right" ? 2 * cornerRadius + pointerLength : 2 * cornerRadius;
	        return Math.max(minWidth, calculatedWidth);
	      };
	      return {
	        height: props.height || getHeight(props, labelSize, orientation) + padding / 2,
	        width: props.width || getWidth(props, labelSize, orientation) + padding
	      };
	    }
	  }, {
	    key: "getLabelProps",
	    value: function getLabelProps(props, calculatedValues) {
	      var flyoutCenter = calculatedValues.flyoutCenter,
	          labelStyle = calculatedValues.labelStyle,
	          labelSize = calculatedValues.labelSize,
	          dy = calculatedValues.dy,
	          dx = calculatedValues.dx;
	      var text = props.text,
	          datum = props.datum,
	          labelComponent = props.labelComponent,
	          index = props.index;
	
	      var textAnchor = (Array.isArray(labelStyle) && labelStyle.length ? labelStyle[0].textAnchor : labelStyle.textAnchor) || "middle";
	      var getLabelX = function () {
	        var sign = textAnchor === "end" ? -1 : 1;
	        return flyoutCenter.x - sign * (labelSize.width / 2);
	      };
	      return (0, _defaults3.default)({}, labelComponent.props, {
	        key: "label-" + index,
	        text: text, datum: datum, textAnchor: textAnchor, dy: dy, dx: dx,
	        style: labelStyle,
	        x: !textAnchor || textAnchor === "middle" ? flyoutCenter.x : getLabelX(),
	        y: flyoutCenter.y,
	        verticalAnchor: "middle",
	        angle: labelStyle.angle
	      });
	    }
	  }, {
	    key: "getFlyoutProps",
	    value: function getFlyoutProps(props, calculatedValues) {
	      var flyoutDimensions = calculatedValues.flyoutDimensions,
	          flyoutStyle = calculatedValues.flyoutStyle;
	      var x = props.x,
	          y = props.y,
	          dx = props.dx,
	          dy = props.dy,
	          datum = props.datum,
	          index = props.index,
	          orientation = props.orientation,
	          pointerLength = props.pointerLength,
	          pointerWidth = props.pointerWidth,
	          cornerRadius = props.cornerRadius,
	          events = props.events,
	          flyoutComponent = props.flyoutComponent;
	
	      return (0, _defaults3.default)({}, flyoutComponent.props, {
	        x: x, y: y, dx: dx, dy: dy, datum: datum, index: index, orientation: orientation, pointerLength: pointerLength, pointerWidth: pointerWidth, cornerRadius: cornerRadius, events: events,
	        key: "flyout-" + index,
	        width: flyoutDimensions.width,
	        height: flyoutDimensions.height,
	        style: flyoutStyle
	      });
	    }
	
	    // Overridden in victory-core-native
	
	  }, {
	    key: "renderTooltip",
	    value: function renderTooltip(props) {
	      var evaluatedProps = this.getEvaluatedProps(props);
	      var flyoutComponent = evaluatedProps.flyoutComponent,
	          labelComponent = evaluatedProps.labelComponent,
	          groupComponent = evaluatedProps.groupComponent,
	          active = evaluatedProps.active,
	          renderInPortal = evaluatedProps.renderInPortal;
	
	      if (!active) {
	        return renderInPortal ? _react2.default.createElement(
	          _victoryPortal2.default,
	          null,
	          null
	        ) : null;
	      }
	      var calculatedValues = this.getCalculatedValues(evaluatedProps);
	      var children = [_react2.default.cloneElement(flyoutComponent, this.getFlyoutProps(evaluatedProps, calculatedValues)), _react2.default.cloneElement(labelComponent, this.getLabelProps(evaluatedProps, calculatedValues))];
	      var tooltip = _react2.default.cloneElement(groupComponent, { role: "presentation", transform: calculatedValues.transform }, children);
	      return renderInPortal ? _react2.default.createElement(
	        _victoryPortal2.default,
	        null,
	        tooltip
	      ) : tooltip;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var props = _helpers2.default.modifyProps(this.props, fallbackProps, "tooltip");
	      return this.renderTooltip(props);
	    }
	  }]);
	
	  return VictoryTooltip;
	}(_react2.default.Component);
	
	VictoryTooltip.displayName = "VictoryTooltip";
	VictoryTooltip.propTypes = {
	  activateData: _propTypes2.default.bool,
	  active: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.func]),
	  angle: _propTypes2.default.number,
	  cornerRadius: _propTypes2.default.oneOfType([_propTypes4.default.nonNegative, _propTypes2.default.func]),
	  data: _propTypes2.default.array,
	  datum: _propTypes2.default.object,
	  dx: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.func]),
	  dy: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.func]),
	  events: _propTypes2.default.object,
	  flyoutComponent: _propTypes2.default.element,
	  flyoutStyle: _propTypes2.default.object,
	  groupComponent: _propTypes2.default.element,
	  height: _propTypes2.default.oneOfType([_propTypes4.default.nonNegative, _propTypes2.default.func]),
	  horizontal: _propTypes2.default.bool,
	  index: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  labelComponent: _propTypes2.default.element,
	  orientation: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(["top", "bottom", "left", "right"]), _propTypes2.default.func]),
	  pointerLength: _propTypes2.default.oneOfType([_propTypes4.default.nonNegative, _propTypes2.default.func]),
	  pointerWidth: _propTypes2.default.oneOfType([_propTypes4.default.nonNegative, _propTypes2.default.func]),
	  polar: _propTypes2.default.bool,
	  renderInPortal: _propTypes2.default.bool,
	  style: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.array]),
	  text: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.func, _propTypes2.default.array]),
	  theme: _propTypes2.default.object,
	  width: _propTypes2.default.oneOfType([_propTypes4.default.nonNegative, _propTypes2.default.func]),
	  x: _propTypes2.default.number,
	  y: _propTypes2.default.number
	};
	VictoryTooltip.defaultProps = {
	  active: false,
	  renderInPortal: true,
	  labelComponent: _react2.default.createElement(_victoryLabel2.default, null),
	  flyoutComponent: _react2.default.createElement(_flyout2.default, null),
	  groupComponent: _react2.default.createElement("g", null)
	};
	
	VictoryTooltip.defaultEvents = function (props) {
	  return [{
	    target: "data",
	    eventHandlers: {
	      onMouseOver: function () {
	        return props.activateData ? [{ target: "labels", mutation: function () {
	            return { active: true };
	          } }, { target: "data", mutation: function () {
	            return { active: true };
	          } }] : [{ target: "labels", mutation: function () {
	            return { active: true };
	          } }];
	      },
	      onTouchStart: function () {
	        return props.activateData ? [{ target: "labels", mutation: function () {
	            return { active: true };
	          } }, { target: "data", mutation: function () {
	            return { active: true };
	          } }] : [{ target: "labels", mutation: function () {
	            return { active: true };
	          } }];
	      },
	      onMouseOut: function () {
	        return props.activateData ? [{ target: "labels", mutation: function () {
	            return { active: false };
	          } }, { target: "data", mutation: function () {
	            return { active: false };
	          } }] : [{ target: "labels", mutation: function () {
	            return { active: false };
	          } }];
	      },
	      onTouchEnd: function () {
	        return props.activateData ? [{ target: "labels", mutation: function () {
	            return { active: false };
	          } }, { target: "data", mutation: function () {
	            return { active: false };
	          } }] : [{ target: "labels", mutation: function () {
	            return { active: false };
	          } }];
	      }
	    }
	  }];
	};
	
	exports.default = VictoryTooltip;

/***/ },
/* 616 */
/***/ function(module, exports) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/* eslint-disable func-style */
	exports.default = {
	  continuousTransitions: function () {
	    return {
	      onLoad: {
	        duration: 2000
	      },
	      onExit: {
	        duration: 500
	      },
	      onEnter: {
	        duration: 500
	      }
	    };
	  },
	  continuousPolarTransitions: function () {
	    return {
	      onLoad: {
	        duration: 2000,
	        before: function () {
	          return { _y: 0, _y1: 0, _y0: 0 };
	        },
	        after: function (datum) {
	          return { _y: datum._y, _y1: datum._y1, _y0: datum._y0 };
	        }
	      },
	      onExit: {
	        duration: 500,
	        before: function (datum, index, data) {
	          var adjacent = function (attr) {
	            var adj = index === 0 ? data[index + 1] : data[index - 1];
	            return adj[attr];
	          };
	          return { _x: adjacent("_x"), _y: adjacent("_y"), _y0: adjacent("_y0") };
	        }
	      },
	      onEnter: {
	        duration: 500,
	        before: function (datum, index, data) {
	          var adjacent = function (attr) {
	            var adj = index === 0 ? data[index + 1] : data[index - 1];
	            return adj[attr];
	          };
	          return { _x: adjacent("_x"), _y: adjacent("_y"), _y0: adjacent("_y0") };
	        },
	        after: function (datum) {
	          return { _x: datum._x, _y: datum._y, _y1: datum._y1, _y0: datum._y0 };
	        }
	      }
	    };
	  },
	  discreteTransitions: function () {
	    return {
	      onLoad: {
	        duration: 2000,
	        before: function () {
	          return { opacity: 0 };
	        },
	        after: function (datum) {
	          return datum;
	        }
	      },
	      onExit: {
	        duration: 600,
	        before: function () {
	          return { opacity: 0 };
	        }
	      },
	      onEnter: {
	        duration: 600,
	        before: function () {
	          return { opacity: 0 };
	        },
	        after: function (datum) {
	          return datum;
	        }
	      }
	    };
	  }
	};

/***/ },
/* 617 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _sortedUniq2 = __webpack_require__(498);
	
	var _sortedUniq3 = _interopRequireDefault(_sortedUniq2);
	
	var _isPlainObject2 = __webpack_require__(36);
	
	var _isPlainObject3 = _interopRequireDefault(_isPlainObject2);
	
	var _includes2 = __webpack_require__(94);
	
	var _includes3 = _interopRequireDefault(_includes2);
	
	var _flatten2 = __webpack_require__(93);
	
	var _flatten3 = _interopRequireDefault(_flatten2);
	
	var _data = __webpack_require__(148);
	
	var _data2 = _interopRequireDefault(_data);
	
	var _scale = __webpack_require__(151);
	
	var _scale2 = _interopRequireDefault(_scale);
	
	var _helpers = __webpack_require__(6);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	var _collection = __webpack_require__(8);
	
	var _collection2 = _interopRequireDefault(_collection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	exports.default = {
	
	  /**
	   * Returns a domain for a given axis based on props, catefory, or data
	   * @param {Object} props: the props object
	   * @param {String} axis: the current axis
	   * @returns {Array} the domain for the given axis
	   */
	  getDomain: function (props, axis) {
	    var propsDomain = this.getDomainFromProps(props, axis);
	    if (propsDomain) {
	      return this.padDomain(propsDomain, props, axis);
	    }
	    var categoryDomain = this.getDomainFromCategories(props, axis);
	    if (categoryDomain) {
	      return this.padDomain(categoryDomain, props, axis);
	    }
	    var dataset = _data2.default.getData(props);
	    var domain = this.getDomainFromData(props, axis, dataset);
	    return this.cleanDomain(this.padDomain(domain, props, axis), props, axis);
	  },
	
	
	  /**
	   * Returns the cleaned domain. Some scale types break when certain data is supplied.
	   * This method will replace elements in the domain that break certain scales.
	   * So far this method only removes zeroes for log scales
	   * @param {Array} domain: the original domain
	   * @param {Object} props: the props object
	   * @param {String} axis: the current axis
	   * @returns {Array} the cleaned domain
	   */
	  cleanDomain: function (domain, props, axis) {
	    var scaleType = _scale2.default.getScaleType(props, axis);
	
	    if (scaleType !== "log") {
	      return domain;
	    }
	
	    var rules = function (dom) {
	      var almostZero = dom[0] < 0 || dom[1] < 0 ? -1 / Number.MAX_SAFE_INTEGER : 1 / Number.MAX_SAFE_INTEGER;
	      var domainOne = dom[0] === 0 ? almostZero : dom[0];
	      var domainTwo = dom[1] === 0 ? almostZero : dom[1];
	      return [domainOne, domainTwo];
	    };
	
	    return rules(domain);
	  },
	
	
	  /**
	   * Returns a domain for a given axis. This method forces the domain to include
	   * zero unless the deomain is explicitly specified in props.
	   * @param {Object} props: the props object
	   * @param {String} axis: the current axis
	   * @returns {Array} the domain for the given axis
	   */
	  getDomainWithZero: function (props, axis) {
	    var propsDomain = this.getDomainFromProps(props, axis);
	    if (propsDomain) {
	      return this.cleanDomain(this.padDomain(propsDomain, props, axis), props, axis);
	    }
	    var horizontal = props.horizontal;
	
	    var ensureZero = function (domain, dataset) {
	      var currentAxis = _helpers2.default.getCurrentAxis(axis, horizontal);
	      if (currentAxis === "x") {
	        return domain;
	      } else if (!dataset) {
	        return [_collection2.default.getMinValue(domain, 0), _collection2.default.getMaxValue(domain, 0)];
	      }
	      var flatData = (0, _flatten3.default)(dataset);
	      var minData = flatData.map(function (datum) {
	        return datum["_" + currentAxis + "0"] || 0;
	      });
	      var maxData = flatData.map(function (datum) {
	        return datum["_" + currentAxis + "1"] || datum["_" + currentAxis] || 0;
	      });
	      var min = _collection2.default.getMinValue([].concat(_toConsumableArray(domain), _toConsumableArray(minData), _toConsumableArray(maxData)));
	      var max = _collection2.default.getMaxValue([].concat(_toConsumableArray(domain), _toConsumableArray(maxData), _toConsumableArray(minData)));
	      return [min, max];
	    };
	    var categoryDomain = this.getDomainFromCategories(props, axis);
	    if (categoryDomain) {
	      return this.cleanDomain(this.padDomain(ensureZero(categoryDomain), props, axis), props, axis);
	    }
	    var dataset = _data2.default.getData(props);
	    var domain = ensureZero(this.getDomainFromData(props, axis, dataset), dataset);
	    return this.cleanDomain(this.padDomain(domain, props, axis), props, axis);
	  },
	
	
	  /**
	   * Returns a the domain for a given axis if domain is given in props
	   * @param {Object} props: the props object
	   * @param {String} axis: the current axis
	   * @returns {Array|undefined} the domain based on props
	   */
	  getDomainFromProps: function (props, axis) {
	    if (props.domain && props.domain[axis]) {
	      return props.domain[axis];
	    } else if (props.domain && Array.isArray(props.domain)) {
	      return props.domain;
	    }
	    return undefined;
	  },
	
	
	  /**
	   * Returns a domain from a dataset for a given axis
	   * @param {Object} props: the props object
	   * @param {String} axis: the current axis
	   * @param {Array} dataset: an array of data
	   * @returns {Array} the domain based on data
	   */
	  getDomainFromData: function (props, axis, dataset) {
	    var currentAxis = _helpers2.default.getCurrentAxis(axis, props.horizontal);
	    var flatData = (0, _flatten3.default)(dataset);
	    var allData = flatData.map(function (datum) {
	      return typeof datum["_" + currentAxis + "1"] === "undefined" ? datum["_" + currentAxis] : datum["_" + currentAxis + "1"];
	    });
	    var allMinData = flatData.map(function (datum) {
	      return typeof datum["_" + currentAxis + "0"] === "undefined" ? datum["_" + currentAxis] : datum["_" + currentAxis + "0"];
	    });
	    if (allData.length < 1) {
	      return _scale2.default.getBaseScale(props, axis).domain();
	    }
	
	    var min = _collection2.default.getMinValue(allMinData);
	    var max = _collection2.default.getMaxValue(allData);
	    var domain = void 0;
	    if (+min === +max) {
	      domain = this.getSinglePointDomain(max);
	    } else {
	      domain = [min, max];
	    }
	    var angularRange = Math.abs((props.startAngle || 0) - (props.endAngle || 360));
	    return props.polar && axis === "x" && angularRange === 360 ? this.getSymmetricDomain(domain, allData) : domain;
	  },
	  getSinglePointDomain: function (val) {
	    // d3-scale does not properly resolve very small differences.
	    // eslint-disable-next-line no-magic-numbers
	    var verySmallNumber = Math.pow(10, -10);
	    var verySmallDate = 1;
	    var min = val instanceof Date ? new Date(+val - verySmallDate) : val - verySmallNumber;
	    var max = val instanceof Date ? new Date(+val + verySmallDate) : val + verySmallNumber;
	    return [min, max];
	  },
	  getSymmetricDomain: function (domain, data) {
	    var processedData = (0, _sortedUniq3.default)(data.sort(function (a, b) {
	      return a - b;
	    }));
	    var step = processedData[1] - processedData[0];
	    return [domain[0], domain[1] + step];
	  },
	
	
	  /**
	   * Returns a domain based tickValues
	   * @param {Object} props: the props object
	   * @param {String} axis: either x or y
	   * @returns {Array} returns a domain from tickValues
	   */
	  getDomainFromTickValues: function (props, axis) {
	    var domain = void 0;
	    if (_helpers2.default.stringTicks(props)) {
	      domain = [1, props.tickValues.length];
	    } else {
	      // coerce ticks to numbers
	      var ticks = props.tickValues.map(function (value) {
	        return +value;
	      });
	      var initialDomain = [_collection2.default.getMinValue(ticks), _collection2.default.getMaxValue(ticks)];
	      domain = props.polar && axis === "x" ? this.getSymmetricDomain(initialDomain, ticks) : initialDomain;
	    }
	    if (_helpers2.default.isVertical(props)) {
	      domain.reverse();
	    }
	    return domain;
	  },
	
	
	  /**
	   * Returns a domain based on categories if they exist
	   * @param {Object} props: the props object
	   * @param {String} axis: the current axis
	   * @returns {Array|undefined} returns a domain from categories or undefined
	   */
	  getDomainFromCategories: function (props, axis) {
	    var categories = _data2.default.getCategories(props, axis);
	    if (!categories) {
	      return undefined;
	    }
	    var stringArray = _collection2.default.containsStrings(categories) ? _data2.default.getStringsFromCategories(props, axis) : [];
	    var stringMap = stringArray.length === 0 ? null : stringArray.reduce(function (memo, string, index) {
	      memo[string] = index + 1;
	      return memo;
	    }, {});
	    var categoryValues = stringMap ? categories.map(function (value) {
	      return stringMap[value];
	    }) : categories;
	    return [_collection2.default.getMinValue(categoryValues), _collection2.default.getMaxValue(categoryValues)];
	  },
	
	
	  /**
	   * Returns a cumulative domain for a set of grouped datasets (i.e. stacked charts)
	   * @param {Object} props: the props object
	   * @param {String} axis: the current axis
	   * @param {Array} datasets: an array of data arrays
	   * @returns {Array} the cumulative domain
	   */
	  getDomainFromGroupedData: function (props, axis, datasets) {
	    var horizontal = props.horizontal;
	
	    var dependent = axis === "x" && !horizontal || axis === "y" && horizontal;
	    if (dependent && props.categories) {
	      return this.getDomainFromCategories(props, axis);
	    }
	    var globalDomain = this.getDomainFromData(props, axis, datasets);
	    // find the cumulative max for stacked chart types
	    var cumulativeData = !dependent ? this.getCumulativeData(props, axis, datasets) : [];
	    var cumulativeMaxArray = cumulativeData.map(function (dataset) {
	      return dataset.reduce(function (memo, val) {
	        return val > 0 ? +val + +memo : memo;
	      }, 0);
	    });
	    var cumulativeMinArray = cumulativeData.map(function (dataset) {
	      return dataset.reduce(function (memo, val) {
	        return val < 0 ? +val + +memo : memo;
	      }, 0);
	    });
	
	    var cumulativeMin = Math.min.apply(Math, _toConsumableArray(cumulativeMinArray));
	    // use greatest min / max
	    var domainMin = cumulativeMin < 0 ? cumulativeMin : _collection2.default.getMinValue(globalDomain);
	    var domainMax = _collection2.default.getMaxValue.apply(_collection2.default, [globalDomain].concat(_toConsumableArray(cumulativeMaxArray)));
	    if (+domainMin === +domainMax) {
	      return this.getSinglePointDomain(domainMin);
	    }
	    return [domainMin, domainMax];
	  },
	
	
	  /**
	   * Returns cumulative datasets either by index or category
	   * @param {Object} props: the props object
	   * @param {String} axis: the current axis
	   * @param {Array} datasets: an array of data arrays
	   * @returns {Array} an array of data arrays grouped by index or category
	   */
	  getCumulativeData: function (props, axis, datasets) {
	    var currentAxis = _helpers2.default.getCurrentAxis(axis, props.horizontal);
	    var otherAxis = currentAxis === "x" ? "y" : "x";
	    var categories = [];
	    var axisValues = [];
	    datasets.forEach(function (dataset) {
	      dataset.forEach(function (data) {
	        if (data.category !== undefined && !(0, _includes3.default)(categories, data.category)) {
	          categories.push(data.category);
	        } else if (!(0, _includes3.default)(axisValues, data["_" + otherAxis])) {
	          axisValues.push(data["_" + otherAxis]);
	        }
	      });
	    });
	
	    var _dataByCategory = function () {
	      return categories.map(function (value) {
	        return datasets.reduce(function (prev, data) {
	          return data.category === value ? prev.concat(data["_" + axis]) : prev;
	        }, []);
	      });
	    };
	
	    var _dataByIndex = function () {
	      return axisValues.map(function (value, index) {
	        return datasets.map(function (data) {
	          return data[index] && data[index]["_" + currentAxis];
	        });
	      });
	    };
	    return categories.length === 0 ? _dataByIndex() : _dataByCategory();
	  },
	
	
	  /**
	   * Returns the domain padding appropriate for a given axis
	   * @param {Object} props: the props object
	   * @param {String} axis: the current axis
	   * @returns {Object} an object with padding specified for "left" and "right"
	   */
	  getDomainPadding: function (props, axis) {
	    var formatPadding = function (padding) {
	      return Array.isArray(padding) ? { left: padding[0], right: padding[1] } : { left: padding, right: padding };
	    };
	
	    return (0, _isPlainObject3.default)(props.domainPadding) ? formatPadding(props.domainPadding[axis]) : formatPadding(props.domainPadding);
	  },
	
	
	  /**
	   * Returns the domain with padding from the `domainPadding` prop applied
	   * @param {Array} domain: the original domain
	   * @param {Object} props: the props object
	   * @param {String} axis: the current axis
	   * @returns {Array} the domain with padding applied
	   */
	  padDomain: function (domain, props, axis) {
	    if (!props.domainPadding) {
	      return domain;
	    }
	
	    var padding = this.getDomainPadding(props, axis);
	    if (!padding.left && !padding.right) {
	      return domain;
	    }
	
	    var domainMin = _collection2.default.getMinValue(domain);
	    var domainMax = _collection2.default.getMaxValue(domain);
	    var range = _helpers2.default.getRange(props, axis);
	    var rangeExtent = Math.abs(Math.max.apply(Math, _toConsumableArray(range)) - Math.min.apply(Math, _toConsumableArray(range)));
	
	    // Naive initial padding calculation
	    var initialPadding = {
	      left: Math.abs(domainMax - domainMin) * padding.left / rangeExtent,
	      right: Math.abs(domainMax - domainMin) * padding.right / rangeExtent
	    };
	
	    // Adjust the domain by the initial padding
	    var adjustedDomain = {
	      min: domainMin >= 0 && domainMin - initialPadding.left <= 0 ? 0 : domainMin.valueOf() - initialPadding.left,
	      max: domainMax <= 0 && domainMax + initialPadding.right >= 0 ? 0 : domainMax.valueOf() + initialPadding.right
	    };
	
	    // re-calculate padding, taking the adjusted domain into account
	    var finalPadding = {
	      left: Math.abs(adjustedDomain.max - adjustedDomain.min) * padding.left / rangeExtent,
	      right: Math.abs(adjustedDomain.max - adjustedDomain.min) * padding.right / rangeExtent
	    };
	
	    // Adjust the domain by the final padding
	    var finalDomain = {
	      min: domainMin >= 0 && domainMin - finalPadding.left <= 0 ? 0 : domainMin.valueOf() - finalPadding.left,
	      max: domainMax >= 0 && domainMax + finalPadding.right <= 0 ? 0 : domainMax.valueOf() + finalPadding.right
	    };
	
	    return domainMin instanceof Date || domainMax instanceof Date ? [new Date(finalDomain.min), new Date(finalDomain.max)] : [finalDomain.min, finalDomain.max];
	  }
	};

/***/ },
/* 618 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isFunction2 = __webpack_require__(7);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _data = __webpack_require__(148);
	
	var _data2 = _interopRequireDefault(_data);
	
	var _collection = __webpack_require__(8);
	
	var _collection2 = _interopRequireDefault(_collection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  getParentSVG: function (target) {
	    if (target.nodeName === "svg") {
	      return target;
	    } else {
	      return this.getParentSVG(target.parentNode);
	    }
	  },
	  getTransformationMatrix: function (svg) {
	    return svg.getScreenCTM().inverse();
	  },
	  getSVGEventCoordinates: function (evt) {
	    if (typeof document === "undefined") {
	      // react-native override. relies on the RN.View being the _exact_ same size as its child SVG.
	      // this should be fine: the svg is the only child of View and the View shirks to its children
	      return {
	        x: evt.nativeEvent.locationX,
	        y: evt.nativeEvent.locationY
	      };
	    }
	    evt = evt.changedTouches && evt.changedTouches.length ? evt.changedTouches[0] : evt;
	    var svg = this.getParentSVG(evt.target);
	    var matrix = this.getTransformationMatrix(svg);
	    return {
	      x: this.transformTarget(evt.clientX, matrix, "x"),
	      y: this.transformTarget(evt.clientY, matrix, "y")
	    };
	  },
	  transformTarget: function (target, matrix, dimension) {
	    var a = matrix.a,
	        d = matrix.d,
	        e = matrix.e,
	        f = matrix.f;
	
	    return dimension === "y" ? d * target + f : a * target + e;
	  },
	  getDomainCoordinates: function (props, domain) {
	    var scale = props.scale;
	
	    domain = domain || { x: scale.x.domain(), y: scale.y.domain() };
	    return {
	      x: [scale.x(domain.x[0]), scale.x(domain.x[1])],
	      y: [scale.y(domain.y[0]), scale.y(domain.y[1])]
	    };
	  },
	
	
	  // eslint-disable-next-line max-params
	  getDataCoordinates: function (props, scale, x, y) {
	    var polar = props.polar;
	
	    if (!polar) {
	      return {
	        x: scale.x.invert(x),
	        y: scale.y.invert(y)
	      };
	    } else {
	      var origin = props.origin || { x: 0, y: 0 };
	      var baseX = x - origin.x;
	      var baseY = y - origin.y;
	      var radius = Math.abs(baseX * Math.sqrt(1 + Math.pow(-baseY / baseX, 2)));
	      var angle = (-Math.atan2(baseY, baseX) + Math.PI * 2) % (Math.PI * 2);
	      return {
	        x: scale.x.invert(angle),
	        y: scale.y.invert(radius)
	      };
	    }
	  },
	  getBounds: function (props) {
	    var x1 = props.x1,
	        x2 = props.x2,
	        y1 = props.y1,
	        y2 = props.y2,
	        scale = props.scale;
	
	    var point1 = this.getDataCoordinates(props, scale, x1, y1);
	    var point2 = this.getDataCoordinates(props, scale, x2, y2);
	    var makeBound = function (a, b) {
	      return [_collection2.default.getMinValue([a, b]), _collection2.default.getMaxValue([a, b])];
	    };
	
	    return {
	      x: makeBound(point1.x, point2.x),
	      y: makeBound(point1.y, point2.y)
	    };
	  },
	  getDatasets: function (props) {
	    // eslint-disable-line max-statements
	    if (props.data) {
	      return [{ data: props.data }];
	    }
	    var getData = function (childProps) {
	      var data = _data2.default.getData(childProps);
	      return Array.isArray(data) && data.length > 0 ? data : undefined;
	    };
	
	    // Reverse the child array to maintain correct order when looping over
	    // children starting from the end of the array.
	    var children = _react2.default.Children.toArray(props.children).reverse();
	    var childrenLength = children.length;
	    var dataArr = [];
	    var dataArrLength = 0;
	    var childIndex = 0;
	    while (childrenLength > 0) {
	      var child = children[--childrenLength];
	      var childName = child.props.name || childIndex;
	      childIndex++;
	      if (child.type && child.type.role === "axis") {
	        childIndex++;
	      } else if (child.type && (0, _isFunction3.default)(child.type.getData)) {
	        dataArr[dataArrLength++] = { childName: childName, data: child.type.getData(child.props) };
	      } else if (child.props && child.props.children) {
	        var newChildren = _react2.default.Children.toArray(child.props.children);
	        var newChildrenLength = newChildren.length;
	        for (var index = 0; index < newChildrenLength; index++) {
	          children[childrenLength++] = newChildren[index];
	        }
	      } else {
	        dataArr[dataArrLength++] = { childName: childName, data: getData(child.props) };
	      }
	    }
	    return dataArr;
	  },
	  filterDatasets: function (datasets, bounds) {
	    var _this = this;
	
	    var filtered = datasets.reduce(function (memo, dataset) {
	      var selectedData = _this.getSelectedData(dataset.data, bounds);
	      memo = selectedData ? memo.concat({
	        childName: dataset.childName, eventKey: selectedData.eventKey, data: selectedData.data
	      }) : memo;
	      return memo;
	    }, []);
	    return filtered.length ? filtered : null;
	  },
	  getSelectedData: function (dataset, bounds) {
	    var x = bounds.x,
	        y = bounds.y;
	
	    var withinBounds = function (d) {
	      return d._x >= x[0] && d._x <= x[1] && d._y >= y[0] && d._y <= y[1];
	    };
	
	    var selectedData = dataset.reduce(function (accum, datum, index) {
	      if (withinBounds(datum)) {
	        accum.data.push(datum);
	        accum.eventKey.push(datum.eventKey === undefined ? index : datum.eventKey);
	      }
	
	      return accum;
	    }, {
	      data: [],
	      eventKey: []
	    });
	
	    return selectedData.data.length > 0 ? selectedData : null;
	  }
	};

/***/ },
/* 619 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _omit2 = __webpack_require__(25);
	
	var _omit3 = _interopRequireDefault(_omit2);
	
	var _isFunction2 = __webpack_require__(7);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _defaults2 = __webpack_require__(5);
	
	var _defaults3 = _interopRequireDefault(_defaults2);
	
	var _assign2 = __webpack_require__(4);
	
	var _assign3 = _interopRequireDefault(_assign2);
	
	var _d3Shape = __webpack_require__(63);
	
	var d3Shape = _interopRequireWildcard(_d3Shape);
	
	var _victoryCore = __webpack_require__(3);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*eslint no-magic-numbers: ["error", { "ignore": [-1, 0, 1, 2, 45, 135, 180, 225, 315] }]*/
	exports.default = {
	  degreesToRadians: function (degrees) {
	    return degrees * (Math.PI / 180);
	  },
	  checkForValidText: function (text) {
	    if (text === undefined || text === null) {
	      return text;
	    } else {
	      return "" + text;
	    }
	  },
	  getSliceStyle: function (datum, index, calculatedValues) {
	    var style = calculatedValues.style,
	        colors = calculatedValues.colors;
	
	    var fill = this.getColor(style, colors, index);
	    var dataStyles = (0, _omit3.default)(datum, ["_x", "_y", "x", "y", "label"]);
	    return (0, _defaults3.default)({}, dataStyles, { fill: fill }, style.data);
	  },
	  getBaseProps: function (props, fallbackProps) {
	    props = _victoryCore.Helpers.modifyProps(props, fallbackProps, "pie");
	    var calculatedValues = this.getCalculatedValues(props);
	    var slices = calculatedValues.slices,
	        style = calculatedValues.style,
	        pathFunction = calculatedValues.pathFunction,
	        data = calculatedValues.data,
	        origin = calculatedValues.origin;
	
	    var childProps = {
	      parent: {
	        standalone: props.standalone, slices: slices, pathFunction: pathFunction,
	        width: props.width, height: props.height, style: style.parent
	      }
	    };
	
	    for (var index = 0, len = slices.length; index < len; index++) {
	      var slice = slices[index];
	      var datum = data[index];
	      var eventKey = datum.eventKey || index;
	      var dataProps = {
	        index: index, slice: slice, pathFunction: pathFunction, datum: datum, data: data, origin: origin,
	        style: this.getSliceStyle(datum, index, calculatedValues)
	      };
	
	      childProps[eventKey] = {
	        data: dataProps,
	        labels: this.getLabelProps(props, dataProps, calculatedValues)
	      };
	    }
	    return childProps;
	  },
	  getLabelProps: function (props, dataProps, calculatedValues) {
	    var index = dataProps.index,
	        datum = dataProps.datum,
	        data = dataProps.data,
	        slice = dataProps.slice;
	    var style = calculatedValues.style,
	        radius = calculatedValues.radius,
	        origin = calculatedValues.origin;
	
	    var labelStyle = _victoryCore.Helpers.evaluateStyle((0, _assign3.default)({ padding: 0 }, style.labels), datum, props.active);
	    var labelRadius = _victoryCore.Helpers.evaluateProp(props.labelRadius, datum);
	    var labelPosition = this.getLabelPosition(radius, labelRadius, labelStyle);
	    var position = labelPosition.centroid(slice);
	    var orientation = this.getLabelOrientation(slice);
	    return {
	      index: index, datum: datum, data: data, slice: slice, orientation: orientation,
	      style: labelStyle,
	      x: Math.round(position[0]) + origin.x,
	      y: Math.round(position[1]) + origin.y,
	      text: this.getLabelText(props, datum, index),
	      textAnchor: labelStyle.textAnchor || this.getTextAnchor(orientation),
	      verticalAnchor: labelStyle.verticalAnchor || this.getVerticalAnchor(orientation),
	      angle: labelStyle.angle
	    };
	  },
	  getCalculatedValues: function (props) {
	    var theme = props.theme,
	        colorScale = props.colorScale,
	        width = props.width,
	        height = props.height;
	
	    var styleObject = theme && theme.pie && theme.pie.style ? theme.pie.style : {};
	    var style = _victoryCore.Helpers.getStyles(props.style, styleObject, "auto", "100%");
	    var colors = Array.isArray(colorScale) ? colorScale : _victoryCore.Style.getColorScale(colorScale);
	    var padding = _victoryCore.Helpers.getPadding(props);
	    var radius = this.getRadius(props, padding);
	    var offsetWidth = (radius + padding.left + (width - radius - padding.right)) / 2;
	    var offsetHeight = (radius + padding.top + (height - radius - padding.bottom)) / 2;
	    var origin = { x: offsetWidth, y: offsetHeight };
	    var data = _victoryCore.Data.getData(props);
	    var slices = this.getSlices(props, data);
	    var pathFunction = d3Shape.arc().cornerRadius(props.cornerRadius).outerRadius(radius).innerRadius(props.innerRadius);
	    return { style: style, colors: colors, padding: padding, radius: radius, data: data, slices: slices, pathFunction: pathFunction, origin: origin };
	  },
	  getColor: function (style, colors, index) {
	    if (style && style.data && style.data.fill) {
	      return style.data.fill;
	    }
	    return colors && colors[index % colors.length];
	  },
	  getRadius: function (props, padding) {
	    return Math.min(props.width - padding.left - padding.right, props.height - padding.top - padding.bottom) / 2;
	  },
	  getLabelPosition: function (radius, labelRadius, style) {
	    var padding = style && style.padding || 0;
	    var arcRadius = labelRadius || radius + padding;
	    return d3Shape.arc().outerRadius(arcRadius).innerRadius(arcRadius);
	  },
	  getLabelOrientation: function (slice) {
	    var radiansToDegrees = function (radians) {
	      return radians * (180 / Math.PI);
	    };
	    var start = radiansToDegrees(slice.startAngle);
	    var end = radiansToDegrees(slice.endAngle);
	    var degree = start + (end - start) / 2;
	    if (degree < 45 || degree > 315) {
	      return "top";
	    } else if (degree >= 45 && degree < 135) {
	      return "right";
	    } else if (degree >= 135 && degree < 225) {
	      return "bottom";
	    } else {
	      return "left";
	    }
	  },
	  getTextAnchor: function (orientation) {
	    if (orientation === "top" || orientation === "bottom") {
	      return "middle";
	    }
	    return orientation === "right" ? "start" : "end";
	  },
	  getVerticalAnchor: function (orientation) {
	    if (orientation === "left" || orientation === "right") {
	      return "middle";
	    }
	    return orientation === "bottom" ? "start" : "end";
	  },
	  getLabelText: function (props, datum, index) {
	    var text = void 0;
	    if (datum.label) {
	      text = datum.label;
	    } else if (Array.isArray(props.labels)) {
	      text = props.labels[index];
	    } else {
	      text = (0, _isFunction3.default)(props.labels) ? props.labels(datum) : datum.xName || datum._x;
	    }
	    return this.checkForValidText(text);
	  },
	  getSlices: function (props, data) {
	    var layoutFunction = d3Shape.pie().sort(null).startAngle(this.degreesToRadians(props.startAngle)).endAngle(this.degreesToRadians(props.endAngle)).padAngle(this.degreesToRadians(props.padAngle)).value(function (datum) {
	      return datum._y;
	    });
	    return layoutFunction(data);
	  }
	};

/***/ },
/* 620 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _partialRight2 = __webpack_require__(16);
	
	var _partialRight3 = _interopRequireDefault(_partialRight2);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _victoryCore = __webpack_require__(3);
	
	var _helperMethods = __webpack_require__(619);
	
	var _helperMethods2 = _interopRequireDefault(_helperMethods);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*eslint no-magic-numbers: ["error", { "ignore": [-1, 0, 1, 2] }]*/
	
	
	var fallbackProps = {
	  endAngle: 360,
	  height: 400,
	  innerRadius: 0,
	  cornerRadius: 0,
	  padAngle: 0,
	  padding: 30,
	  width: 400,
	  startAngle: 0,
	  colorScale: ["#ffffff", "#f0f0f0", "#d9d9d9", "#bdbdbd", "#969696", "#737373", "#525252", "#252525", "#000000"]
	};
	
	var animationWhitelist = ["data", "endAngle", "height", "innerRadius", "cornerRadius", "padAngle", "padding", "colorScale", "startAngle", "style", "width"];
	
	var VictoryPie = function (_React$Component) {
	  _inherits(VictoryPie, _React$Component);
	
	  function VictoryPie() {
	    _classCallCheck(this, VictoryPie);
	
	    return _possibleConstructorReturn(this, (VictoryPie.__proto__ || Object.getPrototypeOf(VictoryPie)).apply(this, arguments));
	  }
	
	  _createClass(VictoryPie, [{
	    key: "shouldAnimate",
	
	
	    // Overridden in victory-native
	    value: function shouldAnimate() {
	      return Boolean(this.props.animate);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var role = this.constructor.role;
	
	      var props = _victoryCore.Helpers.modifyProps(this.props, fallbackProps, role);
	      if (this.shouldAnimate()) {
	        return this.animateComponent(props, animationWhitelist);
	      }
	
	      var children = this.renderData(props);
	      return props.standalone ? this.renderContainer(props.containerComponent, children) : children;
	    }
	  }]);
	
	  return VictoryPie;
	}(_react2.default.Component);
	
	VictoryPie.displayName = "VictoryPie";
	VictoryPie.role = "pie";
	VictoryPie.defaultTransitions = {
	  onExit: {
	    duration: 500,
	    before: function () {
	      return { _y: 0, label: " " };
	    }
	  },
	  onEnter: {
	    duration: 500,
	    before: function () {
	      return { _y: 0, label: " " };
	    },
	    after: function (datum) {
	      return { y_: datum._y, label: datum.label };
	    }
	  }
	};
	VictoryPie.propTypes = {
	  animate: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.object]),
	  colorScale: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.string), _propTypes2.default.oneOf(["grayscale", "qualitative", "heatmap", "warm", "cool", "red", "green", "blue"])]),
	  containerComponent: _propTypes2.default.element,
	  cornerRadius: _victoryCore.PropTypes.nonNegative,
	  data: _propTypes2.default.array,
	  dataComponent: _propTypes2.default.element,
	  endAngle: _propTypes2.default.number,
	  eventKey: _propTypes2.default.oneOfType([_propTypes2.default.func, _victoryCore.PropTypes.allOfType([_victoryCore.PropTypes.integer, _victoryCore.PropTypes.nonNegative]), _propTypes2.default.string]),
	  events: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    target: _propTypes2.default.oneOf(["data", "labels", "parent"]),
	    eventKey: _propTypes2.default.oneOfType([_propTypes2.default.func, _victoryCore.PropTypes.allOfType([_victoryCore.PropTypes.integer, _victoryCore.PropTypes.nonNegative]), _propTypes2.default.string]),
	    eventHandlers: _propTypes2.default.object
	  })),
	  groupComponent: _propTypes2.default.element,
	  height: _victoryCore.PropTypes.nonNegative,
	  innerRadius: _victoryCore.PropTypes.nonNegative,
	  labelComponent: _propTypes2.default.element,
	  labelRadius: _propTypes2.default.oneOfType([_victoryCore.PropTypes.nonNegative, _propTypes2.default.func]),
	  labels: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.array]),
	  name: _propTypes2.default.string,
	  padAngle: _victoryCore.PropTypes.nonNegative,
	  padding: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.shape({
	    top: _propTypes2.default.number, bottom: _propTypes2.default.number,
	    left: _propTypes2.default.number, right: _propTypes2.default.number
	  })]),
	  sharedEvents: _propTypes2.default.shape({
	    events: _propTypes2.default.array,
	    getEventState: _propTypes2.default.func
	  }),
	  sortKey: _propTypes2.default.oneOfType([_propTypes2.default.func, _victoryCore.PropTypes.allOfType([_victoryCore.PropTypes.integer, _victoryCore.PropTypes.nonNegative]), _propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.string)]),
	  sortOder: _propTypes2.default.oneOf(["ascending", "descending"]),
	  standalone: _propTypes2.default.bool,
	  startAngle: _propTypes2.default.number,
	  style: _propTypes2.default.shape({
	    parent: _propTypes2.default.object, data: _propTypes2.default.object, labels: _propTypes2.default.object
	  }),
	  theme: _propTypes2.default.object,
	  width: _victoryCore.PropTypes.nonNegative,
	  x: _propTypes2.default.oneOfType([_propTypes2.default.func, _victoryCore.PropTypes.allOfType([_victoryCore.PropTypes.integer, _victoryCore.PropTypes.nonNegative]), _propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.string)]),
	  y: _propTypes2.default.oneOfType([_propTypes2.default.func, _victoryCore.PropTypes.allOfType([_victoryCore.PropTypes.integer, _victoryCore.PropTypes.nonNegative]), _propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.string)])
	};
	VictoryPie.defaultProps = {
	  data: [{ x: "A", y: 1 }, { x: "B", y: 2 }, { x: "C", y: 3 }, { x: "D", y: 1 }, { x: "E", y: 2 }],
	  standalone: true,
	  dataComponent: _react2.default.createElement(_victoryCore.Slice, null),
	  labelComponent: _react2.default.createElement(_victoryCore.VictoryLabel, null),
	  containerComponent: _react2.default.createElement(_victoryCore.VictoryContainer, null),
	  groupComponent: _react2.default.createElement("g", null),
	  sortOrder: "ascending",
	  theme: _victoryCore.VictoryTheme.grayscale
	};
	VictoryPie.getBaseProps = (0, _partialRight3.default)(_helperMethods2.default.getBaseProps.bind(_helperMethods2.default), fallbackProps);
	VictoryPie.getData = _victoryCore.Data.getData.bind(_victoryCore.Data);
	VictoryPie.expectedComponents = ["dataComponent", "labelComponent", "groupComponent", "containerComponent"];
	exports.default = (0, _victoryCore.addEvents)(VictoryPie);

/***/ },
/* 621 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.VictoryPie = undefined;
	
	var _victoryPie = __webpack_require__(620);
	
	var _victoryPie2 = _interopRequireDefault(_victoryPie);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.VictoryPie = _victoryPie2.default;

/***/ },
/* 622 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.LabelHelpers = exports.Selection = exports.Transitions = exports.TextSize = exports.Style = exports.Scale = exports.PropTypes = exports.Log = exports.Helpers = exports.Events = exports.Domain = exports.DefaultTransitions = exports.Data = exports.Collection = exports.addEvents = exports.createContainer = exports.combineContainerMixins = exports.voronoiContainerMixin = exports.VoronoiHelpers = exports.VictoryVoronoiContainer = exports.cursorContainerMixin = exports.CursorHelpers = exports.VictoryCursorContainer = exports.brushContainerMixin = exports.BrushHelpers = exports.VictoryBrushContainer = exports.selectionContainerMixin = exports.SelectionHelpers = exports.VictorySelectionContainer = exports.zoomContainerMixin = exports.ZoomHelpers = exports.VictoryZoomContainer = exports.VictoryClipContainer = exports.VictoryContainer = exports.Portal = exports.VictoryPortal = exports.VictoryVoronoi = exports.VictoryTooltip = exports.VictorySharedEvents = exports.VictoryTransition = exports.VictoryTheme = exports.VictoryStack = exports.VictoryScatter = exports.VictoryPie = exports.VictoryLegend = exports.VictoryLabel = exports.VictoryLine = exports.VictoryGroup = exports.VictoryErrorBar = exports.VictoryChart = exports.VictoryCandlestick = exports.VictoryBar = exports.VictoryPolarAxis = exports.VictoryAxis = exports.VictoryArea = exports.VictoryAnimation = exports.Flyout = exports.Voronoi = exports.Slice = exports.Point = exports.Line = exports.ErrorBar = exports.Curve = exports.ClipPath = exports.Candle = exports.Border = exports.Bar = exports.Area = undefined;
	
	var _victoryCore = __webpack_require__(3);
	
	var _victoryChart = __webpack_require__(597);
	
	var _victoryPie = __webpack_require__(621);
	
	exports.Area = _victoryCore.Area;
	exports.Bar = _victoryCore.Bar;
	exports.Border = _victoryCore.Border;
	exports.Candle = _victoryCore.Candle;
	exports.ClipPath = _victoryCore.ClipPath;
	exports.Curve = _victoryCore.Curve;
	exports.ErrorBar = _victoryCore.ErrorBar;
	exports.Line = _victoryCore.Line;
	exports.Point = _victoryCore.Point;
	exports.Slice = _victoryCore.Slice;
	exports.Voronoi = _victoryCore.Voronoi;
	exports.Flyout = _victoryCore.Flyout;
	exports.VictoryAnimation = _victoryCore.VictoryAnimation;
	exports.VictoryArea = _victoryChart.VictoryArea;
	exports.VictoryAxis = _victoryChart.VictoryAxis;
	exports.VictoryPolarAxis = _victoryChart.VictoryPolarAxis;
	exports.VictoryBar = _victoryChart.VictoryBar;
	exports.VictoryCandlestick = _victoryChart.VictoryCandlestick;
	exports.VictoryChart = _victoryChart.VictoryChart;
	exports.VictoryErrorBar = _victoryChart.VictoryErrorBar;
	exports.VictoryGroup = _victoryChart.VictoryGroup;
	exports.VictoryLine = _victoryChart.VictoryLine;
	exports.VictoryLabel = _victoryCore.VictoryLabel;
	exports.VictoryLegend = _victoryCore.VictoryLegend;
	exports.VictoryPie = _victoryPie.VictoryPie;
	exports.VictoryScatter = _victoryChart.VictoryScatter;
	exports.VictoryStack = _victoryChart.VictoryStack;
	exports.VictoryTheme = _victoryCore.VictoryTheme;
	exports.VictoryTransition = _victoryCore.VictoryTransition;
	exports.VictorySharedEvents = _victoryCore.VictorySharedEvents;
	exports.VictoryTooltip = _victoryCore.VictoryTooltip;
	exports.VictoryVoronoi = _victoryChart.VictoryVoronoi;
	exports.VictoryPortal = _victoryCore.VictoryPortal;
	exports.Portal = _victoryCore.Portal;
	exports.VictoryContainer = _victoryCore.VictoryContainer;
	exports.VictoryClipContainer = _victoryCore.VictoryClipContainer;
	exports.VictoryZoomContainer = _victoryChart.VictoryZoomContainer;
	exports.ZoomHelpers = _victoryChart.ZoomHelpers;
	exports.zoomContainerMixin = _victoryChart.zoomContainerMixin;
	exports.VictorySelectionContainer = _victoryChart.VictorySelectionContainer;
	exports.SelectionHelpers = _victoryChart.SelectionHelpers;
	exports.selectionContainerMixin = _victoryChart.selectionContainerMixin;
	exports.VictoryBrushContainer = _victoryChart.VictoryBrushContainer;
	exports.BrushHelpers = _victoryChart.BrushHelpers;
	exports.brushContainerMixin = _victoryChart.brushContainerMixin;
	exports.VictoryCursorContainer = _victoryChart.VictoryCursorContainer;
	exports.CursorHelpers = _victoryChart.CursorHelpers;
	exports.cursorContainerMixin = _victoryChart.cursorContainerMixin;
	exports.VictoryVoronoiContainer = _victoryChart.VictoryVoronoiContainer;
	exports.VoronoiHelpers = _victoryChart.VoronoiHelpers;
	exports.voronoiContainerMixin = _victoryChart.voronoiContainerMixin;
	exports.combineContainerMixins = _victoryChart.combineContainerMixins;
	exports.createContainer = _victoryChart.createContainer;
	exports.addEvents = _victoryCore.addEvents;
	exports.Collection = _victoryCore.Collection;
	exports.Data = _victoryCore.Data;
	exports.DefaultTransitions = _victoryCore.DefaultTransitions;
	exports.Domain = _victoryCore.Domain;
	exports.Events = _victoryCore.Events;
	exports.Helpers = _victoryCore.Helpers;
	exports.Log = _victoryCore.Log;
	exports.PropTypes = _victoryCore.PropTypes;
	exports.Scale = _victoryCore.Scale;
	exports.Style = _victoryCore.Style;
	exports.TextSize = _victoryCore.TextSize;
	exports.Transitions = _victoryCore.Transitions;
	exports.Selection = _victoryCore.Selection;
	exports.LabelHelpers = _victoryCore.LabelHelpers;

/***/ },
/* 623 */
/***/ function(module, exports) {

	(function(self) {
	  'use strict';
	
	  if (self.fetch) {
	    return
	  }
	
	  var support = {
	    searchParams: 'URLSearchParams' in self,
	    iterable: 'Symbol' in self && 'iterator' in Symbol,
	    blob: 'FileReader' in self && 'Blob' in self && (function() {
	      try {
	        new Blob()
	        return true
	      } catch(e) {
	        return false
	      }
	    })(),
	    formData: 'FormData' in self,
	    arrayBuffer: 'ArrayBuffer' in self
	  }
	
	  if (support.arrayBuffer) {
	    var viewClasses = [
	      '[object Int8Array]',
	      '[object Uint8Array]',
	      '[object Uint8ClampedArray]',
	      '[object Int16Array]',
	      '[object Uint16Array]',
	      '[object Int32Array]',
	      '[object Uint32Array]',
	      '[object Float32Array]',
	      '[object Float64Array]'
	    ]
	
	    var isDataView = function(obj) {
	      return obj && DataView.prototype.isPrototypeOf(obj)
	    }
	
	    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
	      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
	    }
	  }
	
	  function normalizeName(name) {
	    if (typeof name !== 'string') {
	      name = String(name)
	    }
	    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
	      throw new TypeError('Invalid character in header field name')
	    }
	    return name.toLowerCase()
	  }
	
	  function normalizeValue(value) {
	    if (typeof value !== 'string') {
	      value = String(value)
	    }
	    return value
	  }
	
	  // Build a destructive iterator for the value list
	  function iteratorFor(items) {
	    var iterator = {
	      next: function() {
	        var value = items.shift()
	        return {done: value === undefined, value: value}
	      }
	    }
	
	    if (support.iterable) {
	      iterator[Symbol.iterator] = function() {
	        return iterator
	      }
	    }
	
	    return iterator
	  }
	
	  function Headers(headers) {
	    this.map = {}
	
	    if (headers instanceof Headers) {
	      headers.forEach(function(value, name) {
	        this.append(name, value)
	      }, this)
	
	    } else if (headers) {
	      Object.getOwnPropertyNames(headers).forEach(function(name) {
	        this.append(name, headers[name])
	      }, this)
	    }
	  }
	
	  Headers.prototype.append = function(name, value) {
	    name = normalizeName(name)
	    value = normalizeValue(value)
	    var oldValue = this.map[name]
	    this.map[name] = oldValue ? oldValue+','+value : value
	  }
	
	  Headers.prototype['delete'] = function(name) {
	    delete this.map[normalizeName(name)]
	  }
	
	  Headers.prototype.get = function(name) {
	    name = normalizeName(name)
	    return this.has(name) ? this.map[name] : null
	  }
	
	  Headers.prototype.has = function(name) {
	    return this.map.hasOwnProperty(normalizeName(name))
	  }
	
	  Headers.prototype.set = function(name, value) {
	    this.map[normalizeName(name)] = normalizeValue(value)
	  }
	
	  Headers.prototype.forEach = function(callback, thisArg) {
	    for (var name in this.map) {
	      if (this.map.hasOwnProperty(name)) {
	        callback.call(thisArg, this.map[name], name, this)
	      }
	    }
	  }
	
	  Headers.prototype.keys = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push(name) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.values = function() {
	    var items = []
	    this.forEach(function(value) { items.push(value) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.entries = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push([name, value]) })
	    return iteratorFor(items)
	  }
	
	  if (support.iterable) {
	    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
	  }
	
	  function consumed(body) {
	    if (body.bodyUsed) {
	      return Promise.reject(new TypeError('Already read'))
	    }
	    body.bodyUsed = true
	  }
	
	  function fileReaderReady(reader) {
	    return new Promise(function(resolve, reject) {
	      reader.onload = function() {
	        resolve(reader.result)
	      }
	      reader.onerror = function() {
	        reject(reader.error)
	      }
	    })
	  }
	
	  function readBlobAsArrayBuffer(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsArrayBuffer(blob)
	    return promise
	  }
	
	  function readBlobAsText(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsText(blob)
	    return promise
	  }
	
	  function readArrayBufferAsText(buf) {
	    var view = new Uint8Array(buf)
	    var chars = new Array(view.length)
	
	    for (var i = 0; i < view.length; i++) {
	      chars[i] = String.fromCharCode(view[i])
	    }
	    return chars.join('')
	  }
	
	  function bufferClone(buf) {
	    if (buf.slice) {
	      return buf.slice(0)
	    } else {
	      var view = new Uint8Array(buf.byteLength)
	      view.set(new Uint8Array(buf))
	      return view.buffer
	    }
	  }
	
	  function Body() {
	    this.bodyUsed = false
	
	    this._initBody = function(body) {
	      this._bodyInit = body
	      if (!body) {
	        this._bodyText = ''
	      } else if (typeof body === 'string') {
	        this._bodyText = body
	      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
	        this._bodyBlob = body
	      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
	        this._bodyFormData = body
	      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	        this._bodyText = body.toString()
	      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
	        this._bodyArrayBuffer = bufferClone(body.buffer)
	        // IE 10-11 can't handle a DataView body.
	        this._bodyInit = new Blob([this._bodyArrayBuffer])
	      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
	        this._bodyArrayBuffer = bufferClone(body)
	      } else {
	        throw new Error('unsupported BodyInit type')
	      }
	
	      if (!this.headers.get('content-type')) {
	        if (typeof body === 'string') {
	          this.headers.set('content-type', 'text/plain;charset=UTF-8')
	        } else if (this._bodyBlob && this._bodyBlob.type) {
	          this.headers.set('content-type', this._bodyBlob.type)
	        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
	        }
	      }
	    }
	
	    if (support.blob) {
	      this.blob = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return Promise.resolve(this._bodyBlob)
	        } else if (this._bodyArrayBuffer) {
	          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as blob')
	        } else {
	          return Promise.resolve(new Blob([this._bodyText]))
	        }
	      }
	
	      this.arrayBuffer = function() {
	        if (this._bodyArrayBuffer) {
	          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
	        } else {
	          return this.blob().then(readBlobAsArrayBuffer)
	        }
	      }
	    }
	
	    this.text = function() {
	      var rejected = consumed(this)
	      if (rejected) {
	        return rejected
	      }
	
	      if (this._bodyBlob) {
	        return readBlobAsText(this._bodyBlob)
	      } else if (this._bodyArrayBuffer) {
	        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
	      } else if (this._bodyFormData) {
	        throw new Error('could not read FormData body as text')
	      } else {
	        return Promise.resolve(this._bodyText)
	      }
	    }
	
	    if (support.formData) {
	      this.formData = function() {
	        return this.text().then(decode)
	      }
	    }
	
	    this.json = function() {
	      return this.text().then(JSON.parse)
	    }
	
	    return this
	  }
	
	  // HTTP methods whose capitalization should be normalized
	  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']
	
	  function normalizeMethod(method) {
	    var upcased = method.toUpperCase()
	    return (methods.indexOf(upcased) > -1) ? upcased : method
	  }
	
	  function Request(input, options) {
	    options = options || {}
	    var body = options.body
	
	    if (input instanceof Request) {
	      if (input.bodyUsed) {
	        throw new TypeError('Already read')
	      }
	      this.url = input.url
	      this.credentials = input.credentials
	      if (!options.headers) {
	        this.headers = new Headers(input.headers)
	      }
	      this.method = input.method
	      this.mode = input.mode
	      if (!body && input._bodyInit != null) {
	        body = input._bodyInit
	        input.bodyUsed = true
	      }
	    } else {
	      this.url = String(input)
	    }
	
	    this.credentials = options.credentials || this.credentials || 'omit'
	    if (options.headers || !this.headers) {
	      this.headers = new Headers(options.headers)
	    }
	    this.method = normalizeMethod(options.method || this.method || 'GET')
	    this.mode = options.mode || this.mode || null
	    this.referrer = null
	
	    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
	      throw new TypeError('Body not allowed for GET or HEAD requests')
	    }
	    this._initBody(body)
	  }
	
	  Request.prototype.clone = function() {
	    return new Request(this, { body: this._bodyInit })
	  }
	
	  function decode(body) {
	    var form = new FormData()
	    body.trim().split('&').forEach(function(bytes) {
	      if (bytes) {
	        var split = bytes.split('=')
	        var name = split.shift().replace(/\+/g, ' ')
	        var value = split.join('=').replace(/\+/g, ' ')
	        form.append(decodeURIComponent(name), decodeURIComponent(value))
	      }
	    })
	    return form
	  }
	
	  function parseHeaders(rawHeaders) {
	    var headers = new Headers()
	    rawHeaders.split(/\r?\n/).forEach(function(line) {
	      var parts = line.split(':')
	      var key = parts.shift().trim()
	      if (key) {
	        var value = parts.join(':').trim()
	        headers.append(key, value)
	      }
	    })
	    return headers
	  }
	
	  Body.call(Request.prototype)
	
	  function Response(bodyInit, options) {
	    if (!options) {
	      options = {}
	    }
	
	    this.type = 'default'
	    this.status = 'status' in options ? options.status : 200
	    this.ok = this.status >= 200 && this.status < 300
	    this.statusText = 'statusText' in options ? options.statusText : 'OK'
	    this.headers = new Headers(options.headers)
	    this.url = options.url || ''
	    this._initBody(bodyInit)
	  }
	
	  Body.call(Response.prototype)
	
	  Response.prototype.clone = function() {
	    return new Response(this._bodyInit, {
	      status: this.status,
	      statusText: this.statusText,
	      headers: new Headers(this.headers),
	      url: this.url
	    })
	  }
	
	  Response.error = function() {
	    var response = new Response(null, {status: 0, statusText: ''})
	    response.type = 'error'
	    return response
	  }
	
	  var redirectStatuses = [301, 302, 303, 307, 308]
	
	  Response.redirect = function(url, status) {
	    if (redirectStatuses.indexOf(status) === -1) {
	      throw new RangeError('Invalid status code')
	    }
	
	    return new Response(null, {status: status, headers: {location: url}})
	  }
	
	  self.Headers = Headers
	  self.Request = Request
	  self.Response = Response
	
	  self.fetch = function(input, init) {
	    return new Promise(function(resolve, reject) {
	      var request = new Request(input, init)
	      var xhr = new XMLHttpRequest()
	
	      xhr.onload = function() {
	        var options = {
	          status: xhr.status,
	          statusText: xhr.statusText,
	          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
	        }
	        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
	        var body = 'response' in xhr ? xhr.response : xhr.responseText
	        resolve(new Response(body, options))
	      }
	
	      xhr.onerror = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.ontimeout = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.open(request.method, request.url, true)
	
	      if (request.credentials === 'include') {
	        xhr.withCredentials = true
	      }
	
	      if ('responseType' in xhr && support.blob) {
	        xhr.responseType = 'blob'
	      }
	
	      request.headers.forEach(function(value, name) {
	        xhr.setRequestHeader(name, value)
	      })
	
	      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
	    })
	  }
	  self.fetch.polyfill = true
	})(typeof self !== 'undefined' ? self : this);


/***/ },
/* 624 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var root = __webpack_require__(__webpack_module_template_argument_0__);
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	module.exports = Symbol;


/***/ },
/* 625 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var Symbol = __webpack_require__(__webpack_module_template_argument_0__),
	    getRawTag = __webpack_require__(__webpack_module_template_argument_1__),
	    objectToString = __webpack_require__(__webpack_module_template_argument_2__);
	
	/** `Object#toString` result references. */
	var nullTag = '[object Null]',
	    undefinedTag = '[object Undefined]';
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	module.exports = baseGetTag;


/***/ },
/* 626 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var overArg = __webpack_require__(__webpack_module_template_argument_0__);
	
	/** Built-in value references. */
	var getPrototype = overArg(Object.getPrototypeOf, Object);
	
	module.exports = getPrototype;


/***/ },
/* 627 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var Symbol = __webpack_require__(__webpack_module_template_argument_0__);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	module.exports = getRawTag;


/***/ },
/* 628 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var freeGlobal = __webpack_require__(__webpack_module_template_argument_0__);
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	module.exports = root;


/***/ },
/* 629 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var baseGetTag = __webpack_require__(__webpack_module_template_argument_0__),
	    getPrototype = __webpack_require__(__webpack_module_template_argument_1__),
	    isObjectLike = __webpack_require__(__webpack_module_template_argument_2__);
	
	/** `Object#toString` result references. */
	var objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	    return false;
	  }
	  var proto = getPrototype(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	    funcToString.call(Ctor) == objectCtorString;
	}
	
	module.exports = isPlainObject;


/***/ }
/******/ ])));


// WEBPACK FOOTER //
// static/js/main.bae27847.js